(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 82419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hH": function() { return /* reexport */ AuthOrigin; },
  "C1": function() { return /* reexport */ PlatformPathname; }
});

// UNUSED EXPORTS: ActiveRole, AppLockReason, ApplicantCompanyType, ApplicantEntity, ApplicantType, AppointmentCancellationReason, AppointmentLeadTimeMinutes, AppointmentLength, AppointmentLengthType, AssetFinanceCalculatedStage, AssetFinanceCalculatedStatus, AssetFinanceReason, AssetFinanceType, AssetPrimaryPurpose, AssetType, AuthTokenFields, BankingFeatures, BeneficialOwnerRole, BeneficialOwnerType, BenefitEnquiries, Brand, BrandInteractionType, BuilderType, BusinessLoanWorkingCapitalLoanType, BusinessStructureType, BusinessType, ClientStatus, CoApplicantBenefit, CoApplicantReason, CompanyApplicantRelatedPartyType, CompanyStructure, CompanyType, Confidence, Construction, Countries, CreditStatus, CtpInterestRateType, CustomerPropertyRelationship, DesiredFeatures, DocumentationDeliveryMethod, DynamoEventName, EligibleForFHOG, EmploymentBasisType, EmploymentStructures, EmploymentSubType, EmploymentType, ExpenseTypes, FinanceStage, FinancialSituation, Frequency, Gender, GovtBenefitTypes, GuarantorLocationType, HousingStatusList, IncomeTypesAsset, IncomeTypesGovt, IncomeTypesOthers, IncomeTypesPayg, IncomeTypesSelfEmployed, IndependentAdviceTypeRequired, IntentToBuy, InteractionType, InterestRateType, InternationalMobileCountriesByBrand, InvitationStatus, LENDERS, LENDER_DICTIONARY, LeisureAssetLoanType, LiabilityClearingFromOtherSource, LiabilityInterestType, LiabilityRepaymentFrequency, LiabilityRepaymentTypeDetails, LiabilityType, LoanCategory, LocationType, MaritalStatus, Mitigant, NON_PARTNER_LENDERS, NON_PARTNER_WITHOUT_SHORTNAME, NON_PARTNER_WITH_SHORTNAME, NonPersonRelatedPartyRelationshipType, OtherPersonalLoanType, OwnershipProportions, PARTNER_LENDERS, PARTNER_LENDERS_WITHOUT_SHORTNAME, PARTNER_LENDERS_WITH_SHORTNAME, PaymentIssues, PaymentType, PersonType, PlantAndEquipmentLoanType, PlatformFinanceStatus, PlatformFinanceSubStatus, PrimaryPurpose, ProductFeatures, ProductPreferences, PropertyAddressRegex, PropertyEstimateBasis, PropertyEventTimelineType, PropertyStatus, PropertyType, PropertyVisibility, PropertyZoneType, PurchaseReason, PurchaseSituation, Purpose, ReferralFeeType, RefinancingReasons, RelatedCompanyType, RelationshipToBorrower, RelationshipToTrust, RepaymentOptions, RepaymentType, RepaymentTypeDetails, ResidencyStatus, State, StreetSuffixes, StreetTypes, SubstantialBenefitType, TeamMemberBrand, TeamMemberBrokerStatus, TeamMemberCommissionStatus, TeamMemberProfile, TeamMemberRestrictionStatus, TeamMemberSalutation, TeamMemberSkill, TeamMemberSkillLGSF, TeamMemberSkillLGSFWithLabel, TeamMemberSubSkillLGSF, TeamMemberSubSkillLGSFWithLabel, TeamMemberTimeZone, TeamMemberUserRole, Title, TransactionType, TrustApplicantRelatedPartyType, TrustSettlorNotApplicableReason, TrustType, Urgency, UserType, VehicleCondition, VehicleFinanceStage, VehicleIntentToBuy, VehicleMake, VehicleModel, VisitContactType, activeRoles, getByName

;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/ApplicantEntity.js
var ApplicantEntity;
(function (ApplicantEntity) {
    ApplicantEntity["Person"] = "PERSON";
    ApplicantEntity["Company"] = "COMPANY";
    ApplicantEntity["Trust"] = "TRUST";
})(ApplicantEntity || (ApplicantEntity = {}));
//# sourceMappingURL=ApplicantEntity.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/ApplicantType.js
var ApplicantType;
(function (ApplicantType) {
    ApplicantType["Borrower"] = "BORROWER";
    ApplicantType["BorrowerAndGuarantor"] = "BORROWER_AND_GUARANTOR";
    ApplicantType["Guarantor"] = "GUARANTOR";
})(ApplicantType || (ApplicantType = {}));
//# sourceMappingURL=ApplicantType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Assets.js
var AssetType;
(function (AssetType) {
    AssetType["Property"] = "PROPERTY";
    AssetType["Vehicle"] = "VEHICLE";
    AssetType["HomeContents"] = "HOME_CONTENTS";
    AssetType["SavingCheckAccount"] = "SAVING_CHECK_ACCOUNT";
    AssetType["Superannuation"] = "SUPERANNUATION";
    AssetType["TermDeposit"] = "TERM_DEPOSIT";
    AssetType["Shares"] = "SHARES";
    AssetType["ManagedFunds"] = "MANAGED_FUNDS";
    AssetType["Gifts"] = "GIFTS";
    AssetType["OtherAsset"] = "OTHER_ASSET";
})(AssetType || (AssetType = {}));
var AssetPrimaryPurpose;
(function (AssetPrimaryPurpose) {
    AssetPrimaryPurpose["Investment"] = "INVESTMENT";
    AssetPrimaryPurpose["OwnerOccupied"] = "OWNER_OCCUPIED";
})(AssetPrimaryPurpose || (AssetPrimaryPurpose = {}));
//# sourceMappingURL=Assets.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/AuthOrigin.js
var AuthOrigin;
(function (AuthOrigin) {
    AuthOrigin["Passwordless"] = "passwordless";
    AuthOrigin["Domain"] = "domain";
    AuthOrigin["Google"] = "google";
})(AuthOrigin || (AuthOrigin = {}));
//# sourceMappingURL=AuthOrigin.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/AuthTokenFields.js
var AuthTokenFields;
(function (AuthTokenFields) {
    AuthTokenFields["UserId"] = "https://lendi/userId";
    AuthTokenFields["Type"] = "https://lendi/type";
    AuthTokenFields["Brand"] = "https://lendi/brand";
    AuthTokenFields["AuthApplications"] = "authorized-applications";
    AuthTokenFields["AuthCustomer"] = "authorized-customer";
    AuthTokenFields["Connection"] = "https://lendi/connection";
})(AuthTokenFields || (AuthTokenFields = {}));
//# sourceMappingURL=AuthTokenFields.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Brand.js
var Brand;
(function (Brand) {
    Brand["Lendi"] = "lendi";
    Brand["Domain"] = "domain";
    Brand["Aussie"] = "aussie";
})(Brand || (Brand = {}));
//# sourceMappingURL=Brand.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/BankingFeatures.js
var BankingFeatures;
(function (BankingFeatures) {
    BankingFeatures["ApplePay"] = "APPLE_PAY";
    BankingFeatures["BranchAccess"] = "BRANCH_ACCESS";
    BankingFeatures["CreditCard"] = "CREDIT_CARD";
    BankingFeatures["FeeFreeAtmTransactions"] = "FEE_FREE_ATM_TRANSACTIONS";
    BankingFeatures["GooglePay"] = "GOOGLE_PAY";
    BankingFeatures["InternetBanking"] = "INTERNET_BANKING";
    BankingFeatures["MobileApp"] = "MOBILE_APP";
    BankingFeatures["OpenToEverything"] = "OPEN_TO_EVERYTHING";
    BankingFeatures["SamsungPay"] = "SAMSUNG_PAY";
    BankingFeatures["UrgentTurnaround"] = "URGENT_TURNAROUND";
})(BankingFeatures || (BankingFeatures = {}));
//# sourceMappingURL=BankingFeatures.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/BrokerInterviews.js
var BenefitEnquiries;
(function (BenefitEnquiries) {
    BenefitEnquiries["Other"] = "OTHER";
    BenefitEnquiries["ProportionsInAssetsPurchased"] = "PROPORTION_IN_ASSETS_PURCHASED";
    BenefitEnquiries["RepayDebtsOrOtherObligations"] = "REPAY_DEBTS_OR_OTHER_OBLIGATIONS";
})(BenefitEnquiries || (BenefitEnquiries = {}));
var CoApplicantBenefit;
(function (CoApplicantBenefit) {
    CoApplicantBenefit["NoSubstantialBenefit"] = "NO_SUBSTANTIAL_BENEFIT";
    CoApplicantBenefit["NoSubstantialBenefitAndProceed"] = "NO_SUBSTANTIAL_BENEFIT_AND_PROCEED";
    CoApplicantBenefit["SubstantialBenefit"] = "SUBSTANTIAL_BENEFIT";
})(CoApplicantBenefit || (CoApplicantBenefit = {}));
var CoApplicantReason;
(function (CoApplicantReason) {
    CoApplicantReason["AccessToCashOrEquity"] = "ACCESS_TO_CASH_OR_EQUITY";
    CoApplicantReason["BuyingAVehicalWhereOnlyOneBorrowerCanBeTheRegisteredOwner"] = "BUYING_A_VEHICLE_WHERE_ONLY_ONE_BORROWER_CAN_BE_THE_REGISTERED_OWNER";
    CoApplicantReason["IndependentFinancialLegalOrAccountingAdviceRequired"] = "INDEPENDENT_FINANCIAL_LEGAL_OR_ACCOUNTING_ADVICE_RECEIVED";
    CoApplicantReason["SpousalAssetProtectionTaxBenefitsOrDebtReduction"] = "SPOUSAL_ASSET_PROTECTION_TAX_BENEFITS_OR_DEBT_REDUCTION";
    CoApplicantReason["SubstantialBenefitFromAtLeastOneOfTheLoanPurposes"] = "SUBSTANTIAL_BENEFIT_FROM_AT_LEAST_ONE_OF_THE_LOAN_PURPOSES";
})(CoApplicantReason || (CoApplicantReason = {}));
var DocumentationDeliveryMethod;
(function (DocumentationDeliveryMethod) {
    DocumentationDeliveryMethod["email"] = "EMAIL";
    DocumentationDeliveryMethod["post"] = "POST";
    DocumentationDeliveryMethod["collectFromNearestBranch"] = "COLLECT_FROM_NEAREST_BRANCH";
})(DocumentationDeliveryMethod || (DocumentationDeliveryMethod = {}));
var GuarantorLocationType;
(function (GuarantorLocationType) {
    GuarantorLocationType["lendiApprovedPhotoInterview"] = "LENDI_APPROVED_PHONE_INTERVIEW";
    GuarantorLocationType["faceToFace"] = "FACE_TO_FACE";
})(GuarantorLocationType || (GuarantorLocationType = {}));
var IndependentAdviceTypeRequired;
(function (IndependentAdviceTypeRequired) {
    IndependentAdviceTypeRequired["legalAdvice"] = "LEGAL_ADVICE";
    IndependentAdviceTypeRequired["financialAdvice"] = "FINANCIAL_ADVICE";
    IndependentAdviceTypeRequired["notNeeded"] = "NOT_NEEDED";
})(IndependentAdviceTypeRequired || (IndependentAdviceTypeRequired = {}));
var LocationType;
(function (LocationType) {
    LocationType["CustomerResidence"] = "CUSTOMER_RESIDENCE";
    LocationType["LendiApprovedPhoneInterview"] = "LENDI_APPROVED_PHONE_INTERVIEW";
    LocationType["Other"] = "OTHER";
})(LocationType || (LocationType = {}));
//# sourceMappingURL=BrokerInterviews.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Company.js
var CompanyStructure;
(function (CompanyStructure) {
    CompanyStructure["Corporation"] = "CORPORATION";
    CompanyStructure["Partnership"] = "PARTNERSHIP";
    CompanyStructure["SoleTrader"] = "SOLE_TRADER";
    CompanyStructure["Trust"] = "TRUST";
})(CompanyStructure || (CompanyStructure = {}));
var CompanyType;
(function (CompanyType) {
    CompanyType["Incorporated"] = "INCORPORATED";
    CompanyType["Ltd"] = "LTD";
    CompanyType["NL"] = "NL";
    CompanyType["PtyLtd"] = "PTY_LTD";
})(CompanyType || (CompanyType = {}));
//# sourceMappingURL=Company.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Confidence.js
var Confidence;
(function (Confidence) {
    Confidence["Low"] = "LOW";
    Confidence["MediumLow"] = "MEDIUM_LOW";
    Confidence["Medium"] = "MEDIUM";
    Confidence["MediumHigh"] = "MEDIUM_HIGH";
    Confidence["High"] = "HIGH";
})(Confidence || (Confidence = {}));
//# sourceMappingURL=Confidence.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Construction.js
var Construction;
(function (Construction) {
    Construction["BuildAProperty"] = "BUILD_A_PROPERTY";
    Construction["KnockdownRebuild"] = "KNOCKDOWN_REBUILD";
    Construction["StructuralRenovations"] = "STRUCTURAL_RENOVATIONS";
})(Construction || (Construction = {}));
//# sourceMappingURL=Construction.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/CreditStatus.js
var CreditStatus;
(function (CreditStatus) {
    CreditStatus["Fair"] = "FAIR";
    CreditStatus["Unknown"] = "UNKNOWN";
    CreditStatus["Average"] = "AVERAGE";
    CreditStatus["Excellent"] = "EXCELLENT";
})(CreditStatus || (CreditStatus = {}));
//# sourceMappingURL=CreditStatus.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/DesiredFeatures.js
var DesiredFeatures;
(function (DesiredFeatures) {
    DesiredFeatures["MobileApp"] = "MOBILE_APP";
    DesiredFeatures["MajorLender"] = "MAJOR_LENDER";
    DesiredFeatures["OffsetOrRedraw"] = "OFFSET_OR_REDRAW";
    DesiredFeatures["FixedRate"] = "FIXED_RATE";
})(DesiredFeatures || (DesiredFeatures = {}));
//# sourceMappingURL=DesiredFeatures.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/EligibleForFHOG.js
var EligibleForFHOG;
(function (EligibleForFHOG) {
    EligibleForFHOG["Yes"] = "YES";
    EligibleForFHOG["No"] = "NO";
    EligibleForFHOG["NotSure"] = "NOT_SURE";
})(EligibleForFHOG || (EligibleForFHOG = {}));
//# sourceMappingURL=EligibleForFHOG.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/EmploymentType.js
var EmploymentType;
(function (EmploymentType) {
    EmploymentType["Employee"] = "EMPLOYEE";
    EmploymentType["SelfEmployed"] = "SELF_EMPLOYED";
    EmploymentType["NotEmployed"] = "NOT_EMPLOYED";
    EmploymentType["Unknown"] = "UNKNOWN";
    EmploymentType["NotWorking"] = "NOT_WORKING";
})(EmploymentType || (EmploymentType = {}));
//# sourceMappingURL=EmploymentType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/FinancialSituation.js
var FinancialSituation;
(function (FinancialSituation) {
    FinancialSituation["ExtendedUnpaidLeave"] = "EXTENDED_UNPAID_LEAVE";
    FinancialSituation["IncreasedDebtRepaymentForExistingLoan"] = "INCREASED_DEBT_REPAYMENT_FOR_EXISTING_LOAN";
    FinancialSituation["LargeExpenditure"] = "LARGE_EXPENDITURE";
    FinancialSituation["MedicalTreatmentOrIllness"] = "MEDICAL_TREATMENT_OR_ILLNESS";
    FinancialSituation["None"] = "NONE";
    FinancialSituation["Other"] = "OTHER";
    FinancialSituation["PermanentDecreaseInIncome"] = "PERMANENT_DECREASE_IN_INCOME";
    FinancialSituation["TemporaryDecreaseInIncome"] = "TEMPORARY_DECREASE_IN_INCOME";
    FinancialSituation["TemporaryIncreaseInExpense"] = "TEMPORARY_INCREASE_IN_EXPENSE";
})(FinancialSituation || (FinancialSituation = {}));
//# sourceMappingURL=FinancialSituation.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Gender.js
var Gender;
(function (Gender) {
    Gender["Female"] = "FEMALE";
    Gender["Male"] = "MALE";
    Gender["Undisclosed"] = "UNDISCLOSED";
    Gender["Unknown"] = "UNKNOWN";
})(Gender || (Gender = {}));
//# sourceMappingURL=Gender.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/InterestRateType.js
var InterestRateType;
(function (InterestRateType) {
    InterestRateType["Variable"] = "VARIABLE";
    InterestRateType["Fixed"] = "FIXED";
    InterestRateType["Both"] = "BOTH";
})(InterestRateType || (InterestRateType = {}));
//# sourceMappingURL=InterestRateType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/InvitationStatus.js
var InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus["Pending"] = "PENDING";
    InvitationStatus["Expired"] = "EXPIRED";
    InvitationStatus["Accepted"] = "ACCEPTED";
    InvitationStatus["Cancelled"] = "CANCELLED";
})(InvitationStatus || (InvitationStatus = {}));
//# sourceMappingURL=InvitationStatus.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Liabilities.js
var LiabilityType;
(function (LiabilityType) {
    LiabilityType["Vehicle"] = "CAR_LOAN";
    LiabilityType["HomeLoan"] = "HOME_LOAN";
    LiabilityType["CreditCard"] = "CREDIT_CARD";
    LiabilityType["StoreCard"] = "STORE_CARD";
    LiabilityType["PersonalLoan"] = "PERSONAL_LOAN";
    LiabilityType["ShortTermFinance"] = "SHORT_TERM_FINANCE";
    LiabilityType["Lease"] = "LEASE";
    LiabilityType["HirePurchase"] = "HIRE_PURCHASE";
    LiabilityType["TaxDebt"] = "TAX_DEBT";
    LiabilityType["LineOfCredit"] = "LINE_OF_CREDIT";
    LiabilityType["Overdraft"] = "OVERDRAFT";
    LiabilityType["HelpHecsDebt"] = "HELP_HECS_DEBT";
    LiabilityType["Other"] = "OTHER";
    LiabilityType["Unknown"] = "UNKNOWN";
})(LiabilityType || (LiabilityType = {}));
var LiabilityRepaymentTypeDetails;
(function (LiabilityRepaymentTypeDetails) {
    LiabilityRepaymentTypeDetails["InterestOnly"] = "INTEREST_ONLY";
    LiabilityRepaymentTypeDetails["PrincipalAndInterest"] = "PRINCIPAL_AND_INTEREST";
})(LiabilityRepaymentTypeDetails || (LiabilityRepaymentTypeDetails = {}));
var LiabilityRepaymentFrequency;
(function (LiabilityRepaymentFrequency) {
    LiabilityRepaymentFrequency["Weekly"] = "WEEKLY";
    LiabilityRepaymentFrequency["Fortnightly"] = "FORTNIGHTLY";
    LiabilityRepaymentFrequency["Monthly"] = "MONTHLY";
    LiabilityRepaymentFrequency["Annually"] = "ANNUALLY";
})(LiabilityRepaymentFrequency || (LiabilityRepaymentFrequency = {}));
var LiabilityClearingFromOtherSource;
(function (LiabilityClearingFromOtherSource) {
    LiabilityClearingFromOtherSource["PayingOut"] = "PAYING_OUT";
    LiabilityClearingFromOtherSource["Reducing"] = "REDUCING";
})(LiabilityClearingFromOtherSource || (LiabilityClearingFromOtherSource = {}));
var LiabilityInterestType;
(function (LiabilityInterestType) {
    LiabilityInterestType["FixedRate"] = "FIXED_RATE";
    LiabilityInterestType["Variable"] = "VARIABLE";
})(LiabilityInterestType || (LiabilityInterestType = {}));
//# sourceMappingURL=Liabilities.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/MaritalStatus.js
var MaritalStatus;
(function (MaritalStatus) {
    MaritalStatus["DeFacto"] = "DE_FACTO";
    MaritalStatus["Divorced"] = "DIVORCED";
    MaritalStatus["Married"] = "MARRIED";
    MaritalStatus["Single"] = "SINGLE";
    MaritalStatus["Unknown"] = "UNKNOWN";
})(MaritalStatus || (MaritalStatus = {}));
//# sourceMappingURL=MaritalStatus.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Mitigant.js
var Mitigant;
(function (Mitigant) {
    Mitigant["ApplicationReflectsChanges"] = "APPLICATION_REFLECTS_CHANGES";
    Mitigant["CoApplicantsIncome"] = "CO_APPLICANTS_INCOME";
    Mitigant["ReduceExpenditure"] = "REDUCING_EXPENDITURE";
    Mitigant["SaleOfAssets"] = "SALE_OF_ASSETS";
    Mitigant["SecuringAdditionalIncome"] = "SECURING_ADDITIONAL_INCOME";
    Mitigant["UsingSavings"] = "USING_SAVINGS";
    Mitigant["Other"] = "OTHER";
})(Mitigant || (Mitigant = {}));
//# sourceMappingURL=Mitigant.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/OwnershipProportions.js
var OwnershipProportions;
(function (OwnershipProportions) {
    OwnershipProportions["Equal"] = "EQUAL";
    OwnershipProportions["Specified"] = "SPECIFIED";
    OwnershipProportions["NotSpecified"] = "NOT_SPECIFIED";
})(OwnershipProportions || (OwnershipProportions = {}));
//# sourceMappingURL=OwnershipProportions.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/PaymentIssues.js
var PaymentIssues;
(function (PaymentIssues) {
    PaymentIssues["HardshipArrangements"] = "HARDSHIP_ARRANGEMENTS";
    PaymentIssues["LatePayments"] = "LATE_PAYMENTS";
    PaymentIssues["MissedPayments"] = "MISSED_PAYMENTS";
    PaymentIssues["OutstandingArrears"] = "OUTSTANDING_ARREARS";
    PaymentIssues["None"] = "NONE";
})(PaymentIssues || (PaymentIssues = {}));
//# sourceMappingURL=PaymentIssues.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/PaymentType.js
var PaymentType;
(function (PaymentType) {
    PaymentType["InterestOnly"] = "INTEREST_ONLY";
    PaymentType["PrincipalAndInterest"] = "PRINCIPAL_AND_INTEREST";
    PaymentType["Both"] = "BOTH";
    PaymentType["StillDeciding"] = "STILL_DECIDING";
    PaymentType["Unknown"] = "UNKNOWN";
})(PaymentType || (PaymentType = {}));
//# sourceMappingURL=PaymentType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/ProductFeatures.js
var ProductFeatures;
(function (ProductFeatures) {
    ProductFeatures["Offset"] = "OFFSET";
    ProductFeatures["Redraw"] = "REDRAW";
})(ProductFeatures || (ProductFeatures = {}));
//# sourceMappingURL=ProductFeatures.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/ProductPreferences.js
var ProductPreferences;
(function (ProductPreferences) {
    ProductPreferences["AbilityToAccessPrepaidFundsIfNeeded"] = "ABILITY_TO_ACCESS_PREPAID_FUNDS_IF_NEEDED";
    ProductPreferences["AbilityToPayOffLoanSooner"] = "ABILITY_TO_PAY_OFF_LOAN_SOONER";
    ProductPreferences["AccessFundsSameWayAsRegularBankAccount"] = "ACCESS_FUNDS_SAME_WAY_AS_A_REGULAR_BANK_ACCOUNT";
    ProductPreferences["HaveABalanceOfCertaintyOfRepaymentsAndFlexibility"] = "HAVE_A_BALANCE_OF_CERTAINTY_OF_REPAYMENTS_AND_FLEXIBILITY";
    ProductPreferences["HaveSetRepayments"] = "HAVE_SET_REPAYMENTS";
    ProductPreferences["TakeAdvantageOfInterestRateDrops"] = "TAKE_ADVANTAGE_OF_INTEREST_RATE_DROPS";
    ProductPreferences["UseSavingsOrSalaryToReduceInterest"] = "USE_SAVINGS_OR_SALARY_TO_REDUCE_INTEREST";
})(ProductPreferences || (ProductPreferences = {}));
//# sourceMappingURL=ProductPreferences.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Properties.js
var PropertyStatus;
(function (PropertyStatus) {
    PropertyStatus["NewBuilding"] = "NEW_BUILDING";
    PropertyStatus["OffThePlan"] = "OFF_THE_PLAN";
    PropertyStatus["VacantLand"] = "VACANT_LAND";
    PropertyStatus["Established"] = "ESTABLISHED";
})(PropertyStatus || (PropertyStatus = {}));
var PropertyZoneType;
(function (PropertyZoneType) {
    PropertyZoneType["Residential"] = "RESIDENTIAL";
    PropertyZoneType["Commercial"] = "COMMERCIAL";
    PropertyZoneType["Rural"] = "RURAL";
    PropertyZoneType["Industrial"] = "INDUSTRIAL";
})(PropertyZoneType || (PropertyZoneType = {}));
var PropertyType;
(function (PropertyType) {
    PropertyType["ApartmentUnitLessThan50M2"] = "APARTMENT_UNIT_LESS_THAN_50M2";
    PropertyType["ApartmentUnitMoreThan50M2"] = "APARTMENT_UNIT_MORE_THAN_50M2";
    PropertyType["ServicedApartment"] = "SERVICED_APARTMENT";
    PropertyType["Stuido"] = "STUDIO";
    PropertyType["StudentAccommodation"] = "STUDENT_ACCOMMODATION";
    PropertyType["WarehouseApartment"] = "WAREHOUSE_APARTMENT";
    PropertyType["Duplex"] = "DUPLEX";
    PropertyType["Villa"] = "VILLA";
    PropertyType["FullyDetachedHouse"] = "FULLY_DETACHED_HOUSE";
    PropertyType["KitHome"] = "KIT_HOME";
    PropertyType["MultiDwellingSingleTitle"] = "MULTI_DWELLING_SINGLE_TITLE";
    PropertyType["PropertyOver10HA"] = "PROPERTY_OVER_10_HA";
    PropertyType["SemiDetachedHouse"] = "SEMI_DETACHED_HOUSE";
    PropertyType["Terrace"] = "TERRACE";
    PropertyType["Townhouse"] = "TOWNHOUSE";
    PropertyType["Land"] = "LAND";
})(PropertyType || (PropertyType = {}));
var PropertyEstimateBasis;
(function (PropertyEstimateBasis) {
    PropertyEstimateBasis["ApplicantEstimate"] = "APPLICANT_ESTIMATE";
    PropertyEstimateBasis["BankAssessment"] = "BANK_ASSESSMENT";
    PropertyEstimateBasis["CertifiedValuation"] = "CERTIFIED_VALUATION";
    PropertyEstimateBasis["ElectronicValuation"] = "ELECTRONIC_VALUATION";
    PropertyEstimateBasis["RatesNotice"] = "RATES_NOTICE";
    PropertyEstimateBasis["RPData"] = "RP_DATA";
    PropertyEstimateBasis["Valocity"] = "VALOCITY";
})(PropertyEstimateBasis || (PropertyEstimateBasis = {}));
//# sourceMappingURL=Properties.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/PurchaseReason.js
var PurchaseReason;
(function (PurchaseReason) {
    PurchaseReason["LoanApproval"] = "LOAN_APPROVAL";
    PurchaseReason["LoanEligibility"] = "LOAN_ELIGIBILITY";
    PurchaseReason["LoanAffordability"] = "LOAN_AFFORDABILITY";
})(PurchaseReason || (PurchaseReason = {}));
//# sourceMappingURL=PurchaseReason.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/PurchaseSituation.js
var PurchaseSituation;
(function (PurchaseSituation) {
    PurchaseSituation["ContractsExchanged"] = "CONTRACTS_EXCHANGED";
    PurchaseSituation["OfferMade"] = "OFFER_MADE";
    PurchaseSituation["BuyingSoon"] = "BUYING_SOON";
    PurchaseSituation["ExploringOptions"] = "EXPLORING_OPTIONS";
})(PurchaseSituation || (PurchaseSituation = {}));
//# sourceMappingURL=PurchaseSituation.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Purpose.js
var Purpose;
(function (Purpose) {
    Purpose["NewPurchase"] = "NEW_PURCHASE";
    Purpose["Refinance"] = "REFINANCE";
})(Purpose || (Purpose = {}));
var PrimaryPurpose;
(function (PrimaryPurpose) {
    PrimaryPurpose["Commercial"] = "COMMERCIAL";
    PrimaryPurpose["Construction"] = "CONSTRUCTION";
    PrimaryPurpose["ConstructionAndPurchase"] = "CONSTRUCTION_AND_PURCHASE";
    PrimaryPurpose["ConstructionAndRefinance"] = "CONSTRUCTION_AND_REFINANCE";
    PrimaryPurpose["FastRefinance"] = "FAST_REFINANCE";
    PrimaryPurpose["InternalRefinance"] = "INTERNAL_REFINANCE";
    PrimaryPurpose["NewPurchase"] = "NEW_PURCHASE";
    PrimaryPurpose["PreApproval"] = "PRE_APPROVAL";
    PrimaryPurpose["Purchase"] = "PURCHASE";
    PrimaryPurpose["PurchaseAndRefinance"] = "PURCHASE_AND_REFINANCE";
    PrimaryPurpose["Refinance"] = "REFINANCE";
    PrimaryPurpose["SLR"] = "SLR";
    PrimaryPurpose["TopUp"] = "TOP_UP";
    PrimaryPurpose["Variation"] = "VARIATION";
    PrimaryPurpose["VariationCreditCritical"] = "VARIATION_CREDIT_CRITICAL";
    PrimaryPurpose["VariationNonCreditCritical"] = "VARIATION_NON_CREDIT_CRITICAL";
})(PrimaryPurpose || (PrimaryPurpose = {}));
//# sourceMappingURL=Purpose.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/RefinancingReasons.js
var RefinancingReasons;
(function (RefinancingReasons) {
    RefinancingReasons["ConsolidateCashout"] = "CONSOLIDATE_CASHOUT";
    RefinancingReasons["FasterPayoff"] = "FASTER_PAYOFF";
    RefinancingReasons["DecreaseRepayments"] = "DECREASE_REPAYMENTS";
    RefinancingReasons["Construction"] = "CONSTRUCTION";
    // Few more from Needs & Objectives
    RefinancingReasons["CloseToTheEndOfAFixedRateOrInterestOnlyPeriod"] = "CLOSE_TO_THE_END_OF_A_FIXED_RATE_OR_INTEREST_ONLY_PERIOD";
    RefinancingReasons["ConsolidateDebtAndReduceNumberOfLenders"] = "CONSOLIDATE_DEBT_AND_REDUCE_NUMBER_OF_LENDERS";
    RefinancingReasons["DissatisfiedWithCurrentLender"] = "DISSATISFIED_WITH_CURRENT_LENDER";
    RefinancingReasons["GreaterFlexibilityOrAdditionalLoanFeatures"] = "GREATER_FLEXIBILITY_OR_ADDITIONAL_LOAN_FEATURES";
    RefinancingReasons["IncreaseLoanAmount"] = "INCREASE_LOAN_AMOUNT";
    RefinancingReasons["PayOffLoanFasterWithALowerInterestRate"] = "PAY_OFF_LOAN_FASTER_WITH_A_LOWER_INTEREST_RATE";
    RefinancingReasons["Other"] = "OTHER";
})(RefinancingReasons || (RefinancingReasons = {}));
//# sourceMappingURL=RefinancingReasons.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/RelationshipToBorrower.js
var RelationshipToBorrower;
(function (RelationshipToBorrower) {
    RelationshipToBorrower["FATHER"] = "Father";
    RelationshipToBorrower["MOTHER"] = "Mother";
    RelationshipToBorrower["SPOUSE"] = "Spouse";
    RelationshipToBorrower["BROTHER"] = "Brother";
    RelationshipToBorrower["SISTER"] = "Sister";
    RelationshipToBorrower["SON"] = "Son";
    RelationshipToBorrower["OTHER_RELATIVE"] = "Other Relative";
    RelationshipToBorrower["OTHER"] = "Other";
})(RelationshipToBorrower || (RelationshipToBorrower = {}));
//# sourceMappingURL=RelationshipToBorrower.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/RepaymentOptions.js
var RepaymentOptions;
(function (RepaymentOptions) {
    RepaymentOptions["Downsize"] = "DOWNSIZE";
    RepaymentOptions["RelyOnCoApplicantsIncome"] = "RELY_ON_CO_APPLICANTS_INCOME";
    RepaymentOptions["RepayLoanBeforeRetirement"] = "REPAY_LOAN_BEFORE_RETIREMENT";
    RepaymentOptions["SellAssets"] = "SELL_ASSETS";
    RepaymentOptions["UseIncomeFromOtherInvestments"] = "USE_INCOME_FROM_OTHER_INVESTMENTS";
    RepaymentOptions["UseSavings"] = "USE_SAVINGS";
    RepaymentOptions["UseSuperannuationLumpSum"] = "USE_SUPERANNUATION_LUMP_SUM";
    RepaymentOptions["UseSuperannuationOnGoing"] = "USE_SUPERANNUATION_ONGOING";
    RepaymentOptions["WorkPastRetirementAge"] = "WORK_PAST_RETIREMENT_AGE";
    RepaymentOptions["Other"] = "OTHER";
})(RepaymentOptions || (RepaymentOptions = {}));
//# sourceMappingURL=RepaymentOptions.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/RepaymentType.js
var RepaymentType;
(function (RepaymentType) {
    RepaymentType["InterestOnly"] = "INTEREST_ONLY";
    RepaymentType["PrincipalAndInterest"] = "PRINCIPAL_AND_INTEREST";
    RepaymentType["Both"] = "BOTH";
})(RepaymentType || (RepaymentType = {}));
//# sourceMappingURL=RepaymentType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/RepaymentTypeDetails.js
var RepaymentTypeDetails;
(function (RepaymentTypeDetails) {
    RepaymentTypeDetails["InterestOnlyDueToVariableAndUnpredictableIncome"] = "INTEREST_ONLY_DUE_TO_VARIABLE_AND_UNPREDICTABLE_INCOME";
    RepaymentTypeDetails["InterestOnlyForTaxAndAccountingPurpose"] = "INTEREST_ONLY_FOR_TAX_AND_ACCOUNTING_PURPOSE";
    RepaymentTypeDetails["InterestOnlyToAccommodateTemporaryReductionInIncome"] = "INTEREST_ONLY_TO_ACCOMMODATE_TEMPORARY_REDUCTION_IN_INCOME";
    RepaymentTypeDetails["InterestOnlyToAccommodateNonRecurringExpenses"] = "INTEREST_ONLY_TO_ACCOMMODATE_NON_RECURRING_EXPENSES";
    RepaymentTypeDetails["InterestOnlyToPayOffNonDeductibleDebtsAsAPriority"] = "INTEREST_ONLY_TO_PAY_OFF_NON_DEDUCTIBLE_DEBTS_AS_A_PRIORITY";
    RepaymentTypeDetails["DecreaseDebtOwingOnProperty"] = "DECREASE_DEBT_OWING_ON_PROPERTY";
    RepaymentTypeDetails["MaximiseBorrowingCapacityWithDepositOrAmountOfEquityAccessible"] = "MAXIMISE_BORROWING_CAPACITY_WITH_DEPOSIT_OR_AMOUNT_OF_EQUITY_ACCESSIBLE";
    RepaymentTypeDetails["PaydownPrincipleToMinimiseInterestPaidOverTime"] = "PAY_DOWN_PRINCIPAL_TO_MINIMISE_INTEREST_PAID_OVER_TIME";
    RepaymentTypeDetails["PayLowestPossibleDeposit"] = "PAY_LOWEST_POSSIBLE_DEPOSIT";
    RepaymentTypeDetails["Other"] = "OTHER";
})(RepaymentTypeDetails || (RepaymentTypeDetails = {}));
//# sourceMappingURL=RepaymentTypeDetails.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/ResidencyStatus.js
var ResidencyStatus;
(function (ResidencyStatus) {
    ResidencyStatus["AustralianCitizen"] = "AUSTRALIAN_CITIZEN";
    ResidencyStatus["PermanentResident"] = "PERMANENT_RESIDENT";
    ResidencyStatus["TemporaryResident"] = "TEMPORARY_RESIDENT";
    ResidencyStatus["Unknown"] = "UNKNOWN";
})(ResidencyStatus || (ResidencyStatus = {}));
//# sourceMappingURL=ResidencyStatus.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/States.js
var State;
(function (State) {
    State["QLD"] = "QLD";
    State["NSW"] = "NSW";
    State["VIC"] = "VIC";
    State["WA"] = "WA";
    State["SA"] = "SA";
    State["TAS"] = "TAS";
    State["ACT"] = "ACT";
    State["NT"] = "NT";
})(State || (State = {}));
//# sourceMappingURL=States.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/TeamMemberSkill.js
var TeamMemberSkill;
(function (TeamMemberSkill) {
    TeamMemberSkill["Bridging"] = "Bridging";
    TeamMemberSkill["ComplexInvestments"] = "Complex Investments";
    TeamMemberSkill["Construction"] = "Construction";
    TeamMemberSkill["DebtConsolidation"] = "Debt Consolidation";
    TeamMemberSkill["ExistingCustomer"] = "Existing Customer";
    TeamMemberSkill["Guarantor"] = "Guarantor";
    TeamMemberSkill["HighValue"] = "High Value";
    TeamMemberSkill["LoanSizeLessThan200k"] = "Loan Size < 200k";
    TeamMemberSkill["LowDoc"] = "Low Doc";
    TeamMemberSkill["NonConformingLending"] = "Non-conforming lending";
    TeamMemberSkill["PAYG"] = "PAYG";
    TeamMemberSkill["SelfEmployedPtyLtd"] = "Self Employed PTY LTD";
    TeamMemberSkill["SelfEmployedSoleTrader"] = "Self Employed sole trader";
    TeamMemberSkill["Trust"] = "Trust";
    TeamMemberSkill["SlrToHls"] = "SLR to HLS";
    TeamMemberSkill["VideoAppointment"] = "Video Appointment";
})(TeamMemberSkill || (TeamMemberSkill = {}));
//# sourceMappingURL=TeamMemberSkill.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/TeamMemberSkillLGSF.js
var TeamMemberSkillLGSF;
(function (TeamMemberSkillLGSF) {
    TeamMemberSkillLGSF["NewPurchase"] = "NEW_PURCHASE";
    TeamMemberSkillLGSF["Refinance"] = "REFINANCE";
    TeamMemberSkillLGSF["Construction"] = "CONSTRUCTION";
    TeamMemberSkillLGSF["TopUps"] = "TOP_UPS";
    TeamMemberSkillLGSF["LowDoc"] = "LOW_DOC";
    TeamMemberSkillLGSF["Bridging"] = "BRIDGING";
    TeamMemberSkillLGSF["NonConformingLoan"] = "NON_CONFORMING_LOAN";
    TeamMemberSkillLGSF["Trust"] = "TRUST";
    TeamMemberSkillLGSF["Guarantor"] = "GUARANTOR";
    TeamMemberSkillLGSF["Commercial"] = "COMMERCIAL";
    TeamMemberSkillLGSF["SelfEmployed"] = "SELF_EMPLOYED";
    TeamMemberSkillLGSF["AssetFinance"] = "ASSET_FINANCE";
})(TeamMemberSkillLGSF || (TeamMemberSkillLGSF = {}));
var TeamMemberSkillLGSFWithLabel = {
    NewPurchase: {
        value: 'NEW_PURCHASE',
        label: 'New Purchase',
    },
    Refinance: {
        value: 'REFINANCE',
        label: 'Refinance',
    },
    Construction: {
        value: 'CONSTRUCTION',
        label: 'Construction',
    },
    TopUps: {
        value: 'TOP_UPS',
        label: 'Top ups',
    },
    LowDoc: {
        value: 'LOW_DOC',
        label: 'Low Doc',
    },
    Bridging: {
        value: 'BRIDGING',
        label: 'Bridging',
    },
    NonConformingLoan: {
        value: 'NON_CONFORMING_LOAN',
        label: 'Non Conforming Loan',
    },
    Trust: {
        value: 'TRUST',
        label: 'Trust',
    },
    Guarantor: {
        value: 'GUARANTOR',
        label: 'Guarantor',
    },
    Commercial: {
        value: 'COMMERCIAL',
        label: 'Commercial',
    },
    SelfEmployed: {
        value: 'SELF_EMPLOYED',
        label: 'Self employed',
    },
    AssetFinance: {
        value: 'ASSET_FINANCE',
        label: 'Asset Finance',
    },
};
//# sourceMappingURL=TeamMemberSkillLGSF.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/TeamMemberSubSkillLGSF.js
var TeamMemberSubSkillLGSF;
(function (TeamMemberSubSkillLGSF) {
    TeamMemberSubSkillLGSF["ExistingCustomer"] = "EXISTING_CUSTOMER";
    TeamMemberSubSkillLGSF["SlrToHls"] = "SLR_TO_HLS";
    TeamMemberSubSkillLGSF["HighValue"] = "HIGH_VALUE";
    TeamMemberSubSkillLGSF["ComplexInvestment"] = "COMPLEX_INVESTMENT";
    TeamMemberSubSkillLGSF["LoanAmountUnder200k"] = "LOAN_AMOUNT_UNDER_200K";
    TeamMemberSubSkillLGSF["TestGroupA"] = "TEST_GROUP_A";
    TeamMemberSubSkillLGSF["TestGroupB"] = "TEST_GROUP_B";
    TeamMemberSubSkillLGSF["PurchaseExploringOptions"] = "PURCHASE_EXPLORING_OPTIONS";
})(TeamMemberSubSkillLGSF || (TeamMemberSubSkillLGSF = {}));
var TeamMemberSubSkillLGSFWithLabel = {
    ExistingCustomer: {
        value: 'EXISTING_CUSTOMER',
        label: 'Existing Customer',
    },
    SlrToHls: {
        value: 'SLR_TO_HLS',
        label: 'SLR to HLS',
    },
    HighValue: {
        value: 'HIGH_VALUE',
        label: 'High Value',
    },
    ComplexInvestment: {
        value: 'COMPLEX_INVESTMENT',
        label: 'Complex Investment',
    },
    LoanAmountUnder200k: {
        value: 'LOAN_AMOUNT_UNDER_200K',
        label: 'Loan amount under 200k',
    },
    TestGroupA: {
        value: 'TEST_GROUP_A',
        label: 'Test Group A',
    },
    TestGroupB: {
        value: 'TEST_GROUP_B',
        label: 'Test Group B',
    },
    PurchaseExploringOptions: {
        value: 'PURCHASE_EXPLORING_OPTIONS',
        label: 'Purchase Exploring Options',
    },
};
//# sourceMappingURL=TeamMemberSubSkillLGSF.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Title.js
var Title;
(function (Title) {
    Title["Dr"] = "DR";
    Title["Miss"] = "MISS";
    Title["Mr"] = "MR";
    Title["Mrs"] = "MRS";
    Title["Ms"] = "MS";
    Title["Other"] = "OTHER";
    Title["Unknown"] = "UNKNOWN";
})(Title || (Title = {}));
//# sourceMappingURL=Title.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/TransactionType.js
var TransactionType;
(function (TransactionType) {
    TransactionType["ConstructionLoan"] = "CONSTRUCTION_LOAN";
})(TransactionType || (TransactionType = {}));
//# sourceMappingURL=TransactionType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Urgency.js
var Urgency;
(function (Urgency) {
    Urgency["Urgent"] = "URGENT";
    Urgency["NotUrgent"] = "NOT_URGENT";
})(Urgency || (Urgency = {}));
//# sourceMappingURL=Urgency.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/UserType.js
var UserType;
(function (UserType) {
    UserType["Customer"] = "customer";
    UserType["Team"] = "team";
    UserType["M2M"] = "m2m";
})(UserType || (UserType = {}));
//# sourceMappingURL=UserType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/DynamoStream.js
var DynamoEventName;
(function (DynamoEventName) {
    DynamoEventName["Insert"] = "INSERT";
    DynamoEventName["Modify"] = "MODIFY";
    DynamoEventName["Remove"] = "REMOVE";
})(DynamoEventName || (DynamoEventName = {}));
//# sourceMappingURL=DynamoStream.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/HousingStatusList.js
var HousingStatusList;
(function (HousingStatusList) {
    HousingStatusList["Renting"] = "Renting";
    HousingStatusList["Boarding"] = "Boarding";
    HousingStatusList["Caravan"] = "Caravan";
    HousingStatusList["Other"] = "Other";
    HousingStatusList["OwnHome"] = "Own Home";
    HousingStatusList["OwnHomeMortgage"] = "Own Home Mortgage";
    HousingStatusList["SuppliedByEmployer"] = "Supplied by Employer";
    HousingStatusList["WithParents"] = "With Parents";
})(HousingStatusList || (HousingStatusList = {}));
//# sourceMappingURL=HousingStatusList.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/ExpenseTypes.js
var ExpenseTypes;
(function (ExpenseTypes) {
    ExpenseTypes["LivingExpensesEstimate"] = "LIVING_EXPENSES_ESTIMATE";
    ExpenseTypes["Groceries"] = "GROCERIES";
    ExpenseTypes["Childcare"] = "CHILDCARE";
    ExpenseTypes["ChildAndSpousalMaintenance"] = "CHILD_AND_SPOUSAL_MAINTENANCE";
    ExpenseTypes["PrimarySecondaryEducation"] = "PRIMARY_SECONDARY_EDUCATION";
    ExpenseTypes["HigherVocationalTrainingEducation"] = "HIGHER_VOCATIONAL_TRAINING_EDUCATION";
    ExpenseTypes["PrivateSchoolingAndTuition"] = "PRIVATE_SCHOOLING_AND_TUITION";
    ExpenseTypes["ClothingAndPersonalCare"] = "CLOTHING_AND_PERSONAL_CARE";
    ExpenseTypes["RecreationAndEntertainment"] = "RECREATION_AND_ENTERTAINMENT";
    ExpenseTypes["TelephoneInternetPayTvAndMediaStreamingSubscriptions"] = "TELEPHONE_INTERNET_PAY_TV_AND_MEDIA_STREAMING_SUBSCRIPTIONS";
    ExpenseTypes["PetCare"] = "PET_CARE";
    ExpenseTypes["Transport"] = "TRANSPORT";
    ExpenseTypes["BodyCorporateFeesStrataFeesAndLandTax"] = "BODY_CORPORATE_FEES_STRATA_FEES_AND_LAND_TAX";
    ExpenseTypes["PrimaryResidenceRunningCosts"] = "PRIMARY_RESIDENCE_RUNNING_COSTS";
    ExpenseTypes["InvestmentPropertyRunningCosts"] = "INVESTMENT_PROPERTY_RUNNING_COSTS";
    ExpenseTypes["SecondaryResidenceRunningCosts"] = "SECONDARY_RESIDENCE_RUNNING_COSTS";
    ExpenseTypes["Insurance"] = "INSURANCE";
    ExpenseTypes["LifeInsurance"] = "LIFE_INSURANCE";
    ExpenseTypes["HealthInsurance"] = "HEALTH_INSURANCE";
    ExpenseTypes["MedicalAndHealth"] = "MEDICAL_AND_HEALTH";
    ExpenseTypes["Rent"] = "RENT";
    ExpenseTypes["RentUtilities"] = "RENT_UTILITIES";
    ExpenseTypes["Board"] = "BOARD";
    ExpenseTypes["Other"] = "OTHER";
})(ExpenseTypes || (ExpenseTypes = {}));
//# sourceMappingURL=ExpenseTypes.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Frequency.js
var Frequency;
(function (Frequency) {
    Frequency["Fortnightly"] = "FORTNIGHTLY";
    Frequency["Monthly"] = "MONTHLY";
    Frequency["Quarterly"] = "QUARTERLY";
    Frequency["Weekly"] = "WEEKLY";
    Frequency["Yearly"] = "YEARLY";
})(Frequency || (Frequency = {}));
//# sourceMappingURL=Frequency.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/GovtBenefitTypes.js
var GovtBenefitTypes;
(function (GovtBenefitTypes) {
    GovtBenefitTypes["FamilyTax"] = "FAMILY_TAX";
    GovtBenefitTypes["AgePension"] = "AGE_PENSION";
    GovtBenefitTypes["DisabilitySupportPension"] = "DISABILITY_SUPPORT_PENSION";
    GovtBenefitTypes["Other"] = "OTHER";
})(GovtBenefitTypes || (GovtBenefitTypes = {}));
//# sourceMappingURL=GovtBenefitTypes.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/IncomeTypesAsset.js
var IncomeTypesAsset;
(function (IncomeTypesAsset) {
    IncomeTypesAsset["SelfEmployedBusinessIncome"] = "SELF_EMPLOYED_BUSINESS_INCOME";
    IncomeTypesAsset["RentalIncome"] = "RENTAL_INCOME";
    IncomeTypesAsset["InvestmentIncome"] = "INVESTMENT_INCOME";
})(IncomeTypesAsset || (IncomeTypesAsset = {}));
//# sourceMappingURL=IncomeTypesAsset.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/IncomeTypesGovt.js
var IncomeTypesGovt;
(function (IncomeTypesGovt) {
    IncomeTypesGovt["GovtBenefit"] = "GOVT_BENEFIT";
})(IncomeTypesGovt || (IncomeTypesGovt = {}));
//# sourceMappingURL=IncomeTypesGovt.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/IncomeTypesOthers.js
var IncomeTypesOthers;
(function (IncomeTypesOthers) {
    IncomeTypesOthers["SuperAnnuityPension"] = "SUPER_ANNUITY_PENSION";
    IncomeTypesOthers["WorkersCompensation"] = "WORKERS_COMPENSATION";
    IncomeTypesOthers["ForeignIncome"] = "FOREIGN_INCOME";
    IncomeTypesOthers["ChildMaintenance"] = "CHILD_MAINTENANCE";
    IncomeTypesOthers["CentrelinkBenefit"] = "CENTRELINK_BENEFIT";
    IncomeTypesOthers["OtherIncome"] = "OTHER_INCOME";
})(IncomeTypesOthers || (IncomeTypesOthers = {}));
//# sourceMappingURL=IncomeTypesOthers.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/IncomeTypesPayg.js
var IncomeTypesPayg;
(function (IncomeTypesPayg) {
    IncomeTypesPayg["BaseSalary"] = "PAYG_BASE_SALARY";
    IncomeTypesPayg["CommissionIncome"] = "PAYG_COMMISSION_INCOME";
    IncomeTypesPayg["BonusIncome"] = "PAYG_BONUS_INCOME";
    IncomeTypesPayg["OvertimeIncome"] = "PAYG_OVERTIME_INCOME";
    IncomeTypesPayg["CarAllowance"] = "PAYG_CAR_ALLOWANCE";
    IncomeTypesPayg["AllowancesTaxed"] = "PAYG_ALLOWANCES_TAXED";
    IncomeTypesPayg["AllowancesNotTaxed"] = "PAYG_ALLOWANCES_NOT_TAXED";
    IncomeTypesPayg["CompanyCar"] = "PAYG_COMPANY_CAR";
    IncomeTypesPayg["NonVoluntaryDeductionsPreTax"] = "PAYG_NON_VOLUNTARY_DEDUCTIONS_PRE_TAX";
    IncomeTypesPayg["SalarySacrifice"] = "PAYG_SALARY_SACRIFICE";
})(IncomeTypesPayg || (IncomeTypesPayg = {}));
//# sourceMappingURL=IncomeTypesPayg.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/IncomeTypesSelfEmployed.js
var IncomeTypesSelfEmployed;
(function (IncomeTypesSelfEmployed) {
    IncomeTypesSelfEmployed["SelfEmployedBusinessIncomeFullDoc"] = "SELF_EMPLOYED_BUSINESS_INCOME_FULL_DOC";
    IncomeTypesSelfEmployed["SelfEmployedBusinessIncomeLowDoc"] = "SELF_EMPLOYED_BUSINESS_INCOME_LOW_DOC";
})(IncomeTypesSelfEmployed || (IncomeTypesSelfEmployed = {}));
//# sourceMappingURL=IncomeTypesSelfEmployed.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Lenders.js
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var PARTNER_LENDERS_WITH_SHORTNAME = [
    { name: 'Adelaide Bank', shortName: 'ADE', id: 'adelaide_bank', isPartner: true },
    { name: 'AMP', shortName: 'AMP', id: 'amp', isPartner: true },
    { name: 'ANZ Bank', shortName: 'anz', id: 'anz_bank', isPartner: true },
    { name: 'Auswide Bank', shortName: 'auswide', id: 'auswide_bank', isPartner: true },
    { name: 'Bank Australia', shortName: 'BAU', id: 'bank_australia', isPartner: true },
    { name: 'Bank First', shortName: 'BF', id: 'bank_first', isPartner: true },
    { name: 'Bankwest', shortName: 'bankwest', id: 'bank_west', isPartner: true },
    { name: 'Bluebay Home Loans', shortName: 'BLB', id: 'bluebay_home_loans', isPartner: true },
    { name: 'Better Mortgage Mgmt', shortName: 'BMM', id: 'better_mortgage_mgmt', isPartner: true },
    { name: 'Bank of Melbourne', shortName: 'bom', id: 'bank_of_melbourne', isPartner: true },
    { name: 'Bank SA', shortName: 'BSA', id: 'bank_sa', isPartner: true },
    { name: 'Bluestone', shortName: 'BST', id: 'blue_stone', isPartner: true },
    { name: 'Commonwealth Bank', shortName: 'CBA', id: 'commonwealth_bank', isPartner: true },
    { name: 'Connective Home Loans', shortName: 'CHLA', id: 'connective_home_loans', isPartner: true },
    { name: 'Citibank', shortName: 'citibank', id: 'citi_bank', isPartner: true },
    { name: 'Click Loans', shortName: 'Click_loans', id: 'click_loans', isPartner: true },
    { name: 'Firstmac', shortName: 'FMC', id: 'first_mac', isPartner: true },
    { name: 'Gateway Bank', shortName: 'GCU', id: 'gateway_bank', isPartner: true },
    { name: 'Heritage', shortName: 'heritage', id: 'heritage', isPartner: true },
    { name: 'Better Choice', shortName: 'IDE', id: 'better_choice', isPartner: true },
    { name: 'ING', shortName: 'ing', id: 'ing', isPartner: true },
    { name: 'Laboratories Credit Union', shortName: 'LCU', id: 'laboratories_credit_union', isPartner: true },
    { name: 'LaTrobe', shortName: 'La_Trobe', id: 'la_trobe', isPartner: true },
    { name: 'Loanave', shortName: 'LOA', id: 'loanave', isPartner: true },
    { name: 'Macquarie', shortName: 'macquarie', id: 'macquarie', isPartner: true },
    { name: 'ME Bank', shortName: 'mebank', id: 'me_bank', isPartner: true },
    { name: 'MKM Capital', shortName: 'MKM', id: 'mkm_capital', isPartner: true },
    { name: 'My State Bank', shortName: 'mystate', id: 'my_state_bank', isPartner: true },
    { name: 'NAB', shortName: 'NAB', id: 'nab', isPartner: true },
    {
        name: 'Newcastle Permanent Building Society',
        shortName: 'newcastle',
        id: 'newcastle_permanent_building_society',
        isPartner: true,
    },
    { name: 'Paramount', shortName: 'PAM', id: 'paramount', isPartner: true },
    { name: 'Pepper', shortName: 'pepper', id: 'pepper', isPartner: true },
    { name: 'P&N Bank', shortName: 'pnbank', id: 'pn_bank', isPartner: true },
    { name: 'RESIMAC', shortName: 'Resimac', id: 'resimac', isPartner: true },
    { name: 'St George', shortName: 'stgeorge', id: 'st_george', isPartner: true },
    { name: 'Suncorp', shortName: 'suncorp', id: 'suncorp', isPartner: true },
    { name: 'Teachers Mutual', shortName: 'TMB', id: 'teachers_mutual', isPartner: true },
    { name: 'Virgin Money', shortName: 'VMY', id: 'virgin_money', isPartner: true },
    { name: 'Westpac Bank', shortName: 'Westpac', id: 'westpac_bank', isPartner: true },
    {
        name: 'Connective Home Loans Select ',
        shortName: 'CHLAB',
        id: 'connective_home_loans_select_adelaide',
        isPartner: true,
    },
];
var PARTNER_LENDERS_WITHOUT_SHORTNAME = [
    { name: 'Pacific Mortgage Group', shortName: '', id: 'pacific_mortgage_group', isPartner: true },
    { name: 'Gateway Credit Union', shortName: '', id: 'gateway_credit_union', isPartner: true },
];
var PARTNER_LENDERS = __spreadArray(__spreadArray([], PARTNER_LENDERS_WITH_SHORTNAME, true), PARTNER_LENDERS_WITHOUT_SHORTNAME, true);
var NON_PARTNER_WITH_SHORTNAME = [
    { name: 'AAMI', shortName: 'AAMI', id: 'aami', isPartner: false },
    { name: 'AAPBS Settlements Services', shortName: 'AAPBS', id: 'aapbs_ settlements_services', isPartner: false },
    { name: 'Arab Bank of Australia', shortName: 'ABAL', id: 'arab_bank_of_australia', isPartner: false },
    { name: 'ABN AMRO', shortName: 'ABN AMRO', id: 'abn_amro', isPartner: false },
    { name: 'Australia Central Credit Union', shortName: 'ACCU', id: 'australia_central_credit_union', isPartner: false },
    {
        name: 'Australian Defence Credit Union',
        shortName: 'ADCU',
        id: 'australian_defence_credit_union',
        isPartner: false,
    },
    { name: 'Advantedge', shortName: 'Advantedge', id: 'advantedge', isPartner: false },
    { name: 'AFG Home Loans', shortName: 'AFG', id: 'afg_home_loans', isPartner: false },
    { name: 'Australian First Mortgage', shortName: 'AFM', id: 'australian_first_mortgage', isPartner: false },
    { name: 'Australian Military Bank', shortName: 'AMB', id: 'australian_military_bank', isPartner: false },
    { name: 'Australian Mortgage Options', shortName: 'AMO', id: 'australian_mortgage_options', isPartner: false },
    { name: 'AGC', shortName: 'AGC', id: 'agc', isPartner: false },
    { name: 'AIMS Home Loans', shortName: 'AIMS', id: 'aims', isPartner: false },
    { name: 'Allianz', shortName: 'ALV', id: 'allianz', isPartner: false },
    { name: 'AMG', shortName: 'AMG', id: 'amg', isPartner: false },
    { name: 'AMIC', shortName: 'AMIC', id: 'amic', isPartner: false },
    { name: 'AMIST', shortName: 'AMIST', id: 'amist', isPartner: false },
    { name: 'AMS', shortName: 'AMS', id: 'ams', isPartner: false },
    { name: 'Aon Master Trust', shortName: 'AON', id: 'aon_master_trust', isPartner: false },
    { name: 'API', shortName: 'API', id: 'api', isPartner: false },
    { name: 'Athena Home Loans', shortName: 'Athena', id: 'athena_home_loans', isPartner: false },
    {
        name: 'Australian Unity Building Society',
        shortName: 'AUBS',
        id: 'australian_unity_building_society',
        isPartner: false,
    },
    { name: 'Aussie Activate', shortName: 'AUSPEPPER', id: 'aussie_activate', isPartner: false },
    { name: 'Aussie Elevate', shortName: 'AUSADE', id: 'aussie_elevate', isPartner: false },
    { name: 'Aussie Home Loans', shortName: 'Aussie', id: 'aussie_home_loans', isPartner: false },
    { name: 'Aussie Select', shortName: 'AUSCBA', id: 'aussie_select', isPartner: false },
    { name: 'AVCO', shortName: 'AVCO', id: 'avco', isPartner: false },
    { name: 'AWA Alliance Bank', shortName: 'AWA', id: 'awa_alliance_bank', isPartner: false },
    { name: 'AXA', shortName: 'AXA', id: 'axa', isPartner: false },
    { name: 'American Express', shortName: 'AMEX', id: 'american_express', isPartner: false },
    { name: 'Bank of America', shortName: 'BAC', id: 'bank_of_america', isPartner: false },
    { name: 'B&E', shortName: 'bande', id: 'bande', isPartner: false },
    { name: 'Bank mecu', shortName: 'bankmecu', id: 'bank_mecu', isPartner: false },
    { name: 'Bank of Sydney', shortName: 'banksyd', id: 'bank_of_sydney', isPartner: false },
    { name: 'Bank Vic', shortName: 'bankvic', id: 'bank_vic', isPartner: false },
    { name: 'Barclays', shortName: 'BARC', id: 'barclays', isPartner: false },
    { name: 'BCU', shortName: 'bcu', id: 'bcu', isPartner: false },
    { name: 'BDCU Alliance Bank', shortName: 'BDCUAB', id: 'bdcu_alliance_bank', isPartner: false },
    {
        name: 'Bass and Equitable Building Society',
        shortName: 'BEBS',
        id: 'bass_and_equitable_building_society',
        isPartner: false,
    },
    { name: 'Bendigo Bank', shortName: 'bendigo', id: 'bendigo_bank', isPartner: false },
    { name: 'Beyond Bank Australia', shortName: 'beyondbank', id: 'beyond_bank_australia', isPartner: false },
    {
        name: 'Broken Hill Community Credit Union',
        shortName: 'BHCCU',
        id: 'broken_hill_community_credit_union',
        isPartner: false,
    },
    { name: 'Bigsky Building Society', shortName: 'bigsky', id: 'bigsky_building_society', isPartner: false },
    { name: 'Better Mortgage Corporation', shortName: 'BMMC', id: 'better_mortgage_corporation', isPartner: false },
    { name: 'BMW Australia', shortName: 'BMW', id: 'bmw_australia', isPartner: false },
    { name: 'Banque Nationale De Paris', shortName: 'BNP', id: 'banque_nationale_de_paris', isPartner: false },
    { name: 'Bank of China', shortName: 'BOC', id: 'bank_of_china', isPartner: false },
    { name: 'Bank of Heritage Isle', shortName: 'BOCHI', id: 'bank_of_heritage_isle', isPartner: false },
    { name: 'Bank of Queensland', shortName: 'boq', id: 'bank_of_queensland', isPartner: false },
    { name: 'Bankers Trust Australia', shortName: 'BTA', id: 'bankers_trust_australia', isPartner: false },
    { name: 'BankVic', shortName: 'BV', id: 'bankvic', isPartner: false },
    { name: 'Mutual Community', shortName: 'Bupa', id: 'mutual_community', isPartner: false },
    { name: 'BUSSQ', shortName: 'BUSSQ', id: 'bussq', isPartner: false },
    { name: 'CBFC', shortName: 'CBFC', id: 'cbfc', isPartner: false },
    { name: 'CBUS', shortName: 'CBUS', id: 'cbus', isPartner: false },
    { name: 'Central West Credit Union', shortName: 'CWCU', id: 'central_west_credit_union', isPartner: false },
    { name: 'City Coast Credit Union', shortName: 'CCCU', id: 'city_coast_credit_union', isPartner: false },
    { name: 'Circle Credit Union', shortName: 'CCU', id: 'circle_credit_union', isPartner: false },
    { name: 'CGU', shortName: 'CGU', id: 'cgu', isPartner: false },
    { name: 'CHU', shortName: 'CHU', id: 'chu', isPartner: false },
    { name: 'CIC', shortName: 'CIC', id: 'cic', isPartner: false },
    { name: 'CIL', shortName: 'CIL', id: 'cil', isPartner: false },
    { name: 'Circle Alliance Bank', shortName: 'CAB', id: 'circle_alliance_bank', isPartner: false },
    { name: 'CIT Credit Pty', shortName: 'CIT', id: 'cit_credit_pty', isPartner: false },
    { name: 'Club Plus Super', shortName: 'CLB', id: 'clb_plus_super', isPartner: false },
    { name: 'Challenge Bank', shortName: 'CLG', id: 'challenge_bank', isPartner: false },
    {
        name: 'Community First Credit Union',
        shortName: 'communityfirst',
        id: 'comunity_first_credit_union',
        isPartner: false,
    },
    { name: 'Credit Union Australia', shortName: 'cua', id: 'credit_union_australia', isPartner: false },
    {
        name: 'Credit Union Financial Services',
        shortName: 'CUFS',
        id: 'credit_union_financial_services',
        isPartner: false,
    },
    { name: 'Coastline Credit Union', shortName: 'CUS', id: 'coastline_credit_union', isPartner: false },
    { name: 'Deutsche Bank', shortName: 'DBK', id: 'deutsche_bank', isPartner: false },
    { name: 'Diners Club', shortName: 'DCI', id: 'diners_club', isPartner: false },
    { name: 'Defence Bank', shortName: 'defencebank', id: 'defence_bank', isPartner: false },
    { name: 'ECU', shortName: 'ECU', id: 'ecu', isPartner: false },
    { name: 'EECU', shortName: 'EECU', id: 'eecu', isPartner: false },
    { name: 'Elders', shortName: 'EFP', id: 'elders', isPartner: false },
    { name: 'EISS', shortName: 'EISS', id: 'eiss', isPartner: false },
    { name: 'Fundcorp', shortName: 'FCI', id: 'fundcorp', isPartner: false },
    { name: 'Firefighters mutual bank', shortName: 'FMB', id: 'firefighters_mutual_bank', isPartner: false },
    { name: 'Genworth', shortName: 'Genworth', id: 'genworth', isPartner: false },
    { name: 'GIO', shortName: 'GIO', id: 'gio', isPartner: false },
    { name: 'Goldfields Money', shortName: 'goldfields_money', id: 'gmac_finance', isPartner: false },
    { name: 'Great Pacific Financial', shortName: 'GPF', id: 'great_pacific_financial', isPartner: false },
    { name: 'Great Southern Bank', shortName: 'GSB', id: 'great_southern_bank', isPartner: false },
    { name: 'GRE', shortName: 'GRE', id: 'gre', isPartner: false },
    { name: 'Guild', shortName: 'Guild', id: 'guild', isPartner: false },
    { name: 'HBF', shortName: 'HBF', id: 'hbf', isPartner: false },
    { name: 'HESTA', shortName: 'Hesta', id: 'hesta', isPartner: false },
    { name: 'Holiday Coast Credit Union', shortName: 'HCCU', id: 'holiday_coast_credit_union', isPartner: false },
    { name: 'Homeloans Ltd', shortName: 'HLLC', id: 'homeloans_ltd', isPartner: false },
    { name: 'HSBC', shortName: 'hsbc', id: 'hsbc', isPartner: false },
    { name: 'Hume Building Society', shortName: 'Hume', id: 'hume_building_society', isPartner: false },
    { name: 'International Acceptance', shortName: 'IA', id: 'international_acceptance', isPartner: false },
    {
        name: 'International Commercial Bank of China',
        shortName: 'ICBC',
        id: 'international_commercial_bank_of_china',
        isPartner: false,
    },
    { name: 'IDEG', shortName: 'IDEG', id: 'ideg', isPartner: false },
    { name: 'Illawarra Credit Union', shortName: 'illawarra', id: 'illawarra_credit_union', isPartner: false },
    { name: 'IMB Ltd', shortName: 'imb', id: 'imb_ltd', isPartner: false },
    { name: 'ING Direct', shortName: 'INGC', id: 'ing_direct', isPartner: false },
    { name: 'IOOF Building Society', shortName: 'IOOF', id: 'ioof_building_society', isPartner: false },
    { name: 'Keystart Home Loans', shortName: 'KST', id: 'keystart_home_loans', isPartner: false },
    { name: 'Kwik Kash International', shortName: 'Kwik Kash', id: 'kwik_kash_international', isPartner: false },
    { name: 'Local Government', shortName: 'LGS', id: 'local_government', isPartner: false },
    { name: 'Liberty', shortName: 'liberty', id: 'liberty', isPartner: false },
    { name: 'Lombard Finance', shortName: 'Lombard', id: 'lombard_finance', isPartner: false },
    { name: 'LUCRF Super', shortName: 'LUCRF', id: 'lucrf_super', isPartner: false },
    { name: 'Macquarie Credit Union', shortName: 'macquariecu', id: 'macquarie_credit_union', isPartner: false },
    { name: 'MAP', shortName: 'MAP', id: 'map', isPartner: false },
    { name: 'Mediplan Australia', shortName: 'Mediplan', id: 'mediplan_australia', isPartner: false },
    { name: 'Mercantile Mutual', shortName: 'MERC', id: 'mercantile_mutual', isPartner: false },
    { name: 'Mercer Wealth', shortName: 'Mercer', id: 'mercer_wealth', isPartner: false },
    { name: 'Midland Bank PLC', shortName: 'Midland', id: 'midland_bank_plc', isPartner: false },
    { name: 'Mine Wealth and Wellbeing', shortName: 'Mine Super', id: 'mine_wealth_and_wellbeing', isPartner: false },
    { name: 'MIP', shortName: 'MIP', id: 'mip', isPartner: false },
    { name: 'MIS', shortName: 'MIS', id: 'mis', isPartner: false },
    { name: 'MLC', shortName: 'MLC', id: 'mlc', isPartner: false },
    { name: 'MMI', shortName: 'MMI', id: 'mmi', isPartner: false },
    { name: 'MTAA', shortName: 'MTAA', id: 'mtaa', isPartner: false },
    { name: 'My Credit Union', shortName: 'mycredit', id: 'my_credit_union', isPartner: false },
    { name: 'NSF Super', shortName: 'Nationwide', id: 'nsf_super', isPartner: false },
    { name: 'Natwest Markets Australia', shortName: 'Natwest', id: 'natwest_markets_australia', isPartner: false },
    { name: 'Northern Building Society', shortName: 'NBS', id: 'northern_building_society', isPartner: false },
    { name: 'Northern Inland Credit Union', shortName: 'NICU', id: 'northern_inland_credit_union', isPartner: false },
    { name: 'NGS', shortName: 'NGS', id: 'ngs', isPartner: false },
    { name: 'National Mortgage Company', shortName: 'nmc', id: 'national_mortgage_company', isPartner: false },
    { name: 'NRMA', shortName: 'NRMA', id: 'nrma', isPartner: false },
    { name: 'NZI', shortName: 'NZI', id: 'nzi', isPartner: false },
    { name: 'OneTwo', shortName: 'OneTwo', id: 'one_two', isPartner: false },
    {
        name: 'Overseas-Chinese Banking Corporation',
        shortName: 'OCBC Bank',
        id: 'overseas_chinese_banking_corporation',
        isPartner: false,
    },
    { name: 'Origin Finance', shortName: 'Origin', id: 'origin_finance', isPartner: false },
    { name: 'Origin MMS', shortName: 'OriginMMS', id: 'origin_mms', isPartner: false },
    {
        name: 'Pioneer Permanent Building Society',
        shortName: 'PBS',
        id: 'pioneer_permanent_building_society',
        isPartner: false,
    },
    {
        name: "People's Choice Credit Union",
        shortName: 'peopleschoicecu',
        id: 'peoples_choice_credit_union',
        isPartner: false,
    },
    { name: 'Perpetual Limited', shortName: 'Perpetual', id: 'perpetual_limited', isPartner: false },
    { name: 'Plum', shortName: 'Plum', id: 'plum', isPartner: false },
    { name: 'Police Credit Union', shortName: 'policecu', id: 'police_credit_union', isPartner: false },
    { name: 'QANTAS Credit Union', shortName: 'qantas', id: 'qantas_credit_union', isPartner: false },
    { name: 'QBE', shortName: 'QBE', id: 'qbe', isPartner: false },
    {
        name: 'Queensland Country Credit Union',
        shortName: 'QCCU',
        id: 'queensland_country_credit_union',
        isPartner: false,
    },
    { name: 'RAC', shortName: 'RAC', id: 'rac', isPartner: false },
    { name: 'RACV', shortName: 'RACV', id: 'racv', isPartner: false },
    { name: 'RAMS', shortName: 'rams', id: 'rams', isPartner: false },
    { name: 'Reserve Bank of Australia', shortName: 'RBA', id: 'reserve_bank_of_australia', isPartner: false },
    { name: 'REA Home Loans', shortName: 'REA', id: 'rea_home_loans', isPartner: false },
    { name: 'Safrock Finance', shortName: 'Safrock', id: 'safrock_finance', isPartner: false },
    { name: 'Suncorp Metway', shortName: 'SCMC', id: 'suncorp_metway', isPartner: false },
    { name: 'SGIC', shortName: 'SGIC', id: 'sgic', isPartner: false },
    { name: 'SGIO', shortName: 'SGIO', id: 'sgio', isPartner: false },
    {
        name: 'State Street Bank And Trust Company',
        shortName: 'state street',
        id: 'state_street_bank_and_trust_company',
        isPartner: false,
    },
    { name: 'Summerland Credit Union', shortName: 'Summerland', id: 'summerland_credit_union', isPartner: false },
    { name: 'Macarthur Credit Union', shortName: 'The MAC', id: 'macarthur_credit_union', isPartner: false },
    {
        name: 'Maitland Mutual Building Society',
        shortName: 'The Mutual',
        id: 'maitland_mutual_building_society',
        isPartner: false,
    },
    {
        name: 'Thinktank lending commercial finance',
        shortName: 'Thinktank',
        id: 'thinktank_lending_commercial_finance',
        isPartner: false,
    },
    { name: 'Tictoc Online', shortName: 'Tictoc', id: 'tictoc_online', isPartner: false },
    { name: 'Tic:Toc Home Loans', shortName: 'Tictoc', id: 'tictoc_home_loans', isPartner: false },
    { name: 'Trust Bank of Tasmania', shortName: 'Trust Bank', id: 'trust_bank_of_tasmania', isPartner: false },
    { name: 'Unibank', shortName: 'Uni', id: 'unibank', isPartner: false },
    { name: 'United Overseas Bank', shortName: 'UOB', id: 'united_overseas_bank', isPartner: false },
    {
        name: 'Victoria Teachers Credit Union Ltd',
        shortName: 'victeach',
        id: 'victeach_teachers_credit_union_ltd',
        isPartner: false,
    },
    { name: 'Credit Corp', shortName: 'CCFS', id: 'credit_corp', isPartner: false },
    { name: 'Credit Union SA', shortName: 'CUSA', id: 'credit_union_sa', isPartner: false },
    { name: 'Family First Credit Union', shortName: 'FFCU', id: 'family_first_credit_union', isPartner: false },
    { name: 'Fox Symes', shortName: 'FS', id: 'fox_symes', isPartner: false },
    { name: 'Freedom Lend', shortName: 'FL', id: 'freedom_lend', isPartner: false },
    { name: 'Lysaght Credit Union', shortName: 'LCU', id: 'lysaght_credit_union', isPartner: false },
    { name: 'Police Credit Union (NSW)', shortName: 'policecu', id: 'police_credit_union_nsw', isPartner: false },
    { name: 'The Rock', shortName: 'RBS', id: 'the_rock', isPartner: false },
    { name: 'Zip Co', shortName: 'Zip', id: 'zip', isPartner: false },
    { name: 'Plenti', shortName: 'Plenti', id: 'plenti', isPartner: false },
    { name: 'Latitude Financial', shortName: 'Latitude', id: 'latitude', isPartner: false },
    { name: 'Cash Converters', shortName: 'Cash Converters', id: 'cash_converters', isPartner: false },
    { name: 'Nimble', shortName: 'Nimble', id: 'nimble', isPartner: false },
    { name: 'SocietyOne', shortName: 'SocietyOne', id: 'societyone', isPartner: false },
    { name: 'MoneyMe', shortName: 'mme', id: 'moneyme', isPartner: false },
    { name: 'Harmoney', shortName: 'Harmoney', id: 'harmoney', isPartner: false },
    { name: 'Afterpay', shortName: 'Afterpay', id: 'afterpay', isPartner: false },
    {
        name: 'Australian Pensioners Insurance',
        shortName: 'API',
        id: 'australian_pensioners_insurance',
        isPartner: false,
    },
    { name: 'Cash Converters ', shortName: 'Cash Converters', id: 'cash_converters_', isPartner: false },
    { name: 'Iden Group', shortName: 'Iden', id: 'iden_group', isPartner: false },
    { name: 'Members Equity Bank', shortName: 'ME Bank', id: 'members_equity_bank', isPartner: false },
    { name: 'National Mortgage Corporation', shortName: 'NMC', id: 'national_mortgage_corporation', isPartner: false },
    { name: 'Queensland Credit Union', shortName: 'QCU', id: 'queensland_credit_union', isPartner: false },
    {
        name: 'Queensland Professional Credit Union',
        shortName: 'QPCU',
        id: 'queensland_professional_credit_union',
        isPartner: false,
    },
    { name: 'Think Tank Group Pty Ltd', shortName: 'Think Tank', id: 'think_tank_group_pty_ltd', isPartner: false },
    {
        name: 'Volkswagon Financial Services',
        shortName: 'VW Finance',
        id: 'volkswagon_financial_services',
        isPartner: false,
    },
    { name: 'Zip Co', shortName: 'zip', id: 'zip_co', isPartner: false },
];
var NON_PARTNER_WITHOUT_SHORTNAME = [
    { name: 'CommBank Financial Planner', shortName: '', id: 'commBank_financial_planner', isPartner: false },
    { name: 'Homeloans.com.au', shortName: '', id: 'homeloans_com_au', isPartner: false },
    { name: 'Horizon Bank', shortName: '', id: 'horizon_bank', isPartner: false },
    { name: 'Loans.com.au', shortName: '', id: 'loans_com_au', isPartner: false },
    { name: 'Nova Alliance Bank', shortName: '', id: 'nova_alliance_bank', isPartner: false },
    { name: 'QBank', shortName: '', id: 'qbank', isPartner: false },
    { name: 'Reduce', shortName: '', id: 'reduce', isPartner: false },
    { name: 'Regional Australia Bank', shortName: '', id: 'regional_australia_bank', isPartner: false },
    { name: 'Unity Bank', shortName: '', id: 'unity_bank', isPartner: false },
    { name: 'Allstate Home Loans', shortName: '', id: 'allstate_home_loans', isPartner: false },
    { name: 'ANZ Wealth', shortName: '', id: 'anz_wealth', isPartner: false },
    { name: 'Armidale Building Society', shortName: '', id: 'armidale_building_society', isPartner: false },
    { name: 'Asahi Bank', shortName: '', id: 'asahi_bank', isPartner: false },
    { name: 'Assured', shortName: '', id: 'assured', isPartner: false },
    { name: 'Athena', shortName: '', id: 'athena', isPartner: false },
    { name: 'Aussie Mastercard', shortName: '', id: 'aussie_mastercard', isPartner: false },
    { name: 'Aussie Mortgage Ltd', shortName: '', id: 'aussie_mortgage', isPartner: false },
    { name: 'Aust Alliance', shortName: '', id: 'aust_alliance', isPartner: false },
    { name: 'Austral Mortgage', shortName: '', id: 'austral_mortgage', isPartner: false },
    { name: 'Australian Ethical', shortName: '', id: 'australian _ethical', isPartner: false },
    { name: 'AustralianSuper', shortName: '', id: 'australian_super', isPartner: false },
    { name: 'AustSafe', shortName: '', id: 'aust_safe', isPartner: false },
    { name: 'Australian Catholic', shortName: '', id: 'australian_catholic', isPartner: false },
    { name: 'Australian Eagle', shortName: '', id: 'australian_eagle', isPartner: false },
    { name: 'AV Super', shortName: '', id: 'av_super', isPartner: false },
    { name: 'Bank of Tokyo-Mitsubishi', shortName: '', id: 'bank_of_tokyo_mitsubishi', isPartner: false },
    { name: 'Barnes Home Loans', shortName: '', id: 'barnes_home_loans', isPartner: false },
    { name: 'Brighten Home Loans', shortName: '', id: 'brighten_ome_loans', isPartner: false },
    { name: 'Building Society MP', shortName: '', id: 'building_society_mp', isPartner: false },
    { name: 'Buyers Edge', shortName: '', id: 'buyers_edge', isPartner: false },
    { name: 'Capital Finance', shortName: '', id: 'capital_finance', isPartner: false },
    { name: 'Capricornia Credit Union', shortName: '', id: 'capricornia_credit_union', isPartner: false },
    { name: 'CareSuper', shortName: '', id: 'care_super', isPartner: false },
    { name: 'Cash Doctors', shortName: '', id: 'cash_doctors', isPartner: false },
    { name: 'Catalyst Money', shortName: '', id: 'catalyst_money', isPartner: false },
    { name: 'Catholic Church', shortName: '', id: 'catholic_church', isPartner: false },
    { name: 'Catholic Super', shortName: '', id: 'catholic_super', isPartner: false },
    { name: 'Certegy', shortName: '', id: 'certegy', isPartner: false },
    { name: 'Chase Manhattan Bank', shortName: '', id: 'chase_manhattan_bank', isPartner: false },
    { name: 'Chequecash Pty Ltd', shortName: '', id: 'chequecash_pty_ltd', isPartner: false },
    { name: 'ChoiceLend', shortName: '', id: 'choiceLend', isPartner: false },
    { name: 'Christian Super', shortName: '', id: 'christian_super', isPartner: false },
    { name: 'Citywide Home Loans', shortName: '', id: 'citywide_home_loans', isPartner: false },
    { name: 'Co Operative Ins Co', shortName: '', id: 'co_operative_ins_co', isPartner: false },
    { name: 'Colonial First State', shortName: '', id: 'colonial_first_state', isPartner: false },
    { name: 'Colonial Mutual', shortName: '', id: 'colonial_mutual', isPartner: false },
    { name: 'Colonial', shortName: '', id: 'colonial', isPartner: false },
    { name: 'Commercial Union', shortName: '', id: 'commercial_union', isPartner: false },
    { name: 'CommInsure', shortName: '', id: 'commInsure', isPartner: false },
    { name: 'CPS Credit Union', shortName: '', id: 'cps_ credit Union', isPartner: false },
    { name: 'Credit Union Settlement Services', shortName: '', id: 'credit_union_settlement_services', isPartner: false },
    { name: 'Cumis', shortName: '', id: 'cumis', isPartner: false },
    { name: 'Cuscal', shortName: '', id: 'Cuscal', isPartner: false },
    { name: 'Custom Credit', shortName: '', id: 'custom_credit', isPartner: false },
    { name: 'Dai-Ichi Kango Bank', shortName: '', id: 'dai_ichi_kango_bank', isPartner: false },
    { name: 'Daimlerchrysler Finance', shortName: '', id: 'daimlerchrysler_finance', isPartner: false },
    { name: 'Debt Purchase Australia', shortName: '', id: 'debt_purchase_australia', isPartner: false },
    { name: 'Defence Credit', shortName: '', id: 'defence_credit', isPartner: false },
    {
        name: 'Defence Force Credit Union Limited',
        shortName: '',
        id: 'defence_force_credit_union_limited',
        isPartner: false,
    },
    { name: 'Defence Services Homes', shortName: '', id: 'defence_services_homes', isPartner: false },
    { name: 'Delphi Bank', shortName: '', id: 'delphi_bank', isPartner: false },
    {
        name: 'Dnister Ukrainian Credit Co-operative',
        shortName: '',
        id: 'dnister_ukrainian_credit_co_operative',
        isPartner: false,
    },
    { name: 'Easy Street Financial Services', shortName: '', id: 'easy_street_financial_services', isPartner: false },
    { name: 'ELCOM Credit Union', shortName: '', id: 'elcom_credit_union', isPartner: false },
    { name: 'Energy Super', shortName: '', id: 'energy_super', isPartner: false },
    { name: 'Equity Super', shortName: '', id: 'equity_super', isPartner: false },
    { name: 'Esanda', shortName: '', id: 'esanda', isPartner: false },
    { name: 'Essential Super', shortName: '', id: 'essential_super', isPartner: false },
    { name: 'Ezy Bank', shortName: '', id: 'ezy_bank', isPartner: false },
    { name: 'FAI', shortName: '', id: 'fai', isPartner: false },
    { name: 'FASTLend', shortName: '', id: 'fastlend', isPartner: false },
    { name: 'Federation', shortName: '', id: 'federation', isPartner: false },
    { name: 'FinancePath', shortName: '', id: 'finance_path', isPartner: false },
    { name: 'Fire Brigades Credit Union', shortName: '', id: 'fire_brigades_credit_union', isPartner: false },
    { name: 'Fire Service Credit Union', shortName: '', id: 'fire_service_credit_union', isPartner: false },
    { name: 'First Choice Credit Union', shortName: '', id: 'first_choice_credit_union', isPartner: false },
    { name: 'First National Bank of Chicago', shortName: '', id: 'first_national_bank_of_chicago', isPartner: false },
    { name: 'First Option Bank', shortName: '', id: 'first_option_bank', isPartner: false },
    { name: 'First Permanent Home Loans', shortName: '', id: 'first_permanent_home_loans', isPartner: false },
    {
        name: 'First Provincial Building Society',
        shortName: '',
        id: 'first_provincial_building_society',
        isPartner: false,
    },
    { name: 'First State Super', shortName: '', id: 'first_state_super', isPartner: false },
    { name: 'First Super', shortName: '', id: 'first_super', isPartner: false },
    { name: 'Flexirent', shortName: '', id: 'flexirent', isPartner: false },
    { name: 'Ford Credit', shortName: '', id: 'ford_credit', isPartner: false },
    { name: 'Fortis', shortName: '', id: 'fortis', isPartner: false },
    { name: 'Future Financial', shortName: '', id: 'future_financial', isPartner: false },
    { name: 'G&C Mutual Bank', shortName: '', id: 'gc_mutual_bank', isPartner: false },
    { name: 'GE Automotive', shortName: '', id: 'ge_automotive', isPartner: false },
    {
        name: 'GE Capital Finance (Go Mastercard)',
        shortName: '',
        id: 'ge_capital_finance_go_mastercard',
        isPartner: false,
    },
    { name: 'GE Capital Finance', shortName: '', id: 'ge_capital_finance', isPartner: false },
    { name: 'GE Credit Line', shortName: '', id: 'ge_credit_line', isPartner: false },
    { name: 'Ge Finance', shortName: '', id: 'ge_finance', isPartner: false },
    { name: 'GE Money Aust Pty Ltd', shortName: '', id: 'ge_money_aust_pty_ltd', isPartner: false },
    { name: 'GE Mortgages', shortName: '', id: 'ge_mortgages', isPartner: false },
    { name: 'Geelong Bank', shortName: '', id: 'geelong_bank', isPartner: false },
    { name: 'GIO Building Society', shortName: '', id: 'gio_building_society', isPartner: false },
    { name: 'Grace Bros', shortName: '', id: 'grace_bros', isPartner: false },
    { name: 'Greater Building Society', shortName: '', id: 'greater_building_society', isPartner: false },
    { name: 'Hanover Consumer Finance', shortName: '', id: 'hanover_consumer_finance', isPartner: false },
    { name: 'Home Building Society', shortName: '', id: 'home_building_society', isPartner: false },
    { name: 'Homeside', shortName: '', id: 'homeside', isPartner: false },
    { name: 'Homestar Finance', shortName: '', id: 'homestar_finance', isPartner: false },
    { name: 'Homestart Finance', shortName: 'HST', id: 'homestart_finance', isPartner: false },
    { name: 'Homeswest', shortName: '', id: 'homeswest', isPartner: false },
    { name: 'Hunter United', shortName: '', id: 'hunter_united', isPartner: false },
    { name: 'IBJ Australia Bank', shortName: '', id: 'ibj_australia_bank', isPartner: false },
    { name: 'Ignite', shortName: '', id: 'ignite', isPartner: false },
    { name: 'Illawarra Building Society', shortName: '', id: 'illawarra_building_society', isPartner: false },
    { name: 'INC Invest', shortName: '', id: 'inc_invest', isPartner: false },
    { name: 'ING Mercantile Mutual Bank', shortName: '', id: 'ing_mercantile_mutual_bank', isPartner: false },
    { name: 'Intech Credit Union', shortName: '', id: 'intech_credit_union', isPartner: false },
    { name: 'InTrust', shortName: '', id: 'in_trust', isPartner: false },
    { name: 'Investec', shortName: '', id: 'investec', isPartner: false },
    { name: 'Kinetic', shortName: '', id: 'kinetic', isPartner: false },
    { name: 'Legal Super', shortName: '', id: 'legal_super', isPartner: false },
    { name: 'Lion Finance', shortName: '', id: 'lion_finance', isPartner: false },
    { name: 'M Capitol', shortName: '', id: 'm_capitol', isPartner: false },
    {
        name: 'Mackay Permanent Building Society',
        shortName: '',
        id: 'mackay_permanent_building_society',
        isPartner: false,
    },
    { name: 'Manufacture Mutual', shortName: '', id: 'manufacture_mutual', isPartner: false },
    { name: 'Media Super', shortName: '', id: 'media_super', isPartner: false },
    { name: 'Mitchell Building Society', shortName: '', id: 'mitchell_building_society', isPartner: false },
    {
        name: 'Morgan Guaranty Trust Bank of New York',
        shortName: '',
        id: 'morgan_guaranty_trust_bank_of_new_york',
        isPartner: false,
    },
    { name: 'Mortgage Choice', shortName: '', id: 'mortgage_choice', isPartner: false },
    { name: 'Mortgage Ezy', shortName: '', id: 'mortgage_ezy', isPartner: false },
    { name: 'Mortgage House', shortName: '', id: 'mortgage_house', isPartner: false },
    { name: 'Mortgage Mart', shortName: '', id: 'mortgage_mart', isPartner: false },
    { name: 'Mortgageport', shortName: '', id: 'mortgageport', isPartner: false },
    { name: 'MOVE Bank', shortName: '', id: 'move_bank', isPartner: false },
    { name: 'NCUIS', shortName: '', id: 'ncuis', isPartner: false },
    { name: 'NSW Home Loans', shortName: '', id: 'new_home_loans', isPartner: false },
    { name: 'NSW Teachers Credit Union', shortName: '', id: 'new__teachers_credit_union', isPartner: false },
    { name: 'OneAnswer', shortName: '', id: 'one_answer', isPartner: false },
    { name: 'Orange Credit Union', shortName: '', id: 'orange_credit_union', isPartner: false },
    { name: 'Other', shortName: '', id: 'other', isPartner: false },
    { name: 'Payday Central', shortName: '', id: 'payday_central', isPartner: false },
    { name: 'Pensioners Insurance', shortName: '', id: 'pensioners_insurance', isPartner: false },
    { name: 'Perpetual Trustee', shortName: '', id: 'perpetual_trustee', isPartner: false },
    { name: 'PLANLend', shortName: '', id: 'planlend', isPartner: false },
    { name: 'Police and Nurses', shortName: '', id: 'police_and_nurses', isPartner: false },
    { name: 'Police Bank', shortName: '', id: 'police_bank', isPartner: false },
    { name: 'Powerstate Credit Union', shortName: '', id: 'powerstate_credit_union', isPartner: false },
    {
        name: 'Primary Industry Bank of Australia',
        shortName: '',
        id: 'primary_industry_bank_of_australia',
        isPartner: false,
    },
    { name: 'Prime', shortName: '', id: 'prime', isPartner: false },
    { name: 'Prospect Credit Union', shortName: '', id: 'prospect_credit_union', isPartner: false },
    { name: 'Public Trustee', shortName: '', id: 'public_trustee', isPartner: false },
    { name: 'Pulse Credit Union', shortName: '', id: 'pulse_credit_union', isPartner: false },
    { name: 'Qudos Bank', shortName: '', id: 'qudos_bank', isPartner: false },
    {
        name: 'Queensland Industry Development Corp',
        shortName: '',
        id: 'queensland_industry_development_corp',
        isPartner: false,
    },
    { name: 'Queensland Teachers Credit Union', shortName: '', id: 'queensland_teachers_credit_union', isPartner: false },
    { name: 'Queenslanders Credit Union', shortName: '', id: 'queenslanders_credit_union', isPartner: false },
    { name: 'REST Super', shortName: '', id: 'rest_super', isPartner: false },
    { name: 'RAC WA', shortName: '', id: 'rac_wa', isPartner: false },
    { name: 'RACQ Bank', shortName: '', id: 'racq_bank', isPartner: false },
    { name: 'Radio Rentals', shortName: '', id: 'radio_rentals', isPartner: false },
    { name: 'Railways Credit Union', shortName: '', id: 'railways_credit_union', isPartner: false },
    { name: 'Repcol', shortName: '', id: 'repcol', isPartner: false },
    { name: 'RESI Mortgage Corporation', shortName: '', id: 'resi_mortgage_corporation,', isPartner: false },
    { name: 'Resi', shortName: '', id: 'resi,', isPartner: false },
    { name: 'Royal Life', shortName: '', id: 'royal_life,', isPartner: false },
    { name: 'Russell Investments', shortName: '', id: 'russell_investments', isPartner: false },
    { name: 'Sanwa Australia Finance Limited', shortName: '', id: 'Sanwa Australia Finance Limited', isPartner: false },
    { name: 'Savings And Loans Credit Union', shortName: '', id: 'savings_and_loans_credit_union', isPartner: false },
    { name: 'SCU', shortName: '', id: 'scu', isPartner: false },
    { name: 'Service One Alliance Bank', shortName: '', id: 'service_one_alliance_bank', isPartner: false },
    { name: 'Shannons', shortName: '', id: 'shannons', isPartner: false },
    { name: 'SmartSave', shortName: '', id: 'smart_save', isPartner: false },
    { name: 'Southern Cross Credit Union', shortName: '', id: 'southern_cross_credit_union', isPartner: false },
    { name: 'Sovereign Credit', shortName: '', id: 'sovereign_credit', isPartner: false },
    { name: 'St Andrew', shortName: '', id: 'st_andrew', isPartner: false },
    { name: 'Standard Chartered Bank Aust', shortName: '', id: 'standard_chartered_bank_aust', isPartner: false },
    { name: 'State Custodians', shortName: '', id: 'state_custodians', isPartner: false },
    { name: 'Statewide', shortName: '', id: 'statewide', isPartner: false },
    { name: 'Stronghold', shortName: '', id: 'stronghold', isPartner: false },
    { name: 'Sun Alliance', shortName: '', id: 'sun_alliance', isPartner: false },
    { name: 'Sunsuper', shortName: '', id: 'sunsuper', isPartner: false },
    { name: 'Swann', shortName: '', id: 'swann', isPartner: false },
    { name: 'TasPlan', shortName: '', id: 'tas_plan', isPartner: false },
    { name: 'Teachers Credit Union', shortName: '', id: 'teachers_credit_union', isPartner: false },
    {
        name: 'Territory Mutual Building Society',
        shortName: '',
        id: 'territory_mutual_building_society',
        isPartner: false,
    },
    { name: 'The Capricornia', shortName: '', id: 'the_capricornia', isPartner: false },
    { name: 'The Mac', shortName: '', id: 'the_mac', isPartner: false },
    { name: 'The Mutual Bank', shortName: '', id: 'the_mutual_bank', isPartner: false },
    { name: 'Tonto Home Loans', shortName: '', id: 'tonto_home_loans', isPartner: false },
    { name: 'Town And Country Bank', shortName: '', id: 'town_and_country_bank', isPartner: false },
    { name: 'Toyota Finance Australia', shortName: '', id: 'toyota_finance_australia', isPartner: false },
    { name: 'Transport Mutual Credit Union', shortName: '', id: 'transport_mutual_credit_union', isPartner: false },
    { name: 'TWUSUPER', shortName: '', id: 'twusuper', isPartner: false },
    { name: 'UBank', shortName: '', id: 'ubank', isPartner: false },
    { name: 'United Credit Union', shortName: '', id: 'united_credit_union', isPartner: false },
    { name: 'University Credit Society', shortName: '', id: 'university_credit_society', isPartner: false },
    { name: 'VACC', shortName: '', id: 'vacc', isPartner: false },
    { name: 'Vero', shortName: '', id: 'vero', isPartner: false },
    { name: 'VicSuper', shortName: '', id: 'vic_super', isPartner: false },
    { name: 'Virgin Super', shortName: '', id: 'virgin_super', isPartner: false },
    { name: 'Visions', shortName: '', id: 'visions', isPartner: false },
    { name: 'Western QBE', shortName: '', id: 'western_qbe', isPartner: false },
    { name: 'Westfarmers', shortName: '', id: 'westfarmers', isPartner: false },
    { name: 'Westpack Insurance Services', shortName: '', id: 'westpack_insurance_services', isPartner: false },
    {
        name: 'Wide Bay Capricorn Building Society',
        shortName: '',
        id: 'wide_bay_capricorn_building_society',
        isPartner: false,
    },
    { name: 'Wizard', shortName: '', id: 'wizard', isPartner: false },
    {
        name: 'Woolworths Employees Credit Union',
        shortName: '',
        id: 'woolworths_employees_credit_union',
        isPartner: false,
    },
    { name: 'ANZ Asset Finance', shortName: '', id: 'anz_asset_finance', isPartner: false },
    { name: 'Nab Broker', shortName: '', id: 'nab_broker', isPartner: false },
    { name: 'PNC Financial services', shortName: '', id: 'pnc_financial_services', isPartner: false },
    { name: 'World Marine and General', shortName: '', id: 'world_marine_and_general', isPartner: false },
    { name: 'Xinja', shortName: '', id: 'xinjia', isPartner: false },
    { name: 'Yellow Brick Road', shortName: '', id: 'yellow_brick_road', isPartner: false },
    { name: 'Zurich', shortName: '', id: 'zurich', isPartner: false },
    { name: 'Volt', shortName: '', id: 'volt', isPartner: false },
    { name: 'BNK', shortName: '', id: 'BNK', isPartner: false },
    { name: '86 400', shortName: '', id: '86_400', isPartner: false },
    { name: 'ADCU', shortName: '', id: 'adcu', isPartner: false },
    { name: 'AFG Advantedge', shortName: '', id: 'afg_advantedge', isPartner: false },
    { name: 'AFM', shortName: '', id: 'afm', isPartner: false },
    { name: 'Ample Capital Australia', shortName: '', id: 'ample_capital_australia', isPartner: false },
    { name: 'Anchorage', shortName: '', id: 'anchorage', isPartner: false },
    { name: 'ANZ Asset Finance ', shortName: '', id: 'anz_asset_finance_', isPartner: false },
    { name: 'AUL', shortName: '', id: 'aul', isPartner: false },
    {
        name: 'Australian Financial Holdings Pty Ltd',
        shortName: '',
        id: 'australian_financial_holdings_pty_ltd',
        isPartner: false,
    },
    { name: 'Australian Lending Services', shortName: '', id: 'australian_lending_services', isPartner: false },
    { name: 'Australian Wholesale Lending', shortName: '', id: 'australian_wholesale_lending', isPartner: false },
    { name: 'Bank of South Australia', shortName: '', id: 'bank_of_south_australia', isPartner: false },
    { name: 'Banksia', shortName: '', id: 'banksia', isPartner: false },
    { name: 'BCHL', shortName: '', id: 'bchl', isPartner: false },
    { name: 'Bluegum', shortName: '', id: 'bluegum', isPartner: false },
    { name: 'BMC', shortName: '', id: 'bmc', isPartner: false },
    { name: 'BMC Advantedge', shortName: '', id: 'bmc_advantedge', isPartner: false },
    { name: 'CACU', shortName: '', id: 'cacu', isPartner: false },
    { name: 'Coles Financial Services', shortName: '', id: 'coles_financial_services', isPartner: false },
    { name: 'Collins Securities', shortName: '', id: 'collins_securities', isPartner: false },
    { name: 'Columbus Capital Pty Ltd', shortName: '', id: 'columbus_capital_pty_ltd', isPartner: false },
    { name: 'Community CPS Australia ', shortName: '', id: 'community_cps_australia_', isPartner: false },
    { name: 'Community Mutual Ltd', shortName: '', id: 'community_mutual_ltd', isPartner: false },
    { name: 'Credit Union Home Loans', shortName: '', id: 'credit_union_home_loans', isPartner: false },
    { name: 'Direct Mortgage Solutions', shortName: '', id: 'direct_mortgage_solutions', isPartner: false },
    { name: 'Director of Housing VIC ', shortName: '', id: 'director_of_housing_vic_', isPartner: false },
    { name: 'Domain', shortName: '', id: 'domain', isPartner: false },
    { name: 'Economy', shortName: '', id: 'economy', isPartner: false },
    { name: 'eMoney', shortName: '', id: 'emoney', isPartner: false },
    { name: 'Ezy Mortgage', shortName: '', id: 'ezy_mortgage', isPartner: false },
    { name: 'Faraday West and Co Pty Ltd', shortName: '', id: 'faraday_west_and_co_pty_ltd', isPartner: false },
    { name: 'Fifty Group', shortName: '', id: 'fifty_group', isPartner: false },
    { name: 'Finance Express Home Loans', shortName: '', id: 'finance_express_home_loans', isPartner: false },
    { name: 'First Folio', shortName: '', id: 'first_folio', isPartner: false },
    { name: 'Firstmac', shortName: '', id: 'firstmac', isPartner: false },
    { name: 'Fleet Partners Auto Loan', shortName: '', id: 'fleet_partners_auto_loan', isPartner: false },
    { name: 'FlexiGroup', shortName: '', id: 'flexigroup', isPartner: false },
    { name: 'Good Shepherd Microfinance', shortName: '', id: 'good_shepherd_microfinance', isPartner: false },
    { name: 'Great Southern Loans', shortName: '', id: 'great_southern_loans', isPartner: false },
    { name: 'Greater Bank Ltd', shortName: '', id: 'greater_bank_ltd', isPartner: false },
    { name: 'Harmoney Australia', shortName: '', id: 'harmoney_australia', isPartner: false },
    { name: 'HBS', shortName: '', id: 'hbs', isPartner: false },
    { name: 'Hemisphere', shortName: '', id: 'hemisphere', isPartner: false },
    { name: 'Homeloan Centre Australia', shortName: '', id: 'homeloan_centre_australia', isPartner: false },
    { name: 'HomePath', shortName: '', id: 'homepath', isPartner: false },
    { name: 'HostPlus', shortName: '', id: 'hostplus', isPartner: false },
    { name: 'Humm', shortName: '', id: 'humm', isPartner: false },
    { name: 'Infiniti Finservices Australia', shortName: '', id: 'infiniti_finservices_australia', isPartner: false },
    { name: 'JetStar Credit Cards', shortName: '', id: 'jetstar_credit_cards', isPartner: false },
    { name: 'Latitude Finance Australia', shortName: '', id: 'latitude_finance_australia', isPartner: false },
    { name: 'LoanMarket Advantedge', shortName: '', id: 'loanmarket_advantedge', isPartner: false },
    { name: 'LoanPlan', shortName: '', id: 'loanplan', isPartner: false },
    { name: 'Maxxia', shortName: '', id: 'maxxia', isPartner: false },
    { name: 'MCCA', shortName: '', id: 'mcca', isPartner: false },
    { name: 'Mercedez-Benz Financial Services', shortName: '', id: 'mercedez-benz_financial_services', isPartner: false },
    { name: 'MIIP', shortName: '', id: 'miip', isPartner: false },
    { name: 'Mitsubishi', shortName: '', id: 'mitsubishi', isPartner: false },
    { name: 'Money Quest Australia Pty Ltd', shortName: '', id: 'money_quest_australia_pty_ltd', isPartner: false },
    { name: 'MoneyPlace AFSL', shortName: '', id: 'moneyplace_afsl', isPartner: false },
    { name: 'MSL', shortName: '', id: 'msl', isPartner: false },
    { name: 'Myer Credit Cards', shortName: '', id: 'myer_credit_cards', isPartner: false },
    { name: 'MyOzMoney', shortName: '', id: 'myozmoney', isPartner: false },
    { name: 'Napiers', shortName: '', id: 'napiers', isPartner: false },
    { name: 'NCF Financial Services PtyLtd', shortName: '', id: 'ncf_financial_services_ptyltd', isPartner: false },
    { name: 'NFC', shortName: '', id: 'nfc', isPartner: false },
    { name: 'NHL', shortName: '', id: 'nhl', isPartner: false },
    { name: 'Nissan Financial Services', shortName: '', id: 'nissan_financial_services', isPartner: false },
    { name: 'NMMC', shortName: '', id: 'nmmc', isPartner: false },
    { name: 'Now Finance', shortName: '', id: 'now_finance', isPartner: false },
    { name: 'OFG', shortName: '', id: 'ofg', isPartner: false },
    { name: 'ORIX', shortName: '', id: 'orix', isPartner: false },
    { name: 'Paladin', shortName: '', id: 'paladin', isPartner: false },
    { name: 'Pioneer Credit Ltd', shortName: '', id: 'pioneer_credit_ltd', isPartner: false },
    { name: 'PNCS', shortName: '', id: 'pncs', isPartner: false },
    { name: 'Power Home Loans', shortName: '', id: 'power_home_loans', isPartner: false },
    { name: 'Rate Money Pty Ltd', shortName: '', id: 'rate_money_pty_ltd', isPartner: false },
    { name: 'RedZed', shortName: '', id: 'redzed', isPartner: false },
    { name: 'Renault Finance ', shortName: '', id: 'renault_finance_', isPartner: false },
    { name: 'Residential Mortgage Group', shortName: '', id: 'residential_mortgage_group', isPartner: false },
    { name: 'RHG', shortName: '', id: 'rhg', isPartner: false },
    { name: 'Sam Loans', shortName: '', id: 'sam_loans', isPartner: false },
    { name: 'Sandhurst Trustees', shortName: '', id: 'sandhurst_trustees', isPartner: false },
    { name: 'SGE Credit Union', shortName: '', id: 'sge_credit_union', isPartner: false },
    { name: 'Skyline Car Finance', shortName: '', id: 'skyline_car_finance', isPartner: false },
    { name: 'Smartline', shortName: '', id: 'smartline', isPartner: false },
    { name: 'Society One Australia', shortName: '', id: 'society_one_australia', isPartner: false },
    { name: 'Southland Building Society', shortName: '', id: 'southland_building_society', isPartner: false },
    { name: 'Sydney Home Loans', shortName: '', id: 'sydney_home_loans', isPartner: false },
    { name: 'Symple Loans Australia', shortName: '', id: 'symple_loans_australia', isPartner: false },
    { name: 'The Co-operative Bank', shortName: '', id: 'the_co-operative_bank', isPartner: false },
    { name: 'ThinkMe Finance', shortName: '', id: 'thinkme_finance', isPartner: false },
    { name: 'VTMB', shortName: '', id: 'vtmb', isPartner: false },
    { name: 'Wisr Finance Pty Ltd', shortName: '', id: 'wisr_finance_pty_ltd', isPartner: false },
    { name: 'Woolworths', shortName: '', id: 'woolworths', isPartner: false },
    { name: 'World Home Loans', shortName: '', id: 'world_home_loans', isPartner: false },
    { name: 'Yes Home Loans', shortName: '', id: 'yes_home_loans', isPartner: false },
    { name: 'Your Manager', shortName: '', id: 'your_manager', isPartner: false },
];
var NON_PARTNER_LENDERS = __spreadArray(__spreadArray([], NON_PARTNER_WITH_SHORTNAME, true), NON_PARTNER_WITHOUT_SHORTNAME, true);
var LENDERS = __spreadArray(__spreadArray([], PARTNER_LENDERS, true), NON_PARTNER_LENDERS, true);
var LENDER_DICTIONARY = Object.fromEntries(__spreadArray(__spreadArray([], PARTNER_LENDERS_WITH_SHORTNAME.map(function (pl) { return [pl.name, pl]; }), true), NON_PARTNER_WITH_SHORTNAME.map(function (npl) { return [npl.name, npl]; }), true));
var getByName = function (name) {
    return LENDER_DICTIONARY[name];
};
//# sourceMappingURL=Lenders.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Address.js
var StreetSuffixes;
(function (StreetSuffixes) {
    StreetSuffixes[StreetSuffixes["Central"] = 0] = "Central";
    StreetSuffixes[StreetSuffixes["Deviation"] = 1] = "Deviation";
    StreetSuffixes[StreetSuffixes["East"] = 2] = "East";
    StreetSuffixes[StreetSuffixes["Extension"] = 3] = "Extension";
    StreetSuffixes[StreetSuffixes["Lower"] = 4] = "Lower";
    StreetSuffixes[StreetSuffixes["Inner"] = 5] = "Inner";
    StreetSuffixes[StreetSuffixes["Mall"] = 6] = "Mall";
    StreetSuffixes[StreetSuffixes["North"] = 7] = "North";
    StreetSuffixes[StreetSuffixes["North East"] = 8] = "North East";
    StreetSuffixes[StreetSuffixes["North West"] = 9] = "North West";
    StreetSuffixes[StreetSuffixes["Off"] = 10] = "Off";
    StreetSuffixes[StreetSuffixes["On"] = 11] = "On";
    StreetSuffixes[StreetSuffixes["Outer"] = 12] = "Outer";
    StreetSuffixes[StreetSuffixes["Overpass"] = 13] = "Overpass";
    StreetSuffixes[StreetSuffixes["South"] = 14] = "South";
    StreetSuffixes[StreetSuffixes["South East"] = 15] = "South East";
    StreetSuffixes[StreetSuffixes["South West"] = 16] = "South West";
    StreetSuffixes[StreetSuffixes["Upper"] = 17] = "Upper";
    StreetSuffixes[StreetSuffixes["West"] = 18] = "West";
})(StreetSuffixes || (StreetSuffixes = {}));
var StreetTypes;
(function (StreetTypes) {
    StreetTypes[StreetTypes["Access"] = 0] = "Access";
    StreetTypes[StreetTypes["Alley"] = 1] = "Alley";
    StreetTypes[StreetTypes["Alleyway"] = 2] = "Alleyway";
    StreetTypes[StreetTypes["Amble"] = 3] = "Amble";
    StreetTypes[StreetTypes["Anchorage"] = 4] = "Anchorage";
    StreetTypes[StreetTypes["Approach"] = 5] = "Approach";
    StreetTypes[StreetTypes["Arcade"] = 6] = "Arcade";
    StreetTypes[StreetTypes["Arterial"] = 7] = "Arterial";
    StreetTypes[StreetTypes["Artery"] = 8] = "Artery";
    StreetTypes[StreetTypes["Avenue"] = 9] = "Avenue";
    StreetTypes[StreetTypes["Banan"] = 10] = "Banan";
    StreetTypes[StreetTypes["Bank"] = 11] = "Bank";
    StreetTypes[StreetTypes["Basin"] = 12] = "Basin";
    StreetTypes[StreetTypes["Bay"] = 13] = "Bay";
    StreetTypes[StreetTypes["Beach"] = 14] = "Beach";
    StreetTypes[StreetTypes["Bend"] = 15] = "Bend";
    StreetTypes[StreetTypes["Block"] = 16] = "Block";
    StreetTypes[StreetTypes["Boardwalk"] = 17] = "Boardwalk";
    StreetTypes[StreetTypes["Boulevard"] = 18] = "Boulevard";
    StreetTypes[StreetTypes["Boulevarde"] = 19] = "Boulevarde";
    StreetTypes[StreetTypes["Bowl"] = 20] = "Bowl";
    StreetTypes[StreetTypes["Brace"] = 21] = "Brace";
    StreetTypes[StreetTypes["Brae"] = 22] = "Brae";
    StreetTypes[StreetTypes["Break"] = 23] = "Break";
    StreetTypes[StreetTypes["Bridge"] = 24] = "Bridge";
    StreetTypes[StreetTypes["Broadway"] = 25] = "Broadway";
    StreetTypes[StreetTypes["Brow"] = 26] = "Brow";
    StreetTypes[StreetTypes["Bypass"] = 27] = "Bypass";
    StreetTypes[StreetTypes["Byway"] = 28] = "Byway";
    StreetTypes[StreetTypes["Canal"] = 29] = "Canal";
    StreetTypes[StreetTypes["Causeway"] = 30] = "Causeway";
    StreetTypes[StreetTypes["Centre"] = 31] = "Centre";
    StreetTypes[StreetTypes["Centreway"] = 32] = "Centreway";
    StreetTypes[StreetTypes["Chase"] = 33] = "Chase";
    StreetTypes[StreetTypes["Circle"] = 34] = "Circle";
    StreetTypes[StreetTypes["Circlet"] = 35] = "Circlet";
    StreetTypes[StreetTypes["Circuit"] = 36] = "Circuit";
    StreetTypes[StreetTypes["Circus"] = 37] = "Circus";
    StreetTypes[StreetTypes["Close"] = 38] = "Close";
    StreetTypes[StreetTypes["Cluster"] = 39] = "Cluster";
    StreetTypes[StreetTypes["Colonnade"] = 40] = "Colonnade";
    StreetTypes[StreetTypes["Common"] = 41] = "Common";
    StreetTypes[StreetTypes["Concourse"] = 42] = "Concourse";
    StreetTypes[StreetTypes["Connection"] = 43] = "Connection";
    StreetTypes[StreetTypes["Copse"] = 44] = "Copse";
    StreetTypes[StreetTypes["Corner"] = 45] = "Corner";
    StreetTypes[StreetTypes["Corso"] = 46] = "Corso";
    StreetTypes[StreetTypes["Course"] = 47] = "Course";
    StreetTypes[StreetTypes["Court"] = 48] = "Court";
    StreetTypes[StreetTypes["Courtyard"] = 49] = "Courtyard";
    StreetTypes[StreetTypes["Cove"] = 50] = "Cove";
    StreetTypes[StreetTypes["Crescent"] = 51] = "Crescent";
    StreetTypes[StreetTypes["Crest"] = 52] = "Crest";
    StreetTypes[StreetTypes["Cross"] = 53] = "Cross";
    StreetTypes[StreetTypes["Crossing"] = 54] = "Crossing";
    StreetTypes[StreetTypes["Crossroad"] = 55] = "Crossroad";
    StreetTypes[StreetTypes["Crossway"] = 56] = "Crossway";
    StreetTypes[StreetTypes["Cruiseway"] = 57] = "Cruiseway";
    StreetTypes[StreetTypes["Cul-De-Sac"] = 58] = "Cul-De-Sac";
    StreetTypes[StreetTypes["Cutting"] = 59] = "Cutting";
    StreetTypes[StreetTypes["Dale"] = 60] = "Dale";
    StreetTypes[StreetTypes["Dell"] = 61] = "Dell";
    StreetTypes[StreetTypes["Dene"] = 62] = "Dene";
    StreetTypes[StreetTypes["Deviation"] = 63] = "Deviation";
    StreetTypes[StreetTypes["Dip"] = 64] = "Dip";
    StreetTypes[StreetTypes["Distributor"] = 65] = "Distributor";
    StreetTypes[StreetTypes["Divide"] = 66] = "Divide";
    StreetTypes[StreetTypes["Dock"] = 67] = "Dock";
    StreetTypes[StreetTypes["Domain"] = 68] = "Domain";
    StreetTypes[StreetTypes["Drive"] = 69] = "Drive";
    StreetTypes[StreetTypes["Driveway"] = 70] = "Driveway";
    StreetTypes[StreetTypes["Edge"] = 71] = "Edge";
    StreetTypes[StreetTypes["Elbow"] = 72] = "Elbow";
    StreetTypes[StreetTypes["End"] = 73] = "End";
    StreetTypes[StreetTypes["Entrance"] = 74] = "Entrance";
    StreetTypes[StreetTypes["Esplanade"] = 75] = "Esplanade";
    StreetTypes[StreetTypes["Estate"] = 76] = "Estate";
    StreetTypes[StreetTypes["Estuary"] = 77] = "Estuary";
    StreetTypes[StreetTypes["Expressway"] = 78] = "Expressway";
    StreetTypes[StreetTypes["Extension"] = 79] = "Extension";
    StreetTypes[StreetTypes["Fairway"] = 80] = "Fairway";
    StreetTypes[StreetTypes["Fire Track"] = 81] = "Fire Track";
    StreetTypes[StreetTypes["Firebreak"] = 82] = "Firebreak";
    StreetTypes[StreetTypes["Fireline"] = 83] = "Fireline";
    StreetTypes[StreetTypes["Firetrack"] = 84] = "Firetrack";
    StreetTypes[StreetTypes["Firetrail"] = 85] = "Firetrail";
    StreetTypes[StreetTypes["Flat"] = 86] = "Flat";
    StreetTypes[StreetTypes["Follow"] = 87] = "Follow";
    StreetTypes[StreetTypes["Footway"] = 88] = "Footway";
    StreetTypes[StreetTypes["Ford"] = 89] = "Ford";
    StreetTypes[StreetTypes["Foreshore"] = 90] = "Foreshore";
    StreetTypes[StreetTypes["Formation"] = 91] = "Formation";
    StreetTypes[StreetTypes["Freeway"] = 92] = "Freeway";
    StreetTypes[StreetTypes["Front"] = 93] = "Front";
    StreetTypes[StreetTypes["Frontage"] = 94] = "Frontage";
    StreetTypes[StreetTypes["Gap"] = 95] = "Gap";
    StreetTypes[StreetTypes["Garden"] = 96] = "Garden";
    StreetTypes[StreetTypes["Gardens"] = 97] = "Gardens";
    StreetTypes[StreetTypes["Gate"] = 98] = "Gate";
    StreetTypes[StreetTypes["Gates"] = 99] = "Gates";
    StreetTypes[StreetTypes["Gateway"] = 100] = "Gateway";
    StreetTypes[StreetTypes["Glade"] = 101] = "Glade";
    StreetTypes[StreetTypes["Glen"] = 102] = "Glen";
    StreetTypes[StreetTypes["Grange"] = 103] = "Grange";
    StreetTypes[StreetTypes["Green"] = 104] = "Green";
    StreetTypes[StreetTypes["Ground"] = 105] = "Ground";
    StreetTypes[StreetTypes["Grove"] = 106] = "Grove";
    StreetTypes[StreetTypes["Gully"] = 107] = "Gully";
    StreetTypes[StreetTypes["Harbour"] = 108] = "Harbour";
    StreetTypes[StreetTypes["Heath"] = 109] = "Heath";
    StreetTypes[StreetTypes["Heights"] = 110] = "Heights";
    StreetTypes[StreetTypes["Highroad"] = 111] = "Highroad";
    StreetTypes[StreetTypes["Highway"] = 112] = "Highway";
    StreetTypes[StreetTypes["Hill"] = 113] = "Hill";
    StreetTypes[StreetTypes["Hollow"] = 114] = "Hollow";
    StreetTypes[StreetTypes["Hub"] = 115] = "Hub";
    StreetTypes[StreetTypes["Interchange"] = 116] = "Interchange";
    StreetTypes[StreetTypes["Intersection"] = 117] = "Intersection";
    StreetTypes[StreetTypes["Junction"] = 118] = "Junction";
    StreetTypes[StreetTypes["Key"] = 119] = "Key";
    StreetTypes[StreetTypes["Keys"] = 120] = "Keys";
    StreetTypes[StreetTypes["Landing"] = 121] = "Landing";
    StreetTypes[StreetTypes["Lane"] = 122] = "Lane";
    StreetTypes[StreetTypes["Laneway"] = 123] = "Laneway";
    StreetTypes[StreetTypes["Lees"] = 124] = "Lees";
    StreetTypes[StreetTypes["Line"] = 125] = "Line";
    StreetTypes[StreetTypes["Link"] = 126] = "Link";
    StreetTypes[StreetTypes["Little"] = 127] = "Little";
    StreetTypes[StreetTypes["Lookout"] = 128] = "Lookout";
    StreetTypes[StreetTypes["Loop"] = 129] = "Loop";
    StreetTypes[StreetTypes["Lower"] = 130] = "Lower";
    StreetTypes[StreetTypes["Mall"] = 131] = "Mall";
    StreetTypes[StreetTypes["Manor"] = 132] = "Manor";
    StreetTypes[StreetTypes["Meander"] = 133] = "Meander";
    StreetTypes[StreetTypes["Mears"] = 134] = "Mears";
    StreetTypes[StreetTypes["Mew"] = 135] = "Mew";
    StreetTypes[StreetTypes["Mews"] = 136] = "Mews";
    StreetTypes[StreetTypes["Mile"] = 137] = "Mile";
    StreetTypes[StreetTypes["Motorway"] = 138] = "Motorway";
    StreetTypes[StreetTypes["Mount"] = 139] = "Mount";
    StreetTypes[StreetTypes["Nook"] = 140] = "Nook";
    StreetTypes[StreetTypes["Outlet"] = 141] = "Outlet";
    StreetTypes[StreetTypes["Outlook"] = 142] = "Outlook";
    StreetTypes[StreetTypes["Parade"] = 143] = "Parade";
    StreetTypes[StreetTypes["Park"] = 144] = "Park";
    StreetTypes[StreetTypes["Parklands"] = 145] = "Parklands";
    StreetTypes[StreetTypes["Parkway"] = 146] = "Parkway";
    StreetTypes[StreetTypes["Part"] = 147] = "Part";
    StreetTypes[StreetTypes["Pass"] = 148] = "Pass";
    StreetTypes[StreetTypes["Passage"] = 149] = "Passage";
    StreetTypes[StreetTypes["Path"] = 150] = "Path";
    StreetTypes[StreetTypes["Pathway"] = 151] = "Pathway";
    StreetTypes[StreetTypes["Piazza"] = 152] = "Piazza";
    StreetTypes[StreetTypes["Pier"] = 153] = "Pier";
    StreetTypes[StreetTypes["Place"] = 154] = "Place";
    StreetTypes[StreetTypes["Plateau"] = 155] = "Plateau";
    StreetTypes[StreetTypes["Plaza"] = 156] = "Plaza";
    StreetTypes[StreetTypes["Pocket"] = 157] = "Pocket";
    StreetTypes[StreetTypes["Point"] = 158] = "Point";
    StreetTypes[StreetTypes["Port"] = 159] = "Port";
    StreetTypes[StreetTypes["Portal"] = 160] = "Portal";
    StreetTypes[StreetTypes["Promenade"] = 161] = "Promenade";
    StreetTypes[StreetTypes["Pursuit"] = 162] = "Pursuit";
    StreetTypes[StreetTypes["Quad"] = 163] = "Quad";
    StreetTypes[StreetTypes["Quadrangle"] = 164] = "Quadrangle";
    StreetTypes[StreetTypes["Quadrant"] = 165] = "Quadrant";
    StreetTypes[StreetTypes["Quay"] = 166] = "Quay";
    StreetTypes[StreetTypes["Quays"] = 167] = "Quays";
    StreetTypes[StreetTypes["Ramble"] = 168] = "Ramble";
    StreetTypes[StreetTypes["Ramp"] = 169] = "Ramp";
    StreetTypes[StreetTypes["Range"] = 170] = "Range";
    StreetTypes[StreetTypes["Reach"] = 171] = "Reach";
    StreetTypes[StreetTypes["Reserve"] = 172] = "Reserve";
    StreetTypes[StreetTypes["Rest"] = 173] = "Rest";
    StreetTypes[StreetTypes["Retreat"] = 174] = "Retreat";
    StreetTypes[StreetTypes["Return"] = 175] = "Return";
    StreetTypes[StreetTypes["Ride"] = 176] = "Ride";
    StreetTypes[StreetTypes["Ridge"] = 177] = "Ridge";
    StreetTypes[StreetTypes["Ridgeway"] = 178] = "Ridgeway";
    StreetTypes[StreetTypes["Right Of Way"] = 179] = "Right Of Way";
    StreetTypes[StreetTypes["Ring"] = 180] = "Ring";
    StreetTypes[StreetTypes["Rise"] = 181] = "Rise";
    StreetTypes[StreetTypes["Rising"] = 182] = "Rising";
    StreetTypes[StreetTypes["River"] = 183] = "River";
    StreetTypes[StreetTypes["Riverway"] = 184] = "Riverway";
    StreetTypes[StreetTypes["Riviera"] = 185] = "Riviera";
    StreetTypes[StreetTypes["Road"] = 186] = "Road";
    StreetTypes[StreetTypes["Roads"] = 187] = "Roads";
    StreetTypes[StreetTypes["Roadside"] = 188] = "Roadside";
    StreetTypes[StreetTypes["Roadway"] = 189] = "Roadway";
    StreetTypes[StreetTypes["Ronde"] = 190] = "Ronde";
    StreetTypes[StreetTypes["Rosebowl"] = 191] = "Rosebowl";
    StreetTypes[StreetTypes["Rotary"] = 192] = "Rotary";
    StreetTypes[StreetTypes["Round"] = 193] = "Round";
    StreetTypes[StreetTypes["Route"] = 194] = "Route";
    StreetTypes[StreetTypes["Row"] = 195] = "Row";
    StreetTypes[StreetTypes["Rue"] = 196] = "Rue";
    StreetTypes[StreetTypes["Run"] = 197] = "Run";
    StreetTypes[StreetTypes["Service Way"] = 198] = "Service Way";
    StreetTypes[StreetTypes["Shunt"] = 199] = "Shunt";
    StreetTypes[StreetTypes["Siding"] = 200] = "Siding";
    StreetTypes[StreetTypes["Slope"] = 201] = "Slope";
    StreetTypes[StreetTypes["Sound"] = 202] = "Sound";
    StreetTypes[StreetTypes["Spur"] = 203] = "Spur";
    StreetTypes[StreetTypes["Square"] = 204] = "Square";
    StreetTypes[StreetTypes["Stairs"] = 205] = "Stairs";
    StreetTypes[StreetTypes["State Highway"] = 206] = "State Highway";
    StreetTypes[StreetTypes["Steps"] = 207] = "Steps";
    StreetTypes[StreetTypes["Strand"] = 208] = "Strand";
    StreetTypes[StreetTypes["Street"] = 209] = "Street";
    StreetTypes[StreetTypes["Streets"] = 210] = "Streets";
    StreetTypes[StreetTypes["Strip"] = 211] = "Strip";
    StreetTypes[StreetTypes["Subway"] = 212] = "Subway";
    StreetTypes[StreetTypes["Tarn"] = 213] = "Tarn";
    StreetTypes[StreetTypes["Tarnice Way"] = 214] = "Tarnice Way";
    StreetTypes[StreetTypes["Terrace"] = 215] = "Terrace";
    StreetTypes[StreetTypes["Thoroughfare"] = 216] = "Thoroughfare";
    StreetTypes[StreetTypes["Throughway"] = 217] = "Throughway";
    StreetTypes[StreetTypes["Tollway"] = 218] = "Tollway";
    StreetTypes[StreetTypes["Top"] = 219] = "Top";
    StreetTypes[StreetTypes["Tor"] = 220] = "Tor";
    StreetTypes[StreetTypes["Towers"] = 221] = "Towers";
    StreetTypes[StreetTypes["Track"] = 222] = "Track";
    StreetTypes[StreetTypes["Trail"] = 223] = "Trail";
    StreetTypes[StreetTypes["Trailer"] = 224] = "Trailer";
    StreetTypes[StreetTypes["Triangle"] = 225] = "Triangle";
    StreetTypes[StreetTypes["Trunkway"] = 226] = "Trunkway";
    StreetTypes[StreetTypes["Turn"] = 227] = "Turn";
    StreetTypes[StreetTypes["Twist"] = 228] = "Twist";
    StreetTypes[StreetTypes["Underpass"] = 229] = "Underpass";
    StreetTypes[StreetTypes["Upper"] = 230] = "Upper";
    StreetTypes[StreetTypes["Vale"] = 231] = "Vale";
    StreetTypes[StreetTypes["Viaduct"] = 232] = "Viaduct";
    StreetTypes[StreetTypes["View"] = 233] = "View";
    StreetTypes[StreetTypes["Villas"] = 234] = "Villas";
    StreetTypes[StreetTypes["Vista"] = 235] = "Vista";
    StreetTypes[StreetTypes["Wade"] = 236] = "Wade";
    StreetTypes[StreetTypes["Walk"] = 237] = "Walk";
    StreetTypes[StreetTypes["Walkway"] = 238] = "Walkway";
    StreetTypes[StreetTypes["Waterway"] = 239] = "Waterway";
    StreetTypes[StreetTypes["Way"] = 240] = "Way";
    StreetTypes[StreetTypes["Wharf"] = 241] = "Wharf";
    StreetTypes[StreetTypes["Woods"] = 242] = "Woods";
    StreetTypes[StreetTypes["Wynd"] = 243] = "Wynd";
    StreetTypes[StreetTypes["Yard"] = 244] = "Yard";
})(StreetTypes || (StreetTypes = {}));
//# sourceMappingURL=Address.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/BusinessType.js
var BusinessType;
(function (BusinessType) {
    BusinessType["Private"] = "PRIVATE";
    BusinessType["Public"] = "PUBLIC";
})(BusinessType || (BusinessType = {}));
//# sourceMappingURL=BusinessType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/BusinessStructureType.js
var BusinessStructureType;
(function (BusinessStructureType) {
    BusinessStructureType["Company"] = "COMPANY";
    BusinessStructureType["SoleTrader"] = "SOLE_TRADER";
    BusinessStructureType["Partnership"] = "PARTNERSHIP";
    BusinessStructureType["Trust"] = "TRUST";
})(BusinessStructureType || (BusinessStructureType = {}));
//# sourceMappingURL=BusinessStructureType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/BeneficialOwnerRole.js
var BeneficialOwnerRole;
(function (BeneficialOwnerRole) {
    BeneficialOwnerRole["Accountant"] = "ACCOUNTANT";
    BeneficialOwnerRole["Appointor"] = "APPOINTOR";
    BeneficialOwnerRole["AuthorisedSignatory"] = "AUTHORISED_SIGNATORY";
    BeneficialOwnerRole["Beneficiary"] = "BENEFICIARY";
    BeneficialOwnerRole["BusinessPartner"] = "BUSINESS_PARTNER";
    BeneficialOwnerRole["Ceo"] = "CEO";
    BeneficialOwnerRole["Cfo"] = "CFO";
    BeneficialOwnerRole["Chairman"] = "CHAIRMAN";
    BeneficialOwnerRole["CoBorrower"] = "CO_BORROWER";
    BeneficialOwnerRole["Coo"] = "COO";
    BeneficialOwnerRole["Director"] = "DIRECTOR";
    BeneficialOwnerRole["Guarantor"] = "GUARANTOR";
    BeneficialOwnerRole["Guardian"] = "GUARDIAN";
    BeneficialOwnerRole["Partner"] = "PARTNER";
    BeneficialOwnerRole["PowerOfAttorney"] = "POWER_OF_ATTORNEY";
    BeneficialOwnerRole["President"] = "PRESIDENT";
    BeneficialOwnerRole["Secretary"] = "SECRETARY";
    BeneficialOwnerRole["ShareholderOfLessThan25Percent"] = "SHAREHOLDER_OF_LESS_THAN_25_PERCENT";
    BeneficialOwnerRole["SupportStaff"] = "SUPPORT_STAFF";
    BeneficialOwnerRole["ThirdPartyAuthority"] = "THIRD_PARTY_AUTHORITY";
    BeneficialOwnerRole["Treasurer"] = "TREASURER";
    BeneficialOwnerRole["Trustee"] = "TRUSTEE";
})(BeneficialOwnerRole || (BeneficialOwnerRole = {}));
//# sourceMappingURL=BeneficialOwnerRole.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/BeneficialOwnerType.js
var BeneficialOwnerType;
(function (BeneficialOwnerType) {
    BeneficialOwnerType["Controller"] = "CONTROLLER";
    BeneficialOwnerType["ShareHolder"] = "SHARE_HOLDER";
    BeneficialOwnerType["Other"] = "OTHER";
})(BeneficialOwnerType || (BeneficialOwnerType = {}));
//# sourceMappingURL=BeneficialOwnerType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/Countries.js
var Countries;
(function (Countries) {
    Countries[Countries["Afghanistan"] = 0] = "Afghanistan";
    Countries[Countries["Albania"] = 1] = "Albania";
    Countries[Countries["Algeria"] = 2] = "Algeria";
    Countries[Countries["American Samoa"] = 3] = "American Samoa";
    Countries[Countries["Andorra"] = 4] = "Andorra";
    Countries[Countries["Angola"] = 5] = "Angola";
    Countries[Countries["Anguilla"] = 6] = "Anguilla";
    Countries[Countries["Antarctica"] = 7] = "Antarctica";
    Countries[Countries["Antigua And Barbuda"] = 8] = "Antigua And Barbuda";
    Countries[Countries["Argentina"] = 9] = "Argentina";
    Countries[Countries["Armenia"] = 10] = "Armenia";
    Countries[Countries["Aruba"] = 11] = "Aruba";
    Countries[Countries["Australia"] = 12] = "Australia";
    Countries[Countries["Austria"] = 13] = "Austria";
    Countries[Countries["Azerbaijan"] = 14] = "Azerbaijan";
    Countries[Countries["Bahamas"] = 15] = "Bahamas";
    Countries[Countries["Bahrain"] = 16] = "Bahrain";
    Countries[Countries["Bangladesh"] = 17] = "Bangladesh";
    Countries[Countries["Barbados"] = 18] = "Barbados";
    Countries[Countries["Belarus"] = 19] = "Belarus";
    Countries[Countries["Belgium"] = 20] = "Belgium";
    Countries[Countries["Belize"] = 21] = "Belize";
    Countries[Countries["Benin"] = 22] = "Benin";
    Countries[Countries["Bermuda"] = 23] = "Bermuda";
    Countries[Countries["Bhutan"] = 24] = "Bhutan";
    Countries[Countries["Bolivia"] = 25] = "Bolivia";
    Countries[Countries["Bosnia And Herzegovina"] = 26] = "Bosnia And Herzegovina";
    Countries[Countries["Botswana"] = 27] = "Botswana";
    Countries[Countries["Bouvet Island"] = 28] = "Bouvet Island";
    Countries[Countries["Brazil"] = 29] = "Brazil";
    Countries[Countries["British Indian Ocean Territory"] = 30] = "British Indian Ocean Territory";
    Countries[Countries["Brunei Darussalam"] = 31] = "Brunei Darussalam";
    Countries[Countries["Bulgaria"] = 32] = "Bulgaria";
    Countries[Countries["Burkina Faso"] = 33] = "Burkina Faso";
    Countries[Countries["Burundi"] = 34] = "Burundi";
    Countries[Countries["Cambodia"] = 35] = "Cambodia";
    Countries[Countries["Cameroon"] = 36] = "Cameroon";
    Countries[Countries["Canada"] = 37] = "Canada";
    Countries[Countries["Cape Verde"] = 38] = "Cape Verde";
    Countries[Countries["Cayman Islands"] = 39] = "Cayman Islands";
    Countries[Countries["Central African Republic"] = 40] = "Central African Republic";
    Countries[Countries["Chad"] = 41] = "Chad";
    Countries[Countries["Chile"] = 42] = "Chile";
    Countries[Countries["China"] = 43] = "China";
    Countries[Countries["Christmas Island"] = 44] = "Christmas Island";
    Countries[Countries["Cocos (Keeling) Islands"] = 45] = "Cocos (Keeling) Islands";
    Countries[Countries["Colombia"] = 46] = "Colombia";
    Countries[Countries["Comoros"] = 47] = "Comoros";
    Countries[Countries["Democratic People's Republic of Korea"] = 48] = "Democratic People's Republic of Korea";
    Countries[Countries["Democratic Republic Of The Congo"] = 49] = "Democratic Republic Of The Congo";
    Countries[Countries["Cook Islands"] = 50] = "Cook Islands";
    Countries[Countries["Costa Rica"] = 51] = "Costa Rica";
    Countries[Countries["Cote D'ivoire"] = 52] = "Cote D'ivoire";
    Countries[Countries["Croatia"] = 53] = "Croatia";
    Countries[Countries["Cuba"] = 54] = "Cuba";
    Countries[Countries["Cyprus"] = 55] = "Cyprus";
    Countries[Countries["Czech Republic"] = 56] = "Czech Republic";
    Countries[Countries["Denmark"] = 57] = "Denmark";
    Countries[Countries["Djibouti"] = 58] = "Djibouti";
    Countries[Countries["Dominica"] = 59] = "Dominica";
    Countries[Countries["Dominican Republic"] = 60] = "Dominican Republic";
    Countries[Countries["East Timor"] = 61] = "East Timor";
    Countries[Countries["Ecuador"] = 62] = "Ecuador";
    Countries[Countries["Egypt"] = 63] = "Egypt";
    Countries[Countries["El Salvador"] = 64] = "El Salvador";
    Countries[Countries["Equatorial Guinea"] = 65] = "Equatorial Guinea";
    Countries[Countries["Eritrea"] = 66] = "Eritrea";
    Countries[Countries["Estonia"] = 67] = "Estonia";
    Countries[Countries["Ethiopia"] = 68] = "Ethiopia";
    Countries[Countries["Falkland Islands"] = 69] = "Falkland Islands";
    Countries[Countries["Faroe Islands"] = 70] = "Faroe Islands";
    Countries[Countries["Fiji"] = 71] = "Fiji";
    Countries[Countries["Finland"] = 72] = "Finland";
    Countries[Countries["France"] = 73] = "France";
    Countries[Countries["French Guiana"] = 74] = "French Guiana";
    Countries[Countries["French Polynesia"] = 75] = "French Polynesia";
    Countries[Countries["French Southern Territories"] = 76] = "French Southern Territories";
    Countries[Countries["Gabon"] = 77] = "Gabon";
    Countries[Countries["Gambia"] = 78] = "Gambia";
    Countries[Countries["Georgia"] = 79] = "Georgia";
    Countries[Countries["Germany"] = 80] = "Germany";
    Countries[Countries["Ghana"] = 81] = "Ghana";
    Countries[Countries["Gibraltar"] = 82] = "Gibraltar";
    Countries[Countries["Greece"] = 83] = "Greece";
    Countries[Countries["Greenland"] = 84] = "Greenland";
    Countries[Countries["Grenada"] = 85] = "Grenada";
    Countries[Countries["Guadeloupe"] = 86] = "Guadeloupe";
    Countries[Countries["Guam"] = 87] = "Guam";
    Countries[Countries["Guatemala"] = 88] = "Guatemala";
    Countries[Countries["Guinea"] = 89] = "Guinea";
    Countries[Countries["Guinea-bissau"] = 90] = "Guinea-bissau";
    Countries[Countries["Guyana"] = 91] = "Guyana";
    Countries[Countries["Haiti"] = 92] = "Haiti";
    Countries[Countries["Heard Island And Mcdonald Islands"] = 93] = "Heard Island And Mcdonald Islands";
    Countries[Countries["Holy See (Vatican City State)"] = 94] = "Holy See (Vatican City State)";
    Countries[Countries["Honduras"] = 95] = "Honduras";
    Countries[Countries["Hong Kong"] = 96] = "Hong Kong";
    Countries[Countries["Hungary"] = 97] = "Hungary";
    Countries[Countries["Iceland"] = 98] = "Iceland";
    Countries[Countries["India"] = 99] = "India";
    Countries[Countries["Indonesia"] = 100] = "Indonesia";
    Countries[Countries["Iran"] = 101] = "Iran";
    Countries[Countries["Iraq"] = 102] = "Iraq";
    Countries[Countries["Ireland"] = 103] = "Ireland";
    Countries[Countries["Israel"] = 104] = "Israel";
    Countries[Countries["Italy"] = 105] = "Italy";
    Countries[Countries["Jamaica"] = 106] = "Jamaica";
    Countries[Countries["Japan"] = 107] = "Japan";
    Countries[Countries["Jordan"] = 108] = "Jordan";
    Countries[Countries["Kazakstan"] = 109] = "Kazakstan";
    Countries[Countries["Kenya"] = 110] = "Kenya";
    Countries[Countries["Kiribati"] = 111] = "Kiribati";
    Countries[Countries["Kosovo"] = 112] = "Kosovo";
    Countries[Countries["Kuwait"] = 113] = "Kuwait";
    Countries[Countries["Kyrgyzstan"] = 114] = "Kyrgyzstan";
    Countries[Countries["Laos"] = 115] = "Laos";
    Countries[Countries["Latvia"] = 116] = "Latvia";
    Countries[Countries["Lebanon"] = 117] = "Lebanon";
    Countries[Countries["Lesotho"] = 118] = "Lesotho";
    Countries[Countries["Liberia"] = 119] = "Liberia";
    Countries[Countries["Libyan Arab Jamahiriya"] = 120] = "Libyan Arab Jamahiriya";
    Countries[Countries["Liechtenstein"] = 121] = "Liechtenstein";
    Countries[Countries["Lithuania"] = 122] = "Lithuania";
    Countries[Countries["Luxembourg"] = 123] = "Luxembourg";
    Countries[Countries["Macau"] = 124] = "Macau";
    Countries[Countries["Macedonia"] = 125] = "Macedonia";
    Countries[Countries["Madagascar"] = 126] = "Madagascar";
    Countries[Countries["Malawi"] = 127] = "Malawi";
    Countries[Countries["Malaysia"] = 128] = "Malaysia";
    Countries[Countries["Maldives"] = 129] = "Maldives";
    Countries[Countries["Mali"] = 130] = "Mali";
    Countries[Countries["Malta"] = 131] = "Malta";
    Countries[Countries["Marshall Islands"] = 132] = "Marshall Islands";
    Countries[Countries["Martinique"] = 133] = "Martinique";
    Countries[Countries["Mauritania"] = 134] = "Mauritania";
    Countries[Countries["Mauritius"] = 135] = "Mauritius";
    Countries[Countries["Mayotte"] = 136] = "Mayotte";
    Countries[Countries["Mexico"] = 137] = "Mexico";
    Countries[Countries["Federated States Of Micronesia"] = 138] = "Federated States Of Micronesia";
    Countries[Countries["Republic Of Moldova"] = 139] = "Republic Of Moldova";
    Countries[Countries["Monaco"] = 140] = "Monaco";
    Countries[Countries["Mongolia"] = 141] = "Mongolia";
    Countries[Countries["Montserrat"] = 142] = "Montserrat";
    Countries[Countries["Montenegro"] = 143] = "Montenegro";
    Countries[Countries["Morocco"] = 144] = "Morocco";
    Countries[Countries["Mozambique"] = 145] = "Mozambique";
    Countries[Countries["Myanmar"] = 146] = "Myanmar";
    Countries[Countries["Namibia"] = 147] = "Namibia";
    Countries[Countries["Nauru"] = 148] = "Nauru";
    Countries[Countries["Nepal"] = 149] = "Nepal";
    Countries[Countries["Netherlands"] = 150] = "Netherlands";
    Countries[Countries["Netherlands Antilles"] = 151] = "Netherlands Antilles";
    Countries[Countries["New Caledonia"] = 152] = "New Caledonia";
    Countries[Countries["New Zealand"] = 153] = "New Zealand";
    Countries[Countries["Nicaragua"] = 154] = "Nicaragua";
    Countries[Countries["Niger"] = 155] = "Niger";
    Countries[Countries["Nigeria"] = 156] = "Nigeria";
    Countries[Countries["Niue"] = 157] = "Niue";
    Countries[Countries["Norfolk Island"] = 158] = "Norfolk Island";
    Countries[Countries["Northern Mariana Islands"] = 159] = "Northern Mariana Islands";
    Countries[Countries["Norway"] = 160] = "Norway";
    Countries[Countries["Oman"] = 161] = "Oman";
    Countries[Countries["Pakistan"] = 162] = "Pakistan";
    Countries[Countries["Palau"] = 163] = "Palau";
    Countries[Countries["Palestinian Territory"] = 164] = "Palestinian Territory";
    Countries[Countries["Panama"] = 165] = "Panama";
    Countries[Countries["Papua New Guinea"] = 166] = "Papua New Guinea";
    Countries[Countries["Paraguay"] = 167] = "Paraguay";
    Countries[Countries["Peru"] = 168] = "Peru";
    Countries[Countries["Philippines"] = 169] = "Philippines";
    Countries[Countries["Pitcairn"] = 170] = "Pitcairn";
    Countries[Countries["Poland"] = 171] = "Poland";
    Countries[Countries["Portugal"] = 172] = "Portugal";
    Countries[Countries["Puerto Rico"] = 173] = "Puerto Rico";
    Countries[Countries["Qatar"] = 174] = "Qatar";
    Countries[Countries["Romania"] = 175] = "Romania";
    Countries[Countries["Russian Federation"] = 176] = "Russian Federation";
    Countries[Countries["Rwanda"] = 177] = "Rwanda";
    Countries[Countries["Saint Helena"] = 178] = "Saint Helena";
    Countries[Countries["Saint Kitts And Nevis"] = 179] = "Saint Kitts And Nevis";
    Countries[Countries["Saint Lucia"] = 180] = "Saint Lucia";
    Countries[Countries["Saint Pierre And Miquelon"] = 181] = "Saint Pierre And Miquelon";
    Countries[Countries["Saint Vincent And The Grenadines"] = 182] = "Saint Vincent And The Grenadines";
    Countries[Countries["Samoa"] = 183] = "Samoa";
    Countries[Countries["San Marino"] = 184] = "San Marino";
    Countries[Countries["Sao Tome And Principe"] = 185] = "Sao Tome And Principe";
    Countries[Countries["Saudi Arabia"] = 186] = "Saudi Arabia";
    Countries[Countries["Senegal"] = 187] = "Senegal";
    Countries[Countries["Serbia"] = 188] = "Serbia";
    Countries[Countries["Seychelles"] = 189] = "Seychelles";
    Countries[Countries["Sierra Leone"] = 190] = "Sierra Leone";
    Countries[Countries["Singapore"] = 191] = "Singapore";
    Countries[Countries["Slovakia"] = 192] = "Slovakia";
    Countries[Countries["Slovenia"] = 193] = "Slovenia";
    Countries[Countries["Solomon Islands"] = 194] = "Solomon Islands";
    Countries[Countries["Somalia"] = 195] = "Somalia";
    Countries[Countries["South Africa"] = 196] = "South Africa";
    Countries[Countries["South Georgia And The South Sandwich Islands"] = 197] = "South Georgia And The South Sandwich Islands";
    Countries[Countries["The Republic of South Korea"] = 198] = "The Republic of South Korea";
    Countries[Countries["Spain"] = 199] = "Spain";
    Countries[Countries["Sri Lanka"] = 200] = "Sri Lanka";
    Countries[Countries["Sudan"] = 201] = "Sudan";
    Countries[Countries["Suriname"] = 202] = "Suriname";
    Countries[Countries["Svalbard And Jan Mayen"] = 203] = "Svalbard And Jan Mayen";
    Countries[Countries["Swaziland"] = 204] = "Swaziland";
    Countries[Countries["Sweden"] = 205] = "Sweden";
    Countries[Countries["Switzerland"] = 206] = "Switzerland";
    Countries[Countries["Syrian Arab Republic"] = 207] = "Syrian Arab Republic";
    Countries[Countries["Taiwan"] = 208] = "Taiwan";
    Countries[Countries["Tajikistan"] = 209] = "Tajikistan";
    Countries[Countries["Tanzania"] = 210] = "Tanzania";
    Countries[Countries["Thailand"] = 211] = "Thailand";
    Countries[Countries["Togo"] = 212] = "Togo";
    Countries[Countries["Tokelau"] = 213] = "Tokelau";
    Countries[Countries["Tonga"] = 214] = "Tonga";
    Countries[Countries["Trinidad And Tobago"] = 215] = "Trinidad And Tobago";
    Countries[Countries["Tunisia"] = 216] = "Tunisia";
    Countries[Countries["Turkey"] = 217] = "Turkey";
    Countries[Countries["Turkmenistan"] = 218] = "Turkmenistan";
    Countries[Countries["Turks And Caicos Islands"] = 219] = "Turks And Caicos Islands";
    Countries[Countries["Tuvalu"] = 220] = "Tuvalu";
    Countries[Countries["Uganda"] = 221] = "Uganda";
    Countries[Countries["Ukraine"] = 222] = "Ukraine";
    Countries[Countries["United Arab Emirates"] = 223] = "United Arab Emirates";
    Countries[Countries["United Kingdom"] = 224] = "United Kingdom";
    Countries[Countries["United States of America"] = 225] = "United States of America";
    Countries[Countries["United States Minor Outlying Islands"] = 226] = "United States Minor Outlying Islands";
    Countries[Countries["Uruguay"] = 227] = "Uruguay";
    Countries[Countries["Uzbekistan"] = 228] = "Uzbekistan";
    Countries[Countries["Vanuatu"] = 229] = "Vanuatu";
    Countries[Countries["Venezuela"] = 230] = "Venezuela";
    Countries[Countries["Vietnam"] = 231] = "Vietnam";
    Countries[Countries["British Virgin Islands"] = 232] = "British Virgin Islands";
    Countries[Countries["US Virgin Islands"] = 233] = "US Virgin Islands";
    Countries[Countries["Wallis And Futuna"] = 234] = "Wallis And Futuna";
    Countries[Countries["Western Sahara"] = 235] = "Western Sahara";
    Countries[Countries["Yemen"] = 236] = "Yemen";
    Countries[Countries["Zambia"] = 237] = "Zambia";
    Countries[Countries["Zimbabwe"] = 238] = "Zimbabwe";
})(Countries || (Countries = {}));
//# sourceMappingURL=Countries.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/RelatedParty.js
var RelatedParty_CompanyType;
(function (CompanyType) {
    CompanyType["Accountant"] = "ACCOUNTANT";
    CompanyType["Solicitor"] = "SOLICITOR";
})(RelatedParty_CompanyType || (RelatedParty_CompanyType = {}));
var PersonType;
(function (PersonType) {
    PersonType["Spouse"] = "SPOUSE";
})(PersonType || (PersonType = {}));
var VisitContactType;
(function (VisitContactType) {
    VisitContactType["LoanParty"] = "LOAN_PARTY";
    VisitContactType["Tenant"] = "TENANT";
    VisitContactType["RealEstateAgent"] = "REAL_ESTATE_AGENT";
})(VisitContactType || (VisitContactType = {}));
var SubstantialBenefitType;
(function (SubstantialBenefitType) {
    SubstantialBenefitType["SubstantialBenefit"] = "SUBSTANTIAL_BENEFIT";
    SubstantialBenefitType["NoSubstantialBenefitAndProceed"] = "NO_SUBSTANTIAL_BENEFIT_AND_PROCEED";
    SubstantialBenefitType["NoSubstantialBenefit"] = "NO_SUBSTANTIAL_BENEFIT";
})(SubstantialBenefitType || (SubstantialBenefitType = {}));
var CompanyApplicantRelatedPartyType;
(function (CompanyApplicantRelatedPartyType) {
    CompanyApplicantRelatedPartyType["CompanyContact"] = "COMPANY_CONTACT";
    CompanyApplicantRelatedPartyType["CompanyBeneficialOwner"] = "COMPANY_BENEFICIAL_OWNER";
    CompanyApplicantRelatedPartyType["Director"] = "DIRECTOR";
})(CompanyApplicantRelatedPartyType || (CompanyApplicantRelatedPartyType = {}));
var TrustApplicantRelatedPartyType;
(function (TrustApplicantRelatedPartyType) {
    TrustApplicantRelatedPartyType["TrustSettlor"] = "TRUST_SETTLOR";
    TrustApplicantRelatedPartyType["TrustBeneficialOwner"] = "TRUST_BENEFICIAL_OWNER";
    TrustApplicantRelatedPartyType["TrustBeneficiary"] = "TRUST_BENEFICIARY";
    TrustApplicantRelatedPartyType["Trustee"] = "TRUSTEE";
})(TrustApplicantRelatedPartyType || (TrustApplicantRelatedPartyType = {}));
//# sourceMappingURL=RelatedParty.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/EmploymentBasisType.js
var EmploymentBasisType;
(function (EmploymentBasisType) {
    EmploymentBasisType["FullTime"] = "FULL_TIME";
    EmploymentBasisType["PartTime"] = "PART_TIME";
    EmploymentBasisType["Casual"] = "CASUAL";
    EmploymentBasisType["Contractor"] = "CONTRACTOR";
    EmploymentBasisType["MaternityLeave"] = "MATERNITY_LEAVE";
})(EmploymentBasisType || (EmploymentBasisType = {}));
//# sourceMappingURL=EmploymentBasisType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/EmploymentStructures.js
var EmploymentStructures;
(function (EmploymentStructures) {
    EmploymentStructures["Primary"] = "PRIMARY";
    EmploymentStructures["Secondary"] = "SECONDARY";
    EmploymentStructures["Previous"] = "PREVIOUS";
})(EmploymentStructures || (EmploymentStructures = {}));
//# sourceMappingURL=EmploymentStructures.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/EmploymentSubType.js
var EmploymentSubType;
(function (EmploymentSubType) {
    EmploymentSubType["FullDoc"] = "FULL_DOC";
    EmploymentSubType["LowDoc"] = "LOW_DOC";
})(EmploymentSubType || (EmploymentSubType = {}));
//# sourceMappingURL=EmploymentSubType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/NonPersonRelatedPartyRelationshipType.js
var NonPersonRelatedPartyRelationshipType;
(function (NonPersonRelatedPartyRelationshipType) {
    NonPersonRelatedPartyRelationshipType["Applicant"] = "APPLICANT";
    NonPersonRelatedPartyRelationshipType["NonApplicant"] = "NON_APPLICANT";
    NonPersonRelatedPartyRelationshipType["NotApplicable"] = "NOT_APPLICABLE";
})(NonPersonRelatedPartyRelationshipType || (NonPersonRelatedPartyRelationshipType = {}));
//# sourceMappingURL=NonPersonRelatedPartyRelationshipType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/RelationshipToTrust.js
var RelationshipToTrust;
(function (RelationshipToTrust) {
    RelationshipToTrust["Trustee"] = "TRUSTEE";
    RelationshipToTrust["Beneficiary"] = "BENEFICIARY";
    RelationshipToTrust["Director"] = "DIRECTOR";
    RelationshipToTrust["ShareholderOfCorporateTrustee"] = "SHAREHOLDER_OF_CORPORATE_TRUSTEE";
})(RelationshipToTrust || (RelationshipToTrust = {}));
//# sourceMappingURL=RelationshipToTrust.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/RelatedCompany.js
var RelatedCompanyType;
(function (RelatedCompanyType) {
    RelatedCompanyType["Employer"] = "EMPLOYER";
    RelatedCompanyType["SelfEmploymentBusiness"] = "SELF_EMPLOYMENT_BUSINESS";
})(RelatedCompanyType || (RelatedCompanyType = {}));
//# sourceMappingURL=RelatedCompany.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/BuilderType.js
var BuilderType;
(function (BuilderType) {
    BuilderType["LicensedBuilder"] = "LICENSED_BUILDER";
    BuilderType["OwnerBuilder"] = "OWNER_BUILDER";
})(BuilderType || (BuilderType = {}));
//# sourceMappingURL=BuilderType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/CustomerPropertyRelationship.js
var CustomerPropertyRelationship;
(function (CustomerPropertyRelationship) {
    CustomerPropertyRelationship["OWNER"] = "OWNER";
    CustomerPropertyRelationship["LOOKING_TO_BUY"] = "LOOKING_TO_BUY";
    CustomerPropertyRelationship["JUST_LOOKING"] = "JUST_LOOKING";
})(CustomerPropertyRelationship || (CustomerPropertyRelationship = {}));
//# sourceMappingURL=CustomerPropertyRelationship.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/PropertyEventTimelineType.js
var PropertyEventTimelineType;
(function (PropertyEventTimelineType) {
    PropertyEventTimelineType["Rented"] = "RENTED";
    PropertyEventTimelineType["Sold"] = "SOLD";
})(PropertyEventTimelineType || (PropertyEventTimelineType = {}));
//# sourceMappingURL=PropertyEventTimelineType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/PropertyVisibility.js
var PropertyVisibility;
(function (PropertyVisibility) {
    PropertyVisibility["ACTIVE"] = "ACTIVE";
    PropertyVisibility["ARCHIVED"] = "ARCHIVED";
    PropertyVisibility["ACTIVE_TO_TEAM_ONLY"] = "ACTIVE_TO_TEAM_ONLY";
})(PropertyVisibility || (PropertyVisibility = {}));
//# sourceMappingURL=PropertyVisibility.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/PlatformPathname.js
var PlatformPathname;
(function (PlatformPathname) {
    PlatformPathname["BOOKING_APPOINTMENT_PATHNAME"] = "/book-appointment";
    PlatformPathname["BOOKING_APPOINTMENT_BUYERS_AGENT_PATHNAME"] = "/book-appointment/buyers-agent";
    PlatformPathname["BUYERS_AGENT_PATHNAME"] = "/buyers-agent";
    PlatformPathname["TIME_SELECTION_PROCESS_PATHNAME"] = "/book-appointment/process";
    PlatformPathname["STAMP_DUTY_PATHNAME"] = "/stamp-duty-calculator";
    PlatformPathname["PROPERTY_REPORT_PATHNAME"] = "/property-report";
    PlatformPathname["CHECK_YOUR_CREDIT_SCORE_PATHNAME"] = "/check-your-credit-score";
    PlatformPathname["FREE_CREDIT_SCORE_CHECK_PATHNAME"] = "/free-credit-score-check";
    PlatformPathname["CREDIT_SCORE_RESULT_PATHNAME"] = "/credit-score/result";
    PlatformPathname["REFINANCE_FUNNEL_PATHNAME"] = "/home-loans/basics/refinance/refinance-loan-amount";
    PlatformPathname["NEW_PURCHASE_FUNNEL_PATHNAME"] = "/home-loans/basics/new-home/purchase-price";
    PlatformPathname["BORROWING_POWER_FUNNEL_PATHNAME"] = "/home-loans/basics/borrowing-power/applicants";
    PlatformPathname["REFER_A_FRIEND_PATHNAME"] = "/home-loans/refer-a-friend";
})(PlatformPathname || (PlatformPathname = {}));
//# sourceMappingURL=PlatformPathname.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/CtpInterestRateType.js
var CtpInterestRateType;
(function (CtpInterestRateType) {
    CtpInterestRateType["Variable"] = "VariableRate";
    CtpInterestRateType["Fixed"] = "FixedRate";
})(CtpInterestRateType || (CtpInterestRateType = {}));
//# sourceMappingURL=CtpInterestRateType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/AppointmentCancellationReason.js
var AppointmentCancellationReason;
(function (AppointmentCancellationReason) {
    AppointmentCancellationReason["CustomerNotResponding"] = "CUSTOMER_NOT_RESPONDING";
    AppointmentCancellationReason["ExploringOptions"] = "EXPLORING_OPTIONS";
    AppointmentCancellationReason["HappyWithCurrentBankAndRates"] = "HAPPY_WITH_CURRENT_BANK_AND_RATES";
    AppointmentCancellationReason["ServicingIncomeOrEmployment"] = "SERVICING_INCOME_OR_EMPLOYMENT";
    AppointmentCancellationReason["DuplicatedAppointment"] = "DUPLICATED_APPOINTMENT";
    AppointmentCancellationReason["CreditIssues"] = "CREDIT_ISSUES";
    AppointmentCancellationReason["LowRefinanceLvr"] = "LOW_REFINANCE_LVR";
    AppointmentCancellationReason["InsufficientDeposit"] = "INSUFFICIENT_DEPOSIT";
    AppointmentCancellationReason["InsufficientExitStrategy"] = "INSUFFICIENT_EXIT_STRATEGY";
    AppointmentCancellationReason["PurchasingAfterThreeMonths"] = "PURCHASING_AFTER_THREE_MONTHS";
    AppointmentCancellationReason["PendingLegalMatter"] = "PENDING_LEGAL_MATTER";
})(AppointmentCancellationReason || (AppointmentCancellationReason = {}));
//# sourceMappingURL=AppointmentCancellationReason.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/TrustType.js
var TrustType;
(function (TrustType) {
    TrustType["CashManagementTrust"] = "CASH_MANAGEMENT_TRUST";
    TrustType["DiscretionaryTrust"] = "DISCRETIONARY_TRUST";
    TrustType["Fixed"] = "FIXED";
    TrustType["Hybrid"] = "HYBRID";
    TrustType["Other"] = "OTHER";
    TrustType["SimpleOrBare"] = "SIMPLE_OR_BARE";
    TrustType["SuperannuationTrusts"] = "SUPERANNUATION_TRUSTS";
    TrustType["Unit"] = "UNIT";
})(TrustType || (TrustType = {}));
//# sourceMappingURL=TrustType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/TrustSettlorNotApplicableReason.js
var TrustSettlorNotApplicableReason;
(function (TrustSettlorNotApplicableReason) {
    TrustSettlorNotApplicableReason["Deceased"] = "DECEASED";
    TrustSettlorNotApplicableReason["MinorContribution"] = "MINOR_CONTRIBUTION";
})(TrustSettlorNotApplicableReason || (TrustSettlorNotApplicableReason = {}));
//# sourceMappingURL=TrustSettlorNotApplicableReason.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/AppointmentLength.js
var _a, _b, _c, _d, _e, _f, _g, _h;

var InteractionType;
(function (InteractionType) {
    InteractionType["Phone"] = "Phone";
    InteractionType["FaceToFace"] = "F2F";
    InteractionType["Video"] = "Video";
    InteractionType["Store"] = "Store";
})(InteractionType || (InteractionType = {}));
var AppointmentLengthType;
(function (AppointmentLengthType) {
    AppointmentLengthType["15_30_15"] = "15_30_15";
    AppointmentLengthType["15_60_15"] = "15_60_15";
    AppointmentLengthType["60_60_60"] = "60_60_60";
})(AppointmentLengthType || (AppointmentLengthType = {}));
var AppointmentLength = {
    '15_30_15': {
        preBuffer: 15,
        length: 30,
        postBuffer: 15,
    },
    '15_60_15': {
        preBuffer: 15,
        length: 60,
        postBuffer: 15,
    },
    '60_60_60': {
        preBuffer: 60,
        length: 60,
        postBuffer: 60,
    },
};
var BrandInteractionType = (_a = {},
    _a[Brand.Lendi] = (_b = {},
        _b[InteractionType.Phone] = AppointmentLengthType['15_30_15'],
        _b[InteractionType.Video] = AppointmentLengthType['15_30_15'],
        _b[InteractionType.FaceToFace] = AppointmentLengthType['15_30_15'],
        _b),
    _a[Brand.Domain] = (_c = {},
        _c[InteractionType.Phone] = AppointmentLengthType['15_30_15'],
        _c[InteractionType.Video] = AppointmentLengthType['15_30_15'],
        _c[InteractionType.FaceToFace] = AppointmentLengthType['15_30_15'],
        _c),
    _a[Brand.Aussie] = (_d = {},
        _d[InteractionType.Phone] = AppointmentLengthType['15_30_15'],
        _d[InteractionType.Video] = AppointmentLengthType['15_30_15'],
        _d[InteractionType.FaceToFace] = AppointmentLengthType['60_60_60'],
        _d[InteractionType.Store] = AppointmentLengthType['15_60_15'],
        _d),
    _a);
var AppointmentLeadTimeMinutes = (_e = {},
    _e[Brand.Lendi] = (_f = {},
        _f[InteractionType.Phone] = 60,
        _f[InteractionType.Video] = 60,
        _f),
    _e[Brand.Domain] = (_g = {},
        _g[InteractionType.Phone] = 60,
        _g[InteractionType.Video] = 60,
        _g),
    _e[Brand.Aussie] = (_h = {},
        _h[InteractionType.Phone] = 120,
        _h[InteractionType.Video] = 120,
        _h[InteractionType.FaceToFace] = 240,
        _h[InteractionType.Store] = 240,
        _h),
    _e);
//# sourceMappingURL=AppointmentLength.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/ActiveRoles.js
var ActiveRole;
(function (ActiveRole) {
    ActiveRole["Borrower"] = "BORROWER";
    ActiveRole["Guarantor"] = "GUARANTOR";
    ActiveRole["AppReadonly"] = "APP_READONLY";
})(ActiveRole || (ActiveRole = {}));
var activeRoles = [ActiveRole.Borrower, ActiveRole.Guarantor, ActiveRole.AppReadonly];
//# sourceMappingURL=ActiveRoles.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/AssetFinance.js
var AssetFinanceType;
(function (AssetFinanceType) {
    AssetFinanceType["BusinessLoanWorkingCapital"] = "BUSINESS_LOAN_OR_WORKING_CAPITAL";
    AssetFinanceType["DebtConsolidation"] = "DEBT_CONSOLIDATION";
    AssetFinanceType["HomeImprovement"] = "HOME_IMPROVEMENT";
    AssetFinanceType["LeisureAsset"] = "LEISURE_ASSET";
    AssetFinanceType["OtherPersonal"] = "OTHER_OR_PERSONAL";
    AssetFinanceType["PlantAndEquipment"] = "PLANT_AND_EQUIPMENT";
    AssetFinanceType["VehicleLoan"] = "VEHICLE_LOAN";
})(AssetFinanceType || (AssetFinanceType = {}));
var ClientStatus;
(function (ClientStatus) {
    ClientStatus["ExistingCustomerWithHomeLoan"] = "EXISTING_HOME_LOAN_CUSTOMER";
    ClientStatus["ExistingCustomerWithoutHomeLoan"] = "EXISTING_CUSTOMER_NO_HOME_LOAN";
    ClientStatus["NewCustomer"] = "NEW_CUSTOMER_NO_PRIOR_RELATIONSHIP";
})(ClientStatus || (ClientStatus = {}));
var FinanceStage;
(function (FinanceStage) {
    FinanceStage["NoQuote"] = "NO_QUOTE";
    FinanceStage["QuoteHeld"] = "QUOTE_HELD";
    FinanceStage["Unknown"] = "UNKNOWN";
})(FinanceStage || (FinanceStage = {}));
var IntentToBuy;
(function (IntentToBuy) {
    IntentToBuy["EnquiryOnly"] = "ENQUIRY_ONLY";
    IntentToBuy["ReadyToGo"] = "READY_TO_GO";
    IntentToBuy["Unknown"] = "UNKNOWN";
})(IntentToBuy || (IntentToBuy = {}));
var LoanCategory;
(function (LoanCategory) {
    LoanCategory["Commercial"] = "COMMERCIAL";
    LoanCategory["Consumer"] = "CONSUMER";
})(LoanCategory || (LoanCategory = {}));
var BusinessLoanWorkingCapitalLoanType;
(function (BusinessLoanWorkingCapitalLoanType) {
    BusinessLoanWorkingCapitalLoanType["BusinessOverdraft"] = "BUSINESS_OVERDRAFT";
    BusinessLoanWorkingCapitalLoanType["InsurancePremium"] = "INSURANCE_PREMIUM";
    BusinessLoanWorkingCapitalLoanType["InvoiceFinance"] = "INVOICE_FINANCE";
    BusinessLoanWorkingCapitalLoanType["LineOfCredit"] = "LINE_OF_CREDIT";
    BusinessLoanWorkingCapitalLoanType["Other"] = "OTHER";
    BusinessLoanWorkingCapitalLoanType["UnsecuredBusinessLoans"] = "UNSECURED_BUSINESS_LOANS";
})(BusinessLoanWorkingCapitalLoanType || (BusinessLoanWorkingCapitalLoanType = {}));
var LeisureAssetLoanType;
(function (LeisureAssetLoanType) {
    LeisureAssetLoanType["MarineAsset"] = "BOAT_JETSKI";
    LeisureAssetLoanType["Other"] = "OTHER";
    LeisureAssetLoanType["WheeledAsset"] = "CARAVAN_HORSEFLOAT_TRAILER";
})(LeisureAssetLoanType || (LeisureAssetLoanType = {}));
var OtherPersonalLoanType;
(function (OtherPersonalLoanType) {
    OtherPersonalLoanType["Dental"] = "DENTAL";
    OtherPersonalLoanType["Education"] = "EDUCATION";
    OtherPersonalLoanType["Furnishings"] = "FURNISHINGS";
    OtherPersonalLoanType["Medical"] = "MEDICAL";
    OtherPersonalLoanType["Other"] = "OTHER";
    OtherPersonalLoanType["Travel"] = "TRAVEL";
    OtherPersonalLoanType["WeddingOrFuneral"] = "WEDDING_OR_FUNERAL";
})(OtherPersonalLoanType || (OtherPersonalLoanType = {}));
var PlantAndEquipmentLoanType;
(function (PlantAndEquipmentLoanType) {
    PlantAndEquipmentLoanType["BusinessEquipment"] = "GENERATORS_MACHINERY_GYM_EQUIPMENT";
    PlantAndEquipmentLoanType["FitoutFinance"] = "FITOUT_FINANCE";
    PlantAndEquipmentLoanType["Other"] = "OTHER";
    PlantAndEquipmentLoanType["TruckAndTrailer"] = "TRUCK_AND_TRAILER";
    PlantAndEquipmentLoanType["WheeledAssets"] = "TRACTORS_EXCAVATORS_LIFTS";
})(PlantAndEquipmentLoanType || (PlantAndEquipmentLoanType = {}));
var VehicleCondition;
(function (VehicleCondition) {
    VehicleCondition["Demo"] = "DEMO";
    VehicleCondition["New"] = "NEW";
    VehicleCondition["Unknown"] = "UNKNOWN";
    VehicleCondition["Used"] = "USED";
})(VehicleCondition || (VehicleCondition = {}));
var VehicleFinanceStage;
(function (VehicleFinanceStage) {
    VehicleFinanceStage["BankOrOtherLenderQuote"] = "BANK_OR_OTHER_LENDER_QUOTE";
    VehicleFinanceStage["DealerQuote"] = "DEALER_QUOTE";
    VehicleFinanceStage["NoQuoteHeld"] = "NO_QUOTE_HELD";
    VehicleFinanceStage["Unknown"] = "UNKNOWN";
})(VehicleFinanceStage || (VehicleFinanceStage = {}));
var VehicleIntentToBuy;
(function (VehicleIntentToBuy) {
    VehicleIntentToBuy["BuyNowVehicleInMind"] = "BUY_NOW_VEHICLE_IN_MIND";
    VehicleIntentToBuy["BuyNowNoVehicleInMind"] = "BUY_NOW_NO_VEHICLE_IN_MIND";
    VehicleIntentToBuy["EnquiryOnly"] = "ENQUIRY_ONLY";
    VehicleIntentToBuy["Unknown"] = "UNKNOWN";
})(VehicleIntentToBuy || (VehicleIntentToBuy = {}));
var VehicleMake;
(function (VehicleMake) {
    VehicleMake["Abarth"] = "Abarth";
    VehicleMake["Alfa Romeo"] = "Alfa Romeo";
    VehicleMake["Aston Martin"] = "Aston Martin";
    VehicleMake["Audi"] = "Audi";
    VehicleMake["BMW"] = "BMW";
    VehicleMake["Bentley"] = "Bentley";
    VehicleMake["Caterham"] = "Caterham";
    VehicleMake["Chery"] = "Chery";
    VehicleMake["Chrysler"] = "Chrysler";
    VehicleMake["Citroen"] = "Citroen";
    VehicleMake["Dodge"] = "Dodge";
    VehicleMake["Ferrari"] = "Ferrari";
    VehicleMake["Fiat"] = "Fiat";
    VehicleMake["Ford"] = "Ford";
    VehicleMake["Foton"] = "Foton";
    VehicleMake["Geely"] = "Geely";
    VehicleMake["Great Wall"] = "Great Wall";
    VehicleMake["HSV"] = "HSV";
    VehicleMake["Holden"] = "Holden";
    VehicleMake["Honda"] = "Honda";
    VehicleMake["Hummer"] = "Hummer";
    VehicleMake["Hyundai"] = "Hyundai";
    VehicleMake["Infiniti"] = "Infiniti";
    VehicleMake["Isuzu"] = "Isuzu";
    VehicleMake["Jaguar"] = "Jaguar";
    VehicleMake["Jeep"] = "Jeep";
    VehicleMake["Kia"] = "Kia";
    VehicleMake["LDV"] = "LDV";
    VehicleMake["Lamborghini"] = "Lamborghini";
    VehicleMake["Land Rover"] = "Land Rover";
    VehicleMake["Lexus"] = "Lexus";
    VehicleMake["Lotus"] = "Lotus";
    VehicleMake["M.G."] = "M.G.";
    VehicleMake["Mahindra"] = "Mahindra";
    VehicleMake["Maserati"] = "Maserati";
    VehicleMake["Maybach"] = "Maybach";
    VehicleMake["Mazda"] = "Mazda";
    VehicleMake["Mclaren"] = "Mclaren";
    VehicleMake["Mercedes-Benz"] = "Mercedes-Benz";
    VehicleMake["Mini"] = "Mini";
    VehicleMake["Mitsubishi"] = "Mitsubishi";
    VehicleMake["Morgan"] = "Morgan";
    VehicleMake["Nissan"] = "Nissan";
    VehicleMake["Opel"] = "Opel";
    VehicleMake["Other"] = "Other";
    VehicleMake["Peugeot"] = "Peugeot";
    VehicleMake["Porsche"] = "Porsche";
    VehicleMake["Proton"] = "Proton";
    VehicleMake["Range Rover"] = "Range Rover";
    VehicleMake["Renault"] = "Renault";
    VehicleMake["Rolls-Royce"] = "Rolls-Royce";
    VehicleMake["Saab"] = "Saab";
    VehicleMake["Skoda"] = "Skoda";
    VehicleMake["Smart"] = "Smart";
    VehicleMake["Ssangyong"] = "Ssangyong";
    VehicleMake["Subaru"] = "Subaru";
    VehicleMake["Suzuki"] = "Suzuki";
    VehicleMake["Tata"] = "Tata";
    VehicleMake["Tesla"] = "Tesla";
    VehicleMake["Toyota"] = "Toyota";
    VehicleMake["Volkswagen"] = "Volkswagen";
    VehicleMake["Volvo"] = "Volvo";
    VehicleMake["ZX Auto"] = "ZX Auto";
})(VehicleMake || (VehicleMake = {}));
var VehicleModel = {
    Abarth: ['500', '595', '695', 'Other'],
    'Alfa Romeo': ['147', '156', '159', '166', '4C', 'Brera', 'GT', 'Giulietta', 'Mito', 'Spider', 'Other'],
    'Aston Martin': ['DB7', 'DB9', 'DBS', 'Rapide', 'V12', 'V8', 'Vanquish', 'Virage', 'Other'],
    Audi: [
        'A1',
        'A3',
        'A4',
        'A5',
        'A6',
        'A7',
        'A8',
        'Allroad Quattro',
        'Q3',
        'Q5',
        'Q7',
        'R8',
        'RS Q3',
        'RS4',
        'RS5',
        'RS6',
        'RS7',
        'S1',
        'S3',
        'S4',
        'S5',
        'S6',
        'S7',
        'S8',
        'SQ5',
        'TT',
        'Other',
    ],
    BMW: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        'I3',
        'I8',
        'M3',
        'M4',
        'M5',
        'M6',
        'X1',
        'X3',
        'X4',
        'X5',
        'X6',
        'Z4',
        'Other',
    ],
    Bentley: ['Arnage', 'Continental', 'Flying Spur', 'Mulsanne', 'Other'],
    Caterham: ['Seven', 'Other'],
    Chery: ['J1', 'J11', 'J3', 'Other'],
    Chrysler: ['300', '300C', 'Crossfire', 'Grand Voyager', 'PT Cruiser', 'Sebring', 'Voyager', 'Other'],
    Citroen: [
        'Berlingo',
        'Berlingo II',
        'C2',
        'C3',
        'C4',
        'C4 Grand Picasso',
        'C4 Picasso',
        'C5',
        'C6',
        'DS3',
        'DS4',
        'DS5',
        'Dispatch',
        'Grand C4',
        'Other',
    ],
    Dodge: ['Avenger', 'Caliber', 'Journey', 'Nitro', 'Other'],
    Ferrari: ['458', '599', '612', 'California', 'F12', 'F430', 'FF', 'Superamerica', 'Other'],
    Fiat: ['500', 'Doblo', 'Freemont', 'Panda', 'Punto', 'Ritmo', 'Scudo', 'Other'],
    Ford: [
        'Courier',
        'Econovan',
        'Ecosport',
        'Escape',
        'Explorer',
        'F250',
        'F350',
        'FPV',
        'Fairlane',
        'Fairmont',
        'Falcon',
        'Fiesta',
        'Focus',
        'G6',
        'Kuga',
        'LTD',
        'Mondeo',
        'Ranger',
        'Territory',
        'Transit',
        'Transit Custom',
        'Other',
    ],
    Foton: ['Tunland', 'Other'],
    Geely: ['MK', 'Other'],
    'Great Wall': ['SA220', 'V200', 'V240', 'X200', 'X240', 'Other'],
    HSV: ['Avalanche', 'Clubsport', 'Coupe', 'GTS', 'Grange', 'Maloo', 'SV6000', 'Senator', 'VXR', 'W427', 'Other'],
    Holden: [
        'Adventra',
        'Astra',
        'Barina',
        'Barina Spark',
        'Berlina',
        'Calais',
        'Caprice',
        'Captiva',
        'Colorado',
        'Colorado 7',
        'Combo',
        'Commodore',
        'Crewman',
        'Cruze',
        'Epica',
        'Malibu',
        'Monaro',
        'Rodeo',
        'Statesman',
        'Tigra',
        'Trax',
        'UTE',
        'Vectra',
        'Viva',
        'Volt',
        'Zafira',
        'Other',
    ],
    Honda: [
        'Accord',
        'CR-Z',
        'CRV',
        'City',
        'Civic',
        'HR-V',
        'Insight',
        'Integra',
        'Jazz',
        'Legend',
        'MDX',
        'Odyssey',
        'S2000',
        'Other',
    ],
    Hummer: ['H3', 'Other'],
    Hyundai: [
        'Accent',
        'Elantra',
        'Genesis',
        'Getz',
        'Grandeur',
        'I20',
        'I30',
        'I40',
        'I45',
        'IX35',
        'Iload',
        'Imax',
        'Santa FE',
        'Sonata',
        'Terracan',
        'Tiburon',
        'Trajet',
        'Tucson',
        'Veloster',
        'Other',
    ],
    Infiniti: ['FX', 'G37', 'M', 'Q50', 'Q60', 'Q70', 'QX70', 'Other'],
    Isuzu: ['D-MAX', 'MU-X', 'Other'],
    Jaguar: ['F-Type', 'S Type', 'X Type', 'XF', 'XJ', 'XJ6', 'XJ8', 'XJR', 'XK', 'XK8', 'XKR', 'Other'],
    Jeep: ['Cherokee', 'Commander', 'Compass', 'Grand Cherokee', 'Patriot', 'Wrangler', 'Wrangler Unlimited', 'Other'],
    Kia: [
        'Carnival',
        'Cerato',
        'Grand Carnival',
        'K2700',
        'K2900',
        'Magentis',
        'Optima',
        'PRO CEE`D',
        'Pregio',
        'RIO',
        'Rondo',
        'Sorento',
        'Soul',
        'Sportage',
        'Other',
    ],
    LDV: ['V80', 'Other'],
    Lamborghini: ['Aventador', 'Gallardo', 'Huracan', 'Murcielago', 'Other'],
    'Land Rover': ['Defender', 'Discovery 3', 'Discovery 4', 'Freelander', 'Freelander 2', 'Other'],
    Lexus: [
        'CT 200H. Hybrid',
        'ES300',
        'ES300H',
        'ES350',
        'GS250',
        'GS300',
        'GS300H',
        'GS350',
        'GS430',
        'GS450H',
        'GS460',
        'IS F',
        'IS250',
        'IS250C',
        'IS300H',
        'IS350',
        'LFA',
        'LS430',
        'LS460',
        'LS600H',
        'LS600HL',
        'LX470',
        'LX570',
        'NX200T',
        'NX300H',
        'RC F',
        'RC350',
        'RX270',
        'RX330',
        'RX350',
        'RX400H',
        'RX450H',
        'SC430',
        'Other',
    ],
    Lotus: ['Elise', 'Europa', 'Evora', 'Exige', 'Other'],
    'M.G.': ['MG6', 'Other'],
    Mahindra: ['Genio', 'PIK-UP', 'XUV500', 'Other'],
    Maserati: ['Coupe', 'Ghibli', 'Grancabrio', 'Gransport', 'Granturismo', 'Quattroporte', 'Spyder', 'Other'],
    Maybach: ['57', '62', 'Other'],
    Mazda: [
        'B2500',
        'B2600',
        'B4000',
        'BT50',
        'CX-5',
        'CX-7',
        'CX-9',
        'E1800',
        'E2000',
        'MPV',
        'MX-5',
        'Mazda2',
        'Mazda3',
        'Mazda6',
        'RX-8',
        'Tribute',
        'Other',
    ],
    Mclaren: ['MP4-12C', 'Other'],
    'Mercedes-Benz': [
        'A150',
        'A170',
        'A180',
        'A200',
        'A250',
        'A45',
        'B180',
        'B200',
        'B250',
        'C180',
        'C200',
        'C220',
        'C230',
        'C250',
        'C280',
        'C300',
        'C320',
        'C350',
        'C55',
        'C63',
        'CL',
        'CL500',
        'CL600',
        'CLA',
        'CLC',
        'CLK200K',
        'CLK280',
        'CLK350',
        'CLK500',
        'CLK55',
        'CLK63',
        'CLS',
        'E200',
        'E200K',
        'E220',
        'E250',
        'E280',
        'E300',
        'E350',
        'E400',
        'E500',
        'E55',
        'E63',
        'G',
        'GL',
        'GLA',
        'ML',
        'R',
        'S300',
        'S320',
        'S350',
        'S400',
        'S430',
        'S500',
        'S55',
        'S600',
        'S63',
        'S65',
        'SL',
        'SL350',
        'SL500',
        'SL600',
        'SLK',
        'SLS',
        'Valente',
        'Viano',
        'Vito',
        'Other',
    ],
    Mini: ['Cooper', 'ONE', 'Other'],
    Mitsubishi: [
        '380',
        'ASX',
        'Challenger',
        'Colt',
        'Express',
        'Grandis',
        'I-Miev',
        'Lancer',
        'Mirage',
        'Outlander',
        'Pajero',
        'Triton',
        'Other',
    ],
    Morgan: ['3 Wheeler', '4/4', 'Aero Coupe', 'Aero Supersports', 'Plus 4', 'Plus 8', 'Roadster', 'Other'],
    Nissan: [
        '350Z',
        '370Z',
        'Almera',
        'Altima',
        'Dualis',
        'GT-R',
        'Juke',
        'Leaf',
        'Maxima',
        'Micra',
        'Murano',
        'Navara',
        'Pathfinder',
        'Patrol',
        'Pulsar',
        'Qashqai',
        'Tiida',
        'X-Trail',
        'Other',
    ],
    Opel: ['Astra', 'Corsa', 'Insignia', 'Zafira', 'Other'],
    Peugeot: [
        '206',
        '207',
        '208',
        '307',
        '308',
        '407',
        '508',
        '607',
        '2008',
        '3008',
        '4007',
        '4008',
        '5008',
        'Expert',
        'Partner',
        'RCZ',
        'Other',
    ],
    Porsche: ['911', 'Boxster', 'Cayenne', 'Cayman', 'Macan', 'Panamera', 'Other'],
    Proton: [
        'Exora',
        'GEN.2',
        'Jumbuck',
        'Persona',
        'Preve',
        'S16',
        'S16 FLX',
        'Satria',
        'Satria-NEO',
        'Savvy',
        'Suprima S',
        'Waja',
        'Other',
    ],
    'Range Rover': ['Evoque', 'Range Rover', 'Other'],
    Renault: [
        'Captur',
        'Clio',
        'Fluence',
        'Grand Scenic II',
        'Kangoo',
        'Koleos',
        'Laguna',
        'Latitude',
        'Megane',
        'Scenic II',
        'Trafic',
        'Other',
    ],
    'Rolls-Royce': ['Ghost', 'Phantom', 'Other'],
    Saab: ['9-3', '9-5', 'Turbo X', 'Other'],
    Skoda: ['Fabia', 'Octavia', 'Rapid Spaceback', 'Roomster', 'Superb', 'Yeti', 'Other'],
    Smart: ['Forfour', 'Fortwo', 'Roadster', 'Other'],
    Ssangyong: [
        'Actyon',
        'Actyon Sports',
        'Chairman',
        'Korando',
        'Kyron',
        'Musso',
        'Rexton',
        'Rexton II',
        'Stavic',
        'Other',
    ],
    Subaru: ['BRZ', 'Forester', 'Impreza', 'Liberty', 'Outback', 'Tribeca', 'WRX', 'XV', 'Other'],
    Suzuki: [
        'APV',
        'Alto',
        'Celerio',
        'Grand Vitara',
        'Jimny',
        'Kizashi',
        'Liana',
        'S-Cross',
        'SX4',
        'Swift',
        'XL-7',
        'Other',
    ],
    Tata: ['Xenon', 'Other'],
    Tesla: ['Model S', 'Other'],
    Toyota: [
        '86',
        'Aurion',
        'Avalon',
        'Avensis',
        'Camry',
        'Celica',
        'Corolla',
        'FJ Cruiser',
        'Hiace',
        'Hilux',
        'Kluger',
        'Landcruiser',
        'MR2',
        'Prius',
        'Prius V',
        'Prius-C',
        'RAV4',
        'Rukus',
        'TRD',
        'Tarago',
        'Yaris',
        'Other',
    ],
    Volkswagen: [
        'Amarok',
        'Beetle',
        'Bora',
        'CC',
        'Caddy',
        'Caravelle',
        'Citivan',
        'EOS',
        'Golf',
        'Jetta',
        'Kombi',
        'Multivan',
        'Passat',
        'Passat CC',
        'Polo',
        'Scirocco',
        'Tiguan',
        'Touareg',
        'Transporter',
        'UP!',
        'Other',
    ],
    Volvo: ['C30', 'C70', 'S40', 'S60', 'S80', 'V40', 'V50', 'V60', 'V70', 'XC60', 'XC70', 'XC90', 'Other'],
    'ZX Auto': ['Grand Tiger', 'Other'],
    Other: ['Other'],
};
var PlatformFinanceStatus;
(function (PlatformFinanceStatus) {
    PlatformFinanceStatus["Accepted"] = "ACCEPTED";
    PlatformFinanceStatus["Application"] = "APPLICATION";
    PlatformFinanceStatus["Approved"] = "APPROVED";
    PlatformFinanceStatus["AppBooked"] = "APP_BOOKED";
    PlatformFinanceStatus["Assessment"] = "ASSESSMENT";
    PlatformFinanceStatus["AwaitingAcceptance"] = "AWAITING_ACCEPTANCE";
    PlatformFinanceStatus["CALL_ONE"] = "CALL_ONE";
    PlatformFinanceStatus["CALL_TWO"] = "CALL_TWO";
    PlatformFinanceStatus["Converted"] = "CONVERTED";
    PlatformFinanceStatus["DealLost"] = "DEAL_LOST";
    PlatformFinanceStatus["DnpMarket"] = "DNP_MARKET";
    PlatformFinanceStatus["Documents"] = "DOCUMENTS";
    PlatformFinanceStatus["FollowUp"] = "FOLLOW_UP";
    PlatformFinanceStatus["HotLead"] = "HOT_LEAD";
    PlatformFinanceStatus["NewLead"] = "NEW_LEAD";
    PlatformFinanceStatus["PendingInfo"] = "PENDING_INFO";
    PlatformFinanceStatus["PendingSupportingDocs"] = "PENDING_SUPPORTING_DOCS";
    PlatformFinanceStatus["QuoteSent"] = "QUOTE_SENT";
    PlatformFinanceStatus["ReferredToBroker"] = "REFERRED_TO_BROKER ";
    PlatformFinanceStatus["Settled"] = "SETTLED";
    PlatformFinanceStatus["SmsSent"] = "SMS_SENT";
    PlatformFinanceStatus["Workshop"] = "WORKSHOP";
})(PlatformFinanceStatus || (PlatformFinanceStatus = {}));
var PlatformFinanceSubStatus;
(function (PlatformFinanceSubStatus) {
    PlatformFinanceSubStatus["AlternativeFunding"] = "ALTERNATIVE_FUNDING";
    PlatformFinanceSubStatus["ApplicationReceived"] = "APPLICATION_RECEIVED";
    PlatformFinanceSubStatus["ApplicationSent"] = "APPLICATION_SENT";
    PlatformFinanceSubStatus["AppointmentIncomplete"] = "APPOINTMENT_INCOMPLET";
    PlatformFinanceSubStatus["AwaitingFurtherInformation"] = "AWAITING_FURTHER_INFORMATION";
    PlatformFinanceSubStatus["AwaitingVehicle"] = "AWAITING_VEHICLE";
    PlatformFinanceSubStatus["BadCredit"] = "BAD_CREDIT";
    PlatformFinanceSubStatus["ChangedMind"] = "CHANGED_MIND";
    PlatformFinanceSubStatus["CouldNotContact"] = "COULD_NOT_CONTACT";
    PlatformFinanceSubStatus["DocumentsReceived"] = "DOCUMENTS_RECEIVED";
    PlatformFinanceSubStatus["DocumentsRequested"] = "DOCUMENTS_REQUESTED";
    PlatformFinanceSubStatus["DocumentsSent"] = "DOCUMENTS_SENT";
    PlatformFinanceSubStatus["Duplicate"] = "DUPLICATE";
    PlatformFinanceSubStatus["FutureContact"] = "FUTURE_CONTACT";
    PlatformFinanceSubStatus["InvoiceReceived"] = "INVOICE_RECEIVED";
    PlatformFinanceSubStatus["InvoiceRequested"] = "INVOICE_REQUESTED";
    PlatformFinanceSubStatus["Junk"] = "JUNK";
    PlatformFinanceSubStatus["Junklead"] = "JUNKLEAD";
    PlatformFinanceSubStatus["NoCapacity"] = "NO_CAPACITY";
    PlatformFinanceSubStatus["NoClientResponse"] = "NO_CLIENT_RESPONSE";
    PlatformFinanceSubStatus["Other"] = "OTHER";
    PlatformFinanceSubStatus["OtherFinancier"] = "OTHER_FINANCIER";
    PlatformFinanceSubStatus["OutsideGuidelines"] = "OUTSIDE_GUIDELINES";
    PlatformFinanceSubStatus["PreApproved"] = "PRE_APPROVED";
    PlatformFinanceSubStatus["QuoteOnly"] = "QUOTE_ONLY";
    PlatformFinanceSubStatus["ReadyForSettlement"] = "READY_FOR_SETTLEMENT";
    PlatformFinanceSubStatus["SentForSettlement"] = "SENT_FOR_SETTLEMENT";
    PlatformFinanceSubStatus["SubmissionRequest"] = "SUBMISSION_REQUEST";
    PlatformFinanceSubStatus["SubmittedToLender"] = "SUBMITTED_TO_LENDER";
})(PlatformFinanceSubStatus || (PlatformFinanceSubStatus = {}));
var AssetFinanceCalculatedStage;
(function (AssetFinanceCalculatedStage) {
    AssetFinanceCalculatedStage["PreSubmission"] = "PRE_SUBMISSION";
    AssetFinanceCalculatedStage["ClosedLost"] = "CLOSED_LOST";
    AssetFinanceCalculatedStage["ApplicationLodgement"] = "APPLICATION_LODGEMENT";
    AssetFinanceCalculatedStage["Application"] = "APPLICATION";
    AssetFinanceCalculatedStage["Assessment"] = "ASSESSMENT";
    AssetFinanceCalculatedStage["Approval"] = "APPROVAL";
    AssetFinanceCalculatedStage["PreSettlement"] = "PRE_SETTLEMENT";
    AssetFinanceCalculatedStage["PostSettlement"] = "POST_SETTLEMENT";
})(AssetFinanceCalculatedStage || (AssetFinanceCalculatedStage = {}));
var AssetFinanceCalculatedStatus;
(function (AssetFinanceCalculatedStatus) {
    AssetFinanceCalculatedStatus["InProgress"] = "IN_PROGRESS";
    AssetFinanceCalculatedStatus["LeadInProgress"] = "LEAD_IN_PROGRESS";
    AssetFinanceCalculatedStatus["OnHold"] = "ON_HOLD";
    AssetFinanceCalculatedStatus["SubmittedToLender"] = "SUBMITTED_TO_LENDER";
    AssetFinanceCalculatedStatus["SubmissionRequest"] = "SUBMISSION_REQUEST";
    AssetFinanceCalculatedStatus["MoreInformationRequested"] = "MORE_INFORMATION_REQUESTED";
    AssetFinanceCalculatedStatus["ApprovedInPrinciple"] = "APPROVED_IN_PRINCIPLE";
    AssetFinanceCalculatedStatus["InvoiceRequested"] = "INVOICE_REQUESTED";
    AssetFinanceCalculatedStatus["AwaitingVehicle"] = "AWAITING_VEHICLE";
    AssetFinanceCalculatedStatus["DocumentsRequested"] = "DOCUMENTS_REQUESTED";
    AssetFinanceCalculatedStatus["DocumentsIssued"] = "DOCUMENTS_ISSUED";
    AssetFinanceCalculatedStatus["DocumentsReceived"] = "DOCUMENTS_RECEIVED";
    AssetFinanceCalculatedStatus["ReadyForSettlement"] = "READY_FOR_SETTLEMENT";
    AssetFinanceCalculatedStatus["SettlementBooked"] = "SETTLEMENT_BOOKED";
    AssetFinanceCalculatedStatus["Settled"] = "SETTLED";
    AssetFinanceCalculatedStatus["Lost"] = "LOST";
})(AssetFinanceCalculatedStatus || (AssetFinanceCalculatedStatus = {}));
var AssetFinanceReason;
(function (AssetFinanceReason) {
    AssetFinanceReason["AlternativeFunding"] = "ALTERNATIVE_FUNDING";
    AssetFinanceReason["Other"] = "OTHER";
    AssetFinanceReason["ChangedMind"] = "CHANGED_MIND";
    AssetFinanceReason["CouldNotContact"] = "COULD_NOT_CONTACT";
    AssetFinanceReason["FutureContact"] = "FUTURE_CONTACT";
    AssetFinanceReason["NoClientResponse"] = "NO_CLIENT_RESPONSE";
    AssetFinanceReason["QuoteOnly"] = "QUOTE_ONLY";
    AssetFinanceReason["BadCredit"] = "BAD_CREDIT";
    AssetFinanceReason["NoCapacity"] = "NO_CAPACITY";
    AssetFinanceReason["OtherFinancier"] = "OTHER_FINANCIER";
    AssetFinanceReason["OutsideGuidelines"] = "OUTSIDE_GUIDELINES";
    AssetFinanceReason["NotInterested"] = "NOT_INTERESTED";
})(AssetFinanceReason || (AssetFinanceReason = {}));
var ReferralFeeType;
(function (ReferralFeeType) {
    ReferralFeeType["Dollar"] = "DOLLAR";
    ReferralFeeType["Percentage"] = "PERCENTAGE";
})(ReferralFeeType || (ReferralFeeType = {}));
//# sourceMappingURL=AssetFinance.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/TeamMember.js
var TeamMemberBrand;
(function (TeamMemberBrand) {
    TeamMemberBrand["aussie"] = "AUSSIE";
    TeamMemberBrand["domain"] = "DOMAIN";
    TeamMemberBrand["lendi"] = "LENDI";
})(TeamMemberBrand || (TeamMemberBrand = {}));
var TeamMemberProfile;
(function (TeamMemberProfile) {
    TeamMemberProfile["associate"] = "Associate";
    TeamMemberProfile["broker"] = "Broker";
    TeamMemberProfile["brokerManager"] = "Broker Manager";
    TeamMemberProfile["customerSolutions"] = "Customer Solutions";
    TeamMemberProfile["offboardedUser"] = "Offboarded User";
    TeamMemberProfile["partnerBroker"] = "Partner Broker";
    TeamMemberProfile["relationshipManager"] = "Relationship Manager";
    TeamMemberProfile["seniorRelationshipManager"] = "Senior Relationship Manager";
})(TeamMemberProfile || (TeamMemberProfile = {}));
var TeamMemberUserRole;
(function (TeamMemberUserRole) {
    TeamMemberUserRole["aussieExecutive"] = "AUSSIE_EXECUTIVE";
    TeamMemberUserRole["aussieAssociateManager"] = "AUSSIE_ASSOCIATE_MANAGER";
    TeamMemberUserRole["aussieAssociate"] = "AUSSIE_ASSOCIATE";
    TeamMemberUserRole["brokerLifecycle"] = "BROKER_LIFECYCLE";
    TeamMemberUserRole["clientSolutions"] = "CLIENT_SOLUTIONS";
    TeamMemberUserRole["clientSolutionsAssessmentAssociate"] = "CLIENT_SOLUTIONS_ASSESSMENT_ASSOCIATE";
    TeamMemberUserRole["clientSolutionsAssessmentExpert"] = "CLIENT_SOLUTIONS_ASSESSMENT_EXPERT";
    TeamMemberUserRole["clientSolutionsManager"] = "CLIENT_SOLUTIONS_MANAGER";
    TeamMemberUserRole["clientSolutionsSettlementAssociate"] = "CLIENT_SOLUTIONS_SETTLEMENT_ASSOCIATE";
    TeamMemberUserRole["clientSolutionsSettlementExpert"] = "CLIENT_SOLUTIONS_SETTLEMENT_EXPERT";
    TeamMemberUserRole["clientSolutionsSpecialist"] = "CLIENT_SOLUTIONS_SPECIALIST";
    TeamMemberUserRole["domainAssociate"] = "DOMAIN_ASSOCIATE";
    TeamMemberUserRole["domainAssociateManager"] = "DOMAIN_ASSOCIATE_MANAGER";
    TeamMemberUserRole["domainBrokerLiaison"] = "DOMAIN_BROKER_LIAISON";
    TeamMemberUserRole["domainBrokerManager"] = "DOMAIN_BROKER_MANAGER";
    TeamMemberUserRole["domainExecutive"] = "DOMAIN_EXECUTIVE";
    TeamMemberUserRole["domainHomeLoanSpecialist"] = "DOMAIN_HOME_LOAN_SPECIALIST";
    TeamMemberUserRole["domainSalesExecutive"] = "DOMAIN_SALES_EXECUTIVE";
    TeamMemberUserRole["fieldAssistant"] = "FIELD_ASSISTANT";
    TeamMemberUserRole["franchiseeBroker"] = "FRANCHISEE_BROKER";
    TeamMemberUserRole["franchiseeNonBroker"] = "FRANCHISEE_NON_BROKER";
    TeamMemberUserRole["graduateManager"] = "GRADUATE_MANAGER";
    TeamMemberUserRole["lendiAssociate"] = "LENDI_ASSOCIATE";
    TeamMemberUserRole["lendiAssociateManager"] = "LENDI_ASSOCIATE_MANAGER";
    TeamMemberUserRole["lendiBrokerAdmin"] = "LENDI_BROKER_ADMIN";
    TeamMemberUserRole["lendiBrokerLiaison"] = "LENDI_BROKER_LIAISON";
    TeamMemberUserRole["lendiBrokerManager"] = "LENDI_BROKER_MANAGER";
    TeamMemberUserRole["lendiExecutive"] = "LENDI_EXECUTIVE";
    TeamMemberUserRole["lendiGroupExecutive"] = "LENDI_GROUP_EXECUTIVE";
    TeamMemberUserRole["lendiHomeLoanConsultant"] = "LENDI_HOME_LOAN_CONSULTANT";
    TeamMemberUserRole["lendiHomeLoanSpecialist"] = "LENDI_HOME_LOAN_SPECIALIST";
    TeamMemberUserRole["lendiSalesExecutive"] = "LENDI_SALES_EXECUTIVE";
    TeamMemberUserRole["lendiSameLenderRefinance"] = "LENDI_SAME_LENDER_REFINANCE";
    TeamMemberUserRole["mobileRegionHead"] = "MOBILE_REGION_HEAD";
    TeamMemberUserRole["mobileRegionManager"] = "MOBILE_REGION_MANAGER";
    TeamMemberUserRole["mobileBroker"] = "MOBILE_BROKER";
    TeamMemberUserRole["seniorRelationshipManager"] = "SENIOR_RELATIONSHIP_MANAGER";
    TeamMemberUserRole["offboardedTeamMember"] = "OFFBOARDED_TEAM_MEMBER";
    TeamMemberUserRole["relationshipManager"] = "RELATIONSHIP_MANAGER";
    TeamMemberUserRole["retailStateHead"] = "RETAIL_STATE_HEAD";
    TeamMemberUserRole["retailManager"] = "RETAIL_MANAGER";
    TeamMemberUserRole["retailBroker"] = "RETAIL_BROKER";
    TeamMemberUserRole["storeAdmin"] = "STORE_ADMIN";
    TeamMemberUserRole["trainer"] = "TRAINER";
})(TeamMemberUserRole || (TeamMemberUserRole = {}));
var TeamMemberSalutation;
(function (TeamMemberSalutation) {
    TeamMemberSalutation["mr"] = "Mr.";
    TeamMemberSalutation["ms"] = "Ms.";
    TeamMemberSalutation["mrs"] = "Mrs.";
    TeamMemberSalutation["dr"] = "Dr.";
    TeamMemberSalutation["prof"] = "Prof.";
})(TeamMemberSalutation || (TeamMemberSalutation = {}));
var TeamMemberRestrictionStatus;
(function (TeamMemberRestrictionStatus) {
    TeamMemberRestrictionStatus["restricted"] = "RESTRICTED";
    TeamMemberRestrictionStatus["unrestricted"] = "UNRESTRICTED";
})(TeamMemberRestrictionStatus || (TeamMemberRestrictionStatus = {}));
var TeamMemberBrokerStatus;
(function (TeamMemberBrokerStatus) {
    TeamMemberBrokerStatus["competent"] = "Competent";
    TeamMemberBrokerStatus["compliance"] = "Compliance";
    TeamMemberBrokerStatus["graduate"] = "Graduate";
    TeamMemberBrokerStatus["pip"] = "PIP";
    TeamMemberBrokerStatus["offBoarded"] = "Off Boarded";
    TeamMemberBrokerStatus["roleChange"] = "Role Change";
    TeamMemberBrokerStatus["active"] = "Active";
    TeamMemberBrokerStatus["suspended"] = "Suspended";
})(TeamMemberBrokerStatus || (TeamMemberBrokerStatus = {}));
var TeamMemberTimeZone;
(function (TeamMemberTimeZone) {
    TeamMemberTimeZone["adelaide"] = "Australia/Adelaide";
    TeamMemberTimeZone["brisbane"] = "Australia/Brisbane";
    TeamMemberTimeZone["brokenHill"] = "Australia/Broken_Hill";
    TeamMemberTimeZone["currie"] = "Australia/Currie";
    TeamMemberTimeZone["darwin"] = "Australia/Darwin";
    TeamMemberTimeZone["eucla"] = "Australia/Eucla";
    TeamMemberTimeZone["hobart"] = "Australia/Hobart";
    TeamMemberTimeZone["lindeman"] = "Australia/Lindeman";
    TeamMemberTimeZone["lordHowe"] = "Australia/Lord_Howe";
    TeamMemberTimeZone["melbourne"] = "Australia/Melbourne";
    TeamMemberTimeZone["perth"] = "Australia/Perth";
    TeamMemberTimeZone["sydney"] = "Australia/Sydney";
})(TeamMemberTimeZone || (TeamMemberTimeZone = {}));
var TeamMemberCommissionStatus;
(function (TeamMemberCommissionStatus) {
    TeamMemberCommissionStatus["active"] = "Active";
    TeamMemberCommissionStatus["inactive"] = "Inactive";
    TeamMemberCommissionStatus["suspended"] = "Suspended";
})(TeamMemberCommissionStatus || (TeamMemberCommissionStatus = {}));
//# sourceMappingURL=TeamMember.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/AppLockReason.js
var AppLockReason;
(function (AppLockReason) {
    AppLockReason["PostSettlementSettled"] = "POST_SETTLEMENT_SETTLED";
    AppLockReason["PostSettlementDischarged"] = "POST_SETTLEMENT_DISCHARGED";
    AppLockReason["ClosedLostLost"] = "CLOSED_LOST_LOST";
    AppLockReason["ClosedLostDeclined"] = "CLOSED_LOST_DECLINED";
    AppLockReason["RetiredDomainBrand"] = "RETIRED_DOMAIN_BRAND";
    AppLockReason["SubmittedToLender"] = "SUBMITTED_TO_LENDER";
    AppLockReason["PreApproved"] = "PRE_APPROVED";
    AppLockReason["Settlement"] = "SETTLEMENT";
})(AppLockReason || (AppLockReason = {}));
//# sourceMappingURL=AppLockReason.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/InternationalMobileCountries.js

var InternationalMobileCountriesByBrand = new Map([
    [Brand.Lendi, ['AU']],
    [Brand.Domain, ['AU']],
    [
        Brand.Aussie,
        [
            'AC',
            'AD',
            'AE',
            'AF',
            'AI',
            'AL',
            'AM',
            'AO',
            'AR',
            'AS',
            'AT',
            'AU',
            'AW',
            'AZ',
            'BA',
            'BB',
            'BD',
            'BE',
            'BF',
            'BG',
            'BH',
            'BI',
            'BJ',
            'BM',
            'BN',
            'BO',
            'BR',
            'BS',
            'BT',
            'BW',
            'BY',
            'BZ',
            'CA',
            'CC',
            'CD',
            'CF',
            'CG',
            'CH',
            'CI',
            'CK',
            'CL',
            'CM',
            'CN',
            'CO',
            'CR',
            'CU',
            'CV',
            'CW',
            'CX',
            'CY',
            'CZ',
            'DE',
            'DJ',
            'DK',
            'DM',
            'DO',
            'DO',
            'DZ',
            'EC',
            'EG',
            'ER',
            'ES',
            'ET',
            'FI',
            'FJ',
            'FK',
            'FM',
            'FO',
            'FR',
            'GA',
            'GB',
            'GD',
            'GE',
            'GF',
            'GG',
            'GH',
            'GI',
            'GL',
            'GM',
            'GN',
            'GP',
            'GQ',
            'GR',
            'GS',
            'GT',
            'GU',
            'GW',
            'GY',
            'HK',
            'HN',
            'HR',
            'HT',
            'HU',
            'ID',
            'IE',
            'IL',
            'IM',
            'IN',
            'IO',
            'IQ',
            'IR',
            'IS',
            'IT',
            'JE',
            'JM',
            'JO',
            'JP',
            'KE',
            'KG',
            'KH',
            'KI',
            'KM',
            'KN',
            'KP',
            'KR',
            'KW',
            'KY',
            'KZ',
            'LA',
            'LB',
            'LC',
            'LI',
            'LK',
            'LR',
            'LS',
            'LT',
            'LU',
            'LV',
            'LY',
            'MA',
            'MC',
            'MD',
            'ME',
            'MF',
            'MG',
            'MH',
            'MK',
            'ML',
            'MM',
            'MN',
            'MO',
            'MP',
            'MQ',
            'MR',
            'MS',
            'MT',
            'MU',
            'MV',
            'MW',
            'MX',
            'MY',
            'MZ',
            'NA',
            'NC',
            'NE',
            'NF',
            'NG',
            'NI',
            'NL',
            'NO',
            'NP',
            'NR',
            'NU',
            'NZ',
            'OM',
            'PA',
            'PE',
            'PF',
            'PG',
            'PH',
            'PK',
            'PL',
            'PM',
            'PN',
            'PR',
            'PS',
            'PT',
            'PW',
            'PY',
            'QA',
            'RE',
            'RO',
            'RS',
            'RU',
            'RW',
            'SA',
            'SB',
            'SC',
            'SD',
            'SE',
            'SG',
            'SH',
            'SI',
            'SK',
            'SL',
            'SM',
            'SN',
            'SO',
            'SR',
            'SS',
            'ST',
            'SV',
            'SX',
            'SY',
            'SZ',
            'TC',
            'TD',
            'TG',
            'TH',
            'TJ',
            'TK',
            'TL',
            'TM',
            'TN',
            'TO',
            'TR',
            'TT',
            'TV',
            'TW',
            'TZ',
            'UA',
            'UG',
            'US',
            'UY',
            'UZ',
            'VA',
            'VC',
            'VE',
            'VG',
            'VI',
            'VN',
            'VU',
            'WF',
            'WS',
            'YE',
            'YT',
            'ZA',
            'ZM',
            'ZW',
        ],
    ],
]);
//# sourceMappingURL=InternationalMobileCountries.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/core-constants/lib/esm/index.js





















































































//# sourceMappingURL=index.js.map

/***/ }),

/***/ 49481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vA": function() { return /* reexport */ LendiGroupLeads; },
  "aP": function() { return /* reexport */ Origin; },
  "$D": function() { return /* reexport */ createLead; }
});

// UNUSED EXPORTS: AppointmentSource, Brand, CreditScorePurpose, CreditStatus, DesiredFeatures, EligibleForFHOG, EmploymentType, EnquiryPurpose, FunnelPropertyStatus, FunnelPropertyType, NumberOfBorrowers, PaymentMethod, PropertyUse, PurchaseIntent, PurchaseSituation, Purpose, RefinancingReason, RelationshipWithProperty, StampDutyPropertyState, StampDutyPropertyType, Urgency, camelToSnake, createPIIExcludedLeadLog, formatUtm, getTimezone, leadStoreGenerator, logFailedLeadRequest, logInvokedLeadRequest, logSuccessfulLeadRequest, removeDuplicate, retrieveAccountOrigin, retrieveGCLID, retrieveUtm, sessionStorage, snakeToCamel, strEnum, upperSnake

// NAMESPACE OBJECT: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/platform/common/utils.js
var common_utils_namespaceObject = {};
__webpack_require__.r(common_utils_namespaceObject);
__webpack_require__.d(common_utils_namespaceObject, {
  "hasBrowserEnv": function() { return hasBrowserEnv; },
  "hasStandardBrowserEnv": function() { return hasStandardBrowserEnv; },
  "hasStandardBrowserWebWorkerEnv": function() { return hasStandardBrowserWebWorkerEnv; },
  "navigator": function() { return _navigator; },
  "origin": function() { return origin; }
});

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/boot/init.js
var init = __webpack_require__(27627);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/getGlobalObject.js
var getGlobalObject = __webpack_require__(1692);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/context/contextManager.js
var contextManager = __webpack_require__(79217);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js
var boundedBuffer = __webpack_require__(84554);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/mergeInto.js
var mergeInto = __webpack_require__(20377);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(853);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(93099);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(42818);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/eventBridge.js
var eventBridge = __webpack_require__(52325);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/context/storedContextManager.js
var storedContextManager = __webpack_require__(7876);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/serialisation/sanitize.js
var sanitize = __webpack_require__(53185);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/user/user.js
var user = __webpack_require__(17662);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(95959);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(10160);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js + 3 modules
var configuration_configuration = __webpack_require__(66869);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js
var reportObservable = __webpack_require__(11954);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/arrayUtils.js
var arrayUtils = __webpack_require__(50985);
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/domain/configuration.js

/**
 * arbitrary value, byte precision not needed
 */
var DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT = 32 * byteUtils/* ONE_KIBI_BYTE */.Hi;
function validateAndBuildLogsConfiguration(initConfiguration) {
    var baseConfiguration = (0,configuration_configuration/* validateAndBuildConfiguration */.fP)(initConfiguration);
    var forwardConsoleLogs = validateAndBuildForwardOption(initConfiguration.forwardConsoleLogs, (0,polyfills/* objectValues */.TT)(display/* ConsoleApiName */.vA), 'Forward Console Logs');
    var forwardReports = validateAndBuildForwardOption(initConfiguration.forwardReports, (0,polyfills/* objectValues */.TT)(reportObservable/* RawReportType */._), 'Forward Reports');
    if (!baseConfiguration || !forwardConsoleLogs || !forwardReports) {
        return;
    }
    if (initConfiguration.forwardErrorsToLogs && !(0,polyfills/* includes */.q9)(forwardConsoleLogs, display/* ConsoleApiName.error */.vA.error)) {
        forwardConsoleLogs.push(display/* ConsoleApiName.error */.vA.error);
    }
    return (0,polyfills/* assign */.f0)({
        forwardErrorsToLogs: initConfiguration.forwardErrorsToLogs !== false,
        forwardConsoleLogs: forwardConsoleLogs,
        forwardReports: forwardReports,
        requestErrorResponseLengthLimit: DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT,
    }, baseConfiguration);
}
function validateAndBuildForwardOption(option, allowedValues, label) {
    if (option === undefined) {
        return [];
    }
    if (!(option === 'all' || (Array.isArray(option) && option.every(function (api) { return (0,polyfills/* includes */.q9)(allowedValues, api); })))) {
        display/* display.error */.jf.error("".concat(label, " should be \"all\" or an array with allowed values \"").concat(allowedValues.join('", "'), "\""));
        return;
    }
    return option === 'all' ? allowedValues : (0,arrayUtils/* removeDuplicates */.R)(option);
}
function serializeLogsConfiguration(configuration) {
    var baseSerializedInitConfiguration = (0,configuration_configuration/* serializeConfiguration */.JZ)(configuration);
    return (0,polyfills/* assign */.f0)({
        forward_errors_to_logs: configuration.forwardErrorsToLogs,
        forward_console_logs: configuration.forwardConsoleLogs,
        forward_reports: configuration.forwardReports,
    }, baseSerializedInitConfiguration);
}
//# sourceMappingURL=configuration.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var error_types = __webpack_require__(10494);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/tracekit/computeStackTrace.js
var computeStackTrace = __webpack_require__(94856);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.js
var error_error = __webpack_require__(30331);
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/domain/logger.js
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var StatusType = {
    debug: 'debug',
    error: 'error',
    info: 'info',
    warn: 'warn',
};
var HandlerType = {
    console: 'console',
    http: 'http',
    silent: 'silent',
};
var STATUSES = Object.keys(StatusType);
var Logger = /** @class */ (function () {
    function Logger(handleLogStrategy, name, handlerType, level, loggerContext) {
        if (handlerType === void 0) { handlerType = HandlerType.http; }
        if (level === void 0) { level = StatusType.debug; }
        if (loggerContext === void 0) { loggerContext = {}; }
        this.handleLogStrategy = handleLogStrategy;
        this.handlerType = handlerType;
        this.level = level;
        this.contextManager = (0,contextManager/* createContextManager */.W)(3 /* CustomerDataType.LoggerContext */);
        this.contextManager.set((0,polyfills/* assign */.f0)({}, loggerContext, name ? { logger: { name: name } } : undefined));
    }
    Logger.prototype.log = function (message, messageContext, status, error) {
        if (status === void 0) { status = StatusType.info; }
        var errorContext;
        if (status === StatusType.error) {
            // Always add origin if status is error (backward compatibility - Remove in next major)
            errorContext = { origin: error_types/* ErrorSource.LOGGER */.z.LOGGER };
        }
        if (error !== undefined && error !== null) {
            var stackTrace = error instanceof Error ? (0,computeStackTrace/* computeStackTrace */._)(error) : undefined;
            var rawError = (0,error_error/* computeRawError */.AP)({
                stackTrace: stackTrace,
                originalError: error,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
                source: error_types/* ErrorSource.LOGGER */.z.LOGGER,
                handling: "handled" /* ErrorHandling.HANDLED */,
                startClocks: (0,timeUtils/* clocksNow */.$I)(),
            });
            errorContext = {
                origin: error_types/* ErrorSource.LOGGER */.z.LOGGER,
                stack: rawError.stack,
                kind: rawError.type,
                message: rawError.message,
            };
        }
        var sanitizedMessageContext = (0,sanitize/* sanitize */.N)(messageContext);
        var context = errorContext
            ? (0,mergeInto/* combine */.$e)({ error: errorContext }, sanitizedMessageContext)
            : sanitizedMessageContext;
        this.handleLogStrategy({
            message: (0,sanitize/* sanitize */.N)(message),
            context: context,
            status: status,
        }, this);
    };
    Logger.prototype.debug = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.debug, error);
    };
    Logger.prototype.info = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.info, error);
    };
    Logger.prototype.warn = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.warn, error);
    };
    Logger.prototype.error = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.error, error);
    };
    Logger.prototype.setContext = function (context) {
        this.contextManager.set(context);
    };
    Logger.prototype.getContext = function () {
        return this.contextManager.get();
    };
    Logger.prototype.addContext = function (key, value) {
        this.contextManager.add(key, value);
    };
    Logger.prototype.removeContext = function (key) {
        this.contextManager.remove(key);
    };
    Logger.prototype.setHandler = function (handler) {
        this.handlerType = handler;
    };
    Logger.prototype.getHandler = function () {
        return this.handlerType;
    };
    Logger.prototype.setLevel = function (level) {
        this.level = level;
    };
    Logger.prototype.getLevel = function () {
        return this.level;
    };
    __decorate([
        monitor/* monitored */.Th
    ], Logger.prototype, "log", null);
    return Logger;
}());

//# sourceMappingURL=logger.js.map
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/boot/logsPublicApi.js



var LOGS_STORAGE_KEY = 'logs';
function makeLogsPublicApi(startLogsImpl) {
    var isAlreadyInitialized = false;
    var globalContextManager = (0,contextManager/* createContextManager */.W)(2 /* CustomerDataType.GlobalContext */);
    var userContextManager = (0,contextManager/* createContextManager */.W)(1 /* CustomerDataType.User */);
    var customLoggers = {};
    var getInternalContextStrategy = function () { return undefined; };
    var beforeInitLoggerLog = new boundedBuffer/* BoundedBuffer */.S();
    var handleLogStrategy = function (logsMessage, logger, savedCommonContext, date) {
        if (savedCommonContext === void 0) { savedCommonContext = (0,mergeInto/* deepClone */.I8)(buildCommonContext()); }
        if (date === void 0) { date = (0,timeUtils/* timeStampNow */.n$)(); }
        beforeInitLoggerLog.add(function () { return handleLogStrategy(logsMessage, logger, savedCommonContext, date); });
    };
    var getInitConfigurationStrategy = function () { return undefined; };
    var mainLogger = new Logger(function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return handleLogStrategy.apply(void 0, params);
    });
    function buildCommonContext() {
        return {
            view: {
                referrer: document.referrer,
                url: window.location.href,
            },
            context: globalContextManager.getContext(),
            user: userContextManager.getContext(),
        };
    }
    return (0,init/* makePublicApi */.r)({
        logger: mainLogger,
        init: (0,monitor/* monitor */.zk)(function (initConfiguration) {
            var _a;
            if (!initConfiguration) {
                display/* display.error */.jf.error('Missing configuration');
                return;
            }
            // This function should be available, regardless of initialization success.
            getInitConfigurationStrategy = function () { return (0,mergeInto/* deepClone */.I8)(initConfiguration); };
            if ((0,eventBridge/* canUseEventBridge */.x)()) {
                initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
            }
            if (!canInitLogs(initConfiguration)) {
                return;
            }
            var configuration = validateAndBuildLogsConfiguration(initConfiguration);
            if (!configuration) {
                return;
            }
            if (initConfiguration.storeContextsAcrossPages) {
                var beforeInitGlobalContext = globalContextManager.getContext();
                globalContextManager = (0,storedContextManager/* createStoredContextManager */.PI)(configuration, LOGS_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */);
                globalContextManager.setContext((0,mergeInto/* combine */.$e)(globalContextManager.getContext(), beforeInitGlobalContext));
                var beforeInitUserContext = userContextManager.getContext();
                userContextManager = (0,storedContextManager/* createStoredContextManager */.PI)(configuration, LOGS_STORAGE_KEY, 1 /* CustomerDataType.User */);
                userContextManager.setContext((0,mergeInto/* combine */.$e)(userContextManager.getContext(), beforeInitUserContext));
            }
            ;
            (_a = startLogsImpl(initConfiguration, configuration, buildCommonContext, mainLogger), handleLogStrategy = _a.handleLog, getInternalContextStrategy = _a.getInternalContext);
            beforeInitLoggerLog.drain();
            isAlreadyInitialized = true;
        }),
        /** @deprecated: use getGlobalContext instead */
        getLoggerGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.get(); }),
        getGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.getContext(); }),
        /** @deprecated: use setGlobalContext instead */
        setLoggerGlobalContext: (0,monitor/* monitor */.zk)(function (context) { return globalContextManager.set(context); }),
        setGlobalContext: (0,monitor/* monitor */.zk)(function (context) { return globalContextManager.setContext(context); }),
        /** @deprecated: use setGlobalContextProperty instead */
        addLoggerGlobalContext: (0,monitor/* monitor */.zk)(function (key, value) { return globalContextManager.add(key, value); }),
        setGlobalContextProperty: (0,monitor/* monitor */.zk)(function (key, value) { return globalContextManager.setContextProperty(key, value); }),
        /** @deprecated: use removeGlobalContextProperty instead */
        removeLoggerGlobalContext: (0,monitor/* monitor */.zk)(function (key) { return globalContextManager.remove(key); }),
        removeGlobalContextProperty: (0,monitor/* monitor */.zk)(function (key) { return globalContextManager.removeContextProperty(key); }),
        clearGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.clearContext(); }),
        createLogger: (0,monitor/* monitor */.zk)(function (name, conf) {
            if (conf === void 0) { conf = {}; }
            customLoggers[name] = new Logger(function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                return handleLogStrategy.apply(void 0, params);
            }, (0,sanitize/* sanitize */.N)(name), conf.handler, conf.level, (0,sanitize/* sanitize */.N)(conf.context));
            return customLoggers[name];
        }),
        getLogger: (0,monitor/* monitor */.zk)(function (name) { return customLoggers[name]; }),
        getInitConfiguration: (0,monitor/* monitor */.zk)(function () { return getInitConfigurationStrategy(); }),
        getInternalContext: (0,monitor/* monitor */.zk)(function (startTime) { return getInternalContextStrategy(startTime); }),
        setUser: (0,monitor/* monitor */.zk)(function (newUser) {
            if ((0,user/* checkUser */.z)(newUser)) {
                userContextManager.setContext((0,user/* sanitizeUser */.I)(newUser));
            }
        }),
        getUser: (0,monitor/* monitor */.zk)(function () { return userContextManager.getContext(); }),
        setUserProperty: (0,monitor/* monitor */.zk)(function (key, property) {
            var _a;
            var sanitizedProperty = (0,user/* sanitizeUser */.I)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: (0,monitor/* monitor */.zk)(function (key) { return userContextManager.removeContextProperty(key); }),
        clearUser: (0,monitor/* monitor */.zk)(function () { return userContextManager.clearContext(); }),
    });
    function overrideInitConfigurationForBridge(initConfiguration) {
        return (0,polyfills/* assign */.f0)({}, initConfiguration, { clientToken: 'empty' });
    }
    function canInitLogs(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                display/* display.error */.jf.error('DD_LOGS is already initialized.');
            }
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=logsPublicApi.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(15017);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry_telemetry = __webpack_require__(41887);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js
var browser_pageExitObservable = __webpack_require__(19609);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/synthetics/syntheticsWorkerValues.js
var syntheticsWorkerValues = __webpack_require__(27478);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/startBatchWithReplica.js + 2 modules
var startBatchWithReplica = __webpack_require__(22556);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js
var session_sessionManager = __webpack_require__(42972);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/observable.js
var observable = __webpack_require__(87658);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(76135);
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/domain/logsSessionManager.js

var LOGS_SESSION_KEY = 'logs';
function startLogsSessionManager(configuration) {
    var sessionManager = (0,session_sessionManager/* startSessionManager */.HX)(configuration, LOGS_SESSION_KEY, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            return session && session.trackingType === "1" /* LoggerTrackingType.TRACKED */
                ? {
                    id: session.id,
                }
                : undefined;
        },
        expireObservable: sessionManager.expireObservable,
    };
}
function startLogsSessionManagerStub(configuration) {
    var isTracked = computeTrackingType(configuration) === "1" /* LoggerTrackingType.TRACKED */;
    var session = isTracked ? {} : undefined;
    return {
        findTrackedSession: function () { return session; },
        expireObservable: new observable/* Observable */.y(),
    };
}
function computeTrackingType(configuration) {
    if (!(0,numberUtils/* performDraw */.y7)(configuration.sessionSampleRate)) {
        return "0" /* LoggerTrackingType.NOT_TRACKED */;
    }
    return "1" /* LoggerTrackingType.TRACKED */;
}
function computeSessionState(configuration, rawSessionType) {
    var trackingType = hasValidLoggerSession(rawSessionType) ? rawSessionType : computeTrackingType(configuration);
    return {
        trackingType: trackingType,
        isTracked: trackingType === "1" /* LoggerTrackingType.TRACKED */,
    };
}
function hasValidLoggerSession(trackingType) {
    return trackingType === "0" /* LoggerTrackingType.NOT_TRACKED */ || trackingType === "1" /* LoggerTrackingType.TRACKED */;
}
//# sourceMappingURL=logsSessionManager.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/eventRateLimiter/createEventRateLimiter.js
var createEventRateLimiter = __webpack_require__(76427);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(47970);
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/domain/logger/loggerCollection.js
var _a;


var STATUS_PRIORITIES = (_a = {},
    _a[StatusType.debug] = 0,
    _a[StatusType.info] = 1,
    _a[StatusType.warn] = 2,
    _a[StatusType.error] = 3,
    _a);
function startLoggerCollection(lifeCycle) {
    function handleLog(logsMessage, logger, savedCommonContext, savedDate) {
        var messageContext = logsMessage.context;
        if (isAuthorized(logsMessage.status, HandlerType.console, logger)) {
            displayInConsole(logsMessage, (0,mergeInto/* combine */.$e)(logger.getContext(), messageContext));
        }
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: savedDate || (0,timeUtils/* timeStampNow */.n$)(),
                message: logsMessage.message,
                status: logsMessage.status,
                origin: error_types/* ErrorSource.LOGGER */.z.LOGGER,
            },
            messageContext: messageContext,
            savedCommonContext: savedCommonContext,
            logger: logger,
        });
    }
    return {
        handleLog: handleLog,
    };
}
function isAuthorized(status, handlerType, logger) {
    var loggerHandler = logger.getHandler();
    var sanitizedHandlerType = Array.isArray(loggerHandler) ? loggerHandler : [loggerHandler];
    return (STATUS_PRIORITIES[status] >= STATUS_PRIORITIES[logger.getLevel()] && (0,polyfills/* includes */.q9)(sanitizedHandlerType, handlerType));
}
function displayInConsole(logsMessage, messageContext) {
    display/* originalConsoleMethods */.LD[logsMessage.status].call(display/* globalConsole */.jG, logsMessage.message, messageContext);
}
//# sourceMappingURL=loggerCollection.js.map
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/domain/assembly.js



function startLogsAssembly(sessionManager, configuration, lifeCycle, buildCommonContext, mainLogger, // Todo: [RUMF-1230] Remove this parameter in the next major release
reportError) {
    var statusWithCustom = STATUSES.concat(['custom']);
    var logRateLimiters = {};
    statusWithCustom.forEach(function (status) {
        logRateLimiters[status] = (0,createEventRateLimiter/* createEventRateLimiter */.K)(status, configuration.eventRateLimiterThreshold, reportError);
    });
    lifeCycle.subscribe(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, function (_a) {
        var _b, _c, _d;
        var rawLogsEvent = _a.rawLogsEvent, _e = _a.messageContext, messageContext = _e === void 0 ? undefined : _e, _f = _a.savedCommonContext, savedCommonContext = _f === void 0 ? undefined : _f, _g = _a.logger, logger = _g === void 0 ? mainLogger : _g;
        var startTime = (0,timeUtils/* getRelativeTime */.ni)(rawLogsEvent.date);
        var session = sessionManager.findTrackedSession(startTime);
        if (!session) {
            return;
        }
        var commonContext = savedCommonContext || buildCommonContext();
        var log = (0,mergeInto/* combine */.$e)({
            service: configuration.service,
            session_id: session.id,
            // Insert user first to allow overrides from global context
            usr: !(0,objectUtils/* isEmptyObject */.Qr)(commonContext.user) ? commonContext.user : undefined,
            view: commonContext.view,
        }, commonContext.context, getRUMInternalContext(startTime), rawLogsEvent, logger.getContext(), messageContext);
        if (
        // Todo: [RUMF-1230] Move this check to the logger collection in the next major release
        !isAuthorized(rawLogsEvent.status, HandlerType.http, logger) ||
            ((_b = configuration.beforeSend) === null || _b === void 0 ? void 0 : _b.call(configuration, log)) === false ||
            (((_c = log.error) === null || _c === void 0 ? void 0 : _c.origin) !== error_types/* ErrorSource.AGENT */.z.AGENT &&
                ((_d = logRateLimiters[log.status]) !== null && _d !== void 0 ? _d : logRateLimiters['custom']).isLimitReached())) {
            return;
        }
        lifeCycle.notify(1 /* LifeCycleEventType.LOG_COLLECTED */, log);
    });
}
var logsSentBeforeRumInjectionTelemetryAdded = false;
function getRUMInternalContext(startTime) {
    var browserWindow = window;
    if ((0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)()) {
        var context = getInternalContextFromRumGlobal(browserWindow.DD_RUM_SYNTHETICS);
        if (!context && !logsSentBeforeRumInjectionTelemetryAdded) {
            logsSentBeforeRumInjectionTelemetryAdded = true;
            (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Logs sent before RUM is injected by the synthetics worker', {
                testId: (0,syntheticsWorkerValues/* getSyntheticsTestId */.L7)(),
                resultId: (0,syntheticsWorkerValues/* getSyntheticsResultId */.QB)(),
            });
        }
        return context;
    }
    return getInternalContextFromRumGlobal(browserWindow.DD_RUM);
    function getInternalContextFromRumGlobal(rumGlobal) {
        if (rumGlobal && rumGlobal.getInternalContext) {
            return rumGlobal.getInternalContext(startTime);
        }
    }
}
function resetRUMInternalContext() {
    logsSentBeforeRumInjectionTelemetryAdded = false;
}
//# sourceMappingURL=assembly.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js
var consoleObservable = __webpack_require__(78587);
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/domain/console/consoleCollection.js
var consoleCollection_a;


var LogStatusForApi = (consoleCollection_a = {},
    consoleCollection_a[display/* ConsoleApiName.log */.vA.log] = StatusType.info,
    consoleCollection_a[display/* ConsoleApiName.debug */.vA.debug] = StatusType.debug,
    consoleCollection_a[display/* ConsoleApiName.info */.vA.info] = StatusType.info,
    consoleCollection_a[display/* ConsoleApiName.warn */.vA.warn] = StatusType.warn,
    consoleCollection_a[display/* ConsoleApiName.error */.vA.error] = StatusType.error,
    consoleCollection_a);
function startConsoleCollection(configuration, lifeCycle) {
    var consoleSubscription = (0,consoleObservable/* initConsoleObservable */.a)(configuration.forwardConsoleLogs).subscribe(function (log) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: (0,timeUtils/* timeStampNow */.n$)(),
                message: log.message,
                origin: error_types/* ErrorSource.CONSOLE */.z.CONSOLE,
                error: log.api === display/* ConsoleApiName.error */.vA.error
                    ? {
                        origin: error_types/* ErrorSource.CONSOLE */.z.CONSOLE,
                        stack: log.stack,
                        fingerprint: log.fingerprint,
                    }
                    : undefined,
                status: LogStatusForApi[log.api],
            },
        });
    });
    return {
        stop: function () {
            consoleSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=consoleCollection.js.map
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/domain/report/reportCollection.js
var reportCollection_a;


var LogStatusForReport = (reportCollection_a = {},
    reportCollection_a[reportObservable/* RawReportType.cspViolation */._.cspViolation] = StatusType.error,
    reportCollection_a[reportObservable/* RawReportType.intervention */._.intervention] = StatusType.error,
    reportCollection_a[reportObservable/* RawReportType.deprecation */._.deprecation] = StatusType.warn,
    reportCollection_a);
function startReportCollection(configuration, lifeCycle) {
    var reportSubscription = (0,reportObservable/* initReportObservable */.v)(configuration, configuration.forwardReports).subscribe(function (report) {
        var message = report.message;
        var status = LogStatusForReport[report.type];
        var error;
        if (status === StatusType.error) {
            error = {
                kind: report.subtype,
                origin: error_types/* ErrorSource.REPORT */.z.REPORT,
                stack: report.stack,
            };
        }
        else if (report.stack) {
            message += " Found in ".concat((0,error_error/* getFileFromStackTraceString */.u5)(report.stack));
        }
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: (0,timeUtils/* timeStampNow */.n$)(),
                message: message,
                origin: error_types/* ErrorSource.REPORT */.z.REPORT,
                error: error,
                status: status,
            },
        });
    });
    return {
        stop: function () {
            reportSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=reportCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js
var functionUtils = __webpack_require__(84164);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/xhrObservable.js
var xhrObservable = __webpack_require__(76842);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/fetchObservable.js
var fetchObservable = __webpack_require__(96817);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
var responseUtils = __webpack_require__(98744);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/readBytesFromStream.js
var readBytesFromStream = __webpack_require__(57717);
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/domain/networkError/networkErrorCollection.js


function startNetworkErrorCollection(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) {
        return { stop: functionUtils/* noop */.Z };
    }
    var xhrSubscription = (0,xhrObservable/* initXhrObservable */.S)(configuration).subscribe(function (context) {
        if (context.state === 'complete') {
            handleResponse("xhr" /* RequestType.XHR */, context);
        }
    });
    var fetchSubscription = (0,fetchObservable/* initFetchObservable */.y)().subscribe(function (context) {
        if (context.state === 'resolve') {
            handleResponse("fetch" /* RequestType.FETCH */, context);
        }
    });
    function handleResponse(type, request) {
        if (!configuration.isIntakeUrl(request.url) && (isRejected(request) || (0,responseUtils/* isServerError */.o)(request.status))) {
            if ('xhr' in request) {
                computeXhrResponseData(request.xhr, configuration, onResponseDataAvailable);
            }
            else if (request.response) {
                computeFetchResponseText(request.response, configuration, onResponseDataAvailable);
            }
            else if (request.error) {
                computeFetchErrorText(request.error, configuration, onResponseDataAvailable);
            }
        }
        function onResponseDataAvailable(responseData) {
            lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
                rawLogsEvent: {
                    message: "".concat(format(type), " error ").concat(request.method, " ").concat(request.url),
                    date: request.startClocks.timeStamp,
                    error: {
                        origin: error_types/* ErrorSource.NETWORK */.z.NETWORK,
                        stack: responseData || 'Failed to load',
                    },
                    http: {
                        method: request.method,
                        status_code: request.status,
                        url: request.url,
                    },
                    status: StatusType.error,
                    origin: error_types/* ErrorSource.NETWORK */.z.NETWORK,
                },
            });
        }
    }
    return {
        stop: function () {
            xhrSubscription.unsubscribe();
            fetchSubscription.unsubscribe();
        },
    };
}
// TODO: ideally, computeXhrResponseData should always call the callback with a string instead of
// `unknown`. But to keep backward compatibility, in the case of XHR with a `responseType` different
// than "text", the response data should be whatever `xhr.response` is. This is a bit confusing as
// Logs event 'stack' is expected to be a string. This should be changed in a future major version
// as it could be a breaking change.
function computeXhrResponseData(xhr, configuration, callback) {
    if (typeof xhr.response === 'string') {
        callback(truncateResponseText(xhr.response, configuration));
    }
    else {
        callback(xhr.response);
    }
}
function computeFetchErrorText(error, configuration, callback) {
    callback(truncateResponseText((0,error_error/* toStackTraceString */.P3)((0,computeStackTrace/* computeStackTrace */._)(error)), configuration));
}
function computeFetchResponseText(response, configuration, callback) {
    var clonedResponse = (0,responseUtils/* tryToClone */.u)(response);
    if (!clonedResponse || !clonedResponse.body) {
        // if the clone failed or if the body is null, let's not try to read it.
        callback();
    }
    else if (!window.TextDecoder) {
        // If the browser doesn't support TextDecoder, let's read the whole response then truncate it.
        //
        // This should only be the case on early versions of Edge (before they migrated to Chromium).
        // Even if it could be possible to implement a workaround for the missing TextDecoder API (using
        // a Blob and FileReader), we found another issue preventing us from reading only the first
        // bytes from the response: contrary to other browsers, when reading from the cloned response,
        // if the original response gets canceled, the cloned response is also canceled and we can't
        // know about it.  In the following illustration, the promise returned by `reader.read()` may
        // never be fulfilled:
        //
        // fetch('/').then((response) => {
        //   const reader = response.clone().body.getReader()
        //   readMore()
        //   function readMore() {
        //     reader.read().then(
        //       (result) => {
        //         if (result.done) {
        //           console.log('done')
        //         } else {
        //           readMore()
        //         }
        //       },
        //       () => console.log('error')
        //     )
        //   }
        //   response.body.getReader().cancel()
        // })
        clonedResponse.text().then((0,monitor/* monitor */.zk)(function (text) { return callback(truncateResponseText(text, configuration)); }), (0,monitor/* monitor */.zk)(function (error) { return callback("Unable to retrieve response: ".concat(error)); }));
    }
    else {
        truncateResponseStream(clonedResponse.body, configuration.requestErrorResponseLengthLimit, function (error, responseText) {
            if (error) {
                callback("Unable to retrieve response: ".concat(error));
            }
            else {
                callback(responseText);
            }
        });
    }
}
function isRejected(request) {
    return request.status === 0 && request.responseType !== 'opaque';
}
function truncateResponseText(responseText, configuration) {
    if (responseText.length > configuration.requestErrorResponseLengthLimit) {
        return "".concat(responseText.substring(0, configuration.requestErrorResponseLengthLimit), "...");
    }
    return responseText;
}
function format(type) {
    if ("xhr" /* RequestType.XHR */ === type) {
        return 'XHR';
    }
    return 'Fetch';
}
function truncateResponseStream(stream, bytesLimit, callback) {
    (0,readBytesFromStream/* readBytesFromStream */.n)(stream, function (error, bytes, limitExceeded) {
        if (error) {
            callback(error);
        }
        else {
            var responseText = new TextDecoder().decode(bytes);
            if (limitExceeded) {
                responseText += '...';
            }
            callback(undefined, responseText);
        }
    }, {
        bytesLimit: bytesLimit,
        collectStreamBody: true,
    });
}
//# sourceMappingURL=networkErrorCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js + 1 modules
var trackRuntimeError = __webpack_require__(80676);
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/domain/runtimeError/runtimeErrorCollection.js


function startRuntimeErrorCollection(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) {
        return { stop: functionUtils/* noop */.Z };
    }
    var rawErrorObservable = new observable/* Observable */.y();
    var stopRuntimeErrorTracking = (0,trackRuntimeError/* trackRuntimeError */.L)(rawErrorObservable).stop;
    var rawErrorSubscription = rawErrorObservable.subscribe(function (rawError) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: rawError.message,
                date: rawError.startClocks.timeStamp,
                error: {
                    kind: rawError.type,
                    origin: error_types/* ErrorSource.SOURCE */.z.SOURCE,
                    stack: rawError.stack,
                },
                origin: error_types/* ErrorSource.SOURCE */.z.SOURCE,
                status: StatusType.error,
            },
        });
    });
    return {
        stop: function () {
            stopRuntimeErrorTracking();
            rawErrorSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=runtimeErrorCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/abstractLifeCycle.js
var abstractLifeCycle = __webpack_require__(77357);
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/domain/lifeCycle.js

var LifeCycle = (abstractLifeCycle/* AbstractLifeCycle */.l);
//# sourceMappingURL=lifeCycle.js.map
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/transport/startLogsBatch.js

function startLogsBatch(configuration, lifeCycle, reportError, pageExitObservable, sessionExpireObservable) {
    var batch = (0,startBatchWithReplica/* startBatchWithReplica */.W)(configuration, {
        endpoint: configuration.logsEndpointBuilder,
    }, configuration.replica && {
        endpoint: configuration.replica.logsEndpointBuilder,
    }, reportError, pageExitObservable, sessionExpireObservable);
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */, function (serverLogsEvent) {
        batch.add(serverLogsEvent);
    });
    return batch;
}
//# sourceMappingURL=startLogsBatch.js.map
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/transport/startLogsBridge.js

function startLogsBridge(lifeCycle) {
    var bridge = (0,eventBridge/* getEventBridge */.A)();
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */, function (serverLogsEvent) {
        bridge.send('log', serverLogsEvent);
    });
}
//# sourceMappingURL=startLogsBridge.js.map
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/domain/internalContext.js
function startInternalContext(sessionManager) {
    return {
        get: function (startTime) {
            var trackedSession = sessionManager.findTrackedSession(startTime);
            if (trackedSession) {
                return {
                    session_id: trackedSession.id,
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/boot/startLogs.js














function startLogs(initConfiguration, configuration, buildCommonContext, mainLogger) {
    var lifeCycle = new LifeCycle();
    var cleanupTasks = [];
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */, function (log) { return (0,sendToExtension/* sendToExtension */.j)('logs', log); });
    var reportError = function (error) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: error.message,
                date: error.startClocks.timeStamp,
                error: {
                    origin: error_types/* ErrorSource.AGENT */.z.AGENT, // Todo: Remove in the next major release
                },
                origin: error_types/* ErrorSource.AGENT */.z.AGENT,
                status: StatusType.error,
            },
        });
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Error reported to customer', { 'error.message': error.message });
    };
    var pageExitObservable = (0,browser_pageExitObservable/* createPageExitObservable */.Pd)(configuration);
    var session = configuration.sessionStoreStrategyType && !(0,eventBridge/* canUseEventBridge */.x)() && !(0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)()
        ? startLogsSessionManager(configuration)
        : startLogsSessionManagerStub(configuration);
    var _a = startLogsTelemetry(configuration, reportError, pageExitObservable, session.expireObservable), telemetry = _a.telemetry, stopLogsTelemetry = _a.stop;
    cleanupTasks.push(function () { return stopLogsTelemetry(); });
    telemetry.setContextProvider(function () {
        var _a, _b, _c, _d, _e, _f;
        return ({
            application: {
                id: (_a = getRUMInternalContext()) === null || _a === void 0 ? void 0 : _a.application_id,
            },
            session: {
                id: (_b = session.findTrackedSession()) === null || _b === void 0 ? void 0 : _b.id,
            },
            view: {
                id: (_d = (_c = getRUMInternalContext()) === null || _c === void 0 ? void 0 : _c.view) === null || _d === void 0 ? void 0 : _d.id,
            },
            action: {
                id: (_f = (_e = getRUMInternalContext()) === null || _e === void 0 ? void 0 : _e.user_action) === null || _f === void 0 ? void 0 : _f.id,
            },
        });
    });
    startNetworkErrorCollection(configuration, lifeCycle);
    startRuntimeErrorCollection(configuration, lifeCycle);
    startConsoleCollection(configuration, lifeCycle);
    startReportCollection(configuration, lifeCycle);
    var handleLog = startLoggerCollection(lifeCycle).handleLog;
    startLogsAssembly(session, configuration, lifeCycle, buildCommonContext, mainLogger, reportError);
    if (!(0,eventBridge/* canUseEventBridge */.x)()) {
        var stopLogsBatch_1 = startLogsBatch(configuration, lifeCycle, reportError, pageExitObservable, session.expireObservable).stop;
        cleanupTasks.push(function () { return stopLogsBatch_1(); });
    }
    else {
        startLogsBridge(lifeCycle);
    }
    (0,telemetry_telemetry/* addTelemetryConfiguration */.Uo)(serializeLogsConfiguration(initConfiguration));
    var internalContext = startInternalContext(session);
    return {
        handleLog: handleLog,
        getInternalContext: internalContext.get,
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
function startLogsTelemetry(configuration, reportError, pageExitObservable, sessionExpireObservable) {
    var telemetry = (0,telemetry_telemetry/* startTelemetry */.VL)("browser-logs-sdk" /* TelemetryService.LOGS */, configuration);
    var cleanupTasks = [];
    if ((0,eventBridge/* canUseEventBridge */.x)()) {
        var bridge_1 = (0,eventBridge/* getEventBridge */.A)();
        var telemetrySubscription_1 = telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
        cleanupTasks.push(function () { return telemetrySubscription_1.unsubscribe(); });
    }
    else {
        var telemetryBatch_1 = (0,startBatchWithReplica/* startBatchWithReplica */.W)(configuration, {
            endpoint: configuration.rumEndpointBuilder,
        }, configuration.replica && {
            endpoint: configuration.replica.rumEndpointBuilder,
        }, reportError, pageExitObservable, sessionExpireObservable);
        cleanupTasks.push(function () { return telemetryBatch_1.stop(); });
        var telemetrySubscription_2 = telemetry.observable.subscribe(function (event) {
            return telemetryBatch_1.add(event, (0,telemetry_telemetry/* isTelemetryReplicationAllowed */.VG)(configuration));
        });
        cleanupTasks.push(function () { return telemetrySubscription_2.unsubscribe(); });
    }
    return {
        telemetry: telemetry,
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
//# sourceMappingURL=startLogs.js.map
;// CONCATENATED MODULE: ../node_modules/@datadog/browser-logs/esm/entries/main.js




var datadogLogs = makeLogsPublicApi(startLogs);
(0,init/* defineGlobal */.y)((0,getGlobalObject/* getGlobalObject */.R)(), 'DD_LOGS', datadogLogs);
//# sourceMappingURL=main.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/initialize-logger/config.js
// set env vars used by the app
var datadogConfig = {
    applicationId: '06f787c5-114c-47ed-b589-b6e5fbe1c7a7',
    site: 'datadoghq.com',
    clientToken: 'pubc8838d3ffe6ce05a722407476b02a006',
    serviceId: 'lendigroup-leads-library',
};
//# sourceMappingURL=config.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/initialize-logger/index.js


var redactEmail = function (payload) { return payload.replace(/email=[^&]*/, 'email=REDACTED'); };
var redactName = function (payload) { return payload.replace(/name=[^&]*/, 'name=REDACTED'); };
var redactToken = function (payload) { return payload.replace(/access_token=[^&]*/, 'access_token=REDACTED'); };
var redactPII = function (payload) { return redactToken(redactName(redactEmail(payload))); };
var initializeLogger = function () {
    datadogLogs.init({
        clientToken: datadogConfig.clientToken,
        site: datadogConfig.site,
        service: datadogConfig.serviceId,
        forwardErrorsToLogs: false,
        sampleRate: 100,
        beforeSend: function (log) {
            var _a, _b, _c, _d, _e;
            // @ts-ignore
            if ((_b = (_a = log === null || log === void 0 ? void 0 : log.error) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.data) {
                // @ts-ignore
                log.error.config.data = undefined;
            }
            if ((_c = log === null || log === void 0 ? void 0 : log.view) === null || _c === void 0 ? void 0 : _c.url) {
                log.view.url = redactPII(log.view.url);
            }
            if ((_d = log === null || log === void 0 ? void 0 : log.http) === null || _d === void 0 ? void 0 : _d.url) {
                log.http.url = redactPII(log.http.url);
            }
            if ((_e = log === null || log === void 0 ? void 0 : log.view) === null || _e === void 0 ? void 0 : _e.referrer) {
                log.view.referrer = redactPII(log.view.referrer);
            }
        },
    });
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/ApplicantEntity.js
var ApplicantEntity;
(function (ApplicantEntity) {
    ApplicantEntity["Person"] = "PERSON";
    ApplicantEntity["Company"] = "COMPANY";
    ApplicantEntity["Trust"] = "TRUST";
})(ApplicantEntity || (ApplicantEntity = {}));
//# sourceMappingURL=ApplicantEntity.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/ApplicantType.js
var ApplicantType;
(function (ApplicantType) {
    ApplicantType["Borrower"] = "BORROWER";
    ApplicantType["BorrowerAndGuarantor"] = "BORROWER_AND_GUARANTOR";
    ApplicantType["Guarantor"] = "GUARANTOR";
})(ApplicantType || (ApplicantType = {}));
//# sourceMappingURL=ApplicantType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Assets.js
var AssetType;
(function (AssetType) {
    AssetType["Property"] = "PROPERTY";
    AssetType["Vehicle"] = "VEHICLE";
    AssetType["HomeContents"] = "HOME_CONTENTS";
    AssetType["SavingCheckAccount"] = "SAVING_CHECK_ACCOUNT";
    AssetType["Superannuation"] = "SUPERANNUATION";
    AssetType["TermDeposit"] = "TERM_DEPOSIT";
    AssetType["Shares"] = "SHARES";
    AssetType["ManagedFunds"] = "MANAGED_FUNDS";
    AssetType["Gifts"] = "GIFTS";
    AssetType["OtherAsset"] = "OTHER_ASSET";
})(AssetType || (AssetType = {}));
var AssetPrimaryPurpose;
(function (AssetPrimaryPurpose) {
    AssetPrimaryPurpose["Investment"] = "INVESTMENT";
    AssetPrimaryPurpose["OwnerOccupied"] = "OWNER_OCCUPIED";
})(AssetPrimaryPurpose || (AssetPrimaryPurpose = {}));
//# sourceMappingURL=Assets.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/AuthOrigin.js
var AuthOrigin;
(function (AuthOrigin) {
    AuthOrigin["Passwordless"] = "passwordless";
    AuthOrigin["Domain"] = "domain";
    AuthOrigin["Google"] = "google";
})(AuthOrigin || (AuthOrigin = {}));
//# sourceMappingURL=AuthOrigin.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/AuthTokenFields.js
var AuthTokenFields;
(function (AuthTokenFields) {
    AuthTokenFields["UserId"] = "https://lendi/userId";
    AuthTokenFields["Type"] = "https://lendi/type";
    AuthTokenFields["Brand"] = "https://lendi/brand";
    AuthTokenFields["AuthApplications"] = "authorized-applications";
    AuthTokenFields["AuthCustomer"] = "authorized-customer";
})(AuthTokenFields || (AuthTokenFields = {}));
//# sourceMappingURL=AuthTokenFields.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Brand.js
var Brand;
(function (Brand) {
    Brand["Lendi"] = "lendi";
    Brand["Domain"] = "domain";
    Brand["Aussie"] = "aussie";
})(Brand || (Brand = {}));
//# sourceMappingURL=Brand.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/BankingFeatures.js
var BankingFeatures;
(function (BankingFeatures) {
    BankingFeatures["ApplePay"] = "APPLE_PAY";
    BankingFeatures["BranchAccess"] = "BRANCH_ACCESS";
    BankingFeatures["CreditCard"] = "CREDIT_CARD";
    BankingFeatures["FeeFreeAtmTransactions"] = "FEE_FREE_ATM_TRANSACTIONS";
    BankingFeatures["GooglePay"] = "GOOGLE_PAY";
    BankingFeatures["InternetBanking"] = "INTERNET_BANKING";
    BankingFeatures["MobileApp"] = "MOBILE_APP";
    BankingFeatures["OpenToEverything"] = "OPEN_TO_EVERYTHING";
    BankingFeatures["SamsungPay"] = "SAMSUNG_PAY";
    BankingFeatures["UrgentTurnaround"] = "URGENT_TURNAROUND";
})(BankingFeatures || (BankingFeatures = {}));
//# sourceMappingURL=BankingFeatures.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/BrokerInterviews.js
var BenefitEnquiries;
(function (BenefitEnquiries) {
    BenefitEnquiries["Other"] = "OTHER";
    BenefitEnquiries["ProportionsInAssetsPurchased"] = "PROPORTION_IN_ASSETS_PURCHASED";
    BenefitEnquiries["RepayDebtsOrOtherObligations"] = "REPAY_DEBTS_OR_OTHER_OBLIGATIONS";
})(BenefitEnquiries || (BenefitEnquiries = {}));
var CoApplicantBenefit;
(function (CoApplicantBenefit) {
    CoApplicantBenefit["NoSubstantialBenefit"] = "NO_SUBSTANTIAL_BENEFIT";
    CoApplicantBenefit["NoSubstantialBenefitAndProceed"] = "NO_SUBSTANTIAL_BENEFIT_AND_PROCEED";
    CoApplicantBenefit["SubstantialBenefit"] = "SUBSTANTIAL_BENEFIT";
})(CoApplicantBenefit || (CoApplicantBenefit = {}));
var CoApplicantReason;
(function (CoApplicantReason) {
    CoApplicantReason["AccessToCashOrEquity"] = "ACCESS_TO_CASH_OR_EQUITY";
    CoApplicantReason["BuyingAVehicalWhereOnlyOneBorrowerCanBeTheRegisteredOwner"] = "BUYING_A_VEHICLE_WHERE_ONLY_ONE_BORROWER_CAN_BE_THE_REGISTERED_OWNER";
    CoApplicantReason["IndependentFinancialLegalOrAccountingAdviceRequired"] = "INDEPENDENT_FINANCIAL_LEGAL_OR_ACCOUNTING_ADVICE_RECEIVED";
    CoApplicantReason["SpousalAssetProtectionTaxBenefitsOrDebtReduction"] = "SPOUSAL_ASSET_PROTECTION_TAX_BENEFITS_OR_DEBT_REDUCTION";
    CoApplicantReason["SubstantialBenefitFromAtLeastOneOfTheLoanPurposes"] = "SUBSTANTIAL_BENEFIT_FROM_AT_LEAST_ONE_OF_THE_LOAN_PURPOSES";
})(CoApplicantReason || (CoApplicantReason = {}));
var DocumentationDeliveryMethod;
(function (DocumentationDeliveryMethod) {
    DocumentationDeliveryMethod["email"] = "EMAIL";
    DocumentationDeliveryMethod["post"] = "POST";
    DocumentationDeliveryMethod["collectFromNearestBranch"] = "COLLECT_FROM_NEAREST_BRANCH";
})(DocumentationDeliveryMethod || (DocumentationDeliveryMethod = {}));
var GuarantorLocationType;
(function (GuarantorLocationType) {
    GuarantorLocationType["lendiApprovedPhotoInterview"] = "LENDI_APPROVED_PHONE_INTERVIEW";
    GuarantorLocationType["faceToFace"] = "FACE_TO_FACE";
})(GuarantorLocationType || (GuarantorLocationType = {}));
var IndependentAdviceTypeRequired;
(function (IndependentAdviceTypeRequired) {
    IndependentAdviceTypeRequired["legalAdvice"] = "LEGAL_ADVICE";
    IndependentAdviceTypeRequired["financialAdvice"] = "FINANCIAL_ADVICE";
    IndependentAdviceTypeRequired["notNeeded"] = "NOT_NEEDED";
})(IndependentAdviceTypeRequired || (IndependentAdviceTypeRequired = {}));
var LocationType;
(function (LocationType) {
    LocationType["CustomerResidence"] = "CUSTOMER_RESIDENCE";
    LocationType["LendiApprovedPhoneInterview"] = "LENDI_APPROVED_PHONE_INTERVIEW";
    LocationType["Other"] = "OTHER";
})(LocationType || (LocationType = {}));
//# sourceMappingURL=BrokerInterviews.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Confidence.js
var Confidence;
(function (Confidence) {
    Confidence["Low"] = "LOW";
    Confidence["MediumLow"] = "MEDIUM_LOW";
    Confidence["Medium"] = "MEDIUM";
    Confidence["MediumHigh"] = "MEDIUM_HIGH";
    Confidence["High"] = "HIGH";
})(Confidence || (Confidence = {}));
//# sourceMappingURL=Confidence.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Construction.js
var Construction;
(function (Construction) {
    Construction["BuildAProperty"] = "BUILD_A_PROPERTY";
    Construction["KnockdownRebuild"] = "KNOCKDOWN_REBUILD";
    Construction["StructuralRenovations"] = "STRUCTURAL_RENOVATIONS";
})(Construction || (Construction = {}));
//# sourceMappingURL=Construction.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/CreditStatus.js
var CreditStatus;
(function (CreditStatus) {
    CreditStatus["Fair"] = "FAIR";
    CreditStatus["Unknown"] = "UNKNOWN";
    CreditStatus["Average"] = "AVERAGE";
    CreditStatus["Excellent"] = "EXCELLENT";
})(CreditStatus || (CreditStatus = {}));
//# sourceMappingURL=CreditStatus.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/DesiredFeatures.js
var DesiredFeatures;
(function (DesiredFeatures) {
    DesiredFeatures["MobileApp"] = "MOBILE_APP";
    DesiredFeatures["MajorLender"] = "MAJOR_LENDER";
    DesiredFeatures["OffsetOrRedraw"] = "OFFSET_OR_REDRAW";
    DesiredFeatures["FixedRate"] = "FIXED_RATE";
})(DesiredFeatures || (DesiredFeatures = {}));
//# sourceMappingURL=DesiredFeatures.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/EligibleForFHOG.js
var EligibleForFHOG;
(function (EligibleForFHOG) {
    EligibleForFHOG["Yes"] = "YES";
    EligibleForFHOG["No"] = "NO";
    EligibleForFHOG["NotSure"] = "NOT_SURE";
})(EligibleForFHOG || (EligibleForFHOG = {}));
//# sourceMappingURL=EligibleForFHOG.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/EmploymentType.js
var EmploymentType;
(function (EmploymentType) {
    EmploymentType["Employee"] = "EMPLOYEE";
    EmploymentType["SelfEmployed"] = "SELF_EMPLOYED";
    EmploymentType["NotEmployed"] = "NOT_EMPLOYED";
    EmploymentType["Unknown"] = "UNKNOWN";
    EmploymentType["NotWorking"] = "NOT_WORKING";
})(EmploymentType || (EmploymentType = {}));
//# sourceMappingURL=EmploymentType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/FinancialSituation.js
var FinancialSituation;
(function (FinancialSituation) {
    FinancialSituation["ExtendedUnpaidLeave"] = "EXTENDED_UNPAID_LEAVE";
    FinancialSituation["IncreasedDebtRepaymentForExistingLoan"] = "INCREASED_DEBT_REPAYMENT_FOR_EXISTING_LOAN";
    FinancialSituation["LargeExpenditure"] = "LARGE_EXPENDITURE";
    FinancialSituation["MedicalTreatmentOrIllness"] = "MEDICAL_TREATMENT_OR_ILLNESS";
    FinancialSituation["None"] = "NONE";
    FinancialSituation["Other"] = "OTHER";
    FinancialSituation["PermanentDecreaseInIncome"] = "PERMANENT_DECREASE_IN_INCOME";
    FinancialSituation["TemporaryDecreaseInIncome"] = "TEMPORARY_DECREASE_IN_INCOME";
    FinancialSituation["TemporaryIncreaseInExpense"] = "TEMPORARY_INCREASE_IN_EXPENSE";
})(FinancialSituation || (FinancialSituation = {}));
//# sourceMappingURL=FinancialSituation.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Gender.js
var Gender;
(function (Gender) {
    Gender["Female"] = "FEMALE";
    Gender["Male"] = "MALE";
    Gender["Undisclosed"] = "UNDISCLOSED";
    Gender["Unknown"] = "UNKNOWN";
})(Gender || (Gender = {}));
//# sourceMappingURL=Gender.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/InterestRateType.js
var InterestRateType;
(function (InterestRateType) {
    InterestRateType["Variable"] = "VARIABLE";
    InterestRateType["Fixed"] = "FIXED";
    InterestRateType["Both"] = "BOTH";
})(InterestRateType || (InterestRateType = {}));
//# sourceMappingURL=InterestRateType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/InvitationStatus.js
var InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus["Pending"] = "PENDING";
    InvitationStatus["Expired"] = "EXPIRED";
    InvitationStatus["Accepted"] = "ACCEPTED";
    InvitationStatus["Cancelled"] = "CANCELLED";
})(InvitationStatus || (InvitationStatus = {}));
//# sourceMappingURL=InvitationStatus.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Liabilities.js
var LiabilityType;
(function (LiabilityType) {
    LiabilityType["Vehicle"] = "CAR_LOAN";
    LiabilityType["HomeLoan"] = "HOME_LOAN";
    LiabilityType["CreditCard"] = "CREDIT_CARD";
    LiabilityType["StoreCard"] = "STORE_CARD";
    LiabilityType["PersonalLoan"] = "PERSONAL_LOAN";
    LiabilityType["ShortTermFinance"] = "SHORT_TERM_FINANCE";
    LiabilityType["Lease"] = "LEASE";
    LiabilityType["HirePurchase"] = "HIRE_PURCHASE";
    LiabilityType["TaxDebt"] = "TAX_DEBT";
    LiabilityType["LineOfCredit"] = "LINE_OF_CREDIT";
    LiabilityType["Overdraft"] = "OVERDRAFT";
    LiabilityType["HelpHecsDebt"] = "HELP_HECS_DEBT";
    LiabilityType["Other"] = "OTHER";
    LiabilityType["Unknown"] = "UNKNOWN";
})(LiabilityType || (LiabilityType = {}));
var LiabilityRepaymentTypeDetails;
(function (LiabilityRepaymentTypeDetails) {
    LiabilityRepaymentTypeDetails["InterestOnly"] = "INTEREST_ONLY";
    LiabilityRepaymentTypeDetails["PrincipalAndInterest"] = "PRINCIPAL_AND_INTEREST";
})(LiabilityRepaymentTypeDetails || (LiabilityRepaymentTypeDetails = {}));
var LiabilityRepaymentFrequency;
(function (LiabilityRepaymentFrequency) {
    LiabilityRepaymentFrequency["Weekly"] = "WEEKLY";
    LiabilityRepaymentFrequency["Fortnightly"] = "FORTNIGHTLY";
    LiabilityRepaymentFrequency["Monthly"] = "MONTHLY";
    LiabilityRepaymentFrequency["Annually"] = "ANNUALLY";
})(LiabilityRepaymentFrequency || (LiabilityRepaymentFrequency = {}));
var LiabilityClearingFromOtherSource;
(function (LiabilityClearingFromOtherSource) {
    LiabilityClearingFromOtherSource["PayingOut"] = "PAYING_OUT";
    LiabilityClearingFromOtherSource["Reducing"] = "REDUCING";
})(LiabilityClearingFromOtherSource || (LiabilityClearingFromOtherSource = {}));
var LiabilityInterestType;
(function (LiabilityInterestType) {
    LiabilityInterestType["FixedRate"] = "FIXED_RATE";
    LiabilityInterestType["Variable"] = "VARIABLE";
})(LiabilityInterestType || (LiabilityInterestType = {}));
//# sourceMappingURL=Liabilities.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/MaritalStatus.js
var MaritalStatus;
(function (MaritalStatus) {
    MaritalStatus["DeFacto"] = "DE_FACTO";
    MaritalStatus["Divorced"] = "DIVORCED";
    MaritalStatus["Married"] = "MARRIED";
    MaritalStatus["Single"] = "SINGLE";
    MaritalStatus["Unknown"] = "UNKNOWN";
})(MaritalStatus || (MaritalStatus = {}));
//# sourceMappingURL=MaritalStatus.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Mitigant.js
var Mitigant;
(function (Mitigant) {
    Mitigant["ApplicationReflectsChanges"] = "APPLICATION_REFLECTS_CHANGES";
    Mitigant["CoApplicantsIncome"] = "CO_APPLICANTS_INCOME";
    Mitigant["ReduceExpenditure"] = "REDUCING_EXPENDITURE";
    Mitigant["SaleOfAssets"] = "SALE_OF_ASSETS";
    Mitigant["SecuringAdditionalIncome"] = "SECURING_ADDITIONAL_INCOME";
    Mitigant["UsingSavings"] = "USING_SAVINGS";
    Mitigant["Other"] = "OTHER";
})(Mitigant || (Mitigant = {}));
//# sourceMappingURL=Mitigant.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/OwnershipProportions.js
var OwnershipProportions;
(function (OwnershipProportions) {
    OwnershipProportions["Equal"] = "EQUAL";
    OwnershipProportions["Specified"] = "SPECIFIED";
    OwnershipProportions["NotSpecified"] = "NOT_SPECIFIED";
})(OwnershipProportions || (OwnershipProportions = {}));
//# sourceMappingURL=OwnershipProportions.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/PaymentIssues.js
var PaymentIssues;
(function (PaymentIssues) {
    PaymentIssues["HardshipArrangements"] = "HARDSHIP_ARRANGEMENTS";
    PaymentIssues["LatePayments"] = "LATE_PAYMENTS";
    PaymentIssues["MissedPayments"] = "MISSED_PAYMENTS";
    PaymentIssues["OutstandingArrears"] = "OUTSTANDING_ARREARS";
    PaymentIssues["None"] = "NONE";
})(PaymentIssues || (PaymentIssues = {}));
//# sourceMappingURL=PaymentIssues.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/PaymentType.js
var PaymentType;
(function (PaymentType) {
    PaymentType["InterestOnly"] = "INTEREST_ONLY";
    PaymentType["PrincipalAndInterest"] = "PRINCIPAL_AND_INTEREST";
    PaymentType["Both"] = "BOTH";
    PaymentType["StillDeciding"] = "STILL_DECIDING";
    PaymentType["Unknown"] = "UNKNOWN";
})(PaymentType || (PaymentType = {}));
//# sourceMappingURL=PaymentType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/ProductFeatures.js
var ProductFeatures;
(function (ProductFeatures) {
    ProductFeatures["Offset"] = "OFFSET";
    ProductFeatures["Redraw"] = "REDRAW";
})(ProductFeatures || (ProductFeatures = {}));
//# sourceMappingURL=ProductFeatures.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/ProductPreferences.js
var ProductPreferences;
(function (ProductPreferences) {
    ProductPreferences["AbilityToAccessPrepaidFundsIfNeeded"] = "ABILITY_TO_ACCESS_PREPAID_FUNDS_IF_NEEDED";
    ProductPreferences["AbilityToPayOffLoanSooner"] = "ABILITY_TO_PAY_OFF_LOAN_SOONER";
    ProductPreferences["AccessFundsSameWayAsRegularBankAccount"] = "ACCESS_FUNDS_SAME_WAY_AS_A_REGULAR_BANK_ACCOUNT";
    ProductPreferences["HaveABalanceOfCertaintyOfRepaymentsAndFlexibility"] = "HAVE_A_BALANCE_OF_CERTAINTY_OF_REPAYMENTS_AND_FLEXIBILITY";
    ProductPreferences["HaveSetRepayments"] = "HAVE_SET_REPAYMENTS";
    ProductPreferences["TakeAdvantageOfInterestRateDrops"] = "TAKE_ADVANTAGE_OF_INTEREST_RATE_DROPS";
    ProductPreferences["UseSavingsOrSalaryToReduceInterest"] = "USE_SAVINGS_OR_SALARY_TO_REDUCE_INTEREST";
})(ProductPreferences || (ProductPreferences = {}));
//# sourceMappingURL=ProductPreferences.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Properties.js
var PropertyStatus;
(function (PropertyStatus) {
    PropertyStatus["NewBuilding"] = "NEW_BUILDING";
    PropertyStatus["OffThePlan"] = "OFF_THE_PLAN";
    PropertyStatus["VacantLand"] = "VACANT_LAND";
    PropertyStatus["Established"] = "ESTABLISHED";
})(PropertyStatus || (PropertyStatus = {}));
var PropertyZoneType;
(function (PropertyZoneType) {
    PropertyZoneType["Residential"] = "RESIDENTIAL";
    PropertyZoneType["Commercial"] = "COMMERCIAL";
    PropertyZoneType["Rural"] = "RURAL";
    PropertyZoneType["Industrial"] = "INDUSTRIAL";
})(PropertyZoneType || (PropertyZoneType = {}));
var PropertyType;
(function (PropertyType) {
    PropertyType["ApartmentUnitLessThan50M2"] = "APARTMENT_UNIT_LESS_THAN_50M2";
    PropertyType["ApartmentUnitMoreThan50M2"] = "APARTMENT_UNIT_MORE_THAN_50M2";
    PropertyType["ServicedApartment"] = "SERVICED_APARTMENT";
    PropertyType["Stuido"] = "STUDIO";
    PropertyType["StudentAccommodation"] = "STUDENT_ACCOMMODATION";
    PropertyType["WarehouseApartment"] = "WAREHOUSE_APARTMENT";
    PropertyType["Duplex"] = "DUPLEX";
    PropertyType["Villa"] = "VILLA";
    PropertyType["FullyDetachedHouse"] = "FULLY_DETACHED_HOUSE";
    PropertyType["KitHome"] = "KIT_HOME";
    PropertyType["MultiDwellingSingleTitle"] = "MULTI_DWELLING_SINGLE_TITLE";
    PropertyType["PropertyOver10HA"] = "PROPERTY_OVER_10_HA";
    PropertyType["SemiDetachedHouse"] = "SEMI_DETACHED_HOUSE";
    PropertyType["Terrace"] = "TERRACE";
    PropertyType["Townhouse"] = "TOWNHOUSE";
    PropertyType["Land"] = "LAND";
})(PropertyType || (PropertyType = {}));
var PropertyEstimateBasis;
(function (PropertyEstimateBasis) {
    PropertyEstimateBasis["ApplicantEstimate"] = "APPLICANT_ESTIMATE";
    PropertyEstimateBasis["BankAssessment"] = "BANK_ASSESSMENT";
    PropertyEstimateBasis["CertifiedValuation"] = "CERTIFIED_VALUATION";
    PropertyEstimateBasis["ElectronicValuation"] = "ELECTRONIC_VALUATION";
    PropertyEstimateBasis["RatesNotice"] = "RATES_NOTICE";
    PropertyEstimateBasis["RPData"] = "RP_DATA";
    PropertyEstimateBasis["Valocity"] = "VALOCITY";
})(PropertyEstimateBasis || (PropertyEstimateBasis = {}));
//# sourceMappingURL=Properties.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/PurchaseReason.js
var PurchaseReason;
(function (PurchaseReason) {
    PurchaseReason["LoanApproval"] = "LOAN_APPROVAL";
    PurchaseReason["LoanEligibility"] = "LOAN_ELIGIBILITY";
    PurchaseReason["LoanAffordability"] = "LOAN_AFFORDABILITY";
})(PurchaseReason || (PurchaseReason = {}));
//# sourceMappingURL=PurchaseReason.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/PurchaseSituation.js
var PurchaseSituation;
(function (PurchaseSituation) {
    PurchaseSituation["ContractsExchanged"] = "CONTRACTS_EXCHANGED";
    PurchaseSituation["OfferMade"] = "OFFER_MADE";
    PurchaseSituation["BuyingSoon"] = "BUYING_SOON";
    PurchaseSituation["ExploringOptions"] = "EXPLORING_OPTIONS";
})(PurchaseSituation || (PurchaseSituation = {}));
//# sourceMappingURL=PurchaseSituation.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Purpose.js
var Purpose;
(function (Purpose) {
    Purpose["NewPurchase"] = "NEW_PURCHASE";
    Purpose["Refinance"] = "REFINANCE";
})(Purpose || (Purpose = {}));
var PrimaryPurpose;
(function (PrimaryPurpose) {
    PrimaryPurpose["Commercial"] = "COMMERCIAL";
    PrimaryPurpose["Construction"] = "CONSTRUCTION";
    PrimaryPurpose["ConstructionAndPurchase"] = "CONSTRUCTION_AND_PURCHASE";
    PrimaryPurpose["ConstructionAndRefinance"] = "CONSTRUCTION_AND_REFINANCE";
    PrimaryPurpose["InternalRefinance"] = "INTERNAL_REFINANCE";
    PrimaryPurpose["NewPurchase"] = "NEW_PURCHASE";
    PrimaryPurpose["PreApproval"] = "PRE_APPROVAL";
    PrimaryPurpose["Purchase"] = "PURCHASE";
    PrimaryPurpose["PurchaseAndRefinance"] = "PURCHASE_AND_REFINANCE";
    PrimaryPurpose["Refinance"] = "REFINANCE";
    PrimaryPurpose["SLR"] = "SLR";
    PrimaryPurpose["TopUp"] = "TOP_UP";
    PrimaryPurpose["Variation"] = "VARIATION";
    PrimaryPurpose["VariationCreditCritical"] = "VARIATION_CREDIT_CRITICAL";
    PrimaryPurpose["VariationNonCreditCritical"] = "VARIATION_NON_CREDIT_CRITICAL";
})(PrimaryPurpose || (PrimaryPurpose = {}));
//# sourceMappingURL=Purpose.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RefinancingReasons.js
var RefinancingReasons;
(function (RefinancingReasons) {
    RefinancingReasons["ConsolidateCashout"] = "CONSOLIDATE_CASHOUT";
    RefinancingReasons["FasterPayoff"] = "FASTER_PAYOFF";
    RefinancingReasons["DecreaseRepayments"] = "DECREASE_REPAYMENTS";
    RefinancingReasons["Construction"] = "CONSTRUCTION";
    // Few more from Needs & Objectives
    RefinancingReasons["CloseToTheEndOfAFixedRateOrInterestOnlyPeriod"] = "CLOSE_TO_THE_END_OF_A_FIXED_RATE_OR_INTEREST_ONLY_PERIOD";
    RefinancingReasons["ConsolidateDebtAndReduceNumberOfLenders"] = "CONSOLIDATE_DEBT_AND_REDUCE_NUMBER_OF_LENDERS";
    RefinancingReasons["DissatisfiedWithCurrentLender"] = "DISSATISFIED_WITH_CURRENT_LENDER";
    RefinancingReasons["GreaterFlexibilityOrAdditionalLoanFeatures"] = "GREATER_FLEXIBILITY_OR_ADDITIONAL_LOAN_FEATURES";
    RefinancingReasons["IncreaseLoanAmount"] = "INCREASE_LOAN_AMOUNT";
    RefinancingReasons["PayOffLoanFasterWithALowerInterestRate"] = "PAY_OFF_LOAN_FASTER_WITH_A_LOWER_INTEREST_RATE";
    RefinancingReasons["Other"] = "OTHER";
})(RefinancingReasons || (RefinancingReasons = {}));
//# sourceMappingURL=RefinancingReasons.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RelationshipToBorrower.js
var RelationshipToBorrower;
(function (RelationshipToBorrower) {
    RelationshipToBorrower["FATHER"] = "Father";
    RelationshipToBorrower["MOTHER"] = "Mother";
    RelationshipToBorrower["SPOUSE"] = "Spouse";
    RelationshipToBorrower["BROTHER"] = "Brother";
    RelationshipToBorrower["SISTER"] = "Sister";
    RelationshipToBorrower["SON"] = "Son";
    RelationshipToBorrower["OTHER_RELATIVE"] = "Other Relative";
    RelationshipToBorrower["OTHER"] = "Other";
})(RelationshipToBorrower || (RelationshipToBorrower = {}));
//# sourceMappingURL=RelationshipToBorrower.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RepaymentOptions.js
var RepaymentOptions;
(function (RepaymentOptions) {
    RepaymentOptions["Downsize"] = "DOWNSIZE";
    RepaymentOptions["RelyOnCoApplicantsIncome"] = "RELY_ON_CO_APPLICANTS_INCOME";
    RepaymentOptions["RepayLoanBeforeRetirement"] = "REPAY_LOAN_BEFORE_RETIREMENT";
    RepaymentOptions["SellAssets"] = "SELL_ASSETS";
    RepaymentOptions["UseIncomeFromOtherInvestments"] = "USE_INCOME_FROM_OTHER_INVESTMENTS";
    RepaymentOptions["UseSavings"] = "USE_SAVINGS";
    RepaymentOptions["UseSuperannuationLumpSum"] = "USE_SUPERANNUATION_LUMP_SUM";
    RepaymentOptions["UseSuperannuationOnGoing"] = "USE_SUPERANNUATION_ONGOING";
    RepaymentOptions["WorkPastRetirementAge"] = "WORK_PAST_RETIREMENT_AGE";
    RepaymentOptions["Other"] = "OTHER";
})(RepaymentOptions || (RepaymentOptions = {}));
//# sourceMappingURL=RepaymentOptions.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RepaymentType.js
var RepaymentType;
(function (RepaymentType) {
    RepaymentType["InterestOnly"] = "INTEREST_ONLY";
    RepaymentType["PrincipalAndInterest"] = "PRINCIPAL_AND_INTEREST";
    RepaymentType["Both"] = "BOTH";
})(RepaymentType || (RepaymentType = {}));
//# sourceMappingURL=RepaymentType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RepaymentTypeDetails.js
var RepaymentTypeDetails;
(function (RepaymentTypeDetails) {
    RepaymentTypeDetails["InterestOnlyDueToVariableAndUnpredictableIncome"] = "INTEREST_ONLY_DUE_TO_VARIABLE_AND_UNPREDICTABLE_INCOME";
    RepaymentTypeDetails["InterestOnlyForTaxAndAccountingPurpose"] = "INTEREST_ONLY_FOR_TAX_AND_ACCOUNTING_PURPOSE";
    RepaymentTypeDetails["InterestOnlyToAccommodateTemporaryReductionInIncome"] = "INTEREST_ONLY_TO_ACCOMMODATE_TEMPORARY_REDUCTION_IN_INCOME";
    RepaymentTypeDetails["InterestOnlyToAccommodateNonRecurringExpenses"] = "INTEREST_ONLY_TO_ACCOMMODATE_NON_RECURRING_EXPENSES";
    RepaymentTypeDetails["InterestOnlyToPayOffNonDeductibleDebtsAsAPriority"] = "INTEREST_ONLY_TO_PAY_OFF_NON_DEDUCTIBLE_DEBTS_AS_A_PRIORITY";
    RepaymentTypeDetails["DecreaseDebtOwingOnProperty"] = "DECREASE_DEBT_OWING_ON_PROPERTY";
    RepaymentTypeDetails["MaximiseBorrowingCapacityWithDepositOrAmountOfEquityAccessible"] = "MAXIMISE_BORROWING_CAPACITY_WITH_DEPOSIT_OR_AMOUNT_OF_EQUITY_ACCESSIBLE";
    RepaymentTypeDetails["PaydownPrincipleToMinimiseInterestPaidOverTime"] = "PAY_DOWN_PRINCIPAL_TO_MINIMISE_INTEREST_PAID_OVER_TIME";
    RepaymentTypeDetails["PayLowestPossibleDeposit"] = "PAY_LOWEST_POSSIBLE_DEPOSIT";
    RepaymentTypeDetails["Other"] = "OTHER";
})(RepaymentTypeDetails || (RepaymentTypeDetails = {}));
//# sourceMappingURL=RepaymentTypeDetails.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/ResidencyStatus.js
var ResidencyStatus;
(function (ResidencyStatus) {
    ResidencyStatus["AustralianCitizen"] = "AUSTRALIAN_CITIZEN";
    ResidencyStatus["PermanentResident"] = "PERMANENT_RESIDENT";
    ResidencyStatus["TemporaryResident"] = "TEMPORARY_RESIDENT";
    ResidencyStatus["Unknown"] = "UNKNOWN";
})(ResidencyStatus || (ResidencyStatus = {}));
//# sourceMappingURL=ResidencyStatus.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/States.js
var State;
(function (State) {
    State["QLD"] = "QLD";
    State["NSW"] = "NSW";
    State["VIC"] = "VIC";
    State["WA"] = "WA";
    State["SA"] = "SA";
    State["TAS"] = "TAS";
    State["ACT"] = "ACT";
    State["NT"] = "NT";
})(State || (State = {}));
//# sourceMappingURL=States.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/TeamMemberSkill.js
var TeamMemberSkill;
(function (TeamMemberSkill) {
    TeamMemberSkill["Bridging"] = "Bridging";
    TeamMemberSkill["ComplexInvestments"] = "Complex Investments";
    TeamMemberSkill["Construction"] = "Construction";
    TeamMemberSkill["DebtConsolidation"] = "Debt Consolidation";
    TeamMemberSkill["ExistingCustomer"] = "Existing Customer";
    TeamMemberSkill["Guarantor"] = "Guarantor";
    TeamMemberSkill["HighValue"] = "High Value";
    TeamMemberSkill["LoanSizeLessThan200k"] = "Loan Size < 200k";
    TeamMemberSkill["LowDoc"] = "Low Doc";
    TeamMemberSkill["NonConformingLending"] = "Non-conforming lending";
    TeamMemberSkill["PAYG"] = "PAYG";
    TeamMemberSkill["SelfEmployedPtyLtd"] = "Self Employed PTY LTD";
    TeamMemberSkill["SelfEmployedSoleTrader"] = "Self Employed sole trader";
    TeamMemberSkill["Trust"] = "Trust";
    TeamMemberSkill["SlrToHls"] = "SLR to HLS";
    TeamMemberSkill["VideoAppointment"] = "Video Appointment";
})(TeamMemberSkill || (TeamMemberSkill = {}));
//# sourceMappingURL=TeamMemberSkill.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/TeamMemberSkillLGSF.js
var TeamMemberSkillLGSF;
(function (TeamMemberSkillLGSF) {
    TeamMemberSkillLGSF["Construction"] = "CONSTRUCTION";
    TeamMemberSkillLGSF["LowDoc"] = "LOW_DOC";
    TeamMemberSkillLGSF["NonConformingLoan"] = "NON_CONFORMING_LOAN";
    TeamMemberSkillLGSF["Guarantor"] = "GUARANTOR";
    TeamMemberSkillLGSF["SelfEmployed"] = "SELF_EMPLOYED";
    TeamMemberSkillLGSF["TopUps"] = "TOP_UPS";
    TeamMemberSkillLGSF["Bridging"] = "BRIDGING";
    TeamMemberSkillLGSF["Trust"] = "TRUST";
    TeamMemberSkillLGSF["Commercial"] = "COMMERCIAL";
})(TeamMemberSkillLGSF || (TeamMemberSkillLGSF = {}));
var TeamMemberSkillLGSFWithLabel = {
    Construction: {
        value: 'CONSTRUCTION',
        label: 'Construction',
    },
    LowDoc: {
        value: 'LOW_DOC',
        label: 'Low Doc',
    },
    NonConformingLoan: {
        value: 'NON_CONFORMING_LOAN',
        label: 'Non Conforming Loan',
    },
    Guarantor: {
        value: 'GUARANTOR',
        label: 'Guarantor',
    },
    SelfEmployed: {
        value: 'SELF_EMPLOYED',
        label: 'Self employed',
    },
    TopUps: {
        value: 'TOP_UPS',
        label: 'Top ups',
    },
    Bridging: {
        value: 'BRIDGING',
        label: 'Bridging',
    },
    Trust: {
        value: 'TRUST',
        label: 'Trust',
    },
    Commercial: {
        value: 'COMMERCIAL',
        label: 'Commercial',
    },
};
//# sourceMappingURL=TeamMemberSkillLGSF.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/TeamMemberSubSkillLGSF.js
var TeamMemberSubSkillLGSF;
(function (TeamMemberSubSkillLGSF) {
    TeamMemberSubSkillLGSF["ExistingCustomer"] = "EXISTING_CUSTOMER";
    TeamMemberSubSkillLGSF["SlrToHls"] = "SLR_TO_HLS";
    TeamMemberSubSkillLGSF["VideoAppts"] = "VIDEO_APPTS";
    TeamMemberSubSkillLGSF["HighValue"] = "HIGH_VALUE";
    TeamMemberSubSkillLGSF["ComplexInvestment"] = "COMPLEX_INVESTMENT";
    TeamMemberSubSkillLGSF["LoanAmountUnder200k"] = "LOAN_AMOUNT_UNDER_200K";
    TeamMemberSubSkillLGSF["TestGroupA"] = "TEST_GROUP_A";
    TeamMemberSubSkillLGSF["TestGroupB"] = "TEST_GROUP_B";
})(TeamMemberSubSkillLGSF || (TeamMemberSubSkillLGSF = {}));
var TeamMemberSubSkillLGSFWithLabel = {
    ExistingCustomer: {
        value: 'EXISTING_CUSTOMER',
        label: 'Existing Customer',
    },
    SlrToHls: {
        value: 'SLR_TO_HLS',
        label: 'SLR to HLS',
    },
    VideoAppts: {
        value: 'VIDEO_APPTS',
        label: 'Video Appointments',
    },
    HighValue: {
        value: 'HIGH_VALUE',
        label: 'High Value',
    },
    ComplexInvestment: {
        value: 'COMPLEX_INVESTMENT',
        label: 'Complex Investment',
    },
    LoanAmountUnder200k: {
        value: 'LOAN_AMOUNT_UNDER_200K',
        label: 'Loan amount under 200k',
    },
    TestGroupA: {
        value: 'TEST_GROUP_A',
        label: 'Test Group A',
    },
    TestGroupB: {
        value: 'TEST_GROUP_B',
        label: 'Test Group B',
    },
};
//# sourceMappingURL=TeamMemberSubSkillLGSF.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Title.js
var Title;
(function (Title) {
    Title["Dr"] = "DR";
    Title["Miss"] = "MISS";
    Title["Mr"] = "MR";
    Title["Mrs"] = "MRS";
    Title["Ms"] = "MS";
    Title["Other"] = "OTHER";
    Title["Unknown"] = "UNKNOWN";
})(Title || (Title = {}));
//# sourceMappingURL=Title.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/TransactionType.js
var TransactionType;
(function (TransactionType) {
    TransactionType["ConstructionLoan"] = "CONSTRUCTION_LOAN";
})(TransactionType || (TransactionType = {}));
//# sourceMappingURL=TransactionType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Urgency.js
var Urgency;
(function (Urgency) {
    Urgency["Urgent"] = "URGENT";
    Urgency["NotUrgent"] = "NOT_URGENT";
})(Urgency || (Urgency = {}));
//# sourceMappingURL=Urgency.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/UserType.js
var UserType;
(function (UserType) {
    UserType["Customer"] = "customer";
    UserType["Team"] = "team";
    UserType["M2M"] = "m2m";
})(UserType || (UserType = {}));
//# sourceMappingURL=UserType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/DynamoStream.js
var DynamoEventName;
(function (DynamoEventName) {
    DynamoEventName["Insert"] = "INSERT";
    DynamoEventName["Modify"] = "MODIFY";
    DynamoEventName["Remove"] = "REMOVE";
})(DynamoEventName || (DynamoEventName = {}));
//# sourceMappingURL=DynamoStream.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/HousingStatusList.js
var HousingStatusList;
(function (HousingStatusList) {
    HousingStatusList["Renting"] = "Renting";
    HousingStatusList["Boarding"] = "Boarding";
    HousingStatusList["Caravan"] = "Caravan";
    HousingStatusList["Other"] = "Other";
    HousingStatusList["OwnHome"] = "Own Home";
    HousingStatusList["OwnHomeMortgage"] = "Own Home Mortgage";
    HousingStatusList["SuppliedByEmployer"] = "Supplied by Employer";
    HousingStatusList["WithParents"] = "With Parents";
})(HousingStatusList || (HousingStatusList = {}));
//# sourceMappingURL=HousingStatusList.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/ExpenseTypes.js
var ExpenseTypes;
(function (ExpenseTypes) {
    ExpenseTypes["LivingExpensesEstimate"] = "LIVING_EXPENSES_ESTIMATE";
    ExpenseTypes["Groceries"] = "GROCERIES";
    ExpenseTypes["Childcare"] = "CHILDCARE";
    ExpenseTypes["ChildAndSpousalMaintenance"] = "CHILD_AND_SPOUSAL_MAINTENANCE";
    ExpenseTypes["PrimarySecondaryEducation"] = "PRIMARY_SECONDARY_EDUCATION";
    ExpenseTypes["HigherVocationalTrainingEducation"] = "HIGHER_VOCATIONAL_TRAINING_EDUCATION";
    ExpenseTypes["PrivateSchoolingAndTuition"] = "PRIVATE_SCHOOLING_AND_TUITION";
    ExpenseTypes["ClothingAndPersonalCare"] = "CLOTHING_AND_PERSONAL_CARE";
    ExpenseTypes["RecreationAndEntertainment"] = "RECREATION_AND_ENTERTAINMENT";
    ExpenseTypes["TelephoneInternetPayTvAndMediaStreamingSubscriptions"] = "TELEPHONE_INTERNET_PAY_TV_AND_MEDIA_STREAMING_SUBSCRIPTIONS";
    ExpenseTypes["PetCare"] = "PET_CARE";
    ExpenseTypes["Transport"] = "TRANSPORT";
    ExpenseTypes["BodyCorporateFeesStrataFeesAndLandTax"] = "BODY_CORPORATE_FEES_STRATA_FEES_AND_LAND_TAX";
    ExpenseTypes["PrimaryResidenceRunningCosts"] = "PRIMARY_RESIDENCE_RUNNING_COSTS";
    ExpenseTypes["InvestmentPropertyRunningCosts"] = "INVESTMENT_PROPERTY_RUNNING_COSTS";
    ExpenseTypes["SecondaryResidenceRunningCosts"] = "SECONDARY_RESIDENCE_RUNNING_COSTS";
    ExpenseTypes["Insurance"] = "INSURANCE";
    ExpenseTypes["LifeInsurance"] = "LIFE_INSURANCE";
    ExpenseTypes["HealthInsurance"] = "HEALTH_INSURANCE";
    ExpenseTypes["MedicalAndHealth"] = "MEDICAL_AND_HEALTH";
    ExpenseTypes["Rent"] = "RENT";
    ExpenseTypes["Board"] = "BOARD";
    ExpenseTypes["Other"] = "OTHER";
})(ExpenseTypes || (ExpenseTypes = {}));
//# sourceMappingURL=ExpenseTypes.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Frequency.js
var Frequency;
(function (Frequency) {
    Frequency["Fortnightly"] = "FORTNIGHTLY";
    Frequency["Monthly"] = "MONTHLY";
    Frequency["Quarterly"] = "QUARTERLY";
    Frequency["Weekly"] = "WEEKLY";
    Frequency["Yearly"] = "YEARLY";
})(Frequency || (Frequency = {}));
//# sourceMappingURL=Frequency.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/GovtBenefitTypes.js
var GovtBenefitTypes;
(function (GovtBenefitTypes) {
    GovtBenefitTypes["FamilyTax"] = "FAMILY_TAX";
    GovtBenefitTypes["AgePension"] = "AGE_PENSION";
    GovtBenefitTypes["DisabilitySupportPension"] = "DISABILITY_SUPPORT_PENSION";
    GovtBenefitTypes["Other"] = "OTHER";
})(GovtBenefitTypes || (GovtBenefitTypes = {}));
//# sourceMappingURL=GovtBenefitTypes.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/IncomeTypesAsset.js
var IncomeTypesAsset;
(function (IncomeTypesAsset) {
    IncomeTypesAsset["SelfEmployedBusinessIncome"] = "SELF_EMPLOYED_BUSINESS_INCOME";
    IncomeTypesAsset["RentalIncome"] = "RENTAL_INCOME";
    IncomeTypesAsset["InvestmentIncome"] = "INVESTMENT_INCOME";
})(IncomeTypesAsset || (IncomeTypesAsset = {}));
//# sourceMappingURL=IncomeTypesAsset.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/IncomeTypesGovt.js
var IncomeTypesGovt;
(function (IncomeTypesGovt) {
    IncomeTypesGovt["GovtBenefit"] = "GOVT_BENEFIT";
})(IncomeTypesGovt || (IncomeTypesGovt = {}));
//# sourceMappingURL=IncomeTypesGovt.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/IncomeTypesOthers.js
var IncomeTypesOthers;
(function (IncomeTypesOthers) {
    IncomeTypesOthers["SuperAnnuityPension"] = "SUPER_ANNUITY_PENSION";
    IncomeTypesOthers["WorkersCompensation"] = "WORKERS_COMPENSATION";
    IncomeTypesOthers["ForeignIncome"] = "FOREIGN_INCOME";
    IncomeTypesOthers["ChildMaintenance"] = "CHILD_MAINTENANCE";
    IncomeTypesOthers["CentrelinkBenefit"] = "CENTRELINK_BENEFIT";
    IncomeTypesOthers["OtherIncome"] = "OTHER_INCOME";
})(IncomeTypesOthers || (IncomeTypesOthers = {}));
//# sourceMappingURL=IncomeTypesOthers.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/IncomeTypesPayg.js
var IncomeTypesPayg;
(function (IncomeTypesPayg) {
    IncomeTypesPayg["BaseSalary"] = "PAYG_BASE_SALARY";
    IncomeTypesPayg["CommissionIncome"] = "PAYG_COMMISSION_INCOME";
    IncomeTypesPayg["BonusIncome"] = "PAYG_BONUS_INCOME";
    IncomeTypesPayg["OvertimeIncome"] = "PAYG_OVERTIME_INCOME";
    IncomeTypesPayg["CarAllowance"] = "PAYG_CAR_ALLOWANCE";
    IncomeTypesPayg["AllowancesTaxed"] = "PAYG_ALLOWANCES_TAXED";
    IncomeTypesPayg["AllowancesNotTaxed"] = "PAYG_ALLOWANCES_NOT_TAXED";
    IncomeTypesPayg["CompanyCar"] = "PAYG_COMPANY_CAR";
    IncomeTypesPayg["NonVoluntaryDeductionsPreTax"] = "PAYG_NON_VOLUNTARY_DEDUCTIONS_PRE_TAX";
    IncomeTypesPayg["SalarySacrifice"] = "PAYG_SALARY_SACRIFICE";
})(IncomeTypesPayg || (IncomeTypesPayg = {}));
//# sourceMappingURL=IncomeTypesPayg.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/IncomeTypesSelfEmployed.js
var IncomeTypesSelfEmployed;
(function (IncomeTypesSelfEmployed) {
    IncomeTypesSelfEmployed["SelfEmployedBusinessIncomeFullDoc"] = "SELF_EMPLOYED_BUSINESS_INCOME_FULL_DOC";
    IncomeTypesSelfEmployed["SelfEmployedBusinessIncomeLowDoc"] = "SELF_EMPLOYED_BUSINESS_INCOME_LOW_DOC";
})(IncomeTypesSelfEmployed || (IncomeTypesSelfEmployed = {}));
//# sourceMappingURL=IncomeTypesSelfEmployed.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Lenders.js
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var PARTNER_LENDERS_WITH_SHORTNAME = [
    { name: 'Adelaide Bank', shortName: 'ADE', id: 'adelaide_bank', isPartner: true },
    { name: 'AMP', shortName: 'AMP', id: 'amp', isPartner: true },
    { name: 'ANZ Bank', shortName: 'anz', id: 'anz_bank', isPartner: true },
    { name: 'Auswide Bank', shortName: 'auswide', id: 'auswide_bank', isPartner: true },
    { name: 'Bank Australia', shortName: 'BAU', id: 'bank_australia', isPartner: true },
    { name: 'Bank First', shortName: 'BF', id: 'bank_first', isPartner: true },
    { name: 'Bankwest', shortName: 'bankwest', id: 'bank_west', isPartner: true },
    { name: 'Bluebay Home Loans', shortName: 'BLB', id: 'bluebay_home_loans', isPartner: true },
    { name: 'Better Mortgage Mgmt', shortName: 'BMM', id: 'better_mortgage_mgmt', isPartner: true },
    { name: 'Bank of Melbourne', shortName: 'bom', id: 'bank_of_melbourne', isPartner: true },
    { name: 'Bank SA', shortName: 'BSA', id: 'bank_sa', isPartner: true },
    { name: 'Bluestone', shortName: 'BST', id: 'blue_stone', isPartner: true },
    { name: 'Commonwealth Bank', shortName: 'CBA', id: 'commonwealth_bank', isPartner: true },
    { name: 'Connective Home Loans', shortName: 'CHLA', id: 'connective_home_loans', isPartner: true },
    { name: 'Citibank', shortName: 'citibank', id: 'citi_bank', isPartner: true },
    { name: 'Click Loans', shortName: 'Click_loans', id: 'click_loans', isPartner: true },
    { name: 'Firstmac', shortName: 'FMC', id: 'first_mac', isPartner: true },
    { name: 'Gateway Bank', shortName: 'GCU', id: 'gateway_bank', isPartner: true },
    { name: 'Heritage', shortName: 'heritage', id: 'heritage', isPartner: true },
    { name: 'Better Choice', shortName: 'IDE', id: 'better_choice', isPartner: true },
    { name: 'ING', shortName: 'ing', id: 'ing', isPartner: true },
    { name: 'Laboratories Credit Union', shortName: 'LCU', id: 'laboratories_credit_union', isPartner: true },
    { name: 'LaTrobe', shortName: 'La_Trobe', id: 'la_trobe', isPartner: true },
    { name: 'Loanave', shortName: 'LOA', id: 'loanave', isPartner: true },
    { name: 'Macquarie', shortName: 'macquarie', id: 'macquarie', isPartner: true },
    { name: 'ME Bank', shortName: 'mebank', id: 'me_bank', isPartner: true },
    { name: 'MKM Capital', shortName: 'MKM', id: 'mkm_capital', isPartner: true },
    { name: 'My State Bank', shortName: 'mystate', id: 'my_state_bank', isPartner: true },
    { name: 'NAB', shortName: 'NAB', id: 'nab', isPartner: true },
    {
        name: 'Newcastle Permanent Building Society',
        shortName: 'newcastle',
        id: 'newcastle_permanent_building_society',
        isPartner: true,
    },
    { name: 'Paramount', shortName: 'PAM', id: 'paramount', isPartner: true },
    { name: 'Pepper', shortName: 'pepper', id: 'pepper', isPartner: true },
    { name: 'P&N Bank', shortName: 'pnbank', id: 'pn_bank', isPartner: true },
    { name: 'RESIMAC', shortName: 'Resimac', id: 'resimac', isPartner: true },
    { name: 'St George', shortName: 'stgeorge', id: 'st_george', isPartner: true },
    { name: 'Suncorp', shortName: 'suncorp', id: 'suncorp', isPartner: true },
    { name: 'Teachers Mutual', shortName: 'TMB', id: 'teachers_mutual', isPartner: true },
    { name: 'Virgin Money', shortName: 'VMY', id: 'virgin_money', isPartner: true },
    { name: 'Westpac Bank', shortName: 'Westpac', id: 'westpac_bank', isPartner: true },
    {
        name: 'Connective Home Loans Select ',
        shortName: 'CHLAB',
        id: 'connective_home_loans_select_adelaide',
        isPartner: true,
    },
];
var PARTNER_LENDERS_WITHOUT_SHORTNAME = [
    { name: 'Pacific Mortgage Group', shortName: '', id: 'pacific_mortgage_group', isPartner: true },
    { name: 'Gateway Credit Union', shortName: '', id: 'gateway_credit_union', isPartner: true },
];
var PARTNER_LENDERS = __spreadArrays(PARTNER_LENDERS_WITH_SHORTNAME, PARTNER_LENDERS_WITHOUT_SHORTNAME);
var NON_PARTNER_WITH_SHORTNAME = [
    { name: 'AAMI', shortName: 'AAMI', id: 'aami', isPartner: false },
    { name: 'AAPBS Settlements Services', shortName: 'AAPBS', id: 'aapbs_ settlements_services', isPartner: false },
    { name: 'Arab Bank of Australia', shortName: 'ABAL', id: 'arab_bank_of_australia', isPartner: false },
    { name: 'ABN AMRO', shortName: 'ABN AMRO', id: 'abn_amro', isPartner: false },
    { name: 'Australia Central Credit Union', shortName: 'ACCU', id: 'australia_central_credit_union', isPartner: false },
    {
        name: 'Australian Defence Credit Union',
        shortName: 'ADCU',
        id: 'australian_defence_credit_union',
        isPartner: false,
    },
    { name: 'Advantedge', shortName: 'Advantedge', id: 'advantedge', isPartner: false },
    { name: 'AFG Home Loans', shortName: 'AFG', id: 'afg_home_loans', isPartner: false },
    { name: 'Australian First Mortgage', shortName: 'AFM', id: 'australian_first_mortgage', isPartner: false },
    { name: 'Australian Military Bank', shortName: 'AMB', id: 'australian_military_bank', isPartner: false },
    { name: 'Australian Mortgage Options', shortName: 'AMO', id: 'australian_mortgage_options', isPartner: false },
    { name: 'AGC', shortName: 'AGC', id: 'agc', isPartner: false },
    { name: 'AIMS Home Loans', shortName: 'AIMS', id: 'aims', isPartner: false },
    { name: 'Allianz', shortName: 'ALV', id: 'allianz', isPartner: false },
    { name: 'AMG', shortName: 'AMG', id: 'amg', isPartner: false },
    { name: 'AMIC', shortName: 'AMIC', id: 'amic', isPartner: false },
    { name: 'AMIST', shortName: 'AMIST', id: 'amist', isPartner: false },
    { name: 'AMS', shortName: 'AMS', id: 'ams', isPartner: false },
    { name: 'Aon Master Trust', shortName: 'AON', id: 'aon_master_trust', isPartner: false },
    { name: 'API', shortName: 'API', id: 'api', isPartner: false },
    { name: 'Athena Home Loans', shortName: 'Athena', id: 'athena_home_loans', isPartner: false },
    {
        name: 'Australian Unity Building Society',
        shortName: 'AUBS',
        id: 'australian_unity_building_society',
        isPartner: false,
    },
    { name: 'Aussie Home Loans', shortName: 'Aussie', id: 'aussie_home_loans', isPartner: false },
    { name: 'AVCO', shortName: 'AVCO', id: 'avco', isPartner: false },
    { name: 'AWA Alliance Bank', shortName: 'AWA', id: 'awa_alliance_bank', isPartner: false },
    { name: 'AXA', shortName: 'AXA', id: 'axa', isPartner: false },
    { name: 'American Express', shortName: 'AMEX', id: 'american_express', isPartner: false },
    { name: 'Bank of America', shortName: 'BAC', id: 'bank_of_america', isPartner: false },
    { name: 'B&E', shortName: 'bande', id: 'bande', isPartner: false },
    { name: 'Bank mecu', shortName: 'bankmecu', id: 'bank_mecu', isPartner: false },
    { name: 'Bank of Sydney', shortName: 'banksyd', id: 'bank_of_sydney', isPartner: false },
    { name: 'Bank Vic', shortName: 'bankvic', id: 'bank_vic', isPartner: false },
    { name: 'Barclays', shortName: 'BARC', id: 'barclays', isPartner: false },
    { name: 'BCU', shortName: 'bcu', id: 'bcu', isPartner: false },
    { name: 'BDCU Alliance Bank', shortName: 'BDCUAB', id: 'bdcu_alliance_bank', isPartner: false },
    {
        name: 'Bass and Equitable Building Society',
        shortName: 'BEBS',
        id: 'bass_and_equitable_building_society',
        isPartner: false,
    },
    { name: 'Bendigo Bank', shortName: 'bendigo', id: 'bendigo_bank', isPartner: false },
    { name: 'Beyond Bank Australia', shortName: 'beyondbank', id: 'beyond_bank_australia', isPartner: false },
    {
        name: 'Broken Hill Community Credit Union',
        shortName: 'BHCCU',
        id: 'broken_hill_community_credit_union',
        isPartner: false,
    },
    { name: 'Bigsky Building Society', shortName: 'bigsky', id: 'bigsky_building_society', isPartner: false },
    { name: 'Better Mortgage Corporation', shortName: 'BMMC', id: 'better_mortgage_corporation', isPartner: false },
    { name: 'BMW Australia', shortName: 'BMW', id: 'bmw_australia', isPartner: false },
    { name: 'Banque Nationale De Paris', shortName: 'BNP', id: 'banque_nationale_de_paris', isPartner: false },
    { name: 'Bank of China', shortName: 'BOC', id: 'bank_of_china', isPartner: false },
    { name: 'Bank of Heritage Isle', shortName: 'BOCHI', id: 'bank_of_heritage_isle', isPartner: false },
    { name: 'Bank of Queensland', shortName: 'boq', id: 'bank_of_queensland', isPartner: false },
    { name: 'Bankers Trust Australia', shortName: 'BTA', id: 'bankers_trust_australia', isPartner: false },
    { name: 'BankVic', shortName: 'BV', id: 'bankvic', isPartner: false },
    { name: 'Mutual Community', shortName: 'Bupa', id: 'mutual_community', isPartner: false },
    { name: 'BUSSQ', shortName: 'BUSSQ', id: 'bussq', isPartner: false },
    { name: 'CBFC', shortName: 'CBFC', id: 'cbfc', isPartner: false },
    { name: 'CBUS', shortName: 'CBUS', id: 'cbus', isPartner: false },
    { name: 'Central West Credit Union', shortName: 'CWCU', id: 'central_west_credit_union', isPartner: false },
    { name: 'City Coast Credit Union', shortName: 'CCCU', id: 'city_coast_credit_union', isPartner: false },
    { name: 'Circle Credit Union', shortName: 'CCU', id: 'circle_credit_union', isPartner: false },
    { name: 'CGU', shortName: 'CGU', id: 'cgu', isPartner: false },
    { name: 'CHU', shortName: 'CHU', id: 'chu', isPartner: false },
    { name: 'CIC', shortName: 'CIC', id: 'cic', isPartner: false },
    { name: 'CIL', shortName: 'CIL', id: 'cil', isPartner: false },
    { name: 'Circle Alliance Bank', shortName: 'CAB', id: 'circle_alliance_bank', isPartner: false },
    { name: 'CIT Credit Pty', shortName: 'CIT', id: 'cit_credit_pty', isPartner: false },
    { name: 'Club Plus Super', shortName: 'CLB', id: 'clb_plus_super', isPartner: false },
    { name: 'Challenge Bank', shortName: 'CLG', id: 'challenge_bank', isPartner: false },
    {
        name: 'Community First Credit Union',
        shortName: 'communityfirst',
        id: 'comunity_first_credit_union',
        isPartner: false,
    },
    { name: 'Credit Union Australia', shortName: 'cua', id: 'credit_union_australia', isPartner: false },
    {
        name: 'Credit Union Financial Services',
        shortName: 'CUFS',
        id: 'credit_union_financial_services',
        isPartner: false,
    },
    { name: 'Coastline Credit Union', shortName: 'CUS', id: 'coastline_credit_union', isPartner: false },
    { name: 'Deutsche Bank', shortName: 'DBK', id: 'deutsche_bank', isPartner: false },
    { name: 'Diners Club', shortName: 'DCI', id: 'diners_club', isPartner: false },
    { name: 'Defence Bank', shortName: 'defencebank', id: 'defence_bank', isPartner: false },
    { name: 'ECU', shortName: 'ECU', id: 'ecu', isPartner: false },
    { name: 'EECU', shortName: 'EECU', id: 'eecu', isPartner: false },
    { name: 'Elders', shortName: 'EFP', id: 'elders', isPartner: false },
    { name: 'EISS', shortName: 'EISS', id: 'eiss', isPartner: false },
    { name: 'Fundcorp', shortName: 'FCI', id: 'fundcorp', isPartner: false },
    { name: 'Firefighters mutual bank', shortName: 'FMB', id: 'firefighters_mutual_bank', isPartner: false },
    { name: 'Genworth', shortName: 'Genworth', id: 'genworth', isPartner: false },
    { name: 'GIO', shortName: 'GIO', id: 'gio', isPartner: false },
    { name: 'Goldfields Money', shortName: 'goldfields_money', id: 'gmac_finance', isPartner: false },
    { name: 'Great Pacific Financial', shortName: 'GPF', id: 'great_pacific_financial', isPartner: false },
    { name: 'GRE', shortName: 'GRE', id: 'gre', isPartner: false },
    { name: 'Guild', shortName: 'Guild', id: 'guild', isPartner: false },
    { name: 'HBF', shortName: 'HBF', id: 'hbf', isPartner: false },
    { name: 'HESTA', shortName: 'Hesta', id: 'hesta', isPartner: false },
    { name: 'Holiday Coast Credit Union', shortName: 'HCCU', id: 'holiday_coast_credit_union', isPartner: false },
    { name: 'Homeloans Ltd', shortName: 'HLLC', id: 'homeloans_ltd', isPartner: false },
    { name: 'HSBC', shortName: 'hsbc', id: 'hsbc', isPartner: false },
    { name: 'Hume Building Society', shortName: 'Hume', id: 'hume_building_society', isPartner: false },
    { name: 'International Acceptance', shortName: 'IA', id: 'international_acceptance', isPartner: false },
    {
        name: 'International Commercial Bank of China',
        shortName: 'ICBC',
        id: 'international_commercial_bank_of_china',
        isPartner: false,
    },
    { name: 'IDEG', shortName: 'IDEG', id: 'ideg', isPartner: false },
    { name: 'Illawarra Credit Union', shortName: 'illawarra', id: 'illawarra_credit_union', isPartner: false },
    { name: 'IMB Ltd', shortName: 'imb', id: 'imb_ltd', isPartner: false },
    { name: 'ING Direct', shortName: 'INGC', id: 'ing_direct', isPartner: false },
    { name: 'IOOF Building Society', shortName: 'IOOF', id: 'ioof_building_society', isPartner: false },
    { name: 'Keystart Home Loans', shortName: 'Keystart', id: 'keystart_home_loans', isPartner: false },
    { name: 'Kwik Kash International', shortName: 'Kwik Kash', id: 'kwik_kash_international', isPartner: false },
    { name: 'Local Government', shortName: 'LGS', id: 'local_government', isPartner: false },
    { name: 'Liberty', shortName: 'liberty', id: 'liberty', isPartner: false },
    { name: 'Lombard Finance', shortName: 'Lombard', id: 'lombard_finance', isPartner: false },
    { name: 'LUCRF Super', shortName: 'LUCRF', id: 'lucrf_super', isPartner: false },
    { name: 'Macquarie Credit Union', shortName: 'macquariecu', id: 'macquarie_credit_union', isPartner: false },
    { name: 'MAP', shortName: 'MAP', id: 'map', isPartner: false },
    { name: 'Mediplan Australia', shortName: 'Mediplan', id: 'mediplan_australia', isPartner: false },
    { name: 'Mercantile Mutual', shortName: 'MERC', id: 'mercantile_mutual', isPartner: false },
    { name: 'Mercer Wealth', shortName: 'Mercer', id: 'mercer_wealth', isPartner: false },
    { name: 'Midland Bank PLC', shortName: 'Midland', id: 'midland_bank_plc', isPartner: false },
    { name: 'Mine Wealth and Wellbeing', shortName: 'Mine Super', id: 'mine_wealth_and_wellbeing', isPartner: false },
    { name: 'MIP', shortName: 'MIP', id: 'mip', isPartner: false },
    { name: 'MIS', shortName: 'MIS', id: 'mis', isPartner: false },
    { name: 'MLC', shortName: 'MLC', id: 'mlc', isPartner: false },
    { name: 'MMI', shortName: 'MMI', id: 'mmi', isPartner: false },
    { name: 'MTAA', shortName: 'MTAA', id: 'mtaa', isPartner: false },
    { name: 'My Credit Union', shortName: 'mycredit', id: 'my_credit_union', isPartner: false },
    { name: 'NSF Super', shortName: 'Nationwide', id: 'nsf_super', isPartner: false },
    { name: 'Natwest Markets Australia', shortName: 'Natwest', id: 'natwest_markets_australia', isPartner: false },
    { name: 'Northern Building Society', shortName: 'NBS', id: 'northern_building_society', isPartner: false },
    { name: 'Northern Inland Credit Union', shortName: 'NICU', id: 'northern_inland_credit_union', isPartner: false },
    { name: 'NGS', shortName: 'NGS', id: 'ngs', isPartner: false },
    { name: 'National Mortgage Company', shortName: 'nmc', id: 'national_mortgage_company', isPartner: false },
    { name: 'NRMA', shortName: 'NRMA', id: 'nrma', isPartner: false },
    { name: 'NZI', shortName: 'NZI', id: 'nzi', isPartner: false },
    {
        name: 'Overseas-Chinese Banking Corporation',
        shortName: 'OCBC Bank',
        id: 'overseas_chinese_banking_corporation',
        isPartner: false,
    },
    { name: 'Origin Finance', shortName: 'Origin', id: 'origin_finance', isPartner: false },
    { name: 'Origin MMS', shortName: 'OriginMMS', id: 'origin_mms', isPartner: false },
    {
        name: 'Pioneer Permanent Building Society',
        shortName: 'PBS',
        id: 'pioneer_permanent_building_society',
        isPartner: false,
    },
    {
        name: "People's Choice Credit Union",
        shortName: 'peopleschoicecu',
        id: 'peoples_choice_credit_union',
        isPartner: false,
    },
    { name: 'Perpetual Limited', shortName: 'Perpetual', id: 'perpetual_limited', isPartner: false },
    { name: 'Plum', shortName: 'Plum', id: 'plum', isPartner: false },
    { name: 'Police Credit Union', shortName: 'policecu', id: 'police_credit_union', isPartner: false },
    { name: 'QANTAS Credit Union', shortName: 'qantas', id: 'qantas_credit_union', isPartner: false },
    { name: 'QBE', shortName: 'QBE', id: 'qbe', isPartner: false },
    {
        name: 'Queensland Country Credit Union',
        shortName: 'QCCU',
        id: 'queensland_country_credit_union',
        isPartner: false,
    },
    { name: 'RAC', shortName: 'RAC', id: 'rac', isPartner: false },
    { name: 'RACV', shortName: 'RACV', id: 'racv', isPartner: false },
    { name: 'RAMS', shortName: 'rams', id: 'rams', isPartner: false },
    { name: 'Reserve Bank of Australia', shortName: 'RBA', id: 'reserve_bank_of_australia', isPartner: false },
    { name: 'REA Home Loans', shortName: 'REA', id: 'rea_home_loans', isPartner: false },
    { name: 'Safrock Finance', shortName: 'Safrock', id: 'safrock_finance', isPartner: false },
    { name: 'Suncorp Metway', shortName: 'SCMC', id: 'suncorp_metway', isPartner: false },
    { name: 'SGIC', shortName: 'SGIC', id: 'sgic', isPartner: false },
    { name: 'SGIO', shortName: 'SGIO', id: 'sgio', isPartner: false },
    {
        name: 'State Street Bank And Trust Company',
        shortName: 'state street',
        id: 'state_street_bank_and_trust_company',
        isPartner: false,
    },
    { name: 'Summerland Credit Union', shortName: 'Summerland', id: 'summerland_credit_union', isPartner: false },
    { name: 'Macarthur Credit Union', shortName: 'The MAC', id: 'macarthur_credit_union', isPartner: false },
    {
        name: 'Maitland Mutual Building Society',
        shortName: 'The Mutual',
        id: 'maitland_mutual_building_society',
        isPartner: false,
    },
    {
        name: 'Thinktank lending commercial finance',
        shortName: 'Thinktank',
        id: 'thinktank_lending_commercial_finance',
        isPartner: false,
    },
    { name: 'Tictoc Online', shortName: 'Tictoc', id: 'tictoc_online', isPartner: false },
    { name: 'Tic:Toc Home Loans', shortName: 'Tictoc', id: 'tictoc_home_loans', isPartner: false },
    { name: 'Trust Bank of Tasmania', shortName: 'Trust Bank', id: 'trust_bank_of_tasmania', isPartner: false },
    { name: 'Unibank', shortName: 'Uni', id: 'unibank', isPartner: false },
    { name: 'United Overseas Bank', shortName: 'UOB', id: 'united_overseas_bank', isPartner: false },
    {
        name: 'Victoria Teachers Credit Union Ltd',
        shortName: 'victeach',
        id: 'victeach_teachers_credit_union_ltd',
        isPartner: false,
    },
    { name: 'Credit Corp', shortName: 'CCFS', id: 'credit_corp', isPartner: false },
    { name: 'Credit Union SA', shortName: 'CUSA', id: 'credit_union_sa', isPartner: false },
    { name: 'Family First Credit Union', shortName: 'FFCU', id: 'family_first_credit_union', isPartner: false },
    { name: 'Fox Symes', shortName: 'FS', id: 'fox_symes', isPartner: false },
    { name: 'Freedom Lend', shortName: 'FL', id: 'freedom_lend', isPartner: false },
    { name: 'Lysaght Credit Union', shortName: 'LCU', id: 'lysaght_credit_union', isPartner: false },
    { name: 'Police Credit Union (NSW)', shortName: 'policecu', id: 'police_credit_union_nsw', isPartner: false },
    { name: 'The Rock', shortName: 'RBS', id: 'the_rock', isPartner: false },
    { name: 'Zip Co', shortName: 'Zip', id: 'zip', isPartner: false },
    { name: 'Plenti', shortName: 'Plenti', id: 'plenti', isPartner: false },
    { name: 'Latitude Financial', shortName: 'Latitude', id: 'latitude', isPartner: false },
    { name: 'Cash Converters', shortName: 'Cash Converters', id: 'cash_converters', isPartner: false },
    { name: 'Nimble', shortName: 'Nimble', id: 'nimble', isPartner: false },
    { name: 'SocietyOne', shortName: 'SocietyOne', id: 'societyone', isPartner: false },
    { name: 'MoneyMe', shortName: 'mme', id: 'moneyme', isPartner: false },
    { name: 'Harmoney', shortName: 'Harmoney', id: 'harmoney', isPartner: false },
    { name: 'Afterpay', shortName: 'Afterpay', id: 'afterpay', isPartner: false },
    {
        name: 'Australian Pensioners Insurance',
        shortName: 'API',
        id: 'australian_pensioners_insurance',
        isPartner: false,
    },
    { name: 'Cash Converters ', shortName: 'Cash Converters', id: 'cash_converters_', isPartner: false },
    { name: 'Iden Group', shortName: 'Iden', id: 'iden_group', isPartner: false },
    { name: 'Members Equity Bank', shortName: 'ME Bank', id: 'members_equity_bank', isPartner: false },
    { name: 'National Mortgage Corporation', shortName: 'NMC', id: 'national_mortgage_corporation', isPartner: false },
    { name: 'Queensland Credit Union', shortName: 'QCU', id: 'queensland_credit_union', isPartner: false },
    {
        name: 'Queensland Professional Credit Union',
        shortName: 'QPCU',
        id: 'queensland_professional_credit_union',
        isPartner: false,
    },
    { name: 'Think Tank Group Pty Ltd', shortName: 'Think Tank', id: 'think_tank_group_pty_ltd', isPartner: false },
    {
        name: 'Volkswagon Financial Services',
        shortName: 'VW Finance',
        id: 'volkswagon_financial_services',
        isPartner: false,
    },
    { name: 'Zip Co', shortName: 'zip', id: 'zip_co', isPartner: false },
];
var NON_PARTNER_WITHOUT_SHORTNAME = [
    { name: 'CommBank Financial Planner', shortName: '', id: 'commBank_financial_planner', isPartner: false },
    { name: 'Homeloans.com.au', shortName: '', id: 'homeloans_com_au', isPartner: false },
    { name: 'Horizon Bank', shortName: '', id: 'horizon_bank', isPartner: false },
    { name: 'Loans.com.au', shortName: '', id: 'loans_com_au', isPartner: false },
    { name: 'Nova Alliance Bank', shortName: '', id: 'nova_alliance_bank', isPartner: false },
    { name: 'QBank', shortName: '', id: 'qbank', isPartner: false },
    { name: 'Reduce', shortName: '', id: 'reduce', isPartner: false },
    { name: 'Regional Australia Bank', shortName: '', id: 'regional_australia_bank', isPartner: false },
    { name: 'Unity Bank', shortName: '', id: 'unity_bank', isPartner: false },
    { name: 'Allstate Home Loans', shortName: '', id: 'allstate_home_loans', isPartner: false },
    { name: 'ANZ Wealth', shortName: '', id: 'anz_wealth', isPartner: false },
    { name: 'Armidale Building Society', shortName: '', id: 'armidale_building_society', isPartner: false },
    { name: 'Asahi Bank', shortName: '', id: 'asahi_bank', isPartner: false },
    { name: 'Assured', shortName: '', id: 'assured', isPartner: false },
    { name: 'Athena', shortName: '', id: 'athena', isPartner: false },
    { name: 'Aussie Mastercard', shortName: '', id: 'aussie_mastercard', isPartner: false },
    { name: 'Aussie Mortgage Ltd', shortName: '', id: 'aussie_mortgage', isPartner: false },
    { name: 'Aust Alliance', shortName: '', id: 'aust_alliance', isPartner: false },
    { name: 'Austral Mortgage', shortName: '', id: 'austral_mortgage', isPartner: false },
    { name: 'Australian Ethical', shortName: '', id: 'australian _ethical', isPartner: false },
    { name: 'AustralianSuper', shortName: '', id: 'australian_super', isPartner: false },
    { name: 'AustSafe', shortName: '', id: 'aust_safe', isPartner: false },
    { name: 'Australian Catholic', shortName: '', id: 'australian_catholic', isPartner: false },
    { name: 'Australian Eagle', shortName: '', id: 'australian_eagle', isPartner: false },
    { name: 'AV Super', shortName: '', id: 'av_super', isPartner: false },
    { name: 'Bank of Tokyo-Mitsubishi', shortName: '', id: 'bank_of_tokyo_mitsubishi', isPartner: false },
    { name: 'Barnes Home Loans', shortName: '', id: 'barnes_home_loans', isPartner: false },
    { name: 'Brighten Home Loans', shortName: '', id: 'brighten_ome_loans', isPartner: false },
    { name: 'Building Society MP', shortName: '', id: 'building_society_mp', isPartner: false },
    { name: 'Buyers Edge', shortName: '', id: 'buyers_edge', isPartner: false },
    { name: 'Capital Finance', shortName: '', id: 'capital_finance', isPartner: false },
    { name: 'Capricornia Credit Union', shortName: '', id: 'capricornia_credit_union', isPartner: false },
    { name: 'CareSuper', shortName: '', id: 'care_super', isPartner: false },
    { name: 'Cash Doctors', shortName: '', id: 'cash_doctors', isPartner: false },
    { name: 'Catalyst Money', shortName: '', id: 'catalyst_money', isPartner: false },
    { name: 'Catholic Church', shortName: '', id: 'catholic_church', isPartner: false },
    { name: 'Catholic Super', shortName: '', id: 'catholic_super', isPartner: false },
    { name: 'Certegy', shortName: '', id: 'certegy', isPartner: false },
    { name: 'Chase Manhattan Bank', shortName: '', id: 'chase_manhattan_bank', isPartner: false },
    { name: 'Chequecash Pty Ltd', shortName: '', id: 'chequecash_pty_ltd', isPartner: false },
    { name: 'ChoiceLend', shortName: '', id: 'choiceLend', isPartner: false },
    { name: 'Christian Super', shortName: '', id: 'christian_super', isPartner: false },
    { name: 'Citywide Home Loans', shortName: '', id: 'citywide_home_loans', isPartner: false },
    { name: 'Co Operative Ins Co', shortName: '', id: 'co_operative_ins_co', isPartner: false },
    { name: 'Colonial First State', shortName: '', id: 'colonial_first_state', isPartner: false },
    { name: 'Colonial Mutual', shortName: '', id: 'colonial_mutual', isPartner: false },
    { name: 'Colonial', shortName: '', id: 'colonial', isPartner: false },
    { name: 'Commercial Union', shortName: '', id: 'commercial_union', isPartner: false },
    { name: 'CommInsure', shortName: '', id: 'commInsure', isPartner: false },
    { name: 'CPS Credit Union', shortName: '', id: 'cps_ credit Union', isPartner: false },
    { name: 'Credit Union Settlement Services', shortName: '', id: 'credit_union_settlement_services', isPartner: false },
    { name: 'Cumis', shortName: '', id: 'cumis', isPartner: false },
    { name: 'Cuscal', shortName: '', id: 'Cuscal', isPartner: false },
    { name: 'Custom Credit', shortName: '', id: 'custom_credit', isPartner: false },
    { name: 'Dai-Ichi Kango Bank', shortName: '', id: 'dai_ichi_kango_bank', isPartner: false },
    { name: 'Daimlerchrysler Finance', shortName: '', id: 'daimlerchrysler_finance', isPartner: false },
    { name: 'Debt Purchase Australia', shortName: '', id: 'debt_purchase_australia', isPartner: false },
    { name: 'Defence Credit', shortName: '', id: 'defence_credit', isPartner: false },
    {
        name: 'Defence Force Credit Union Limited',
        shortName: '',
        id: 'defence_force_credit_union_limited',
        isPartner: false,
    },
    { name: 'Defence Services Homes', shortName: '', id: 'defence_services_homes', isPartner: false },
    { name: 'Delphi Bank', shortName: '', id: 'delphi_bank', isPartner: false },
    {
        name: 'Dnister Ukrainian Credit Co-operative',
        shortName: '',
        id: 'dnister_ukrainian_credit_co_operative',
        isPartner: false,
    },
    { name: 'Easy Street Financial Services', shortName: '', id: 'easy_street_financial_services', isPartner: false },
    { name: 'ELCOM Credit Union', shortName: '', id: 'elcom_credit_union', isPartner: false },
    { name: 'Energy Super', shortName: '', id: 'energy_super', isPartner: false },
    { name: 'Equity Super', shortName: '', id: 'equity_super', isPartner: false },
    { name: 'Esanda', shortName: '', id: 'esanda', isPartner: false },
    { name: 'Essential Super', shortName: '', id: 'essential_super', isPartner: false },
    { name: 'Ezy Bank', shortName: '', id: 'ezy_bank', isPartner: false },
    { name: 'FAI', shortName: '', id: 'fai', isPartner: false },
    { name: 'FASTLend', shortName: '', id: 'fastlend', isPartner: false },
    { name: 'Federation', shortName: '', id: 'federation', isPartner: false },
    { name: 'FinancePath', shortName: '', id: 'finance_path', isPartner: false },
    { name: 'Fire Brigades Credit Union', shortName: '', id: 'fire_brigades_credit_union', isPartner: false },
    { name: 'Fire Service Credit Union', shortName: '', id: 'fire_service_credit_union', isPartner: false },
    { name: 'First Choice Credit Union', shortName: '', id: 'first_choice_credit_union', isPartner: false },
    { name: 'First National Bank of Chicago', shortName: '', id: 'first_national_bank_of_chicago', isPartner: false },
    { name: 'First Option Bank', shortName: '', id: 'first_option_bank', isPartner: false },
    { name: 'First Permanent Home Loans', shortName: '', id: 'first_permanent_home_loans', isPartner: false },
    {
        name: 'First Provincial Building Society',
        shortName: '',
        id: 'first_provincial_building_society',
        isPartner: false,
    },
    { name: 'First State Super', shortName: '', id: 'first_state_super', isPartner: false },
    { name: 'First Super', shortName: '', id: 'first_super', isPartner: false },
    { name: 'Flexirent', shortName: '', id: 'flexirent', isPartner: false },
    { name: 'Ford Credit', shortName: '', id: 'ford_credit', isPartner: false },
    { name: 'Fortis', shortName: '', id: 'fortis', isPartner: false },
    { name: 'Future Financial', shortName: '', id: 'future_financial', isPartner: false },
    { name: 'G&C Mutual Bank', shortName: '', id: 'gc_mutual_bank', isPartner: false },
    { name: 'GE Automotive', shortName: '', id: 'ge_automotive', isPartner: false },
    {
        name: 'GE Capital Finance (Go Mastercard)',
        shortName: '',
        id: 'ge_capital_finance_go_mastercard',
        isPartner: false,
    },
    { name: 'GE Capital Finance', shortName: '', id: 'ge_capital_finance', isPartner: false },
    { name: 'GE Credit Line', shortName: '', id: 'ge_credit_line', isPartner: false },
    { name: 'Ge Finance', shortName: '', id: 'ge_finance', isPartner: false },
    { name: 'GE Money Aust Pty Ltd', shortName: '', id: 'ge_money_aust_pty_ltd', isPartner: false },
    { name: 'GE Mortgages', shortName: '', id: 'ge_mortgages', isPartner: false },
    { name: 'Geelong Bank', shortName: '', id: 'geelong_bank', isPartner: false },
    { name: 'GIO Building Society', shortName: '', id: 'gio_building_society', isPartner: false },
    { name: 'Grace Bros', shortName: '', id: 'grace_bros', isPartner: false },
    { name: 'Greater Building Society', shortName: '', id: 'greater_building_society', isPartner: false },
    { name: 'Hanover Consumer Finance', shortName: '', id: 'hanover_consumer_finance', isPartner: false },
    { name: 'Home Building Society', shortName: '', id: 'home_building_society', isPartner: false },
    { name: 'Homeside', shortName: '', id: 'homeside', isPartner: false },
    { name: 'Homestar Finance', shortName: '', id: 'homestar_finance', isPartner: false },
    { name: 'Homestart Finance', shortName: '', id: 'homestart_finance', isPartner: false },
    { name: 'Homeswest', shortName: '', id: 'homeswest', isPartner: false },
    { name: 'Hunter United', shortName: '', id: 'hunter_united', isPartner: false },
    { name: 'IBJ Australia Bank', shortName: '', id: 'ibj_australia_bank', isPartner: false },
    { name: 'Ignite', shortName: '', id: 'ignite', isPartner: false },
    { name: 'Illawarra Building Society', shortName: '', id: 'illawarra_building_society', isPartner: false },
    { name: 'INC Invest', shortName: '', id: 'inc_invest', isPartner: false },
    { name: 'ING Mercantile Mutual Bank', shortName: '', id: 'ing_mercantile_mutual_bank', isPartner: false },
    { name: 'Intech Credit Union', shortName: '', id: 'intech_credit_union', isPartner: false },
    { name: 'InTrust', shortName: '', id: 'in_trust', isPartner: false },
    { name: 'Investec', shortName: '', id: 'investec', isPartner: false },
    { name: 'Kinetic', shortName: '', id: 'kinetic', isPartner: false },
    { name: 'Legal Super', shortName: '', id: 'legal_super', isPartner: false },
    { name: 'Lion Finance', shortName: '', id: 'lion_finance', isPartner: false },
    { name: 'M Capitol', shortName: '', id: 'm_capitol', isPartner: false },
    {
        name: 'Mackay Permanent Building Society',
        shortName: '',
        id: 'mackay_permanent_building_society',
        isPartner: false,
    },
    { name: 'Manufacture Mutual', shortName: '', id: 'manufacture_mutual', isPartner: false },
    { name: 'Media Super', shortName: '', id: 'media_super', isPartner: false },
    { name: 'Mitchell Building Society', shortName: '', id: 'mitchell_building_society', isPartner: false },
    {
        name: 'Morgan Guaranty Trust Bank of New York',
        shortName: '',
        id: 'morgan_guaranty_trust_bank_of_new_york',
        isPartner: false,
    },
    { name: 'Mortgage Choice', shortName: '', id: 'mortgage_choice', isPartner: false },
    { name: 'Mortgage Ezy', shortName: '', id: 'mortgage_ezy', isPartner: false },
    { name: 'Mortgage House', shortName: '', id: 'mortgage_house', isPartner: false },
    { name: 'Mortgage Mart', shortName: '', id: 'mortgage_mart', isPartner: false },
    { name: 'Mortgageport', shortName: '', id: 'mortgageport', isPartner: false },
    { name: 'MOVE Bank', shortName: '', id: 'move_bank', isPartner: false },
    { name: 'NCUIS', shortName: '', id: 'ncuis', isPartner: false },
    { name: 'NSW Home Loans', shortName: '', id: 'new_home_loans', isPartner: false },
    { name: 'NSW Teachers Credit Union', shortName: '', id: 'new__teachers_credit_union', isPartner: false },
    { name: 'OneAnswer', shortName: '', id: 'one_answer', isPartner: false },
    { name: 'Orange Credit Union', shortName: '', id: 'orange_credit_union', isPartner: false },
    { name: 'Other', shortName: '', id: 'other', isPartner: false },
    { name: 'Payday Central', shortName: '', id: 'payday_central', isPartner: false },
    { name: 'Pensioners Insurance', shortName: '', id: 'pensioners_insurance', isPartner: false },
    { name: 'Perpetual Trustee', shortName: '', id: 'perpetual_trustee', isPartner: false },
    { name: 'PLANLend', shortName: '', id: 'planlend', isPartner: false },
    { name: 'Police and Nurses', shortName: '', id: 'police_and_nurses', isPartner: false },
    { name: 'Police Bank', shortName: '', id: 'police_bank', isPartner: false },
    { name: 'Powerstate Credit Union', shortName: '', id: 'powerstate_credit_union', isPartner: false },
    {
        name: 'Primary Industry Bank of Australia',
        shortName: '',
        id: 'primary_industry_bank_of_australia',
        isPartner: false,
    },
    { name: 'Prime', shortName: '', id: 'prime', isPartner: false },
    { name: 'Prospect Credit Union', shortName: '', id: 'prospect_credit_union', isPartner: false },
    { name: 'Public Trustee', shortName: '', id: 'public_trustee', isPartner: false },
    { name: 'Pulse Credit Union', shortName: '', id: 'pulse_credit_union', isPartner: false },
    { name: 'Qudos Bank', shortName: '', id: 'qudos_bank', isPartner: false },
    {
        name: 'Queensland Industry Development Corp',
        shortName: '',
        id: 'queensland_industry_development_corp',
        isPartner: false,
    },
    { name: 'Queensland Teachers Credit Union', shortName: '', id: 'queensland_teachers_credit_union', isPartner: false },
    { name: 'Queenslanders Credit Union', shortName: '', id: 'queenslanders_credit_union', isPartner: false },
    { name: 'RAC WA', shortName: '', id: 'rac_wa', isPartner: false },
    { name: 'RACQ Bank', shortName: '', id: 'racq_bank', isPartner: false },
    { name: 'Radio Rentals', shortName: '', id: 'radio_rentals', isPartner: false },
    { name: 'Railways Credit Union', shortName: '', id: 'railways_credit_union', isPartner: false },
    { name: 'Repcol', shortName: '', id: 'repcol', isPartner: false },
    { name: 'RESI Mortgage Corporation', shortName: '', id: 'resi_mortgage_corporation,', isPartner: false },
    { name: 'Resi', shortName: '', id: 'resi,', isPartner: false },
    { name: 'Royal Life', shortName: '', id: 'royal_life,', isPartner: false },
    { name: 'Russell Investments', shortName: '', id: 'russell_investments', isPartner: false },
    { name: 'Sanwa Australia Finance Limited', shortName: '', id: 'Sanwa Australia Finance Limited', isPartner: false },
    { name: 'Savings And Loans Credit Union', shortName: '', id: 'savings_and_loans_credit_union', isPartner: false },
    { name: 'SCU', shortName: '', id: 'scu', isPartner: false },
    { name: 'Service One Alliance Bank', shortName: '', id: 'service_one_alliance_bank', isPartner: false },
    { name: 'Shannons', shortName: '', id: 'shannons', isPartner: false },
    { name: 'SmartSave', shortName: '', id: 'smart_save', isPartner: false },
    { name: 'Southern Cross Credit Union', shortName: '', id: 'southern_cross_credit_union', isPartner: false },
    { name: 'Sovereign Credit', shortName: '', id: 'sovereign_credit', isPartner: false },
    { name: 'St Andrew', shortName: '', id: 'st_andrew', isPartner: false },
    { name: 'Standard Chartered Bank Aust', shortName: '', id: 'standard_chartered_bank_aust', isPartner: false },
    { name: 'State Custodians', shortName: '', id: 'state_custodians', isPartner: false },
    { name: 'Statewide', shortName: '', id: 'statewide', isPartner: false },
    { name: 'Stronghold', shortName: '', id: 'stronghold', isPartner: false },
    { name: 'Sun Alliance', shortName: '', id: 'sun_alliance', isPartner: false },
    { name: 'Sunsuper', shortName: '', id: 'sunsuper', isPartner: false },
    { name: 'Swann', shortName: '', id: 'swann', isPartner: false },
    { name: 'TasPlan', shortName: '', id: 'tas_plan', isPartner: false },
    { name: 'Teachers Credit Union', shortName: '', id: 'teachers_credit_union', isPartner: false },
    {
        name: 'Territory Mutual Building Society',
        shortName: '',
        id: 'territory_mutual_building_society',
        isPartner: false,
    },
    { name: 'The Capricornia', shortName: '', id: 'the_capricornia', isPartner: false },
    { name: 'The Mac', shortName: '', id: 'the_mac', isPartner: false },
    { name: 'The Mutual Bank', shortName: '', id: 'the_mutual_bank', isPartner: false },
    { name: 'Tonto Home Loans', shortName: '', id: 'tonto_home_loans', isPartner: false },
    { name: 'Town And Country Bank', shortName: '', id: 'town_and_country_bank', isPartner: false },
    { name: 'Toyota Finance Australia', shortName: '', id: 'toyota_finance_australia', isPartner: false },
    { name: 'Transport Mutual Credit Union', shortName: '', id: 'transport_mutual_credit_union', isPartner: false },
    { name: 'TWUSUPER', shortName: '', id: 'twusuper', isPartner: false },
    { name: 'UBank', shortName: '', id: 'ubank', isPartner: false },
    { name: 'United Credit Union', shortName: '', id: 'united_credit_union', isPartner: false },
    { name: 'University Credit Society', shortName: '', id: 'university_credit_society', isPartner: false },
    { name: 'VACC', shortName: '', id: 'vacc', isPartner: false },
    { name: 'Vero', shortName: '', id: 'vero', isPartner: false },
    { name: 'VicSuper', shortName: '', id: 'vic_super', isPartner: false },
    { name: 'Virgin Super', shortName: '', id: 'virgin_super', isPartner: false },
    { name: 'Visions', shortName: '', id: 'visions', isPartner: false },
    { name: 'Western QBE', shortName: '', id: 'western_qbe', isPartner: false },
    { name: 'Westfarmers', shortName: '', id: 'westfarmers', isPartner: false },
    { name: 'Westpack Insurance Services', shortName: '', id: 'westpack_insurance_services', isPartner: false },
    {
        name: 'Wide Bay Capricorn Building Society',
        shortName: '',
        id: 'wide_bay_capricorn_building_society',
        isPartner: false,
    },
    { name: 'Wizard', shortName: '', id: 'wizard', isPartner: false },
    {
        name: 'Woolworths Employees Credit Union',
        shortName: '',
        id: 'woolworths_employees_credit_union',
        isPartner: false,
    },
    { name: 'ANZ Asset Finance', shortName: '', id: 'anz_asset_finance', isPartner: false },
    { name: 'Nab Broker', shortName: '', id: 'nab_broker', isPartner: false },
    { name: 'PNC Financial services', shortName: '', id: 'pnc_financial_services', isPartner: false },
    { name: 'World Marine and General', shortName: '', id: 'world_marine_and_general', isPartner: false },
    { name: 'Xinja', shortName: '', id: 'xinjia', isPartner: false },
    { name: 'Yellow Brick Road', shortName: '', id: 'yellow_brick_road', isPartner: false },
    { name: 'Zurich', shortName: '', id: 'zurich', isPartner: false },
    { name: 'Volt', shortName: '', id: 'volt', isPartner: false },
    { name: 'BNK', shortName: '', id: 'BNK', isPartner: false },
    { name: '86 400', shortName: '', id: '86_400', isPartner: false },
    { name: 'ADCU', shortName: '', id: 'adcu', isPartner: false },
    { name: 'AFG Advantedge', shortName: '', id: 'afg_advantedge', isPartner: false },
    { name: 'AFM', shortName: '', id: 'afm', isPartner: false },
    { name: 'Ample Capital Australia', shortName: '', id: 'ample_capital_australia', isPartner: false },
    { name: 'Anchorage', shortName: '', id: 'anchorage', isPartner: false },
    { name: 'ANZ Asset Finance ', shortName: '', id: 'anz_asset_finance_', isPartner: false },
    { name: 'AUL', shortName: '', id: 'aul', isPartner: false },
    {
        name: 'Australian Financial Holdings Pty Ltd',
        shortName: '',
        id: 'australian_financial_holdings_pty_ltd',
        isPartner: false,
    },
    { name: 'Australian Lending Services', shortName: '', id: 'australian_lending_services', isPartner: false },
    { name: 'Australian Wholesale Lending', shortName: '', id: 'australian_wholesale_lending', isPartner: false },
    { name: 'Bank of South Australia', shortName: '', id: 'bank_of_south_australia', isPartner: false },
    { name: 'Banksia', shortName: '', id: 'banksia', isPartner: false },
    { name: 'BCHL', shortName: '', id: 'bchl', isPartner: false },
    { name: 'Bluegum', shortName: '', id: 'bluegum', isPartner: false },
    { name: 'BMC', shortName: '', id: 'bmc', isPartner: false },
    { name: 'BMC Advantedge', shortName: '', id: 'bmc_advantedge', isPartner: false },
    { name: 'CACU', shortName: '', id: 'cacu', isPartner: false },
    { name: 'Coles Financial Services', shortName: '', id: 'coles_financial_services', isPartner: false },
    { name: 'Collins Securities', shortName: '', id: 'collins_securities', isPartner: false },
    { name: 'Columbus Capital Pty Ltd', shortName: '', id: 'columbus_capital_pty_ltd', isPartner: false },
    { name: 'Community CPS Australia ', shortName: '', id: 'community_cps_australia_', isPartner: false },
    { name: 'Community Mutual Ltd', shortName: '', id: 'community_mutual_ltd', isPartner: false },
    { name: 'Credit Union Home Loans', shortName: '', id: 'credit_union_home_loans', isPartner: false },
    { name: 'Direct Mortgage Solutions', shortName: '', id: 'direct_mortgage_solutions', isPartner: false },
    { name: 'Director of Housing VIC ', shortName: '', id: 'director_of_housing_vic_', isPartner: false },
    { name: 'Domain', shortName: '', id: 'domain', isPartner: false },
    { name: 'Economy', shortName: '', id: 'economy', isPartner: false },
    { name: 'eMoney', shortName: '', id: 'emoney', isPartner: false },
    { name: 'Ezy Mortgage', shortName: '', id: 'ezy_mortgage', isPartner: false },
    { name: 'Faraday West and Co Pty Ltd', shortName: '', id: 'faraday_west_and_co_pty_ltd', isPartner: false },
    { name: 'Fifty Group', shortName: '', id: 'fifty_group', isPartner: false },
    { name: 'Finance Express Home Loans', shortName: '', id: 'finance_express_home_loans', isPartner: false },
    { name: 'First Folio', shortName: '', id: 'first_folio', isPartner: false },
    { name: 'Firstmac', shortName: '', id: 'firstmac', isPartner: false },
    { name: 'Fleet Partners Auto Loan', shortName: '', id: 'fleet_partners_auto_loan', isPartner: false },
    { name: 'FlexiGroup', shortName: '', id: 'flexigroup', isPartner: false },
    { name: 'Good Shepherd Microfinance', shortName: '', id: 'good_shepherd_microfinance', isPartner: false },
    { name: 'Great Southern Loans', shortName: '', id: 'great_southern_loans', isPartner: false },
    { name: 'Greater Bank Ltd', shortName: '', id: 'greater_bank_ltd', isPartner: false },
    { name: 'Harmoney Australia', shortName: '', id: 'harmoney_australia', isPartner: false },
    { name: 'HBS', shortName: '', id: 'hbs', isPartner: false },
    { name: 'Hemisphere', shortName: '', id: 'hemisphere', isPartner: false },
    { name: 'Homeloan Centre Australia', shortName: '', id: 'homeloan_centre_australia', isPartner: false },
    { name: 'HomePath', shortName: '', id: 'homepath', isPartner: false },
    { name: 'HostPlus', shortName: '', id: 'hostplus', isPartner: false },
    { name: 'Humm', shortName: '', id: 'humm', isPartner: false },
    { name: 'Infiniti Finservices Australia', shortName: '', id: 'infiniti_finservices_australia', isPartner: false },
    { name: 'JetStar Credit Cards', shortName: '', id: 'jetstar_credit_cards', isPartner: false },
    { name: 'Latitude Finance Australia', shortName: '', id: 'latitude_finance_australia', isPartner: false },
    { name: 'LoanMarket Advantedge', shortName: '', id: 'loanmarket_advantedge', isPartner: false },
    { name: 'LoanPlan', shortName: '', id: 'loanplan', isPartner: false },
    { name: 'Maxxia', shortName: '', id: 'maxxia', isPartner: false },
    { name: 'MCCA', shortName: '', id: 'mcca', isPartner: false },
    { name: 'Mercedez-Benz Financial Services', shortName: '', id: 'mercedez-benz_financial_services', isPartner: false },
    { name: 'MIIP', shortName: '', id: 'miip', isPartner: false },
    { name: 'Mitsubishi', shortName: '', id: 'mitsubishi', isPartner: false },
    { name: 'Money Quest Australia Pty Ltd', shortName: '', id: 'money_quest_australia_pty_ltd', isPartner: false },
    { name: 'MoneyPlace AFSL', shortName: '', id: 'moneyplace_afsl', isPartner: false },
    { name: 'MSL', shortName: '', id: 'msl', isPartner: false },
    { name: 'Myer Credit Cards', shortName: '', id: 'myer_credit_cards', isPartner: false },
    { name: 'MyOzMoney', shortName: '', id: 'myozmoney', isPartner: false },
    { name: 'Napiers', shortName: '', id: 'napiers', isPartner: false },
    { name: 'NCF Financial Services PtyLtd', shortName: '', id: 'ncf_financial_services_ptyltd', isPartner: false },
    { name: 'NFC', shortName: '', id: 'nfc', isPartner: false },
    { name: 'NHL', shortName: '', id: 'nhl', isPartner: false },
    { name: 'Nissan Financial Services', shortName: '', id: 'nissan_financial_services', isPartner: false },
    { name: 'NMMC', shortName: '', id: 'nmmc', isPartner: false },
    { name: 'Now Finance', shortName: '', id: 'now_finance', isPartner: false },
    { name: 'OFG', shortName: '', id: 'ofg', isPartner: false },
    { name: 'ORIX', shortName: '', id: 'orix', isPartner: false },
    { name: 'Paladin', shortName: '', id: 'paladin', isPartner: false },
    { name: 'Pioneer Credit Ltd', shortName: '', id: 'pioneer_credit_ltd', isPartner: false },
    { name: 'PNCS', shortName: '', id: 'pncs', isPartner: false },
    { name: 'Power Home Loans', shortName: '', id: 'power_home_loans', isPartner: false },
    { name: 'Rate Money Pty Ltd', shortName: '', id: 'rate_money_pty_ltd', isPartner: false },
    { name: 'RedZed', shortName: '', id: 'redzed', isPartner: false },
    { name: 'Renault Finance ', shortName: '', id: 'renault_finance_', isPartner: false },
    { name: 'Residential Mortgage Group', shortName: '', id: 'residential_mortgage_group', isPartner: false },
    { name: 'RHG', shortName: '', id: 'rhg', isPartner: false },
    { name: 'Sam Loans', shortName: '', id: 'sam_loans', isPartner: false },
    { name: 'Sandhurst Trustees', shortName: '', id: 'sandhurst_trustees', isPartner: false },
    { name: 'SGE Credit Union', shortName: '', id: 'sge_credit_union', isPartner: false },
    { name: 'Skyline Car Finance', shortName: '', id: 'skyline_car_finance', isPartner: false },
    { name: 'Smartline', shortName: '', id: 'smartline', isPartner: false },
    { name: 'Society One Australia', shortName: '', id: 'society_one_australia', isPartner: false },
    { name: 'Southland Building Society', shortName: '', id: 'southland_building_society', isPartner: false },
    { name: 'Sydney Home Loans', shortName: '', id: 'sydney_home_loans', isPartner: false },
    { name: 'Symple Loans Australia', shortName: '', id: 'symple_loans_australia', isPartner: false },
    { name: 'The Co-operative Bank', shortName: '', id: 'the_co-operative_bank', isPartner: false },
    { name: 'ThinkMe Finance', shortName: '', id: 'thinkme_finance', isPartner: false },
    { name: 'VTMB', shortName: '', id: 'vtmb', isPartner: false },
    { name: 'Wisr Finance Pty Ltd', shortName: '', id: 'wisr_finance_pty_ltd', isPartner: false },
    { name: 'Woolworths', shortName: '', id: 'woolworths', isPartner: false },
    { name: 'World Home Loans', shortName: '', id: 'world_home_loans', isPartner: false },
    { name: 'Yes Home Loans', shortName: '', id: 'yes_home_loans', isPartner: false },
    { name: 'Your Manager', shortName: '', id: 'your_manager', isPartner: false },
];
var NON_PARTNER_LENDERS = __spreadArrays(NON_PARTNER_WITH_SHORTNAME, NON_PARTNER_WITHOUT_SHORTNAME);
var LENDERS = __spreadArrays(PARTNER_LENDERS, NON_PARTNER_LENDERS);
var LENDER_DICTIONARY = Object.fromEntries(__spreadArrays(PARTNER_LENDERS_WITH_SHORTNAME.map(function (pl) { return [pl.name, pl]; }), NON_PARTNER_WITH_SHORTNAME.map(function (npl) { return [npl.name, npl]; })));
var getByName = function (name) {
    return LENDER_DICTIONARY[name];
};
//# sourceMappingURL=Lenders.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Address.js
var StreetSuffixes;
(function (StreetSuffixes) {
    StreetSuffixes[StreetSuffixes["Central"] = 0] = "Central";
    StreetSuffixes[StreetSuffixes["Deviation"] = 1] = "Deviation";
    StreetSuffixes[StreetSuffixes["East"] = 2] = "East";
    StreetSuffixes[StreetSuffixes["Extension"] = 3] = "Extension";
    StreetSuffixes[StreetSuffixes["Lower"] = 4] = "Lower";
    StreetSuffixes[StreetSuffixes["Inner"] = 5] = "Inner";
    StreetSuffixes[StreetSuffixes["Mall"] = 6] = "Mall";
    StreetSuffixes[StreetSuffixes["North"] = 7] = "North";
    StreetSuffixes[StreetSuffixes["North East"] = 8] = "North East";
    StreetSuffixes[StreetSuffixes["North West"] = 9] = "North West";
    StreetSuffixes[StreetSuffixes["Off"] = 10] = "Off";
    StreetSuffixes[StreetSuffixes["On"] = 11] = "On";
    StreetSuffixes[StreetSuffixes["Outer"] = 12] = "Outer";
    StreetSuffixes[StreetSuffixes["Overpass"] = 13] = "Overpass";
    StreetSuffixes[StreetSuffixes["South"] = 14] = "South";
    StreetSuffixes[StreetSuffixes["South East"] = 15] = "South East";
    StreetSuffixes[StreetSuffixes["South West"] = 16] = "South West";
    StreetSuffixes[StreetSuffixes["Upper"] = 17] = "Upper";
    StreetSuffixes[StreetSuffixes["West"] = 18] = "West";
})(StreetSuffixes || (StreetSuffixes = {}));
var StreetTypes;
(function (StreetTypes) {
    StreetTypes[StreetTypes["Access"] = 0] = "Access";
    StreetTypes[StreetTypes["Alley"] = 1] = "Alley";
    StreetTypes[StreetTypes["Alleyway"] = 2] = "Alleyway";
    StreetTypes[StreetTypes["Amble"] = 3] = "Amble";
    StreetTypes[StreetTypes["Anchorage"] = 4] = "Anchorage";
    StreetTypes[StreetTypes["Approach"] = 5] = "Approach";
    StreetTypes[StreetTypes["Arcade"] = 6] = "Arcade";
    StreetTypes[StreetTypes["Arterial"] = 7] = "Arterial";
    StreetTypes[StreetTypes["Artery"] = 8] = "Artery";
    StreetTypes[StreetTypes["Avenue"] = 9] = "Avenue";
    StreetTypes[StreetTypes["Banan"] = 10] = "Banan";
    StreetTypes[StreetTypes["Bank"] = 11] = "Bank";
    StreetTypes[StreetTypes["Basin"] = 12] = "Basin";
    StreetTypes[StreetTypes["Bay"] = 13] = "Bay";
    StreetTypes[StreetTypes["Beach"] = 14] = "Beach";
    StreetTypes[StreetTypes["Bend"] = 15] = "Bend";
    StreetTypes[StreetTypes["Block"] = 16] = "Block";
    StreetTypes[StreetTypes["Boardwalk"] = 17] = "Boardwalk";
    StreetTypes[StreetTypes["Boulevard"] = 18] = "Boulevard";
    StreetTypes[StreetTypes["Boulevarde"] = 19] = "Boulevarde";
    StreetTypes[StreetTypes["Bowl"] = 20] = "Bowl";
    StreetTypes[StreetTypes["Brace"] = 21] = "Brace";
    StreetTypes[StreetTypes["Brae"] = 22] = "Brae";
    StreetTypes[StreetTypes["Break"] = 23] = "Break";
    StreetTypes[StreetTypes["Bridge"] = 24] = "Bridge";
    StreetTypes[StreetTypes["Broadway"] = 25] = "Broadway";
    StreetTypes[StreetTypes["Brow"] = 26] = "Brow";
    StreetTypes[StreetTypes["Bypass"] = 27] = "Bypass";
    StreetTypes[StreetTypes["Byway"] = 28] = "Byway";
    StreetTypes[StreetTypes["Canal"] = 29] = "Canal";
    StreetTypes[StreetTypes["Causeway"] = 30] = "Causeway";
    StreetTypes[StreetTypes["Centre"] = 31] = "Centre";
    StreetTypes[StreetTypes["Centreway"] = 32] = "Centreway";
    StreetTypes[StreetTypes["Chase"] = 33] = "Chase";
    StreetTypes[StreetTypes["Circle"] = 34] = "Circle";
    StreetTypes[StreetTypes["Circlet"] = 35] = "Circlet";
    StreetTypes[StreetTypes["Circuit"] = 36] = "Circuit";
    StreetTypes[StreetTypes["Circus"] = 37] = "Circus";
    StreetTypes[StreetTypes["Close"] = 38] = "Close";
    StreetTypes[StreetTypes["Cluster"] = 39] = "Cluster";
    StreetTypes[StreetTypes["Colonnade"] = 40] = "Colonnade";
    StreetTypes[StreetTypes["Common"] = 41] = "Common";
    StreetTypes[StreetTypes["Concourse"] = 42] = "Concourse";
    StreetTypes[StreetTypes["Connection"] = 43] = "Connection";
    StreetTypes[StreetTypes["Copse"] = 44] = "Copse";
    StreetTypes[StreetTypes["Corner"] = 45] = "Corner";
    StreetTypes[StreetTypes["Corso"] = 46] = "Corso";
    StreetTypes[StreetTypes["Course"] = 47] = "Course";
    StreetTypes[StreetTypes["Court"] = 48] = "Court";
    StreetTypes[StreetTypes["Courtyard"] = 49] = "Courtyard";
    StreetTypes[StreetTypes["Cove"] = 50] = "Cove";
    StreetTypes[StreetTypes["Crescent"] = 51] = "Crescent";
    StreetTypes[StreetTypes["Crest"] = 52] = "Crest";
    StreetTypes[StreetTypes["Cross"] = 53] = "Cross";
    StreetTypes[StreetTypes["Crossing"] = 54] = "Crossing";
    StreetTypes[StreetTypes["Crossroad"] = 55] = "Crossroad";
    StreetTypes[StreetTypes["Crossway"] = 56] = "Crossway";
    StreetTypes[StreetTypes["Cruiseway"] = 57] = "Cruiseway";
    StreetTypes[StreetTypes["Cul-De-Sac"] = 58] = "Cul-De-Sac";
    StreetTypes[StreetTypes["Cutting"] = 59] = "Cutting";
    StreetTypes[StreetTypes["Dale"] = 60] = "Dale";
    StreetTypes[StreetTypes["Dell"] = 61] = "Dell";
    StreetTypes[StreetTypes["Dene"] = 62] = "Dene";
    StreetTypes[StreetTypes["Deviation"] = 63] = "Deviation";
    StreetTypes[StreetTypes["Dip"] = 64] = "Dip";
    StreetTypes[StreetTypes["Distributor"] = 65] = "Distributor";
    StreetTypes[StreetTypes["Divide"] = 66] = "Divide";
    StreetTypes[StreetTypes["Dock"] = 67] = "Dock";
    StreetTypes[StreetTypes["Domain"] = 68] = "Domain";
    StreetTypes[StreetTypes["Drive"] = 69] = "Drive";
    StreetTypes[StreetTypes["Driveway"] = 70] = "Driveway";
    StreetTypes[StreetTypes["Edge"] = 71] = "Edge";
    StreetTypes[StreetTypes["Elbow"] = 72] = "Elbow";
    StreetTypes[StreetTypes["End"] = 73] = "End";
    StreetTypes[StreetTypes["Entrance"] = 74] = "Entrance";
    StreetTypes[StreetTypes["Esplanade"] = 75] = "Esplanade";
    StreetTypes[StreetTypes["Estate"] = 76] = "Estate";
    StreetTypes[StreetTypes["Estuary"] = 77] = "Estuary";
    StreetTypes[StreetTypes["Expressway"] = 78] = "Expressway";
    StreetTypes[StreetTypes["Extension"] = 79] = "Extension";
    StreetTypes[StreetTypes["Fairway"] = 80] = "Fairway";
    StreetTypes[StreetTypes["Fire Track"] = 81] = "Fire Track";
    StreetTypes[StreetTypes["Firebreak"] = 82] = "Firebreak";
    StreetTypes[StreetTypes["Fireline"] = 83] = "Fireline";
    StreetTypes[StreetTypes["Firetrack"] = 84] = "Firetrack";
    StreetTypes[StreetTypes["Firetrail"] = 85] = "Firetrail";
    StreetTypes[StreetTypes["Flat"] = 86] = "Flat";
    StreetTypes[StreetTypes["Follow"] = 87] = "Follow";
    StreetTypes[StreetTypes["Footway"] = 88] = "Footway";
    StreetTypes[StreetTypes["Ford"] = 89] = "Ford";
    StreetTypes[StreetTypes["Foreshore"] = 90] = "Foreshore";
    StreetTypes[StreetTypes["Formation"] = 91] = "Formation";
    StreetTypes[StreetTypes["Freeway"] = 92] = "Freeway";
    StreetTypes[StreetTypes["Front"] = 93] = "Front";
    StreetTypes[StreetTypes["Frontage"] = 94] = "Frontage";
    StreetTypes[StreetTypes["Gap"] = 95] = "Gap";
    StreetTypes[StreetTypes["Garden"] = 96] = "Garden";
    StreetTypes[StreetTypes["Gardens"] = 97] = "Gardens";
    StreetTypes[StreetTypes["Gate"] = 98] = "Gate";
    StreetTypes[StreetTypes["Gates"] = 99] = "Gates";
    StreetTypes[StreetTypes["Gateway"] = 100] = "Gateway";
    StreetTypes[StreetTypes["Glade"] = 101] = "Glade";
    StreetTypes[StreetTypes["Glen"] = 102] = "Glen";
    StreetTypes[StreetTypes["Grange"] = 103] = "Grange";
    StreetTypes[StreetTypes["Green"] = 104] = "Green";
    StreetTypes[StreetTypes["Ground"] = 105] = "Ground";
    StreetTypes[StreetTypes["Grove"] = 106] = "Grove";
    StreetTypes[StreetTypes["Gully"] = 107] = "Gully";
    StreetTypes[StreetTypes["Harbour"] = 108] = "Harbour";
    StreetTypes[StreetTypes["Heath"] = 109] = "Heath";
    StreetTypes[StreetTypes["Heights"] = 110] = "Heights";
    StreetTypes[StreetTypes["Highroad"] = 111] = "Highroad";
    StreetTypes[StreetTypes["Highway"] = 112] = "Highway";
    StreetTypes[StreetTypes["Hill"] = 113] = "Hill";
    StreetTypes[StreetTypes["Hollow"] = 114] = "Hollow";
    StreetTypes[StreetTypes["Hub"] = 115] = "Hub";
    StreetTypes[StreetTypes["Interchange"] = 116] = "Interchange";
    StreetTypes[StreetTypes["Intersection"] = 117] = "Intersection";
    StreetTypes[StreetTypes["Junction"] = 118] = "Junction";
    StreetTypes[StreetTypes["Key"] = 119] = "Key";
    StreetTypes[StreetTypes["Keys"] = 120] = "Keys";
    StreetTypes[StreetTypes["Landing"] = 121] = "Landing";
    StreetTypes[StreetTypes["Lane"] = 122] = "Lane";
    StreetTypes[StreetTypes["Laneway"] = 123] = "Laneway";
    StreetTypes[StreetTypes["Lees"] = 124] = "Lees";
    StreetTypes[StreetTypes["Line"] = 125] = "Line";
    StreetTypes[StreetTypes["Link"] = 126] = "Link";
    StreetTypes[StreetTypes["Little"] = 127] = "Little";
    StreetTypes[StreetTypes["Lookout"] = 128] = "Lookout";
    StreetTypes[StreetTypes["Loop"] = 129] = "Loop";
    StreetTypes[StreetTypes["Lower"] = 130] = "Lower";
    StreetTypes[StreetTypes["Mall"] = 131] = "Mall";
    StreetTypes[StreetTypes["Manor"] = 132] = "Manor";
    StreetTypes[StreetTypes["Meander"] = 133] = "Meander";
    StreetTypes[StreetTypes["Mears"] = 134] = "Mears";
    StreetTypes[StreetTypes["Mew"] = 135] = "Mew";
    StreetTypes[StreetTypes["Mews"] = 136] = "Mews";
    StreetTypes[StreetTypes["Mile"] = 137] = "Mile";
    StreetTypes[StreetTypes["Motorway"] = 138] = "Motorway";
    StreetTypes[StreetTypes["Mount"] = 139] = "Mount";
    StreetTypes[StreetTypes["Nook"] = 140] = "Nook";
    StreetTypes[StreetTypes["Outlet"] = 141] = "Outlet";
    StreetTypes[StreetTypes["Outlook"] = 142] = "Outlook";
    StreetTypes[StreetTypes["Parade"] = 143] = "Parade";
    StreetTypes[StreetTypes["Park"] = 144] = "Park";
    StreetTypes[StreetTypes["Parklands"] = 145] = "Parklands";
    StreetTypes[StreetTypes["Parkway"] = 146] = "Parkway";
    StreetTypes[StreetTypes["Part"] = 147] = "Part";
    StreetTypes[StreetTypes["Pass"] = 148] = "Pass";
    StreetTypes[StreetTypes["Passage"] = 149] = "Passage";
    StreetTypes[StreetTypes["Path"] = 150] = "Path";
    StreetTypes[StreetTypes["Pathway"] = 151] = "Pathway";
    StreetTypes[StreetTypes["Piazza"] = 152] = "Piazza";
    StreetTypes[StreetTypes["Pier"] = 153] = "Pier";
    StreetTypes[StreetTypes["Place"] = 154] = "Place";
    StreetTypes[StreetTypes["Plateau"] = 155] = "Plateau";
    StreetTypes[StreetTypes["Plaza"] = 156] = "Plaza";
    StreetTypes[StreetTypes["Pocket"] = 157] = "Pocket";
    StreetTypes[StreetTypes["Point"] = 158] = "Point";
    StreetTypes[StreetTypes["Port"] = 159] = "Port";
    StreetTypes[StreetTypes["Portal"] = 160] = "Portal";
    StreetTypes[StreetTypes["Promenade"] = 161] = "Promenade";
    StreetTypes[StreetTypes["Pursuit"] = 162] = "Pursuit";
    StreetTypes[StreetTypes["Quad"] = 163] = "Quad";
    StreetTypes[StreetTypes["Quadrangle"] = 164] = "Quadrangle";
    StreetTypes[StreetTypes["Quadrant"] = 165] = "Quadrant";
    StreetTypes[StreetTypes["Quay"] = 166] = "Quay";
    StreetTypes[StreetTypes["Quays"] = 167] = "Quays";
    StreetTypes[StreetTypes["Ramble"] = 168] = "Ramble";
    StreetTypes[StreetTypes["Ramp"] = 169] = "Ramp";
    StreetTypes[StreetTypes["Range"] = 170] = "Range";
    StreetTypes[StreetTypes["Reach"] = 171] = "Reach";
    StreetTypes[StreetTypes["Reserve"] = 172] = "Reserve";
    StreetTypes[StreetTypes["Rest"] = 173] = "Rest";
    StreetTypes[StreetTypes["Retreat"] = 174] = "Retreat";
    StreetTypes[StreetTypes["Return"] = 175] = "Return";
    StreetTypes[StreetTypes["Ride"] = 176] = "Ride";
    StreetTypes[StreetTypes["Ridge"] = 177] = "Ridge";
    StreetTypes[StreetTypes["Ridgeway"] = 178] = "Ridgeway";
    StreetTypes[StreetTypes["Right Of Way"] = 179] = "Right Of Way";
    StreetTypes[StreetTypes["Ring"] = 180] = "Ring";
    StreetTypes[StreetTypes["Rise"] = 181] = "Rise";
    StreetTypes[StreetTypes["Rising"] = 182] = "Rising";
    StreetTypes[StreetTypes["River"] = 183] = "River";
    StreetTypes[StreetTypes["Riverway"] = 184] = "Riverway";
    StreetTypes[StreetTypes["Riviera"] = 185] = "Riviera";
    StreetTypes[StreetTypes["Road"] = 186] = "Road";
    StreetTypes[StreetTypes["Roads"] = 187] = "Roads";
    StreetTypes[StreetTypes["Roadside"] = 188] = "Roadside";
    StreetTypes[StreetTypes["Roadway"] = 189] = "Roadway";
    StreetTypes[StreetTypes["Ronde"] = 190] = "Ronde";
    StreetTypes[StreetTypes["Rosebowl"] = 191] = "Rosebowl";
    StreetTypes[StreetTypes["Rotary"] = 192] = "Rotary";
    StreetTypes[StreetTypes["Round"] = 193] = "Round";
    StreetTypes[StreetTypes["Route"] = 194] = "Route";
    StreetTypes[StreetTypes["Row"] = 195] = "Row";
    StreetTypes[StreetTypes["Rue"] = 196] = "Rue";
    StreetTypes[StreetTypes["Run"] = 197] = "Run";
    StreetTypes[StreetTypes["Service Way"] = 198] = "Service Way";
    StreetTypes[StreetTypes["Shunt"] = 199] = "Shunt";
    StreetTypes[StreetTypes["Siding"] = 200] = "Siding";
    StreetTypes[StreetTypes["Slope"] = 201] = "Slope";
    StreetTypes[StreetTypes["Sound"] = 202] = "Sound";
    StreetTypes[StreetTypes["Spur"] = 203] = "Spur";
    StreetTypes[StreetTypes["Square"] = 204] = "Square";
    StreetTypes[StreetTypes["Stairs"] = 205] = "Stairs";
    StreetTypes[StreetTypes["State Highway"] = 206] = "State Highway";
    StreetTypes[StreetTypes["Steps"] = 207] = "Steps";
    StreetTypes[StreetTypes["Strand"] = 208] = "Strand";
    StreetTypes[StreetTypes["Street"] = 209] = "Street";
    StreetTypes[StreetTypes["Streets"] = 210] = "Streets";
    StreetTypes[StreetTypes["Strip"] = 211] = "Strip";
    StreetTypes[StreetTypes["Subway"] = 212] = "Subway";
    StreetTypes[StreetTypes["Tarn"] = 213] = "Tarn";
    StreetTypes[StreetTypes["Tarnice Way"] = 214] = "Tarnice Way";
    StreetTypes[StreetTypes["Terrace"] = 215] = "Terrace";
    StreetTypes[StreetTypes["Thoroughfare"] = 216] = "Thoroughfare";
    StreetTypes[StreetTypes["Throughway"] = 217] = "Throughway";
    StreetTypes[StreetTypes["Tollway"] = 218] = "Tollway";
    StreetTypes[StreetTypes["Top"] = 219] = "Top";
    StreetTypes[StreetTypes["Tor"] = 220] = "Tor";
    StreetTypes[StreetTypes["Towers"] = 221] = "Towers";
    StreetTypes[StreetTypes["Track"] = 222] = "Track";
    StreetTypes[StreetTypes["Trail"] = 223] = "Trail";
    StreetTypes[StreetTypes["Trailer"] = 224] = "Trailer";
    StreetTypes[StreetTypes["Triangle"] = 225] = "Triangle";
    StreetTypes[StreetTypes["Trunkway"] = 226] = "Trunkway";
    StreetTypes[StreetTypes["Turn"] = 227] = "Turn";
    StreetTypes[StreetTypes["Twist"] = 228] = "Twist";
    StreetTypes[StreetTypes["Underpass"] = 229] = "Underpass";
    StreetTypes[StreetTypes["Upper"] = 230] = "Upper";
    StreetTypes[StreetTypes["Vale"] = 231] = "Vale";
    StreetTypes[StreetTypes["Viaduct"] = 232] = "Viaduct";
    StreetTypes[StreetTypes["View"] = 233] = "View";
    StreetTypes[StreetTypes["Villas"] = 234] = "Villas";
    StreetTypes[StreetTypes["Vista"] = 235] = "Vista";
    StreetTypes[StreetTypes["Wade"] = 236] = "Wade";
    StreetTypes[StreetTypes["Walk"] = 237] = "Walk";
    StreetTypes[StreetTypes["Walkway"] = 238] = "Walkway";
    StreetTypes[StreetTypes["Waterway"] = 239] = "Waterway";
    StreetTypes[StreetTypes["Way"] = 240] = "Way";
    StreetTypes[StreetTypes["Wharf"] = 241] = "Wharf";
    StreetTypes[StreetTypes["Woods"] = 242] = "Woods";
    StreetTypes[StreetTypes["Wynd"] = 243] = "Wynd";
    StreetTypes[StreetTypes["Yard"] = 244] = "Yard";
})(StreetTypes || (StreetTypes = {}));
//# sourceMappingURL=Address.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Countries.js
var Countries;
(function (Countries) {
    Countries[Countries["Afghanistan"] = 0] = "Afghanistan";
    Countries[Countries["Albania"] = 1] = "Albania";
    Countries[Countries["Algeria"] = 2] = "Algeria";
    Countries[Countries["American Samoa"] = 3] = "American Samoa";
    Countries[Countries["Andorra"] = 4] = "Andorra";
    Countries[Countries["Angola"] = 5] = "Angola";
    Countries[Countries["Anguilla"] = 6] = "Anguilla";
    Countries[Countries["Antarctica"] = 7] = "Antarctica";
    Countries[Countries["Antigua And Barbuda"] = 8] = "Antigua And Barbuda";
    Countries[Countries["Argentina"] = 9] = "Argentina";
    Countries[Countries["Armenia"] = 10] = "Armenia";
    Countries[Countries["Aruba"] = 11] = "Aruba";
    Countries[Countries["Australia"] = 12] = "Australia";
    Countries[Countries["Austria"] = 13] = "Austria";
    Countries[Countries["Azerbaijan"] = 14] = "Azerbaijan";
    Countries[Countries["Bahamas"] = 15] = "Bahamas";
    Countries[Countries["Bahrain"] = 16] = "Bahrain";
    Countries[Countries["Bangladesh"] = 17] = "Bangladesh";
    Countries[Countries["Barbados"] = 18] = "Barbados";
    Countries[Countries["Belarus"] = 19] = "Belarus";
    Countries[Countries["Belgium"] = 20] = "Belgium";
    Countries[Countries["Belize"] = 21] = "Belize";
    Countries[Countries["Benin"] = 22] = "Benin";
    Countries[Countries["Bermuda"] = 23] = "Bermuda";
    Countries[Countries["Bhutan"] = 24] = "Bhutan";
    Countries[Countries["Bolivia"] = 25] = "Bolivia";
    Countries[Countries["Bosnia And Herzegovina"] = 26] = "Bosnia And Herzegovina";
    Countries[Countries["Botswana"] = 27] = "Botswana";
    Countries[Countries["Bouvet Island"] = 28] = "Bouvet Island";
    Countries[Countries["Brazil"] = 29] = "Brazil";
    Countries[Countries["British Indian Ocean Territory"] = 30] = "British Indian Ocean Territory";
    Countries[Countries["Brunei Darussalam"] = 31] = "Brunei Darussalam";
    Countries[Countries["Bulgaria"] = 32] = "Bulgaria";
    Countries[Countries["Burkina Faso"] = 33] = "Burkina Faso";
    Countries[Countries["Burundi"] = 34] = "Burundi";
    Countries[Countries["Cambodia"] = 35] = "Cambodia";
    Countries[Countries["Cameroon"] = 36] = "Cameroon";
    Countries[Countries["Canada"] = 37] = "Canada";
    Countries[Countries["Cape Verde"] = 38] = "Cape Verde";
    Countries[Countries["Cayman Islands"] = 39] = "Cayman Islands";
    Countries[Countries["Central African Republic"] = 40] = "Central African Republic";
    Countries[Countries["Chad"] = 41] = "Chad";
    Countries[Countries["Chile"] = 42] = "Chile";
    Countries[Countries["China"] = 43] = "China";
    Countries[Countries["Christmas Island"] = 44] = "Christmas Island";
    Countries[Countries["Cocos (Keeling) Islands"] = 45] = "Cocos (Keeling) Islands";
    Countries[Countries["Colombia"] = 46] = "Colombia";
    Countries[Countries["Comoros"] = 47] = "Comoros";
    Countries[Countries["Democratic People's Republic of Korea"] = 48] = "Democratic People's Republic of Korea";
    Countries[Countries["Democratic Republic Of The Congo"] = 49] = "Democratic Republic Of The Congo";
    Countries[Countries["Cook Islands"] = 50] = "Cook Islands";
    Countries[Countries["Costa Rica"] = 51] = "Costa Rica";
    Countries[Countries["Cote D'ivoire"] = 52] = "Cote D'ivoire";
    Countries[Countries["Croatia"] = 53] = "Croatia";
    Countries[Countries["Cuba"] = 54] = "Cuba";
    Countries[Countries["Cyprus"] = 55] = "Cyprus";
    Countries[Countries["Czech Republic"] = 56] = "Czech Republic";
    Countries[Countries["Denmark"] = 57] = "Denmark";
    Countries[Countries["Djibouti"] = 58] = "Djibouti";
    Countries[Countries["Dominica"] = 59] = "Dominica";
    Countries[Countries["Dominican Republic"] = 60] = "Dominican Republic";
    Countries[Countries["East Timor"] = 61] = "East Timor";
    Countries[Countries["Ecuador"] = 62] = "Ecuador";
    Countries[Countries["Egypt"] = 63] = "Egypt";
    Countries[Countries["El Salvador"] = 64] = "El Salvador";
    Countries[Countries["Equatorial Guinea"] = 65] = "Equatorial Guinea";
    Countries[Countries["Eritrea"] = 66] = "Eritrea";
    Countries[Countries["Estonia"] = 67] = "Estonia";
    Countries[Countries["Ethiopia"] = 68] = "Ethiopia";
    Countries[Countries["Falkland Islands"] = 69] = "Falkland Islands";
    Countries[Countries["Faroe Islands"] = 70] = "Faroe Islands";
    Countries[Countries["Fiji"] = 71] = "Fiji";
    Countries[Countries["Finland"] = 72] = "Finland";
    Countries[Countries["France"] = 73] = "France";
    Countries[Countries["French Guiana"] = 74] = "French Guiana";
    Countries[Countries["French Polynesia"] = 75] = "French Polynesia";
    Countries[Countries["French Southern Territories"] = 76] = "French Southern Territories";
    Countries[Countries["Gabon"] = 77] = "Gabon";
    Countries[Countries["Gambia"] = 78] = "Gambia";
    Countries[Countries["Georgia"] = 79] = "Georgia";
    Countries[Countries["Germany"] = 80] = "Germany";
    Countries[Countries["Ghana"] = 81] = "Ghana";
    Countries[Countries["Gibraltar"] = 82] = "Gibraltar";
    Countries[Countries["Greece"] = 83] = "Greece";
    Countries[Countries["Greenland"] = 84] = "Greenland";
    Countries[Countries["Grenada"] = 85] = "Grenada";
    Countries[Countries["Guadeloupe"] = 86] = "Guadeloupe";
    Countries[Countries["Guam"] = 87] = "Guam";
    Countries[Countries["Guatemala"] = 88] = "Guatemala";
    Countries[Countries["Guinea"] = 89] = "Guinea";
    Countries[Countries["Guinea-bissau"] = 90] = "Guinea-bissau";
    Countries[Countries["Guyana"] = 91] = "Guyana";
    Countries[Countries["Haiti"] = 92] = "Haiti";
    Countries[Countries["Heard Island And Mcdonald Islands"] = 93] = "Heard Island And Mcdonald Islands";
    Countries[Countries["Holy See (Vatican City State)"] = 94] = "Holy See (Vatican City State)";
    Countries[Countries["Honduras"] = 95] = "Honduras";
    Countries[Countries["Hong Kong"] = 96] = "Hong Kong";
    Countries[Countries["Hungary"] = 97] = "Hungary";
    Countries[Countries["Iceland"] = 98] = "Iceland";
    Countries[Countries["India"] = 99] = "India";
    Countries[Countries["Indonesia"] = 100] = "Indonesia";
    Countries[Countries["Iran"] = 101] = "Iran";
    Countries[Countries["Iraq"] = 102] = "Iraq";
    Countries[Countries["Ireland"] = 103] = "Ireland";
    Countries[Countries["Israel"] = 104] = "Israel";
    Countries[Countries["Italy"] = 105] = "Italy";
    Countries[Countries["Jamaica"] = 106] = "Jamaica";
    Countries[Countries["Japan"] = 107] = "Japan";
    Countries[Countries["Jordan"] = 108] = "Jordan";
    Countries[Countries["Kazakstan"] = 109] = "Kazakstan";
    Countries[Countries["Kenya"] = 110] = "Kenya";
    Countries[Countries["Kiribati"] = 111] = "Kiribati";
    Countries[Countries["Kosovo"] = 112] = "Kosovo";
    Countries[Countries["Kuwait"] = 113] = "Kuwait";
    Countries[Countries["Kyrgyzstan"] = 114] = "Kyrgyzstan";
    Countries[Countries["Laos"] = 115] = "Laos";
    Countries[Countries["Latvia"] = 116] = "Latvia";
    Countries[Countries["Lebanon"] = 117] = "Lebanon";
    Countries[Countries["Lesotho"] = 118] = "Lesotho";
    Countries[Countries["Liberia"] = 119] = "Liberia";
    Countries[Countries["Libyan Arab Jamahiriya"] = 120] = "Libyan Arab Jamahiriya";
    Countries[Countries["Liechtenstein"] = 121] = "Liechtenstein";
    Countries[Countries["Lithuania"] = 122] = "Lithuania";
    Countries[Countries["Luxembourg"] = 123] = "Luxembourg";
    Countries[Countries["Macau"] = 124] = "Macau";
    Countries[Countries["Macedonia"] = 125] = "Macedonia";
    Countries[Countries["Madagascar"] = 126] = "Madagascar";
    Countries[Countries["Malawi"] = 127] = "Malawi";
    Countries[Countries["Malaysia"] = 128] = "Malaysia";
    Countries[Countries["Maldives"] = 129] = "Maldives";
    Countries[Countries["Mali"] = 130] = "Mali";
    Countries[Countries["Malta"] = 131] = "Malta";
    Countries[Countries["Marshall Islands"] = 132] = "Marshall Islands";
    Countries[Countries["Martinique"] = 133] = "Martinique";
    Countries[Countries["Mauritania"] = 134] = "Mauritania";
    Countries[Countries["Mauritius"] = 135] = "Mauritius";
    Countries[Countries["Mayotte"] = 136] = "Mayotte";
    Countries[Countries["Mexico"] = 137] = "Mexico";
    Countries[Countries["Federated States Of Micronesia"] = 138] = "Federated States Of Micronesia";
    Countries[Countries["Republic Of Moldova"] = 139] = "Republic Of Moldova";
    Countries[Countries["Monaco"] = 140] = "Monaco";
    Countries[Countries["Mongolia"] = 141] = "Mongolia";
    Countries[Countries["Montserrat"] = 142] = "Montserrat";
    Countries[Countries["Montenegro"] = 143] = "Montenegro";
    Countries[Countries["Morocco"] = 144] = "Morocco";
    Countries[Countries["Mozambique"] = 145] = "Mozambique";
    Countries[Countries["Myanmar"] = 146] = "Myanmar";
    Countries[Countries["Namibia"] = 147] = "Namibia";
    Countries[Countries["Nauru"] = 148] = "Nauru";
    Countries[Countries["Nepal"] = 149] = "Nepal";
    Countries[Countries["Netherlands"] = 150] = "Netherlands";
    Countries[Countries["Netherlands Antilles"] = 151] = "Netherlands Antilles";
    Countries[Countries["New Caledonia"] = 152] = "New Caledonia";
    Countries[Countries["New Zealand"] = 153] = "New Zealand";
    Countries[Countries["Nicaragua"] = 154] = "Nicaragua";
    Countries[Countries["Niger"] = 155] = "Niger";
    Countries[Countries["Nigeria"] = 156] = "Nigeria";
    Countries[Countries["Niue"] = 157] = "Niue";
    Countries[Countries["Norfolk Island"] = 158] = "Norfolk Island";
    Countries[Countries["Northern Mariana Islands"] = 159] = "Northern Mariana Islands";
    Countries[Countries["Norway"] = 160] = "Norway";
    Countries[Countries["Oman"] = 161] = "Oman";
    Countries[Countries["Pakistan"] = 162] = "Pakistan";
    Countries[Countries["Palau"] = 163] = "Palau";
    Countries[Countries["Palestinian Territory"] = 164] = "Palestinian Territory";
    Countries[Countries["Panama"] = 165] = "Panama";
    Countries[Countries["Papua New Guinea"] = 166] = "Papua New Guinea";
    Countries[Countries["Paraguay"] = 167] = "Paraguay";
    Countries[Countries["Peru"] = 168] = "Peru";
    Countries[Countries["Philippines"] = 169] = "Philippines";
    Countries[Countries["Pitcairn"] = 170] = "Pitcairn";
    Countries[Countries["Poland"] = 171] = "Poland";
    Countries[Countries["Portugal"] = 172] = "Portugal";
    Countries[Countries["Puerto Rico"] = 173] = "Puerto Rico";
    Countries[Countries["Qatar"] = 174] = "Qatar";
    Countries[Countries["Romania"] = 175] = "Romania";
    Countries[Countries["Russian Federation"] = 176] = "Russian Federation";
    Countries[Countries["Rwanda"] = 177] = "Rwanda";
    Countries[Countries["Saint Helena"] = 178] = "Saint Helena";
    Countries[Countries["Saint Kitts And Nevis"] = 179] = "Saint Kitts And Nevis";
    Countries[Countries["Saint Lucia"] = 180] = "Saint Lucia";
    Countries[Countries["Saint Pierre And Miquelon"] = 181] = "Saint Pierre And Miquelon";
    Countries[Countries["Saint Vincent And The Grenadines"] = 182] = "Saint Vincent And The Grenadines";
    Countries[Countries["Samoa"] = 183] = "Samoa";
    Countries[Countries["San Marino"] = 184] = "San Marino";
    Countries[Countries["Sao Tome And Principe"] = 185] = "Sao Tome And Principe";
    Countries[Countries["Saudi Arabia"] = 186] = "Saudi Arabia";
    Countries[Countries["Senegal"] = 187] = "Senegal";
    Countries[Countries["Serbia"] = 188] = "Serbia";
    Countries[Countries["Seychelles"] = 189] = "Seychelles";
    Countries[Countries["Sierra Leone"] = 190] = "Sierra Leone";
    Countries[Countries["Singapore"] = 191] = "Singapore";
    Countries[Countries["Slovakia"] = 192] = "Slovakia";
    Countries[Countries["Slovenia"] = 193] = "Slovenia";
    Countries[Countries["Solomon Islands"] = 194] = "Solomon Islands";
    Countries[Countries["Somalia"] = 195] = "Somalia";
    Countries[Countries["South Africa"] = 196] = "South Africa";
    Countries[Countries["South Georgia And The South Sandwich Islands"] = 197] = "South Georgia And The South Sandwich Islands";
    Countries[Countries["The Republic of South Korea"] = 198] = "The Republic of South Korea";
    Countries[Countries["Spain"] = 199] = "Spain";
    Countries[Countries["Sri Lanka"] = 200] = "Sri Lanka";
    Countries[Countries["Sudan"] = 201] = "Sudan";
    Countries[Countries["Suriname"] = 202] = "Suriname";
    Countries[Countries["Svalbard And Jan Mayen"] = 203] = "Svalbard And Jan Mayen";
    Countries[Countries["Swaziland"] = 204] = "Swaziland";
    Countries[Countries["Sweden"] = 205] = "Sweden";
    Countries[Countries["Switzerland"] = 206] = "Switzerland";
    Countries[Countries["Syrian Arab Republic"] = 207] = "Syrian Arab Republic";
    Countries[Countries["Taiwan"] = 208] = "Taiwan";
    Countries[Countries["Tajikistan"] = 209] = "Tajikistan";
    Countries[Countries["Tanzania"] = 210] = "Tanzania";
    Countries[Countries["Thailand"] = 211] = "Thailand";
    Countries[Countries["Togo"] = 212] = "Togo";
    Countries[Countries["Tokelau"] = 213] = "Tokelau";
    Countries[Countries["Tonga"] = 214] = "Tonga";
    Countries[Countries["Trinidad And Tobago"] = 215] = "Trinidad And Tobago";
    Countries[Countries["Tunisia"] = 216] = "Tunisia";
    Countries[Countries["Turkey"] = 217] = "Turkey";
    Countries[Countries["Turkmenistan"] = 218] = "Turkmenistan";
    Countries[Countries["Turks And Caicos Islands"] = 219] = "Turks And Caicos Islands";
    Countries[Countries["Tuvalu"] = 220] = "Tuvalu";
    Countries[Countries["Uganda"] = 221] = "Uganda";
    Countries[Countries["Ukraine"] = 222] = "Ukraine";
    Countries[Countries["United Arab Emirates"] = 223] = "United Arab Emirates";
    Countries[Countries["United Kingdom"] = 224] = "United Kingdom";
    Countries[Countries["United States of America"] = 225] = "United States of America";
    Countries[Countries["United States Minor Outlying Islands"] = 226] = "United States Minor Outlying Islands";
    Countries[Countries["Uruguay"] = 227] = "Uruguay";
    Countries[Countries["Uzbekistan"] = 228] = "Uzbekistan";
    Countries[Countries["Vanuatu"] = 229] = "Vanuatu";
    Countries[Countries["Venezuela"] = 230] = "Venezuela";
    Countries[Countries["Vietnam"] = 231] = "Vietnam";
    Countries[Countries["British Virgin Islands"] = 232] = "British Virgin Islands";
    Countries[Countries["US Virgin Islands"] = 233] = "US Virgin Islands";
    Countries[Countries["Wallis And Futuna"] = 234] = "Wallis And Futuna";
    Countries[Countries["Western Sahara"] = 235] = "Western Sahara";
    Countries[Countries["Yemen"] = 236] = "Yemen";
    Countries[Countries["Zambia"] = 237] = "Zambia";
    Countries[Countries["Zimbabwe"] = 238] = "Zimbabwe";
})(Countries || (Countries = {}));
//# sourceMappingURL=Countries.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RelatedParty.js
var CompanyType;
(function (CompanyType) {
    CompanyType["Accountant"] = "ACCOUNTANT";
    CompanyType["Solicitor"] = "SOLICITOR";
})(CompanyType || (CompanyType = {}));
var PersonType;
(function (PersonType) {
    PersonType["Spouse"] = "SPOUSE";
})(PersonType || (PersonType = {}));
var VisitContactType;
(function (VisitContactType) {
    VisitContactType["LoanParty"] = "LOAN_PARTY";
    VisitContactType["Tenant"] = "TENANT";
    VisitContactType["RealEstateAgent"] = "REAL_ESTATE_AGENT";
})(VisitContactType || (VisitContactType = {}));
var SubstantialBenefitType;
(function (SubstantialBenefitType) {
    SubstantialBenefitType["SubstantialBenefit"] = "SUBSTANTIAL_BENEFIT";
    SubstantialBenefitType["NoSubstantialBenefitAndProceed"] = "NO_SUBSTANTIAL_BENEFIT_AND_PROCEED";
    SubstantialBenefitType["NoSubstantialBenefit"] = "NO_SUBSTANTIAL_BENEFIT";
})(SubstantialBenefitType || (SubstantialBenefitType = {}));
//# sourceMappingURL=RelatedParty.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/BusinessType.js
var BusinessType;
(function (BusinessType) {
    BusinessType["Private"] = "PRIVATE";
    BusinessType["Public"] = "PUBLIC";
})(BusinessType || (BusinessType = {}));
//# sourceMappingURL=BusinessType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/BusinessStructureType.js
var BusinessStructureType;
(function (BusinessStructureType) {
    BusinessStructureType["Company"] = "COMPANY";
    BusinessStructureType["SoleTrader"] = "SOLE_TRADER";
    BusinessStructureType["Partnership"] = "PARTNERSHIP";
    BusinessStructureType["Trust"] = "TRUST";
})(BusinessStructureType || (BusinessStructureType = {}));
//# sourceMappingURL=BusinessStructureType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/TrustType.js
var TrustType;
(function (TrustType) {
    TrustType["CashManagementTrust"] = "CASH_MANAGEMENT_TRUST";
    TrustType["DiscretionaryTrust"] = "DISCRETIONARY_TRUST";
    TrustType["Fixed"] = "FIXED";
    TrustType["Hybrid"] = "HYBRID";
    TrustType["Other"] = "OTHER";
    TrustType["SimpleOrBare"] = "SIMPLE_OR_BARE";
    TrustType["SuperannuationTrusts"] = "SUPERANNUATION_TRUSTS";
    TrustType["Unit"] = "UNIT";
})(TrustType || (TrustType = {}));
//# sourceMappingURL=TrustType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/EmploymentBasisType.js
var EmploymentBasisType;
(function (EmploymentBasisType) {
    EmploymentBasisType["FullTime"] = "FULL_TIME";
    EmploymentBasisType["PartTime"] = "PART_TIME";
    EmploymentBasisType["Casual"] = "CASUAL";
    EmploymentBasisType["Contractor"] = "CONTRACTOR";
    EmploymentBasisType["MaternityLeave"] = "MATERNITY_LEAVE";
})(EmploymentBasisType || (EmploymentBasisType = {}));
//# sourceMappingURL=EmploymentBasisType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/EmploymentStructures.js
var EmploymentStructures;
(function (EmploymentStructures) {
    EmploymentStructures["Primary"] = "PRIMARY";
    EmploymentStructures["Secondary"] = "SECONDARY";
    EmploymentStructures["Previous"] = "PREVIOUS";
})(EmploymentStructures || (EmploymentStructures = {}));
//# sourceMappingURL=EmploymentStructures.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/EmploymentSubType.js
var EmploymentSubType;
(function (EmploymentSubType) {
    EmploymentSubType["FullDoc"] = "FULL_DOC";
    EmploymentSubType["LowDoc"] = "LOW_DOC";
})(EmploymentSubType || (EmploymentSubType = {}));
//# sourceMappingURL=EmploymentSubType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RelationshipToTrust.js
var RelationshipToTrust;
(function (RelationshipToTrust) {
    RelationshipToTrust["Trustee"] = "TRUSTEE";
    RelationshipToTrust["Beneficiary"] = "BENEFICIARY";
    RelationshipToTrust["Director"] = "DIRECTOR";
    RelationshipToTrust["ShareholderOfCorporateTrustee"] = "SHAREHOLDER_OF_CORPORATE_TRUSTEE";
})(RelationshipToTrust || (RelationshipToTrust = {}));
//# sourceMappingURL=RelationshipToTrust.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RelatedCompany.js
var RelatedCompanyType;
(function (RelatedCompanyType) {
    RelatedCompanyType["Employer"] = "EMPLOYER";
    RelatedCompanyType["SelfEmploymentBusiness"] = "SELF_EMPLOYMENT_BUSINESS";
})(RelatedCompanyType || (RelatedCompanyType = {}));
//# sourceMappingURL=RelatedCompany.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/BuilderType.js
var BuilderType;
(function (BuilderType) {
    BuilderType["LicensedBuilder"] = "LICENSED_BUILDER";
    BuilderType["OwnerBuilder"] = "OWNER_BUILDER";
})(BuilderType || (BuilderType = {}));
//# sourceMappingURL=BuilderType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/CustomerPropertyRelationship.js
var CustomerPropertyRelationship;
(function (CustomerPropertyRelationship) {
    CustomerPropertyRelationship["OWNER"] = "OWNER";
    CustomerPropertyRelationship["LOOKING_TO_BUY"] = "LOOKING_TO_BUY";
    CustomerPropertyRelationship["JUST_LOOKING"] = "JUST_LOOKING";
})(CustomerPropertyRelationship || (CustomerPropertyRelationship = {}));
//# sourceMappingURL=CustomerPropertyRelationship.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/PropertyEventTimelineType.js
var PropertyEventTimelineType;
(function (PropertyEventTimelineType) {
    PropertyEventTimelineType["Rented"] = "RENTED";
    PropertyEventTimelineType["Sold"] = "SOLD";
})(PropertyEventTimelineType || (PropertyEventTimelineType = {}));
//# sourceMappingURL=PropertyEventTimelineType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/PropertyVisibility.js
var PropertyVisibility;
(function (PropertyVisibility) {
    PropertyVisibility["ACTIVE"] = "ACTIVE";
    PropertyVisibility["ARCHIVED"] = "ARCHIVED";
    PropertyVisibility["ACTIVE_TO_TEAM_ONLY"] = "ACTIVE_TO_TEAM_ONLY";
})(PropertyVisibility || (PropertyVisibility = {}));
//# sourceMappingURL=PropertyVisibility.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/PlatformPathname.js
var PlatformPathname;
(function (PlatformPathname) {
    PlatformPathname["BOOKING_APPOINTMENT_PATHNAME"] = "/book-appointment";
    PlatformPathname["TIME_SELECTION_PROCESS_PATHNAME"] = "/book-appointment/process";
    PlatformPathname["STAMP_DUTY_PATHNAME"] = "/stamp-duty-calculator";
    PlatformPathname["PROPERTY_REPORT_PATHNAME"] = "/property-report";
    PlatformPathname["REFINANCE_FUNNEL_PATHNAME"] = "/home-loans/basics/refinance/refinance-loan-amount";
    PlatformPathname["NEW_PURCHASE_FUNNEL_PATHNAME"] = "/home-loans/basics/new-home/purchase-price";
    PlatformPathname["BORROWING_POWER_FUNNEL_PATHNAME"] = "/home-loans/basics/borrowing-power/applicants";
})(PlatformPathname || (PlatformPathname = {}));
//# sourceMappingURL=PlatformPathname.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/CtpInterestRateType.js
var CtpInterestRateType;
(function (CtpInterestRateType) {
    CtpInterestRateType["Variable"] = "VariableRate";
    CtpInterestRateType["Fixed"] = "FixedRate";
})(CtpInterestRateType || (CtpInterestRateType = {}));
//# sourceMappingURL=CtpInterestRateType.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/AppointmentCancellationReason.js
var AppointmentCancellationReason;
(function (AppointmentCancellationReason) {
    AppointmentCancellationReason["CustomerNotResponding"] = "CUSTOMER_NOT_RESPONDING";
    AppointmentCancellationReason["ExploringOptions"] = "EXPLORING_OPTIONS";
    AppointmentCancellationReason["HappyWithCurrentBankAndRates"] = "HAPPY_WITH_CURRENT_BANK_AND_RATES";
    AppointmentCancellationReason["ServicingIncomeOrEmployment"] = "SERVICING_INCOME_OR_EMPLOYMENT";
    AppointmentCancellationReason["DuplicatedAppointment"] = "DUPLICATED_APPOINTMENT";
    AppointmentCancellationReason["CreditIssues"] = "CREDIT_ISSUES";
    AppointmentCancellationReason["LowRefinanceLvr"] = "LOW_REFINANCE_LVR";
    AppointmentCancellationReason["InsufficientDeposit"] = "INSUFFICIENT_DEPOSIT";
    AppointmentCancellationReason["InsufficientExitStrategy"] = "INSUFFICIENT_EXIT_STRATEGY";
    AppointmentCancellationReason["PurchasingAfterThreeMonths"] = "PURCHASING_AFTER_THREE_MONTHS";
    AppointmentCancellationReason["PendingLegalMatter"] = "PENDING_LEGAL_MATTER";
})(AppointmentCancellationReason || (AppointmentCancellationReason = {}));
//# sourceMappingURL=AppointmentCancellationReason.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/index.js










































































//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/appointment-source/index.js
var AppointmentSource;
(function (AppointmentSource) {
    AppointmentSource["CallbackRequest"] = "CALLBACK_REQUEST";
    AppointmentSource["NoAppointmentAvailabilities"] = "NO_APPOINTMENT_AVAILABILITIES";
})(AppointmentSource || (AppointmentSource = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/credit-score-purpose/index.js
var CreditScorePurpose;
(function (CreditScorePurpose) {
    CreditScorePurpose["Refinance"] = "REFINANCE";
    CreditScorePurpose["NewPurchase"] = "NEW_PURCHASE";
    CreditScorePurpose["NewPurchaseLater"] = "NEW_PURCHASE_LATER";
    CreditScorePurpose["NmpPersonalCarLoan"] = "NMP_PERSONAL_CAR_LOAN";
    CreditScorePurpose["Curious"] = "CURIOUS";
    CreditScorePurpose["CreditCard"] = "CREDIT_CARD";
    CreditScorePurpose["Other"] = "OTHER";
})(CreditScorePurpose || (CreditScorePurpose = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/credit-status/index.js
var credit_status_CreditStatus;
(function (CreditStatus) {
    CreditStatus["Excellent"] = "EXCELLENT";
    CreditStatus["Average"] = "AVERAGE";
    CreditStatus["Fair"] = "FAIR";
    CreditStatus["Unknown"] = "UNKNOWN";
})(credit_status_CreditStatus || (credit_status_CreditStatus = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/desired-features/index.js
var desired_features_DesiredFeatures;
(function (DesiredFeatures) {
    DesiredFeatures["FixedRate"] = "FIXED_RATE";
    DesiredFeatures["MobileApp"] = "MOBILE_APP";
    DesiredFeatures["MajorLender"] = "MAJOR_LENDER";
    DesiredFeatures["OffsetRedraw"] = "OFFSET_OR_REDRAW";
    DesiredFeatures["Offset"] = "OFFSET";
    DesiredFeatures["Redraw"] = "REDRAW";
})(desired_features_DesiredFeatures || (desired_features_DesiredFeatures = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/eligible-for-fhog/index.js
var eligible_for_fhog_EligibleForFHOG;
(function (EligibleForFHOG) {
    EligibleForFHOG["Yes"] = "YES";
    EligibleForFHOG["No"] = "No";
    EligibleForFHOG["NotSure"] = "NotSure";
})(eligible_for_fhog_EligibleForFHOG || (eligible_for_fhog_EligibleForFHOG = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/employment-type/index.js
var employment_type_EmploymentType;
(function (EmploymentType) {
    EmploymentType["Employee"] = "EMPLOYEE";
    EmploymentType["SelfEmployed"] = "SELF_EMPLOYED";
    EmploymentType["Other"] = "UNKNOWN";
})(employment_type_EmploymentType || (employment_type_EmploymentType = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/enquiry-purpose/index.js
var EnquiryPurpose;
(function (EnquiryPurpose) {
    EnquiryPurpose["AppointmentRequest"] = "APPOINTMENT_REQUEST";
    EnquiryPurpose["Insurance"] = "INSURANCE";
    EnquiryPurpose["Investor"] = "INVESTOR";
    EnquiryPurpose["NewPurchase"] = "NEW_PURCHASE";
    EnquiryPurpose["NonMortgageLoan"] = "NON_MORTGAGE_LOAN";
    EnquiryPurpose["Other"] = "OTHER";
    EnquiryPurpose["Refinance"] = "REFINANCE";
    EnquiryPurpose["UrgentCallbackRequest"] = "URGENT_CALLBACK_REQUEST";
})(EnquiryPurpose || (EnquiryPurpose = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/funnel-property-status/index.js
var FunnelPropertyStatus;
(function (FunnelPropertyStatus) {
    FunnelPropertyStatus["NewBuilding"] = "NEW_BUILDING";
    FunnelPropertyStatus["VacantLand"] = "VACANT_LAND";
    FunnelPropertyStatus["Established"] = "ESTABLISHED";
})(FunnelPropertyStatus || (FunnelPropertyStatus = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/funnel-property-type/index.js
var FunnelPropertyType;
(function (FunnelPropertyType) {
    FunnelPropertyType["ApartmentUnitLessThan50M2"] = "APARTMENT_UNIT_LESS_THAN_50M2";
    FunnelPropertyType["ApartmentUnitMoreThan50M2"] = "APARTMENT_UNIT_MORE_THAN_50M2";
    FunnelPropertyType["ServicedApartment"] = "SERVICED_APARTMENT";
    FunnelPropertyType["Studio"] = "STUDIO";
    FunnelPropertyType["StudentAccommodation"] = "STUDENT_ACCOMMODATION";
    FunnelPropertyType["WarehouseApartment"] = "WAREHOUSE_APARTMENT";
    FunnelPropertyType["Duplex"] = "DUPLEX";
    FunnelPropertyType["Villa"] = "VILLA";
    FunnelPropertyType["FullyDetachedHouse"] = "FULLY_DETACHED_HOUSE";
    FunnelPropertyType["KitHome"] = "KIT_HOME";
    FunnelPropertyType["MultiDwellingSingleTitle"] = "MULTI_DWELLING_SINGLE_TITLE";
    FunnelPropertyType["PropertyOver10HA"] = "PROPERTY_OVER_10_HA";
    FunnelPropertyType["SemiDetachedHouse"] = "SEMI_DETACHED_HOUSE";
    FunnelPropertyType["Terrace"] = "TERRACE";
    FunnelPropertyType["Townhouse"] = "TOWNHOUSE";
    FunnelPropertyType["Land"] = "LAND";
})(FunnelPropertyType || (FunnelPropertyType = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/number-of-borrowers/index.js
var NumberOfBorrowers;
(function (NumberOfBorrowers) {
    NumberOfBorrowers[NumberOfBorrowers["One"] = 1] = "One";
    NumberOfBorrowers[NumberOfBorrowers["Two"] = 2] = "Two";
})(NumberOfBorrowers || (NumberOfBorrowers = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/origin/index.js
var Origin;
(function (Origin) {
    Origin["AreaReport"] = "AREA_REPORT";
    Origin["AussieHomes"] = "AUSSIE_HOMES";
    Origin["BorrowingPower"] = "BORROWING_POWER";
    Origin["PropertyReport"] = "PROPERTY_REPORT";
    Origin["Toolbox"] = "TOOLBOX";
    Origin["LAMForm"] = "LAM_FORM";
    Origin["LisitngSearch"] = "LISTING_SEARCH";
    Origin["SignUp"] = "SIGN_UP";
    Origin["NewHomeLoan"] = "NEW_HOME_LOAN";
    Origin["Refinance"] = "REFINANCE";
    Origin["Blog"] = "BLOG";
    Origin["StampDutyCalculator"] = "STAMP_DUTY_CALCULATOR";
    Origin["AppointmentBooking"] = "APPOINTMENT_BOOKING";
    Origin["Invite"] = "INVITE";
    Origin["Chat"] = "CHAT";
    Origin["SelfGen"] = "SELF_GEN";
    Origin["CreditScore"] = "CREDIT_SCORE";
    Origin["FixedRateExpiry"] = "FIXED_RATE_EXPIRY";
    Origin["AffiliateLead"] = "AFFILIATE_LEAD";
    Origin["MarketingOther"] = "MARKETING_OTHER";
    Origin["CarLoan"] = "CAR_LOAN";
    Origin["BusinessLoanAssetFinance"] = "BUSINESS_LOAN_ASSET_FINANCE";
    Origin["BusinessLoanCommercial"] = "BUSINESS_LOAN_COMMERCIAL";
    Origin["Insurance"] = "INSURANCE";
})(Origin || (Origin = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/payment-method/index.js
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["InterestOnly"] = "INTEREST_ONLY";
    PaymentMethod["PrincipalInterest"] = "PRINCIPAL_AND_INTEREST";
    PaymentMethod["StillDeciding"] = "STILL_DECIDING";
})(PaymentMethod || (PaymentMethod = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/property-use/index.js
var PropertyUse;
(function (PropertyUse) {
    PropertyUse["OwnerOccupied"] = "OWNER_OCCUPIED";
    PropertyUse["Investment"] = "INVESTMENT";
})(PropertyUse || (PropertyUse = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/purchase-intent/index.js
var PurchaseIntent;
(function (PurchaseIntent) {
    PurchaseIntent["FirstHome"] = "FIRST_HOME";
    PurchaseIntent["NextHome"] = "NEXT_HOME";
    PurchaseIntent["Investment"] = "INVESTMENT";
})(PurchaseIntent || (PurchaseIntent = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/purchase-situation/index.js
var purchase_situation_PurchaseSituation;
(function (PurchaseSituation) {
    PurchaseSituation["ContractsExchanged"] = "CONTRACTS_EXCHANGED";
    PurchaseSituation["OfferMade"] = "OFFER_MADE";
    PurchaseSituation["BuyingSoon"] = "BUYING_SOON";
    PurchaseSituation["ExploringOptions"] = "EXPLORING_OPTIONS";
    PurchaseSituation["ActivelyLookingForAHome"] = "ACTIVELY_LOOKING_FOR_A_HOME";
})(purchase_situation_PurchaseSituation || (purchase_situation_PurchaseSituation = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/purpose/index.js
var purpose_Purpose;
(function (Purpose) {
    Purpose["NewPurchase"] = "NEW_PURCHASE";
    Purpose["Refinance"] = "REFINANCE";
})(purpose_Purpose || (purpose_Purpose = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/refinancing-reason/index.js
var RefinancingReason;
(function (RefinancingReason) {
    RefinancingReason["ConsolidateCashout"] = "CONSOLIDATE_CASHOUT";
    RefinancingReason["FasterPayoff"] = "FASTER_PAYOFF";
    RefinancingReason["DecreaseRepayments"] = "DECREASE_REPAYMENTS";
    RefinancingReason["Construction"] = "CONSTRUCTION";
    RefinancingReason["Consolidate"] = "CONSOLIDATE_DEBT";
    RefinancingReason["Cashout"] = "GET_CASHOUT";
})(RefinancingReason || (RefinancingReason = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/relationship-with-property/index.js
var RelationshipWithProperty;
(function (RelationshipWithProperty) {
    RelationshipWithProperty["Owner"] = "OWNER";
    RelationshipWithProperty["InterestedToBuy"] = "INTERESTED_TO_BUY";
    RelationshipWithProperty["CurrentlyRenting"] = "CURRENTLY_RENTING";
    RelationshipWithProperty["Curious"] = "JUST_CURIOUS";
})(RelationshipWithProperty || (RelationshipWithProperty = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/stamp-duty-property-state/index.js
var StampDutyPropertyState;
(function (StampDutyPropertyState) {
    StampDutyPropertyState["NSW"] = "NSW";
    StampDutyPropertyState["QLD"] = "QLD";
    StampDutyPropertyState["WA"] = "WA";
    StampDutyPropertyState["VIC"] = "VIC";
    StampDutyPropertyState["TAS"] = "TAS";
    StampDutyPropertyState["ACT"] = "ACT";
    StampDutyPropertyState["NT"] = "NT";
    StampDutyPropertyState["SA"] = "SA";
})(StampDutyPropertyState || (StampDutyPropertyState = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/stamp-duty-property-type/index.js
var StampDutyPropertyType;
(function (StampDutyPropertyType) {
    StampDutyPropertyType["NewHome"] = "NEW_HOME";
    StampDutyPropertyType["EstablishedHome"] = "ESTABLISHED_HOME";
    StampDutyPropertyType["VacantLand"] = "VACANT_LAND";
})(StampDutyPropertyType || (StampDutyPropertyType = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/urgency/index.js
var urgency_Urgency;
(function (Urgency) {
    Urgency["Urgent"] = "URGENT";
    Urgency["NotUrgent"] = "NOT_URGENT";
})(urgency_Urgency || (urgency_Urgency = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/index.js






















//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/configuration/index.js

var configuration = {
    sessionStorageKeyPrefix: 'l3',
    sessionStorageKeySuffixes: {
        firstName: 'firstName',
        mobileNumber: 'mobileNumber',
        email: 'email',
        brokerId: 'brokerId',
        storeId: 'storeId',
    },
    brokerStorePageLeadJourneys: [Origin.AppointmentBooking, Origin.Refinance, Origin.NewHomeLoan, Origin.BorrowingPower],
    defaultTimezone: 'Australia/Sydney',
};
/* harmony default export */ var esm_configuration = (configuration);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/utils.js
/* provided dependency */ var process = __webpack_require__(13158);




// utils is a library of generic helper functions non-specific to axios

const {toString: utils_toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = utils_toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

const [isReadableStream, isRequest, isResponse, isHeaders] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(kindOfTest);

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34

const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }

  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({source, data}) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);

    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    }
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === 'function',
  isFunction(_global.postMessage)
);

const asap = typeof queueMicrotask !== 'undefined' ?
  queueMicrotask.bind(_global) : ( typeof process !== 'undefined' && process.nextTick || _setImmediate);

// *********************

/* harmony default export */ var utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap
});

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});

const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ var core_AxiosError = (AxiosError);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ var helpers_null = (null);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(75291)["lW"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ var helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ var core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/platform/browser/index.js




/* harmony default export */ var browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/platform/common/utils.js
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

const _navigator = typeof navigator === 'object' && navigator || undefined;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = hasBrowserEnv &&
  (!_navigator || ['ReactNative', 'NativeScript', 'NS'].indexOf(_navigator.product) < 0);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();

const origin = hasBrowserEnv && window.location.href || 'http://localhost';



;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/platform/index.js



/* harmony default export */ var platform = ({
  ...common_utils_namespaceObject,
  ...browser
});

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/defaults/index.js










/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http', 'fetch'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data) ||
      utils.isReadableStream(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (utils.isResponse(data) || utils.isReadableStream(data)) {
      return data;
    }

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

/* harmony default export */ var lib_defaults = (defaults);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils.isHeaders(header)) {
      for (const [key, value] of header.entries()) {
        setHeader(value, key, rewrite);
      }
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils.freezeMethods(AxiosHeaders);

/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});

/* harmony default export */ var cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/throttle.js
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle(fn, freq) {
  let timestamp = 0;
  let threshold = 1000 / freq;
  let lastArgs;
  let timer;

  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn.apply(null, args);
  }

  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if ( passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs)
        }, threshold - passed);
      }
    }
  }

  const flush = () => lastArgs && invoke(lastArgs);

  return [throttled, flush];
}

/* harmony default export */ var helpers_throttle = (throttle);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/progressEventReducer.js




const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return helpers_throttle(e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? 'download' : 'upload']: true
    };

    listener(data);
  }, freq);
}

const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;

  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
}

const asyncDecorator = (fn) => (...args) => utils.asap(() => fn(...args));

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/isURLSameOrigin.js





/* harmony default export */ var isURLSameOrigin = (platform.hasStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/cookies.js



/* harmony default export */ var cookies = (platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils.isString(path) && cookie.push('path=' + path);

      utils.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  });


;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/resolveConfig.js









/* harmony default export */ var resolveConfig = ((config) => {
  const newConfig = mergeConfig({}, config);

  let {data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth} = newConfig;

  newConfig.headers = headers = core_AxiosHeaders.from(headers);

  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);

  // HTTP basic authentication
  if (auth) {
    headers.set('Authorization', 'Basic ' +
      btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : ''))
    );
  }

  let contentType;

  if (utils.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(undefined); // Let the browser set it
    } else if ((contentType = headers.getContentType()) !== false) {
      // fix semicolon duplication issue for ReactNative FormData implementation
      const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
    }
  }

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.

  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));

    if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(newConfig.url))) {
      // Add xsrf header
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);

      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }

  return newConfig;
});


;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/adapters/xhr.js











const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = core_AxiosHeaders.from(_config.headers).normalize();
    let {responseType, onUploadProgress, onDownloadProgress} = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;

    function done() {
      flushUpload && flushUpload(); // flush events
      flushDownload && flushDownload(); // flush events

      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);

      _config.signal && _config.signal.removeEventListener('abort', onCanceled);
    }

    let request = new XMLHttpRequest();

    request.open(_config.method.toUpperCase(), _config.url, true);

    // Set the request timeout in MS
    request.timeout = _config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = _config.transitional || defaults_transitional;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = _config.responseType;
    }

    // Handle progress if needed
    if (onDownloadProgress) {
      ([downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true));
      request.addEventListener('progress', downloadThrottled);
    }

    // Not all browsers support upload events
    if (onUploadProgress && request.upload) {
      ([uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress));

      request.upload.addEventListener('progress', uploadThrottled);

      request.upload.addEventListener('loadend', flushUpload);
    }

    if (_config.cancelToken || _config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(_config.url);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/composeSignals.js




const composeSignals = (signals, timeout) => {
  const {length} = (signals = signals ? signals.filter(Boolean) : []);

  if (timeout || length) {
    let controller = new AbortController();

    let aborted;

    const onabort = function (reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof core_AxiosError ? err : new cancel_CanceledError(err instanceof Error ? err.message : err));
      }
    }

    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new core_AxiosError(`timeout ${timeout} of ms exceeded`, core_AxiosError.ETIMEDOUT))
    }, timeout)

    const unsubscribe = () => {
      if (signals) {
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach(signal => {
          signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
      }
    }

    signals.forEach((signal) => signal.addEventListener('abort', onabort));

    const {signal} = controller;

    signal.unsubscribe = () => utils.asap(unsubscribe);

    return signal;
  }
}

/* harmony default export */ var helpers_composeSignals = (composeSignals);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/trackStream.js

const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;

  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }

  let pos = 0;
  let end;

  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
}

const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
}

const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }

  const reader = stream.getReader();
  try {
    for (;;) {
      const {done, value} = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
}

const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);

  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  }

  return new ReadableStream({
    async pull(controller) {
      try {
        const {done, value} = await iterator.next();

        if (done) {
         _onFinish();
          controller.close();
          return;
        }

        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  })
}

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/adapters/fetch.js










const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';

// used only inside the fetch adapter
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ?
    ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) :
    async (str) => new Uint8Array(await new Response(str).arrayBuffer())
);

const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false
  }
}

const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;

  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: 'POST',
    get duplex() {
      duplexAccessed = true;
      return 'half';
    },
  }).headers.has('Content-Type');

  return duplexAccessed && !hasContentType;
});

const DEFAULT_CHUNK_SIZE = 64 * 1024;

const supportsResponseStream = isReadableStreamSupported &&
  test(() => utils.isReadableStream(new Response('').body));


const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};

isFetchSupported && (((res) => {
  ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(type => {
    !resolvers[type] && (resolvers[type] = utils.isFunction(res[type]) ? (res) => res[type]() :
      (_, config) => {
        throw new core_AxiosError(`Response type '${type}' is not supported`, core_AxiosError.ERR_NOT_SUPPORT, config);
      })
  });
})(new Response));

const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }

  if(utils.isBlob(body)) {
    return body.size;
  }

  if(utils.isSpecCompliantForm(body)) {
    const _request = new Request(platform.origin, {
      method: 'POST',
      body,
    });
    return (await _request.arrayBuffer()).byteLength;
  }

  if(utils.isArrayBufferView(body) || utils.isArrayBuffer(body)) {
    return body.byteLength;
  }

  if(utils.isURLSearchParams(body)) {
    body = body + '';
  }

  if(utils.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
}

const resolveBodyLength = async (headers, body) => {
  const length = utils.toFiniteNumber(headers.getContentLength());

  return length == null ? getBodyLength(body) : length;
}

/* harmony default export */ var adapters_fetch = (isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = 'same-origin',
    fetchOptions
  } = resolveConfig(config);

  responseType = responseType ? (responseType + '').toLowerCase() : 'text';

  let composedSignal = helpers_composeSignals([signal, cancelToken && cancelToken.toAbortSignal()], timeout);

  let request;

  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
      composedSignal.unsubscribe();
  });

  let requestContentLength;

  try {
    if (
      onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' &&
      (requestContentLength = await resolveBodyLength(headers, data)) !== 0
    ) {
      let _request = new Request(url, {
        method: 'POST',
        body: data,
        duplex: "half"
      });

      let contentTypeHeader;

      if (utils.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
        headers.setContentType(contentTypeHeader)
      }

      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(
          requestContentLength,
          progressEventReducer(asyncDecorator(onUploadProgress))
        );

        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }

    if (!utils.isString(withCredentials)) {
      withCredentials = withCredentials ? 'include' : 'omit';
    }

    // Cloudflare Workers throws when credentials are defined
    // see https://github.com/cloudflare/workerd/issues/902
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : undefined
    });

    let response = await fetch(request);

    const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');

    if (supportsResponseStream && (onDownloadProgress || (isStreamResponse && unsubscribe))) {
      const options = {};

      ['status', 'statusText', 'headers'].forEach(prop => {
        options[prop] = response[prop];
      });

      const responseContentLength = utils.toFiniteNumber(response.headers.get('content-length'));

      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
        responseContentLength,
        progressEventReducer(asyncDecorator(onDownloadProgress), true)
      ) || [];

      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          unsubscribe && unsubscribe();
        }),
        options
      );
    }

    responseType = responseType || 'text';

    let responseData = await resolvers[utils.findKey(resolvers, responseType) || 'text'](response, config);

    !isStreamResponse && unsubscribe && unsubscribe();

    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: core_AxiosHeaders.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      })
    })
  } catch (err) {
    unsubscribe && unsubscribe();

    if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) {
      throw Object.assign(
        new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      )
    }

    throw core_AxiosError.from(err, err && err.code, config, request);
  }
}));



;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/adapters/adapters.js






const knownAdapters = {
  http: helpers_null,
  xhr: xhr,
  fetch: adapters_fetch
}

utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils.isFunction(adapter) || adapter === null || adapter === false;

/* harmony default export */ var adapters = ({
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new core_AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new core_AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
});

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/env/data.js
const VERSION = "1.7.7";
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var validator = ({
  assertOptions,
  validators
});

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/core/Axios.js











const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy;

        Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
        try {
          if (!err.stack) {
            err.stack = stack;
            // match without the 2 top stack lines
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
            err.stack += '\n' + stack
          }
        } catch (e) {
          // ignore the case where "stack" is an un-writable property
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ var core_Axios = (Axios);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  toAbortSignal() {
    const controller = new AbortController();

    const abort = (err) => {
      controller.abort(err);
    };

    this.subscribe(abort);

    controller.signal.unsubscribe = () => this.unsubscribe(abort);

    return controller.signal;
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ var cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios);

;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/integrations/leads-api/index.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var buildAxiosRequestConfig = function (options) {
    if (options === void 0) { options = {}; }
    return (__assign(__assign({}, options), { headers: __assign({ Accept: 'application/json' }, ('headers' in options && options.headers)) }));
};
var sendLead = function (baseURL, payload, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var request, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!baseURL)
                        throw new Error("A baseURL must be provided for sendLead() to be used.");
                    if (!payload)
                        throw new Error("A payload must be provided to call sendLead().");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    logInvokedLeadRequest(payload);
                    return [4 /*yield*/, lib_axios.post(baseURL.concat("/v3/leads"), payload, buildAxiosRequestConfig(options))];
                case 2:
                    request = _a.sent();
                    data = request.data;
                    logSuccessfulLeadRequest(payload, data);
                    return [2 /*return*/, data];
                case 3:
                    error_1 = _a.sent();
                    logFailedLeadRequest(payload, error_1);
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/LendiGroupLeads/index.js
var LendiGroupLeads_assign = (undefined && undefined.__assign) || function () {
    LendiGroupLeads_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return LendiGroupLeads_assign.apply(this, arguments);
};
var LendiGroupLeads_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var LendiGroupLeads_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





var keyPrefix = configuration.sessionStorageKeyPrefix;
var keySuffixes = configuration.sessionStorageKeySuffixes;
var LendiGroupLeads = /** @class */ (function () {
    function LendiGroupLeads(leadOrigin) {
        this.storageKey = "".concat(keyPrefix, "-").concat(leadOrigin);
    }
    /**
     * set()
     *
     * @version: Used by LALA to identify this lead data is a lg lead as opposed to a legacy lead.
     * @timestamp: Used by this library to identify the latest lead that was set. (see retrieveLatestLeadData())
     *
     * @param payload
     */
    LendiGroupLeads.prototype.set = function (payload) {
        session_storage_sessionStorage.set(this.storageKey, LendiGroupLeads_assign(LendiGroupLeads_assign({}, payload), { version: 'v3', timestamp: new Date().getTime() }));
    };
    LendiGroupLeads.prototype.get = function () {
        return session_storage_sessionStorage.get(this.storageKey) || {};
    };
    Object.defineProperty(LendiGroupLeads, "firstName", {
        get: function () {
            return session_storage_sessionStorage.get("".concat(keyPrefix, "-").concat(keySuffixes.firstName));
        },
        enumerable: false,
        configurable: true
    });
    LendiGroupLeads.prototype.setFirstName = function (firstName) {
        session_storage_sessionStorage.set("".concat(keyPrefix, "-").concat(keySuffixes.firstName), firstName);
    };
    Object.defineProperty(LendiGroupLeads, "email", {
        get: function () {
            return session_storage_sessionStorage.get("".concat(keyPrefix, "-").concat(keySuffixes.email));
        },
        enumerable: false,
        configurable: true
    });
    LendiGroupLeads.prototype.setEmail = function (email) {
        session_storage_sessionStorage.set("".concat(keyPrefix, "-").concat(keySuffixes.email), email);
    };
    Object.defineProperty(LendiGroupLeads, "mobileNumber", {
        get: function () {
            return session_storage_sessionStorage.get("".concat(keyPrefix, "-").concat(keySuffixes.mobileNumber));
        },
        enumerable: false,
        configurable: true
    });
    LendiGroupLeads.prototype.setMobileNumber = function (mobileNumber) {
        session_storage_sessionStorage.set("".concat(keyPrefix, "-").concat(keySuffixes.mobileNumber), mobileNumber);
    };
    Object.defineProperty(LendiGroupLeads, "storeId", {
        /**
         * storeId()
         *
         * Used to get the store id set by broker & store pages for Aussie leads.
         */
        get: function () {
            return session_storage_sessionStorage.get("".concat(keyPrefix, "-").concat(keySuffixes.storeId));
        },
        enumerable: false,
        configurable: true
    });
    /**
     * setStoreId()
     *
     * Used to set a store id by broker & store pages for Aussie leads.
     */
    LendiGroupLeads.setStoreId = function (storeId) {
        session_storage_sessionStorage.set("".concat(keyPrefix, "-").concat(keySuffixes.storeId), storeId);
    };
    /**
     * unsetStoreId()
     *
     * Used to unset a store id set by store pages for Aussie leads.
     */
    LendiGroupLeads.unsetStoreId = function () {
        session_storage_sessionStorage.remove("".concat(keyPrefix, "-").concat(keySuffixes.storeId));
    };
    Object.defineProperty(LendiGroupLeads, "brokerId", {
        /**
         * brokerId()
         *
         * Set by broker & store pages for Aussie leads.
         */
        get: function () {
            return session_storage_sessionStorage.get("".concat(keyPrefix, "-").concat(keySuffixes.brokerId));
        },
        enumerable: false,
        configurable: true
    });
    /**
     * unsetBrokerId()
     *
     * Used to unset a broker id set by broker pages for Aussie leads.
     */
    LendiGroupLeads.unsetBrokerId = function () {
        session_storage_sessionStorage.remove("".concat(keyPrefix, "-").concat(keySuffixes.brokerId));
    };
    /**
     * setBrokerId()
     *
     * Set by broker & store pages for Aussie leads.
     */
    LendiGroupLeads.setBrokerId = function (brokerId) {
        session_storage_sessionStorage.set("".concat(keyPrefix, "-").concat(keySuffixes.brokerId), brokerId);
    };
    LendiGroupLeads.getAllStoredLeads = function () {
        var results = [];
        var leadOrigins = Object.keys(leadStoreGenerator());
        leadOrigins.forEach(function (origin) {
            var data = session_storage_sessionStorage.get("".concat(configuration.sessionStorageKeyPrefix, "-").concat(origin));
            if (data)
                results.push({ data: data, funnelName: origin });
        });
        return results;
    };
    /**
     * retrieveLatestLeadData()
     *
     * Finds the latest stored lead data in sessionStorage
     * by timestamp.
     */
    LendiGroupLeads.retrieveLatestLeadData = function () {
        var defaultLead = {
            funnelName: Origin.SignUp,
            data: { timestamp: 0, version: 'v3' },
        };
        try {
            var leads = this.getAllStoredLeads();
            return leads.reduce(function (acc, funnelData) {
                var _b, _c;
                try {
                    if (((_b = acc === null || acc === void 0 ? void 0 : acc.data) === null || _b === void 0 ? void 0 : _b.timestamp) === undefined || ((_c = funnelData === null || funnelData === void 0 ? void 0 : funnelData.data) === null || _c === void 0 ? void 0 : _c.timestamp) === undefined)
                        return acc;
                    var isLatestLead = acc.data.timestamp < funnelData.data.timestamp;
                    return isLatestLead ? funnelData : acc;
                }
                catch (_d) {
                    return acc;
                }
            }, defaultLead);
        }
        catch (error) {
            datadogLogs.logger.error("An error occurred while retrieve latest lead data.", {}, error);
            return defaultLead;
        }
    };
    var _a;
    _a = LendiGroupLeads;
    /**
     * constructLeadsServicePayload()
     *
     * Used to construct lead data and obtain any additional
     * properties and add them to the lead object before sending
     * the lead data to the leads service.
     *
     * It also deletes properties that are specifically applied by the
     * lendigroup-leads-library (timestamp & version).
     *
     * @param leadData
     * @param returnUrl
     */
    LendiGroupLeads.constructLeadsServicePayload = function (leadData, returnUrl) {
        var leadOrigin = leadData.origin || Origin.SignUp;
        var shouldRetrieveBrokerStorePageData = configuration.brokerStorePageLeadJourneys.includes(leadOrigin);
        var leadAccountOrigin = (leadData === null || leadData === void 0 ? void 0 : leadData.accountOrigin) || retrieveAccountOrigin(leadData);
        var leadStoreId = leadData.storeId || (shouldRetrieveBrokerStorePageData && LendiGroupLeads.storeId);
        var leadOwnerId = (shouldRetrieveBrokerStorePageData && LendiGroupLeads.brokerId) || leadData.ownerId;
        var leadMobileNumber = leadData.mobileNumber || LendiGroupLeads.mobileNumber;
        var leadEmail = leadData.email || LendiGroupLeads.email;
        var leadFirstName = leadData.firstName || LendiGroupLeads.firstName;
        var leadGeneratedAt = new Date().toISOString();
        var leadGclId = retrieveGCLID(leadData.accountOrigin);
        var leadTimezone = leadData.timeZone || getTimezone();
        var retrievedUTMs = retrieveUtm(leadData, returnUrl);
        var lead = LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign({}, leadData), { 
            // Required properties
            mobileNumber: leadMobileNumber, origin: leadOrigin, accountOrigin: leadAccountOrigin, generatedAt: leadGeneratedAt, timeZone: leadTimezone }), (leadData.data && { data: leadData.data })), (leadFirstName && { firstName: leadFirstName })), (leadEmail && { email: leadEmail })), (leadStoreId && { storeId: leadStoreId })), (leadOwnerId && { ownerId: leadOwnerId })), (leadGclId && { gclId: leadGclId })), (retrievedUTMs && { utm: retrievedUTMs }));
        // Cleanup properties set by lendigroup-leads-library
        if ('timestamp' in lead)
            delete lead.timestamp;
        if ('version' in lead)
            delete lead.version;
        return lead;
    };
    /**
     * sendLatestLead()
     *
     * @param baseURL
     * @param additionalLeadProperties
     * @param returnUrl
     * @usage
     *
     * import { LendiGroupLeads } from 'lendigroup-leads-library'
     *
     * LendiGroupLeads.sendLatestLead(baseURL, additionalLeadData)
     */
    LendiGroupLeads.sendLatestLead = function (baseURL, additionalLeadProperties, returnUrl) { return LendiGroupLeads_awaiter(void 0, void 0, void 0, function () {
        var leadFunnelObject, leadFunnelOrigin, leadFunnelData, error_1;
        return LendiGroupLeads_generator(_a, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    leadFunnelObject = this.retrieveLatestLeadData();
                    leadFunnelOrigin = leadFunnelObject.funnelName;
                    leadFunnelData = leadFunnelObject.data;
                    return [4 /*yield*/, sendLead(baseURL, this.constructLeadsServicePayload(LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign({}, leadFunnelData), additionalLeadProperties), { origin: leadFunnelOrigin }), returnUrl))];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    error_1 = _b.sent();
                    datadogLogs.logger.error('An error occurred while sending a lead.', {}, error_1);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /**
     * sendRawLead()
     *
     * Used to send a raw lead to leads v3 API. This lead
     * data will still be validated inside sendLead().
     *
     * @param baseURL
     * @param rawLeadData
     * @usage
     *
     * import { LendiGroupLeads } from 'lendigroup-leads-library'
     *
     * LendiGroupLeads.sendRawLead(baseURL, rawLeadData)
     */
    LendiGroupLeads.sendRawLead = function (baseURL, rawLeadData) { return LendiGroupLeads_awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return LendiGroupLeads_generator(_a, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, sendLead(baseURL, rawLeadData)];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    error_2 = _b.sent();
                    datadogLogs.logger.error("An error occurred while sending a raw lead.", {}, error_2);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return LendiGroupLeads;
}());

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/Affiliate/index.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Affiliate = /** @class */ (function (_super) {
    __extends(Affiliate, _super);
    function Affiliate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Affiliate;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/AppointmentBooking/index.js
var AppointmentBooking_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AppointmentBooking = /** @class */ (function (_super) {
    AppointmentBooking_extends(AppointmentBooking, _super);
    function AppointmentBooking() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AppointmentBooking;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/Blog/index.js
var Blog_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Blog = /** @class */ (function (_super) {
    Blog_extends(Blog, _super);
    function Blog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Blog;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/BorrowingPower/index.js
var BorrowingPower_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var BorrowingPower = /** @class */ (function (_super) {
    BorrowingPower_extends(BorrowingPower, _super);
    function BorrowingPower() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BorrowingPower;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/BusinessLoanAssetFinance/index.js
var BusinessLoanAssetFinance_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var BusinessLoanAssetFinance = /** @class */ (function (_super) {
    BusinessLoanAssetFinance_extends(BusinessLoanAssetFinance, _super);
    function BusinessLoanAssetFinance() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BusinessLoanAssetFinance;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/BusinessLoanCommercial/index.js
var BusinessLoanCommercial_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var BusinessLoanCommercial = /** @class */ (function (_super) {
    BusinessLoanCommercial_extends(BusinessLoanCommercial, _super);
    function BusinessLoanCommercial() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BusinessLoanCommercial;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/CarLoan/index.js
var CarLoan_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var CarLoan = /** @class */ (function (_super) {
    CarLoan_extends(CarLoan, _super);
    function CarLoan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CarLoan;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/Chat/index.js
var Chat_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Chat = /** @class */ (function (_super) {
    Chat_extends(Chat, _super);
    function Chat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Chat;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/CreditScore/index.js
var CreditScore_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var CreditScore = /** @class */ (function (_super) {
    CreditScore_extends(CreditScore, _super);
    function CreditScore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CreditScore;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/FixedRateExpiry/index.js
var FixedRateExpiry_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var FixedRateExpiry = /** @class */ (function (_super) {
    FixedRateExpiry_extends(FixedRateExpiry, _super);
    function FixedRateExpiry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FixedRateExpiry;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/Insurance/index.js
var Insurance_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Insurance = /** @class */ (function (_super) {
    Insurance_extends(Insurance, _super);
    function Insurance() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Insurance;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/Invite/index.js
var Invite_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Invite = /** @class */ (function (_super) {
    Invite_extends(Invite, _super);
    function Invite() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Invite;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/MarketingOther/index.js
var MarketingOther_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var MarketingOther = /** @class */ (function (_super) {
    MarketingOther_extends(MarketingOther, _super);
    function MarketingOther() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MarketingOther;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/NewHomeLoan/index.js
var NewHomeLoan_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var NewHomeLoan = /** @class */ (function (_super) {
    NewHomeLoan_extends(NewHomeLoan, _super);
    function NewHomeLoan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NewHomeLoan;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/PropertyReport/index.js
var PropertyReport_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PropertyReport = /** @class */ (function (_super) {
    PropertyReport_extends(PropertyReport, _super);
    function PropertyReport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertyReport;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/Refinance/index.js
var Refinance_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Refinance = /** @class */ (function (_super) {
    Refinance_extends(Refinance, _super);
    function Refinance() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Refinance;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/RetrievalUtils/index.js

var RetrievalUtils = /** @class */ (function () {
    function RetrievalUtils() {
    }
    RetrievalUtils.retrieveUtm = function (leadData) {
        return retrieveUtm(leadData);
    };
    RetrievalUtils.retrieveGCLID = function (accountOrigin) {
        return retrieveGCLID(accountOrigin);
    };
    RetrievalUtils.retrieveAccountOrigin = function (leadData) {
        return retrieveAccountOrigin(leadData);
    };
    return RetrievalUtils;
}());

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/SelfGen/index.js
var SelfGen_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var SelfGen = /** @class */ (function (_super) {
    SelfGen_extends(SelfGen, _super);
    function SelfGen() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SelfGen;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/SignUp/index.js
var SignUp_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var SignUp = /** @class */ (function (_super) {
    SignUp_extends(SignUp, _super);
    function SignUp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SignUp;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/StampDutyCalculator/index.js
var StampDutyCalculator_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var StampDutyCalculator = /** @class */ (function (_super) {
    StampDutyCalculator_extends(StampDutyCalculator, _super);
    function StampDutyCalculator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StampDutyCalculator;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/AussieHomes/index.js
var AussieHomes_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AussieHomes = /** @class */ (function (_super) {
    AussieHomes_extends(AussieHomes, _super);
    function AussieHomes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AussieHomes;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/AreaReport/index.js
var AreaReport_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AreaReport = /** @class */ (function (_super) {
    AreaReport_extends(AreaReport, _super);
    function AreaReport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AreaReport;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/LisitngSearch/index.js
var LisitngSearch_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var LisitngSearch = /** @class */ (function (_super) {
    LisitngSearch_extends(LisitngSearch, _super);
    function LisitngSearch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LisitngSearch;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/index.js
























//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/lead-store/index.js


var leadStoreGenerator = function () {
    var _a;
    return (_a = {},
        _a[Origin.PropertyReport] = PropertyReport,
        _a[Origin.SignUp] = SignUp,
        _a[Origin.BorrowingPower] = BorrowingPower,
        _a[Origin.NewHomeLoan] = NewHomeLoan,
        _a[Origin.Refinance] = Refinance,
        _a[Origin.Blog] = Blog,
        _a[Origin.StampDutyCalculator] = StampDutyCalculator,
        _a[Origin.AppointmentBooking] = AppointmentBooking,
        _a[Origin.Invite] = Invite,
        _a[Origin.Chat] = Chat,
        _a[Origin.SelfGen] = SelfGen,
        _a[Origin.CreditScore] = CreditScore,
        _a[Origin.FixedRateExpiry] = FixedRateExpiry,
        _a[Origin.AffiliateLead] = Affiliate,
        _a[Origin.MarketingOther] = MarketingOther,
        _a[Origin.CarLoan] = CarLoan,
        _a[Origin.BusinessLoanAssetFinance] = BusinessLoanAssetFinance,
        _a[Origin.BusinessLoanCommercial] = BusinessLoanCommercial,
        _a[Origin.Insurance] = Insurance,
        _a[Origin.AussieHomes] = AussieHomes,
        _a[Origin.AreaReport] = AreaReport,
        _a[Origin.LisitngSearch] = LisitngSearch,
        _a);
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/create-lead/index.js

var createLead = function (origin) {
    var leadStore = leadStoreGenerator();
    if (!Object.keys(leadStore).includes(origin)) {
        throw new Error("Invalid origin of ".concat(origin, " provided. This lead origin is not supported by this library."));
    }
    return new leadStore[origin](origin);
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/constants/index.js
var UTMS = ['utmSource', 'utmContent', 'utmMedium', 'utmCampaign', 'utmTerm'];
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/camel-to-snake/index.js
var camelToSnake = function (str) {
    return str.replace(/([a-zA-Z])(?=[A-Z])/g, '$1_').toLowerCase();
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/remove-duplicate/index.js
var removeDuplicate = function (field) { return (Array.isArray(field) ? field[0] : field); };
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/snake-to-camel/index.js
var snakeToCamel = function (str) { return str.replace(/(_\w)/g, function (k) { return k[1].toUpperCase(); }); };
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/format-utm/index.js
var format_utm_assign = (undefined && undefined.__assign) || function () {
    format_utm_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return format_utm_assign.apply(this, arguments);
};





var isValidUTMParam = function (paramKey) { return Boolean(paramKey.startsWith('utm') && UTMS.includes(paramKey)); };
function formatUtm(queryParams) {
    var defaultUTMs = {
        utmSource: '',
        utmContent: '',
        utmMedium: '',
        utmCampaign: '',
        utmTerm: '',
    };
    try {
        var parsedUTMs = Object.keys(queryParams)
            .map(function (queryParamKey) { return snakeToCamel(queryParamKey); })
            .filter(function (queryParamKey) { return isValidUTMParam(queryParamKey); })
            .reduce(function (acc, utmParamKey) {
            var _a;
            var _b;
            return (format_utm_assign(format_utm_assign({}, acc), (_a = {}, _a[utmParamKey] = removeDuplicate((_b = queryParams[camelToSnake(utmParamKey)]) !== null && _b !== void 0 ? _b : queryParams[utmParamKey]), _a)));
        }, {});
        return parsedUTMs;
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred while attempting to retrieve UTM's from query data", {}, error);
        return defaultUTMs;
    }
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/jstz/index.js
var jstz = __webpack_require__(96342);
var jstz_default = /*#__PURE__*/__webpack_require__.n(jstz);
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/get-timezone/index.js


var getTimezone = function (defaultTimezone) {
    if (defaultTimezone === void 0) { defaultTimezone = esm_configuration.defaultTimezone; }
    try {
        var timezone = jstz_default().determine();
        return timezone.name() || defaultTimezone;
    }
    catch (_a) {
        return defaultTimezone;
    }
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/create-pii-excluded-lead-log/index.js
var createPIIExcludedLeadLog = function (lead) { return ({
    leadHasMobileNumber: Boolean('mobileNumber' in lead && (lead === null || lead === void 0 ? void 0 : lead.mobileNumber)),
    leadHasEmail: Boolean('email' in lead && (lead === null || lead === void 0 ? void 0 : lead.email)),
    leadHasAccountOrigin: Boolean('accountOrigin' in lead && (lead === null || lead === void 0 ? void 0 : lead.accountOrigin)),
    leadHasFirstName: Boolean('firstName' in lead && (lead === null || lead === void 0 ? void 0 : lead.firstName)),
    leadHasLastName: Boolean('lastName' in lead && (lead === null || lead === void 0 ? void 0 : lead.lastName)),
    generatedAt: lead === null || lead === void 0 ? void 0 : lead.generatedAt,
    customerId: lead === null || lead === void 0 ? void 0 : lead.customerId,
    brand: lead === null || lead === void 0 ? void 0 : lead.brand,
    utm: lead === null || lead === void 0 ? void 0 : lead.utm,
    origin: lead === null || lead === void 0 ? void 0 : lead.origin,
    timeZone: lead === null || lead === void 0 ? void 0 : lead.timeZone,
    storeId: lead === null || lead === void 0 ? void 0 : lead.storeId,
    ownerId: lead === null || lead === void 0 ? void 0 : lead.ownerId,
    gclId: lead === null || lead === void 0 ? void 0 : lead.gclId,
}); };
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/log-utils/index.js


var logInvokedLeadRequest = function (payload) {
    datadogLogs.logger.info('Lead request invoked.', {
        leadData: createPIIExcludedLeadLog(payload),
    });
};
var logSuccessfulLeadRequest = function (payload, response) {
    datadogLogs.logger.info('Lead request successful.', {
        leadData: createPIIExcludedLeadLog(payload),
        response: response,
    });
};
var logFailedLeadRequest = function (payload, error) {
    datadogLogs.logger.error('Lead request failed.', {
        leadData: createPIIExcludedLeadLog(payload),
    }, error);
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/qs/lib/index.js
var lib = __webpack_require__(33348);
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/retrieve-account-origin/index.js



var retrieveAccountOriginFromQueryString = function () {
    var queryString = lib.parse(location === null || location === void 0 ? void 0 : location.search, { ignoreQueryPrefix: true });
    return (queryString === null || queryString === void 0 ? void 0 : queryString.origin) || '';
};
var retrieveAccountOriginFromLeadData = function (leadData) {
    var _a;
    try {
        return (leadData === null || leadData === void 0 ? void 0 : leadData.accountOrigin) || ((_a = leadData === null || leadData === void 0 ? void 0 : leadData.data) === null || _a === void 0 ? void 0 : _a.accountOrigin) || '';
    }
    catch (_b) {
        return '';
    }
};
var retrieveAccountOrigin = function (leadData) {
    try {
        return leadData && retrieveAccountOriginFromLeadData(leadData)
            ? retrieveAccountOriginFromLeadData(leadData)
            : retrieveAccountOriginFromQueryString();
    }
    catch (error) {
        datadogLogs.logger.error('An error occurred while attempting to retrieve account origin from lead data.', { leadData: leadData ? createPIIExcludedLeadLog(leadData) : {} }, error);
        return '';
    }
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/retrieve-gcl-id/index.js



var retrieveGCLID = function (accountOrigin) {
    var _a, _b;
    try {
        if (location === null || location === void 0 ? void 0 : location.search) {
            var queryString = lib.parse(location === null || location === void 0 ? void 0 : location.search, { ignoreQueryPrefix: true });
            return ((_a = removeDuplicate(queryString.gclid)) === null || _a === void 0 ? void 0 : _a.toString()) || null;
        }
        else if (accountOrigin) {
            var queryString = lib.parse(new URL(accountOrigin).search, { ignoreQueryPrefix: true });
            return ((_b = removeDuplicate(queryString.gclid)) === null || _b === void 0 ? void 0 : _b.toString()) || null;
        }
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred while attempting to retrieve GclId.", { error: error }, error);
    }
    return null;
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/add-protocol-if-missing/index.js
var addProtocolIfMissing = function (url) {
    if (!/^(?:f|ht)tps?:\/\//.test(url)) {
        url = 'http://' + url;
    }
    return url;
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/retrieve-utm/index.js
var retrieve_utm_assign = (undefined && undefined.__assign) || function () {
    retrieve_utm_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return retrieve_utm_assign.apply(this, arguments);
};




var replaceLTMsWithUTMs = function (payload) {
    return payload.replace(/ltm_(?<verb>(term|campaign|content|source|medium))/gm, 'utm_$<verb>');
};
var emptyUTMsObject = {
    utmSource: '',
};
var parseUTMsFromURLOrPath = function (payload) {
    if (!payload)
        return emptyUTMsObject;
    var parsedPayload = payload.indexOf('utm') === -1 ? replaceLTMsWithUTMs(payload) : payload;
    var parsedQueryString = lib.parse(parsedPayload, { ignoreQueryPrefix: true });
    var parsedUTMs = formatUtm(parsedQueryString);
    var nestedParamsPossible = Boolean(!(parsedUTMs === null || parsedUTMs === void 0 ? void 0 : parsedUTMs.utmSource) && (parsedQueryString === null || parsedQueryString === void 0 ? void 0 : parsedQueryString.returnURL));
    if (nestedParamsPossible) {
        var parsedReturnURLParams = parseUTMsFromURLOrPath(new URL(addProtocolIfMissing(parsedQueryString.returnURL)).search);
        return retrieve_utm_assign(retrieve_utm_assign({}, parsedUTMs), parsedReturnURLParams);
    }
    return parsedUTMs;
};
var parseUTMsFromCurrentUrl = function () {
    var _a;
    try {
        return parseUTMsFromURLOrPath((_a = location === null || location === void 0 ? void 0 : location.search) !== null && _a !== void 0 ? _a : '');
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred parsing location.search, see errorDetails for more information.", {
            errorDetails: {
                error: error,
                locationSearch: location === null || location === void 0 ? void 0 : location.search,
            },
        });
        return emptyUTMsObject;
    }
};
/**
 * parseUTMsFromReturnURL()
 *
 * Sources UTM data from returnURL if provided.
 *
 * @param returnUrl
 */
var parseUTMsFromReturnURL = function (returnUrl) {
    try {
        if (!returnUrl)
            return emptyUTMsObject;
        var builtReturnURL = new URL(addProtocolIfMissing(returnUrl));
        return parseUTMsFromURLOrPath(builtReturnURL.search);
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred parsing UTMs from returnURL, see errorDetails for more information.", {
            errorDetails: {
                error: error,
                returnURL: returnUrl !== null && returnUrl !== void 0 ? returnUrl : '',
            },
        });
        return emptyUTMsObject;
    }
};
/**
 * parseUTMsFromAccountOrigin()
 *
 * Sources UTMs from accountOrigin if provided.
 *
 * @param accountOrigin
 */
var parseUTMsFromAccountOrigin = function (accountOrigin) {
    try {
        if (!accountOrigin)
            return emptyUTMsObject;
        var builtAccountOrigin = new URL(addProtocolIfMissing(accountOrigin));
        return parseUTMsFromURLOrPath(builtAccountOrigin.search);
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred parsing account origin, see errorDetails for more information.", {
            errorDetails: {
                error: error,
                accountOrigin: accountOrigin,
            },
        });
        return emptyUTMsObject;
    }
};
var isValidUTMData = function (utmData) {
    try {
        return !!(utmData === null || utmData === void 0 ? void 0 : utmData.utmSource);
    }
    catch (_a) {
        return false;
    }
};
/**
 * Retrieve UTMs is used to retrieve UTMs with consideration for fallbacks and niche flows.
 *
 * The fallback flow is as follows:
 *
 * - If UTMs are in lead data, the lead UTM data will be used.
 * - If UTMs are found in the current URL (location?.search), the current URL UTM data will be used.
 * - If UTMs are found using the account origin set in the lead data, the account origin UTM data will be used.
 * - If UTMs are found in the returnURL provided by LALA, the returnURL UTM data will be used.
 *
 * In order for lead data to be considered valid, it must contain utmSource with a value, the rest are optional.
 *
 * ie:
 *
 * ```
 * {
 *   utmSource: 'some-utm-source'
 * }
 * ```
 *
 * @param leadData
 * @param returnUrl - Provided by LALA due to Domain redirection flow, absolute fallback for sourcing UTMs
 */
var retrieveUtm = function (leadData, returnUrl) {
    var _a;
    try {
        var leadDataUTMs = ((_a = leadData === null || leadData === void 0 ? void 0 : leadData.utm) === null || _a === void 0 ? void 0 : _a.utmSource) ? leadData === null || leadData === void 0 ? void 0 : leadData.utm : emptyUTMsObject;
        var currentUrlUTMs = parseUTMsFromCurrentUrl();
        var accountOriginUTMs = parseUTMsFromAccountOrigin(leadData === null || leadData === void 0 ? void 0 : leadData.accountOrigin);
        var returnUrlUTMs = parseUTMsFromReturnURL(returnUrl);
        if (isValidUTMData(leadDataUTMs))
            return leadDataUTMs;
        if (isValidUTMData(currentUrlUTMs))
            return currentUrlUTMs;
        if (isValidUTMData(accountOriginUTMs))
            return accountOriginUTMs;
        if (isValidUTMData(returnUrlUTMs))
            return returnUrlUTMs;
        return false;
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred while attempting to retrieve UTMs.", {}, error);
        return false;
    }
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/store/plugins/defaults.js
var plugins_defaults = __webpack_require__(2053);
var defaults_default = /*#__PURE__*/__webpack_require__.n(plugins_defaults);
// EXTERNAL MODULE: ../../../node_modules/store/src/store-engine.js
var store_engine = __webpack_require__(4330);
var store_engine_default = /*#__PURE__*/__webpack_require__.n(store_engine);
// EXTERNAL MODULE: ../../../node_modules/store/storages/sessionStorage.js
var sessionStorage = __webpack_require__(33600);
var sessionStorage_default = /*#__PURE__*/__webpack_require__.n(sessionStorage);
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/session-storage/index.js



var session_storage_sessionStorage = store_engine_default().createStore([(sessionStorage_default())], [(defaults_default())]);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/index.js















//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/index.js

// Library Setup
initializeLogger();




//# sourceMappingURL=index.js.map

/***/ }),

/***/ 66299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ BreakpointMedia; },
/* harmony export */   "G": function() { return /* binding */ Gutters; },
/* harmony export */   "L": function() { return /* binding */ LineHeight; },
/* harmony export */   "_": function() { return /* binding */ _objectSpread2; },
/* harmony export */   "a": function() { return /* binding */ Breakpoint; },
/* harmony export */   "b": function() { return /* binding */ baseFontSize; },
/* harmony export */   "f": function() { return /* binding */ fontSize; }
/* harmony export */ });
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

// Spacing in LUI now is all based in px values, we could redefine these in LUI now (in a more sensible reusable place)
// Needs to be compatable with Figma so can we even use rems here
/**
 * @property {string}  xxxs = 4px
 * @property {string}  xxs = 8px
 * @property {string}  xs = 12px
 * @property {string}  sm = 16px
 * @property {string}  md = 24px
 * @property {string}  lg = 32px
 * @property {string}  xl = 40px
 * @property {string}  xxl = 64px
 * @property {string}  xxxl = 80px
 */
var Spacing = {
  xxxs: '0.25rem',
  xxs: '0.5rem',
  xs: '0.75rem',
  sm: '1rem',
  md: '1.5rem',
  lg: '2rem',
  xl: '2.5rem',
  xxl: '4rem',
  xxxl: '5rem'
};
var Breakpoint = {
  xs: '35.9375rem',
  sm: '36rem',
  md: '48rem',
  lg: '62rem',
  xl: '75rem'
};
var BreakpointMedia = {
  xs: "@media (max-width: ".concat(Breakpoint.xs, ")"),
  sm: "@media (min-width: ".concat(Breakpoint.sm, ")"),
  md: "@media (min-width: ".concat(Breakpoint.md, ")"),
  lg: "@media (min-width: ".concat(Breakpoint.lg, ")"),
  xl: "@media (min-width: ".concat(Breakpoint.xl, ")")
};
var Gutters = {
  md: Spacing.md,
  sm: Spacing.sm
};
var LineHeight = {
  nospace: 1,
  heading: 1.2,
  body: 1.5
};
var baseFontSize = 16;

// Font size is kept in pixels but converted to rem when used
var fontSize = {
  '1': 12,
  '2': 14,
  '3': 16,
  '4': 18,
  '5': 20,
  '6': 24,
  '7': 28,
  '8': 32,
  '9': 40,
  '10': 48
};




/***/ }),

/***/ 38570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ GlobalStyle; },
/* harmony export */   "a": function() { return /* binding */ aussieTheme; },
/* harmony export */   "d": function() { return /* binding */ domainTheme; },
/* harmony export */   "l": function() { return /* binding */ lendiNextTheme; },
/* harmony export */   "s": function() { return /* binding */ setThemeName; },
/* harmony export */   "t": function() { return /* binding */ theme; },
/* harmony export */   "u": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var _index_03130070_esm_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66299);
/* harmony import */ var _lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7401);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96324);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32735);





var colorPrefixes = ['primary', 'secondary', 'tertiary', 'shade', 'info', 'warn', 'error', 'success']; // All available prefix

var capitalizeFirstLetter = string => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * Custom setThemeName function
 *
 * At runtime, it sets the correct theme to the `document`
 *
 * It replys on `document` `data-attributes` as primary mechanism,
 * ans `sessionStoryage` as a backup mechanism.
 *
 * It works in conjunction with Custom getThemeName from `@lendi-ui/commons`
 *
 * @deprecated Deprecated since 0.2.3. Use SC's Theme instead.
 */
var setThemeName = themeName => {
  // Check browser for runtime
  if (_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .jU) {
    var _window;
    // Get `theme` from DOM `data-attributes` if it's already available.
    var dataTheme = (_window = window) === null || _window === void 0 ? void 0 : _window.document.documentElement.getAttribute(_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .themeAttribute */ .SY);

    // Check `domTheme` against provided runtime `themeName`
    if (dataTheme !== themeName) {
      var _window2;
      // If different, set runtime `themeName` to data-attributes
      (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.document.documentElement.setAttribute(_lendi_ui_commons_utils__WEBPACK_IMPORTED_MODULE_1__/* .themeAttribute */ .SY, themeName);

      // If different, set runtime `themeName` to sessionStorage
      try {
        var themeValue = JSON.stringify({
          label: capitalizeFirstLetter(themeName),
          value: themeName
        });
        window.sessionStorage.setItem('theme', themeValue);
      } catch (error) {
        // TODO: Report Error
      }
    }
  }
};
var mapToColorsLegacyFormat = colorToken => {
  var colors = {};
  var categories = Object.keys(colorToken);
  var shouldInclude = category => colorPrefixes.includes(category);
  categories.filter(shouldInclude).map(category => {
    var transparencies = Object.keys(colorToken[category]);
    transparencies.map(transparency => {
      colors = (0,_index_03130070_esm_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_index_03130070_esm_js__WEBPACK_IMPORTED_MODULE_0__._)({}, colors), {}, {
        ["".concat(category, ".").concat(transparency)]: colorToken[category][transparency]
      });
    });
  });
  return colors;
};

var tokens$3 = {
	asset: {
		font: {
			heading: {
				weight: 700,
				family: "'Cabin', sans-serif",
				metrics: {
					familyName: "Cabin",
					capHeight: 1400,
					ascent: 1930,
					descent: -500,
					lineGap: 0,
					unitsPerEm: 2000
				}
			},
			body: {
				weight: 400,
				family: "'Open Sans', sans-serif",
				metrics: {
					familyName: "Open Sans",
					capHeight: 1462,
					ascent: 2189,
					descent: -600,
					lineGap: 0,
					unitsPerEm: 2048
				}
			}
		}
	},
	color: {
		info: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431",
			"950": "#112431"
		},
		error: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314",
			"950": "#331314"
		},
		success: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210",
			"950": "#0d2210"
		},
		warn: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12",
			"950": "#321e12"
		},
		ultramarine: {
			"25": "#fbfbff",
			"50": "#f6f7ff",
			"100": "#eaecff",
			"200": "#d3d8ff",
			"300": "#a9b3ff",
			"400": "#8291ff",
			"500": "#5e72ff",
			"600": "#3d53f5",
			"700": "#3645b8",
			"800": "#29337b",
			"900": "#171b3d"
		},
		transparent: {
			"0": "rgba(0, 0, 0, 0)"
		},
		white: {
			"0": "#ffffff"
		},
		black: {
			"1000": "#000000"
		},
		green: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210"
		},
		red: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314"
		},
		orange: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12"
		},
		blue: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431"
		},
		primary: {
			"25": "#f2fbfa",
			"50": "#e5f8f6",
			"100": "#ccf2ed",
			"200": "#99e5db",
			"300": "#66d9c9",
			"400": "#32ccb7",
			"500": "#00c0a5",
			"600": "#329984",
			"700": "#007363",
			"800": "#004c42",
			"900": "#002621",
			"950": "#001310"
		},
		secondary: {
			"25": "#f2f6f7",
			"50": "#e6eef0",
			"100": "#cedee1",
			"200": "#9ebdc4",
			"300": "#6d9ca7",
			"400": "#3d7a8a",
			"500": "#0d5a6d",
			"600": "#0a4857",
			"700": "#073641",
			"800": "#05242b",
			"900": "#021215",
			"950": "#01080a"
		},
		tertiary: {
			"25": "#fff7f7",
			"50": "#fff0ef",
			"100": "#ffe2df",
			"200": "#ffc5c0",
			"300": "#ffa9a1",
			"400": "#ff8c82",
			"500": "#ff7063",
			"600": "#cc594f",
			"700": "#99433b",
			"800": "#662c27",
			"900": "#331613",
			"950": "#190b09"
		},
		shade: {
			"0": "#ffffff",
			"25": "#f8f8f8",
			"50": "#f1f1f1",
			"100": "#e3e3e3",
			"200": "#c8c8c8",
			"300": "#adadad",
			"400": "#929292",
			"500": "#777777",
			"600": "#5f5f5f",
			"700": "#474747",
			"800": "#2f2f2f",
			"900": "#171717",
			"950": "#0b0b0b",
			"1000": "#000000"
		},
		text: {
			main: "#474747",
			subtle: "#5f5f5f",
			inverse: "#ffffff",
			contrast: "#0d5a6d"
		},
		interaction: {
			main: "#00c0a5",
			subtle: "#ffffff",
			contrast: "#00c0a5",
			emphasis: "#ff7063",
			disabled: "#474747",
			success: "#2cac41",
			error: "#ff282f"
		},
		fill: {
			main: "#ffffff",
			selected: "#e5f8f6",
			disabled: "#f8f8f8",
			accent: "#00c0a5",
			contrast: "#0d5a6d"
		},
		background: {
			page: "#f8f8f8",
			container: "#ffffff",
			surface: "#e3e3e3",
			emphasis: "#f1f1f1"
		},
		border: {
			container: "#e3e3e3",
			divider: "#adadad",
			dividerEmphasis: "#2f2f2f",
			interaction: {
				"default": "#c8c8c8",
				hover: "#0d5a6d",
				selected: "#00c0a5",
				focus: "#3f86f7"
			}
		},
		buttonFill: {
			primary: {
				"default": "#00c0a5",
				hover: "#32ccb7",
				focus: "#329984",
				disabled: "#00c0a5",
				pressed: "#329984"
			},
			primaryInverse: {
				"default": "#ff7063",
				hover: "#ffffff",
				focus: "#ff7063",
				disabled: "#f8f8f8",
				pressed: "#ff7063"
			},
			secondary: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#e5f8f6"
			},
			secondaryInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#ffffff",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#e5f8f6"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "rgba(0, 0, 0, 0)",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "rgba(0, 0, 0, 0)"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "rgba(0, 0, 0, 0)",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "rgba(0, 0, 0, 0)"
			}
		},
		buttonForeground: {
			primary: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#ffffff"
			},
			primaryInverse: {
				"default": "#ffffff",
				hover: "#ff7063",
				focused: "#ffffff",
				disabled: "#474747",
				pressed: "#ffffff"
			},
			secondary: {
				"default": "#00c0a5",
				hover: "#00c0a5",
				focus: "#00c0a5",
				disabled: "#00c0a5",
				pressed: "#329984"
			},
			secondaryInverse: {
				"default": "#ffffff",
				hover: "#00c0a5",
				focused: "#ffffff",
				disabled: "#ffffff",
				pressed: "#329984"
			},
			text: {
				"default": "#00c0a5",
				hover: "#00c0a5",
				focus: "#00c0a5",
				disabled: "#00c0a5",
				pressed: "#329984"
			},
			textInverse: {
				"default": "#ffffff",
				hover: "#00c0a5",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#ffffff"
			}
		},
		buttonBorder: {
			primary: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "rgba(0, 0, 0, 0)"
			},
			primaryInverse: {
				pressed: "#ff7063",
				"default": "#ff7063",
				hover: "#ffffff",
				focus: "#ff7063",
				disabled: "#474747"
			},
			secondary: {
				"default": "#00c0a5",
				hover: "#32ccb7",
				focus: "#00c0a5",
				disabled: "#00c0a5",
				pressed: "#329984"
			},
			secondaryInverse: {
				"default": "#ffffff",
				hover: "#00c0a5",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#329984"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "rgba(0, 0, 0, 0)",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "rgba(0, 0, 0, 0)"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "rgba(0, 0, 0, 0)",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "rgba(0, 0, 0, 0)"
			}
		}
	},
	size: {
		breakpoint: {
			mobile: "0rem",
			tablet: "36rem",
			desktop: "62rem",
			sm: "36rem",
			md: "48rem",
			lg: "62rem",
			xl: "75rem"
		}
	}
};

var themeName$3 = 'lendi';

/**
 * @deprecated Use tokens instead
 */
var typography$2 = {
  /**
   * @deprecated Use `asset.font.heading.family` instead
   */
  heading: {
    fontFamily: tokens$3.asset.font.heading.family
  },
  /**
   * @deprecated Use `asset.font.body.family` instead
   */
  body: {
    fontFamily: tokens$3.asset.font.body.family
  }
};

/**
 * @deprecated Use `theme.name` instead
 * @example
 * import { useTheme } from '@lendi/ui/Theme';
 *
 * const theme = useTheme();
 * const themeName = theme.name;
 */
var logo$1 = {
  logoName: 'LendiLogo'
};
var borderRadius$1 = '6px';

/**
 * @deprecated Use `theme.color.xxx.yyy` instead. Will be removed in future major release.
 * @example
 * import { useTheme } from '@lendi/ui/Theme';
 *
 * const theme = useTheme();
 * theme.color.interaction.main;
 */
// @ts-expect-error
var colors$1 = mapToColorsLegacyFormat(tokens$3.color);
var theme = (0,_index_03130070_esm_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_index_03130070_esm_js__WEBPACK_IMPORTED_MODULE_0__._)({
  typography: typography$2,
  colors: colors$1,
  logo: logo$1,
  borderRadius: borderRadius$1
}, tokens$3), {}, {
  name: themeName$3
});

var tokens$2 = {
	asset: {
		font: {
			heading: {
				weight: 700,
				family: "'F37 Bolton', Helvetica, Arial, sans-serif",
				metrics: {
					fontFamily: "F37 Bolton",
					capHeight: 717,
					ascent: 714,
					descent: -286,
					lineGap: 250,
					unitsPerEm: 1000
				}
			},
			body: {
				weight: 400,
				family: "'F37 Bolton', Helvetica, Arial, sans-serif",
				metrics: {
					fontFamily: "F37 Bolton",
					capHeight: 717,
					ascent: 714,
					descent: -286,
					lineGap: 250,
					unitsPerEm: 1000
				}
			}
		}
	},
	color: {
		info: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431",
			"950": "#112431"
		},
		error: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314",
			"950": "#331314"
		},
		success: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210",
			"950": "#0d2210"
		},
		warn: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12",
			"950": "#321e12"
		},
		ultramarine: {
			"25": "#fbfbff",
			"50": "#f6f7ff",
			"100": "#eaecff",
			"200": "#d3d8ff",
			"300": "#a9b3ff",
			"400": "#8291ff",
			"500": "#5e72ff",
			"600": "#3d53f5",
			"700": "#3645b8",
			"800": "#29337b",
			"900": "#171b3d"
		},
		transparent: {
			"0": "rgba(0, 0, 0, 0)"
		},
		white: {
			"0": "#ffffff"
		},
		black: {
			"1000": "#000000"
		},
		green: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210"
		},
		red: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314"
		},
		orange: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12"
		},
		blue: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431"
		},
		primary: {
			"25": "#e4ffe2",
			"50": "#caffc5",
			"100": "#abfca4",
			"200": "#85f27c",
			"300": "#56d94a",
			"400": "#2ec121",
			"500": "#0ea800",
			"600": "#16860b",
			"700": "#186511",
			"800": "#154311",
			"900": "#0d220b",
			"950": "#0d220b"
		},
		secondary: {
			"25": "#f4f8fe",
			"50": "#eaf1fd",
			"100": "#dae5f9",
			"200": "#c1d2ee",
			"300": "#98aed4",
			"400": "#748eba",
			"500": "#5470a1",
			"600": "#3a5687",
			"700": "#25406e",
			"800": "#142c54",
			"900": "#0e182a",
			"950": "#0e182a"
		},
		tertiary: {
			"25": "#f8f7ff",
			"50": "#f1efff",
			"100": "#e4e1ff",
			"200": "#cdc8ff",
			"300": "#a89ffb",
			"400": "#857ae9",
			"500": "#6458d7",
			"600": "#483bc5",
			"700": "#3b3194",
			"800": "#292363",
			"900": "#161331",
			"950": "#161331"
		},
		lime: {
			"25": "#e4ffe2",
			"50": "#caffc5",
			"100": "#abfca4",
			"200": "#85f27c",
			"300": "#56d94a",
			"400": "#2ec121",
			"500": "#0ea800",
			"600": "#16860b",
			"700": "#186511",
			"800": "#154311",
			"900": "#0d220b"
		},
		navy: {
			"25": "#f4f8fe",
			"50": "#eaf1fd",
			"100": "#dae5f9",
			"200": "#c1d2ee",
			"300": "#98aed4",
			"400": "#748eba",
			"500": "#5470a1",
			"600": "#3a5687",
			"700": "#25406e",
			"800": "#142c54",
			"900": "#0e182a"
		},
		ocean: {
			"25": "#f8f7ff",
			"50": "#f1efff",
			"100": "#e4e1ff",
			"200": "#cdc8ff",
			"300": "#a89ffb",
			"400": "#857ae9",
			"500": "#6458d7",
			"600": "#483bc5",
			"700": "#3b3194",
			"800": "#292363",
			"900": "#161331"
		},
		vermillion: {
			"25": "#fff5f3",
			"50": "#ffe9e5",
			"100": "#ffd8d1",
			"200": "#ffbeb2",
			"300": "#ff9684",
			"400": "#f8715a",
			"500": "#e84f34",
			"600": "#d93013",
			"700": "#a3301c",
			"800": "#6d281c",
			"900": "#361712"
		},
		grey: {
			"25": "#fbfbfc",
			"50": "#f8f8f9",
			"100": "#eff0f3",
			"200": "#dbdee5",
			"300": "#b5bcca",
			"400": "#929cae",
			"500": "#727d92",
			"600": "#556177",
			"700": "#3c475b",
			"800": "#232c3d",
			"900": "#0f141e"
		},
		shade: {
			"0": "#ffffff",
			"25": "#fbfbfc",
			"50": "#f8f8f9",
			"100": "#eff0f3",
			"200": "#dbdee5",
			"300": "#b5bcca",
			"400": "#929cae",
			"500": "#727d92",
			"600": "#556177",
			"700": "#3c475b",
			"800": "#232c3d",
			"900": "#0f141e",
			"950": "#0b0b0b",
			"1000": "#000000"
		},
		text: {
			main: "#0f141e",
			subtle: "#3c475b",
			contrast: "#142c54",
			inverse: "#ffffff",
			"default": "#0f141e"
		},
		interaction: {
			main: "#0ea800",
			subtle: "#ffffff",
			contrast: "#0ea800",
			emphasis: "#d93013",
			disabled: "#929cae",
			success: "#288a38",
			error: "#cc2b30"
		},
		fill: {
			main: "#ffffff",
			contrast: "#142c54",
			accent: "#0ea800",
			selected: "#eaf1fd",
			disabled: "#f8f8f9"
		},
		background: {
			page: "#fbfbfc",
			container: "#ffffff",
			surface: "#eff0f3",
			emphasis: "#f8f8f9"
		},
		border: {
			container: "#dbdee5",
			divider: "#eff0f3",
			dividerEmphasis: "#0f141e",
			interaction: {
				"default": "#727d92",
				hover: "#3c475b",
				focus: "#5e72ff",
				selected: "#142c54"
			}
		},
		buttonFill: {
			primary: {
				"default": "#0ea800",
				hover: "#2ec121",
				focus: "#0ea800",
				disabled: "#929cae",
				pressed: "#16860b"
			},
			primaryInverse: {
				"default": "#ffffff",
				hover: "#e4ffe2",
				focus: "#ffffff",
				disabled: "#f8f8f9",
				pressed: "#caffc5"
			},
			secondary: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e4ffe2",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#caffc5"
			},
			secondaryInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#25406e",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#0e182a"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e4ffe2",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#caffc5"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#25406e",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#0e182a"
			}
		},
		buttonForeground: {
			primary: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#ffffff"
			},
			primaryInverse: {
				"default": "#0ea800",
				hover: "#0ea800",
				focused: "#0ea800",
				disabled: "#929cae",
				pressed: "#0ea800"
			},
			secondary: {
				"default": "#0ea800",
				hover: "#0ea800",
				focused: "#0ea800",
				disabled: "#929cae",
				pressed: "#0ea800"
			},
			secondaryInverse: {
				"default": "#ffffff",
				hover: "#ffffff",
				focused: "#ffffff",
				disabled: "#929cae",
				pressed: "#ffffff"
			},
			text: {
				"default": "#0ea800",
				hover: "#0ea800",
				focused: "#0ea800",
				disabled: "#929cae",
				pressed: "#0ea800"
			},
			textInverse: {
				"default": "#ffffff",
				hover: "#ffffff",
				focused: "#ffffff",
				disabled: "#929cae",
				pressed: "#ffffff"
			}
		},
		buttonBorder: {
			primary: {
				"default": "#0ea800",
				hover: "#2ec121",
				focus: "#0ea800",
				disabled: "#929cae",
				pressed: "#16860b"
			},
			primaryInverse: {
				"default": "#ffffff",
				hover: "#e4ffe2",
				focus: "#ffffff",
				disabled: "#f8f8f9",
				pressed: "#caffc5"
			},
			secondary: {
				"default": "#0ea800",
				hover: "#0ea800",
				focus: "#0ea800",
				disabled: "#929cae",
				pressed: "#0ea800"
			},
			secondaryInverse: {
				"default": "#ffffff",
				focus: "#ffffff",
				hover: "#ffffff",
				pressed: "#ffffff",
				disabled: "#929cae"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e4ffe2",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#caffc5"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#25406e",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#0e182a"
			}
		}
	},
	size: {
		breakpoint: {
			mobile: "0rem",
			tablet: "36rem",
			desktop: "62rem",
			sm: "36rem",
			md: "48rem",
			lg: "62rem",
			xl: "75rem"
		}
	}
};

var themeName$2 = 'domain';

/**
 * @deprecated Use tokens instead
 */
var typography$1 = {
  /**
   * @deprecated Use `asset.font.heading.family` instead
   */
  heading: {
    fontFamily: tokens$2.asset.font.heading.family
  },
  /**
   * @deprecated Use `asset.font.body.family` instead
   */
  body: {
    fontFamily: tokens$2.asset.font.body.family
  }
};

/**
 * @deprecated Use `theme.name` instead
 * @example
 * import { useTheme } from '@lendi/ui/Theme';
 *
 * const theme = useTheme();
 * const themeName = theme.name;
 */
var logo = {
  logoName: 'DomainLogo'
};
var borderRadius = '3px';

/**
 * @deprecated Use `theme.color.xxx.yyy` instead. Will be removed in future major release.
 * @example
 * const theme = useTheme();
 * theme.color.interaction.main;
 */
// @ts-expect-error
var colors = mapToColorsLegacyFormat(tokens$2.color);

/**
 * @since 9.2.3
 */

var domainTheme = (0,_index_03130070_esm_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_index_03130070_esm_js__WEBPACK_IMPORTED_MODULE_0__._)({
  typography: typography$1,
  colors,
  logo,
  borderRadius
}, tokens$2), {}, {
  name: themeName$2
});

var tokens$1 = {
	asset: {
		font: {
			heading: {
				weight: 700,
				family: "'Cabin', sans-serif",
				metrics: {
					familyName: "Cabin",
					capHeight: 1400,
					ascent: 1930,
					descent: -500,
					lineGap: 0,
					unitsPerEm: 2000
				}
			},
			body: {
				weight: 400,
				family: "'Open Sans', sans-serif",
				metrics: {
					familyName: "Open Sans",
					capHeight: 1462,
					ascent: 2189,
					descent: -600,
					lineGap: 0,
					unitsPerEm: 2048
				}
			}
		}
	},
	color: {
		info: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431",
			"950": "#112431"
		},
		error: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314",
			"950": "#331314"
		},
		success: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210",
			"950": "#0d2210"
		},
		warn: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12",
			"950": "#321e12"
		},
		ultramarine: {
			"25": "#fbfbff",
			"50": "#f6f7ff",
			"100": "#eaecff",
			"200": "#d3d8ff",
			"300": "#a9b3ff",
			"400": "#8291ff",
			"500": "#5e72ff",
			"600": "#3d53f5",
			"700": "#3645b8",
			"800": "#29337b",
			"900": "#171b3d"
		},
		transparent: {
			"0": "rgba(0, 0, 0, 0)"
		},
		white: {
			"0": "#ffffff"
		},
		black: {
			"1000": "#000000"
		},
		green: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210"
		},
		red: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314"
		},
		orange: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12"
		},
		blue: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431"
		},
		tiber: {
			"25": "#f0fafc",
			"50": "#e0f5fa",
			"100": "#cdedf4",
			"200": "#b0dce6",
			"300": "#85becb",
			"400": "#61a1b0",
			"500": "#428594",
			"600": "#296a79",
			"700": "#15505d",
			"800": "#083742",
			"900": "#091d21"
		},
		turquoise: {
			"25": "#dbfffa",
			"50": "#b7fff5",
			"100": "#8efced",
			"200": "#60f1dd",
			"300": "#2bd9c2",
			"400": "#00c0a5",
			"500": "#0ba08b",
			"600": "#128071",
			"700": "#146056",
			"800": "#12403a",
			"900": "#0b201d"
		},
		lagoon: {
			"25": "#e7faff",
			"50": "#cff5ff",
			"100": "#b3ebfb",
			"200": "#8fdbf0",
			"300": "#60bdd7",
			"400": "#39a1be",
			"500": "#1987a5",
			"600": "#006e8c",
			"700": "#0b5569",
			"800": "#0f3a46",
			"900": "#0b1e23"
		},
		coral: {
			"25": "#fff6f5",
			"50": "#ffebe9",
			"100": "#ffdad7",
			"200": "#ffc0ba",
			"300": "#ff978d",
			"400": "#ff7063",
			"500": "#d45e54",
			"600": "#aa4c44",
			"700": "#803a34",
			"800": "#552723",
			"900": "#2b1412"
		},
		grey: {
			"25": "#fafafa",
			"50": "#f5f5f5",
			"100": "#ececec",
			"200": "#dcdcdc",
			"300": "#bfbfbf",
			"400": "#a1a1a1",
			"500": "#838383",
			"600": "#656565",
			"700": "#474747",
			"800": "#2f2f2f",
			"900": "#181818"
		},
		shade: {
			"0": "#ffffff",
			"25": "#fafafa",
			"50": "#f5f5f5",
			"100": "#ececec",
			"200": "#dcdcdc",
			"300": "#bfbfbf",
			"400": "#a1a1a1",
			"500": "#838383",
			"600": "#656565",
			"700": "#474747",
			"800": "#2f2f2f",
			"900": "#181818",
			"950": "#0b0b0b",
			"1000": "#000000"
		},
		text: {
			main: "#181818",
			subtle: "#474747",
			contrast: "#083742",
			inverse: "#ffffff"
		},
		interaction: {
			main: "#006e8c",
			subtle: "#ffffff",
			contrast: "#0ba08b",
			emphasis: "#ff7063",
			disabled: "#a1a1a1",
			success: "#288a38",
			error: "#cc2b30"
		},
		fill: {
			main: "#ffffff",
			contrast: "#006e8c",
			accent: "#00c0a5",
			selected: "#cff5ff",
			disabled: "#f5f5f5"
		},
		background: {
			page: "#fafafa",
			container: "#ffffff",
			surface: "#ececec",
			emphasis: "#f5f5f5"
		},
		border: {
			container: "#dcdcdc",
			divider: "#ececec",
			dividerEmphasis: "#181818",
			interaction: {
				"default": "#838383",
				hover: "#474747",
				focus: "#5e72ff",
				selected: "#006e8c"
			}
		},
		buttonFill: {
			primary: {
				"default": "#006e8c",
				hover: "#0b5569",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#0f3a46"
			},
			primaryInverse: {
				"default": "#ffffff",
				hover: "#e7faff",
				focus: "#ffffff",
				disabled: "#f5f5f5",
				pressed: "#cff5ff"
			},
			secondary: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e7faff",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#cff5ff"
			},
			secondaryInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#15505d",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#091d21"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e7faff",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#cff5ff"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#15505d",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#091d21"
			}
		},
		buttonForeground: {
			primary: {
				"default": "#ffffff",
				hover: "#ffffff",
				disabled: "#ffffff",
				pressed: "#ffffff"
			},
			primaryInverse: {
				"default": "#006e8c",
				hover: "#006e8c",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#006e8c"
			},
			secondary: {
				"default": "#006e8c",
				hover: "#006e8c",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#006e8c"
			},
			secondaryInverse: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#a1a1a1",
				pressed: "#ffffff"
			},
			text: {
				"default": "#006e8c",
				hover: "#006e8c",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#006e8c"
			},
			textInverse: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#a1a1a1",
				pressed: "#ffffff"
			}
		},
		buttonBorder: {
			primary: {
				"default": "#006e8c",
				hover: "#0b5569",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#0f3a46"
			},
			primaryInverse: {
				"default": "#ffffff",
				hover: "#e7faff",
				focus: "#ffffff",
				disabled: "#f5f5f5",
				pressed: "#cff5ff"
			},
			secondary: {
				"default": "#006e8c",
				hover: "#006e8c",
				focus: "#006e8c",
				disabled: "#a1a1a1",
				pressed: "#006e8c"
			},
			secondaryInverse: {
				"default": "#ffffff",
				focus: "#ffffff",
				hover: "#ffffff",
				pressed: "#ffffff",
				disabled: "#a1a1a1"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#e7faff",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#cff5ff"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#15505d",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#091d21"
			}
		}
	},
	size: {
		breakpoint: {
			mobile: "0rem",
			tablet: "36rem",
			desktop: "62rem",
			sm: "36rem",
			md: "48rem",
			lg: "62rem",
			xl: "75rem"
		}
	}
};

var themeName$1 = 'lendi-next';
var lendiNextTheme = (0,_index_03130070_esm_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_index_03130070_esm_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_index_03130070_esm_js__WEBPACK_IMPORTED_MODULE_0__._)({}, theme), tokens$1), {}, {
  name: themeName$1
});

var tokens = {
	asset: {
		font: {
			heading: {
				weight: 700,
				family: "'TT Commons Pro', sans-serif",
				metrics: {
					familyName: "TT Commons Pro",
					capHeight: 700,
					ascent: 1000,
					descent: -200,
					lineGap: 0,
					unitsPerEm: 1000
				}
			},
			body: {
				weight: 400,
				family: "'Barlow', sans-serif",
				metrics: {
					familyName: "Barlow",
					capHeight: 700,
					ascent: 1000,
					descent: -200,
					lineGap: 0,
					unitsPerEm: 1000
				}
			}
		}
	},
	color: {
		info: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431",
			"950": "#112431"
		},
		error: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314",
			"950": "#331314"
		},
		success: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210",
			"950": "#0d2210"
		},
		warn: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12",
			"950": "#321e12"
		},
		ultramarine: {
			"25": "#fbfbff",
			"50": "#f6f7ff",
			"100": "#eaecff",
			"200": "#d3d8ff",
			"300": "#a9b3ff",
			"400": "#8291ff",
			"500": "#5e72ff",
			"600": "#3d53f5",
			"700": "#3645b8",
			"800": "#29337b",
			"900": "#171b3d"
		},
		transparent: {
			"0": "rgba(0, 0, 0, 0)"
		},
		white: {
			"0": "#ffffff"
		},
		black: {
			"1000": "#000000"
		},
		green: {
			"25": "#ecffef",
			"50": "#d9ffdf",
			"100": "#c1fecb",
			"200": "#a0f4ae",
			"300": "#73dc84",
			"400": "#4cc460",
			"500": "#2cac41",
			"600": "#288a38",
			"700": "#21672d",
			"800": "#18451f",
			"900": "#0d2210"
		},
		red: {
			"25": "#fff3f3",
			"50": "#ffe5e6",
			"100": "#ffcfd1",
			"200": "#ffafb2",
			"300": "#ff7f84",
			"400": "#ff5158",
			"500": "#ff282f",
			"600": "#cc2b30",
			"700": "#99282c",
			"800": "#662022",
			"900": "#331314"
		},
		orange: {
			"25": "#fff7f2",
			"50": "#ffeee4",
			"100": "#ffe0ce",
			"200": "#ffcbad",
			"300": "#ffac7c",
			"400": "#ff904f",
			"500": "#fc7426",
			"600": "#ca6429",
			"700": "#975027",
			"800": "#65391f",
			"900": "#321e12"
		},
		blue: {
			"25": "#f0f9ff",
			"50": "#def1ff",
			"100": "#c5e7ff",
			"200": "#a2d8ff",
			"300": "#70c3ff",
			"400": "#42b0ff",
			"500": "#1898f5",
			"600": "#207fc4",
			"700": "#216393",
			"800": "#1d4562",
			"900": "#112431"
		},
		purple: {
			"25": "#faf3fe",
			"50": "#f3e6fc",
			"100": "#e9d5f7",
			"200": "#d8bbeb",
			"300": "#b791d1",
			"400": "#996db7",
			"500": "#7d4e9c",
			"600": "#633482",
			"700": "#4b1f68",
			"800": "#331745",
			"900": "#1a0d23"
		},
		yellow: {
			"25": "#fffbe9",
			"50": "#fff6d1",
			"100": "#ffefb1",
			"200": "#ffe788",
			"300": "#ffdc51",
			"400": "#ffd11f",
			"500": "#d4b024",
			"600": "#aa8f26",
			"700": "#806d23",
			"800": "#55491b",
			"900": "#2b2610"
		},
		teal: {
			"25": "#ecfffb",
			"50": "#d8fff7",
			"100": "#bffff1",
			"200": "#9dffea",
			"300": "#6eedd1",
			"400": "#45d9ba",
			"500": "#3db59b",
			"600": "#33917d",
			"700": "#286d5e",
			"800": "#1c483e",
			"900": "#0f241f"
		},
		peach: {
			"25": "#fff8f5",
			"50": "#fff0ea",
			"100": "#ffe4d9",
			"200": "#ffd0bc",
			"300": "#ffb18f",
			"400": "#ff9366",
			"500": "#d47b56",
			"600": "#aa6345",
			"700": "#804b34",
			"800": "#553223",
			"900": "#2b1a12"
		},
		grey: {
			"25": "#fcfcf9",
			"50": "#f8f8f6",
			"100": "#f2f2f0",
			"200": "#e4e4e2",
			"300": "#c7c7c5",
			"400": "#ababa9",
			"500": "#8f8f8e",
			"600": "#737372",
			"700": "#575756",
			"800": "#3a3a39",
			"900": "#1d1d1d"
		},
		shade: {
			"0": "#ffffff",
			"25": "#fcfcf9",
			"50": "#f8f8f6",
			"100": "#f2f2f0",
			"200": "#e4e4e2",
			"300": "#c7c7c5",
			"400": "#ababa9",
			"500": "#8f8f8e",
			"600": "#737372",
			"700": "#575756",
			"800": "#3a3a39",
			"900": "#1d1d1d",
			"950": "#0b0b0b",
			"1000": "#000000"
		},
		text: {
			main: "#1d1d1d",
			subtle: "#575756",
			contrast: "#4b1f68",
			inverse: "#ffffff",
			"default": "#1d1d1d"
		},
		interaction: {
			main: "#4b1f68",
			subtle: "#ffffff",
			contrast: "#4b1f68",
			emphasis: "#ffd11f",
			disabled: "#ababa9",
			success: "#288a38",
			error: "#cc2b30"
		},
		fill: {
			main: "#ffffff",
			contrast: "#4b1f68",
			accent: "#4b1f68",
			selected: "#f3e6fc",
			disabled: "#f8f8f6"
		},
		background: {
			page: "#fcfcf9",
			container: "#ffffff",
			surface: "#f2f2f0",
			emphasis: "#f8f8f6"
		},
		border: {
			container: "#e4e4e2",
			divider: "#f2f2f0",
			dividerEmphasis: "#1d1d1d",
			interaction: {
				"default": "#8f8f8e",
				hover: "#575756",
				focus: "#5e72ff",
				selected: "#4b1f68"
			}
		},
		buttonFill: {
			primary: {
				"default": "#4b1f68",
				hover: "#633482",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#331745"
			},
			primaryInverse: {
				"default": "#ffd11f",
				hover: "#ffdc51",
				focus: "#ffd11f",
				disabled: "#f8f8f6",
				pressed: "#d4b024"
			},
			secondary: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#faf3fe",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#f3e6fc"
			},
			secondaryInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#633482",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#331745"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#faf3fe",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#f3e6fc"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#633482",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#331745"
			}
		},
		buttonForeground: {
			primary: {
				"default": "#ffffff",
				hover: "#ffffff",
				focus: "#ffffff",
				disabled: "#ffffff",
				pressed: "#ffffff"
			},
			primaryInverse: {
				"default": "#4b1f68",
				hover: "#4b1f68",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#4b1f68"
			},
			secondary: {
				"default": "#4b1f68",
				hover: "#4b1f68",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#4b1f68"
			},
			secondaryInverse: {
				"default": "#ffd11f",
				hover: "#ffd11f",
				focused: "#ffd11f",
				disabled: "#ababa9",
				pressed: "#ffd11f"
			},
			text: {
				"default": "#4b1f68",
				hover: "#4b1f68",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#4b1f68"
			},
			textInverse: {
				"default": "#ffd11f",
				hover: "#ffd11f",
				focused: "#ffd11f",
				disabled: "#ababa9",
				pressed: "#ffd11f"
			}
		},
		buttonBorder: {
			primary: {
				"default": "#4b1f68",
				hover: "#633482",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#331745"
			},
			primaryInverse: {
				"default": "#ffd11f",
				hover: "#ffdc51",
				focus: "#ffd11f",
				disabled: "#f8f8f6",
				pressed: "#d4b024"
			},
			secondary: {
				"default": "#4b1f68",
				hover: "#4b1f68",
				focus: "#4b1f68",
				disabled: "#ababa9",
				pressed: "#4b1f68"
			},
			secondaryInverse: {
				"default": "#ffd11f",
				hover: "#ffd11f",
				focus: "#ffd11f",
				disabled: "#ababa9",
				pressed: "#ffd11f"
			},
			text: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#faf3fe",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#f3e6fc"
			},
			textInverse: {
				"default": "rgba(0, 0, 0, 0)",
				hover: "#633482",
				focus: "rgba(0, 0, 0, 0)",
				disabled: "rgba(0, 0, 0, 0)",
				pressed: "#331745"
			}
		}
	},
	size: {
		breakpoint: {
			mobile: "0rem",
			tablet: "36rem",
			desktop: "62rem",
			sm: "36rem",
			md: "48rem",
			lg: "62rem",
			xl: "75rem"
		}
	}
};

var themeName = 'aussie';

/**
 * @deprecated Use tokens instead
 */
var typography = {
  /**
   * @deprecated Use `asset.font.heading.family` instead
   */
  heading: {
    fontFamily: tokens.asset.font.heading.family
  },
  /**
   * @deprecated Use `asset.font.body.family` instead
   */
  body: {
    fontFamily: tokens.asset.font.body.family
  }
};
var aussieTheme = (0,_index_03130070_esm_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_index_03130070_esm_js__WEBPACK_IMPORTED_MODULE_0__._)((0,_index_03130070_esm_js__WEBPACK_IMPORTED_MODULE_0__._)({}, theme), {}, {
  typography
}, tokens), {}, {
  name: themeName
});

// Any cross browser resets should occur here
var GlobalStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .createGlobalStyle */ .vJ)(["html{box-sizing:border-box;font-size:100%;}*,*:before,*:after{box-sizing:inherit;}html,body{margin:0;padding:0;}body{color:", ";font-family:", ";}h1,h2,h3,h4,h5,h6{font-family:", ";font-weight:", ";}input::-ms-clear{display:none;}:root{--lendi-ui-size:14px;}@media (min-width:", "){:root{--lendi-ui-size:16px;}}.sr-only{border:0 !important;clip:rect(1px,1px,1px,1px) !important;clip-path:inset(50%) !important;height:1px !important;overflow:hidden !important;padding:0 !important;position:absolute !important;width:1px !important;white-space:nowrap !important;}.sr-only-focusable:focus,.sr-only-focusable:active{clip:auto !important;clip-path:none !important;height:auto !important;overflow:visible !important;width:auto !important;white-space:normal !important;}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.main;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.asset.font.body.family;
}, _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.asset.font.heading.family;
}, _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.asset.font.heading.weight;
}, _index_03130070_esm_js__WEBPACK_IMPORTED_MODULE_0__.a.sm);

/**
 * useTheme is a custom hook to return theme object.
 *
 * It is natively available in Style Component v5. However since Lendi's using v4, this custom hook is necessary.
 */
var useTheme = () => {
  return (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(styled_components__WEBPACK_IMPORTED_MODULE_3__/* .ThemeContext */ .Ni);
};




/***/ }),

/***/ 36437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ Theme; }
});

// UNUSED EXPORTS: L, r, s

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../node_modules/@lendi/ui/dist/index-83c6f867.esm.js
var index_83c6f867_esm = __webpack_require__(38570);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../node_modules/@lendi/ui/dist/index-03130070.esm.js
var index_03130070_esm = __webpack_require__(66299);
// EXTERNAL MODULE: ../../../node_modules/@testing-library/react/dist/@testing-library/react.esm.js + 1 modules
var react_esm = __webpack_require__(72720);
// EXTERNAL MODULE: ../../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(96324);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/utils/dist/commons.esm.js
var commons_esm = __webpack_require__(7401);
// EXTERNAL MODULE: ../../../node_modules/react-helmet/es/Helmet.js
var Helmet = __webpack_require__(74758);
;// CONCATENATED MODULE: ../../../node_modules/@reach/visually-hidden/dist/reach-visually-hidden.esm.js



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["as", "style"];

/**
 * VisuallyHidden
 *
 * Provides text for screen readers that is visually hidden.
 * It is the logical opposite of the `aria-hidden` attribute.
 */
var VisuallyHidden = /*#__PURE__*/(0,react.forwardRef)(function VisuallyHidden(_ref, ref) {
  var _ref$as = _ref.as,
      Comp = _ref$as === void 0 ? "span" : _ref$as,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/(0,react.createElement)(Comp, _extends({
    ref: ref,
    style: _extends({
      border: 0,
      clip: "rect(0 0 0 0)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      // https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
      whiteSpace: "nowrap",
      wordWrap: "normal"
    }, style)
  }, props));
});
/**
 * @see Docs https://reach.tech/visually-hidden#visuallyhidden-props
 */

if (false) {} ////////////////////////////////////////////////////////////////////////////////

/* harmony default export */ var reach_visually_hidden_esm = (VisuallyHidden);


// EXTERNAL MODULE: ../../../node_modules/react-element-to-jsx-string/dist/cjs/index.js
var cjs = __webpack_require__(44782);
;// CONCATENATED MODULE: ../node_modules/@lendi/ui/dist/select-73d530a0.esm.js











var fallback$2 = "\n  body, p  {\n    font-size: 16px;\n    line-height: 1.5;\n    letter-spacing: -0.6px;\n    word-spacing: -0.25px;\n    visibility: visible;\n    font-weight: 300;\n    font-family: verdana;\n    height: auto;\n  }\n\n  h1, h2, .lui-title2, h3, h4, h5, h6 {\n    line-height: 1.4;\n    letter-spacing: 0px;\n    word-spacing: -1px;\n    visibility: visible;\n    font-weight: 700;\n    height: auto;\n    font-family: Arial;\n  }\n\n  h1, .lui-display {\n    font-size: 30px;\n  }\n\n  h2, .lui-title1 {\n    font-size: 22px;\n  }\n";

var fallback$1 = "\n  body,\n  h4,\n  h5,\n  h6,\n  p,\n  .lui-subtitle1,\n  .lui-subtitle2,\n  .lui-body1,\n  .lui-body2 {\n    font-family: Arial;\n    visibility: visible;\n    letter-spacing: -0.4px;\n    font-weight: 400;\n    word-spacing: 0.4px;\n  }\n\n  h1,\n  .lui-display {\n    font-family: Arial;\n    font-size: 48px;\n    line-height: 1.3;\n    visibility: visible;\n    letter-spacing: -0.85px;\n    word-spacing: -1.65px;\n    font-weight: 700;\n  }\n\n  h2,\n  .lui-title1 {\n    font-family: Arial;\n    font-size: 32px;\n    line-height: 1.2;\n    visibility: visible;\n    letter-spacing: -0.75px;\n    word-spacing: 0.2px;\n    font-weight: 700;\n  }\n\n  h3,\n  .lui-title2 {\n    font-family: Arial;\n    font-size: 24px;\n    line-height: 1.3;\n    visibility: visible;\n    letter-spacing: -0.55px;\n    word-spacing: -0.15px;\n    font-weight: 700;\n  }\n";

var fallback = "\n  body,\n  h4,\n  h5,\n  h6,\n  p,\n  .lui-subtitle1,\n  .lui-subtitle2,\n  .lui-body1,\n  .lui-body2 {\n    font-family: Arial;\n    font-size: 16px;\n    line-height: 1.5;\n    font-weight: 300;\n    letter-spacing: -0.15px;\n    word-spacing: 0.65px;\n    visibility: visible;\n  }\n\n  h1,\n  .lui-display {\n    font-family: Arial;\n    font-size: 46px;\n    line-height: 1.5;\n    font-weight: 700;\n    letter-spacing: -0.5px;\n    word-spacing: -1.05px;\n    visibility: visible;\n  }\n\n  h2,\n  .lui-title1 {\n    font-family: Arial;\n    font-size: 31px;\n    line-height: 1.5;\n    font-weight: 700;\n    letter-spacing: -0.3px;\n    word-spacing: -0.9px;\n    visibility: visible;\n  }\n\n  .lui-title2 {\n    font-family: Arial;\n    font-size: 22px;\n    line-height: 1.4;\n    font-weight: 600;\n    letter-spacing: 0.2px;\n    word-spacing: 0.2px;\n    visibility: visible;\n  }\n";

// All CDN assets can be found in the /public folder in this repo
var config = {
  lendi: {
    fontFamilies: ['Open Sans', 'Cabin'],
    fallback: fallback$2,
    brandFontFace: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://fonts.googleapis.com/css2?family=Cabin:wght@400;700&family=Open+Sans:wght@400;600;700&display=swap",
      rel: "stylesheet"
    }, "lendi")]
  },
  'lendi-next': {
    // ^^ duplicate of lendi above ^^, but ts complains if we don't redeclare it here
    fontFamilies: ['Open Sans', 'Cabin'],
    fallback: fallback$2,
    brandFontFace: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://fonts.googleapis.com/css2?family=Cabin:wght@400;700&family=Open+Sans:wght@400;600;700&display=swap",
      rel: "stylesheet"
    }, "lendi")]
  },
  domain: {
    fontFamilies: ['F37 Bolton'],
    fallback: fallback,
    brandFontFace: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://lendi.style/font-face/domain.css",
      rel: "stylesheet"
    }, "domain")]
  },
  aussie: {
    fontFamilies: ['Barlow', 'TT Commons Pro'],
    fallback: fallback$1,
    brandFontFace: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap",
      rel: "stylesheet"
    }, "aussie-google"), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      href: "https://lendi.style/font-face/aussie.css",
      rel: "stylesheet"
    }, "aussie")]
  }
};
var FontComponent = _ref => {
  var {
    children,
    disableFallbackFonts = false,
    themeName
  } = _ref;
  var currentThemeConfig = config[themeName];
  var [brandFontLoaded, setBrandFontLoaded] = (0,react.useState)(false);
  (0,react.useEffect)(() => {
    if (!brandFontLoaded && 'fonts' in document) {
      document.fonts.onloadingdone = fontFaceSetEvent => {
        var _fontFaceSetEvent$ret;
        setBrandFontLoaded((_fontFaceSetEvent$ret = fontFaceSetEvent === null || fontFaceSetEvent === void 0 ? void 0 : fontFaceSetEvent.returnValue) !== null && _fontFaceSetEvent$ret !== void 0 ? _fontFaceSetEvent$ret : true);
      };
      return;
    }
    setBrandFontLoaded(true);
  }, [brandFontLoaded]);
  var FontDetector = () => {
    var fontFamilies = currentThemeConfig.fontFamilies;
    if (brandFontLoaded) {
      return null;
    }
    return /*#__PURE__*/(0,jsx_runtime.jsx)(reach_visually_hidden_esm, {
      "aria-hidden": "true",
      children: fontFamilies.map((fontFamily, index) => /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        style: {
          fontFamily
        },
        children: "\xA0"
      }, index))
    });
  };
  var fontLinks = currentThemeConfig.brandFontFace.map(fontFace => (0,cjs/* default */.ZP)(fontFace)).join();
  var useFallbackFonts = !brandFontLoaded && !disableFallbackFonts;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Helmet/* Helmet */.q, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "preconnect",
        href: "https://lendi.style/",
        crossOrigin: "true"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "preconnect",
        href: "https://fonts.gstatic.com",
        crossOrigin: "true"
      }), currentThemeConfig.brandFontFace.map(fontFace => fontFace), useFallbackFonts && /*#__PURE__*/(0,jsx_runtime.jsx)("style", {
        children: currentThemeConfig === null || currentThemeConfig === void 0 ? void 0 : currentThemeConfig.fallback
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("noscript", {
        children: fontLinks
      })]
    }), children, /*#__PURE__*/(0,jsx_runtime.jsx)(FontDetector, {})]
  });
};
var Font = FontComponent;

var FaviconComponent = _ref => {
  var _favicons$themeName;
  var {
    themeName
  } = _ref;
  var cdnLink = (0,commons_esm/* getCDNLink */.nJ)();
  var favicons = {
    lendi: [{
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/lendi/favicon.ico?v=72cdf7edd3ca6e222efcae0835c04113"),
      type: ''
    }, {
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/lendi/favicon-32x32.png?v=72cdf7edd3ca6e222efcae0835c04113"),
      type: 'image/png'
    }],
    'lendi-next': [{
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/lendi/favicon.ico?v=72cdf7edd3ca6e222efcae0835c04113"),
      type: ''
    }, {
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/lendi/favicon-32x32.png?v=72cdf7edd3ca6e222efcae0835c04113"),
      type: 'image/png'
    }],
    domain: [{
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/domain/favicon.icon"),
      type: ''
    }, {
      rel: 'shortcut icon',
      href: "".concat(cdnLink, "/favicons/domain/favicon.icon"),
      type: ''
    }, {
      rel: 'icon',
      sizes: '16x16',
      href: "".concat(cdnLink, "/favicons/domain/16x16.png"),
      type: 'image/png'
    }, {
      rel: 'icon',
      sizes: '32x32',
      href: "".concat(cdnLink, "/favicons/domain/32x32.png"),
      type: 'image/png'
    }, {
      rel: 'icon',
      sizes: '192x192',
      href: "".concat(cdnLink, "/favicons/domain/192x192.png"),
      type: 'image/png'
    }, {
      rel: 'icon',
      sizes: '512x512',
      href: "".concat(cdnLink, "/favicons/domain/512x512.png"),
      type: 'image/png'
    }, {
      rel: 'apple-touch-icon-precomposed',
      href: "".concat(cdnLink, "/favicons/domain/apple-touch-icon.png"),
      type: ''
    }],
    aussie: [{
      rel: 'icon',
      href: "".concat(cdnLink, "/favicons/aussie/favicon.ico"),
      type: ''
    }, {
      rel: 'shortcut icon',
      href: "".concat(cdnLink, "/favicons/aussie/favicon.ico"),
      type: ''
    }]
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Helmet/* Helmet */.q, {
    children: (_favicons$themeName = favicons[themeName]) === null || _favicons$themeName === void 0 ? void 0 : _favicons$themeName.map((props, index) => /*#__PURE__*/(0,jsx_runtime.jsx)("link", (0,index_03130070_esm._)({}, props), index))
  });
};
var Favicon = FaviconComponent;

var LUIProvider = _ref => {
  var {
    children,
    themeName,
    disableFallbackFonts = false
  } = _ref;
  // Run runtime setThemeName to apply theming data attribute
  setThemeName(themeName);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Favicon, {
      themeName: themeName
    }), /*#__PURE__*/jsx(Font, {
      themeName: themeName,
      disableFallbackFonts: disableFallbackFonts,
      children: children
    })]
  });
};

/**
 * To provide the best transition experience, and avoid breaking changes, we’re going to keep the `name` as optional.
 *
 * Meanwhile, `mapThemeNameToLegacyKind` will ensure to correct mapping.
 *
 * We will make `name` mandatory in the next breaking change.
 *
 * @since 0.2.3
 * @param {string} themeName the new ThemeName
 * @return {ThemeMap | undefined} kind the legacy ThemeMap
 *
 * @todo LUI-785 Remove backwards compatibility in next major.
 * @see https://creditandfinance.atlassian.net/browse/LUI-785
 */
var mapThemeNameToLegacyKind = themeName => {
  switch (themeName) {
    case 'lendi':
      return index_83c6f867_esm.t;
    case 'domain':
      return index_83c6f867_esm.d;
    case 'lendi-next':
      return index_83c6f867_esm.l;
    case 'aussie':
      return index_83c6f867_esm.a;
    default:
      return undefined;
  }
};

/**
 * @param {ThemeProps} props
 * @param {string} props.name `lendi`, `domain`, `aussie`, `lendi-next`
 * @param {ThemeMap} props.kind Deprecated. Use `name` instead.
 * @param {boolean} props.disableFallbackFonts Whether you wish to disable fallback fonts.
 * @param {ReactNode} props.children React children
 *
 * @since 0.2.3
 */
var Theme = _ref => {
  var _mapThemeNameToLegacy, _innerKind$name;
  var {
    kind = index_83c6f867_esm.t,
    name,
    disableFallbackFonts = false,
    children
  } = _ref;
  var innerKind = (_mapThemeNameToLegacy = mapThemeNameToLegacyKind(name)) !== null && _mapThemeNameToLegacy !== void 0 ? _mapThemeNameToLegacy : kind;
  /**
   * Determine appropriate themeName based on to backwards compatibility
   *
   * If `kind` is provided, use that first, because that's the backwards supported API.
   * Else, if `name` is provided, use that next, because that's the new API.
   *
   * @todo LUI-785 Remove backwards compatibility in next major.
   */
  var themeName = (_innerKind$name = innerKind === null || innerKind === void 0 ? void 0 : innerKind.name) !== null && _innerKind$name !== void 0 ? _innerKind$name : name;
  if (!themeName) return null;

  // Run runtime setThemeName to apply theming data attribute
  (0,index_83c6f867_esm.s)(themeName);

  /**
   * As part of ThemeV2 & Navbar constraint (use of `window`), the following `isBrowser` check enforces Client Side Rendering.
   * This is a temporary measure, and will be removed in the future once SSR is fully supported.
   * @see [LUI-854](https://creditandfinance.atlassian.net/browse/LUI-854)
   */
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styled_components_browser_esm/* ThemeProvider */.f6, {
    theme: innerKind,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_83c6f867_esm.G, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Favicon, {
      themeName: themeName
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Font, {
      themeName: themeName,
      disableFallbackFonts: disableFallbackFonts,
      children: commons_esm/* isBrowser */.jU ? children : ''
    })]
  });
};

var ThemeProvider = _ref => {
  var {
    children,
    name
  } = _ref;
  return /*#__PURE__*/jsx(Theme, {
    name: name,
    children: children
  });
};
var renderWithTheme = (ui, options) => render(ui, _objectSpread2({
  wrapper: props => {
    var _options$name;
    return /*#__PURE__*/jsx(ThemeProvider, _objectSpread2(_objectSpread2({}, props), {}, {
      name: (_options$name = options === null || options === void 0 ? void 0 : options.name) !== null && _options$name !== void 0 ? _options$name : 'lendi'
    }));
  }
}, options));

function select_73d530a0_esm_select(path, defaultValue) {
  return _ref => {
    var {
      theme
    } = _ref;
    if (!theme) {
      throw new Error('@lendi-ui/theme: Theme not found. Please ensure your components are wrapped in the Theme component e.g. <Theme><App/></Theme>');
    }
    var obj = theme;
    var startIndex = -1;
    var finishIndex = -1;
    do {
      // check if there is a key that matches the remainder of the path
      var restOfPath = path.substr(startIndex + 1);
      if (Object.prototype.hasOwnProperty.call(obj, restOfPath)) {
        return obj[restOfPath];
      }

      // check if there is a key that matches the next part of the path
      finishIndex = path.indexOf('.', startIndex + 1);
      var nextPartOfPath = path.substr(startIndex + 1, finishIndex - startIndex - 1);
      if (finishIndex === -1 || !Object.prototype.hasOwnProperty.call(obj, nextPartOfPath)) {
        if (defaultValue !== undefined) {
          return defaultValue;
        } else {
          throw new Error("@lendi-ui/theme: Could not find a property named \"".concat(path, "\" on the theme."));
        }
      }
      obj = obj[nextPartOfPath];
      startIndex = finishIndex;
    } while (true); // eslint-disable-line no-constant-condition
  };
}




/***/ }),

/***/ 67921:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 91649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vb": function() { return /* binding */ esm_ce; },
  "mC": function() { return /* binding */ esm_pe; },
  "VO": function() { return /* binding */ esm_Q; }
});

// UNUSED EXPORTS: LDProvider, asyncWithLDProvider, basicLogger, camelCaseKeys, createConsoleLogger, defaultReactOptions, initialize, useLDClientError, version, withLDConsumer

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../node_modules/launchdarkly-js-client-sdk/dist/ldclient.es.js
function ldclient_es_e(e){function t(e,t){Error.captureStackTrace&&Error.captureStackTrace(this,this.constructor),this.message=e,this.code=t}return t.prototype=new Error,t.prototype.name=e,t.prototype.constructor=t,t}const ldclient_es_t=ldclient_es_e("LaunchDarklyUnexpectedResponseError"),n=ldclient_es_e("LaunchDarklyInvalidEnvironmentIdError"),r=ldclient_es_e("LaunchDarklyInvalidUserError"),ldclient_es_o=ldclient_es_e("LaunchDarklyInvalidEventKeyError"),i=ldclient_es_e("LaunchDarklyInvalidArgumentError"),ldclient_es_a=ldclient_es_e("LaunchDarklyFlagFetchError");for(var ldclient_es_s={LDUnexpectedResponseError:ldclient_es_t,LDInvalidEnvironmentIdError:n,LDInvalidUserError:r,LDInvalidEventKeyError:ldclient_es_o,LDInvalidArgumentError:i,LDInvalidDataError:ldclient_es_e("LaunchDarklyInvalidDataError"),LDFlagFetchError:ldclient_es_a,isHttpErrorRecoverable:function(e){return!(e>=400&&e<500)||(400===e||408===e||429===e)}},c=function(e){var t=m(e),n=t[0],r=t[1];return 3*(n+r)/4-r},u=function(e){var t,n,r=m(e),o=r[0],i=r[1],a=new g(function(e,t,n){return 3*(t+n)/4-n}(0,o,i)),s=0,c=i>0?o-4:o;for(n=0;n<c;n+=4)t=f[e.charCodeAt(n)]<<18|f[e.charCodeAt(n+1)]<<12|f[e.charCodeAt(n+2)]<<6|f[e.charCodeAt(n+3)],a[s++]=t>>16&255,a[s++]=t>>8&255,a[s++]=255&t;2===i&&(t=f[e.charCodeAt(n)]<<2|f[e.charCodeAt(n+1)]>>4,a[s++]=255&t);1===i&&(t=f[e.charCodeAt(n)]<<10|f[e.charCodeAt(n+1)]<<4|f[e.charCodeAt(n+2)]>>2,a[s++]=t>>8&255,a[s++]=255&t);return a},l=function(e){for(var t,n=e.length,r=n%3,o=[],i=16383,a=0,s=n-r;a<s;a+=i)o.push(h(e,a,a+i>s?s:a+i));1===r?(t=e[n-1],o.push(d[t>>2]+d[t<<4&63]+"==")):2===r&&(t=(e[n-2]<<8)+e[n-1],o.push(d[t>>10]+d[t>>4&63]+d[t<<2&63]+"="));return o.join("")},d=[],f=[],g="undefined"!=typeof Uint8Array?Uint8Array:Array,v="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",p=0;p<64;++p)d[p]=v[p],f[v.charCodeAt(p)]=p;function m(e){var t=e.length;if(t%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var n=e.indexOf("=");return-1===n&&(n=t),[n,n===t?0:4-n%4]}function h(e,t,n){for(var r,o,i=[],a=t;a<n;a+=3)r=(e[a]<<16&16711680)+(e[a+1]<<8&65280)+(255&e[a+2]),i.push(d[(o=r)>>18&63]+d[o>>12&63]+d[o>>6&63]+d[63&o]);return i.join("")}f["-".charCodeAt(0)]=62,f["_".charCodeAt(0)]=63;var y={byteLength:c,toByteArray:u,fromByteArray:l},w=Array.isArray,b=Object.keys,k=Object.prototype.hasOwnProperty,E=function e(t,n){if(t===n)return!0;if(t&&n&&"object"==typeof t&&"object"==typeof n){var r,o,i,a=w(t),s=w(n);if(a&&s){if((o=t.length)!=n.length)return!1;for(r=o;0!=r--;)if(!e(t[r],n[r]))return!1;return!0}if(a!=s)return!1;var c=t instanceof Date,u=n instanceof Date;if(c!=u)return!1;if(c&&u)return t.getTime()==n.getTime();var l=t instanceof RegExp,d=n instanceof RegExp;if(l!=d)return!1;if(l&&d)return t.toString()==n.toString();var f=b(t);if((o=f.length)!==b(n).length)return!1;for(r=o;0!=r--;)if(!k.call(n,f[r]))return!1;for(r=o;0!=r--;)if(!e(t[i=f[r]],n[i]))return!1;return!0}return t!=t&&n!=n};const D=["key","ip","country","email","firstName","lastName","avatar","name"];function C(e){const t=unescape(encodeURIComponent(e));return y.fromByteArray(function(e){const t=[];for(let n=0;n<e.length;n++)t.push(e.charCodeAt(n));return t}(t))}function x(e){return C(e).replace(/=/g,"").replace(/\+/g,"-").replace(/\//g,"_")}function P(e,t){return Object.prototype.hasOwnProperty.call(e,t)}var S,I={appendUrlPath:function(e,t){return(e.endsWith("/")?e.substring(0,e.length-1):e)+(t.startsWith("/")?"":"/")+t},base64URLEncode:x,btoa:C,chunkEventsForUrl:function(e,t){const n=t.slice(0),r=[];let o,i=e;for(;n.length>0;){for(o=[];i>0;){const e=n.shift();if(!e)break;i-=x(JSON.stringify(e)).length,i<0&&o.length>0?n.unshift(e):o.push(e)}i=e,r.push(o)}return r},clone:function(e){return JSON.parse(JSON.stringify(e))},deepEquals:function(e,t){return E(e,t)},extend:function(...e){return e.reduce(((e,t)=>({...e,...t})),{})},getLDUserAgentString:function(e){const t=e.version||"?";return e.userAgent+"/"+t},objectHasOwnProperty:P,onNextTick:function(e){setTimeout(e,0)},sanitizeContext:function(e){if(!e)return e;let t;return null!==e.kind&&void 0!==e.kind||D.forEach((n=>{const r=e[n];void 0!==r&&"string"!=typeof r&&(t=t||{...e},t[n]=String(r))})),t||e},transformValuesToVersionedValues:function(e){const t={};for(const n in e)P(e,n)&&(t[n]={value:e[n],version:0});return t},transformVersionedValuesToValues:function(e){const t={};for(const n in e)P(e,n)&&(t[n]=e[n].value);return t},wrapPromiseCallback:function(e,t){const n=e.then((e=>(t&&setTimeout((()=>{t(null,e)}),0),e)),(e=>{if(!t)return Promise.reject(e);setTimeout((()=>{t(e,null)}),0)}));return t?void 0:n}},O=new Uint8Array(16);function L(){if(!S&&!(S="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto)))throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return S(O)}var U=/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;function T(e){return"string"==typeof e&&U.test(e)}for(var R,A,j=[],F=0;F<256;++F)j.push((F+256).toString(16).substr(1));function N(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=(j[e[t+0]]+j[e[t+1]]+j[e[t+2]]+j[e[t+3]]+"-"+j[e[t+4]]+j[e[t+5]]+"-"+j[e[t+6]]+j[e[t+7]]+"-"+j[e[t+8]]+j[e[t+9]]+"-"+j[e[t+10]]+j[e[t+11]]+j[e[t+12]]+j[e[t+13]]+j[e[t+14]]+j[e[t+15]]).toLowerCase();if(!T(n))throw TypeError("Stringified UUID is invalid");return n}var $=0,V=0;function H(e){if(!T(e))throw TypeError("Invalid UUID");var t,n=new Uint8Array(16);return n[0]=(t=parseInt(e.slice(0,8),16))>>>24,n[1]=t>>>16&255,n[2]=t>>>8&255,n[3]=255&t,n[4]=(t=parseInt(e.slice(9,13),16))>>>8,n[5]=255&t,n[6]=(t=parseInt(e.slice(14,18),16))>>>8,n[7]=255&t,n[8]=(t=parseInt(e.slice(19,23),16))>>>8,n[9]=255&t,n[10]=(t=parseInt(e.slice(24,36),16))/1099511627776&255,n[11]=t/4294967296&255,n[12]=t>>>24&255,n[13]=t>>>16&255,n[14]=t>>>8&255,n[15]=255&t,n}function q(e,t,n){function r(e,r,o,i){if("string"==typeof e&&(e=function(e){e=unescape(encodeURIComponent(e));for(var t=[],n=0;n<e.length;++n)t.push(e.charCodeAt(n));return t}(e)),"string"==typeof r&&(r=H(r)),16!==r.length)throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");var a=new Uint8Array(16+e.length);if(a.set(r),a.set(e,r.length),(a=n(a))[6]=15&a[6]|t,a[8]=63&a[8]|128,o){i=i||0;for(var s=0;s<16;++s)o[i+s]=a[s];return o}return N(a)}try{r.name=e}catch(e){}return r.DNS="6ba7b810-9dad-11d1-80b4-00c04fd430c8",r.URL="6ba7b811-9dad-11d1-80b4-00c04fd430c8",r}function M(e){return 14+(e+64>>>9<<4)+1}function K(e,t){var n=(65535&e)+(65535&t);return(e>>16)+(t>>16)+(n>>16)<<16|65535&n}function _(e,t,n,r,o,i){return K((a=K(K(t,e),K(r,i)))<<(s=o)|a>>>32-s,n);var a,s}function J(e,t,n,r,o,i,a){return _(t&n|~t&r,e,t,o,i,a)}function z(e,t,n,r,o,i,a){return _(t&r|n&~r,e,t,o,i,a)}function B(e,t,n,r,o,i,a){return _(t^n^r,e,t,o,i,a)}function G(e,t,n,r,o,i,a){return _(n^(t|~r),e,t,o,i,a)}var W=q("v3",48,(function(e){if("string"==typeof e){var t=unescape(encodeURIComponent(e));e=new Uint8Array(t.length);for(var n=0;n<t.length;++n)e[n]=t.charCodeAt(n)}return function(e){for(var t=[],n=32*e.length,r="0123456789abcdef",o=0;o<n;o+=8){var i=e[o>>5]>>>o%32&255,a=parseInt(r.charAt(i>>>4&15)+r.charAt(15&i),16);t.push(a)}return t}(function(e,t){e[t>>5]|=128<<t%32,e[M(t)-1]=t;for(var n=1732584193,r=-271733879,o=-1732584194,i=271733878,a=0;a<e.length;a+=16){var s=n,c=r,u=o,l=i;n=J(n,r,o,i,e[a],7,-680876936),i=J(i,n,r,o,e[a+1],12,-389564586),o=J(o,i,n,r,e[a+2],17,606105819),r=J(r,o,i,n,e[a+3],22,-1044525330),n=J(n,r,o,i,e[a+4],7,-176418897),i=J(i,n,r,o,e[a+5],12,1200080426),o=J(o,i,n,r,e[a+6],17,-1473231341),r=J(r,o,i,n,e[a+7],22,-45705983),n=J(n,r,o,i,e[a+8],7,1770035416),i=J(i,n,r,o,e[a+9],12,-1958414417),o=J(o,i,n,r,e[a+10],17,-42063),r=J(r,o,i,n,e[a+11],22,-1990404162),n=J(n,r,o,i,e[a+12],7,1804603682),i=J(i,n,r,o,e[a+13],12,-40341101),o=J(o,i,n,r,e[a+14],17,-1502002290),n=z(n,r=J(r,o,i,n,e[a+15],22,1236535329),o,i,e[a+1],5,-165796510),i=z(i,n,r,o,e[a+6],9,-1069501632),o=z(o,i,n,r,e[a+11],14,643717713),r=z(r,o,i,n,e[a],20,-373897302),n=z(n,r,o,i,e[a+5],5,-701558691),i=z(i,n,r,o,e[a+10],9,38016083),o=z(o,i,n,r,e[a+15],14,-660478335),r=z(r,o,i,n,e[a+4],20,-405537848),n=z(n,r,o,i,e[a+9],5,568446438),i=z(i,n,r,o,e[a+14],9,-1019803690),o=z(o,i,n,r,e[a+3],14,-187363961),r=z(r,o,i,n,e[a+8],20,1163531501),n=z(n,r,o,i,e[a+13],5,-1444681467),i=z(i,n,r,o,e[a+2],9,-51403784),o=z(o,i,n,r,e[a+7],14,1735328473),n=B(n,r=z(r,o,i,n,e[a+12],20,-1926607734),o,i,e[a+5],4,-378558),i=B(i,n,r,o,e[a+8],11,-2022574463),o=B(o,i,n,r,e[a+11],16,1839030562),r=B(r,o,i,n,e[a+14],23,-35309556),n=B(n,r,o,i,e[a+1],4,-1530992060),i=B(i,n,r,o,e[a+4],11,1272893353),o=B(o,i,n,r,e[a+7],16,-155497632),r=B(r,o,i,n,e[a+10],23,-1094730640),n=B(n,r,o,i,e[a+13],4,681279174),i=B(i,n,r,o,e[a],11,-358537222),o=B(o,i,n,r,e[a+3],16,-722521979),r=B(r,o,i,n,e[a+6],23,76029189),n=B(n,r,o,i,e[a+9],4,-640364487),i=B(i,n,r,o,e[a+12],11,-421815835),o=B(o,i,n,r,e[a+15],16,530742520),n=G(n,r=B(r,o,i,n,e[a+2],23,-995338651),o,i,e[a],6,-198630844),i=G(i,n,r,o,e[a+7],10,1126891415),o=G(o,i,n,r,e[a+14],15,-1416354905),r=G(r,o,i,n,e[a+5],21,-57434055),n=G(n,r,o,i,e[a+12],6,1700485571),i=G(i,n,r,o,e[a+3],10,-1894986606),o=G(o,i,n,r,e[a+10],15,-1051523),r=G(r,o,i,n,e[a+1],21,-2054922799),n=G(n,r,o,i,e[a+8],6,1873313359),i=G(i,n,r,o,e[a+15],10,-30611744),o=G(o,i,n,r,e[a+6],15,-1560198380),r=G(r,o,i,n,e[a+13],21,1309151649),n=G(n,r,o,i,e[a+4],6,-145523070),i=G(i,n,r,o,e[a+11],10,-1120210379),o=G(o,i,n,r,e[a+2],15,718787259),r=G(r,o,i,n,e[a+9],21,-343485551),n=K(n,s),r=K(r,c),o=K(o,u),i=K(i,l)}return[n,r,o,i]}(function(e){if(0===e.length)return[];for(var t=8*e.length,n=new Uint32Array(M(t)),r=0;r<t;r+=8)n[r>>5]|=(255&e[r/8])<<r%32;return n}(e),8*e.length))})),X=W;function Q(e,t,n,r){switch(e){case 0:return t&n^~t&r;case 1:case 3:return t^n^r;case 2:return t&n^t&r^n&r}}function Y(e,t){return e<<t|e>>>32-t}var Z=q("v5",80,(function(e){var t=[1518500249,1859775393,2400959708,3395469782],n=[1732584193,4023233417,2562383102,271733878,3285377520];if("string"==typeof e){var r=unescape(encodeURIComponent(e));e=[];for(var o=0;o<r.length;++o)e.push(r.charCodeAt(o))}else Array.isArray(e)||(e=Array.prototype.slice.call(e));e.push(128);for(var i=e.length/4+2,a=Math.ceil(i/16),s=new Array(a),c=0;c<a;++c){for(var u=new Uint32Array(16),l=0;l<16;++l)u[l]=e[64*c+4*l]<<24|e[64*c+4*l+1]<<16|e[64*c+4*l+2]<<8|e[64*c+4*l+3];s[c]=u}s[a-1][14]=8*(e.length-1)/Math.pow(2,32),s[a-1][14]=Math.floor(s[a-1][14]),s[a-1][15]=8*(e.length-1)&4294967295;for(var d=0;d<a;++d){for(var f=new Uint32Array(80),g=0;g<16;++g)f[g]=s[d][g];for(var v=16;v<80;++v)f[v]=Y(f[v-3]^f[v-8]^f[v-14]^f[v-16],1);for(var p=n[0],m=n[1],h=n[2],y=n[3],w=n[4],b=0;b<80;++b){var k=Math.floor(b/20),E=Y(p,5)+Q(k,m,h,y)+w+t[k]+f[b]>>>0;w=y,y=h,h=Y(m,30)>>>0,m=p,p=E}n[0]=n[0]+p>>>0,n[1]=n[1]+m>>>0,n[2]=n[2]+h>>>0,n[3]=n[3]+y>>>0,n[4]=n[4]+w>>>0}return[n[0]>>24&255,n[0]>>16&255,n[0]>>8&255,255&n[0],n[1]>>24&255,n[1]>>16&255,n[1]>>8&255,255&n[1],n[2]>>24&255,n[2]>>16&255,n[2]>>8&255,255&n[2],n[3]>>24&255,n[3]>>16&255,n[3]>>8&255,255&n[3],n[4]>>24&255,n[4]>>16&255,n[4]>>8&255,255&n[4]]})),ee=Z;var te=Object.freeze({__proto__:null,v1:function(e,t,n){var r=t&&n||0,o=t||new Array(16),i=(e=e||{}).node||R,a=void 0!==e.clockseq?e.clockseq:A;if(null==i||null==a){var s=e.random||(e.rng||L)();null==i&&(i=R=[1|s[0],s[1],s[2],s[3],s[4],s[5]]),null==a&&(a=A=16383&(s[6]<<8|s[7]))}var c=void 0!==e.msecs?e.msecs:Date.now(),u=void 0!==e.nsecs?e.nsecs:V+1,l=c-$+(u-V)/1e4;if(l<0&&void 0===e.clockseq&&(a=a+1&16383),(l<0||c>$)&&void 0===e.nsecs&&(u=0),u>=1e4)throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");$=c,V=u,A=a;var d=(1e4*(268435455&(c+=122192928e5))+u)%4294967296;o[r++]=d>>>24&255,o[r++]=d>>>16&255,o[r++]=d>>>8&255,o[r++]=255&d;var f=c/4294967296*1e4&268435455;o[r++]=f>>>8&255,o[r++]=255&f,o[r++]=f>>>24&15|16,o[r++]=f>>>16&255,o[r++]=a>>>8|128,o[r++]=255&a;for(var g=0;g<6;++g)o[r+g]=i[g];return t||N(o)},v3:X,v4:function(e,t,n){var r=(e=e||{}).random||(e.rng||L)();if(r[6]=15&r[6]|64,r[8]=63&r[8]|128,t){n=n||0;for(var o=0;o<16;++o)t[n+o]=r[o];return t}return N(r)},v5:ee,NIL:"00000000-0000-0000-0000-000000000000",version:function(e){if(!T(e))throw TypeError("Invalid UUID");return parseInt(e.substr(14,1),16)},validate:T,stringify:N,parse:H});const ne=["debug","info","warn","error","none"];var re={commonBasicLogger:function(e,t){if(e&&e.destination&&"function"!=typeof e.destination)throw new Error("destination for basicLogger was set to a non-function");function n(e){return function(t){console&&console[e]&&console[e].call(console,t)}}const r=e&&e.destination?[e.destination,e.destination,e.destination,e.destination]:[n("log"),n("info"),n("warn"),n("error")],o=!(!e||!e.destination),i=e&&void 0!==e.prefix&&null!==e.prefix?e.prefix:"[LaunchDarkly] ";let a=1;if(e&&e.level)for(let t=0;t<ne.length;t++)ne[t]===e.level&&(a=t);function s(e,n,a){if(a.length<1)return;let s;const c=o?n+": "+i:i;if(1!==a.length&&t){const e=[...a];e[0]=c+e[0],s=t(...e)}else s=c+a[0];try{r[e](s)}catch(e){console&&console.log&&console.log("[LaunchDarkly] Configured logger's "+n+" method threw an exception: "+e)}}const c={};for(let e=0;e<ne.length;e++){const t=ne[e];if("none"!==t)if(e<a)c[t]=()=>{};else{const n=e;c[t]=function(){s(n,t,arguments)}}}return c},validateLogger:function(e){ne.forEach((t=>{if("none"!==t&&(!e[t]||"function"!=typeof e[t]))throw new Error("Provided logger instance must support logger."+t+"(...) method")}))}};function oe(e){return e&&e.message?e.message:"string"==typeof e||e instanceof String?e:JSON.stringify(e)}const ie=" Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initializing-the-client for instructions on SDK initialization.";var ae={bootstrapInvalid:function(){return"LaunchDarkly bootstrap data is not available because the back end could not read the flags."},bootstrapOldFormat:function(){return"LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly."+ie},clientInitialized:function(){return"LaunchDarkly client initialized"},clientNotReady:function(){return"LaunchDarkly client is not ready"},debugEnqueueingEvent:function(e){return'enqueueing "'+e+'" event'},debugPostingDiagnosticEvent:function(e){return"sending diagnostic event ("+e.kind+")"},debugPostingEvents:function(e){return"sending "+e+" events"},debugStreamDelete:function(e){return'received streaming deletion for flag "'+e+'"'},debugStreamDeleteIgnored:function(e){return'received streaming deletion for flag "'+e+'" but ignored due to version check'},debugStreamPatch:function(e){return'received streaming update for flag "'+e+'"'},debugStreamPatchIgnored:function(e){return'received streaming update for flag "'+e+'" but ignored due to version check'},debugStreamPing:function(){return"received ping message from stream"},debugPolling:function(e){return"polling for feature flags at "+e},debugStreamPut:function(){return"received streaming update for all flags"},deprecated:function(e,t){return t?'"'+e+'" is deprecated, please use "'+t+'"':'"'+e+'" is deprecated'},environmentNotFound:function(){return"Environment not found. Double check that you specified a valid environment/client-side ID."+ie},environmentNotSpecified:function(){return"No environment/client-side ID was specified."+ie},errorFetchingFlags:function(e){return"Error fetching flag settings: "+oe(e)},eventCapacityExceeded:function(){return"Exceeded event queue capacity. Increase capacity to avoid dropping events."},eventWithoutContext:function(){return"Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript"},httpErrorMessage:function(e,t,n){return"Received error "+e+(401===e?" (invalid SDK key)":"")+" for "+t+" - "+(ldclient_es_s.isHttpErrorRecoverable(e)?n:"giving up permanently")},httpUnavailable:function(){return"Cannot make HTTP requests in this environment."+ie},identifyDisabled:function(){return"identify() has no effect here; it must be called on the main client instance"},inspectorMethodError:(e,t)=>`an inspector: "${t}" of type: "${e}" generated an exception`,invalidContentType:function(e){return'Expected application/json content type but got "'+e+'"'},invalidData:function(){return"Invalid data received from LaunchDarkly; connection may have been interrupted"},invalidInspector:(e,t)=>`an inspector: "${t}" of an invalid type (${e}) was configured`,invalidKey:function(){return"Event key must be a string"},invalidContext:function(){return"Invalid context specified."+ie},invalidTagValue:e=>`Config option "${e}" must only contain letters, numbers, ., _ or -.`,localStorageUnavailable:function(e){return"local storage is unavailable: "+oe(e)},networkError:e=>"network error"+(e?" ("+e+")":""),optionBelowMinimum:(e,t,n)=>'Config option "'+e+'" was set to '+t+", changing to minimum value of "+n,streamClosing:function(){return"Closing stream connection"},streamConnecting:function(e){return"Opening stream connection to "+e},streamError:function(e,t){return"Error on stream connection: "+oe(e)+", will continue retrying after "+t+" milliseconds."},tagValueTooLong:e=>`Value of "${e}" was longer than 64 characters and was discarded.`,unknownCustomEventKey:function(e){return'Custom event "'+e+'" does not exist'},unknownOption:e=>'Ignoring unknown config option "'+e+'"',contextNotSpecified:function(){return"No context specified."+ie},unrecoverableStreamError:e=>`Error on stream connection ${oe(e)}, giving up permanently`,wrongOptionType:(e,t,n)=>'Config option "'+e+'" should be of type '+t+", got "+n+", using default value",wrongOptionTypeBoolean:(e,t)=>'Config option "'+e+'" should be a boolean, got '+t+", converting to boolean"};const{validateLogger:se}=re,ce={baseUrl:{default:"https://app.launchdarkly.com"},streamUrl:{default:"https://clientstream.launchdarkly.com"},eventsUrl:{default:"https://events.launchdarkly.com"},sendEvents:{default:!0},streaming:{type:"boolean"},sendLDHeaders:{default:!0},requestHeaderTransform:{type:"function"},sendEventsOnlyForVariation:{default:!1},useReport:{default:!1},evaluationReasons:{default:!1},eventCapacity:{default:100,minimum:1},flushInterval:{default:2e3,minimum:2e3},samplingInterval:{default:0,minimum:0},streamReconnectDelay:{default:1e3,minimum:0},allAttributesPrivate:{default:!1},privateAttributes:{default:[]},bootstrap:{type:"string|object"},diagnosticRecordingInterval:{default:9e5,minimum:2e3},diagnosticOptOut:{default:!1},wrapperName:{type:"string"},wrapperVersion:{type:"string"},stateProvider:{type:"object"},application:{validator:function(e,t,n){const r={};t.id&&(r.id=de(`${e}.id`,t.id,n));t.version&&(r.version=de(`${e}.version`,t.version,n));return r}},inspectors:{default:[]}},ue=/^(\w|\.|-)+$/;function le(e){return e&&e.replace(/\/+$/,"")}function de(e,t,n){if("string"==typeof t&&t.match(ue)){if(!(t.length>64))return t;n.warn(ae.tagValueTooLong(e))}else n.warn(ae.invalidTagValue(e))}var fe={baseOptionDefs:ce,validate:function(e,t,n,r){const o=I.extend({logger:{default:r}},ce,n),i={};function a(e){I.onNextTick((()=>{t&&t.maybeReportError(new ldclient_es_s.LDInvalidArgumentError(e))}))}let c=I.extend({},e||{});return function(e){const t=e;Object.keys(i).forEach((e=>{if(void 0!==t[e]){const n=i[e];r&&r.warn(ae.deprecated(e,n)),n&&(void 0===t[n]&&(t[n]=t[e]),delete t[e])}}))}(c),c=function(e){const t=I.extend({},e);return Object.keys(o).forEach((e=>{void 0!==t[e]&&null!==t[e]||(t[e]=o[e]&&o[e].default)})),t}(c),c=function(e){const t=I.extend({},e),n=e=>{if(null===e)return"any";if(void 0===e)return;if(Array.isArray(e))return"array";const t=typeof e;return"boolean"===t||"string"===t||"number"===t||"function"===t?t:"object"};return Object.keys(e).forEach((i=>{const s=e[i];if(null!=s){const c=o[i];if(void 0===c)a(ae.unknownOption(i));else{const o=c.type||n(c.default),u=c.validator;if(u){const n=u(i,e[i],r);void 0!==n?t[i]=n:delete t[i]}else if("any"!==o){const e=o.split("|"),r=n(s);e.indexOf(r)<0?"boolean"===o?(t[i]=!!s,a(ae.wrongOptionTypeBoolean(i,r))):(a(ae.wrongOptionType(i,o,r)),t[i]=c.default):"number"===r&&void 0!==c.minimum&&s<c.minimum&&(a(ae.optionBelowMinimum(i,s,c.minimum)),t[i]=c.minimum)}}}})),t.baseUrl=le(t.baseUrl),t.streamUrl=le(t.streamUrl),t.eventsUrl=le(t.eventsUrl),t}(c),se(c.logger),c},getTags:function(e){const t={};return e&&(e.application&&void 0!==e.application.id&&null!==e.application.id&&(t["application-id"]=[e.application.id]),e.application&&void 0!==e.application.version&&null!==e.application.id&&(t["application-version"]=[e.application.version])),t}};const{getLDUserAgentString:ge}=I;var ve={getLDHeaders:function(e,t){if(t&&!t.sendLDHeaders)return{};const n={};n[e.userAgentHeaderName||"User-Agent"]=ge(e),t&&t.wrapperName&&(n["X-LaunchDarkly-Wrapper"]=t.wrapperVersion?t.wrapperName+"/"+t.wrapperVersion:t.wrapperName);const r=fe.getTags(t),o=Object.keys(r);return o.length&&(n["x-launchdarkly-tags"]=o.sort().map((e=>Array.isArray(r[e])?r[e].sort().map((t=>`${e}/${t}`)):[`${e}/${r[e]}`])).reduce(((e,t)=>e.concat(t)),[]).join(" ")),n},transformHeaders:function(e,t){return t&&t.requestHeaderTransform?t.requestHeaderTransform({...e}):e}};const{v1:pe}=te,{getLDHeaders:me,transformHeaders:he}=ve;var ye=function(e,t,n){const r="/a/"+t+".gif",o=I.extend({"Content-Type":"application/json"},me(e,n)),i=e.httpFallbackPing,a={};return a.sendChunk=(t,a,c,u)=>{const l=JSON.stringify(t),d=c?null:pe();return u?function t(r){const i=c?o:I.extend({},o,{"X-LaunchDarkly-Event-Schema":"4","X-LaunchDarkly-Payload-ID":d});return e.httpRequest("POST",a,he(i,n),l).promise.then((e=>{if(e)return e.status>=400&&ldclient_es_s.isHttpErrorRecoverable(e.status)&&r?t(!1):function(e){const t={status:e.status},n=e.header("date");if(n){const e=Date.parse(n);e&&(t.serverTime=e)}return t}(e)})).catch((()=>r?t(!1):Promise.reject()))}(!0).catch((()=>{})):(i&&i(a+r+"?d="+I.base64URLEncode(l)),Promise.resolve())},a.sendEvents=function(t,n,r){if(!e.httpRequest)return Promise.resolve();const o=e.httpAllowsPost();let i;i=o?[t]:I.chunkEventsForUrl(2e3-n.length,t);const s=[];for(let e=0;e<i.length;e++)s.push(a.sendChunk(i[e],n,r,o));return Promise.all(s)},a};const{commonBasicLogger:we}=re;function be(e){return"string"==typeof e&&"kind"!==e&&e.match(/^(\w|\.|-)+$/)}function ke(e){return e.includes("%")||e.includes(":")?e.replace(/%/g,"%25").replace(/:/g,"%3A"):e}var Ee={checkContext:function(e,t){if(e){if(t&&(void 0===e.kind||null===e.kind))return void 0!==e.key&&null!==e.key;const n=e.key,r=void 0===e.kind?"user":e.kind,o=be(r),i="multi"===r||null!=n&&""!==n;if("multi"===r){const t=Object.keys(e).filter((e=>"kind"!==e));return i&&t.every((e=>be(e)))&&t.every((t=>{const n=e[t].key;return null!=n&&""!==n}))}return i&&o}return!1},getContextKeys:function(e,t=we()){if(!e)return;const n={},{kind:r,key:o}=e;switch(r){case void 0:n.user=`${o}`;break;case"multi":Object.entries(e).filter((([e])=>"kind"!==e)).forEach((([e,t])=>{t&&t.key&&(n[e]=t.key)}));break;case null:t.warn(`null is not a valid context kind: ${e}`);break;case"":t.warn(`'' is not a valid context kind: ${e}`);break;default:n[r]=`${o}`}return n},getContextKinds:function(e){return e?null===e.kind||void 0===e.kind?["user"]:"multi"!==e.kind?[e.kind]:Object.keys(e).filter((e=>"kind"!==e)):[]},getCanonicalKey:function(e){if(e){if((void 0===e.kind||null===e.kind||"user"===e.kind)&&e.key)return e.key;if("multi"!==e.kind&&e.key)return`${e.kind}:${ke(e.key)}`;if("multi"===e.kind)return Object.keys(e).sort().filter((e=>"kind"!==e)).map((t=>`${t}:${ke(e[t].key)}`)).join(":")}}};const{getContextKinds:De}=Ee;var Ce=function(){const e={};let t=0,n=0,r={},o={};return e.summarizeEvent=e=>{if("feature"===e.kind){const i=e.key+":"+(null!==e.variation&&void 0!==e.variation?e.variation:"")+":"+(null!==e.version&&void 0!==e.version?e.version:""),a=r[i];let s=o[e.key];s||(s=new Set,o[e.key]=s),function(e){return e.context?De(e.context):e.contextKeys?Object.keys(e.contextKeys):[]}(e).forEach((e=>s.add(e))),a?a.count=a.count+1:r[i]={count:1,key:e.key,version:e.version,variation:e.variation,value:e.value,default:e.default},(0===t||e.creationDate<t)&&(t=e.creationDate),e.creationDate>n&&(n=e.creationDate)}},e.getSummary=()=>{const e={};let i=!0;for(const t of Object.values(r)){let n=e[t.key];n||(n={default:t.default,counters:[],contextKinds:[...o[t.key]]},e[t.key]=n);const r={value:t.value,count:t.count};void 0!==t.variation&&null!==t.variation&&(r.variation=t.variation),void 0!==t.version&&null!==t.version?r.version=t.version:r.unknown=!0,n.counters.push(r),i=!1}return i?null:{startDate:t,endDate:n,features:e}},e.clearSummary=()=>{t=0,n=0,r={},o={}},e};function xe(e){return e.replace(/~/g,"~0").replace(/\//g,"~1")}function Pe(e){return(e.startsWith("/")?e.substring(1):e).split("/").map((e=>e.indexOf("~")>=0?e.replace(/~1/g,"/").replace(/~0/g,"~"):e))}function Se(e){return!e.startsWith("/")}function Ie(e,t){const n=Se(e),r=Se(t);if(n&&r)return e===t;if(n){const n=Pe(t);return 1===n.length&&e===n[0]}if(r){const n=Pe(e);return 1===n.length&&t===n[0]}return e===t}function Oe(e){return`/${xe(e)}`}var Le={cloneExcluding:function(e,t){const n=[],r={},o=[];for(n.push(...Object.keys(e).map((t=>({key:t,ptr:Oe(t),source:e,parent:r,visited:[e]}))));n.length;){const e=n.pop();if(t.some((t=>Ie(t,e.ptr))))o.push(e.ptr);else{const t=e.source[e.key];if(null===t)e.parent[e.key]=t;else if(Array.isArray(t))e.parent[e.key]=[...t];else if("object"==typeof t){if(e.visited.includes(t))continue;e.parent[e.key]={},n.push(...Object.keys(t).map((n=>{return{key:n,ptr:(r=e.ptr,o=xe(n),`${r}/${o}`),source:t,parent:e.parent[e.key],visited:[...e.visited,t]};var r,o})))}else e.parent[e.key]=t}}return{cloned:r,excluded:o.sort()}},compare:Ie,literalToReference:Oe};var Ue=function(e){const t={},n=e.allAttributesPrivate,r=e.privateAttributes||[],o=["key","kind","_meta","anonymous"],i=["name","ip","firstName","lastName","email","avatar","country"],a=e=>{if("object"!=typeof e||null===e||Array.isArray(e))return;const{cloned:t,excluded:i}=Le.cloneExcluding(e,(e=>(n?Object.keys(e):[...r,...e._meta&&e._meta.privateAttributes||[]]).filter((e=>!o.some((t=>Le.compare(e,t))))))(e));return t.key=String(t.key),i.length&&(t._meta||(t._meta={}),t._meta.redactedAttributes=i),t._meta&&(delete t._meta.privateAttributes,0===Object.keys(t._meta).length&&delete t._meta),void 0!==t.anonymous&&(t.anonymous=!!t.anonymous),t};return t.filter=e=>void 0===e.kind||null===e.kind?a((e=>{const t={...e.custom||{},kind:"user",key:e.key};void 0!==e.anonymous&&(t.anonymous=!!e.anonymous);for(const n of i)delete t[n],void 0!==e[n]&&null!==e[n]&&(t[n]=String(e[n]));return void 0!==e.privateAttributeNames&&null!==e.privateAttributeNames&&(t._meta=t._meta||{},t._meta.privateAttributes=e.privateAttributeNames.map((e=>e.startsWith("/")?Le.literalToReference(e):e))),t})(e)):"multi"===e.kind?(e=>{const t={kind:e.kind},n=Object.keys(e);for(const r of n)if("kind"!==r){const n=a(e[r]);n&&(t[r]=n)}return t})(e):a(e),t};const{getContextKeys:Te}=Ee;var Re=function(e,t,n,r=null,o=null,i=null){const a={},c=i||ye(e,n,t),u=I.appendUrlPath(t.eventsUrl,"/events/bulk/"+n),l=Ce(),d=Ue(t),f=t.samplingInterval,g=t.eventCapacity,v=t.flushInterval,p=t.logger;let m,h=[],y=0,w=!1,b=!1;function k(){return 0===f||0===Math.floor(Math.random()*f)}function E(e){const t=I.extend({},e);return"identify"===e.kind?t.context=d.filter(e.context):(t.contextKeys=Te(e.context,p),delete t.context),"feature"===e.kind&&(delete t.trackEvents,delete t.debugEventsUntilDate),t}function D(e){h.length<g?(h.push(e),b=!1):(b||(b=!0,p.warn(ae.eventCapacityExceeded())),r&&r.incrementDroppedEvents())}return a.enqueue=function(e){if(w)return;let t=!1,n=!1;var r;if(l.summarizeEvent(e),"feature"===e.kind?k()&&(t=!!e.trackEvents,n=!!(r=e).debugEventsUntilDate&&r.debugEventsUntilDate>y&&r.debugEventsUntilDate>(new Date).getTime()):t=k(),t&&D(E(e)),n){const t=I.extend({},e,{kind:"debug"});t.context=d.filter(t.context),delete t.trackEvents,delete t.debugEventsUntilDate,D(t)}},a.flush=function(){if(w)return Promise.resolve();const e=h,t=l.getSummary();return l.clearSummary(),t&&(t.kind="summary",e.push(t)),r&&r.setEventsInLastBatch(e.length),0===e.length?Promise.resolve():(h=[],p.debug(ae.debugPostingEvents(e.length)),c.sendEvents(e,u).then((e=>{const t=e&&e[0];t&&(t.serverTime&&(y=t.serverTime),ldclient_es_s.isHttpErrorRecoverable(t.status)||(w=!0),t.status>=400&&I.onNextTick((()=>{o.maybeReportError(new ldclient_es_s.LDUnexpectedResponseError(ae.httpErrorMessage(t.status,"event posting","some events were dropped")))})))})))},a.start=function(){const e=()=>{a.flush(),m=setTimeout(e,v)};m=setTimeout(e,v)},a.stop=function(){clearTimeout(m)},a};var Ae=function(e){const t={},n={};return t.on=function(e,t,r){n[e]=n[e]||[],n[e]=n[e].concat({handler:t,context:r})},t.off=function(e,t,r){if(n[e])for(let o=0;o<n[e].length;o++)n[e][o].handler===t&&n[e][o].context===r&&(n[e]=n[e].slice(0,o).concat(n[e].slice(o+1)))},t.emit=function(e){if(!n[e])return;const t=n[e].slice(0);for(let e=0;e<t.length;e++)t[e].handler.apply(t[e].context,Array.prototype.slice.call(arguments,1))},t.getEvents=function(){return Object.keys(n)},t.getEventListenerCount=function(e){return n[e]?n[e].length:0},t.maybeReportError=function(t){t&&(n["error"]?this.emit("error",t):(e||console).error(t.message))},t};const je="ready",Fe="initialized",Ne="failed";var $e=function(e){let t=!1,n=!1,r=null,o=null;const i=new Promise((t=>{const n=()=>{e.off(je,n),t()};e.on(je,n)})).catch((()=>{}));return{getInitializationPromise:()=>o||(t?Promise.resolve():n?Promise.reject(r):(o=new Promise(((t,n)=>{const r=()=>{e.off(Fe,r),t()},o=t=>{e.off(Ne,o),n(t)};e.on(Fe,r),e.on(Ne,o)})),o)),getReadyPromise:()=>i,signalSuccess:()=>{t||n||(t=!0,e.emit(Fe),e.emit(je))},signalFailure:o=>{t||n||(n=!0,r=o,e.emit(Ne,o),e.emit(je)),e.maybeReportError(o)}}};var Ve=function(e,t,n,r){const o={};function i(){let e="";const o=r.getContext();return o&&(e=n||I.btoa(JSON.stringify(o))),"ld:"+t+":"+e}return o.loadFlags=()=>e.get(i()).then((e=>{if(null==e)return null;try{let t=JSON.parse(e);if(t){const e=t.$schema;void 0===e||e<1?t=I.transformValuesToVersionedValues(t):delete t.$schema}return t}catch(e){return o.clearFlags().then((()=>null))}})),o.saveFlags=t=>{const n=I.extend({},t,{$schema:1});return e.set(i(),JSON.stringify(n))},o.clearFlags=()=>e.clear(i()),o};var He=function(e,t){const n={};let r=!1;const o=e=>{r||(r=!0,t.warn(ae.localStorageUnavailable(e)))};return n.isEnabled=()=>!!e,n.get=t=>new Promise((n=>{e?e.get(t).then(n).catch((e=>{o(e),n(void 0)})):n(void 0)})),n.set=(t,n)=>new Promise((r=>{e?e.set(t,n).then((()=>r(!0))).catch((e=>{o(e),r(!1)})):r(!1)})),n.clear=t=>new Promise((n=>{e?e.clear(t).then((()=>n(!0))).catch((e=>{o(e),n(!1)})):n(!1)})),n};const{appendUrlPath:qe,base64URLEncode:Me,objectHasOwnProperty:Ke}=I,{getLDHeaders:_e,transformHeaders:Je}=ve,{isHttpErrorRecoverable:ze}=ldclient_es_s;var Be=function(e,t,n,r){const o=t.streamUrl,i=t.logger,a={},s=qe(o,"/eval/"+n),c=t.useReport,u=t.evaluationReasons,l=t.streamReconnectDelay,d=_e(e,t);let f,g=!1,v=null,p=null,m=null,h=null,y=null,w=0;function b(){const e=(t=function(){const e=l*Math.pow(2,w);return e>3e4?3e4:e}(),t-Math.trunc(.5*Math.random()*t));var t;return w+=1,e}function k(e){if(e.status&&"number"==typeof e.status&&!ze(e.status))return C(),i.error(ae.unrecoverableStreamError(e)),void(p&&(clearTimeout(p),p=null));const t=b();g||(i.warn(ae.streamError(e,t)),g=!0),x(!1),C(),E(t)}function E(e){p||(e?p=setTimeout(D,e):D())}function D(){let r;p=null;let a="";const l={headers:d,readTimeoutMillis:3e5};if(e.eventSourceFactory){null!=h&&(a="h="+h),c?e.eventSourceAllowsReport?(r=s,l.method="REPORT",l.headers["Content-Type"]="application/json",l.body=JSON.stringify(m)):(r=qe(o,"/ping/"+n),a=""):r=s+"/"+Me(JSON.stringify(m)),l.headers=Je(l.headers,t),u&&(a=a+(a?"&":"")+"withReasons=true"),r=r+(a?"?":"")+a,C(),i.info(ae.streamConnecting(r)),f=(new Date).getTime(),v=e.eventSourceFactory(r,l);for(const e in y)Ke(y,e)&&v.addEventListener(e,y[e]);v.onerror=k,v.onopen=()=>{w=0}}}function C(){v&&(i.info(ae.streamClosing()),v.close(),v=null)}function x(e){f&&r&&r.recordStreamInit(f,!e,(new Date).getTime()-f),f=null}return a.connect=function(e,t,n){m=e,h=t,y={};for(const e in n||{})y[e]=function(t){g=!1,x(!0),n[e]&&n[e](t)};E()},a.disconnect=function(){clearTimeout(p),p=null,C()},a.isConnected=function(){return!!(v&&e.eventSourceIsActive&&e.eventSourceIsActive(v))},a};var Ge=function(e){let t,n,r,o;const i={addPromise:(i,a)=>{t=i,n&&n(),n=a,i.then((n=>{t===i&&(r(n),e&&e())}),(n=>{t===i&&(o(n),e&&e())}))}};return i.resultPromise=new Promise(((e,t)=>{r=e,o=t})),i};const{transformHeaders:We,getLDHeaders:Xe}=ve,Qe="application/json";var Ye=function(e,t,n){const r=t.baseUrl,o=t.useReport,i=t.evaluationReasons,a=t.logger,c={},u={};function l(n,r){if(!e.httpRequest)return new Promise(((e,t)=>{t(new ldclient_es_s.LDFlagFetchError(ae.httpUnavailable()))}));const o=r?"REPORT":"GET",i=Xe(e,t);r&&(i["Content-Type"]=Qe);let a=u[n];a||(a=Ge((()=>{delete u[n]})),u[n]=a);const c=e.httpRequest(o,n,We(i,t),r),l=c.promise.then((e=>{if(200===e.status){if(e.header("content-type")&&e.header("content-type").substring(0,16)===Qe)return JSON.parse(e.body);{const t=ae.invalidContentType(e.header("content-type")||"");return Promise.reject(new ldclient_es_s.LDFlagFetchError(t))}}return Promise.reject(function(e){return 404===e.status?new ldclient_es_s.LDInvalidEnvironmentIdError(ae.environmentNotFound()):new ldclient_es_s.LDFlagFetchError(ae.errorFetchingFlags(e.statusText||String(e.status)))}(e))}),(e=>Promise.reject(new ldclient_es_s.LDFlagFetchError(ae.networkError(e)))));return a.addPromise(l,(()=>{c.cancel&&c.cancel()})),a.resultPromise}return c.fetchJSON=function(e){return l(I.appendUrlPath(r,e),null)},c.fetchFlagSettings=function(e,t){let s,c,u,d="";return o?(c=[r,"/sdk/evalx/",n,"/context"].join(""),u=JSON.stringify(e)):(s=I.base64URLEncode(JSON.stringify(e)),c=[r,"/sdk/evalx/",n,"/contexts/",s].join("")),t&&(d="h="+t),i&&(d=d+(d?"&":"")+"withReasons=true"),c=c+(d?"?":"")+d,a.debug(ae.debugPolling(c)),l(c,u)},c};var Ze=function(e,t){const n={};let r;return n.setContext=function(e){r=I.sanitizeContext(e),r&&t&&t(I.clone(r))},n.getContext=function(){return r?I.clone(r):null},e&&n.setContext(e),n};const{v1:et}=te,{getContextKinds:tt}=Ee;var nt=function(e){function t(e){return null==e||"user"===e?"ld:$anonUserId":`ld:$contextKey:${e}`}function n(n,r){return null!==r.key&&void 0!==r.key?(r.key=r.key.toString(),Promise.resolve(r)):r.anonymous?function(n){return e.get(t(n))}(n).then((o=>{if(o)return r.key=o,r;{const o=et();return r.key=o,function(n,r){return e.set(t(r),n)}(o,n).then((()=>r))}})):Promise.reject(new ldclient_es_s.LDInvalidUserError(ae.invalidContext()))}this.processContext=e=>{if(!e)return Promise.reject(new ldclient_es_s.LDInvalidUserError(ae.contextNotSpecified()));const t=I.clone(e);if("multi"===e.kind){const e=tt(t);return Promise.all(e.map((e=>n(e,t[e])))).then((()=>t))}return n(e.kind,t)}};const{v1:rt}=te,{baseOptionDefs:ot}=fe,{appendUrlPath:it}=I;var at={DiagnosticId:function(e){const t={diagnosticId:rt()};return e&&(t.sdkKeySuffix=e.length>6?e.substring(e.length-6):e),t},DiagnosticsAccumulator:function(e){let t,n,r,o;function i(e){t=e,n=0,r=0,o=[]}return i(e),{getProps:()=>({dataSinceDate:t,droppedEvents:n,eventsInLastBatch:r,streamInits:o}),setProps:e=>{t=e.dataSinceDate,n=e.droppedEvents||0,r=e.eventsInLastBatch||0,o=e.streamInits||[]},incrementDroppedEvents:()=>{n++},setEventsInLastBatch:e=>{r=e},recordStreamInit:(e,t,n)=>{const r={timestamp:e,failed:t,durationMillis:n};o.push(r)},reset:i}},DiagnosticsManager:function(e,t,n,r,o,i,a){const s=!!e.diagnosticUseCombinedEvent,c="ld:"+o+":$diagnostics",u=it(i.eventsUrl,"/events/diagnostic/"+o),l=i.diagnosticRecordingInterval,d=n;let f,g,v=!!i.streaming;const p={};function m(){return{sdk:w(),configuration:b(),platform:e.diagnosticPlatformData}}function h(e){i.logger&&i.logger.debug(ae.debugPostingDiagnosticEvent(e)),r.sendEvents(e,u,!0).then((()=>{})).catch((()=>{}))}function y(){h(function(){const e=(new Date).getTime();let t={kind:s?"diagnostic-combined":"diagnostic",id:a,creationDate:e,...d.getProps()};return s&&(t={...t,...m()}),d.reset(e),t}()),g=setTimeout(y,l),f=(new Date).getTime(),s&&function(){if(t.isEnabled()){const e={...d.getProps()};t.set(c,JSON.stringify(e))}}()}function w(){const t={...e.diagnosticSdkData};return i.wrapperName&&(t.wrapperName=i.wrapperName),i.wrapperVersion&&(t.wrapperVersion=i.wrapperVersion),t}function b(){return{customBaseURI:i.baseUrl!==ot.baseUrl.default,customStreamURI:i.streamUrl!==ot.streamUrl.default,customEventsURI:i.eventsUrl!==ot.eventsUrl.default,eventsCapacity:i.eventCapacity,eventsFlushIntervalMillis:i.flushInterval,reconnectTimeMillis:i.streamReconnectDelay,streamingDisabled:!v,allAttributesPrivate:!!i.allAttributesPrivate,diagnosticRecordingIntervalMillis:i.diagnosticRecordingInterval,usingSecureMode:!!i.hash,bootstrapMode:!!i.bootstrap,fetchGoalsDisabled:!i.fetchGoals,sendEventsOnlyForVariation:!!i.sendEventsOnlyForVariation}}return p.start=()=>{s?function(e){if(!t.isEnabled())return e(!1);t.get(c).then((t=>{if(t)try{const e=JSON.parse(t);d.setProps(e),f=e.dataSinceDate}catch(e){}e(!0)})).catch((()=>{e(!1)}))}((e=>{if(e){const e=(f||0)+l,t=(new Date).getTime();t>=e?y():g=setTimeout(y,e-t)}else 0===Math.floor(4*Math.random())?y():g=setTimeout(y,l)})):(h({kind:"diagnostic-init",id:a,creationDate:d.getProps().dataSinceDate,...m()}),g=setTimeout(y,l))},p.stop=()=>{g&&clearTimeout(g)},p.setStreaming=e=>{v=e},p}};var st=function(e,t){let n=!1;const r={type:e.type,name:e.name,method:(...o)=>{try{e.method(...o)}catch{n||(n=!0,t.warn(ae.inspectorMethodError(r.type,r.name)))}}};return r};const{onNextTick:ct}=I,ut={flagUsed:"flag-used",flagDetailsChanged:"flag-details-changed",flagDetailChanged:"flag-detail-changed",clientIdentityChanged:"client-identity-changed"};Object.freeze(ut);var lt={InspectorTypes:ut,InspectorManager:function(e,t){const n={},r={[ut.flagUsed]:[],[ut.flagDetailsChanged]:[],[ut.flagDetailChanged]:[],[ut.clientIdentityChanged]:[]},o=e&&e.map((e=>st(e,t)));return o&&o.forEach((e=>{Object.prototype.hasOwnProperty.call(r,e.type)?r[e.type].push(e):t.warn(ae.invalidInspector(e.type,e.name))})),n.hasListeners=e=>r[e]&&r[e].length,n.onFlagUsed=(e,t,n)=>{r[ut.flagUsed].length&&ct((()=>{r[ut.flagUsed].forEach((r=>r.method(e,t,n)))}))},n.onFlags=e=>{r[ut.flagDetailsChanged].length&&ct((()=>{r[ut.flagDetailsChanged].forEach((t=>t.method(e)))}))},n.onFlagChanged=(e,t)=>{r[ut.flagDetailChanged].length&&ct((()=>{r[ut.flagDetailChanged].forEach((n=>n.method(e,t)))}))},n.onIdentityChanged=e=>{r[ut.clientIdentityChanged].length&&ct((()=>{r[ut.clientIdentityChanged].forEach((t=>t.method(e)))}))},n}};const{commonBasicLogger:dt}=re,{checkContext:ft,getContextKeys:gt}=Ee,{InspectorTypes:vt,InspectorManager:pt}=lt,mt="change",ht="internal-change";var yt={initialize:function(e,t,n,r,o){const i=function(){if(n&&n.logger)return n.logger;return o&&o.logger&&o.logger.default||dt("warn")}(),a=Ae(i),c=$e(a),u=fe.validate(n,a,o,i),l=pt(u.inspectors,i),d=u.sendEvents;let f=e,g=u.hash;const v=He(r.localStorage,i),p=ye(r,f,u),m=u.sendEvents&&!u.diagnosticOptOut,h=m?at.DiagnosticId(f):null,y=m?at.DiagnosticsAccumulator((new Date).getTime()):null,w=m?at.DiagnosticsManager(r,v,y,p,f,u,h):null,b=Be(r,u,f,y),k=u.eventProcessor||Re(r,u,f,y,a,p),E=Ye(r,u,f);let D,C,x,P={},S=u.streaming,O=!1,L=!1,U=!0;const T=u.stateProvider,R=Ze(null,(function(e){(function(e){if(T)return;e&&F({kind:"identify",context:e,creationDate:(new Date).getTime()})})(e),l.hasListeners(vt.clientIdentityChanged)&&l.onIdentityChanged(R.getContext())})),A=new nt(v),j=v.isEnabled()?Ve(v,f,g,R):null;function F(e){f&&(T&&T.enqueueEvent&&T.enqueueEvent(e)||(e.context?(U=!1,!d||L||r.isDoNotTrack()||(i.debug(ae.debugEnqueueingEvent(e.kind)),k.enqueue(e))):U&&(i.warn(ae.eventWithoutContext()),U=!1)))}function N(e,t){l.hasListeners(vt.flagDetailChanged)&&l.onFlagChanged(e.key,M(t))}function $(){l.hasListeners(vt.flagDetailsChanged)&&l.onFlags(Object.entries(P).map((([e,t])=>({key:e,detail:M(t)}))).reduce(((e,t)=>(e[t.key]=t.detail,e)),{}))}function V(e,t,n,r){const o=R.getContext(),i=new Date,a={kind:"feature",key:e,context:o,value:t?t.value:null,variation:t?t.variationIndex:null,default:n,creationDate:i.getTime()},s=P[e];s&&(a.version=s.flagVersion?s.flagVersion:s.version,a.trackEvents=s.trackEvents,a.debugEventsUntilDate=s.debugEventsUntilDate),(r||s&&s.trackReason)&&t&&(a.reason=t.reason),F(a)}function H(e){return ft(e,!1)?Promise.resolve(e):Promise.reject(new ldclient_es_s.LDInvalidUserError(ae.invalidContext()))}function q(e,t,n,r,o){let i;if(P&&I.objectHasOwnProperty(P,e)&&P[e]&&!P[e].deleted){const n=P[e];i=M(n),null!==n.value&&void 0!==n.value||(i.value=t)}else i={value:t,variationIndex:null,reason:{kind:"ERROR",errorKind:"FLAG_NOT_FOUND"}};return n&&V(e,i,t,r),o||function(e,t){l.hasListeners(vt.flagUsed)&&l.onFlagUsed(e,t,R.getContext())}(e,i),i}function M(e){return{value:e.value,variationIndex:void 0===e.variation?null:e.variation,reason:e.reason||null}}function K(){if(C=!0,!R.getContext())return;const e=e=>{try{return JSON.parse(e)}catch(e){return void a.maybeReportError(new ldclient_es_s.LDInvalidDataError(ae.invalidData()))}};b.connect(R.getContext(),g,{ping:function(){i.debug(ae.debugStreamPing());const e=R.getContext();E.fetchFlagSettings(e,g).then((t=>{I.deepEquals(e,R.getContext())&&J(t||{})})).catch((e=>{a.maybeReportError(new ldclient_es_s.LDFlagFetchError(ae.errorFetchingFlags(e)))}))},put:function(t){const n=e(t.data);n&&(i.debug(ae.debugStreamPut()),J(n))},patch:function(t){const n=e(t.data);if(!n)return;const r=P[n.key];if(!r||!r.version||!n.version||r.version<n.version){i.debug(ae.debugStreamPatch(n.key));const e={},t=I.extend({},n);delete t.key,P[n.key]=t;const o=M(t);e[n.key]=r?{previous:r.value,current:o}:{current:o},z(e),N(n,t)}else i.debug(ae.debugStreamPatchIgnored(n.key))},delete:function(t){const n=e(t.data);if(n)if(!P[n.key]||P[n.key].version<n.version){i.debug(ae.debugStreamDelete(n.key));const e={};P[n.key]&&!P[n.key].deleted&&(e[n.key]={previous:P[n.key].value}),P[n.key]={version:n.version,deleted:!0},N(n,P[n.key]),z(e)}else i.debug(ae.debugStreamDeleteIgnored(n.key))}})}function _(){C&&(b.disconnect(),C=!1)}function J(e){const t={};if(!e)return Promise.resolve();for(const n in P)I.objectHasOwnProperty(P,n)&&P[n]&&(e[n]&&!I.deepEquals(e[n].value,P[n].value)?t[n]={previous:P[n].value,current:M(e[n])}:e[n]&&!e[n].deleted||(t[n]={previous:P[n].value}));for(const n in e)I.objectHasOwnProperty(e,n)&&e[n]&&(!P[n]||P[n].deleted)&&(t[n]={current:M(e[n])});return P={...e},$(),z(t).catch((()=>{}))}function z(e){const t=Object.keys(e);if(t.length>0){const n={};t.forEach((t=>{const r=e[t].current,o=r?r.value:void 0,i=e[t].previous;a.emit(mt+":"+t,o,i),n[t]=r?{current:o,previous:i}:{previous:i}})),a.emit(mt,n),a.emit(ht,P),u.sendEventsOnlyForVariation||T||t.forEach((t=>{V(t,e[t].current)}))}return D&&j?j.saveFlags(P):Promise.resolve()}function B(){const e=S||x&&void 0===S;e&&!C?K():!e&&C&&_(),w&&w.setStreaming(e)}function G(e){return e===mt||e.substr(0,7)===mt+":"}if("string"==typeof u.bootstrap&&"LOCALSTORAGE"===u.bootstrap.toUpperCase()&&(j?D=!0:i.warn(ae.localStorageUnavailable())),"object"==typeof u.bootstrap&&(P=function(e){const t=Object.keys(e),n="$flagsState",r="$valid",o=e[n];!o&&t.length&&i.warn(ae.bootstrapOldFormat()),!1===e[r]&&i.warn(ae.bootstrapInvalid());const a={};return t.forEach((t=>{if(t!==n&&t!==r){let n={value:e[t]};o&&o[t]?n=I.extend(n,o[t]):n.version=0,a[t]=n}})),a}(u.bootstrap)),T){const e=T.getInitialState();e?W(e):T.on("init",W),T.on("update",(function(e){e.context&&R.setContext(e.context);e.flags&&J(e.flags)}))}else(function(){if(!e)return Promise.reject(new ldclient_es_s.LDInvalidEnvironmentIdError(ae.environmentNotSpecified()));return A.processContext(t).then(H).then((e=>(R.setContext(e),"object"==typeof u.bootstrap?X():D?j.loadFlags().then((e=>null==e?(P={},E.fetchFlagSettings(R.getContext(),g).then((e=>J(e||{}))).then(X).catch((e=>{Q(new ldclient_es_s.LDFlagFetchError(ae.errorFetchingFlags(e)))}))):(P=e,I.onNextTick(X),E.fetchFlagSettings(R.getContext(),g).then((e=>J(e))).catch((e=>a.maybeReportError(e)))))):E.fetchFlagSettings(R.getContext(),g).then((e=>{P=e||{},$(),X()})).catch((e=>{P={},Q(e)})))))})().catch(Q);function W(e){f=e.environment,R.setContext(e.context),P={...e.flags},I.onNextTick(X)}function X(){i.info(ae.clientInitialized()),O=!0,B(),c.signalSuccess()}function Q(e){c.signalFailure(e)}const Y={waitForInitialization:()=>c.getInitializationPromise(),waitUntilReady:()=>c.getReadyPromise(),identify:function(e,t,n){if(L)return I.wrapPromiseCallback(Promise.resolve({}),n);if(T)return i.warn(ae.identifyDisabled()),I.wrapPromiseCallback(Promise.resolve(I.transformVersionedValuesToValues(P)),n);const r=D&&j?j.clearFlags():Promise.resolve();return I.wrapPromiseCallback(r.then((()=>A.processContext(e))).then(H).then((e=>E.fetchFlagSettings(e,t).then((n=>{const r=I.transformVersionedValuesToValues(n);return R.setContext(e),g=t,n?J(n).then((()=>r)):r})))).then((e=>(C&&K(),e))).catch((e=>(a.maybeReportError(e),Promise.reject(e)))),n)},getContext:function(){return R.getContext()},variation:function(e,t){return q(e,t,!0,!1,!1).value},variationDetail:function(e,t){return q(e,t,!0,!0,!1)},track:function(e,t,n){if("string"!=typeof e)return void a.maybeReportError(new ldclient_es_s.LDInvalidEventKeyError(ae.unknownCustomEventKey(e)));r.customEventFilter&&!r.customEventFilter(e)&&i.warn(ae.unknownCustomEventKey(e));const o=R.getContext(),c={kind:"custom",key:e,context:o,url:r.getCurrentUrl(),creationDate:(new Date).getTime()};o&&o.anonymous&&(c.contextKind=o.anonymous?"anonymousUser":"user"),null!=t&&(c.data=t),null!=n&&(c.metricValue=n),F(c)},on:function(e,t,n){G(e)?(x=!0,O&&B(),a.on(e,t,n)):a.on(...arguments)},off:function(e){if(a.off(...arguments),G(e)){let e=!1;a.getEvents().forEach((t=>{G(t)&&a.getEventListenerCount(t)>0&&(e=!0)})),e||(x=!1,C&&void 0===S&&_())}},setStreaming:function(e){const t=null===e?void 0:e;t!==S&&(S=t,B())},flush:function(e){return I.wrapPromiseCallback(d?k.flush():Promise.resolve(),e)},allFlags:function(){const e={};if(!P)return e;for(const t in P)I.objectHasOwnProperty(P,t)&&!P[t].deleted&&(e[t]=q(t,null,!u.sendEventsOnlyForVariation,!1,!0).value);return e},close:function(e){if(L)return I.wrapPromiseCallback(Promise.resolve(),e);const t=()=>{L=!0,P={}},n=Promise.resolve().then((()=>{if(_(),w&&w.stop(),d)return k.stop(),k.flush()})).then(t).catch(t);return I.wrapPromiseCallback(n,e)}};return{client:Y,options:u,emitter:a,ident:R,logger:i,requestor:E,start:function(){d&&(w&&w.start(),k.start())},enqueueEvent:F,getFlagsInternal:function(){return P},getEnvironmentId:()=>f,internalChangeEventName:ht}},commonBasicLogger:dt,errors:ldclient_es_s,messages:ae,utils:I,getContextKeys:gt},wt=yt.initialize,bt=yt.errors,kt=yt.messages;function Et(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function Dt(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Et(Object(n),!0).forEach((function(t){Ct(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Et(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}function Ct(e,t,n){return(t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t||"default");if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var xt=yt.commonBasicLogger;var Pt=function(e){return xt(Dt({destination:console.log},e))};var St={promise:Promise.resolve({status:200,header:function(){return null},body:null})};function It(e,t,n,r,o){if(o&&!function(){var e=window.navigator&&window.navigator.userAgent;if(e){var t=e.match(/Chrom(e|ium)\/([0-9]+)\./);if(t)return parseInt(t[2],10)<73}return!0}())return St;var i=new window.XMLHttpRequest;for(var a in i.open(e,t,!o),n||{})Object.prototype.hasOwnProperty.call(n,a)&&i.setRequestHeader(a,n[a]);if(o){try{i.send(r)}catch(e){}return St}var s,c=new Promise((function(e,t){i.addEventListener("load",(function(){s||e({status:i.status,header:function(e){return i.getResponseHeader(e)},body:i.responseText})})),i.addEventListener("error",(function(){s||t(new Error)})),i.send(r)}));return{promise:c,cancel:function(){s=!0,i.abort()}}}var Ot=e=>{if("string"!=typeof e)throw new TypeError("Expected a string");return e.replace(/[|\\{}()[\]^$+*?.]/g,"\\$&").replace(/-/g,"\\x2d")};function Lt(e,t,n,r){var o,i,a=(("substring"===e.kind||"regex"===e.kind)&&r.includes("/")?t:t.replace(r,"")).replace(n,"");switch(e.kind){case"exact":i=t,o=new RegExp("^"+Ot(e.url)+"/?$");break;case"canonical":i=a,o=new RegExp("^"+Ot(e.url)+"/?$");break;case"substring":i=a,o=new RegExp(".*"+Ot(e.substring)+".*$");break;case"regex":i=a,o=new RegExp(e.pattern);break;default:return!1}return o.test(i)}function Ut(e,t){for(var n={},r=null,o=[],i=0;i<e.length;i++)for(var a=e[i],s=a.urls||[],c=0;c<s.length;c++)if(Lt(s[c],window.location.href,window.location.search,window.location.hash)){"pageview"===a.kind?t("pageview",a):(o.push(a),t("click_pageview",a));break}return o.length>0&&(r=function(e){for(var n=function(e,t){for(var n=[],r=0;r<t.length;r++)for(var o=e.target,i=t[r],a=i.selector,s=document.querySelectorAll(a);o&&s.length>0;){for(var c=0;c<s.length;c++)o===s[c]&&n.push(i);o=o.parentNode}return n}(e,o),r=0;r<n.length;r++)t("click",n[r])},document.addEventListener("click",r)),n.dispose=function(){document.removeEventListener("click",r)},n}var Tt=300;function Rt(e,t){var n,r;function o(){r&&r.dispose(),n&&n.length&&(r=Ut(n,i))}function i(t,n){var r=e.ident.getContext(),o={kind:t,key:n.key,data:null,url:window.location.href,creationDate:(new Date).getTime(),context:r};return"click"===t&&(o.selector=n.selector),e.enqueueEvent(o)}return e.requestor.fetchJSON("/sdk/goals/"+e.getEnvironmentId()).then((function(e){e&&e.length>0&&(r=Ut(n=e,i),function(e,t){var n,r=window.location.href;function o(){(n=window.location.href)!==r&&(r=n,t())}!function e(t,n){t(),setTimeout((function(){e(t,n)}),n)}(o,e),window.history&&window.history.pushState?window.addEventListener("popstate",o):window.addEventListener("hashchange",o)}(Tt,o)),t()})).catch((function(n){e.emitter.maybeReportError(new bt.LDUnexpectedResponseError((n&&n.message,n.message))),t()})),{}}var At="goalsReady",jt={fetchGoals:{default:!0},hash:{type:"string"},eventProcessor:{type:"object"},eventUrlTransformer:{type:"function"},disableSyncEventPost:{default:!1}};function Ft(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=function(e){var t,n={userAgentHeaderName:"X-LaunchDarkly-User-Agent",synchronousFlush:!1};if(window.XMLHttpRequest){var r=e&&e.disableSyncEventPost;n.httpRequest=function(e,t,o,i){var a=n.synchronousFlush&!r;return n.synchronousFlush=!1,It(e,t,o,i,a)}}n.httpAllowsPost=function(){return void 0===t&&(t=!!window.XMLHttpRequest&&"withCredentials"in new window.XMLHttpRequest),t},n.httpFallbackPing=function(e){(new window.Image).src=e};var o,i=e&&e.eventUrlTransformer;n.getCurrentUrl=function(){return i?i(window.location.href):window.location.href},n.isDoNotTrack=function(){var e;return 1===(e=window.navigator&&void 0!==window.navigator.doNotTrack?window.navigator.doNotTrack:window.navigator&&void 0!==window.navigator.msDoNotTrack?window.navigator.msDoNotTrack:window.doNotTrack)||!0===e||"1"===e||"yes"===e};try{window.localStorage&&(n.localStorage={get:function(e){return new Promise((function(t){t(window.localStorage.getItem(e))}))},set:function(e,t){return new Promise((function(n){window.localStorage.setItem(e,t),n()}))},clear:function(e){return new Promise((function(t){window.localStorage.removeItem(e),t()}))}})}catch(e){n.localStorage=null}if(e&&e.useReport&&"function"==typeof window.EventSourcePolyfill&&window.EventSourcePolyfill.supportedOptions&&window.EventSourcePolyfill.supportedOptions.method?(n.eventSourceAllowsReport=!0,o=window.EventSourcePolyfill):(n.eventSourceAllowsReport=!1,o=window.EventSource),window.EventSource){var a=3e5;n.eventSourceFactory=function(e,t){var n=Dt(Dt({},{heartbeatTimeout:a,silentTimeout:a,skipDefaultHeaders:!0}),t);return new o(e,n)},n.eventSourceIsActive=function(e){return e.readyState===window.EventSource.OPEN||e.readyState===window.EventSource.CONNECTING}}return n.userAgent="JSClient",n.version="3.1.4",n.diagnosticSdkData={name:"js-client-sdk",version:"3.1.4"},n.diagnosticPlatformData={name:"JS"},n.diagnosticUseCombinedEvent=!0,n}(n),o=wt(e,t,n,r,jt),i=o.client,a=o.options,s=o.emitter,c=new Promise((function(e){var t=s.on(At,(function(){s.off(At,t),e()}))}));i.waitUntilGoalsReady=function(){return c},a.fetchGoals?Rt(o,(function(){return s.emit(At)})):s.emit(At),"complete"!==document.readyState?window.addEventListener("load",o.start):o.start();var u=function(){r.synchronousFlush=!0,i.flush().catch((function(){})),r.synchronousFlush=!1};return document.addEventListener("visibilitychange",(function(){"hidden"===document.visibilityState&&u()})),window.addEventListener("pagehide",u),i}var Nt=(/* unused pure expression or super */ null && (Pt)),$t=void 0,Vt="3.1.4";var Ht={initialize:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return console&&console.warn&&console.warn(kt.deprecated("default export","named LDClient export")),Ft(e,t,n)},version:Vt};
//# sourceMappingURL=ldclient.es.js.map

// EXTERNAL MODULE: ../../../node_modules/lodash.camelcase/index.js
var lodash_camelcase = __webpack_require__(8122);
var lodash_camelcase_default = /*#__PURE__*/__webpack_require__.n(lodash_camelcase);
// EXTERNAL MODULE: ../../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(86058);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../node_modules/launchdarkly-react-client-sdk/lib/esm/index.js
const esm_p={useCamelCaseFlagKeys:!0,sendEventsOnFlagRead:!0},esm_u=(0,react.createContext)({flags:{},flagKeyMap:{},ldClient:void 0}),{Provider:esm_f,Consumer:esm_y}=esm_u,esm_d=e=>{var t;return null!=(t=e.context)?t:e.user},esm_g=e=>{const t={};for(const r in e)0!==r.indexOf("$")&&(t[lodash_camelcase_default()(r)]=e[r]);return t},esm_b=(e,t)=>{const r={};for(const n in e)t&&void 0===t[n]||(r[n]=e[n].current);return r},esm_h=(e,t)=>{const r=e.allFlags();return t?Object.keys(t).reduce(((e,n)=>(e[n]=Object.prototype.hasOwnProperty.call(r,n)?r[n]:t[n],e)),{}):r};esm_g.camelCaseKeys=esm_g;var esm_O=Object.defineProperty,esm_m=Object.getOwnPropertySymbols,esm_v=Object.prototype.hasOwnProperty,esm_j=Object.prototype.propertyIsEnumerable,esm_P=(e,t,r)=>t in e?esm_O(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,esm_w=(e,t)=>{for(var r in t||(t={}))esm_v.call(t,r)&&esm_P(e,r,t[r]);if(esm_m)for(var r of esm_m(t))esm_j.call(t,r)&&esm_P(e,r,t[r]);return e};const esm_C={wrapperName:"react-client-sdk",wrapperVersion:"3.0.9",sendEventsOnlyForVariation:!0},esm_x=(e,...t)=>{return r=void 0,n=[e,...t],o=function*(e,t={anonymous:!0,kind:"user"},r,n){const o=Ft(e,t,esm_w(esm_w({},esm_C),r));return new Promise((e=>{function t(){o.off("ready",s),o.off("failed",r)}function r(r){t(),e({flags:{},ldClient:o,error:r})}function s(){t();const r=esm_h(o,n);e({flags:r,ldClient:o})}o.on("failed",r),o.on("ready",s)}))},new Promise(((e,t)=>{var s=e=>{try{l(o.next(e))}catch(e){t(e)}},a=e=>{try{l(o.throw(e))}catch(e){t(e)}},l=t=>t.done?e(t.value):Promise.resolve(t.value).then(s,a);l((o=o.apply(r,n)).next())}));var r,n,o};function esm_F(e,t,r=esm_p,n){const o=function(e,t){if(void 0===t)return e;return Object.keys(t).reduce(((t,r)=>(esm_E(e,r)&&(t[r]=e[r]),t)),{})}(t,n),{useCamelCaseFlagKeys:s=!0}=r,[a,l={}]=s?function(e){const t={},r={};for(const n in e){if(0===n.indexOf("$"))continue;const o=lodash_camelcase_default()(n);t[o]=e[n],r[o]=n}return[t,r]}(o):[o];return{flags:r.sendEventsOnFlagRead?esm_K(e,a,l,s):a,flagKeyMap:l}}function esm_E(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function esm_K(e,t,r,n){return new Proxy(t,{get(t,o,s){const a=Reflect.get(t,o,s),l=n&&esm_E(r,o)||esm_E(t,o);if("symbol"==typeof o||!l)return a;if(void 0===a)return;const i=n?r[o]:o;return e.variation(i,a)}})}var esm_S=Object.defineProperty,esm_k=Object.defineProperties,esm_D=Object.getOwnPropertyDescriptors,esm_I=Object.getOwnPropertySymbols,esm_M=Object.prototype.hasOwnProperty,esm_R=Object.prototype.propertyIsEnumerable,esm_L=(e,t,r)=>t in e?esm_S(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,esm_z=(e,t)=>{for(var r in t||(t={}))esm_M.call(t,r)&&esm_L(e,r,t[r]);if(esm_I)for(var r of esm_I(t))esm_R.call(t,r)&&esm_L(e,r,t[r]);return e},esm_T=(e,t,r)=>(esm_L(e,"symbol"!=typeof t?t+"":t,r),r),esm_V=(e,t,r)=>new Promise(((n,o)=>{var s=e=>{try{l(r.next(e))}catch(e){o(e)}},a=e=>{try{l(r.throw(e))}catch(e){o(e)}},l=e=>e.done?n(e.value):Promise.resolve(e.value).then(s,a);l((r=r.apply(e,t)).next())}));class esm_$ extends react.Component{constructor(e){super(e),esm_T(this,"state"),esm_T(this,"getReactOptions",(()=>esm_z(esm_z({},esm_p),this.props.reactOptions))),esm_T(this,"subscribeToChanges",(e=>{const{flags:t}=this.props;e.on("change",(r=>{const n=this.getReactOptions(),o=esm_b(r,t),s=esm_z(esm_z({},this.state.unproxiedFlags),o);Object.keys(o).length>0&&this.setState(esm_z({unproxiedFlags:s},esm_F(e,s,n,t)))}))})),esm_T(this,"initLDClient",(()=>esm_V(this,null,(function*(){const{clientSideID:e,flags:t,options:r}=this.props;let n=yield this.props.ldClient;const o=this.getReactOptions();let s,a=this.state.unproxiedFlags;if(n)a=esm_h(n,t);else{const o=yield esm_x(e,esm_d(this.props),r,t);s=o.error,s||(a=o.flags),n=o.ldClient}var l;this.setState((l=esm_z({unproxiedFlags:a},esm_F(n,a,o,t)),esm_k(l,esm_D({ldClient:n,error:s})))),this.subscribeToChanges(n)}))));const{options:t}=e;if(this.state={flags:{},unproxiedFlags:{},flagKeyMap:{},ldClient:void 0},t){const{bootstrap:e}=t;if(e&&"localStorage"!==e){const{useCamelCaseFlagKeys:t}=this.getReactOptions();this.state={flags:t?esm_g(e):e,unproxiedFlags:e,flagKeyMap:{},ldClient:void 0}}}}componentDidMount(){return esm_V(this,null,(function*(){const{deferInitialization:e}=this.props;e&&!esm_d(this.props)||(yield this.initLDClient())}))}componentDidUpdate(e){return esm_V(this,null,(function*(){const{deferInitialization:t}=this.props,r=!esm_d(e)&&esm_d(this.props);t&&r&&(yield this.initLDClient())}))}render(){const{flags:e,flagKeyMap:r,ldClient:n,error:o}=this.state;return react.createElement(esm_f,{value:{flags:e,flagKeyMap:r,ldClient:n,error:o}},this.props.children)}}var esm_N=Object.defineProperty,esm_U=Object.defineProperties,esm_q=Object.getOwnPropertyDescriptors,esm_A=Object.getOwnPropertySymbols,esm_B=Object.prototype.hasOwnProperty,esm_G=Object.prototype.propertyIsEnumerable,esm_H=(e,t,r)=>t in e?esm_N(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,esm_J=(e,t)=>{for(var r in t||(t={}))esm_B.call(t,r)&&esm_H(e,r,t[r]);if(esm_A)for(var r of esm_A(t))esm_G.call(t,r)&&esm_H(e,r,t[r]);return e};function esm_Q(t){return function(r){const{reactOptions:n}=t,o=esm_J(esm_J({},esm_p),n),s=(a=esm_J({},t),esm_U(a,esm_q({reactOptions:o})));var a;function l(t){return react.createElement(esm_$,esm_J({},s),react.createElement(r,esm_J({},t)))}return hoist_non_react_statics_cjs_default()(l,r),l}}var esm_W=Object.defineProperty,esm_X=Object.getOwnPropertySymbols,esm_Y=Object.prototype.hasOwnProperty,esm_Z=Object.prototype.propertyIsEnumerable,esm_=(e,t,r)=>t in e?esm_W(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,esm_ee=(e,t)=>{for(var r in t||(t={}))esm_Y.call(t,r)&&esm_(e,r,t[r]);if(esm_X)for(var r of esm_X(t))esm_Z.call(t,r)&&esm_(e,r,t[r]);return e};function esm_te(e){return r=this,n=null,a=function*(){const{clientSideID:r,flags:n,options:a,reactOptions:l}=e,i=esm_ee(esm_ee({},esm_p),l),{ldClient:c,flags:u,error:y}=yield esm_x(r,esm_d(e),a,n),g=(null==a?void 0:a.bootstrap)&&"localStorage"!==a.bootstrap?a.bootstrap:u;return({children:e})=>{const[r,a]=o((()=>esm_ee({unproxiedFlags:g},esm_F(c,g,i,n))));s((()=>{function e(e){const t=esm_b(e,n);Object.keys(t).length>0&&a((({unproxiedFlags:e})=>{const r=esm_ee(esm_ee({},e),t);return esm_ee({unproxiedFlags:r},esm_F(c,r,i,n))}))}return c.on("change",e),function(){c.off("change",e)}}),[]);const{flags:l,flagKeyMap:p}=r;return t.createElement(esm_f,{value:{flags:l,flagKeyMap:p,ldClient:c,error:y}},e)}},new Promise(((e,t)=>{var o=e=>{try{l(a.next(e))}catch(e){t(e)}},s=e=>{try{l(a.throw(e))}catch(e){t(e)}},l=t=>t.done?e(t.value):Promise.resolve(t.value).then(o,s);l((a=a.apply(r,n)).next())}));var r,n,a}var esm_re=Object.defineProperty,esm_ne=Object.getOwnPropertySymbols,esm_oe=Object.prototype.hasOwnProperty,esm_se=Object.prototype.propertyIsEnumerable,esm_ae=(e,t,r)=>t in e?esm_re(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,esm_le=(e,t)=>{for(var r in t||(t={}))esm_oe.call(t,r)&&esm_ae(e,r,t[r]);if(esm_ne)for(var r of esm_ne(t))esm_se.call(t,r)&&esm_ae(e,r,t[r]);return e};function esm_ie(t={clientOnly:!1}){return function(r){return n=>e.createElement(esm_y,null,(({flags:o,ldClient:s})=>t.clientOnly?e.createElement(r,esm_le({ldClient:s},n)):e.createElement(r,esm_le({flags:o,ldClient:s},n))))}}const esm_ce=()=>{const{flags:e}=(0,react.useContext)(esm_u);return e},esm_pe=()=>{const{ldClient:e}=(0,react.useContext)(esm_u);return e};function esm_ue(){const{error:e}=a(esm_u);return e}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 15068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* global analytics */
var config = {
  /* Your segment writeKey */
  writeKey: null,

  /* Disable anonymous MTU */
  disableAnonymousTraffic: false,

  /* Sync segment Anonymous id with `analytics` Anon id */
  syncAnonymousId: false,

  /* Enable/disable segment destinations https://bit.ly/38nRBj3 */
  integrations: {}
  /* Override the Segment snippet url, for loading via custom CDN proxy */

};
/**
 * Segment analytics plugin
 * @link https://getanalytics.io/plugins/segment/
 * @link https://segment.com/docs/sources/website/analytics.js/
 * @param {object}  pluginConfig - Plugin settings
 * @param {string}  pluginConfig.writeKey - Your segment writeKey
 * @param {boolean} [pluginConfig.disableAnonymousTraffic] - Disable loading segment for anonymous visitors
 * @param {boolean} [pluginConfig.customScriptSrc] - Override the Segment snippet url, for loading via custom CDN proxy
 * @param {object}  [pluginConfig.integrations] - Enable/disable segment destinations https://bit.ly/38nRBj3
 * @return {object} Analytics plugin
 * @example
 *
 * segmentPlugin({
 *   writeKey: '123-xyz'
 * })
 */

function segmentPlugin() {
  var pluginConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    name: 'segment',
    config: _objectSpread(_objectSpread({}, config), pluginConfig),

    /* Custom methods to add .group call */
    methods: {
      /* Group https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#group */
      group: function group(groupId) {
        var traits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var callback = arguments.length > 3 ? arguments[3] : undefined;

        // const analyticsInstance = this.instance
        // If no segment, return early
        if (typeof window.analytics === 'undefined') {
          return;
        } // Make group call to segment


        window.analytics.group(groupId, traits, options, callback);
      }
    },
    bootstrap: function bootstrap(_ref) {
      var config = _ref.config,
          instance = _ref.instance;

      /* Load segment script after userId exists */
      if (config.disableAnonymousTraffic && !instance.user('userId')) {
        instance.once('identifyStart', function (_ref2) {
          var plugins = _ref2.plugins;
          var self = plugins['segment'];

          if (!self.loaded()) {
            // instance.loadPlugin('segment')
            initialize({
              config: config,
              instance: instance
            });
          }
        });
      }
    },

    /* Load Segment analytics.js on page */
    initialize: initialize,

    /* Trigger Segment page view http://bit.ly/2LSPFr1 */
    page: function page(_ref3) {
      var payload = _ref3.payload,
          config = _ref3.config;
      if (typeof analytics === 'undefined') return;
      var properties = payload.properties || {};
      var name = properties.name || properties.title;
      var category = properties.category;
      analytics.page(category, name, properties, _objectSpread({
        integrations: config.integrations
      }, payload.options));
    },

    /* Track Segment event http://bit.ly/2WLnYkK */
    track: function track(_ref4) {
      var payload = _ref4.payload,
          config = _ref4.config;
      if (typeof analytics === 'undefined') return;
      analytics.track(payload.event, payload.properties, _objectSpread({
        integrations: config.integrations
      }, payload.options));
    },

    /* Identify Segment user http://bit.ly/2VL45xD */
    identify: function identify(_ref5) {
      var payload = _ref5.payload,
          config = _ref5.config;
      if (typeof analytics === 'undefined') return;
      var userId = payload.userId,
          traits = payload.traits,
          options = payload.options;

      if (typeof userId === 'string') {
        analytics.identify(userId, traits, _objectSpread({
          integrations: config.integrations
        }, options));
      } else {
        analytics.identify(traits, _objectSpread({
          integrations: config.integrations
        }, options));
      }
    },

    /* Remove segment cookies on analytics.reset */
    reset: function reset() {
      if (typeof analytics === 'undefined') return;
      analytics.reset();
    },

    /* Sync id when ready */
    ready: function ready(_ref6) {
      var instance = _ref6.instance,
          config = _ref6.config;
      if (!config.syncAnonymousId || typeof analytics === 'undefined') return;
      var segmentUser = analytics.user();

      if (segmentUser) {
        var segmentAnonId = segmentUser.anonymousId();
        var analyticsAnonId = instance.user('anonymousId'); // If has segment anonymous ID && doesnt match analytics anon id, update

        if (segmentAnonId && segmentAnonId !== analyticsAnonId) {
          instance.setAnonymousId(segmentAnonId);
        }
      }
    },

    /* Check if segment loaded */
    loaded: function loaded() {
      return window.analytics && !!analytics.initialized;
    }
  };
}

function initialize(_ref7) {
  var config = _ref7.config,
      instance = _ref7.instance;
  var disableAnonymousTraffic = config.disableAnonymousTraffic,
      writeKey = config.writeKey,
      customScriptSrc = config.customScriptSrc;

  if (!writeKey) {
    throw new Error('No segment writeKey');
  }
  /* Disable segment.com if user is not yet identified. Save on Monthly MTU bill $$$ */


  var userID = instance.user('userId');

  if (!userID && disableAnonymousTraffic) {
    return false;
  }
  /* eslint-disable */


  !function () {
    var analytics = window.analytics = window.analytics || [];

    function isScriptLoaded() {
      var scripts = document.getElementsByTagName('script');
      var scriptMatch = customScriptSrc || 'cdn.segment.com/analytics.js/v1/';
      return !!Object.keys(scripts).filter(function (key) {
        var scriptInfo = scripts[key] || {};
        var src = scriptInfo.src || '';
        return src.indexOf(scriptMatch) > -1;
      }).length;
    }

    if (!analytics.initialize) {
      if (!isScriptLoaded()) {
        analytics.invoked = !0;
        analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on"];

        analytics.factory = function (t) {
          return function () {
            var e = Array.prototype.slice.call(arguments);
            e.unshift(t);
            analytics.push(e);
            return analytics;
          };
        };

        for (var t = 0; t < analytics.methods.length; t++) {
          var e = analytics.methods[t];
          analytics[e] = analytics.factory(e);
        }

        analytics.load = function (t, e) {
          var n = document.createElement("script");
          n.type = "text/javascript";
          n.async = !0;
          n.src = customScriptSrc || "https://cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js";
          n.id = 'segment-io';
          var a = document.getElementsByTagName("script")[0];
          a.parentNode.insertBefore(n, a);
          analytics._loadOptions = e;
        };

        analytics.SNIPPET_VERSION = "4.1.0";
        analytics.load(writeKey);
      }
    }
  }();
  /* eslint-enable */
}

/* This module will shake out unused code + work in browser and node 🎉 */

var index = segmentPlugin ;




/***/ }),

/***/ 58521:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var seen = [];
/**
 * Check if a value is an object or a function. Keep in mind that array, function, regexp, etc, are objects in JavaScript.
 *
 * @param value the value to check
 * @return true if the value is an object or a function
 */
function isObj(value) {
    var type = typeof value;
    return value !== null && (type === 'object' || type === 'function');
}
/**
 * Check if a value is a regular expression.
 *
 * @param value the value to check
 * @return true if the value is a regular expression
 */
function isRegexp(value) {
    return Object.prototype.toString.call(value) === '[object RegExp]';
}
/**
 * Get an array of all of the enumerable symbols for an object.
 *
 * @param object the object to get the enumerable symbols for
 */
function getOwnEnumPropSymbols(object) {
    return Object.getOwnPropertySymbols(object).filter(function (keySymbol) { return Object.prototype.propertyIsEnumerable.call(object, keySymbol); });
}
/**
 * pretty print an object
 *
 * @param input the object to pretty print
 * @param options the formatting options, transforms, and filters
 * @param pad the padding string
 */
function prettyPrint(input, options, pad) {
    if (pad === void 0) { pad = ''; }
    // sensible option defaults
    var defaultOptions = {
        indent: '\t',
        singleQuotes: true
    };
    var combinedOptions = __assign(__assign({}, defaultOptions), options);
    var tokens;
    if (combinedOptions.inlineCharacterLimit === undefined) {
        tokens = {
            newLine: '\n',
            newLineOrSpace: '\n',
            pad: pad,
            indent: pad + combinedOptions.indent
        };
    }
    else {
        tokens = {
            newLine: '@@__PRETTY_PRINT_NEW_LINE__@@',
            newLineOrSpace: '@@__PRETTY_PRINT_NEW_LINE_OR_SPACE__@@',
            pad: '@@__PRETTY_PRINT_PAD__@@',
            indent: '@@__PRETTY_PRINT_INDENT__@@'
        };
    }
    var expandWhiteSpace = function (string) {
        if (combinedOptions.inlineCharacterLimit === undefined) {
            return string;
        }
        var oneLined = string
            .replace(new RegExp(tokens.newLine, 'g'), '')
            .replace(new RegExp(tokens.newLineOrSpace, 'g'), ' ')
            .replace(new RegExp(tokens.pad + '|' + tokens.indent, 'g'), '');
        if (oneLined.length <= combinedOptions.inlineCharacterLimit) {
            return oneLined;
        }
        return string
            .replace(new RegExp(tokens.newLine + '|' + tokens.newLineOrSpace, 'g'), '\n')
            .replace(new RegExp(tokens.pad, 'g'), pad)
            .replace(new RegExp(tokens.indent, 'g'), pad + combinedOptions.indent);
    };
    if (seen.indexOf(input) !== -1) {
        return '"[Circular]"';
    }
    if (input === null ||
        input === undefined ||
        typeof input === 'number' ||
        typeof input === 'boolean' ||
        typeof input === 'function' ||
        typeof input === 'symbol' ||
        isRegexp(input)) {
        return String(input);
    }
    if (input instanceof Date) {
        return "new Date('" + input.toISOString() + "')";
    }
    if (Array.isArray(input)) {
        if (input.length === 0) {
            return '[]';
        }
        seen.push(input);
        var ret = '[' + tokens.newLine + input.map(function (el, i) {
            var eol = input.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
            var value = prettyPrint(el, combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) {
                value = combinedOptions.transform(input, i, value);
            }
            return tokens.indent + value + eol;
        }).join('') + tokens.pad + ']';
        seen.pop();
        return expandWhiteSpace(ret);
    }
    if (isObj(input)) {
        var objKeys_1 = __spreadArrays(Object.keys(input), (getOwnEnumPropSymbols(input)));
        if (combinedOptions.filter) {
            objKeys_1 = objKeys_1.filter(function (el) { return combinedOptions.filter && combinedOptions.filter(input, el); });
        }
        if (objKeys_1.length === 0) {
            return '{}';
        }
        seen.push(input);
        var ret = '{' + tokens.newLine + objKeys_1.map(function (el, i) {
            var eol = objKeys_1.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
            var isSymbol = typeof el === 'symbol';
            var isClassic = !isSymbol && /^[a-z$_][a-z$_0-9]*$/i.test(el.toString());
            var key = isSymbol || isClassic ? el : prettyPrint(el, combinedOptions);
            var value = prettyPrint(input[el], combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) {
                value = combinedOptions.transform(input, el, value);
            }
            return tokens.indent + String(key) + ': ' + value + eol;
        }).join('') + tokens.pad + '}';
        seen.pop();
        return expandWhiteSpace(ret);
    }
    input = String(input).replace(/[\r\n]/g, function (x) { return x === '\n' ? '\\n' : '\\r'; });
    if (!combinedOptions.singleQuotes) {
        input = input.replace(/"/g, '\\"');
        return "\"" + input + "\"";
    }
    input = input.replace(/\\?'/g, '\\\'');
    return "'" + input + "'";
}
exports.prettyPrint = prettyPrint;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 27627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ makePublicApi; },
/* harmony export */   "y": function() { return /* binding */ defineGlobal; }
/* harmony export */ });
/* harmony import */ var _tools_catchUserErrors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25686);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93099);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95959);



function makePublicApi(stub) {
    var publicApi = (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .assign */ .f0)({
        version: "4.50.1",
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfere with the user uncaught exceptions.
        onReady: function (callback) {
            callback();
        },
    }, stub);
    // Add a "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(publicApi, '_setDebug', {
        get: function () {
            return _tools_monitor__WEBPACK_IMPORTED_MODULE_1__/* .setDebugMode */ .yD;
        },
        enumerable: false,
    });
    return publicApi;
}
function defineGlobal(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach(function (fn) { return (0,_tools_catchUserErrors__WEBPACK_IMPORTED_MODULE_2__/* .catchUserErrors */ .Z)(fn, 'onReady callback threw an error:')(); });
    }
}
//# sourceMappingURL=init.js.map

/***/ }),

/***/ 7411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ addEventListener; },
/* harmony export */   "y": function() { return /* binding */ addEventListeners; }
/* harmony export */ });
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93099);
/* harmony import */ var _tools_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56376);


/**
 * Add an event listener to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(configuration, eventTarget, eventName, listener, options) {
    return addEventListeners(configuration, eventTarget, [eventName], listener, options);
}
/**
 * Add event listeners to an event target object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by: using an option object only if needed and emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are listened
 */
function addEventListeners(_, eventTarget, eventNames, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var listenerWithMonitor = (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(once
        ? function (event) {
            stop();
            listener(event);
        }
        : listener);
    var options = passive ? { capture: capture, passive: passive } : capture;
    var add = (0,_tools_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_1__/* .getZoneJsOriginalValue */ .I)(eventTarget, 'addEventListener');
    eventNames.forEach(function (eventName) { return add.call(eventTarget, eventName, listenerWithMonitor, options); });
    function stop() {
        var remove = (0,_tools_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_1__/* .getZoneJsOriginalValue */ .I)(eventTarget, 'removeEventListener');
        eventNames.forEach(function (eventName) { return remove.call(eventTarget, eventName, listenerWithMonitor, options); });
    }
    return {
        stop: stop,
    };
}
//# sourceMappingURL=addEventListener.js.map

/***/ }),

/***/ 60791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WQ": function() { return /* binding */ getCurrentSite; },
/* harmony export */   "d8": function() { return /* binding */ setCookie; },
/* harmony export */   "ej": function() { return /* binding */ getCookie; },
/* harmony export */   "kT": function() { return /* binding */ deleteCookie; },
/* harmony export */   "oX": function() { return /* binding */ areCookiesAuthorized; }
/* harmony export */ });
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42818);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(853);
/* harmony import */ var _tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61206);



function setCookie(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=".concat(date.toUTCString());
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=".concat(options.domain) : '';
    var secure = options && options.secure ? ';secure' : '';
    document.cookie = "".concat(name, "=").concat(value, ";").concat(expires, ";path=/;samesite=").concat(sameSite).concat(domain).concat(secure);
}
function getCookie(name) {
    return (0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .findCommaSeparatedValue */ .MY)(document.cookie, name);
}
function deleteCookie(name, options) {
    setCookie(name, '', 0, options);
}
function areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_".concat((0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .generateUUID */ .DO)());
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .ONE_MINUTE */ .yR, options);
        var isCookieCorrectlySet = getCookie(testCookieName) === testCookieValue;
        deleteCookie(testCookieName, options);
        return isCookieCorrectlySet;
    }
    catch (error) {
        _tools_display__WEBPACK_IMPORTED_MODULE_2__/* .display.error */ .jf.error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
    if (getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_".concat((0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_0__/* .generateUUID */ .DO)());
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while (domainLevels.length && !getCookie(testCookieName)) {
            candidateDomain = "".concat(domainLevels.pop(), ".").concat(candidateDomain);
            setCookie(testCookieName, testCookieValue, _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .ONE_SECOND */ .WT, { domain: candidateDomain });
        }
        deleteCookie(testCookieName, { domain: candidateDomain });
        getCurrentSiteCache = candidateDomain;
    }
    return getCurrentSiteCache;
}
//# sourceMappingURL=cookie.js.map

/***/ }),

/***/ 96817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ initFetchObservable; }
/* harmony export */ });
/* harmony import */ var _tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11516);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93099);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87658);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(853);
/* harmony import */ var _tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6239);





var fetchObservable;
function initFetchObservable() {
    if (!fetchObservable) {
        fetchObservable = createFetchObservable();
    }
    return fetchObservable;
}
function createFetchObservable() {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function () {
        if (!window.fetch) {
            return;
        }
        var stop = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethod */ .Su)(window, 'fetch', function (originalFetch) {
            return function (input, init) {
                var responsePromise;
                var context = (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .callMonitored */ .L6)(beforeSend, null, [observable, input, init]);
                if (context) {
                    responsePromise = originalFetch.call(this, context.input, context.init);
                    (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .callMonitored */ .L6)(afterSend, null, [observable, responsePromise, context]);
                }
                else {
                    responsePromise = originalFetch.call(this, input, init);
                }
                return responsePromise;
            };
        }).stop;
        return stop;
    });
    return observable;
}
function beforeSend(observable, input, init) {
    var method = (init && init.method) || (input instanceof Request && input.method) || 'GET';
    var url = input instanceof Request ? input.url : (0,_tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_3__/* .normalizeUrl */ .D5)(String(input));
    var startClocks = (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_4__/* .clocksNow */ .$I)();
    var context = {
        state: 'start',
        init: init,
        input: input,
        method: method,
        startClocks: startClocks,
        url: url,
    };
    observable.notify(context);
    return context;
}
function afterSend(observable, responsePromise, startContext) {
    var reportFetch = function (response) {
        var context = startContext;
        context.state = 'resolve';
        if ('stack' in response || response instanceof Error) {
            context.status = 0;
            context.isAborted = response instanceof DOMException && response.code === DOMException.ABORT_ERR;
            context.error = response;
        }
        else if ('status' in response) {
            context.response = response;
            context.responseType = response.type;
            context.status = response.status;
            context.isAborted = false;
        }
        observable.notify(context);
    };
    responsePromise.then((0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(reportFetch), (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(reportFetch));
}
//# sourceMappingURL=fetchObservable.js.map

/***/ }),

/***/ 19609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PT": function() { return /* binding */ isPageExitReason; },
/* harmony export */   "Pd": function() { return /* binding */ createPageExitObservable; },
/* harmony export */   "k$": function() { return /* binding */ PageExitReason; }
/* harmony export */ });
/* harmony import */ var _tools_experimentalFeatures__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28852);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87658);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95959);
/* harmony import */ var _tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84164);
/* harmony import */ var _addEventListener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7411);





var PageExitReason = {
    HIDDEN: 'visibility_hidden',
    UNLOADING: 'before_unload',
    PAGEHIDE: 'page_hide',
    FROZEN: 'page_frozen',
};
function createPageExitObservable(configuration) {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function () {
        var pagehideEnabled = (0,_tools_experimentalFeatures__WEBPACK_IMPORTED_MODULE_1__/* .isExperimentalFeatureEnabled */ .W_)(_tools_experimentalFeatures__WEBPACK_IMPORTED_MODULE_1__/* .ExperimentalFeature.PAGEHIDE */ .uh.PAGEHIDE);
        var stopListeners = (0,_addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .addEventListeners */ .y)(configuration, window, ["visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */, "freeze" /* DOM_EVENT.FREEZE */, "pagehide" /* DOM_EVENT.PAGE_HIDE */], function (event) {
            if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */ && pagehideEnabled) {
                /**
                 * Only event that detect page unload events while being compatible with the back/forward cache (bfcache)
                 */
                observable.notify({ reason: PageExitReason.PAGEHIDE });
            }
            else if (event.type === "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */ && document.visibilityState === 'hidden') {
                /**
                 * Only event that guarantee to fire on mobile devices when the page transitions to background state
                 * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
                 */
                observable.notify({ reason: PageExitReason.HIDDEN });
            }
            else if (event.type === "freeze" /* DOM_EVENT.FREEZE */) {
                /**
                 * After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
                 * Allow to collect events happening between hidden and frozen state.
                 */
                observable.notify({ reason: PageExitReason.FROZEN });
            }
        }, { capture: true }).stop;
        var stopBeforeUnloadListener = _tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_3__/* .noop */ .Z;
        if (!pagehideEnabled) {
            stopBeforeUnloadListener = (0,_addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .addEventListener */ .O)(configuration, window, "beforeunload" /* DOM_EVENT.BEFORE_UNLOAD */, function () {
                observable.notify({ reason: PageExitReason.UNLOADING });
            }).stop;
        }
        return function () {
            stopListeners();
            stopBeforeUnloadListener();
        };
    });
    return observable;
}
function isPageExitReason(reason) {
    return (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_4__/* .includes */ .q9)((0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_4__/* .objectValues */ .TT)(PageExitReason), reason);
}
//# sourceMappingURL=pageExitObservable.js.map

/***/ }),

/***/ 76842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ initXhrObservable; }
/* harmony export */ });
/* harmony import */ var _tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11516);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87658);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(853);
/* harmony import */ var _tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6239);
/* harmony import */ var _tools_utils_objectUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47970);
/* harmony import */ var _addEventListener__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7411);






var xhrObservable;
var xhrContexts = new WeakMap();
function initXhrObservable(configuration) {
    if (!xhrObservable) {
        xhrObservable = createXhrObservable(configuration);
    }
    return xhrObservable;
}
function createXhrObservable(configuration) {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function () {
        var stopInstrumentingStart = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethodAndCallOriginal */ .Lm)(XMLHttpRequest.prototype, 'open', {
            before: openXhr,
        }).stop;
        var stopInstrumentingSend = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethodAndCallOriginal */ .Lm)(XMLHttpRequest.prototype, 'send', {
            before: function () {
                sendXhr.call(this, configuration, observable);
            },
        }).stop;
        var stopInstrumentingAbort = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethodAndCallOriginal */ .Lm)(XMLHttpRequest.prototype, 'abort', {
            before: abortXhr,
        }).stop;
        return function () {
            stopInstrumentingStart();
            stopInstrumentingSend();
            stopInstrumentingAbort();
        };
    });
    return observable;
}
function openXhr(method, url) {
    xhrContexts.set(this, {
        state: 'open',
        method: method,
        url: (0,_tools_utils_urlPolyfill__WEBPACK_IMPORTED_MODULE_2__/* .normalizeUrl */ .D5)(String(url)),
    });
}
function sendXhr(configuration, observable) {
    var _this = this;
    var context = xhrContexts.get(this);
    if (!context) {
        return;
    }
    var startContext = context;
    startContext.state = 'start';
    startContext.startTime = (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .relativeNow */ ._q)();
    startContext.startClocks = (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .clocksNow */ .$I)();
    startContext.isAborted = false;
    startContext.xhr = this;
    var hasBeenReported = false;
    var stopInstrumentingOnReadyStateChange = (0,_tools_instrumentMethod__WEBPACK_IMPORTED_MODULE_1__/* .instrumentMethodAndCallOriginal */ .Lm)(this, 'onreadystatechange', {
        before: function () {
            if (this.readyState === XMLHttpRequest.DONE) {
                // Try to report the XHR as soon as possible, because the XHR may be mutated by the
                // application during a future event. For example, Angular is calling .abort() on
                // completed requests during a onreadystatechange event, so the status becomes '0'
                // before the request is collected.
                onEnd();
            }
        },
    }).stop;
    var onEnd = function () {
        unsubscribeLoadEndListener();
        stopInstrumentingOnReadyStateChange();
        if (hasBeenReported) {
            return;
        }
        hasBeenReported = true;
        var completeContext = context;
        completeContext.state = 'complete';
        completeContext.duration = (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .elapsed */ ._J)(startContext.startClocks.timeStamp, (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_3__/* .timeStampNow */ .n$)());
        completeContext.status = _this.status;
        observable.notify((0,_tools_utils_objectUtils__WEBPACK_IMPORTED_MODULE_4__/* .shallowClone */ .mv)(completeContext));
    };
    var unsubscribeLoadEndListener = (0,_addEventListener__WEBPACK_IMPORTED_MODULE_5__/* .addEventListener */ .O)(configuration, this, 'loadend', onEnd).stop;
    observable.notify(startContext);
}
function abortXhr() {
    var context = xhrContexts.get(this);
    if (context) {
        context.isAborted = true;
    }
}
//# sourceMappingURL=xhrObservable.js.map

/***/ }),

/***/ 66869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jj": function() { return /* binding */ DefaultPrivacyLevel; },
  "JZ": function() { return /* binding */ serializeConfiguration; },
  "fP": function() { return /* binding */ validateAndBuildConfiguration; }
});

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/catchUserErrors.js
var catchUserErrors = __webpack_require__(25686);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(42818);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
var experimentalFeatures = __webpack_require__(28852);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(853);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(76135);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(10160);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(47970);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(95959);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js + 6 modules
var sessionStore = __webpack_require__(42133);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/urlPolyfill.js
var urlPolyfill = __webpack_require__(6239);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.js
var stringUtils = __webpack_require__(61206);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var intakeSites = __webpack_require__(61280);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/endpointBuilder.js





var ENDPOINTS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'session-replay',
};
var INTAKE_TRACKS = {
    logs: 'logs',
    rum: 'rum',
    sessionReplay: 'replay',
};
function createEndpointBuilder(initConfiguration, endpointType, configurationTags) {
    var buildUrlWithParameters = createEndpointUrlWithParametersBuilder(initConfiguration, endpointType);
    return {
        build: function (api, payload) {
            var parameters = buildEndpointParameters(initConfiguration, endpointType, configurationTags, api, payload);
            return buildUrlWithParameters(parameters);
        },
        urlPrefix: buildUrlWithParameters(''),
        endpointType: endpointType,
    };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */
function createEndpointUrlWithParametersBuilder(initConfiguration, endpointType) {
    var path = "/api/v2/".concat(INTAKE_TRACKS[endpointType]);
    var proxy = initConfiguration.proxy, proxyUrl = initConfiguration.proxyUrl;
    if (proxy) {
        var normalizedProxyUrl_1 = (0,urlPolyfill/* normalizeUrl */.D5)(proxy);
        return function (parameters) { return "".concat(normalizedProxyUrl_1, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters))); };
    }
    var host = buildEndpointHost(initConfiguration, endpointType);
    if (proxy === undefined && proxyUrl) {
        // TODO: remove this in a future major.
        var normalizedProxyUrl_2 = (0,urlPolyfill/* normalizeUrl */.D5)(proxyUrl);
        return function (parameters) {
            return "".concat(normalizedProxyUrl_2, "?ddforward=").concat(encodeURIComponent("https://".concat(host).concat(path, "?").concat(parameters)));
        };
    }
    return function (parameters) { return "https://".concat(host).concat(path, "?").concat(parameters); };
}
function buildEndpointHost(initConfiguration, endpointType) {
    var _a = initConfiguration.site, site = _a === void 0 ? intakeSites/* INTAKE_SITE_US1 */.D_ : _a, internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
    if (internalAnalyticsSubdomain && site === intakeSites/* INTAKE_SITE_US1 */.D_) {
        return "".concat(internalAnalyticsSubdomain, ".").concat(intakeSites/* INTAKE_SITE_US1 */.D_);
    }
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    var subdomain = site !== intakeSites/* INTAKE_SITE_AP1 */.G8 ? "".concat(ENDPOINTS[endpointType], ".") : '';
    return "".concat(subdomain, "browser-intake-").concat(domainParts.join('-'), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */
function buildEndpointParameters(_a, endpointType, configurationTags, api, _b) {
    var clientToken = _a.clientToken, internalAnalyticsSubdomain = _a.internalAnalyticsSubdomain;
    var retry = _b.retry, flushReason = _b.flushReason, encoding = _b.encoding;
    var tags = ["sdk_version:".concat("4.50.1"), "api:".concat(api)].concat(configurationTags);
    if (flushReason && (0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.COLLECT_FLUSH_REASON */.uh.COLLECT_FLUSH_REASON)) {
        tags.push("flush_reason:".concat(flushReason));
    }
    if (retry) {
        tags.push("retry_count:".concat(retry.count), "retry_after:".concat(retry.lastFailureStatus));
    }
    var parameters = [
        'ddsource=browser',
        "ddtags=".concat(encodeURIComponent(tags.join(','))),
        "dd-api-key=".concat(clientToken),
        "dd-evp-origin-version=".concat(encodeURIComponent("4.50.1")),
        'dd-evp-origin=browser',
        "dd-request-id=".concat((0,stringUtils/* generateUUID */.DO)()),
    ];
    if (encoding) {
        parameters.push("dd-evp-encoding=".concat(encoding));
    }
    if (endpointType === 'rum') {
        parameters.push("batch_time=".concat((0,timeUtils/* timeStampNow */.n$)()));
    }
    if (internalAnalyticsSubdomain) {
        parameters.reverse();
    }
    return parameters.join('&');
}
//# sourceMappingURL=endpointBuilder.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/tags.js

var TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
    var env = configuration.env, service = configuration.service, version = configuration.version, datacenter = configuration.datacenter;
    var tags = [];
    if (env) {
        tags.push(buildTag('env', env));
    }
    if (service) {
        tags.push(buildTag('service', service));
    }
    if (version) {
        tags.push(buildTag('version', version));
    }
    if (datacenter) {
        tags.push(buildTag('datacenter', datacenter));
    }
    return tags;
}
var FORBIDDEN_CHARACTERS = /[^a-z0-9_:./-]/;
function buildTag(key, rawValue) {
    // See https://docs.datadoghq.com/getting_started/tagging/#defining-tags for tags syntax. Note
    // that the backend may not follow the exact same rules, so we only want to display an informal
    // warning.
    var valueSizeLimit = TAG_SIZE_LIMIT - key.length - 1;
    if (rawValue.length > valueSizeLimit || FORBIDDEN_CHARACTERS.test(rawValue)) {
        display/* display.warn */.jf.warn("".concat(key, " value doesn't meet tag requirements and will be sanitized"));
    }
    // Let the backend do most of the sanitization, but still make sure multiple tags can't be crafted
    // by forging a value containing commas.
    var sanitizedValue = rawValue.replace(/,/g, '_');
    return "".concat(key, ":").concat(sanitizedValue);
}
//# sourceMappingURL=tags.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/transportConfiguration.js




function computeTransportConfiguration(initConfiguration) {
    var tags = buildTags(initConfiguration);
    var endpointBuilders = computeEndpointBuilders(initConfiguration, tags);
    var intakeUrlPrefixes = (0,polyfills/* objectValues */.TT)(endpointBuilders).map(function (builder) { return builder.urlPrefix; });
    var replicaConfiguration = computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags);
    return (0,polyfills/* assign */.f0)({
        isIntakeUrl: function (url) { return intakeUrlPrefixes.some(function (intakeEndpoint) { return url.indexOf(intakeEndpoint) === 0; }); },
        replica: replicaConfiguration,
        site: initConfiguration.site || intakeSites/* INTAKE_SITE_US1 */.D_,
    }, endpointBuilders);
}
function computeEndpointBuilders(initConfiguration, tags) {
    return {
        logsEndpointBuilder: createEndpointBuilder(initConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(initConfiguration, 'rum', tags),
        sessionReplayEndpointBuilder: createEndpointBuilder(initConfiguration, 'sessionReplay', tags),
    };
}
function computeReplicaConfiguration(initConfiguration, intakeUrlPrefixes, tags) {
    if (!initConfiguration.replica) {
        return;
    }
    var replicaConfiguration = (0,polyfills/* assign */.f0)({}, initConfiguration, {
        site: intakeSites/* INTAKE_SITE_US1 */.D_,
        clientToken: initConfiguration.replica.clientToken,
    });
    var replicaEndpointBuilders = {
        logsEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'logs', tags),
        rumEndpointBuilder: createEndpointBuilder(replicaConfiguration, 'rum', tags),
    };
    intakeUrlPrefixes.push.apply(intakeUrlPrefixes, (0,polyfills/* objectValues */.TT)(replicaEndpointBuilders).map(function (builder) { return builder.urlPrefix; }));
    return (0,polyfills/* assign */.f0)({ applicationId: initConfiguration.replica.applicationId }, replicaEndpointBuilders);
}
//# sourceMappingURL=transportConfiguration.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js










var DefaultPrivacyLevel = {
    ALLOW: 'allow',
    MASK: 'mask',
    MASK_USER_INPUT: 'mask-user-input',
};
function validateAndBuildConfiguration(initConfiguration) {
    var _a, _b, _c;
    if (!initConfiguration || !initConfiguration.clientToken) {
        display/* display.error */.jf.error('Client Token is not configured, we will not send any data.');
        return;
    }
    var sessionSampleRate = (_a = initConfiguration.sessionSampleRate) !== null && _a !== void 0 ? _a : initConfiguration.sampleRate;
    if (sessionSampleRate !== undefined && !(0,numberUtils/* isPercentage */.zz)(sessionSampleRate)) {
        display/* display.error */.jf.error('Session Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetrySampleRate !== undefined && !(0,numberUtils/* isPercentage */.zz)(initConfiguration.telemetrySampleRate)) {
        display/* display.error */.jf.error('Telemetry Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.telemetryConfigurationSampleRate !== undefined &&
        !(0,numberUtils/* isPercentage */.zz)(initConfiguration.telemetryConfigurationSampleRate)) {
        display/* display.error */.jf.error('Telemetry Configuration Sample Rate should be a number between 0 and 100');
        return;
    }
    // Set the experimental feature flags as early as possible, so we can use them in most places
    if (Array.isArray(initConfiguration.enableExperimentalFeatures)) {
        (0,experimentalFeatures/* addExperimentalFeatures */.vn)(initConfiguration.enableExperimentalFeatures.filter(function (flag) {
            return (0,objectUtils/* objectHasValue */.E5)(experimentalFeatures/* ExperimentalFeature */.uh, flag);
        }));
    }
    return (0,polyfills/* assign */.f0)({
        beforeSend: initConfiguration.beforeSend && (0,catchUserErrors/* catchUserErrors */.Z)(initConfiguration.beforeSend, 'beforeSend threw an error:'),
        sessionStoreStrategyType: (0,sessionStore/* selectSessionStoreStrategyType */.hB)(initConfiguration),
        sessionSampleRate: sessionSampleRate !== null && sessionSampleRate !== void 0 ? sessionSampleRate : 100,
        telemetrySampleRate: (_b = initConfiguration.telemetrySampleRate) !== null && _b !== void 0 ? _b : 20,
        telemetryConfigurationSampleRate: (_c = initConfiguration.telemetryConfigurationSampleRate) !== null && _c !== void 0 ? _c : 5,
        service: initConfiguration.service,
        silentMultipleInit: !!initConfiguration.silentMultipleInit,
        /**
         * beacon payload max queue size implementation is 64kb
         * ensure that we leave room for logs, rum and potential other users
         */
        batchBytesLimit: 16 * byteUtils/* ONE_KIBI_BYTE */.Hi,
        eventRateLimiterThreshold: 3000,
        maxTelemetryEventsPerPage: 15,
        /**
         * flush automatically, aim to be lower than ALB connection timeout
         * to maximize connection reuse.
         */
        flushTimeout: (30 * timeUtils/* ONE_SECOND */.WT),
        /**
         * Logs intake limit
         */
        batchMessagesLimit: 50,
        messageBytesLimit: 256 * byteUtils/* ONE_KIBI_BYTE */.Hi,
    }, computeTransportConfiguration(initConfiguration));
}
function serializeConfiguration(initConfiguration) {
    var _a, _b;
    var proxy = (_a = initConfiguration.proxy) !== null && _a !== void 0 ? _a : initConfiguration.proxyUrl;
    return {
        session_sample_rate: (_b = initConfiguration.sessionSampleRate) !== null && _b !== void 0 ? _b : initConfiguration.sampleRate,
        telemetry_sample_rate: initConfiguration.telemetrySampleRate,
        telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
        use_before_send: !!initConfiguration.beforeSend,
        use_cross_site_session_cookie: initConfiguration.useCrossSiteSessionCookie,
        use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
        use_proxy: proxy !== undefined ? !!proxy : undefined,
        silent_multiple_init: initConfiguration.silentMultipleInit,
        track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
        track_resources: initConfiguration.trackResources,
        track_long_task: initConfiguration.trackLongTasks,
        allow_fallback_to_local_storage: !!initConfiguration.allowFallbackToLocalStorage,
        store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
    };
}
//# sourceMappingURL=configuration.js.map

/***/ }),

/***/ 61280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DZ": function() { return /* binding */ INTAKE_SITE_STAGING; },
/* harmony export */   "D_": function() { return /* binding */ INTAKE_SITE_US1; },
/* harmony export */   "Ds": function() { return /* binding */ INTAKE_SITE_EU1; },
/* harmony export */   "G8": function() { return /* binding */ INTAKE_SITE_AP1; },
/* harmony export */   "y7": function() { return /* binding */ INTAKE_SITE_US1_FED; }
/* harmony export */ });
var INTAKE_SITE_STAGING = 'datad0g.com';
var INTAKE_SITE_US1 = 'datadoghq.com';
var INTAKE_SITE_EU1 = 'datadoghq.eu';
var INTAKE_SITE_AP1 = 'ap1.datadoghq.com';
var INTAKE_SITE_US1_FED = 'ddog-gov.com';
//# sourceMappingURL=intakeSites.js.map

/***/ }),

/***/ 78587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ initConsoleObservable; }
/* harmony export */ });
/* unused harmony export resetConsoleObservable */
/* harmony import */ var _tracekit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94856);
/* harmony import */ var _error_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30331);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87658);
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42818);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93099);
/* harmony import */ var _tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53185);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95959);
/* harmony import */ var _tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41192);








var consoleObservablesByApi = {};
function initConsoleObservable(apis) {
    var consoleObservables = apis.map(function (api) {
        if (!consoleObservablesByApi[api]) {
            consoleObservablesByApi[api] = createConsoleObservable(api);
        }
        return consoleObservablesByApi[api];
    });
    return _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .mergeObservables.apply */ .$.apply(void 0, consoleObservables);
}
function resetConsoleObservable() {
    consoleObservablesByApi = {};
}
function createConsoleObservable(api) {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y(function () {
        var originalConsoleApi = _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .globalConsole */ .jG[api];
        _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .globalConsole */ .jG[api] = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            originalConsoleApi.apply(console, params);
            var handlingStack = (0,_error_error__WEBPACK_IMPORTED_MODULE_2__/* .createHandlingStack */ .Xp)();
            (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_3__/* .callMonitored */ .L6)(function () {
                observable.notify(buildConsoleLog(params, api, handlingStack));
            });
        };
        return function () {
            _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .globalConsole */ .jG[api] = originalConsoleApi;
        };
    });
    return observable;
}
function buildConsoleLog(params, api, handlingStack) {
    // Todo: remove console error prefix in the next major version
    var message = params.map(function (param) { return formatConsoleParameters(param); }).join(' ');
    var stack;
    var fingerprint;
    if (api === _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .ConsoleApiName.error */ .vA.error) {
        var firstErrorParam = (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_4__/* .find */ .sE)(params, function (param) { return param instanceof Error; });
        stack = firstErrorParam ? (0,_error_error__WEBPACK_IMPORTED_MODULE_2__/* .toStackTraceString */ .P3)((0,_tracekit__WEBPACK_IMPORTED_MODULE_5__/* .computeStackTrace */ ._)(firstErrorParam)) : undefined;
        fingerprint = (0,_error_error__WEBPACK_IMPORTED_MODULE_2__/* .tryToGetFingerprint */ .un)(firstErrorParam);
        message = "console error: ".concat(message);
    }
    return {
        api: api,
        message: message,
        stack: stack,
        handlingStack: handlingStack,
        fingerprint: fingerprint,
    };
}
function formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return (0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_6__/* .sanitize */ .N)(param);
    }
    if (param instanceof Error) {
        return (0,_error_error__WEBPACK_IMPORTED_MODULE_2__/* .formatErrorMessage */ .jN)((0,_tracekit__WEBPACK_IMPORTED_MODULE_5__/* .computeStackTrace */ ._)(param));
    }
    return (0,_tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_7__/* .jsonStringify */ .l)((0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_6__/* .sanitize */ .N)(param), undefined, 2);
}
//# sourceMappingURL=consoleObservable.js.map

/***/ }),

/***/ 79217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ createContextManager; }
/* harmony export */ });
/* unused harmony export BYTES_COMPUTATION_THROTTLING_DELAY */
/* harmony import */ var _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10160);
/* harmony import */ var _tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84164);
/* harmony import */ var _tools_mergeInto__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20377);
/* harmony import */ var _tools_utils_typeUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74505);
/* harmony import */ var _tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41192);
/* harmony import */ var _tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53185);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87658);
/* harmony import */ var _heavyCustomerDataWarning__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89258);








var BYTES_COMPUTATION_THROTTLING_DELAY = 200;
function createContextManager(customerDataType, computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .computeBytesCount */ .qt; }
    var context = {};
    var bytesCountCache;
    var alreadyWarned = false;
    var changeObservable = new _tools_observable__WEBPACK_IMPORTED_MODULE_1__/* .Observable */ .y();
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call context APIs synchronously multiple times in a row
    var computeBytesCountThrottled = (0,_tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_2__/* .throttle */ .P)(function (context) {
        bytesCountCache = computeBytesCountImpl((0,_tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_3__/* .jsonStringify */ .l)(context));
        if (!alreadyWarned) {
            alreadyWarned = (0,_heavyCustomerDataWarning__WEBPACK_IMPORTED_MODULE_4__/* .warnIfCustomerDataLimitReached */ .H)(bytesCountCache, customerDataType);
        }
    }, BYTES_COMPUTATION_THROTTLING_DELAY).throttled;
    var contextManager = {
        getBytesCount: function () { return bytesCountCache; },
        /** @deprecated use getContext instead */
        get: function () { return context; },
        /** @deprecated use setContextProperty instead */
        add: function (key, value) {
            context[key] = value;
            computeBytesCountThrottled(context);
            changeObservable.notify();
        },
        /** @deprecated renamed to removeContextProperty */
        remove: function (key) {
            delete context[key];
            computeBytesCountThrottled(context);
            changeObservable.notify();
        },
        /** @deprecated use setContext instead */
        set: function (newContext) {
            context = newContext;
            computeBytesCountThrottled(context);
            changeObservable.notify();
        },
        getContext: function () { return (0,_tools_mergeInto__WEBPACK_IMPORTED_MODULE_5__/* .deepClone */ .I8)(context); },
        setContext: function (newContext) {
            if ((0,_tools_utils_typeUtils__WEBPACK_IMPORTED_MODULE_6__/* .getType */ .o)(newContext) === 'object') {
                context = (0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_7__/* .sanitize */ .N)(newContext);
                computeBytesCountThrottled(context);
            }
            else {
                contextManager.clearContext();
            }
            changeObservable.notify();
        },
        setContextProperty: function (key, property) {
            context[key] = (0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_7__/* .sanitize */ .N)(property);
            computeBytesCountThrottled(context);
            changeObservable.notify();
        },
        removeContextProperty: function (key) {
            delete context[key];
            computeBytesCountThrottled(context);
            changeObservable.notify();
        },
        clearContext: function () {
            context = {};
            bytesCountCache = 0;
            changeObservable.notify();
        },
        changeObservable: changeObservable,
    };
    return contextManager;
}
//# sourceMappingURL=contextManager.js.map

/***/ }),

/***/ 89258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ warnIfCustomerDataLimitReached; }
/* harmony export */ });
/* unused harmony export CUSTOMER_DATA_BYTES_LIMIT */
/* harmony import */ var _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10160);
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42818);
var _a;


// RUM and logs batch bytes limit is 16KB
// ensure that we leave room for other event attributes and maintain a decent amount of event per batch
// (3KB (customer data) + 1KB (other attributes)) * 4 (events per batch) = 16KB
var CUSTOMER_DATA_BYTES_LIMIT = 3 * _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_KIBI_BYTE */ .Hi;
var CustomerDataLabel = (_a = {},
    _a[0 /* CustomerDataType.FeatureFlag */] = 'feature flag evaluation',
    _a[1 /* CustomerDataType.User */] = 'user',
    _a[2 /* CustomerDataType.GlobalContext */] = 'global context',
    _a[3 /* CustomerDataType.LoggerContext */] = 'logger context',
    _a);
function warnIfCustomerDataLimitReached(bytesCount, customerDataType) {
    if (bytesCount > CUSTOMER_DATA_BYTES_LIMIT) {
        _tools_display__WEBPACK_IMPORTED_MODULE_1__/* .display.warn */ .jf.warn("The ".concat(CustomerDataLabel[customerDataType], " data exceeds the recommended ").concat(CUSTOMER_DATA_BYTES_LIMIT / _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_KIBI_BYTE */ .Hi, "KiB threshold. More details: https://docs.datadoghq.com/real_user_monitoring/browser/troubleshooting/#customer-data-exceeds-the-recommended-3kib-warning"));
        return true;
    }
    return false;
}
//# sourceMappingURL=heavyCustomerDataWarning.js.map

/***/ }),

/***/ 7876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PI": function() { return /* binding */ createStoredContextManager; }
/* harmony export */ });
/* unused harmony exports buildStorageKey, removeStorageListeners */
/* harmony import */ var _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10160);
/* harmony import */ var _browser_addEventListener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7411);
/* harmony import */ var _contextManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79217);



var CONTEXT_STORE_KEY_PREFIX = '_dd_c';
var storageListeners = [];
function createStoredContextManager(configuration, productKey, customerDataType, computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = _tools_utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .computeBytesCount */ .qt; }
    var storageKey = buildStorageKey(productKey, customerDataType);
    var contextManager = (0,_contextManager__WEBPACK_IMPORTED_MODULE_1__/* .createContextManager */ .W)(customerDataType, computeBytesCountImpl);
    synchronizeWithStorage();
    storageListeners.push((0,_browser_addEventListener__WEBPACK_IMPORTED_MODULE_2__/* .addEventListener */ .O)(configuration, window, "storage" /* DOM_EVENT.STORAGE */, function (_a) {
        var key = _a.key;
        if (storageKey === key) {
            synchronizeWithStorage();
        }
    }));
    contextManager.changeObservable.subscribe(dumpToStorage);
    return contextManager;
    function synchronizeWithStorage() {
        var rawContext = localStorage.getItem(storageKey);
        var context = rawContext !== null ? JSON.parse(rawContext) : {};
        contextManager.setContext(context);
    }
    function dumpToStorage() {
        localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
    }
}
function buildStorageKey(productKey, customerDataType) {
    return "".concat(CONTEXT_STORE_KEY_PREFIX, "_").concat(productKey, "_").concat(customerDataType);
}
function removeStorageListeners() {
    storageListeners.map(function (listener) { return listener.stop(); });
}
//# sourceMappingURL=storedContextManager.js.map

/***/ }),

/***/ 30331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ computeRawError; },
/* harmony export */   "K$": function() { return /* binding */ NO_ERROR_STACK_PRESENT_MESSAGE; },
/* harmony export */   "P3": function() { return /* binding */ toStackTraceString; },
/* harmony export */   "Xp": function() { return /* binding */ createHandlingStack; },
/* harmony export */   "jN": function() { return /* binding */ formatErrorMessage; },
/* harmony export */   "u5": function() { return /* binding */ getFileFromStackTraceString; },
/* harmony export */   "un": function() { return /* binding */ tryToGetFingerprint; }
/* harmony export */ });
/* unused harmony export flattenErrorCauses */
/* harmony import */ var _tracekit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94856);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93099);
/* harmony import */ var _tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53185);
/* harmony import */ var _tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84164);
/* harmony import */ var _tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41192);





var NO_ERROR_STACK_PRESENT_MESSAGE = 'No stack, consider using an instance of Error';
function computeRawError(_a) {
    var stackTrace = _a.stackTrace, originalError = _a.originalError, handlingStack = _a.handlingStack, startClocks = _a.startClocks, nonErrorPrefix = _a.nonErrorPrefix, source = _a.source, handling = _a.handling;
    var isErrorInstance = originalError instanceof Error;
    var message = computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError);
    var stack = hasUsableStack(isErrorInstance, stackTrace)
        ? toStackTraceString(stackTrace)
        : NO_ERROR_STACK_PRESENT_MESSAGE;
    var causes = isErrorInstance ? flattenErrorCauses(originalError, source) : undefined;
    var type = stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name;
    var fingerprint = tryToGetFingerprint(originalError);
    return {
        startClocks: startClocks,
        source: source,
        handling: handling,
        handlingStack: handlingStack,
        originalError: originalError,
        type: type,
        message: message,
        stack: stack,
        causes: causes,
        fingerprint: fingerprint,
    };
}
function computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
    // Favor stackTrace message only if tracekit has really been able to extract something meaningful (message + name)
    // TODO rework tracekit integration to avoid scattering error building logic
    return (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.message) && (stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name)
        ? stackTrace.message
        : !isErrorInstance
            ? "".concat(nonErrorPrefix, " ").concat((0,_tools_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_0__/* .jsonStringify */ .l)((0,_tools_serialisation_sanitize__WEBPACK_IMPORTED_MODULE_1__/* .sanitize */ .N)(originalError)))
            : 'Empty message';
}
function hasUsableStack(isErrorInstance, stackTrace) {
    if (stackTrace === undefined) {
        return false;
    }
    if (isErrorInstance) {
        return true;
    }
    // handle cases where tracekit return stack = [] or stack = [{url: undefined, line: undefined, column: undefined}]
    // TODO rework tracekit integration to avoid generating those unusable stack
    return stackTrace.stack.length > 0 && (stackTrace.stack.length > 1 || stackTrace.stack[0].url !== undefined);
}
function tryToGetFingerprint(originalError) {
    return originalError instanceof Error && 'dd_fingerprint' in originalError
        ? String(originalError.dd_fingerprint)
        : undefined;
}
function toStackTraceString(stack) {
    var result = formatErrorMessage(stack);
    stack.stack.forEach(function (frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(".concat(frame.args.join(', '), ")") : '';
        var line = frame.line ? ":".concat(frame.line) : '';
        var column = frame.line && frame.column ? ":".concat(frame.column) : '';
        result += "\n  at ".concat(func).concat(args, " @ ").concat(frame.url).concat(line).concat(column);
    });
    return result;
}
function getFileFromStackTraceString(stack) {
    var _a;
    return (_a = /@ (.+)/.exec(stack)) === null || _a === void 0 ? void 0 : _a[1];
}
function formatErrorMessage(stack) {
    return "".concat(stack.name || 'Error', ": ").concat(stack.message);
}
/**
 Creates a stacktrace without SDK internal frames.
 
 Constraints:
 - Has to be called at the utmost position of the call stack.
 - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
 */
function createHandlingStack() {
    /**
     * Skip the two internal frames:
     * - SDK API (console.error, ...)
     * - this function
     * in order to keep only the user calls
     */
    var internalFramesToSkip = 2;
    var error = new Error();
    var formattedStack;
    // IE needs to throw the error to fill in the stack trace
    if (!error.stack) {
        try {
            throw error;
        }
        catch (e) {
            (0,_tools_utils_functionUtils__WEBPACK_IMPORTED_MODULE_2__/* .noop */ .Z)();
        }
    }
    (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_3__/* .callMonitored */ .L6)(function () {
        var stackTrace = (0,_tracekit__WEBPACK_IMPORTED_MODULE_4__/* .computeStackTrace */ ._)(error);
        stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
        formattedStack = toStackTraceString(stackTrace);
    });
    return formattedStack;
}
function flattenErrorCauses(error, parentSource) {
    var currentError = error;
    var causes = [];
    while ((currentError === null || currentError === void 0 ? void 0 : currentError.cause) instanceof Error && causes.length < 10) {
        var stackTrace = (0,_tracekit__WEBPACK_IMPORTED_MODULE_4__/* .computeStackTrace */ ._)(currentError.cause);
        causes.push({
            message: currentError.cause.message,
            source: parentSource,
            type: stackTrace === null || stackTrace === void 0 ? void 0 : stackTrace.name,
            stack: stackTrace && toStackTraceString(stackTrace),
        });
        currentError = currentError.cause;
    }
    return causes.length ? causes : undefined;
}
//# sourceMappingURL=error.js.map

/***/ }),

/***/ 10494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ErrorSource; }
/* harmony export */ });
var ErrorSource = {
    AGENT: 'agent',
    CONSOLE: 'console',
    CUSTOM: 'custom',
    LOGGER: 'logger',
    NETWORK: 'network',
    SOURCE: 'source',
    REPORT: 'report',
};
//# sourceMappingURL=error.types.js.map

/***/ }),

/***/ 80676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ trackRuntimeError; }
});

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(853);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/instrumentMethod.js
var instrumentMethod = __webpack_require__(11516);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/tracekit/computeStackTrace.js
var computeStackTrace = __webpack_require__(94856);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/tracekit/tracekit.js


// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
/**
 * Cross-browser collection of unhandled errors
 *
 * Supports:
 * - Firefox: full stack trace with line numbers, plus column number
 * on top frame; column number is not guaranteed
 * - Opera: full stack trace with line and column numbers
 * - Chrome: full stack trace with line and column numbers
 * - Safari: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 * - IE: line and column number for the top frame only; some frames
 * may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 * - IE5.5+ (only 8.0 tested)
 * - Firefox 0.9+ (only 3.5+ tested)
 * - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 * Exceptions Have Stacktrace to be enabled in opera:config)
 * - Safari 3+ (only 4+ tested)
 * - Chrome 1+ (only 5+ tested)
 * - Konqueror 3.5+ (untested)
 *
 * Tries to catch all unhandled errors and report them to the
 * callback.
 *
 * Callbacks receive a StackTrace object as described in the
 * computeStackTrace docs.
 *
 * @memberof TraceKit
 * @namespace
 */
function startUnhandledErrorCollection(callback) {
    var stopInstrumentingOnError = instrumentOnError(callback).stop;
    var stopInstrumentingOnUnhandledRejection = instrumentUnhandledRejection(callback).stop;
    return {
        stop: function () {
            stopInstrumentingOnError();
            stopInstrumentingOnUnhandledRejection();
        },
    };
}
/**
 * Install a global onerror handler
 */
function instrumentOnError(callback) {
    return (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(window, 'onerror', {
        before: function (messageObj, url, line, column, errorObj) {
            var stackTrace;
            if (errorObj instanceof Error) {
                stackTrace = (0,computeStackTrace/* computeStackTrace */._)(errorObj);
            }
            else {
                var stack = [{ url: url, column: column, line: line }];
                var _a = tryToParseMessage(messageObj), name_1 = _a.name, message = _a.message;
                stackTrace = {
                    name: name_1,
                    message: message,
                    stack: stack,
                };
            }
            callback(stackTrace, errorObj !== null && errorObj !== void 0 ? errorObj : messageObj);
        },
    });
}
function tryToParseMessage(messageObj) {
    var _a;
    var name;
    var message;
    if ({}.toString.call(messageObj) === '[object String]') {
        ;
        _a = ERROR_TYPES_RE.exec(messageObj), name = _a[1], message = _a[2];
    }
    return { name: name, message: message };
}
/**
 * Install a global onunhandledrejection handler
 */
function instrumentUnhandledRejection(callback) {
    return (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(window, 'onunhandledrejection', {
        before: function (e) {
            var reason = e.reason || 'Empty reason';
            var stack = (0,computeStackTrace/* computeStackTrace */._)(reason);
            callback(stack, reason);
        },
    });
}
//# sourceMappingURL=tracekit.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.js
var error = __webpack_require__(30331);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var error_types = __webpack_require__(10494);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js




function trackRuntimeError(errorObservable) {
    return startUnhandledErrorCollection(function (stackTrace, originalError) {
        errorObservable.notify((0,error/* computeRawError */.AP)({
            stackTrace: stackTrace,
            originalError: originalError,
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
            nonErrorPrefix: "Uncaught" /* NonErrorPrefix.UNCAUGHT */,
            source: error_types/* ErrorSource.SOURCE */.z.SOURCE,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */,
        }));
    });
}
//# sourceMappingURL=trackRuntimeError.js.map

/***/ }),

/***/ 76427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ createEventRateLimiter; }
/* harmony export */ });
/* harmony import */ var _tools_timer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48399);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(853);
/* harmony import */ var _error_error_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10494);



function createEventRateLimiter(eventType, limit, onLimitReached) {
    var eventCount = 0;
    var allowNextEvent = false;
    return {
        isLimitReached: function () {
            if (eventCount === 0) {
                (0,_tools_timer__WEBPACK_IMPORTED_MODULE_0__/* .setTimeout */ .iK)(function () {
                    eventCount = 0;
                }, _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .ONE_MINUTE */ .yR);
            }
            eventCount += 1;
            if (eventCount <= limit || allowNextEvent) {
                allowNextEvent = false;
                return false;
            }
            if (eventCount === limit + 1) {
                allowNextEvent = true;
                try {
                    onLimitReached({
                        message: "Reached max number of ".concat(eventType, "s by minute: ").concat(limit),
                        source: _error_error_types__WEBPACK_IMPORTED_MODULE_2__/* .ErrorSource.AGENT */ .z.AGENT,
                        startClocks: (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_1__/* .clocksNow */ .$I)(),
                    });
                }
                finally {
                    allowNextEvent = false;
                }
            }
            return true;
        },
    };
}
//# sourceMappingURL=createEventRateLimiter.js.map

/***/ }),

/***/ 11954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ RawReportType; },
/* harmony export */   "v": function() { return /* binding */ initReportObservable; }
/* harmony export */ });
/* harmony import */ var _error_error__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30331);
/* harmony import */ var _tools_monitor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93099);
/* harmony import */ var _tools_observable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87658);
/* harmony import */ var _browser_addEventListener__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7411);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95959);
/* harmony import */ var _tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61206);






var RawReportType = {
    intervention: 'intervention',
    deprecation: 'deprecation',
    cspViolation: 'csp_violation',
};
function initReportObservable(configuration, apis) {
    var observables = [];
    if ((0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .includes */ .q9)(apis, RawReportType.cspViolation)) {
        observables.push(createCspViolationReportObservable(configuration));
    }
    var reportTypes = apis.filter(function (api) { return api !== RawReportType.cspViolation; });
    if (reportTypes.length) {
        observables.push(createReportObservable(reportTypes));
    }
    return _tools_observable__WEBPACK_IMPORTED_MODULE_1__/* .mergeObservables.apply */ .$.apply(void 0, observables);
}
function createReportObservable(reportTypes) {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_1__/* .Observable */ .y(function () {
        if (!window.ReportingObserver) {
            return;
        }
        var handleReports = (0,_tools_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(function (reports, _) {
            return reports.forEach(function (report) {
                observable.notify(buildRawReportFromReport(report));
            });
        });
        var observer = new window.ReportingObserver(handleReports, {
            types: reportTypes,
            buffered: true,
        });
        observer.observe();
        return function () {
            observer.disconnect();
        };
    });
    return observable;
}
function createCspViolationReportObservable(configuration) {
    var observable = new _tools_observable__WEBPACK_IMPORTED_MODULE_1__/* .Observable */ .y(function () {
        var stop = (0,_browser_addEventListener__WEBPACK_IMPORTED_MODULE_3__/* .addEventListener */ .O)(configuration, document, "securitypolicyviolation" /* DOM_EVENT.SECURITY_POLICY_VIOLATION */, function (event) {
            observable.notify(buildRawReportFromCspViolation(event));
        }).stop;
        return stop;
    });
    return observable;
}
function buildRawReportFromReport(_a) {
    var type = _a.type, body = _a.body;
    return {
        type: type,
        subtype: body.id,
        message: "".concat(type, ": ").concat(body.message),
        stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber),
    };
}
function buildRawReportFromCspViolation(event) {
    var type = RawReportType.cspViolation;
    var message = "'".concat(event.blockedURI, "' blocked by '").concat(event.effectiveDirective, "' directive");
    return {
        type: RawReportType.cspViolation,
        subtype: event.effectiveDirective,
        message: "".concat(type, ": ").concat(message),
        stack: buildStack(event.effectiveDirective, event.originalPolicy
            ? "".concat(message, " of the policy \"").concat((0,_tools_utils_stringUtils__WEBPACK_IMPORTED_MODULE_4__/* .safeTruncate */ ._z)(event.originalPolicy, 100, '...'), "\"")
            : 'no policy', event.sourceFile, event.lineNumber, event.columnNumber),
    };
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
    return sourceFile
        ? (0,_error_error__WEBPACK_IMPORTED_MODULE_5__/* .toStackTraceString */ .P3)({
            name: name,
            message: message,
            stack: [
                {
                    func: '?',
                    url: sourceFile,
                    line: lineNumber !== null && lineNumber !== void 0 ? lineNumber : undefined,
                    column: columnNumber !== null && columnNumber !== void 0 ? columnNumber : undefined,
                },
            ],
        })
        : undefined;
}
//# sourceMappingURL=reportObservable.js.map

/***/ }),

/***/ 26216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ SESSION_TIME_OUT_DELAY; },
/* harmony export */   "s": function() { return /* binding */ SESSION_EXPIRATION_DELAY; }
/* harmony export */ });
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(853);

var SESSION_TIME_OUT_DELAY = 4 * _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_HOUR */ .dV;
var SESSION_EXPIRATION_DELAY = 15 * _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR;
//# sourceMappingURL=sessionConstants.js.map

/***/ }),

/***/ 42972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HX": function() { return /* binding */ startSessionManager; }
/* harmony export */ });
/* unused harmony exports VISIBILITY_CHECK_DELAY, stopSessionManager */
/* harmony import */ var _tools_valueHistory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53769);
/* harmony import */ var _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(853);
/* harmony import */ var _browser_addEventListener__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7411);
/* harmony import */ var _tools_timer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48399);
/* harmony import */ var _sessionConstants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26216);
/* harmony import */ var _sessionStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42133);






var VISIBILITY_CHECK_DELAY = _tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR;
var SESSION_CONTEXT_TIMEOUT_DELAY = _sessionConstants__WEBPACK_IMPORTED_MODULE_1__/* .SESSION_TIME_OUT_DELAY */ .T;
var stopCallbacks = [];
function startSessionManager(configuration, productKey, computeSessionState) {
    // TODO - Improve configuration type and remove assertion
    var sessionStore = (0,_sessionStore__WEBPACK_IMPORTED_MODULE_2__/* .startSessionStore */ .vH)(configuration.sessionStoreStrategyType, productKey, computeSessionState);
    stopCallbacks.push(function () { return sessionStore.stop(); });
    var sessionContextHistory = new _tools_valueHistory__WEBPACK_IMPORTED_MODULE_3__/* .ValueHistory */ .P(SESSION_CONTEXT_TIMEOUT_DELAY);
    stopCallbacks.push(function () { return sessionContextHistory.stop(); });
    sessionStore.renewObservable.subscribe(function () {
        sessionContextHistory.add(buildSessionContext(), (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .relativeNow */ ._q)());
    });
    sessionStore.expireObservable.subscribe(function () {
        sessionContextHistory.closeActive((0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .relativeNow */ ._q)());
    });
    sessionStore.expandOrRenewSession();
    sessionContextHistory.add(buildSessionContext(), (0,_tools_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .clocksOrigin */ .cQ)().relative);
    trackActivity(configuration, function () { return sessionStore.expandOrRenewSession(); });
    trackVisibility(configuration, function () { return sessionStore.expandSession(); });
    function buildSessionContext() {
        return {
            id: sessionStore.getSession().id,
            trackingType: sessionStore.getSession()[productKey],
        };
    }
    return {
        findActiveSession: function (startTime) { return sessionContextHistory.find(startTime); },
        renewObservable: sessionStore.renewObservable,
        expireObservable: sessionStore.expireObservable,
        expire: sessionStore.expire,
    };
}
function stopSessionManager() {
    stopCallbacks.forEach(function (e) { return e(); });
    stopCallbacks = [];
}
function trackActivity(configuration, expandOrRenewSession) {
    var stop = (0,_browser_addEventListener__WEBPACK_IMPORTED_MODULE_4__/* .addEventListeners */ .y)(configuration, window, ["click" /* DOM_EVENT.CLICK */, "touchstart" /* DOM_EVENT.TOUCH_START */, "keydown" /* DOM_EVENT.KEY_DOWN */, "scroll" /* DOM_EVENT.SCROLL */], expandOrRenewSession, { capture: true, passive: true }).stop;
    stopCallbacks.push(stop);
}
function trackVisibility(configuration, expandSession) {
    var expandSessionWhenVisible = function () {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    };
    var stop = (0,_browser_addEventListener__WEBPACK_IMPORTED_MODULE_4__/* .addEventListener */ .O)(configuration, document, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */, expandSessionWhenVisible).stop;
    stopCallbacks.push(stop);
    var visibilityCheckInterval = (0,_tools_timer__WEBPACK_IMPORTED_MODULE_5__/* .setInterval */ .Zi)(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
    stopCallbacks.push(function () {
        (0,_tools_timer__WEBPACK_IMPORTED_MODULE_5__/* .clearInterval */ .cv)(visibilityCheckInterval);
    });
}
//# sourceMappingURL=sessionManager.js.map

/***/ }),

/***/ 42133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hB": function() { return /* binding */ selectSessionStoreStrategyType; },
  "vH": function() { return /* binding */ startSessionStore; }
});

// UNUSED EXPORTS: STORAGE_POLL_DELAY

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(48399);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/observable.js
var observable = __webpack_require__(87658);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(853);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js
var functionUtils = __webpack_require__(84164);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.js
var stringUtils = __webpack_require__(61206);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js
var sessionConstants = __webpack_require__(26216);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/browserDetection.js
var browserDetection = __webpack_require__(89741);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/cookie.js
var cookie = __webpack_require__(60791);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionStoreStrategy.js
var SESSION_STORE_KEY = '_dd_s';
//# sourceMappingURL=sessionStoreStrategy.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(47970);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(95959);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionState.js




var SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
function isSessionInExpiredState(session) {
    return (0,objectUtils/* isEmptyObject */.Qr)(session);
}
function expandSessionState(session) {
    session.expire = String((0,timeUtils/* dateNow */.m6)() + sessionConstants/* SESSION_EXPIRATION_DELAY */.s);
}
function toSessionString(session) {
    return (0,polyfills/* objectEntries */.qP)(session)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value);
    })
        .join(SESSION_ENTRY_SEPARATOR);
}
function toSessionState(sessionString) {
    var session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
            var matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                var key = matches[1], value = matches[2];
                session[key] = value;
            }
        });
    }
    return session;
}
function isValidSessionString(sessionString) {
    return (!!sessionString &&
        (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString)));
}
//# sourceMappingURL=sessionState.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/oldCookiesMigration.js



var OLD_SESSION_COOKIE_NAME = '_dd';
var OLD_RUM_COOKIE_NAME = '_dd_r';
var OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
var RUM_SESSION_KEY = 'rum';
var LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(cookieStoreStrategy) {
    var sessionString = (0,cookie/* getCookie */.ej)(SESSION_STORE_KEY);
    if (!sessionString) {
        var oldSessionId = (0,cookie/* getCookie */.ej)(OLD_SESSION_COOKIE_NAME);
        var oldRumType = (0,cookie/* getCookie */.ej)(OLD_RUM_COOKIE_NAME);
        var oldLogsType = (0,cookie/* getCookie */.ej)(OLD_LOGS_COOKIE_NAME);
        var session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[RUM_SESSION_KEY] = oldRumType;
        }
        if (!isSessionInExpiredState(session)) {
            expandSessionState(session);
            cookieStoreStrategy.persistSession(session);
        }
    }
}
//# sourceMappingURL=oldCookiesMigration.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInCookie.js






function selectCookieStrategy(initConfiguration) {
    var cookieOptions = buildCookieOptions(initConfiguration);
    return (0,cookie/* areCookiesAuthorized */.oX)(cookieOptions) ? { type: 'Cookie', cookieOptions: cookieOptions } : undefined;
}
function initCookieStrategy(cookieOptions) {
    var cookieStore = {
        /**
         * Lock strategy allows mitigating issues due to concurrent access to cookie.
         * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
         */
        isLockEnabled: (0,browserDetection/* isChromium */.mJ)(),
        persistSession: persistSessionCookie(cookieOptions),
        retrieveSession: retrieveSessionCookie,
        clearSession: deleteSessionCookie(cookieOptions),
    };
    tryOldCookiesMigration(cookieStore);
    return cookieStore;
}
function persistSessionCookie(options) {
    return function (session) {
        (0,cookie/* setCookie */.d8)(SESSION_STORE_KEY, toSessionString(session), sessionConstants/* SESSION_EXPIRATION_DELAY */.s, options);
    };
}
function retrieveSessionCookie() {
    var sessionString = (0,cookie/* getCookie */.ej)(SESSION_STORE_KEY);
    return toSessionState(sessionString);
}
function deleteSessionCookie(options) {
    return function () {
        (0,cookie/* deleteCookie */.kT)(SESSION_STORE_KEY, options);
    };
}
function buildCookieOptions(initConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = !!initConfiguration.useSecureSessionCookie || !!initConfiguration.useCrossSiteSessionCookie;
    cookieOptions.crossSite = !!initConfiguration.useCrossSiteSessionCookie;
    if (initConfiguration.trackSessionAcrossSubdomains) {
        cookieOptions.domain = (0,cookie/* getCurrentSite */.WQ)();
    }
    return cookieOptions;
}
//# sourceMappingURL=sessionInCookie.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInLocalStorage.js



var LOCAL_STORAGE_TEST_KEY = '_dd_test_';
function selectLocalStorageStrategy() {
    try {
        var id = (0,stringUtils/* generateUUID */.DO)();
        var testKey = "".concat(LOCAL_STORAGE_TEST_KEY).concat(id);
        localStorage.setItem(testKey, id);
        var retrievedId = localStorage.getItem(testKey);
        localStorage.removeItem(testKey);
        return id === retrievedId ? { type: 'LocalStorage' } : undefined;
    }
    catch (e) {
        return undefined;
    }
}
function initLocalStorageStrategy() {
    return {
        isLockEnabled: false,
        persistSession: persistInLocalStorage,
        retrieveSession: retrieveSessionFromLocalStorage,
        clearSession: clearSessionFromLocalStorage,
    };
}
function persistInLocalStorage(sessionState) {
    localStorage.setItem(SESSION_STORE_KEY, toSessionString(sessionState));
}
function retrieveSessionFromLocalStorage() {
    var sessionString = localStorage.getItem(SESSION_STORE_KEY);
    return toSessionState(sessionString);
}
function clearSessionFromLocalStorage() {
    localStorage.removeItem(SESSION_STORE_KEY);
}
//# sourceMappingURL=sessionInLocalStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionStoreOperations.js



var LOCK_RETRY_DELAY = 10;
var LOCK_MAX_TRIES = 100;
var bufferedOperations = [];
var ongoingOperations;
function processSessionStoreOperations(operations, sessionStoreStrategy, numberOfRetries) {
    var _a;
    if (numberOfRetries === void 0) { numberOfRetries = 0; }
    var isLockEnabled = sessionStoreStrategy.isLockEnabled, retrieveSession = sessionStoreStrategy.retrieveSession, persistSession = sessionStoreStrategy.persistSession, clearSession = sessionStoreStrategy.clearSession;
    if (!ongoingOperations) {
        ongoingOperations = operations;
    }
    if (operations !== ongoingOperations) {
        bufferedOperations.push(operations);
        return;
    }
    if (isLockEnabled && numberOfRetries >= LOCK_MAX_TRIES) {
        next(sessionStoreStrategy);
        return;
    }
    var currentLock;
    var currentSession = retrieveSession();
    if (isLockEnabled) {
        // if someone has lock, retry later
        if (currentSession.lock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
        // acquire lock
        currentLock = (0,stringUtils/* generateUUID */.DO)();
        currentSession.lock = currentLock;
        persistSession(currentSession);
        // if lock is not acquired, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    var processedSession = operations.process(currentSession);
    if (isLockEnabled) {
        // if lock corrupted after process, retry later
        currentSession = retrieveSession();
        if (currentSession.lock !== currentLock) {
            retryLater(operations, sessionStoreStrategy, numberOfRetries);
            return;
        }
    }
    if (processedSession) {
        if (isSessionInExpiredState(processedSession)) {
            clearSession();
        }
        else {
            expandSessionState(processedSession);
            persistSession(processedSession);
        }
    }
    if (isLockEnabled) {
        // correctly handle lock around expiration would require to handle this case properly at several levels
        // since we don't have evidence of lock issues around expiration, let's just not do the corruption check for it
        if (!(processedSession && isSessionInExpiredState(processedSession))) {
            // if lock corrupted after persist, retry later
            currentSession = retrieveSession();
            if (currentSession.lock !== currentLock) {
                retryLater(operations, sessionStoreStrategy, numberOfRetries);
                return;
            }
            delete currentSession.lock;
            persistSession(currentSession);
            processedSession = currentSession;
        }
    }
    // call after even if session is not persisted in order to perform operations on
    // up-to-date session state value => the value could have been modified by another tab
    (_a = operations.after) === null || _a === void 0 ? void 0 : _a.call(operations, processedSession || currentSession);
    next(sessionStoreStrategy);
}
function retryLater(operations, sessionStore, currentNumberOfRetries) {
    (0,timer/* setTimeout */.iK)(function () {
        processSessionStoreOperations(operations, sessionStore, currentNumberOfRetries + 1);
    }, LOCK_RETRY_DELAY);
}
function next(sessionStore) {
    ongoingOperations = undefined;
    var nextOperations = bufferedOperations.shift();
    if (nextOperations) {
        processSessionStoreOperations(nextOperations, sessionStore);
    }
}
//# sourceMappingURL=sessionStoreOperations.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionStore.js









/**
 * Every second, the storage will be polled to check for any change that can occur
 * to the session state in another browser tab, or another window.
 * This value has been determined from our previous cookie-only implementation.
 */
var STORAGE_POLL_DELAY = timeUtils/* ONE_SECOND */.WT;
/**
 * Checks if cookies are available as the preferred storage
 * Else, checks if LocalStorage is allowed and available
 */
function selectSessionStoreStrategyType(initConfiguration) {
    var sessionStoreStrategyType = selectCookieStrategy(initConfiguration);
    if (!sessionStoreStrategyType && initConfiguration.allowFallbackToLocalStorage) {
        sessionStoreStrategyType = selectLocalStorageStrategy();
    }
    return sessionStoreStrategyType;
}
/**
 * Different session concepts:
 * - tracked, the session has an id and is updated along the user navigation
 * - not tracked, the session does not have an id but it is updated along the user navigation
 * - inactive, no session in store or session expired, waiting for a renew session
 */
function startSessionStore(sessionStoreStrategyType, productKey, computeSessionState) {
    var renewObservable = new observable/* Observable */.y();
    var expireObservable = new observable/* Observable */.y();
    var sessionStoreStrategy = sessionStoreStrategyType.type === 'Cookie'
        ? initCookieStrategy(sessionStoreStrategyType.cookieOptions)
        : initLocalStorageStrategy();
    var clearSession = sessionStoreStrategy.clearSession, retrieveSession = sessionStoreStrategy.retrieveSession;
    var watchSessionTimeoutId = (0,timer/* setInterval */.Zi)(watchSession, STORAGE_POLL_DELAY);
    var sessionCache = retrieveActiveSession();
    function expandOrRenewSession() {
        var isTracked;
        processSessionStoreOperations({
            process: function (sessionState) {
                var synchronizedSession = synchronizeSession(sessionState);
                isTracked = expandOrRenewSessionState(synchronizedSession);
                return synchronizedSession;
            },
            after: function (sessionState) {
                if (isTracked && !hasSessionInCache()) {
                    renewSessionInCache(sessionState);
                }
                sessionCache = sessionState;
            },
        }, sessionStoreStrategy);
    }
    function expandSession() {
        processSessionStoreOperations({
            process: function (sessionState) { return (hasSessionInCache() ? synchronizeSession(sessionState) : undefined); },
        }, sessionStoreStrategy);
    }
    /**
     * allows two behaviors:
     * - if the session is active, synchronize the session cache without updating the session store
     * - if the session is not active, clear the session store and expire the session cache
     */
    function watchSession() {
        processSessionStoreOperations({
            process: function (sessionState) { return (!isActiveSession(sessionState) ? {} : undefined); },
            after: synchronizeSession,
        }, sessionStoreStrategy);
    }
    function synchronizeSession(sessionState) {
        if (!isActiveSession(sessionState)) {
            sessionState = {};
        }
        if (hasSessionInCache()) {
            if (isSessionInCacheOutdated(sessionState)) {
                expireSessionInCache();
            }
            else {
                sessionCache = sessionState;
            }
        }
        return sessionState;
    }
    function expandOrRenewSessionState(sessionState) {
        var _a = computeSessionState(sessionState[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        sessionState[productKey] = trackingType;
        if (isTracked && !sessionState.id) {
            sessionState.id = (0,stringUtils/* generateUUID */.DO)();
            sessionState.created = String((0,timeUtils/* dateNow */.m6)());
        }
        return isTracked;
    }
    function hasSessionInCache() {
        return sessionCache[productKey] !== undefined;
    }
    function isSessionInCacheOutdated(sessionState) {
        return sessionCache.id !== sessionState.id || sessionCache[productKey] !== sessionState[productKey];
    }
    function expireSessionInCache() {
        sessionCache = {};
        expireObservable.notify();
    }
    function renewSessionInCache(sessionState) {
        sessionCache = sessionState;
        renewObservable.notify();
    }
    function retrieveActiveSession() {
        var session = retrieveSession();
        if (isActiveSession(session)) {
            return session;
        }
        return {};
    }
    function isActiveSession(sessionState) {
        // created and expire can be undefined for versions which was not storing them
        // these checks could be removed when older versions will not be available/live anymore
        return ((sessionState.created === undefined || (0,timeUtils/* dateNow */.m6)() - Number(sessionState.created) < sessionConstants/* SESSION_TIME_OUT_DELAY */.T) &&
            (sessionState.expire === undefined || (0,timeUtils/* dateNow */.m6)() < Number(sessionState.expire)));
    }
    return {
        expandOrRenewSession: (0,functionUtils/* throttle */.P)(expandOrRenewSession, STORAGE_POLL_DELAY).throttled,
        expandSession: expandSession,
        getSession: function () { return sessionCache; },
        renewObservable: renewObservable,
        expireObservable: expireObservable,
        expire: function () {
            clearSession();
            synchronizeSession({});
        },
        stop: function () {
            (0,timer/* clearInterval */.cv)(watchSessionTimeoutId);
        },
    };
}
//# sourceMappingURL=sessionStore.js.map

/***/ }),

/***/ 27478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L7": function() { return /* binding */ getSyntheticsTestId; },
/* harmony export */   "QB": function() { return /* binding */ getSyntheticsResultId; },
/* harmony export */   "Y9": function() { return /* binding */ willSyntheticsInjectRum; }
/* harmony export */ });
/* unused harmony exports SYNTHETICS_TEST_ID_COOKIE_NAME, SYNTHETICS_RESULT_ID_COOKIE_NAME, SYNTHETICS_INJECTS_RUM_COOKIE_NAME */
/* harmony import */ var _browser_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60791);

var SYNTHETICS_TEST_ID_COOKIE_NAME = 'datadog-synthetics-public-id';
var SYNTHETICS_RESULT_ID_COOKIE_NAME = 'datadog-synthetics-result-id';
var SYNTHETICS_INJECTS_RUM_COOKIE_NAME = 'datadog-synthetics-injects-rum';
function willSyntheticsInjectRum() {
    return Boolean(window._DATADOG_SYNTHETICS_INJECTS_RUM || (0,_browser_cookie__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
function getSyntheticsTestId() {
    var value = window._DATADOG_SYNTHETICS_PUBLIC_ID || (0,_browser_cookie__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(SYNTHETICS_TEST_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
function getSyntheticsResultId() {
    var value = window._DATADOG_SYNTHETICS_RESULT_ID || (0,_browser_cookie__WEBPACK_IMPORTED_MODULE_0__/* .getCookie */ .ej)(SYNTHETICS_RESULT_ID_COOKIE_NAME);
    return typeof value === 'string' ? value : undefined;
}
//# sourceMappingURL=syntheticsWorkerValues.js.map

/***/ }),

/***/ 41887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Uo": function() { return /* binding */ addTelemetryConfiguration; },
  "eJ": function() { return /* binding */ addTelemetryDebug; },
  "Sz": function() { return /* binding */ addTelemetryError; },
  "VG": function() { return /* binding */ isTelemetryReplicationAllowed; },
  "VL": function() { return /* binding */ startTelemetry; }
});

// UNUSED EXPORTS: formatError, resetTelemetry, scrubCustomerFrames, startFakeTelemetry

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(42818);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.js
var error = __webpack_require__(30331);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
var experimentalFeatures = __webpack_require__(28852);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var intakeSites = __webpack_require__(61280);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/tracekit/computeStackTrace.js
var computeStackTrace = __webpack_require__(94856);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/observable.js
var tools_observable = __webpack_require__(87658);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(853);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(93099);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(15017);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(95959);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(76135);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.js
var jsonStringify = __webpack_require__(41192);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/mergeInto.js
var mergeInto = __webpack_require__(20377);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/telemetry/rawTelemetryEvent.types.js
var TelemetryType = {
    log: 'log',
    configuration: 'configuration',
};
//# sourceMappingURL=rawTelemetryEvent.types.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js














var ALLOWED_FRAME_URLS = [
    'https://www.datadoghq-browser-agent.com',
    'https://www.datad0g-browser-agent.com',
    'https://d3uc069fcn7uxw.cloudfront.net',
    'https://d20xtzwzcl0ceb.cloudfront.net',
    'http://localhost',
    '<anonymous>',
];
var TELEMETRY_EXCLUDED_SITES = [intakeSites/* INTAKE_SITE_US1_FED */.y7];
var telemetryConfiguration = { maxEventsPerPage: 0, sentEventCount: 0, telemetryEnabled: false, telemetryConfigurationEnabled: false };
var onRawTelemetryEventCollected;
function startTelemetry(telemetryService, configuration) {
    var contextProvider;
    var observable = new tools_observable/* Observable */.y();
    telemetryConfiguration.telemetryEnabled =
        !(0,polyfills/* includes */.q9)(TELEMETRY_EXCLUDED_SITES, configuration.site) && (0,numberUtils/* performDraw */.y7)(configuration.telemetrySampleRate);
    telemetryConfiguration.telemetryConfigurationEnabled =
        telemetryConfiguration.telemetryEnabled && (0,numberUtils/* performDraw */.y7)(configuration.telemetryConfigurationSampleRate);
    var runtimeEnvInfo = getRuntimeEnvInfo();
    onRawTelemetryEventCollected = function (rawEvent) {
        if (telemetryConfiguration.telemetryEnabled) {
            var event_1 = toTelemetryEvent(telemetryService, rawEvent, runtimeEnvInfo);
            observable.notify(event_1);
            (0,sendToExtension/* sendToExtension */.j)('telemetry', event_1);
        }
    };
    (0,monitor/* startMonitorErrorCollection */.P_)(addTelemetryError);
    (0,polyfills/* assign */.f0)(telemetryConfiguration, {
        maxEventsPerPage: configuration.maxTelemetryEventsPerPage,
        sentEventCount: 0,
    });
    function toTelemetryEvent(telemetryService, event, runtimeEnvInfo) {
        return (0,mergeInto/* combine */.$e)({
            type: 'telemetry',
            date: (0,timeUtils/* timeStampNow */.n$)(),
            service: telemetryService,
            version: "4.50.1",
            source: 'browser',
            _dd: {
                format_version: 2,
            },
            telemetry: (0,mergeInto/* combine */.$e)(event, {
                runtime_env: runtimeEnvInfo,
            }),
            experimental_features: (0,polyfills/* arrayFrom */.Oc)((0,experimentalFeatures/* getExperimentalFeatures */.u0)()),
        }, contextProvider !== undefined ? contextProvider() : {});
    }
    return {
        setContextProvider: function (provider) {
            contextProvider = provider;
        },
        observable: observable,
        enabled: telemetryConfiguration.telemetryEnabled,
    };
}
function getRuntimeEnvInfo() {
    return {
        is_local_file: window.location.protocol === 'file:',
        is_worker: 'WorkerGlobalScope' in self,
    };
}
function startFakeTelemetry() {
    var events = [];
    assign(telemetryConfiguration, {
        maxEventsPerPage: Infinity,
        sentEventCount: 0,
    });
    onRawTelemetryEventCollected = function (event) {
        events.push(event);
    };
    return events;
}
function resetTelemetry() {
    onRawTelemetryEventCollected = undefined;
}
/**
 * Avoid mixing telemetry events from different data centers
 * but keep replicating staging events for reliability
 */
function isTelemetryReplicationAllowed(configuration) {
    return configuration.site === intakeSites/* INTAKE_SITE_STAGING */.DZ;
}
function addTelemetryDebug(message, context) {
    (0,monitor/* displayIfDebugEnabled */.DV)(display/* ConsoleApiName.debug */.vA.debug, message, context);
    addTelemetry((0,polyfills/* assign */.f0)({
        type: TelemetryType.log,
        message: message,
        status: "debug" /* StatusType.debug */,
    }, context));
}
function addTelemetryError(e, context) {
    addTelemetry((0,polyfills/* assign */.f0)({
        type: TelemetryType.log,
        status: "error" /* StatusType.error */,
    }, formatError(e), context));
}
function addTelemetryConfiguration(configuration) {
    if (telemetryConfiguration.telemetryConfigurationEnabled) {
        addTelemetry({
            type: TelemetryType.configuration,
            configuration: configuration,
        });
    }
}
function addTelemetry(event) {
    if (onRawTelemetryEventCollected && telemetryConfiguration.sentEventCount < telemetryConfiguration.maxEventsPerPage) {
        telemetryConfiguration.sentEventCount += 1;
        onRawTelemetryEventCollected(event);
    }
}
function formatError(e) {
    if (e instanceof Error) {
        var stackTrace = (0,computeStackTrace/* computeStackTrace */._)(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: (0,error/* toStackTraceString */.P3)(scrubCustomerFrames(stackTrace)),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: error/* NO_ERROR_STACK_PRESENT_MESSAGE */.K$,
        },
        message: "".concat("Uncaught" /* NonErrorPrefix.UNCAUGHT */, " ").concat((0,jsonStringify/* jsonStringify */.l)(e)),
    };
}
function scrubCustomerFrames(stackTrace) {
    stackTrace.stack = stackTrace.stack.filter(function (frame) { return !frame.url || ALLOWED_FRAME_URLS.some(function (allowedFrameUrl) { return (0,polyfills/* startsWith */.Ny)(frame.url, allowedFrameUrl); }); });
    return stackTrace;
}
//# sourceMappingURL=telemetry.js.map

/***/ }),

/***/ 94856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ computeStackTrace; }
/* harmony export */ });
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95959);

var UNKNOWN_FUNCTION = '?';
/**
 * Computes a stack trace for an exception.
 */
function computeStackTrace(ex) {
    var stack = [];
    var stackProperty = tryToGetString(ex, 'stack');
    var exString = String(ex);
    if (stackProperty && (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .startsWith */ .Ny)(stackProperty, exString)) {
        stackProperty = stackProperty.slice(exString.length);
    }
    if (stackProperty) {
        stackProperty.split('\n').forEach(function (line) {
            var stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);
            if (stackFrame) {
                if (!stackFrame.func && stackFrame.line) {
                    stackFrame.func = UNKNOWN_FUNCTION;
                }
                stack.push(stackFrame);
            }
        });
    }
    return {
        message: tryToGetString(ex, 'message'),
        name: tryToGetString(ex, 'name'),
        stack: stack,
    };
}
var fileUrl = '((?:file|https?|blob|chrome-extension|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)';
var filePosition = '(?::(\\d+))';
var CHROME_LINE_RE = new RegExp("^\\s*at (.*?) ?\\(".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "?\\)?\\s*$"), 'i');
var CHROME_EVAL_RE = new RegExp("\\((\\S*)".concat(filePosition).concat(filePosition, "\\)"));
function parseChromeLine(line) {
    var parts = CHROME_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
    var submatch = CHROME_EVAL_RE.exec(parts[2]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = submatch[1]; // url
        parts[3] = submatch[2]; // line
        parts[4] = submatch[3]; // column
    }
    return {
        args: isNative ? [parts[2]] : [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[3] ? +parts[3] : undefined,
        url: !isNative ? parts[2] : undefined,
    };
}
var CHROME_ANONYMOUS_FUNCTION_RE = new RegExp("^\\s*at ?".concat(fileUrl).concat(filePosition, "?").concat(filePosition, "??\\s*$"), 'i');
function parseChromeAnonymousLine(line) {
    var parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[3] ? +parts[3] : undefined,
        func: UNKNOWN_FUNCTION,
        line: parts[2] ? +parts[2] : undefined,
        url: parts[1],
    };
}
var WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
    var parts = WINJS_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    return {
        args: [],
        column: parts[4] ? +parts[4] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: +parts[3],
        url: parts[2],
    };
}
var GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
var GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
    var parts = GECKO_LINE_RE.exec(line);
    if (!parts) {
        return;
    }
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    var submatch = GECKO_EVAL_RE.exec(parts[3]);
    if (isEval && submatch) {
        // throw out eval line/column and use top-most line number
        parts[3] = submatch[1];
        parts[4] = submatch[2];
        parts[5] = undefined; // no column when eval
    }
    return {
        args: parts[2] ? parts[2].split(',') : [],
        column: parts[5] ? +parts[5] : undefined,
        func: parts[1] || UNKNOWN_FUNCTION,
        line: parts[4] ? +parts[4] : undefined,
        url: parts[3],
    };
}
function tryToGetString(candidate, property) {
    if (typeof candidate !== 'object' || !candidate || !(property in candidate)) {
        return undefined;
    }
    var value = candidate[property];
    return typeof value === 'string' ? value : undefined;
}
//# sourceMappingURL=computeStackTrace.js.map

/***/ }),

/***/ 17662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ sanitizeUser; },
/* harmony export */   "z": function() { return /* binding */ checkUser; }
/* harmony export */ });
/* harmony import */ var _tools_display__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42818);
/* harmony import */ var _tools_utils_typeUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74505);
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95959);



/**
 * Clone input data and ensure known user properties (id, name, email)
 * are strings, as defined here:
 * https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
 */
function sanitizeUser(newUser) {
    // We shallow clone only to prevent mutation of user data.
    var user = (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .assign */ .f0)({}, newUser);
    var keys = ['id', 'name', 'email'];
    keys.forEach(function (key) {
        if (key in user) {
            user[key] = String(user[key]);
        }
    });
    return user;
}
/**
 * Simple check to ensure user is valid
 */
function checkUser(newUser) {
    var isValid = (0,_tools_utils_typeUtils__WEBPACK_IMPORTED_MODULE_1__/* .getType */ .o)(newUser) === 'object';
    if (!isValid) {
        _tools_display__WEBPACK_IMPORTED_MODULE_2__/* .display.error */ .jf.error('Unsupported user:', newUser);
    }
    return isValid;
}
//# sourceMappingURL=user.js.map

/***/ }),

/***/ 77357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ AbstractLifeCycle; }
/* harmony export */ });
var AbstractLifeCycle = /** @class */ (function () {
    function AbstractLifeCycle() {
        this.callbacks = {};
    }
    AbstractLifeCycle.prototype.notify = function (eventType, data) {
        var eventCallbacks = this.callbacks[eventType];
        if (eventCallbacks) {
            eventCallbacks.forEach(function (callback) { return callback(data); });
        }
    };
    AbstractLifeCycle.prototype.subscribe = function (eventType, callback) {
        var _this = this;
        if (!this.callbacks[eventType]) {
            this.callbacks[eventType] = [];
        }
        this.callbacks[eventType].push(callback);
        return {
            unsubscribe: function () {
                _this.callbacks[eventType] = _this.callbacks[eventType].filter(function (other) { return callback !== other; });
            },
        };
    };
    return AbstractLifeCycle;
}());

//# sourceMappingURL=abstractLifeCycle.js.map

/***/ }),

/***/ 84554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ BoundedBuffer; }
/* harmony export */ });
var BUFFER_LIMIT = 500;
var BoundedBuffer = /** @class */ (function () {
    function BoundedBuffer() {
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function (callback) {
        var length = this.buffer.push(callback);
        if (length > BUFFER_LIMIT) {
            this.buffer.splice(0, 1);
        }
    };
    BoundedBuffer.prototype.drain = function () {
        this.buffer.forEach(function (callback) { return callback(); });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}());

//# sourceMappingURL=boundedBuffer.js.map

/***/ }),

/***/ 25686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ catchUserErrors; }
/* harmony export */ });
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42818);

function catchUserErrors(fn, errorMsg) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            return fn.apply(void 0, args);
        }
        catch (err) {
            _display__WEBPACK_IMPORTED_MODULE_0__/* .display.error */ .jf.error(errorMsg, err);
        }
    };
}
//# sourceMappingURL=catchUserErrors.js.map

/***/ }),

/***/ 42818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LD": function() { return /* binding */ originalConsoleMethods; },
/* harmony export */   "jG": function() { return /* binding */ globalConsole; },
/* harmony export */   "jf": function() { return /* binding */ display; },
/* harmony export */   "vA": function() { return /* binding */ ConsoleApiName; }
/* harmony export */ });
/* eslint-disable local-rules/disallow-side-effects */
/**
 * Keep references on console methods to avoid triggering patched behaviors
 *
 * NB: in some setup, console could already be patched by another SDK.
 * In this case, some display messages can be sent by the other SDK
 * but we should be safe from infinite loop nonetheless.
 */
var ConsoleApiName = {
    log: 'log',
    debug: 'debug',
    info: 'info',
    warn: 'warn',
    error: 'error',
};
/**
 * When building JS bundles, some users might use a plugin[1] or configuration[2] to remove
 * "console.*" references. This causes some issue as we expect `console.*` to be defined.
 * As a workaround, let's use a variable alias, so those expressions won't be taken into account by
 * simple static analysis.
 *
 * [1]: https://babeljs.io/docs/babel-plugin-transform-remove-console/
 * [2]: https://github.com/terser/terser#compress-options (look for drop_console)
 */
var globalConsole = console;
var originalConsoleMethods = {};
Object.keys(ConsoleApiName).forEach(function (name) {
    originalConsoleMethods[name] = globalConsole[name];
});
var PREFIX = 'Datadog Browser SDK:';
var display = {
    debug: originalConsoleMethods.debug.bind(globalConsole, PREFIX),
    log: originalConsoleMethods.log.bind(globalConsole, PREFIX),
    info: originalConsoleMethods.info.bind(globalConsole, PREFIX),
    warn: originalConsoleMethods.warn.bind(globalConsole, PREFIX),
    error: originalConsoleMethods.error.bind(globalConsole, PREFIX),
};
//# sourceMappingURL=display.js.map

/***/ }),

/***/ 28852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W_": function() { return /* binding */ isExperimentalFeatureEnabled; },
/* harmony export */   "u0": function() { return /* binding */ getExperimentalFeatures; },
/* harmony export */   "uh": function() { return /* binding */ ExperimentalFeature; },
/* harmony export */   "vn": function() { return /* binding */ addExperimentalFeatures; }
/* harmony export */ });
/* unused harmony export resetExperimentalFeatures */
/**
 * LIMITATION:
 * For NPM setup, this feature flag singleton is shared between RUM and Logs product.
 * This means that an experimental flag set on the RUM product will be set on the Logs product.
 * So keep in mind that in certain configurations, your experimental feature flag may affect other products.
 *
 * FORMAT:
 * All feature flags should be snake_cased
 */
// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected feature flag
// eslint-disable-next-line no-restricted-syntax
var ExperimentalFeature;
(function (ExperimentalFeature) {
    ExperimentalFeature["PAGEHIDE"] = "pagehide";
    ExperimentalFeature["FEATURE_FLAGS"] = "feature_flags";
    ExperimentalFeature["RESOURCE_PAGE_STATES"] = "resource_page_states";
    ExperimentalFeature["PAGE_STATES"] = "page_states";
    ExperimentalFeature["COLLECT_FLUSH_REASON"] = "collect_flush_reason";
    ExperimentalFeature["NO_RESOURCE_DURATION_FROZEN_STATE"] = "no_resource_duration_frozen_state";
    ExperimentalFeature["SCROLLMAP"] = "scrollmap";
    ExperimentalFeature["INTERACTION_TO_NEXT_PAINT"] = "interaction_to_next_paint";
    ExperimentalFeature["WEB_VITALS_ATTRIBUTION"] = "web_vitals_attribution";
    ExperimentalFeature["DISABLE_REPLAY_INLINE_CSS"] = "disable_replay_inline_css";
})(ExperimentalFeature || (ExperimentalFeature = {}));
var enabledExperimentalFeatures = new Set();
function addExperimentalFeatures(enabledFeatures) {
    enabledFeatures.forEach(function (flag) {
        enabledExperimentalFeatures.add(flag);
    });
}
function isExperimentalFeatureEnabled(featureName) {
    return enabledExperimentalFeatures.has(featureName);
}
function resetExperimentalFeatures() {
    enabledExperimentalFeatures.clear();
}
function getExperimentalFeatures() {
    return enabledExperimentalFeatures;
}
//# sourceMappingURL=experimentalFeatures.js.map

/***/ }),

/***/ 1692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getGlobalObject; }
/* harmony export */ });
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function () {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore _dd_temp is defined using defineProperty
    var globalObject = _dd_temp_;
    // @ts-ignore _dd_temp is defined using defineProperty
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
//# sourceMappingURL=getGlobalObject.js.map

/***/ }),

/***/ 56376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getZoneJsOriginalValue; }
/* harmony export */ });
/* harmony import */ var _getGlobalObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1692);

/**
 * Gets the original value for a DOM API that was potentially patched by Zone.js.
 *
 * Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
 * value of the patched functions/constructors/methods in a hidden property prefixed by
 * __zone_symbol__.
 *
 * In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
 * browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
 * use the original DOM API instead of the one patched by Zone.js.
 *
 * [1]: https://github.com/angular/angular/tree/main/packages/zone.js
 */
function getZoneJsOriginalValue(target, name) {
    var browserWindow = (0,_getGlobalObject__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
    var original;
    if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === 'function') {
        original = target[browserWindow.Zone.__symbol__(name)];
    }
    if (!original) {
        original = target[name];
    }
    return original;
}
//# sourceMappingURL=getZoneJsOriginalValue.js.map

/***/ }),

/***/ 11516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lm": function() { return /* binding */ instrumentMethodAndCallOriginal; },
/* harmony export */   "Su": function() { return /* binding */ instrumentMethod; },
/* harmony export */   "Xk": function() { return /* binding */ instrumentSetter; }
/* harmony export */ });
/* harmony import */ var _timer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48399);
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93099);
/* harmony import */ var _utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84164);



function instrumentMethod(object, method, instrumentationFactory) {
    var original = object[method];
    var instrumentation = instrumentationFactory(original);
    var instrumentationWrapper = function () {
        if (typeof instrumentation !== 'function') {
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return instrumentation.apply(this, arguments);
    };
    object[method] = instrumentationWrapper;
    return {
        stop: function () {
            if (object[method] === instrumentationWrapper) {
                object[method] = original;
            }
            else {
                instrumentation = original;
            }
        },
    };
}
function instrumentMethodAndCallOriginal(object, method, _a) {
    var before = _a.before, after = _a.after;
    return instrumentMethod(object, method, function (original) {
        return function () {
            var args = arguments;
            var result;
            if (before) {
                (0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .callMonitored */ .L6)(before, this, args);
            }
            if (typeof original === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                result = original.apply(this, args);
            }
            if (after) {
                (0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .callMonitored */ .L6)(after, this, args);
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return result;
        };
    });
}
function instrumentSetter(object, property, after) {
    var originalDescriptor = Object.getOwnPropertyDescriptor(object, property);
    if (!originalDescriptor || !originalDescriptor.set || !originalDescriptor.configurable) {
        return { stop: _utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .Z };
    }
    var instrumentation = function (thisObject, value) {
        // put hooked setter into event loop to avoid of set latency
        (0,_timer__WEBPACK_IMPORTED_MODULE_2__/* .setTimeout */ .iK)(function () {
            after(thisObject, value);
        }, 0);
    };
    var instrumentationWrapper = function (value) {
        originalDescriptor.set.call(this, value);
        instrumentation(this, value);
    };
    Object.defineProperty(object, property, {
        set: instrumentationWrapper,
    });
    return {
        stop: function () {
            var _a;
            if (((_a = Object.getOwnPropertyDescriptor(object, property)) === null || _a === void 0 ? void 0 : _a.set) === instrumentationWrapper) {
                Object.defineProperty(object, property, originalDescriptor);
            }
            else {
                instrumentation = _utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .Z;
            }
        },
    };
}
//# sourceMappingURL=instrumentMethod.js.map

/***/ }),

/***/ 20377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "I8": function() { return /* binding */ deepClone; }
/* harmony export */ });
/* unused harmony export mergeInto */
/* harmony import */ var _utils_typeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74505);

/**
 * Iterate over source and affect its sub values into destination, recursively.
 * If the source and destination can't be merged, return source.
 */
function mergeInto(destination, source, circularReferenceChecker) {
    if (circularReferenceChecker === void 0) { circularReferenceChecker = createCircularReferenceChecker(); }
    // ignore the source if it is undefined
    if (source === undefined) {
        return destination;
    }
    if (typeof source !== 'object' || source === null) {
        // primitive values - just return source
        return source;
    }
    else if (source instanceof Date) {
        return new Date(source.getTime());
    }
    else if (source instanceof RegExp) {
        var flags = source.flags ||
            // old browsers compatibility
            [
                source.global ? 'g' : '',
                source.ignoreCase ? 'i' : '',
                source.multiline ? 'm' : '',
                source.sticky ? 'y' : '',
                source.unicode ? 'u' : '',
            ].join('');
        return new RegExp(source.source, flags);
    }
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        // remove circular references
        return undefined;
    }
    else if (Array.isArray(source)) {
        var merged_1 = Array.isArray(destination) ? destination : [];
        for (var i = 0; i < source.length; ++i) {
            merged_1[i] = mergeInto(merged_1[i], source[i], circularReferenceChecker);
        }
        return merged_1;
    }
    var merged = (0,_utils_typeUtils__WEBPACK_IMPORTED_MODULE_0__/* .getType */ .o)(destination) === 'object' ? destination : {};
    for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            merged[key] = mergeInto(merged[key], source[key], circularReferenceChecker);
        }
    }
    return merged;
}
/**
 * A simplistic implementation of a deep clone algorithm.
 * Caveats:
 * - It doesn't maintain prototype chains - don't use with instances of custom classes.
 * - It doesn't handle Map and Set
 */
function deepClone(value) {
    return mergeInto(undefined, value);
}
function combine() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var destination;
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto(destination, source);
    }
    return destination;
}
function createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function (value) {
                var has = set_1.has(value);
                if (!has) {
                    set_1.add(value);
                }
                return has;
            },
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function (value) {
            var has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
//# sourceMappingURL=mergeInto.js.map

/***/ }),

/***/ 93099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ displayIfDebugEnabled; },
/* harmony export */   "L6": function() { return /* binding */ callMonitored; },
/* harmony export */   "P_": function() { return /* binding */ startMonitorErrorCollection; },
/* harmony export */   "Th": function() { return /* binding */ monitored; },
/* harmony export */   "yD": function() { return /* binding */ setDebugMode; },
/* harmony export */   "zk": function() { return /* binding */ monitor; }
/* harmony export */ });
/* unused harmony export resetMonitor */
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42818);
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var onMonitorErrorCollected;
var debugMode = false;
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
    onMonitorErrorCollected = newOnMonitorErrorCollected;
}
function setDebugMode(newDebugMode) {
    debugMode = newDebugMode;
}
function resetMonitor() {
    onMonitorErrorCollected = undefined;
    debugMode = false;
}
function monitored(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var decorated = onMonitorErrorCollected ? monitor(originalMethod) : originalMethod;
        return decorated.apply(this, args);
    };
}
function monitor(fn) {
    return function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return callMonitored(fn, this, arguments);
    }; // consider output type has input type
}
function callMonitored(fn, context, args) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return fn.apply(context, args);
    }
    catch (e) {
        displayIfDebugEnabled(e);
        if (onMonitorErrorCollected) {
            try {
                onMonitorErrorCollected(e);
            }
            catch (e) {
                displayIfDebugEnabled(e);
            }
        }
    }
}
function displayIfDebugEnabled() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (debugMode) {
        _display__WEBPACK_IMPORTED_MODULE_0__/* .display.error.apply */ .jf.error.apply(_display__WEBPACK_IMPORTED_MODULE_0__/* .display */ .jf, __spreadArray(['[MONITOR]'], args, false));
    }
}
//# sourceMappingURL=monitor.js.map

/***/ }),

/***/ 87658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ mergeObservables; },
/* harmony export */   "y": function() { return /* binding */ Observable; }
/* harmony export */ });
var Observable = /** @class */ (function () {
    function Observable(onFirstSubscribe) {
        this.onFirstSubscribe = onFirstSubscribe;
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        var _this = this;
        if (!this.observers.length && this.onFirstSubscribe) {
            this.onLastUnsubscribe = this.onFirstSubscribe() || undefined;
        }
        this.observers.push(f);
        return {
            unsubscribe: function () {
                _this.observers = _this.observers.filter(function (other) { return f !== other; });
                if (!_this.observers.length && _this.onLastUnsubscribe) {
                    _this.onLastUnsubscribe();
                }
            },
        };
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());

function mergeObservables() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var globalObservable = new Observable(function () {
        var subscriptions = observables.map(function (observable) {
            return observable.subscribe(function (data) { return globalObservable.notify(data); });
        });
        return function () { return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); }); };
    });
    return globalObservable;
}
//# sourceMappingURL=observable.js.map

/***/ }),

/***/ 57717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ readBytesFromStream; }
/* harmony export */ });
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93099);
/* harmony import */ var _utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84164);


/**
 * Read bytes from a ReadableStream until at least `limit` bytes have been read (or until the end of
 * the stream). The callback is invoked with the at most `limit` bytes, and indicates that the limit
 * has been exceeded if more bytes were available.
 */
function readBytesFromStream(stream, callback, options) {
    var reader = stream.getReader();
    var chunks = [];
    var readBytesCount = 0;
    readMore();
    function readMore() {
        reader.read().then((0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(function (result) {
            if (result.done) {
                onDone();
                return;
            }
            if (options.collectStreamBody) {
                chunks.push(result.value);
            }
            readBytesCount += result.value.length;
            if (readBytesCount > options.bytesLimit) {
                onDone();
            }
            else {
                readMore();
            }
        }), (0,_monitor__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(function (error) { return callback(error); }));
    }
    function onDone() {
        reader.cancel().catch(
        // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
        // as an unhandled rejection
        _utils_functionUtils__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .Z);
        var bytes;
        var limitExceeded;
        if (options.collectStreamBody) {
            var completeBuffer_1;
            if (chunks.length === 1) {
                // optimization: if the response is small enough to fit in a single buffer (provided by the browser), just
                // use it directly.
                completeBuffer_1 = chunks[0];
            }
            else {
                // else, we need to copy buffers into a larger buffer to concatenate them.
                completeBuffer_1 = new Uint8Array(readBytesCount);
                var offset_1 = 0;
                chunks.forEach(function (chunk) {
                    completeBuffer_1.set(chunk, offset_1);
                    offset_1 += chunk.length;
                });
            }
            bytes = completeBuffer_1.slice(0, options.bytesLimit);
            limitExceeded = completeBuffer_1.length > options.bytesLimit;
        }
        callback(undefined, bytes, limitExceeded);
    }
}
//# sourceMappingURL=readBytesFromStream.js.map

/***/ }),

/***/ 15017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ sendToExtension; }
/* harmony export */ });
function sendToExtension(type, payload) {
    var callback = window.__ddBrowserSdkExtensionCallback;
    if (callback) {
        callback({ type: type, payload: payload });
    }
}
//# sourceMappingURL=sendToExtension.js.map

/***/ }),

/***/ 41192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ jsonStringify; },
/* harmony export */   "y": function() { return /* binding */ detachToJsonMethod; }
/* harmony export */ });
/* harmony import */ var _utils_functionUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84164);

/**
 * Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
 * because some sites badly override toJSON on certain objects. Removing all toJSON methods from
 * nested values would be too costly, so we just detach them from the root value, and native classes
 * used to build JSON values (Array and Object).
 *
 * Note: this still assumes that JSON.stringify is correct.
 */
function jsonStringify(value, replacer, space) {
    if (typeof value !== 'object' || value === null) {
        return JSON.stringify(value);
    }
    // Note: The order matter here. We need to detach toJSON methods on parent classes before their
    // subclasses.
    var restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
    var restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
    var restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
    var restoreValueToJson = detachToJsonMethod(value);
    try {
        return JSON.stringify(value, replacer, space);
    }
    catch (_a) {
        return '<error: unable to serialize object>';
    }
    finally {
        restoreObjectPrototypeToJson();
        restoreArrayPrototypeToJson();
        restoreValuePrototypeToJson();
        restoreValueToJson();
    }
}
function detachToJsonMethod(value) {
    var object = value;
    var objectToJson = object.toJSON;
    if (objectToJson) {
        delete object.toJSON;
        return function () {
            object.toJSON = objectToJson;
        };
    }
    return _utils_functionUtils__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z;
}
//# sourceMappingURL=jsonStringify.js.map

/***/ }),

/***/ 53185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ sanitize; }
/* harmony export */ });
/* harmony import */ var _display__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42818);
/* harmony import */ var _utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10160);
/* harmony import */ var _jsonStringify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41192);



// The maximum size of a single event is 256KiB. By default, we ensure that user-provided data
// going through sanitize fits inside our events, while leaving room for other contexts, metadata, ...
var SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * _utils_byteUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_KIBI_BYTE */ .Hi;
// Symbol for the root element of the JSONPath used for visited objects
var JSON_PATH_ROOT_ELEMENT = '$';
// When serializing (using JSON.stringify) a key of an object, { key: 42 } gets wrapped in quotes as "key".
// With the separator (:), we need to add 3 characters to the count.
var KEY_DECORATION_LENGTH = 3;
function sanitize(source, maxCharacterCount) {
    var _a;
    if (maxCharacterCount === void 0) { maxCharacterCount = SANITIZE_DEFAULT_MAX_CHARACTER_COUNT; }
    // Unbind any toJSON function we may have on [] or {} prototypes
    var restoreObjectPrototypeToJson = (0,_jsonStringify__WEBPACK_IMPORTED_MODULE_1__/* .detachToJsonMethod */ .y)(Object.prototype);
    var restoreArrayPrototypeToJson = (0,_jsonStringify__WEBPACK_IMPORTED_MODULE_1__/* .detachToJsonMethod */ .y)(Array.prototype);
    // Initial call to sanitizeProcessor - will populate containerQueue if source is an Array or a plain Object
    var containerQueue = [];
    var visitedObjectsWithPath = new WeakMap();
    var sanitizedData = sanitizeProcessor(source, JSON_PATH_ROOT_ELEMENT, undefined, containerQueue, visitedObjectsWithPath);
    var accumulatedCharacterCount = ((_a = JSON.stringify(sanitizedData)) === null || _a === void 0 ? void 0 : _a.length) || 0;
    if (accumulatedCharacterCount > maxCharacterCount) {
        warnOverCharacterLimit(maxCharacterCount, 'discarded', source);
        return undefined;
    }
    while (containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount) {
        var containerToProcess = containerQueue.shift();
        var separatorLength = 0; // 0 for the first element, 1 for subsequent elements
        // Arrays and Objects have to be handled distinctly to ensure
        // we do not pick up non-numerical properties from Arrays
        if (Array.isArray(containerToProcess.source)) {
            for (var key = 0; key < containerToProcess.source.length; key++) {
                var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                if (targetData !== undefined) {
                    accumulatedCharacterCount += JSON.stringify(targetData).length;
                }
                else {
                    // When an element of an Array (targetData) is undefined, it is serialized as null:
                    // JSON.stringify([undefined]) => '[null]' - This accounts for 4 characters
                    accumulatedCharacterCount += 4;
                }
                accumulatedCharacterCount += separatorLength;
                separatorLength = 1;
                if (accumulatedCharacterCount > maxCharacterCount) {
                    warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                    break;
                }
                ;
                containerToProcess.target[key] = targetData;
            }
        }
        else {
            for (var key in containerToProcess.source) {
                if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
                    var targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
                    // When a property of an object has an undefined value, it will be dropped during serialization:
                    // JSON.stringify({a:undefined}) => '{}'
                    if (targetData !== undefined) {
                        accumulatedCharacterCount +=
                            JSON.stringify(targetData).length + separatorLength + key.length + KEY_DECORATION_LENGTH;
                        separatorLength = 1;
                    }
                    if (accumulatedCharacterCount > maxCharacterCount) {
                        warnOverCharacterLimit(maxCharacterCount, 'truncated', source);
                        break;
                    }
                    ;
                    containerToProcess.target[key] = targetData;
                }
            }
        }
    }
    // Rebind detached toJSON functions
    restoreObjectPrototypeToJson();
    restoreArrayPrototypeToJson();
    return sanitizedData;
}
/**
 * Internal function to factorize the process common to the
 * initial call to sanitize, and iterations for Arrays and Objects
 *
 */
function sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
    // Start by handling toJSON, as we want to sanitize its output
    var sourceToSanitize = tryToApplyToJSON(source);
    if (!sourceToSanitize || typeof sourceToSanitize !== 'object') {
        return sanitizePrimitivesAndFunctions(sourceToSanitize);
    }
    var sanitizedSource = sanitizeObjects(sourceToSanitize);
    if (sanitizedSource !== '[Object]' && sanitizedSource !== '[Array]' && sanitizedSource !== '[Error]') {
        return sanitizedSource;
    }
    // Handle potential cyclic references
    // We need to use source as sourceToSanitize could be a reference to a new object
    // At this stage, we know the source is an object type
    var sourceAsObject = source;
    if (visitedObjectsWithPath.has(sourceAsObject)) {
        return "[Reference seen at ".concat(visitedObjectsWithPath.get(sourceAsObject), "]");
    }
    // Add processed source to queue
    var currentPath = key !== undefined ? "".concat(parentPath, ".").concat(key) : parentPath;
    var target = Array.isArray(sourceToSanitize) ? [] : {};
    visitedObjectsWithPath.set(sourceAsObject, currentPath);
    queue.push({ source: sourceToSanitize, target: target, path: currentPath });
    return target;
}
/**
 * Handles sanitization of simple, non-object types
 *
 */
function sanitizePrimitivesAndFunctions(value) {
    // BigInt cannot be serialized by JSON.stringify(), convert it to a string representation
    if (typeof value === 'bigint') {
        return "[BigInt] ".concat(value.toString());
    }
    // Functions cannot be serialized by JSON.stringify(). Moreover, if a faulty toJSON is present, it needs to be converted
    // so it won't prevent stringify from serializing later
    if (typeof value === 'function') {
        return "[Function] ".concat(value.name || 'unknown');
    }
    // JSON.stringify() does not serialize symbols.
    if (typeof value === 'symbol') {
        return "[Symbol] ".concat(value.description || value.toString());
    }
    return value;
}
/**
 * Handles sanitization of object types
 *
 * LIMITATIONS
 * - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
 * To avoid this, a toJSON method can be defined.
 * - IE11 does not return a distinct type for objects such as Map, WeakMap, ... These objects will pass through and their
 * properties enumerated if any.
 *
 */
function sanitizeObjects(value) {
    try {
        // Handle events - Keep a simple implementation to avoid breaking changes
        if (value instanceof Event) {
            return {
                isTrusted: value.isTrusted,
            };
        }
        // Handle all remaining object types in a generic way
        var result = Object.prototype.toString.call(value);
        var match = result.match(/\[object (.*)\]/);
        if (match && match[1]) {
            return "[".concat(match[1], "]");
        }
    }
    catch (_a) {
        // If the previous serialization attempts failed, and we cannot convert using
        // Object.prototype.toString, declare the value unserializable
    }
    return '[Unserializable]';
}
/**
 * Checks if a toJSON function exists and tries to execute it
 *
 */
function tryToApplyToJSON(value) {
    var object = value;
    if (object && typeof object.toJSON === 'function') {
        try {
            return object.toJSON();
        }
        catch (_a) {
            // If toJSON fails, we continue by trying to serialize the value manually
        }
    }
    return value;
}
/**
 * Helper function to display the warning when the accumulated character count is over the limit
 */
function warnOverCharacterLimit(maxCharacterCount, changeType, source) {
    _display__WEBPACK_IMPORTED_MODULE_2__/* .display.warn */ .jf.warn("The data provided has been ".concat(changeType, " as it is over the limit of ").concat(maxCharacterCount, " characters:"), source);
}
//# sourceMappingURL=sanitize.js.map

/***/ }),

/***/ 48399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zi": function() { return /* binding */ setInterval; },
/* harmony export */   "cv": function() { return /* binding */ clearInterval; },
/* harmony export */   "gr": function() { return /* binding */ clearTimeout; },
/* harmony export */   "iK": function() { return /* binding */ setTimeout; }
/* harmony export */ });
/* harmony import */ var _getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56376);
/* harmony import */ var _monitor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93099);
/* harmony import */ var _getGlobalObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1692);



function setTimeout(callback, delay) {
    return (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_getGlobalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)(), 'setTimeout')((0,_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(callback), delay);
}
function clearTimeout(timeoutId) {
    (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_getGlobalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)(), 'clearTimeout')(timeoutId);
}
function setInterval(callback, delay) {
    return (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_getGlobalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)(), 'setInterval')((0,_monitor__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(callback), delay);
}
function clearInterval(timeoutId) {
    (0,_getZoneJsOriginalValue__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)((0,_getGlobalObject__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)(), 'clearInterval')(timeoutId);
}
//# sourceMappingURL=timer.js.map

/***/ }),

/***/ 50985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ removeDuplicates; }
/* harmony export */ });
/* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95959);

function removeDuplicates(array) {
    var set = new Set();
    array.forEach(function (item) { return set.add(item); });
    return (0,_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .arrayFrom */ .Oc)(set);
}
//# sourceMappingURL=arrayUtils.js.map

/***/ }),

/***/ 89741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G6": function() { return /* binding */ isSafari; },
/* harmony export */   "mJ": function() { return /* binding */ isChromium; },
/* harmony export */   "w1": function() { return /* binding */ isIE; }
/* harmony export */ });
var browserIsIE;
function isIE() {
    return browserIsIE !== null && browserIsIE !== void 0 ? browserIsIE : (browserIsIE = Boolean(document.documentMode));
}
var browserIsChromium;
function isChromium() {
    return (browserIsChromium !== null && browserIsChromium !== void 0 ? browserIsChromium : (browserIsChromium = !!window.chrome || /HeadlessChrome/.test(window.navigator.userAgent)));
}
var browserIsSafari;
function isSafari() {
    return browserIsSafari !== null && browserIsSafari !== void 0 ? browserIsSafari : (browserIsSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent));
}
//# sourceMappingURL=browserDetection.js.map

/***/ }),

/***/ 10160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hi": function() { return /* binding */ ONE_KIBI_BYTE; },
/* harmony export */   "Kb": function() { return /* binding */ concatBuffers; },
/* harmony export */   "X9": function() { return /* binding */ ONE_MEBI_BYTE; },
/* harmony export */   "qt": function() { return /* binding */ computeBytesCount; }
/* harmony export */ });
var ONE_KIBI_BYTE = 1024;
var ONE_MEBI_BYTE = 1024 * ONE_KIBI_BYTE;
// eslint-disable-next-line no-control-regex
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function computeBytesCount(candidate) {
    // Accurate bytes count computations can degrade performances when there is a lot of events to process
    if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
        return candidate.length;
    }
    if (window.TextEncoder !== undefined) {
        return new TextEncoder().encode(candidate).length;
    }
    return new Blob([candidate]).size;
}
function concatBuffers(buffers) {
    var length = buffers.reduce(function (total, buffer) { return total + buffer.length; }, 0);
    var result = new Uint8Array(length);
    var offset = 0;
    for (var _i = 0, buffers_1 = buffers; _i < buffers_1.length; _i++) {
        var buffer = buffers_1[_i];
        result.set(buffer, offset);
        offset += buffer.length;
    }
    return result;
}
//# sourceMappingURL=byteUtils.js.map

/***/ }),

/***/ 84164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ throttle; },
/* harmony export */   "Z": function() { return /* binding */ noop; }
/* harmony export */ });
/* harmony import */ var _timer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48399);

// use lodash API
function throttle(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var pendingExecutionWithParameters;
    var pendingTimeoutId;
    return {
        throttled: function () {
            var parameters = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                parameters[_i] = arguments[_i];
            }
            if (inWaitPeriod) {
                pendingExecutionWithParameters = parameters;
                return;
            }
            if (needLeadingExecution) {
                fn.apply(void 0, parameters);
            }
            else {
                pendingExecutionWithParameters = parameters;
            }
            inWaitPeriod = true;
            pendingTimeoutId = (0,_timer__WEBPACK_IMPORTED_MODULE_0__/* .setTimeout */ .iK)(function () {
                if (needTrailingExecution && pendingExecutionWithParameters) {
                    fn.apply(void 0, pendingExecutionWithParameters);
                }
                inWaitPeriod = false;
                pendingExecutionWithParameters = undefined;
            }, wait);
        },
        cancel: function () {
            (0,_timer__WEBPACK_IMPORTED_MODULE_0__/* .clearTimeout */ .gr)(pendingTimeoutId);
            inWaitPeriod = false;
            pendingExecutionWithParameters = undefined;
        },
    };
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }
//# sourceMappingURL=functionUtils.js.map

/***/ }),

/***/ 76135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NM": function() { return /* binding */ round; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; },
/* harmony export */   "y7": function() { return /* binding */ performDraw; },
/* harmony export */   "zz": function() { return /* binding */ isPercentage; }
/* harmony export */ });
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
    return +num.toFixed(decimals);
}
function isPercentage(value) {
    return isNumber(value) && value >= 0 && value <= 100;
}
function isNumber(value) {
    return typeof value === 'number';
}
//# sourceMappingURL=numberUtils.js.map

/***/ }),

/***/ 47970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E5": function() { return /* binding */ objectHasValue; },
/* harmony export */   "Q8": function() { return /* binding */ mapValues; },
/* harmony export */   "Qr": function() { return /* binding */ isEmptyObject; },
/* harmony export */   "mv": function() { return /* binding */ shallowClone; }
/* harmony export */ });
/* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95959);

function shallowClone(object) {
    return (0,_polyfills__WEBPACK_IMPORTED_MODULE_0__/* .assign */ .f0)({}, object);
}
function objectHasValue(object, value) {
    return Object.keys(object).some(function (key) { return object[key] === value; });
}
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
    var newObject = {};
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var key = _a[_i];
        newObject[key] = fn(object[key]);
    }
    return newObject;
}
//# sourceMappingURL=objectUtils.js.map

/***/ }),

/***/ 95959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ap": function() { return /* binding */ elementMatches; },
/* harmony export */   "Ed": function() { return /* binding */ forEach; },
/* harmony export */   "Ny": function() { return /* binding */ startsWith; },
/* harmony export */   "Oc": function() { return /* binding */ arrayFrom; },
/* harmony export */   "QA": function() { return /* binding */ cssEscape; },
/* harmony export */   "TT": function() { return /* binding */ objectValues; },
/* harmony export */   "dF": function() { return /* binding */ findLast; },
/* harmony export */   "f0": function() { return /* binding */ assign; },
/* harmony export */   "pn": function() { return /* binding */ endsWith; },
/* harmony export */   "q9": function() { return /* binding */ includes; },
/* harmony export */   "qP": function() { return /* binding */ objectEntries; },
/* harmony export */   "sE": function() { return /* binding */ find; }
/* harmony export */ });
function includes(candidate, search) {
    return candidate.indexOf(search) !== -1;
}
function arrayFrom(arrayLike) {
    if (Array.from) {
        return Array.from(arrayLike);
    }
    var array = [];
    if (arrayLike instanceof Set) {
        arrayLike.forEach(function (item) { return array.push(item); });
    }
    else {
        for (var i = 0; i < arrayLike.length; i++) {
            array.push(arrayLike[i]);
        }
    }
    return array;
}
function find(array, predicate) {
    for (var i = 0; i < array.length; i += 1) {
        var item = array[i];
        if (predicate(item, i)) {
            return item;
        }
    }
    return undefined;
}
function findLast(array, predicate) {
    for (var i = array.length - 1; i >= 0; i -= 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
function forEach(list, callback) {
    Array.prototype.forEach.call(list, callback);
}
function objectValues(object) {
    return Object.keys(object).map(function (key) { return object[key]; });
}
function objectEntries(object) {
    return Object.keys(object).map(function (key) { return [key, object[key]]; });
}
function startsWith(candidate, search) {
    return candidate.slice(0, search.length) === search;
}
function endsWith(candidate, search) {
    return candidate.slice(-search.length) === search;
}
function elementMatches(element, selector) {
    if (element.matches) {
        return element.matches(selector);
    }
    // IE11 support
    if (element.msMatchesSelector) {
        return element.msMatchesSelector(selector);
    }
    return false;
}
// https://github.com/jquery/jquery/blob/a684e6ba836f7c553968d7d026ed7941e1a612d8/src/selector/escapeSelector.js
function cssEscape(str) {
    if (window.CSS && window.CSS.escape) {
        return window.CSS.escape(str);
    }
    // eslint-disable-next-line no-control-regex
    return str.replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === '\0') {
                return '\uFFFD';
            }
            // Control characters and (dependent upon position) numbers get escaped as code points
            return "".concat(ch.slice(0, -1), "\\").concat(ch.charCodeAt(ch.length - 1).toString(16), " ");
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\".concat(ch);
    });
}
function assign(target) {
    var toAssign = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        toAssign[_i - 1] = arguments[_i];
    }
    toAssign.forEach(function (source) {
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    });
    return target;
}
//# sourceMappingURL=polyfills.js.map

/***/ }),

/***/ 98744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ isServerError; },
/* harmony export */   "u": function() { return /* binding */ tryToClone; }
/* harmony export */ });
function isServerError(status) {
    return status >= 500;
}
function tryToClone(response) {
    try {
        return response.clone();
    }
    catch (e) {
        // clone can throw if the response has already been used by another instrumentation or is disturbed
        return;
    }
}
//# sourceMappingURL=responseUtils.js.map

/***/ }),

/***/ 61206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DO": function() { return /* binding */ generateUUID; },
/* harmony export */   "MY": function() { return /* binding */ findCommaSeparatedValue; },
/* harmony export */   "_z": function() { return /* binding */ safeTruncate; }
/* harmony export */ });
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
    return placeholder
        ? // eslint-disable-next-line  no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : "".concat(1e7, "-").concat(1e3, "-").concat(4e3, "-").concat(8e3, "-").concat(1e11).replace(/[018]/g, generateUUID);
}
function findCommaSeparatedValue(rawString, name) {
    var regex = new RegExp("(?:^|;)\\s*".concat(name, "\\s*=\\s*([^;]+)"));
    var matches = regex.exec(rawString);
    return matches ? matches[1] : undefined;
}
function safeTruncate(candidate, length, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var lastChar = candidate.charCodeAt(length - 1);
    var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
    var correctedLength = isLastCharSurrogatePair ? length + 1 : length;
    if (candidate.length <= correctedLength) {
        return candidate;
    }
    return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}
//# sourceMappingURL=stringUtils.js.map

/***/ }),

/***/ 853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$I": function() { return /* binding */ clocksNow; },
/* harmony export */   "Cn": function() { return /* binding */ looksLikeRelativeTime; },
/* harmony export */   "DY": function() { return /* binding */ relativeToClocks; },
/* harmony export */   "QA": function() { return /* binding */ currentDrift; },
/* harmony export */   "WK": function() { return /* binding */ addDuration; },
/* harmony export */   "WT": function() { return /* binding */ ONE_SECOND; },
/* harmony export */   "_J": function() { return /* binding */ elapsed; },
/* harmony export */   "_q": function() { return /* binding */ relativeNow; },
/* harmony export */   "c0": function() { return /* binding */ toServerDuration; },
/* harmony export */   "cQ": function() { return /* binding */ clocksOrigin; },
/* harmony export */   "dV": function() { return /* binding */ ONE_HOUR; },
/* harmony export */   "m6": function() { return /* binding */ dateNow; },
/* harmony export */   "n$": function() { return /* binding */ timeStampNow; },
/* harmony export */   "ni": function() { return /* binding */ getRelativeTime; },
/* harmony export */   "yR": function() { return /* binding */ ONE_MINUTE; }
/* harmony export */ });
/* unused harmony exports ONE_DAY, ONE_YEAR, getTimeStamp, resetNavigationStart */
/* harmony import */ var _numberUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76135);

var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_DAY = 24 * ONE_HOUR;
var ONE_YEAR = 365 * ONE_DAY;
function relativeToClocks(relative) {
    return { relative: relative, timeStamp: getCorrectedTimeStamp(relative) };
}
function getCorrectedTimeStamp(relativeTime) {
    var correctedOrigin = (dateNow() - performance.now());
    // apply correction only for positive drift
    if (correctedOrigin > getNavigationStart()) {
        return Math.round(addDuration(correctedOrigin, relativeTime));
    }
    return getTimeStamp(relativeTime);
}
function currentDrift() {
    return Math.round(dateNow() - addDuration(getNavigationStart(), performance.now()));
}
function toServerDuration(duration) {
    if (!(0,_numberUtils__WEBPACK_IMPORTED_MODULE_0__/* .isNumber */ .hj)(duration)) {
        return duration;
    }
    return (0,_numberUtils__WEBPACK_IMPORTED_MODULE_0__/* .round */ .NM)(duration * 1e6, 0);
}
function dateNow() {
    // Do not use `Date.now` because sometimes websites are wrongly "polyfilling" it. For example, we
    // had some users using a very old version of `datejs`, which patched `Date.now` to return a Date
    // instance instead of a timestamp[1]. Those users are unlikely to fix this, so let's handle this
    // case ourselves.
    // [1]: https://github.com/datejs/Datejs/blob/97f5c7c58c5bc5accdab8aa7602b6ac56462d778/src/core-debug.js#L14-L16
    return new Date().getTime();
}
function timeStampNow() {
    return dateNow();
}
function relativeNow() {
    return performance.now();
}
function clocksNow() {
    return { relative: relativeNow(), timeStamp: timeStampNow() };
}
function clocksOrigin() {
    return { relative: 0, timeStamp: getNavigationStart() };
}
function elapsed(start, end) {
    return (end - start);
}
function addDuration(a, b) {
    return a + b;
}
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
    return (timestamp - getNavigationStart());
}
function getTimeStamp(relativeTime) {
    return Math.round(addDuration(getNavigationStart(), relativeTime));
}
function looksLikeRelativeTime(time) {
    return time < ONE_YEAR;
}
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
    if (navigationStart === undefined) {
        navigationStart = performance.timing.navigationStart;
    }
    return navigationStart;
}
function resetNavigationStart() {
    navigationStart = undefined;
}
//# sourceMappingURL=timeUtils.js.map

/***/ }),

/***/ 74505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ getType; }
/* harmony export */ });
/**
 * Similar to `typeof`, but distinguish plain objects from `null` and arrays
 */
function getType(value) {
    if (value === null) {
        return 'null';
    }
    if (Array.isArray(value)) {
        return 'array';
    }
    return typeof value;
}
//# sourceMappingURL=typeUtils.js.map

/***/ }),

/***/ 6239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D5": function() { return /* binding */ normalizeUrl; },
/* harmony export */   "P$": function() { return /* binding */ getOrigin; },
/* harmony export */   "Q2": function() { return /* binding */ buildUrl; },
/* harmony export */   "jv": function() { return /* binding */ isValidUrl; },
/* harmony export */   "ye": function() { return /* binding */ getPathName; }
/* harmony export */ });
/* unused harmony exports getSearch, getHash, getLocationOrigin, getLinkElementOrigin */
/* harmony import */ var _serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41192);

function normalizeUrl(url) {
    return buildUrl(url, getLocationOrigin()).href;
}
function isValidUrl(url) {
    try {
        return !!buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
function getOrigin(url) {
    return getLinkElementOrigin(buildUrl(url));
}
function getPathName(url) {
    var pathname = buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : "/".concat(pathname);
}
function getSearch(url) {
    return buildUrl(url).search;
}
function getHash(url) {
    return buildUrl(url).hash;
}
function buildUrl(url, base) {
    var supportedURL = getSupportedUrl();
    if (supportedURL) {
        try {
            return base !== undefined ? new supportedURL(url, base) : new supportedURL(url);
        }
        catch (error) {
            throw new Error("Failed to construct URL: ".concat(String(error), " ").concat((0,_serialisation_jsonStringify__WEBPACK_IMPORTED_MODULE_0__/* .jsonStringify */ .l)({ url: url, base: base })));
        }
    }
    if (base === undefined && !/:/.test(url)) {
        throw new Error("Invalid URL: '".concat(url, "'"));
    }
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var originalURL = URL;
var isURLSupported;
function getSupportedUrl() {
    if (isURLSupported === undefined) {
        try {
            var url = new originalURL('http://test/path');
            isURLSupported = url.href === 'http://test/path';
        }
        catch (_a) {
            isURLSupported = false;
        }
    }
    return isURLSupported ? originalURL : undefined;
}
function getLocationOrigin() {
    return getLinkElementOrigin(window.location);
}
/**
 * Fallback
 * On IE HTMLAnchorElement origin is not supported: https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/origin
 * On Firefox window.location.origin is "null" for file: URIs: https://bugzilla.mozilla.org/show_bug.cgi?id=878297
 */
function getLinkElementOrigin(element) {
    if (element.origin && element.origin !== 'null') {
        return element.origin;
    }
    var sanitizedHost = element.host.replace(/(:80|:443)$/, '');
    return "".concat(element.protocol, "//").concat(sanitizedHost);
}
//# sourceMappingURL=urlPolyfill.js.map

/***/ }),

/***/ 53769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ ValueHistory; }
/* harmony export */ });
/* unused harmony export CLEAR_OLD_VALUES_INTERVAL */
/* harmony import */ var _timer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48399);
/* harmony import */ var _utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(853);


var END_OF_TIMES = Infinity;
var CLEAR_OLD_VALUES_INTERVAL = _utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR;
/**
 * Store and keep track of values spans. This whole class assumes that values are added in
 * chronological order (i.e. all entries have an increasing start time).
 */
var ValueHistory = /** @class */ (function () {
    function ValueHistory(expireDelay, maxEntries) {
        var _this = this;
        this.expireDelay = expireDelay;
        this.maxEntries = maxEntries;
        this.entries = [];
        this.clearOldValuesInterval = (0,_timer__WEBPACK_IMPORTED_MODULE_1__/* .setInterval */ .Zi)(function () { return _this.clearOldValues(); }, CLEAR_OLD_VALUES_INTERVAL);
    }
    /**
     * Add a value to the history associated with a start time. Returns a reference to this newly
     * added entry that can be removed or closed.
     */
    ValueHistory.prototype.add = function (value, startTime) {
        var _this = this;
        var entry = {
            value: value,
            startTime: startTime,
            endTime: END_OF_TIMES,
            remove: function () {
                var index = _this.entries.indexOf(entry);
                if (index >= 0) {
                    _this.entries.splice(index, 1);
                }
            },
            close: function (endTime) {
                entry.endTime = endTime;
            },
        };
        if (this.maxEntries && this.entries.length >= this.maxEntries) {
            this.entries.pop();
        }
        this.entries.unshift(entry);
        return entry;
    };
    /**
     * Return the latest value that was active during `startTime`, or the currently active value
     * if no `startTime` is provided. This method assumes that entries are not overlapping.
     */
    ValueHistory.prototype.find = function (startTime) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        for (var _i = 0, _a = this.entries; _i < _a.length; _i++) {
            var entry = _a[_i];
            if (entry.startTime <= startTime) {
                if (startTime <= entry.endTime) {
                    return entry.value;
                }
                break;
            }
        }
    };
    /**
     * Helper function to close the currently active value, if any. This method assumes that entries
     * are not overlapping.
     */
    ValueHistory.prototype.closeActive = function (endTime) {
        var latestEntry = this.entries[0];
        if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
            latestEntry.close(endTime);
        }
    };
    /**
     * Return all values with an active period overlapping with the duration,
     * or all values that were active during `startTime` if no duration is provided,
     * or all currently active values if no `startTime` is provided.
     */
    ValueHistory.prototype.findAll = function (startTime, duration) {
        if (startTime === void 0) { startTime = END_OF_TIMES; }
        if (duration === void 0) { duration = 0; }
        var endTime = (0,_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .addDuration */ .WK)(startTime, duration);
        return this.entries
            .filter(function (entry) { return entry.startTime <= endTime && startTime <= entry.endTime; })
            .map(function (entry) { return entry.value; });
    };
    /**
     * Remove all entries from this collection.
     */
    ValueHistory.prototype.reset = function () {
        this.entries = [];
    };
    /**
     * Stop internal garbage collection of past entries.
     */
    ValueHistory.prototype.stop = function () {
        (0,_timer__WEBPACK_IMPORTED_MODULE_1__/* .clearInterval */ .cv)(this.clearOldValuesInterval);
    };
    ValueHistory.prototype.clearOldValues = function () {
        var oldTimeThreshold = (0,_utils_timeUtils__WEBPACK_IMPORTED_MODULE_0__/* .relativeNow */ ._q)() - this.expireDelay;
        while (this.entries.length > 0 && this.entries[this.entries.length - 1].endTime < oldTimeThreshold) {
            this.entries.pop();
        }
    };
    return ValueHistory;
}());

//# sourceMappingURL=valueHistory.js.map

/***/ }),

/***/ 52325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getEventBridge; },
/* harmony export */   "x": function() { return /* binding */ canUseEventBridge; }
/* harmony export */ });
/* harmony import */ var _tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95959);
/* harmony import */ var _tools_getGlobalObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1692);


function getEventBridge() {
    var eventBridgeGlobal = getEventBridgeGlobal();
    if (!eventBridgeGlobal) {
        return;
    }
    return {
        getAllowedWebViewHosts: function () {
            return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
        },
        send: function (eventType, event) {
            eventBridgeGlobal.send(JSON.stringify({ eventType: eventType, event: event }));
        },
    };
}
function canUseEventBridge(currentHost) {
    var _a;
    if (currentHost === void 0) { currentHost = (_a = (0,_tools_getGlobalObject__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().location) === null || _a === void 0 ? void 0 : _a.hostname; }
    var bridge = getEventBridge();
    return (!!bridge &&
        bridge
            .getAllowedWebViewHosts()
            .some(function (allowedHost) { return currentHost === allowedHost || (0,_tools_utils_polyfills__WEBPACK_IMPORTED_MODULE_1__/* .endsWith */ .pn)(currentHost, ".".concat(allowedHost)); }));
}
function getEventBridgeGlobal() {
    return (0,_tools_getGlobalObject__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)().DatadogEventBridge;
}
//# sourceMappingURL=eventBridge.js.map

/***/ }),

/***/ 13152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UF": function() { return /* binding */ createHttpRequest; }
});

// UNUSED EXPORTS: fetchKeepAliveStrategy, sendXHR

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry = __webpack_require__(41887);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(93099);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/addEventListener.js
var addEventListener = __webpack_require__(7411);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(48399);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(853);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(10160);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
var responseUtils = __webpack_require__(98744);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var error_types = __webpack_require__(10494);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/sendWithRetryStrategy.js





var MAX_ONGOING_BYTES_COUNT = 80 * byteUtils/* ONE_KIBI_BYTE */.Hi;
var MAX_ONGOING_REQUESTS = 32;
var MAX_QUEUE_BYTES_COUNT = 3 * byteUtils/* ONE_MEBI_BYTE */.X9;
var MAX_BACKOFF_TIME = timeUtils/* ONE_MINUTE */.yR;
var INITIAL_BACKOFF_TIME = timeUtils/* ONE_SECOND */.WT;
function sendWithRetryStrategy(payload, state, sendStrategy, endpointType, reportError) {
    if (state.transportStatus === 0 /* TransportStatus.UP */ &&
        state.queuedPayloads.size() === 0 &&
        state.bandwidthMonitor.canHandle(payload)) {
        send(payload, state, sendStrategy, {
            onSuccess: function () { return retryQueuedPayloads(0 /* RetryReason.AFTER_SUCCESS */, state, sendStrategy, endpointType, reportError); },
            onFailure: function () {
                state.queuedPayloads.enqueue(payload);
                scheduleRetry(state, sendStrategy, endpointType, reportError);
            },
        });
    }
    else {
        state.queuedPayloads.enqueue(payload);
    }
}
function scheduleRetry(state, sendStrategy, endpointType, reportError) {
    if (state.transportStatus !== 2 /* TransportStatus.DOWN */) {
        return;
    }
    (0,timer/* setTimeout */.iK)(function () {
        var payload = state.queuedPayloads.first();
        send(payload, state, sendStrategy, {
            onSuccess: function () {
                state.queuedPayloads.dequeue();
                state.currentBackoffTime = INITIAL_BACKOFF_TIME;
                retryQueuedPayloads(1 /* RetryReason.AFTER_RESUME */, state, sendStrategy, endpointType, reportError);
            },
            onFailure: function () {
                state.currentBackoffTime = Math.min(MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
                scheduleRetry(state, sendStrategy, endpointType, reportError);
            },
        });
    }, state.currentBackoffTime);
}
function send(payload, state, sendStrategy, _a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    state.bandwidthMonitor.add(payload);
    sendStrategy(payload, function (response) {
        state.bandwidthMonitor.remove(payload);
        if (!shouldRetryRequest(response)) {
            state.transportStatus = 0 /* TransportStatus.UP */;
            onSuccess();
        }
        else {
            // do not consider transport down if another ongoing request could succeed
            state.transportStatus =
                state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 /* TransportStatus.FAILURE_DETECTED */ : 2 /* TransportStatus.DOWN */;
            payload.retry = {
                count: payload.retry ? payload.retry.count + 1 : 1,
                lastFailureStatus: response.status,
            };
            onFailure();
        }
    });
}
function retryQueuedPayloads(reason, state, sendStrategy, endpointType, reportError) {
    if (reason === 0 /* RetryReason.AFTER_SUCCESS */ && state.queuedPayloads.isFull() && !state.queueFullReported) {
        reportError({
            message: "Reached max ".concat(endpointType, " events size queued for upload: ").concat(MAX_QUEUE_BYTES_COUNT / byteUtils/* ONE_MEBI_BYTE */.X9, "MiB"),
            source: error_types/* ErrorSource.AGENT */.z.AGENT,
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
        });
        state.queueFullReported = true;
    }
    var previousQueue = state.queuedPayloads;
    state.queuedPayloads = newPayloadQueue();
    while (previousQueue.size() > 0) {
        sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, endpointType, reportError);
    }
}
function shouldRetryRequest(response) {
    return (response.type !== 'opaque' &&
        ((response.status === 0 && !navigator.onLine) ||
            response.status === 408 ||
            response.status === 429 ||
            (0,responseUtils/* isServerError */.o)(response.status)));
}
function newRetryState() {
    return {
        transportStatus: 0 /* TransportStatus.UP */,
        currentBackoffTime: INITIAL_BACKOFF_TIME,
        bandwidthMonitor: newBandwidthMonitor(),
        queuedPayloads: newPayloadQueue(),
        queueFullReported: false,
    };
}
function newPayloadQueue() {
    var queue = [];
    return {
        bytesCount: 0,
        enqueue: function (payload) {
            if (this.isFull()) {
                return;
            }
            queue.push(payload);
            this.bytesCount += payload.bytesCount;
        },
        first: function () {
            return queue[0];
        },
        dequeue: function () {
            var payload = queue.shift();
            if (payload) {
                this.bytesCount -= payload.bytesCount;
            }
            return payload;
        },
        size: function () {
            return queue.length;
        },
        isFull: function () {
            return this.bytesCount >= MAX_QUEUE_BYTES_COUNT;
        },
    };
}
function newBandwidthMonitor() {
    return {
        ongoingRequestCount: 0,
        ongoingByteCount: 0,
        canHandle: function (payload) {
            return (this.ongoingRequestCount === 0 ||
                (this.ongoingByteCount + payload.bytesCount <= MAX_ONGOING_BYTES_COUNT &&
                    this.ongoingRequestCount < MAX_ONGOING_REQUESTS));
        },
        add: function (payload) {
            this.ongoingRequestCount += 1;
            this.ongoingByteCount += payload.bytesCount;
        },
        remove: function (payload) {
            this.ongoingRequestCount -= 1;
            this.ongoingByteCount -= payload.bytesCount;
        },
    };
}
//# sourceMappingURL=sendWithRetryStrategy.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/httpRequest.js




function createHttpRequest(configuration, endpointBuilder, bytesLimit, reportError) {
    var retryState = newRetryState();
    var sendStrategyForRetry = function (payload, onResponse) {
        return fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse);
    };
    return {
        send: function (payload) {
            sendWithRetryStrategy(payload, retryState, sendStrategyForRetry, endpointBuilder.endpointType, reportError);
        },
        /**
         * Since fetch keepalive behaves like regular fetch on Firefox,
         * keep using sendBeaconStrategy on exit
         */
        sendOnExit: function (payload) {
            sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload);
        },
    };
}
function sendBeaconStrategy(configuration, endpointBuilder, bytesLimit, payload) {
    var canUseBeacon = !!navigator.sendBeacon && payload.bytesCount < bytesLimit;
    if (canUseBeacon) {
        try {
            var beaconUrl = endpointBuilder.build('beacon', payload);
            var isQueued = navigator.sendBeacon(beaconUrl, payload.data);
            if (isQueued) {
                return;
            }
        }
        catch (e) {
            reportBeaconError(e);
        }
    }
    var xhrUrl = endpointBuilder.build('xhr', payload);
    sendXHR(configuration, xhrUrl, payload.data);
}
var hasReportedBeaconError = false;
function reportBeaconError(e) {
    if (!hasReportedBeaconError) {
        hasReportedBeaconError = true;
        (0,telemetry/* addTelemetryError */.Sz)(e);
    }
}
function fetchKeepAliveStrategy(configuration, endpointBuilder, bytesLimit, payload, onResponse) {
    var canUseKeepAlive = isKeepAliveSupported() && payload.bytesCount < bytesLimit;
    if (canUseKeepAlive) {
        var fetchUrl = endpointBuilder.build('fetch', payload);
        fetch(fetchUrl, { method: 'POST', body: payload.data, keepalive: true, mode: 'cors' }).then((0,monitor/* monitor */.zk)(function (response) { return onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: response.status, type: response.type }); }), (0,monitor/* monitor */.zk)(function () {
            var xhrUrl = endpointBuilder.build('xhr', payload);
            // failed to queue the request
            sendXHR(configuration, xhrUrl, payload.data, onResponse);
        }));
    }
    else {
        var xhrUrl = endpointBuilder.build('xhr', payload);
        sendXHR(configuration, xhrUrl, payload.data, onResponse);
    }
}
function isKeepAliveSupported() {
    // Request can throw, cf https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#errors
    try {
        return window.Request && 'keepalive' in new Request('http://a');
    }
    catch (_a) {
        return false;
    }
}
function sendXHR(configuration, url, data, onResponse) {
    var request = new XMLHttpRequest();
    request.open('POST', url, true);
    (0,addEventListener/* addEventListener */.O)(configuration, request, 'loadend', function () {
        onResponse === null || onResponse === void 0 ? void 0 : onResponse({ status: request.status });
    }, {
        // prevent multiple onResponse callbacks
        // if the xhr instance is reused by a third party
        once: true,
    });
    request.send(data);
}
//# sourceMappingURL=httpRequest.js.map

/***/ }),

/***/ 22556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ startBatchWithReplica; }
});

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(42818);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(95959);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js
var pageExitObservable = __webpack_require__(19609);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(10160);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.js
var jsonStringify = __webpack_require__(41192);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/batch.js





var Batch = /** @class */ (function () {
    function Batch(request, flushController, messageBytesLimit) {
        var _this = this;
        this.request = request;
        this.flushController = flushController;
        this.messageBytesLimit = messageBytesLimit;
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        this.flushSubscription = this.flushController.flushObservable.subscribe(function (event) { return _this.flush(event); });
    }
    Batch.prototype.add = function (message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function (message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.stop = function () {
        this.flushSubscription.unsubscribe();
    };
    Batch.prototype.flush = function (event) {
        var messages = this.pushOnlyBuffer.concat((0,polyfills/* objectValues */.TT)(this.upsertBuffer));
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        var payload = { data: messages.join('\n'), bytesCount: event.bytesCount, flushReason: event.reason };
        if ((0,pageExitObservable/* isPageExitReason */.PT)(event.reason)) {
            this.request.sendOnExit(payload);
        }
        else {
            this.request.send(payload);
        }
    };
    Batch.prototype.addOrUpdate = function (message, key) {
        var _a = this.process(message), processedMessage = _a.processedMessage, messageBytesCount = _a.messageBytesCount;
        if (messageBytesCount >= this.messageBytesLimit) {
            display/* display.warn */.jf.warn("Discarded a message whose size was bigger than the maximum allowed size ".concat(this.messageBytesLimit, "KB."));
            return;
        }
        if (this.hasMessageFor(key)) {
            this.remove(key);
        }
        this.push(processedMessage, messageBytesCount, key);
    };
    Batch.prototype.process = function (message) {
        var processedMessage = (0,jsonStringify/* jsonStringify */.l)(message);
        var messageBytesCount = (0,byteUtils/* computeBytesCount */.qt)(processedMessage);
        return { processedMessage: processedMessage, messageBytesCount: messageBytesCount };
    };
    Batch.prototype.push = function (processedMessage, messageBytesCount, key) {
        // If there are other messages, a '\n' will be added at serialization
        var separatorBytesCount = this.flushController.messagesCount > 0 ? 1 : 0;
        this.flushController.notifyBeforeAddMessage(messageBytesCount + separatorBytesCount);
        if (key !== undefined) {
            this.upsertBuffer[key] = processedMessage;
        }
        else {
            this.pushOnlyBuffer.push(processedMessage);
        }
        this.flushController.notifyAfterAddMessage();
    };
    Batch.prototype.remove = function (key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesCount = (0,byteUtils/* computeBytesCount */.qt)(removedMessage);
        // If there are other messages, a '\n' will be added at serialization
        var separatorBytesCount = this.flushController.messagesCount > 1 ? 1 : 0;
        this.flushController.notifyAfterRemoveMessage(messageBytesCount + separatorBytesCount);
    };
    Batch.prototype.hasMessageFor = function (key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    return Batch;
}());

//# sourceMappingURL=batch.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/httpRequest.js + 1 modules
var httpRequest = __webpack_require__(13152);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/observable.js
var observable = __webpack_require__(87658);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(48399);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/flushController.js


/**
 * Returns a "flush controller", responsible of notifying when flushing a pool of pending data needs
 * to happen. The implementation is designed to support both synchronous and asynchronous usages,
 * but relies on invariants described in each method documentation to keep a coherent state.
 */
function createFlushController(_a) {
    var messagesLimit = _a.messagesLimit, bytesLimit = _a.bytesLimit, durationLimit = _a.durationLimit, pageExitObservable = _a.pageExitObservable, sessionExpireObservable = _a.sessionExpireObservable;
    var pageExitSubscription = pageExitObservable.subscribe(function (event) { return flush(event.reason); });
    var sessionExpireSubscription = sessionExpireObservable.subscribe(function () { return flush('session_expire'); });
    var flushObservable = new observable/* Observable */.y(function () { return function () {
        pageExitSubscription.unsubscribe();
        sessionExpireSubscription.unsubscribe();
    }; });
    var currentBytesCount = 0;
    var currentMessagesCount = 0;
    function flush(flushReason) {
        if (currentMessagesCount === 0) {
            return;
        }
        var messagesCount = currentMessagesCount;
        var bytesCount = currentBytesCount;
        currentMessagesCount = 0;
        currentBytesCount = 0;
        cancelDurationLimitTimeout();
        flushObservable.notify({
            reason: flushReason,
            messagesCount: messagesCount,
            bytesCount: bytesCount,
        });
    }
    var durationLimitTimeoutId;
    function scheduleDurationLimitTimeout() {
        if (durationLimitTimeoutId === undefined) {
            durationLimitTimeoutId = (0,timer/* setTimeout */.iK)(function () {
                flush('duration_limit');
            }, durationLimit);
        }
    }
    function cancelDurationLimitTimeout() {
        (0,timer/* clearTimeout */.gr)(durationLimitTimeoutId);
        durationLimitTimeoutId = undefined;
    }
    return {
        flushObservable: flushObservable,
        get messagesCount() {
            return currentMessagesCount;
        },
        /**
         * Notifies that a message will be added to a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right before adding the message, so no flush
         * event can happen after `notifyBeforeAddMessage` and before adding the message.
         */
        notifyBeforeAddMessage: function (messageBytesCount) {
            if (currentBytesCount + messageBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
            // Consider the message to be added now rather than in `notifyAfterAddMessage`, because if no
            // message was added yet and `notifyAfterAddMessage` is called asynchronously, we still want
            // to notify when a flush is needed (for example on page exit).
            currentMessagesCount += 1;
            currentBytesCount += messageBytesCount;
            scheduleDurationLimitTimeout();
        },
        /**
         * Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
         *
         * This function can be called asynchronously after the message was added, but in this case it
         * should not be called if a flush event occurred in between.
         */
        notifyAfterAddMessage: function () {
            if (currentMessagesCount >= messagesLimit) {
                flush('messages_limit');
            }
            else if (currentBytesCount >= bytesLimit) {
                flush('bytes_limit');
            }
        },
        /**
         * Notifies that a message was removed from a pool of pending messages waiting to be flushed.
         *
         * This function needs to be called synchronously, right after removing the message, so no flush
         * event can happen after removing the message and before `notifyAfterRemoveMessage`.
         */
        notifyAfterRemoveMessage: function (messageBytesCount) {
            currentBytesCount -= messageBytesCount;
            currentMessagesCount -= 1;
            if (currentMessagesCount === 0) {
                cancelDurationLimitTimeout();
            }
        },
    };
}
//# sourceMappingURL=flushController.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/startBatchWithReplica.js



function startBatchWithReplica(configuration, primary, replica, reportError, pageExitObservable, sessionExpireObservable) {
    var primaryBatch = createBatch(configuration, primary.endpoint);
    var replicaBatch = replica && createBatch(configuration, replica.endpoint);
    function createBatch(configuration, endpointBuilder) {
        return new Batch((0,httpRequest/* createHttpRequest */.UF)(configuration, endpointBuilder, configuration.batchBytesLimit, reportError), createFlushController({
            messagesLimit: configuration.batchMessagesLimit,
            bytesLimit: configuration.batchBytesLimit,
            durationLimit: configuration.flushTimeout,
            pageExitObservable: pageExitObservable,
            sessionExpireObservable: sessionExpireObservable,
        }), configuration.messageBytesLimit);
    }
    return {
        flushObservable: primaryBatch.flushController.flushObservable,
        add: function (message, replicated) {
            if (replicated === void 0) { replicated = true; }
            primaryBatch.add(message);
            if (replicaBatch && replicated) {
                replicaBatch.add(replica.transformMessage ? replica.transformMessage(message) : message);
            }
        },
        upsert: function (message, key) {
            primaryBatch.upsert(message, key);
            if (replicaBatch) {
                replicaBatch.upsert(replica.transformMessage ? replica.transformMessage(message) : message, key);
            }
        },
        stop: function () {
            primaryBatch.stop();
            replicaBatch === null || replicaBatch === void 0 ? void 0 : replicaBatch.stop();
        },
    };
}
//# sourceMappingURL=startBatchWithReplica.js.map

/***/ }),

/***/ 45142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fy": function() { return /* reexport */ datadogLogs; }
});

// UNUSED EXPORTS: Datacenter, HandlerType, Logger, StatusType

;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var tslib_es6_assign = function() {
    tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return tslib_es6_assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/contextManager.js
function createContextManager() {
    var context = {};
    return {
        get: function () {
            return context;
        },
        add: function (key, value) {
            context[key] = value;
        },
        remove: function (key) {
            delete context[key];
        },
        set: function (newContext) {
            context = newContext;
        },
    };
}
//# sourceMappingURL=contextManager.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/context.js
function withSnakeCaseKeys(candidate) {
    var result = {};
    Object.keys(candidate).forEach(function (key) {
        result[toSnakeCase(key)] = deepSnakeCase(candidate[key]);
    });
    return result;
}
function deepSnakeCase(candidate) {
    if (Array.isArray(candidate)) {
        return candidate.map(function (value) { return deepSnakeCase(value); });
    }
    if (typeof candidate === 'object' && candidate !== null) {
        return withSnakeCaseKeys(candidate);
    }
    return candidate;
}
function toSnakeCase(word) {
    return word
        .replace(/[A-Z]/g, function (uppercaseLetter, index) { return "" + (index !== 0 ? '_' : '') + uppercaseLetter.toLowerCase(); })
        .replace(/-/g, '_');
}
var isContextArray = function (value) { return Array.isArray(value); };
var isContext = function (value) {
    return !Array.isArray(value) && typeof value === 'object' && value !== null;
};
function combine() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var destination;
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        // Ignore any undefined or null sources.
        if (source === undefined || source === null) {
            continue;
        }
        destination = mergeInto(destination, source, createCircularReferenceChecker());
    }
    return destination;
}
/*
 * Performs a deep clone of objects and arrays.
 * - Circular references are replaced by 'undefined'
 */
function deepClone(context) {
    return mergeInto(undefined, context, createCircularReferenceChecker());
}
function createCircularReferenceChecker() {
    if (typeof WeakSet !== 'undefined') {
        var set_1 = new WeakSet();
        return {
            hasAlreadyBeenSeen: function (value) {
                var has = set_1.has(value);
                if (!has) {
                    set_1.add(value);
                }
                return has;
            },
        };
    }
    var array = [];
    return {
        hasAlreadyBeenSeen: function (value) {
            var has = array.indexOf(value) >= 0;
            if (!has) {
                array.push(value);
            }
            return has;
        },
    };
}
/**
 * Iterate over 'source' and affect its subvalues into 'destination', recursively.  If the 'source'
 * and 'destination' can't be merged, return 'source'.
 */
function mergeInto(destination, source, circularReferenceChecker) {
    // Ignore the 'source' if it is undefined
    if (source === undefined) {
        return destination;
    }
    // If the 'source' is not an object or array, it can't be merged with 'destination' in any way, so
    // return it directly.
    if (!isContext(source) && !isContextArray(source)) {
        return source;
    }
    // Return 'undefined' if we already iterated over this 'source' to avoid infinite recursion
    if (circularReferenceChecker.hasAlreadyBeenSeen(source)) {
        return undefined;
    }
    // 'source' and 'destination' are objects, merge them together
    if (isContext(source) && (destination === undefined || isContext(destination))) {
        var finalDestination = destination || {};
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                finalDestination[key] = mergeInto(finalDestination[key], source[key], circularReferenceChecker);
            }
        }
        return finalDestination;
    }
    // 'source' and 'destination' are arrays, merge them together
    if (isContextArray(source) && (destination === undefined || isContextArray(destination))) {
        var finalDestination = destination || [];
        finalDestination.length = Math.max(finalDestination.length, source.length);
        for (var index = 0; index < source.length; index += 1) {
            finalDestination[index] = mergeInto(finalDestination[index], source[index], circularReferenceChecker);
        }
        return finalDestination;
    }
    // The destination in not an array nor an object, so we can't merge it
    return source;
}
//# sourceMappingURL=context.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/transport/transport.js


// https://en.wikipedia.org/wiki/UTF-8
var HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
/**
 * Use POST request without content type to:
 * - avoid CORS preflight requests
 * - allow usage of sendBeacon
 *
 * multiple elements are sent separated by \n in order
 * to be parsed correctly without content type header
 */
var HttpRequest = /** @class */ (function () {
    function HttpRequest(endpointUrl, bytesLimit, withBatchTime) {
        if (withBatchTime === void 0) { withBatchTime = false; }
        this.endpointUrl = endpointUrl;
        this.bytesLimit = bytesLimit;
        this.withBatchTime = withBatchTime;
    }
    HttpRequest.prototype.send = function (data, size) {
        var url = this.withBatchTime ? addBatchTime(this.endpointUrl) : this.endpointUrl;
        if (navigator.sendBeacon && size < this.bytesLimit) {
            var isQueued = navigator.sendBeacon(url, data);
            if (isQueued) {
                return;
            }
        }
        var request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.send(data);
    };
    return HttpRequest;
}());

function addBatchTime(url) {
    return "" + url + (url.indexOf('?') === -1 ? '?' : '&') + "batch_time=" + new Date().getTime();
}
var Batch = /** @class */ (function () {
    function Batch(request, maxSize, bytesLimit, maxMessageSize, flushTimeout, beforeUnloadCallback) {
        if (beforeUnloadCallback === void 0) { beforeUnloadCallback = noop; }
        this.request = request;
        this.maxSize = maxSize;
        this.bytesLimit = bytesLimit;
        this.maxMessageSize = maxMessageSize;
        this.flushTimeout = flushTimeout;
        this.beforeUnloadCallback = beforeUnloadCallback;
        this.pushOnlyBuffer = [];
        this.upsertBuffer = {};
        this.bufferBytesSize = 0;
        this.bufferMessageCount = 0;
        this.flushOnVisibilityHidden();
        this.flushPeriodically();
    }
    Batch.prototype.add = function (message) {
        this.addOrUpdate(message);
    };
    Batch.prototype.upsert = function (message, key) {
        this.addOrUpdate(message, key);
    };
    Batch.prototype.flush = function () {
        if (this.bufferMessageCount !== 0) {
            var messages = __spreadArrays(this.pushOnlyBuffer, objectValues(this.upsertBuffer));
            this.request.send(messages.join('\n'), this.bufferBytesSize);
            this.pushOnlyBuffer = [];
            this.upsertBuffer = {};
            this.bufferBytesSize = 0;
            this.bufferMessageCount = 0;
        }
    };
    Batch.prototype.sizeInBytes = function (candidate) {
        // Accurate byte size computations can degrade performances when there is a lot of events to process
        if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) {
            return candidate.length;
        }
        if (window.TextEncoder !== undefined) {
            return new TextEncoder().encode(candidate).length;
        }
        return new Blob([candidate]).size;
    };
    Batch.prototype.addOrUpdate = function (message, key) {
        var _a = this.process(message), processedMessage = _a.processedMessage, messageBytesSize = _a.messageBytesSize;
        if (messageBytesSize >= this.maxMessageSize) {
            console.warn("Discarded a message whose size was bigger than the maximum allowed size " + this.maxMessageSize + "KB.");
            return;
        }
        if (this.hasMessageFor(key)) {
            this.remove(key);
        }
        if (this.willReachedBytesLimitWith(messageBytesSize)) {
            this.flush();
        }
        this.push(processedMessage, messageBytesSize, key);
        if (this.isFull()) {
            this.flush();
        }
    };
    Batch.prototype.process = function (message) {
        var processedMessage = jsonStringify(message);
        var messageBytesSize = this.sizeInBytes(processedMessage);
        return { processedMessage: processedMessage, messageBytesSize: messageBytesSize };
    };
    Batch.prototype.push = function (processedMessage, messageBytesSize, key) {
        if (this.bufferMessageCount > 0) {
            // \n separator at serialization
            this.bufferBytesSize += 1;
        }
        if (key !== undefined) {
            this.upsertBuffer[key] = processedMessage;
        }
        else {
            this.pushOnlyBuffer.push(processedMessage);
        }
        this.bufferBytesSize += messageBytesSize;
        this.bufferMessageCount += 1;
    };
    Batch.prototype.remove = function (key) {
        var removedMessage = this.upsertBuffer[key];
        delete this.upsertBuffer[key];
        var messageBytesSize = this.sizeInBytes(removedMessage);
        this.bufferBytesSize -= messageBytesSize;
        this.bufferMessageCount -= 1;
        if (this.bufferMessageCount > 0) {
            this.bufferBytesSize -= 1;
        }
    };
    Batch.prototype.hasMessageFor = function (key) {
        return key !== undefined && this.upsertBuffer[key] !== undefined;
    };
    Batch.prototype.willReachedBytesLimitWith = function (messageBytesSize) {
        // byte of the separator at the end of the message
        return this.bufferBytesSize + messageBytesSize + 1 >= this.bytesLimit;
    };
    Batch.prototype.isFull = function () {
        return this.bufferMessageCount === this.maxSize || this.bufferBytesSize >= this.bytesLimit;
    };
    Batch.prototype.flushPeriodically = function () {
        var _this = this;
        setTimeout(function () {
            _this.flush();
            _this.flushPeriodically();
        }, this.flushTimeout);
    };
    Batch.prototype.flushOnVisibilityHidden = function () {
        var _this = this;
        /**
         * With sendBeacon, requests are guaranteed to be successfully sent during document unload
         */
        // @ts-ignore this function is not always defined
        if (navigator.sendBeacon) {
            /**
             * beforeunload is called before visibilitychange
             * register first to be sure to be called before flush on beforeunload
             * caveat: unload can still be canceled by another listener
             */
            addEventListener(window, DOM_EVENT.BEFORE_UNLOAD, this.beforeUnloadCallback);
            /**
             * Only event that guarantee to fire on mobile devices when the page transitions to background state
             * (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
             */
            addEventListener(document, DOM_EVENT.VISIBILITY_CHANGE, function () {
                if (document.visibilityState === 'hidden') {
                    _this.flush();
                }
            });
            /**
             * Safari does not support yet to send a request during:
             * - a visibility change during doc unload (cf: https://bugs.webkit.org/show_bug.cgi?id=194897)
             * - a page hide transition (cf: https://bugs.webkit.org/show_bug.cgi?id=188329)
             */
            addEventListener(window, DOM_EVENT.BEFORE_UNLOAD, function () { return _this.flush(); });
        }
    };
    return Batch;
}());

//# sourceMappingURL=transport.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/tracekit.js
// tslint:disable no-unsafe-any

var UNKNOWN_FUNCTION = '?';
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
// tslint:disable-next-line max-line-length
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
/**
 * A better form of hasOwnProperty<br/>
 * Example: `has(MainHostObject, property) === true/false`
 *
 * @param {Object} object to check property
 * @param {string} key to check
 * @return {Boolean} true if the object has the key and it is not inherited
 */
function has(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
}
/**
 * Returns true if the parameter is undefined<br/>
 * Example: `isUndefined(val) === true/false`
 *
 * @param {*} what Value to check
 * @return {Boolean} true if undefined and false otherwise
 */
function isUndefined(what) {
    return typeof what === 'undefined';
}
/**
 * Wrap any function in a TraceKit reporter<br/>
 * Example: `func = wrap(func);`
 *
 * @param {Function} func Function to be wrapped
 * @return {Function} The wrapped func
 * @memberof TraceKit
 */
// tslint:disable-next-line ban-types
function wrap(func) {
    function wrapped() {
        try {
            return func.apply(this, arguments);
        }
        catch (e) {
            tracekit_report(e);
            throw e;
        }
    }
    return wrapped;
}
/**
 * Cross-browser processing of unhandled exceptions
 *
 * Syntax:
 * ```js
 *   report.subscribe(function(stackInfo) { ... })
 *   report.unsubscribe(function(stackInfo) { ... })
 *   report(exception)
 *   try { ...code... } catch(ex) { report(ex); }
 * ```
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *     on top frame; column number is not guaranteed
 *   - Opera: full stack trace with line and column numbers
 *   - Chrome: full stack trace with line and column numbers
 *   - Safari: line and column number for the top frame only; some frames
 *     may be missing, and column number is not guaranteed
 *   - IE: line and column number for the top frame only; some frames
 *     may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where report was called.
 *
 * Handlers receive a StackTrace object as described in the
 * computeStackTrace docs.
 *
 * @memberof TraceKit
 * @namespace
 */
var tracekit_report = (function reportModuleWrapper() {
    var handlers = [];
    var lastException;
    var lastExceptionStack;
    /**
     * Add a crash handler.
     * @param {Function} handler
     * @memberof report
     */
    function subscribe(handler) {
        installGlobalHandler();
        installGlobalUnhandledRejectionHandler();
        handlers.push(handler);
    }
    /**
     * Remove a crash handler.
     * @param {Function} handler
     * @memberof report
     */
    function unsubscribe(handler) {
        for (var i = handlers.length - 1; i >= 0; i -= 1) {
            if (handlers[i] === handler) {
                handlers.splice(i, 1);
            }
        }
        if (handlers.length === 0) {
            uninstallGlobalHandler();
            uninstallGlobalUnhandledRejectionHandler();
        }
    }
    /**
     * Dispatch stack information to all handlers.
     * @param {StackTrace} stack
     * @param {boolean} isWindowError Is this a top-level window error?
     * @param {Error=} error The error that's being handled (if available, null otherwise)
     * @memberof report
     * @throws An exception if an error occurs while calling an handler.
     */
    function notifyHandlers(stack, isWindowError, error) {
        var exception;
        for (var i in handlers) {
            if (has(handlers, i)) {
                try {
                    handlers[i](stack, isWindowError, error);
                }
                catch (inner) {
                    exception = inner;
                }
            }
        }
        if (exception) {
            throw exception;
        }
    }
    var oldOnerrorHandler;
    var onErrorHandlerInstalled;
    var oldOnunhandledrejectionHandler;
    var onUnhandledRejectionHandlerInstalled;
    /**
     * Ensures all global unhandled exceptions are recorded.
     * Supported by Gecko and IE.
     * @param {Event|string} message Error message.
     * @param {string=} url URL of script that generated the exception.
     * @param {(number|string)=} lineNo The line number at which the error occurred.
     * @param {(number|string)=} columnNo The column number at which the error occurred.
     * @param {Error=} errorObj The actual Error object.
     * @memberof report
     */
    function traceKitWindowOnError(message, url, lineNo, columnNo, errorObj) {
        var stack;
        if (lastExceptionStack) {
            computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, "" + message);
            processLastException();
        }
        else if (errorObj) {
            stack = computeStackTrace(errorObj);
            notifyHandlers(stack, true, errorObj);
        }
        else {
            var location_1 = {
                url: url,
                column: columnNo,
                line: lineNo,
            };
            var name_1;
            var msg = message;
            if ({}.toString.call(message) === '[object String]') {
                var groups = msg.match(ERROR_TYPES_RE);
                if (groups) {
                    name_1 = groups[1];
                    msg = groups[2];
                }
            }
            stack = {
                name: name_1,
                message: msg,
                stack: [location_1],
            };
            notifyHandlers(stack, true);
        }
        if (oldOnerrorHandler) {
            return oldOnerrorHandler.apply(this, arguments);
        }
        return false;
    }
    /**
     * Ensures all unhandled rejections are recorded.
     * @param {PromiseRejectionEvent} e event.
     * @memberof report
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onunhandledrejection
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
     */
    function traceKitWindowOnUnhandledRejection(e) {
        var reason = e.reason || 'Empty reason';
        var stack = computeStackTrace(reason);
        notifyHandlers(stack, true, reason);
    }
    /**
     * Install a global onerror handler
     * @memberof report
     */
    function installGlobalHandler() {
        if (onErrorHandlerInstalled) {
            return;
        }
        oldOnerrorHandler = window.onerror;
        window.onerror = monitor(traceKitWindowOnError);
        onErrorHandlerInstalled = true;
    }
    /**
     * Uninstall the global onerror handler
     * @memberof report
     */
    function uninstallGlobalHandler() {
        if (onErrorHandlerInstalled) {
            window.onerror = oldOnerrorHandler;
            onErrorHandlerInstalled = false;
        }
    }
    /**
     * Install a global onunhandledrejection handler
     * @memberof report
     */
    function installGlobalUnhandledRejectionHandler() {
        if (onUnhandledRejectionHandlerInstalled) {
            return;
        }
        oldOnunhandledrejectionHandler = window.onunhandledrejection !== null ? window.onunhandledrejection : undefined;
        window.onunhandledrejection = monitor(traceKitWindowOnUnhandledRejection);
        onUnhandledRejectionHandlerInstalled = true;
    }
    /**
     * Uninstall the global onunhandledrejection handler
     * @memberof report
     */
    function uninstallGlobalUnhandledRejectionHandler() {
        if (onUnhandledRejectionHandlerInstalled) {
            window.onunhandledrejection = oldOnunhandledrejectionHandler;
            onUnhandledRejectionHandlerInstalled = false;
        }
    }
    /**
     * Process the most recent exception
     * @memberof report
     */
    function processLastException() {
        var currentLastExceptionStack = lastExceptionStack;
        var currentLastException = lastException;
        lastExceptionStack = undefined;
        lastException = undefined;
        notifyHandlers(currentLastExceptionStack, false, currentLastException);
    }
    /**
     * Reports an unhandled Error.
     * @param {Error} ex
     * @memberof report
     * @throws An exception if an incomplete stack trace is detected (old IE browsers).
     */
    function doReport(ex) {
        if (lastExceptionStack) {
            if (lastException === ex) {
                return; // already caught by an inner catch block, ignore
            }
            processLastException();
        }
        var stack = computeStackTrace(ex);
        lastExceptionStack = stack;
        lastException = ex;
        // If the stack trace is incomplete, wait for 2 seconds for
        // slow slow IE to see if onerror occurs or not before reporting
        // this exception; otherwise, we will end up with an incomplete
        // stack trace
        setTimeout(function () {
            if (lastException === ex) {
                processLastException();
            }
        }, stack.incomplete ? 2000 : 0);
        throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
    doReport.subscribe = subscribe;
    doReport.unsubscribe = unsubscribe;
    doReport.traceKitWindowOnError = traceKitWindowOnError;
    return doReport;
})();
/**
 * computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   ```js
 *   s = computeStackTrace.ofCaller([depth])
 *   s = computeStackTrace(exception) // consider using report instead (see below)
 *   ```
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with report,
 * which builds on top of computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 * Tracing example:
 *  ```js
 *     function trace(message) {
 *         let stackInfo = computeStackTrace.ofCaller();
 *         let data = message + "\n";
 *         for(let i in stackInfo.stack) {
 *             let item = stackInfo.stack[i];
 *             data += (item.func || '[anonymous]') + "() in " + item.url + ":" + (item.line || '0') + "\n";
 *         }
 *         if (window.console)
 *             console.info(data);
 *         else
 *             alert(data);
 *     }
 * ```
 * @memberof TraceKit
 * @namespace
 */
var computeStackTrace = (function computeStackTraceWrapper() {
    var debug = false;
    // Contents of Exception in various browsers.
    //
    // SAFARI:
    // ex.message = Can't find variable: qq
    // ex.line = 59
    // ex.sourceId = 580238192
    // ex.sourceURL = http://...
    // ex.expressionBeginOffset = 96
    // ex.expressionCaretOffset = 98
    // ex.expressionEndOffset = 98
    // ex.name = ReferenceError
    //
    // FIREFOX:
    // ex.message = qq is not defined
    // ex.fileName = http://...
    // ex.lineNumber = 59
    // ex.columnNumber = 69
    // ex.stack = ...stack trace... (see the example below)
    // ex.name = ReferenceError
    //
    // CHROME:
    // ex.message = qq is not defined
    // ex.name = ReferenceError
    // ex.type = not_defined
    // ex.arguments = ['aa']
    // ex.stack = ...stack trace...
    //
    // INTERNET EXPLORER:
    // ex.message = ...
    // ex.name = ReferenceError
    //
    // OPERA:
    // ex.message = ...message... (see the example below)
    // ex.name = ReferenceError
    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
    /**
     * Computes stack trace information from the stack property.
     * Chrome and Gecko use this property.
     * @param {Error} ex
     * @return {?StackTrace} Stack trace information.
     * @memberof computeStackTrace
     */
    function computeStackTraceFromStackProp(ex) {
        if (!ex.stack) {
            return;
        }
        // tslint:disable-next-line max-line-length
        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
        // tslint:disable-next-line max-line-length
        var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i;
        // tslint:disable-next-line max-line-length
        var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
        // Used to additionally parse URL/line/column from eval frames
        var isEval;
        var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
        var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
        var lines = ex.stack.split('\n');
        var stack = [];
        var submatch;
        var parts;
        var element;
        for (var i = 0, j = lines.length; i < j; i += 1) {
            if (chrome.exec(lines[i])) {
                parts = chrome.exec(lines[i]);
                var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
                isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
                submatch = chromeEval.exec(parts[2]);
                if (isEval && submatch) {
                    // throw out eval line/column and use top-most line/column number
                    parts[2] = submatch[1]; // url
                    parts[3] = submatch[2]; // line
                    parts[4] = submatch[3]; // column
                }
                element = {
                    args: isNative ? [parts[2]] : [],
                    column: parts[4] ? +parts[4] : undefined,
                    func: parts[1] || UNKNOWN_FUNCTION,
                    line: parts[3] ? +parts[3] : undefined,
                    url: !isNative ? parts[2] : undefined,
                };
            }
            else if (winjs.exec(lines[i])) {
                parts = winjs.exec(lines[i]);
                element = {
                    args: [],
                    column: parts[4] ? +parts[4] : undefined,
                    func: parts[1] || UNKNOWN_FUNCTION,
                    line: +parts[3],
                    url: parts[2],
                };
            }
            else if (gecko.exec(lines[i])) {
                parts = gecko.exec(lines[i]);
                isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
                submatch = geckoEval.exec(parts[3]);
                if (isEval && submatch) {
                    // throw out eval line/column and use top-most line number
                    parts[3] = submatch[1];
                    parts[4] = submatch[2];
                    parts[5] = undefined; // no column when eval
                }
                else if (i === 0 && !parts[5] && !isUndefined(ex.columnNumber)) {
                    // FireFox uses this awesome columnNumber property for its top frame
                    // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                    // so adding 1
                    // NOTE: this hack doesn't work if top-most frame is eval
                    stack[0].column = ex.columnNumber + 1;
                }
                element = {
                    args: parts[2] ? parts[2].split(',') : [],
                    column: parts[5] ? +parts[5] : undefined,
                    func: parts[1] || UNKNOWN_FUNCTION,
                    line: parts[4] ? +parts[4] : undefined,
                    url: parts[3],
                };
            }
            else {
                continue;
            }
            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }
            stack.push(element);
        }
        if (!stack.length) {
            return;
        }
        return {
            stack: stack,
            message: ex.message,
            name: ex.name,
        };
    }
    /**
     * Computes stack trace information from the stacktrace property.
     * Opera 10+ uses this property.
     * @param {Error} ex
     * @return {?StackTrace} Stack trace information.
     * @memberof computeStackTrace
     */
    function computeStackTraceFromStacktraceProp(ex) {
        // Access and store the stacktrace property before doing ANYTHING
        // else to it because Opera is not very good at providing it
        // reliably in other circumstances.
        var stacktrace = ex.stacktrace;
        if (!stacktrace) {
            return;
        }
        var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
        // tslint:disable-next-line max-line-length
        var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i;
        var lines = stacktrace.split('\n');
        var stack = [];
        var parts;
        for (var line = 0; line < lines.length; line += 2) {
            var element = void 0;
            if (opera10Regex.exec(lines[line])) {
                parts = opera10Regex.exec(lines[line]);
                element = {
                    args: [],
                    column: undefined,
                    func: parts[3],
                    line: +parts[1],
                    url: parts[2],
                };
            }
            else if (opera11Regex.exec(lines[line])) {
                parts = opera11Regex.exec(lines[line]);
                element = {
                    args: parts[5] ? parts[5].split(',') : [],
                    column: +parts[2],
                    func: parts[3] || parts[4],
                    line: +parts[1],
                    url: parts[6],
                };
            }
            if (element) {
                if (!element.func && element.line) {
                    element.func = UNKNOWN_FUNCTION;
                }
                element.context = [lines[line + 1]];
                stack.push(element);
            }
        }
        if (!stack.length) {
            return;
        }
        return {
            stack: stack,
            message: ex.message,
            name: ex.name,
        };
    }
    /**
     * NOT TESTED.
     * Computes stack trace information from an error message that includes
     * the stack trace.
     * Opera 9 and earlier use this method if the option to show stack
     * traces is turned on in opera:config.
     * @param {Error} ex
     * @return {?StackTrace} Stack information.
     * @memberof computeStackTrace
     */
    function computeStackTraceFromOperaMultiLineMessage(ex) {
        // TODO: Clean this function up
        // Opera includes a stack trace into the exception message. An example is:
        //
        // Statement on line 3: Undefined variable: undefinedFunc
        // Backtrace:
        //   Line 3 of linked script file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.js:
        //   In function zzz
        //         undefinedFunc(a);
        //   Line 7 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html:
        //   In function yyy
        //           zzz(x, y, z);
        //   Line 3 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html:
        //   In function xxx
        //           yyy(a, a, a);
        //   Line 1 of function script
        //     try { xxx('hi'); return false; } catch(ex) { report(ex); }
        //   ...
        var lines = ex.message.split('\n');
        if (lines.length < 4) {
            return;
        }
        var lineRE1 = /^\s*Line (\d+) of linked script ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i;
        var lineRE2 = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i;
        var lineRE3 = /^\s*Line (\d+) of function script\s*$/i;
        var stack = [];
        var scripts = window && window.document && window.document.getElementsByTagName('script');
        var inlineScriptBlocks = [];
        var parts;
        for (var s in scripts) {
            if (has(scripts, s) && !scripts[s].src) {
                inlineScriptBlocks.push(scripts[s]);
            }
        }
        for (var line = 2; line < lines.length; line += 2) {
            var item = void 0;
            if (lineRE1.exec(lines[line])) {
                parts = lineRE1.exec(lines[line]);
                item = {
                    args: [],
                    column: undefined,
                    func: parts[3],
                    line: +parts[1],
                    url: parts[2],
                };
            }
            else if (lineRE2.exec(lines[line])) {
                parts = lineRE2.exec(lines[line]);
                item = {
                    args: [],
                    column: undefined,
                    func: parts[4],
                    line: +parts[1],
                    url: parts[3],
                };
            }
            else if (lineRE3.exec(lines[line])) {
                parts = lineRE3.exec(lines[line]);
                var url = window.location.href.replace(/#.*$/, '');
                item = {
                    url: url,
                    args: [],
                    column: undefined,
                    func: '',
                    line: +parts[1],
                };
            }
            if (item) {
                if (!item.func) {
                    item.func = UNKNOWN_FUNCTION;
                }
                item.context = [lines[line + 1]];
                stack.push(item);
            }
        }
        if (!stack.length) {
            return; // could not parse multiline exception message as Opera stack trace
        }
        return {
            stack: stack,
            message: lines[0],
            name: ex.name,
        };
    }
    /**
     * Adds information about the first frame to incomplete stack traces.
     * Safari and IE require this to get complete data on the first frame.
     * @param {StackTrace} stackInfo Stack trace information from
     * one of the compute* methods.
     * @param {string=} url The URL of the script that caused an error.
     * @param {(number|string)=} lineNo The line number of the script that
     * caused an error.
     * @param {string=} message The error generated by the browser, which
     * hopefully contains the name of the object that caused the error.
     * @return {boolean} Whether or not the stack information was
     * augmented.
     * @memberof computeStackTrace
     */
    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
        var initial = {
            url: url,
            line: lineNo ? +lineNo : undefined,
        };
        if (initial.url && initial.line) {
            stackInfo.incomplete = false;
            var stack = stackInfo.stack;
            if (stack.length > 0) {
                if (stack[0].url === initial.url) {
                    if (stack[0].line === initial.line) {
                        return false; // already in stack trace
                    }
                    if (!stack[0].line && stack[0].func === initial.func) {
                        stack[0].line = initial.line;
                        stack[0].context = initial.context;
                        return false;
                    }
                }
            }
            stack.unshift(initial);
            stackInfo.partial = true;
            return true;
        }
        stackInfo.incomplete = true;
        return false;
    }
    /**
     * Computes stack trace information by walking the arguments.caller
     * chain at the time the exception occurred. This will cause earlier
     * frames to be missed but is the only way to get any stack trace in
     * Safari and IE. The top frame is restored by
     * {@link augmentStackTraceWithInitialElement}.
     * @param {Error} ex
     * @param {number} depth
     * @return {StackTrace} Stack trace information.
     * @memberof computeStackTrace
     */
    function computeStackTraceByWalkingCallerChain(ex, depth) {
        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i;
        var stack = [];
        var funcs = {};
        var recursion = false;
        var parts;
        var item;
        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
            if (curr === computeStackTrace || curr === tracekit_report) {
                continue;
            }
            item = {
                args: [],
                column: undefined,
                func: UNKNOWN_FUNCTION,
                line: undefined,
                url: undefined,
            };
            parts = functionName.exec(curr.toString());
            if (curr.name) {
                item.func = curr.name;
            }
            else if (parts) {
                item.func = parts[1];
            }
            if (typeof item.func === 'undefined') {
                item.func = parts ? parts.input.substring(0, parts.input.indexOf('{')) : undefined;
            }
            if (funcs["" + curr]) {
                recursion = true;
            }
            else {
                funcs["" + curr] = true;
            }
            stack.push(item);
        }
        if (depth) {
            stack.splice(0, depth);
        }
        var result = {
            stack: stack,
            message: ex.message,
            name: ex.name,
        };
        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
        return result;
    }
    /**
     * Computes a stack trace for an exception.
     * @param {Error} ex
     * @param {(string|number)=} depth
     * @memberof computeStackTrace
     */
    function doComputeStackTrace(ex, depth) {
        var stack;
        var normalizedDepth = depth === undefined ? 0 : +depth;
        try {
            // This must be tried first because Opera 10 *destroys*
            // its stacktrace property if you try to access the stack
            // property first!!
            stack = computeStackTraceFromStacktraceProp(ex);
            if (stack) {
                return stack;
            }
        }
        catch (e) {
            if (debug) {
                throw e;
            }
        }
        try {
            stack = computeStackTraceFromStackProp(ex);
            if (stack) {
                return stack;
            }
        }
        catch (e) {
            if (debug) {
                throw e;
            }
        }
        try {
            stack = computeStackTraceFromOperaMultiLineMessage(ex);
            if (stack) {
                return stack;
            }
        }
        catch (e) {
            if (debug) {
                throw e;
            }
        }
        try {
            stack = computeStackTraceByWalkingCallerChain(ex, normalizedDepth + 1);
            if (stack) {
                return stack;
            }
        }
        catch (e) {
            if (debug) {
                throw e;
            }
        }
        return {
            message: ex.message,
            name: ex.name,
            stack: [],
        };
    }
    /**
     * Logs a stacktrace starting from the previous call and working down.
     * @param {(number|string)=} depth How many frames deep to trace.
     * @return {StackTrace} Stack trace information.
     * @memberof computeStackTrace
     */
    function computeStackTraceOfCaller(depth) {
        var currentDepth = (depth === undefined ? 0 : +depth) + 1; // "+ 1" because "ofCaller" should drop one frame
        try {
            throw new Error();
        }
        catch (ex) {
            return computeStackTrace(ex, currentDepth + 1);
        }
    }
    doComputeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
    doComputeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
    doComputeStackTrace.ofCaller = computeStackTraceOfCaller;
    return doComputeStackTrace;
})();
/**
 * Extends support for global error handling for asynchronous browser
 * functions. Adopted from Closure Library's errorhandler.js
 * @memberof TraceKit
 */
function extendToAsynchronousCallbacks() {
    function helper(fnName) {
        var originalFn = window[fnName];
        window[fnName] = function traceKitAsyncExtension() {
            // Make a copy of the arguments
            var args = [].slice.call(arguments);
            var originalCallback = args[0];
            if (typeof originalCallback === 'function') {
                args[0] = wrap(originalCallback);
            }
            // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
            // also only supports 2 argument and doesn't care what "this" is, so we
            // can just call the original function directly.
            if (originalFn.apply) {
                return originalFn.apply(this, args);
            }
            return originalFn(args[0], args[1]);
        };
    }
    helper('setTimeout');
    helper('setInterval');
}
//# sourceMappingURL=tracekit.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/internalMonitoring.js

// tslint:disable ban-types





var StatusType;
(function (StatusType) {
    StatusType["info"] = "info";
    StatusType["error"] = "error";
})(StatusType || (StatusType = {}));
var monitoringConfiguration = { maxMessagesPerPage: 0, sentMessageCount: 0 };
var externalContextProvider;
function startInternalMonitoring(configuration) {
    if (configuration.internalMonitoringEndpoint) {
        var batch = startMonitoringBatch(configuration);
        utils_assign(monitoringConfiguration, {
            batch: batch,
            maxMessagesPerPage: configuration.maxInternalMonitoringMessagesPerPage,
            sentMessageCount: 0,
        });
    }
    return {
        setExternalContextProvider: function (provider) {
            externalContextProvider = provider;
        },
    };
}
function startMonitoringBatch(configuration) {
    var primaryBatch = createMonitoringBatch(configuration.internalMonitoringEndpoint);
    var replicaBatch;
    if (configuration.replica !== undefined) {
        replicaBatch = createMonitoringBatch(configuration.replica.internalMonitoringEndpoint);
    }
    function createMonitoringBatch(endpointUrl) {
        return new Batch(new HttpRequest(endpointUrl, configuration.batchBytesLimit), configuration.maxBatchSize, configuration.batchBytesLimit, configuration.maxMessageSize, configuration.flushTimeout);
    }
    function withContext(message) {
        return combine({
            date: new Date().getTime(),
            view: {
                referrer: document.referrer,
                url: window.location.href,
            },
        }, externalContextProvider !== undefined ? externalContextProvider() : {}, message);
    }
    return {
        add: function (message) {
            var contextualizedMessage = withContext(message);
            primaryBatch.add(contextualizedMessage);
            if (replicaBatch) {
                replicaBatch.add(contextualizedMessage);
            }
        },
    };
}
function resetInternalMonitoring() {
    monitoringConfiguration.batch = undefined;
}
function monitored(_, __, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function () {
        var decorated = (monitoringConfiguration.batch ? monitor(originalMethod) : originalMethod);
        return decorated.apply(this, arguments);
    };
}
function monitor(fn) {
    return function () {
        try {
            return fn.apply(this, arguments);
        }
        catch (e) {
            logErrorIfDebug(e);
            try {
                addErrorToMonitoringBatch(e);
            }
            catch (e) {
                logErrorIfDebug(e);
            }
        }
    }; // consider output type has input type
}
function addMonitoringMessage(message, context) {
    logMessageIfDebug(message);
    addToMonitoringBatch(__assign(__assign({ message: message }, context), { status: StatusType.info }));
}
function addErrorToMonitoringBatch(e) {
    addToMonitoringBatch(tslib_es6_assign(tslib_es6_assign({}, formatError(e)), { status: StatusType.error }));
}
function addToMonitoringBatch(message) {
    if (monitoringConfiguration.batch &&
        monitoringConfiguration.sentMessageCount < monitoringConfiguration.maxMessagesPerPage) {
        monitoringConfiguration.sentMessageCount += 1;
        monitoringConfiguration.batch.add(message);
    }
}
function formatError(e) {
    if (e instanceof Error) {
        var stackTrace = computeStackTrace(e);
        return {
            error: {
                kind: stackTrace.name,
                stack: toStackTraceString(stackTrace),
            },
            message: stackTrace.message,
        };
    }
    return {
        error: {
            stack: 'Not an instance of error',
        },
        message: "Uncaught " + jsonStringify(e),
    };
}
function setDebugMode(debugMode) {
    monitoringConfiguration.debugMode = debugMode;
}
function logErrorIfDebug(e) {
    if (monitoringConfiguration.debugMode) {
        // Log as warn to not forward the logs.
        console.warn('[INTERNAL ERROR]', e);
    }
}
function logMessageIfDebug(message) {
    if (monitoringConfiguration.debugMode) {
        console.log('[MONITORING MESSAGE]', message);
    }
}
//# sourceMappingURL=internalMonitoring.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/utils.js

var ONE_SECOND = 1000;
var ONE_MINUTE = 60 * ONE_SECOND;
var ONE_HOUR = 60 * ONE_MINUTE;
var ONE_KILO_BYTE = 1024;
var DOM_EVENT;
(function (DOM_EVENT) {
    DOM_EVENT["BEFORE_UNLOAD"] = "beforeunload";
    DOM_EVENT["CLICK"] = "click";
    DOM_EVENT["KEY_DOWN"] = "keydown";
    DOM_EVENT["LOAD"] = "load";
    DOM_EVENT["POP_STATE"] = "popstate";
    DOM_EVENT["SCROLL"] = "scroll";
    DOM_EVENT["TOUCH_START"] = "touchstart";
    DOM_EVENT["VISIBILITY_CHANGE"] = "visibilitychange";
    DOM_EVENT["DOM_CONTENT_LOADED"] = "DOMContentLoaded";
    DOM_EVENT["POINTER_DOWN"] = "pointerdown";
    DOM_EVENT["POINTER_UP"] = "pointerup";
    DOM_EVENT["POINTER_CANCEL"] = "pointercancel";
    DOM_EVENT["HASH_CHANGE"] = "hashchange";
    DOM_EVENT["PAGE_HIDE"] = "pagehide";
    DOM_EVENT["MOUSE_DOWN"] = "mousedown";
})(DOM_EVENT || (DOM_EVENT = {}));
var ResourceType;
(function (ResourceType) {
    ResourceType["DOCUMENT"] = "document";
    ResourceType["XHR"] = "xhr";
    ResourceType["BEACON"] = "beacon";
    ResourceType["FETCH"] = "fetch";
    ResourceType["CSS"] = "css";
    ResourceType["JS"] = "js";
    ResourceType["IMAGE"] = "image";
    ResourceType["FONT"] = "font";
    ResourceType["MEDIA"] = "media";
    ResourceType["OTHER"] = "other";
})(ResourceType || (ResourceType = {}));
var RequestType;
(function (RequestType) {
    RequestType["FETCH"] = "fetch";
    RequestType["XHR"] = "xhr";
})(RequestType || (RequestType = {}));
// use lodash API
function throttle(fn, wait, options) {
    var needLeadingExecution = options && options.leading !== undefined ? options.leading : true;
    var needTrailingExecution = options && options.trailing !== undefined ? options.trailing : true;
    var inWaitPeriod = false;
    var hasPendingExecution = false;
    var pendingTimeoutId;
    return {
        throttled: function () {
            var _this = this;
            if (inWaitPeriod) {
                hasPendingExecution = true;
                return;
            }
            if (needLeadingExecution) {
                fn.apply(this);
            }
            else {
                hasPendingExecution = true;
            }
            inWaitPeriod = true;
            pendingTimeoutId = window.setTimeout(function () {
                if (needTrailingExecution && hasPendingExecution) {
                    fn.apply(_this);
                }
                inWaitPeriod = false;
                hasPendingExecution = false;
            }, wait);
        },
        cancel: function () {
            window.clearTimeout(pendingTimeoutId);
            inWaitPeriod = false;
            hasPendingExecution = false;
        },
    };
}
function utils_assign(target) {
    var toAssign = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        toAssign[_i - 1] = arguments[_i];
    }
    toAssign.forEach(function (source) {
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    });
}
/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
function generateUUID(placeholder) {
    return placeholder
        ? // tslint:disable-next-line no-bitwise
            (parseInt(placeholder, 10) ^ ((Math.random() * 16) >> (parseInt(placeholder, 10) / 4))).toString(16)
        : (1e7 + "-" + 1e3 + "-" + 4e3 + "-" + 8e3 + "-" + 1e11).replace(/[018]/g, generateUUID);
}
/**
 * Return true if the draw is successful
 * @param threshold between 0 and 100
 */
function performDraw(threshold) {
    return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
    return +num.toFixed(decimals);
}
function msToNs(duration) {
    if (typeof duration !== 'number') {
        return duration;
    }
    return round(duration * 1e6, 0);
}
// tslint:disable-next-line:no-empty
function noop() { }
/**
 * Custom implementation of JSON.stringify that ignores value.toJSON.
 * We need to do that because some sites badly override toJSON on certain objects.
 * Note this still supposes that JSON.stringify is correct...
 */
function jsonStringify(value, replacer, space) {
    if (value === null || value === undefined) {
        return JSON.stringify(value);
    }
    var originalToJSON = [false, undefined];
    if (hasToJSON(value)) {
        // We need to add a flag and not rely on the truthiness of value.toJSON
        // because it can be set but undefined and that's actually significant.
        originalToJSON = [true, value.toJSON];
        delete value.toJSON;
    }
    var originalProtoToJSON = [false, undefined];
    var prototype;
    if (typeof value === 'object') {
        prototype = Object.getPrototypeOf(value);
        if (hasToJSON(prototype)) {
            originalProtoToJSON = [true, prototype.toJSON];
            delete prototype.toJSON;
        }
    }
    var result;
    try {
        result = JSON.stringify(value, undefined, space);
    }
    catch (_a) {
        result = '<error: unable to serialize object>';
    }
    finally {
        if (originalToJSON[0]) {
            ;
            value.toJSON = originalToJSON[1];
        }
        if (originalProtoToJSON[0]) {
            ;
            prototype.toJSON = originalProtoToJSON[1];
        }
    }
    return result;
}
function hasToJSON(value) {
    return typeof value === 'object' && value !== null && value.hasOwnProperty('toJSON');
}
function includes(candidate, search) {
    // tslint:disable-next-line: no-unsafe-any
    return candidate.indexOf(search) !== -1;
}
function find(array, predicate) {
    for (var i = 0; i < array.length; i += 1) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
    return undefined;
}
function isPercentage(value) {
    return isNumber(value) && value >= 0 && value <= 100;
}
function isNumber(value) {
    return typeof value === 'number';
}
/**
 * Get the time since the navigation was started.
 *
 * Note: this does not use `performance.timeOrigin` because it doesn't seem to reflect the actual
 * time on which the navigation has started: it may be much farther in the past, at least in Firefox 71.
 * Related issue in Firefox: https://bugzilla.mozilla.org/show_bug.cgi?id=1429926
 */
function getRelativeTime(timestamp) {
    return timestamp - getNavigationStart();
}
function getTimestamp(relativeTime) {
    return Math.floor(getNavigationStart() + relativeTime);
}
/**
 * Navigation start slightly change on some rare cases
 */
var navigationStart;
function getNavigationStart() {
    if (navigationStart === undefined) {
        navigationStart = performance.timing.navigationStart;
    }
    return navigationStart;
}
function objectValues(object) {
    var values = [];
    Object.keys(object).forEach(function (key) {
        values.push(object[key]);
    });
    return values;
}
function objectEntries(object) {
    return Object.keys(object).map(function (key) { return [key, object[key]]; });
}
function isEmptyObject(object) {
    return Object.keys(object).length === 0;
}
/**
 * inspired by https://mathiasbynens.be/notes/globalthis
 */
function getGlobalObject() {
    if (typeof globalThis === 'object') {
        return globalThis;
    }
    Object.defineProperty(Object.prototype, '_dd_temp_', {
        get: function () {
            return this;
        },
        configurable: true,
    });
    // @ts-ignore
    var globalObject = _dd_temp_;
    // @ts-ignore
    delete Object.prototype._dd_temp_;
    if (typeof globalObject !== 'object') {
        // on safari _dd_temp_ is available on window but not globally
        // fallback on other browser globals check
        if (typeof self === 'object') {
            globalObject = self;
        }
        else if (typeof window === 'object') {
            globalObject = window;
        }
        else {
            globalObject = {};
        }
    }
    return globalObject;
}
function getLocationOrigin() {
    return utils_getLinkElementOrigin(window.location);
}
/**
 * IE fallback
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/origin
 */
function utils_getLinkElementOrigin(element) {
    if (element.origin) {
        return element.origin;
    }
    var sanitizedHost = element.host.replace(/(:80|:443)$/, '');
    return element.protocol + "//" + sanitizedHost;
}
function findCommaSeparatedValue(rawString, name) {
    var matches = rawString.match("(?:^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return matches ? matches[1] : undefined;
}
function safeTruncate(candidate, length) {
    var lastChar = candidate.charCodeAt(length - 1);
    // check if it is the high part of a surrogate pair
    if (lastChar >= 0xd800 && lastChar <= 0xdbff) {
        return candidate.slice(0, length + 1);
    }
    return candidate.slice(0, length);
}
/**
 * Add an event listener to an event emitter object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by:
 *   * using an option object only if needed
 *   * emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 */
function addEventListener(emitter, event, listener, options) {
    return addEventListeners(emitter, [event], listener, options);
}
/**
 * Add event listeners to an event emitter object (Window, Element, mock object...).  This provides
 * a few conveniences compared to using `element.addEventListener` directly:
 *
 * * supports IE11 by:
 *   * using an option object only if needed
 *   * emulating the `once` option
 *
 * * wraps the listener with a `monitor` function
 *
 * * returns a `stop` function to remove the listener
 *
 * * with `once: true`, the listener will be called at most once, even if different events are
 *   listened
 */
function addEventListeners(emitter, events, listener, _a) {
    var _b = _a === void 0 ? {} : _a, once = _b.once, capture = _b.capture, passive = _b.passive;
    var wrapedListener = monitor(once
        ? function (event) {
            stop();
            listener(event);
        }
        : listener);
    var options = passive ? { capture: capture, passive: passive } : capture;
    events.forEach(function (event) { return emitter.addEventListener(event, wrapedListener, options); });
    var stop = function () { return events.forEach(function (event) { return emitter.removeEventListener(event, wrapedListener, options); }); };
    return {
        stop: stop,
    };
}
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/error.js

var ErrorSource;
(function (ErrorSource) {
    ErrorSource["AGENT"] = "agent";
    ErrorSource["CONSOLE"] = "console";
    ErrorSource["NETWORK"] = "network";
    ErrorSource["SOURCE"] = "source";
    ErrorSource["LOGGER"] = "logger";
    ErrorSource["CUSTOM"] = "custom";
})(ErrorSource || (ErrorSource = {}));
function formatUnknownError(stackTrace, errorObject, nonErrorPrefix) {
    if (!stackTrace || (stackTrace.message === undefined && !(errorObject instanceof Error))) {
        return {
            message: nonErrorPrefix + " " + jsonStringify(errorObject),
            stack: 'No stack, consider using an instance of Error',
            type: stackTrace && stackTrace.name,
        };
    }
    return {
        message: stackTrace.message || 'Empty message',
        stack: toStackTraceString(stackTrace),
        type: stackTrace.name,
    };
}
function toStackTraceString(stack) {
    var result = (stack.name || 'Error') + ": " + stack.message;
    stack.stack.forEach(function (frame) {
        var func = frame.func === '?' ? '<anonymous>' : frame.func;
        var args = frame.args && frame.args.length > 0 ? "(" + frame.args.join(', ') + ")" : '';
        var line = frame.line ? ":" + frame.line : '';
        var column = frame.line && frame.column ? ":" + frame.column : '';
        result += "\n  at " + func + args + " @ " + frame.url + line + column;
    });
    return result;
}
//# sourceMappingURL=error.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/logger.js
var _a;


var logger_StatusType;
(function (StatusType) {
    StatusType["debug"] = "debug";
    StatusType["info"] = "info";
    StatusType["warn"] = "warn";
    StatusType["error"] = "error";
})(logger_StatusType || (logger_StatusType = {}));
var STATUS_PRIORITIES = (_a = {},
    _a[logger_StatusType.debug] = 0,
    _a[logger_StatusType.info] = 1,
    _a[logger_StatusType.warn] = 2,
    _a[logger_StatusType.error] = 3,
    _a);
var STATUSES = Object.keys(logger_StatusType);
var HandlerType;
(function (HandlerType) {
    HandlerType["http"] = "http";
    HandlerType["console"] = "console";
    HandlerType["silent"] = "silent";
})(HandlerType || (HandlerType = {}));
var Logger = /** @class */ (function () {
    function Logger(sendLog, handlerType, level, loggerContext) {
        if (handlerType === void 0) { handlerType = HandlerType.http; }
        if (level === void 0) { level = logger_StatusType.debug; }
        if (loggerContext === void 0) { loggerContext = {}; }
        this.sendLog = sendLog;
        this.handlerType = handlerType;
        this.level = level;
        this.contextManager = createContextManager();
        this.contextManager.set(loggerContext);
    }
    Logger.prototype.log = function (message, messageContext, status) {
        if (status === void 0) { status = logger_StatusType.info; }
        if (STATUS_PRIORITIES[status] >= STATUS_PRIORITIES[this.level]) {
            switch (this.handlerType) {
                case HandlerType.http:
                    this.sendLog(tslib_es6_assign({ message: message,
                        status: status }, combine(this.contextManager.get(), messageContext)));
                    break;
                case HandlerType.console:
                    console.log(status + ": " + message, combine(this.contextManager.get(), messageContext));
                    break;
                case HandlerType.silent:
                    break;
            }
        }
    };
    Logger.prototype.debug = function (message, messageContext) {
        this.log(message, messageContext, logger_StatusType.debug);
    };
    Logger.prototype.info = function (message, messageContext) {
        this.log(message, messageContext, logger_StatusType.info);
    };
    Logger.prototype.warn = function (message, messageContext) {
        this.log(message, messageContext, logger_StatusType.warn);
    };
    Logger.prototype.error = function (message, messageContext) {
        var errorOrigin = {
            error: {
                origin: ErrorSource.LOGGER,
            },
        };
        this.log(message, combine(errorOrigin, messageContext), logger_StatusType.error);
    };
    Logger.prototype.setContext = function (context) {
        this.contextManager.set(context);
    };
    Logger.prototype.addContext = function (key, value) {
        this.contextManager.add(key, value);
    };
    Logger.prototype.removeContext = function (key) {
        this.contextManager.remove(key);
    };
    Logger.prototype.setHandler = function (handler) {
        this.handlerType = handler;
    };
    Logger.prototype.setLevel = function (level) {
        this.level = level;
    };
    __decorate([
        monitored
    ], Logger.prototype, "log", null);
    return Logger;
}());

//# sourceMappingURL=logger.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/browser/cookie.js

var COOKIE_ACCESS_DELAY = ONE_SECOND;
function cacheCookieAccess(name, options) {
    var timeout;
    var cache;
    var hasCache = false;
    var cacheAccess = function () {
        hasCache = true;
        window.clearTimeout(timeout);
        timeout = window.setTimeout(function () {
            hasCache = false;
        }, COOKIE_ACCESS_DELAY);
    };
    return {
        get: function () {
            if (hasCache) {
                return cache;
            }
            cache = getCookie(name);
            cacheAccess();
            return cache;
        },
        set: function (value, expireDelay) {
            setCookie(name, value, expireDelay, options);
            cache = value;
            cacheAccess();
        },
    };
}
function setCookie(name, value, expireDelay, options) {
    var date = new Date();
    date.setTime(date.getTime() + expireDelay);
    var expires = "expires=" + date.toUTCString();
    var sameSite = options && options.crossSite ? 'none' : 'strict';
    var domain = options && options.domain ? ";domain=" + options.domain : '';
    var secure = options && options.secure ? ";secure" : '';
    document.cookie = name + "=" + value + ";" + expires + ";path=/;samesite=" + sameSite + domain + secure;
}
function getCookie(name) {
    return findCommaSeparatedValue(document.cookie, name);
}
function cookie_areCookiesAuthorized(options) {
    if (document.cookie === undefined || document.cookie === null) {
        return false;
    }
    try {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_cookie_test_" + generateUUID();
        var testCookieValue = 'test';
        setCookie(testCookieName, testCookieValue, ONE_SECOND, options);
        return getCookie(testCookieName) === testCookieValue;
    }
    catch (error) {
        console.error(error);
        return false;
    }
}
/**
 * No API to retrieve it, number of levels for subdomain and suffix are unknown
 * strategy: find the minimal domain on which cookies are allowed to be set
 * https://web.dev/same-site-same-origin/#site
 */
var getCurrentSiteCache;
function getCurrentSite() {
    if (getCurrentSiteCache === undefined) {
        // Use a unique cookie name to avoid issues when the SDK is initialized multiple times during
        // the test cookie lifetime
        var testCookieName = "dd_site_test_" + generateUUID();
        var testCookieValue = 'test';
        var domainLevels = window.location.hostname.split('.');
        var candidateDomain = domainLevels.pop();
        while (domainLevels.length && !getCookie(testCookieName)) {
            candidateDomain = domainLevels.pop() + "." + candidateDomain;
            setCookie(testCookieName, testCookieValue, ONE_SECOND, { domain: candidateDomain });
        }
        getCurrentSiteCache = candidateDomain;
    }
    return getCurrentSiteCache;
}
//# sourceMappingURL=cookie.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/configuration.js




var DEFAULT_CONFIGURATION = {
    allowedTracingOrigins: [],
    maxErrorsByMinute: 3000,
    maxInternalMonitoringMessagesPerPage: 15,
    resourceSampleRate: 100,
    sampleRate: 100,
    silentMultipleInit: false,
    trackInteractions: false,
    /**
     * arbitrary value, byte precision not needed
     */
    requestErrorResponseLengthLimit: 32 * ONE_KILO_BYTE,
    /**
     * flush automatically, aim to be lower than ALB connection timeout
     * to maximize connection reuse.
     */
    flushTimeout: 30 * ONE_SECOND,
    /**
     * Logs intake limit
     */
    maxBatchSize: 50,
    maxMessageSize: 256 * ONE_KILO_BYTE,
    /**
     * beacon payload max queue size implementation is 64kb
     * ensure that we leave room for logs, rum and potential other users
     */
    batchBytesLimit: 16 * ONE_KILO_BYTE,
};
var ENDPOINTS = {
    alternate: {
        logs: 'logs',
        rum: 'rum',
        trace: 'trace',
    },
    classic: {
        logs: 'browser',
        rum: 'rum',
        trace: 'public-trace',
    },
};
function buildConfiguration(userConfiguration, buildEnv) {
    var transportConfiguration = {
        applicationId: userConfiguration.applicationId,
        buildMode: buildEnv.buildMode,
        clientToken: userConfiguration.clientToken,
        env: userConfiguration.env,
        proxyHost: userConfiguration.proxyHost,
        sdkVersion: buildEnv.sdkVersion,
        service: userConfiguration.service,
        site: userConfiguration.site || INTAKE_SITE[userConfiguration.datacenter || buildEnv.datacenter],
        version: userConfiguration.version,
    };
    var enableExperimentalFeatures = Array.isArray(userConfiguration.enableExperimentalFeatures)
        ? userConfiguration.enableExperimentalFeatures
        : [];
    var intakeType = userConfiguration.useAlternateIntakeDomains ? 'alternate' : 'classic';
    var intakeUrls = getIntakeUrls(intakeType, transportConfiguration, userConfiguration.replica !== undefined);
    var configuration = tslib_es6_assign({ cookieOptions: buildCookieOptions(userConfiguration), isEnabled: function (feature) {
            return includes(enableExperimentalFeatures, feature);
        }, logsEndpoint: getEndpoint(intakeType, 'logs', transportConfiguration), proxyHost: userConfiguration.proxyHost, rumEndpoint: getEndpoint(intakeType, 'rum', transportConfiguration), service: userConfiguration.service, traceEndpoint: getEndpoint(intakeType, 'trace', transportConfiguration), isIntakeUrl: function (url) { return intakeUrls.some(function (intakeUrl) { return url.indexOf(intakeUrl) === 0; }); } }, DEFAULT_CONFIGURATION);
    if (userConfiguration.internalMonitoringApiKey) {
        configuration.internalMonitoringEndpoint = getEndpoint(intakeType, 'logs', transportConfiguration, 'browser-agent-internal-monitoring');
    }
    if ('allowedTracingOrigins' in userConfiguration) {
        configuration.allowedTracingOrigins = userConfiguration.allowedTracingOrigins;
    }
    if ('sampleRate' in userConfiguration) {
        configuration.sampleRate = userConfiguration.sampleRate;
    }
    if ('resourceSampleRate' in userConfiguration) {
        configuration.resourceSampleRate = userConfiguration.resourceSampleRate;
    }
    if ('trackInteractions' in userConfiguration) {
        configuration.trackInteractions = !!userConfiguration.trackInteractions;
    }
    if (transportConfiguration.buildMode === BuildMode.E2E_TEST) {
        configuration.internalMonitoringEndpoint = '<<< E2E INTERNAL MONITORING ENDPOINT >>>';
        configuration.logsEndpoint = '<<< E2E LOGS ENDPOINT >>>';
        configuration.rumEndpoint = '<<< E2E RUM ENDPOINT >>>';
    }
    if (transportConfiguration.buildMode === BuildMode.STAGING) {
        if (userConfiguration.replica !== undefined) {
            var replicaTransportConfiguration = tslib_es6_assign(tslib_es6_assign({}, transportConfiguration), { applicationId: userConfiguration.replica.applicationId, clientToken: userConfiguration.replica.clientToken, site: INTAKE_SITE[Datacenter.US] });
            configuration.replica = {
                applicationId: userConfiguration.replica.applicationId,
                internalMonitoringEndpoint: getEndpoint(intakeType, 'logs', replicaTransportConfiguration, 'browser-agent-internal-monitoring'),
                logsEndpoint: getEndpoint(intakeType, 'logs', replicaTransportConfiguration),
                rumEndpoint: getEndpoint(intakeType, 'rum', replicaTransportConfiguration),
            };
        }
    }
    return configuration;
}
function buildCookieOptions(userConfiguration) {
    var cookieOptions = {};
    cookieOptions.secure = mustUseSecureCookie(userConfiguration);
    cookieOptions.crossSite = !!userConfiguration.useCrossSiteSessionCookie;
    if (!!userConfiguration.trackSessionAcrossSubdomains) {
        cookieOptions.domain = getCurrentSite();
    }
    return cookieOptions;
}
function getEndpoint(intakeType, endpointType, conf, source) {
    var tags = "sdk_version:" + conf.sdkVersion +
        ("" + (conf.env ? ",env:" + conf.env : '')) +
        ("" + (conf.service ? ",service:" + conf.service : '')) +
        ("" + (conf.version ? ",version:" + conf.version : ''));
    var datadogHost = getHost(intakeType, endpointType, conf.site);
    var host = conf.proxyHost ? conf.proxyHost : datadogHost;
    var proxyParameter = conf.proxyHost ? "ddhost=" + datadogHost + "&" : '';
    var applicationIdParameter = conf.applicationId ? "_dd.application_id=" + conf.applicationId + "&" : '';
    var parameters = "" + applicationIdParameter + proxyParameter + "ddsource=" + (source || 'browser') + "&ddtags=" + tags;
    return "https://" + host + "/v1/input/" + conf.clientToken + "?" + parameters;
}
function getHost(intakeType, endpointType, site) {
    var endpoint = ENDPOINTS[intakeType][endpointType];
    if (intakeType === 'classic') {
        return endpoint + "-http-intake.logs." + site;
    }
    var domainParts = site.split('.');
    var extension = domainParts.pop();
    var suffix = domainParts.join('-') + "." + extension;
    return endpoint + ".browser-intake-" + suffix;
}
function getIntakeUrls(intakeType, conf, withReplica) {
    if (conf.proxyHost) {
        return ["https://" + conf.proxyHost + "/v1/input/"];
    }
    var sites = [conf.site];
    if (conf.buildMode === BuildMode.STAGING && withReplica) {
        sites.push(INTAKE_SITE[Datacenter.US]);
    }
    var urls = [];
    var endpointTypes = Object.keys(ENDPOINTS[intakeType]);
    for (var _i = 0, sites_1 = sites; _i < sites_1.length; _i++) {
        var site = sites_1[_i];
        for (var _a = 0, endpointTypes_1 = endpointTypes; _a < endpointTypes_1.length; _a++) {
            var endpointType = endpointTypes_1[_a];
            urls.push("https://" + getHost(intakeType, endpointType, site) + "/v1/input/");
        }
    }
    return urls;
}
function mustUseSecureCookie(userConfiguration) {
    return !!userConfiguration.useSecureSessionCookie || !!userConfiguration.useCrossSiteSessionCookie;
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/boot/init.js
var init_a;




function makeGlobal(stub) {
    var global = tslib_es6_assign(tslib_es6_assign({}, stub), { 
        // This API method is intentionally not monitored, since the only thing executed is the
        // user-provided 'callback'.  All SDK usages executed in the callback should be monitored, and
        // we don't want to interfer with the user uncaught exceptions.
        onReady: function (callback) {
            callback();
        } });
    // Add an "hidden" property to set debug mode. We define it that way to hide it
    // as much as possible but of course it's not a real protection.
    Object.defineProperty(global, '_setDebug', {
        get: function () {
            return setDebugMode;
        },
        enumerable: false,
    });
    return global;
}
function defineGlobal(global, name, api) {
    var existingGlobalVariable = global[name];
    global[name] = api;
    if (existingGlobalVariable && existingGlobalVariable.q) {
        existingGlobalVariable.q.forEach(function (fn) { return fn(); });
    }
}
var Datacenter;
(function (Datacenter) {
    Datacenter["US"] = "us";
    Datacenter["EU"] = "eu";
})(Datacenter || (Datacenter = {}));
var INTAKE_SITE = (init_a = {},
    init_a[Datacenter.EU] = 'datadoghq.eu',
    init_a[Datacenter.US] = 'datadoghq.com',
    init_a);
var BuildMode;
(function (BuildMode) {
    BuildMode["RELEASE"] = "release";
    BuildMode["STAGING"] = "staging";
    BuildMode["E2E_TEST"] = "e2e-test";
})(BuildMode || (BuildMode = {}));
function commonInit(userConfiguration, buildEnv) {
    var configuration = buildConfiguration(userConfiguration, buildEnv);
    var internalMonitoring = startInternalMonitoring(configuration);
    return {
        configuration: configuration,
        internalMonitoring: internalMonitoring,
    };
}
function checkCookiesAuthorized(options) {
    if (!areCookiesAuthorized(options)) {
        console.warn('Cookies are not authorized, we will not send any data.');
        return false;
    }
    return true;
}
function checkIsNotLocalFile() {
    if (isLocalFile()) {
        console.error('Execution is not allowed in the current context.');
        return false;
    }
    return true;
}
function isLocalFile() {
    return window.location.protocol === 'file:';
}
//# sourceMappingURL=init.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js
var DEFAULT_LIMIT = 10000;
var BoundedBuffer = /** @class */ (function () {
    function BoundedBuffer(limit) {
        if (limit === void 0) { limit = DEFAULT_LIMIT; }
        this.limit = limit;
        this.buffer = [];
    }
    BoundedBuffer.prototype.add = function (item) {
        var length = this.buffer.push(item);
        if (length > this.limit) {
            this.buffer.splice(0, 1);
        }
    };
    BoundedBuffer.prototype.drain = function (fn) {
        this.buffer.forEach(function (item) { return fn(item); });
        this.buffer.length = 0;
    };
    return BoundedBuffer;
}());

//# sourceMappingURL=boundedBuffer.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/urlPolyfill.js

function normalizeUrl(url) {
    return buildUrl(url, getLocationOrigin()).href;
}
function isValidUrl(url) {
    try {
        return !!buildUrl(url);
    }
    catch (_a) {
        return false;
    }
}
function haveSameOrigin(url1, url2) {
    return getOrigin(url1) === getOrigin(url2);
}
function getOrigin(url) {
    return getLinkElementOrigin(buildUrl(url));
}
function getPathName(url) {
    var pathname = buildUrl(url).pathname;
    return pathname[0] === '/' ? pathname : "/" + pathname;
}
function getSearch(url) {
    return buildUrl(url).search;
}
function getHash(url) {
    return buildUrl(url).hash;
}
function buildUrl(url, base) {
    if (checkURLSupported()) {
        return base !== undefined ? new URL(url, base) : new URL(url);
    }
    if (base === undefined && !/:/.test(url)) {
        throw new Error("Invalid URL: '" + url + "'");
    }
    var doc = document;
    var anchorElement = doc.createElement('a');
    if (base !== undefined) {
        doc = document.implementation.createHTMLDocument('');
        var baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        doc.body.appendChild(anchorElement);
    }
    anchorElement.href = url;
    return anchorElement;
}
var isURLSupported;
function checkURLSupported() {
    if (isURLSupported !== undefined) {
        return isURLSupported;
    }
    try {
        var url = new URL('http://test/path');
        isURLSupported = url.href === 'http://test/path';
        return isURLSupported;
    }
    catch (_a) {
        isURLSupported = false;
    }
    return isURLSupported;
}
//# sourceMappingURL=urlPolyfill.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/browser/fetchProxy.js





var fetchProxySingleton;
var originalFetch;
var beforeSendCallbacks = [];
var onRequestCompleteCallbacks = [];
function startFetchProxy() {
    if (!fetchProxySingleton) {
        proxyFetch();
        fetchProxySingleton = {
            beforeSend: function (callback) {
                beforeSendCallbacks.push(callback);
            },
            onRequestComplete: function (callback) {
                onRequestCompleteCallbacks.push(callback);
            },
        };
    }
    return fetchProxySingleton;
}
function resetFetchProxy() {
    if (fetchProxySingleton) {
        fetchProxySingleton = undefined;
        beforeSendCallbacks.splice(0, beforeSendCallbacks.length);
        onRequestCompleteCallbacks.splice(0, onRequestCompleteCallbacks.length);
        window.fetch = originalFetch;
    }
}
function proxyFetch() {
    if (!window.fetch) {
        return;
    }
    originalFetch = window.fetch;
    // tslint:disable promise-function-async
    window.fetch = monitor(function (input, init) {
        var _this = this;
        var method = (init && init.method) || (typeof input === 'object' && input.method) || 'GET';
        var url = normalizeUrl((typeof input === 'object' && input.url) || input);
        var startTime = performance.now();
        var context = {
            init: init,
            method: method,
            startTime: startTime,
            url: url,
        };
        var reportFetch = function (response) { return __awaiter(_this, void 0, void 0, function () {
            var text, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        context.duration = performance.now() - context.startTime;
                        if (!('stack' in response || response instanceof Error)) return [3 /*break*/, 1];
                        context.status = 0;
                        context.response = toStackTraceString(computeStackTrace(response));
                        onRequestCompleteCallbacks.forEach(function (callback) { return callback(context); });
                        return [3 /*break*/, 6];
                    case 1:
                        if (!('status' in response)) return [3 /*break*/, 6];
                        text = void 0;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, response.clone().text()];
                    case 3:
                        text = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        text = "Unable to retrieve response: " + e_1;
                        return [3 /*break*/, 5];
                    case 5:
                        context.response = text;
                        context.responseType = response.type;
                        context.status = response.status;
                        onRequestCompleteCallbacks.forEach(function (callback) { return callback(context); });
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        beforeSendCallbacks.forEach(function (callback) { return callback(context); });
        var responsePromise = originalFetch.call(this, input, context.init);
        responsePromise.then(monitor(reportFetch), monitor(reportFetch));
        return responsePromise;
    });
}
//# sourceMappingURL=fetchProxy.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/browser/xhrProxy.js


var xhrProxySingleton;
var xhrProxy_beforeSendCallbacks = [];
var xhrProxy_onRequestCompleteCallbacks = [];
var originalXhrOpen;
var originalXhrSend;
function startXhrProxy() {
    if (!xhrProxySingleton) {
        proxyXhr();
        xhrProxySingleton = {
            beforeSend: function (callback) {
                xhrProxy_beforeSendCallbacks.push(callback);
            },
            onRequestComplete: function (callback) {
                xhrProxy_onRequestCompleteCallbacks.push(callback);
            },
        };
    }
    return xhrProxySingleton;
}
function resetXhrProxy() {
    if (xhrProxySingleton) {
        xhrProxySingleton = undefined;
        xhrProxy_beforeSendCallbacks.splice(0, xhrProxy_beforeSendCallbacks.length);
        xhrProxy_onRequestCompleteCallbacks.splice(0, xhrProxy_onRequestCompleteCallbacks.length);
        XMLHttpRequest.prototype.open = originalXhrOpen;
        XMLHttpRequest.prototype.send = originalXhrSend;
    }
}
function proxyXhr() {
    originalXhrOpen = XMLHttpRequest.prototype.open;
    originalXhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = monitor(function (method, url) {
        // WARN: since this data structure is tied to the instance, it is shared by both logs and rum
        // and can be used by different code versions depending on customer setup
        // so it should stay compatible with older versions
        this._datadog_xhr = {
            method: method,
            startTime: -1,
            url: normalizeUrl(url),
        };
        return originalXhrOpen.apply(this, arguments);
    });
    XMLHttpRequest.prototype.send = monitor(function (body) {
        var _this = this;
        if (this._datadog_xhr) {
            this._datadog_xhr.startTime = performance.now();
            var originalOnreadystatechange_1 = this.onreadystatechange;
            this.onreadystatechange = function () {
                if (this.readyState === XMLHttpRequest.DONE) {
                    monitor(reportXhr_1)();
                }
                if (originalOnreadystatechange_1) {
                    originalOnreadystatechange_1.apply(this, arguments);
                }
            };
            var hasBeenReported_1 = false;
            var reportXhr_1 = function () {
                if (hasBeenReported_1) {
                    return;
                }
                hasBeenReported_1 = true;
                _this._datadog_xhr.duration = performance.now() - _this._datadog_xhr.startTime;
                _this._datadog_xhr.response = _this.response;
                _this._datadog_xhr.status = _this.status;
                xhrProxy_onRequestCompleteCallbacks.forEach(function (callback) { return callback(_this._datadog_xhr); });
            };
            this.addEventListener('loadend', monitor(reportXhr_1));
            xhrProxy_beforeSendCallbacks.forEach(function (callback) { return callback(_this._datadog_xhr, _this); });
        }
        return originalXhrSend.apply(this, arguments);
    });
}
//# sourceMappingURL=xhrProxy.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/tools/observable.js
var Observable = /** @class */ (function () {
    function Observable() {
        this.observers = [];
    }
    Observable.prototype.subscribe = function (f) {
        this.observers.push(f);
    };
    Observable.prototype.notify = function (data) {
        this.observers.forEach(function (observer) { return observer(data); });
    };
    return Observable;
}());

//# sourceMappingURL=observable.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/automaticErrorCollection.js








var filteredErrorsObservable;
function startAutomaticErrorCollection(configuration) {
    if (!filteredErrorsObservable) {
        var errorObservable = new Observable();
        trackNetworkError(configuration, errorObservable);
        startConsoleTracking(errorObservable);
        startRuntimeErrorTracking(errorObservable);
        filteredErrorsObservable = filterErrors(configuration, errorObservable);
    }
    return filteredErrorsObservable;
}
function filterErrors(configuration, errorObservable) {
    var errorCount = 0;
    var filteredErrorObservable = new Observable();
    errorObservable.subscribe(function (error) {
        if (errorCount < configuration.maxErrorsByMinute) {
            errorCount += 1;
            filteredErrorObservable.notify(error);
        }
        else if (errorCount === configuration.maxErrorsByMinute) {
            errorCount += 1;
            filteredErrorObservable.notify({
                message: "Reached max number of errors by minute: " + configuration.maxErrorsByMinute,
                source: ErrorSource.AGENT,
                startTime: performance.now(),
            });
        }
    });
    setInterval(function () { return (errorCount = 0); }, ONE_MINUTE);
    return filteredErrorObservable;
}
var originalConsoleError;
function startConsoleTracking(errorObservable) {
    originalConsoleError = console.error;
    console.error = monitor(function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        originalConsoleError.apply(console, __spreadArrays([message], optionalParams));
        errorObservable.notify({
            message: __spreadArrays(['console error:', message], optionalParams).map(formatConsoleParameters).join(' '),
            source: ErrorSource.CONSOLE,
            startTime: performance.now(),
        });
    });
}
function stopConsoleTracking() {
    console.error = originalConsoleError;
}
function formatConsoleParameters(param) {
    if (typeof param === 'string') {
        return param;
    }
    if (param instanceof Error) {
        return toStackTraceString(computeStackTrace(param));
    }
    return jsonStringify(param, undefined, 2);
}
var traceKitReportHandler;
function startRuntimeErrorTracking(errorObservable) {
    traceKitReportHandler = function (stackTrace, _, errorObject) {
        var _a = formatUnknownError(stackTrace, errorObject, 'Uncaught'), stack = _a.stack, message = _a.message, type = _a.type;
        errorObservable.notify({
            message: message,
            stack: stack,
            type: type,
            source: ErrorSource.SOURCE,
            startTime: performance.now(),
        });
    };
    tracekit_report.subscribe(traceKitReportHandler);
}
function stopRuntimeErrorTracking() {
    ;
    report.unsubscribe(traceKitReportHandler);
}
function trackNetworkError(configuration, errorObservable) {
    startXhrProxy().onRequestComplete(function (context) { return handleCompleteRequest(RequestType.XHR, context); });
    startFetchProxy().onRequestComplete(function (context) { return handleCompleteRequest(RequestType.FETCH, context); });
    function handleCompleteRequest(type, request) {
        if (!configuration.isIntakeUrl(request.url) && (isRejected(request) || isServerError(request))) {
            errorObservable.notify({
                message: format(type) + " error " + request.method + " " + request.url,
                resource: {
                    method: request.method,
                    statusCode: request.status,
                    url: request.url,
                },
                source: ErrorSource.NETWORK,
                stack: truncateResponse(request.response, configuration) || 'Failed to load',
                startTime: request.startTime,
            });
        }
    }
    return {
        stop: function () {
            resetXhrProxy();
            resetFetchProxy();
        },
    };
}
function isRejected(request) {
    return request.status === 0 && request.responseType !== 'opaque';
}
function isServerError(request) {
    return request.status >= 500;
}
function truncateResponse(response, configuration) {
    if (response && response.length > configuration.requestErrorResponseLengthLimit) {
        return response.substring(0, configuration.requestErrorResponseLengthLimit) + "...";
    }
    return response;
}
function format(type) {
    if (RequestType.XHR === type) {
        return 'XHR';
    }
    return 'Fetch';
}
//# sourceMappingURL=automaticErrorCollection.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/oldCookiesMigration.js


var OLD_SESSION_COOKIE_NAME = '_dd';
var OLD_RUM_COOKIE_NAME = '_dd_r';
var OLD_LOGS_COOKIE_NAME = '_dd_l';
// duplicate values to avoid dependency issues
var RUM_SESSION_KEY = 'rum';
var LOGS_SESSION_KEY = 'logs';
/**
 * This migration should remain in the codebase as long as older versions are available/live
 * to allow older sdk versions to be upgraded to newer versions without compatibility issues.
 */
function tryOldCookiesMigration(sessionCookie) {
    var sessionString = sessionCookie.get();
    var oldSessionId = getCookie(OLD_SESSION_COOKIE_NAME);
    var oldRumType = getCookie(OLD_RUM_COOKIE_NAME);
    var oldLogsType = getCookie(OLD_LOGS_COOKIE_NAME);
    if (!sessionString) {
        var session = {};
        if (oldSessionId) {
            session.id = oldSessionId;
        }
        if (oldLogsType && /^[01]$/.test(oldLogsType)) {
            session[LOGS_SESSION_KEY] = oldLogsType;
        }
        if (oldRumType && /^[012]$/.test(oldRumType)) {
            session[RUM_SESSION_KEY] = oldRumType;
        }
        persistSession(session, sessionCookie);
    }
}
//# sourceMappingURL=oldCookiesMigration.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/node_modules/@datadog/browser-core/esm/domain/sessionManagement.js





var SESSION_COOKIE_NAME = '_dd_s';
var SESSION_EXPIRATION_DELAY = 15 * ONE_MINUTE;
var SESSION_TIME_OUT_DELAY = 4 * ONE_HOUR;
var VISIBILITY_CHECK_DELAY = ONE_MINUTE;
/**
 * Limit access to cookie to avoid performance issues
 */
function startSessionManagement(options, productKey, computeSessionState) {
    var sessionCookie = cacheCookieAccess(SESSION_COOKIE_NAME, options);
    tryOldCookiesMigration(sessionCookie);
    var renewObservable = new Observable();
    var currentSessionId = retrieveActiveSession(sessionCookie).id;
    var expandOrRenewSession = throttle(function () {
        var session = retrieveActiveSession(sessionCookie);
        var _a = computeSessionState(session[productKey]), trackingType = _a.trackingType, isTracked = _a.isTracked;
        session[productKey] = trackingType;
        if (isTracked && !session.id) {
            session.id = generateUUID();
            session.created = String(Date.now());
        }
        // save changes and expand session duration
        persistSession(session, sessionCookie);
        // If the session id has changed, notify that the session has been renewed
        if (isTracked && currentSessionId !== session.id) {
            currentSessionId = session.id;
            renewObservable.notify();
        }
    }, COOKIE_ACCESS_DELAY).throttled;
    var expandSession = function () {
        var session = retrieveActiveSession(sessionCookie);
        persistSession(session, sessionCookie);
    };
    expandOrRenewSession();
    trackActivity(expandOrRenewSession);
    trackVisibility(expandSession);
    return {
        getId: function () {
            return retrieveActiveSession(sessionCookie).id;
        },
        getTrackingType: function () {
            return retrieveActiveSession(sessionCookie)[productKey];
        },
        renewObservable: renewObservable,
    };
}
var SESSION_ENTRY_REGEXP = /^([a-z]+)=([a-z0-9-]+)$/;
var SESSION_ENTRY_SEPARATOR = '&';
function isValidSessionString(sessionString) {
    return (sessionString !== undefined &&
        (sessionString.indexOf(SESSION_ENTRY_SEPARATOR) !== -1 || SESSION_ENTRY_REGEXP.test(sessionString)));
}
function retrieveActiveSession(sessionCookie) {
    var session = retrieveSession(sessionCookie);
    if (isActiveSession(session)) {
        return session;
    }
    clearSession(sessionCookie);
    return {};
}
function isActiveSession(session) {
    // created and expire can be undefined for versions which was not storing them
    // these checks could be removed when older versions will not be available/live anymore
    return ((session.created === undefined || Date.now() - Number(session.created) < SESSION_TIME_OUT_DELAY) &&
        (session.expire === undefined || Date.now() < Number(session.expire)));
}
function retrieveSession(sessionCookie) {
    var sessionString = sessionCookie.get();
    var session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach(function (entry) {
            var matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                var key = matches[1], value = matches[2];
                session[key] = value;
            }
        });
    }
    return session;
}
function persistSession(session, cookie) {
    if (isEmptyObject(session)) {
        clearSession(cookie);
        return;
    }
    session.expire = String(Date.now() + SESSION_EXPIRATION_DELAY);
    var cookieString = objectEntries(session)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return key + "=" + value;
    })
        .join(SESSION_ENTRY_SEPARATOR);
    cookie.set(cookieString, SESSION_EXPIRATION_DELAY);
}
function clearSession(cookie) {
    cookie.set('', 0);
}
function stopSessionManagement() {
    stopCallbacks.forEach(function (e) { return e(); });
    stopCallbacks = [];
}
var stopCallbacks = [];
function trackActivity(expandOrRenewSession) {
    var stop = addEventListeners(window, [DOM_EVENT.CLICK, DOM_EVENT.TOUCH_START, DOM_EVENT.KEY_DOWN, DOM_EVENT.SCROLL], expandOrRenewSession, { capture: true, passive: true }).stop;
    stopCallbacks.push(stop);
}
function trackVisibility(expandSession) {
    var expandSessionWhenVisible = monitor(function () {
        if (document.visibilityState === 'visible') {
            expandSession();
        }
    });
    var stop = addEventListener(document, DOM_EVENT.VISIBILITY_CHANGE, expandSessionWhenVisible).stop;
    stopCallbacks.push(stop);
    var visibilityCheckInterval = window.setInterval(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
    stopCallbacks.push(function () {
        clearInterval(visibilityCheckInterval);
    });
}
//# sourceMappingURL=sessionManagement.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/domain/loggerSession.js

var LOGGER_SESSION_KEY = 'logs';
var LoggerTrackingType;
(function (LoggerTrackingType) {
    LoggerTrackingType["NOT_TRACKED"] = "0";
    LoggerTrackingType["TRACKED"] = "1";
})(LoggerTrackingType || (LoggerTrackingType = {}));
function startLoggerSession(configuration, areCookieAuthorized) {
    if (!areCookieAuthorized) {
        var isTracked_1 = computeTrackingType(configuration) === LoggerTrackingType.TRACKED;
        return {
            getId: function () { return undefined; },
            isTracked: function () { return isTracked_1; },
        };
    }
    var session = startSessionManagement(configuration.cookieOptions, LOGGER_SESSION_KEY, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    return {
        getId: session.getId,
        isTracked: function () { return session.getTrackingType() === LoggerTrackingType.TRACKED; },
    };
}
function computeTrackingType(configuration) {
    if (!performDraw(configuration.sampleRate)) {
        return LoggerTrackingType.NOT_TRACKED;
    }
    return LoggerTrackingType.TRACKED;
}
function computeSessionState(configuration, rawSessionType) {
    var trackingType = hasValidLoggerSession(rawSessionType) ? rawSessionType : computeTrackingType(configuration);
    return {
        trackingType: trackingType,
        isTracked: trackingType === LoggerTrackingType.TRACKED,
    };
}
function hasValidLoggerSession(trackingType) {
    return trackingType === LoggerTrackingType.NOT_TRACKED || trackingType === LoggerTrackingType.TRACKED;
}
//# sourceMappingURL=loggerSession.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/boot/buildEnv.js
var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '1.26.3',
};
//# sourceMappingURL=buildEnv.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/boot/logs.js



function startLogs(userConfiguration, errorLogger, getGlobalContext) {
    var _a = commonInit(userConfiguration, buildEnv), configuration = _a.configuration, internalMonitoring = _a.internalMonitoring;
    var errorObservable = userConfiguration.forwardErrorsToLogs !== false
        ? startAutomaticErrorCollection(configuration)
        : new Observable();
    var session = startLoggerSession(configuration, cookie_areCookiesAuthorized(configuration.cookieOptions));
    return doStartLogs(configuration, errorObservable, internalMonitoring, session, errorLogger, getGlobalContext);
}
function doStartLogs(configuration, errorObservable, internalMonitoring, session, errorLogger, getGlobalContext) {
    internalMonitoring.setExternalContextProvider(function () {
        return combine({ session_id: session.getId() }, getGlobalContext(), getRUMInternalContext());
    });
    var batch = startLoggerBatch(configuration, session);
    errorObservable.subscribe(function (error) {
        errorLogger.error(error.message, combine({
            date: getTimestamp(error.startTime),
            error: {
                kind: error.type,
                origin: error.source,
                stack: error.stack,
            },
        }, error.resource
            ? {
                http: {
                    method: error.resource.method,
                    status_code: error.resource.statusCode,
                    url: error.resource.url,
                },
            }
            : undefined, getRUMInternalContext(error.startTime)));
    });
    return function (message, currentContext) {
        if (session.isTracked()) {
            batch.add(message, currentContext);
        }
    };
}
function startLoggerBatch(configuration, session) {
    var primaryBatch = createLoggerBatch(configuration.logsEndpoint);
    var replicaBatch;
    if (configuration.replica !== undefined) {
        replicaBatch = createLoggerBatch(configuration.replica.logsEndpoint);
    }
    function createLoggerBatch(endpointUrl) {
        return new Batch(new HttpRequest(endpointUrl, configuration.batchBytesLimit), configuration.maxBatchSize, configuration.batchBytesLimit, configuration.maxMessageSize, configuration.flushTimeout);
    }
    return {
        add: function (message, currentContext) {
            var contextualizedMessage = assembleMessageContexts({ service: configuration.service, session_id: session.getId() }, currentContext, getRUMInternalContext(), message);
            primaryBatch.add(contextualizedMessage);
            if (replicaBatch) {
                replicaBatch.add(contextualizedMessage);
            }
        },
    };
}
function assembleMessageContexts(defaultContext, currentContext, rumInternalContext, message) {
    return combine(defaultContext, currentContext, rumInternalContext, message);
}
function getRUMInternalContext(startTime) {
    var rum = window.DD_RUM;
    return rum && rum.getInternalContext ? rum.getInternalContext(startTime) : undefined;
}
//# sourceMappingURL=logs.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/boot/logs.entry.js




var datadogLogs = makeLogsGlobal(startLogs);
defineGlobal(getGlobalObject(), 'DD_LOGS', datadogLogs);
function makeLogsGlobal(startLogsImpl) {
    var isAlreadyInitialized = false;
    var globalContextManager = createContextManager();
    var customLoggers = {};
    var beforeInitSendLog = new BoundedBuffer();
    var sendLogStrategy = function (message, currentContext) {
        beforeInitSendLog.add([message, currentContext]);
    };
    var logger = new Logger(sendLog);
    return makeGlobal({
        logger: logger,
        init: monitor(function (userConfiguration) {
            if (!checkIsNotLocalFile() || !canInitLogs(userConfiguration)) {
                return;
            }
            if (userConfiguration.publicApiKey) {
                userConfiguration.clientToken = userConfiguration.publicApiKey;
                console.warn('Public API Key is deprecated. Please use Client Token instead.');
            }
            sendLogStrategy = startLogsImpl(userConfiguration, logger, globalContextManager.get);
            beforeInitSendLog.drain(function (_a) {
                var message = _a[0], context = _a[1];
                return sendLogStrategy(message, context);
            });
            isAlreadyInitialized = true;
        }),
        getLoggerGlobalContext: monitor(globalContextManager.get),
        setLoggerGlobalContext: monitor(globalContextManager.set),
        addLoggerGlobalContext: monitor(globalContextManager.add),
        removeLoggerGlobalContext: monitor(globalContextManager.remove),
        createLogger: monitor(function (name, conf) {
            if (conf === void 0) { conf = {}; }
            customLoggers[name] = new Logger(sendLog, conf.handler, conf.level, tslib_es6_assign(tslib_es6_assign({}, conf.context), { logger: { name: name } }));
            return customLoggers[name];
        }),
        getLogger: monitor(function (name) {
            return customLoggers[name];
        }),
    });
    function canInitLogs(userConfiguration) {
        if (isAlreadyInitialized) {
            if (!userConfiguration.silentMultipleInit) {
                console.error('DD_LOGS is already initialized.');
            }
            return false;
        }
        if (!userConfiguration || (!userConfiguration.publicApiKey && !userConfiguration.clientToken)) {
            console.error('Client Token is not configured, we will not send any data.');
            return false;
        }
        if (userConfiguration.sampleRate !== undefined && !isPercentage(userConfiguration.sampleRate)) {
            console.error('Sample Rate should be a number between 0 and 100');
            return false;
        }
        return true;
    }
    function sendLog(message) {
        sendLogStrategy(message, combine({
            date: Date.now(),
            view: {
                referrer: document.referrer,
                url: window.location.href,
            },
        }, globalContextManager.get()));
    }
}
//# sourceMappingURL=logs.entry.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-logs/esm/index.js



//# sourceMappingURL=index.js.map

/***/ }),

/***/ 66715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* reexport */ configuration_configuration/* DefaultPrivacyLevel */.Jj; },
  "v": function() { return /* binding */ datadogRum; }
});

// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/boot/init.js
var init = __webpack_require__(27627);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/getGlobalObject.js
var getGlobalObject = __webpack_require__(1692);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/context/contextManager.js
var contextManager = __webpack_require__(79217);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js
var functionUtils = __webpack_require__(84164);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js
var boundedBuffer = __webpack_require__(84554);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(853);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(42818);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/mergeInto.js
var mergeInto = __webpack_require__(20377);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/synthetics/syntheticsWorkerValues.js
var syntheticsWorkerValues = __webpack_require__(27478);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/eventBridge.js
var eventBridge = __webpack_require__(52325);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/context/storedContextManager.js
var storedContextManager = __webpack_require__(7876);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(93099);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/serialisation/sanitize.js
var sanitize = __webpack_require__(53185);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.js
var error_error = __webpack_require__(30331);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/user/user.js
var user = __webpack_require__(17662);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(95959);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(76135);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js + 3 modules
var configuration_configuration = __webpack_require__(66869);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(47970);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/typeUtils.js
var typeUtils = __webpack_require__(74505);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/matchOption.js



function isMatchOption(item) {
    var itemType = (0,typeUtils/* getType */.o)(item);
    return itemType === 'string' || itemType === 'function' || item instanceof RegExp;
}
/**
 * Returns true if value can be matched by at least one of the provided MatchOptions.
 * When comparing strings, setting useStartsWith to true will compare the value with the start of
 * the option, instead of requiring an exact match.
 */
function matchList(list, value, useStartsWith) {
    if (useStartsWith === void 0) { useStartsWith = false; }
    return list.some(function (item) {
        try {
            if (typeof item === 'function') {
                return item(value);
            }
            else if (item instanceof RegExp) {
                return item.test(value);
            }
            else if (typeof item === 'string') {
                return useStartsWith ? (0,polyfills/* startsWith */.Ny)(value, item) : item === value;
            }
        }
        catch (e) {
            display/* display.error */.jf.error(e);
        }
        return false;
    });
}
//# sourceMappingURL=matchOption.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/urlPolyfill.js
var urlPolyfill = __webpack_require__(6239);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/tracing/tracer.js

function isTracingOption(item) {
    var expectedItem = item;
    return ((0,typeUtils/* getType */.o)(expectedItem) === 'object' &&
        isMatchOption(expectedItem.match) &&
        Array.isArray(expectedItem.propagatorTypes));
}
/**
 * Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
 * request did not reach the server, but the browser does not expose this. So, we clear tracing
 * information if the request ended with status 0 without being aborted by the application.
 *
 * Reasoning:
 *
 * * Applications are usually aborting requests after a bit of time, for example when the user is
 * typing (autocompletion) or navigating away (in a SPA). With a performant device and good
 * network conditions, the request is likely to reach the server before being canceled.
 *
 * * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
 * are likely to finish quickly and without reaching the server.
 *
 * Of course, it might not be the case every time, but it should limit having incomplete traces a
 * bit.
 * */
function clearTracingIfNeeded(context) {
    if (context.status === 0 && !context.isAborted) {
        context.traceId = undefined;
        context.spanId = undefined;
        context.traceSampled = undefined;
    }
}
function startTracer(configuration, sessionManager) {
    return {
        clearTracingIfNeeded: clearTracingIfNeeded,
        traceFetch: function (context) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                var _a;
                if (context.input instanceof Request && !((_a = context.init) === null || _a === void 0 ? void 0 : _a.headers)) {
                    context.input = new Request(context.input);
                    Object.keys(tracingHeaders).forEach(function (key) {
                        ;
                        context.input.headers.append(key, tracingHeaders[key]);
                    });
                }
                else {
                    context.init = (0,objectUtils/* shallowClone */.mv)(context.init);
                    var headers_1 = [];
                    if (context.init.headers instanceof Headers) {
                        context.init.headers.forEach(function (value, key) {
                            headers_1.push([key, value]);
                        });
                    }
                    else if (Array.isArray(context.init.headers)) {
                        context.init.headers.forEach(function (header) {
                            headers_1.push(header);
                        });
                    }
                    else if (context.init.headers) {
                        Object.keys(context.init.headers).forEach(function (key) {
                            headers_1.push([key, context.init.headers[key]]);
                        });
                    }
                    context.init.headers = headers_1.concat((0,polyfills/* objectEntries */.qP)(tracingHeaders));
                }
            });
        },
        traceXhr: function (context, xhr) {
            return injectHeadersIfTracingAllowed(configuration, context, sessionManager, function (tracingHeaders) {
                Object.keys(tracingHeaders).forEach(function (name) {
                    xhr.setRequestHeader(name, tracingHeaders[name]);
                });
            });
        },
    };
}
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, inject) {
    if (!isTracingSupported() || !sessionManager.findTrackedSession()) {
        return;
    }
    var tracingOption = (0,polyfills/* find */.sE)(configuration.allowedTracingUrls, function (tracingOption) {
        return matchList([tracingOption.match], context.url, true);
    });
    if (!tracingOption) {
        return;
    }
    context.traceId = new TraceIdentifier();
    context.spanId = new TraceIdentifier();
    context.traceSampled = !(0,numberUtils/* isNumber */.hj)(configuration.traceSampleRate) || (0,numberUtils/* performDraw */.y7)(configuration.traceSampleRate);
    inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, tracingOption.propagatorTypes));
}
function isTracingSupported() {
    return getCrypto() !== undefined;
}
function getCrypto() {
    return window.crypto || window.msCrypto;
}
/**
 * When trace is not sampled, set priority to '0' instead of not adding the tracing headers
 * to prepare the implementation for sampling delegation.
 */
function makeTracingHeaders(traceId, spanId, traceSampled, propagatorTypes) {
    var tracingHeaders = {};
    propagatorTypes.forEach(function (propagatorType) {
        switch (propagatorType) {
            case 'datadog': {
                (0,polyfills/* assign */.f0)(tracingHeaders, {
                    'x-datadog-origin': 'rum',
                    'x-datadog-parent-id': spanId.toDecimalString(),
                    'x-datadog-sampling-priority': traceSampled ? '1' : '0',
                    'x-datadog-trace-id': traceId.toDecimalString(),
                });
                break;
            }
            // https://www.w3.org/TR/trace-context/
            case 'tracecontext': {
                (0,polyfills/* assign */.f0)(tracingHeaders, {
                    traceparent: "00-0000000000000000".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-0").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            // https://github.com/openzipkin/b3-propagation
            case 'b3': {
                (0,polyfills/* assign */.f0)(tracingHeaders, {
                    b3: "".concat(traceId.toPaddedHexadecimalString(), "-").concat(spanId.toPaddedHexadecimalString(), "-").concat(traceSampled ? '1' : '0'),
                });
                break;
            }
            case 'b3multi': {
                (0,polyfills/* assign */.f0)(tracingHeaders, {
                    'X-B3-TraceId': traceId.toPaddedHexadecimalString(),
                    'X-B3-SpanId': spanId.toPaddedHexadecimalString(),
                    'X-B3-Sampled': traceSampled ? '1' : '0',
                });
                break;
            }
        }
    });
    return tracingHeaders;
}
/* eslint-disable no-bitwise */
var TraceIdentifier = /** @class */ (function () {
    function TraceIdentifier() {
        this.buffer = new Uint8Array(8);
        getCrypto().getRandomValues(this.buffer);
        this.buffer[0] = this.buffer[0] & 0x7f; // force 63-bit
    }
    TraceIdentifier.prototype.toString = function (radix) {
        var high = this.readInt32(0);
        var low = this.readInt32(4);
        var str = '';
        do {
            var mod = (high % radix) * 4294967296 + low;
            high = Math.floor(high / radix);
            low = Math.floor(mod / radix);
            str = (mod % radix).toString(radix) + str;
        } while (high || low);
        return str;
    };
    /**
     * Format used everywhere except the trace intake
     */
    TraceIdentifier.prototype.toDecimalString = function () {
        return this.toString(10);
    };
    /**
     * Format used by OTel headers
     */
    TraceIdentifier.prototype.toPaddedHexadecimalString = function () {
        var traceId = this.toString(16);
        return Array(17 - traceId.length).join('0') + traceId;
    };
    TraceIdentifier.prototype.readInt32 = function (offset) {
        return (this.buffer[offset] * 16777216 +
            (this.buffer[offset + 1] << 16) +
            (this.buffer[offset + 2] << 8) +
            this.buffer[offset + 3]);
    };
    return TraceIdentifier;
}());

/* eslint-enable no-bitwise */
//# sourceMappingURL=tracer.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/configuration.js


function validateAndBuildRumConfiguration(initConfiguration) {
    var _a, _b, _c, _d, _e, _f;
    if (!initConfiguration.applicationId) {
        display/* display.error */.jf.error('Application ID is not configured, no RUM data will be collected.');
        return;
    }
    if (initConfiguration.sessionReplaySampleRate !== undefined &&
        !(0,numberUtils/* isPercentage */.zz)(initConfiguration.sessionReplaySampleRate)) {
        display/* display.error */.jf.error('Session Replay Sample Rate should be a number between 0 and 100');
        return;
    }
    // TODO remove fallback in next major
    var premiumSampleRate = (_a = initConfiguration.premiumSampleRate) !== null && _a !== void 0 ? _a : initConfiguration.replaySampleRate;
    if (premiumSampleRate !== undefined && initConfiguration.sessionReplaySampleRate !== undefined) {
        display/* display.warn */.jf.warn('Ignoring Premium Sample Rate because Session Replay Sample Rate is set');
        premiumSampleRate = undefined;
    }
    if (premiumSampleRate !== undefined && !(0,numberUtils/* isPercentage */.zz)(premiumSampleRate)) {
        display/* display.error */.jf.error('Premium Sample Rate should be a number between 0 and 100');
        return;
    }
    var traceSampleRate = (_b = initConfiguration.traceSampleRate) !== null && _b !== void 0 ? _b : initConfiguration.tracingSampleRate;
    if (traceSampleRate !== undefined && !(0,numberUtils/* isPercentage */.zz)(traceSampleRate)) {
        display/* display.error */.jf.error('Trace Sample Rate should be a number between 0 and 100');
        return;
    }
    if (initConfiguration.excludedActivityUrls !== undefined && !Array.isArray(initConfiguration.excludedActivityUrls)) {
        display/* display.error */.jf.error('Excluded Activity Urls should be an array');
        return;
    }
    var allowedTracingUrls = validateAndBuildTracingOptions(initConfiguration);
    if (!allowedTracingUrls) {
        return;
    }
    var baseConfiguration = (0,configuration_configuration/* validateAndBuildConfiguration */.fP)(initConfiguration);
    if (!baseConfiguration) {
        return;
    }
    var trackUserInteractions = !!((_c = initConfiguration.trackUserInteractions) !== null && _c !== void 0 ? _c : initConfiguration.trackInteractions);
    var trackFrustrations = !!initConfiguration.trackFrustrations;
    return (0,polyfills/* assign */.f0)({
        applicationId: initConfiguration.applicationId,
        version: initConfiguration.version,
        actionNameAttribute: initConfiguration.actionNameAttribute,
        sessionReplaySampleRate: (_e = (_d = initConfiguration.sessionReplaySampleRate) !== null && _d !== void 0 ? _d : premiumSampleRate) !== null && _e !== void 0 ? _e : 100,
        oldPlansBehavior: initConfiguration.sessionReplaySampleRate === undefined,
        traceSampleRate: traceSampleRate,
        allowedTracingUrls: allowedTracingUrls,
        excludedActivityUrls: (_f = initConfiguration.excludedActivityUrls) !== null && _f !== void 0 ? _f : [],
        workerUrl: initConfiguration.workerUrl,
        trackUserInteractions: trackUserInteractions || trackFrustrations,
        trackFrustrations: trackFrustrations,
        trackViewsManually: !!initConfiguration.trackViewsManually,
        trackResources: initConfiguration.trackResources,
        trackLongTasks: initConfiguration.trackLongTasks,
        subdomain: initConfiguration.subdomain,
        defaultPrivacyLevel: (0,objectUtils/* objectHasValue */.E5)(configuration_configuration/* DefaultPrivacyLevel */.Jj, initConfiguration.defaultPrivacyLevel)
            ? initConfiguration.defaultPrivacyLevel
            : configuration_configuration/* DefaultPrivacyLevel.MASK_USER_INPUT */.Jj.MASK_USER_INPUT,
        customerDataTelemetrySampleRate: 1,
    }, baseConfiguration);
}
/**
 * Handles allowedTracingUrls and processes legacy allowedTracingOrigins
 */
function validateAndBuildTracingOptions(initConfiguration) {
    // Advise about parameters precedence.
    if (initConfiguration.allowedTracingUrls !== undefined && initConfiguration.allowedTracingOrigins !== undefined) {
        display/* display.warn */.jf.warn('Both allowedTracingUrls and allowedTracingOrigins (deprecated) have been defined. The parameter allowedTracingUrls will override allowedTracingOrigins.');
    }
    // Handle allowedTracingUrls first
    if (initConfiguration.allowedTracingUrls !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingUrls)) {
            display/* display.error */.jf.error('Allowed Tracing URLs should be an array');
            return;
        }
        if (initConfiguration.allowedTracingUrls.length !== 0 && initConfiguration.service === undefined) {
            display/* display.error */.jf.error('Service needs to be configured when tracing is enabled');
            return;
        }
        // Convert from (MatchOption | TracingOption) to TracingOption, remove unknown properties
        var tracingOptions_1 = [];
        initConfiguration.allowedTracingUrls.forEach(function (option) {
            if (isMatchOption(option)) {
                tracingOptions_1.push({ match: option, propagatorTypes: ['datadog'] });
            }
            else if (isTracingOption(option)) {
                tracingOptions_1.push(option);
            }
            else {
                display/* display.warn */.jf.warn('Allowed Tracing Urls parameters should be a string, RegExp, function, or an object. Ignoring parameter', option);
            }
        });
        return tracingOptions_1;
    }
    // Handle conversion of allowedTracingOrigins to allowedTracingUrls
    if (initConfiguration.allowedTracingOrigins !== undefined) {
        if (!Array.isArray(initConfiguration.allowedTracingOrigins)) {
            display/* display.error */.jf.error('Allowed Tracing Origins should be an array');
            return;
        }
        if (initConfiguration.allowedTracingOrigins.length !== 0 && initConfiguration.service === undefined) {
            display/* display.error */.jf.error('Service needs to be configured when tracing is enabled');
            return;
        }
        var tracingOptions_2 = [];
        initConfiguration.allowedTracingOrigins.forEach(function (legacyMatchOption) {
            var tracingOption = convertLegacyMatchOptionToTracingOption(legacyMatchOption);
            if (tracingOption) {
                tracingOptions_2.push(tracingOption);
            }
        });
        return tracingOptions_2;
    }
    return [];
}
/**
 * Converts parameters from the deprecated allowedTracingOrigins
 * to allowedTracingUrls. Handles the change from origin to full URLs.
 */
function convertLegacyMatchOptionToTracingOption(item) {
    var match;
    if (typeof item === 'string') {
        match = item;
    }
    else if (item instanceof RegExp) {
        match = function (url) { return item.test((0,urlPolyfill/* getOrigin */.P$)(url)); };
    }
    else if (typeof item === 'function') {
        match = function (url) { return item((0,urlPolyfill/* getOrigin */.P$)(url)); };
    }
    if (match === undefined) {
        display/* display.warn */.jf.warn('Allowed Tracing Origins parameters should be a string, RegExp or function. Ignoring parameter', item);
        return undefined;
    }
    return { match: match, propagatorTypes: ['datadog'] };
}
/**
 * Combines the selected tracing propagators from the different options in allowedTracingUrls,
 * and assumes 'datadog' has been selected when using allowedTracingOrigins
 */
function getSelectedTracingPropagators(configuration) {
    var usedTracingPropagators = new Set();
    if (Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0) {
        configuration.allowedTracingUrls.forEach(function (option) {
            if (isMatchOption(option)) {
                usedTracingPropagators.add('datadog');
            }
            else if ((0,typeUtils/* getType */.o)(option) === 'object' && Array.isArray(option.propagatorTypes)) {
                // Ensure we have an array, as we cannot rely on types yet (configuration is provided by users)
                option.propagatorTypes.forEach(function (propagatorType) { return usedTracingPropagators.add(propagatorType); });
            }
        });
    }
    if (Array.isArray(configuration.allowedTracingOrigins) && configuration.allowedTracingOrigins.length > 0) {
        usedTracingPropagators.add('datadog');
    }
    return (0,polyfills/* arrayFrom */.Oc)(usedTracingPropagators);
}
function serializeRumConfiguration(configuration) {
    var _a, _b;
    var baseSerializedConfiguration = (0,configuration_configuration/* serializeConfiguration */.JZ)(configuration);
    return (0,polyfills/* assign */.f0)({
        premium_sample_rate: configuration.premiumSampleRate,
        replay_sample_rate: configuration.replaySampleRate,
        session_replay_sample_rate: configuration.sessionReplaySampleRate,
        trace_sample_rate: (_a = configuration.traceSampleRate) !== null && _a !== void 0 ? _a : configuration.tracingSampleRate,
        action_name_attribute: configuration.actionNameAttribute,
        use_allowed_tracing_origins: Array.isArray(configuration.allowedTracingOrigins) && configuration.allowedTracingOrigins.length > 0,
        use_allowed_tracing_urls: Array.isArray(configuration.allowedTracingUrls) && configuration.allowedTracingUrls.length > 0,
        selected_tracing_propagators: getSelectedTracingPropagators(configuration),
        default_privacy_level: configuration.defaultPrivacyLevel,
        use_excluded_activity_urls: Array.isArray(configuration.excludedActivityUrls) && configuration.excludedActivityUrls.length > 0,
        use_worker_url: !!configuration.workerUrl,
        track_frustrations: configuration.trackFrustrations,
        track_views_manually: configuration.trackViewsManually,
        track_user_interactions: (_b = configuration.trackUserInteractions) !== null && _b !== void 0 ? _b : configuration.trackInteractions,
    }, baseSerializedConfiguration);
}
//# sourceMappingURL=configuration.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/commonContext.js
function buildCommonContext(globalContextManager, userContextManager, recorderApi) {
    return {
        context: globalContextManager.getContext(),
        user: userContextManager.getContext(),
        hasReplay: recorderApi.isRecording() ? true : undefined,
    };
}
//# sourceMappingURL=commonContext.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/boot/rumPublicApi.js



var RUM_STORAGE_KEY = 'rum';
function makeRumPublicApi(startRumImpl, recorderApi, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.ignoreInitIfSyntheticsWillInjectRum, ignoreInitIfSyntheticsWillInjectRum = _c === void 0 ? true : _c;
    var isAlreadyInitialized = false;
    var globalContextManager = (0,contextManager/* createContextManager */.W)(2 /* CustomerDataType.GlobalContext */);
    var userContextManager = (0,contextManager/* createContextManager */.W)(1 /* CustomerDataType.User */);
    var getInternalContextStrategy = function () { return undefined; };
    var getInitConfigurationStrategy = function () { return undefined; };
    var stopSessionStrategy = functionUtils/* noop */.Z;
    var getSessionReplayLinkStrategy = function () { return undefined; };
    var bufferApiCalls = new boundedBuffer/* BoundedBuffer */.S();
    var addTimingStrategy = function (name, time) {
        if (time === void 0) { time = (0,timeUtils/* timeStampNow */.n$)(); }
        bufferApiCalls.add(function () { return addTimingStrategy(name, time); });
    };
    var startViewStrategy = function (options, startClocks) {
        if (startClocks === void 0) { startClocks = (0,timeUtils/* clocksNow */.$I)(); }
        bufferApiCalls.add(function () { return startViewStrategy(options, startClocks); });
    };
    var addActionStrategy = function (action, commonContext) {
        if (commonContext === void 0) { commonContext = buildCommonContext(globalContextManager, userContextManager, recorderApi); }
        bufferApiCalls.add(function () { return addActionStrategy(action, commonContext); });
    };
    var addErrorStrategy = function (providedError, commonContext) {
        if (commonContext === void 0) { commonContext = buildCommonContext(globalContextManager, userContextManager, recorderApi); }
        bufferApiCalls.add(function () { return addErrorStrategy(providedError, commonContext); });
    };
    var addFeatureFlagEvaluationStrategy = function (key, value) {
        bufferApiCalls.add(function () { return addFeatureFlagEvaluationStrategy(key, value); });
    };
    function initRum(initConfiguration) {
        if (!initConfiguration) {
            display/* display.error */.jf.error('Missing configuration');
            return;
        }
        // This function should be available, regardless of initialization success.
        getInitConfigurationStrategy = function () { return (0,mergeInto/* deepClone */.I8)(initConfiguration); };
        // If we are in a Synthetics test configured to automatically inject a RUM instance, we want to
        // completely discard the customer application RUM instance by ignoring their init() call.  But,
        // we should not ignore the init() call from the Synthetics-injected RUM instance, so the
        // internal `ignoreInitIfSyntheticsWillInjectRum` option is here to bypass this condition.
        if (ignoreInitIfSyntheticsWillInjectRum && (0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)()) {
            return;
        }
        var eventBridgeAvailable = (0,eventBridge/* canUseEventBridge */.x)();
        if (eventBridgeAvailable) {
            initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
        }
        if (!canInitRum(initConfiguration)) {
            return;
        }
        var configuration = validateAndBuildRumConfiguration(initConfiguration);
        if (!configuration) {
            return;
        }
        if (!eventBridgeAvailable && !configuration.sessionStoreStrategyType) {
            display/* display.warn */.jf.warn('No storage available for session. We will not send any data.');
            return;
        }
        if (!configuration.trackViewsManually) {
            doStartRum(initConfiguration, configuration);
        }
        else {
            // drain beforeInitCalls by buffering them until we start RUM
            // if we get a startView, drain re-buffered calls before continuing to drain beforeInitCalls
            // in order to ensure that calls are processed in order
            var beforeInitCalls = bufferApiCalls;
            bufferApiCalls = new boundedBuffer/* BoundedBuffer */.S();
            startViewStrategy = function (options) {
                doStartRum(initConfiguration, configuration, options);
            };
            beforeInitCalls.drain();
        }
        isAlreadyInitialized = true;
    }
    function doStartRum(initConfiguration, configuration, initialViewOptions) {
        if (initConfiguration.storeContextsAcrossPages) {
            var beforeInitGlobalContext = globalContextManager.getContext();
            globalContextManager = (0,storedContextManager/* createStoredContextManager */.PI)(configuration, RUM_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */);
            globalContextManager.setContext((0,mergeInto/* combine */.$e)(globalContextManager.getContext(), beforeInitGlobalContext));
            var beforeInitUserContext = userContextManager.getContext();
            userContextManager = (0,storedContextManager/* createStoredContextManager */.PI)(configuration, RUM_STORAGE_KEY, 1 /* CustomerDataType.User */);
            userContextManager.setContext((0,mergeInto/* combine */.$e)(userContextManager.getContext(), beforeInitUserContext));
        }
        var startRumResults = startRumImpl(initConfiguration, configuration, recorderApi, globalContextManager, userContextManager, initialViewOptions);
        getSessionReplayLinkStrategy = function () {
            return recorderApi.getSessionReplayLink(configuration, startRumResults.session, startRumResults.viewContexts);
        };
        (startViewStrategy = startRumResults.startView, addActionStrategy = startRumResults.addAction, addErrorStrategy = startRumResults.addError, addTimingStrategy = startRumResults.addTiming, addFeatureFlagEvaluationStrategy = startRumResults.addFeatureFlagEvaluation, getInternalContextStrategy = startRumResults.getInternalContext, stopSessionStrategy = startRumResults.stopSession);
        bufferApiCalls.drain();
        recorderApi.onRumStart(startRumResults.lifeCycle, configuration, startRumResults.session, startRumResults.viewContexts);
    }
    var startView = (0,monitor/* monitor */.zk)(function (options) {
        var sanitizedOptions = typeof options === 'object' ? options : { name: options };
        startViewStrategy(sanitizedOptions);
    });
    var rumPublicApi = (0,init/* makePublicApi */.r)({
        init: (0,monitor/* monitor */.zk)(initRum),
        /** @deprecated: use setGlobalContextProperty instead */
        addRumGlobalContext: (0,monitor/* monitor */.zk)(function (key, value) { return globalContextManager.add(key, value); }),
        setGlobalContextProperty: (0,monitor/* monitor */.zk)(function (key, value) { return globalContextManager.setContextProperty(key, value); }),
        /** @deprecated: use removeGlobalContextProperty instead */
        removeRumGlobalContext: (0,monitor/* monitor */.zk)(function (key) { return globalContextManager.remove(key); }),
        removeGlobalContextProperty: (0,monitor/* monitor */.zk)(function (key) { return globalContextManager.removeContextProperty(key); }),
        /** @deprecated: use getGlobalContext instead */
        getRumGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.get(); }),
        getGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.getContext(); }),
        /** @deprecated: use setGlobalContext instead */
        setRumGlobalContext: (0,monitor/* monitor */.zk)(function (context) { return globalContextManager.set(context); }),
        setGlobalContext: (0,monitor/* monitor */.zk)(function (context) { return globalContextManager.setContext(context); }),
        clearGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.clearContext(); }),
        getInternalContext: (0,monitor/* monitor */.zk)(function (startTime) { return getInternalContextStrategy(startTime); }),
        getInitConfiguration: (0,monitor/* monitor */.zk)(function () { return getInitConfigurationStrategy(); }),
        addAction: (0,monitor/* monitor */.zk)(function (name, context) {
            addActionStrategy({
                name: (0,sanitize/* sanitize */.N)(name),
                context: (0,sanitize/* sanitize */.N)(context),
                startClocks: (0,timeUtils/* clocksNow */.$I)(),
                type: "custom" /* ActionType.CUSTOM */,
            });
        }),
        addError: function (error, context) {
            var handlingStack = (0,error_error/* createHandlingStack */.Xp)();
            (0,monitor/* callMonitored */.L6)(function () {
                addErrorStrategy({
                    error: error,
                    handlingStack: handlingStack,
                    context: (0,sanitize/* sanitize */.N)(context),
                    startClocks: (0,timeUtils/* clocksNow */.$I)(),
                });
            });
        },
        addTiming: (0,monitor/* monitor */.zk)(function (name, time) {
            addTimingStrategy((0,sanitize/* sanitize */.N)(name), time);
        }),
        setUser: (0,monitor/* monitor */.zk)(function (newUser) {
            if ((0,user/* checkUser */.z)(newUser)) {
                userContextManager.setContext((0,user/* sanitizeUser */.I)(newUser));
            }
        }),
        getUser: (0,monitor/* monitor */.zk)(function () { return userContextManager.getContext(); }),
        setUserProperty: (0,monitor/* monitor */.zk)(function (key, property) {
            var _a;
            var sanitizedProperty = (0,user/* sanitizeUser */.I)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: (0,monitor/* monitor */.zk)(function (key) { return userContextManager.removeContextProperty(key); }),
        /** @deprecated: renamed to clearUser */
        removeUser: (0,monitor/* monitor */.zk)(function () { return userContextManager.clearContext(); }),
        clearUser: (0,monitor/* monitor */.zk)(function () { return userContextManager.clearContext(); }),
        startView: startView,
        stopSession: (0,monitor/* monitor */.zk)(function () {
            stopSessionStrategy();
        }),
        startSessionReplayRecording: (0,monitor/* monitor */.zk)(recorderApi.start),
        stopSessionReplayRecording: (0,monitor/* monitor */.zk)(recorderApi.stop),
        /**
         * This feature is currently in beta. For more information see the full [feature flag tracking guide](https://docs.datadoghq.com/real_user_monitoring/feature_flag_tracking/).
         */
        addFeatureFlagEvaluation: (0,monitor/* monitor */.zk)(function (key, value) {
            addFeatureFlagEvaluationStrategy((0,sanitize/* sanitize */.N)(key), (0,sanitize/* sanitize */.N)(value));
        }),
        getSessionReplayLink: (0,monitor/* monitor */.zk)(function () { return getSessionReplayLinkStrategy(); }),
    });
    return rumPublicApi;
    function canInitRum(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                display/* display.error */.jf.error('DD_RUM is already initialized.');
            }
            return false;
        }
        return true;
    }
    function overrideInitConfigurationForBridge(initConfiguration) {
        return (0,polyfills/* assign */.f0)({}, initConfiguration, {
            applicationId: '00000000-aaaa-0000-aaaa-000000000000',
            clientToken: 'empty',
            sessionSampleRate: 100,
        });
    }
}
//# sourceMappingURL=rumPublicApi.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(15017);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry_telemetry = __webpack_require__(41887);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js
var browser_pageExitObservable = __webpack_require__(19609);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/observable.js
var tools_observable = __webpack_require__(87658);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/getZoneJsOriginalValue.js
var getZoneJsOriginalValue = __webpack_require__(56376);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/browser/domMutationObservable.js

function createDOMMutationObservable() {
    var MutationObserver = getMutationObserverConstructor();
    var observable = new tools_observable/* Observable */.y(function () {
        if (!MutationObserver) {
            return;
        }
        var observer = new MutationObserver((0,monitor/* monitor */.zk)(function () { return observable.notify(); }));
        observer.observe(document, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        });
        return function () { return observer.disconnect(); };
    });
    return observable;
}
function getMutationObserverConstructor() {
    var constructor;
    var browserWindow = window;
    // Angular uses Zone.js to provide a context persisting across async tasks.  Zone.js replaces the
    // global MutationObserver constructor with a patched version to support the context propagation.
    // There is an ongoing issue[1][2] with this setup when using a MutationObserver within a Angular
    // component: on some occasions, the callback is being called in an infinite loop, causing the
    // page to freeze (even if the callback is completely empty).
    //
    // To work around this issue, we try to get the original MutationObserver constructor stored by
    // Zone.js.
    //
    // [1] https://github.com/angular/angular/issues/26948
    // [2] https://github.com/angular/angular/issues/31712
    if (browserWindow.Zone) {
        // Zone.js 0.8.6+ is storing original class constructors into the browser 'window' object[3].
        //
        // [3] https://github.com/angular/angular/blob/6375fa79875c0fe7b815efc45940a6e6f5c9c9eb/packages/zone.js/lib/common/utils.ts#L288
        constructor = (0,getZoneJsOriginalValue/* getZoneJsOriginalValue */.I)(browserWindow, 'MutationObserver');
        if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) {
            // Anterior Zone.js versions (used in Angular 2) does not expose the original MutationObserver
            // in the 'window' object. Luckily, the patched MutationObserver class is storing an original
            // instance in its properties[4]. Let's get the original MutationObserver constructor from
            // there.
            //
            // [4] https://github.com/angular/zone.js/blob/v0.8.5/lib/common/utils.ts#L412
            var patchedInstance = new browserWindow.MutationObserver(functionUtils/* noop */.Z);
            var originalInstance = (0,getZoneJsOriginalValue/* getZoneJsOriginalValue */.I)(patchedInstance, 'originalInstance');
            constructor = originalInstance && originalInstance.constructor;
        }
    }
    if (!constructor) {
        constructor = browserWindow.MutationObserver;
    }
    return constructor;
}
//# sourceMappingURL=domMutationObservable.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/timer.js
var timer = __webpack_require__(48399);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/addEventListener.js
var addEventListener = __webpack_require__(7411);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/runOnReadyState.js

function runOnReadyState(configuration, expectedReadyState, callback) {
    if (document.readyState === expectedReadyState || document.readyState === 'complete') {
        callback();
    }
    else {
        var eventName = expectedReadyState === 'complete' ? "load" /* DOM_EVENT.LOAD */ : "DOMContentLoaded" /* DOM_EVENT.DOM_CONTENT_LOADED */;
        (0,addEventListener/* addEventListener */.O)(configuration, window, eventName, callback, { once: true });
    }
}
//# sourceMappingURL=runOnReadyState.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/resource/resourceUtils.js

var FAKE_INITIAL_DOCUMENT = 'initial_document';
var RESOURCE_TYPES = [
    ["document" /* ResourceType.DOCUMENT */, function (initiatorType) { return FAKE_INITIAL_DOCUMENT === initiatorType; }],
    ["xhr" /* ResourceType.XHR */, function (initiatorType) { return 'xmlhttprequest' === initiatorType; }],
    ["fetch" /* ResourceType.FETCH */, function (initiatorType) { return 'fetch' === initiatorType; }],
    ["beacon" /* ResourceType.BEACON */, function (initiatorType) { return 'beacon' === initiatorType; }],
    ["css" /* ResourceType.CSS */, function (_, path) { return /\.css$/i.test(path); }],
    ["js" /* ResourceType.JS */, function (_, path) { return /\.js$/i.test(path); }],
    [
        "image" /* ResourceType.IMAGE */,
        function (initiatorType, path) {
            return (0,polyfills/* includes */.q9)(['image', 'img', 'icon'], initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null;
        },
    ],
    ["font" /* ResourceType.FONT */, function (_, path) { return /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null; }],
    [
        "media" /* ResourceType.MEDIA */,
        function (initiatorType, path) {
            return (0,polyfills/* includes */.q9)(['audio', 'video'], initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null;
        },
    ],
];
function computeResourceKind(timing) {
    var url = timing.name;
    if (!(0,urlPolyfill/* isValidUrl */.jv)(url)) {
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)("Failed to construct URL for \"".concat(timing.name, "\""));
        return "other" /* ResourceType.OTHER */;
    }
    var path = (0,urlPolyfill/* getPathName */.ye)(url);
    for (var _i = 0, RESOURCE_TYPES_1 = RESOURCE_TYPES; _i < RESOURCE_TYPES_1.length; _i++) {
        var _a = RESOURCE_TYPES_1[_i], type = _a[0], isType = _a[1];
        if (isType(timing.initiatorType, path)) {
            return type;
        }
    }
    return "other" /* ResourceType.OTHER */;
}
function areInOrder() {
    var numbers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        numbers[_i] = arguments[_i];
    }
    for (var i = 1; i < numbers.length; i += 1) {
        if (numbers[i - 1] > numbers[i]) {
            return false;
        }
    }
    return true;
}
function isRequestKind(timing) {
    return timing.initiatorType === 'xmlhttprequest' || timing.initiatorType === 'fetch';
}
function computePerformanceResourceDuration(entry) {
    var duration = entry.duration, startTime = entry.startTime, responseEnd = entry.responseEnd;
    // Safari duration is always 0 on timings blocked by cross origin policies.
    if (duration === 0 && startTime < responseEnd) {
        return (0,timeUtils/* toServerDuration */.c0)((0,timeUtils/* elapsed */._J)(startTime, responseEnd));
    }
    return (0,timeUtils/* toServerDuration */.c0)(duration);
}
function computePerformanceResourceDetails(entry) {
    var validEntry = toValidEntry(entry);
    if (!validEntry) {
        return undefined;
    }
    var startTime = validEntry.startTime, fetchStart = validEntry.fetchStart, redirectStart = validEntry.redirectStart, redirectEnd = validEntry.redirectEnd, domainLookupStart = validEntry.domainLookupStart, domainLookupEnd = validEntry.domainLookupEnd, connectStart = validEntry.connectStart, secureConnectionStart = validEntry.secureConnectionStart, connectEnd = validEntry.connectEnd, requestStart = validEntry.requestStart, responseStart = validEntry.responseStart, responseEnd = validEntry.responseEnd;
    var details = {
        download: formatTiming(startTime, responseStart, responseEnd),
        first_byte: formatTiming(startTime, requestStart, responseStart),
    };
    // Make sure a connection occurred
    if (connectEnd !== fetchStart) {
        details.connect = formatTiming(startTime, connectStart, connectEnd);
        // Make sure a secure connection occurred
        if (areInOrder(connectStart, secureConnectionStart, connectEnd)) {
            details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
        }
    }
    // Make sure a domain lookup occurred
    if (domainLookupEnd !== fetchStart) {
        details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
    }
    if (hasRedirection(entry)) {
        details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
    }
    return details;
}
function toValidEntry(entry) {
    // Ensure timings are in the right order. On top of filtering out potential invalid
    // RumPerformanceResourceTiming, it will ignore entries from requests where timings cannot be
    // collected, for example cross origin requests without a "Timing-Allow-Origin" header allowing
    // it.
    if (!areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd)) {
        return undefined;
    }
    if (!hasRedirection(entry)) {
        return entry;
    }
    var redirectStart = entry.redirectStart, redirectEnd = entry.redirectEnd;
    // Firefox doesn't provide redirect timings on cross origin requests.
    // Provide a default for those.
    if (redirectStart < entry.startTime) {
        redirectStart = entry.startTime;
    }
    if (redirectEnd < entry.startTime) {
        redirectEnd = entry.fetchStart;
    }
    // Make sure redirect timings are in order
    if (!areInOrder(entry.startTime, redirectStart, redirectEnd, entry.fetchStart)) {
        return undefined;
    }
    return (0,polyfills/* assign */.f0)({}, entry, {
        redirectEnd: redirectEnd,
        redirectStart: redirectStart,
    });
}
function hasRedirection(entry) {
    // The only time fetchStart is different than startTime is if a redirection occurred.
    return entry.fetchStart !== entry.startTime;
}
function formatTiming(origin, start, end) {
    return {
        duration: (0,timeUtils/* toServerDuration */.c0)((0,timeUtils/* elapsed */._J)(start, end)),
        start: (0,timeUtils/* toServerDuration */.c0)((0,timeUtils/* elapsed */._J)(origin, start)),
    };
}
function computeSize(entry) {
    // Make sure a request actually occurred
    if (entry.startTime < entry.responseStart) {
        return entry.decodedBodySize;
    }
    return undefined;
}
function isAllowedRequestUrl(configuration, url) {
    return url && !configuration.isIntakeUrl(url);
}
//# sourceMappingURL=resourceUtils.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.js
var stringUtils = __webpack_require__(61206);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/browser/htmlDomUtils.js
function isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function isCommentNode(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
function isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function isNodeShadowHost(node) {
    return isElementNode(node) && Boolean(node.shadowRoot);
}
function isNodeShadowRoot(node) {
    var shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && isElementNode(shadowRoot.host);
}
function hasChildNodes(node) {
    return node.childNodes.length > 0 || isNodeShadowHost(node);
}
function forEachChildNodes(node, callback) {
    node.childNodes.forEach(callback);
    if (isNodeShadowHost(node)) {
        callback(node.shadowRoot);
    }
}
/**
 * Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
 */
function getParentNode(node) {
    return isNodeShadowRoot(node) ? node.host : node.parentNode;
}
//# sourceMappingURL=htmlDomUtils.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/tracing/getDocumentTraceId.js


var INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * timeUtils/* ONE_MINUTE */.yR;
function getDocumentTraceId(document) {
    var data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
    if (!data || data.traceTime <= (0,timeUtils/* dateNow */.m6)() - INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) {
        return undefined;
    }
    return data.traceId;
}
function getDocumentTraceDataFromMeta(document) {
    var traceIdMeta = document.querySelector('meta[name=dd-trace-id]');
    var traceTimeMeta = document.querySelector('meta[name=dd-trace-time]');
    return createDocumentTraceData(traceIdMeta && traceIdMeta.content, traceTimeMeta && traceTimeMeta.content);
}
function getDocumentTraceDataFromComment(document) {
    var comment = findTraceComment(document);
    if (!comment) {
        return undefined;
    }
    return createDocumentTraceData((0,stringUtils/* findCommaSeparatedValue */.MY)(comment, 'trace-id'), (0,stringUtils/* findCommaSeparatedValue */.MY)(comment, 'trace-time'));
}
function createDocumentTraceData(traceId, rawTraceTime) {
    var traceTime = rawTraceTime && Number(rawTraceTime);
    if (!traceId || !traceTime) {
        return undefined;
    }
    return {
        traceId: traceId,
        traceTime: traceTime,
    };
}
function findTraceComment(document) {
    // 1. Try to find the comment as a direct child of the document
    // Note: TSLint advises to use a 'for of', but TS doesn't allow to use 'for of' if the iterated
    // value is not an array or string (here, a NodeList).
    for (var i = 0; i < document.childNodes.length; i += 1) {
        var comment = getTraceCommentFromNode(document.childNodes[i]);
        if (comment) {
            return comment;
        }
    }
    // 2. If the comment is placed after the </html> tag, but have some space or new lines before or
    // after, the DOM parser will lift it (and the surrounding text) at the end of the <body> tag.
    // Try to look for the comment at the end of the <body> by by iterating over its child nodes in
    // reverse order, stopping if we come across a non-text node.
    if (document.body) {
        for (var i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
            var node = document.body.childNodes[i];
            var comment = getTraceCommentFromNode(node);
            if (comment) {
                return comment;
            }
            if (!isTextNode(node)) {
                break;
            }
        }
    }
}
function getTraceCommentFromNode(node) {
    if (node && isCommentNode(node)) {
        var match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
        if (match) {
            return match[1];
        }
    }
}
//# sourceMappingURL=getDocumentTraceId.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/browser/performanceCollection.js



// We want to use a real enum (i.e. not a const enum) here, to be able to check whether an arbitrary
// string is an expected performance entry
// eslint-disable-next-line no-restricted-syntax
var RumPerformanceEntryType;
(function (RumPerformanceEntryType) {
    RumPerformanceEntryType["EVENT"] = "event";
    RumPerformanceEntryType["FIRST_INPUT"] = "first-input";
    RumPerformanceEntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
    RumPerformanceEntryType["LAYOUT_SHIFT"] = "layout-shift";
    RumPerformanceEntryType["LONG_TASK"] = "longtask";
    RumPerformanceEntryType["NAVIGATION"] = "navigation";
    RumPerformanceEntryType["PAINT"] = "paint";
    RumPerformanceEntryType["RESOURCE"] = "resource";
})(RumPerformanceEntryType || (RumPerformanceEntryType = {}));
function supportPerformanceObject() {
    return window.performance !== undefined && 'getEntries' in performance;
}
function supportPerformanceTimingEvent(entryType) {
    return (window.PerformanceObserver &&
        PerformanceObserver.supportedEntryTypes !== undefined &&
        PerformanceObserver.supportedEntryTypes.includes(entryType));
}
function startPerformanceCollection(lifeCycle, configuration) {
    retrieveInitialDocumentResourceTiming(configuration, function (timing) {
        handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
    });
    if (supportPerformanceObject()) {
        var performanceEntries_1 = performance.getEntries();
        // Because the performance entry list can be quite large
        // delay the computation to prevent the SDK from blocking the main thread on init
        (0,timer/* setTimeout */.iK)(function () { return handleRumPerformanceEntries(lifeCycle, configuration, performanceEntries_1); });
    }
    if (window.PerformanceObserver) {
        var handlePerformanceEntryList_1 = (0,monitor/* monitor */.zk)(function (entries) {
            return handleRumPerformanceEntries(lifeCycle, configuration, entries.getEntries());
        });
        var mainEntries = [
            RumPerformanceEntryType.RESOURCE,
            RumPerformanceEntryType.NAVIGATION,
            RumPerformanceEntryType.LONG_TASK,
            RumPerformanceEntryType.PAINT,
        ];
        var experimentalEntries = [
            RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT,
            RumPerformanceEntryType.FIRST_INPUT,
            RumPerformanceEntryType.LAYOUT_SHIFT,
            RumPerformanceEntryType.EVENT,
        ];
        try {
            // Experimental entries are not retrieved by performance.getEntries()
            // use a single PerformanceObserver with buffered flag by type
            // to get values that could happen before SDK init
            experimentalEntries.forEach(function (type) {
                var observer = new window.PerformanceObserver(handlePerformanceEntryList_1);
                observer.observe({
                    type: type,
                    buffered: true,
                    // durationThreshold only impact PerformanceEventTiming entries used for INP computation which requires a threshold at 40 (default is 104ms)
                    // cf: https://github.com/GoogleChrome/web-vitals/blob/3806160ffbc93c3c4abf210a167b81228172b31c/src/onINP.ts#L209
                    durationThreshold: 40,
                });
            });
        }
        catch (e) {
            // Some old browser versions (ex: chrome 67) don't support the PerformanceObserver type and buffered options
            // In these cases, fallback to PerformanceObserver with entryTypes
            mainEntries.push.apply(mainEntries, experimentalEntries);
        }
        var mainObserver = new PerformanceObserver(handlePerformanceEntryList_1);
        mainObserver.observe({ entryTypes: mainEntries });
        if (supportPerformanceObject() && 'addEventListener' in performance) {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1559377
            (0,addEventListener/* addEventListener */.O)(configuration, performance, 'resourcetimingbufferfull', function () {
                performance.clearResourceTimings();
            });
        }
    }
    if (!supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION)) {
        retrieveNavigationTiming(configuration, function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
    if (!supportPerformanceTimingEvent(RumPerformanceEntryType.FIRST_INPUT)) {
        retrieveFirstInputTiming(configuration, function (timing) {
            handleRumPerformanceEntries(lifeCycle, configuration, [timing]);
        });
    }
}
function retrieveInitialDocumentResourceTiming(configuration, callback) {
    runOnReadyState(configuration, 'interactive', function () {
        var timing;
        var forcedAttributes = {
            entryType: RumPerformanceEntryType.RESOURCE,
            initiatorType: FAKE_INITIAL_DOCUMENT,
            traceId: getDocumentTraceId(document),
            toJSON: function () { return (0,polyfills/* assign */.f0)({}, timing, { toJSON: undefined }); },
        };
        if (supportPerformanceTimingEvent(RumPerformanceEntryType.NAVIGATION) &&
            performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION).length > 0) {
            var navigationEntry = performance.getEntriesByType(RumPerformanceEntryType.NAVIGATION)[0];
            timing = (0,polyfills/* assign */.f0)(navigationEntry.toJSON(), forcedAttributes);
        }
        else {
            var relativePerformanceTiming = computeRelativePerformanceTiming();
            timing = (0,polyfills/* assign */.f0)(relativePerformanceTiming, {
                decodedBodySize: 0,
                duration: relativePerformanceTiming.responseEnd,
                name: window.location.href,
                startTime: 0,
            }, forcedAttributes);
        }
        callback(timing);
    });
}
function retrieveNavigationTiming(configuration, callback) {
    function sendFakeTiming() {
        callback((0,polyfills/* assign */.f0)(computeRelativePerformanceTiming(), {
            entryType: RumPerformanceEntryType.NAVIGATION,
        }));
    }
    runOnReadyState(configuration, 'complete', function () {
        // Send it a bit after the actual load event, so the "loadEventEnd" timing is accurate
        (0,timer/* setTimeout */.iK)(sendFakeTiming);
    });
}
/**
 * first-input timing entry polyfill based on
 * https://github.com/GoogleChrome/web-vitals/blob/master/src/lib/polyfills/firstInputPolyfill.ts
 */
function retrieveFirstInputTiming(configuration, callback) {
    var startTimeStamp = (0,timeUtils/* dateNow */.m6)();
    var timingSent = false;
    var removeEventListeners = (0,addEventListener/* addEventListeners */.y)(configuration, window, ["click" /* DOM_EVENT.CLICK */, "mousedown" /* DOM_EVENT.MOUSE_DOWN */, "keydown" /* DOM_EVENT.KEY_DOWN */, "touchstart" /* DOM_EVENT.TOUCH_START */, "pointerdown" /* DOM_EVENT.POINTER_DOWN */], function (evt) {
        // Only count cancelable events, which should trigger behavior important to the user.
        if (!evt.cancelable) {
            return;
        }
        // This timing will be used to compute the "first Input delay", which is the delta between
        // when the system received the event (e.g. evt.timeStamp) and when it could run the callback
        // (e.g. performance.now()).
        var timing = {
            entryType: RumPerformanceEntryType.FIRST_INPUT,
            processingStart: (0,timeUtils/* relativeNow */._q)(),
            processingEnd: (0,timeUtils/* relativeNow */._q)(),
            startTime: evt.timeStamp,
            duration: 0,
            name: '',
        };
        if (evt.type === "pointerdown" /* DOM_EVENT.POINTER_DOWN */) {
            sendTimingIfPointerIsNotCancelled(configuration, timing);
        }
        else {
            sendTiming(timing);
        }
    }, { passive: true, capture: true }).stop;
    /**
     * Pointer events are a special case, because they can trigger main or compositor thread behavior.
     * We differentiate these cases based on whether or not we see a pointercancel event, which are
     * fired when we scroll. If we're scrolling we don't need to report input delay since FID excludes
     * scrolling and pinch/zooming.
     */
    function sendTimingIfPointerIsNotCancelled(configuration, timing) {
        (0,addEventListener/* addEventListeners */.y)(configuration, window, ["pointerup" /* DOM_EVENT.POINTER_UP */, "pointercancel" /* DOM_EVENT.POINTER_CANCEL */], function (event) {
            if (event.type === "pointerup" /* DOM_EVENT.POINTER_UP */) {
                sendTiming(timing);
            }
        }, { once: true });
    }
    function sendTiming(timing) {
        if (!timingSent) {
            timingSent = true;
            removeEventListeners();
            // In some cases the recorded delay is clearly wrong, e.g. it's negative or it's larger than
            // the time between now and when the page was loaded.
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/4
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/6
            // - https://github.com/GoogleChromeLabs/first-input-delay/issues/7
            var delay = timing.processingStart - timing.startTime;
            if (delay >= 0 && delay < (0,timeUtils/* dateNow */.m6)() - startTimeStamp) {
                callback(timing);
            }
        }
    }
}
function computeRelativePerformanceTiming() {
    var result = {};
    var timing = performance.timing;
    for (var key in timing) {
        if ((0,numberUtils/* isNumber */.hj)(timing[key])) {
            var numberKey = key;
            var timingElement = timing[numberKey];
            result[numberKey] = timingElement === 0 ? 0 : (0,timeUtils/* getRelativeTime */.ni)(timingElement);
        }
    }
    return result;
}
function handleRumPerformanceEntries(lifeCycle, configuration, entries) {
    var rumPerformanceEntries = entries.filter(function (entry) {
        return (0,objectUtils/* objectHasValue */.E5)(RumPerformanceEntryType, entry.entryType);
    });
    var rumAllowedPerformanceEntries = rumPerformanceEntries.filter(function (entry) { return !isIncompleteNavigation(entry) && !isForbiddenResource(configuration, entry); });
    if (rumAllowedPerformanceEntries.length) {
        lifeCycle.notify(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, rumAllowedPerformanceEntries);
    }
}
function isIncompleteNavigation(entry) {
    return entry.entryType === RumPerformanceEntryType.NAVIGATION && entry.loadEventEnd <= 0;
}
function isForbiddenResource(configuration, entry) {
    return entry.entryType === RumPerformanceEntryType.RESOURCE && !isAllowedRequestUrl(configuration, entry.name);
}
//# sourceMappingURL=performanceCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/eventRateLimiter/createEventRateLimiter.js
var createEventRateLimiter = __webpack_require__(76427);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/syntheticsContext.js

function getSyntheticsContext() {
    var testId = (0,syntheticsWorkerValues/* getSyntheticsTestId */.L7)();
    var resultId = (0,syntheticsWorkerValues/* getSyntheticsResultId */.QB)();
    if (testId && resultId) {
        return {
            test_id: testId,
            result_id: resultId,
            injected: (0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)(),
        };
    }
}
//# sourceMappingURL=syntheticsContext.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/ciTestContext.js
function getCiTestContext() {
    var _a;
    var testExecutionId = (_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId');
    if (typeof testExecutionId === 'string') {
        return {
            test_execution_id: testExecutionId,
        };
    }
}
//# sourceMappingURL=ciTestContext.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/limitModification.js

/**
 * Current limitation:
 * - field path do not support array, 'a.b.c' only
 */
function limitModification(object, modifiableFieldPaths, modifier) {
    var clone = (0,mergeInto/* deepClone */.I8)(object);
    var result = modifier(clone);
    (0,polyfills/* objectEntries */.qP)(modifiableFieldPaths).forEach(function (_a) {
        var fieldPath = _a[0], fieldType = _a[1];
        var newValue = get(clone, fieldPath);
        var newType = (0,typeUtils/* getType */.o)(newValue);
        if (newType === fieldType) {
            set(object, fieldPath, (0,sanitize/* sanitize */.N)(newValue));
        }
        else if (fieldType === 'object' && (newType === 'undefined' || newType === 'null')) {
            set(object, fieldPath, {});
        }
    });
    return result;
}
function get(object, path) {
    var current = object;
    for (var _i = 0, _a = path.split('.'); _i < _a.length; _i++) {
        var field = _a[_i];
        if (!isValidObjectContaining(current, field)) {
            return;
        }
        current = current[field];
    }
    return current;
}
function set(object, path, value) {
    var current = object;
    var fields = path.split('.');
    for (var i = 0; i < fields.length; i += 1) {
        var field = fields[i];
        if (!isValidObject(current)) {
            return;
        }
        if (i !== fields.length - 1) {
            current = current[field];
        }
        else {
            current[field] = value;
        }
    }
}
function isValidObject(object) {
    return (0,typeUtils/* getType */.o)(object) === 'object';
}
function isValidObjectContaining(object, field) {
    return isValidObject(object) && Object.prototype.hasOwnProperty.call(object, field);
}
//# sourceMappingURL=limitModification.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/assembly.js




var VIEW_MODIFIABLE_FIELD_PATHS = {
    'view.name': 'string',
    'view.url': 'string',
    'view.referrer': 'string',
};
var USER_CUSTOMIZABLE_FIELD_PATHS = {
    context: 'object',
};
var modifiableFieldPathsByEvent;
function startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, buildCommonContext, reportError) {
    var _a, _b;
    modifiableFieldPathsByEvent = (_a = {},
        _a["view" /* RumEventType.VIEW */] = VIEW_MODIFIABLE_FIELD_PATHS,
        _a["error" /* RumEventType.ERROR */] = (0,polyfills/* assign */.f0)({
            'error.message': 'string',
            'error.stack': 'string',
            'error.resource.url': 'string',
            'error.fingerprint': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["resource" /* RumEventType.RESOURCE */] = (0,polyfills/* assign */.f0)({
            'resource.url': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["action" /* RumEventType.ACTION */] = (0,polyfills/* assign */.f0)({
            'action.target.name': 'string',
        }, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a["long_task" /* RumEventType.LONG_TASK */] = (0,polyfills/* assign */.f0)({}, USER_CUSTOMIZABLE_FIELD_PATHS, VIEW_MODIFIABLE_FIELD_PATHS),
        _a);
    var eventRateLimiters = (_b = {},
        _b["error" /* RumEventType.ERROR */] = (0,createEventRateLimiter/* createEventRateLimiter */.K)("error" /* RumEventType.ERROR */, configuration.eventRateLimiterThreshold, reportError),
        _b["action" /* RumEventType.ACTION */] = (0,createEventRateLimiter/* createEventRateLimiter */.K)("action" /* RumEventType.ACTION */, configuration.eventRateLimiterThreshold, reportError),
        _b);
    var syntheticsContext = getSyntheticsContext();
    var ciTestContext = getCiTestContext();
    lifeCycle.subscribe(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (_a) {
        var startTime = _a.startTime, rawRumEvent = _a.rawRumEvent, domainContext = _a.domainContext, savedCommonContext = _a.savedCommonContext, customerContext = _a.customerContext;
        var viewContext = viewContexts.findView(startTime);
        var urlContext = urlContexts.findUrl(startTime);
        var session = sessionManager.findTrackedSession(startTime);
        if (session && viewContext && urlContext) {
            var commonContext = savedCommonContext || buildCommonContext();
            var actionId = actionContexts.findActionId(startTime);
            var rumContext = {
                _dd: {
                    format_version: 2,
                    drift: (0,timeUtils/* currentDrift */.QA)(),
                    session: {
                        plan: session.plan,
                    },
                    configuration: {
                        session_sample_rate: (0,numberUtils/* round */.NM)(configuration.sessionSampleRate, 3),
                        session_replay_sample_rate: (0,numberUtils/* round */.NM)(configuration.sessionReplaySampleRate, 3),
                    },
                    browser_sdk_version: (0,eventBridge/* canUseEventBridge */.x)() ? "4.50.1" : undefined,
                },
                application: {
                    id: configuration.applicationId,
                },
                date: (0,timeUtils/* timeStampNow */.n$)(),
                service: viewContext.service || configuration.service,
                version: viewContext.version || configuration.version,
                source: 'browser',
                session: {
                    id: session.id,
                    type: syntheticsContext ? "synthetics" /* SessionType.SYNTHETICS */ : ciTestContext ? "ci_test" /* SessionType.CI_TEST */ : "user" /* SessionType.USER */,
                },
                view: {
                    id: viewContext.id,
                    name: viewContext.name,
                    url: urlContext.url,
                    referrer: urlContext.referrer,
                },
                action: needToAssembleWithAction(rawRumEvent) && actionId ? { id: actionId } : undefined,
                synthetics: syntheticsContext,
                ci_test: ciTestContext,
                display: displayContext.get(),
            };
            var serverRumEvent = (0,mergeInto/* combine */.$e)(rumContext, rawRumEvent);
            serverRumEvent.context = (0,mergeInto/* combine */.$e)(commonContext.context, customerContext);
            if (!('has_replay' in serverRumEvent.session)) {
                ;
                serverRumEvent.session.has_replay = commonContext.hasReplay;
            }
            if (!(0,objectUtils/* isEmptyObject */.Qr)(commonContext.user)) {
                ;
                serverRumEvent.usr = commonContext.user;
            }
            if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
                if ((0,objectUtils/* isEmptyObject */.Qr)(serverRumEvent.context)) {
                    delete serverRumEvent.context;
                }
                lifeCycle.notify(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, serverRumEvent);
            }
        }
    });
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
    var _a;
    if (beforeSend) {
        var result = limitModification(event, modifiableFieldPathsByEvent[event.type], function (event) {
            return beforeSend(event, domainContext);
        });
        if (result === false && event.type !== "view" /* RumEventType.VIEW */) {
            return false;
        }
        if (result === false) {
            display/* display.warn */.jf.warn("Can't dismiss view events using beforeSend!");
        }
    }
    var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
    return !rateLimitReached;
}
function needToAssembleWithAction(event) {
    return ["error" /* RumEventType.ERROR */, "resource" /* RumEventType.RESOURCE */, "long_task" /* RumEventType.LONG_TASK */].indexOf(event.type) !== -1;
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/internalContext.js
/**
 * Internal context keep returning v1 format
 * to not break compatibility with logs data format
 */
function startInternalContext(applicationId, sessionManager, viewContexts, actionContexts, urlContexts) {
    return {
        get: function (startTime) {
            var viewContext = viewContexts.findView(startTime);
            var urlContext = urlContexts.findUrl(startTime);
            var session = sessionManager.findTrackedSession(startTime);
            if (session && viewContext && urlContext) {
                var actionId = actionContexts.findActionId(startTime);
                return {
                    application_id: applicationId,
                    session_id: session.id,
                    user_action: actionId ? { id: actionId } : undefined,
                    view: { id: viewContext.id, name: viewContext.name, referrer: urlContext.referrer, url: urlContext.url },
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/abstractLifeCycle.js
var abstractLifeCycle = __webpack_require__(77357);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/lifeCycle.js

var LifeCycle = (abstractLifeCycle/* AbstractLifeCycle */.l);
//# sourceMappingURL=lifeCycle.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.js
var sessionConstants = __webpack_require__(26216);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/valueHistory.js
var valueHistory = __webpack_require__(53769);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/viewContexts.js

var VIEW_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
function startViewContexts(lifeCycle) {
    var viewContextHistory = new valueHistory/* ValueHistory */.P(VIEW_CONTEXT_TIME_OUT_DELAY);
    lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (view) {
        viewContextHistory.add(buildViewContext(view), view.startClocks.relative);
    });
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        viewContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        viewContextHistory.reset();
    });
    function buildViewContext(view) {
        return {
            service: view.service,
            version: view.version,
            id: view.id,
            name: view.name,
            startClocks: view.startClocks,
        };
    }
    return {
        findView: function (startTime) { return viewContextHistory.find(startTime); },
        stop: function () {
            viewContextHistory.stop();
        },
    };
}
//# sourceMappingURL=viewContexts.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/xhrObservable.js
var xhrObservable = __webpack_require__(76842);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/fetchObservable.js
var fetchObservable = __webpack_require__(96817);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
var responseUtils = __webpack_require__(98744);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/readBytesFromStream.js
var readBytesFromStream = __webpack_require__(57717);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/requestCollection.js



var nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager) {
    var tracer = startTracer(configuration, sessionManager);
    trackXhr(lifeCycle, configuration, tracer);
    trackFetch(lifeCycle, configuration, tracer);
}
function trackXhr(lifeCycle, configuration, tracer) {
    var subscription = (0,xhrObservable/* initXhrObservable */.S)(configuration).subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceXhr(context, context.xhr);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'complete':
                tracer.clearTracingIfNeeded(context);
                lifeCycle.notify(6 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                    duration: context.duration,
                    method: context.method,
                    requestIndex: context.requestIndex,
                    spanId: context.spanId,
                    startClocks: context.startClocks,
                    status: context.status,
                    traceId: context.traceId,
                    traceSampled: context.traceSampled,
                    type: "xhr" /* RequestType.XHR */,
                    url: context.url,
                    xhr: context.xhr,
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function trackFetch(lifeCycle, configuration, tracer) {
    var subscription = (0,fetchObservable/* initFetchObservable */.y)().subscribe(function (rawContext) {
        var context = rawContext;
        if (!isAllowedRequestUrl(configuration, context.url)) {
            return;
        }
        switch (context.state) {
            case 'start':
                tracer.traceFetch(context);
                context.requestIndex = getNextRequestIndex();
                lifeCycle.notify(5 /* LifeCycleEventType.REQUEST_STARTED */, {
                    requestIndex: context.requestIndex,
                    url: context.url,
                });
                break;
            case 'resolve':
                waitForResponseToComplete(context, function (duration) {
                    tracer.clearTracingIfNeeded(context);
                    lifeCycle.notify(6 /* LifeCycleEventType.REQUEST_COMPLETED */, {
                        duration: duration,
                        method: context.method,
                        requestIndex: context.requestIndex,
                        responseType: context.responseType,
                        spanId: context.spanId,
                        startClocks: context.startClocks,
                        status: context.status,
                        traceId: context.traceId,
                        traceSampled: context.traceSampled,
                        type: "fetch" /* RequestType.FETCH */,
                        url: context.url,
                        response: context.response,
                        init: context.init,
                        input: context.input,
                    });
                });
                break;
        }
    });
    return { stop: function () { return subscription.unsubscribe(); } };
}
function getNextRequestIndex() {
    var result = nextRequestIndex;
    nextRequestIndex += 1;
    return result;
}
function waitForResponseToComplete(context, callback) {
    var clonedResponse = context.response && (0,responseUtils/* tryToClone */.u)(context.response);
    if (!clonedResponse || !clonedResponse.body) {
        // do not try to wait for the response if the clone failed, fetch error or null body
        callback((0,timeUtils/* elapsed */._J)(context.startClocks.timeStamp, (0,timeUtils/* timeStampNow */.n$)()));
    }
    else {
        (0,readBytesFromStream/* readBytesFromStream */.n)(clonedResponse.body, function () {
            callback((0,timeUtils/* elapsed */._J)(context.startClocks.timeStamp, (0,timeUtils/* timeStampNow */.n$)()));
        }, {
            bytesLimit: Number.POSITIVE_INFINITY,
            collectStreamBody: false,
        });
    }
}
//# sourceMappingURL=requestCollection.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/trackEventCounts.js

function trackEventCounts(_a) {
    var lifeCycle = _a.lifeCycle, isChildEvent = _a.isChildEvent, _b = _a.onChange, callback = _b === void 0 ? functionUtils/* noop */.Z : _b;
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        actionCount: 0,
        frustrationCount: 0,
    };
    var subscription = lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
        var _a;
        if (event.type === 'view' || !isChildEvent(event)) {
            return;
        }
        switch (event.type) {
            case "error" /* RumEventType.ERROR */:
                eventCounts.errorCount += 1;
                callback();
                break;
            case "action" /* RumEventType.ACTION */:
                eventCounts.actionCount += 1;
                if (event.action.frustration) {
                    eventCounts.frustrationCount += event.action.frustration.type.length;
                }
                callback();
                break;
            case "long_task" /* RumEventType.LONG_TASK */:
                eventCounts.longTaskCount += 1;
                callback();
                break;
            case "resource" /* RumEventType.RESOURCE */:
                if (!((_a = event._dd) === null || _a === void 0 ? void 0 : _a.discarded)) {
                    eventCounts.resourceCount += 1;
                    callback();
                }
                break;
        }
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackEventCounts.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/instrumentMethod.js
var instrumentMethod = __webpack_require__(11516);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/waitPageActivityEnd.js


// Delay to wait for a page activity to validate the tracking process
var PAGE_ACTIVITY_VALIDATION_DELAY = 100;
// Delay to wait after a page activity to end the tracking process
var PAGE_ACTIVITY_END_DELAY = 100;
/**
 * Wait for the page activity end
 *
 * Detection lifecycle:
 * ```
 *                        Wait page activity end
 *              .-------------------'--------------------.
 *              v                                        v
 *     [Wait for a page activity ]          [Wait for a maximum duration]
 *     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
 *          /                  \                           |
 *         v                    v                          |
 *  [No page activity]   [Page activity]                   |
 *         |                   |,----------------------.   |
 *         v                   v                       |   |
 *     (Discard)     [Wait for a page activity]        |   |
 *                   [   timeout: END_DELAY   ]        |   |
 *                       /                \            |   |
 *                      v                  v           |   |
 *             [No page activity]    [Page activity]   |   |
 *                      |                 |            |   |
 *                      |                 '------------'   |
 *                      '-----------. ,--------------------'
 *                                   v
 *                                 (End)
 * ```
 *
 * Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
 * process is still alive after maxDuration, it has been validated.
 */
function waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, pageActivityEndCallback, maxDuration) {
    var pageActivityObservable = createPageActivityObservable(lifeCycle, domMutationObservable, configuration);
    return doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration);
}
function doWaitPageActivityEnd(pageActivityObservable, pageActivityEndCallback, maxDuration) {
    var pageActivityEndTimeoutId;
    var hasCompleted = false;
    var validationTimeoutId = (0,timer/* setTimeout */.iK)((0,monitor/* monitor */.zk)(function () { return complete({ hadActivity: false }); }), PAGE_ACTIVITY_VALIDATION_DELAY);
    var maxDurationTimeoutId = maxDuration !== undefined
        ? (0,timer/* setTimeout */.iK)((0,monitor/* monitor */.zk)(function () { return complete({ hadActivity: true, end: (0,timeUtils/* timeStampNow */.n$)() }); }), maxDuration)
        : undefined;
    var pageActivitySubscription = pageActivityObservable.subscribe(function (_a) {
        var isBusy = _a.isBusy;
        (0,timer/* clearTimeout */.gr)(validationTimeoutId);
        (0,timer/* clearTimeout */.gr)(pageActivityEndTimeoutId);
        var lastChangeTime = (0,timeUtils/* timeStampNow */.n$)();
        if (!isBusy) {
            pageActivityEndTimeoutId = (0,timer/* setTimeout */.iK)((0,monitor/* monitor */.zk)(function () { return complete({ hadActivity: true, end: lastChangeTime }); }), PAGE_ACTIVITY_END_DELAY);
        }
    });
    var stop = function () {
        hasCompleted = true;
        (0,timer/* clearTimeout */.gr)(validationTimeoutId);
        (0,timer/* clearTimeout */.gr)(pageActivityEndTimeoutId);
        (0,timer/* clearTimeout */.gr)(maxDurationTimeoutId);
        pageActivitySubscription.unsubscribe();
    };
    function complete(event) {
        if (hasCompleted) {
            return;
        }
        stop();
        pageActivityEndCallback(event);
    }
    return { stop: stop };
}
function createPageActivityObservable(lifeCycle, domMutationObservable, configuration) {
    var observable = new tools_observable/* Observable */.y(function () {
        var subscriptions = [];
        var firstRequestIndex;
        var pendingRequestsCount = 0;
        subscriptions.push(domMutationObservable.subscribe(notifyPageActivity), lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
            if (entries.some(function (entry) { return entry.entryType === RumPerformanceEntryType.RESOURCE && !isExcludedUrl(configuration, entry.name); })) {
                notifyPageActivity();
            }
        }), lifeCycle.subscribe(5 /* LifeCycleEventType.REQUEST_STARTED */, function (startEvent) {
            if (isExcludedUrl(configuration, startEvent.url)) {
                return;
            }
            if (firstRequestIndex === undefined) {
                firstRequestIndex = startEvent.requestIndex;
            }
            pendingRequestsCount += 1;
            notifyPageActivity();
        }), lifeCycle.subscribe(6 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
            if (isExcludedUrl(configuration, request.url) ||
                firstRequestIndex === undefined ||
                // If the request started before the tracking start, ignore it
                request.requestIndex < firstRequestIndex) {
                return;
            }
            pendingRequestsCount -= 1;
            notifyPageActivity();
        }));
        var stopTrackingWindowOpen = trackWindowOpen(notifyPageActivity).stop;
        return function () {
            stopTrackingWindowOpen();
            subscriptions.forEach(function (s) { return s.unsubscribe(); });
        };
        function notifyPageActivity() {
            observable.notify({ isBusy: pendingRequestsCount > 0 });
        }
    });
    return observable;
}
function isExcludedUrl(configuration, requestUrl) {
    return matchList(configuration.excludedActivityUrls, requestUrl);
}
function trackWindowOpen(callback) {
    return (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(window, 'open', { before: callback });
}
//# sourceMappingURL=waitPageActivityEnd.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/browserDetection.js
var browserDetection = __webpack_require__(89741);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/action/getActionNameFromElement.js

/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
var DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = 'data-dd-action-name';
function getActionNameFromElement(element, userProgrammaticAttribute) {
    // Proceed to get the action name in two steps:
    // * first, get the name programmatically, explicitly defined by the user.
    // * then, use strategies that are known to return good results. Those strategies will be used on
    //   the element and a few parents, but it's likely that they won't succeed at all.
    // * if no name is found this way, use strategies returning less accurate names as a fallback.
    //   Those are much likely to succeed.
    return (getActionNameFromElementProgrammatically(element, DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE) ||
        (userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute)) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, priorityStrategies) ||
        getActionNameFromElementForStrategies(element, userProgrammaticAttribute, fallbackStrategies) ||
        '');
}
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
    var elementWithAttribute;
    // We don't use getActionNameFromElementForStrategies here, because we want to consider all parents,
    // without limit. It is up to the user to declare a relevant naming strategy.
    // If available, use element.closest() to match get the attribute from the element or any of its
    // parent.  Else fallback to a more traditional implementation.
    if (supportsElementClosest()) {
        elementWithAttribute = targetElement.closest("[".concat(programmaticAttribute, "]"));
    }
    else {
        var element = targetElement;
        while (element) {
            if (element.hasAttribute(programmaticAttribute)) {
                elementWithAttribute = element;
                break;
            }
            element = element.parentElement;
        }
    }
    if (!elementWithAttribute) {
        return;
    }
    var name = elementWithAttribute.getAttribute(programmaticAttribute);
    return truncate(normalizeWhitespace(name.trim()));
}
var priorityStrategies = [
    // associated LABEL text
    function (element, userProgrammaticAttribute) {
        // IE does not support element.labels, so we fallback to a CSS selector based on the element id
        // instead
        if (supportsLabelProperty()) {
            if ('labels' in element && element.labels && element.labels.length > 0) {
                return getTextualContent(element.labels[0], userProgrammaticAttribute);
            }
        }
        else if (element.id) {
            var label = element.ownerDocument &&
                (0,polyfills/* find */.sE)(element.ownerDocument.querySelectorAll('label'), function (label) { return label.htmlFor === element.id; });
            return label && getTextualContent(label, userProgrammaticAttribute);
        }
    },
    // INPUT button (and associated) value
    function (element) {
        if (element.nodeName === 'INPUT') {
            var input = element;
            var type = input.getAttribute('type');
            if (type === 'button' || type === 'submit' || type === 'reset') {
                return input.value;
            }
        }
    },
    // BUTTON, LABEL or button-like element text
    function (element, userProgrammaticAttribute) {
        if (element.nodeName === 'BUTTON' || element.nodeName === 'LABEL' || element.getAttribute('role') === 'button') {
            return getTextualContent(element, userProgrammaticAttribute);
        }
    },
    function (element) { return element.getAttribute('aria-label'); },
    // associated element text designated by the aria-labelledby attribute
    function (element, userProgrammaticAttribute) {
        var labelledByAttribute = element.getAttribute('aria-labelledby');
        if (labelledByAttribute) {
            return labelledByAttribute
                .split(/\s+/)
                .map(function (id) { return getElementById(element, id); })
                .filter(function (label) { return Boolean(label); })
                .map(function (element) { return getTextualContent(element, userProgrammaticAttribute); })
                .join(' ');
        }
    },
    function (element) { return element.getAttribute('alt'); },
    function (element) { return element.getAttribute('name'); },
    function (element) { return element.getAttribute('title'); },
    function (element) { return element.getAttribute('placeholder'); },
    // SELECT first OPTION text
    function (element, userProgrammaticAttribute) {
        if ('options' in element && element.options.length > 0) {
            return getTextualContent(element.options[0], userProgrammaticAttribute);
        }
    },
];
var fallbackStrategies = [
    function (element, userProgrammaticAttribute) { return getTextualContent(element, userProgrammaticAttribute); },
];
/**
 * Iterates over the target element and its parent, using the strategies list to get an action name.
 * Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
 */
var MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, userProgrammaticAttribute, strategies) {
    var element = targetElement;
    var recursionCounter = 0;
    while (recursionCounter <= MAX_PARENTS_TO_CONSIDER &&
        element &&
        element.nodeName !== 'BODY' &&
        element.nodeName !== 'HTML' &&
        element.nodeName !== 'HEAD') {
        for (var _i = 0, strategies_1 = strategies; _i < strategies_1.length; _i++) {
            var strategy = strategies_1[_i];
            var name_1 = strategy(element, userProgrammaticAttribute);
            if (typeof name_1 === 'string') {
                var trimmedName = name_1.trim();
                if (trimmedName) {
                    return truncate(normalizeWhitespace(trimmedName));
                }
            }
        }
        // Consider a FORM as a contextual limit to get the action name.  This is experimental and may
        // be reconsidered in the future.
        if (element.nodeName === 'FORM') {
            break;
        }
        element = element.parentElement;
        recursionCounter += 1;
    }
}
function normalizeWhitespace(s) {
    return s.replace(/\s+/g, ' ');
}
function truncate(s) {
    return s.length > 100 ? "".concat((0,stringUtils/* safeTruncate */._z)(s, 100), " [...]") : s;
}
function getElementById(refElement, id) {
    // Use the element ownerDocument here, because tests are executed in an iframe, so
    // document.getElementById won't work.
    return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getTextualContent(element, userProgrammaticAttribute) {
    if (element.isContentEditable) {
        return;
    }
    if ('innerText' in element) {
        var text_1 = element.innerText;
        var removeTextFromElements = function (query) {
            var list = element.querySelectorAll(query);
            for (var index = 0; index < list.length; index += 1) {
                var element_1 = list[index];
                if ('innerText' in element_1) {
                    var textToReplace = element_1.innerText;
                    if (textToReplace && textToReplace.trim().length > 0) {
                        text_1 = text_1.replace(textToReplace, '');
                    }
                }
            }
        };
        if (!supportsInnerTextScriptAndStyleRemoval()) {
            // remove the inner text of SCRIPT and STYLES from the result. This is a bit dirty, but should
            // be relatively fast and work in most cases.
            removeTextFromElements('script, style');
        }
        // remove the text of elements with programmatic attribute value
        removeTextFromElements("[".concat(DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE, "]"));
        if (userProgrammaticAttribute) {
            removeTextFromElements("[".concat(userProgrammaticAttribute, "]"));
        }
        return text_1;
    }
    return element.textContent;
}
/**
 * Returns true if element.innerText excludes the text from inline SCRIPT and STYLE element. This
 * should be the case everywhere except on Internet Explorer 10 and 11 (see [1])
 *
 * The innerText property relies on what is actually rendered to compute its output, so to check if
 * it actually excludes SCRIPT and STYLE content, a solution would be to create a style element, set
 * its content to '*', inject it in the document body, and check if the style element innerText
 * property returns '*'. Using a new `document` instance won't work as it is not rendered.
 *
 * This solution requires specific CSP rules (see [2]) to be set by the customer. We want to avoid
 * this, so instead we rely on browser detection. In case of false negative, the impact should be
 * low, since we rely on this result to remove the SCRIPT and STYLE innerText (which will be empty)
 * from a parent element innerText.
 *
 * [1]: https://web.archive.org/web/20210602165716/http://perfectionkills.com/the-poor-misunderstood-innerText/#diff-with-textContent
 * [2]: https://github.com/DataDog/browser-sdk/issues/1084
 */
function supportsInnerTextScriptAndStyleRemoval() {
    return !(0,browserDetection/* isIE */.w1)();
}
/**
 * Returns true if the browser supports the element.labels property.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsLabelPropertyResult;
function supportsLabelProperty() {
    if (supportsLabelPropertyResult === undefined) {
        supportsLabelPropertyResult = 'labels' in HTMLInputElement.prototype;
    }
    return supportsLabelPropertyResult;
}
/**
 * Returns true if the browser supports the element.closest method.  This should be the case
 * everywhere except on Internet Explorer.
 * Note: The result is computed lazily, because we don't want any DOM access when the SDK is
 * evaluated.
 */
var supportsElementClosestResult;
function supportsElementClosest() {
    if (supportsElementClosestResult === undefined) {
        supportsElementClosestResult = 'closest' in HTMLElement.prototype;
    }
    return supportsElementClosestResult;
}
//# sourceMappingURL=getActionNameFromElement.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/getSelectorFromElement.js


/**
 * Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
 * component). Those attribute values should not be generated randomly (hardcoded most of the time)
 * and stay the same across deploys. They are not necessarily unique across the document.
 */
var STABLE_ATTRIBUTES = [
    DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE,
    // Common test attributes (list provided by google recorder)
    'data-testid',
    'data-test',
    'data-qa',
    'data-cy',
    'data-test-id',
    'data-qa-id',
    'data-testing',
    // FullStory decorator attributes:
    'data-component',
    'data-element',
    'data-source-file',
];
// Selectors to use if they target a single element on the whole document. Those selectors are
// considered as "stable" and uniquely identify an element regardless of the page state. If we find
// one, we should consider the selector "complete" and stop iterating over ancestors.
var GLOBALLY_UNIQUE_SELECTOR_GETTERS = [getStableAttributeSelector, getIDSelector];
// Selectors to use if they target a single element among an element descendants. Those selectors
// are more brittle than "globally unique" selectors and should be combined with ancestor selectors
// to improve specificity.
var UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
    getStableAttributeSelector,
    getClassSelector,
    getTagNameSelector,
];
function getSelectorFromElement(targetElement, actionNameAttribute) {
    var targetElementSelector = '';
    var element = targetElement;
    while (element && element.nodeName !== 'HTML') {
        var globallyUniqueSelector = findSelector(element, GLOBALLY_UNIQUE_SELECTOR_GETTERS, isSelectorUniqueGlobally, actionNameAttribute, targetElementSelector);
        if (globallyUniqueSelector) {
            return globallyUniqueSelector;
        }
        var uniqueSelectorAmongChildren = findSelector(element, UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, isSelectorUniqueAmongSiblings, actionNameAttribute, targetElementSelector);
        targetElementSelector =
            uniqueSelectorAmongChildren || combineSelector(getPositionSelector(element), targetElementSelector);
        element = element.parentElement;
    }
    return targetElementSelector;
}
function isGeneratedValue(value) {
    // To compute the "URL path group", the backend replaces every URL path parts as a question mark
    // if it thinks the part is an identifier. The condition it uses is to checks whether a digit is
    // present.
    //
    // Here, we use the same strategy: if a the value contains a digit, we consider it generated. This
    // strategy might be a bit naive and fail in some cases, but there are many fallbacks to generate
    // CSS selectors so it should be fine most of the time. We might want to allow customers to
    // provide their own `isGeneratedValue` at some point.
    return /[0-9]/.test(value);
}
function getIDSelector(element) {
    if (element.id && !isGeneratedValue(element.id)) {
        return "#".concat((0,polyfills/* cssEscape */.QA)(element.id));
    }
}
function getClassSelector(element) {
    if (element.tagName === 'BODY') {
        return;
    }
    if (element.classList.length > 0) {
        for (var i = 0; i < element.classList.length; i += 1) {
            var className = element.classList[i];
            if (isGeneratedValue(className)) {
                continue;
            }
            return "".concat((0,polyfills/* cssEscape */.QA)(element.tagName), ".").concat((0,polyfills/* cssEscape */.QA)(className));
        }
    }
}
function getTagNameSelector(element) {
    return (0,polyfills/* cssEscape */.QA)(element.tagName);
}
function getStableAttributeSelector(element, actionNameAttribute) {
    if (actionNameAttribute) {
        var selector = getAttributeSelector(actionNameAttribute);
        if (selector) {
            return selector;
        }
    }
    for (var _i = 0, STABLE_ATTRIBUTES_1 = STABLE_ATTRIBUTES; _i < STABLE_ATTRIBUTES_1.length; _i++) {
        var attributeName = STABLE_ATTRIBUTES_1[_i];
        var selector = getAttributeSelector(attributeName);
        if (selector) {
            return selector;
        }
    }
    function getAttributeSelector(attributeName) {
        if (element.hasAttribute(attributeName)) {
            return "".concat((0,polyfills/* cssEscape */.QA)(element.tagName), "[").concat(attributeName, "=\"").concat((0,polyfills/* cssEscape */.QA)(element.getAttribute(attributeName)), "\"]");
        }
    }
}
function getPositionSelector(element) {
    var sibling = element.parentElement.firstElementChild;
    var elementIndex = 1;
    while (sibling && sibling !== element) {
        if (sibling.tagName === element.tagName) {
            elementIndex += 1;
        }
        sibling = sibling.nextElementSibling;
    }
    return "".concat((0,polyfills/* cssEscape */.QA)(element.tagName), ":nth-of-type(").concat(elementIndex, ")");
}
function findSelector(element, selectorGetters, predicate, actionNameAttribute, childSelector) {
    for (var _i = 0, selectorGetters_1 = selectorGetters; _i < selectorGetters_1.length; _i++) {
        var selectorGetter = selectorGetters_1[_i];
        var elementSelector = selectorGetter(element, actionNameAttribute);
        if (!elementSelector) {
            continue;
        }
        var fullSelector = combineSelector(elementSelector, childSelector);
        if (predicate(element, fullSelector)) {
            return fullSelector;
        }
    }
}
/**
 * Check whether the selector is unique among the whole document.
 */
function isSelectorUniqueGlobally(element, selector) {
    return element.ownerDocument.querySelectorAll(selector).length === 1;
}
/**
 * Check whether the selector is unique among the element siblings. In other words, it returns true
 * if "ELEMENT_PARENT > SELECTOR" returns a single element.
 *
 * The result will be less accurate on browsers that don't support :scope (i. e. IE): it will check
 * for any element matching the selector contained in the parent (in other words,
 * "ELEMENT_PARENT SELECTOR" returns a single element), regardless of whether the selector is a
 * direct descendent of the element parent. This should not impact results too much: if it
 * inaccurately returns false, we'll just fall back to another strategy.
 */
function isSelectorUniqueAmongSiblings(element, selector) {
    return (element.parentElement.querySelectorAll(supportScopeSelector() ? combineSelector(':scope', selector) : selector)
        .length === 1);
}
function combineSelector(parent, child) {
    return child ? "".concat(parent, ">").concat(child) : parent;
}
var supportScopeSelectorCache;
function supportScopeSelector() {
    if (supportScopeSelectorCache === undefined) {
        try {
            document.querySelector(':scope');
            supportScopeSelectorCache = true;
        }
        catch (_a) {
            supportScopeSelectorCache = false;
        }
    }
    return supportScopeSelectorCache;
}
//# sourceMappingURL=getSelectorFromElement.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/action/clickChain.js

var MAX_DURATION_BETWEEN_CLICKS = timeUtils/* ONE_SECOND */.WT;
var MAX_DISTANCE_BETWEEN_CLICKS = 100;
function createClickChain(firstClick, onFinalize) {
    var bufferedClicks = [];
    var status = 0 /* ClickChainStatus.WaitingForMoreClicks */;
    var maxDurationBetweenClicksTimeoutId;
    appendClick(firstClick);
    function appendClick(click) {
        click.stopObservable.subscribe(tryFinalize);
        bufferedClicks.push(click);
        (0,timer/* clearTimeout */.gr)(maxDurationBetweenClicksTimeoutId);
        maxDurationBetweenClicksTimeoutId = (0,timer/* setTimeout */.iK)(dontAcceptMoreClick, MAX_DURATION_BETWEEN_CLICKS);
    }
    function tryFinalize() {
        if (status === 1 /* ClickChainStatus.WaitingForClicksToStop */ && bufferedClicks.every(function (click) { return click.isStopped(); })) {
            status = 2 /* ClickChainStatus.Finalized */;
            onFinalize(bufferedClicks);
        }
    }
    function dontAcceptMoreClick() {
        (0,timer/* clearTimeout */.gr)(maxDurationBetweenClicksTimeoutId);
        if (status === 0 /* ClickChainStatus.WaitingForMoreClicks */) {
            status = 1 /* ClickChainStatus.WaitingForClicksToStop */;
            tryFinalize();
        }
    }
    return {
        tryAppend: function (click) {
            if (status !== 0 /* ClickChainStatus.WaitingForMoreClicks */) {
                return false;
            }
            if (bufferedClicks.length > 0 &&
                !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
                dontAcceptMoreClick();
                return false;
            }
            appendClick(click);
            return true;
        },
        stop: function () {
            dontAcceptMoreClick();
        },
    };
}
/**
 * Checks whether two events are similar by comparing their target, position and timestamp
 */
function areEventsSimilar(first, second) {
    return (first.target === second.target &&
        mouseEventDistance(first, second) <= MAX_DISTANCE_BETWEEN_CLICKS &&
        first.timeStamp - second.timeStamp <= MAX_DURATION_BETWEEN_CLICKS);
}
function mouseEventDistance(origin, other) {
    return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}
//# sourceMappingURL=clickChain.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/action/listenActionEvents.js

function listenActionEvents(configuration, _a) {
    var onPointerDown = _a.onPointerDown, onPointerUp = _a.onPointerUp;
    var selectionEmptyAtPointerDown;
    var userActivity = {
        selection: false,
        input: false,
    };
    var clickContext;
    var listeners = [
        (0,addEventListener/* addEventListener */.O)(configuration, window, "pointerdown" /* DOM_EVENT.POINTER_DOWN */, function (event) {
            if (isValidPointerEvent(event)) {
                selectionEmptyAtPointerDown = isSelectionEmpty();
                userActivity = {
                    selection: false,
                    input: false,
                };
                clickContext = onPointerDown(event);
            }
        }, { capture: true }),
        (0,addEventListener/* addEventListener */.O)(configuration, window, "selectionchange" /* DOM_EVENT.SELECTION_CHANGE */, function () {
            if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) {
                userActivity.selection = true;
            }
        }, { capture: true }),
        (0,addEventListener/* addEventListener */.O)(configuration, window, "pointerup" /* DOM_EVENT.POINTER_UP */, function (event) {
            if (isValidPointerEvent(event) && clickContext) {
                // Use a scoped variable to make sure the value is not changed by other clicks
                var localUserActivity_1 = userActivity;
                onPointerUp(clickContext, event, function () { return localUserActivity_1; });
                clickContext = undefined;
            }
        }, { capture: true }),
        (0,addEventListener/* addEventListener */.O)(configuration, window, "input" /* DOM_EVENT.INPUT */, function () {
            userActivity.input = true;
        }, { capture: true }),
    ];
    return {
        stop: function () {
            listeners.forEach(function (listener) { return listener.stop(); });
        },
    };
}
function isSelectionEmpty() {
    var selection = window.getSelection();
    return !selection || selection.isCollapsed;
}
function isValidPointerEvent(event) {
    return (event.target instanceof Element &&
        // Only consider 'primary' pointer events for now. Multi-touch support could be implemented in
        // the future.
        event.isPrimary !== false);
}
//# sourceMappingURL=listenActionEvents.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/action/computeFrustration.js

var MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function computeFrustration(clicks, rageClick) {
    if (isRage(clicks)) {
        rageClick.addFrustration("rage_click" /* FrustrationType.RAGE_CLICK */);
        if (clicks.some(isDead)) {
            rageClick.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
        }
        if (rageClick.hasError) {
            rageClick.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
        }
        return { isRage: true };
    }
    var hasSelectionChanged = clicks.some(function (click) { return click.getUserActivity().selection; });
    clicks.forEach(function (click) {
        if (click.hasError) {
            click.addFrustration("error_click" /* FrustrationType.ERROR_CLICK */);
        }
        if (isDead(click) &&
            // Avoid considering clicks part of a double-click or triple-click selections as dead clicks
            !hasSelectionChanged) {
            click.addFrustration("dead_click" /* FrustrationType.DEAD_CLICK */);
        }
    });
    return { isRage: false };
}
function isRage(clicks) {
    if (clicks.some(function (click) { return click.getUserActivity().selection; })) {
        return false;
    }
    for (var i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) {
        if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <=
            timeUtils/* ONE_SECOND */.WT) {
            return true;
        }
    }
    return false;
}
var DEAD_CLICK_EXCLUDE_SELECTOR = 
// inputs that don't trigger a meaningful event like "input" when clicked, including textual
// inputs (using a negative selector is shorter here)
'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]),' +
    'textarea,' +
    'select,' +
    // contenteditable and their descendants don't always trigger meaningful changes when manipulated
    '[contenteditable],' +
    '[contenteditable] *,' +
    // canvas, as there is no good way to detect activity occurring on them
    'canvas,' +
    // links that are interactive (have an href attribute) or any of their descendants, as they can
    // open a new tab or navigate to a hash without triggering a meaningful event
    'a[href],' +
    'a[href] *';
function isDead(click) {
    if (click.hasPageActivity || click.getUserActivity().input) {
        return false;
    }
    return !(0,polyfills/* elementMatches */.Ap)(click.event.target, DEAD_CLICK_EXCLUDE_SELECTOR);
}
//# sourceMappingURL=computeFrustration.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/action/trackClickActions.js








// Maximum duration for click actions
var CLICK_ACTION_MAX_DURATION = 10 * timeUtils/* ONE_SECOND */.WT;
var ACTION_CONTEXT_TIME_OUT_DELAY = 5 * timeUtils/* ONE_MINUTE */.yR; // arbitrary
function trackClickActions(lifeCycle, domMutationObservable, configuration) {
    var history = new valueHistory/* ValueHistory */.P(ACTION_CONTEXT_TIME_OUT_DELAY);
    var stopObservable = new tools_observable/* Observable */.y();
    var currentClickChain;
    lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
        history.reset();
    });
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, stopClickChain);
    var stopActionEventsListener = listenActionEvents(configuration, {
        onPointerDown: function (pointerDownEvent) {
            return processPointerDown(configuration, lifeCycle, domMutationObservable, history, pointerDownEvent);
        },
        onPointerUp: function (_a, startEvent, getUserActivity) {
            var clickActionBase = _a.clickActionBase, hadActivityOnPointerDown = _a.hadActivityOnPointerDown;
            return startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
        },
    }).stop;
    var actionContexts = {
        findActionId: function (startTime) {
            return configuration.trackFrustrations ? history.findAll(startTime) : history.find(startTime);
        },
    };
    return {
        stop: function () {
            stopClickChain();
            stopObservable.notify();
            stopActionEventsListener();
        },
        actionContexts: actionContexts,
    };
    function appendClickToClickChain(click) {
        if (!currentClickChain || !currentClickChain.tryAppend(click)) {
            var rageClick_1 = click.clone();
            currentClickChain = createClickChain(click, function (clicks) {
                finalizeClicks(clicks, rageClick_1);
            });
        }
    }
    function stopClickChain() {
        if (currentClickChain) {
            currentClickChain.stop();
        }
    }
}
function processPointerDown(configuration, lifeCycle, domMutationObservable, history, pointerDownEvent) {
    if (!configuration.trackFrustrations && history.find()) {
        // TODO: remove this in a future major version. To keep retrocompatibility, ignore any new
        // action if another one is already occurring.
        return;
    }
    var clickActionBase = computeClickActionBase(pointerDownEvent, configuration.actionNameAttribute);
    if (!configuration.trackFrustrations && !clickActionBase.name) {
        // TODO: remove this in a future major version. To keep retrocompatibility, ignore any action
        // with a blank name
        return;
    }
    var hadActivityOnPointerDown = false;
    waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
    }, 
    // We don't care about the activity duration, we just want to know whether an activity did happen
    // within the "validation delay" or not. Limit the duration so the callback is called sooner.
    PAGE_ACTIVITY_VALIDATION_DELAY);
    return { clickActionBase: clickActionBase, hadActivityOnPointerDown: function () { return hadActivityOnPointerDown; } };
}
function startClickAction(configuration, lifeCycle, domMutationObservable, history, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
    var click = newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent);
    if (configuration.trackFrustrations) {
        appendClickToClickChain(click);
    }
    var stopWaitPageActivityEnd = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (pageActivityEndEvent) {
        if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) {
            // If the clock is looking weird, just discard the click
            click.discard();
        }
        else {
            if (pageActivityEndEvent.hadActivity) {
                click.stop(pageActivityEndEvent.end);
            }
            else if (hadActivityOnPointerDown()) {
                click.stop(
                // using the click start as activity end, so the click will have some activity but its
                // duration will be 0 (as the activity started before the click start)
                click.startClocks.timeStamp);
            }
            else {
                click.stop();
            }
            // Validate or discard the click only if we don't track frustrations. It'll be done when
            // the click chain is finalized.
            if (!configuration.trackFrustrations) {
                if (!pageActivityEndEvent.hadActivity) {
                    // If we are not tracking frustrations, we should discard the click to keep backward
                    // compatibility.
                    click.discard();
                }
                else {
                    click.validate();
                }
            }
        }
    }, CLICK_ACTION_MAX_DURATION).stop;
    var viewEndedSubscription = lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        click.stop(endClocks.timeStamp);
    });
    var stopSubscription = stopObservable.subscribe(function () {
        click.stop();
    });
    click.stopObservable.subscribe(function () {
        viewEndedSubscription.unsubscribe();
        stopWaitPageActivityEnd();
        stopSubscription.unsubscribe();
    });
}
function computeClickActionBase(event, actionNameAttribute) {
    var rect = event.target.getBoundingClientRect();
    return {
        type: "click" /* ActionType.CLICK */,
        target: {
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            selector: getSelectorFromElement(event.target, actionNameAttribute),
        },
        position: {
            // Use clientX and Y because for SVG element offsetX and Y are relatives to the <svg> element
            x: Math.round(event.clientX - rect.left),
            y: Math.round(event.clientY - rect.top),
        },
        name: getActionNameFromElement(event.target, actionNameAttribute),
    };
}
function newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent) {
    var id = (0,stringUtils/* generateUUID */.DO)();
    var startClocks = (0,timeUtils/* clocksNow */.$I)();
    var historyEntry = history.add(id, startClocks.relative);
    var eventCountsSubscription = trackEventCounts({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) {
            return event.action !== undefined &&
                (Array.isArray(event.action.id) ? (0,polyfills/* includes */.q9)(event.action.id, id) : event.action.id === id);
        },
    });
    var status = 0 /* ClickStatus.ONGOING */;
    var activityEndTime;
    var frustrationTypes = [];
    var stopObservable = new tools_observable/* Observable */.y();
    function stop(newActivityEndTime) {
        if (status !== 0 /* ClickStatus.ONGOING */) {
            return;
        }
        activityEndTime = newActivityEndTime;
        status = 1 /* ClickStatus.STOPPED */;
        if (activityEndTime) {
            historyEntry.close((0,timeUtils/* getRelativeTime */.ni)(activityEndTime));
        }
        else {
            historyEntry.remove();
        }
        eventCountsSubscription.stop();
        stopObservable.notify();
    }
    return {
        event: startEvent,
        stop: stop,
        stopObservable: stopObservable,
        get hasError() {
            return eventCountsSubscription.eventCounts.errorCount > 0;
        },
        get hasPageActivity() {
            return activityEndTime !== undefined;
        },
        getUserActivity: getUserActivity,
        addFrustration: function (frustrationType) {
            frustrationTypes.push(frustrationType);
        },
        startClocks: startClocks,
        isStopped: function () { return status === 1 /* ClickStatus.STOPPED */ || status === 2 /* ClickStatus.FINALIZED */; },
        clone: function () { return newClick(lifeCycle, history, getUserActivity, clickActionBase, startEvent); },
        validate: function (domEvents) {
            stop();
            if (status !== 1 /* ClickStatus.STOPPED */) {
                return;
            }
            var _a = eventCountsSubscription.eventCounts, resourceCount = _a.resourceCount, errorCount = _a.errorCount, longTaskCount = _a.longTaskCount;
            var clickAction = (0,polyfills/* assign */.f0)({
                type: "click" /* ActionType.CLICK */,
                duration: activityEndTime && (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, activityEndTime),
                startClocks: startClocks,
                id: id,
                frustrationTypes: frustrationTypes,
                counts: {
                    resourceCount: resourceCount,
                    errorCount: errorCount,
                    longTaskCount: longTaskCount,
                },
                events: domEvents !== null && domEvents !== void 0 ? domEvents : [startEvent],
                event: startEvent,
            }, clickActionBase);
            lifeCycle.notify(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, clickAction);
            status = 2 /* ClickStatus.FINALIZED */;
        },
        discard: function () {
            stop();
            status = 2 /* ClickStatus.FINALIZED */;
        },
    };
}
function finalizeClicks(clicks, rageClick) {
    var isRage = computeFrustration(clicks, rageClick).isRage;
    if (isRage) {
        clicks.forEach(function (click) { return click.discard(); });
        rageClick.stop((0,timeUtils/* timeStampNow */.n$)());
        rageClick.validate(clicks.map(function (click) { return click.event; }));
    }
    else {
        rageClick.discard();
        clicks.forEach(function (click) { return click.validate(); });
    }
}
//# sourceMappingURL=trackClickActions.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/action/actionCollection.js


function startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory) {
    lifeCycle.subscribe(1 /* LifeCycleEventType.AUTO_ACTION_COMPLETED */, function (action) {
        return lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processAction(action, pageStateHistory));
    });
    var actionContexts = { findActionId: functionUtils/* noop */.Z };
    if (configuration.trackUserInteractions) {
        actionContexts = trackClickActions(lifeCycle, domMutationObservable, configuration).actionContexts;
    }
    return {
        addAction: function (action, savedCommonContext) {
            lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, (0,polyfills/* assign */.f0)({
                savedCommonContext: savedCommonContext,
            }, processAction(action, pageStateHistory)));
        },
        actionContexts: actionContexts,
    };
}
function processAction(action, pageStateHistory) {
    var autoActionProperties = isAutoAction(action)
        ? {
            action: {
                id: action.id,
                loading_time: (0,timeUtils/* toServerDuration */.c0)(action.duration),
                frustration: {
                    type: action.frustrationTypes,
                },
                error: {
                    count: action.counts.errorCount,
                },
                long_task: {
                    count: action.counts.longTaskCount,
                },
                resource: {
                    count: action.counts.resourceCount,
                },
            },
            _dd: {
                action: {
                    target: action.target,
                    position: action.position,
                },
            },
        }
        : undefined;
    var customerContext = !isAutoAction(action) ? action.context : undefined;
    var actionEvent = (0,mergeInto/* combine */.$e)({
        action: {
            id: (0,stringUtils/* generateUUID */.DO)(),
            target: {
                name: action.name,
            },
            type: action.type,
        },
        date: action.startClocks.timeStamp,
        type: "action" /* RumEventType.ACTION */,
        view: { in_foreground: pageStateHistory.isInActivePageStateAt(action.startClocks.relative) },
    }, autoActionProperties);
    return {
        customerContext: customerContext,
        rawRumEvent: actionEvent,
        startTime: action.startClocks.relative,
        domainContext: isAutoAction(action) ? { event: action.event, events: action.events } : {},
    };
}
function isAutoAction(action) {
    return action.type !== "custom" /* ActionType.CUSTOM */;
}
//# sourceMappingURL=actionCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js + 1 modules
var trackRuntimeError = __webpack_require__(80676);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/tracekit/computeStackTrace.js
var computeStackTrace = __webpack_require__(94856);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var error_types = __webpack_require__(10494);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js
var consoleObservable = __webpack_require__(78587);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/error/trackConsoleError.js

function trackConsoleError(errorObservable) {
    var subscription = (0,consoleObservable/* initConsoleObservable */.a)([display/* ConsoleApiName.error */.vA.error]).subscribe(function (consoleError) {
        return errorObservable.notify({
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
            message: consoleError.message,
            stack: consoleError.stack,
            fingerprint: consoleError.fingerprint,
            source: error_types/* ErrorSource.CONSOLE */.z.CONSOLE,
            handling: "handled" /* ErrorHandling.HANDLED */,
            handlingStack: consoleError.handlingStack,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackConsoleError.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js
var reportObservable = __webpack_require__(11954);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/error/trackReportError.js

function trackReportError(configuration, errorObservable) {
    var subscription = (0,reportObservable/* initReportObservable */.v)(configuration, [
        reportObservable/* RawReportType.cspViolation */._.cspViolation,
        reportObservable/* RawReportType.intervention */._.intervention,
    ]).subscribe(function (reportError) {
        return errorObservable.notify({
            startClocks: (0,timeUtils/* clocksNow */.$I)(),
            message: reportError.message,
            stack: reportError.stack,
            type: reportError.subtype,
            source: error_types/* ErrorSource.REPORT */.z.REPORT,
            handling: "unhandled" /* ErrorHandling.UNHANDLED */,
        });
    });
    return {
        stop: function () {
            subscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackReportError.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/error/errorCollection.js



function startErrorCollection(lifeCycle, configuration, pageStateHistory, featureFlagContexts) {
    var errorObservable = new tools_observable/* Observable */.y();
    trackConsoleError(errorObservable);
    (0,trackRuntimeError/* trackRuntimeError */.L)(errorObservable);
    trackReportError(configuration, errorObservable);
    errorObservable.subscribe(function (error) { return lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error }); });
    return doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts);
}
function doStartErrorCollection(lifeCycle, pageStateHistory, featureFlagContexts) {
    lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, function (_a) {
        var error = _a.error, customerContext = _a.customerContext, savedCommonContext = _a.savedCommonContext;
        lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, (0,polyfills/* assign */.f0)({
            customerContext: customerContext,
            savedCommonContext: savedCommonContext,
        }, processError(error, pageStateHistory, featureFlagContexts)));
    });
    return {
        addError: function (_a, savedCommonContext) {
            var error = _a.error, handlingStack = _a.handlingStack, startClocks = _a.startClocks, customerContext = _a.context;
            var stackTrace = error instanceof Error ? (0,computeStackTrace/* computeStackTrace */._)(error) : undefined;
            var rawError = (0,error_error/* computeRawError */.AP)({
                stackTrace: stackTrace,
                originalError: error,
                handlingStack: handlingStack,
                startClocks: startClocks,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
                source: error_types/* ErrorSource.CUSTOM */.z.CUSTOM,
                handling: "handled" /* ErrorHandling.HANDLED */,
            });
            lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
                customerContext: customerContext,
                savedCommonContext: savedCommonContext,
                error: rawError,
            });
        },
    };
}
function processError(error, pageStateHistory, featureFlagContexts) {
    var rawRumEvent = {
        date: error.startClocks.timeStamp,
        error: {
            id: (0,stringUtils/* generateUUID */.DO)(),
            message: error.message,
            source: error.source,
            stack: error.stack,
            handling_stack: error.handlingStack,
            type: error.type,
            handling: error.handling,
            causes: error.causes,
            source_type: 'browser',
            fingerprint: error.fingerprint,
        },
        type: "error" /* RumEventType.ERROR */,
        view: { in_foreground: pageStateHistory.isInActivePageStateAt(error.startClocks.relative) },
    };
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(error.startClocks.relative);
    if (featureFlagContext && !(0,objectUtils/* isEmptyObject */.Qr)(featureFlagContext)) {
        rawRumEvent.feature_flags = featureFlagContext;
    }
    return {
        rawRumEvent: rawRumEvent,
        startTime: error.startClocks.relative,
        domainContext: {
            error: error.originalError,
        },
    };
}
//# sourceMappingURL=errorCollection.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/longTask/longTaskCollection.js


function startLongTaskCollection(lifeCycle, sessionManager) {
    lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType !== RumPerformanceEntryType.LONG_TASK) {
                break;
            }
            var session = sessionManager.findTrackedSession(entry.startTime);
            if (!session || !session.longTaskAllowed) {
                break;
            }
            var startClocks = (0,timeUtils/* relativeToClocks */.DY)(entry.startTime);
            var rawRumEvent = {
                date: startClocks.timeStamp,
                long_task: {
                    id: (0,stringUtils/* generateUUID */.DO)(),
                    duration: (0,timeUtils/* toServerDuration */.c0)(entry.duration),
                },
                type: "long_task" /* RumEventType.LONG_TASK */,
                _dd: {
                    discarded: false,
                },
            };
            lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, {
                rawRumEvent: rawRumEvent,
                startTime: startClocks.relative,
                domainContext: { performanceEntry: entry.toJSON() },
            });
        }
    });
}
//# sourceMappingURL=longTaskCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.js
var experimentalFeatures = __webpack_require__(28852);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/resource/matchRequestTiming.js


/**
 * Look for corresponding timing in resource timing buffer
 *
 * Observations:
 * - Timing (start, end) are nested inside the request (start, end)
 * - Some timing can be not exactly nested, being off by < 1 ms
 *
 * Strategy:
 * - from valid nested entries (with 1 ms error margin)
 * - if a single timing match, return the timing
 * - otherwise we can't decide, return undefined
 */
function matchRequestTiming(request) {
    if (!performance || !('getEntriesByName' in performance)) {
        return;
    }
    var sameNameEntries = performance.getEntriesByName(request.url, 'resource');
    if (!sameNameEntries.length || !('toJSON' in sameNameEntries[0])) {
        return;
    }
    var candidates = sameNameEntries
        .map(function (entry) { return entry.toJSON(); })
        .filter(toValidEntry)
        .filter(function (entry) {
        return isBetween(entry, request.startClocks.relative, endTime({ startTime: request.startClocks.relative, duration: request.duration }));
    });
    if (candidates.length === 1) {
        return candidates[0];
    }
    return;
}
function endTime(timing) {
    return (0,timeUtils/* addDuration */.WK)(timing.startTime, timing.duration);
}
function isBetween(timing, start, end) {
    var errorMargin = 1;
    return timing.startTime >= start - errorMargin && endTime(timing) <= (0,timeUtils/* addDuration */.WK)(end, errorMargin);
}
//# sourceMappingURL=matchRequestTiming.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/resource/resourceCollection.js




function startResourceCollection(lifeCycle, configuration, sessionManager, pageStateHistory) {
    lifeCycle.subscribe(6 /* LifeCycleEventType.REQUEST_COMPLETED */, function (request) {
        lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processRequest(request, configuration, sessionManager, pageStateHistory));
    });
    lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === RumPerformanceEntryType.RESOURCE && !isRequestKind(entry)) {
                lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processResourceEntry(entry, configuration, sessionManager, pageStateHistory));
            }
        }
    });
}
function processRequest(request, configuration, sessionManager, pageStateHistory) {
    var _a;
    var type = request.type === "xhr" /* RequestType.XHR */ ? "xhr" /* ResourceType.XHR */ : "fetch" /* ResourceType.FETCH */;
    var matchingTiming = matchRequestTiming(request);
    var startClocks = matchingTiming ? (0,timeUtils/* relativeToClocks */.DY)(matchingTiming.startTime) : request.startClocks;
    var correspondingTimingOverrides = matchingTiming ? computePerformanceEntryMetrics(matchingTiming) : undefined;
    var tracingInfo = computeRequestTracingInfo(request, configuration);
    var indexingInfo = computeIndexingInfo(sessionManager, startClocks);
    var duration = computeRequestDuration(pageStateHistory, startClocks, request.duration);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, (_a = matchingTiming === null || matchingTiming === void 0 ? void 0 : matchingTiming.duration) !== null && _a !== void 0 ? _a : request.duration);
    var resourceEvent = (0,mergeInto/* combine */.$e)({
        date: startClocks.timeStamp,
        resource: {
            id: (0,stringUtils/* generateUUID */.DO)(),
            type: type,
            duration: duration,
            method: request.method,
            status_code: request.status,
            url: request.url,
        },
        type: "resource" /* RumEventType.RESOURCE */,
    }, tracingInfo, correspondingTimingOverrides, indexingInfo, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: matchingTiming && toPerformanceEntryRepresentation(matchingTiming),
            xhr: request.xhr,
            response: request.response,
            requestInput: request.input,
            requestInit: request.init,
            error: request.error,
        },
    };
}
function processResourceEntry(entry, configuration, sessionManager, pageStateHistory) {
    var type = computeResourceKind(entry);
    var entryMetrics = computePerformanceEntryMetrics(entry);
    var startClocks = (0,timeUtils/* relativeToClocks */.DY)(entry.startTime);
    var tracingInfo = computeEntryTracingInfo(entry, configuration);
    var indexingInfo = computeIndexingInfo(sessionManager, startClocks);
    var pageStateInfo = computePageStateInfo(pageStateHistory, startClocks, entry.duration);
    var resourceEvent = (0,mergeInto/* combine */.$e)({
        date: startClocks.timeStamp,
        resource: {
            id: (0,stringUtils/* generateUUID */.DO)(),
            type: type,
            url: entry.name,
        },
        type: "resource" /* RumEventType.RESOURCE */,
    }, tracingInfo, entryMetrics, indexingInfo, pageStateInfo);
    return {
        startTime: startClocks.relative,
        rawRumEvent: resourceEvent,
        domainContext: {
            performanceEntry: toPerformanceEntryRepresentation(entry),
        },
    };
}
function computePerformanceEntryMetrics(timing) {
    return {
        resource: (0,polyfills/* assign */.f0)({
            duration: computePerformanceResourceDuration(timing),
            size: computeSize(timing),
        }, computePerformanceResourceDetails(timing)),
    };
}
function computeRequestTracingInfo(request, configuration) {
    var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            span_id: request.spanId.toDecimalString(),
            trace_id: request.traceId.toDecimalString(),
            rule_psr: getRulePsr(configuration),
        },
    };
}
function computeEntryTracingInfo(entry, configuration) {
    var hasBeenTraced = entry.traceId;
    if (!hasBeenTraced) {
        return undefined;
    }
    return {
        _dd: {
            trace_id: entry.traceId,
            rule_psr: getRulePsr(configuration),
        },
    };
}
// TODO next major: use directly PerformanceEntry type in domain context
function toPerformanceEntryRepresentation(entry) {
    return entry;
}
/**
 * @returns number between 0 and 1 which represents trace sample rate
 */
function getRulePsr(configuration) {
    return (0,numberUtils/* isNumber */.hj)(configuration.traceSampleRate) ? configuration.traceSampleRate / 100 : undefined;
}
function computeIndexingInfo(sessionManager, resourceStart) {
    var session = sessionManager.findTrackedSession(resourceStart.relative);
    return {
        _dd: {
            discarded: !session || !session.resourceAllowed,
        },
    };
}
function computePageStateInfo(pageStateHistory, startClocks, duration) {
    if (!(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.RESOURCE_PAGE_STATES */.uh.RESOURCE_PAGE_STATES)) {
        return;
    }
    return {
        _dd: {
            page_states: pageStateHistory.findAll(startClocks.relative, duration),
            page_was_discarded: String(document.wasDiscarded),
        },
    };
}
function computeRequestDuration(pageStateHistory, startClocks, duration) {
    var _a;
    // TODO remove FF in next major
    if (!(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.NO_RESOURCE_DURATION_FROZEN_STATE */.uh.NO_RESOURCE_DURATION_FROZEN_STATE)) {
        return (0,timeUtils/* toServerDuration */.c0)(duration);
    }
    var requestCrossedFrozenState = (_a = pageStateHistory
        .findAll(startClocks.relative, duration)) === null || _a === void 0 ? void 0 : _a.some(function (pageState) { return pageState.state === "frozen" /* PageState.FROZEN */; });
    return !requestCrossedFrozenState ? (0,timeUtils/* toServerDuration */.c0)(duration) : undefined;
}
//# sourceMappingURL=resourceCollection.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/foregroundContexts.js

// Todo: Remove in the next major release
function mapToForegroundPeriods(pageStateServerEntries, duration) {
    var foregroundPeriods = [];
    for (var i = 0; i < pageStateServerEntries.length; i++) {
        var current = pageStateServerEntries[i];
        var next = pageStateServerEntries[i + 1];
        if (current.state === "active" /* PageState.ACTIVE */) {
            var start = current.start >= 0 ? current.start : 0;
            var end = next ? next.start : (0,timeUtils/* toServerDuration */.c0)(duration);
            foregroundPeriods.push({
                start: start,
                duration: (end - start),
            });
        }
    }
    return foregroundPeriods;
}
//# sourceMappingURL=foregroundContexts.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/trackViewEventCounts.js

function trackViewEventCounts(lifeCycle, viewId, onChange) {
    var _a = trackEventCounts({
        lifeCycle: lifeCycle,
        isChildEvent: function (event) { return event.view.id === viewId; },
        onChange: onChange,
    }), stop = _a.stop, eventCounts = _a.eventCounts;
    return {
        stop: stop,
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackViewEventCounts.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstContentfulPaint.js


// Discard FCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var FCP_MAXIMUM_DELAY = 10 * timeUtils/* ONE_MINUTE */.yR;
function trackFirstContentfulPaint(lifeCycle, firstHidden, callback) {
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var fcpEntry = (0,polyfills/* find */.sE)(entries, function (entry) {
            return entry.entryType === RumPerformanceEntryType.PAINT &&
                entry.name === 'first-contentful-paint' &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < FCP_MAXIMUM_DELAY;
        });
        if (fcpEntry) {
            callback(fcpEntry.startTime);
        }
    }).unsubscribe;
    return {
        stop: unsubscribeLifeCycle,
    };
}
//# sourceMappingURL=trackFirstContentfulPaint.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstInput.js




/**
 * Track the first input occurring during the initial View to return:
 * - First Input Delay
 * - First Input Time
 * Callback is called at most one time.
 * Documentation: https://web.dev/fid/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getFID.ts
 */
function trackFirstInput(lifeCycle, configuration, firstHidden, callback) {
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var firstInputEntry = (0,polyfills/* find */.sE)(entries, function (entry) {
            return entry.entryType === RumPerformanceEntryType.FIRST_INPUT && entry.startTime < firstHidden.timeStamp;
        });
        if (firstInputEntry) {
            var firstInputDelay = (0,timeUtils/* elapsed */._J)(firstInputEntry.startTime, firstInputEntry.processingStart);
            var firstInputTargetSelector = void 0;
            if ((0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.WEB_VITALS_ATTRIBUTION */.uh.WEB_VITALS_ATTRIBUTION) &&
                firstInputEntry.target &&
                isElementNode(firstInputEntry.target)) {
                firstInputTargetSelector = getSelectorFromElement(firstInputEntry.target, configuration.actionNameAttribute);
            }
            callback({
                // Ensure firstInputDelay to be positive, see
                // https://bugs.chromium.org/p/chromium/issues/detail?id=1185815
                delay: firstInputDelay >= 0 ? firstInputDelay : 0,
                time: firstInputEntry.startTime,
                targetSelector: firstInputTargetSelector,
            });
        }
    }).unsubscribe;
    return {
        stop: unsubscribeLifeCycle,
    };
}
//# sourceMappingURL=trackFirstInput.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackNavigationTimings.js


function trackNavigationTimings(lifeCycle, callback) {
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === RumPerformanceEntryType.NAVIGATION) {
                callback({
                    domComplete: entry.domComplete,
                    domContentLoaded: entry.domContentLoadedEventEnd,
                    domInteractive: entry.domInteractive,
                    loadEvent: entry.loadEventEnd,
                    // In some cases the value reported is negative or is larger
                    // than the current page time. Ignore these cases:
                    // https://github.com/GoogleChrome/web-vitals/issues/137
                    // https://github.com/GoogleChrome/web-vitals/issues/162
                    firstByte: entry.responseStart >= 0 && entry.responseStart <= (0,timeUtils/* relativeNow */._q)() ? entry.responseStart : undefined,
                });
            }
        }
    }).unsubscribe;
    return { stop: stop };
}
//# sourceMappingURL=trackNavigationTimings.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackLargestContentfulPaint.js



// Discard LCP timings above a certain delay to avoid incorrect data
// It happens in some cases like sleep mode or some browser implementations
var LCP_MAXIMUM_DELAY = 10 * timeUtils/* ONE_MINUTE */.yR;
/**
 * Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
 * multiple values, only the most recent one should be used.
 * Documentation: https://web.dev/lcp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/onLCP.ts
 */
function trackLargestContentfulPaint(lifeCycle, configuration, firstHidden, eventTarget, callback) {
    // Ignore entries that come after the first user interaction.  According to the documentation, the
    // browser should not send largest-contentful-paint entries after a user interact with the page,
    // but the web-vitals reference implementation uses this as a safeguard.
    var firstInteractionTimestamp = Infinity;
    var stopEventListener = (0,addEventListener/* addEventListeners */.y)(configuration, eventTarget, ["pointerdown" /* DOM_EVENT.POINTER_DOWN */, "keydown" /* DOM_EVENT.KEY_DOWN */], function (event) {
        firstInteractionTimestamp = event.timeStamp;
    }, { capture: true, once: true }).stop;
    var unsubscribeLifeCycle = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var lcpEntry = (0,polyfills/* findLast */.dF)(entries, function (entry) {
            return entry.entryType === RumPerformanceEntryType.LARGEST_CONTENTFUL_PAINT &&
                entry.startTime < firstInteractionTimestamp &&
                entry.startTime < firstHidden.timeStamp &&
                entry.startTime < LCP_MAXIMUM_DELAY;
        });
        if (lcpEntry) {
            var lcpTargetSelector = void 0;
            if ((0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.WEB_VITALS_ATTRIBUTION */.uh.WEB_VITALS_ATTRIBUTION) && lcpEntry.element) {
                lcpTargetSelector = getSelectorFromElement(lcpEntry.element, configuration.actionNameAttribute);
            }
            callback({
                value: lcpEntry.startTime,
                targetSelector: lcpTargetSelector,
            });
        }
    }).unsubscribe;
    return {
        stop: function () {
            stopEventListener();
            unsubscribeLifeCycle();
        },
    };
}
//# sourceMappingURL=trackLargestContentfulPaint.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstHidden.js

function trackFirstHidden(configuration, eventTarget) {
    if (eventTarget === void 0) { eventTarget = window; }
    var timeStamp;
    var stopListeners;
    if (document.visibilityState === 'hidden') {
        timeStamp = 0;
    }
    else {
        timeStamp = Infinity;
        (stopListeners = (0,addEventListener/* addEventListeners */.y)(configuration, eventTarget, ["pagehide" /* DOM_EVENT.PAGE_HIDE */, "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */], function (event) {
            if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */ || document.visibilityState === 'hidden') {
                timeStamp = event.timeStamp;
                stopListeners();
            }
        }, { capture: true }).stop);
    }
    return {
        get timeStamp() {
            return timeStamp;
        },
        stop: function () {
            stopListeners === null || stopListeners === void 0 ? void 0 : stopListeners();
        },
    };
}
//# sourceMappingURL=trackFirstHidden.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackInitialViewMetrics.js





function trackInitialViewMetrics(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate) {
    var initialViewMetrics = {};
    var stopNavigationTracking = trackNavigationTimings(lifeCycle, function (navigationTimings) {
        setLoadEvent(navigationTimings.loadEvent);
        initialViewMetrics.navigationTimings = navigationTimings;
        scheduleViewUpdate();
    }).stop;
    var firstHidden = trackFirstHidden(configuration);
    var stopFCPTracking = trackFirstContentfulPaint(lifeCycle, firstHidden, function (firstContentfulPaint) {
        initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
        scheduleViewUpdate();
    }).stop;
    var stopLCPTracking = trackLargestContentfulPaint(lifeCycle, configuration, firstHidden, window, function (largestContentfulPaint) {
        initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
        scheduleViewUpdate();
    }).stop;
    var stopFIDTracking = trackFirstInput(lifeCycle, configuration, firstHidden, function (firstInput) {
        initialViewMetrics.firstInput = firstInput;
        scheduleViewUpdate();
    }).stop;
    function stop() {
        stopNavigationTracking();
        stopFCPTracking();
        stopLCPTracking();
        stopFIDTracking();
        firstHidden.stop();
    }
    return {
        stop: stop,
        initialViewMetrics: initialViewMetrics,
    };
}
//# sourceMappingURL=trackInitialViewMetrics.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackCumulativeLayoutShift.js




/**
 * Track the cumulative layout shifts (CLS).
 * Layout shifts are grouped into session windows.
 * The minimum gap between session windows is 1 second.
 * The maximum duration of a session window is 5 second.
 * The session window layout shift value is the sum of layout shifts inside it.
 * The CLS value is the max of session windows values.
 *
 * This yields a new value whenever the CLS value is updated (a higher session window value is computed).
 *
 * See isLayoutShiftSupported to check for browser support.
 *
 * Documentation:
 * https://web.dev/cls/
 * https://web.dev/evolving-cls/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
 */
function trackCumulativeLayoutShift(configuration, lifeCycle, callback) {
    if (!isLayoutShiftSupported()) {
        return {
            stop: functionUtils/* noop */.Z,
        };
    }
    var maxClsValue = 0;
    // if no layout shift happen the value should be reported as 0
    callback({
        value: 0,
    });
    var window = slidingSessionWindow();
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (entry.entryType === RumPerformanceEntryType.LAYOUT_SHIFT && !entry.hadRecentInput) {
                window.update(entry);
                if (window.value() > maxClsValue) {
                    maxClsValue = window.value();
                    var cls = (0,numberUtils/* round */.NM)(maxClsValue, 4);
                    var clsTarget = window.largestLayoutShiftTarget();
                    var cslTargetSelector = void 0;
                    if ((0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.WEB_VITALS_ATTRIBUTION */.uh.WEB_VITALS_ATTRIBUTION) && clsTarget) {
                        cslTargetSelector = getSelectorFromElement(clsTarget, configuration.actionNameAttribute);
                    }
                    callback({
                        value: cls,
                        targetSelector: cslTargetSelector,
                    });
                }
            }
        }
    }).unsubscribe;
    return {
        stop: stop,
    };
}
function slidingSessionWindow() {
    var value = 0;
    var startTime;
    var endTime;
    var largestLayoutShift = 0;
    var largestLayoutShiftTarget;
    var largestLayoutShiftTime;
    return {
        update: function (entry) {
            var _a, _b;
            var shouldCreateNewWindow = startTime === undefined ||
                entry.startTime - endTime >= timeUtils/* ONE_SECOND */.WT ||
                entry.startTime - startTime >= 5 * timeUtils/* ONE_SECOND */.WT;
            if (shouldCreateNewWindow) {
                startTime = endTime = entry.startTime;
                value = entry.value;
                largestLayoutShift = 0;
                largestLayoutShiftTarget = undefined;
            }
            else {
                value += entry.value;
                endTime = entry.startTime;
            }
            if (entry.value > largestLayoutShift) {
                largestLayoutShift = entry.value;
                largestLayoutShiftTime = entry.startTime;
                if ((_a = entry.sources) === null || _a === void 0 ? void 0 : _a.length) {
                    largestLayoutShiftTarget = (_b = (0,polyfills/* find */.sE)(entry.sources, function (s) { return !!s.node && isElementNode(s.node); })) === null || _b === void 0 ? void 0 : _b.node;
                }
                else {
                    largestLayoutShiftTarget = undefined;
                }
            }
        },
        value: function () { return value; },
        largestLayoutShiftTarget: function () { return largestLayoutShiftTarget; },
        largestLayoutShiftTime: function () { return largestLayoutShiftTime; },
    };
}
/**
 * Check whether `layout-shift` is supported by the browser.
 */
function isLayoutShiftSupported() {
    return supportPerformanceTimingEvent(RumPerformanceEntryType.LAYOUT_SHIFT);
}
//# sourceMappingURL=trackCumulativeLayoutShift.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/interactionCountPolyfill.js
/**
 * performance.interactionCount polyfill
 *
 * The interactionCount is an integer which counts the total number of distinct user interactions,
 * for which there was a unique interactionId.
 *
 * The interactionCount polyfill is an estimate based on a convention specific to Chrome. Cf: https://github.com/GoogleChrome/web-vitals/pull/213
 * This is currently not an issue as the polyfill is only used for INP which is currently only supported on Chrome.
 * Hopefully when/if other browsers will support INP, they will also implement performance.interactionCount at the same time, so we won't need that polyfill.
 *
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
 */

var observer;
var interactionCountEstimate = 0;
var minKnownInteractionId = Infinity;
var maxKnownInteractionId = 0;
function initInteractionCountPolyfill() {
    if ('interactionCount' in performance || observer) {
        return;
    }
    observer = new window.PerformanceObserver((0,monitor/* monitor */.zk)(function (entries) {
        entries.getEntries().forEach(function (e) {
            var entry = e;
            if (entry.interactionId) {
                minKnownInteractionId = Math.min(minKnownInteractionId, entry.interactionId);
                maxKnownInteractionId = Math.max(maxKnownInteractionId, entry.interactionId);
                interactionCountEstimate = (maxKnownInteractionId - minKnownInteractionId) / 7 + 1;
            }
        });
    }));
    observer.observe({ type: 'event', buffered: true, durationThreshold: 0 });
}
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */
var getInteractionCount = function () {
    return observer ? interactionCountEstimate : window.performance.interactionCount || 0;
};
//# sourceMappingURL=interactionCountPolyfill.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackInteractionToNextPaint.js





// Arbitrary value to prevent unnecessary memory usage on views with lots of interactions.
var MAX_INTERACTION_ENTRIES = 10;
/**
 * Track the interaction to next paint (INP).
 * To avoid outliers, return the p98 worst interaction of the view.
 * Documentation: https://web.dev/inp/
 * Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/onINP.ts
 */
function trackInteractionToNextPaint(configuration, viewStart, viewLoadingType, lifeCycle) {
    if (!isInteractionToNextPaintSupported() ||
        !(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.INTERACTION_TO_NEXT_PAINT */.uh.INTERACTION_TO_NEXT_PAINT)) {
        return {
            getInteractionToNextPaint: function () { return undefined; },
            stop: functionUtils/* noop */.Z,
        };
    }
    var getViewInteractionCount = trackViewInteractionCount(viewLoadingType).getViewInteractionCount;
    var longestInteractions = trackLongestInteractions(getViewInteractionCount);
    var interactionToNextPaint = -1;
    var interactionToNextPaintTargetSelector;
    var telemetryCollected = false;
    var stop = lifeCycle.subscribe(0 /* LifeCycleEventType.PERFORMANCE_ENTRIES_COLLECTED */, function (entries) {
        var _a;
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if ((entry.entryType === RumPerformanceEntryType.EVENT ||
                entry.entryType === RumPerformanceEntryType.FIRST_INPUT) &&
                entry.interactionId) {
                longestInteractions.process(entry);
            }
        }
        var newInteraction = longestInteractions.estimateP98Interaction();
        if (newInteraction) {
            interactionToNextPaint = newInteraction.duration;
            if (interactionToNextPaint > 10 * timeUtils/* ONE_MINUTE */.yR && !telemetryCollected) {
                telemetryCollected = true;
                (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('INP outlier', {
                    inp: interactionToNextPaint,
                    interaction: {
                        timeFromViewStart: (0,timeUtils/* elapsed */._J)(viewStart.relative, newInteraction.startTime),
                        duration: newInteraction.duration,
                        startTime: newInteraction.startTime,
                        processingStart: newInteraction.processingStart,
                        processingEnd: newInteraction.processingEnd,
                        interactionId: newInteraction.interactionId,
                        name: newInteraction.name,
                        targetNodeName: (_a = newInteraction.target) === null || _a === void 0 ? void 0 : _a.nodeName,
                    },
                });
            }
            if ((0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.WEB_VITALS_ATTRIBUTION */.uh.WEB_VITALS_ATTRIBUTION) &&
                newInteraction.target &&
                isElementNode(newInteraction.target)) {
                interactionToNextPaintTargetSelector = getSelectorFromElement(newInteraction.target, configuration.actionNameAttribute);
            }
            else {
                interactionToNextPaintTargetSelector = undefined;
            }
        }
    }).unsubscribe;
    return {
        getInteractionToNextPaint: function () {
            // If no INP duration where captured because of the performanceObserver 40ms threshold
            // but the view interaction count > 0 then report 0
            if (interactionToNextPaint >= 0) {
                return {
                    value: interactionToNextPaint,
                    targetSelector: interactionToNextPaintTargetSelector,
                };
            }
            else if (getViewInteractionCount()) {
                return {
                    value: 0,
                };
            }
        },
        stop: stop,
    };
}
function trackLongestInteractions(getViewInteractionCount) {
    var longestInteractions = [];
    function sortAndTrimLongestInteractions() {
        longestInteractions.sort(function (a, b) { return b.duration - a.duration; }).splice(MAX_INTERACTION_ENTRIES);
    }
    return {
        /**
         * Process the performance entry:
         * - if its duration is long enough, add the performance entry to the list of worst interactions
         * - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
         */
        process: function (entry) {
            var interactionIndex = longestInteractions.findIndex(function (interaction) { return entry.interactionId === interaction.interactionId; });
            var minLongestInteraction = longestInteractions[longestInteractions.length - 1];
            if (interactionIndex !== -1) {
                if (entry.duration > longestInteractions[interactionIndex].duration) {
                    longestInteractions[interactionIndex] = entry;
                    sortAndTrimLongestInteractions();
                }
            }
            else if (longestInteractions.length < MAX_INTERACTION_ENTRIES ||
                entry.duration > minLongestInteraction.duration) {
                longestInteractions.push(entry);
                sortAndTrimLongestInteractions();
            }
        },
        /**
         * Compute the p98 longest interaction.
         * For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
         */
        estimateP98Interaction: function () {
            var interactionIndex = Math.min(longestInteractions.length - 1, Math.floor(getViewInteractionCount() / 50));
            return longestInteractions[interactionIndex];
        },
    };
}
function trackViewInteractionCount(viewLoadingType) {
    initInteractionCountPolyfill();
    var previousInteractionCount = viewLoadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */ ? 0 : getInteractionCount();
    return {
        getViewInteractionCount: function () { return getInteractionCount() - previousInteractionCount; },
    };
}
function isInteractionToNextPaintSupported() {
    return (supportPerformanceTimingEvent(RumPerformanceEntryType.EVENT) &&
        window.PerformanceEventTiming &&
        'interactionId' in PerformanceEventTiming.prototype);
}
//# sourceMappingURL=trackInteractionToNextPaint.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackLoadingTime.js


function trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadType, viewStart, callback) {
    var isWaitingForLoadEvent = loadType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */;
    var isWaitingForActivityLoadingTime = true;
    var loadingTimeCandidates = [];
    function invokeCallbackIfAllCandidatesAreReceived() {
        if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
            callback(Math.max.apply(Math, loadingTimeCandidates));
        }
    }
    var stop = waitPageActivityEnd(lifeCycle, domMutationObservable, configuration, function (event) {
        if (isWaitingForActivityLoadingTime) {
            isWaitingForActivityLoadingTime = false;
            if (event.hadActivity) {
                loadingTimeCandidates.push((0,timeUtils/* elapsed */._J)(viewStart.timeStamp, event.end));
            }
            invokeCallbackIfAllCandidatesAreReceived();
        }
    }).stop;
    return {
        stop: stop,
        setLoadEvent: function (loadEvent) {
            if (isWaitingForLoadEvent) {
                isWaitingForLoadEvent = false;
                loadingTimeCandidates.push(loadEvent);
                invokeCallbackIfAllCandidatesAreReceived();
            }
        },
    };
}
//# sourceMappingURL=trackLoadingTime.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/browser/scroll.js
function getScrollX() {
    var scrollX;
    var visual = window.visualViewport;
    if (visual) {
        scrollX = visual.pageLeft - visual.offsetLeft;
    }
    else if (window.scrollX !== undefined) {
        scrollX = window.scrollX;
    }
    else {
        scrollX = window.pageXOffset || 0;
    }
    return Math.round(scrollX);
}
function getScrollY() {
    var scrollY;
    var visual = window.visualViewport;
    if (visual) {
        scrollY = visual.pageTop - visual.offsetTop;
    }
    else if (window.scrollY !== undefined) {
        scrollY = window.scrollY;
    }
    else {
        scrollY = window.pageYOffset || 0;
    }
    return Math.round(scrollY);
}
//# sourceMappingURL=scroll.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/browser/viewportObservable.js

var viewportObservable;
function initViewportObservable(configuration) {
    if (!viewportObservable) {
        viewportObservable = createViewportObservable(configuration);
    }
    return viewportObservable;
}
function createViewportObservable(configuration) {
    var observable = new tools_observable/* Observable */.y(function () {
        var updateDimension = (0,functionUtils/* throttle */.P)(function () {
            observable.notify(getViewportDimension());
        }, 200).throttled;
        return (0,addEventListener/* addEventListener */.O)(configuration, window, "resize" /* DOM_EVENT.RESIZE */, updateDimension, { capture: true, passive: true })
            .stop;
    });
    return observable;
}
// excludes the width and height of any rendered classic scrollbar that is fixed to the visual viewport
function getViewportDimension() {
    var visual = window.visualViewport;
    if (visual) {
        return {
            width: Number(visual.width * visual.scale),
            height: Number(visual.height * visual.scale),
        };
    }
    return {
        width: Number(window.innerWidth || 0),
        height: Number(window.innerHeight || 0),
    };
}
//# sourceMappingURL=viewportObservable.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackScrollMetrics.js



/** Arbitrary scroll throttle duration */
var THROTTLE_SCROLL_DURATION = timeUtils/* ONE_SECOND */.WT;
function trackScrollMetrics(configuration, viewStart, callback, scrollValues) {
    if (scrollValues === void 0) { scrollValues = createScrollValuesObservable(configuration); }
    var maxScrollDepth = 0;
    var maxScrollHeight = 0;
    var maxScrollHeightTime = 0;
    var subscription = scrollValues.subscribe(function (_a) {
        var scrollDepth = _a.scrollDepth, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight;
        var shouldUpdate = false;
        if (scrollDepth > maxScrollDepth) {
            maxScrollDepth = scrollDepth;
            shouldUpdate = true;
        }
        if (scrollHeight > maxScrollHeight) {
            maxScrollHeight = scrollHeight;
            var now = (0,timeUtils/* relativeNow */._q)();
            maxScrollHeightTime = (0,timeUtils/* elapsed */._J)(viewStart.relative, now);
            shouldUpdate = true;
        }
        if (shouldUpdate) {
            callback({
                maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
                maxDepthScrollTop: scrollTop,
                maxScrollHeight: maxScrollHeight,
                maxScrollHeightTime: maxScrollHeightTime,
            });
        }
    });
    return {
        stop: function () { return subscription.unsubscribe(); },
    };
}
function computeScrollValues() {
    var scrollTop = getScrollY();
    var height = getViewportDimension().height;
    var scrollHeight = Math.round((document.scrollingElement || document.documentElement).scrollHeight);
    var scrollDepth = Math.round(height + scrollTop);
    return {
        scrollHeight: scrollHeight,
        scrollDepth: scrollDepth,
        scrollTop: scrollTop,
    };
}
function createScrollValuesObservable(configuration, throttleDuration) {
    if (throttleDuration === void 0) { throttleDuration = THROTTLE_SCROLL_DURATION; }
    var observable = new tools_observable/* Observable */.y(function () {
        function notify() {
            observable.notify(computeScrollValues());
        }
        if (window.ResizeObserver) {
            var throttledNotify_1 = (0,functionUtils/* throttle */.P)(notify, throttleDuration, {
                leading: false,
                trailing: true,
            });
            var observerTarget_1 = document.scrollingElement || document.documentElement;
            var resizeObserver_1 = new ResizeObserver((0,monitor/* monitor */.zk)(throttledNotify_1.throttled));
            resizeObserver_1.observe(observerTarget_1);
            var eventListener_1 = (0,addEventListener/* addEventListener */.O)(configuration, window, "scroll" /* DOM_EVENT.SCROLL */, throttledNotify_1.throttled, {
                passive: true,
            });
            return function () {
                throttledNotify_1.cancel();
                resizeObserver_1.unobserve(observerTarget_1);
                eventListener_1.stop();
            };
        }
    });
    return observable;
}
//# sourceMappingURL=trackScrollMetrics.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackCommonViewMetrics.js




function trackCommonViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
    var commonViewMetrics = {};
    var _a = trackLoadingTime(lifeCycle, domMutationObservable, configuration, loadingType, viewStart, function (newLoadingTime) {
        commonViewMetrics.loadingTime = newLoadingTime;
        scheduleViewUpdate();
    }), stopLoadingTimeTracking = _a.stop, setLoadEvent = _a.setLoadEvent;
    var stopScrollMetricsTracking = trackScrollMetrics(configuration, viewStart, function (newScrollMetrics) {
        commonViewMetrics.scroll = newScrollMetrics;
    }).stop;
    var stopCLSTracking = trackCumulativeLayoutShift(configuration, lifeCycle, function (cumulativeLayoutShift) {
        commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
        scheduleViewUpdate();
    }).stop;
    var _b = trackInteractionToNextPaint(configuration, viewStart, loadingType, lifeCycle), stopINPTracking = _b.stop, getInteractionToNextPaint = _b.getInteractionToNextPaint;
    return {
        stop: function () {
            stopLoadingTimeTracking();
            stopCLSTracking();
            stopScrollMetricsTracking();
            stopINPTracking();
        },
        setLoadEvent: setLoadEvent,
        getCommonViewMetrics: function () {
            commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
            return commonViewMetrics;
        },
    };
}
//# sourceMappingURL=trackCommonViewMetrics.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/trackViews.js




var THROTTLE_VIEW_UPDATE_PERIOD = 3000;
var SESSION_KEEP_ALIVE_INTERVAL = 5 * timeUtils/* ONE_MINUTE */.yR;
// Some events or metrics can be captured after the end of the view. To avoid missing those;
// an arbitrary delay is added for stopping their tracking after the view ends.
//
// Ideally, we would not stop and keep tracking events or metrics until the end of the session.
// But this might have a small performance impact if there are many many views.
// So let's have a fairly short delay improving the situation in most cases and avoid impacting performances too much.
var KEEP_TRACKING_AFTER_VIEW_DELAY = 5 * timeUtils/* ONE_MINUTE */.yR;
function trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
    var activeViews = new Set();
    var currentView = startNewView("initial_load" /* ViewLoadingType.INITIAL_LOAD */, (0,timeUtils/* clocksOrigin */.cQ)(), initialViewOptions);
    startViewLifeCycle();
    var locationChangeSubscription;
    if (areViewsTrackedAutomatically) {
        locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
    }
    function startNewView(loadingType, startClocks, viewOptions) {
        var newlyCreatedView = newView(lifeCycle, domMutationObservable, configuration, location, loadingType, startClocks, viewOptions);
        activeViews.add(newlyCreatedView);
        newlyCreatedView.stopObservable.subscribe(function () {
            activeViews.delete(newlyCreatedView);
        });
        return newlyCreatedView;
    }
    function startViewLifeCycle() {
        lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
            // Renew view on session renewal
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, undefined, {
                name: currentView.name,
                service: currentView.service,
                version: currentView.version,
            });
        });
        lifeCycle.subscribe(7 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
            currentView.end({ sessionIsActive: false });
        });
        // End the current view on page unload
        lifeCycle.subscribe(9 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
            if (pageExitEvent.reason === browser_pageExitObservable/* PageExitReason.UNLOADING */.k$.UNLOADING || pageExitEvent.reason === browser_pageExitObservable/* PageExitReason.PAGEHIDE */.k$.PAGEHIDE) {
                currentView.end();
            }
        });
    }
    function renewViewOnLocationChange(locationChangeObservable) {
        return locationChangeObservable.subscribe(function (_a) {
            var oldLocation = _a.oldLocation, newLocation = _a.newLocation;
            if (areDifferentLocation(oldLocation, newLocation)) {
                currentView.end();
                currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */);
            }
        });
    }
    return {
        addTiming: function (name, time) {
            if (time === void 0) { time = (0,timeUtils/* timeStampNow */.n$)(); }
            currentView.addTiming(name, time);
        },
        startView: function (options, startClocks) {
            currentView.end({ endClocks: startClocks });
            currentView = startNewView("route_change" /* ViewLoadingType.ROUTE_CHANGE */, startClocks, options);
        },
        stop: function () {
            locationChangeSubscription === null || locationChangeSubscription === void 0 ? void 0 : locationChangeSubscription.unsubscribe();
            currentView.end();
            activeViews.forEach(function (view) { return view.stop(); });
        },
    };
}
function newView(lifeCycle, domMutationObservable, configuration, initialLocation, loadingType, startClocks, viewOptions) {
    if (startClocks === void 0) { startClocks = (0,timeUtils/* clocksNow */.$I)(); }
    // Setup initial values
    var id = (0,stringUtils/* generateUUID */.DO)();
    var stopObservable = new tools_observable/* Observable */.y();
    var customTimings = {};
    var documentVersion = 0;
    var endClocks;
    var location = (0,objectUtils/* shallowClone */.mv)(initialLocation);
    var sessionIsActive = true;
    var name;
    var service;
    var version;
    if (viewOptions) {
        name = viewOptions.name;
        service = viewOptions.service;
        version = viewOptions.version;
    }
    lifeCycle.notify(2 /* LifeCycleEventType.VIEW_CREATED */, {
        id: id,
        name: name,
        startClocks: startClocks,
        service: service,
        version: version,
    });
    // Update the view every time the measures are changing
    var _a = (0,functionUtils/* throttle */.P)(triggerViewUpdate, THROTTLE_VIEW_UPDATE_PERIOD, {
        leading: false,
    }), scheduleViewUpdate = _a.throttled, cancelScheduleViewUpdate = _a.cancel;
    var _b = trackCommonViewMetrics(lifeCycle, domMutationObservable, configuration, scheduleViewUpdate, loadingType, startClocks), setLoadEvent = _b.setLoadEvent, stopCommonViewMetricsTracking = _b.stop, getCommonViewMetrics = _b.getCommonViewMetrics;
    var _c = loadingType === "initial_load" /* ViewLoadingType.INITIAL_LOAD */
        ? trackInitialViewMetrics(lifeCycle, configuration, setLoadEvent, scheduleViewUpdate)
        : { stop: functionUtils/* noop */.Z, initialViewMetrics: {} }, stopInitialViewMetricsTracking = _c.stop, initialViewMetrics = _c.initialViewMetrics;
    var _d = trackViewEventCounts(lifeCycle, id, scheduleViewUpdate), stopEventCountsTracking = _d.stop, eventCounts = _d.eventCounts;
    // Session keep alive
    var keepAliveIntervalId = (0,timer/* setInterval */.Zi)(triggerViewUpdate, SESSION_KEEP_ALIVE_INTERVAL);
    // Initial view update
    triggerViewUpdate();
    function triggerViewUpdate() {
        cancelScheduleViewUpdate();
        documentVersion += 1;
        var currentEnd = endClocks === undefined ? (0,timeUtils/* timeStampNow */.n$)() : endClocks.timeStamp;
        lifeCycle.notify(3 /* LifeCycleEventType.VIEW_UPDATED */, {
            customTimings: customTimings,
            documentVersion: documentVersion,
            id: id,
            name: name,
            service: service,
            version: version,
            loadingType: loadingType,
            location: location,
            startClocks: startClocks,
            commonViewMetrics: getCommonViewMetrics(),
            initialViewMetrics: initialViewMetrics,
            duration: (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, currentEnd),
            isActive: endClocks === undefined,
            sessionIsActive: sessionIsActive,
            eventCounts: eventCounts,
        });
    }
    return {
        name: name,
        service: service,
        version: version,
        stopObservable: stopObservable,
        end: function (options) {
            var _this = this;
            var _a, _b;
            if (options === void 0) { options = {}; }
            if (endClocks) {
                // view already ended
                return;
            }
            endClocks = (_a = options.endClocks) !== null && _a !== void 0 ? _a : (0,timeUtils/* clocksNow */.$I)();
            sessionIsActive = (_b = options.sessionIsActive) !== null && _b !== void 0 ? _b : true;
            lifeCycle.notify(4 /* LifeCycleEventType.VIEW_ENDED */, { endClocks: endClocks });
            (0,timer/* clearInterval */.cv)(keepAliveIntervalId);
            stopCommonViewMetricsTracking();
            triggerViewUpdate();
            (0,timer/* setTimeout */.iK)(function () {
                _this.stop();
            }, KEEP_TRACKING_AFTER_VIEW_DELAY);
        },
        stop: function () {
            stopInitialViewMetricsTracking();
            stopEventCountsTracking();
            stopObservable.notify();
        },
        addTiming: function (name, time) {
            if (endClocks) {
                return;
            }
            var relativeTime = (0,timeUtils/* looksLikeRelativeTime */.Cn)(time) ? time : (0,timeUtils/* elapsed */._J)(startClocks.timeStamp, time);
            customTimings[sanitizeTiming(name)] = relativeTime;
            scheduleViewUpdate();
        },
    };
}
/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 */
function sanitizeTiming(name) {
    var sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, '_');
    if (sanitized !== name) {
        display/* display.warn */.jf.warn("Invalid timing name: ".concat(name, ", sanitized to: ").concat(sanitized));
    }
    return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
    return (currentLocation.pathname !== otherLocation.pathname ||
        (!isHashAnAnchor(otherLocation.hash) &&
            getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash)));
}
function isHashAnAnchor(hash) {
    var correspondingId = hash.substr(1);
    return !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
    var index = hash.indexOf('?');
    return index < 0 ? hash : hash.slice(0, index);
}
//# sourceMappingURL=trackViews.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/view/viewCollection.js



function startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions) {
    lifeCycle.subscribe(3 /* LifeCycleEventType.VIEW_UPDATED */, function (view) {
        return lifeCycle.notify(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory));
    });
    return trackViews(location, lifeCycle, domMutationObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function processViewUpdate(view, configuration, featureFlagContexts, recorderApi, pageStateHistory) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var replayStats = recorderApi.getReplayStats(view.id);
    var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations(view.startClocks.relative);
    var pageStatesEnabled = (0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.PAGE_STATES */.uh.PAGE_STATES);
    var pageStates = pageStateHistory.findAll(view.startClocks.relative, view.duration);
    var viewEvent = {
        _dd: {
            document_version: view.documentVersion,
            replay_stats: replayStats,
            page_states: pageStatesEnabled ? pageStates : undefined,
        },
        date: view.startClocks.timeStamp,
        type: "view" /* RumEventType.VIEW */,
        view: {
            action: {
                count: view.eventCounts.actionCount,
            },
            frustration: {
                count: view.eventCounts.frustrationCount,
            },
            cumulative_layout_shift: (_a = view.commonViewMetrics.cumulativeLayoutShift) === null || _a === void 0 ? void 0 : _a.value,
            cumulative_layout_shift_target_selector: (_b = view.commonViewMetrics.cumulativeLayoutShift) === null || _b === void 0 ? void 0 : _b.targetSelector,
            first_byte: (0,timeUtils/* toServerDuration */.c0)((_c = view.initialViewMetrics.navigationTimings) === null || _c === void 0 ? void 0 : _c.firstByte),
            dom_complete: (0,timeUtils/* toServerDuration */.c0)((_d = view.initialViewMetrics.navigationTimings) === null || _d === void 0 ? void 0 : _d.domComplete),
            dom_content_loaded: (0,timeUtils/* toServerDuration */.c0)((_e = view.initialViewMetrics.navigationTimings) === null || _e === void 0 ? void 0 : _e.domContentLoaded),
            dom_interactive: (0,timeUtils/* toServerDuration */.c0)((_f = view.initialViewMetrics.navigationTimings) === null || _f === void 0 ? void 0 : _f.domInteractive),
            error: {
                count: view.eventCounts.errorCount,
            },
            first_contentful_paint: (0,timeUtils/* toServerDuration */.c0)(view.initialViewMetrics.firstContentfulPaint),
            first_input_delay: (0,timeUtils/* toServerDuration */.c0)((_g = view.initialViewMetrics.firstInput) === null || _g === void 0 ? void 0 : _g.delay),
            first_input_time: (0,timeUtils/* toServerDuration */.c0)((_h = view.initialViewMetrics.firstInput) === null || _h === void 0 ? void 0 : _h.time),
            first_input_target_selector: (_j = view.initialViewMetrics.firstInput) === null || _j === void 0 ? void 0 : _j.targetSelector,
            interaction_to_next_paint: (0,timeUtils/* toServerDuration */.c0)((_k = view.commonViewMetrics.interactionToNextPaint) === null || _k === void 0 ? void 0 : _k.value),
            interaction_to_next_paint_target_selector: (_l = view.commonViewMetrics.interactionToNextPaint) === null || _l === void 0 ? void 0 : _l.targetSelector,
            is_active: view.isActive,
            name: view.name,
            largest_contentful_paint: (0,timeUtils/* toServerDuration */.c0)((_m = view.initialViewMetrics.largestContentfulPaint) === null || _m === void 0 ? void 0 : _m.value),
            largest_contentful_paint_target_selector: (_o = view.initialViewMetrics.largestContentfulPaint) === null || _o === void 0 ? void 0 : _o.targetSelector,
            load_event: (0,timeUtils/* toServerDuration */.c0)((_p = view.initialViewMetrics.navigationTimings) === null || _p === void 0 ? void 0 : _p.loadEvent),
            loading_time: discardNegativeDuration((0,timeUtils/* toServerDuration */.c0)(view.commonViewMetrics.loadingTime)),
            loading_type: view.loadingType,
            long_task: {
                count: view.eventCounts.longTaskCount,
            },
            resource: {
                count: view.eventCounts.resourceCount,
            },
            time_spent: (0,timeUtils/* toServerDuration */.c0)(view.duration),
            in_foreground_periods: !pageStatesEnabled && pageStates ? mapToForegroundPeriods(pageStates, view.duration) : undefined, // Todo: Remove in the next major release
        },
        feature_flags: featureFlagContext && !(0,objectUtils/* isEmptyObject */.Qr)(featureFlagContext) ? featureFlagContext : undefined,
        display: view.commonViewMetrics.scroll
            ? {
                scroll: {
                    max_depth: view.commonViewMetrics.scroll.maxDepth,
                    max_depth_scroll_top: view.commonViewMetrics.scroll.maxDepthScrollTop,
                    max_scroll_height: view.commonViewMetrics.scroll.maxScrollHeight,
                    max_scroll_height_time: (0,timeUtils/* toServerDuration */.c0)(view.commonViewMetrics.scroll.maxScrollHeightTime),
                },
            }
            : undefined,
        session: {
            has_replay: replayStats ? true : undefined,
            is_active: view.sessionIsActive ? undefined : false,
        },
        privacy: {
            replay_level: configuration.defaultPrivacyLevel,
        },
    };
    if (!(0,objectUtils/* isEmptyObject */.Qr)(view.customTimings)) {
        viewEvent.view.custom_timings = (0,objectUtils/* mapValues */.Q8)(view.customTimings, timeUtils/* toServerDuration */.c0);
    }
    return {
        rawRumEvent: viewEvent,
        startTime: view.startClocks.relative,
        domainContext: {
            location: view.location,
        },
    };
}
function discardNegativeDuration(duration) {
    return (0,numberUtils/* isNumber */.hj)(duration) && duration < 0 ? undefined : duration;
}
//# sourceMappingURL=viewCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js
var session_sessionManager = __webpack_require__(42972);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/rumSessionManager.js

var RUM_SESSION_KEY = 'rum';
function startRumSessionManager(configuration, lifeCycle) {
    var sessionManager = (0,session_sessionManager/* startSessionManager */.HX)(configuration, RUM_SESSION_KEY, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    sessionManager.expireObservable.subscribe(function () {
        lifeCycle.notify(7 /* LifeCycleEventType.SESSION_EXPIRED */);
    });
    sessionManager.renewObservable.subscribe(function () {
        lifeCycle.notify(8 /* LifeCycleEventType.SESSION_RENEWED */);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            if (!session || !isTypeTracked(session.trackingType)) {
                return;
            }
            var plan = session.trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */
                ? 2 /* RumSessionPlan.WITH_SESSION_REPLAY */
                : 1 /* RumSessionPlan.WITHOUT_SESSION_REPLAY */;
            return {
                id: session.id,
                plan: plan,
                sessionReplayAllowed: plan === 2 /* RumSessionPlan.WITH_SESSION_REPLAY */,
                longTaskAllowed: configuration.trackLongTasks !== undefined
                    ? configuration.trackLongTasks
                    : configuration.oldPlansBehavior && plan === 2 /* RumSessionPlan.WITH_SESSION_REPLAY */,
                resourceAllowed: configuration.trackResources !== undefined
                    ? configuration.trackResources
                    : configuration.oldPlansBehavior && plan === 2 /* RumSessionPlan.WITH_SESSION_REPLAY */,
            };
        },
        expire: sessionManager.expire,
        expireObservable: sessionManager.expireObservable,
    };
}
/**
 * Start a tracked replay session stub
 */
function startRumSessionManagerStub() {
    var session = {
        id: '00000000-aaaa-0000-aaaa-000000000000',
        plan: 1 /* RumSessionPlan.WITHOUT_SESSION_REPLAY */,
        sessionReplayAllowed: false,
        longTaskAllowed: true,
        resourceAllowed: true,
    };
    return {
        findTrackedSession: function () { return session; },
        expire: functionUtils/* noop */.Z,
        expireObservable: new tools_observable/* Observable */.y(),
    };
}
function computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if (hasValidRumSession(rawTrackingType)) {
        trackingType = rawTrackingType;
    }
    else if (!(0,numberUtils/* performDraw */.y7)(configuration.sessionSampleRate)) {
        trackingType = "0" /* RumTrackingType.NOT_TRACKED */;
    }
    else if (!(0,numberUtils/* performDraw */.y7)(configuration.sessionReplaySampleRate)) {
        trackingType = "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */;
    }
    else {
        trackingType = "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */;
    }
    return {
        trackingType: trackingType,
        isTracked: isTypeTracked(trackingType),
    };
}
function hasValidRumSession(trackingType) {
    return (trackingType === "0" /* RumTrackingType.NOT_TRACKED */ ||
        trackingType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */ ||
        trackingType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */);
}
function isTypeTracked(rumSessionType) {
    return (rumSessionType === "2" /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */ ||
        rumSessionType === "1" /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */);
}
//# sourceMappingURL=rumSessionManager.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/startBatchWithReplica.js + 2 modules
var startBatchWithReplica = __webpack_require__(22556);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/transport/startRumBatch.js

function startRumBatch(configuration, lifeCycle, telemetryEventObservable, reportError, pageExitObservable, sessionExpireObservable) {
    var replica = configuration.replica;
    var batch = (0,startBatchWithReplica/* startBatchWithReplica */.W)(configuration, {
        endpoint: configuration.rumEndpointBuilder,
    }, replica && {
        endpoint: replica.rumEndpointBuilder,
        transformMessage: function (message) { return (0,mergeInto/* combine */.$e)(message, { application: { id: replica.applicationId } }); },
    }, reportError, pageExitObservable, sessionExpireObservable);
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        if (serverRumEvent.type === "view" /* RumEventType.VIEW */) {
            batch.upsert(serverRumEvent, serverRumEvent.view.id);
        }
        else {
            batch.add(serverRumEvent);
        }
    });
    telemetryEventObservable.subscribe(function (event) { return batch.add(event, (0,telemetry_telemetry/* isTelemetryReplicationAllowed */.VG)(configuration)); });
    return batch;
}
//# sourceMappingURL=startRumBatch.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/transport/startRumEventBridge.js

function startRumEventBridge(lifeCycle) {
    var bridge = (0,eventBridge/* getEventBridge */.A)();
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (serverRumEvent) {
        bridge.send('rum', serverRumEvent);
    });
}
//# sourceMappingURL=startRumEventBridge.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/urlContexts.js

/**
 * We want to attach to an event:
 * - the url corresponding to its start
 * - the referrer corresponding to the previous view url (or document referrer for initial view)
 */
var URL_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
function startUrlContexts(lifeCycle, locationChangeObservable, location) {
    var urlContextHistory = new valueHistory/* ValueHistory */.P(URL_CONTEXT_TIME_OUT_DELAY);
    var previousViewUrl;
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        urlContextHistory.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        var viewUrl = location.href;
        urlContextHistory.add(buildUrlContext({
            url: viewUrl,
            referrer: !previousViewUrl ? document.referrer : previousViewUrl,
        }), startClocks.relative);
        previousViewUrl = viewUrl;
    });
    var locationChangeSubscription = locationChangeObservable.subscribe(function (_a) {
        var newLocation = _a.newLocation;
        var current = urlContextHistory.find();
        if (current) {
            var changeTime = (0,timeUtils/* relativeNow */._q)();
            urlContextHistory.closeActive(changeTime);
            urlContextHistory.add(buildUrlContext({
                url: newLocation.href,
                referrer: current.referrer,
            }), changeTime);
        }
    });
    function buildUrlContext(_a) {
        var url = _a.url, referrer = _a.referrer;
        return {
            url: url,
            referrer: referrer,
        };
    }
    return {
        findUrl: function (startTime) { return urlContextHistory.find(startTime); },
        stop: function () {
            locationChangeSubscription.unsubscribe();
            urlContextHistory.stop();
        },
    };
}
//# sourceMappingURL=urlContexts.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/browser/locationChangeObservable.js

function createLocationChangeObservable(configuration, location) {
    var currentLocation = (0,objectUtils/* shallowClone */.mv)(location);
    var observable = new tools_observable/* Observable */.y(function () {
        var stopHistoryTracking = trackHistory(configuration, onLocationChange).stop;
        var stopHashTracking = trackHash(configuration, onLocationChange).stop;
        return function () {
            stopHistoryTracking();
            stopHashTracking();
        };
    });
    function onLocationChange() {
        if (currentLocation.href === location.href) {
            return;
        }
        var newLocation = (0,objectUtils/* shallowClone */.mv)(location);
        observable.notify({
            newLocation: newLocation,
            oldLocation: currentLocation,
        });
        currentLocation = newLocation;
    }
    return observable;
}
function trackHistory(configuration, onHistoryChange) {
    var stopInstrumentingPushState = (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(history, 'pushState', {
        after: onHistoryChange,
    }).stop;
    var stopInstrumentingReplaceState = (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(history, 'replaceState', {
        after: onHistoryChange,
    }).stop;
    var removeListener = (0,addEventListener/* addEventListener */.O)(configuration, window, "popstate" /* DOM_EVENT.POP_STATE */, onHistoryChange).stop;
    return {
        stop: function () {
            stopInstrumentingPushState();
            stopInstrumentingReplaceState();
            removeListener();
        },
    };
}
function trackHash(configuration, onHashChange) {
    return (0,addEventListener/* addEventListener */.O)(configuration, window, "hashchange" /* DOM_EVENT.HASH_CHANGE */, onHashChange);
}
//# sourceMappingURL=locationChangeObservable.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(10160);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.js
var jsonStringify = __webpack_require__(41192);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/context/heavyCustomerDataWarning.js
var heavyCustomerDataWarning = __webpack_require__(89258);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/featureFlagContext.js

var FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
var BYTES_COMPUTATION_THROTTLING_DELAY = 200;
/**
 * Start feature flag contexts
 *
 * Feature flag contexts follow the life of views.
 * A new context is added when a view is created and ended when the view is ended
 *
 * Note: we choose not to add a new context at each evaluation to save memory
 */
function startFeatureFlagContexts(lifeCycle, computeBytesCountImpl) {
    if (computeBytesCountImpl === void 0) { computeBytesCountImpl = byteUtils/* computeBytesCount */.qt; }
    if (!(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.FEATURE_FLAGS */.uh.FEATURE_FLAGS)) {
        return {
            findFeatureFlagEvaluations: function () { return undefined; },
            getFeatureFlagBytesCount: function () { return 0; },
            addFeatureFlagEvaluation: functionUtils/* noop */.Z,
            stop: functionUtils/* noop */.Z,
        };
    }
    var featureFlagContexts = new valueHistory/* ValueHistory */.P(FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY);
    var bytesCountCache = 0;
    var alreadyWarned = false;
    lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function (_a) {
        var endClocks = _a.endClocks;
        featureFlagContexts.closeActive(endClocks.relative);
    });
    lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (_a) {
        var startClocks = _a.startClocks;
        featureFlagContexts.add({}, startClocks.relative);
        bytesCountCache = 0;
    });
    // Throttle the bytes computation to minimize the impact on performance.
    // Especially useful if the user call addFeatureFlagEvaluation API synchronously multiple times in a row
    var _a = (0,functionUtils/* throttle */.P)(function (context) {
        bytesCountCache = computeBytesCountImpl((0,jsonStringify/* jsonStringify */.l)(context));
        if (!alreadyWarned) {
            alreadyWarned = (0,heavyCustomerDataWarning/* warnIfCustomerDataLimitReached */.H)(bytesCountCache, 0 /* CustomerDataType.FeatureFlag */);
        }
    }, BYTES_COMPUTATION_THROTTLING_DELAY), computeBytesCountThrottled = _a.throttled, cancelPendingComputation = _a.cancel;
    return {
        findFeatureFlagEvaluations: function (startTime) { return featureFlagContexts.find(startTime); },
        getFeatureFlagBytesCount: function () {
            var currentContext = featureFlagContexts.find();
            if (!currentContext) {
                return 0;
            }
            return bytesCountCache;
        },
        addFeatureFlagEvaluation: function (key, value) {
            var currentContext = featureFlagContexts.find();
            if (currentContext) {
                currentContext[key] = value;
                computeBytesCountThrottled(currentContext);
            }
        },
        stop: cancelPendingComputation,
    };
}
//# sourceMappingURL=featureFlagContext.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/startCustomerDataTelemetry.js

var MEASURES_PERIOD_DURATION = 10 * timeUtils/* ONE_SECOND */.WT;
var currentPeriodMeasures;
var currentBatchMeasures;
var batchHasRumEvent;
function startCustomerDataTelemetry(configuration, telemetry, lifeCycle, globalContextManager, userContextManager, featureFlagContexts, batchFlushObservable) {
    var customerDataTelemetryEnabled = telemetry.enabled && (0,numberUtils/* performDraw */.y7)(configuration.customerDataTelemetrySampleRate);
    if (!customerDataTelemetryEnabled) {
        return;
    }
    initCurrentPeriodMeasures();
    initCurrentBatchMeasures();
    // We measure the data of every view updates even if there could only be one per batch due to the upsert
    // It means that contexts bytes count sums can be higher than it really is
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) {
        batchHasRumEvent = true;
        updateMeasure(currentBatchMeasures.globalContextBytes, !(0,objectUtils/* isEmptyObject */.Qr)(globalContextManager.get()) ? globalContextManager.getBytesCount() : 0);
        updateMeasure(currentBatchMeasures.userContextBytes, !(0,objectUtils/* isEmptyObject */.Qr)(userContextManager.get()) ? userContextManager.getBytesCount() : 0);
        var featureFlagContext = featureFlagContexts.findFeatureFlagEvaluations();
        var hasFeatureFlagContext = (0,polyfills/* includes */.q9)(["view" /* RumEventType.VIEW */, "error" /* RumEventType.ERROR */], event.type) &&
            featureFlagContext &&
            !(0,objectUtils/* isEmptyObject */.Qr)(featureFlagContext);
        updateMeasure(currentBatchMeasures.featureFlagBytes, hasFeatureFlagContext ? featureFlagContexts.getFeatureFlagBytesCount() : 0);
    });
    batchFlushObservable.subscribe(function (_a) {
        var bytesCount = _a.bytesCount, messagesCount = _a.messagesCount;
        // Don't measure batch that only contains telemetry events to avoid batch sending loop
        // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
        if (!batchHasRumEvent) {
            return;
        }
        currentPeriodMeasures.batchCount += 1;
        updateMeasure(currentPeriodMeasures.batchBytesCount, bytesCount);
        updateMeasure(currentPeriodMeasures.batchMessagesCount, messagesCount);
        mergeMeasure(currentPeriodMeasures.globalContextBytes, currentBatchMeasures.globalContextBytes);
        mergeMeasure(currentPeriodMeasures.userContextBytes, currentBatchMeasures.userContextBytes);
        mergeMeasure(currentPeriodMeasures.featureFlagBytes, currentBatchMeasures.featureFlagBytes);
        initCurrentBatchMeasures();
    });
    (0,timer/* setInterval */.Zi)(sendCurrentPeriodMeasures, MEASURES_PERIOD_DURATION);
}
function sendCurrentPeriodMeasures() {
    if (currentPeriodMeasures.batchCount === 0) {
        return;
    }
    (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Customer data measures', currentPeriodMeasures);
    initCurrentPeriodMeasures();
}
function createMeasure() {
    return { min: Infinity, max: 0, sum: 0 };
}
function updateMeasure(measure, value) {
    measure.sum += value;
    measure.min = Math.min(measure.min, value);
    measure.max = Math.max(measure.max, value);
}
function mergeMeasure(target, source) {
    target.sum += source.sum;
    target.min = Math.min(target.min, source.min);
    target.max = Math.max(target.max, source.max);
}
function initCurrentPeriodMeasures() {
    currentPeriodMeasures = {
        batchCount: 0,
        batchBytesCount: createMeasure(),
        batchMessagesCount: createMeasure(),
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
function initCurrentBatchMeasures() {
    batchHasRumEvent = false;
    currentBatchMeasures = {
        globalContextBytes: createMeasure(),
        userContextBytes: createMeasure(),
        featureFlagBytes: createMeasure(),
    };
}
//# sourceMappingURL=startCustomerDataTelemetry.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/pageStateHistory.js

// Arbitrary value to cap number of element for memory consumption in the browser
var MAX_PAGE_STATE_ENTRIES = 4000;
// Arbitrary value to cap number of element for backend & to save bandwidth
var MAX_PAGE_STATE_ENTRIES_SELECTABLE = 500;
var PAGE_STATE_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.T;
function startPageStateHistory(configuration, maxPageStateEntriesSelectable) {
    if (maxPageStateEntriesSelectable === void 0) { maxPageStateEntriesSelectable = MAX_PAGE_STATE_ENTRIES_SELECTABLE; }
    var pageStateHistory = new valueHistory/* ValueHistory */.P(PAGE_STATE_CONTEXT_TIME_OUT_DELAY, MAX_PAGE_STATE_ENTRIES);
    var currentPageState;
    addPageState(getPageState(), (0,timeUtils/* relativeNow */._q)());
    var stopEventListeners = (0,addEventListener/* addEventListeners */.y)(configuration, window, [
        "pageshow" /* DOM_EVENT.PAGE_SHOW */,
        "focus" /* DOM_EVENT.FOCUS */,
        "blur" /* DOM_EVENT.BLUR */,
        "visibilitychange" /* DOM_EVENT.VISIBILITY_CHANGE */,
        "resume" /* DOM_EVENT.RESUME */,
        "freeze" /* DOM_EVENT.FREEZE */,
        "pagehide" /* DOM_EVENT.PAGE_HIDE */,
    ], function (event) {
        // Only get events fired by the browser to avoid false currentPageState changes done with custom events
        // cf: developer extension auto flush: https://github.com/DataDog/browser-sdk/blob/2f72bf05a672794c9e33965351964382a94c72ba/developer-extension/src/panel/flushEvents.ts#L11-L12
        if (event.isTrusted) {
            addPageState(computePageState(event), event.timeStamp);
        }
    }, { capture: true }).stop;
    function addPageState(nextPageState, startTime) {
        if (startTime === void 0) { startTime = (0,timeUtils/* relativeNow */._q)(); }
        if (nextPageState === currentPageState) {
            return;
        }
        currentPageState = nextPageState;
        pageStateHistory.closeActive(startTime);
        pageStateHistory.add({ state: currentPageState, startTime: startTime }, startTime);
    }
    return {
        findAll: function (eventStartTime, duration) {
            var pageStateEntries = pageStateHistory.findAll(eventStartTime, duration);
            if (pageStateEntries.length === 0) {
                return;
            }
            var pageStateServerEntries = [];
            // limit the number of entries to return
            var limit = Math.max(0, pageStateEntries.length - maxPageStateEntriesSelectable);
            // loop page state entries backward to return the selected ones in desc order
            for (var index = pageStateEntries.length - 1; index >= limit; index--) {
                var pageState = pageStateEntries[index];
                // compute the start time relative to the event start time (ex: to be relative to the view start time)
                var relativeStartTime = (0,timeUtils/* elapsed */._J)(eventStartTime, pageState.startTime);
                pageStateServerEntries.push({
                    state: pageState.state,
                    start: (0,timeUtils/* toServerDuration */.c0)(relativeStartTime),
                });
            }
            return pageStateServerEntries;
        },
        isInActivePageStateAt: function (startTime) {
            var pageStateEntry = pageStateHistory.find(startTime);
            return pageStateEntry !== undefined && pageStateEntry.state === "active" /* PageState.ACTIVE */;
        },
        addPageState: addPageState,
        stop: function () {
            stopEventListeners();
            pageStateHistory.stop();
        },
    };
}
function computePageState(event) {
    if (event.type === "freeze" /* DOM_EVENT.FREEZE */) {
        return "frozen" /* PageState.FROZEN */;
    }
    else if (event.type === "pagehide" /* DOM_EVENT.PAGE_HIDE */) {
        return event.persisted ? "frozen" /* PageState.FROZEN */ : "terminated" /* PageState.TERMINATED */;
    }
    return getPageState();
}
function getPageState() {
    if (document.visibilityState === 'hidden') {
        return "hidden" /* PageState.HIDDEN */;
    }
    if (document.hasFocus()) {
        return "active" /* PageState.ACTIVE */;
    }
    return "passive" /* PageState.PASSIVE */;
}
//# sourceMappingURL=pageStateHistory.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/contexts/displayContext.js

function startDisplayContext(configuration) {
    var viewport = getViewportDimension();
    var unsubscribeViewport = initViewportObservable(configuration).subscribe(function (viewportDimension) {
        viewport = viewportDimension;
    }).unsubscribe;
    return {
        get: function () { return ({ viewport: viewport }); },
        stop: unsubscribeViewport,
    };
}
//# sourceMappingURL=displayContext.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/boot/startRum.js
























function startRum(initConfiguration, configuration, recorderApi, globalContextManager, userContextManager, initialViewOptions) {
    var cleanupTasks = [];
    var lifeCycle = new LifeCycle();
    lifeCycle.subscribe(11 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, function (event) { return (0,sendToExtension/* sendToExtension */.j)('rum', event); });
    var telemetry = startRumTelemetry(configuration);
    telemetry.setContextProvider(function () {
        var _a, _b;
        return ({
            application: {
                id: configuration.applicationId,
            },
            session: {
                id: (_a = session.findTrackedSession()) === null || _a === void 0 ? void 0 : _a.id,
            },
            view: {
                id: (_b = viewContexts.findView()) === null || _b === void 0 ? void 0 : _b.id,
            },
            action: {
                id: actionContexts.findActionId(),
            },
        });
    });
    var reportError = function (error) {
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error });
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Error reported to customer', { 'error.message': error.message });
    };
    var featureFlagContexts = startFeatureFlagContexts(lifeCycle);
    var pageExitObservable = (0,browser_pageExitObservable/* createPageExitObservable */.Pd)(configuration);
    var pageExitSubscription = pageExitObservable.subscribe(function (event) {
        lifeCycle.notify(9 /* LifeCycleEventType.PAGE_EXITED */, event);
    });
    cleanupTasks.push(function () { return pageExitSubscription.unsubscribe(); });
    var session = !(0,eventBridge/* canUseEventBridge */.x)() ? startRumSessionManager(configuration, lifeCycle) : startRumSessionManagerStub();
    if (!(0,eventBridge/* canUseEventBridge */.x)()) {
        var batch_1 = startRumBatch(configuration, lifeCycle, telemetry.observable, reportError, pageExitObservable, session.expireObservable);
        cleanupTasks.push(function () { return batch_1.stop(); });
        startCustomerDataTelemetry(configuration, telemetry, lifeCycle, globalContextManager, userContextManager, featureFlagContexts, batch_1.flushObservable);
    }
    else {
        startRumEventBridge(lifeCycle);
    }
    var domMutationObservable = createDOMMutationObservable();
    var locationChangeObservable = createLocationChangeObservable(configuration, location);
    var _a = startRumEventCollection(lifeCycle, configuration, location, session, locationChangeObservable, domMutationObservable, function () { return buildCommonContext(globalContextManager, userContextManager, recorderApi); }, reportError), viewContexts = _a.viewContexts, pageStateHistory = _a.pageStateHistory, urlContexts = _a.urlContexts, actionContexts = _a.actionContexts, addAction = _a.addAction, stopRumEventCollection = _a.stop;
    cleanupTasks.push(stopRumEventCollection);
    (0,telemetry_telemetry/* addTelemetryConfiguration */.Uo)(serializeRumConfiguration(initConfiguration));
    startLongTaskCollection(lifeCycle, session);
    startResourceCollection(lifeCycle, configuration, session, pageStateHistory);
    var _b = startViewCollection(lifeCycle, configuration, location, domMutationObservable, locationChangeObservable, featureFlagContexts, pageStateHistory, recorderApi, initialViewOptions), addTiming = _b.addTiming, startView = _b.startView, stopViewCollection = _b.stop;
    cleanupTasks.push(stopViewCollection);
    var addError = startErrorCollection(lifeCycle, configuration, pageStateHistory, featureFlagContexts).addError;
    startRequestCollection(lifeCycle, configuration, session);
    startPerformanceCollection(lifeCycle, configuration);
    var internalContext = startInternalContext(configuration.applicationId, session, viewContexts, actionContexts, urlContexts);
    return {
        addAction: addAction,
        addError: addError,
        addTiming: addTiming,
        addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
        startView: startView,
        lifeCycle: lifeCycle,
        viewContexts: viewContexts,
        session: session,
        stopSession: function () { return session.expire(); },
        getInternalContext: internalContext.get,
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
function startRumTelemetry(configuration) {
    var telemetry = (0,telemetry_telemetry/* startTelemetry */.VL)("browser-rum-sdk" /* TelemetryService.RUM */, configuration);
    if ((0,eventBridge/* canUseEventBridge */.x)()) {
        var bridge_1 = (0,eventBridge/* getEventBridge */.A)();
        telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
    }
    return telemetry;
}
function startRumEventCollection(lifeCycle, configuration, location, sessionManager, locationChangeObservable, domMutationObservable, buildCommonContext, reportError) {
    var viewContexts = startViewContexts(lifeCycle);
    var urlContexts = startUrlContexts(lifeCycle, locationChangeObservable, location);
    var pageStateHistory = startPageStateHistory(configuration);
    var _a = startActionCollection(lifeCycle, domMutationObservable, configuration, pageStateHistory), addAction = _a.addAction, actionContexts = _a.actionContexts;
    var displayContext = startDisplayContext(configuration);
    startRumAssembly(configuration, lifeCycle, sessionManager, viewContexts, urlContexts, actionContexts, displayContext, buildCommonContext, reportError);
    return {
        viewContexts: viewContexts,
        pageStateHistory: pageStateHistory,
        urlContexts: urlContexts,
        addAction: addAction,
        actionContexts: actionContexts,
        stop: function () {
            displayContext.stop();
            pageStateHistory.stop();
            urlContexts.stop();
            viewContexts.stop();
            pageStateHistory.stop();
        },
    };
}
//# sourceMappingURL=startRum.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/intakeSites.js
var intakeSites = __webpack_require__(61280);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/domain/getSessionReplayUrl.js

function getSessionReplayUrl(configuration, _a) {
    var session = _a.session, viewContext = _a.viewContext, errorType = _a.errorType;
    var sessionId = session ? session.id : 'no-session-id';
    var parameters = [];
    if (errorType !== undefined) {
        parameters.push("error-type=".concat(errorType));
    }
    if (viewContext) {
        parameters.push("seed=".concat(viewContext.id));
        parameters.push("from=".concat(viewContext.startClocks.timeStamp));
    }
    var origin = getDatadogSiteUrl(configuration);
    var path = "/rum/replay/sessions/".concat(sessionId);
    return "".concat(origin).concat(path, "?").concat(parameters.join('&'));
}
function getDatadogSiteUrl(rumConfiguration) {
    var site = rumConfiguration.site;
    var subdomain = rumConfiguration.subdomain || getSiteDefaultSubdomain(rumConfiguration);
    return "https://".concat(subdomain ? "".concat(subdomain, ".") : '').concat(site);
}
function getSiteDefaultSubdomain(configuration) {
    switch (configuration.site) {
        case intakeSites/* INTAKE_SITE_US1 */.D_:
        case intakeSites/* INTAKE_SITE_EU1 */.Ds:
            return 'app';
        case intakeSites/* INTAKE_SITE_STAGING */.DZ:
            return 'dd';
        default:
            return undefined;
    }
}
//# sourceMappingURL=getSessionReplayUrl.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum-core/esm/index.js










//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/httpRequest.js + 1 modules
var transport_httpRequest = __webpack_require__(13152);
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/types/sessionReplayConstants.js
var RecordType = {
    FullSnapshot: 2,
    IncrementalSnapshot: 3,
    Meta: 4,
    Focus: 6,
    ViewEnd: 7,
    VisualViewport: 8,
    FrustrationRecord: 9,
};
var NodeType = {
    Document: 0,
    DocumentType: 1,
    Element: 2,
    Text: 3,
    CDATA: 4,
    DocumentFragment: 11,
};
var IncrementalSource = {
    Mutation: 0,
    MouseMove: 1,
    MouseInteraction: 2,
    Scroll: 3,
    ViewportResize: 4,
    Input: 5,
    TouchMove: 6,
    MediaInteraction: 7,
    StyleSheetRule: 8,
    // CanvasMutation : 9,
    // Font : 10,
};
var MouseInteractionType = {
    MouseUp: 0,
    MouseDown: 1,
    Click: 2,
    ContextMenu: 3,
    DblClick: 4,
    Focus: 5,
    Blur: 6,
    TouchStart: 7,
    TouchEnd: 9,
};
var MediaInteractionType = {
    Play: 0,
    Pause: 1,
};
//# sourceMappingURL=sessionReplayConstants.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/types/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/assembly.js


function assembleIncrementalSnapshot(source, data) {
    return {
        data: (0,polyfills/* assign */.f0)({
            source: source,
        }, data),
        type: RecordType.IncrementalSnapshot,
        timestamp: (0,timeUtils/* timeStampNow */.n$)(),
    };
}
//# sourceMappingURL=assembly.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/constants.js

var NodePrivacyLevel = {
    IGNORE: 'ignore',
    HIDDEN: 'hidden',
    ALLOW: configuration_configuration/* DefaultPrivacyLevel.ALLOW */.Jj.ALLOW,
    MASK: configuration_configuration/* DefaultPrivacyLevel.MASK */.Jj.MASK,
    MASK_USER_INPUT: configuration_configuration/* DefaultPrivacyLevel.MASK_USER_INPUT */.Jj.MASK_USER_INPUT,
};
var PRIVACY_ATTR_NAME = 'data-dd-privacy';
// Privacy Attrs
var PRIVACY_ATTR_VALUE_ALLOW = 'allow';
var PRIVACY_ATTR_VALUE_MASK = 'mask';
var PRIVACY_ATTR_VALUE_MASK_USER_INPUT = 'mask-user-input';
var PRIVACY_ATTR_VALUE_HIDDEN = 'hidden';
// Privacy Classes - not all customers can set plain HTML attributes, so support classes too
var PRIVACY_CLASS_ALLOW = 'dd-privacy-allow';
var PRIVACY_CLASS_MASK = 'dd-privacy-mask';
var PRIVACY_CLASS_MASK_USER_INPUT = 'dd-privacy-mask-user-input';
var PRIVACY_CLASS_HIDDEN = 'dd-privacy-hidden';
// Private Replacement Templates
var CENSORED_STRING_MARK = '***';
var CENSORED_IMG_MARK = 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==';
var FORM_PRIVATE_TAG_NAMES = {
    INPUT: true,
    OUTPUT: true,
    TEXTAREA: true,
    SELECT: true,
    OPTION: true,
    DATALIST: true,
    OPTGROUP: true,
};
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/privacy.js


var MAX_ATTRIBUTE_VALUE_CHAR_LENGTH = 100000;
var TEXT_MASKING_CHAR = 'x';
/**
 * Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
 * know, it is best to use something like:
 *
 * derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
 */
function getNodePrivacyLevel(node, defaultPrivacyLevel) {
    var parentNode = getParentNode(node);
    var parentNodePrivacyLevel = parentNode ? getNodePrivacyLevel(parentNode, defaultPrivacyLevel) : defaultPrivacyLevel;
    var selfNodePrivacyLevel = getNodeSelfPrivacyLevel(node);
    return reducePrivacyLevel(selfNodePrivacyLevel, parentNodePrivacyLevel);
}
/**
 * Reduces the next privacy level based on self + parent privacy levels
 */
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
    switch (parentNodePrivacyLevel) {
        // These values cannot be overridden
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return parentNodePrivacyLevel;
    }
    switch (childPrivacyLevel) {
        case NodePrivacyLevel.ALLOW:
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.MASK_USER_INPUT:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return childPrivacyLevel;
        default:
            return parentNodePrivacyLevel;
    }
}
/**
 * Determines the node's own privacy level without checking for ancestors.
 */
function getNodeSelfPrivacyLevel(node) {
    // Only Element types can have a privacy level set
    if (!isElementNode(node)) {
        return;
    }
    var privAttr = node.getAttribute(PRIVACY_ATTR_NAME);
    // Overrules for replay purpose
    if (node.tagName === 'BASE') {
        return NodePrivacyLevel.ALLOW;
    }
    // Overrules to enforce end-user protection
    if (node.tagName === 'INPUT') {
        var inputElement = node;
        if (inputElement.type === 'password' || inputElement.type === 'email' || inputElement.type === 'tel') {
            return NodePrivacyLevel.MASK;
        }
        if (inputElement.type === 'hidden') {
            return NodePrivacyLevel.MASK;
        }
        var autocomplete = inputElement.getAttribute('autocomplete');
        // Handle input[autocomplete=cc-number/cc-csc/cc-exp/cc-exp-month/cc-exp-year]
        if (autocomplete && autocomplete.indexOf('cc-') === 0) {
            return NodePrivacyLevel.MASK;
        }
    }
    // Check HTML privacy attributes and classes
    if (privAttr === PRIVACY_ATTR_VALUE_HIDDEN || node.classList.contains(PRIVACY_CLASS_HIDDEN)) {
        return NodePrivacyLevel.HIDDEN;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK || node.classList.contains(PRIVACY_CLASS_MASK)) {
        return NodePrivacyLevel.MASK;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_MASK_USER_INPUT || node.classList.contains(PRIVACY_CLASS_MASK_USER_INPUT)) {
        return NodePrivacyLevel.MASK_USER_INPUT;
    }
    if (privAttr === PRIVACY_ATTR_VALUE_ALLOW || node.classList.contains(PRIVACY_CLASS_ALLOW)) {
        return NodePrivacyLevel.ALLOW;
    }
    if (shouldIgnoreElement(node)) {
        return NodePrivacyLevel.IGNORE;
    }
}
/**
 * Helper aiming to unify `mask` and `mask-user-input` privacy levels:
 *
 * In the `mask` case, it is trivial: we should mask the element.
 *
 * In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
 * direct parent is a form element for text nodes).
 *
 * Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
 * node if it is ignored or hidden? it doesn't matter since it won't be serialized).
 */
function shouldMaskNode(node, privacyLevel) {
    switch (privacyLevel) {
        case NodePrivacyLevel.MASK:
        case NodePrivacyLevel.HIDDEN:
        case NodePrivacyLevel.IGNORE:
            return true;
        case NodePrivacyLevel.MASK_USER_INPUT:
            return isTextNode(node) ? isFormElement(node.parentNode) : isFormElement(node);
        default:
            return false;
    }
}
function isFormElement(node) {
    if (!node || node.nodeType !== node.ELEMENT_NODE) {
        return false;
    }
    var element = node;
    if (element.tagName === 'INPUT') {
        switch (element.type) {
            case 'button':
            case 'color':
            case 'reset':
            case 'submit':
                return false;
        }
    }
    return !!FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
 * Text censoring non-destructively maintains whitespace characters in order to preserve text shape
 * during replay.
 */
var censorText = function (text) { return text.replace(/\S/g, TEXT_MASKING_CHAR); };
function getTextContent(textNode, ignoreWhiteSpace, parentNodePrivacyLevel) {
    var _a;
    // The parent node may not be a html element which has a tagName attribute.
    // So just let it be undefined which is ok in this use case.
    var parentTagName = (_a = textNode.parentElement) === null || _a === void 0 ? void 0 : _a.tagName;
    var textContent = textNode.textContent || '';
    if (ignoreWhiteSpace && !textContent.trim()) {
        return;
    }
    var nodePrivacyLevel = parentNodePrivacyLevel;
    var isScript = parentTagName === 'SCRIPT';
    if (isScript) {
        // For perf reasons, we don't record script (heuristic)
        textContent = CENSORED_STRING_MARK;
    }
    else if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // Should never occur, but just in case, we set to CENSORED_MARK.
        textContent = CENSORED_STRING_MARK;
    }
    else if (shouldMaskNode(textNode, nodePrivacyLevel)) {
        if (
        // Scrambling the child list breaks text nodes for DATALIST/SELECT/OPTGROUP
        parentTagName === 'DATALIST' ||
            parentTagName === 'SELECT' ||
            parentTagName === 'OPTGROUP') {
            if (!textContent.trim()) {
                return;
            }
        }
        else if (parentTagName === 'OPTION') {
            // <Option> has low entropy in charset + text length, so use `CENSORED_STRING_MARK` when masked
            textContent = CENSORED_STRING_MARK;
        }
        else {
            textContent = censorText(textContent);
        }
    }
    return textContent;
}
/**
 * TODO: Preserve CSS element order, and record the presence of the tag, just don't render
 * We don't need this logic on the recorder side.
 * For security related meta's, customer can mask themmanually given they
 * are easy to identify in the HEAD tag.
 */
function shouldIgnoreElement(element) {
    if (element.nodeName === 'SCRIPT') {
        return true;
    }
    if (element.nodeName === 'LINK') {
        var relAttribute = getLowerCaseAttribute('rel');
        return (
        // Link as script - Ignore only when rel=preload, modulepreload or prefetch
        (/preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute('as') === 'script') ||
            // Favicons
            relAttribute === 'shortcut icon' ||
            relAttribute === 'icon');
    }
    if (element.nodeName === 'META') {
        var nameAttribute = getLowerCaseAttribute('name');
        var relAttribute = getLowerCaseAttribute('rel');
        var propertyAttribute = getLowerCaseAttribute('property');
        return (
        // Favicons
        /^msapplication-tile(image|color)$/.test(nameAttribute) ||
            nameAttribute === 'application-name' ||
            relAttribute === 'icon' ||
            relAttribute === 'apple-touch-icon' ||
            relAttribute === 'shortcut icon' ||
            // Description
            nameAttribute === 'keywords' ||
            nameAttribute === 'description' ||
            // Social
            /^(og|twitter|fb):/.test(propertyAttribute) ||
            /^(og|twitter):/.test(nameAttribute) ||
            nameAttribute === 'pinterest' ||
            // Robots
            nameAttribute === 'robots' ||
            nameAttribute === 'googlebot' ||
            nameAttribute === 'bingbot' ||
            // Http headers. Ex: X-UA-Compatible, Content-Type, Content-Language, cache-control,
            // X-Translated-By
            element.hasAttribute('http-equiv') ||
            // Authorship
            nameAttribute === 'author' ||
            nameAttribute === 'generator' ||
            nameAttribute === 'framework' ||
            nameAttribute === 'publisher' ||
            nameAttribute === 'progid' ||
            /^article:/.test(propertyAttribute) ||
            /^product:/.test(propertyAttribute) ||
            // Verification
            nameAttribute === 'google-site-verification' ||
            nameAttribute === 'yandex-verification' ||
            nameAttribute === 'csrf-token' ||
            nameAttribute === 'p:domain_verify' ||
            nameAttribute === 'verify-v1' ||
            nameAttribute === 'verification' ||
            nameAttribute === 'shopify-checkout-api-token');
    }
    function getLowerCaseAttribute(name) {
        return (element.getAttribute(name) || '').toLowerCase();
    }
    return false;
}
//# sourceMappingURL=privacy.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializationUtils.js




var serializedNodeIds = new WeakMap();
function hasSerializedNode(node) {
    return serializedNodeIds.has(node);
}
function nodeAndAncestorsHaveSerializedNode(node) {
    var current = node;
    while (current) {
        if (!hasSerializedNode(current) && !isNodeShadowRoot(current)) {
            return false;
        }
        current = getParentNode(current);
    }
    return true;
}
function getSerializedNodeId(node) {
    return serializedNodeIds.get(node);
}
function setSerializedNodeId(node, serializeNodeId) {
    serializedNodeIds.set(node, serializeNodeId);
}
/**
 * Get the element "value" to be serialized as an attribute or an input update record. It respects
 * the input privacy mode of the element.
 * PERFROMANCE OPTIMIZATION: Assumes that privacy level `HIDDEN` is never encountered because of earlier checks.
 */
function getElementInputValue(element, nodePrivacyLevel) {
    /*
     BROWSER SPEC NOTE: <input>, <select>
     For some <input> elements, the `value` is an exceptional property/attribute that has the
     value synced between el.value and el.getAttribute()
     input[type=button,checkbox,hidden,image,radio,reset,submit]
     */
    var tagName = element.tagName;
    var value = element.value;
    if (shouldMaskNode(element, nodePrivacyLevel)) {
        var type = element.type;
        if (tagName === 'INPUT' && (type === 'button' || type === 'submit' || type === 'reset')) {
            // Overrule `MASK` privacy level for button-like element values, as they are used during replay
            // to display their label. They can still be hidden via the "hidden" privacy attribute or class name.
            return value;
        }
        else if (!value || tagName === 'OPTION') {
            // <Option> value provides no benefit
            return;
        }
        return CENSORED_STRING_MARK;
    }
    if (tagName === 'OPTION' || tagName === 'SELECT') {
        return element.value;
    }
    if (tagName !== 'INPUT' && tagName !== 'TEXTAREA') {
        return;
    }
    return value;
}
var URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")([^"]*)"|([^)]*))\)/gm;
var ABSOLUTE_URL = /^[A-Za-z]+:|^\/\//;
var DATA_URI = /^data:.*,/i;
function switchToAbsoluteUrl(cssText, cssHref) {
    return cssText.replace(URL_IN_CSS_REF, function (matchingSubstring, singleQuote, urlWrappedInSingleQuotes, doubleQuote, urlWrappedInDoubleQuotes, urlNotWrappedInQuotes) {
        var url = urlWrappedInSingleQuotes || urlWrappedInDoubleQuotes || urlNotWrappedInQuotes;
        if (!cssHref || !url || ABSOLUTE_URL.test(url) || DATA_URI.test(url)) {
            return matchingSubstring;
        }
        var quote = singleQuote || doubleQuote || '';
        return "url(".concat(quote).concat(makeUrlAbsolute(url, cssHref)).concat(quote, ")");
    });
}
function makeUrlAbsolute(url, baseUrl) {
    try {
        return (0,urlPolyfill/* buildUrl */.Q2)(url, baseUrl).href;
    }
    catch (_) {
        return url;
    }
}
var TAG_NAME_REGEX = /[^a-z1-6-_]/;
function getValidTagName(tagName) {
    var processedTagName = tagName.toLowerCase().trim();
    if (TAG_NAME_REGEX.test(processedTagName)) {
        // if the tag name is odd and we cannot extract
        // anything from the string, then we return a
        // generic div
        return 'div';
    }
    return processedTagName;
}
//# sourceMappingURL=serializationUtils.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeStyleSheets.js
function serializeStyleSheets(cssStyleSheets) {
    if (cssStyleSheets === undefined || cssStyleSheets.length === 0) {
        return undefined;
    }
    return cssStyleSheets.map(function (cssStyleSheet) {
        var rules = cssStyleSheet.cssRules || cssStyleSheet.rules;
        var cssRules = Array.from(rules, function (cssRule) { return cssRule.cssText; });
        var styleSheet = {
            cssRules: cssRules,
            disabled: cssStyleSheet.disabled || undefined,
            media: cssStyleSheet.media.length > 0 ? Array.from(cssStyleSheet.media) : undefined,
        };
        return styleSheet;
    });
}
//# sourceMappingURL=serializeStyleSheets.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeAttribute.js




function serializeAttribute(element, nodePrivacyLevel, attributeName, configuration) {
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        // dup condition for direct access case
        return null;
    }
    var attributeValue = element.getAttribute(attributeName);
    if (nodePrivacyLevel === NodePrivacyLevel.MASK &&
        attributeName !== PRIVACY_ATTR_NAME &&
        !STABLE_ATTRIBUTES.includes(attributeName) &&
        attributeName !== configuration.actionNameAttribute) {
        var tagName = element.tagName;
        switch (attributeName) {
            // Mask Attribute text content
            case 'title':
            case 'alt':
            case 'placeholder':
                return CENSORED_STRING_MARK;
        }
        // mask image URLs
        if (tagName === 'IMG' || tagName === 'SOURCE') {
            if (attributeName === 'src' || attributeName === 'srcset') {
                return CENSORED_IMG_MARK;
            }
        }
        // mask <a> URLs
        if (tagName === 'A' && attributeName === 'href') {
            return CENSORED_STRING_MARK;
        }
        // mask data-* attributes
        if (attributeValue && (0,polyfills/* startsWith */.Ny)(attributeName, 'data-')) {
            // Exception: it's safe to reveal the `${PRIVACY_ATTR_NAME}` attr
            return CENSORED_STRING_MARK;
        }
    }
    if (!attributeValue || typeof attributeValue !== 'string') {
        return attributeValue;
    }
    // Minimum Fix for customer.
    if (attributeValue.length > MAX_ATTRIBUTE_VALUE_CHAR_LENGTH && attributeValue.slice(0, 5) === 'data:') {
        return 'data:truncated';
    }
    return attributeValue;
}
//# sourceMappingURL=serializeAttribute.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeAttributes.js





function serializeAttributes(element, nodePrivacyLevel, options) {
    var _a;
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        return {};
    }
    var safeAttrs = {};
    var tagName = getValidTagName(element.tagName);
    var doc = element.ownerDocument;
    for (var i = 0; i < element.attributes.length; i += 1) {
        var attribute = element.attributes.item(i);
        var attributeName = attribute.name;
        var attributeValue = serializeAttribute(element, nodePrivacyLevel, attributeName, options.configuration);
        if (attributeValue !== null) {
            safeAttrs[attributeName] = attributeValue;
        }
    }
    if (element.value &&
        (tagName === 'textarea' || tagName === 'select' || tagName === 'option' || tagName === 'input')) {
        var formValue = getElementInputValue(element, nodePrivacyLevel);
        if (formValue !== undefined) {
            safeAttrs.value = formValue;
        }
    }
    /**
     * <Option> can be selected, which occurs if its `value` matches ancestor `<Select>.value`
     */
    if (tagName === 'option' && nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
        // For privacy=`MASK`, all the values would be the same, so skip.
        var optionElement = element;
        if (optionElement.selected) {
            safeAttrs.selected = optionElement.selected;
        }
    }
    // remote css
    if (tagName === 'link') {
        var stylesheet = Array.from(doc.styleSheets).find(function (s) { return s.href === element.href; });
        var cssText = getCssRulesString(stylesheet);
        if (cssText && stylesheet && !(0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.DISABLE_REPLAY_INLINE_CSS */.uh.DISABLE_REPLAY_INLINE_CSS)) {
            safeAttrs._cssText = cssText;
        }
    }
    // dynamic stylesheet
    if (tagName === 'style' && element.sheet) {
        var cssText = getCssRulesString(element.sheet);
        if (cssText) {
            safeAttrs._cssText = cssText;
        }
    }
    /**
     * Forms: input[type=checkbox,radio]
     * The `checked` property for <input> is a little bit special:
     * 1. el.checked is a setter that returns if truthy.
     * 2. getAttribute returns the string value
     * getAttribute('checked') does not sync with `Element.checked`, so use JS property
     * NOTE: `checked` property exists on `HTMLInputElement`. For serializer assumptions, we check for type=radio|check.
     */
    var inputElement = element;
    if (tagName === 'input' && (inputElement.type === 'radio' || inputElement.type === 'checkbox')) {
        if (nodePrivacyLevel === NodePrivacyLevel.ALLOW) {
            safeAttrs.checked = !!inputElement.checked;
        }
        else if (shouldMaskNode(inputElement, nodePrivacyLevel)) {
            delete safeAttrs.checked;
        }
    }
    /**
     * Serialize the media playback state
     */
    if (tagName === 'audio' || tagName === 'video') {
        var mediaElement = element;
        safeAttrs.rr_mediaState = mediaElement.paused ? 'paused' : 'played';
    }
    /**
     * Serialize the scroll state for each element only for full snapshot
     */
    var scrollTop;
    var scrollLeft;
    var serializationContext = options.serializationContext;
    switch (serializationContext.status) {
        case 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */:
            scrollTop = Math.round(element.scrollTop);
            scrollLeft = Math.round(element.scrollLeft);
            if (scrollTop || scrollLeft) {
                serializationContext.elementsScrollPositions.set(element, { scrollTop: scrollTop, scrollLeft: scrollLeft });
            }
            break;
        case 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */:
            if (serializationContext.elementsScrollPositions.has(element)) {
                ;
                (_a = serializationContext.elementsScrollPositions.get(element), scrollTop = _a.scrollTop, scrollLeft = _a.scrollLeft);
            }
            break;
    }
    if (scrollLeft) {
        safeAttrs.rr_scrollLeft = scrollLeft;
    }
    if (scrollTop) {
        safeAttrs.rr_scrollTop = scrollTop;
    }
    return safeAttrs;
}
function getCssRulesString(cssStyleSheet) {
    if (!cssStyleSheet) {
        return null;
    }
    var rules;
    try {
        rules = cssStyleSheet.rules || cssStyleSheet.cssRules;
    }
    catch (_a) {
        // if css is protected by CORS we cannot access cssRules see: https://www.w3.org/TR/cssom-1/#the-cssstylesheet-interface
    }
    if (!rules) {
        return null;
    }
    var styleSheetCssText = Array.from(rules, (0,browserDetection/* isSafari */.G6)() ? getCssRuleStringForSafari : getCssRuleString).join('');
    return switchToAbsoluteUrl(styleSheetCssText, cssStyleSheet.href);
}
function getCssRuleStringForSafari(rule) {
    // Safari does not escape attribute selectors containing : properly
    // https://bugs.webkit.org/show_bug.cgi?id=184604
    if (isCSSStyleRule(rule) && rule.selectorText.includes(':')) {
        // This regex replaces [foo:bar] by [foo\\:bar]
        var escapeColon = /(\[[\w-]+[^\\])(:[^\]]+\])/g;
        return rule.cssText.replace(escapeColon, '$1\\$2');
    }
    return getCssRuleString(rule);
}
function getCssRuleString(rule) {
    // If it's an @import rule, try to inline sub-rules recursively with `getCssRulesString`. This
    // operation can fail if the imported stylesheet is protected by CORS, in which case we fallback
    // to the @import rule CSS text.
    return (isCSSImportRule(rule) && getCssRulesString(rule.styleSheet)) || rule.cssText;
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
//# sourceMappingURL=serializeAttributes.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeNode.js








function serializeNodeWithId(node, options) {
    var serializedNode = serializeNode(node, options);
    if (!serializedNode) {
        return null;
    }
    // Try to reuse the previous id
    var id = getSerializedNodeId(node) || generateNextId();
    var serializedNodeWithId = serializedNode;
    serializedNodeWithId.id = id;
    setSerializedNodeId(node, id);
    if (options.serializedNodeIds) {
        options.serializedNodeIds.add(id);
    }
    return serializedNodeWithId;
}
var _nextId = 1;
function generateNextId() {
    return _nextId++;
}
function serializeChildNodes(node, options) {
    var result = [];
    forEachChildNodes(node, function (childNode) {
        var serializedChildNode = serializeNodeWithId(childNode, options);
        if (serializedChildNode) {
            result.push(serializedChildNode);
        }
    });
    return result;
}
function serializeNode(node, options) {
    switch (node.nodeType) {
        case node.DOCUMENT_NODE:
            return serializeDocumentNode(node, options);
        case node.DOCUMENT_FRAGMENT_NODE:
            return serializeDocumentFragmentNode(node, options);
        case node.DOCUMENT_TYPE_NODE:
            return serializeDocumentTypeNode(node);
        case node.ELEMENT_NODE:
            return serializeElementNode(node, options);
        case node.TEXT_NODE:
            return serializeTextNode(node, options);
        case node.CDATA_SECTION_NODE:
            return serializeCDataNode();
    }
}
function serializeDocumentNode(document, options) {
    return {
        type: NodeType.Document,
        childNodes: serializeChildNodes(document, options),
        adoptedStyleSheets: serializeStyleSheets(document.adoptedStyleSheets),
    };
}
function serializeDocumentFragmentNode(element, options) {
    var isShadowRoot = isNodeShadowRoot(element);
    if (isShadowRoot) {
        options.serializationContext.shadowRootsController.addShadowRoot(element);
    }
    return {
        type: NodeType.DocumentFragment,
        childNodes: serializeChildNodes(element, options),
        isShadowRoot: isShadowRoot,
        adoptedStyleSheets: isShadowRoot ? serializeStyleSheets(element.adoptedStyleSheets) : undefined,
    };
}
function serializeDocumentTypeNode(documentType) {
    return {
        type: NodeType.DocumentType,
        name: documentType.name,
        publicId: documentType.publicId,
        systemId: documentType.systemId,
    };
}
/**
 * Serializing Element nodes involves capturing:
 * 1. HTML ATTRIBUTES:
 * 2. JS STATE:
 * - scroll offsets
 * - Form fields (input value, checkbox checked, option selection, range)
 * - Canvas state,
 * - Media (video/audio) play mode + currentTime
 * - iframe contents
 * - webcomponents
 * 3. CUSTOM PROPERTIES:
 * - height+width for when `hidden` to cover the element
 * 4. EXCLUDED INTERACTION STATE:
 * - focus (possible, but not worth perf impact)
 * - hover (tracked only via mouse activity)
 * - fullscreen mode
 */
function serializeElementNode(element, options) {
    var _a;
    var tagName = getValidTagName(element.tagName);
    var isSVG = isSVGElement(element) || undefined;
    // For performance reason, we don't use getNodePrivacyLevel directly: we leverage the
    // parentNodePrivacyLevel option to avoid iterating over all parents
    var nodePrivacyLevel = reducePrivacyLevel(getNodeSelfPrivacyLevel(element), options.parentNodePrivacyLevel);
    if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
        var _b = element.getBoundingClientRect(), width = _b.width, height = _b.height;
        return {
            type: NodeType.Element,
            tagName: tagName,
            attributes: (_a = {
                    rr_width: "".concat(width, "px"),
                    rr_height: "".concat(height, "px")
                },
                _a[PRIVACY_ATTR_NAME] = PRIVACY_ATTR_VALUE_HIDDEN,
                _a),
            childNodes: [],
            isSVG: isSVG,
        };
    }
    // Ignore Elements like Script and some Link, Metas
    if (nodePrivacyLevel === NodePrivacyLevel.IGNORE) {
        return;
    }
    var attributes = serializeAttributes(element, nodePrivacyLevel, options);
    var childNodes = [];
    if (hasChildNodes(element) &&
        // Do not serialize style children as the css rules are already in the _cssText attribute
        tagName !== 'style') {
        // OBJECT POOLING OPTIMIZATION:
        // We should not create a new object systematically as it could impact performances. Try to reuse
        // the same object as much as possible, and clone it only if we need to.
        var childNodesSerializationOptions = void 0;
        if (options.parentNodePrivacyLevel === nodePrivacyLevel && options.ignoreWhiteSpace === (tagName === 'head')) {
            childNodesSerializationOptions = options;
        }
        else {
            childNodesSerializationOptions = (0,polyfills/* assign */.f0)({}, options, {
                parentNodePrivacyLevel: nodePrivacyLevel,
                ignoreWhiteSpace: tagName === 'head',
            });
        }
        childNodes = serializeChildNodes(element, childNodesSerializationOptions);
    }
    return {
        type: NodeType.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: childNodes,
        isSVG: isSVG,
    };
}
function isSVGElement(el) {
    return el.tagName === 'svg' || el instanceof SVGElement;
}
/**
 * Text Nodes are dependant on Element nodes
 * Privacy levels are set on elements so we check the parentElement of a text node
 * for privacy level.
 */
function serializeTextNode(textNode, options) {
    var textContent = getTextContent(textNode, options.ignoreWhiteSpace || false, options.parentNodePrivacyLevel);
    if (textContent === undefined) {
        return;
    }
    return {
        type: NodeType.Text,
        textContent: textContent,
    };
}
function serializeCDataNode() {
    return {
        type: NodeType.CDATA,
        textContent: '',
    };
}
//# sourceMappingURL=serializeNode.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/serializeDocument.js

function serializeDocument(document, configuration, serializationContext) {
    // We are sure that Documents are never ignored, so this function never returns null
    return serializeNodeWithId(document, {
        serializationContext: serializationContext,
        parentNodePrivacyLevel: configuration.defaultPrivacyLevel,
        configuration: configuration,
    });
}
//# sourceMappingURL=serializeDocument.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/serialization/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/eventsUtils.js

function isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function getEventTarget(event) {
    if (event.composed === true && isNodeShadowHost(event.target)) {
        return event.composedPath()[0];
    }
    return event.target;
}
//# sourceMappingURL=eventsUtils.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/viewports.js
/**
 * Browsers have not standardized various dimension properties. Mobile devices typically report
 * dimensions in reference to the visual viewport, while desktop uses the layout viewport. For example,
 * Mobile Chrome will change innerWidth when a pinch zoom takes place, while Chrome Desktop (mac) will not.
 *
 * With the new Viewport API, we now calculate and normalize dimension properties to the layout viewport.
 * If the VisualViewport API is not supported by a browser, it isn't reasonably possible to detect or normalize
 * which viewport is being measured. Therefore these exported functions will fallback to assuming that the layout
 * viewport is being measured by the browser
 */
// Scrollbar widths vary across properties on different devices and browsers
var TOLERANCE = 25;
/**
 * Use the Visual Viewport API's properties to measure scrollX/Y in reference to the layout viewport
 * in order to determine if window.scrollX/Y is measuring the layout or visual viewport.
 * This finding corresponds to which viewport mouseEvent.clientX/Y and window.innerWidth/Height measures.
 */
function isVisualViewportFactoredIn(visualViewport) {
    return (Math.abs(visualViewport.pageTop - visualViewport.offsetTop - window.scrollY) > TOLERANCE ||
        Math.abs(visualViewport.pageLeft - visualViewport.offsetLeft - window.scrollX) > TOLERANCE);
}
var convertMouseEventToLayoutCoordinates = function (clientX, clientY) {
    var visualViewport = window.visualViewport;
    var normalized = {
        layoutViewportX: clientX,
        layoutViewportY: clientY,
        visualViewportX: clientX,
        visualViewportY: clientY,
    };
    if (!visualViewport) {
        // On old browsers, we cannot normalize, so fallback to clientX/Y
        return normalized;
    }
    else if (isVisualViewportFactoredIn(visualViewport)) {
        // Typically Mobile Devices
        normalized.layoutViewportX = Math.round(clientX + visualViewport.offsetLeft);
        normalized.layoutViewportY = Math.round(clientY + visualViewport.offsetTop);
    }
    else {
        // Typically Desktop Devices
        normalized.visualViewportX = Math.round(clientX - visualViewport.offsetLeft);
        normalized.visualViewportY = Math.round(clientY - visualViewport.offsetTop);
    }
    return normalized;
};
var getVisualViewport = function (visualViewport) { return ({
    scale: visualViewport.scale,
    offsetLeft: visualViewport.offsetLeft,
    offsetTop: visualViewport.offsetTop,
    pageLeft: visualViewport.pageLeft,
    pageTop: visualViewport.pageTop,
    height: visualViewport.height,
    width: visualViewport.width,
}); };
//# sourceMappingURL=viewports.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/moveObserver.js





var MOUSE_MOVE_OBSERVER_THRESHOLD = 50;
function initMoveObserver(configuration, cb) {
    var updatePosition = (0,functionUtils/* throttle */.P)(function (event) {
        var target = getEventTarget(event);
        if (hasSerializedNode(target)) {
            var coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            var position = {
                id: getSerializedNodeId(target),
                timeOffset: 0,
                x: coordinates.x,
                y: coordinates.y,
            };
            cb([position], isTouchEvent(event) ? IncrementalSource.TouchMove : IncrementalSource.MouseMove);
        }
    }, MOUSE_MOVE_OBSERVER_THRESHOLD, {
        trailing: false,
    }).throttled;
    return (0,addEventListener/* addEventListeners */.y)(configuration, document, ["mousemove" /* DOM_EVENT.MOUSE_MOVE */, "touchmove" /* DOM_EVENT.TOUCH_MOVE */], updatePosition, {
        capture: true,
        passive: true,
    }).stop;
}
function tryToComputeCoordinates(event) {
    var _a = isTouchEvent(event) ? event.changedTouches[0] : event, x = _a.clientX, y = _a.clientY;
    if (window.visualViewport) {
        var _b = convertMouseEventToLayoutCoordinates(x, y), visualViewportX = _b.visualViewportX, visualViewportY = _b.visualViewportY;
        x = visualViewportX;
        y = visualViewportY;
    }
    if (!Number.isFinite(x) || !Number.isFinite(y)) {
        if (event.isTrusted) {
            (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('mouse/touch event without x/y');
        }
        return undefined;
    }
    return { x: x, y: y };
}
//# sourceMappingURL=moveObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/scrollObserver.js






var SCROLL_OBSERVER_THRESHOLD = 100;
function initScrollObserver(configuration, cb, defaultPrivacyLevel, elementsScrollPositions) {
    var updatePosition = (0,functionUtils/* throttle */.P)(function (event) {
        var target = getEventTarget(event);
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        var scrollPositions = target === document
            ? {
                scrollTop: getScrollY(),
                scrollLeft: getScrollX(),
            }
            : {
                scrollTop: Math.round(target.scrollTop),
                scrollLeft: Math.round(target.scrollLeft),
            };
        elementsScrollPositions.set(target, scrollPositions);
        cb({
            id: id,
            x: scrollPositions.scrollLeft,
            y: scrollPositions.scrollTop,
        });
    }, SCROLL_OBSERVER_THRESHOLD).throttled;
    return (0,addEventListener/* addEventListener */.O)(configuration, document, "scroll" /* DOM_EVENT.SCROLL */, updatePosition, { capture: true, passive: true })
        .stop;
}
//# sourceMappingURL=scrollObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/mouseInteractionObserver.js
var _a;








var eventTypeToMouseInteraction = (_a = {},
    // Listen for pointerup DOM events instead of mouseup for MouseInteraction/MouseUp records. This
    // allows to reference such records from Frustration records.
    //
    // In the context of supporting Mobile Session Replay, we introduced `PointerInteraction` records
    // used by the Mobile SDKs in place of `MouseInteraction`. In the future, we should replace
    // `MouseInteraction` by `PointerInteraction` in the Browser SDK so we have an uniform way to
    // convey such interaction. This would cleanly solve the issue since we would have
    // `PointerInteraction/Up` records that we could reference from `Frustration` records.
    _a["pointerup" /* DOM_EVENT.POINTER_UP */] = MouseInteractionType.MouseUp,
    _a["mousedown" /* DOM_EVENT.MOUSE_DOWN */] = MouseInteractionType.MouseDown,
    _a["click" /* DOM_EVENT.CLICK */] = MouseInteractionType.Click,
    _a["contextmenu" /* DOM_EVENT.CONTEXT_MENU */] = MouseInteractionType.ContextMenu,
    _a["dblclick" /* DOM_EVENT.DBL_CLICK */] = MouseInteractionType.DblClick,
    _a["focus" /* DOM_EVENT.FOCUS */] = MouseInteractionType.Focus,
    _a["blur" /* DOM_EVENT.BLUR */] = MouseInteractionType.Blur,
    _a["touchstart" /* DOM_EVENT.TOUCH_START */] = MouseInteractionType.TouchStart,
    _a["touchend" /* DOM_EVENT.TOUCH_END */] = MouseInteractionType.TouchEnd,
    _a);
function initMouseInteractionObserver(configuration, cb, recordIds) {
    var handler = function (event) {
        var target = getEventTarget(event);
        if (getNodePrivacyLevel(target, configuration.defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        var id = getSerializedNodeId(target);
        var type = eventTypeToMouseInteraction[event.type];
        var interaction;
        if (type !== MouseInteractionType.Blur && type !== MouseInteractionType.Focus) {
            var coordinates = tryToComputeCoordinates(event);
            if (!coordinates) {
                return;
            }
            interaction = { id: id, type: type, x: coordinates.x, y: coordinates.y };
        }
        else {
            interaction = { id: id, type: type };
        }
        var record = (0,polyfills/* assign */.f0)({ id: recordIds.getIdForEvent(event) }, assembleIncrementalSnapshot(IncrementalSource.MouseInteraction, interaction));
        cb(record);
    };
    return (0,addEventListener/* addEventListeners */.y)(configuration, document, Object.keys(eventTypeToMouseInteraction), handler, {
        capture: true,
        passive: true,
    }).stop;
}
//# sourceMappingURL=mouseInteractionObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/inputObserver.js





function initInputObserver(configuration, cb, target) {
    if (target === void 0) { target = document; }
    var defaultPrivacyLevel = configuration.defaultPrivacyLevel;
    var lastInputStateMap = new WeakMap();
    var isShadowRoot = target !== document;
    var stopEventListeners = (0,addEventListener/* addEventListeners */.y)(configuration, target, 
    // The 'input' event bubbles across shadow roots, so we don't have to listen for it on shadow
    // roots since it will be handled by the event listener that we did add to the document. Only
    // the 'change' event is blocked and needs to be handled on shadow roots.
    isShadowRoot ? ["change" /* DOM_EVENT.CHANGE */] : ["input" /* DOM_EVENT.INPUT */, "change" /* DOM_EVENT.CHANGE */], function (event) {
        var target = getEventTarget(event);
        if (target instanceof HTMLInputElement ||
            target instanceof HTMLTextAreaElement ||
            target instanceof HTMLSelectElement) {
            onElementChange(target);
        }
    }, {
        capture: true,
        passive: true,
    }).stop;
    var stopPropertySetterInstrumentation;
    if (!isShadowRoot) {
        var instrumentationStoppers_1 = [
            (0,instrumentMethod/* instrumentSetter */.Xk)(HTMLInputElement.prototype, 'value', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.Xk)(HTMLInputElement.prototype, 'checked', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.Xk)(HTMLSelectElement.prototype, 'value', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.Xk)(HTMLTextAreaElement.prototype, 'value', onElementChange),
            (0,instrumentMethod/* instrumentSetter */.Xk)(HTMLSelectElement.prototype, 'selectedIndex', onElementChange),
        ];
        stopPropertySetterInstrumentation = function () {
            instrumentationStoppers_1.forEach(function (stopper) { return stopper.stop(); });
        };
    }
    else {
        stopPropertySetterInstrumentation = functionUtils/* noop */.Z;
    }
    return function () {
        stopPropertySetterInstrumentation();
        stopEventListeners();
    };
    function onElementChange(target) {
        var nodePrivacyLevel = getNodePrivacyLevel(target, defaultPrivacyLevel);
        if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) {
            return;
        }
        var type = target.type;
        var inputState;
        if (type === 'radio' || type === 'checkbox') {
            if (shouldMaskNode(target, nodePrivacyLevel)) {
                return;
            }
            inputState = { isChecked: target.checked };
        }
        else {
            var value = getElementInputValue(target, nodePrivacyLevel);
            if (value === undefined) {
                return;
            }
            inputState = { text: value };
        }
        // Can be multiple changes on the same node within the same batched mutation observation.
        cbWithDedup(target, inputState);
        // If a radio was checked, other radios with the same name attribute will be unchecked.
        var name = target.name;
        if (type === 'radio' && name && target.checked) {
            (0,polyfills/* forEach */.Ed)(document.querySelectorAll("input[type=\"radio\"][name=\"".concat((0,polyfills/* cssEscape */.QA)(name), "\"]")), function (el) {
                if (el !== target) {
                    // TODO: Consider the privacy implications for various differing input privacy levels
                    cbWithDedup(el, { isChecked: false });
                }
            });
        }
    }
    /**
     * There can be multiple changes on the same node within the same batched mutation observation.
     */
    function cbWithDedup(target, inputState) {
        if (!hasSerializedNode(target)) {
            return;
        }
        var lastInputState = lastInputStateMap.get(target);
        if (!lastInputState ||
            lastInputState.text !== inputState.text ||
            lastInputState.isChecked !== inputState.isChecked) {
            lastInputStateMap.set(target, inputState);
            cb((0,polyfills/* assign */.f0)({
                id: getSerializedNodeId(target),
            }, inputState));
        }
    }
}
//# sourceMappingURL=inputObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/styleSheetObserver.js


function initStyleSheetObserver(cb) {
    function checkStyleSheetAndCallback(styleSheet, callback) {
        if (styleSheet && hasSerializedNode(styleSheet.ownerNode)) {
            callback(getSerializedNodeId(styleSheet.ownerNode));
        }
    }
    var instrumentationStoppers = [
        (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(CSSStyleSheet.prototype, 'insertRule', {
            before: function (rule, index) {
                checkStyleSheetAndCallback(this, function (id) { return cb({ id: id, adds: [{ rule: rule, index: index }] }); });
            },
        }),
        (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(CSSStyleSheet.prototype, 'deleteRule', {
            before: function (index) {
                checkStyleSheetAndCallback(this, function (id) { return cb({ id: id, removes: [{ index: index }] }); });
            },
        }),
    ];
    if (typeof CSSGroupingRule !== 'undefined') {
        instrumentGroupingCSSRuleClass(CSSGroupingRule);
    }
    else {
        instrumentGroupingCSSRuleClass(CSSMediaRule);
        instrumentGroupingCSSRuleClass(CSSSupportsRule);
    }
    function instrumentGroupingCSSRuleClass(cls) {
        instrumentationStoppers.push((0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(cls.prototype, 'insertRule', {
            before: function (rule, index) {
                var _this = this;
                checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
                    var path = getPathToNestedCSSRule(_this);
                    if (path) {
                        path.push(index || 0);
                        cb({ id: id, adds: [{ rule: rule, index: path }] });
                    }
                });
            },
        }), (0,instrumentMethod/* instrumentMethodAndCallOriginal */.Lm)(cls.prototype, 'deleteRule', {
            before: function (index) {
                var _this = this;
                checkStyleSheetAndCallback(this.parentStyleSheet, function (id) {
                    var path = getPathToNestedCSSRule(_this);
                    if (path) {
                        path.push(index);
                        cb({ id: id, removes: [{ index: path }] });
                    }
                });
            },
        }));
    }
    return function () { return instrumentationStoppers.forEach(function (stopper) { return stopper.stop(); }); };
}
function getPathToNestedCSSRule(rule) {
    var path = [];
    var currentRule = rule;
    while (currentRule.parentRule) {
        var rules_1 = Array.from(currentRule.parentRule.cssRules);
        var index_1 = rules_1.indexOf(currentRule);
        path.unshift(index_1);
        currentRule = currentRule.parentRule;
    }
    // A rule may not be attached to a stylesheet
    if (!currentRule.parentStyleSheet) {
        return;
    }
    var rules = Array.from(currentRule.parentStyleSheet.cssRules);
    var index = rules.indexOf(currentRule);
    path.unshift(index);
    return path;
}
//# sourceMappingURL=styleSheetObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/mediaInteractionObserver.js






function initMediaInteractionObserver(configuration, mediaInteractionCb, defaultPrivacyLevel) {
    return (0,addEventListener/* addEventListeners */.y)(configuration, document, ["play" /* DOM_EVENT.PLAY */, "pause" /* DOM_EVENT.PAUSE */], function (event) {
        var target = getEventTarget(event);
        if (!target ||
            getNodePrivacyLevel(target, defaultPrivacyLevel) === NodePrivacyLevel.HIDDEN ||
            !hasSerializedNode(target)) {
            return;
        }
        mediaInteractionCb({
            id: getSerializedNodeId(target),
            type: event.type === "play" /* DOM_EVENT.PLAY */ ? MediaInteractionType.Play : MediaInteractionType.Pause,
        });
    }, {
        capture: true,
        passive: true,
    }).stop;
}
//# sourceMappingURL=mediaInteractionObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/frustrationObserver.js

function initFrustrationObserver(lifeCycle, frustrationCb, recordIds) {
    return lifeCycle.subscribe(10 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (data) {
        var _a, _b, _c;
        if (data.rawRumEvent.type === "action" /* RumEventType.ACTION */ &&
            data.rawRumEvent.action.type === "click" /* ActionType.CLICK */ &&
            ((_b = (_a = data.rawRumEvent.action.frustration) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.length) &&
            'events' in data.domainContext &&
            ((_c = data.domainContext.events) === null || _c === void 0 ? void 0 : _c.length)) {
            frustrationCb({
                timestamp: data.rawRumEvent.date,
                type: RecordType.FrustrationRecord,
                data: {
                    frustrationTypes: data.rawRumEvent.action.frustration.type,
                    recordIds: data.domainContext.events.map(function (e) { return recordIds.getIdForEvent(e); }),
                },
            });
        }
    }).unsubscribe;
}
//# sourceMappingURL=frustrationObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/viewportResizeObserver.js



var VISUAL_VIEWPORT_OBSERVER_THRESHOLD = 200;
function initViewportResizeObserver(configuration, cb) {
    return initViewportObservable(configuration).subscribe(cb).unsubscribe;
}
function initVisualViewportResizeObserver(configuration, cb) {
    var visualViewport = window.visualViewport;
    if (!visualViewport) {
        return functionUtils/* noop */.Z;
    }
    var _a = (0,functionUtils/* throttle */.P)(function () {
        cb(getVisualViewport(visualViewport));
    }, VISUAL_VIEWPORT_OBSERVER_THRESHOLD, {
        trailing: false,
    }), updateDimension = _a.throttled, cancelThrottle = _a.cancel;
    var removeListener = (0,addEventListener/* addEventListeners */.y)(configuration, visualViewport, ["resize" /* DOM_EVENT.RESIZE */, "scroll" /* DOM_EVENT.SCROLL */], updateDimension, {
        capture: true,
        passive: true,
    }).stop;
    return function stop() {
        removeListener();
        cancelThrottle();
    };
}
//# sourceMappingURL=viewportResizeObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/mutationBatch.js

/**
 * Maximum duration to wait before processing mutations. If the browser is idle, mutations will be
 * processed more quickly. If the browser is busy executing small tasks (ex: rendering frames), the
 * mutations will wait MUTATION_PROCESS_MAX_DELAY milliseconds before being processed. If the
 * browser is busy executing a longer task, mutations will be processed after this task.
 */
var MUTATION_PROCESS_MAX_DELAY = 100;
function createMutationBatch(processMutationBatch) {
    var cancelScheduledFlush = functionUtils/* noop */.Z;
    var pendingMutations = [];
    function flush() {
        cancelScheduledFlush();
        processMutationBatch(pendingMutations);
        pendingMutations = [];
    }
    return {
        addMutations: function (mutations) {
            if (pendingMutations.length === 0) {
                cancelScheduledFlush = requestIdleCallback(flush, { timeout: MUTATION_PROCESS_MAX_DELAY });
            }
            pendingMutations.push.apply(pendingMutations, mutations);
        },
        flush: flush,
        stop: function () {
            cancelScheduledFlush();
        },
    };
}
/**
 * Use 'requestIdleCallback' when available: it will throttle the mutation processing if the
 * browser is busy rendering frames (ex: when frames are below 60fps). When not available, the
 * fallback on 'requestAnimationFrame' will still ensure the mutations are processed after any
 * browser rendering process (Layout, Recalculate Style, etc.), so we can serialize DOM nodes efficiently.
 *
 * Note: check both 'requestIdleCallback' and 'cancelIdleCallback' existence because some polyfills only implement 'requestIdleCallback'.
 */
function requestIdleCallback(callback, opts) {
    if (window.requestIdleCallback && window.cancelIdleCallback) {
        var id_1 = window.requestIdleCallback((0,monitor/* monitor */.zk)(callback), opts);
        return function () { return window.cancelIdleCallback(id_1); };
    }
    var id = window.requestAnimationFrame((0,monitor/* monitor */.zk)(callback));
    return function () { return window.cancelAnimationFrame(id); };
}
//# sourceMappingURL=mutationBatch.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/mutationObserver.js






/**
 * Buffers and aggregate mutations generated by a MutationObserver into MutationPayload
 */
function initMutationObserver(mutationCallback, configuration, shadowRootsController, target) {
    var MutationObserver = getMutationObserverConstructor();
    if (!MutationObserver) {
        return { stop: functionUtils/* noop */.Z, flush: functionUtils/* noop */.Z };
    }
    var mutationBatch = createMutationBatch(function (mutations) {
        processMutations(mutations.concat(observer.takeRecords()), mutationCallback, configuration, shadowRootsController);
    });
    var observer = new MutationObserver((0,monitor/* monitor */.zk)(mutationBatch.addMutations));
    observer.observe(target, {
        attributeOldValue: true,
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true,
    });
    return {
        stop: function () {
            observer.disconnect();
            mutationBatch.stop();
        },
        flush: function () {
            mutationBatch.flush();
        },
    };
}
function processMutations(mutations, mutationCallback, configuration, shadowRootsController) {
    mutations
        .filter(function (mutation) { return mutation.type === 'childList'; })
        .forEach(function (mutation) {
        mutation.removedNodes.forEach(function (removedNode) {
            traverseRemovedShadowDom(removedNode, shadowRootsController.removeShadowRoot);
        });
    });
    // Discard any mutation with a 'target' node that:
    // * isn't injected in the current document or isn't known/serialized yet: those nodes are likely
    // part of a mutation occurring in a parent Node
    // * should be hidden or ignored
    var filteredMutations = mutations.filter(function (mutation) {
        return mutation.target.isConnected &&
            nodeAndAncestorsHaveSerializedNode(mutation.target) &&
            getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel) !== NodePrivacyLevel.HIDDEN;
    });
    var _a = processChildListMutations(filteredMutations.filter(function (mutation) { return mutation.type === 'childList'; }), configuration, shadowRootsController), adds = _a.adds, removes = _a.removes, hasBeenSerialized = _a.hasBeenSerialized;
    var texts = processCharacterDataMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'characterData' && !hasBeenSerialized(mutation.target);
    }), configuration);
    var attributes = processAttributesMutations(filteredMutations.filter(function (mutation) {
        return mutation.type === 'attributes' && !hasBeenSerialized(mutation.target);
    }), configuration);
    if (!texts.length && !attributes.length && !removes.length && !adds.length) {
        return;
    }
    mutationCallback({
        adds: adds,
        removes: removes,
        texts: texts,
        attributes: attributes,
    });
}
function processChildListMutations(mutations, configuration, shadowRootsController) {
    // First, we iterate over mutations to collect:
    //
    // * nodes that have been added in the document and not removed by a subsequent mutation
    // * nodes that have been removed from the document but were not added in a previous mutation
    //
    // For this second category, we also collect their previous parent (mutation.target) because we'll
    // need it to emit a 'remove' mutation.
    //
    // Those two categories may overlap: if a node moved from a position to another, it is reported as
    // two mutation records, one with a "removedNodes" and the other with "addedNodes". In this case,
    // the node will be in both sets.
    var addedAndMovedNodes = new Set();
    var removedNodes = new Map();
    var _loop_1 = function (mutation) {
        mutation.addedNodes.forEach(function (node) {
            addedAndMovedNodes.add(node);
        });
        mutation.removedNodes.forEach(function (node) {
            if (!addedAndMovedNodes.has(node)) {
                removedNodes.set(node, mutation.target);
            }
            addedAndMovedNodes.delete(node);
        });
    };
    for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
        var mutation = mutations_1[_i];
        _loop_1(mutation);
    }
    // Then, we sort nodes that are still in the document by topological order, for two reasons:
    //
    // * We will serialize each added nodes with their descendants. We don't want to serialize a node
    // twice, so we need to iterate over the parent nodes first and skip any node that is contained in
    // a precedent node.
    //
    // * To emit "add" mutations, we need references to the parent and potential next sibling of each
    // added node. So we need to iterate over the parent nodes first, and when multiple nodes are
    // siblings, we want to iterate from last to first. This will ensure that any "next" node is
    // already serialized and have an id.
    var sortedAddedAndMovedNodes = Array.from(addedAndMovedNodes);
    sortAddedAndMovedNodes(sortedAddedAndMovedNodes);
    // Then, we iterate over our sorted node sets to emit mutations. We collect the newly serialized
    // node ids in a set to be able to skip subsequent related mutations.
    var serializedNodeIds = new Set();
    var addedNodeMutations = [];
    for (var _a = 0, sortedAddedAndMovedNodes_1 = sortedAddedAndMovedNodes; _a < sortedAddedAndMovedNodes_1.length; _a++) {
        var node = sortedAddedAndMovedNodes_1[_a];
        if (hasBeenSerialized(node)) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(node.parentNode, configuration.defaultPrivacyLevel);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        var serializedNode = serializeNodeWithId(node, {
            serializedNodeIds: serializedNodeIds,
            parentNodePrivacyLevel: parentNodePrivacyLevel,
            serializationContext: { status: 2 /* SerializationContextStatus.MUTATION */, shadowRootsController: shadowRootsController },
            configuration: configuration,
        });
        if (!serializedNode) {
            continue;
        }
        var parentNode = getParentNode(node);
        addedNodeMutations.push({
            nextId: getNextSibling(node),
            parentId: getSerializedNodeId(parentNode),
            node: serializedNode,
        });
    }
    // Finally, we emit remove mutations.
    var removedNodeMutations = [];
    removedNodes.forEach(function (parent, node) {
        if (hasSerializedNode(node)) {
            removedNodeMutations.push({
                parentId: getSerializedNodeId(parent),
                id: getSerializedNodeId(node),
            });
        }
    });
    return { adds: addedNodeMutations, removes: removedNodeMutations, hasBeenSerialized: hasBeenSerialized };
    function hasBeenSerialized(node) {
        return hasSerializedNode(node) && serializedNodeIds.has(getSerializedNodeId(node));
    }
    function getNextSibling(node) {
        var nextSibling = node.nextSibling;
        while (nextSibling) {
            if (hasSerializedNode(nextSibling)) {
                return getSerializedNodeId(nextSibling);
            }
            nextSibling = nextSibling.nextSibling;
        }
        return null;
    }
}
function processCharacterDataMutations(mutations, configuration) {
    var _a;
    var textMutations = [];
    // Deduplicate mutations based on their target node
    var handledNodes = new Set();
    var filteredMutations = mutations.filter(function (mutation) {
        if (handledNodes.has(mutation.target)) {
            return false;
        }
        handledNodes.add(mutation.target);
        return true;
    });
    // Emit mutations
    for (var _i = 0, filteredMutations_1 = filteredMutations; _i < filteredMutations_1.length; _i++) {
        var mutation = filteredMutations_1[_i];
        var value = mutation.target.textContent;
        if (value === mutation.oldValue) {
            continue;
        }
        var parentNodePrivacyLevel = getNodePrivacyLevel(getParentNode(mutation.target), configuration.defaultPrivacyLevel);
        if (parentNodePrivacyLevel === NodePrivacyLevel.HIDDEN || parentNodePrivacyLevel === NodePrivacyLevel.IGNORE) {
            continue;
        }
        textMutations.push({
            id: getSerializedNodeId(mutation.target),
            // TODO: pass a valid "ignoreWhiteSpace" argument
            value: (_a = getTextContent(mutation.target, false, parentNodePrivacyLevel)) !== null && _a !== void 0 ? _a : null,
        });
    }
    return textMutations;
}
function processAttributesMutations(mutations, configuration) {
    var attributeMutations = [];
    // Deduplicate mutations based on their target node and changed attribute
    var handledElements = new Map();
    var filteredMutations = mutations.filter(function (mutation) {
        var handledAttributes = handledElements.get(mutation.target);
        if (handledAttributes === null || handledAttributes === void 0 ? void 0 : handledAttributes.has(mutation.attributeName)) {
            return false;
        }
        if (!handledAttributes) {
            handledElements.set(mutation.target, new Set([mutation.attributeName]));
        }
        else {
            handledAttributes.add(mutation.attributeName);
        }
        return true;
    });
    // Emit mutations
    var emittedMutations = new Map();
    for (var _i = 0, filteredMutations_2 = filteredMutations; _i < filteredMutations_2.length; _i++) {
        var mutation = filteredMutations_2[_i];
        var uncensoredValue = mutation.target.getAttribute(mutation.attributeName);
        if (uncensoredValue === mutation.oldValue) {
            continue;
        }
        var privacyLevel = getNodePrivacyLevel(mutation.target, configuration.defaultPrivacyLevel);
        var attributeValue = serializeAttribute(mutation.target, privacyLevel, mutation.attributeName, configuration);
        var transformedValue = void 0;
        if (mutation.attributeName === 'value') {
            var inputValue = getElementInputValue(mutation.target, privacyLevel);
            if (inputValue === undefined) {
                continue;
            }
            transformedValue = inputValue;
        }
        else if (typeof attributeValue === 'string') {
            transformedValue = attributeValue;
        }
        else {
            transformedValue = null;
        }
        var emittedMutation = emittedMutations.get(mutation.target);
        if (!emittedMutation) {
            emittedMutation = {
                id: getSerializedNodeId(mutation.target),
                attributes: {},
            };
            attributeMutations.push(emittedMutation);
            emittedMutations.set(mutation.target, emittedMutation);
        }
        emittedMutation.attributes[mutation.attributeName] = transformedValue;
    }
    return attributeMutations;
}
function sortAddedAndMovedNodes(nodes) {
    nodes.sort(function (a, b) {
        var position = a.compareDocumentPosition(b);
        /* eslint-disable no-bitwise */
        if (position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return -1;
        }
        else if (position & Node.DOCUMENT_POSITION_CONTAINS) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
            return 1;
        }
        else if (position & Node.DOCUMENT_POSITION_PRECEDING) {
            return -1;
        }
        /* eslint-enable no-bitwise */
        return 0;
    });
}
function traverseRemovedShadowDom(removedNode, shadowDomRemovedCallback) {
    if (isNodeShadowHost(removedNode)) {
        shadowDomRemovedCallback(removedNode.shadowRoot);
    }
    forEachChildNodes(removedNode, function (childNode) { return traverseRemovedShadowDom(childNode, shadowDomRemovedCallback); });
}
//# sourceMappingURL=mutationObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/focusObserver.js

function initFocusObserver(configuration, focusCb) {
    return (0,addEventListener/* addEventListeners */.y)(configuration, window, ["focus" /* DOM_EVENT.FOCUS */, "blur" /* DOM_EVENT.BLUR */], function () {
        focusCb({ has_focus: document.hasFocus() });
    }).stop;
}
//# sourceMappingURL=focusObserver.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/recordIds.js
function initRecordIds() {
    var recordIds = new WeakMap();
    var nextId = 1;
    return {
        getIdForEvent: function (event) {
            if (!recordIds.has(event)) {
                recordIds.set(event, nextId++);
            }
            return recordIds.get(event);
        },
    };
}
//# sourceMappingURL=recordIds.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/observers.js











function initObservers(configuration, o) {
    var recordIds = initRecordIds();
    var mutationHandler = initMutationObserver(o.mutationCb, o.configuration, o.shadowRootsController, document);
    var mousemoveHandler = initMoveObserver(configuration, o.mousemoveCb);
    var mouseInteractionHandler = initMouseInteractionObserver(configuration, o.mouseInteractionCb, recordIds);
    var scrollHandler = initScrollObserver(configuration, o.scrollCb, o.configuration.defaultPrivacyLevel, o.elementsScrollPositions);
    var viewportResizeHandler = initViewportResizeObserver(configuration, o.viewportResizeCb);
    var inputHandler = initInputObserver(configuration, o.inputCb);
    var mediaInteractionHandler = initMediaInteractionObserver(configuration, o.mediaInteractionCb, o.configuration.defaultPrivacyLevel);
    var styleSheetObserver = initStyleSheetObserver(o.styleSheetCb);
    var focusHandler = initFocusObserver(configuration, o.focusCb);
    var visualViewportResizeHandler = initVisualViewportResizeObserver(configuration, o.visualViewportResizeCb);
    var frustrationHandler = initFrustrationObserver(o.lifeCycle, o.frustrationCb, recordIds);
    return {
        flush: function () {
            mutationHandler.flush();
        },
        stop: function () {
            mutationHandler.stop();
            mousemoveHandler();
            mouseInteractionHandler();
            scrollHandler();
            viewportResizeHandler();
            inputHandler();
            mediaInteractionHandler();
            styleSheetObserver();
            focusHandler();
            visualViewportResizeHandler();
            frustrationHandler();
        },
    };
}
//# sourceMappingURL=observers.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/observers/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/elementsScrollPositions.js
function createElementsScrollPositions() {
    var scrollPositionsByElement = new WeakMap();
    return {
        set: function (element, scrollPositions) {
            if (element === document && !document.scrollingElement) {
                // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
                // in some cases scrolling elements can not be defined, we don't support those for now
                return;
            }
            scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
        },
        get: function (element) {
            return scrollPositionsByElement.get(element);
        },
        has: function (element) {
            return scrollPositionsByElement.has(element);
        },
    };
}
//# sourceMappingURL=elementsScrollPositions.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/shadowRootsController.js

var initShadowRootsController = function (configuration, _a) {
    var mutationCb = _a.mutationCb, inputCb = _a.inputCb;
    var controllerByShadowRoot = new Map();
    var shadowRootsController = {
        addShadowRoot: function (shadowRoot) {
            var _a = initMutationObserver(mutationCb, configuration, shadowRootsController, shadowRoot), stopMutationObserver = _a.stop, flush = _a.flush;
            // the change event no do bubble up across the shadow root, we have to listen on the shadow root
            var stopInputObserver = initInputObserver(configuration, inputCb, shadowRoot);
            controllerByShadowRoot.set(shadowRoot, {
                flush: flush,
                stop: function () {
                    stopMutationObserver();
                    stopInputObserver();
                },
            });
        },
        removeShadowRoot: function (shadowRoot) {
            var entry = controllerByShadowRoot.get(shadowRoot);
            if (!entry) {
                // unidentified root cause: observed in some cases with shadow DOM added by browser extensions
                return;
            }
            entry.stop();
            controllerByShadowRoot.delete(shadowRoot);
        },
        stop: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var stop = _a.stop;
                return stop();
            });
        },
        flush: function () {
            controllerByShadowRoot.forEach(function (_a) {
                var flush = _a.flush;
                return flush();
            });
        },
    };
    return shadowRootsController;
};
//# sourceMappingURL=shadowRootsController.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/record.js









function record(options) {
    var emit = options.emit, configuration = options.configuration;
    // runtime checks for user options
    if (!emit) {
        throw new Error('emit function is required');
    }
    var elementsScrollPositions = createElementsScrollPositions();
    var mutationCb = function (mutation) {
        emit(assembleIncrementalSnapshot(IncrementalSource.Mutation, mutation));
    };
    var inputCb = function (s) { return emit(assembleIncrementalSnapshot(IncrementalSource.Input, s)); };
    var shadowRootsController = initShadowRootsController(configuration, { mutationCb: mutationCb, inputCb: inputCb });
    var takeFullSnapshot = function (timestamp, serializationContext) {
        if (timestamp === void 0) { timestamp = (0,timeUtils/* timeStampNow */.n$)(); }
        if (serializationContext === void 0) { serializationContext = {
            status: 0 /* SerializationContextStatus.INITIAL_FULL_SNAPSHOT */,
            elementsScrollPositions: elementsScrollPositions,
            shadowRootsController: shadowRootsController,
        }; }
        var _a = getViewportDimension(), width = _a.width, height = _a.height;
        emit({
            data: {
                height: height,
                href: window.location.href,
                width: width,
            },
            type: RecordType.Meta,
            timestamp: timestamp,
        });
        emit({
            data: {
                has_focus: document.hasFocus(),
            },
            type: RecordType.Focus,
            timestamp: timestamp,
        });
        emit({
            data: {
                node: serializeDocument(document, configuration, serializationContext),
                initialOffset: {
                    left: getScrollX(),
                    top: getScrollY(),
                },
            },
            type: RecordType.FullSnapshot,
            timestamp: timestamp,
        });
        if (window.visualViewport) {
            emit({
                data: getVisualViewport(window.visualViewport),
                type: RecordType.VisualViewport,
                timestamp: timestamp,
            });
        }
    };
    takeFullSnapshot();
    var _a = initObservers(configuration, {
        lifeCycle: options.lifeCycle,
        configuration: configuration,
        elementsScrollPositions: elementsScrollPositions,
        inputCb: inputCb,
        mediaInteractionCb: function (p) {
            return emit(assembleIncrementalSnapshot(IncrementalSource.MediaInteraction, p));
        },
        mouseInteractionCb: function (mouseInteractionRecord) { return emit(mouseInteractionRecord); },
        mousemoveCb: function (positions, source) { return emit(assembleIncrementalSnapshot(source, { positions: positions })); },
        mutationCb: mutationCb,
        scrollCb: function (p) { return emit(assembleIncrementalSnapshot(IncrementalSource.Scroll, p)); },
        styleSheetCb: function (r) { return emit(assembleIncrementalSnapshot(IncrementalSource.StyleSheetRule, r)); },
        viewportResizeCb: function (d) { return emit(assembleIncrementalSnapshot(IncrementalSource.ViewportResize, d)); },
        frustrationCb: function (frustrationRecord) { return emit(frustrationRecord); },
        focusCb: function (data) {
            return emit({
                data: data,
                type: RecordType.Focus,
                timestamp: (0,timeUtils/* timeStampNow */.n$)(),
            });
        },
        visualViewportResizeCb: function (data) {
            emit({
                data: data,
                type: RecordType.VisualViewport,
                timestamp: (0,timeUtils/* timeStampNow */.n$)(),
            });
        },
        shadowRootsController: shadowRootsController,
    }), stopObservers = _a.stop, flushMutationsFromObservers = _a.flush;
    function flushMutations() {
        shadowRootsController.flush();
        flushMutationsFromObservers();
    }
    return {
        stop: function () {
            shadowRootsController.stop();
            stopObservers();
        },
        takeSubsequentFullSnapshot: function (timestamp) {
            flushMutations();
            takeFullSnapshot(timestamp, {
                shadowRootsController: shadowRootsController,
                status: 1 /* SerializationContextStatus.SUBSEQUENT_FULL_SNAPSHOT */,
                elementsScrollPositions: elementsScrollPositions,
            });
        },
        flushMutations: flushMutations,
        shadowRootsController: shadowRootsController,
    };
}
//# sourceMappingURL=record.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/record/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/buildReplayPayload.js

function buildReplayPayload(data, metadata, rawSegmentBytesCount) {
    var formData = new FormData();
    formData.append('segment', new Blob([data], {
        type: 'application/octet-stream',
    }), "".concat(metadata.session.id, "-").concat(metadata.start));
    var metadataAndSegmentSizes = (0,polyfills/* assign */.f0)({
        raw_segment_size: rawSegmentBytesCount,
        compressed_segment_size: data.byteLength,
    }, metadata);
    var serializedMetadataAndSegmentSizes = JSON.stringify(metadataAndSegmentSizes);
    formData.append('event', new Blob([serializedMetadataAndSegmentSizes], { type: 'application/json' }));
    return { data: formData, bytesCount: data.byteLength };
}
//# sourceMappingURL=buildReplayPayload.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/replayStats.js
var MAX_STATS_HISTORY = 10;
var statsPerView;
function getSegmentsCount(viewId) {
    return getOrCreateReplayStats(viewId).segments_count;
}
function addSegment(viewId) {
    getOrCreateReplayStats(viewId).segments_count += 1;
}
function addRecord(viewId) {
    getOrCreateReplayStats(viewId).records_count += 1;
}
function addWroteData(viewId, additionalBytesCount) {
    getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function getReplayStats(viewId) {
    return statsPerView === null || statsPerView === void 0 ? void 0 : statsPerView.get(viewId);
}
function resetReplayStats() {
    statsPerView = undefined;
}
function getOrCreateReplayStats(viewId) {
    if (!statsPerView) {
        statsPerView = new Map();
    }
    var replayStats;
    if (statsPerView.has(viewId)) {
        replayStats = statsPerView.get(viewId);
    }
    else {
        replayStats = {
            records_count: 0,
            segments_count: 0,
            segments_total_raw_size: 0,
        };
        statsPerView.set(viewId, replayStats);
        if (statsPerView.size > MAX_STATS_HISTORY) {
            deleteOldestStats();
        }
    }
    return replayStats;
}
function deleteOldestStats() {
    if (!statsPerView) {
        return;
    }
    if (statsPerView.keys) {
        statsPerView.delete(statsPerView.keys().next().value);
    }
    else {
        // IE11 doesn't support map.keys
        var isFirst_1 = true;
        statsPerView.forEach(function (_value, key) {
            if (isFirst_1) {
                statsPerView.delete(key);
                isFirst_1 = false;
            }
        });
    }
}
//# sourceMappingURL=replayStats.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segment.js



var Segment = /** @class */ (function () {
    function Segment(encoder, context, creationReason) {
        this.encoder = encoder;
        var viewId = context.view.id;
        this.metadata = (0,polyfills/* assign */.f0)({
            start: Infinity,
            end: -Infinity,
            creation_reason: creationReason,
            records_count: 0,
            has_full_snapshot: false,
            index_in_view: getSegmentsCount(viewId),
            source: 'browser',
        }, context);
        addSegment(viewId);
    }
    Segment.prototype.addRecord = function (record, callback) {
        var _a;
        this.metadata.start = Math.min(this.metadata.start, record.timestamp);
        this.metadata.end = Math.max(this.metadata.end, record.timestamp);
        this.metadata.records_count += 1;
        (_a = this.metadata).has_full_snapshot || (_a.has_full_snapshot = record.type === RecordType.FullSnapshot);
        (0,sendToExtension/* sendToExtension */.j)('record', { record: record, segment: this.metadata });
        addRecord(this.metadata.view.id);
        var prefix = this.metadata.records_count === 1 ? '{"records":[' : ',';
        this.encoder.write(prefix + JSON.stringify(record), callback);
    };
    Segment.prototype.flush = function (callback) {
        var _this = this;
        if (this.metadata.records_count === 0) {
            throw new Error('Empty segment flushed');
        }
        this.encoder.write("],".concat(JSON.stringify(this.metadata).slice(1), "\n"), function () {
            addWroteData(_this.metadata.view.id, _this.encoder.rawBytesCount);
            callback(_this.metadata);
        });
        this.encoder.reset();
    };
    return Segment;
}());

//# sourceMappingURL=segment.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/segmentCollection.js



var SEGMENT_DURATION_LIMIT = 30 * timeUtils/* ONE_SECOND */.WT;
/**
 * beacon payload max queue size implementation is 64kb
 * ensure that we leave room for logs, rum and potential other users
 */
var SEGMENT_BYTES_LIMIT = 60000;
// Segments are the main data structure for session replays. They contain context information used
// for indexing or UI needs, and a list of records (RRWeb 'events', renamed to avoid confusing
// namings). They are stored without any processing from the intake, and fetched one after the
// other while a session is being replayed. Their encoding (deflate) are carefully crafted to allow
// concatenating multiple segments together. Segments have a size overhead (metadata), so our goal is to
// build segments containing as many records as possible while complying with the various flush
// strategies to guarantee a good replay quality.
//
// When the recording starts, a segment is initially created.  The segment is flushed (finalized and
// sent) based on various events (non-exhaustive list):
//
// * the page visibility change or becomes to unload
// * the segment duration reaches a limit
// * the encoded segment bytes count reaches a limit
// * ...
//
// A segment cannot be created without its context.  If the RUM session ends and no session id is
// available when creating a new segment, records will be ignored, until the session is renewed and
// a new session id is available.
//
// Empty segments (segments with no record) aren't useful and should be ignored.
//
// To help investigate session replays issues, each segment is created with a "creation reason",
// indicating why the session has been created.
function startSegmentCollection(lifeCycle, configuration, sessionManager, viewContexts, httpRequest, encoder) {
    return doStartSegmentCollection(lifeCycle, function () { return computeSegmentContext(configuration.applicationId, sessionManager, viewContexts); }, httpRequest, encoder);
}
function doStartSegmentCollection(lifeCycle, getSegmentContext, httpRequest, encoder) {
    var state = {
        status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
        nextSegmentCreationReason: 'init',
    };
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function () {
        flushSegment('view_change');
    }).unsubscribe;
    var unsubscribePageExited = lifeCycle.subscribe(9 /* LifeCycleEventType.PAGE_EXITED */, function (pageExitEvent) {
        flushSegment(pageExitEvent.reason);
    }).unsubscribe;
    function flushSegment(flushReason) {
        if (state.status === 1 /* SegmentCollectionStatus.SegmentPending */) {
            state.segment.flush(function (metadata) {
                var payload = buildReplayPayload(encoder.encodedBytes, metadata, encoder.rawBytesCount);
                if ((0,browser_pageExitObservable/* isPageExitReason */.PT)(flushReason)) {
                    httpRequest.sendOnExit(payload);
                }
                else {
                    httpRequest.send(payload);
                }
            });
            (0,timer/* clearTimeout */.gr)(state.expirationTimeoutId);
        }
        if (flushReason !== 'stop') {
            state = {
                status: 0 /* SegmentCollectionStatus.WaitingForInitialRecord */,
                nextSegmentCreationReason: flushReason,
            };
        }
        else {
            state = {
                status: 2 /* SegmentCollectionStatus.Stopped */,
            };
        }
    }
    return {
        addRecord: function (record) {
            if (state.status === 2 /* SegmentCollectionStatus.Stopped */) {
                return;
            }
            if (state.status === 0 /* SegmentCollectionStatus.WaitingForInitialRecord */) {
                var context = getSegmentContext();
                if (!context) {
                    return;
                }
                state = {
                    status: 1 /* SegmentCollectionStatus.SegmentPending */,
                    segment: new Segment(encoder, context, state.nextSegmentCreationReason),
                    expirationTimeoutId: (0,timer/* setTimeout */.iK)(function () {
                        flushSegment('segment_duration_limit');
                    }, SEGMENT_DURATION_LIMIT),
                };
            }
            var segment = state.segment;
            segment.addRecord(record, function () {
                if (
                // the written segment is still pending
                state.status === 1 /* SegmentCollectionStatus.SegmentPending */ &&
                    state.segment === segment &&
                    encoder.encodedBytesCount > SEGMENT_BYTES_LIMIT) {
                    flushSegment('segment_bytes_limit');
                }
            });
        },
        stop: function () {
            flushSegment('stop');
            unsubscribeViewCreated();
            unsubscribePageExited();
        },
    };
}
function computeSegmentContext(applicationId, sessionManager, viewContexts) {
    var session = sessionManager.findTrackedSession();
    var viewContext = viewContexts.findView();
    if (!session || !viewContext) {
        return undefined;
    }
    return {
        application: {
            id: applicationId,
        },
        session: {
            id: session.id,
        },
        view: {
            id: viewContext.id,
        },
    };
}
function setSegmentBytesLimit(newSegmentBytesLimit) {
    if (newSegmentBytesLimit === void 0) { newSegmentBytesLimit = 60000; }
    SEGMENT_BYTES_LIMIT = newSegmentBytesLimit;
}
//# sourceMappingURL=segmentCollection.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/segmentCollection/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/boot/startRecording.js




function startRecording(lifeCycle, configuration, sessionManager, viewContexts, encoder, httpRequest) {
    var reportError = function (error) {
        lifeCycle.notify(12 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, { error: error });
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Error reported to customer', { 'error.message': error.message });
    };
    var replayRequest = httpRequest ||
        (0,transport_httpRequest/* createHttpRequest */.UF)(configuration, configuration.sessionReplayEndpointBuilder, SEGMENT_BYTES_LIMIT, reportError);
    var _a = startSegmentCollection(lifeCycle, configuration, sessionManager, viewContexts, replayRequest, encoder), addRecord = _a.addRecord, stopSegmentCollection = _a.stop;
    var _b = record({
        emit: addRecord,
        configuration: configuration,
        lifeCycle: lifeCycle,
    }), stopRecording = _b.stop, takeSubsequentFullSnapshot = _b.takeSubsequentFullSnapshot, flushMutations = _b.flushMutations;
    var unsubscribeViewEnded = lifeCycle.subscribe(4 /* LifeCycleEventType.VIEW_ENDED */, function () {
        flushMutations();
        addRecord({
            timestamp: (0,timeUtils/* timeStampNow */.n$)(),
            type: RecordType.ViewEnd,
        });
    }).unsubscribe;
    var unsubscribeViewCreated = lifeCycle.subscribe(2 /* LifeCycleEventType.VIEW_CREATED */, function (view) {
        takeSubsequentFullSnapshot(view.startClocks.timeStamp);
    }).unsubscribe;
    return {
        stop: function () {
            unsubscribeViewEnded();
            unsubscribeViewCreated();
            stopRecording();
            stopSegmentCollection();
        },
    };
}
//# sourceMappingURL=startRecording.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/boot/isBrowserSupported.js
/**
 * Test for Browser features used while recording
 */
function isBrowserSupported() {
    return (
    // Array.from is a bit less supported by browsers than CSSSupportsRule, but has higher chances
    // to be polyfilled. Test for both to be more confident. We could add more things if we find out
    // this test is not sufficient.
    typeof Array.from === 'function' &&
        typeof CSSSupportsRule === 'function' &&
        typeof URL.createObjectURL === 'function' &&
        'forEach' in NodeList.prototype);
}
//# sourceMappingURL=isBrowserSupported.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/getSessionReplayLink.js


function getSessionReplayLink(configuration, sessionManager, viewContexts, isRecordingStarted) {
    var session = sessionManager.findTrackedSession();
    var errorType = getErrorType(session, isRecordingStarted);
    var viewContext = viewContexts.findView();
    return getSessionReplayUrl(configuration, {
        viewContext: viewContext,
        errorType: errorType,
        session: session,
    });
}
function getErrorType(session, isRecordingStarted) {
    if (!isBrowserSupported()) {
        return 'browser-not-supported';
    }
    if (!session) {
        // possibilities:
        // - rum sampled out
        // - session expired (edge case)
        return 'rum-not-tracked';
    }
    if (!session.sessionReplayAllowed) {
        // possibilities
        // - replay sampled out
        return 'incorrect-session-plan';
    }
    if (!isRecordingStarted) {
        return 'replay-not-started';
    }
}
//# sourceMappingURL=getSessionReplayLink.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/deflate/deflateEncoder.js

function createDeflateEncoder(configuration, worker, streamId) {
    var rawBytesCount = 0;
    var compressedData = [];
    var compressedDataTrailer;
    var nextWriteActionId = 0;
    var pendingWriteActions = [];
    var removeMessageListener = (0,addEventListener/* addEventListener */.O)(configuration, worker, 'message', function (_a) {
        var data = _a.data;
        if (data.type !== 'wrote' || data.streamId !== streamId) {
            return;
        }
        var nextPendingAction = pendingWriteActions.shift();
        if (nextPendingAction && nextPendingAction.id === data.id) {
            if (data.id === 0) {
                // Initial state
                rawBytesCount = data.additionalBytesCount;
                compressedData = [data.result];
            }
            else {
                rawBytesCount += data.additionalBytesCount;
                compressedData.push(data.result);
            }
            compressedDataTrailer = data.trailer;
            nextPendingAction.callback();
        }
        else {
            removeMessageListener();
            (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Worker responses received out of order.');
        }
    }).stop;
    return {
        get encodedBytes() {
            if (!compressedData.length) {
                return new Uint8Array(0);
            }
            return (0,byteUtils/* concatBuffers */.Kb)(compressedData.concat(compressedDataTrailer));
        },
        get encodedBytesCount() {
            if (!compressedData.length) {
                return 0;
            }
            return compressedData.reduce(function (total, buffer) { return total + buffer.length; }, 0) + compressedDataTrailer.length;
        },
        get rawBytesCount() {
            return rawBytesCount;
        },
        write: function (data, callback) {
            worker.postMessage({
                action: 'write',
                id: nextWriteActionId,
                data: data,
                streamId: streamId,
            });
            pendingWriteActions.push({
                id: nextWriteActionId,
                callback: callback,
            });
            nextWriteActionId += 1;
        },
        reset: function () {
            worker.postMessage({
                action: 'reset',
                streamId: streamId,
            });
            nextWriteActionId = 0;
        },
        stop: function () {
            removeMessageListener();
        },
    };
}
//# sourceMappingURL=deflateEncoder.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/deflate/deflateWorker.js

var INITIALIZATION_TIME_OUT_DELAY = 10 * timeUtils/* ONE_SECOND */.WT;
function createDeflateWorker(configuration) {
    return new Worker(configuration.workerUrl || URL.createObjectURL(new Blob(["!function(){\"use strict\";function t(t){for(var e=t.reduce((function(t,e){return t+e.length}),0),a=new Uint8Array(e),n=0,r=0,i=t;r<i.length;r++){var s=i[r];a.set(s,n),n+=s.length}return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=256,n=286,r=30,i=15,s=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),_=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),h=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),l=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),o=new Array(576);e(o);var d=new Array(60);e(d);var u=new Array(512);e(u);var f=new Array(256);e(f);var c=new Array(29);e(c);var p,g,w,v=new Array(r);function b(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t&&t.length}function m(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(v);var y=function(t){return t<256?u[t]:u[256+(t>>>7)]},k=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},z=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,k(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},x=function(t,e,a){z(t,a[2*e],a[2*e+1])},A=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},E=function(t,e,a){var n,r,s=new Array(16),_=0;for(n=1;n<=i;n++)s[n]=_=_+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=A(s[h]++,h))}},Z=function(t){var e;for(e=0;e<n;e++)t.dyn_ltree[2*e]=0;for(e=0;e<r;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},U=function(t){t.bi_valid>8?k(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},S=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},R=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&S(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!S(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},L=function(t,e,n){var r,i,h,l,o=0;if(0!==t.last_lit)do{r=t.pending_buf[t.d_buf+2*o]<<8|t.pending_buf[t.d_buf+2*o+1],i=t.pending_buf[t.l_buf+o],o++,0===r?x(t,i,e):(h=f[i],x(t,h+a+1,e),0!==(l=s[h])&&(i-=c[h],z(t,i,l)),r--,h=y(r),x(t,h,n),0!==(l=_[h])&&(r-=v[h],z(t,r,l)))}while(o<t.last_lit);x(t,256,e)},F=function(t,e){var a,n,r,s=e.dyn_tree,_=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,o=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==s[2*a]?(t.heap[++t.heap_len]=o=a,t.depth[a]=0):s[2*a+1]=0;for(;t.heap_len<2;)s[2*(r=t.heap[++t.heap_len]=o<2?++o:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=_[2*r+1]);for(e.max_code=o,a=t.heap_len>>1;a>=1;a--)R(t,s,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],R(t,s,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,s[2*r]=s[2*a]+s[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,s[2*a+1]=s[2*n+1]=r,t.heap[1]=r++,R(t,s,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,s,_,h,l=e.dyn_tree,o=e.max_code,d=e.stat_desc.static_tree,u=e.stat_desc.has_stree,f=e.stat_desc.extra_bits,c=e.stat_desc.extra_base,p=e.stat_desc.max_length,g=0;for(s=0;s<=i;s++)t.bl_count[s]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(s=l[2*l[2*(n=t.heap[a])+1]+1]+1)>p&&(s=p,g++),l[2*n+1]=s,n>o||(t.bl_count[s]++,_=0,n>=c&&(_=f[n-c]),h=l[2*n],t.opt_len+=h*(s+_),u&&(t.static_len+=h*(d[2*n+1]+_)));if(0!==g){do{for(s=p-1;0===t.bl_count[s];)s--;t.bl_count[s]--,t.bl_count[s+1]+=2,t.bl_count[p]--,g-=2}while(g>0);for(s=p;0!==s;s--)for(n=t.bl_count[s];0!==n;)(r=t.heap[--a])>o||(l[2*r+1]!==s&&(t.opt_len+=(s-l[2*r+1])*l[2*r],l[2*r+1]=s),n--)}}(t,e),E(s,o,t.bl_count)},T=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++_<h&&r===s||(_<l?t.bl_tree[2*r]+=_:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):_<=10?t.bl_tree[34]++:t.bl_tree[36]++,_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4))},I=function(t,e,a){var n,r,i=-1,s=e[1],_=0,h=7,l=4;for(0===s&&(h=138,l=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++_<h&&r===s)){if(_<l)do{x(t,r,t.bl_tree)}while(0!=--_);else 0!==r?(r!==i&&(x(t,r,t.bl_tree),_--),x(t,16,t.bl_tree),z(t,_-3,2)):_<=10?(x(t,17,t.bl_tree),z(t,_-3,3)):(x(t,18,t.bl_tree),z(t,_-11,7));_=0,i=r,0===s?(h=138,l=3):r===s?(h=6,l=3):(h=7,l=4)}},N=!1,O=function(t,e,a,n){z(t,0+(n?1:0),3),function(t,e,a,n){U(t),n&&(k(t,a),k(t,~a)),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a,!0)},D=function(t,e,n,r){var i,s,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,n=4093624447;for(e=0;e<=31;e++,n>>>=1)if(1&n&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<a;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),F(t,t.l_desc),F(t,t.d_desc),_=function(t){var e;for(T(t,t.dyn_ltree,t.l_desc.max_code),T(t,t.dyn_dtree,t.d_desc.max_code),F(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*l[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),i=t.opt_len+3+7>>>3,(s=t.static_len+3+7>>>3)<=i&&(i=s)):i=s=n+5,n+4<=i&&-1!==e?O(t,e,n,r):4===t.strategy||s===i?(z(t,2+(r?1:0),3),L(t,o,d)):(z(t,4+(r?1:0),3),function(t,e,a,n){var r;for(z(t,e-257,5),z(t,a-1,5),z(t,n-4,4),r=0;r<n;r++)z(t,t.bl_tree[2*l[r]+1],3);I(t,t.dyn_ltree,e-1),I(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),L(t,t.dyn_ltree,t.dyn_dtree)),Z(t),r&&U(t)},B={_tr_init:function(t){N||(!function(){var t,e,a,l,m,y=new Array(16);for(a=0,l=0;l<28;l++)for(c[l]=a,t=0;t<1<<s[l];t++)f[a++]=l;for(f[a-1]=l,m=0,l=0;l<16;l++)for(v[l]=m,t=0;t<1<<_[l];t++)u[m++]=l;for(m>>=7;l<r;l++)for(v[l]=m<<7,t=0;t<1<<_[l]-7;t++)u[256+m++]=l;for(e=0;e<=i;e++)y[e]=0;for(t=0;t<=143;)o[2*t+1]=8,t++,y[8]++;for(;t<=255;)o[2*t+1]=9,t++,y[9]++;for(;t<=279;)o[2*t+1]=7,t++,y[7]++;for(;t<=287;)o[2*t+1]=8,t++,y[8]++;for(E(o,287,y),t=0;t<r;t++)d[2*t+1]=5,d[2*t]=A(t,5);p=new b(o,s,257,n,i),g=new b(d,_,0,r,i),w=new b(new Array(0),h,0,19,7)}(),N=!0),t.l_desc=new m(t.dyn_ltree,p),t.d_desc=new m(t.dyn_dtree,g),t.bl_desc=new m(t.bl_tree,w),t.bi_buf=0,t.bi_valid=0,Z(t)},_tr_stored_block:O,_tr_flush_block:D,_tr_tally:function(t,e,n){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&n,t.last_lit++,0===e?t.dyn_ltree[2*n]++:(t.matches++,e--,t.dyn_ltree[2*(f[n]+a+1)]++,t.dyn_dtree[2*y(e)]++),t.last_lit===t.lit_bufsize-1},_tr_align:function(t){z(t,2,3),x(t,256,o),function(t){16===t.bi_valid?(k(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}},C=function(t,e,a,n){for(var r=65535&t|0,i=t>>>16&65535|0,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16|0},H=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),M=function(t,e,a,n){var r=H,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},Y={2:\"need dictionary\",1:\"stream end\",0:\"\",\"-1\":\"file error\",\"-2\":\"stream error\",\"-3\":\"data error\",\"-4\":\"insufficient memory\",\"-5\":\"buffer error\",\"-6\":\"incompatible version\"},K={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8},P=B._tr_init,j=B._tr_stored_block,G=B._tr_flush_block,X=B._tr_tally,W=B._tr_align,q=K.Z_NO_FLUSH,J=K.Z_PARTIAL_FLUSH,Q=K.Z_FULL_FLUSH,V=K.Z_FINISH,$=K.Z_BLOCK,tt=K.Z_OK,et=K.Z_STREAM_END,at=K.Z_STREAM_ERROR,nt=K.Z_DATA_ERROR,rt=K.Z_BUF_ERROR,it=K.Z_DEFAULT_COMPRESSION,st=K.Z_FILTERED,_t=K.Z_HUFFMAN_ONLY,ht=K.Z_RLE,lt=K.Z_FIXED,ot=K.Z_DEFAULT_STRATEGY,dt=K.Z_UNKNOWN,ut=K.Z_DEFLATED,ft=258,ct=262,pt=103,gt=113,wt=666,vt=function(t,e){return t.msg=Y[e],e},bt=function(t){return(t<<1)-(t>4?9:0)},mt=function(t){for(var e=t.length;--e>=0;)t[e]=0},yt=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},kt=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},zt=function(t,e){G(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,kt(t.strm)},xt=function(t,e){t.pending_buf[t.pending++]=e},At=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},Et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,_=t.nice_match,h=t.strstart>t.w_size-ct?t.strstart-(t.w_size-ct):0,l=t.window,o=t.w_mask,d=t.prev,u=t.strstart+ft,f=l[i+s-1],c=l[i+s];t.prev_length>=t.good_match&&(r>>=2),_>t.lookahead&&(_=t.lookahead);do{if(l[(a=e)+s]===c&&l[a+s-1]===f&&l[a]===l[i]&&l[++a]===l[i+1]){i+=2,a++;do{}while(l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&l[++i]===l[++a]&&i<u);if(n=ft-(u-i),i=u-ft,n>s){if(t.match_start=e,s=n,n>=_)break;f=l[i+s-1],c=l[i+s]}}}while((e=d[e&o])>h&&0!=--r);return s<=t.lookahead?s:t.lookahead},Zt=function(t){var e,a,n,r,i,s,_,h,l,o,d=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=d+(d-ct)){t.window.set(t.window.subarray(d,d+d),0),t.match_start-=d,t.strstart-=d,t.block_start-=d,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=d?n-d:0}while(--a);e=a=d;do{n=t.prev[--e],t.prev[e]=n>=d?n-d:0}while(--a);r+=d}if(0===t.strm.avail_in)break;if(s=t.strm,_=t.window,h=t.strstart+t.lookahead,l=r,o=void 0,(o=s.avail_in)>l&&(o=l),a=0===o?0:(s.avail_in-=o,_.set(s.input.subarray(s.next_in,s.next_in+o),h),1===s.state.wrap?s.adler=C(s.adler,_,o,h):2===s.state.wrap&&(s.adler=M(s.adler,_,o,h)),s.next_in+=o,s.total_in+=o,o),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=yt(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=yt(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<ct&&0!==t.strm.avail_in)},Ut=function(t,e){for(var a,n;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a)),t.match_length>=3)if(n=X(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=yt(t,t.ins_h,t.window[t.strstart+1]);else n=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2},St=function(t,e){for(var a,n,r;;){if(t.lookahead<ct){if(Zt(t),t.lookahead<ct&&e===q)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-ct&&(t.match_length=Et(t,a),t.match_length<=5&&(t.strategy===st||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=X(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=yt(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(zt(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=X(t,0,t.window[t.strstart-1]))&&zt(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=X(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2};function Rt(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var Lt=[new Rt(0,0,0,0,(function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(Zt(t),0===t.lookahead&&e===q)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,zt(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-ct&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(zt(t,!1),t.strm.avail_out),1)})),new Rt(4,4,8,4,Ut),new Rt(4,5,16,8,Ut),new Rt(4,6,32,32,Ut),new Rt(4,4,16,16,St),new Rt(8,16,32,32,St),new Rt(8,16,128,128,St),new Rt(8,32,128,256,St),new Rt(32,128,258,1024,St),new Rt(32,258,258,4096,St)];function Ft(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ut,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),mt(this.dyn_ltree),mt(this.dyn_dtree),mt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),mt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),mt(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}var Tt=function(t){if(!t||!t.state)return vt(t,at);t.total_in=t.total_out=0,t.data_type=dt;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:gt,t.adler=2===e.wrap?0:1,e.last_flush=q,P(e),tt},It=function(t){var e,a=Tt(t);return a===tt&&((e=t.state).window_size=2*e.w_size,mt(e.head),e.max_lazy_match=Lt[e.level].max_lazy,e.good_match=Lt[e.level].good_length,e.nice_match=Lt[e.level].nice_length,e.max_chain_length=Lt[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),a},Nt=function(t,e,a,n,r,i){if(!t)return at;var s=1;if(e===it&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||a!==ut||n<8||n>15||e<0||e>9||i<0||i>lt)return vt(t,at);8===n&&(n=9);var _=new Ft;return t.state=_,_.strm=t,_.wrap=s,_.gzhead=null,_.w_bits=n,_.w_size=1<<_.w_bits,_.w_mask=_.w_size-1,_.hash_bits=r+7,_.hash_size=1<<_.hash_bits,_.hash_mask=_.hash_size-1,_.hash_shift=~~((_.hash_bits+3-1)/3),_.window=new Uint8Array(2*_.w_size),_.head=new Uint16Array(_.hash_size),_.prev=new Uint16Array(_.w_size),_.lit_bufsize=1<<r+6,_.pending_buf_size=4*_.lit_bufsize,_.pending_buf=new Uint8Array(_.pending_buf_size),_.d_buf=1*_.lit_bufsize,_.l_buf=3*_.lit_bufsize,_.level=e,_.strategy=i,_.method=a,It(t)},Ot={deflateInit:function(t,e){return Nt(t,e,ut,15,8,ot)},deflateInit2:Nt,deflateReset:It,deflateResetKeep:Tt,deflateSetHeader:function(t,e){return t&&t.state?2!==t.state.wrap?at:(t.state.gzhead=e,tt):at},deflate:function(t,e){var a,n;if(!t||!t.state||e>$||e<0)return t?vt(t,at):at;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===wt&&e!==V)return vt(t,0===t.avail_out?rt:at);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,xt(r,31),xt(r,139),xt(r,8),r.gzhead?(xt(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),xt(r,255&r.gzhead.time),xt(r,r.gzhead.time>>8&255),xt(r,r.gzhead.time>>16&255),xt(r,r.gzhead.time>>24&255),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,255&r.gzhead.os),r.gzhead.extra&&r.gzhead.extra.length&&(xt(r,255&r.gzhead.extra.length),xt(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=M(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,0),xt(r,9===r.level?2:r.strategy>=_t||r.level<2?4:0),xt(r,3),r.status=gt);else{var s=ut+(r.w_bits-8<<4)<<8;s|=(r.strategy>=_t||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(s|=32),s+=31-s%31,r.status=gt,At(r,s),0!==r.strstart&&(At(r,t.adler>>>16),At(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending!==r.pending_buf_size));)xt(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),kt(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,xt(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=M(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=pt)}else r.status=pt;if(r.status===pt&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&kt(t),r.pending+2<=r.pending_buf_size&&(xt(r,255&t.adler),xt(r,t.adler>>8&255),t.adler=0,r.status=gt)):r.status=gt),0!==r.pending){if(kt(t),0===t.avail_out)return r.last_flush=-1,tt}else if(0===t.avail_in&&bt(e)<=bt(i)&&e!==V)return vt(t,rt);if(r.status===wt&&0!==t.avail_in)return vt(t,rt);if(0!==t.avail_in||0!==r.lookahead||e!==q&&r.status!==wt){var _=r.strategy===_t?function(t,e){for(var a;;){if(0===t.lookahead&&(Zt(t),0===t.lookahead)){if(e===q)return 1;break}if(t.match_length=0,a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):r.strategy===ht?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=ft){if(Zt(t),t.lookahead<=ft&&e===q)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+ft;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=ft-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=X(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=X(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(zt(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===V?(zt(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(zt(t,!1),0===t.strm.avail_out)?1:2}(r,e):Lt[r.level].func(r,e);if(3!==_&&4!==_||(r.status=wt),1===_||3===_)return 0===t.avail_out&&(r.last_flush=-1),tt;if(2===_&&(e===J?W(r):e!==$&&(j(r,0,0,!1),e===Q&&(mt(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),kt(t),0===t.avail_out))return r.last_flush=-1,tt}return e!==V?tt:r.wrap<=0?et:(2===r.wrap?(xt(r,255&t.adler),xt(r,t.adler>>8&255),xt(r,t.adler>>16&255),xt(r,t.adler>>24&255),xt(r,255&t.total_in),xt(r,t.total_in>>8&255),xt(r,t.total_in>>16&255),xt(r,t.total_in>>24&255)):(At(r,t.adler>>>16),At(r,65535&t.adler)),kt(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?tt:et)},deflateEnd:function(t){if(!t||!t.state)return at;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==pt&&e!==gt&&e!==wt?vt(t,at):(t.state=null,e===gt?vt(t,nt):tt)},deflateSetDictionary:function(t,e){var a=e.length;if(!t||!t.state)return at;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return at;if(1===r&&(t.adler=C(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(mt(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,_=t.next_in,h=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,Zt(n);n.lookahead>=3;){var l=n.strstart,o=n.lookahead-2;do{n.ins_h=yt(n,n.ins_h,n.window[l+3-1]),n.prev[l&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=l,l++}while(--o);n.strstart=l,n.lookahead=2,Zt(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=_,t.input=h,t.avail_in=s,n.wrap=r,tt},deflateInfo:\"pako deflate (from Nodeca project)\"};for(var Dt=new Uint8Array(256),Bt=0;Bt<256;Bt++)Dt[Bt]=Bt>=252?6:Bt>=248?5:Bt>=240?4:Bt>=224?3:Bt>=192?2:1;Dt[254]=Dt[254]=1;var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg=\"\",this.state=null,this.data_type=2,this.adler=0},Ht=Object.prototype.toString,Mt=K.Z_NO_FLUSH,Yt=K.Z_SYNC_FLUSH,Kt=K.Z_FULL_FLUSH,Pt=K.Z_FINISH,jt=K.Z_OK,Gt=K.Z_STREAM_END,Xt=K.Z_DEFAULT_COMPRESSION,Wt=K.Z_DEFAULT_STRATEGY,qt=K.Z_DEFLATED;function Jt(){this.options={level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg=\"\",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;var e=Ot.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(e!==jt)throw new Error(Y[e]);if(t.header&&Ot.deflateSetHeader(this.strm,t.header),t.dictionary){var a;if(a=\"[object ArrayBuffer]\"===Ht.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(e=Ot.deflateSetDictionary(this.strm,a))!==jt)throw new Error(Y[e]);this._dict_set=!0}}function Qt(t,e,a){try{t.postMessage({type:\"errored\",error:e,streamId:a})}catch(n){t.postMessage({type:\"errored\",error:String(e),streamId:a})}}function Vt(t){var e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}Jt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?Pt:Mt,\"[object ArrayBuffer]\"===Ht.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(n===Yt||n===Kt)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if((a=Ot.deflate(r,n))===Gt)return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=Ot.deflateEnd(this.strm),this.onEnd(a),this.ended=!0,a===jt;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===jt&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,_=t.length;i<_;i++){var h=t[i];r.set(h,s),s+=h.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e){void 0===e&&(e=self);try{var a=new Map;e.addEventListener(\"message\",(function(n){try{var r=function(e,a){switch(a.action){case\"init\":return{type:\"initialized\",version:\"4.50.1\"};case\"write\":var n=e.get(a.streamId);n||(n=new Jt,e.set(a.streamId,n));var r=n.chunks.length,i=function(t){if(\"function\"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);var e,a,n,r,i,s=t.length,_=0;for(r=0;r<s;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),_+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(_),i=0,r=0;i<_;r++)55296==(64512&(a=t.charCodeAt(r)))&&r+1<s&&56320==(64512&(n=t.charCodeAt(r+1)))&&(a=65536+(a-55296<<10)+(n-56320),r++),a<128?e[i++]=a:a<2048?(e[i++]=192|a>>>6,e[i++]=128|63&a):a<65536?(e[i++]=224|a>>>12,e[i++]=128|a>>>6&63,e[i++]=128|63&a):(e[i++]=240|a>>>18,e[i++]=128|a>>>12&63,e[i++]=128|a>>>6&63,e[i++]=128|63&a);return e}(a.data);return n.push(i,K.Z_SYNC_FLUSH),{type:\"wrote\",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:Vt(n),additionalBytesCount:i.length};case\"reset\":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){Qt(e,t,n.data&&\"streamId\"in n.data?n.data.streamId:void 0)}}))}catch(t){Qt(e,t)}}()}();"])));
}
var state = { status: 0 /* DeflateWorkerStatus.Nil */ };
function startDeflateWorker(configuration, source, onInitializationFailure, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    if (state.status === 0 /* DeflateWorkerStatus.Nil */) {
        // doStartDeflateWorker updates the state to "loading" or "error"
        doStartDeflateWorker(configuration, source, createDeflateWorkerImpl);
    }
    switch (state.status) {
        case 1 /* DeflateWorkerStatus.Loading */:
            state.initializationFailureCallbacks.push(onInitializationFailure);
            return state.worker;
        case 3 /* DeflateWorkerStatus.Initialized */:
            return state.worker;
    }
}
function resetDeflateWorkerState() {
    if (state.status === 3 /* DeflateWorkerStatus.Initialized */ || state.status === 1 /* DeflateWorkerStatus.Loading */) {
        state.stop();
    }
    state = { status: 0 /* DeflateWorkerStatus.Nil */ };
}
function getDeflateWorkerStatus() {
    return state.status;
}
/**
 * Starts the deflate worker and handle messages and errors
 *
 * The spec allow browsers to handle worker errors differently:
 * - Chromium throws an exception
 * - Firefox fires an error event
 *
 * more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
 */
function doStartDeflateWorker(configuration, source, createDeflateWorkerImpl) {
    if (createDeflateWorkerImpl === void 0) { createDeflateWorkerImpl = createDeflateWorker; }
    try {
        var worker = createDeflateWorkerImpl(configuration);
        var removeErrorListener_1 = (0,addEventListener/* addEventListener */.O)(configuration, worker, 'error', function (error) {
            onError(configuration, source, error);
        }).stop;
        var removeMessageListener_1 = (0,addEventListener/* addEventListener */.O)(configuration, worker, 'message', function (_a) {
            var data = _a.data;
            if (data.type === 'errored') {
                onError(configuration, source, data.error, data.streamId);
            }
            else if (data.type === 'initialized') {
                onInitialized(data.version);
            }
        }).stop;
        worker.postMessage({ action: 'init' });
        (0,timer/* setTimeout */.iK)(function () { return onTimeout(source); }, INITIALIZATION_TIME_OUT_DELAY);
        var stop_1 = function () {
            removeErrorListener_1();
            removeMessageListener_1();
        };
        state = { status: 1 /* DeflateWorkerStatus.Loading */, worker: worker, stop: stop_1, initializationFailureCallbacks: [] };
    }
    catch (error) {
        onError(configuration, source, error);
    }
}
function onTimeout(source) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        display/* display.error */.jf.error("".concat(source, " failed to start: a timeout occurred while initializing the Worker"));
        state.initializationFailureCallbacks.forEach(function (callback) { return callback(); });
        state = { status: 2 /* DeflateWorkerStatus.Error */ };
    }
}
function onInitialized(version) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
        state = { status: 3 /* DeflateWorkerStatus.Initialized */, worker: state.worker, stop: state.stop, version: version };
    }
}
function onError(configuration, source, error, streamId) {
    if (state.status === 1 /* DeflateWorkerStatus.Loading */ || state.status === 0 /* DeflateWorkerStatus.Nil */) {
        display/* display.error */.jf.error("".concat(source, " failed to start: an error occurred while creating the Worker:"), error);
        if (error instanceof Event || (error instanceof Error && isMessageCspRelated(error.message))) {
            var baseMessage = void 0;
            if (configuration.workerUrl) {
                baseMessage = "Please make sure the Worker URL ".concat(configuration.workerUrl, " is correct and CSP is correctly configured.");
            }
            else {
                baseMessage = 'Please make sure CSP is correctly configured.';
            }
            display/* display.error */.jf.error("".concat(baseMessage, " See documentation at https://docs.datadoghq.com/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay"));
        }
        else {
            (0,telemetry_telemetry/* addTelemetryError */.Sz)(error);
        }
        if (state.status === 1 /* DeflateWorkerStatus.Loading */) {
            state.initializationFailureCallbacks.forEach(function (callback) { return callback(); });
        }
        state = { status: 2 /* DeflateWorkerStatus.Error */ };
    }
    else {
        (0,telemetry_telemetry/* addTelemetryError */.Sz)(error, {
            worker_version: state.status === 3 /* DeflateWorkerStatus.Initialized */ && state.version,
            stream_id: streamId,
        });
    }
}
function isMessageCspRelated(message) {
    return ((0,polyfills/* includes */.q9)(message, 'Content Security Policy') ||
        // Related to `require-trusted-types-for` CSP: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/require-trusted-types-for
        (0,polyfills/* includes */.q9)(message, "requires 'TrustedScriptURL'"));
}
//# sourceMappingURL=deflateWorker.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/domain/deflate/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/boot/recorderApi.js





function makeRecorderApi(startRecordingImpl, createDeflateWorkerImpl) {
    if ((0,eventBridge/* canUseEventBridge */.x)() || !isBrowserSupported()) {
        return {
            start: functionUtils/* noop */.Z,
            stop: functionUtils/* noop */.Z,
            getReplayStats: function () { return undefined; },
            onRumStart: functionUtils/* noop */.Z,
            isRecording: function () { return false; },
            getSessionReplayLink: function () { return undefined; },
        };
    }
    var state = {
        status: 0 /* RecorderStatus.Stopped */,
    };
    var startStrategy = function () {
        state = { status: 1 /* RecorderStatus.IntentToStart */ };
    };
    var stopStrategy = function () {
        state = { status: 0 /* RecorderStatus.Stopped */ };
    };
    return {
        start: function () { return startStrategy(); },
        stop: function () { return stopStrategy(); },
        getSessionReplayLink: function (configuration, sessionManager, viewContexts) {
            return getSessionReplayLink(configuration, sessionManager, viewContexts, state.status !== 0 /* RecorderStatus.Stopped */);
        },
        onRumStart: function (lifeCycle, configuration, sessionManager, viewContexts) {
            lifeCycle.subscribe(7 /* LifeCycleEventType.SESSION_EXPIRED */, function () {
                if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
                    stopStrategy();
                    state = { status: 1 /* RecorderStatus.IntentToStart */ };
                }
            });
            lifeCycle.subscribe(8 /* LifeCycleEventType.SESSION_RENEWED */, function () {
                if (state.status === 1 /* RecorderStatus.IntentToStart */) {
                    startStrategy();
                }
            });
            startStrategy = function () {
                var session = sessionManager.findTrackedSession();
                if (!session || !session.sessionReplayAllowed) {
                    state = { status: 1 /* RecorderStatus.IntentToStart */ };
                    return;
                }
                if (state.status === 2 /* RecorderStatus.Starting */ || state.status === 3 /* RecorderStatus.Started */) {
                    return;
                }
                state = { status: 2 /* RecorderStatus.Starting */ };
                runOnReadyState(configuration, 'interactive', function () {
                    if (state.status !== 2 /* RecorderStatus.Starting */) {
                        return;
                    }
                    var worker = startDeflateWorker(configuration, 'Datadog Session Replay', function () {
                        stopStrategy();
                    }, createDeflateWorkerImpl);
                    if (!worker) {
                        state = {
                            status: 0 /* RecorderStatus.Stopped */,
                        };
                        return;
                    }
                    var stopRecording = startRecordingImpl(lifeCycle, configuration, sessionManager, viewContexts, createDeflateEncoder(configuration, worker, 1 /* DeflateEncoderStreamId.REPLAY */)).stop;
                    state = {
                        status: 3 /* RecorderStatus.Started */,
                        stopRecording: stopRecording,
                    };
                });
            };
            stopStrategy = function () {
                if (state.status === 0 /* RecorderStatus.Stopped */) {
                    return;
                }
                if (state.status === 3 /* RecorderStatus.Started */) {
                    state.stopRecording();
                }
                state = {
                    status: 0 /* RecorderStatus.Stopped */,
                };
            };
            if (state.status === 1 /* RecorderStatus.IntentToStart */) {
                startStrategy();
            }
        },
        isRecording: function () {
            // The worker is started optimistically, meaning we could have started to record but its
            // initialization fails a bit later. This could happen when:
            // * the worker URL (blob or plain URL) is blocked by CSP in Firefox only (Chromium and Safari
            // throw an exception when instantiating the worker, and IE doesn't care about CSP)
            // * the browser fails to load the worker in case the workerUrl is used
            // * an unexpected error occurs in the Worker before initialization, ex:
            //   * a runtime exception collected by monitor()
            //   * a syntax error notified by the browser via an error event
            // * the worker is unresponsive for some reason and timeouts
            //
            // It is not expected to happen often. Nonetheless, the "replayable" status on RUM events is
            // an important part of the Datadog App:
            // * If we have a false positive (we set has_replay: true even if no replay data is present),
            // we might display broken links to the Session Replay player.
            // * If we have a false negative (we don't set has_replay: true even if replay data is
            // available), it is less noticeable because no link will be displayed.
            //
            // Thus, it is better to have false negative, so let's make sure the worker is correctly
            // initialized before advertizing that we are recording.
            //
            // In the future, when the compression worker will also be used for RUM data, this will be
            // less important since no RUM event will be sent when the worker fails to initialize.
            return getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ && state.status === 3 /* RecorderStatus.Started */;
        },
        getReplayStats: function (viewId) {
            return getDeflateWorkerStatus() === 3 /* DeflateWorkerStatus.Initialized */ ? getReplayStats(viewId) : undefined;
        },
    };
}
//# sourceMappingURL=recorderApi.js.map
;// CONCATENATED MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js
// Keep the following in sync with packages/rum-slim/src/entries/main.ts





var recorderApi = makeRecorderApi(startRecording);
var datadogRum = makeRumPublicApi(startRum, recorderApi);
(0,init/* defineGlobal */.y)((0,getGlobalObject/* getGlobalObject */.R)(), 'DD_RUM', datadogRum);
//# sourceMappingURL=main.js.map

/***/ }),

/***/ 71250:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (memoize);


/***/ }),

/***/ 79159:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["Z"] = (unitlessKeys);


/***/ }),

/***/ 7401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q1": function() { return /* binding */ pxToRem; },
/* harmony export */   "SY": function() { return /* binding */ themeAttribute; },
/* harmony export */   "W0": function() { return /* binding */ spacing; },
/* harmony export */   "Yo": function() { return /* binding */ getThemeName; },
/* harmony export */   "hN": function() { return /* binding */ ThemeNames; },
/* harmony export */   "im": function() { return /* binding */ srOnly; },
/* harmony export */   "jC": function() { return /* binding */ filterGlobalProps; },
/* harmony export */   "jU": function() { return /* binding */ isBrowser; },
/* harmony export */   "nJ": function() { return /* binding */ getCDNLink; }
/* harmony export */ });
/* unused harmony exports cssReset, cssResetObj, defaultTheme, escapeRegExp, srOnlyFocusable, useLocalStorage, useReadLocalStorage */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96324);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* provided dependency */ var process = __webpack_require__(13158);



/**
 * @deprecated no longer recommended, see LUI-877, LUI-910, and LUI-875 for more details
 */
var cssResetObj = {
  all: 'initial',
  boxSizing: 'border-box'
};

/**
 * @deprecated no longer recommended, see LUI-877, LUI-910, and LUI-875 for more details
 */
var cssReset = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["all:initial;box-sizing:border-box;"]);

/**
 * Escape regex char
 *
 * See: https://stackoverflow.com/questions/17885855/use-dynamic-variable-string-as-regex-pattern-in-javascript
 */
var escapeRegExp = stringToGoIntoTheRegex => {
  // eslint-disable-next-line no-useless-escape
  return stringToGoIntoTheRegex.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
};

// Global whitelist props for all LUI components
var whitelist = ['id', 'data-component', 'data-testid', 'data-tracking-event'];
// Global props should always apply to the outermost component
var filterGlobalProps = props => {
  return Object.keys(props).filter(propKey => whitelist.includes(propKey)).reduce((obj, propKey) => {
    obj[propKey] = props[propKey];
    return obj;
  }, {});
};

/**
 * note: useLocalStorage is being transitioned to sessionStorage
 */
function useLocalStorage(key, initialValue) {
  // Get from local storage then
  // parse stored json or return initialValue
  var readValue = () => {
    // Prevent build error "window is undefined" but keep keep working
    if (typeof window === 'undefined') {
      return initialValue;
    }
    try {
      var item = window.sessionStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.warn("Error reading sessionStorage key \u201C".concat(key, "\u201D:"), error);
      return initialValue;
    }
  };

  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  var [storedValue, setStoredValue] = useState(readValue);

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to sessionStorage.
  var setValue = value => {
    // Prevent build error "window is undefined" but keeps working
    if (typeof window === 'undefined') {
      console.warn("Tried setting sessionStorage key \u201C".concat(key, "\u201D even though environment is not a client"));
    }
    try {
      // Allow value to be a function so we have the same API as useState
      var newValue = value instanceof Function ? value(storedValue) : value;

      // Save to local storage
      window.sessionStorage.setItem(key, JSON.stringify(newValue));

      // Save state
      setStoredValue(newValue);

      // We dispatch a custom event so every useLocalStorage hook are notified
      window.dispatchEvent(new Event('local-storage'));
    } catch (error) {
      console.warn("Error setting sessionStorage key \u201C".concat(key, "\u201D:"), error);
    }
  };
  useEffect(() => {
    setStoredValue(readValue());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    var handleStorageChange = () => {
      setStoredValue(readValue());
    };

    // this only works for other documents, not the current one
    window.addEventListener('storage', handleStorageChange);

    // this is a custom event, triggered in writeValueToLocalStorage
    window.addEventListener('local-storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('local-storage', handleStorageChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return [storedValue, setValue];
}

function useReadLocalStorage(key) {
  // Get from local storage then
  // parse stored json or return initialValue
  var readValue = () => {
    // Prevent build error "window is undefined" but keep keep working
    if (typeof window === 'undefined') {
      return null;
    }
    try {
      var item = window.sessionStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.warn("Error reading sessionStorage key \u201C".concat(key, "\u201D:"), error);
      return null;
    }
  };

  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  var [storedValue, setStoredValue] = useState(readValue);

  // Listen if sessionStorage changes
  useEffect(() => {
    setStoredValue(readValue());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    var handleStorageChange = () => {
      setStoredValue(readValue());
    };

    // this only works for other documents, not the current one
    window.addEventListener('storage', handleStorageChange);

    // this is a custom event, triggered in writeValueToLocalStorage
    // See: useLocalStorage()
    window.addEventListener('local-storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('local-storage', handleStorageChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return storedValue;
}

/**
 * Custom getThemeName function
 *
 * At runtime, it gets the correct theme from the `document`
 *
 * It replys on `document` `data-attributes` as primary mechanism,
 * ans `sessionStoryage` as a backup mechanism.
 *
 * It works in conjunction with Custom setThemeName from `@lendi/ui`
 *
 * @deprecated Deprecated since 0.2.3. Use SC's Theme instead.
 */
var getThemeName = () => {
  // Check browser for runtime
  if (isBrowser) {
    var _window, _process, _process$env;
    // Get `theme` from DOM `data-attributes` if it's already available.
    var dataTheme = (_window = window) === null || _window === void 0 ? void 0 : _window.document.documentElement.getAttribute(themeAttribute);
    if (dataTheme) return dataTheme;

    // If not available, fallback to session storage (backwards compatibility with older LUIProvider)
    try {
      var storedTheme = window.sessionStorage.getItem('theme');
      if (storedTheme) return JSON.parse(storedTheme).value;
    } catch (error) {
      // TODO: Report Error
    }

    // conditionally generate warning
    var isRuntime = typeof process === 'undefined';
    var showWarning = isRuntime ? true : ((_process = process) === null || process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : "production") !== 'test';
    if (showWarning) {
      console.warn("~~~LUI: No theme detected. Applying default theme \"".concat(defaultTheme, "\"~~~"), '\nYou may not have properly installed the LUIProvider - please refer to https://lendi.style/?path=/docs/foundations-luiprovider--interactive.\n');
    }
  }
  return defaultTheme;
};

var hasWindow = typeof window !== 'undefined';
var hasDocument = typeof document !== 'undefined';
var isBrowser = hasWindow && hasDocument;

// deriveSize based on 16px
var spacing = {
  // start deprecated values
  /*
   * @deprecated use '8' instead
   */
  xxs: 8,
  /*
   * @deprecated use '12' instead
   */
  xs: 12,
  /*
   * @deprecated use '16' instead
   */
  sm: 16,
  /*
   * @deprecated use '24' instead
   */
  md: 24,
  /*
   * @deprecated use '32' instead
   */
  lg: 32,
  /*
   * @deprecated use '40' instead
   */
  xl: 40,
  /*
   * @deprecated use '64' instead
   */
  xxl: 64,
  /*
   * @deprecated use '80' instead
   */
  xxxl: 80,
  /*
   * @deprecated
   */
  '6': 6,
  /*
   * @deprecated
   */
  '40': 40,
  /*
   * @deprecated
   */
  '56': 56,
  /*
   * @deprecated use '96' instead
   */
  '80': 80,
  // end deprecated values
  '0': 0,
  '2': 2,
  '4': 4,
  '8': 8,
  '12': 12,
  '16': 16,
  '24': 24,
  '32': 32,
  '48': 48,
  '64': 64,
  '96': 96,
  '128': 128
};

/**
 *
 * @param {number} size - pixel value
 * @returns {string} - result with rem unit
 *
 * @todo - remove baseFontSize cosnt and replace with token when available
 */

var pxToRem = size => {
  var baseFontSize = 16;
  return "".concat(size / baseFontSize, "rem");
};

var srOnly = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["border:0 !important;clip:rect(1px,1px,1px,1px) !important;clip-path:inset(50%) !important;height:1px !important;overflow:hidden !important;padding:0 !important;position:absolute !important;width:1px !important;white-space:nowrap !important;"]);
var srOnlyFocusable = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["&:focus,&:active{clip:auto !important;clip-path:none !important;height:auto !important;overflow:visible !important;width:auto !important;white-space:normal !important;}"]);

var defaultTheme = 'lendi';
var themeAttribute = 'data-lui-theme';
var getCDNLink = () => 'https://lendicdn.net/62182bb1683f25004d5254ce6e3461c3/71ccb7a35a452ea8153b6d920f9f190e';
var ThemeNames;
(function (ThemeNames) {
  ThemeNames["Lendi"] = "lendi";
  ThemeNames["LendiNext"] = "lendi-next";
  ThemeNames["Aussie"] = "aussie";
  ThemeNames["Domain"] = "domain";
})(ThemeNames || (ThemeNames = {}));




/***/ }),

/***/ 72239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ ChatEventName; }
/* harmony export */ });
var ChatEventName = {
    MESSAGE_READ: 'Chat Message Read',
    MESSAGE_SENT: 'Chat Message Sent',
    OPENED: 'Chat Opened',
    OPENED_FROM_EMAIL: 'Chat Opened From Email',
    FIRST_MESSAGE_SENT: 'Chat First Message Sent',
    OTP_ENTERED: 'Chat OTP Entered',
    FIRST_NAME_ENTERED: 'Chat First Name Entered',
    NO_RESPONSE_MESSAGE_SENT: 'Chat No Response Message Sent',
    PHONE_NUMBER_ENTERED: 'Chat Phone Number Entered',
    EMAIL_ENTERED: 'Chat Email Entered',
    TRANSITIONED_FROM_SMART_TO_LENDI: 'Chat Transitioned From Smart To Lendi',
    USER_AUTHENTICATED: 'User Authenticated',
    CONTACT_US_SHOWN: 'Contact Us Shown',
    PHONE_NUMBER_CHANGED: 'Phone Number Changed',
    CHAT_OPENED_FROM_EXTERNAL: 'Link Clicked',
    OPEN_FROM_EMAIL: 'Chat Opened From Email',
};
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 71771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useBootstrappedChatState; },
/* harmony export */   "h": function() { return /* binding */ ChatBootstrapperContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);

var ChatBootstrapperContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
var useBootstrappedChatState = function () {
    var commPanelState = react__WEBPACK_IMPORTED_MODULE_0__.useContext(ChatBootstrapperContext);
    if (!commPanelState) {
        throw new Error('Please setup <ChatBootstrapperProvider /> as a parent component, before using useBootstrappedChatState().');
    }
    return commPanelState;
};
//# sourceMappingURL=context.js.map

/***/ }),

/***/ 51641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ CustomerChatBootstrapperProvider; }
});

// UNUSED EXPORTS: TeamsChatBootstrapperProvider

// EXTERNAL MODULE: ../../../packages/lala-react/dist/esm/index.js + 318 modules
var esm = __webpack_require__(25980);
// EXTERNAL MODULE: ../../../node_modules/launchdarkly-react-client-sdk/lib/index.js
var lib = __webpack_require__(52850);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/index.js + 22 modules
var dist_esm = __webpack_require__(34795);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/launchdarkly/dist/esm/constants.js
// Those are the clientId from cross-functional team (Funnels). For more info, see: https://creditandfinance.atlassian.net/wiki/spaces/engineering/pages/1074692778/LaunchDarkly+implementation+guideline#Environment-%26-project
var LAUNCH_DARKLY_XF_PRODUCTION_CLIENT_SIDE_ID = '5e5486f5f434d50824ef46b0';
var LAUNCH_DARKLY_XF_PREPRODUCTION_CLIENT_SIDE_ID = '61d4cd637fe8d014e78814fa';
var LAUNCH_DARKLY_XF_STAGING_CLIENT_SIDE_ID = '5e5486f5f434d50824ef46af';
var LAUNCH_DARKLY_XF_DEVELOPMENT_CLIENT_SIDE_ID = '5e54875ff434d50824ef46b6';
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/launchdarkly/dist/esm/utils/getClientId/index.js


var getClientId_getClientId = function (environment) {
    switch (environment) {
        case dist_esm/* Environment.Development */.qA.Development:
            return LAUNCH_DARKLY_XF_DEVELOPMENT_CLIENT_SIDE_ID;
        case dist_esm/* Environment.Staging */.qA.Staging:
            return LAUNCH_DARKLY_XF_STAGING_CLIENT_SIDE_ID;
        case dist_esm/* Environment.Preproduction */.qA.Preproduction:
            return LAUNCH_DARKLY_XF_PREPRODUCTION_CLIENT_SIDE_ID;
        case dist_esm/* Environment.Production */.qA.Production:
            return LAUNCH_DARKLY_XF_PRODUCTION_CLIENT_SIDE_ID;
        default:
            return LAUNCH_DARKLY_XF_DEVELOPMENT_CLIENT_SIDE_ID;
    }
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/launchdarkly/dist/esm/LDProvider/index.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





var LendiLDConsumer = function (_a) {
    // const environment = getEnvironment(); // TODO: A better way to get `type` is to use the `getEnvironment()` method from Acquire team. But they've kept it to themselves in `@lendi/lala-callback-app/src/getEnvironment.ts`. We'll use session's environment for now, but in the futurue ideally we should get it from `getEnvironment()`;
    // const type = getTypeFromHostname(); // TODO: A better way to get `type` is to use the `getTypeFromHostname()` method from Acquire team. But they've kept it to themselves in `@lendi/lala-callback-app/src/getTypeFromHostname.ts`. We'll use session's type for now, but in the futurue ideally we should get it from `getTypeFromHostname()`;
    var children = _a.children, clientId = _a.clientId;
    var _b = (0,esm/* useSession */.kP)(), identity = _b.identity, type = _b.type, _c = _b.brand, brand = _c === void 0 ? (0,dist_esm/* getBrandFromHostname */.Y6)() : _c;
    var isTeamView = type === esm/* Type.Team */.Dy.Team;
    var custom = { isTeamView: isTeamView, brand: brand };
    var ldClient = (0,lib.useLDClient)();
    react.useEffect(function () {
        if (ldClient) {
            if (identity) {
                ldClient.identify({ key: identity.id, custom: custom });
            }
            else {
                ldClient.identify({ anonymous: true, custom: custom }); // TODO: Funnels 1 uses a magic method to track anonymous user. Consider implementing it here. Docs: https://docs.launchdarkly.com/sdk/client-side/javascript#anonymous-users
            }
        }
        else {
            // Do nothing
        }
    }, [ldClient, identity]);
    return react.createElement(react.Fragment, null, children);
};
/**
 * LendiLDProvider
 *
 * This Provider utilzes the session from `@lendi/lala-react` to identify user to LaunchDarkly platform. It'll work for app behind authentication. (Qualis, Submissions)
 *
 * @param clientId In case application wish to provide a custom clientId
 * @param children
 * @constructor
 */
function LDProvider_LendiLDProvider(_a) {
    var children = _a.children, clientId = _a.clientId;
    var _b = (0,esm/* useSession */.kP)().environment /* Use `environment` from `session` if available, otherwise default to Development */, environment = _b === void 0 ? esm/* Environment.Development */.qA.Development : _b /* Use `environment` from `session` if available, otherwise default to Development */;
    var launchdarklyClientId = clientId || getClientId_getClientId(environment);
    var options = {}; // TODO: Set Options
    var reactOptions = {}; // TODO: Set React Options
    return (react.createElement(lib.LDProvider, { clientSideID: launchdarklyClientId, options: options, reactOptions: reactOptions },
        react.createElement(LendiLDConsumer, null, children)));
}
var withLendiLDProvider = function (Component) {
    return function (_a) {
        var clientId = _a.clientId, props = __rest(_a, ["clientId"]);
        var environment = useSession().environment;
        if (!environment) {
            return null;
        }
        return (React.createElement(LDProvider, { clientSideID: clientId || getClientId(environment) },
            React.createElement(LendiLDConsumer, null,
                React.createElement(Component, __assign({}, props)))));
    };
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/analytics/lib/esm/ClientLendiAnalytics.js
var ClientLendiAnalytics = __webpack_require__(99036);
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/analytics/lib/esm/events/common.js
var common = __webpack_require__(32126);
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/dist/esm/analytics/types.js
var types = __webpack_require__(72239);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/hooks/useEmailOpenChat.js
var useEmailOpenChat_assign = (undefined && undefined.__assign) || function () {
    useEmailOpenChat_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return useEmailOpenChat_assign.apply(this, arguments);
};



var analytics = function (navbarAnalyticsEvent) {
    if (window && window.analytics) {
        (0,ClientLendiAnalytics/* trackEvent */.L9)(useEmailOpenChat_assign({}, navbarAnalyticsEvent));
    }
    else {
        if (false) {}
        else {
            // eslint-disable-next-line no-console
            console.error('@lendi/analytics is not loaded');
        }
    }
};
var useEmailOpenChat = function (openChatWindow, channelId) {
    var hasWindow = typeof window !== 'undefined';
    react.useEffect(function () {
        if (hasWindow) {
            var queryData = new URLSearchParams(window.location.search);
            var shouldOpenChatWindow = queryData.get('openChatWindow');
            if (shouldOpenChatWindow) {
                openChatWindow();
                var event_1 = {
                    event_name: types/* ChatEventName.CHAT_OPENED_FROM_EXTERNAL */.Y.CHAT_OPENED_FROM_EXTERNAL,
                    text: 'Chat Opened From Email',
                    linkType: 'Opened From Email',
                    category: common/* EventCategory.NAVBAR */.Jk.NAVBAR,
                };
                analytics(event_1);
            }
        }
    }, []);
};
//# sourceMappingURL=useEmailOpenChat.js.map
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/axios.js + 42 modules
var axios = __webpack_require__(8940);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/apis/getTeamMember/index.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * activateUserGroupForCustomer will make an API call to `chat-service` to retrieve all necessary information
 *
 * userGroupHash: The userGroupHash, which represents Twilio Chat Channel
 * teamMembers?: Array of team member for this user group
 *
 * @param apiBaseUrl
 * @param lendiAuthToken         User's lendiAuthToken
 * @param teamMemberId           TeamMember's ID
 */

var getTeamMember = function (apiBaseUrl, lendiAuthToken, teamMemberId) { return __awaiter(void 0, void 0, void 0, function () {
    var requestUrl, config, _a, status, data, teamMember;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                requestUrl = "".concat(apiBaseUrl, "/v1/team-member/").concat(teamMemberId);
                config = {
                    apiBaseUrl: apiBaseUrl,
                    headers: {
                        Authorization: "Bearer ".concat(lendiAuthToken),
                        'Content-Type': 'application/json',
                    },
                };
                return [4 /*yield*/, axios/* default.get */.Z.get(requestUrl, config)];
            case 1:
                _a = _b.sent(), status = _a.status, data = _a.data;
                if (status === 200) {
                    teamMember = data.data;
                    if (!teamMember) {
                        throw new Error('getTeamMember: data is null. (Likely inconsistent response from team-member-service)');
                    }
                    return [2 /*return*/, teamMember];
                }
                else {
                    throw new Error("getTeamMember: failed to call team-member endpoint");
                }
                return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/hooks/useCustomerOwner.js
var useCustomerOwner_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useCustomerOwner_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var useCustomerOwner = function (session, ownerId, onException) {
    var _a = react.useState(undefined), owner = _a[0], setOwner = _a[1];
    var apiBaseUrl = (0,dist_esm/* getAPIBaseURL */.K0)(session.environment);
    react.useEffect(function () {
        var getTeamMemberDetails = function (lendiAuthToken, ownerId) { return useCustomerOwner_awaiter(void 0, void 0, void 0, function () {
            var owner_1, error_1, e;
            return useCustomerOwner_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getTeamMember(apiBaseUrl, lendiAuthToken, ownerId)];
                    case 1:
                        owner_1 = (_a.sent());
                        setOwner(owner_1);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        e = new Error("@lendi/chat: unable to fetch owner: ".concat(error_1));
                        onException ? onException(e) : console.error(e);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (session.token && ownerId) {
            getTeamMemberDetails(session.token, ownerId);
        }
    }, [session, ownerId]);
    return owner;
};
//# sourceMappingURL=useCustomerOwner.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/hooks/useTeamMember.js
var useTeamMember_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useTeamMember_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var useTeamMember = function (session, teamMemberId, onException) {
    var _a = react.useState(undefined), teamMember = _a[0], setTeamMember = _a[1];
    var apiBaseUrl = (0,dist_esm/* getAPIBaseURL */.K0)(session.environment);
    react.useEffect(function () {
        var getTeamMemberDetails = function (lendiAuthToken, teamMemberId) { return useTeamMember_awaiter(void 0, void 0, void 0, function () {
            var teamMember_1, error_1, e;
            return useTeamMember_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getTeamMember(apiBaseUrl, lendiAuthToken, teamMemberId)];
                    case 1:
                        teamMember_1 = (_a.sent());
                        setTeamMember(teamMember_1);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        e = new Error("@lendi/commpanel: unable to fetch team member: ".concat(error_1));
                        onException ? onException(e) : console.error(e);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (session.token && teamMemberId) {
            getTeamMemberDetails(session.token, teamMemberId);
        }
    }, [session, teamMemberId]);
    return teamMember;
};
//# sourceMappingURL=useTeamMember.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/apis/getUserGroupDetails/polling.js
var polling_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var polling_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Inspiration: https://davidwalsh.name/javascript-polling - just write TS version.
function asyncPoll(fn, pollInterval, pollTimeout) {
    if (pollInterval === void 0) { pollInterval = 1000; }
    if (pollTimeout === void 0) { pollTimeout = 20 * 1000; }
    return polling_awaiter(this, void 0, void 0, function () {
        var endTime, checkCondition;
        return polling_generator(this, function (_a) {
            endTime = new Date().getTime() + pollTimeout;
            checkCondition = function (resolve, reject) {
                fn()
                    .then(function (data) {
                    // If the condition is met, we're done!
                    resolve(data);
                })
                    .catch(function (e) {
                    // If the condition isn't met but the timeout hasn't elapsed, go again
                    if (Number(Date.now()) < endTime) {
                        setTimeout(function () {
                            checkCondition(resolve, reject);
                        }, pollInterval);
                    }
                    else {
                        reject(new Error('Timed out, please try again'));
                    }
                });
            };
            return [2 /*return*/, new Promise(checkCondition)];
        });
    });
}
//# sourceMappingURL=polling.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/apis/getUserGroupDetails/index.js
var getUserGroupDetails_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var getUserGroupDetails_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var getUserGroupDetails = function (type, apiBaseurl, lendiAuthToken, applicationId, customerId, enableHistoricalThreads) { return getUserGroupDetails_awaiter(void 0, void 0, void 0, function () {
    var requestURL;
    return getUserGroupDetails_generator(this, function (_a) {
        // chat 3.2
        if (enableHistoricalThreads) {
            requestURL = "".concat(apiBaseurl, "/v2/chat/application/").concat(applicationId, "/thread");
        }
        else {
            // chat 3.0 can be removed after release of Chat 3.2
            requestURL = applicationId
                ? "".concat(apiBaseurl, "/v2/chat/user-group?applicationId=").concat(applicationId)
                : type === 'customer'
                    ? "".concat(apiBaseurl, "/v2/chat/user-group")
                    : "".concat(apiBaseurl, "/v2/chat/user-group?customerId=").concat(customerId);
        }
        return [2 /*return*/, getUserGroupRequest(type, lendiAuthToken, requestURL, apiBaseurl)];
    });
}); };
var getUserGroupRequest = function (type, lendiAuthToken, requestURL, apiBaseurl) { return getUserGroupDetails_awaiter(void 0, void 0, void 0, function () {
    var config, userGroupCall;
    return getUserGroupDetails_generator(this, function (_a) {
        config = {
            apiBaseurl: apiBaseurl,
            headers: {
                Authorization: "Bearer ".concat(lendiAuthToken),
                'Content-Type': 'application/json',
            },
        };
        userGroupCall = function () { return getUserGroupDetails_awaiter(void 0, void 0, void 0, function () {
            var _a, status_1, data, _b, userGroupHash, teamMembers, migratedToConversation, agentsRemoved, err_1;
            return getUserGroupDetails_generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios/* default.get */.Z.get(requestURL, config)];
                    case 1:
                        _a = _c.sent(), status_1 = _a.status, data = _a.data;
                        if (status_1 === 200) {
                            _b = data.data, userGroupHash = _b.userGroupHash, teamMembers = _b.teamMembers, migratedToConversation = _b.migratedToConversation, agentsRemoved = _b.agentsRemoved;
                            return [2 /*return*/, Promise.resolve({
                                    userGroupHash: userGroupHash,
                                    teamMembers: teamMembers,
                                    migratedToConversation: migratedToConversation,
                                    agentsRemoved: agentsRemoved,
                                })];
                        }
                        else if (status_1 === 401) {
                            return [2 /*return*/, null];
                        }
                        else {
                            throw new Error("getUserGroup: get user-group endpoint error");
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _c.sent();
                        return [2 /*return*/, Promise.reject(err_1)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (type === 'broker') {
            return [2 /*return*/, userGroupCall()];
        }
        else {
            return [2 /*return*/, asyncPoll(function () { return getUserGroupDetails_awaiter(void 0, void 0, void 0, function () {
                    return getUserGroupDetails_generator(this, function (_a) {
                        return [2 /*return*/, userGroupCall()];
                    });
                }); }, 1000, // interval - 1 sec
                20000 // timeout - 20 sec
                )];
        }
        return [2 /*return*/];
    });
}); };
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/apis/migrateChannel/index.js
var migrateChannel_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var migrateChannel_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var migrateChannel = function (apiBaseurl, token, userGroupHash) { return migrateChannel_awaiter(void 0, void 0, void 0, function () {
    var requestURL, config;
    return migrateChannel_generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                requestURL = "/v2/chat/user-group/".concat(userGroupHash, "/migrate-to-conversations");
                config = {
                    baseURL: apiBaseurl,
                    headers: {
                        Authorization: "Bearer ".concat(token),
                        'Content-Type': 'application/json',
                    },
                };
                return [4 /*yield*/, axios/* default.post */.Z.post(requestURL, {}, config)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/hooks/useDisableChat/index.js




var useDisableChat = function () {
    var _a = (0,react.useState)(true), isChatDisabled = _a[0], setIsChatDisabled = _a[1];
    var _b = (0,lib.useFlags)(), disableChat = _b.disableChat, enableAussieChat = _b.enableAussieChat;
    var brand = (0,esm/* useSession */.kP)().brand;
    (0,react.useEffect)(function () {
        if (brand === dist_esm/* Brand.Aussie */.H2.Aussie) {
            if (enableAussieChat !== undefined)
                setIsChatDisabled(!enableAussieChat);
        }
        else {
            if (disableChat !== undefined)
                setIsChatDisabled(disableChat);
        }
    }, [disableChat, enableAussieChat, brand]);
    return isChatDisabled;
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/hooks/useUserGroup.js
var useUserGroup_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useUserGroup_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var useUserGroup_useUserGroup = function (userType, session, onException, customerInfo, applicationId) {
    var _a = (0,react.useState)(undefined), selectedThread = _a[0], setSelectedThread = _a[1];
    var _b = (0,react.useState)(undefined), userGroupHash = _b[0], setUserGroupHash = _b[1];
    var _c = (0,react.useState)(undefined), teamMemberId = _c[0], setTeamMemberId = _c[1];
    var _d = (0,react.useState)(undefined), channelMigrated = _d[0], setChannelMigrated = _d[1];
    var _e = (0,react.useState)(false), meAsBrokerMemberOfChannel = _e[0], setMeAsBrokerMemberOfChannel = _e[1];
    var apiBaseUrl = (0,dist_esm/* getAPIBaseURL */.K0)(session.environment);
    var isChatDisabled = useDisableChat();
    var enableHistoricalThreads = (0,lib.useFlags)().enableHistoricalThreads;
    var _f = (0,react.useState)(undefined), err = _f[0], setError = _f[1];
    (0,react.useEffect)(function () {
        var _a, _b;
        var getUserGroup = function (lendiAuthToken) { return useUserGroup_awaiter(void 0, void 0, void 0, function () {
            var response, userGroupHash_1, _a, teamMembers, migratedToConversation, _b, agentsRemoved, lastTeamMember, error_1, e;
            return useUserGroup_generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getUserGroupDetails(userType, apiBaseUrl, lendiAuthToken, applicationId, customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.customerId, enableHistoricalThreads)];
                    case 1:
                        response = _c.sent();
                        if (response) {
                            userGroupHash_1 = response.userGroupHash, _a = response.teamMembers, teamMembers = _a === void 0 ? [] : _a, migratedToConversation = response.migratedToConversation, _b = response.agentsRemoved, agentsRemoved = _b === void 0 ? false : _b;
                            setUserGroupHash(userGroupHash_1);
                            setChannelMigrated(migratedToConversation);
                            !agentsRemoved &&
                                setMeAsBrokerMemberOfChannel(teamMembers.findIndex(function (tm) { var _a; return tm.userId === ((_a = session.identity) === null || _a === void 0 ? void 0 : _a.id); }) !== -1);
                            if (teamMembers.length > 0) {
                                lastTeamMember = teamMembers[teamMembers.length - 1];
                                setTeamMemberId(lastTeamMember.userId);
                            }
                        }
                        else {
                            setUserGroupHash(undefined);
                            session.logout();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _c.sent();
                        e = new Error("@lendi/chat: useUserGroupForCustomer: unable to fetch userGroup: ".concat(error_1));
                        setError(e);
                        onException ? onException(e) : console.error(e);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (!isChatDisabled) {
            if (session.status !== esm/* Status.Authenticated */.qb.Authenticated) {
                setUserGroupHash(undefined);
            }
            if (selectedThread) {
                setUserGroupHash(selectedThread.userGroupHash);
                if (selectedThread.teamMemberIds.length > 0) {
                    setTeamMemberId(selectedThread.teamMemberIds[selectedThread.teamMemberIds.length - 1]);
                }
                setChannelMigrated(selectedThread.isMigrated);
                setMeAsBrokerMemberOfChannel(selectedThread.teamMemberIds.includes((_b = (_a = session.identity) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : ''));
            }
            else if (session.token) {
                if (enableHistoricalThreads && !applicationId) {
                    setUserGroupHash(undefined);
                }
                else {
                    getUserGroup(session.token);
                }
            }
        }
    }, [session.status, isChatDisabled, selectedThread, enableHistoricalThreads]);
    (0,react.useEffect)(function () {
        var onDemandMigrateChannel = function () { return useUserGroup_awaiter(void 0, void 0, void 0, function () {
            var _error_1;
            return useUserGroup_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(channelMigrated === false && session.token && userGroupHash)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, migrateChannel(apiBaseUrl, session.token, userGroupHash)];
                    case 2:
                        _a.sent();
                        setChannelMigrated(true);
                        return [3 /*break*/, 4];
                    case 3:
                        _error_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        onDemandMigrateChannel();
    }, [userGroupHash, channelMigrated]);
    return {
        userGroupHash: userGroupHash,
        teamMemberId: teamMemberId,
        channelMigrated: channelMigrated,
        meAsBrokerMemberOfChannel: meAsBrokerMemberOfChannel,
        setSelectedThread: function (thread) { return setSelectedThread(thread); },
        err: err,
    };
};
//# sourceMappingURL=useUserGroup.js.map
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/dist/esm/utils/index.js
var utils = __webpack_require__(10212);
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/dist/esm/providers/ChatBootstrapperProvider/context.js
var context = __webpack_require__(71771);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/hooks/useCustomer.js
var useCustomer_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var useCustomer_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var useCustomer = function (session, onException) {
    var _a = (0,react.useState)(undefined), customer = _a[0], setCustomer = _a[1];
    var apiBaseUrl = (0,dist_esm/* getAPIBaseURL */.K0)(session.environment);
    (0,react.useEffect)(function () {
        var getCustomerDetails = function (token) { return useCustomer_awaiter(void 0, void 0, void 0, function () {
            var requestUrl, config, customer_1, error_1, e;
            return useCustomer_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        requestUrl = "".concat(apiBaseUrl, "/v1/customers/me");
                        config = {
                            apiBaseUrl: apiBaseUrl,
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                'Content-Type': 'application/json',
                            },
                        };
                        return [4 /*yield*/, axios/* default.get */.Z.get(requestUrl, config).then(function (res) { return res.data.data; })];
                    case 1:
                        customer_1 = _a.sent();
                        setCustomer(customer_1);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        e = new Error("@lendi/chat: unable to fetch customer: ".concat(error_1));
                        onException ? onException(e) : console.error(e);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        (function () { return useCustomer_awaiter(void 0, void 0, void 0, function () {
            return useCustomer_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getCustomerDetails(session.token)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [session]);
    return customer;
};
//# sourceMappingURL=useCustomer.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/dist/esm/providers/ChatBootstrapperProvider/provider.js
var provider_assign = (undefined && undefined.__assign) || function () {
    provider_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return provider_assign.apply(this, arguments);
};











var CustomerChatBootstrapperProviderInner = function (_a) {
    var children = _a.children, broker = _a.broker, store = _a.store, onException = _a.onException, applicationId = _a.applicationId;
    var enableHistoricalThreads = (0,lib.useFlags)().enableHistoricalThreads;
    var inputApplicationId = enableHistoricalThreads && (applicationId || (0,utils/* checkApplicationScope */.Zd)());
    var _b = (0,react.useState)(false), isCommPanelOpen = _b[0], setCommPanelOpen = _b[1];
    var _c = (0,react.useState)(false), isChatOpen = _c[0], setChatOpen = _c[1];
    var openCommPanel = function () {
        setCommPanelOpen(true);
    };
    var closeCommPanel = function () {
        setCommPanelOpen(false);
    };
    var openChat = function () {
        openCommPanel();
        setChatOpen(true);
    };
    var closeChat = function () {
        setChatOpen(false);
    };
    var session = (0,esm/* useSession */.kP)();
    var _d = useUserGroup_useUserGroup('customer', session, onException, undefined, inputApplicationId), channelId = _d.userGroupHash, teamMemberId = _d.teamMemberId, migratedToConversation = _d.channelMigrated, setSelectedThread = _d.setSelectedThread, err = _d.err;
    // get customer details to get owner
    var customer = useCustomer(session, onException);
    var customerOwner = useCustomerOwner(session, customer === null || customer === void 0 ? void 0 : customer.ownerId, onException);
    var teamMemberFromChannel = useTeamMember(session, teamMemberId, onException);
    useEmailOpenChat(openChat, channelId);
    return (react.createElement(context/* ChatBootstrapperContext.Provider */.h.Provider, { value: {
            isCommPanelOpen: isCommPanelOpen,
            openCommPanel: openCommPanel,
            closeCommPanel: closeCommPanel,
            isChatOpen: isChatOpen,
            openChat: openChat,
            closeChat: closeChat,
            teamMember: teamMemberFromChannel,
            customerOwner: customerOwner,
            broker: broker,
            store: store,
            channelId: channelId,
            migratedToConversation: migratedToConversation,
            setSelectedThread: setSelectedThread,
            applicationId: inputApplicationId,
            errorState: err,
        } }, children));
};
var TeamsChatBootstrapperProviderInner = function (_a) {
    var children = _a.children, onException = _a.onException, customerInfo = _a.customerInfo, applicationId = _a.applicationId;
    var restrictedTeamViewEnabled = useFlags().restrictedTeamViewEnabled;
    var _b = useState(false), isCommPanelOpen = _b[0], setCommPanelOpen = _b[1];
    var _c = useState(false), isChatOpen = _c[0], setChatOpen = _c[1];
    var openCommPanel = function () {
        setCommPanelOpen(true);
    };
    var closeCommPanel = function () {
        setCommPanelOpen(false);
    };
    var openChat = function () {
        openCommPanel();
        setChatOpen(true);
    };
    var closeChat = function () {
        setChatOpen(false);
    };
    var session = useSession();
    var _d = useUserGroup('broker', session, onException, customerInfo, applicationId), channelId = _d.userGroupHash, migratedToConversation = _d.channelMigrated, meAsBrokerMemberOfChannel = _d.meAsBrokerMemberOfChannel, setSelectedThread = _d.setSelectedThread, err = _d.err;
    return (React.createElement(ChatBootstrapperContext.Provider, { value: {
            openChat: openChat,
            closeChat: closeChat,
            isChatOpen: isChatOpen,
            isCommPanelOpen: isCommPanelOpen,
            openCommPanel: openCommPanel,
            closeCommPanel: closeCommPanel,
            channelId: channelId,
            migratedToConversation: migratedToConversation,
            setSelectedThread: setSelectedThread,
            applicationId: applicationId,
            errorState: err,
        } },
        React.createElement(RestrictedTeamViewProvider, { viewEnabled: restrictedTeamViewEnabled, meAsBrokerMemberOfChannel: meAsBrokerMemberOfChannel, channelId: channelId, onException: onException }, children)));
};
// TODO: Merge CustomerChatBootstrapperProvider and TeamsChatBootstrapperProvider into one
var CustomerChatBootstrapperProvider = function (props) {
    return (react.createElement(LDProvider_LendiLDProvider, null,
        react.createElement(CustomerChatBootstrapperProviderInner, provider_assign({}, props))));
};
// TODO: Merge CustomerChatBootstrapperProvider and TeamsChatBootstrapperProvider into one
var TeamsChatBootstrapperProvider = function (props) { return (React.createElement(LendiLDProvider, null,
    React.createElement(TeamsChatBootstrapperProviderInner, provider_assign({}, props)))); };
//# sourceMappingURL=provider.js.map

/***/ }),

/***/ 12818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BT": function() { return /* binding */ PRIVACY_POLICY_TEXT; },
/* harmony export */   "DX": function() { return /* binding */ BOT_FIRSTNAME_DOMAIN; },
/* harmony export */   "Oh": function() { return /* binding */ BOT_FIRSTNAME_AUSSIE; },
/* harmony export */   "Zo": function() { return /* binding */ BOT_IDENTITY; },
/* harmony export */   "_3": function() { return /* binding */ PRIVACY_POLICY_LINK_AUSSIE; },
/* harmony export */   "dt": function() { return /* binding */ BOT_FIRSTNAME_LENDI; },
/* harmony export */   "r6": function() { return /* binding */ PRIVACY_POLICY_LINK_LENDI; }
/* harmony export */ });
var BOT_IDENTITY = 'lendi_bot';
var PRIVACY_POLICY_TEXT = 'Privacy Policy';
var BOT_FIRSTNAME_LENDI = 'Lendi';
var BOT_FIRSTNAME_DOMAIN = 'Domain Home Loans';
var BOT_FIRSTNAME_AUSSIE = 'Aussie';
var PRIVACY_POLICY_LINK_LENDI = 'https://www.lendi.com.au/about-us/privacy-policy/';
var PRIVACY_POLICY_LINK_AUSSIE = 'https://www.aussie.com.au/about-us/privacy/';
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ 10212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lv": function() { return /* binding */ getFirstNameForBrand; },
/* harmony export */   "Zd": function() { return /* binding */ checkApplicationScope; },
/* harmony export */   "uC": function() { return /* binding */ getPrivacyPolicyLink; }
/* harmony export */ });
/* unused harmony export isDomain */
/* harmony import */ var _lendi_lala_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34795);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12818);


var isDomain = (0,_lendi_lala_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBrandFromHostname */ .Y6)() === _lendi_lala_utils__WEBPACK_IMPORTED_MODULE_0__/* .Brand.Domain */ .H2.Domain;
var getPrivacyPolicyLink = function (brand) {
    switch (brand) {
        case _lendi_lala_utils__WEBPACK_IMPORTED_MODULE_0__/* .Brand.Aussie */ .H2.Aussie:
            return _constants__WEBPACK_IMPORTED_MODULE_1__/* .PRIVACY_POLICY_LINK_AUSSIE */ ._3;
        case _lendi_lala_utils__WEBPACK_IMPORTED_MODULE_0__/* .Brand.Lendi */ .H2.Lendi:
        default:
            return _constants__WEBPACK_IMPORTED_MODULE_1__/* .PRIVACY_POLICY_LINK_LENDI */ .r6;
    }
};
var getFirstNameForBrand = function () {
    var brand = (0,_lendi_lala_utils__WEBPACK_IMPORTED_MODULE_0__/* .getBrandFromHostname */ .Y6)();
    switch (brand) {
        case _lendi_lala_utils__WEBPACK_IMPORTED_MODULE_0__/* .Brand.Aussie */ .H2.Aussie:
            return _constants__WEBPACK_IMPORTED_MODULE_1__/* .BOT_FIRSTNAME_AUSSIE */ .Oh;
        case _lendi_lala_utils__WEBPACK_IMPORTED_MODULE_0__/* .Brand.Domain */ .H2.Domain:
            return _constants__WEBPACK_IMPORTED_MODULE_1__/* .BOT_FIRSTNAME_DOMAIN */ .DX;
        case _lendi_lala_utils__WEBPACK_IMPORTED_MODULE_0__/* .Brand.Lendi */ .H2.Lendi:
        default:
            return _constants__WEBPACK_IMPORTED_MODULE_1__/* .BOT_FIRSTNAME_LENDI */ .dt;
    }
};
// this check the application scoped and return applicationId if there is an application else undefined
function checkApplicationScope() {
    var pathNameArray = window.location.pathname.split('/');
    var indexOfApplicationId = pathNameArray.indexOf('application') + 1;
    var urlParamApplicationId = indexOfApplicationId && pathNameArray[indexOfApplicationId];
    return urlParamApplicationId;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 99036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L9": function() { return /* binding */ trackEvent; }
/* harmony export */ });
/* unused harmony exports identify, trackPage */
/* harmony import */ var _analytics_segment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15068);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70303);
/* provided dependency */ var process = __webpack_require__(13158);
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


let analyticsInstance;
const getAnalyticsInstance = (callback) => {
    if (analyticsInstance) {
        return analyticsInstance;
    }
    if (typeof window !== 'undefined') {
        const writeKey = getWriteKey();
        if (!writeKey) {
            const error = new Error(`@lendi/analytics: segment write id is not given, so we can't track your events.`);
            // eslint-disable-next-line no-console
            callback ? callback(error) : console.error(error);
        }
        const config = {
            flushAt: +(process.env.LENDI_ANALYTICS_FLUSH_AT || 0),
            flushInterval: +(process.env.LENDI_ANALYTICS_FLUSH_INTERVAL || 0),
            enable: process.env.LENDI_ANALYTICS_ENABLE !== 'true',
            debug: process.env.LENDI_ANALYTICS_DEBUG === 'true',
        };
        analyticsInstance = (0,analytics__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
            debug: config.debug,
            plugins: [
                (0,_analytics_segment__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(Object.assign({ writeKey }, config)),
            ],
        });
        return analyticsInstance;
    }
};
/**
 * @deprecated We do not encourage to this method anymore so start using to LendiAnalyticsV2 from the same package by upgrading
 */
const identify = (userId, traits, options, callback) => {
    return getAnalyticsInstance(callback).identify(userId, traits, options);
};
/**
 * @deprecated We do not encourage to this method anymore so start using to LendiAnalyticsV2 from the same package by upgrading
 */
const trackPage = (category, name, callback) => {
    return getAnalyticsInstance(callback).page({
        category,
        name,
    });
};
/**
 * @deprecated We do not encourage to this method anymore so start using to LendiAnalyticsV2 from the same package by upgrading
 */
const trackEvent = (trackingEvent, options, callback) => {
    const { event_name } = trackingEvent, payload = __rest(trackingEvent, ["event_name"]);
    if (typeof window !== 'undefined') {
        payload.path = location.href.replace(location.origin, '');
    }
    return getAnalyticsInstance(callback).track(event_name, payload, options);
};
const getWriteKey = () => {
    const hostname = window.location.hostname;
    if (hostname.indexOf('aussie') !== -1) {
        return process.env.REACT_APP_AUSSIE_SEGMENT_ID || "DG28VL1bGGGxzPCmafNbGoTkBJzGh0HH";
    }
    else if (hostname.indexOf('domain') !== -1 || hostname.indexOf('dlf') !== -1) {
        return process.env.REACT_APP_DLF_SEGMENT_ID;
    }
    else {
        return (process.env.REACT_APP_SEGMENT_ID || "PFkvq4uKElRVl2KtYPdHDpN2Up9isSYY" || 0);
    }
};
//# sourceMappingURL=ClientLendiAnalytics.js.map

/***/ }),

/***/ 32126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jk": function() { return /* binding */ EventCategory; },
/* harmony export */   "y_": function() { return /* binding */ AuthenticationStatus; }
/* harmony export */ });
/* unused harmony export CustomerType */
var CustomerType;
(function (CustomerType) {
    CustomerType["CUSTOMER"] = "Customer";
    CustomerType["TEAM"] = "Team";
})(CustomerType || (CustomerType = {}));
var AuthenticationStatus;
(function (AuthenticationStatus) {
    AuthenticationStatus["AUTHENTICATED"] = "Authenticated";
    AuthenticationStatus["UNAUTHENTICATED"] = "Unauthenticated";
})(AuthenticationStatus || (AuthenticationStatus = {}));
var EventCategory;
(function (EventCategory) {
    EventCategory["APPLICATION_SUMMARY"] = "Application Summary";
    EventCategory["APPLICATION"] = "Application";
    EventCategory["APPROVAL_CONFIDENCE"] = "Approval Confidence";
    EventCategory["AUTH"] = "Auth";
    EventCategory["BOOK_APPOINTMENT"] = "Book Appointment";
    EventCategory["CASH_OUT"] = "Cash Out";
    EventCategory["CHAT"] = "Chat";
    EventCategory["CHOOSE_YOUR_LOAN"] = "Choose Your Loan";
    EventCategory["COMMSPANEL"] = "CommsPanel";
    EventCategory["CREDIT_GUIDE"] = "Credit Guide";
    EventCategory["CREDIT_PROPOSAL"] = "Credit Proposal";
    EventCategory["CUSTOMER"] = "Customer";
    EventCategory["DASHBOARD"] = "Dashboard";
    EventCategory["ERROR_PAGES"] = "Error Pages";
    EventCategory["FOOTER"] = "Footer";
    EventCategory["FUNDING_POSITION"] = "Funding Position";
    EventCategory["FREE_FORM_FUNDING_POSITION"] = "Free Form Funding Position";
    EventCategory["INITIAL_FUNDING_POSITION"] = "Initial Funding Position";
    EventCategory["FUNNELS"] = "Funnels";
    EventCategory["INSPIRE_BLOG"] = "Inspire Blog";
    EventCategory["JAM_LANDING_PAGES"] = "Jam Landing Pages";
    EventCategory["NAVBAR"] = "Navbar";
    EventCategory["NOTES"] = "Notes";
    EventCategory["NOTIFICATION"] = "Notification";
    EventCategory["PACKAGE_COMPARISON"] = "Package Comparison";
    EventCategory["PRODUCT_SEARCH"] = "Product Search";
    EventCategory["PROPERTY_REPORT"] = "Property Report";
    EventCategory["REQUIRED_ACTIONS"] = "Required Actions";
    EventCategory["REQUIRED_DOCUMENTS"] = "Required Documents";
    EventCategory["SAFETYNET_CTP"] = "Safetynet CTP";
    EventCategory["SAVINGS_CALCULATOR"] = "Savings Calculator";
    EventCategory["FREE_FORM_SAVINGS_CALCULATOR"] = "Free Form Savings Calculator";
    EventCategory["STAMP_DUTY_CALCULATOR"] = "Stamp Duty Calculator";
    EventCategory["CMS"] = "CMS";
    EventCategory["POSTCODE"] = "Customer Suburb";
    EventCategory["EMAIL_VERIFICATION"] = "email-verification";
    EventCategory["ACCOUNT_LINKING"] = "account-linking";
    EventCategory["SMS_SENDER"] = "SMS Sender";
    EventCategory["FIXED_RATE_EXPIRY_CALCULATOR"] = "Fixed Rate Expiry Calculator";
    EventCategory["TEAM_VIEW_NAV_V2"] = "Team Nav v2";
})(EventCategory || (EventCategory = {}));
//# sourceMappingURL=common.js.map

/***/ }),

/***/ 34795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H2": function() { return /* reexport */ Brand_Brand; },
  "qA": function() { return /* reexport */ Environment_Environment; },
  "K0": function() { return /* reexport */ getAPIBaseURL; },
  "Y6": function() { return /* reexport */ getBrandFromHostname; }
});

// UNUSED EXPORTS: AuthError, BYPASS_POSTCODE, BlockedUser, CUSTOMER_REFERRAL_CODE, EMPTY_RETURNURL, ErrorCodes, ErrorMessages, GenericError, IDENTITY_TOKEN_AUTH_ID_KEY, IDENTITY_TOKEN_CONNECTION_KEY, IDENTITY_TOKEN_EXISTING_KEY, IDENTITY_TOKEN_PROFILE_KEY, IDENTITY_TOKEN_ROLE_KEY, IDENTITY_TOKEN_USER_ID_KEY, InvalidCountry, LG_APP_AUTH_SESSION_COOKIE_NAME, LOCAL_STORAGE_KEYS, LalaSentry, LegacyAuthMeError, NoAccessToken, NoExpiry, NoIdentityToken, NumberNotWorking, PRL_BROKER_ID, PRL_STORE_ID, ParseStateError, PopupClosedError, RETURNURL_STORAGE_KEY, SAFETY_NET_COOKIE_NAME, SESSION_STORAGE_KEYS, SMSGatewayError, SSOAccountMerge, STATE_STORAGE_KEY, STATE_STORAGE_VERSION, SsoVerifyGeneric, TooManyAttempts, Type, WrongCode, executeReturnURL, getAudience, getClientID, getDomain, getEnv, getReturnURLFromLALAURLQueries, getReturnURLFromQuery, getReturnURLFromStorage, getStateFromAuthResult, getStateFromStorage, getTypeFromHostname, getURLs, isAuthenticatedState, isUnauthenticatedState, matchAuth0ErrorToLALAAuthError, matchPatterns, parseAuthError, parseStorageError, setReturnURLInStorage, setStateInStorage, shorternReturnURL, validateReturnURL, validateReturnURLByMap

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/Brand.js
var Brand_Brand;
(function (Brand) {
    Brand["Lendi"] = "lendi";
    Brand["Domain"] = "domain";
    Brand["Aussie"] = "aussie";
})(Brand_Brand || (Brand_Brand = {}));
//# sourceMappingURL=Brand.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/Type.js
var Type_Type;
(function (Type) {
    Type["Customer"] = "customer";
    Type["Team"] = "team";
})(Type_Type || (Type_Type = {}));
//# sourceMappingURL=Type.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/Environment.js
var Environment_Environment;
(function (Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Preproduction"] = "preproduction";
    Environment["Production"] = "production";
})(Environment_Environment || (Environment_Environment = {}));
var getEnv = function (environment) {
    var env = environment || "production" || 0;
    switch (env) {
        case Environment_Environment.Development:
        case Environment_Environment.Staging:
        case Environment_Environment.Preproduction:
        case Environment_Environment.Production:
            return env;
        default:
            throw new Error("Invalid environment ".concat(env));
    }
};
var getAPIBaseURL = function (env) {
    switch (env) {
        case Environment_Environment.Development:
        default:
            return 'https://api.lendi-dev.net';
        case Environment_Environment.Production:
            return 'https://api.lendi.com.au';
        case Environment_Environment.Preproduction:
            return 'https://api.lendi-preprod.net';
        case Environment_Environment.Staging:
            return 'https://api.lendi-stg.net';
    }
};
//# sourceMappingURL=Environment.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/getTenant.js



function getTenant_getTenant(brand, type, environment) {
    if (type === Type.Team) {
        // lendi-team cause we were too pushed for time to delete the old tenants and create new
        // tenants when we found that team members aren't split by brand
        return "lendi-team-".concat(environment, ".au.auth0.com");
    }
    if (brand === Brand.Domain) {
        return "dlf-".concat(type, "-").concat(environment, ".au.auth0.com");
    }
    if (type === Type.Customer && brand === Brand.Lendi) {
        switch (environment) {
            case Environment.Development:
                return "lala.lendi-dev.net";
            case Environment.Staging:
                return "lala.lendi-stg.net";
            case Environment.Preproduction:
                return "lala.lendi-preprod.net";
            case Environment.Production:
                return "lala.lendi.com.au";
        }
    }
    if (type === Type.Customer && brand === Brand.Aussie) {
        switch (environment) {
            case Environment.Development:
                return "lala.aussie-dev.com.au";
            case Environment.Staging:
                return "lala.aussie-stg.com.au";
            case Environment.Preproduction:
                return "lala.aussie-preprod.com.au";
            case Environment.Production:
                return "lala.aussie.com.au";
        }
    }
    return "".concat(brand, "-").concat(type, "-").concat(environment, ".au.auth0.com");
}
//# sourceMappingURL=getTenant.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/getDomain.js

function getDomain(brand, type, environment) {
    return getTenant(brand, type, environment);
}
//# sourceMappingURL=getDomain.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/getClientID.js



function getClientID(brand, type, environment) {
    if (type === Type.Team) {
        switch (environment) {
            // FIXME: reduce to one team tenant per environment instead of two
            // using `lendi-team-*` for now
            case Environment.Development:
                return 'IdtM2Iu7uhHWQNRMVB6vuaeSo0tRmkXe';
            case Environment.Staging:
                return '7VfZtkRmcNwkL5hLrr2JOz6ID09aQx5S';
            case Environment.Preproduction:
                return 'Q1kDu5GAx4xslZa9yCNg09Iu8KjbTqTb';
            case Environment.Production:
                return 'oVRWqJ9V6BjAKExYQEYHbmbHD9ey4BA7';
        }
    }
    if (brand === Brand.Lendi && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return '02HMKpY3DBWow93s4Liv4hOo7LBy5E0v';
            case Environment.Staging:
                return 'KX2f6VfN8m46kAmo2aeVJ6rp3ZSn8G6V';
            case Environment.Preproduction:
                return 'Wo0q6I3JX2gpgCW2ACNvi1z2Ua3YeLoW';
            case Environment.Production:
                return 'HRuDIzIv8Y0X5XNcCzN6xu0E84VkGS0z';
        }
    }
    if (brand === Brand.Domain && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'sI2IAYsp5Wq7clzrwXf6CJfo5j8MWi2n';
            case Environment.Staging:
                return 'qf5mv1u4KfXJh9lqskxpN3wQAiy137US';
            case Environment.Preproduction:
                return 'ZgMxT6WN70VwXv5FEWdiyK4WvI1iQ14Z';
            case Environment.Production:
                return 'cwbIAhyZQvTube2aIg6A7NkIJonxtMaW';
        }
    }
    if (brand === Brand.Aussie && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'BmMQl2jaxrMHr8S814STOl46RH75Bb5V';
            case Environment.Staging:
                return '8hO4kNgj4ejLlnh5PRooHQt6g0x88Cqe';
            case Environment.Preproduction:
                return 'YA3q6iku85NDdWOfUQXCOeuB0kD3q5qb';
            case Environment.Production:
                return '3Kb8uy7nsTawMVTviFmuBjSCkajs24GE';
        }
    }
    throw new Error("Unable to determine client ID for ".concat(brand, " ").concat(type, " ").concat(environment, "."));
}
//# sourceMappingURL=getClientID.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/getURLs.js

function getBaseURL(brand, type, environment, lendiGroupTeamView) {
    if (typeof window !== 'undefined') {
        switch (window.location.hostname) {
            case 'www.lendi.com.au.local':
            case 'team.lendi.com.au.local':
            case 'dlf.lendi-paas.net.local':
            case 'team.aussie.com.au.local':
                return location.origin;
        }
        if (window.location.hostname && window.location.hostname.indexOf('test.lendi-dev.net') >= 0) {
            return location.origin;
        }
    }
    if (brand === Brand.Lendi && type === Type.Team) {
        switch (environment) {
            case Environment.Development:
                return !lendiGroupTeamView ? 'https://team.lendi-dev.net' : 'https://lendi-team-dev.lendigroup.com.au';
            case Environment.Staging:
                return !lendiGroupTeamView ? 'https://team.lendi-stg.net' : 'https://lendi-team-stg.lendigroup.com.au';
            case Environment.Preproduction:
                return !lendiGroupTeamView ? 'https://team.lendi-preprod.net' : 'https://lendi-team-preprod.lendigroup.com.au';
            case Environment.Production:
                return !lendiGroupTeamView ? 'https://team.lendi.com.au' : 'https://lendi-team.lendigroup.com.au';
        }
    }
    if (brand === Brand.Domain && type === Type.Team) {
        switch (environment) {
            case Environment.Development:
                return 'https://team-dlf.lendi-dev.net';
            case Environment.Staging:
                return 'https://team-dlf.lendi-stg.net';
            case Environment.Preproduction:
                return 'https://team-dlf.lendi-preprod.net';
            case Environment.Production:
                return 'https://team-dlf.lendi.com.au';
        }
    }
    if (brand === Brand.Aussie && type === Type.Team) {
        switch (environment) {
            case Environment.Development:
                return !lendiGroupTeamView ? 'https://team.aussie-dev.com.au' : 'https://aussie-team-dev.lendigroup.com.au';
            case Environment.Staging:
                return !lendiGroupTeamView ? 'https://team.aussie-stg.com.au' : 'https://aussie-team-stg.lendigroup.com.au';
            case Environment.Preproduction:
                return !lendiGroupTeamView
                    ? 'https://team.aussie-preprod.com.au'
                    : 'https://aussie-team-preprod.lendigroup.com.au';
            case Environment.Production:
                return !lendiGroupTeamView ? 'https://team.aussie.com.au' : 'https://aussie-team.lendigroup.com.au';
        }
    }
    if (brand === Brand.Lendi && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'https://www.lendi-dev.net';
            case Environment.Staging:
                return 'https://www.lendi-stg.net';
            case Environment.Preproduction:
                return 'https://www.lendi-preprod.net';
            case Environment.Production:
                return 'https://www.lendi.com.au';
        }
    }
    if (brand === Brand.Domain && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'https://dlf.lendi-paas-dev.net';
            case Environment.Staging:
                return 'https://stage.domain.com.au/loanfinder';
            case Environment.Preproduction:
                return 'https://stage.domain.com.au/loanfinder';
            case Environment.Production:
                return 'https://www.domain.com.au/loanfinder';
        }
    }
    if (brand === Brand.Aussie && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'https://www.aussie-dev.com.au';
            case Environment.Staging:
                return 'https://www.aussie-stg.com.au';
            case Environment.Preproduction:
                return 'https://www.aussie-preprod.com.au';
            case Environment.Production:
                return 'https://www.aussie.com.au';
        }
    }
    throw new Error("Unable to determine URLs for ".concat(brand, " ").concat(type, " ").concat(environment));
}
function getDomainUnauthUrl(environment) {
    switch (environment) {
        case Environment.Development:
            return 'https://dlf.lendi-paas-dev.net/authentications/Logoff?ReturnURL=%2Fhome-loans%2F';
        case Environment.Staging:
        case Environment.Preproduction:
            return 'https://stage.domain.com.au/authentications/Logoff?ReturnURL=%2Fhome-loans%2F';
        case Environment.Production:
            return 'https://www.domain.com.au/authentications/Logoff?ReturnURL=%2Fhome-loans%2F';
        default:
            throw new Error("Unable to determine URLs for Domain in ".concat(environment));
    }
}
function getDomainAuthUrl(environment) {
    switch (environment) {
        case Environment.Development:
            return 'https://dlf.lendi-paas-dev.net/authentications/login';
        case Environment.Staging:
        case Environment.Preproduction:
            return 'https://stage.domain.com.au/authentications/login';
        case Environment.Production:
            return 'https://www.domain.com.au/authentications/login';
        default:
            throw new Error("Unable to determine URLs for Domain in ".concat(environment));
    }
}
function getURLs_getURLs(brand, type, environment, lendiGroupTeamView) {
    if (lendiGroupTeamView === void 0) { lendiGroupTeamView = false; }
    var baseURL = getBaseURL(brand, type, environment, lendiGroupTeamView);
    var unauthBaseURL = brand === Brand.Domain ? getDomainUnauthUrl(environment) : baseURL;
    var authBaseURL = brand === Brand.Domain ? getDomainAuthUrl(environment) : baseURL;
    if (type === Type.Team) {
        return {
            origin: "".concat(baseURL, "/"),
            authenticate: "".concat(baseURL, "/sign-in/"),
            register: '',
            authenticated: brand === Brand.Domain ? "".concat(baseURL, "/loanfinder/dashboard/applications") : "".concat(baseURL, "/dashboard/applications"),
            unauthenticated: "".concat(baseURL, "/"),
            callback: "".concat(baseURL, "/sign-in/callback/"),
            popupCallback: "".concat(baseURL, "/sign-in/callback/popup/"),
            linkCustomer: "".concat(baseURL, "/sign-in/link-accounts/"),
        };
    }
    if (type === Type.Customer) {
        return {
            origin: "".concat(baseURL, "/"),
            authenticate: "".concat(baseURL, "/sign-in/"),
            register: brand === Brand.Domain ? "".concat(baseURL, "/sign-in/") : "".concat(baseURL, "/sign-in/sign-up/"),
            authenticated: "".concat(authBaseURL),
            unauthenticated: "".concat(unauthBaseURL, "/"),
            callback: "".concat(baseURL, "/sign-in/callback/"),
            popupCallback: "".concat(baseURL, "/sign-in/callback/popup/"),
            linkCustomer: "".concat(baseURL, "/sign-in/link-accounts/"),
        };
    }
    throw new Error("Unable to determine URLs for ".concat(brand, " ").concat(type, " ").concat(environment));
}
//# sourceMappingURL=getURLs.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/AuthError.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AuthError_ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["ACCESS_DENIED"] = "access_denied";
    ErrorCodes["TOO_MANY_ATTEMPTS"] = "too_many_attempts";
    ErrorCodes["BLOCKED_USER"] = "blocked_user";
    ErrorCodes["SMS_PROVIDER_ERROR"] = "sms_provider_error";
    ErrorCodes["GENERIC"] = "invalid";
    ErrorCodes["PARSE_STATE"] = "parse";
    ErrorCodes["POPUP_CLOSED"] = "popup_closed";
    ErrorCodes["NUMBER_NOT_WORKING"] = "number_not_working";
    ErrorCodes["SSO_VERIFY_GENERIC"] = "sso_verify_generic";
    ErrorCodes["SSO_ACCOUNT_MERGE"] = "sso_account_merge";
    ErrorCodes["UNAUTHORIZED"] = "unauthorized";
    ErrorCodes["INVALID_COUNTRY"] = "invalid_country";
})(AuthError_ErrorCodes || (AuthError_ErrorCodes = {}));
var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["WRONG_CODE"] = "One-time passcode incorrect, please try again.";
    ErrorMessages["TOO_MANY_ATTEMPTS"] = "Sorry, your account has been locked following multiple failed login attempts.";
    ErrorMessages["SUSPICIOUS_LOGIN"] = "Sorry, you have been blocked from logging in because we detected suspicious login behaviour.";
    ErrorMessages["GENERIC"] = "Please try again, something went wrong.";
    ErrorMessages["BLOCKED_USER"] = "Sorry, you may be blocked from logging in.";
    ErrorMessages["NO_ACCESS_TOKEN"] = "An access token was not received from the identity provider.";
    ErrorMessages["NO_EXPIRY"] = "The access token did not have an expiry date.";
    ErrorMessages["NO_IDENTITY_TOKEN"] = "An identity token was not received from the identity provider.";
    ErrorMessages["PARSE_STATE"] = "An error occured while parsing the authentication state.";
    ErrorMessages["NUMBER_NOT_WORKING"] = "The provided number is not working, please check again.";
    ErrorMessages["SMS_GATEWAY_ERROR"] = "Unexpected response while calling the SMS gateway, try after sometime.";
    ErrorMessages["POPUP_CLOSED"] = "The popup window has been closed.";
    ErrorMessages["SSO_VERIFY_GENERIC"] = "Something went wrong with the social sign in verification";
    ErrorMessages["SSO_ACCOUNT_MERGE"] = "Something went wrong while merging accounts";
    ErrorMessages["INVALID_COUNTRY"] = "Non-AU customer self-sign-up is not allowed!";
})(ErrorMessages || (ErrorMessages = {}));
var AuthError_AuthError = /** @class */ (function () {
    function AuthError(code, description, contactUs) {
        this._code = code || AuthError_ErrorCodes.GENERIC;
        this._description = description || ErrorMessages.GENERIC;
        this._contactUs = typeof contactUs === 'undefined' ? false : contactUs;
    }
    Object.defineProperty(AuthError.prototype, "code", {
        get: function () {
            return this._code;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthError.prototype, "description", {
        get: function () {
            return this._description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthError.prototype, "contactUs", {
        get: function () {
            return this._contactUs;
        },
        enumerable: false,
        configurable: true
    });
    return AuthError;
}());

var AuthError_WrongCode = /** @class */ (function (_super) {
    __extends(WrongCode, _super);
    function WrongCode() {
        return _super.call(this, AuthError_ErrorCodes.ACCESS_DENIED, ErrorMessages.WRONG_CODE) || this;
    }
    return WrongCode;
}(AuthError_AuthError));

var AuthError_TooManyAttempts = /** @class */ (function (_super) {
    __extends(TooManyAttempts, _super);
    function TooManyAttempts() {
        return _super.call(this, AuthError_ErrorCodes.TOO_MANY_ATTEMPTS, ErrorMessages.TOO_MANY_ATTEMPTS) || this;
    }
    return TooManyAttempts;
}(AuthError_AuthError));

var AuthError_BlockedUser = /** @class */ (function (_super) {
    __extends(BlockedUser, _super);
    function BlockedUser() {
        return _super.call(this, AuthError_ErrorCodes.BLOCKED_USER, ErrorMessages.BLOCKED_USER, true) || this;
    }
    return BlockedUser;
}(AuthError_AuthError));

var AuthError_NumberNotWorking = /** @class */ (function (_super) {
    __extends(NumberNotWorking, _super);
    function NumberNotWorking() {
        return _super.call(this, AuthError_ErrorCodes.NUMBER_NOT_WORKING, ErrorMessages.NUMBER_NOT_WORKING) || this;
    }
    return NumberNotWorking;
}(AuthError_AuthError));

var AuthError_SMSGatewayError = /** @class */ (function (_super) {
    __extends(SMSGatewayError, _super);
    function SMSGatewayError() {
        return _super.call(this, AuthError_ErrorCodes.SMS_PROVIDER_ERROR, ErrorMessages.SMS_GATEWAY_ERROR) || this;
    }
    return SMSGatewayError;
}(AuthError_AuthError));

var AuthError_NoAccessToken = /** @class */ (function (_super) {
    __extends(NoAccessToken, _super);
    function NoAccessToken() {
        return _super.call(this, AuthError_ErrorCodes.GENERIC, ErrorMessages.NO_ACCESS_TOKEN) || this;
    }
    return NoAccessToken;
}(AuthError_AuthError));

var AuthError_NoExpiry = /** @class */ (function (_super) {
    __extends(NoExpiry, _super);
    function NoExpiry() {
        return _super.call(this, AuthError_ErrorCodes.GENERIC, ErrorMessages.NO_EXPIRY) || this;
    }
    return NoExpiry;
}(AuthError_AuthError));

var AuthError_NoIdentityToken = /** @class */ (function (_super) {
    __extends(NoIdentityToken, _super);
    function NoIdentityToken() {
        return _super.call(this, AuthError_ErrorCodes.GENERIC, ErrorMessages.NO_IDENTITY_TOKEN) || this;
    }
    return NoIdentityToken;
}(AuthError_AuthError));

var AuthError_GenericError = /** @class */ (function (_super) {
    __extends(GenericError, _super);
    function GenericError() {
        return _super.call(this, AuthError_ErrorCodes.GENERIC, ErrorMessages.GENERIC, true) || this;
    }
    return GenericError;
}(AuthError_AuthError));

var AuthError_ParseStateError = /** @class */ (function (_super) {
    __extends(ParseStateError, _super);
    function ParseStateError() {
        return _super.call(this, AuthError_ErrorCodes.PARSE_STATE, ErrorMessages.PARSE_STATE) || this;
    }
    return ParseStateError;
}(AuthError_AuthError));

var AuthError_PopupClosedError = /** @class */ (function (_super) {
    __extends(PopupClosedError, _super);
    function PopupClosedError() {
        return _super.call(this, AuthError_ErrorCodes.POPUP_CLOSED, ErrorMessages.POPUP_CLOSED) || this;
    }
    return PopupClosedError;
}(AuthError_AuthError));

var SsoVerifyGeneric = /** @class */ (function (_super) {
    __extends(SsoVerifyGeneric, _super);
    function SsoVerifyGeneric() {
        return _super.call(this, AuthError_ErrorCodes.SSO_VERIFY_GENERIC, ErrorMessages.SSO_VERIFY_GENERIC) || this;
    }
    return SsoVerifyGeneric;
}(AuthError_AuthError));

var SSOAccountMerge = /** @class */ (function (_super) {
    __extends(SSOAccountMerge, _super);
    function SSOAccountMerge() {
        return _super.call(this, AuthError_ErrorCodes.SSO_ACCOUNT_MERGE, ErrorMessages.SSO_ACCOUNT_MERGE) || this;
    }
    return SSOAccountMerge;
}(AuthError_AuthError));

var AuthError_InvalidCountry = /** @class */ (function (_super) {
    __extends(InvalidCountry, _super);
    function InvalidCountry() {
        return _super.call(this, AuthError_ErrorCodes.INVALID_COUNTRY, ErrorMessages.INVALID_COUNTRY) || this;
    }
    return InvalidCountry;
}(AuthError_AuthError));

//# sourceMappingURL=AuthError.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js + 108 modules
var main = __webpack_require__(66715);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-logs/esm/index.js + 24 modules
var esm = __webpack_require__(45142);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/Sentry.js
var Sentry_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var rumOptions = {
    applicationId: "a64100b3-87a7-479c-962a-bf16197efb0f" || 0,
    clientToken: "pub7cc4fc74825700ff94e7c47696f5cd54" || 0,
    site: 'datadoghq.com',
    service: 'LALA',
    sampleRate: 100,
    resourceSampleRate: 100,
    env: "production",
    version: "LALA-6163",
    trackInteractions: true,
};
var logsOptions = {
    clientToken: "pub7cc4fc74825700ff94e7c47696f5cd54" || 0,
    site: 'datadoghq.com',
    service: 'LALA',
    forwardErrorsToLogs: true,
    sampleRate: 100,
    version: "LALA-6163",
    env: "production",
    defaultPrivacyLevel: main/* DefaultPrivacyLevel.MASK */.J.MASK,
};
var LegacyAuthMeError = /** @class */ (function (_super) {
    Sentry_extends(LegacyAuthMeError, _super);
    function LegacyAuthMeError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LegacyAuthMeError;
}(Error));

var logger;
var Sentry_LalaSentry = {
    configureUserContext: function (userCxt) {
        main/* datadogRum.setUser */.v.setUser({ username: userCxt.phoneNumber });
        main/* datadogRum.addAction */.v.addAction('Updated User Context');
    },
    init: function () {
        if (!logger) {
            main/* datadogRum.init */.v.init(rumOptions);
            main/* datadogRum.addAction */.v.addAction('Initialized Rum client');
            esm/* datadogLogs.init */.fy.init(logsOptions);
            logger = esm/* datadogLogs.createLogger */.fy.createLogger('lalaSentryLogger');
        }
    },
    captureException: function (error, errorTag, errorInfo) {
        main/* datadogRum.addError */.v.addError(error, __assign(__assign({}, errorInfo), { errorTag: errorTag }));
    },
    logToSentry: function (message, event) {
        console.log(message, { event: event, loggerInitialized: !!logger, level: 'Info', oldLog: true }); // tslint:disable-line no-console
        if (logger)
            logger.info(message, { event: event });
    },
    logInfo: function (message, tags) {
        console.log(message, __assign(__assign({}, tags), { loggerInitialized: !!logger, level: 'Info' })); // tslint:disable-line no-console
        if (logger)
            logger.info(message, __assign({}, (tags !== null && tags !== void 0 ? tags : {})));
    },
    logWarn: function (message, tags) {
        console.log(message, __assign(__assign({}, tags), { loggerInitialized: !!logger, level: 'warn' })); // tslint:disable-line no-console
        if (logger)
            logger.warn(message, __assign({}, (tags !== null && tags !== void 0 ? tags : {})));
    },
    logError: function (message, tags) {
        console.log(message, __assign(__assign({}, tags), { loggerInitialized: !!logger, level: 'error' })); // tslint:disable-line no-console
        if (logger)
            logger.error(message, __assign({}, (tags !== null && tags !== void 0 ? tags : {})));
    },
};
//# sourceMappingURL=Sentry.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/AuthErrorUtils.js


var matchPatterns;
(function (matchPatterns) {
    matchPatterns["WRONG_CODE"] = "verification code";
    matchPatterns["TOO_MANY_ATTEMPTS"] = "attempts";
    matchPatterns["BLOCKED_USER"] = "blocked";
    matchPatterns["NUMBER_NOT_WORKING"] = "not a valid phone";
    matchPatterns["SMS_GATEWAY_NOT_WORKING"] = "unexpected response";
    matchPatterns["POPUP_CLOSED"] = "User closed the popup window";
    matchPatterns["INVALID_COUNTRY"] = "non-allowed country";
})(matchPatterns || (matchPatterns = {}));
var matchAuth0ErrorToLALAAuthError = function (code, description) {
    if (code === ErrorCodes.ACCESS_DENIED && description.toLowerCase().includes(matchPatterns.WRONG_CODE)) {
        return new WrongCode();
    }
    if (code === ErrorCodes.ACCESS_DENIED && description.toLowerCase().includes(matchPatterns.TOO_MANY_ATTEMPTS)) {
        return new TooManyAttempts();
    }
    if (code === ErrorCodes.BLOCKED_USER && description.toLowerCase().includes(matchPatterns.BLOCKED_USER)) {
        return new BlockedUser();
    }
    if (code === ErrorCodes.SMS_PROVIDER_ERROR && description.toLowerCase().includes(matchPatterns.NUMBER_NOT_WORKING)) {
        return new NumberNotWorking();
    }
    if (code === ErrorCodes.UNAUTHORIZED && description.toLowerCase().includes(matchPatterns.INVALID_COUNTRY)) {
        return new InvalidCountry();
    }
    if (code === ErrorCodes.SMS_PROVIDER_ERROR &&
        description.toLowerCase().includes(matchPatterns.SMS_GATEWAY_NOT_WORKING)) {
        return new SMSGatewayError();
    }
    return new GenericError();
};
var AuthErrorUtils_parseAuthError = function (auth0Error) {
    var code = auth0Error.code, description = auth0Error.description, original = auth0Error.original;
    LalaSentry.logError('Auth failed', { auth0Error: auth0Error });
    if (original === matchPatterns.POPUP_CLOSED) {
        return { error: new PopupClosedError() };
    }
    var errCode = code ? code : ErrorCodes.GENERIC;
    var error = description ? matchAuth0ErrorToLALAAuthError(errCode, description) : new GenericError();
    return {
        error: error,
    };
};
var AuthErrorUtils_parseStorageError = function (_a) {
    var _code = _a._code, _description = _a._description, _contactUs = _a._contactUs;
    return new AuthError(_code, _description, _contactUs);
};
//# sourceMappingURL=AuthErrorUtils.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/consts.js
var NAMESPACE = "https://lendi";
var consts_IDENTITY_TOKEN_USER_ID_KEY = "".concat(NAMESPACE, "/userId");
var consts_IDENTITY_TOKEN_ROLE_KEY = "".concat(NAMESPACE, "/userRole");
var consts_IDENTITY_TOKEN_PROFILE_KEY = "".concat(NAMESPACE, "/userProfile");
var consts_IDENTITY_TOKEN_EXISTING_KEY = "".concat(NAMESPACE, "/existingUser");
var consts_IDENTITY_TOKEN_AUTH_ID_KEY = "".concat(NAMESPACE, "/authId");
var consts_IDENTITY_TOKEN_CONNECTION_KEY = "".concat(NAMESPACE, "/connection");
var consts_RETURNURL_STORAGE_KEY = 'lendi_auth:return_url';
var SAFETY_NET_COOKIE_NAME = 'safetynet';
var LG_APP_AUTH_SESSION_COOKIE_NAME = 'authsession';
var BYPASS_POSTCODE = 'bypass_postcode';
var PRL_STORE_ID = 'prl_storeid';
var PRL_BROKER_ID = 'prl_brokerid';
var CUSTOMER_REFERRAL_CODE = 'customer_refcode';
var LOCAL_STORAGE_KEYS = {
    COTR_PROMPT_DATA: 'cotr_prompt_data',
};
var SESSION_STORAGE_KEYS = {
    CTOR_TARGET_STORE_ID: 'target-storeid',
    CTOR_TARGET_BROKER_ID: 'target-brokerid',
    CTOR_REQUESTED_STORE_ID: 'requested-storeid',
    CTOR_REQUESTED_BROKER_ID: 'requested-brokerid',
};
//# sourceMappingURL=consts.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/getStateFromAuthResult.js



function getStateFromAuthResult(error, result) {
    if (result) {
        if (!result.accessToken) {
            return {
                error: new NoAccessToken(),
            };
        }
        var accessToken = result.accessToken;
        if (!result.expiresIn) {
            return {
                error: new NoExpiry(),
            };
        }
        var expiry = Date.now() + result.expiresIn * 1000;
        if (!result.idTokenPayload) {
            return {
                error: new NoIdentityToken(),
            };
        }
        var userID = result.idTokenPayload[IDENTITY_TOKEN_USER_ID_KEY];
        var role = result.idTokenPayload[IDENTITY_TOKEN_ROLE_KEY];
        var profile = result.idTokenPayload[IDENTITY_TOKEN_PROFILE_KEY];
        var authId = result.idTokenPayload[IDENTITY_TOKEN_AUTH_ID_KEY];
        var existingUser = result.idTokenPayload[IDENTITY_TOKEN_EXISTING_KEY];
        var connection = result.idTokenPayload[IDENTITY_TOKEN_CONNECTION_KEY];
        return {
            token: accessToken,
            expiry: expiry,
            identity: {
                id: userID,
                role: role,
                profile: profile,
                existingUser: existingUser,
                authId: authId,
                connection: connection,
            },
        };
    }
    else if (error) {
        return parseAuthError(error);
    }
    else {
        throw new Error('Please call getStateFromAuthResult() with either an error or a result.');
    }
}
//# sourceMappingURL=getStateFromAuthResult.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/getStateFromStorage.js



function getStateFromStorage() {
    if (typeof sessionStorage === 'undefined') {
        return;
    }
    var value = sessionStorage.getItem(STATE_STORAGE_KEY);
    if (!value) {
        return undefined;
    }
    try {
        var json = JSON.parse(value);
        // if we don't have an object then wtf do we have
        if (typeof json !== 'object') {
            return { error: new ParseStateError() };
        }
        // make sure the object is compatible with this version of the parser
        if (!json.v || json.v !== STATE_STORAGE_VERSION) {
            return undefined;
        }
        delete json.v;
        // parse the authError from storage
        if (json.error) {
            json.error = parseStorageError(json.error);
        }
        return json;
    }
    catch (error) {
        return { error: new ParseStateError() };
    }
}
//# sourceMappingURL=getStateFromStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/setStateInStorage.js
var setStateInStorage_assign = (undefined && undefined.__assign) || function () {
    setStateInStorage_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return setStateInStorage_assign.apply(this, arguments);
};



function isAuthenticatedState(state) {
    return state.token !== undefined;
}
function isUnauthenticatedState(state) {
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return state === undefined;
}
function setStateInStorage(state, broadcast) {
    var _a, _b, _c;
    if (broadcast === void 0) { broadcast = true; }
    LalaSentry.logInfo('setStateInStorage...', { userId: (_a = state === null || state === void 0 ? void 0 : state.identity) === null || _a === void 0 ? void 0 : _a.id });
    if (typeof sessionStorage === 'undefined') {
        return;
    }
    /**
     * If the environment is test then we use simulate type so that our tests do not break
     * as referenced here: https://github.com/pubkey/broadcast-channel/issues/8
     * using simulate is documented here: https://github.com/pubkey/broadcast-channel#methods
     */
    var lalaChannel = new BroadcastChannel('lala', setStateInStorage_assign({}, ( false && 0)));
    var setStorage = function (session) {
        return sessionStorage.setItem(STATE_STORAGE_KEY, JSON.stringify(setStateInStorage_assign({ v: STATE_STORAGE_VERSION }, session)));
    };
    if (isUnauthenticatedState(state)) {
        LalaSentry.logInfo('Removing state from sessionStorage...', { userId: (_b = state === null || state === void 0 ? void 0 : state.identity) === null || _b === void 0 ? void 0 : _b.id });
        sessionStorage.removeItem(STATE_STORAGE_KEY);
    }
    else {
        if (isAuthenticatedState(state)) {
            // this if block is temporary measure to cater for removal of legacy token
            // as soon as all consumers of lala-react upgraded to v12+
            // , this could be removed
            localStorage.setItem('token', 'random-value');
        }
        LalaSentry.logInfo('Setting state to sessionStorage...', { userId: (_c = state === null || state === void 0 ? void 0 : state.identity) === null || _c === void 0 ? void 0 : _c.id });
        setStorage(state);
    }
    if (broadcast) {
        lalaChannel.postMessage(state).catch(function (error) { return LalaSentry.captureException(error, 'setStateInStorageBroadcast'); });
    }
    // tslint:disable-next-line: no-floating-promises
    lalaChannel.close();
}
//# sourceMappingURL=setStateInStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/getAudience.js

function getAudience(environment) {
    switch (environment) {
        case Environment.Staging: {
            return 'https://api.lendi-stg.net/';
        }
        case Environment.Preproduction: {
            return 'https://api.lendi-preprod.net/';
        }
        case Environment.Production: {
            return 'https://api.lendi.com.au/';
        }
        case Environment.Development:
        default: {
            return 'https://api.lendi-dev.net/';
        }
    }
}
//# sourceMappingURL=getAudience.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/getReturnURLFromStorage.js

var EMPTY_RETURNURL = '{ "queries": {} }';
function getReturnURLFromStorage() {
    return JSON.parse(sessionStorage.getItem(RETURNURL_STORAGE_KEY) || EMPTY_RETURNURL);
}
//# sourceMappingURL=getReturnURLFromStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/setReturnURLInStorage.js

function setReturnURLInStorage(url) {
    if (url) {
        sessionStorage.setItem(RETURNURL_STORAGE_KEY, JSON.stringify(url));
    }
    else {
        sessionStorage.removeItem(RETURNURL_STORAGE_KEY);
    }
}
//# sourceMappingURL=setReturnURLInStorage.js.map
// EXTERNAL MODULE: ../../../node_modules/querystring/index.js
var node_modules_querystring = __webpack_require__(67526);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/getReturnURLQueryString.js
var getReturnURLQueryString_assign = (undefined && undefined.__assign) || function () {
    getReturnURLQueryString_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return getReturnURLQueryString_assign.apply(this, arguments);
};


var getOtherQueryStrings = function (queries) {
    return Object.keys(queries)
        .filter(function (queryKey) { return queryKey !== 'returnURL'; })
        .reduce(function (obj, key) {
        var _a;
        var newObj = getReturnURLQueryString_assign(getReturnURLQueryString_assign({}, obj), (_a = {}, _a[key] = queries[key], _a));
        return newObj;
    }, {});
};
var generateReturnURL = function (redirectLinks) {
    if (!redirectLinks.length) {
        return '';
    }
    var returnURL = redirectLinks.pop();
    redirectLinks.reverse();
    redirectLinks.forEach(function (link, i) {
        if (returnURL.includes('?')) {
            returnURL = "".concat(link, "&returnURL=").concat(encodeURIComponent(returnURL));
        }
        else {
            returnURL = "".concat(link, "?returnURL=").concat(encodeURIComponent(returnURL));
        }
    });
    returnURL = "".concat(decodeURI(returnURL));
    return returnURL;
};
var shorternReturnURL = function (returnURL) {
    // IM-422 redirect to the homepage
    if (returnURL.length > 1000) {
        if (returnURL.includes('applicationidplaceholder')) {
            return '/home-loans/basics/landing/?returnURL=/home-loans/basics/application/applicationidplaceholder/ctp/';
        }
        return '/dashboard';
    }
    return returnURL;
};
var getReturnURLFromQuery = function () {
    if (typeof window === 'undefined') {
        return { returnURL: undefined, queries: {} };
    }
    var searchQueries = window.location.search.replace(/\?/, '');
    var parsedQueries = querystring.parse(searchQueries);
    if (parsedQueries) {
        var otherQueries = getOtherQueryStrings(parsedQueries);
        if (parsedQueries.returnURL) {
            var returnURLInQuery = parsedQueries.returnURL;
            if (Array.isArray(returnURLInQuery)) {
                var returnURLArrayString = generateReturnURL(returnURLInQuery);
                LalaSentry.logToSentry('Multiple Return Urls found', returnURLArrayString);
                return { returnURL: shorternReturnURL(returnURLArrayString), queries: otherQueries };
            }
            else {
                return { returnURL: shorternReturnURL(returnURLInQuery), queries: otherQueries };
            }
        }
        return { returnURL: undefined, queries: otherQueries };
    }
    return { returnURL: undefined, queries: {} };
};
//# sourceMappingURL=getReturnURLQueryString.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/validateReturnURL.js

var validateReturnURL = function (brand, type, env, returnURL) {
    var returnURLs = getURLs(brand, type, env);
    return validateReturnURL_validateReturnURLByMap(returnURLs, returnURL);
};
var validateReturnURL_validateReturnURLByMap = function (returnURLs, returnURL) {
    return ((returnURL.startsWith(returnURLs.origin) || returnURL.startsWith('/')) &&
        !returnURL.startsWith(returnURLs.origin + '/') &&
        !returnURL.startsWith('//'));
};
//# sourceMappingURL=validateReturnURL.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/executeReturnURL.js
/// <reference types="node"/>




var generateReturnURLHOF = function (returnURLs) { return function (urlQueries) {
    var stringQueries = querystring.stringify(urlQueries.queries);
    var returnUrlParam = urlQueries.returnURL || '';
    var returnURL = validateReturnURLByMap(returnURLs, returnUrlParam) ? returnUrlParam : returnURLs.authenticated;
    if (stringQueries === '')
        return returnURL;
    if (returnURL.includes('?'))
        return "".concat(returnURL, "&").concat(stringQueries);
    return "".concat(returnURL, "?").concat(stringQueries);
}; };
var getReturnURLFromLALAURLQueries = function (brand, type, env, returnURL) {
    var returnURLs = getURLs(brand, type, env);
    if (brand === Brand.Domain && type === Type.Customer) {
        return generateDomainReturnURL(returnURL, returnURLs);
    }
    else {
        var generateReturnURL = generateReturnURLHOF(returnURLs);
        return generateReturnURL(returnURL);
    }
};
// https://creditandfinance.atlassian.net/browse/SUB-2202
var generateDomainReturnURL = function (urlQueries, returnURLs) {
    var stringQueries = querystring.stringify(urlQueries.queries);
    var returnURLObject = urlQueries.returnURL || '';
    if (returnURLObject) {
        if (stringQueries === '') {
            // with no query params saved in local storage
            return "".concat(returnURLs.authenticated, "?returnURL=").concat(urlQueries.returnURL);
        }
        else {
            // with query params saved in local storage
            return "".concat(returnURLs.authenticated, "?returnURL=").concat(urlQueries.returnURL, "&").concat(stringQueries);
        }
    }
    else {
        // when there is no return url given
        return "".concat(returnURLs.authenticated);
    }
};
var executeReturnURL = function (brand, type, env, returnURL) {
    var returnUrl = getReturnURLFromLALAURLQueries(brand, type, env, returnURL);
    LalaSentry.logInfo('redirect by executeReturnURL', { returnUrl: returnUrl });
    window.location.assign(returnUrl);
};
//# sourceMappingURL=executeReturnURL.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/getBrandFromHostname.js

function getBrandFromHostname() {
    if (typeof window === 'undefined')
        return Brand_Brand.Lendi;
    var hostname = window.location.hostname;
    // lendi customer
    if (hostname === 'www.lendi.com.au' ||
        hostname === 'www.lendi-preprod.net' ||
        hostname === 'www.lendi-stg.net' ||
        hostname === 'www.lendi-dev.net') {
        return Brand_Brand.Lendi;
    }
    // domain customer
    if (hostname === 'www.domain.com.au' || hostname === 'stage.domain.com.au' || hostname === 'dlf.lendi-paas-dev.net') {
        return Brand_Brand.Domain;
    }
    // domain team
    if (hostname === 'team-dlf.lendi.com.au' ||
        hostname === 'team-dlf.lendi-paas-preprod.net' ||
        hostname === 'team-dlf.lendi-paas-stg.net' ||
        hostname === 'team-dlf.lendi-paas-dev.net' ||
        hostname === 'team-dlf.lendi-dev.net' ||
        hostname === 'team-dlf.lendi-stg.net' ||
        hostname === 'team-dlf.lendi.com.au.local') {
        return Brand_Brand.Domain;
    }
    // aussie customer
    if (hostname === 'www.aussie.com.au' ||
        hostname === 'www.aussie-preprod.com.au' ||
        hostname === 'www.aussie-dev.com.au' ||
        hostname === 'www.aussie-stg.com.au' ||
        hostname === 'www.aussie-dev.com.au.local') {
        return Brand_Brand.Aussie;
    }
    // aussie team
    if (hostname === 'team.aussie.com.au' ||
        hostname === 'team.aussie-preprod.com.au' ||
        hostname === 'team.aussie-dev.com.au' ||
        hostname === 'team.aussie-stg.com.au' ||
        hostname === 'team.aussie-dev.com.au.local' ||
        hostname === 'aussie-team-dev.lendigroup.com.au' ||
        hostname === 'aussie-team-stg.lendigroup.com.au' ||
        hostname === 'aussie-team-preprod.lendigroup.com.au' ||
        hostname === 'aussie-team.lendigroup.com.au' ||
        hostname === 'tools.aussie-dev.com.au' ||
        hostname === 'tools.aussie-stg.com.au' ||
        hostname === 'tools.aussie-preprod.com.au' ||
        hostname === 'tools.aussie.com.au') {
        return Brand_Brand.Aussie;
    }
    // default to customer
    return Brand_Brand.Lendi;
}
//# sourceMappingURL=getBrandFromHostname.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/getTypeFromHostname.js

function getTypeFromHostname() {
    var hostname = window.location.hostname;
    var hostNameRegex = new RegExp('team');
    /*
      hostname === 'team.lendi.com.au' ||
      hostname === 'team.lendi-stg.net' ||
      hostname === 'team.lendi-preprod.net' ||
      hostname === 'team.lendi-dev.net' ||
      hostname === 'team.aussie.com.au' ||
      hostname === 'team.aussie-stg.com.au' ||
      hostname === 'team.aussie-preprod.com.au' ||
      hostname === 'team.aussie-dev.com.au' ||
      hostname === 'team-dlf.lendi-dev.net' ||
      hostname === 'team-dlf.lendi-stg.net' ||
      hostname === 'team-dlf.lendi.com.au'
    */
    // team
    if (hostNameRegex.test(hostname) || hostname.startsWith('tools.')) {
        return Type.Team;
    }
    // lendi customer
    if (hostname === 'www.lendi.com.au' ||
        hostname === 'www.lendi-stg.net' ||
        hostname === 'www.lendi-dev.net' ||
        hostname === 'www.lendi-preprod.net') {
        return Type.Customer;
    }
    // aussie customer
    if (hostname === 'www.aussie.com.au' ||
        hostname === 'www.aussie-stg.com.au' ||
        hostname === 'www.aussie-dev.com.au' ||
        hostname === 'www.aussie-preprod.com.au') {
        return Type.Customer;
    }
    // domain customer
    if (hostname === 'www.domain.com.au' || hostname === 'stage.domain.com.au' || hostname === 'dlf.lendi-paas-dev.net') {
        return Type.Customer;
    }
    // default to customer
    return Type.Customer;
}
//# sourceMappingURL=getTypeFromHostname.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/@lendi/lala-utils/dist/esm/index.js






















//# sourceMappingURL=index.js.map

/***/ }),

/***/ 56631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FJ": function() { return /* binding */ pTimeout; },
/* harmony export */   "UI": function() { return /* binding */ invokeCallback; }
/* harmony export */ });
/* unused harmony export sleep */
function pTimeout(promise, timeout) {
    return new Promise(function (resolve, reject) {
        var timeoutId = setTimeout(function () {
            reject(Error('Promise timed out'));
        }, timeout);
        promise
            .then(function (val) {
            clearTimeout(timeoutId);
            return resolve(val);
        })
            .catch(reject);
    });
}
function sleep(timeoutInMs) {
    return new Promise(function (resolve) { return setTimeout(resolve, timeoutInMs); });
}
/**
 * @param ctx
 * @param callback - the function to invoke
 * @param delay - aka "timeout". The amount of time in ms to wait before invoking the callback.
 */
function invokeCallback(ctx, callback, delay) {
    var cb = function () {
        try {
            return Promise.resolve(callback(ctx));
        }
        catch (err) {
            return Promise.reject(err);
        }
    };
    return (sleep(delay)
        // pTimeout ensures that the callback can't cause the context to hang
        .then(function () { return pTimeout(cb(), 1000); })
        .catch(function (err) {
        ctx === null || ctx === void 0 ? void 0 : ctx.log('warn', 'Callback Error', { error: err });
        ctx === null || ctx === void 0 ? void 0 : ctx.stats.increment('callback_error');
    })
        .then(function () { return ctx; }));
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 58074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ ContextCancelation; },
  "_": function() { return /* binding */ CoreContext; }
});

// EXTERNAL MODULE: ../../../node_modules/@lukeed/uuid/dist/index.mjs
var dist = __webpack_require__(29625);
// EXTERNAL MODULE: ../../../node_modules/dset/dist/index.mjs
var dset_dist = __webpack_require__(58506);
// EXTERNAL MODULE: ../../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92712);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/logger/index.js

var CoreLogger = /** @class */ (function () {
    function CoreLogger() {
        this._logs = [];
    }
    CoreLogger.prototype.log = function (level, message, extras) {
        var time = new Date();
        this._logs.push({
            level: level,
            message: message,
            time: time,
            extras: extras,
        });
    };
    Object.defineProperty(CoreLogger.prototype, "logs", {
        get: function () {
            return this._logs;
        },
        enumerable: false,
        configurable: true
    });
    CoreLogger.prototype.flush = function () {
        if (this.logs.length > 1) {
            var formatted = this._logs.reduce(function (logs, log) {
                var _a;
                var _b, _c;
                var line = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, log), { json: JSON.stringify(log.extras, null, ' '), extras: log.extras });
                delete line['time'];
                var key = (_c = (_b = log.time) === null || _b === void 0 ? void 0 : _b.toISOString()) !== null && _c !== void 0 ? _c : '';
                if (logs[key]) {
                    key = "".concat(key, "-").concat(Math.random());
                }
                return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, logs), (_a = {}, _a[key] = line, _a));
            }, {});
            // ie doesn't like console.table
            if (console.table) {
                console.table(formatted);
            }
            else {
                console.log(formatted);
            }
        }
        else {
            this.logs.forEach(function (logEntry) {
                var level = logEntry.level, message = logEntry.message, extras = logEntry.extras;
                if (level === 'info' || level === 'debug') {
                    console.log(message, extras !== null && extras !== void 0 ? extras : '');
                }
                else {
                    console[level](message, extras !== null && extras !== void 0 ? extras : '');
                }
            });
        }
        this._logs = [];
    };
    return CoreLogger;
}());

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/stats/index.js
var esm_stats = __webpack_require__(4291);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/context/index.js




var ContextCancelation = /** @class */ (function () {
    function ContextCancelation(options) {
        var _a, _b, _c;
        this.retry = (_a = options.retry) !== null && _a !== void 0 ? _a : true;
        this.type = (_b = options.type) !== null && _b !== void 0 ? _b : 'plugin Error';
        this.reason = (_c = options.reason) !== null && _c !== void 0 ? _c : '';
    }
    return ContextCancelation;
}());

var CoreContext = /** @class */ (function () {
    function CoreContext(event, id, stats, logger) {
        if (id === void 0) { id = (0,dist.v4)(); }
        if (stats === void 0) { stats = new esm_stats/* NullStats */.i(); }
        if (logger === void 0) { logger = new CoreLogger(); }
        this.attempts = 0;
        this.event = event;
        this._id = id;
        this.logger = logger;
        this.stats = stats;
    }
    CoreContext.system = function () {
        // This should be overridden by the subclass to return an instance of the subclass.
    };
    CoreContext.prototype.isSame = function (other) {
        return other.id === this.id;
    };
    CoreContext.prototype.cancel = function (error) {
        if (error) {
            throw error;
        }
        throw new ContextCancelation({ reason: 'Context Cancel' });
    };
    CoreContext.prototype.log = function (level, message, extras) {
        this.logger.log(level, message, extras);
    };
    Object.defineProperty(CoreContext.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    CoreContext.prototype.updateEvent = function (path, val) {
        var _a;
        // Don't allow integrations that are set to false to be overwritten with integration settings.
        if (path.split('.')[0] === 'integrations') {
            var integrationName = path.split('.')[1];
            if (((_a = this.event.integrations) === null || _a === void 0 ? void 0 : _a[integrationName]) === false) {
                return this.event;
            }
        }
        (0,dset_dist/* dset */.N)(this.event, path, val);
        return this.event;
    };
    CoreContext.prototype.failedDelivery = function () {
        return this._failedDelivery;
    };
    CoreContext.prototype.setFailedDelivery = function (options) {
        this._failedDelivery = options;
    };
    CoreContext.prototype.logs = function () {
        return this.logger.logs;
    };
    CoreContext.prototype.flush = function () {
        this.logger.flush();
        this.stats.flush();
    };
    CoreContext.prototype.toJSON = function () {
        return {
            id: this._id,
            event: this.event,
            logs: this.logger.logs,
            metrics: this.stats.metrics,
        };
    };
    return CoreContext;
}());

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 82635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ ON_REMOVE_FROM_FUTURE; },
  "Z": function() { return /* binding */ PriorityQueue; }
});

// EXTERNAL MODULE: ../../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92712);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-generic-utils/dist/esm/emitter/emitter.js
var emitter = __webpack_require__(53994);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/priority-queue/backoff.js
function backoff(params) {
    var random = Math.random() + 1;
    var _a = params.minTimeout, minTimeout = _a === void 0 ? 500 : _a, _b = params.factor, factor = _b === void 0 ? 2 : _b, attempt = params.attempt, _c = params.maxTimeout, maxTimeout = _c === void 0 ? Infinity : _c;
    return Math.min(random * minTimeout * Math.pow(factor, attempt), maxTimeout);
}
//# sourceMappingURL=backoff.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/priority-queue/index.js



/**
 * @internal
 */
var ON_REMOVE_FROM_FUTURE = 'onRemoveFromFuture';
var PriorityQueue = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(PriorityQueue, _super);
    function PriorityQueue(maxAttempts, queue, seen) {
        var _this = _super.call(this) || this;
        _this.future = [];
        _this.maxAttempts = maxAttempts;
        _this.queue = queue;
        _this.seen = seen !== null && seen !== void 0 ? seen : {};
        return _this;
    }
    PriorityQueue.prototype.push = function () {
        var _this = this;
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var accepted = items.map(function (operation) {
            var attempts = _this.updateAttempts(operation);
            if (attempts > _this.maxAttempts || _this.includes(operation)) {
                return false;
            }
            _this.queue.push(operation);
            return true;
        });
        this.queue = this.queue.sort(function (a, b) { return _this.getAttempts(a) - _this.getAttempts(b); });
        return accepted;
    };
    PriorityQueue.prototype.pushWithBackoff = function (item) {
        var _this = this;
        if (this.getAttempts(item) === 0) {
            return this.push(item)[0];
        }
        var attempt = this.updateAttempts(item);
        if (attempt > this.maxAttempts || this.includes(item)) {
            return false;
        }
        var timeout = backoff({ attempt: attempt - 1 });
        setTimeout(function () {
            _this.queue.push(item);
            // remove from future list
            _this.future = _this.future.filter(function (f) { return f.id !== item.id; });
            // Lets listeners know that a 'future' message is now available in the queue
            _this.emit(ON_REMOVE_FROM_FUTURE);
        }, timeout);
        this.future.push(item);
        return true;
    };
    PriorityQueue.prototype.getAttempts = function (item) {
        var _a;
        return (_a = this.seen[item.id]) !== null && _a !== void 0 ? _a : 0;
    };
    PriorityQueue.prototype.updateAttempts = function (item) {
        this.seen[item.id] = this.getAttempts(item) + 1;
        return this.getAttempts(item);
    };
    PriorityQueue.prototype.includes = function (item) {
        return (this.queue.includes(item) ||
            this.future.includes(item) ||
            Boolean(this.queue.find(function (i) { return i.id === item.id; })) ||
            Boolean(this.future.find(function (i) { return i.id === item.id; })));
    };
    PriorityQueue.prototype.pop = function () {
        return this.queue.shift();
    };
    Object.defineProperty(PriorityQueue.prototype, "length", {
        get: function () {
            return this.queue.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriorityQueue.prototype, "todo", {
        get: function () {
            return this.queue.length + this.future.length;
        },
        enumerable: false,
        configurable: true
    });
    return PriorityQueue;
}(emitter/* Emitter */.Q));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 94270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ attempt; },
/* harmony export */   "z": function() { return /* binding */ ensure; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92712);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58074);


function tryAsync(fn) {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__awaiter)(this, void 0, void 0, function () {
        var err_1;
        return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fn()];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    err_1 = _a.sent();
                    return [2 /*return*/, Promise.reject(err_1)];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function attempt(ctx, plugin) {
    ctx.log('debug', 'plugin', { plugin: plugin.name });
    var start = new Date().getTime();
    var hook = plugin[ctx.event.type];
    if (hook === undefined) {
        return Promise.resolve(ctx);
    }
    var newCtx = tryAsync(function () { return hook.apply(plugin, [ctx]); })
        .then(function (ctx) {
        var done = new Date().getTime() - start;
        ctx.stats.gauge('plugin_time', done, ["plugin:".concat(plugin.name)]);
        return ctx;
    })
        .catch(function (err) {
        if (err instanceof _context__WEBPACK_IMPORTED_MODULE_1__/* .ContextCancelation */ .Y &&
            err.type === 'middleware_cancellation') {
            throw err;
        }
        if (err instanceof _context__WEBPACK_IMPORTED_MODULE_1__/* .ContextCancelation */ .Y) {
            ctx.log('warn', err.type, {
                plugin: plugin.name,
                error: err,
            });
            return err;
        }
        ctx.log('error', 'plugin Error', {
            plugin: plugin.name,
            error: err,
        });
        ctx.stats.increment('plugin_error', 1, ["plugin:".concat(plugin.name)]);
        return err;
    });
    return newCtx;
}
function ensure(ctx, plugin) {
    return attempt(ctx, plugin).then(function (newContext) {
        if (newContext instanceof _context__WEBPACK_IMPORTED_MODULE_1__/* .CoreContext */ ._) {
            return newContext;
        }
        ctx.log('debug', 'Context canceled');
        ctx.stats.increment('context_canceled');
        ctx.cancel(newContext);
    });
}
//# sourceMappingURL=delivery.js.map

/***/ }),

/***/ 4291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ NullStats; },
/* harmony export */   "s": function() { return /* binding */ CoreStats; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92712);

var compactMetricType = function (type) {
    var enums = {
        gauge: 'g',
        counter: 'c',
    };
    return enums[type];
};
var CoreStats = /** @class */ (function () {
    function CoreStats() {
        this.metrics = [];
    }
    CoreStats.prototype.increment = function (metric, by, tags) {
        if (by === void 0) { by = 1; }
        this.metrics.push({
            metric: metric,
            value: by,
            tags: tags !== null && tags !== void 0 ? tags : [],
            type: 'counter',
            timestamp: Date.now(),
        });
    };
    CoreStats.prototype.gauge = function (metric, value, tags) {
        this.metrics.push({
            metric: metric,
            value: value,
            tags: tags !== null && tags !== void 0 ? tags : [],
            type: 'gauge',
            timestamp: Date.now(),
        });
    };
    CoreStats.prototype.flush = function () {
        var formatted = this.metrics.map(function (m) { return ((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, m), { tags: m.tags.join(',') })); });
        // ie doesn't like console.table
        if (console.table) {
            console.table(formatted);
        }
        else {
            console.log(formatted);
        }
        this.metrics = [];
    };
    /**
     * compact keys for smaller payload
     */
    CoreStats.prototype.serialize = function () {
        return this.metrics.map(function (m) {
            return {
                m: m.metric,
                v: m.value,
                t: m.tags,
                k: compactMetricType(m.type),
                e: m.timestamp,
            };
        });
    };
    return CoreStats;
}());

var NullStats = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(NullStats, _super);
    function NullStats() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NullStats.prototype.gauge = function () {
        var _args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _args[_i] = arguments[_i];
        }
    };
    NullStats.prototype.increment = function () {
        var _args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _args[_i] = arguments[_i];
        }
    };
    NullStats.prototype.flush = function () {
        var _args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _args[_i] = arguments[_i];
        }
    };
    NullStats.prototype.serialize = function () {
        var _args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _args[_i] = arguments[_i];
        }
        return [];
    };
    return NullStats;
}(CoreStats));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 58459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gg": function() { return /* binding */ exists; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; },
/* harmony export */   "mf": function() { return /* binding */ isFunction; }
/* harmony export */ });
function isString(obj) {
    return typeof obj === 'string';
}
function isNumber(obj) {
    return typeof obj === 'number';
}
function isFunction(obj) {
    return typeof obj === 'function';
}
function exists(val) {
    return val !== undefined && val !== null;
}
function isPlainObject(obj) {
    return (Object.prototype.toString.call(obj).slice(8, -1).toLowerCase() === 'object');
}
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 34498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ createDeferred; }
/* harmony export */ });
/**
 * Return a promise that can be externally resolved
 */
var createDeferred = function () {
    var resolve;
    var reject;
    var settled = false;
    var promise = new Promise(function (_resolve, _reject) {
        resolve = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            settled = true;
            _resolve.apply(void 0, args);
        };
        reject = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            settled = true;
            _reject.apply(void 0, args);
        };
    });
    return {
        resolve: resolve,
        reject: reject,
        promise: promise,
        isSettled: function () { return settled; },
    };
};
//# sourceMappingURL=create-deferred.js.map

/***/ }),

/***/ 53994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ Emitter; }
/* harmony export */ });
/**
 * Event Emitter that takes the expected contract as a generic
 * @example
 * ```ts
 *  type Contract = {
 *    delivery_success: [DeliverySuccessResponse, Metrics],
 *    delivery_failure: [DeliveryError]
 * }
 *  new Emitter<Contract>()
 *  .on('delivery_success', (res, metrics) => ...)
 *  .on('delivery_failure', (err) => ...)
 * ```
 */
var Emitter = /** @class */ (function () {
    function Emitter(options) {
        var _a;
        this.callbacks = {};
        this.warned = false;
        this.maxListeners = (_a = options === null || options === void 0 ? void 0 : options.maxListeners) !== null && _a !== void 0 ? _a : 10;
    }
    Emitter.prototype.warnIfPossibleMemoryLeak = function (event) {
        if (this.warned) {
            return;
        }
        if (this.maxListeners &&
            this.callbacks[event].length > this.maxListeners) {
            console.warn("Event Emitter: Possible memory leak detected; ".concat(String(event), " has exceeded ").concat(this.maxListeners, " listeners."));
            this.warned = true;
        }
    };
    Emitter.prototype.on = function (event, callback) {
        if (!this.callbacks[event]) {
            this.callbacks[event] = [callback];
        }
        else {
            this.callbacks[event].push(callback);
            this.warnIfPossibleMemoryLeak(event);
        }
        return this;
    };
    Emitter.prototype.once = function (event, callback) {
        var _this = this;
        var on = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.off(event, on);
            callback.apply(_this, args);
        };
        this.on(event, on);
        return this;
    };
    Emitter.prototype.off = function (event, callback) {
        var _a;
        var fns = (_a = this.callbacks[event]) !== null && _a !== void 0 ? _a : [];
        var without = fns.filter(function (fn) { return fn !== callback; });
        this.callbacks[event] = without;
        return this;
    };
    Emitter.prototype.emit = function (event) {
        var _this = this;
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var callbacks = (_a = this.callbacks[event]) !== null && _a !== void 0 ? _a : [];
        callbacks.forEach(function (callback) {
            callback.apply(_this, args);
        });
        return this;
    };
    return Emitter;
}());

//# sourceMappingURL=emitter.js.map

/***/ }),

/***/ 57897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ isOnline; },
/* harmony export */   "s": function() { return /* binding */ isOffline; }
/* harmony export */ });
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31278);

function isOnline() {
    if ((0,_environment__WEBPACK_IMPORTED_MODULE_0__/* .isBrowser */ .j)()) {
        return window.navigator.onLine;
    }
    return true;
}
function isOffline() {
    return !isOnline();
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 76211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ SEGMENT_API_HOST; }
/* harmony export */ });
var SEGMENT_API_HOST = 'api.segment.io/v1';
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 47130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ Context; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92712);
/* harmony import */ var _segment_analytics_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58074);
/* harmony import */ var _stats__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15686);



var Context = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(Context, _super);
    function Context(event, id) {
        return _super.call(this, event, id, new _stats__WEBPACK_IMPORTED_MODULE_1__/* .Stats */ .j()) || this;
    }
    Context.system = function () {
        return new this({ type: 'track', event: 'system' });
    };
    return Context;
}(_segment_analytics_core__WEBPACK_IMPORTED_MODULE_2__/* .CoreContext */ ._));


//# sourceMappingURL=index.js.map

/***/ }),

/***/ 31278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ isBrowser; },
/* harmony export */   "s": function() { return /* binding */ isServer; }
/* harmony export */ });
function isBrowser() {
    return typeof window !== 'undefined';
}
function isServer() {
    return !isBrowser();
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 86198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ gracefulDecodeURIComponent; }
/* harmony export */ });
/**
 * Tries to gets the unencoded version of an encoded component of a
 * Uniform Resource Identifier (URI). If input string is malformed,
 * returns it back as-is.
 *
 * Note: All occurences of the `+` character become ` ` (spaces).
 **/
function gracefulDecodeURIComponent(encodedURIComponent) {
    try {
        return decodeURIComponent(encodedURIComponent.replace(/\+/g, ' '));
    }
    catch (_a) {
        return encodedURIComponent;
    }
}
//# sourceMappingURL=gracefulDecodeURIComponent.js.map

/***/ }),

/***/ 15686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ Stats; }
});

// EXTERNAL MODULE: ../../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92712);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/stats/index.js
var stats = __webpack_require__(4291);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/fetch.js
var fetch = __webpack_require__(30826);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/generated/version.js
var version = __webpack_require__(74042);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/version-type.js
var version_type = __webpack_require__(22029);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/constants/index.js
var constants = __webpack_require__(76211);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/stats/remote-metrics.js





var createRemoteMetric = function (metric, tags, versionType) {
    var formattedTags = tags.reduce(function (acc, t) {
        var _a = t.split(':'), k = _a[0], v = _a[1];
        acc[k] = v;
        return acc;
    }, {});
    return {
        type: 'Counter',
        metric: metric,
        value: 1,
        tags: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, formattedTags), { library: 'analytics.js', library_version: versionType === 'web' ? "next-".concat(version/* version */.i) : "npm:next-".concat(version/* version */.i) }),
    };
};
function logError(err) {
    console.error('Error sending segment performance metrics', err);
}
var RemoteMetrics = /** @class */ (function () {
    function RemoteMetrics(options) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        this.host = (_a = options === null || options === void 0 ? void 0 : options.host) !== null && _a !== void 0 ? _a : constants/* SEGMENT_API_HOST */.U;
        this.sampleRate = (_b = options === null || options === void 0 ? void 0 : options.sampleRate) !== null && _b !== void 0 ? _b : 1;
        this.flushTimer = (_c = options === null || options === void 0 ? void 0 : options.flushTimer) !== null && _c !== void 0 ? _c : 30 * 1000; /* 30s */
        this.maxQueueSize = (_d = options === null || options === void 0 ? void 0 : options.maxQueueSize) !== null && _d !== void 0 ? _d : 20;
        this.protocol = (_e = options === null || options === void 0 ? void 0 : options.protocol) !== null && _e !== void 0 ? _e : 'https';
        this.queue = [];
        if (this.sampleRate > 0) {
            var flushing_1 = false;
            var run_1 = function () {
                if (flushing_1) {
                    return;
                }
                flushing_1 = true;
                _this.flush().catch(logError);
                flushing_1 = false;
                setTimeout(run_1, _this.flushTimer);
            };
            run_1();
        }
    }
    RemoteMetrics.prototype.increment = function (metric, tags) {
        // All metrics are part of an allow list in Tracking API
        if (!metric.includes('analytics_js.')) {
            return;
        }
        // /m doesn't like empty tags
        if (tags.length === 0) {
            return;
        }
        if (Math.random() > this.sampleRate) {
            return;
        }
        if (this.queue.length >= this.maxQueueSize) {
            return;
        }
        var remoteMetric = createRemoteMetric(metric, tags, (0,version_type/* getVersionType */.B)());
        this.queue.push(remoteMetric);
        if (metric.includes('error')) {
            this.flush().catch(logError);
        }
    };
    RemoteMetrics.prototype.flush = function () {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.queue.length <= 0) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.send().catch(function (error) {
                                logError(error);
                                _this.sampleRate = 0;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteMetrics.prototype.send = function () {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var payload, headers, url;
            return (0,tslib_es6.__generator)(this, function (_a) {
                payload = { series: this.queue };
                this.queue = [];
                headers = { 'Content-Type': 'text/plain' };
                url = "".concat(this.protocol, "://").concat(this.host, "/m");
                return [2 /*return*/, (0,fetch/* fetch */.h)(url, {
                        headers: headers,
                        body: JSON.stringify(payload),
                        method: 'POST',
                    })];
            });
        });
    };
    return RemoteMetrics;
}());

//# sourceMappingURL=remote-metrics.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/stats/index.js



var remoteMetrics;
var Stats = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(Stats, _super);
    function Stats() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Stats.initRemoteMetrics = function (options) {
        remoteMetrics = new RemoteMetrics(options);
    };
    Stats.prototype.increment = function (metric, by, tags) {
        _super.prototype.increment.call(this, metric, by, tags);
        remoteMetrics === null || remoteMetrics === void 0 ? void 0 : remoteMetrics.increment(metric, tags !== null && tags !== void 0 ? tags : []);
    };
    return Stats;
}(stats/* CoreStats */.s));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ recordIntegrationMetric; }
/* harmony export */ });
function recordIntegrationMetric(ctx, _a) {
    var methodName = _a.methodName, integrationName = _a.integrationName, type = _a.type, _b = _a.didError, didError = _b === void 0 ? false : _b;
    ctx.stats.increment("analytics_js.integration.invoke".concat(didError ? '.error' : ''), 1, [
        "method:".concat(methodName),
        "integration_name:".concat(integrationName),
        "type:".concat(type),
    ]);
}
//# sourceMappingURL=metric-helpers.js.map

/***/ }),

/***/ 74042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ version; }
/* harmony export */ });
// This file is generated.
var version = '1.70.0';
//# sourceMappingURL=version.js.map

/***/ }),

/***/ 30826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ fetch; }
/* harmony export */ });
/* harmony import */ var unfetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75785);
/* harmony import */ var unfetch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(unfetch__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _get_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38415);


/**
 * Wrapper around native `fetch` containing `unfetch` fallback.
 */
var fetch = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var global = (0,_get_global__WEBPACK_IMPORTED_MODULE_1__/* .getGlobal */ .R)();
    return ((global && global.fetch) || (unfetch__WEBPACK_IMPORTED_MODULE_0___default())).apply(void 0, args);
};
//# sourceMappingURL=fetch.js.map

/***/ }),

/***/ 38415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getGlobal; }
/* harmony export */ });
// This an imperfect polyfill for globalThis
var getGlobal = function () {
    if (typeof globalThis !== 'undefined') {
        return globalThis;
    }
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof __webpack_require__.g !== 'undefined') {
        return __webpack_require__.g;
    }
    return null;
};
//# sourceMappingURL=get-global.js.map

/***/ }),

/***/ 32957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jV": function() { return /* binding */ setGlobalAnalyticsKey; },
/* harmony export */   "ql": function() { return /* binding */ setGlobalAnalytics; },
/* harmony export */   "wI": function() { return /* binding */ getGlobalAnalytics; }
/* harmony export */ });
/**
 * Stores the global window analytics key
 */
var _globalAnalyticsKey = 'analytics';
/**
 * Gets the global analytics/buffer
 * @param key name of the window property where the buffer is stored (default: analytics)
 * @returns AnalyticsSnippet
 */
function getGlobalAnalytics() {
    return window[_globalAnalyticsKey];
}
/**
 * Replaces the global window key for the analytics/buffer object
 * @param key key name
 */
function setGlobalAnalyticsKey(key) {
    _globalAnalyticsKey = key;
}
/**
 * Sets the global analytics object
 * @param analytics analytics snippet
 */
function setGlobalAnalytics(analytics) {
    ;
    window[_globalAnalyticsKey] = analytics;
}
//# sourceMappingURL=global-analytics-helper.js.map

/***/ }),

/***/ 49729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ unloadScript; },
/* harmony export */   "v": function() { return /* binding */ loadScript; }
/* harmony export */ });
function findScript(src) {
    var scripts = Array.prototype.slice.call(window.document.querySelectorAll('script'));
    return scripts.find(function (s) { return s.src === src; });
}
function loadScript(src, attributes) {
    var found = findScript(src);
    if (found !== undefined) {
        var status_1 = found === null || found === void 0 ? void 0 : found.getAttribute('status');
        if (status_1 === 'loaded') {
            return Promise.resolve(found);
        }
        if (status_1 === 'loading') {
            return new Promise(function (resolve, reject) {
                found.addEventListener('load', function () { return resolve(found); });
                found.addEventListener('error', function (err) { return reject(err); });
            });
        }
    }
    return new Promise(function (resolve, reject) {
        var _a;
        var script = window.document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.async = true;
        script.setAttribute('status', 'loading');
        for (var _i = 0, _b = Object.entries(attributes !== null && attributes !== void 0 ? attributes : {}); _i < _b.length; _i++) {
            var _c = _b[_i], k = _c[0], v = _c[1];
            script.setAttribute(k, v);
        }
        script.onload = function () {
            script.onerror = script.onload = null;
            script.setAttribute('status', 'loaded');
            resolve(script);
        };
        script.onerror = function () {
            script.onerror = script.onload = null;
            script.setAttribute('status', 'error');
            reject(new Error("Failed to load ".concat(src)));
        };
        var tag = window.document.getElementsByTagName('script')[0];
        (_a = tag.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(script, tag);
    });
}
function unloadScript(src) {
    var found = findScript(src);
    if (found !== undefined) {
        found.remove();
    }
    return Promise.resolve();
}
//# sourceMappingURL=load-script.js.map

/***/ }),

/***/ 90412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ mergedOptions; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92712);

/**
 * Merge legacy settings and initialized Integration option overrides.
 *
 * This will merge any options that were passed from initialization into
 * overrides for settings that are returned by the Segment CDN.
 *
 * i.e. this allows for passing options directly into destinations from
 * the Analytics constructor.
 */
function mergedOptions(cdnSettings, options) {
    var _a;
    var optionOverrides = Object.entries((_a = options.integrations) !== null && _a !== void 0 ? _a : {}).reduce(function (overrides, _a) {
        var _b, _c;
        var integration = _a[0], options = _a[1];
        if (typeof options === 'object') {
            return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, overrides), (_b = {}, _b[integration] = options, _b));
        }
        return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, overrides), (_c = {}, _c[integration] = {}, _c));
    }, {});
    return Object.entries(cdnSettings.integrations).reduce(function (integrationSettings, _a) {
        var _b;
        var integration = _a[0], settings = _a[1];
        return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, integrationSettings), (_b = {}, _b[integration] = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, settings), optionOverrides[integration]), _b));
    }, {});
}
//# sourceMappingURL=merged-options.js.map

/***/ }),

/***/ 49457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ pWhile; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92712);

var pWhile = function (condition, action) { return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__awaiter)(void 0, void 0, void 0, function () {
    var loop;
    return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function (_a) {
        loop = function (actionResult) { return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__awaiter)(void 0, void 0, void 0, function () {
            var _a;
            return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!condition(actionResult)) return [3 /*break*/, 2];
                        _a = loop;
                        return [4 /*yield*/, action()];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        return [2 /*return*/, loop(undefined)];
    });
}); };
//# sourceMappingURL=p-while.js.map

/***/ }),

/***/ 35008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kg": function() { return /* binding */ getNextIntegrationsURL; },
/* harmony export */   "UH": function() { return /* binding */ setGlobalCDNUrl; },
/* harmony export */   "Vl": function() { return /* binding */ getCDN; }
/* harmony export */ });
/* unused harmony export getLegacyAJSPath */
/* harmony import */ var _global_analytics_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32957);


var analyticsScriptRegex = /(https:\/\/.*)\/analytics\.js\/v1\/(?:.*?)\/(?:platform|analytics.*)?/;
var getCDNUrlFromScriptTag = function () {
    var cdn;
    var scripts = Array.prototype.slice.call(document.querySelectorAll('script'));
    scripts.forEach(function (s) {
        var _a;
        var src = (_a = s.getAttribute('src')) !== null && _a !== void 0 ? _a : '';
        var result = analyticsScriptRegex.exec(src);
        if (result && result[1]) {
            cdn = result[1];
        }
    });
    return cdn;
};
var _globalCDN; // set globalCDN as in-memory singleton
var getGlobalCDNUrl = function () {
    var _a;
    var result = _globalCDN !== null && _globalCDN !== void 0 ? _globalCDN : (_a = (0,_global_analytics_helper__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalAnalytics */ .wI)()) === null || _a === void 0 ? void 0 : _a._cdn;
    return result;
};
var setGlobalCDNUrl = function (cdn) {
    var globalAnalytics = (0,_global_analytics_helper__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalAnalytics */ .wI)();
    if (globalAnalytics) {
        globalAnalytics._cdn = cdn;
    }
    _globalCDN = cdn;
};
var getCDN = function () {
    var globalCdnUrl = getGlobalCDNUrl();
    if (globalCdnUrl)
        return globalCdnUrl;
    var cdnFromScriptTag = getCDNUrlFromScriptTag();
    if (cdnFromScriptTag) {
        return cdnFromScriptTag;
    }
    else {
        // it's possible that the CDN is not found in the page because:
        // - the script is loaded through a proxy
        // - the script is removed after execution
        // in this case, we fall back to the default Segment CDN
        return "https://cdn.segment.com";
    }
};
var getNextIntegrationsURL = function () {
    var cdn = getCDN();
    return "".concat(cdn, "/next-integrations");
};
/**
 * Replaces the CDN URL in the script tag with the one from Analytics.js 1.0
 *
 * @returns the path to Analytics JS 1.0
 **/
function getLegacyAJSPath() {
    var _a, _b, _c;
    var writeKey = (_a = embeddedWriteKey()) !== null && _a !== void 0 ? _a : (_b = getGlobalAnalytics()) === null || _b === void 0 ? void 0 : _b._writeKey;
    var scripts = Array.prototype.slice.call(document.querySelectorAll('script'));
    var path = undefined;
    for (var _i = 0, scripts_1 = scripts; _i < scripts_1.length; _i++) {
        var s = scripts_1[_i];
        var src = (_c = s.getAttribute('src')) !== null && _c !== void 0 ? _c : '';
        var result = analyticsScriptRegex.exec(src);
        if (result && result[1]) {
            path = src;
            break;
        }
    }
    if (path) {
        return path.replace('analytics.min.js', 'analytics.classic.js');
    }
    return "https://cdn.segment.com/analytics.js/v1/".concat(writeKey, "/analytics.classic.js");
}
//# sourceMappingURL=parse-cdn.js.map

/***/ }),

/***/ 14296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ PersistedPriorityQueue; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92712);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82635);
/* harmony import */ var _core_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47130);
/* harmony import */ var _core_environment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31278);




var loc = {
    getItem: function () { },
    setItem: function () { },
    removeItem: function () { },
};
try {
    loc = (0,_core_environment__WEBPACK_IMPORTED_MODULE_0__/* .isBrowser */ .j)() && window.localStorage ? window.localStorage : loc;
}
catch (err) {
    console.warn('Unable to access localStorage', err);
}
function persisted(key) {
    var items = loc.getItem(key);
    return (items ? JSON.parse(items) : []).map(function (p) { return new _core_context__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._(p.event, p.id); });
}
function persistItems(key, items) {
    var existing = persisted(key);
    var all = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)([], items, true), existing, true);
    var merged = all.reduce(function (acc, item) {
        var _a;
        return (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, acc), (_a = {}, _a[item.id] = item, _a));
    }, {});
    loc.setItem(key, JSON.stringify(Object.values(merged)));
}
function seen(key) {
    var stored = loc.getItem(key);
    return stored ? JSON.parse(stored) : {};
}
function persistSeen(key, memory) {
    var stored = seen(key);
    loc.setItem(key, JSON.stringify((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, stored), memory)));
}
function remove(key) {
    loc.removeItem(key);
}
var now = function () { return new Date().getTime(); };
function mutex(key, onUnlock, attempt) {
    if (attempt === void 0) { attempt = 0; }
    var lockTimeout = 50;
    var lockKey = "persisted-queue:v1:".concat(key, ":lock");
    var expired = function (lock) { return new Date().getTime() > lock; };
    var rawLock = loc.getItem(lockKey);
    var lock = rawLock ? JSON.parse(rawLock) : null;
    var allowed = lock === null || expired(lock);
    if (allowed) {
        loc.setItem(lockKey, JSON.stringify(now() + lockTimeout));
        onUnlock();
        loc.removeItem(lockKey);
        return;
    }
    if (!allowed && attempt < 3) {
        setTimeout(function () {
            mutex(key, onUnlock, attempt + 1);
        }, lockTimeout);
    }
    else {
        console.error('Unable to retrieve lock');
    }
}
var PersistedPriorityQueue = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__extends)(PersistedPriorityQueue, _super);
    function PersistedPriorityQueue(maxAttempts, key) {
        var _this = _super.call(this, maxAttempts, []) || this;
        var itemsKey = "persisted-queue:v1:".concat(key, ":items");
        var seenKey = "persisted-queue:v1:".concat(key, ":seen");
        var saved = [];
        var lastSeen = {};
        mutex(key, function () {
            try {
                saved = persisted(itemsKey);
                lastSeen = seen(seenKey);
                remove(itemsKey);
                remove(seenKey);
                _this.queue = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)([], saved, true), _this.queue, true);
                _this.seen = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, lastSeen), _this.seen);
            }
            catch (err) {
                console.error(err);
            }
        });
        window.addEventListener('pagehide', function () {
            // we deliberately want to use the less powerful 'pagehide' API to only persist on events where the analytics instance gets destroyed, and not on tab away.
            if (_this.todo > 0) {
                var items_1 = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)([], _this.queue, true), _this.future, true);
                try {
                    mutex(key, function () {
                        persistItems(itemsKey, items_1);
                        persistSeen(seenKey, _this.seen);
                    });
                }
                catch (err) {
                    console.error(err);
                }
            }
        });
        return _this;
    }
    return PersistedPriorityQueue;
}(___WEBPACK_IMPORTED_MODULE_3__/* .PriorityQueue */ .Z));

//# sourceMappingURL=persisted.js.map

/***/ }),

/***/ 84499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ toFacade; }
/* harmony export */ });
/* harmony import */ var _segment_facade__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22372);
/* harmony import */ var _segment_facade__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_segment_facade__WEBPACK_IMPORTED_MODULE_0__);

function toFacade(evt, options) {
    var fcd = new _segment_facade__WEBPACK_IMPORTED_MODULE_0__.Facade(evt, options);
    if (evt.type === 'track') {
        fcd = new _segment_facade__WEBPACK_IMPORTED_MODULE_0__.Track(evt, options);
    }
    if (evt.type === 'identify') {
        fcd = new _segment_facade__WEBPACK_IMPORTED_MODULE_0__.Identify(evt, options);
    }
    if (evt.type === 'page') {
        fcd = new _segment_facade__WEBPACK_IMPORTED_MODULE_0__.Page(evt, options);
    }
    if (evt.type === 'alias') {
        fcd = new _segment_facade__WEBPACK_IMPORTED_MODULE_0__.Alias(evt, options);
    }
    if (evt.type === 'group') {
        fcd = new _segment_facade__WEBPACK_IMPORTED_MODULE_0__.Group(evt, options);
    }
    if (evt.type === 'screen') {
        fcd = new _segment_facade__WEBPACK_IMPORTED_MODULE_0__.Screen(evt, options);
    }
    Object.defineProperty(fcd, 'obj', {
        value: evt,
        writable: true,
    });
    return fcd;
}
//# sourceMappingURL=to-facade.js.map

/***/ }),

/***/ 22029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ getVersionType; }
/* harmony export */ });
/* unused harmony export setVersionType */
// Default value will be updated to 'web' in `bundle-umd.ts` for web build.
var _version = 'npm';
function setVersionType(version) {
    _version = version;
}
function getVersionType() {
    return _version;
}
//# sourceMappingURL=version-type.js.map

/***/ }),

/***/ 55779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "applyDestinationMiddleware": function() { return /* binding */ applyDestinationMiddleware; },
/* harmony export */   "sourceMiddlewarePlugin": function() { return /* binding */ sourceMiddlewarePlugin; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92712);
/* harmony import */ var _core_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58074);
/* harmony import */ var _lib_to_facade__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84499);



function applyDestinationMiddleware(destination, evt, middleware) {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__awaiter)(this, void 0, void 0, function () {
        function applyMiddleware(event, fn) {
            return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__awaiter)(this, void 0, void 0, function () {
                var nextCalled, returnedEvent;
                var _a;
                return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            nextCalled = false;
                            returnedEvent = null;
                            return [4 /*yield*/, fn({
                                    payload: (0,_lib_to_facade__WEBPACK_IMPORTED_MODULE_1__/* .toFacade */ .D)(event, {
                                        clone: true,
                                        traverse: false,
                                    }),
                                    integration: destination,
                                    next: function (evt) {
                                        nextCalled = true;
                                        if (evt === null) {
                                            returnedEvent = null;
                                        }
                                        if (evt) {
                                            returnedEvent = evt.obj;
                                        }
                                    },
                                })];
                        case 1:
                            _b.sent();
                            if (!nextCalled && returnedEvent !== null) {
                                returnedEvent = returnedEvent;
                                returnedEvent.integrations = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, event.integrations), (_a = {}, _a[destination] = false, _a));
                            }
                            return [2 /*return*/, returnedEvent];
                    }
                });
            });
        }
        var modifiedEvent, _i, middleware_1, md, result;
        return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    modifiedEvent = (0,_lib_to_facade__WEBPACK_IMPORTED_MODULE_1__/* .toFacade */ .D)(evt, {
                        clone: true,
                        traverse: false,
                    }).rawEvent();
                    _i = 0, middleware_1 = middleware;
                    _a.label = 1;
                case 1:
                    if (!(_i < middleware_1.length)) return [3 /*break*/, 4];
                    md = middleware_1[_i];
                    return [4 /*yield*/, applyMiddleware(modifiedEvent, md)];
                case 2:
                    result = _a.sent();
                    if (result === null) {
                        return [2 /*return*/, null];
                    }
                    modifiedEvent = result;
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, modifiedEvent];
            }
        });
    });
}
function sourceMiddlewarePlugin(fn, integrations) {
    function apply(ctx) {
        return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__awaiter)(this, void 0, void 0, function () {
            var nextCalled;
            return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nextCalled = false;
                        return [4 /*yield*/, fn({
                                payload: (0,_lib_to_facade__WEBPACK_IMPORTED_MODULE_1__/* .toFacade */ .D)(ctx.event, {
                                    clone: true,
                                    traverse: false,
                                }),
                                integrations: integrations !== null && integrations !== void 0 ? integrations : {},
                                next: function (evt) {
                                    nextCalled = true;
                                    if (evt) {
                                        ctx.event = evt.obj;
                                    }
                                },
                            })];
                    case 1:
                        _a.sent();
                        if (!nextCalled) {
                            throw new _core_context__WEBPACK_IMPORTED_MODULE_2__/* .ContextCancelation */ .Y({
                                retry: false,
                                type: 'middleware_cancellation',
                                reason: 'Middleware `next` function skipped',
                            });
                        }
                        return [2 /*return*/, ctx];
                }
            });
        });
    }
    return {
        name: "Source Middleware ".concat(fn.name),
        type: 'before',
        version: '0.1.0',
        isLoaded: function () { return true; },
        load: function (ctx) { return Promise.resolve(ctx); },
        track: apply,
        page: apply,
        identify: apply,
        alias: apply,
        group: apply,
    };
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 91137:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var obj_case_1 = __importDefault(__webpack_require__(75188));
function trait(a, b) {
    return function () {
        var traits = this.traits();
        var props = this.properties ? this.properties() : {};
        return (obj_case_1.default(traits, "address." + a) ||
            obj_case_1.default(traits, a) ||
            (b ? obj_case_1.default(traits, "address." + b) : null) ||
            (b ? obj_case_1.default(traits, b) : null) ||
            obj_case_1.default(props, "address." + a) ||
            obj_case_1.default(props, a) ||
            (b ? obj_case_1.default(props, "address." + b) : null) ||
            (b ? obj_case_1.default(props, b) : null));
    };
}
function default_1(proto) {
    proto.zip = trait("postalCode", "zip");
    proto.country = trait("country");
    proto.street = trait("street");
    proto.state = trait("state");
    proto.city = trait("city");
    proto.region = trait("region");
}
exports["default"] = default_1;
//# sourceMappingURL=address.js.map

/***/ }),

/***/ 10610:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Alias = void 0;
var inherits_1 = __importDefault(__webpack_require__(22111));
var facade_1 = __webpack_require__(97029);
function Alias(dictionary, opts) {
    facade_1.Facade.call(this, dictionary, opts);
}
exports.Alias = Alias;
inherits_1.default(Alias, facade_1.Facade);
Alias.prototype.action = function () {
    return "alias";
};
Alias.prototype.type = Alias.prototype.action;
Alias.prototype.previousId = function () {
    return this.field("previousId") || this.field("from");
};
Alias.prototype.from = Alias.prototype.previousId;
Alias.prototype.userId = function () {
    return this.field("userId") || this.field("to");
};
Alias.prototype.to = Alias.prototype.userId;
//# sourceMappingURL=alias.js.map

/***/ }),

/***/ 62089:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.clone = void 0;
function clone(properties) {
    if (typeof properties !== 'object')
        return properties;
    if (Object.prototype.toString.call(properties) === '[object Object]') {
        var temp = {};
        for (var key in properties) {
            if (Object.prototype.hasOwnProperty.call(properties, key)) {
                temp[key] = clone(properties[key]);
            }
        }
        return temp;
    }
    else if (Array.isArray(properties)) {
        return properties.map(clone);
    }
    else {
        return properties;
    }
}
exports.clone = clone;
//# sourceMappingURL=clone.js.map

/***/ }),

/***/ 93669:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Delete = void 0;
var inherits_1 = __importDefault(__webpack_require__(22111));
var facade_1 = __webpack_require__(97029);
function Delete(dictionary, opts) {
    facade_1.Facade.call(this, dictionary, opts);
}
exports.Delete = Delete;
inherits_1.default(Delete, facade_1.Facade);
Delete.prototype.type = function () {
    return "delete";
};
//# sourceMappingURL=delete.js.map

/***/ }),

/***/ 97029:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Facade = void 0;
var address_1 = __importDefault(__webpack_require__(91137));
var clone_1 = __webpack_require__(62089);
var is_enabled_1 = __importDefault(__webpack_require__(4055));
var new_date_1 = __importDefault(__webpack_require__(18463));
var obj_case_1 = __importDefault(__webpack_require__(75188));
var isodate_traverse_1 = __importDefault(__webpack_require__(51305));
function Facade(obj, opts) {
    opts = opts || {};
    this.raw = clone_1.clone(obj);
    if (!("clone" in opts))
        opts.clone = true;
    if (opts.clone)
        obj = clone_1.clone(obj);
    if (!("traverse" in opts))
        opts.traverse = true;
    if (!("timestamp" in obj))
        obj.timestamp = new Date();
    else
        obj.timestamp = new_date_1.default(obj.timestamp);
    if (opts.traverse)
        isodate_traverse_1.default(obj);
    this.opts = opts;
    this.obj = obj;
}
exports.Facade = Facade;
var f = Facade.prototype;
f.proxy = function (field) {
    var fields = field.split(".");
    field = fields.shift();
    var obj = this[field] || this.obj[field];
    if (!obj)
        return obj;
    if (typeof obj === "function")
        obj = obj.call(this) || {};
    if (fields.length === 0)
        return this.opts.clone ? transform(obj) : obj;
    obj = obj_case_1.default(obj, fields.join("."));
    return this.opts.clone ? transform(obj) : obj;
};
f.field = function (field) {
    var obj = this.obj[field];
    return this.opts.clone ? transform(obj) : obj;
};
Facade.proxy = function (field) {
    return function () {
        return this.proxy(field);
    };
};
Facade.field = function (field) {
    return function () {
        return this.field(field);
    };
};
Facade.multi = function (path) {
    return function () {
        var multi = this.proxy(path + "s");
        if (Array.isArray(multi))
            return multi;
        var one = this.proxy(path);
        if (one)
            one = [this.opts.clone ? clone_1.clone(one) : one];
        return one || [];
    };
};
Facade.one = function (path) {
    return function () {
        var one = this.proxy(path);
        if (one)
            return one;
        var multi = this.proxy(path + "s");
        if (Array.isArray(multi))
            return multi[0];
    };
};
f.json = function () {
    var ret = this.opts.clone ? clone_1.clone(this.obj) : this.obj;
    if (this.type)
        ret.type = this.type();
    return ret;
};
f.rawEvent = function () {
    return this.raw;
};
f.options = function (integration) {
    var obj = this.obj.options || this.obj.context || {};
    var options = this.opts.clone ? clone_1.clone(obj) : obj;
    if (!integration)
        return options;
    if (!this.enabled(integration))
        return;
    var integrations = this.integrations();
    var value = integrations[integration] || obj_case_1.default(integrations, integration);
    if (typeof value !== "object")
        value = obj_case_1.default(this.options(), integration);
    return typeof value === "object" ? value : {};
};
f.context = f.options;
f.enabled = function (integration) {
    var allEnabled = this.proxy("options.providers.all");
    if (typeof allEnabled !== "boolean")
        allEnabled = this.proxy("options.all");
    if (typeof allEnabled !== "boolean")
        allEnabled = this.proxy("integrations.all");
    if (typeof allEnabled !== "boolean")
        allEnabled = true;
    var enabled = allEnabled && is_enabled_1.default(integration);
    var options = this.integrations();
    if (options.providers && options.providers.hasOwnProperty(integration)) {
        enabled = options.providers[integration];
    }
    if (options.hasOwnProperty(integration)) {
        var settings = options[integration];
        if (typeof settings === "boolean") {
            enabled = settings;
        }
        else {
            enabled = true;
        }
    }
    return !!enabled;
};
f.integrations = function () {
    return (this.obj.integrations || this.proxy("options.providers") || this.options());
};
f.active = function () {
    var active = this.proxy("options.active");
    if (active === null || active === undefined)
        active = true;
    return active;
};
f.anonymousId = function () {
    return this.field("anonymousId") || this.field("sessionId");
};
f.sessionId = f.anonymousId;
f.groupId = Facade.proxy("options.groupId");
f.traits = function (aliases) {
    var ret = this.proxy("options.traits") || {};
    var id = this.userId();
    aliases = aliases || {};
    if (id)
        ret.id = id;
    for (var alias in aliases) {
        if (Object.prototype.hasOwnProperty.call(aliases, alias)) {
            var value = this[alias] == null
                ? this.proxy("options.traits." + alias)
                : this[alias]();
            if (value == null)
                continue;
            ret[aliases[alias]] = value;
            delete ret[alias];
        }
    }
    return ret;
};
f.library = function () {
    var library = this.proxy("options.library");
    if (!library)
        return { name: "unknown", version: null };
    if (typeof library === "string")
        return { name: library, version: null };
    return library;
};
f.device = function () {
    var device = this.proxy("context.device");
    if (typeof device !== "object" || device === null) {
        device = {};
    }
    var library = this.library().name;
    if (device.type)
        return device;
    if (library.indexOf("ios") > -1)
        device.type = "ios";
    if (library.indexOf("android") > -1)
        device.type = "android";
    return device;
};
f.userAgent = Facade.proxy("context.userAgent");
f.timezone = Facade.proxy("context.timezone");
f.timestamp = Facade.field("timestamp");
f.channel = Facade.field("channel");
f.ip = Facade.proxy("context.ip");
f.userId = Facade.field("userId");
address_1.default(f);
function transform(obj) {
    return clone_1.clone(obj);
}
//# sourceMappingURL=facade.js.map

/***/ }),

/***/ 72512:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Group = void 0;
var inherits_1 = __importDefault(__webpack_require__(22111));
var is_email_1 = __importDefault(__webpack_require__(48596));
var new_date_1 = __importDefault(__webpack_require__(18463));
var facade_1 = __webpack_require__(97029);
function Group(dictionary, opts) {
    facade_1.Facade.call(this, dictionary, opts);
}
exports.Group = Group;
inherits_1.default(Group, facade_1.Facade);
var g = Group.prototype;
g.action = function () {
    return "group";
};
g.type = g.action;
g.groupId = facade_1.Facade.field("groupId");
g.created = function () {
    var created = this.proxy("traits.createdAt") ||
        this.proxy("traits.created") ||
        this.proxy("properties.createdAt") ||
        this.proxy("properties.created");
    if (created)
        return new_date_1.default(created);
};
g.email = function () {
    var email = this.proxy("traits.email");
    if (email)
        return email;
    var groupId = this.groupId();
    if (is_email_1.default(groupId))
        return groupId;
};
g.traits = function (aliases) {
    var ret = this.properties();
    var id = this.groupId();
    aliases = aliases || {};
    if (id)
        ret.id = id;
    for (var alias in aliases) {
        if (Object.prototype.hasOwnProperty.call(aliases, alias)) {
            var value = this[alias] == null
                ? this.proxy("traits." + alias)
                : this[alias]();
            if (value == null)
                continue;
            ret[aliases[alias]] = value;
            delete ret[alias];
        }
    }
    return ret;
};
g.name = facade_1.Facade.proxy("traits.name");
g.industry = facade_1.Facade.proxy("traits.industry");
g.employees = facade_1.Facade.proxy("traits.employees");
g.properties = function () {
    return this.field("traits") || this.field("properties") || {};
};
//# sourceMappingURL=group.js.map

/***/ }),

/***/ 55062:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Identify = void 0;
var facade_1 = __webpack_require__(97029);
var obj_case_1 = __importDefault(__webpack_require__(75188));
var inherits_1 = __importDefault(__webpack_require__(22111));
var is_email_1 = __importDefault(__webpack_require__(48596));
var new_date_1 = __importDefault(__webpack_require__(18463));
var trim = function (str) { return str.trim(); };
function Identify(dictionary, opts) {
    facade_1.Facade.call(this, dictionary, opts);
}
exports.Identify = Identify;
inherits_1.default(Identify, facade_1.Facade);
var i = Identify.prototype;
i.action = function () {
    return "identify";
};
i.type = i.action;
i.traits = function (aliases) {
    var ret = this.field("traits") || {};
    var id = this.userId();
    aliases = aliases || {};
    if (id)
        ret.id = id;
    for (var alias in aliases) {
        var value = this[alias] == null ? this.proxy("traits." + alias) : this[alias]();
        if (value == null)
            continue;
        ret[aliases[alias]] = value;
        if (alias !== aliases[alias])
            delete ret[alias];
    }
    return ret;
};
i.email = function () {
    var email = this.proxy("traits.email");
    if (email)
        return email;
    var userId = this.userId();
    if (is_email_1.default(userId))
        return userId;
};
i.created = function () {
    var created = this.proxy("traits.created") || this.proxy("traits.createdAt");
    if (created)
        return new_date_1.default(created);
};
i.companyCreated = function () {
    var created = this.proxy("traits.company.created") ||
        this.proxy("traits.company.createdAt");
    if (created) {
        return new_date_1.default(created);
    }
};
i.companyName = function () {
    return this.proxy("traits.company.name");
};
i.name = function () {
    var name = this.proxy("traits.name");
    if (typeof name === "string") {
        return trim(name);
    }
    var firstName = this.firstName();
    var lastName = this.lastName();
    if (firstName && lastName) {
        return trim(firstName + " " + lastName);
    }
};
i.firstName = function () {
    var firstName = this.proxy("traits.firstName");
    if (typeof firstName === "string") {
        return trim(firstName);
    }
    var name = this.proxy("traits.name");
    if (typeof name === "string") {
        return trim(name).split(" ")[0];
    }
};
i.lastName = function () {
    var lastName = this.proxy("traits.lastName");
    if (typeof lastName === "string") {
        return trim(lastName);
    }
    var name = this.proxy("traits.name");
    if (typeof name !== "string") {
        return;
    }
    var space = trim(name).indexOf(" ");
    if (space === -1) {
        return;
    }
    return trim(name.substr(space + 1));
};
i.uid = function () {
    return this.userId() || this.username() || this.email();
};
i.description = function () {
    return this.proxy("traits.description") || this.proxy("traits.background");
};
i.age = function () {
    var date = this.birthday();
    var age = obj_case_1.default(this.traits(), "age");
    if (age != null)
        return age;
    if (!(date instanceof Date))
        return;
    var now = new Date();
    return now.getFullYear() - date.getFullYear();
};
i.avatar = function () {
    var traits = this.traits();
    return (obj_case_1.default(traits, "avatar") || obj_case_1.default(traits, "photoUrl") || obj_case_1.default(traits, "avatarUrl"));
};
i.position = function () {
    var traits = this.traits();
    return obj_case_1.default(traits, "position") || obj_case_1.default(traits, "jobTitle");
};
i.username = facade_1.Facade.proxy("traits.username");
i.website = facade_1.Facade.one("traits.website");
i.websites = facade_1.Facade.multi("traits.website");
i.phone = facade_1.Facade.one("traits.phone");
i.phones = facade_1.Facade.multi("traits.phone");
i.address = facade_1.Facade.proxy("traits.address");
i.gender = facade_1.Facade.proxy("traits.gender");
i.birthday = facade_1.Facade.proxy("traits.birthday");
//# sourceMappingURL=identify.js.map

/***/ }),

/***/ 22372:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Delete = exports.Screen = exports.Page = exports.Track = exports.Identify = exports.Group = exports.Alias = exports.Facade = void 0;
var facade_1 = __webpack_require__(97029);
Object.defineProperty(exports, "Facade", ({ enumerable: true, get: function () { return facade_1.Facade; } }));
var alias_1 = __webpack_require__(10610);
Object.defineProperty(exports, "Alias", ({ enumerable: true, get: function () { return alias_1.Alias; } }));
var group_1 = __webpack_require__(72512);
Object.defineProperty(exports, "Group", ({ enumerable: true, get: function () { return group_1.Group; } }));
var identify_1 = __webpack_require__(55062);
Object.defineProperty(exports, "Identify", ({ enumerable: true, get: function () { return identify_1.Identify; } }));
var track_1 = __webpack_require__(45928);
Object.defineProperty(exports, "Track", ({ enumerable: true, get: function () { return track_1.Track; } }));
var page_1 = __webpack_require__(7662);
Object.defineProperty(exports, "Page", ({ enumerable: true, get: function () { return page_1.Page; } }));
var screen_1 = __webpack_require__(74855);
Object.defineProperty(exports, "Screen", ({ enumerable: true, get: function () { return screen_1.Screen; } }));
var delete_1 = __webpack_require__(93669);
Object.defineProperty(exports, "Delete", ({ enumerable: true, get: function () { return delete_1.Delete; } }));
exports["default"] = __assign(__assign({}, facade_1.Facade), { Alias: alias_1.Alias,
    Group: group_1.Group,
    Identify: identify_1.Identify,
    Track: track_1.Track,
    Page: page_1.Page,
    Screen: screen_1.Screen,
    Delete: delete_1.Delete });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 48596:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var matcher = /.+\@.+\..+/;
function isEmail(string) {
    return matcher.test(string);
}
exports["default"] = isEmail;
//# sourceMappingURL=is-email.js.map

/***/ }),

/***/ 4055:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var disabled = {
    Salesforce: true,
};
function default_1(integration) {
    return !disabled[integration];
}
exports["default"] = default_1;
//# sourceMappingURL=is-enabled.js.map

/***/ }),

/***/ 7662:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Page = void 0;
var inherits_1 = __importDefault(__webpack_require__(22111));
var facade_1 = __webpack_require__(97029);
var track_1 = __webpack_require__(45928);
var is_email_1 = __importDefault(__webpack_require__(48596));
function Page(dictionary, opts) {
    facade_1.Facade.call(this, dictionary, opts);
}
exports.Page = Page;
inherits_1.default(Page, facade_1.Facade);
var p = Page.prototype;
p.action = function () {
    return "page";
};
p.type = p.action;
p.category = facade_1.Facade.field("category");
p.name = facade_1.Facade.field("name");
p.title = facade_1.Facade.proxy("properties.title");
p.path = facade_1.Facade.proxy("properties.path");
p.url = facade_1.Facade.proxy("properties.url");
p.referrer = function () {
    return (this.proxy("context.referrer.url") ||
        this.proxy("context.page.referrer") ||
        this.proxy("properties.referrer"));
};
p.properties = function (aliases) {
    var props = this.field("properties") || {};
    var category = this.category();
    var name = this.name();
    aliases = aliases || {};
    if (category)
        props.category = category;
    if (name)
        props.name = name;
    for (var alias in aliases) {
        if (Object.prototype.hasOwnProperty.call(aliases, alias)) {
            var value = this[alias] == null
                ? this.proxy("properties." + alias)
                : this[alias]();
            if (value == null)
                continue;
            props[aliases[alias]] = value;
            if (alias !== aliases[alias])
                delete props[alias];
        }
    }
    return props;
};
p.email = function () {
    var email = this.proxy("context.traits.email") || this.proxy("properties.email");
    if (email)
        return email;
    var userId = this.userId();
    if (is_email_1.default(userId))
        return userId;
};
p.fullName = function () {
    var category = this.category();
    var name = this.name();
    return name && category ? category + " " + name : name;
};
p.event = function (name) {
    return name ? "Viewed " + name + " Page" : "Loaded a Page";
};
p.track = function (name) {
    var json = this.json();
    json.event = this.event(name);
    json.timestamp = this.timestamp();
    json.properties = this.properties();
    return new track_1.Track(json, this.opts);
};
//# sourceMappingURL=page.js.map

/***/ }),

/***/ 74855:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Screen = void 0;
var inherits_1 = __importDefault(__webpack_require__(22111));
var page_1 = __webpack_require__(7662);
var track_1 = __webpack_require__(45928);
function Screen(dictionary, opts) {
    page_1.Page.call(this, dictionary, opts);
}
exports.Screen = Screen;
inherits_1.default(Screen, page_1.Page);
Screen.prototype.action = function () {
    return "screen";
};
Screen.prototype.type = Screen.prototype.action;
Screen.prototype.event = function (name) {
    return name ? "Viewed " + name + " Screen" : "Loaded a Screen";
};
Screen.prototype.track = function (name) {
    var json = this.json();
    json.event = this.event(name);
    json.timestamp = this.timestamp();
    json.properties = this.properties();
    return new track_1.Track(json, this.opts);
};
//# sourceMappingURL=screen.js.map

/***/ }),

/***/ 45928:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Track = void 0;
var inherits_1 = __importDefault(__webpack_require__(22111));
var facade_1 = __webpack_require__(97029);
var identify_1 = __webpack_require__(55062);
var is_email_1 = __importDefault(__webpack_require__(48596));
var obj_case_1 = __importDefault(__webpack_require__(75188));
function Track(dictionary, opts) {
    facade_1.Facade.call(this, dictionary, opts);
}
exports.Track = Track;
inherits_1.default(Track, facade_1.Facade);
var t = Track.prototype;
t.action = function () {
    return "track";
};
t.type = t.action;
t.event = facade_1.Facade.field("event");
t.value = facade_1.Facade.proxy("properties.value");
t.category = facade_1.Facade.proxy("properties.category");
t.id = facade_1.Facade.proxy("properties.id");
t.productId = function () {
    return (this.proxy("properties.product_id") || this.proxy("properties.productId"));
};
t.promotionId = function () {
    return (this.proxy("properties.promotion_id") ||
        this.proxy("properties.promotionId"));
};
t.cartId = function () {
    return this.proxy("properties.cart_id") || this.proxy("properties.cartId");
};
t.checkoutId = function () {
    return (this.proxy("properties.checkout_id") || this.proxy("properties.checkoutId"));
};
t.paymentId = function () {
    return (this.proxy("properties.payment_id") || this.proxy("properties.paymentId"));
};
t.couponId = function () {
    return (this.proxy("properties.coupon_id") || this.proxy("properties.couponId"));
};
t.wishlistId = function () {
    return (this.proxy("properties.wishlist_id") || this.proxy("properties.wishlistId"));
};
t.reviewId = function () {
    return (this.proxy("properties.review_id") || this.proxy("properties.reviewId"));
};
t.orderId = function () {
    return (this.proxy("properties.id") ||
        this.proxy("properties.order_id") ||
        this.proxy("properties.orderId"));
};
t.sku = facade_1.Facade.proxy("properties.sku");
t.tax = facade_1.Facade.proxy("properties.tax");
t.name = facade_1.Facade.proxy("properties.name");
t.price = facade_1.Facade.proxy("properties.price");
t.total = facade_1.Facade.proxy("properties.total");
t.repeat = facade_1.Facade.proxy("properties.repeat");
t.coupon = facade_1.Facade.proxy("properties.coupon");
t.shipping = facade_1.Facade.proxy("properties.shipping");
t.discount = facade_1.Facade.proxy("properties.discount");
t.shippingMethod = function () {
    return (this.proxy("properties.shipping_method") ||
        this.proxy("properties.shippingMethod"));
};
t.paymentMethod = function () {
    return (this.proxy("properties.payment_method") ||
        this.proxy("properties.paymentMethod"));
};
t.description = facade_1.Facade.proxy("properties.description");
t.plan = facade_1.Facade.proxy("properties.plan");
t.subtotal = function () {
    var subtotal = obj_case_1.default(this.properties(), "subtotal");
    var total = this.total() || this.revenue();
    if (subtotal)
        return subtotal;
    if (!total)
        return 0;
    if (this.total()) {
        var n = this.tax();
        if (n)
            total -= n;
        n = this.shipping();
        if (n)
            total -= n;
        n = this.discount();
        if (n)
            total += n;
    }
    return total;
};
t.products = function () {
    var props = this.properties();
    var products = obj_case_1.default(props, "products");
    if (Array.isArray(products)) {
        return products.filter(function (item) { return item !== null; });
    }
    return [];
};
t.quantity = function () {
    var props = this.obj.properties || {};
    return props.quantity || 1;
};
t.currency = function () {
    var props = this.obj.properties || {};
    return props.currency || "USD";
};
t.referrer = function () {
    return (this.proxy("context.referrer.url") ||
        this.proxy("context.page.referrer") ||
        this.proxy("properties.referrer"));
};
t.query = facade_1.Facade.proxy("options.query");
t.properties = function (aliases) {
    var ret = this.field("properties") || {};
    aliases = aliases || {};
    for (var alias in aliases) {
        if (Object.prototype.hasOwnProperty.call(aliases, alias)) {
            var value = this[alias] == null
                ? this.proxy("properties." + alias)
                : this[alias]();
            if (value == null)
                continue;
            ret[aliases[alias]] = value;
            delete ret[alias];
        }
    }
    return ret;
};
t.username = function () {
    return (this.proxy("traits.username") ||
        this.proxy("properties.username") ||
        this.userId() ||
        this.sessionId());
};
t.email = function () {
    var email = this.proxy("traits.email") ||
        this.proxy("properties.email") ||
        this.proxy("options.traits.email");
    if (email)
        return email;
    var userId = this.userId();
    if (is_email_1.default(userId))
        return userId;
};
t.revenue = function () {
    var revenue = this.proxy("properties.revenue");
    var event = this.event();
    var orderCompletedRegExp = /^[ _]?completed[ _]?order[ _]?|^[ _]?order[ _]?completed[ _]?$/i;
    if (!revenue && event && event.match(orderCompletedRegExp)) {
        revenue = this.proxy("properties.total");
    }
    return currency(revenue);
};
t.cents = function () {
    var revenue = this.revenue();
    return typeof revenue !== "number" ? this.value() || 0 : revenue * 100;
};
t.identify = function () {
    var json = this.json();
    json.traits = this.traits();
    return new identify_1.Identify(json, this.opts);
};
function currency(val) {
    if (!val)
        return;
    if (typeof val === "number") {
        return val;
    }
    if (typeof val !== "string") {
        return;
    }
    val = val.replace(/\$/g, "");
    val = parseFloat(val);
    if (!isNaN(val)) {
        return val;
    }
}
//# sourceMappingURL=track.js.map

/***/ }),

/***/ 51305:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isodate = __webpack_require__(87956);

/**
 * Expose `traverse`.
 */
module.exports = traverse;

/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */
function traverse(input, strict) {
  if (strict === undefined) strict = true;
  if (input && typeof input === 'object') {
    return traverseObject(input, strict);
  } else if (Array.isArray(input)) {
    return traverseArray(input, strict);
  } else if (isodate.is(input, strict)) {
    return isodate.parse(input);
  }
  return input;
}

/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */
function traverseObject(obj, strict) {
  Object.keys(obj).forEach(function(key) {
    obj[key] = traverse(obj[key], strict);
  });
  return obj;
}

/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */
function traverseArray(arr, strict) {
  arr.forEach(function(value, index) {
    arr[index] = traverse(value, strict);
  });
  return arr;
}


/***/ }),

/***/ 87956:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */

var matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;

/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */

exports.parse = function(iso) {
  var numericKeys = [1, 5, 6, 7, 11, 12];
  var arr = matcher.exec(iso);
  var offset = 0;

  // fallback to native parsing
  if (!arr) {
    return new Date(iso);
  }

  /* eslint-disable no-cond-assign */
  // remove undefined values
  for (var i = 0, val; val = numericKeys[i]; i++) {
    arr[val] = parseInt(arr[val], 10) || 0;
  }
  /* eslint-enable no-cond-assign */

  // allow undefined days and months
  arr[2] = parseInt(arr[2], 10) || 1;
  arr[3] = parseInt(arr[3], 10) || 1;

  // month is 0-11
  arr[2]--;

  // allow abitrary sub-second precision
  arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;

  // apply timezone if one exists
  if (arr[4] === ' ') {
    offset = new Date().getTimezoneOffset();
  } else if (arr[9] !== 'Z' && arr[10]) {
    offset = arr[11] * 60 + arr[12];
    if (arr[10] === '+') {
      offset = 0 - offset;
    }
  }

  var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
  return new Date(millis);
};


/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */

exports.is = function(string, strict) {
  if (typeof string !== 'string') {
    return false;
  }
  if (strict && (/^\d{4}-\d{2}-\d{2}/).test(string) === false) {
    return false;
  }
  return matcher.test(string);
};


/***/ }),

/***/ 82390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jQ": function() { return /* binding */ configure; },
  "BX": function() { return /* binding */ fireEvent; }
});

// UNUSED EXPORTS: buildQueries, createEvent, findAllByAltText, findAllByDisplayValue, findAllByLabelText, findAllByPlaceholderText, findAllByRole, findAllByTestId, findAllByText, findAllByTitle, findByAltText, findByDisplayValue, findByLabelText, findByPlaceholderText, findByRole, findByTestId, findByText, findByTitle, getAllByAltText, getAllByDisplayValue, getAllByLabelText, getAllByPlaceholderText, getAllByRole, getAllByTestId, getAllByText, getAllByTitle, getByAltText, getByDisplayValue, getByLabelText, getByPlaceholderText, getByRole, getByTestId, getByText, getByTitle, getConfig, getDefaultNormalizer, getElementError, getMultipleElementsFoundError, getNodeText, getQueriesForElement, getRoles, getSuggestedQuery, isInaccessible, logDOM, logRoles, makeFindQuery, makeGetAllQuery, makeSingleQuery, prettyDOM, prettyFormat, queries, queryAllByAltText, queryAllByAttribute, queryAllByDisplayValue, queryAllByLabelText, queryAllByPlaceholderText, queryAllByRole, queryAllByTestId, queryAllByText, queryAllByTitle, queryByAltText, queryByAttribute, queryByDisplayValue, queryByLabelText, queryByPlaceholderText, queryByRole, queryByTestId, queryByText, queryByTitle, queryHelpers, screen, waitFor, waitForElementToBeRemoved, within, wrapAllByQueryWithSuggestion, wrapSingleQueryWithSuggestion

// EXTERNAL MODULE: ../../../node_modules/@testing-library/dom/node_modules/pretty-format/build/index.js
var build = __webpack_require__(57739);
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/polyfills/array.from.mjs
/**
 * @source {https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Polyfill}
 * but without thisArg (too hard to type, no need to `this`)
 */
var toStr = Object.prototype.toString;
function isCallable(fn) {
  return typeof fn === "function" || toStr.call(fn) === "[object Function]";
}
function toInteger(value) {
  var number = Number(value);
  if (isNaN(number)) {
    return 0;
  }
  if (number === 0 || !isFinite(number)) {
    return number;
  }
  return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
}
var maxSafeInteger = Math.pow(2, 53) - 1;
function toLength(value) {
  var len = toInteger(value);
  return Math.min(Math.max(len, 0), maxSafeInteger);
}
/**
 * Creates an array from an iterable object.
 * @param iterable An iterable object to convert to an array.
 */

/**
 * Creates an array from an iterable object.
 * @param iterable An iterable object to convert to an array.
 * @param mapfn A mapping function to call on every element of the array.
 * @param thisArg Value of 'this' used to invoke the mapfn.
 */
function arrayFrom(arrayLike, mapFn) {
  // 1. Let C be the this value.
  // edit(@eps1lon): we're not calling it as Array.from
  var C = Array;

  // 2. Let items be ToObject(arrayLike).
  var items = Object(arrayLike);

  // 3. ReturnIfAbrupt(items).
  if (arrayLike == null) {
    throw new TypeError("Array.from requires an array-like object - not null or undefined");
  }

  // 4. If mapfn is undefined, then let mapping be false.
  // const mapFn = arguments.length > 1 ? arguments[1] : void undefined;

  if (typeof mapFn !== "undefined") {
    // 5. else
    // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
    if (!isCallable(mapFn)) {
      throw new TypeError("Array.from: when provided, the second argument must be a function");
    }
  }

  // 10. Let lenValue be Get(items, "length").
  // 11. Let len be ToLength(lenValue).
  var len = toLength(items.length);

  // 13. If IsConstructor(C) is true, then
  // 13. a. Let A be the result of calling the [[Construct]] internal method
  // of C with an argument list containing the single item len.
  // 14. a. Else, Let A be ArrayCreate(len).
  var A = isCallable(C) ? Object(new C(len)) : new Array(len);

  // 16. Let k be 0.
  var k = 0;
  // 17. Repeat, while k < len… (also steps a - h)
  var kValue;
  while (k < len) {
    kValue = items[k];
    if (mapFn) {
      A[k] = mapFn(kValue, k);
    } else {
      A[k] = kValue;
    }
    k += 1;
  }
  // 18. Let putStatus be Put(A, "length", len, true).
  A.length = len;
  // 20. Return A.
  return A;
}
//# sourceMappingURL=array.from.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/polyfills/SetLike.mjs
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// for environments without Set we fallback to arrays with unique members
var SetLike = /*#__PURE__*/function () {
  function SetLike() {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, SetLike);
    _defineProperty(this, "items", void 0);
    this.items = items;
  }
  _createClass(SetLike, [{
    key: "add",
    value: function add(value) {
      if (this.has(value) === false) {
        this.items.push(value);
      }
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.items = [];
    }
  }, {
    key: "delete",
    value: function _delete(value) {
      var previousLength = this.items.length;
      this.items = this.items.filter(function (item) {
        return item !== value;
      });
      return previousLength !== this.items.length;
    }
  }, {
    key: "forEach",
    value: function forEach(callbackfn) {
      var _this = this;
      this.items.forEach(function (item) {
        callbackfn(item, item, _this);
      });
    }
  }, {
    key: "has",
    value: function has(value) {
      return this.items.indexOf(value) !== -1;
    }
  }, {
    key: "size",
    get: function get() {
      return this.items.length;
    }
  }]);
  return SetLike;
}();
/* harmony default export */ var polyfills_SetLike = (typeof Set === "undefined" ? Set : SetLike);
//# sourceMappingURL=SetLike.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/getRole.mjs
// https://w3c.github.io/html-aria/#document-conformance-requirements-for-use-of-aria-attributes-in-html

/**
 * Safe Element.localName for all supported environments
 * @param element
 */
function getLocalName(element) {
  var _element$localName;
  return (// eslint-disable-next-line no-restricted-properties -- actual guard for environments without localName
    (_element$localName = element.localName) !== null && _element$localName !== void 0 ? _element$localName :
    // eslint-disable-next-line no-restricted-properties -- required for the fallback
    element.tagName.toLowerCase()
  );
}
var localNameToRoleMappings = {
  article: "article",
  aside: "complementary",
  button: "button",
  datalist: "listbox",
  dd: "definition",
  details: "group",
  dialog: "dialog",
  dt: "term",
  fieldset: "group",
  figure: "figure",
  // WARNING: Only with an accessible name
  form: "form",
  footer: "contentinfo",
  h1: "heading",
  h2: "heading",
  h3: "heading",
  h4: "heading",
  h5: "heading",
  h6: "heading",
  header: "banner",
  hr: "separator",
  html: "document",
  legend: "legend",
  li: "listitem",
  math: "math",
  main: "main",
  menu: "list",
  nav: "navigation",
  ol: "list",
  optgroup: "group",
  // WARNING: Only in certain context
  option: "option",
  output: "status",
  progress: "progressbar",
  // WARNING: Only with an accessible name
  section: "region",
  summary: "button",
  table: "table",
  tbody: "rowgroup",
  textarea: "textbox",
  tfoot: "rowgroup",
  // WARNING: Only in certain context
  td: "cell",
  th: "columnheader",
  thead: "rowgroup",
  tr: "row",
  ul: "list"
};
var prohibitedAttributes = {
  caption: new Set(["aria-label", "aria-labelledby"]),
  code: new Set(["aria-label", "aria-labelledby"]),
  deletion: new Set(["aria-label", "aria-labelledby"]),
  emphasis: new Set(["aria-label", "aria-labelledby"]),
  generic: new Set(["aria-label", "aria-labelledby", "aria-roledescription"]),
  insertion: new Set(["aria-label", "aria-labelledby"]),
  paragraph: new Set(["aria-label", "aria-labelledby"]),
  presentation: new Set(["aria-label", "aria-labelledby"]),
  strong: new Set(["aria-label", "aria-labelledby"]),
  subscript: new Set(["aria-label", "aria-labelledby"]),
  superscript: new Set(["aria-label", "aria-labelledby"])
};

/**
 *
 * @param element
 * @param role The role used for this element. This is specified to control whether you want to use the implicit or explicit role.
 */
function hasGlobalAriaAttributes(element, role) {
  // https://rawgit.com/w3c/aria/stable/#global_states
  // commented attributes are deprecated
  return ["aria-atomic", "aria-busy", "aria-controls", "aria-current", "aria-describedby", "aria-details",
  // "disabled",
  "aria-dropeffect",
  // "errormessage",
  "aria-flowto", "aria-grabbed",
  // "haspopup",
  "aria-hidden",
  // "invalid",
  "aria-keyshortcuts", "aria-label", "aria-labelledby", "aria-live", "aria-owns", "aria-relevant", "aria-roledescription"].some(function (attributeName) {
    var _prohibitedAttributes;
    return element.hasAttribute(attributeName) && !((_prohibitedAttributes = prohibitedAttributes[role]) !== null && _prohibitedAttributes !== void 0 && _prohibitedAttributes.has(attributeName));
  });
}
function ignorePresentationalRole(element, implicitRole) {
  // https://rawgit.com/w3c/aria/stable/#conflict_resolution_presentation_none
  return hasGlobalAriaAttributes(element, implicitRole);
}
function getRole(element) {
  var explicitRole = getExplicitRole(element);
  if (explicitRole === null || explicitRole === "presentation") {
    var implicitRole = getImplicitRole(element);
    if (explicitRole !== "presentation" || ignorePresentationalRole(element, implicitRole || "")) {
      return implicitRole;
    }
  }
  return explicitRole;
}
function getImplicitRole(element) {
  var mappedByTag = localNameToRoleMappings[getLocalName(element)];
  if (mappedByTag !== undefined) {
    return mappedByTag;
  }
  switch (getLocalName(element)) {
    case "a":
    case "area":
    case "link":
      if (element.hasAttribute("href")) {
        return "link";
      }
      break;
    case "img":
      if (element.getAttribute("alt") === "" && !ignorePresentationalRole(element, "img")) {
        return "presentation";
      }
      return "img";
    case "input":
      {
        var _ref = element,
          type = _ref.type;
        switch (type) {
          case "button":
          case "image":
          case "reset":
          case "submit":
            return "button";
          case "checkbox":
          case "radio":
            return type;
          case "range":
            return "slider";
          case "email":
          case "tel":
          case "text":
          case "url":
            if (element.hasAttribute("list")) {
              return "combobox";
            }
            return "textbox";
          case "search":
            if (element.hasAttribute("list")) {
              return "combobox";
            }
            return "searchbox";
          case "number":
            return "spinbutton";
          default:
            return null;
        }
      }
    case "select":
      if (element.hasAttribute("multiple") || element.size > 1) {
        return "listbox";
      }
      return "combobox";
  }
  return null;
}
function getExplicitRole(element) {
  var role = element.getAttribute("role");
  if (role !== null) {
    var explicitRole = role.trim().split(" ")[0];
    // String.prototype.split(sep, limit) will always return an array with at least one member
    // as long as limit is either undefined or > 0
    if (explicitRole.length > 0) {
      return explicitRole;
    }
  }
  return null;
}
//# sourceMappingURL=getRole.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/util.mjs


function isElement(node) {
  return node !== null && node.nodeType === node.ELEMENT_NODE;
}
function isHTMLTableCaptionElement(node) {
  return isElement(node) && getLocalName(node) === "caption";
}
function isHTMLInputElement(node) {
  return isElement(node) && getLocalName(node) === "input";
}
function isHTMLOptGroupElement(node) {
  return isElement(node) && getLocalName(node) === "optgroup";
}
function isHTMLSelectElement(node) {
  return isElement(node) && getLocalName(node) === "select";
}
function isHTMLTableElement(node) {
  return isElement(node) && getLocalName(node) === "table";
}
function isHTMLTextAreaElement(node) {
  return isElement(node) && getLocalName(node) === "textarea";
}
function safeWindow(node) {
  var _ref = node.ownerDocument === null ? node : node.ownerDocument,
    defaultView = _ref.defaultView;
  if (defaultView === null) {
    throw new TypeError("no window available");
  }
  return defaultView;
}
function isHTMLFieldSetElement(node) {
  return isElement(node) && getLocalName(node) === "fieldset";
}
function isHTMLLegendElement(node) {
  return isElement(node) && getLocalName(node) === "legend";
}
function isHTMLSlotElement(node) {
  return isElement(node) && getLocalName(node) === "slot";
}
function isSVGElement(node) {
  return isElement(node) && node.ownerSVGElement !== undefined;
}
function isSVGSVGElement(node) {
  return isElement(node) && getLocalName(node) === "svg";
}
function isSVGTitleElement(node) {
  return isSVGElement(node) && getLocalName(node) === "title";
}

/**
 *
 * @param {Node} node -
 * @param {string} attributeName -
 * @returns {Element[]} -
 */
function queryIdRefs(node, attributeName) {
  if (isElement(node) && node.hasAttribute(attributeName)) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute check
    var ids = node.getAttribute(attributeName).split(" ");

    // Browsers that don't support shadow DOM won't have getRootNode
    var root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
    return ids.map(function (id) {
      return root.getElementById(id);
    }).filter(function (element) {
      return element !== null;
    }
    // TODO: why does this not narrow?
    );
  }

  return [];
}
function hasAnyConcreteRoles(node, roles) {
  if (isElement(node)) {
    return roles.indexOf(getRole(node)) !== -1;
  }
  return false;
}
//# sourceMappingURL=util.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/accessible-name-and-description.mjs
/**
 * implements https://w3c.github.io/accname/
 */




/**
 *  A string of characters where all carriage returns, newlines, tabs, and form-feeds are replaced with a single space, and multiple spaces are reduced to a single space. The string contains only character data; it does not contain any markup.
 */

/**
 *
 * @param {string} string -
 * @returns {FlatString} -
 */
function asFlatString(s) {
  return s.trim().replace(/\s\s+/g, " ");
}

/**
 *
 * @param node -
 * @param options - These are not optional to prevent accidentally calling it without options in `computeAccessibleName`
 * @returns {boolean} -
 */
function isHidden(node, getComputedStyleImplementation) {
  if (!isElement(node)) {
    return false;
  }
  if (node.hasAttribute("hidden") || node.getAttribute("aria-hidden") === "true") {
    return true;
  }
  var style = getComputedStyleImplementation(node);
  return style.getPropertyValue("display") === "none" || style.getPropertyValue("visibility") === "hidden";
}

/**
 * @param {Node} node -
 * @returns {boolean} - As defined in step 2E of https://w3c.github.io/accname/#mapping_additional_nd_te
 */
function isControl(node) {
  return hasAnyConcreteRoles(node, ["button", "combobox", "listbox", "textbox"]) || hasAbstractRole(node, "range");
}
function hasAbstractRole(node, role) {
  if (!isElement(node)) {
    return false;
  }
  switch (role) {
    case "range":
      return hasAnyConcreteRoles(node, ["meter", "progressbar", "scrollbar", "slider", "spinbutton"]);
    default:
      throw new TypeError("No knowledge about abstract role '".concat(role, "'. This is likely a bug :("));
  }
}

/**
 * element.querySelectorAll but also considers owned tree
 * @param element
 * @param selectors
 */
function querySelectorAllSubtree(element, selectors) {
  var elements = arrayFrom(element.querySelectorAll(selectors));
  queryIdRefs(element, "aria-owns").forEach(function (root) {
    // babel transpiles this assuming an iterator
    elements.push.apply(elements, arrayFrom(root.querySelectorAll(selectors)));
  });
  return elements;
}
function querySelectedOptions(listbox) {
  if (isHTMLSelectElement(listbox)) {
    // IE11 polyfill
    return listbox.selectedOptions || querySelectorAllSubtree(listbox, "[selected]");
  }
  return querySelectorAllSubtree(listbox, '[aria-selected="true"]');
}
function isMarkedPresentational(node) {
  return hasAnyConcreteRoles(node, ["none", "presentation"]);
}

/**
 * Elements specifically listed in html-aam
 *
 * We don't need this for `label` or `legend` elements.
 * Their implicit roles already allow "naming from content".
 *
 * sources:
 *
 * - https://w3c.github.io/html-aam/#table-element
 */
function isNativeHostLanguageTextAlternativeElement(node) {
  return isHTMLTableCaptionElement(node);
}

/**
 * https://w3c.github.io/aria/#namefromcontent
 */
function allowsNameFromContent(node) {
  return hasAnyConcreteRoles(node, ["button", "cell", "checkbox", "columnheader", "gridcell", "heading", "label", "legend", "link", "menuitem", "menuitemcheckbox", "menuitemradio", "option", "radio", "row", "rowheader", "switch", "tab", "tooltip", "treeitem"]);
}

/**
 * TODO https://github.com/eps1lon/dom-accessibility-api/issues/100
 */
function isDescendantOfNativeHostLanguageTextAlternativeElement(
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- not implemented yet
node) {
  return false;
}
function getValueOfTextbox(element) {
  if (isHTMLInputElement(element) || isHTMLTextAreaElement(element)) {
    return element.value;
  }
  // https://github.com/eps1lon/dom-accessibility-api/issues/4
  return element.textContent || "";
}
function getTextualContent(declaration) {
  var content = declaration.getPropertyValue("content");
  if (/^["'].*["']$/.test(content)) {
    return content.slice(1, -1);
  }
  return "";
}

/**
 * https://html.spec.whatwg.org/multipage/forms.html#category-label
 * TODO: form-associated custom elements
 * @param element
 */
function isLabelableElement(element) {
  var localName = getLocalName(element);
  return localName === "button" || localName === "input" && element.getAttribute("type") !== "hidden" || localName === "meter" || localName === "output" || localName === "progress" || localName === "select" || localName === "textarea";
}

/**
 * > [...], then the first such descendant in tree order is the label element's labeled control.
 * -- https://html.spec.whatwg.org/multipage/forms.html#labeled-control
 * @param element
 */
function findLabelableElement(element) {
  if (isLabelableElement(element)) {
    return element;
  }
  var labelableElement = null;
  element.childNodes.forEach(function (childNode) {
    if (labelableElement === null && isElement(childNode)) {
      var descendantLabelableElement = findLabelableElement(childNode);
      if (descendantLabelableElement !== null) {
        labelableElement = descendantLabelableElement;
      }
    }
  });
  return labelableElement;
}

/**
 * Polyfill of HTMLLabelElement.control
 * https://html.spec.whatwg.org/multipage/forms.html#labeled-control
 * @param label
 */
function getControlOfLabel(label) {
  if (label.control !== undefined) {
    return label.control;
  }
  var htmlFor = label.getAttribute("for");
  if (htmlFor !== null) {
    return label.ownerDocument.getElementById(htmlFor);
  }
  return findLabelableElement(label);
}

/**
 * Polyfill of HTMLInputElement.labels
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/labels
 * @param element
 */
function getLabels(element) {
  var labelsProperty = element.labels;
  if (labelsProperty === null) {
    return labelsProperty;
  }
  if (labelsProperty !== undefined) {
    return arrayFrom(labelsProperty);
  }

  // polyfill
  if (!isLabelableElement(element)) {
    return null;
  }
  var document = element.ownerDocument;
  return arrayFrom(document.querySelectorAll("label")).filter(function (label) {
    return getControlOfLabel(label) === element;
  });
}

/**
 * Gets the contents of a slot used for computing the accname
 * @param slot
 */
function getSlotContents(slot) {
  // Computing the accessible name for elements containing slots is not
  // currently defined in the spec. This implementation reflects the
  // behavior of NVDA 2020.2/Firefox 81 and iOS VoiceOver/Safari 13.6.
  var assignedNodes = slot.assignedNodes();
  if (assignedNodes.length === 0) {
    // if no nodes are assigned to the slot, it displays the default content
    return arrayFrom(slot.childNodes);
  }
  return assignedNodes;
}

/**
 * implements https://w3c.github.io/accname/#mapping_additional_nd_te
 * @param root
 * @param options
 * @returns
 */
function computeTextAlternative(root) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var consultedNodes = new polyfills_SetLike();
  var window = safeWindow(root);
  var _options$compute = options.compute,
    compute = _options$compute === void 0 ? "name" : _options$compute,
    _options$computedStyl = options.computedStyleSupportsPseudoElements,
    computedStyleSupportsPseudoElements = _options$computedStyl === void 0 ? options.getComputedStyle !== undefined : _options$computedStyl,
    _options$getComputedS = options.getComputedStyle,
    getComputedStyle = _options$getComputedS === void 0 ? window.getComputedStyle.bind(window) : _options$getComputedS,
    _options$hidden = options.hidden,
    hidden = _options$hidden === void 0 ? false : _options$hidden;

  // 2F.i
  function computeMiscTextAlternative(node, context) {
    var accumulatedText = "";
    if (isElement(node) && computedStyleSupportsPseudoElements) {
      var pseudoBefore = getComputedStyle(node, "::before");
      var beforeContent = getTextualContent(pseudoBefore);
      accumulatedText = "".concat(beforeContent, " ").concat(accumulatedText);
    }

    // FIXME: Including aria-owns is not defined in the spec
    // But it is required in the web-platform-test
    var childNodes = isHTMLSlotElement(node) ? getSlotContents(node) : arrayFrom(node.childNodes).concat(queryIdRefs(node, "aria-owns"));
    childNodes.forEach(function (child) {
      var result = computeTextAlternative(child, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false,
        recursion: true
      });
      // TODO: Unclear why display affects delimiter
      // see https://github.com/w3c/accname/issues/3
      var display = isElement(child) ? getComputedStyle(child).getPropertyValue("display") : "inline";
      var separator = display !== "inline" ? " " : "";
      // trailing separator for wpt tests
      accumulatedText += "".concat(separator).concat(result).concat(separator);
    });
    if (isElement(node) && computedStyleSupportsPseudoElements) {
      var pseudoAfter = getComputedStyle(node, "::after");
      var afterContent = getTextualContent(pseudoAfter);
      accumulatedText = "".concat(accumulatedText, " ").concat(afterContent);
    }
    return accumulatedText.trim();
  }

  /**
   *
   * @param element
   * @param attributeName
   * @returns A string non-empty string or `null`
   */
  function useAttribute(element, attributeName) {
    var attribute = element.getAttributeNode(attributeName);
    if (attribute !== null && !consultedNodes.has(attribute) && attribute.value.trim() !== "") {
      consultedNodes.add(attribute);
      return attribute.value;
    }
    return null;
  }
  function computeTooltipAttributeValue(node) {
    if (!isElement(node)) {
      return null;
    }
    return useAttribute(node, "title");
  }
  function computeElementTextAlternative(node) {
    if (!isElement(node)) {
      return null;
    }

    // https://w3c.github.io/html-aam/#fieldset-and-legend-elements
    if (isHTMLFieldSetElement(node)) {
      consultedNodes.add(node);
      var children = arrayFrom(node.childNodes);
      for (var i = 0; i < children.length; i += 1) {
        var child = children[i];
        if (isHTMLLegendElement(child)) {
          return computeTextAlternative(child, {
            isEmbeddedInLabel: false,
            isReferenced: false,
            recursion: false
          });
        }
      }
    } else if (isHTMLTableElement(node)) {
      // https://w3c.github.io/html-aam/#table-element
      consultedNodes.add(node);
      var _children = arrayFrom(node.childNodes);
      for (var _i = 0; _i < _children.length; _i += 1) {
        var _child = _children[_i];
        if (isHTMLTableCaptionElement(_child)) {
          return computeTextAlternative(_child, {
            isEmbeddedInLabel: false,
            isReferenced: false,
            recursion: false
          });
        }
      }
    } else if (isSVGSVGElement(node)) {
      // https://www.w3.org/TR/svg-aam-1.0/
      consultedNodes.add(node);
      var _children2 = arrayFrom(node.childNodes);
      for (var _i2 = 0; _i2 < _children2.length; _i2 += 1) {
        var _child2 = _children2[_i2];
        if (isSVGTitleElement(_child2)) {
          return _child2.textContent;
        }
      }
      return null;
    } else if (getLocalName(node) === "img" || getLocalName(node) === "area") {
      // https://w3c.github.io/html-aam/#area-element
      // https://w3c.github.io/html-aam/#img-element
      var nameFromAlt = useAttribute(node, "alt");
      if (nameFromAlt !== null) {
        return nameFromAlt;
      }
    } else if (isHTMLOptGroupElement(node)) {
      var nameFromLabel = useAttribute(node, "label");
      if (nameFromLabel !== null) {
        return nameFromLabel;
      }
    }
    if (isHTMLInputElement(node) && (node.type === "button" || node.type === "submit" || node.type === "reset")) {
      // https://w3c.github.io/html-aam/#input-type-text-input-type-password-input-type-search-input-type-tel-input-type-email-input-type-url-and-textarea-element-accessible-description-computation
      var nameFromValue = useAttribute(node, "value");
      if (nameFromValue !== null) {
        return nameFromValue;
      }

      // TODO: l10n
      if (node.type === "submit") {
        return "Submit";
      }
      // TODO: l10n
      if (node.type === "reset") {
        return "Reset";
      }
    }
    var labels = getLabels(node);
    if (labels !== null && labels.length !== 0) {
      consultedNodes.add(node);
      return arrayFrom(labels).map(function (element) {
        return computeTextAlternative(element, {
          isEmbeddedInLabel: true,
          isReferenced: false,
          recursion: true
        });
      }).filter(function (label) {
        return label.length > 0;
      }).join(" ");
    }

    // https://w3c.github.io/html-aam/#input-type-image-accessible-name-computation
    // TODO: wpt test consider label elements but html-aam does not mention them
    // We follow existing implementations over spec
    if (isHTMLInputElement(node) && node.type === "image") {
      var _nameFromAlt = useAttribute(node, "alt");
      if (_nameFromAlt !== null) {
        return _nameFromAlt;
      }
      var nameFromTitle = useAttribute(node, "title");
      if (nameFromTitle !== null) {
        return nameFromTitle;
      }

      // TODO: l10n
      return "Submit Query";
    }
    if (hasAnyConcreteRoles(node, ["button"])) {
      // https://www.w3.org/TR/html-aam-1.0/#button-element
      var nameFromSubTree = computeMiscTextAlternative(node, {
        isEmbeddedInLabel: false,
        isReferenced: false
      });
      if (nameFromSubTree !== "") {
        return nameFromSubTree;
      }
    }
    return null;
  }
  function computeTextAlternative(current, context) {
    if (consultedNodes.has(current)) {
      return "";
    }

    // 2A
    if (!hidden && isHidden(current, getComputedStyle) && !context.isReferenced) {
      consultedNodes.add(current);
      return "";
    }

    // 2B
    var labelAttributeNode = isElement(current) ? current.getAttributeNode("aria-labelledby") : null;
    // TODO: Do we generally need to block query IdRefs of attributes we have already consulted?
    var labelElements = labelAttributeNode !== null && !consultedNodes.has(labelAttributeNode) ? queryIdRefs(current, "aria-labelledby") : [];
    if (compute === "name" && !context.isReferenced && labelElements.length > 0) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- Can't be null here otherwise labelElements would be empty
      consultedNodes.add(labelAttributeNode);
      return labelElements.map(function (element) {
        // TODO: Chrome will consider repeated values i.e. use a node multiple times while we'll bail out in computeTextAlternative.
        return computeTextAlternative(element, {
          isEmbeddedInLabel: context.isEmbeddedInLabel,
          isReferenced: true,
          // this isn't recursion as specified, otherwise we would skip
          // `aria-label` in
          // <input id="myself" aria-label="foo" aria-labelledby="myself"
          recursion: false
        });
      }).join(" ");
    }

    // 2C
    // Changed from the spec in anticipation of https://github.com/w3c/accname/issues/64
    // spec says we should only consider skipping if we have a non-empty label
    var skipToStep2E = context.recursion && isControl(current) && compute === "name";
    if (!skipToStep2E) {
      var ariaLabel = (isElement(current) && current.getAttribute("aria-label") || "").trim();
      if (ariaLabel !== "" && compute === "name") {
        consultedNodes.add(current);
        return ariaLabel;
      }

      // 2D
      if (!isMarkedPresentational(current)) {
        var elementTextAlternative = computeElementTextAlternative(current);
        if (elementTextAlternative !== null) {
          consultedNodes.add(current);
          return elementTextAlternative;
        }
      }
    }

    // special casing, cheating to make tests pass
    // https://github.com/w3c/accname/issues/67
    if (hasAnyConcreteRoles(current, ["menu"])) {
      consultedNodes.add(current);
      return "";
    }

    // 2E
    if (skipToStep2E || context.isEmbeddedInLabel || context.isReferenced) {
      if (hasAnyConcreteRoles(current, ["combobox", "listbox"])) {
        consultedNodes.add(current);
        var selectedOptions = querySelectedOptions(current);
        if (selectedOptions.length === 0) {
          // defined per test `name_heading_combobox`
          return isHTMLInputElement(current) ? current.value : "";
        }
        return arrayFrom(selectedOptions).map(function (selectedOption) {
          return computeTextAlternative(selectedOption, {
            isEmbeddedInLabel: context.isEmbeddedInLabel,
            isReferenced: false,
            recursion: true
          });
        }).join(" ");
      }
      if (hasAbstractRole(current, "range")) {
        consultedNodes.add(current);
        if (current.hasAttribute("aria-valuetext")) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute guard
          return current.getAttribute("aria-valuetext");
        }
        if (current.hasAttribute("aria-valuenow")) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute guard
          return current.getAttribute("aria-valuenow");
        }
        // Otherwise, use the value as specified by a host language attribute.
        return current.getAttribute("value") || "";
      }
      if (hasAnyConcreteRoles(current, ["textbox"])) {
        consultedNodes.add(current);
        return getValueOfTextbox(current);
      }
    }

    // 2F: https://w3c.github.io/accname/#step2F
    if (allowsNameFromContent(current) || isElement(current) && context.isReferenced || isNativeHostLanguageTextAlternativeElement(current) || isDescendantOfNativeHostLanguageTextAlternativeElement(current)) {
      var accumulatedText2F = computeMiscTextAlternative(current, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false
      });
      if (accumulatedText2F !== "") {
        consultedNodes.add(current);
        return accumulatedText2F;
      }
    }
    if (current.nodeType === current.TEXT_NODE) {
      consultedNodes.add(current);
      return current.textContent || "";
    }
    if (context.recursion) {
      consultedNodes.add(current);
      return computeMiscTextAlternative(current, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false
      });
    }
    var tooltipAttributeValue = computeTooltipAttributeValue(current);
    if (tooltipAttributeValue !== null) {
      consultedNodes.add(current);
      return tooltipAttributeValue;
    }

    // TODO should this be reachable?
    consultedNodes.add(current);
    return "";
  }
  return asFlatString(computeTextAlternative(root, {
    isEmbeddedInLabel: false,
    // by spec computeAccessibleDescription starts with the referenced elements as roots
    isReferenced: compute === "description",
    recursion: false
  }));
}
//# sourceMappingURL=accessible-name-and-description.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/accessible-description.mjs
function accessible_description_typeof(obj) { "@babel/helpers - typeof"; return accessible_description_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, accessible_description_typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { accessible_description_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function accessible_description_defineProperty(obj, key, value) { key = accessible_description_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function accessible_description_toPropertyKey(arg) { var key = accessible_description_toPrimitive(arg, "string"); return accessible_description_typeof(key) === "symbol" ? key : String(key); }
function accessible_description_toPrimitive(input, hint) { if (accessible_description_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (accessible_description_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }



/**
 * @param root
 * @param options
 * @returns
 */
function computeAccessibleDescription(root) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var description = queryIdRefs(root, "aria-describedby").map(function (element) {
    return computeTextAlternative(element, _objectSpread(_objectSpread({}, options), {}, {
      compute: "description"
    }));
  }).join(" ");

  // TODO: Technically we need to make sure that node wasn't used for the accessible name
  //       This causes `description_1.0_combobox-focusable-manual` to fail
  //
  // https://www.w3.org/TR/html-aam-1.0/#accessible-name-and-description-computation
  // says for so many elements to use the `title` that we assume all elements are considered
  if (description === "") {
    var title = root.getAttribute("title");
    description = title === null ? "" : title;
  }
  return description;
}
//# sourceMappingURL=accessible-description.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/accessible-name.mjs



/**
 * https://w3c.github.io/aria/#namefromprohibited
 */
function prohibitsNaming(node) {
  return hasAnyConcreteRoles(node, ["caption", "code", "deletion", "emphasis", "generic", "insertion", "paragraph", "presentation", "strong", "subscript", "superscript"]);
}

/**
 * implements https://w3c.github.io/accname/#mapping_additional_nd_name
 * @param root
 * @param options
 * @returns
 */
function computeAccessibleName(root) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (prohibitsNaming(root)) {
    return "";
  }
  return computeTextAlternative(root, options);
}
//# sourceMappingURL=accessible-name.mjs.map
;// CONCATENATED MODULE: ../../../node_modules/dom-accessibility-api/dist/index.mjs




//# sourceMappingURL=index.mjs.map
// EXTERNAL MODULE: ../../../node_modules/aria-query/lib/index.js
var lib = __webpack_require__(41516);
// EXTERNAL MODULE: ../../../node_modules/lz-string/libs/lz-string.js
var lz_string = __webpack_require__(26499);
var lz_string_default = /*#__PURE__*/__webpack_require__.n(lz_string);
;// CONCATENATED MODULE: ../../../node_modules/@testing-library/dom/dist/@testing-library/dom.esm.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(13158);






/**
 * Source: https://github.com/facebook/jest/blob/e7bb6a1e26ffab90611b2593912df15b69315611/packages/pretty-format/src/plugins/DOMElement.ts
 */
/* eslint-disable -- trying to stay as close to the original as possible */
/* istanbul ignore file */

function escapeHTML(str) {
  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
// Return empty string if keys is empty.
const printProps = (keys, props, config, indentation, depth, refs, printer) => {
  const indentationNext = indentation + config.indent;
  const colors = config.colors;
  return keys.map(key => {
    const value = props[key];
    let printed = printer(value, config, indentationNext, depth, refs);
    if (typeof value !== 'string') {
      if (printed.indexOf('\n') !== -1) {
        printed = config.spacingOuter + indentationNext + printed + config.spacingOuter + indentation;
      }
      printed = '{' + printed + '}';
    }
    return config.spacingInner + indentation + colors.prop.open + key + colors.prop.close + '=' + colors.value.open + printed + colors.value.close;
  }).join('');
};

// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#node_type_constants
const NodeTypeTextNode = 3;

// Return empty string if children is empty.
const printChildren = (children, config, indentation, depth, refs, printer) => children.map(child => {
  const printedChild = typeof child === 'string' ? printText(child, config) : printer(child, config, indentation, depth, refs);
  if (printedChild === '' && typeof child === 'object' && child !== null && child.nodeType !== NodeTypeTextNode) {
    // A plugin serialized this Node to '' meaning we should ignore it.
    return '';
  }
  return config.spacingOuter + indentation + printedChild;
}).join('');
const printText = (text, config) => {
  const contentColor = config.colors.content;
  return contentColor.open + escapeHTML(text) + contentColor.close;
};
const printComment = (comment, config) => {
  const commentColor = config.colors.comment;
  return commentColor.open + '<!--' + escapeHTML(comment) + '-->' + commentColor.close;
};

// Separate the functions to format props, children, and element,
// so a plugin could override a particular function, if needed.
// Too bad, so sad: the traditional (but unnecessary) space
// in a self-closing tagColor requires a second test of printedProps.
const printElement = (type, printedProps, printedChildren, config, indentation) => {
  const tagColor = config.colors.tag;
  return tagColor.open + '<' + type + (printedProps && tagColor.close + printedProps + config.spacingOuter + indentation + tagColor.open) + (printedChildren ? '>' + tagColor.close + printedChildren + config.spacingOuter + indentation + tagColor.open + '</' + type : (printedProps && !config.min ? '' : ' ') + '/') + '>' + tagColor.close;
};
const printElementAsLeaf = (type, config) => {
  const tagColor = config.colors.tag;
  return tagColor.open + '<' + type + tagColor.close + ' …' + tagColor.open + ' />' + tagColor.close;
};
const ELEMENT_NODE$1 = 1;
const TEXT_NODE$1 = 3;
const COMMENT_NODE$1 = 8;
const FRAGMENT_NODE = 11;
const ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/;
const testNode = val => {
  const constructorName = val.constructor.name;
  const {
    nodeType,
    tagName
  } = val;
  const isCustomElement = typeof tagName === 'string' && tagName.includes('-') || typeof val.hasAttribute === 'function' && val.hasAttribute('is');
  return nodeType === ELEMENT_NODE$1 && (ELEMENT_REGEXP.test(constructorName) || isCustomElement) || nodeType === TEXT_NODE$1 && constructorName === 'Text' || nodeType === COMMENT_NODE$1 && constructorName === 'Comment' || nodeType === FRAGMENT_NODE && constructorName === 'DocumentFragment';
};
function nodeIsText(node) {
  return node.nodeType === TEXT_NODE$1;
}
function nodeIsComment(node) {
  return node.nodeType === COMMENT_NODE$1;
}
function nodeIsFragment(node) {
  return node.nodeType === FRAGMENT_NODE;
}
function createDOMElementFilter(filterNode) {
  return {
    test: val => {
      var _val$constructor2;
      return (val == null ? void 0 : (_val$constructor2 = val.constructor) == null ? void 0 : _val$constructor2.name) && testNode(val);
    },
    serialize: (node, config, indentation, depth, refs, printer) => {
      if (nodeIsText(node)) {
        return printText(node.data, config);
      }
      if (nodeIsComment(node)) {
        return printComment(node.data, config);
      }
      const type = nodeIsFragment(node) ? "DocumentFragment" : node.tagName.toLowerCase();
      if (++depth > config.maxDepth) {
        return printElementAsLeaf(type, config);
      }
      return printElement(type, printProps(nodeIsFragment(node) ? [] : Array.from(node.attributes).map(attr => attr.name).sort(), nodeIsFragment(node) ? {} : Array.from(node.attributes).reduce((props, attribute) => {
        props[attribute.name] = attribute.value;
        return props;
      }, {}), config, indentation + config.indent, depth, refs, printer), printChildren(Array.prototype.slice.call(node.childNodes || node.children).filter(filterNode), config, indentation + config.indent, depth, refs, printer), config, indentation);
    }
  };
}

// We try to load node dependencies
let chalk = null;
let readFileSync = null;
let codeFrameColumns = null;
try {
  const nodeRequire = module && module.require;
  readFileSync = nodeRequire.call(module, 'fs').readFileSync;
  codeFrameColumns = nodeRequire.call(module, '@babel/code-frame').codeFrameColumns;
  chalk = nodeRequire.call(module, 'chalk');
} catch {
  // We're in a browser environment
}

// frame has the form "at myMethod (location/to/my/file.js:10:2)"
function getCodeFrame(frame) {
  const locationStart = frame.indexOf('(') + 1;
  const locationEnd = frame.indexOf(')');
  const frameLocation = frame.slice(locationStart, locationEnd);
  const frameLocationElements = frameLocation.split(':');
  const [filename, line, column] = [frameLocationElements[0], parseInt(frameLocationElements[1], 10), parseInt(frameLocationElements[2], 10)];
  let rawFileContents = '';
  try {
    rawFileContents = readFileSync(filename, 'utf-8');
  } catch {
    return '';
  }
  const codeFrame = codeFrameColumns(rawFileContents, {
    start: {
      line,
      column
    }
  }, {
    highlightCode: true,
    linesBelow: 0
  });
  return chalk.dim(frameLocation) + "\n" + codeFrame + "\n";
}
function getUserCodeFrame() {
  // If we couldn't load dependencies, we can't generate the user trace
  /* istanbul ignore next */
  if (!readFileSync || !codeFrameColumns) {
    return '';
  }
  const err = new Error();
  const firstClientCodeFrame = err.stack.split('\n').slice(1) // Remove first line which has the form "Error: TypeError"
  .find(frame => !frame.includes('node_modules/')); // Ignore frames from 3rd party libraries

  return getCodeFrame(firstClientCodeFrame);
}

// Constant node.nodeType for text nodes, see:
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#Node_type_constants
const TEXT_NODE = 3;
function jestFakeTimersAreEnabled() {
  /* istanbul ignore else */
  // eslint-disable-next-line
  if (typeof jest !== 'undefined' && jest !== null) {
    return (
      // legacy timers
      setTimeout._isMockFunction === true ||
      // modern timers
      Object.prototype.hasOwnProperty.call(setTimeout, 'clock')
    );
  }
  // istanbul ignore next
  return false;
}
function getDocument() {
  /* istanbul ignore if */
  if (typeof window === 'undefined') {
    throw new Error('Could not find default container');
  }
  return window.document;
}
function getWindowFromNode(node) {
  if (node.defaultView) {
    // node is document
    return node.defaultView;
  } else if (node.ownerDocument && node.ownerDocument.defaultView) {
    // node is a DOM node
    return node.ownerDocument.defaultView;
  } else if (node.window) {
    // node is window
    return node.window;
  } else if (node.ownerDocument && node.ownerDocument.defaultView === null) {
    throw new Error("It looks like the window object is not available for the provided node.");
  } else if (node.then instanceof Function) {
    throw new Error("It looks like you passed a Promise object instead of a DOM node. Did you do something like `fireEvent.click(screen.findBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`, or await the findBy query `fireEvent.click(await screen.findBy...`?");
  } else if (Array.isArray(node)) {
    throw new Error("It looks like you passed an Array instead of a DOM node. Did you do something like `fireEvent.click(screen.getAllBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`?");
  } else if (typeof node.debug === 'function' && typeof node.logTestingPlaygroundURL === 'function') {
    throw new Error("It looks like you passed a `screen` object. Did you do something like `fireEvent.click(screen, ...` when you meant to use a query, e.g. `fireEvent.click(screen.getBy..., `?");
  } else {
    // The user passed something unusual to a calling function
    throw new Error("The given node is not an Element, the node type is: " + typeof node + ".");
  }
}
function checkContainerType(container) {
  if (!container || !(typeof container.querySelector === 'function') || !(typeof container.querySelectorAll === 'function')) {
    throw new TypeError("Expected container to be an Element, a Document or a DocumentFragment but got " + getTypeName(container) + ".");
  }
  function getTypeName(object) {
    if (typeof object === 'object') {
      return object === null ? 'null' : object.constructor.name;
    }
    return typeof object;
  }
}

const shouldHighlight = () => {
  let colors;
  try {
    var _process, _process$env;
    colors = JSON.parse((_process = process) == null ? void 0 : (_process$env = _process.env) == null ? void 0 : _process$env.COLORS);
  } catch (e) {
    // If this throws, process?.env?.COLORS wasn't parsable. Since we only
    // care about `true` or `false`, we can safely ignore the error.
  }
  if (typeof colors === 'boolean') {
    // If `colors` is set explicitly (both `true` and `false`), use that value.
    return colors;
  } else {
    // If `colors` is not set, colorize if we're in node.
    return typeof process !== 'undefined' && process.versions !== undefined && process.versions.node !== undefined;
  }
};
const {
  DOMCollection
} = build/* plugins */.Gr;

// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#node_type_constants
const ELEMENT_NODE = 1;
const COMMENT_NODE = 8;

// https://github.com/facebook/jest/blob/615084195ae1ae61ddd56162c62bbdda17587569/packages/pretty-format/src/plugins/DOMElement.ts#L50
function filterCommentsAndDefaultIgnoreTagsTags(value) {
  return value.nodeType !== COMMENT_NODE && (value.nodeType !== ELEMENT_NODE || !value.matches(getConfig().defaultIgnore));
}
function prettyDOM(dom, maxLength, options) {
  if (options === void 0) {
    options = {};
  }
  if (!dom) {
    dom = getDocument().body;
  }
  if (typeof maxLength !== 'number') {
    maxLength = typeof process !== 'undefined' && process.env.DEBUG_PRINT_LIMIT || 7000;
  }
  if (maxLength === 0) {
    return '';
  }
  if (dom.documentElement) {
    dom = dom.documentElement;
  }
  let domTypeName = typeof dom;
  if (domTypeName === 'object') {
    domTypeName = dom.constructor.name;
  } else {
    // To don't fall with `in` operator
    dom = {};
  }
  if (!('outerHTML' in dom)) {
    throw new TypeError("Expected an element or document but got " + domTypeName);
  }
  const {
    filterNode = filterCommentsAndDefaultIgnoreTagsTags,
    ...prettyFormatOptions
  } = options;
  const debugContent = build/* format */.WU(dom, {
    plugins: [createDOMElementFilter(filterNode), DOMCollection],
    printFunctionName: false,
    highlight: shouldHighlight(),
    ...prettyFormatOptions
  });
  return maxLength !== undefined && dom.outerHTML.length > maxLength ? debugContent.slice(0, maxLength) + "..." : debugContent;
}
const logDOM = function () {
  const userCodeFrame = getUserCodeFrame();
  if (userCodeFrame) {
    console.log(prettyDOM(...arguments) + "\n\n" + userCodeFrame);
  } else {
    console.log(prettyDOM(...arguments));
  }
};

// It would be cleaner for this to live inside './queries', but
// other parts of the code assume that all exports from
// './queries' are query functions.
let config = {
  testIdAttribute: 'data-testid',
  asyncUtilTimeout: 1000,
  // asyncWrapper and advanceTimersWrapper is to support React's async `act` function.
  // forcing react-testing-library to wrap all async functions would've been
  // a total nightmare (consider wrapping every findBy* query and then also
  // updating `within` so those would be wrapped too. Total nightmare).
  // so we have this config option that's really only intended for
  // react-testing-library to use. For that reason, this feature will remain
  // undocumented.
  asyncWrapper: cb => cb(),
  unstable_advanceTimersWrapper: cb => cb(),
  eventWrapper: cb => cb(),
  // default value for the `hidden` option in `ByRole` queries
  defaultHidden: false,
  // default value for the `ignore` option in `ByText` queries
  defaultIgnore: 'script, style',
  // showOriginalStackTrace flag to show the full error stack traces for async errors
  showOriginalStackTrace: false,
  // throw errors w/ suggestions for better queries. Opt in so off by default.
  throwSuggestions: false,
  // called when getBy* queries fail. (message, container) => Error
  getElementError(message, container) {
    const prettifiedDOM = prettyDOM(container);
    const error = new Error([message, "Ignored nodes: comments, " + config.defaultIgnore + "\n" + prettifiedDOM].filter(Boolean).join('\n\n'));
    error.name = 'TestingLibraryElementError';
    return error;
  },
  _disableExpensiveErrorDiagnostics: false,
  computedStyleSupportsPseudoElements: false
};
function runWithExpensiveErrorDiagnosticsDisabled(callback) {
  try {
    config._disableExpensiveErrorDiagnostics = true;
    return callback();
  } finally {
    config._disableExpensiveErrorDiagnostics = false;
  }
}
function configure(newConfig) {
  if (typeof newConfig === 'function') {
    // Pass the existing config out to the provided function
    // and accept a delta in return
    newConfig = newConfig(config);
  }

  // Merge the incoming config delta
  config = {
    ...config,
    ...newConfig
  };
}
function getConfig() {
  return config;
}

const labelledNodeNames = ['button', 'meter', 'output', 'progress', 'select', 'textarea', 'input'];
function getTextContent(node) {
  if (labelledNodeNames.includes(node.nodeName.toLowerCase())) {
    return '';
  }
  if (node.nodeType === TEXT_NODE) return node.textContent;
  return Array.from(node.childNodes).map(childNode => getTextContent(childNode)).join('');
}
function getLabelContent(element) {
  let textContent;
  if (element.tagName.toLowerCase() === 'label') {
    textContent = getTextContent(element);
  } else {
    textContent = element.value || element.textContent;
  }
  return textContent;
}

// Based on https://github.com/eps1lon/dom-accessibility-api/pull/352
function getRealLabels(element) {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- types are not aware of older browsers that don't implement `labels`
  if (element.labels !== undefined) {
    var _labels;
    return (_labels = element.labels) != null ? _labels : [];
  }
  if (!isLabelable(element)) return [];
  const labels = element.ownerDocument.querySelectorAll('label');
  return Array.from(labels).filter(label => label.control === element);
}
function isLabelable(element) {
  return /BUTTON|METER|OUTPUT|PROGRESS|SELECT|TEXTAREA/.test(element.tagName) || element.tagName === 'INPUT' && element.getAttribute('type') !== 'hidden';
}
function dom_esm_getLabels(container, element, _temp) {
  let {
    selector = '*'
  } = _temp === void 0 ? {} : _temp;
  const ariaLabelledBy = element.getAttribute('aria-labelledby');
  const labelsId = ariaLabelledBy ? ariaLabelledBy.split(' ') : [];
  return labelsId.length ? labelsId.map(labelId => {
    const labellingElement = container.querySelector("[id=\"" + labelId + "\"]");
    return labellingElement ? {
      content: getLabelContent(labellingElement),
      formControl: null
    } : {
      content: '',
      formControl: null
    };
  }) : Array.from(getRealLabels(element)).map(label => {
    const textToMatch = getLabelContent(label);
    const formControlSelector = 'button, input, meter, output, progress, select, textarea';
    const labelledFormControl = Array.from(label.querySelectorAll(formControlSelector)).filter(formControlElement => formControlElement.matches(selector))[0];
    return {
      content: textToMatch,
      formControl: labelledFormControl
    };
  });
}

function assertNotNullOrUndefined(matcher) {
  if (matcher === null || matcher === undefined) {
    throw new Error( // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- implicitly converting `T` to `string`
    "It looks like " + matcher + " was passed instead of a matcher. Did you do something like getByText(" + matcher + ")?");
  }
}
function fuzzyMatches(textToMatch, node, matcher, normalizer) {
  if (typeof textToMatch !== 'string') {
    return false;
  }
  assertNotNullOrUndefined(matcher);
  const normalizedText = normalizer(textToMatch);
  if (typeof matcher === 'string' || typeof matcher === 'number') {
    return normalizedText.toLowerCase().includes(matcher.toString().toLowerCase());
  } else if (typeof matcher === 'function') {
    return matcher(normalizedText, node);
  } else {
    return matchRegExp(matcher, normalizedText);
  }
}
function matches(textToMatch, node, matcher, normalizer) {
  if (typeof textToMatch !== 'string') {
    return false;
  }
  assertNotNullOrUndefined(matcher);
  const normalizedText = normalizer(textToMatch);
  if (matcher instanceof Function) {
    return matcher(normalizedText, node);
  } else if (matcher instanceof RegExp) {
    return matchRegExp(matcher, normalizedText);
  } else {
    return normalizedText === String(matcher);
  }
}
function getDefaultNormalizer(_temp) {
  let {
    trim = true,
    collapseWhitespace = true
  } = _temp === void 0 ? {} : _temp;
  return text => {
    let normalizedText = text;
    normalizedText = trim ? normalizedText.trim() : normalizedText;
    normalizedText = collapseWhitespace ? normalizedText.replace(/\s+/g, ' ') : normalizedText;
    return normalizedText;
  };
}

/**
 * Constructs a normalizer to pass to functions in matches.js
 * @param {boolean|undefined} trim The user-specified value for `trim`, without
 * any defaulting having been applied
 * @param {boolean|undefined} collapseWhitespace The user-specified value for
 * `collapseWhitespace`, without any defaulting having been applied
 * @param {Function|undefined} normalizer The user-specified normalizer
 * @returns {Function} A normalizer
 */

function makeNormalizer(_ref) {
  let {
    trim,
    collapseWhitespace,
    normalizer
  } = _ref;
  if (!normalizer) {
    // No custom normalizer specified. Just use default.
    return getDefaultNormalizer({
      trim,
      collapseWhitespace
    });
  }
  if (typeof trim !== 'undefined' || typeof collapseWhitespace !== 'undefined') {
    // They've also specified a value for trim or collapseWhitespace
    throw new Error('trim and collapseWhitespace are not supported with a normalizer. ' + 'If you want to use the default trim and collapseWhitespace logic in your normalizer, ' + 'use "getDefaultNormalizer({trim, collapseWhitespace})" and compose that into your normalizer');
  }
  return normalizer;
}
function matchRegExp(matcher, text) {
  const match = matcher.test(text);
  if (matcher.global && matcher.lastIndex !== 0) {
    console.warn("To match all elements we had to reset the lastIndex of the RegExp because the global flag is enabled. We encourage to remove the global flag from the RegExp.");
    matcher.lastIndex = 0;
  }
  return match;
}

function getNodeText(node) {
  if (node.matches('input[type=submit], input[type=button], input[type=reset]')) {
    return node.value;
  }
  return Array.from(node.childNodes).filter(child => child.nodeType === TEXT_NODE && Boolean(child.textContent)).map(c => c.textContent).join('');
}

const elementRoleList = buildElementRoleList(lib/* elementRoles */.Qv);

/**
 * @param {Element} element -
 * @returns {boolean} - `true` if `element` and its subtree are inaccessible
 */
function isSubtreeInaccessible(element) {
  if (element.hidden === true) {
    return true;
  }
  if (element.getAttribute('aria-hidden') === 'true') {
    return true;
  }
  const window = element.ownerDocument.defaultView;
  if (window.getComputedStyle(element).display === 'none') {
    return true;
  }
  return false;
}

/**
 * Partial implementation https://www.w3.org/TR/wai-aria-1.2/#tree_exclusion
 * which should only be used for elements with a non-presentational role i.e.
 * `role="none"` and `role="presentation"` will not be excluded.
 *
 * Implements aria-hidden semantics (i.e. parent overrides child)
 * Ignores "Child Presentational: True" characteristics
 *
 * @param {Element} element -
 * @param {object} [options] -
 * @param {function (element: Element): boolean} options.isSubtreeInaccessible -
 * can be used to return cached results from previous isSubtreeInaccessible calls
 * @returns {boolean} true if excluded, otherwise false
 */
function isInaccessible(element, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    isSubtreeInaccessible: isSubtreeInaccessibleImpl = isSubtreeInaccessible
  } = options;
  const window = element.ownerDocument.defaultView;
  // since visibility is inherited we can exit early
  if (window.getComputedStyle(element).visibility === 'hidden') {
    return true;
  }
  let currentElement = element;
  while (currentElement) {
    if (isSubtreeInaccessibleImpl(currentElement)) {
      return true;
    }
    currentElement = currentElement.parentElement;
  }
  return false;
}
function getImplicitAriaRoles(currentNode) {
  // eslint bug here:
  // eslint-disable-next-line no-unused-vars
  for (const {
    match,
    roles
  } of elementRoleList) {
    if (match(currentNode)) {
      return [...roles];
    }
  }
  return [];
}
function buildElementRoleList(elementRolesMap) {
  function makeElementSelector(_ref) {
    let {
      name,
      attributes
    } = _ref;
    return "" + name + attributes.map(_ref2 => {
      let {
        name: attributeName,
        value,
        constraints = []
      } = _ref2;
      const shouldNotExist = constraints.indexOf('undefined') !== -1;
      if (shouldNotExist) {
        return ":not([" + attributeName + "])";
      } else if (value) {
        return "[" + attributeName + "=\"" + value + "\"]";
      } else {
        return "[" + attributeName + "]";
      }
    }).join('');
  }
  function getSelectorSpecificity(_ref3) {
    let {
      attributes = []
    } = _ref3;
    return attributes.length;
  }
  function bySelectorSpecificity(_ref4, _ref5) {
    let {
      specificity: leftSpecificity
    } = _ref4;
    let {
      specificity: rightSpecificity
    } = _ref5;
    return rightSpecificity - leftSpecificity;
  }
  function match(element) {
    let {
      attributes = []
    } = element;

    // https://github.com/testing-library/dom-testing-library/issues/814
    const typeTextIndex = attributes.findIndex(attribute => attribute.value && attribute.name === 'type' && attribute.value === 'text');
    if (typeTextIndex >= 0) {
      // not using splice to not mutate the attributes array
      attributes = [...attributes.slice(0, typeTextIndex), ...attributes.slice(typeTextIndex + 1)];
    }
    const selector = makeElementSelector({
      ...element,
      attributes
    });
    return node => {
      if (typeTextIndex >= 0 && node.type !== 'text') {
        return false;
      }
      return node.matches(selector);
    };
  }
  let result = [];

  // eslint bug here:
  // eslint-disable-next-line no-unused-vars
  for (const [element, roles] of elementRolesMap.entries()) {
    result = [...result, {
      match: match(element),
      roles: Array.from(roles),
      specificity: getSelectorSpecificity(element)
    }];
  }
  return result.sort(bySelectorSpecificity);
}
function getRoles(container, _temp) {
  let {
    hidden = false
  } = _temp === void 0 ? {} : _temp;
  function flattenDOM(node) {
    return [node, ...Array.from(node.children).reduce((acc, child) => [...acc, ...flattenDOM(child)], [])];
  }
  return flattenDOM(container).filter(element => {
    return hidden === false ? isInaccessible(element) === false : true;
  }).reduce((acc, node) => {
    let roles = [];
    // TODO: This violates html-aria which does not allow any role on every element
    if (node.hasAttribute('role')) {
      roles = node.getAttribute('role').split(' ').slice(0, 1);
    } else {
      roles = getImplicitAriaRoles(node);
    }
    return roles.reduce((rolesAcc, role) => Array.isArray(rolesAcc[role]) ? {
      ...rolesAcc,
      [role]: [...rolesAcc[role], node]
    } : {
      ...rolesAcc,
      [role]: [node]
    }, acc);
  }, {});
}
function prettyRoles(dom, _ref6) {
  let {
    hidden,
    includeDescription
  } = _ref6;
  const roles = getRoles(dom, {
    hidden
  });
  // We prefer to skip generic role, we don't recommend it
  return Object.entries(roles).filter(_ref7 => {
    let [role] = _ref7;
    return role !== 'generic';
  }).map(_ref8 => {
    let [role, elements] = _ref8;
    const delimiterBar = '-'.repeat(50);
    const elementsString = elements.map(el => {
      const nameString = "Name \"" + computeAccessibleName(el, {
        computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
      }) + "\":\n";
      const domString = prettyDOM(el.cloneNode(false));
      if (includeDescription) {
        const descriptionString = "Description \"" + computeAccessibleDescription(el, {
          computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
        }) + "\":\n";
        return "" + nameString + descriptionString + domString;
      }
      return "" + nameString + domString;
    }).join('\n\n');
    return role + ":\n\n" + elementsString + "\n\n" + delimiterBar;
  }).join('\n');
}
const logRoles = function (dom, _temp2) {
  let {
    hidden = false
  } = _temp2 === void 0 ? {} : _temp2;
  return console.log(prettyRoles(dom, {
    hidden
  }));
};

/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)selected, undefined if not selectable
 */
function computeAriaSelected(element) {
  // implicit value from html-aam mappings: https://www.w3.org/TR/html-aam-1.0/#html-attribute-state-and-property-mappings
  // https://www.w3.org/TR/html-aam-1.0/#details-id-97
  if (element.tagName === 'OPTION') {
    return element.selected;
  }

  // explicit value
  return checkBooleanAttribute(element, 'aria-selected');
}

/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)checked, undefined if not checked-able
 */
function computeAriaChecked(element) {
  // implicit value from html-aam mappings: https://www.w3.org/TR/html-aam-1.0/#html-attribute-state-and-property-mappings
  // https://www.w3.org/TR/html-aam-1.0/#details-id-56
  // https://www.w3.org/TR/html-aam-1.0/#details-id-67
  if ('indeterminate' in element && element.indeterminate) {
    return undefined;
  }
  if ('checked' in element) {
    return element.checked;
  }

  // explicit value
  return checkBooleanAttribute(element, 'aria-checked');
}

/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)pressed, undefined if not press-able
 */
function computeAriaPressed(element) {
  // https://www.w3.org/TR/wai-aria-1.1/#aria-pressed
  return checkBooleanAttribute(element, 'aria-pressed');
}

/**
 * @param {Element} element -
 * @returns {boolean | string | null} -
 */
function computeAriaCurrent(element) {
  var _ref9, _checkBooleanAttribut;
  // https://www.w3.org/TR/wai-aria-1.1/#aria-current
  return (_ref9 = (_checkBooleanAttribut = checkBooleanAttribute(element, 'aria-current')) != null ? _checkBooleanAttribut : element.getAttribute('aria-current')) != null ? _ref9 : false;
}

/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)expanded, undefined if not expand-able
 */
function computeAriaExpanded(element) {
  // https://www.w3.org/TR/wai-aria-1.1/#aria-expanded
  return checkBooleanAttribute(element, 'aria-expanded');
}
function checkBooleanAttribute(element, attribute) {
  const attributeValue = element.getAttribute(attribute);
  if (attributeValue === 'true') {
    return true;
  }
  if (attributeValue === 'false') {
    return false;
  }
  return undefined;
}

/**
 * @param {Element} element -
 * @returns {number | undefined} - number if implicit heading or aria-level present, otherwise undefined
 */
function computeHeadingLevel(element) {
  // https://w3c.github.io/html-aam/#el-h1-h6
  // https://w3c.github.io/html-aam/#el-h1-h6
  const implicitHeadingLevels = {
    H1: 1,
    H2: 2,
    H3: 3,
    H4: 4,
    H5: 5,
    H6: 6
  };
  // explicit aria-level value
  // https://www.w3.org/TR/wai-aria-1.2/#aria-level
  const ariaLevelAttribute = element.getAttribute('aria-level') && Number(element.getAttribute('aria-level'));
  return ariaLevelAttribute || implicitHeadingLevels[element.tagName];
}

const normalize = getDefaultNormalizer();
function escapeRegExp(string) {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function getRegExpMatcher(string) {
  return new RegExp(escapeRegExp(string.toLowerCase()), 'i');
}
function makeSuggestion(queryName, element, content, _ref) {
  let {
    variant,
    name
  } = _ref;
  let warning = '';
  const queryOptions = {};
  const queryArgs = [['Role', 'TestId'].includes(queryName) ? content : getRegExpMatcher(content)];
  if (name) {
    queryOptions.name = getRegExpMatcher(name);
  }
  if (queryName === 'Role' && isInaccessible(element)) {
    queryOptions.hidden = true;
    warning = "Element is inaccessible. This means that the element and all its children are invisible to screen readers.\n    If you are using the aria-hidden prop, make sure this is the right choice for your case.\n    ";
  }
  if (Object.keys(queryOptions).length > 0) {
    queryArgs.push(queryOptions);
  }
  const queryMethod = variant + "By" + queryName;
  return {
    queryName,
    queryMethod,
    queryArgs,
    variant,
    warning,
    toString() {
      if (warning) {
        console.warn(warning);
      }
      let [text, options] = queryArgs;
      text = typeof text === 'string' ? "'" + text + "'" : text;
      options = options ? ", { " + Object.entries(options).map(_ref2 => {
        let [k, v] = _ref2;
        return k + ": " + v;
      }).join(', ') + " }" : '';
      return queryMethod + "(" + text + options + ")";
    }
  };
}
function canSuggest(currentMethod, requestedMethod, data) {
  return data && (!requestedMethod || requestedMethod.toLowerCase() === currentMethod.toLowerCase());
}
function getSuggestedQuery(element, variant, method) {
  var _element$getAttribute, _getImplicitAriaRoles;
  if (variant === void 0) {
    variant = 'get';
  }
  // don't create suggestions for script and style elements
  if (element.matches(getConfig().defaultIgnore)) {
    return undefined;
  }

  //We prefer to suggest something else if the role is generic
  const role = (_element$getAttribute = element.getAttribute('role')) != null ? _element$getAttribute : (_getImplicitAriaRoles = getImplicitAriaRoles(element)) == null ? void 0 : _getImplicitAriaRoles[0];
  if (role !== 'generic' && canSuggest('Role', method, role)) {
    return makeSuggestion('Role', element, role, {
      variant,
      name: computeAccessibleName(element, {
        computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
      })
    });
  }
  const labelText = dom_esm_getLabels(document, element).map(label => label.content).join(' ');
  if (canSuggest('LabelText', method, labelText)) {
    return makeSuggestion('LabelText', element, labelText, {
      variant
    });
  }
  const placeholderText = element.getAttribute('placeholder');
  if (canSuggest('PlaceholderText', method, placeholderText)) {
    return makeSuggestion('PlaceholderText', element, placeholderText, {
      variant
    });
  }
  const textContent = normalize(getNodeText(element));
  if (canSuggest('Text', method, textContent)) {
    return makeSuggestion('Text', element, textContent, {
      variant
    });
  }
  if (canSuggest('DisplayValue', method, element.value)) {
    return makeSuggestion('DisplayValue', element, normalize(element.value), {
      variant
    });
  }
  const alt = element.getAttribute('alt');
  if (canSuggest('AltText', method, alt)) {
    return makeSuggestion('AltText', element, alt, {
      variant
    });
  }
  const title = element.getAttribute('title');
  if (canSuggest('Title', method, title)) {
    return makeSuggestion('Title', element, title, {
      variant
    });
  }
  const testId = element.getAttribute(getConfig().testIdAttribute);
  if (canSuggest('TestId', method, testId)) {
    return makeSuggestion('TestId', element, testId, {
      variant
    });
  }
  return undefined;
}

// This is so the stack trace the developer sees is one that's
// closer to their code (because async stack traces are hard to follow).
function copyStackTrace(target, source) {
  target.stack = source.stack.replace(source.message, target.message);
}
function waitFor(callback, _ref) {
  let {
    container = getDocument(),
    timeout = getConfig().asyncUtilTimeout,
    showOriginalStackTrace = getConfig().showOriginalStackTrace,
    stackTraceError,
    interval = 50,
    onTimeout = error => {
      error.message = getConfig().getElementError(error.message, container).message;
      return error;
    },
    mutationObserverOptions = {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true
    }
  } = _ref;
  if (typeof callback !== 'function') {
    throw new TypeError('Received `callback` arg must be a function');
  }
  return new Promise(async (resolve, reject) => {
    let lastError, intervalId, observer;
    let finished = false;
    let promiseStatus = 'idle';
    const overallTimeoutTimer = setTimeout(handleTimeout, timeout);
    const usingJestFakeTimers = jestFakeTimersAreEnabled();
    if (usingJestFakeTimers) {
      const {
        unstable_advanceTimersWrapper: advanceTimersWrapper
      } = getConfig();
      checkCallback();
      // this is a dangerous rule to disable because it could lead to an
      // infinite loop. However, eslint isn't smart enough to know that we're
      // setting finished inside `onDone` which will be called when we're done
      // waiting or when we've timed out.
      // eslint-disable-next-line no-unmodified-loop-condition
      while (!finished) {
        if (!jestFakeTimersAreEnabled()) {
          const error = new Error("Changed from using fake timers to real timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to real timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
          if (!showOriginalStackTrace) copyStackTrace(error, stackTraceError);
          reject(error);
          return;
        }
        // we *could* (maybe should?) use `advanceTimersToNextTimer` but it's
        // possible that could make this loop go on forever if someone is using
        // third party code that's setting up recursive timers so rapidly that
        // the user's timer's don't get a chance to resolve. So we'll advance
        // by an interval instead. (We have a test for this case).
        advanceTimersWrapper(() => {
          jest.advanceTimersByTime(interval);
        });

        // It's really important that checkCallback is run *before* we flush
        // in-flight promises. To be honest, I'm not sure why, and I can't quite
        // think of a way to reproduce the problem in a test, but I spent
        // an entire day banging my head against a wall on this.
        checkCallback();
        if (finished) {
          break;
        }

        // In this rare case, we *need* to wait for in-flight promises
        // to resolve before continuing. We don't need to take advantage
        // of parallelization so we're fine.
        // https://stackoverflow.com/a/59243586/971592
        // eslint-disable-next-line no-await-in-loop
        await advanceTimersWrapper(async () => {
          await new Promise(r => {
            setTimeout(r, 0);
            jest.advanceTimersByTime(0);
          });
        });
      }
    } else {
      try {
        checkContainerType(container);
      } catch (e) {
        reject(e);
        return;
      }
      intervalId = setInterval(checkRealTimersCallback, interval);
      const {
        MutationObserver
      } = getWindowFromNode(container);
      observer = new MutationObserver(checkRealTimersCallback);
      observer.observe(container, mutationObserverOptions);
      checkCallback();
    }
    function onDone(error, result) {
      finished = true;
      clearTimeout(overallTimeoutTimer);
      if (!usingJestFakeTimers) {
        clearInterval(intervalId);
        observer.disconnect();
      }
      if (error) {
        reject(error);
      } else {
        resolve(result);
      }
    }
    function checkRealTimersCallback() {
      if (jestFakeTimersAreEnabled()) {
        const error = new Error("Changed from using real timers to fake timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to fake timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
        if (!showOriginalStackTrace) copyStackTrace(error, stackTraceError);
        return reject(error);
      } else {
        return checkCallback();
      }
    }
    function checkCallback() {
      if (promiseStatus === 'pending') return;
      try {
        const result = runWithExpensiveErrorDiagnosticsDisabled(callback);
        if (typeof (result == null ? void 0 : result.then) === 'function') {
          promiseStatus = 'pending';
          result.then(resolvedValue => {
            promiseStatus = 'resolved';
            onDone(null, resolvedValue);
          }, rejectedValue => {
            promiseStatus = 'rejected';
            lastError = rejectedValue;
          });
        } else {
          onDone(null, result);
        }
        // If `callback` throws, wait for the next mutation, interval, or timeout.
      } catch (error) {
        // Save the most recent callback error to reject the promise with it in the event of a timeout
        lastError = error;
      }
    }
    function handleTimeout() {
      let error;
      if (lastError) {
        error = lastError;
        if (!showOriginalStackTrace && error.name === 'TestingLibraryElementError') {
          copyStackTrace(error, stackTraceError);
        }
      } else {
        error = new Error('Timed out in waitFor.');
        if (!showOriginalStackTrace) {
          copyStackTrace(error, stackTraceError);
        }
      }
      onDone(onTimeout(error), null);
    }
  });
}
function waitForWrapper(callback, options) {
  // create the error here so its stack trace is as close to the
  // calling code as possible
  const stackTraceError = new Error('STACK_TRACE_MESSAGE');
  return getConfig().asyncWrapper(() => waitFor(callback, {
    stackTraceError,
    ...options
  }));
}

/*
eslint
  max-lines-per-function: ["error", {"max": 200}],
*/

function getElementError(message, container) {
  return getConfig().getElementError(message, container);
}
function getMultipleElementsFoundError(message, container) {
  return getElementError(message + "\n\n(If this is intentional, then use the `*AllBy*` variant of the query (like `queryAllByText`, `getAllByText`, or `findAllByText`)).", container);
}
function queryAllByAttribute(attribute, container, text, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  return Array.from(container.querySelectorAll("[" + attribute + "]")).filter(node => matcher(node.getAttribute(attribute), node, text, matchNormalizer));
}
function queryByAttribute(attribute, container, text, options) {
  const els = queryAllByAttribute(attribute, container, text, options);
  if (els.length > 1) {
    throw getMultipleElementsFoundError("Found multiple elements by [" + attribute + "=" + text + "]", container);
  }
  return els[0] || null;
}

// this accepts a query function and returns a function which throws an error
// if more than one elements is returned, otherwise it returns the first
// element or null
function makeSingleQuery(allQuery, getMultipleError) {
  return function (container) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const els = allQuery(container, ...args);
    if (els.length > 1) {
      const elementStrings = els.map(element => getElementError(null, element).message).join('\n\n');
      throw getMultipleElementsFoundError(getMultipleError(container, ...args) + "\n\nHere are the matching elements:\n\n" + elementStrings, container);
    }
    return els[0] || null;
  };
}
function getSuggestionError(suggestion, container) {
  return getConfig().getElementError("A better query is available, try this:\n" + suggestion.toString() + "\n", container);
}

// this accepts a query function and returns a function which throws an error
// if an empty list of elements is returned
function makeGetAllQuery(allQuery, getMissingError) {
  return function (container) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    const els = allQuery(container, ...args);
    if (!els.length) {
      throw getConfig().getElementError(getMissingError(container, ...args), container);
    }
    return els;
  };
}

// this accepts a getter query function and returns a function which calls
// waitFor and passing a function which invokes the getter.
function makeFindQuery(getter) {
  return (container, text, options, waitForOptions) => {
    return waitForWrapper(() => {
      return getter(container, text, options);
    }, {
      container,
      ...waitForOptions
    });
  };
}
const wrapSingleQueryWithSuggestion = (query, queryAllByName, variant) => function (container) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }
  const element = query(container, ...args);
  const [{
    suggest = getConfig().throwSuggestions
  } = {}] = args.slice(-1);
  if (element && suggest) {
    const suggestion = getSuggestedQuery(element, variant);
    if (suggestion && !queryAllByName.endsWith(suggestion.queryName)) {
      throw getSuggestionError(suggestion.toString(), container);
    }
  }
  return element;
};
const wrapAllByQueryWithSuggestion = (query, queryAllByName, variant) => function (container) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }
  const els = query(container, ...args);
  const [{
    suggest = getConfig().throwSuggestions
  } = {}] = args.slice(-1);
  if (els.length && suggest) {
    // get a unique list of all suggestion messages.  We are only going to make a suggestion if
    // all the suggestions are the same
    const uniqueSuggestionMessages = [...new Set(els.map(element => {
      var _getSuggestedQuery;
      return (_getSuggestedQuery = getSuggestedQuery(element, variant)) == null ? void 0 : _getSuggestedQuery.toString();
    }))];
    if (
    // only want to suggest if all the els have the same suggestion.
    uniqueSuggestionMessages.length === 1 && !queryAllByName.endsWith(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- TODO: Can this be null at runtime?
    getSuggestedQuery(els[0], variant).queryName)) {
      throw getSuggestionError(uniqueSuggestionMessages[0], container);
    }
  }
  return els;
};

// TODO: This deviates from the published declarations
// However, the implementation always required a dyadic (after `container`) not variadic `queryAllBy` considering the implementation of `makeFindQuery`
// This is at least statically true and can be verified by accepting `QueryMethod<Arguments, HTMLElement[]>`
function buildQueries(queryAllBy, getMultipleError, getMissingError) {
  const queryBy = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllBy, getMultipleError), queryAllBy.name, 'query');
  const getAllBy = makeGetAllQuery(queryAllBy, getMissingError);
  const getBy = makeSingleQuery(getAllBy, getMultipleError);
  const getByWithSuggestions = wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, 'get');
  const getAllWithSuggestions = wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name.replace('query', 'get'), 'getAll');
  const findAllBy = makeFindQuery(wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name, 'findAll'));
  const findBy = makeFindQuery(wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, 'find'));
  return [queryBy, getAllWithSuggestions, getByWithSuggestions, findAllBy, findBy];
}

var queryHelpers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getElementError: getElementError,
  wrapAllByQueryWithSuggestion: wrapAllByQueryWithSuggestion,
  wrapSingleQueryWithSuggestion: wrapSingleQueryWithSuggestion,
  getMultipleElementsFoundError: getMultipleElementsFoundError,
  queryAllByAttribute: queryAllByAttribute,
  queryByAttribute: queryByAttribute,
  makeSingleQuery: makeSingleQuery,
  makeGetAllQuery: makeGetAllQuery,
  makeFindQuery: makeFindQuery,
  buildQueries: buildQueries
});

function queryAllLabels(container) {
  return Array.from(container.querySelectorAll('label,input')).map(node => {
    return {
      node,
      textToMatch: getLabelContent(node)
    };
  }).filter(_ref => {
    let {
      textToMatch
    } = _ref;
    return textToMatch !== null;
  });
}
const queryAllLabelsByText = function (container, text, _temp) {
  let {
    exact = true,
    trim,
    collapseWhitespace,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  const textToMatchByLabels = queryAllLabels(container);
  return textToMatchByLabels.filter(_ref2 => {
    let {
      node,
      textToMatch
    } = _ref2;
    return matcher(textToMatch, node, text, matchNormalizer);
  }).map(_ref3 => {
    let {
      node
    } = _ref3;
    return node;
  });
};
const queryAllByLabelText = function (container, text, _temp2) {
  let {
    selector = '*',
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp2 === void 0 ? {} : _temp2;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  const matchingLabelledElements = Array.from(container.querySelectorAll('*')).filter(element => {
    return getRealLabels(element).length || element.hasAttribute('aria-labelledby');
  }).reduce((labelledElements, labelledElement) => {
    const labelList = dom_esm_getLabels(container, labelledElement, {
      selector
    });
    labelList.filter(label => Boolean(label.formControl)).forEach(label => {
      if (matcher(label.content, label.formControl, text, matchNormalizer) && label.formControl) labelledElements.push(label.formControl);
    });
    const labelsValue = labelList.filter(label => Boolean(label.content)).map(label => label.content);
    if (matcher(labelsValue.join(' '), labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
    if (labelsValue.length > 1) {
      labelsValue.forEach((labelValue, index) => {
        if (matcher(labelValue, labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
        const labelsFiltered = [...labelsValue];
        labelsFiltered.splice(index, 1);
        if (labelsFiltered.length > 1) {
          if (matcher(labelsFiltered.join(' '), labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
        }
      });
    }
    return labelledElements;
  }, []).concat(queryAllByAttribute('aria-label', container, text, {
    exact,
    normalizer: matchNormalizer
  }));
  return Array.from(new Set(matchingLabelledElements)).filter(element => element.matches(selector));
};

// the getAll* query would normally look like this:
// const getAllByLabelText = makeGetAllQuery(
//   queryAllByLabelText,
//   (c, text) => `Unable to find a label with the text of: ${text}`,
// )
// however, we can give a more helpful error message than the generic one,
// so we're writing this one out by hand.
const getAllByLabelText = function (container, text) {
  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }
  const els = queryAllByLabelText(container, text, ...rest);
  if (!els.length) {
    const labels = queryAllLabelsByText(container, text, ...rest);
    if (labels.length) {
      const tagNames = labels.map(label => getTagNameOfElementAssociatedWithLabelViaFor(container, label)).filter(tagName => !!tagName);
      if (tagNames.length) {
        throw getConfig().getElementError(tagNames.map(tagName => "Found a label with the text of: " + text + ", however the element associated with this label (<" + tagName + " />) is non-labellable [https://html.spec.whatwg.org/multipage/forms.html#category-label]. If you really need to label a <" + tagName + " />, you can use aria-label or aria-labelledby instead.").join('\n\n'), container);
      } else {
        throw getConfig().getElementError("Found a label with the text of: " + text + ", however no form control was found associated to that label. Make sure you're using the \"for\" attribute or \"aria-labelledby\" attribute correctly.", container);
      }
    } else {
      throw getConfig().getElementError("Unable to find a label with the text of: " + text, container);
    }
  }
  return els;
};
function getTagNameOfElementAssociatedWithLabelViaFor(container, label) {
  const htmlFor = label.getAttribute('for');
  if (!htmlFor) {
    return null;
  }
  const element = container.querySelector("[id=\"" + htmlFor + "\"]");
  return element ? element.tagName.toLowerCase() : null;
}

// the reason mentioned above is the same reason we're not using buildQueries
const getMultipleError$7 = (c, text) => "Found multiple elements with the text of: " + text;
const queryByLabelText = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllByLabelText, getMultipleError$7), queryAllByLabelText.name, 'query');
const getByLabelText = makeSingleQuery(getAllByLabelText, getMultipleError$7);
const findAllByLabelText = makeFindQuery(wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, 'findAll'));
const findByLabelText = makeFindQuery(wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, 'find'));
const getAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, 'getAll');
const getByLabelTextWithSuggestions = wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, 'get');
const queryAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByLabelText, queryAllByLabelText.name, 'queryAll');

const queryAllByPlaceholderText = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  checkContainerType(args[0]);
  return queryAllByAttribute('placeholder', ...args);
};
const getMultipleError$6 = (c, text) => "Found multiple elements with the placeholder text of: " + text;
const getMissingError$6 = (c, text) => "Unable to find an element with the placeholder text of: " + text;
const queryAllByPlaceholderTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByPlaceholderText, queryAllByPlaceholderText.name, 'queryAll');
const [queryByPlaceholderText, getAllByPlaceholderText, getByPlaceholderText, findAllByPlaceholderText, findByPlaceholderText] = buildQueries(queryAllByPlaceholderText, getMultipleError$6, getMissingError$6);

const queryAllByText = function (container, text, _temp) {
  let {
    selector = '*',
    exact = true,
    collapseWhitespace,
    trim,
    ignore = getConfig().defaultIgnore,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  let baseArray = [];
  if (typeof container.matches === 'function' && container.matches(selector)) {
    baseArray = [container];
  }
  return [...baseArray, ...Array.from(container.querySelectorAll(selector))]
  // TODO: `matches` according lib.dom.d.ts can get only `string` but according our code it can handle also boolean :)
  .filter(node => !ignore || !node.matches(ignore)).filter(node => matcher(getNodeText(node), node, text, matchNormalizer));
};
const getMultipleError$5 = (c, text) => "Found multiple elements with the text: " + text;
const getMissingError$5 = function (c, text, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    collapseWhitespace,
    trim,
    normalizer,
    selector
  } = options;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  const normalizedText = matchNormalizer(text.toString());
  const isNormalizedDifferent = normalizedText !== text.toString();
  const isCustomSelector = (selector != null ? selector : '*') !== '*';
  return "Unable to find an element with the text: " + (isNormalizedDifferent ? normalizedText + " (normalized from '" + text + "')" : text) + (isCustomSelector ? ", which matches selector '" + selector + "'" : '') + ". This could be because the text is broken up by multiple elements. In this case, you can provide a function for your text matcher to make your matcher more flexible.";
};
const queryAllByTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByText, queryAllByText.name, 'queryAll');
const [queryByText, getAllByText, getByText, findAllByText, findByText] = buildQueries(queryAllByText, getMultipleError$5, getMissingError$5);

const queryAllByDisplayValue = function (container, value, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  return Array.from(container.querySelectorAll("input,textarea,select")).filter(node => {
    if (node.tagName === 'SELECT') {
      const selectedOptions = Array.from(node.options).filter(option => option.selected);
      return selectedOptions.some(optionNode => matcher(getNodeText(optionNode), optionNode, value, matchNormalizer));
    } else {
      return matcher(node.value, node, value, matchNormalizer);
    }
  });
};
const getMultipleError$4 = (c, value) => "Found multiple elements with the display value: " + value + ".";
const getMissingError$4 = (c, value) => "Unable to find an element with the display value: " + value + ".";
const queryAllByDisplayValueWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByDisplayValue, queryAllByDisplayValue.name, 'queryAll');
const [queryByDisplayValue, getAllByDisplayValue, getByDisplayValue, findAllByDisplayValue, findByDisplayValue] = buildQueries(queryAllByDisplayValue, getMultipleError$4, getMissingError$4);

// Valid tags are img, input, area and custom elements
const VALID_TAG_REGEXP = /^(img|input|area|.+-.+)$/i;
const queryAllByAltText = function (container, alt, options) {
  if (options === void 0) {
    options = {};
  }
  checkContainerType(container);
  return queryAllByAttribute('alt', container, alt, options).filter(node => VALID_TAG_REGEXP.test(node.tagName));
};
const getMultipleError$3 = (c, alt) => "Found multiple elements with the alt text: " + alt;
const getMissingError$3 = (c, alt) => "Unable to find an element with the alt text: " + alt;
const queryAllByAltTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByAltText, queryAllByAltText.name, 'queryAll');
const [queryByAltText, getAllByAltText, getByAltText, findAllByAltText, findByAltText] = buildQueries(queryAllByAltText, getMultipleError$3, getMissingError$3);

const isSvgTitle = node => {
  var _node$parentElement;
  return node.tagName.toLowerCase() === 'title' && ((_node$parentElement = node.parentElement) == null ? void 0 : _node$parentElement.tagName.toLowerCase()) === 'svg';
};
const queryAllByTitle = function (container, text, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  return Array.from(container.querySelectorAll('[title], svg > title')).filter(node => matcher(node.getAttribute('title'), node, text, matchNormalizer) || isSvgTitle(node) && matcher(getNodeText(node), node, text, matchNormalizer));
};
const getMultipleError$2 = (c, title) => "Found multiple elements with the title: " + title + ".";
const getMissingError$2 = (c, title) => "Unable to find an element with the title: " + title + ".";
const queryAllByTitleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTitle, queryAllByTitle.name, 'queryAll');
const [queryByTitle, getAllByTitle, getByTitle, findAllByTitle, findByTitle] = buildQueries(queryAllByTitle, getMultipleError$2, getMissingError$2);

function queryAllByRole(container, role, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    hidden = getConfig().defaultHidden,
    name,
    description,
    trim,
    normalizer,
    queryFallbacks = false,
    selected,
    checked,
    pressed,
    current,
    level,
    expanded
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim,
    normalizer
  });
  if (selected !== undefined) {
    var _allRoles$get;
    // guard against unknown roles
    if (((_allRoles$get = lib/* roles.get */.uJ.get(role)) == null ? void 0 : _allRoles$get.props['aria-selected']) === undefined) {
      throw new Error("\"aria-selected\" is not supported on role \"" + role + "\".");
    }
  }
  if (checked !== undefined) {
    var _allRoles$get2;
    // guard against unknown roles
    if (((_allRoles$get2 = lib/* roles.get */.uJ.get(role)) == null ? void 0 : _allRoles$get2.props['aria-checked']) === undefined) {
      throw new Error("\"aria-checked\" is not supported on role \"" + role + "\".");
    }
  }
  if (pressed !== undefined) {
    var _allRoles$get3;
    // guard against unknown roles
    if (((_allRoles$get3 = lib/* roles.get */.uJ.get(role)) == null ? void 0 : _allRoles$get3.props['aria-pressed']) === undefined) {
      throw new Error("\"aria-pressed\" is not supported on role \"" + role + "\".");
    }
  }
  if (current !== undefined) {
    var _allRoles$get4;
    /* istanbul ignore next */
    // guard against unknown roles
    // All currently released ARIA versions support `aria-current` on all roles.
    // Leaving this for symetry and forward compatibility
    if (((_allRoles$get4 = lib/* roles.get */.uJ.get(role)) == null ? void 0 : _allRoles$get4.props['aria-current']) === undefined) {
      throw new Error("\"aria-current\" is not supported on role \"" + role + "\".");
    }
  }
  if (level !== undefined) {
    // guard against using `level` option with any role other than `heading`
    if (role !== 'heading') {
      throw new Error("Role \"" + role + "\" cannot have \"level\" property.");
    }
  }
  if (expanded !== undefined) {
    var _allRoles$get5;
    // guard against unknown roles
    if (((_allRoles$get5 = lib/* roles.get */.uJ.get(role)) == null ? void 0 : _allRoles$get5.props['aria-expanded']) === undefined) {
      throw new Error("\"aria-expanded\" is not supported on role \"" + role + "\".");
    }
  }
  const subtreeIsInaccessibleCache = new WeakMap();
  function cachedIsSubtreeInaccessible(element) {
    if (!subtreeIsInaccessibleCache.has(element)) {
      subtreeIsInaccessibleCache.set(element, isSubtreeInaccessible(element));
    }
    return subtreeIsInaccessibleCache.get(element);
  }
  return Array.from(container.querySelectorAll(
  // Only query elements that can be matched by the following filters
  makeRoleSelector(role, exact, normalizer ? matchNormalizer : undefined))).filter(node => {
    const isRoleSpecifiedExplicitly = node.hasAttribute('role');
    if (isRoleSpecifiedExplicitly) {
      const roleValue = node.getAttribute('role');
      if (queryFallbacks) {
        return roleValue.split(' ').filter(Boolean).some(text => matcher(text, node, role, matchNormalizer));
      }
      // if a custom normalizer is passed then let normalizer handle the role value
      if (normalizer) {
        return matcher(roleValue, node, role, matchNormalizer);
      }
      // other wise only send the first word to match
      const [firstWord] = roleValue.split(' ');
      return matcher(firstWord, node, role, matchNormalizer);
    }
    const implicitRoles = getImplicitAriaRoles(node);
    return implicitRoles.some(implicitRole => matcher(implicitRole, node, role, matchNormalizer));
  }).filter(element => {
    if (selected !== undefined) {
      return selected === computeAriaSelected(element);
    }
    if (checked !== undefined) {
      return checked === computeAriaChecked(element);
    }
    if (pressed !== undefined) {
      return pressed === computeAriaPressed(element);
    }
    if (current !== undefined) {
      return current === computeAriaCurrent(element);
    }
    if (expanded !== undefined) {
      return expanded === computeAriaExpanded(element);
    }
    if (level !== undefined) {
      return level === computeHeadingLevel(element);
    }
    // don't care if aria attributes are unspecified
    return true;
  }).filter(element => {
    if (name === undefined) {
      // Don't care
      return true;
    }
    return matches(computeAccessibleName(element, {
      computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
    }), element, name, text => text);
  }).filter(element => {
    if (description === undefined) {
      // Don't care
      return true;
    }
    return matches(computeAccessibleDescription(element, {
      computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
    }), element, description, text => text);
  }).filter(element => {
    return hidden === false ? isInaccessible(element, {
      isSubtreeInaccessible: cachedIsSubtreeInaccessible
    }) === false : true;
  });
}
function makeRoleSelector(role, exact, customNormalizer) {
  var _roleElements$get;
  if (typeof role !== 'string') {
    // For non-string role parameters we can not determine the implicitRoleSelectors.
    return '*';
  }
  const explicitRoleSelector = exact && !customNormalizer ? "*[role~=\"" + role + "\"]" : '*[role]';
  const roleRelations = (_roleElements$get = lib/* roleElements.get */.UN.get(role)) != null ? _roleElements$get : new Set();
  const implicitRoleSelectors = new Set(Array.from(roleRelations).map(_ref => {
    let {
      name
    } = _ref;
    return name;
  }));

  // Current transpilation config sometimes assumes `...` is always applied to arrays.
  // `...` is equivalent to `Array.prototype.concat` for arrays.
  // If you replace this code with `[explicitRoleSelector, ...implicitRoleSelectors]`, make sure every transpilation target retains the `...` in favor of `Array.prototype.concat`.
  return [explicitRoleSelector].concat(Array.from(implicitRoleSelectors)).join(',');
}
const getNameHint = name => {
  let nameHint = '';
  if (name === undefined) {
    nameHint = '';
  } else if (typeof name === 'string') {
    nameHint = " and name \"" + name + "\"";
  } else {
    nameHint = " and name `" + name + "`";
  }
  return nameHint;
};
const getMultipleError$1 = function (c, role, _temp2) {
  let {
    name
  } = _temp2 === void 0 ? {} : _temp2;
  return "Found multiple elements with the role \"" + role + "\"" + getNameHint(name);
};
const getMissingError$1 = function (container, role, _temp3) {
  let {
    hidden = getConfig().defaultHidden,
    name,
    description
  } = _temp3 === void 0 ? {} : _temp3;
  if (getConfig()._disableExpensiveErrorDiagnostics) {
    return "Unable to find role=\"" + role + "\"" + getNameHint(name);
  }
  let roles = '';
  Array.from(container.children).forEach(childElement => {
    roles += prettyRoles(childElement, {
      hidden,
      includeDescription: description !== undefined
    });
  });
  let roleMessage;
  if (roles.length === 0) {
    if (hidden === false) {
      roleMessage = 'There are no accessible roles. But there might be some inaccessible roles. ' + 'If you wish to access them, then set the `hidden` option to `true`. ' + 'Learn more about this here: https://testing-library.com/docs/dom-testing-library/api-queries#byrole';
    } else {
      roleMessage = 'There are no available roles.';
    }
  } else {
    roleMessage = ("\nHere are the " + (hidden === false ? 'accessible' : 'available') + " roles:\n\n  " + roles.replace(/\n/g, '\n  ').replace(/\n\s\s\n/g, '\n\n') + "\n").trim();
  }
  let nameHint = '';
  if (name === undefined) {
    nameHint = '';
  } else if (typeof name === 'string') {
    nameHint = " and name \"" + name + "\"";
  } else {
    nameHint = " and name `" + name + "`";
  }
  let descriptionHint = '';
  if (description === undefined) {
    descriptionHint = '';
  } else if (typeof description === 'string') {
    descriptionHint = " and description \"" + description + "\"";
  } else {
    descriptionHint = " and description `" + description + "`";
  }
  return ("\nUnable to find an " + (hidden === false ? 'accessible ' : '') + "element with the role \"" + role + "\"" + nameHint + descriptionHint + "\n\n" + roleMessage).trim();
};
const queryAllByRoleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByRole, queryAllByRole.name, 'queryAll');
const [queryByRole, getAllByRole, getByRole, findAllByRole, findByRole] = buildQueries(queryAllByRole, getMultipleError$1, getMissingError$1);

const getTestIdAttribute = () => getConfig().testIdAttribute;
const queryAllByTestId = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  checkContainerType(args[0]);
  return queryAllByAttribute(getTestIdAttribute(), ...args);
};
const getMultipleError = (c, id) => "Found multiple elements by: [" + getTestIdAttribute() + "=\"" + id + "\"]";
const getMissingError = (c, id) => "Unable to find an element by: [" + getTestIdAttribute() + "=\"" + id + "\"]";
const queryAllByTestIdWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTestId, queryAllByTestId.name, 'queryAll');
const [queryByTestId, getAllByTestId, getByTestId, findAllByTestId, findByTestId] = buildQueries(queryAllByTestId, getMultipleError, getMissingError);

var queries = /*#__PURE__*/Object.freeze({
  __proto__: null,
  queryAllByLabelText: queryAllByLabelTextWithSuggestions,
  queryByLabelText: queryByLabelText,
  getAllByLabelText: getAllByLabelTextWithSuggestions,
  getByLabelText: getByLabelTextWithSuggestions,
  findAllByLabelText: findAllByLabelText,
  findByLabelText: findByLabelText,
  queryByPlaceholderText: queryByPlaceholderText,
  queryAllByPlaceholderText: queryAllByPlaceholderTextWithSuggestions,
  getByPlaceholderText: getByPlaceholderText,
  getAllByPlaceholderText: getAllByPlaceholderText,
  findAllByPlaceholderText: findAllByPlaceholderText,
  findByPlaceholderText: findByPlaceholderText,
  queryByText: queryByText,
  queryAllByText: queryAllByTextWithSuggestions,
  getByText: getByText,
  getAllByText: getAllByText,
  findAllByText: findAllByText,
  findByText: findByText,
  queryByDisplayValue: queryByDisplayValue,
  queryAllByDisplayValue: queryAllByDisplayValueWithSuggestions,
  getByDisplayValue: getByDisplayValue,
  getAllByDisplayValue: getAllByDisplayValue,
  findAllByDisplayValue: findAllByDisplayValue,
  findByDisplayValue: findByDisplayValue,
  queryByAltText: queryByAltText,
  queryAllByAltText: queryAllByAltTextWithSuggestions,
  getByAltText: getByAltText,
  getAllByAltText: getAllByAltText,
  findAllByAltText: findAllByAltText,
  findByAltText: findByAltText,
  queryByTitle: queryByTitle,
  queryAllByTitle: queryAllByTitleWithSuggestions,
  getByTitle: getByTitle,
  getAllByTitle: getAllByTitle,
  findAllByTitle: findAllByTitle,
  findByTitle: findByTitle,
  queryByRole: queryByRole,
  queryAllByRole: queryAllByRoleWithSuggestions,
  getAllByRole: getAllByRole,
  getByRole: getByRole,
  findAllByRole: findAllByRole,
  findByRole: findByRole,
  queryByTestId: queryByTestId,
  queryAllByTestId: queryAllByTestIdWithSuggestions,
  getByTestId: getByTestId,
  getAllByTestId: getAllByTestId,
  findAllByTestId: findAllByTestId,
  findByTestId: findByTestId
});

/**
 * @typedef {{[key: string]: Function}} FuncMap
 */

/**
 * @param {HTMLElement} element container
 * @param {FuncMap} queries object of functions
 * @param {Object} initialValue for reducer
 * @returns {FuncMap} returns object of functions bound to container
 */
function getQueriesForElement(element, queries$1, initialValue) {
  if (queries$1 === void 0) {
    queries$1 = queries;
  }
  if (initialValue === void 0) {
    initialValue = {};
  }
  return Object.keys(queries$1).reduce((helpers, key) => {
    const fn = queries$1[key];
    helpers[key] = fn.bind(null, element);
    return helpers;
  }, initialValue);
}

const isRemoved = result => !result || Array.isArray(result) && !result.length;

// Check if the element is not present.
// As the name implies, waitForElementToBeRemoved should check `present` --> `removed`
function initialCheck(elements) {
  if (isRemoved(elements)) {
    throw new Error('The element(s) given to waitForElementToBeRemoved are already removed. waitForElementToBeRemoved requires that the element(s) exist(s) before waiting for removal.');
  }
}
async function waitForElementToBeRemoved(callback, options) {
  // created here so we get a nice stacktrace
  const timeoutError = new Error('Timed out in waitForElementToBeRemoved.');
  if (typeof callback !== 'function') {
    initialCheck(callback);
    const elements = Array.isArray(callback) ? callback : [callback];
    const getRemainingElements = elements.map(element => {
      let parent = element.parentElement;
      if (parent === null) return () => null;
      while (parent.parentElement) parent = parent.parentElement;
      return () => parent.contains(element) ? element : null;
    });
    callback = () => getRemainingElements.map(c => c()).filter(Boolean);
  }
  initialCheck(callback());
  return waitForWrapper(() => {
    let result;
    try {
      result = callback();
    } catch (error) {
      if (error.name === 'TestingLibraryElementError') {
        return undefined;
      }
      throw error;
    }
    if (!isRemoved(result)) {
      throw timeoutError;
    }
    return undefined;
  }, options);
}

/*
eslint
  require-await: "off"
*/

const eventMap = {
  // Clipboard Events
  copy: {
    EventType: 'ClipboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  cut: {
    EventType: 'ClipboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  paste: {
    EventType: 'ClipboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Composition Events
  compositionEnd: {
    EventType: 'CompositionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  compositionStart: {
    EventType: 'CompositionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  compositionUpdate: {
    EventType: 'CompositionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Keyboard Events
  keyDown: {
    EventType: 'KeyboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  keyPress: {
    EventType: 'KeyboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  keyUp: {
    EventType: 'KeyboardEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  // Focus Events
  focus: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  blur: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  focusIn: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  focusOut: {
    EventType: 'FocusEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  // Form Events
  change: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  input: {
    EventType: 'InputEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  invalid: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: true
    }
  },
  submit: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  reset: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  // Mouse Events
  click: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      button: 0,
      composed: true
    }
  },
  contextMenu: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dblClick: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  drag: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragEnd: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragEnter: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragExit: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragLeave: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragOver: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragStart: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  drop: {
    EventType: 'DragEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseDown: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseEnter: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  mouseLeave: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  mouseMove: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseOut: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseOver: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseUp: {
    EventType: 'MouseEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Selection Events
  select: {
    EventType: 'Event',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // Touch Events
  touchCancel: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  touchEnd: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  touchMove: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  touchStart: {
    EventType: 'TouchEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // UI Events
  resize: {
    EventType: 'UIEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  scroll: {
    EventType: 'UIEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Wheel Events
  wheel: {
    EventType: 'WheelEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Media Events
  abort: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  canPlay: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  canPlayThrough: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  durationChange: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  emptied: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  encrypted: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  ended: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadedData: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadedMetadata: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadStart: {
    EventType: 'ProgressEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  pause: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  play: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  playing: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  progress: {
    EventType: 'ProgressEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  rateChange: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  seeked: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  seeking: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  stalled: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  suspend: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  timeUpdate: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  volumeChange: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  waiting: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Events
  load: {
    // TODO: load events can be UIEvent or Event depending on what generated them
    // This is where this abstraction breaks down.
    // But the common targets are <img />, <script /> and window.
    // Neither of these targets receive a UIEvent
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  error: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Animation Events
  animationStart: {
    EventType: 'AnimationEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  animationEnd: {
    EventType: 'AnimationEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  animationIteration: {
    EventType: 'AnimationEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // Transition Events
  transitionCancel: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  transitionEnd: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  transitionRun: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  transitionStart: {
    EventType: 'TransitionEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // pointer events
  pointerOver: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerEnter: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  pointerDown: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerMove: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerUp: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerCancel: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  pointerOut: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerLeave: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  gotPointerCapture: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  lostPointerCapture: {
    EventType: 'PointerEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  // history events
  popState: {
    EventType: 'PopStateEvent',
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // window events
  offline: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  online: {
    EventType: 'Event',
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  }
};
const eventAliasMap = {
  doubleClick: 'dblClick'
};

function fireEvent(element, event) {
  return getConfig().eventWrapper(() => {
    if (!event) {
      throw new Error("Unable to fire an event - please provide an event object.");
    }
    if (!element) {
      throw new Error("Unable to fire a \"" + event.type + "\" event - please provide a DOM element.");
    }
    return element.dispatchEvent(event);
  });
}
function createEvent(eventName, node, init, _temp) {
  let {
    EventType = 'Event',
    defaultInit = {}
  } = _temp === void 0 ? {} : _temp;
  if (!node) {
    throw new Error("Unable to fire a \"" + eventName + "\" event - please provide a DOM element.");
  }
  const eventInit = {
    ...defaultInit,
    ...init
  };
  const {
    target: {
      value,
      files,
      ...targetProperties
    } = {}
  } = eventInit;
  if (value !== undefined) {
    setNativeValue(node, value);
  }
  if (files !== undefined) {
    // input.files is a read-only property so this is not allowed:
    // input.files = [file]
    // so we have to use this workaround to set the property
    Object.defineProperty(node, 'files', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: files
    });
  }
  Object.assign(node, targetProperties);
  const window = getWindowFromNode(node);
  const EventConstructor = window[EventType] || window.Event;
  let event;
  /* istanbul ignore else  */
  if (typeof EventConstructor === 'function') {
    event = new EventConstructor(eventName, eventInit);
  } else {
    // IE11 polyfill from https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
    event = window.document.createEvent(EventType);
    const {
      bubbles,
      cancelable,
      detail,
      ...otherInit
    } = eventInit;
    event.initEvent(eventName, bubbles, cancelable, detail);
    Object.keys(otherInit).forEach(eventKey => {
      event[eventKey] = otherInit[eventKey];
    });
  }

  // DataTransfer is not supported in jsdom: https://github.com/jsdom/jsdom/issues/1568
  const dataTransferProperties = ['dataTransfer', 'clipboardData'];
  dataTransferProperties.forEach(dataTransferKey => {
    const dataTransferValue = eventInit[dataTransferKey];
    if (typeof dataTransferValue === 'object') {
      /* istanbul ignore if  */
      if (typeof window.DataTransfer === 'function') {
        Object.defineProperty(event, dataTransferKey, {
          value: Object.getOwnPropertyNames(dataTransferValue).reduce((acc, propName) => {
            Object.defineProperty(acc, propName, {
              value: dataTransferValue[propName]
            });
            return acc;
          }, new window.DataTransfer())
        });
      } else {
        Object.defineProperty(event, dataTransferKey, {
          value: dataTransferValue
        });
      }
    }
  });
  return event;
}
Object.keys(eventMap).forEach(key => {
  const {
    EventType,
    defaultInit
  } = eventMap[key];
  const eventName = key.toLowerCase();
  createEvent[key] = (node, init) => createEvent(eventName, node, init, {
    EventType,
    defaultInit
  });
  fireEvent[key] = (node, init) => fireEvent(node, createEvent[key](node, init));
});

// function written after some investigation here:
// https://github.com/facebook/react/issues/10135#issuecomment-401496776
function setNativeValue(element, value) {
  const {
    set: valueSetter
  } = Object.getOwnPropertyDescriptor(element, 'value') || {};
  const prototype = Object.getPrototypeOf(element);
  const {
    set: prototypeValueSetter
  } = Object.getOwnPropertyDescriptor(prototype, 'value') || {};
  if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
    prototypeValueSetter.call(element, value);
  } else {
    /* istanbul ignore if */
    // eslint-disable-next-line no-lonely-if -- Can't be ignored by istanbul otherwise
    if (valueSetter) {
      valueSetter.call(element, value);
    } else {
      throw new Error('The given element does not have a value setter');
    }
  }
}
Object.keys(eventAliasMap).forEach(aliasKey => {
  const key = eventAliasMap[aliasKey];
  fireEvent[aliasKey] = function () {
    return fireEvent[key](...arguments);
  };
});

/* eslint complexity:["error", 9] */

// WARNING: `lz-string` only has a default export but statically we assume named exports are allowd
function unindent(string) {
  // remove white spaces first, to save a few bytes.
  // testing-playground will reformat on load any ways.
  return string.replace(/[ \t]*[\n][ \t]*/g, '\n');
}
function encode(value) {
  return lz_string_default().compressToEncodedURIComponent(unindent(value));
}
function getPlaygroundUrl(markup) {
  return "https://testing-playground.com/#markup=" + encode(markup);
}
const debug = (element, maxLength, options) => Array.isArray(element) ? element.forEach(el => logDOM(el, maxLength, options)) : logDOM(element, maxLength, options);
const logTestingPlaygroundURL = function (element) {
  if (element === void 0) {
    element = getDocument().body;
  }
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!element || !('innerHTML' in element)) {
    console.log("The element you're providing isn't a valid DOM element.");
    return;
  }
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!element.innerHTML) {
    console.log("The provided element doesn't have any children.");
    return;
  }
  const playgroundUrl = getPlaygroundUrl(element.innerHTML);
  console.log("Open this URL in your browser\n\n" + playgroundUrl);
  return playgroundUrl;
};
const initialValue = {
  debug,
  logTestingPlaygroundURL
};
const screen = typeof document !== 'undefined' && document.body // eslint-disable-line @typescript-eslint/no-unnecessary-condition
? getQueriesForElement(document.body, queries, initialValue) : Object.keys(queries).reduce((helpers, key) => {
  // `key` is for all intents and purposes the type of keyof `helpers`, which itself is the type of `initialValue` plus incoming properties from `queries`
  // if `Object.keys(something)` returned Array<keyof typeof something> this explicit type assertion would not be necessary
  // see https://stackoverflow.com/questions/55012174/why-doesnt-object-keys-return-a-keyof-type-in-typescript
  helpers[key] = () => {
    throw new TypeError('For queries bound to document.body a global document has to be available... Learn more: https://testing-library.com/s/screen-global-error');
  };
  return helpers;
}, initialValue);




/***/ }),

/***/ 76429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


const ANSI_BACKGROUND_OFFSET = 10;

const wrapAnsi256 = (offset = 0) => code => `\u001B[${38 + offset};5;${code}m`;

const wrapAnsi16m = (offset = 0) => (red, green, blue) => `\u001B[${38 + offset};2;${red};${green};${blue}m`;

function assembleStyles() {
	const codes = new Map();
	const styles = {
		modifier: {
			reset: [0, 0],
			// 21 isn't widely supported and 22 does the same thing
			bold: [1, 22],
			dim: [2, 22],
			italic: [3, 23],
			underline: [4, 24],
			overline: [53, 55],
			inverse: [7, 27],
			hidden: [8, 28],
			strikethrough: [9, 29]
		},
		color: {
			black: [30, 39],
			red: [31, 39],
			green: [32, 39],
			yellow: [33, 39],
			blue: [34, 39],
			magenta: [35, 39],
			cyan: [36, 39],
			white: [37, 39],

			// Bright color
			blackBright: [90, 39],
			redBright: [91, 39],
			greenBright: [92, 39],
			yellowBright: [93, 39],
			blueBright: [94, 39],
			magentaBright: [95, 39],
			cyanBright: [96, 39],
			whiteBright: [97, 39]
		},
		bgColor: {
			bgBlack: [40, 49],
			bgRed: [41, 49],
			bgGreen: [42, 49],
			bgYellow: [43, 49],
			bgBlue: [44, 49],
			bgMagenta: [45, 49],
			bgCyan: [46, 49],
			bgWhite: [47, 49],

			// Bright color
			bgBlackBright: [100, 49],
			bgRedBright: [101, 49],
			bgGreenBright: [102, 49],
			bgYellowBright: [103, 49],
			bgBlueBright: [104, 49],
			bgMagentaBright: [105, 49],
			bgCyanBright: [106, 49],
			bgWhiteBright: [107, 49]
		}
	};

	// Alias bright black as gray (and grey)
	styles.color.gray = styles.color.blackBright;
	styles.bgColor.bgGray = styles.bgColor.bgBlackBright;
	styles.color.grey = styles.color.blackBright;
	styles.bgColor.bgGrey = styles.bgColor.bgBlackBright;

	for (const [groupName, group] of Object.entries(styles)) {
		for (const [styleName, style] of Object.entries(group)) {
			styles[styleName] = {
				open: `\u001B[${style[0]}m`,
				close: `\u001B[${style[1]}m`
			};

			group[styleName] = styles[styleName];

			codes.set(style[0], style[1]);
		}

		Object.defineProperty(styles, groupName, {
			value: group,
			enumerable: false
		});
	}

	Object.defineProperty(styles, 'codes', {
		value: codes,
		enumerable: false
	});

	styles.color.close = '\u001B[39m';
	styles.bgColor.close = '\u001B[49m';

	styles.color.ansi256 = wrapAnsi256();
	styles.color.ansi16m = wrapAnsi16m();
	styles.bgColor.ansi256 = wrapAnsi256(ANSI_BACKGROUND_OFFSET);
	styles.bgColor.ansi16m = wrapAnsi16m(ANSI_BACKGROUND_OFFSET);

	// From https://github.com/Qix-/color-convert/blob/3f0e0d4e92e235796ccb17f6e85c72094a651f49/conversions.js
	Object.defineProperties(styles, {
		rgbToAnsi256: {
			value: (red, green, blue) => {
				// We use the extended greyscale palette here, with the exception of
				// black and white. normal palette only has 4 greyscale shades.
				if (red === green && green === blue) {
					if (red < 8) {
						return 16;
					}

					if (red > 248) {
						return 231;
					}

					return Math.round(((red - 8) / 247) * 24) + 232;
				}

				return 16 +
					(36 * Math.round(red / 255 * 5)) +
					(6 * Math.round(green / 255 * 5)) +
					Math.round(blue / 255 * 5);
			},
			enumerable: false
		},
		hexToRgb: {
			value: hex => {
				const matches = /(?<colorString>[a-f\d]{6}|[a-f\d]{3})/i.exec(hex.toString(16));
				if (!matches) {
					return [0, 0, 0];
				}

				let {colorString} = matches.groups;

				if (colorString.length === 3) {
					colorString = colorString.split('').map(character => character + character).join('');
				}

				const integer = Number.parseInt(colorString, 16);

				return [
					(integer >> 16) & 0xFF,
					(integer >> 8) & 0xFF,
					integer & 0xFF
				];
			},
			enumerable: false
		},
		hexToAnsi256: {
			value: hex => styles.rgbToAnsi256(...styles.hexToRgb(hex)),
			enumerable: false
		}
	});

	return styles;
}

// Make the export immutable
Object.defineProperty(module, 'exports', {
	enumerable: true,
	get: assembleStyles
});


/***/ }),

/***/ 31551:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.printIteratorEntries = printIteratorEntries;
exports.printIteratorValues = printIteratorValues;
exports.printListItems = printListItems;
exports.printObjectProperties = printObjectProperties;

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
const getKeysOfEnumerableProperties = (object, compareKeys) => {
  const keys = Object.keys(object).sort(compareKeys);

  if (Object.getOwnPropertySymbols) {
    Object.getOwnPropertySymbols(object).forEach(symbol => {
      if (Object.getOwnPropertyDescriptor(object, symbol).enumerable) {
        keys.push(symbol);
      }
    });
  }

  return keys;
};
/**
 * Return entries (for example, of a map)
 * with spacing, indentation, and comma
 * without surrounding punctuation (for example, braces)
 */

function printIteratorEntries(
  iterator,
  config,
  indentation,
  depth,
  refs,
  printer, // Too bad, so sad that separator for ECMAScript Map has been ' => '
  // What a distracting diff if you change a data structure to/from
  // ECMAScript Object or Immutable.Map/OrderedMap which use the default.
  separator = ': '
) {
  let result = '';
  let current = iterator.next();

  if (!current.done) {
    result += config.spacingOuter;
    const indentationNext = indentation + config.indent;

    while (!current.done) {
      const name = printer(
        current.value[0],
        config,
        indentationNext,
        depth,
        refs
      );
      const value = printer(
        current.value[1],
        config,
        indentationNext,
        depth,
        refs
      );
      result += indentationNext + name + separator + value;
      current = iterator.next();

      if (!current.done) {
        result += ',' + config.spacingInner;
      } else if (!config.min) {
        result += ',';
      }
    }

    result += config.spacingOuter + indentation;
  }

  return result;
}
/**
 * Return values (for example, of a set)
 * with spacing, indentation, and comma
 * without surrounding punctuation (braces or brackets)
 */

function printIteratorValues(
  iterator,
  config,
  indentation,
  depth,
  refs,
  printer
) {
  let result = '';
  let current = iterator.next();

  if (!current.done) {
    result += config.spacingOuter;
    const indentationNext = indentation + config.indent;

    while (!current.done) {
      result +=
        indentationNext +
        printer(current.value, config, indentationNext, depth, refs);
      current = iterator.next();

      if (!current.done) {
        result += ',' + config.spacingInner;
      } else if (!config.min) {
        result += ',';
      }
    }

    result += config.spacingOuter + indentation;
  }

  return result;
}
/**
 * Return items (for example, of an array)
 * with spacing, indentation, and comma
 * without surrounding punctuation (for example, brackets)
 **/

function printListItems(list, config, indentation, depth, refs, printer) {
  let result = '';

  if (list.length) {
    result += config.spacingOuter;
    const indentationNext = indentation + config.indent;

    for (let i = 0; i < list.length; i++) {
      result += indentationNext;

      if (i in list) {
        result += printer(list[i], config, indentationNext, depth, refs);
      }

      if (i < list.length - 1) {
        result += ',' + config.spacingInner;
      } else if (!config.min) {
        result += ',';
      }
    }

    result += config.spacingOuter + indentation;
  }

  return result;
}
/**
 * Return properties of an object
 * with spacing, indentation, and comma
 * without surrounding punctuation (for example, braces)
 */

function printObjectProperties(val, config, indentation, depth, refs, printer) {
  let result = '';
  const keys = getKeysOfEnumerableProperties(val, config.compareKeys);

  if (keys.length) {
    result += config.spacingOuter;
    const indentationNext = indentation + config.indent;

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const name = printer(key, config, indentationNext, depth, refs);
      const value = printer(val[key], config, indentationNext, depth, refs);
      result += indentationNext + name + ': ' + value;

      if (i < keys.length - 1) {
        result += ',' + config.spacingInner;
      } else if (!config.min) {
        result += ',';
      }
    }

    result += config.spacingOuter + indentation;
  }

  return result;
}


/***/ }),

/***/ 57739:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = __webpack_unused_export__ = void 0;
exports.WU = format;
exports.Gr = void 0;

var _ansiStyles = _interopRequireDefault(__webpack_require__(76429));

var _collections = __webpack_require__(31551);

var _AsymmetricMatcher = _interopRequireDefault(
  __webpack_require__(38215)
);

var _ConvertAnsi = _interopRequireDefault(__webpack_require__(81635));

var _DOMCollection = _interopRequireDefault(__webpack_require__(50655));

var _DOMElement = _interopRequireDefault(__webpack_require__(4425));

var _Immutable = _interopRequireDefault(__webpack_require__(51727));

var _ReactElement = _interopRequireDefault(__webpack_require__(87247));

var _ReactTestComponent = _interopRequireDefault(
  __webpack_require__(85642)
);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/* eslint-disable local/ban-types-eventually */
const toString = Object.prototype.toString;
const toISOString = Date.prototype.toISOString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
/**
 * Explicitly comparing typeof constructor to function avoids undefined as name
 * when mock identity-obj-proxy returns the key as the value for any key.
 */

const getConstructorName = val =>
  (typeof val.constructor === 'function' && val.constructor.name) || 'Object';
/* global window */

/** Is val is equal to global window object? Works even if it does not exist :) */

const isWindow = val => typeof window !== 'undefined' && val === window;

const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
const NEWLINE_REGEXP = /\n/gi;

class PrettyFormatPluginError extends Error {
  constructor(message, stack) {
    super(message);
    this.stack = stack;
    this.name = this.constructor.name;
  }
}

function isToStringedArrayType(toStringed) {
  return (
    toStringed === '[object Array]' ||
    toStringed === '[object ArrayBuffer]' ||
    toStringed === '[object DataView]' ||
    toStringed === '[object Float32Array]' ||
    toStringed === '[object Float64Array]' ||
    toStringed === '[object Int8Array]' ||
    toStringed === '[object Int16Array]' ||
    toStringed === '[object Int32Array]' ||
    toStringed === '[object Uint8Array]' ||
    toStringed === '[object Uint8ClampedArray]' ||
    toStringed === '[object Uint16Array]' ||
    toStringed === '[object Uint32Array]'
  );
}

function printNumber(val) {
  return Object.is(val, -0) ? '-0' : String(val);
}

function printBigInt(val) {
  return String(`${val}n`);
}

function printFunction(val, printFunctionName) {
  if (!printFunctionName) {
    return '[Function]';
  }

  return '[Function ' + (val.name || 'anonymous') + ']';
}

function printSymbol(val) {
  return String(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
}

function printError(val) {
  return '[' + errorToString.call(val) + ']';
}
/**
 * The first port of call for printing an object, handles most of the
 * data-types in JS.
 */

function printBasicValue(val, printFunctionName, escapeRegex, escapeString) {
  if (val === true || val === false) {
    return '' + val;
  }

  if (val === undefined) {
    return 'undefined';
  }

  if (val === null) {
    return 'null';
  }

  const typeOf = typeof val;

  if (typeOf === 'number') {
    return printNumber(val);
  }

  if (typeOf === 'bigint') {
    return printBigInt(val);
  }

  if (typeOf === 'string') {
    if (escapeString) {
      return '"' + val.replace(/"|\\/g, '\\$&') + '"';
    }

    return '"' + val + '"';
  }

  if (typeOf === 'function') {
    return printFunction(val, printFunctionName);
  }

  if (typeOf === 'symbol') {
    return printSymbol(val);
  }

  const toStringed = toString.call(val);

  if (toStringed === '[object WeakMap]') {
    return 'WeakMap {}';
  }

  if (toStringed === '[object WeakSet]') {
    return 'WeakSet {}';
  }

  if (
    toStringed === '[object Function]' ||
    toStringed === '[object GeneratorFunction]'
  ) {
    return printFunction(val, printFunctionName);
  }

  if (toStringed === '[object Symbol]') {
    return printSymbol(val);
  }

  if (toStringed === '[object Date]') {
    return isNaN(+val) ? 'Date { NaN }' : toISOString.call(val);
  }

  if (toStringed === '[object Error]') {
    return printError(val);
  }

  if (toStringed === '[object RegExp]') {
    if (escapeRegex) {
      // https://github.com/benjamingr/RegExp.escape/blob/main/polyfill.js
      return regExpToString.call(val).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    return regExpToString.call(val);
  }

  if (val instanceof Error) {
    return printError(val);
  }

  return null;
}
/**
 * Handles more complex objects ( such as objects with circular references.
 * maps and sets etc )
 */

function printComplexValue(
  val,
  config,
  indentation,
  depth,
  refs,
  hasCalledToJSON
) {
  if (refs.indexOf(val) !== -1) {
    return '[Circular]';
  }

  refs = refs.slice();
  refs.push(val);
  const hitMaxDepth = ++depth > config.maxDepth;
  const min = config.min;

  if (
    config.callToJSON &&
    !hitMaxDepth &&
    val.toJSON &&
    typeof val.toJSON === 'function' &&
    !hasCalledToJSON
  ) {
    return printer(val.toJSON(), config, indentation, depth, refs, true);
  }

  const toStringed = toString.call(val);

  if (toStringed === '[object Arguments]') {
    return hitMaxDepth
      ? '[Arguments]'
      : (min ? '' : 'Arguments ') +
          '[' +
          (0, _collections.printListItems)(
            val,
            config,
            indentation,
            depth,
            refs,
            printer
          ) +
          ']';
  }

  if (isToStringedArrayType(toStringed)) {
    return hitMaxDepth
      ? '[' + val.constructor.name + ']'
      : (min
          ? ''
          : !config.printBasicPrototype && val.constructor.name === 'Array'
          ? ''
          : val.constructor.name + ' ') +
          '[' +
          (0, _collections.printListItems)(
            val,
            config,
            indentation,
            depth,
            refs,
            printer
          ) +
          ']';
  }

  if (toStringed === '[object Map]') {
    return hitMaxDepth
      ? '[Map]'
      : 'Map {' +
          (0, _collections.printIteratorEntries)(
            val.entries(),
            config,
            indentation,
            depth,
            refs,
            printer,
            ' => '
          ) +
          '}';
  }

  if (toStringed === '[object Set]') {
    return hitMaxDepth
      ? '[Set]'
      : 'Set {' +
          (0, _collections.printIteratorValues)(
            val.values(),
            config,
            indentation,
            depth,
            refs,
            printer
          ) +
          '}';
  } // Avoid failure to serialize global window object in jsdom test environment.
  // For example, not even relevant if window is prop of React element.

  return hitMaxDepth || isWindow(val)
    ? '[' + getConstructorName(val) + ']'
    : (min
        ? ''
        : !config.printBasicPrototype && getConstructorName(val) === 'Object'
        ? ''
        : getConstructorName(val) + ' ') +
        '{' +
        (0, _collections.printObjectProperties)(
          val,
          config,
          indentation,
          depth,
          refs,
          printer
        ) +
        '}';
}

function isNewPlugin(plugin) {
  return plugin.serialize != null;
}

function printPlugin(plugin, val, config, indentation, depth, refs) {
  let printed;

  try {
    printed = isNewPlugin(plugin)
      ? plugin.serialize(val, config, indentation, depth, refs, printer)
      : plugin.print(
          val,
          valChild => printer(valChild, config, indentation, depth, refs),
          str => {
            const indentationNext = indentation + config.indent;
            return (
              indentationNext +
              str.replace(NEWLINE_REGEXP, '\n' + indentationNext)
            );
          },
          {
            edgeSpacing: config.spacingOuter,
            min: config.min,
            spacing: config.spacingInner
          },
          config.colors
        );
  } catch (error) {
    throw new PrettyFormatPluginError(error.message, error.stack);
  }

  if (typeof printed !== 'string') {
    throw new Error(
      `pretty-format: Plugin must return type "string" but instead returned "${typeof printed}".`
    );
  }

  return printed;
}

function findPlugin(plugins, val) {
  for (let p = 0; p < plugins.length; p++) {
    try {
      if (plugins[p].test(val)) {
        return plugins[p];
      }
    } catch (error) {
      throw new PrettyFormatPluginError(error.message, error.stack);
    }
  }

  return null;
}

function printer(val, config, indentation, depth, refs, hasCalledToJSON) {
  const plugin = findPlugin(config.plugins, val);

  if (plugin !== null) {
    return printPlugin(plugin, val, config, indentation, depth, refs);
  }

  const basicResult = printBasicValue(
    val,
    config.printFunctionName,
    config.escapeRegex,
    config.escapeString
  );

  if (basicResult !== null) {
    return basicResult;
  }

  return printComplexValue(
    val,
    config,
    indentation,
    depth,
    refs,
    hasCalledToJSON
  );
}

const DEFAULT_THEME = {
  comment: 'gray',
  content: 'reset',
  prop: 'yellow',
  tag: 'cyan',
  value: 'green'
};
const DEFAULT_THEME_KEYS = Object.keys(DEFAULT_THEME);
const DEFAULT_OPTIONS = {
  callToJSON: true,
  compareKeys: undefined,
  escapeRegex: false,
  escapeString: true,
  highlight: false,
  indent: 2,
  maxDepth: Infinity,
  min: false,
  plugins: [],
  printBasicPrototype: true,
  printFunctionName: true,
  theme: DEFAULT_THEME
};
__webpack_unused_export__ = DEFAULT_OPTIONS;

function validateOptions(options) {
  Object.keys(options).forEach(key => {
    if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
      throw new Error(`pretty-format: Unknown option "${key}".`);
    }
  });

  if (options.min && options.indent !== undefined && options.indent !== 0) {
    throw new Error(
      'pretty-format: Options "min" and "indent" cannot be used together.'
    );
  }

  if (options.theme !== undefined) {
    if (options.theme === null) {
      throw new Error('pretty-format: Option "theme" must not be null.');
    }

    if (typeof options.theme !== 'object') {
      throw new Error(
        `pretty-format: Option "theme" must be of type "object" but instead received "${typeof options.theme}".`
      );
    }
  }
}

const getColorsHighlight = options =>
  DEFAULT_THEME_KEYS.reduce((colors, key) => {
    const value =
      options.theme && options.theme[key] !== undefined
        ? options.theme[key]
        : DEFAULT_THEME[key];
    const color = value && _ansiStyles.default[value];

    if (
      color &&
      typeof color.close === 'string' &&
      typeof color.open === 'string'
    ) {
      colors[key] = color;
    } else {
      throw new Error(
        `pretty-format: Option "theme" has a key "${key}" whose value "${value}" is undefined in ansi-styles.`
      );
    }

    return colors;
  }, Object.create(null));

const getColorsEmpty = () =>
  DEFAULT_THEME_KEYS.reduce((colors, key) => {
    colors[key] = {
      close: '',
      open: ''
    };
    return colors;
  }, Object.create(null));

const getPrintFunctionName = options =>
  options && options.printFunctionName !== undefined
    ? options.printFunctionName
    : DEFAULT_OPTIONS.printFunctionName;

const getEscapeRegex = options =>
  options && options.escapeRegex !== undefined
    ? options.escapeRegex
    : DEFAULT_OPTIONS.escapeRegex;

const getEscapeString = options =>
  options && options.escapeString !== undefined
    ? options.escapeString
    : DEFAULT_OPTIONS.escapeString;

const getConfig = options => {
  var _options$printBasicPr;

  return {
    callToJSON:
      options && options.callToJSON !== undefined
        ? options.callToJSON
        : DEFAULT_OPTIONS.callToJSON,
    colors:
      options && options.highlight
        ? getColorsHighlight(options)
        : getColorsEmpty(),
    compareKeys:
      options && typeof options.compareKeys === 'function'
        ? options.compareKeys
        : DEFAULT_OPTIONS.compareKeys,
    escapeRegex: getEscapeRegex(options),
    escapeString: getEscapeString(options),
    indent:
      options && options.min
        ? ''
        : createIndent(
            options && options.indent !== undefined
              ? options.indent
              : DEFAULT_OPTIONS.indent
          ),
    maxDepth:
      options && options.maxDepth !== undefined
        ? options.maxDepth
        : DEFAULT_OPTIONS.maxDepth,
    min:
      options && options.min !== undefined ? options.min : DEFAULT_OPTIONS.min,
    plugins:
      options && options.plugins !== undefined
        ? options.plugins
        : DEFAULT_OPTIONS.plugins,
    printBasicPrototype:
      (_options$printBasicPr =
        options === null || options === void 0
          ? void 0
          : options.printBasicPrototype) !== null &&
      _options$printBasicPr !== void 0
        ? _options$printBasicPr
        : true,
    printFunctionName: getPrintFunctionName(options),
    spacingInner: options && options.min ? ' ' : '\n',
    spacingOuter: options && options.min ? '' : '\n'
  };
};

function createIndent(indent) {
  return new Array(indent + 1).join(' ');
}
/**
 * Returns a presentation string of your `val` object
 * @param val any potential JavaScript object
 * @param options Custom settings
 */

function format(val, options) {
  if (options) {
    validateOptions(options);

    if (options.plugins) {
      const plugin = findPlugin(options.plugins, val);

      if (plugin !== null) {
        return printPlugin(plugin, val, getConfig(options), '', 0, []);
      }
    }
  }

  const basicResult = printBasicValue(
    val,
    getPrintFunctionName(options),
    getEscapeRegex(options),
    getEscapeString(options)
  );

  if (basicResult !== null) {
    return basicResult;
  }

  return printComplexValue(val, getConfig(options), '', 0, []);
}

const plugins = {
  AsymmetricMatcher: _AsymmetricMatcher.default,
  ConvertAnsi: _ConvertAnsi.default,
  DOMCollection: _DOMCollection.default,
  DOMElement: _DOMElement.default,
  Immutable: _Immutable.default,
  ReactElement: _ReactElement.default,
  ReactTestComponent: _ReactTestComponent.default
};
exports.Gr = plugins;
var _default = format;
__webpack_unused_export__ = _default;


/***/ }),

/***/ 38215:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _collections = __webpack_require__(31551);

var global = (function () {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  } else if (typeof global !== 'undefined') {
    return global;
  } else if (typeof self !== 'undefined') {
    return self;
  } else if (typeof window !== 'undefined') {
    return window;
  } else {
    return Function('return this')();
  }
})();

var Symbol = global['jest-symbol-do-not-touch'] || global.Symbol;
const asymmetricMatcher =
  typeof Symbol === 'function' && Symbol.for
    ? Symbol.for('jest.asymmetricMatcher')
    : 0x1357a5;
const SPACE = ' ';

const serialize = (val, config, indentation, depth, refs, printer) => {
  const stringedValue = val.toString();

  if (
    stringedValue === 'ArrayContaining' ||
    stringedValue === 'ArrayNotContaining'
  ) {
    if (++depth > config.maxDepth) {
      return '[' + stringedValue + ']';
    }

    return (
      stringedValue +
      SPACE +
      '[' +
      (0, _collections.printListItems)(
        val.sample,
        config,
        indentation,
        depth,
        refs,
        printer
      ) +
      ']'
    );
  }

  if (
    stringedValue === 'ObjectContaining' ||
    stringedValue === 'ObjectNotContaining'
  ) {
    if (++depth > config.maxDepth) {
      return '[' + stringedValue + ']';
    }

    return (
      stringedValue +
      SPACE +
      '{' +
      (0, _collections.printObjectProperties)(
        val.sample,
        config,
        indentation,
        depth,
        refs,
        printer
      ) +
      '}'
    );
  }

  if (
    stringedValue === 'StringMatching' ||
    stringedValue === 'StringNotMatching'
  ) {
    return (
      stringedValue +
      SPACE +
      printer(val.sample, config, indentation, depth, refs)
    );
  }

  if (
    stringedValue === 'StringContaining' ||
    stringedValue === 'StringNotContaining'
  ) {
    return (
      stringedValue +
      SPACE +
      printer(val.sample, config, indentation, depth, refs)
    );
  }

  return val.toAsymmetricMatcher();
};

exports.serialize = serialize;

const test = val => val && val.$$typeof === asymmetricMatcher;

exports.test = test;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 81635:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _ansiRegex = _interopRequireDefault(__webpack_require__(29470));

var _ansiStyles = _interopRequireDefault(__webpack_require__(76429));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const toHumanReadableAnsi = text =>
  text.replace((0, _ansiRegex.default)(), match => {
    switch (match) {
      case _ansiStyles.default.red.close:
      case _ansiStyles.default.green.close:
      case _ansiStyles.default.cyan.close:
      case _ansiStyles.default.gray.close:
      case _ansiStyles.default.white.close:
      case _ansiStyles.default.yellow.close:
      case _ansiStyles.default.bgRed.close:
      case _ansiStyles.default.bgGreen.close:
      case _ansiStyles.default.bgYellow.close:
      case _ansiStyles.default.inverse.close:
      case _ansiStyles.default.dim.close:
      case _ansiStyles.default.bold.close:
      case _ansiStyles.default.reset.open:
      case _ansiStyles.default.reset.close:
        return '</>';

      case _ansiStyles.default.red.open:
        return '<red>';

      case _ansiStyles.default.green.open:
        return '<green>';

      case _ansiStyles.default.cyan.open:
        return '<cyan>';

      case _ansiStyles.default.gray.open:
        return '<gray>';

      case _ansiStyles.default.white.open:
        return '<white>';

      case _ansiStyles.default.yellow.open:
        return '<yellow>';

      case _ansiStyles.default.bgRed.open:
        return '<bgRed>';

      case _ansiStyles.default.bgGreen.open:
        return '<bgGreen>';

      case _ansiStyles.default.bgYellow.open:
        return '<bgYellow>';

      case _ansiStyles.default.inverse.open:
        return '<inverse>';

      case _ansiStyles.default.dim.open:
        return '<dim>';

      case _ansiStyles.default.bold.open:
        return '<bold>';

      default:
        return '';
    }
  });

const test = val =>
  typeof val === 'string' && !!val.match((0, _ansiRegex.default)());

exports.test = test;

const serialize = (val, config, indentation, depth, refs, printer) =>
  printer(toHumanReadableAnsi(val), config, indentation, depth, refs);

exports.serialize = serialize;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 50655:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _collections = __webpack_require__(31551);

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/* eslint-disable local/ban-types-eventually */
const SPACE = ' ';
const OBJECT_NAMES = ['DOMStringMap', 'NamedNodeMap'];
const ARRAY_REGEXP = /^(HTML\w*Collection|NodeList)$/;

const testName = name =>
  OBJECT_NAMES.indexOf(name) !== -1 || ARRAY_REGEXP.test(name);

const test = val =>
  val &&
  val.constructor &&
  !!val.constructor.name &&
  testName(val.constructor.name);

exports.test = test;

const isNamedNodeMap = collection =>
  collection.constructor.name === 'NamedNodeMap';

const serialize = (collection, config, indentation, depth, refs, printer) => {
  const name = collection.constructor.name;

  if (++depth > config.maxDepth) {
    return '[' + name + ']';
  }

  return (
    (config.min ? '' : name + SPACE) +
    (OBJECT_NAMES.indexOf(name) !== -1
      ? '{' +
        (0, _collections.printObjectProperties)(
          isNamedNodeMap(collection)
            ? Array.from(collection).reduce((props, attribute) => {
                props[attribute.name] = attribute.value;
                return props;
              }, {})
            : {...collection},
          config,
          indentation,
          depth,
          refs,
          printer
        ) +
        '}'
      : '[' +
        (0, _collections.printListItems)(
          Array.from(collection),
          config,
          indentation,
          depth,
          refs,
          printer
        ) +
        ']')
  );
};

exports.serialize = serialize;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 4425:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _markup = __webpack_require__(54092);

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const ELEMENT_NODE = 1;
const TEXT_NODE = 3;
const COMMENT_NODE = 8;
const FRAGMENT_NODE = 11;
const ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/;

const testHasAttribute = val => {
  try {
    return typeof val.hasAttribute === 'function' && val.hasAttribute('is');
  } catch {
    return false;
  }
};

const testNode = val => {
  const constructorName = val.constructor.name;
  const {nodeType, tagName} = val;
  const isCustomElement =
    (typeof tagName === 'string' && tagName.includes('-')) ||
    testHasAttribute(val);
  return (
    (nodeType === ELEMENT_NODE &&
      (ELEMENT_REGEXP.test(constructorName) || isCustomElement)) ||
    (nodeType === TEXT_NODE && constructorName === 'Text') ||
    (nodeType === COMMENT_NODE && constructorName === 'Comment') ||
    (nodeType === FRAGMENT_NODE && constructorName === 'DocumentFragment')
  );
};

const test = val => {
  var _val$constructor;

  return (
    (val === null || val === void 0
      ? void 0
      : (_val$constructor = val.constructor) === null ||
        _val$constructor === void 0
      ? void 0
      : _val$constructor.name) && testNode(val)
  );
};

exports.test = test;

function nodeIsText(node) {
  return node.nodeType === TEXT_NODE;
}

function nodeIsComment(node) {
  return node.nodeType === COMMENT_NODE;
}

function nodeIsFragment(node) {
  return node.nodeType === FRAGMENT_NODE;
}

const serialize = (node, config, indentation, depth, refs, printer) => {
  if (nodeIsText(node)) {
    return (0, _markup.printText)(node.data, config);
  }

  if (nodeIsComment(node)) {
    return (0, _markup.printComment)(node.data, config);
  }

  const type = nodeIsFragment(node)
    ? 'DocumentFragment'
    : node.tagName.toLowerCase();

  if (++depth > config.maxDepth) {
    return (0, _markup.printElementAsLeaf)(type, config);
  }

  return (0, _markup.printElement)(
    type,
    (0, _markup.printProps)(
      nodeIsFragment(node)
        ? []
        : Array.from(node.attributes)
            .map(attr => attr.name)
            .sort(),
      nodeIsFragment(node)
        ? {}
        : Array.from(node.attributes).reduce((props, attribute) => {
            props[attribute.name] = attribute.value;
            return props;
          }, {}),
      config,
      indentation + config.indent,
      depth,
      refs,
      printer
    ),
    (0, _markup.printChildren)(
      Array.prototype.slice.call(node.childNodes || node.children),
      config,
      indentation + config.indent,
      depth,
      refs,
      printer
    ),
    config,
    indentation
  );
};

exports.serialize = serialize;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 51727:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _collections = __webpack_require__(31551);

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// SENTINEL constants are from https://github.com/facebook/immutable-js
const IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
const IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
const IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
const IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
const IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
const IS_RECORD_SENTINEL = '@@__IMMUTABLE_RECORD__@@'; // immutable v4

const IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
const IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
const IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

const getImmutableName = name => 'Immutable.' + name;

const printAsLeaf = name => '[' + name + ']';

const SPACE = ' ';
const LAZY = '…'; // Seq is lazy if it calls a method like filter

const printImmutableEntries = (
  val,
  config,
  indentation,
  depth,
  refs,
  printer,
  type
) =>
  ++depth > config.maxDepth
    ? printAsLeaf(getImmutableName(type))
    : getImmutableName(type) +
      SPACE +
      '{' +
      (0, _collections.printIteratorEntries)(
        val.entries(),
        config,
        indentation,
        depth,
        refs,
        printer
      ) +
      '}'; // Record has an entries method because it is a collection in immutable v3.
// Return an iterator for Immutable Record from version v3 or v4.

function getRecordEntries(val) {
  let i = 0;
  return {
    next() {
      if (i < val._keys.length) {
        const key = val._keys[i++];
        return {
          done: false,
          value: [key, val.get(key)]
        };
      }

      return {
        done: true,
        value: undefined
      };
    }
  };
}

const printImmutableRecord = (
  val,
  config,
  indentation,
  depth,
  refs,
  printer
) => {
  // _name property is defined only for an Immutable Record instance
  // which was constructed with a second optional descriptive name arg
  const name = getImmutableName(val._name || 'Record');
  return ++depth > config.maxDepth
    ? printAsLeaf(name)
    : name +
        SPACE +
        '{' +
        (0, _collections.printIteratorEntries)(
          getRecordEntries(val),
          config,
          indentation,
          depth,
          refs,
          printer
        ) +
        '}';
};

const printImmutableSeq = (val, config, indentation, depth, refs, printer) => {
  const name = getImmutableName('Seq');

  if (++depth > config.maxDepth) {
    return printAsLeaf(name);
  }

  if (val[IS_KEYED_SENTINEL]) {
    return (
      name +
      SPACE +
      '{' + // from Immutable collection of entries or from ECMAScript object
      (val._iter || val._object
        ? (0, _collections.printIteratorEntries)(
            val.entries(),
            config,
            indentation,
            depth,
            refs,
            printer
          )
        : LAZY) +
      '}'
    );
  }

  return (
    name +
    SPACE +
    '[' +
    (val._iter || // from Immutable collection of values
    val._array || // from ECMAScript array
    val._collection || // from ECMAScript collection in immutable v4
    val._iterable // from ECMAScript collection in immutable v3
      ? (0, _collections.printIteratorValues)(
          val.values(),
          config,
          indentation,
          depth,
          refs,
          printer
        )
      : LAZY) +
    ']'
  );
};

const printImmutableValues = (
  val,
  config,
  indentation,
  depth,
  refs,
  printer,
  type
) =>
  ++depth > config.maxDepth
    ? printAsLeaf(getImmutableName(type))
    : getImmutableName(type) +
      SPACE +
      '[' +
      (0, _collections.printIteratorValues)(
        val.values(),
        config,
        indentation,
        depth,
        refs,
        printer
      ) +
      ']';

const serialize = (val, config, indentation, depth, refs, printer) => {
  if (val[IS_MAP_SENTINEL]) {
    return printImmutableEntries(
      val,
      config,
      indentation,
      depth,
      refs,
      printer,
      val[IS_ORDERED_SENTINEL] ? 'OrderedMap' : 'Map'
    );
  }

  if (val[IS_LIST_SENTINEL]) {
    return printImmutableValues(
      val,
      config,
      indentation,
      depth,
      refs,
      printer,
      'List'
    );
  }

  if (val[IS_SET_SENTINEL]) {
    return printImmutableValues(
      val,
      config,
      indentation,
      depth,
      refs,
      printer,
      val[IS_ORDERED_SENTINEL] ? 'OrderedSet' : 'Set'
    );
  }

  if (val[IS_STACK_SENTINEL]) {
    return printImmutableValues(
      val,
      config,
      indentation,
      depth,
      refs,
      printer,
      'Stack'
    );
  }

  if (val[IS_SEQ_SENTINEL]) {
    return printImmutableSeq(val, config, indentation, depth, refs, printer);
  } // For compatibility with immutable v3 and v4, let record be the default.

  return printImmutableRecord(val, config, indentation, depth, refs, printer);
}; // Explicitly comparing sentinel properties to true avoids false positive
// when mock identity-obj-proxy returns the key as the value for any key.

exports.serialize = serialize;

const test = val =>
  val &&
  (val[IS_ITERABLE_SENTINEL] === true || val[IS_RECORD_SENTINEL] === true);

exports.test = test;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 87247:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var ReactIs = _interopRequireWildcard(__webpack_require__(72594));

var _markup = __webpack_require__(54092);

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== 'function') return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || (typeof obj !== 'object' && typeof obj !== 'function')) {
    return {default: obj};
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor =
    Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor
        ? Object.getOwnPropertyDescriptor(obj, key)
        : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Given element.props.children, or subtree during recursive traversal,
// return flattened array of children.
const getChildren = (arg, children = []) => {
  if (Array.isArray(arg)) {
    arg.forEach(item => {
      getChildren(item, children);
    });
  } else if (arg != null && arg !== false) {
    children.push(arg);
  }

  return children;
};

const getType = element => {
  const type = element.type;

  if (typeof type === 'string') {
    return type;
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || 'Unknown';
  }

  if (ReactIs.isFragment(element)) {
    return 'React.Fragment';
  }

  if (ReactIs.isSuspense(element)) {
    return 'React.Suspense';
  }

  if (typeof type === 'object' && type !== null) {
    if (ReactIs.isContextProvider(element)) {
      return 'Context.Provider';
    }

    if (ReactIs.isContextConsumer(element)) {
      return 'Context.Consumer';
    }

    if (ReactIs.isForwardRef(element)) {
      if (type.displayName) {
        return type.displayName;
      }

      const functionName = type.render.displayName || type.render.name || '';
      return functionName !== ''
        ? 'ForwardRef(' + functionName + ')'
        : 'ForwardRef';
    }

    if (ReactIs.isMemo(element)) {
      const functionName =
        type.displayName || type.type.displayName || type.type.name || '';
      return functionName !== '' ? 'Memo(' + functionName + ')' : 'Memo';
    }
  }

  return 'UNDEFINED';
};

const getPropKeys = element => {
  const {props} = element;
  return Object.keys(props)
    .filter(key => key !== 'children' && props[key] !== undefined)
    .sort();
};

const serialize = (element, config, indentation, depth, refs, printer) =>
  ++depth > config.maxDepth
    ? (0, _markup.printElementAsLeaf)(getType(element), config)
    : (0, _markup.printElement)(
        getType(element),
        (0, _markup.printProps)(
          getPropKeys(element),
          element.props,
          config,
          indentation + config.indent,
          depth,
          refs,
          printer
        ),
        (0, _markup.printChildren)(
          getChildren(element.props.children),
          config,
          indentation + config.indent,
          depth,
          refs,
          printer
        ),
        config,
        indentation
      );

exports.serialize = serialize;

const test = val => val != null && ReactIs.isElement(val);

exports.test = test;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 85642:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.test = exports.serialize = exports["default"] = void 0;

var _markup = __webpack_require__(54092);

var global = (function () {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  } else if (typeof global !== 'undefined') {
    return global;
  } else if (typeof self !== 'undefined') {
    return self;
  } else if (typeof window !== 'undefined') {
    return window;
  } else {
    return Function('return this')();
  }
})();

var Symbol = global['jest-symbol-do-not-touch'] || global.Symbol;
const testSymbol =
  typeof Symbol === 'function' && Symbol.for
    ? Symbol.for('react.test.json')
    : 0xea71357;

const getPropKeys = object => {
  const {props} = object;
  return props
    ? Object.keys(props)
        .filter(key => props[key] !== undefined)
        .sort()
    : [];
};

const serialize = (object, config, indentation, depth, refs, printer) =>
  ++depth > config.maxDepth
    ? (0, _markup.printElementAsLeaf)(object.type, config)
    : (0, _markup.printElement)(
        object.type,
        object.props
          ? (0, _markup.printProps)(
              getPropKeys(object),
              object.props,
              config,
              indentation + config.indent,
              depth,
              refs,
              printer
            )
          : '',
        object.children
          ? (0, _markup.printChildren)(
              object.children,
              config,
              indentation + config.indent,
              depth,
              refs,
              printer
            )
          : '',
        config,
        indentation
      );

exports.serialize = serialize;

const test = val => val && val.$$typeof === testSymbol;

exports.test = test;
const plugin = {
  serialize,
  test
};
var _default = plugin;
exports["default"] = _default;


/***/ }),

/***/ 62934:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = escapeHTML;

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function escapeHTML(str) {
  return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}


/***/ }),

/***/ 54092:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.printText =
  exports.printProps =
  exports.printElementAsLeaf =
  exports.printElement =
  exports.printComment =
  exports.printChildren =
    void 0;

var _escapeHTML = _interopRequireDefault(__webpack_require__(62934));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {default: obj};
}

/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Return empty string if keys is empty.
const printProps = (keys, props, config, indentation, depth, refs, printer) => {
  const indentationNext = indentation + config.indent;
  const colors = config.colors;
  return keys
    .map(key => {
      const value = props[key];
      let printed = printer(value, config, indentationNext, depth, refs);

      if (typeof value !== 'string') {
        if (printed.indexOf('\n') !== -1) {
          printed =
            config.spacingOuter +
            indentationNext +
            printed +
            config.spacingOuter +
            indentation;
        }

        printed = '{' + printed + '}';
      }

      return (
        config.spacingInner +
        indentation +
        colors.prop.open +
        key +
        colors.prop.close +
        '=' +
        colors.value.open +
        printed +
        colors.value.close
      );
    })
    .join('');
}; // Return empty string if children is empty.

exports.printProps = printProps;

const printChildren = (children, config, indentation, depth, refs, printer) =>
  children
    .map(
      child =>
        config.spacingOuter +
        indentation +
        (typeof child === 'string'
          ? printText(child, config)
          : printer(child, config, indentation, depth, refs))
    )
    .join('');

exports.printChildren = printChildren;

const printText = (text, config) => {
  const contentColor = config.colors.content;
  return (
    contentColor.open + (0, _escapeHTML.default)(text) + contentColor.close
  );
};

exports.printText = printText;

const printComment = (comment, config) => {
  const commentColor = config.colors.comment;
  return (
    commentColor.open +
    '<!--' +
    (0, _escapeHTML.default)(comment) +
    '-->' +
    commentColor.close
  );
}; // Separate the functions to format props, children, and element,
// so a plugin could override a particular function, if needed.
// Too bad, so sad: the traditional (but unnecessary) space
// in a self-closing tagColor requires a second test of printedProps.

exports.printComment = printComment;

const printElement = (
  type,
  printedProps,
  printedChildren,
  config,
  indentation
) => {
  const tagColor = config.colors.tag;
  return (
    tagColor.open +
    '<' +
    type +
    (printedProps &&
      tagColor.close +
        printedProps +
        config.spacingOuter +
        indentation +
        tagColor.open) +
    (printedChildren
      ? '>' +
        tagColor.close +
        printedChildren +
        config.spacingOuter +
        indentation +
        tagColor.open +
        '</' +
        type
      : (printedProps && !config.min ? '' : ' ') + '/') +
    '>' +
    tagColor.close
  );
};

exports.printElement = printElement;

const printElementAsLeaf = (type, config) => {
  const tagColor = config.colors.tag;
  return (
    tagColor.open +
    '<' +
    type +
    tagColor.close +
    ' …' +
    tagColor.open +
    ' />' +
    tagColor.close
  );
};

exports.printElementAsLeaf = printElementAsLeaf;


/***/ }),

/***/ 72720:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// UNUSED EXPORTS: act, buildQueries, cleanup, configure, createEvent, findAllByAltText, findAllByDisplayValue, findAllByLabelText, findAllByPlaceholderText, findAllByRole, findAllByTestId, findAllByText, findAllByTitle, findByAltText, findByDisplayValue, findByLabelText, findByPlaceholderText, findByRole, findByTestId, findByText, findByTitle, fireEvent, getAllByAltText, getAllByDisplayValue, getAllByLabelText, getAllByPlaceholderText, getAllByRole, getAllByTestId, getAllByText, getAllByTitle, getByAltText, getByDisplayValue, getByLabelText, getByPlaceholderText, getByRole, getByTestId, getByText, getByTitle, getConfig, getDefaultNormalizer, getElementError, getMultipleElementsFoundError, getNodeText, getQueriesForElement, getRoles, getSuggestedQuery, isInaccessible, logDOM, logRoles, makeFindQuery, makeGetAllQuery, makeSingleQuery, prettyDOM, prettyFormat, queries, queryAllByAltText, queryAllByAttribute, queryAllByDisplayValue, queryAllByLabelText, queryAllByPlaceholderText, queryAllByRole, queryAllByTestId, queryAllByText, queryAllByTitle, queryByAltText, queryByAttribute, queryByDisplayValue, queryByLabelText, queryByPlaceholderText, queryByRole, queryByTestId, queryByText, queryByTitle, queryHelpers, render, screen, waitFor, waitForElementToBeRemoved, within, wrapAllByQueryWithSuggestion, wrapSingleQueryWithSuggestion

;// CONCATENATED MODULE: ../../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
// EXTERNAL MODULE: ../../../node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(72975);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/next/node_modules/react-dom/index.js
var react_dom = __webpack_require__(88872);
// EXTERNAL MODULE: ../../../node_modules/@testing-library/dom/dist/@testing-library/dom.esm.js + 8 modules
var dom_esm = __webpack_require__(82390);
// EXTERNAL MODULE: ../../../node_modules/react-dom/test-utils.js
var test_utils = __webpack_require__(30740);
;// CONCATENATED MODULE: ../../../node_modules/@testing-library/react/dist/@testing-library/react.esm.js
/* provided dependency */ var process = __webpack_require__(13158);









var reactAct = test_utils.act;
var actSupported = reactAct !== undefined; // act is supported react-dom@16.8.0
// so for versions that don't have act from test utils
// we do this little polyfill. No warnings, but it's
// better than nothing.

function actPolyfill(cb) {
  react_dom.unstable_batchedUpdates(cb);
  react_dom.render( /*#__PURE__*/react.createElement("div", null), document.createElement('div'));
}

var act = reactAct || actPolyfill;
var youHaveBeenWarned = false;
var isAsyncActSupported = null;

function asyncAct(cb) {
  if (actSupported === true) {
    if (isAsyncActSupported === null) {
      return new Promise(function (resolve, reject) {
        // patch console.error here
        var originalConsoleError = console.error;

        console.error = function error() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          /* if console.error fired *with that specific message* */

          /* istanbul ignore next */
          var firstArgIsString = typeof args[0] === 'string';

          if (firstArgIsString && args[0].indexOf('Warning: Do not await the result of calling ReactTestUtils.act') === 0) {
            // v16.8.6
            isAsyncActSupported = false;
          } else if (firstArgIsString && args[0].indexOf('Warning: The callback passed to ReactTestUtils.act(...) function must not return anything') === 0) ; else {
            originalConsoleError.apply(console, args);
          }
        };

        var cbReturn, result;

        try {
          result = reactAct(function () {
            cbReturn = cb();
            return cbReturn;
          });
        } catch (err) {
          console.error = originalConsoleError;
          reject(err);
          return;
        }

        result.then(function () {
          console.error = originalConsoleError; // if it got here, it means async act is supported

          isAsyncActSupported = true;
          resolve();
        }, function (err) {
          console.error = originalConsoleError;
          isAsyncActSupported = true;
          reject(err);
        }); // 16.8.6's act().then() doesn't call a resolve handler, so we need to manually flush here, sigh

        if (isAsyncActSupported === false) {
          console.error = originalConsoleError;
          /* istanbul ignore next */

          if (!youHaveBeenWarned) {
            // if act is supported and async act isn't and they're trying to use async
            // act, then they need to upgrade from 16.8 to 16.9.
            // This is a seamless upgrade, so we'll add a warning
            console.error("It looks like you're using a version of react-dom that supports the \"act\" function, but not an awaitable version of \"act\" which you will need. Please upgrade to at least react-dom@16.9.0 to remove this warning.");
            youHaveBeenWarned = true;
          }

          cbReturn.then(function () {
            // a faux-version.
            // todo - copy https://github.com/facebook/react/blob/master/packages/shared/enqueueTask.js
            Promise.resolve().then(function () {
              // use sync act to flush effects
              act(function () {});
              resolve();
            });
          }, reject);
        }
      });
    } else if (isAsyncActSupported === false) {
      // use the polyfill directly
      var _result;

      act(function () {
        _result = cb();
      });
      return _result.then(function () {
        return Promise.resolve().then(function () {
          // use sync act to flush effects
          act(function () {});
        });
      });
    } // all good! regular act


    return act(cb);
  } // use the polyfill


  var result;
  act(function () {
    result = cb();
  });
  return result.then(function () {
    return Promise.resolve().then(function () {
      // use sync act to flush effects
      act(function () {});
    });
  });
}
/* eslint no-console:0 */

// dom-testing-library's version of fireEvent. The reason
// we make this distinction however is because we have
// a few extra events that work a bit differently

var fireEvent = function fireEvent() {
  return dom_esm/* fireEvent.apply */.BX.apply(void 0, arguments);
};

Object.keys(dom_esm/* fireEvent */.BX).forEach(function (key) {
  fireEvent[key] = function () {
    return dom_esm/* fireEvent */.BX[key].apply(dom_esm/* fireEvent */.BX, arguments);
  };
}); // React event system tracks native mouseOver/mouseOut events for
// running onMouseEnter/onMouseLeave handlers
// @link https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/events/EnterLeaveEventPlugin.js#L24-L31

var mouseEnter = fireEvent.mouseEnter;
var mouseLeave = fireEvent.mouseLeave;

fireEvent.mouseEnter = function () {
  mouseEnter.apply(void 0, arguments);
  return fireEvent.mouseOver.apply(fireEvent, arguments);
};

fireEvent.mouseLeave = function () {
  mouseLeave.apply(void 0, arguments);
  return fireEvent.mouseOut.apply(fireEvent, arguments);
};

var pointerEnter = fireEvent.pointerEnter;
var pointerLeave = fireEvent.pointerLeave;

fireEvent.pointerEnter = function () {
  pointerEnter.apply(void 0, arguments);
  return fireEvent.pointerOver.apply(fireEvent, arguments);
};

fireEvent.pointerLeave = function () {
  pointerLeave.apply(void 0, arguments);
  return fireEvent.pointerOut.apply(fireEvent, arguments);
};

var react_esm_select = fireEvent.select;

fireEvent.select = function (node, init) {
  react_esm_select(node, init); // React tracks this event only on focused inputs

  node.focus(); // React creates this event when one of the following native events happens
  // - contextMenu
  // - mouseUp
  // - dragEnd
  // - keyUp
  // - keyDown
  // so we can use any here
  // @link https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/events/SelectEventPlugin.js#L203-L224

  fireEvent.keyUp(node, init);
}; // React event system tracks native focusout/focusin events for
// running blur/focus handlers
// @link https://github.com/facebook/react/pull/19186


var react_esm_blur = fireEvent.blur;
var react_esm_focus = fireEvent.focus;

fireEvent.blur = function () {
  fireEvent.focusOut.apply(fireEvent, arguments);
  return react_esm_blur.apply(void 0, arguments);
};

fireEvent.focus = function () {
  fireEvent.focusIn.apply(fireEvent, arguments);
  return react_esm_focus.apply(void 0, arguments);
};

(0,dom_esm/* configure */.jQ)({
  asyncWrapper: function () {
    var _asyncWrapper = _asyncToGenerator( /*#__PURE__*/regenerator_default().mark(function _callee2(cb) {
      var result;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return asyncAct( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator_default().mark(function _callee() {
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return cb();

                      case 2:
                        result = _context.sent;

                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));

            case 2:
              return _context2.abrupt("return", result);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function asyncWrapper(_x) {
      return _asyncWrapper.apply(this, arguments);
    }

    return asyncWrapper;
  }(),
  eventWrapper: function eventWrapper(cb) {
    var result;
    act(function () {
      result = cb();
    });
    return result;
  }
});
var mountedContainers = new Set();

function render(ui, _temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      container = _ref2.container,
      _ref2$baseElement = _ref2.baseElement,
      baseElement = _ref2$baseElement === void 0 ? container : _ref2$baseElement,
      queries = _ref2.queries,
      _ref2$hydrate = _ref2.hydrate,
      hydrate = _ref2$hydrate === void 0 ? false : _ref2$hydrate,
      WrapperComponent = _ref2.wrapper;

  if (!baseElement) {
    // default to document.body instead of documentElement to avoid output of potentially-large
    // head elements (such as JSS style blocks) in debug output
    baseElement = document.body;
  }

  if (!container) {
    container = baseElement.appendChild(document.createElement('div'));
  } // we'll add it to the mounted containers regardless of whether it's actually
  // added to document.body so the cleanup method works regardless of whether
  // they're passing us a custom container or not.


  mountedContainers.add(container);

  var wrapUiIfNeeded = function wrapUiIfNeeded(innerElement) {
    return WrapperComponent ? /*#__PURE__*/React.createElement(WrapperComponent, null, innerElement) : innerElement;
  };

  act(function () {
    if (hydrate) {
      ReactDOM.hydrate(wrapUiIfNeeded(ui), container);
    } else {
      ReactDOM.render(wrapUiIfNeeded(ui), container);
    }
  });
  return _extends({
    container: container,
    baseElement: baseElement,
    debug: function debug(el, maxLength, options) {
      if (el === void 0) {
        el = baseElement;
      }

      return Array.isArray(el) ? // eslint-disable-next-line no-console
      el.forEach(function (e) {
        return console.log(prettyDOM(e, maxLength, options));
      }) : // eslint-disable-next-line no-console,
      console.log(prettyDOM(el, maxLength, options));
    },
    unmount: function unmount() {
      act(function () {
        ReactDOM.unmountComponentAtNode(container);
      });
    },
    rerender: function rerender(rerenderUi) {
      render(wrapUiIfNeeded(rerenderUi), {
        container: container,
        baseElement: baseElement
      }); // Intentionally do not return anything to avoid unnecessarily complicating the API.
      // folks can use all the same utilities we return in the first place that are bound to the container
    },
    asFragment: function asFragment() {
      /* istanbul ignore else (old jsdom limitation) */
      if (typeof document.createRange === 'function') {
        return document.createRange().createContextualFragment(container.innerHTML);
      } else {
        var template = document.createElement('template');
        template.innerHTML = container.innerHTML;
        return template.content;
      }
    }
  }, getQueriesForElement(baseElement, queries));
}

function cleanup() {
  mountedContainers.forEach(cleanupAtContainer);
} // maybe one day we'll expose this (perhaps even as a utility returned by render).
// but let's wait until someone asks for it.


function cleanupAtContainer(container) {
  act(function () {
    react_dom.unmountComponentAtNode(container);
  });

  if (container.parentNode === document.body) {
    document.body.removeChild(container);
  }

  mountedContainers.delete(container);
} // just re-export everything from dom-testing-library
// thing for people using react-dom@16.8.0. Anyone else doesn't need it and
// people should just upgrade anyway.

/* eslint func-name-matching:0 */

var _process$env;
// or teardown then we'll automatically run cleanup afterEach test
// this ensures that tests run in isolation from each other
// if you don't like this then either import the `pure` module
// or set the RTL_SKIP_AUTO_CLEANUP env variable to 'true'.

if (typeof process === 'undefined' || !((_process$env = process.env) != null && _process$env.RTL_SKIP_AUTO_CLEANUP)) {
  // ignore teardown() in code coverage because Jest does not support it

  /* istanbul ignore else */
  if (typeof afterEach === 'function') {
    afterEach(function () {
      cleanup();
    });
  } else if (typeof teardown === 'function') {
    // Block is guarded by `typeof` check.
    // eslint does not support `typeof` guards.
    // eslint-disable-next-line no-undef
    teardown(function () {
      cleanup();
    });
  }
}




/***/ }),

/***/ 70303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ analyticsLib; }
});

// UNUSED EXPORTS: Analytics, CONSTANTS, EVENTS, init

// EXTERNAL MODULE: ../../../node_modules/dlv/dist/dlv.umd.js
var dlv_umd = __webpack_require__(93964);
var dlv_umd_default = /*#__PURE__*/__webpack_require__.n(dlv_umd);
;// CONCATENATED MODULE: ../../../node_modules/@analytics/type-utils/dist/analytics-util-types.module.js
/* provided dependency */ var process = __webpack_require__(13158);
var n="function",analytics_util_types_module_t="string",analytics_util_types_module_e="undefined",analytics_util_types_module_r="boolean",o="object",u="array",i="number",c="symbol",a="null",f="error",s="typeError",l="syntaxError",d="asyncFunction",p="generatorFunction",y="asyncGeneratorFunction",g=function(){},b="any",m="*",v="none",h="hidden",j="__",O="form",S="input",A="button",E="select",N="change",w="submit",D=/^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)$/,z=/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,Z=/^\{[\s\S]*\}$|^\[[\s\S]*\]$/,F="undefined"!=typeof process?process:{},P=F.env&&F.env.NODE_ENV||"",x="production"===P,C="staging"===P,L="development"===P,$="undefined"!=typeof document,T=$&&"localhost"===window.location.hostname,_=null!=F.versions&&null!=F.versions.node,k="undefined"!=typeof Deno&&void 0!==Deno.core,B="object"==typeof self&&self.constructor&&"DedicatedWorkerGlobalScope"===self.constructor.name,G=$&&"nodejs"===window.name||"undefined"!=typeof navigator&&void 0!==navigator.userAgent&&(navigator.userAgent.includes("Node.js")||navigator.userAgent.includes("jsdom"));function M(n,t){return t.charAt(0)[n]()+t.slice(1)}var U=M.bind(null,"toUpperCase"),H=M.bind(null,"toLowerCase");function J(n){return Y(n)?U("null"):"object"==typeof n?yn(n):Object.prototype.toString.call(n).slice(8,-1)}function R(n,t){void 0===t&&(t=!0);var e=J(n);return t?H(e):e}function V(n,t){return typeof t===n}var analytics_util_types_module_W=V.bind(null,"function"),q=V.bind(null,"string"),I=V.bind(null,"undefined");function K(n){return!I(n)}var Q=V.bind(null,"boolean"),X=V.bind(null,"symbol");function Y(n){return null===n}function nn(n){return"number"===R(n)&&!isNaN(n)}function tn(n){return!isNaN(parseFloat(n))}function en(n){return!!analytics_util_types_module_W(n)&&/^class /.test(Function.prototype.toString.call(n))}function rn(n){return"array"===R(n)}function on(n){if(!un(n))return!1;for(var t=n;null!==Object.getPrototypeOf(t);)t=Object.getPrototypeOf(t);return Object.getPrototypeOf(n)===t}function un(n){return n&&("object"==typeof n||null!==n)}function cn(n){if(!q(n)||!Z.test(n))return!1;try{JSON.parse(n)}catch(n){return!1}return!0}function an(n){if(Y(n))return!0;switch(typeof n){case"string":case"number":case"symbol":case"undefined":case"boolean":return!0;default:return!1}}function fn(n,t){return on(n)&&analytics_util_types_module_W(n[t])}function sn(n){return!!n&&!!(!I(Promise)&&n instanceof Promise||n.then&&analytics_util_types_module_W(n.then))}function ln(n){return un(n)&&analytics_util_types_module_W(n.throw)&&analytics_util_types_module_W(n.return)&&analytics_util_types_module_W(n.next)}function dn(n){return"generatorFunction"===R(n)}function pn(n){return"asyncFunction"===R(n)}function yn(n){return analytics_util_types_module_W(n.constructor)?n.constructor.name:null}function gn(n){return n instanceof Set}function bn(n){return n instanceof Map}function mn(n){return n instanceof RegExp}function vn(n){return!(!n.constructor||!analytics_util_types_module_W(n.constructor.isBuffer))&&n.constructor.isBuffer(n)}function hn(n){return n instanceof Error||q(n.message)&&n.constructor&&nn(n.constructor.stackTraceLimit)}function jn(n){return un(n)&&q(n.message)&&q(n.name)}function On(n,t){if("object"!=typeof t||Y(t))return!1;if(t instanceof n)return!0;var e=R(new n(""));if(hn(t))for(;t;){if(R(t)===e)return!0;t=Object.getPrototypeOf(t)}return!1}var Sn=On.bind(null,TypeError),An=On.bind(null,SyntaxError);function En(n){if(!analytics_util_types_module_W(n))return!1;var t=/{(\r|\n|\s)*}/gm,e=g+"";return e===(n.toString().match(t)||[""])[0].replace(t,e)}function Nn(n){try{if(nn(n.length)&&analytics_util_types_module_W(n.callee))return!0}catch(n){if(-1!==n.message.indexOf("callee"))return!0}return!1}function wn(n){return!(q(n)&&"false"===n.toLowerCase()||!n)}function Dn(n){return!n}function zn(n){return!0===n}function Zn(n){return!1===n}function Fn(n){return!(n.length>320)&&z.test(n)}function Pn(n){return n instanceof Date||analytics_util_types_module_W(n.toDateString)&&analytics_util_types_module_W(n.getDate)&&analytics_util_types_module_W(n.setDate)}function xn(n){return D.test(n)}function Cn(n){return!(!Y(n)&&(rn(n)?n.length:gn(n)||bn(n)?n.size:on(n)&&Object.keys(n).length))}function Ln(n){return NodeList.prototype.isPrototypeOf(n)}function $n(n,t){var e=n instanceof Element||n instanceof HTMLDocument;return e&&t?Tn(n,t):e}function Tn(n,t){return void 0===t&&(t=""),n&&n.nodeName===t.toUpperCase()}function _n(n){var t=[].slice.call(arguments,1);return function(){return n.apply(void 0,[].slice.call(arguments).concat(t))}}var kn=_n($n,"form"),Bn=_n($n,"button"),Gn=_n($n,"input"),Mn=_n($n,"select");function Un(n,t){if(!n||"hidden"===getComputedStyle(n).visibility)return!0;for(;n;){if(null!=t&&n===t)return!1;if("none"===getComputedStyle(n).display)return!0;n=n.parentElement}return!1}function Hn(n){return n?rn(n)?n:[n]:[]}
//# sourceMappingURL=analytics-util-types.module.js.map

;// CONCATENATED MODULE: ../../../node_modules/analytics-utils/dist/analytics-utils.module.js
function analytics_utils_module_n(e){try{return decodeURIComponent(e.replace(/\+/g," "))}catch(e){return null}}function analytics_utils_module_o(){if($){var r=navigator,t=r.languages;return r.userLanguage||(t&&t.length?t[0]:r.language)}}function analytics_utils_module_a(){try{return Intl.DateTimeFormat().resolvedOptions().timeZone}catch(e){}}function analytics_utils_module_i(r){if(!e)return!1;var t=r||document.referrer;if(t){var n=window.document.location.port,o=t.split("/")[2];return n&&(o=o.replace(":"+n,"")),o!==window.location.hostname}return!1}function analytics_utils_module_u(n){if(!e)return!0;var o=document.getElementsByTagName("script");return!!Object.keys(o).filter(function(e){var a=o[e].src;return r(n)?-1!==a.indexOf(n):!!t(n)&&a.match(n)}).length}function analytics_utils_module_c(e,r){var t=(e.split("?")||[,])[1];if(!t||-1===t.indexOf(r))return e;var n=new RegExp("(\\&|\\?)"+r+'([_A-Za-z0-9"+=.\\/\\-@%]+)',"g"),o=("?"+t).replace(n,"").replace(/^&/,"?");return e.replace("?"+t,o)}function analytics_utils_module_l(e,r){return analytics_utils_module_n((RegExp(e+"=(.+?)(&|$)").exec(r)||[,""])[1])}function analytics_utils_module_s(r){return function(e){for(var r,t=Object.create(null),o=/([^&=]+)=?([^&]*)/g;r=o.exec(e);){var a=analytics_utils_module_n(r[1]),i=analytics_utils_module_n(r[2]);"[]"===a.substring(a.length-2)?(t[a=a.substring(0,a.length-2)]||(t[a]=[])).push(i):t[a]=""===i||i}for(var u in t){var c=u.split("[");c.length>1&&(analytics_utils_module_m(t,c.map(function(e){return e.replace(/[?[\]\\ ]/g,"")}),t[u]),delete t[u])}return t}(function(r){if(r){var t=r.match(/\?(.*)/);return t&&t[1]?t[1].split("#")[0]:""}return $&&window.location.search.substring(1)}(r))}function analytics_utils_module_m(e,r,t){for(var n=r.length-1,o=0;o<n;++o){var a=r[o];if("__proto__"===a||"constructor"===a)break;a in e||(e[a]={}),e=e[a]}e[r[n]]=t}function analytics_utils_module_f(r,t){return e?new Promise(function(e,n){if(window.history&&window.history.replaceState){var o=window.location.href,a=analytics_utils_module_c(o,r);o!==a&&history.replaceState({},"",a)}return t&&t(),e()}):Promise.resolve()}function analytics_utils_module_g(r){if(!$)return null;var t=document.createElement("a");return t.setAttribute("href",r),t.hostname}function analytics_utils_module_p(e){return(analytics_utils_module_g(e)||"").split(".").slice(-2).join(".")}function analytics_utils_module_x(e){var r=e.split(".");return r.length>1?r.slice(0,-1).join("."):e}var analytics_utils_module_d={trimTld:analytics_utils_module_x,getDomainBase:analytics_utils_module_p,getDomainHost:analytics_utils_module_g};function analytics_utils_module_v(r,t){if(!e)return!1;var n={source:"(direct)",medium:"(none)",campaign:"(not set)"};r&&analytics_utils_module_i(r)&&(n.referrer=r);var o=function(r){if(!r||!e)return!1;var t=analytics_utils_module_p(r),n=document.createElement("a");if(n.href=r,n.hostname.indexOf("google")>-1&&(t="google"),analytics_utils_module_w[t]){var o=analytics_utils_module_w[t],a=new RegExp(("string"==typeof o?o:o.p)+"=.*?([^&#]*|$)","gi"),u=n.search.match(a);return{source:o.n||analytics_utils_module_x(t),medium:"organic",term:(u?u[0].split("=")[1]:"")||"(not provided)"}}var c=analytics_utils_module_i(r)?"referral":"internal";return{source:n.hostname,medium:c}}(r);o&&Object.keys(o).length&&(n=Object.assign({},n,o));var a=analytics_utils_module_s(t),u=Object.keys(a);if(!u.length)return n;var c=u.reduce(function(e,r){return r.match(/^utm_/)&&(e[""+r.replace(/^utm_/,"")]=a[r]),r.match(/^(d|g)clid/)&&(e.source="google",e.medium=a.gclid?"cpc":"cpm",e[r]=a[r]),e},{});return Object.assign({},n,c)}var analytics_utils_module_h="q",analytics_utils_module_w={"daum.net":analytics_utils_module_h,"eniro.se":"search_word","naver.com":"query","yahoo.com":"p","msn.com":analytics_utils_module_h,"aol.com":analytics_utils_module_h,"ask.com":analytics_utils_module_h,"baidu.com":"wd","yandex.com":"text","rambler.ru":"words",google:analytics_utils_module_h,"bing.com":{p:analytics_utils_module_h,n:"live"}};function analytics_utils_module_y(){for(var e="",r=0,t=4294967295*Math.random()|0;r++<36;){var n="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"[r-1],o=15&t;e+="-"==n||"4"==n?n:("x"==n?o:3&o|8).toString(16),t=r%8==0?4294967295*Math.random()|0:t>>4}return e}function analytics_utils_module_b(e,r){var t,n,o,a=null,i=0,u=function(){i=new Date,a=null,o=e.apply(t,n)};return function(){var c=new Date;i||(i=c);var l=r-(c-i);return t=this,n=arguments,l<=0?(clearTimeout(a),a=null,i=c,o=e.apply(t,n)):a||(a=setTimeout(u,l)),o}}
//# sourceMappingURL=analytics-utils.module.js.map

;// CONCATENATED MODULE: ../../../node_modules/@analytics/global-storage-utils/dist/analytics-util-global-storage.module.js
var analytics_util_global_storage_module_l="global",analytics_util_global_storage_module_o=j+"global"+j,analytics_util_global_storage_module_n=typeof self===o&&self.self===self&&self||typeof __webpack_require__.g===o&&__webpack_require__.g.global===__webpack_require__.g&&__webpack_require__.g||void 0;function analytics_util_global_storage_module_a(t){return analytics_util_global_storage_module_n[analytics_util_global_storage_module_o][t]}function analytics_util_global_storage_module_f(t,e){return analytics_util_global_storage_module_n[analytics_util_global_storage_module_o][t]=e}function analytics_util_global_storage_module_i(t){delete analytics_util_global_storage_module_n[analytics_util_global_storage_module_o][t]}function analytics_util_global_storage_module_u(t,e,r){var l;try{if(analytics_util_global_storage_module_b(t)){var o=window[t];l=o[e].bind(o)}}catch(t){}return l||r}analytics_util_global_storage_module_n[analytics_util_global_storage_module_o]||(analytics_util_global_storage_module_n[analytics_util_global_storage_module_o]={});var analytics_util_global_storage_module_c={};function analytics_util_global_storage_module_b(t){if(typeof analytics_util_global_storage_module_c[t]!==analytics_util_types_module_e)return analytics_util_global_storage_module_c[t];try{var e=window[t];e.setItem(analytics_util_types_module_e,analytics_util_types_module_e),e.removeItem(analytics_util_types_module_e)}catch(e){return analytics_util_global_storage_module_c[t]=!1}return analytics_util_global_storage_module_c[t]=!0}
//# sourceMappingURL=analytics-util-global-storage.module.js.map

;// CONCATENATED MODULE: ../../../node_modules/@analytics/core/dist/client/analytics-core.module.js
function analytics_core_module_v(){return analytics_core_module_v=Object.assign||function(e){for(var n=1;n<arguments.length;n++){var t=arguments[n];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e},analytics_core_module_v.apply(this,arguments)}var analytics_core_module_y="function",analytics_core_module_b="undefined",analytics_core_module_I="@@redux/"+Math.random().toString(36),analytics_core_module_w=/* #__PURE__ */function(){return typeof Symbol===analytics_core_module_y&&Symbol.observable||"@@observable"}(),analytics_core_module_E=" != "+analytics_core_module_y;function analytics_core_module_P(e,n,t){var r;if(typeof n===analytics_core_module_y&&typeof t===analytics_core_module_b&&(t=n,n=void 0),typeof t!==analytics_core_module_b){if(typeof t!==analytics_core_module_y)throw new Error("enhancer"+analytics_core_module_E);return t(analytics_core_module_P)(e,n)}if(typeof e!==analytics_core_module_y)throw new Error("reducer"+analytics_core_module_E);var i=e,a=n,o=[],u=o,c=!1;function s(){u===o&&(u=o.slice())}function f(){return a}function d(e){if(typeof e!==analytics_core_module_y)throw new Error("Listener"+analytics_core_module_E);var n=!0;return s(),u.push(e),function(){if(n){n=!1,s();var t=u.indexOf(e);u.splice(t,1)}}}function p(e){if(!on(e))throw new Error("Act != obj");if(typeof e.type===analytics_core_module_b)throw new Error("ActType "+analytics_core_module_b);if(c)throw new Error("Dispatch in reducer");try{c=!0,a=i(a,e)}finally{c=!1}for(var n=o=u,t=0;t<n.length;t++)(0,n[t])();return e}return p({type:"@@redux/INIT"}),(r={dispatch:p,subscribe:d,getState:f,replaceReducer:function(e){if(typeof e!==analytics_core_module_y)throw new Error("next reducer"+analytics_core_module_E);i=e,p({type:"@@redux/INIT"})}})[analytics_core_module_w]=function(){var e,n=d;return(e={subscribe:function(e){if("object"!=typeof e)throw new TypeError("Observer != obj");function t(){e.next&&e.next(f())}return t(),{unsubscribe:n(t)}}})[analytics_core_module_w]=function(){return this},e},r}function analytics_core_module_S(e,n){var t=n&&n.type;return"action "+(t&&t.toString()||"?")+"reducer "+e+" returns "+analytics_core_module_b}function analytics_core_module_N(){var e=[].slice.call(arguments);return 0===e.length?function(e){return e}:1===e.length?e[0]:e.reduce(function(e,n){return function(){return e(n.apply(void 0,[].slice.call(arguments)))}})}function analytics_core_module_O(){var e=arguments;return function(n){return function(t,r,i){var a,o=n(t,r,i),u=o.dispatch,c={getState:o.getState,dispatch:function(e){return u(e)}};return a=[].slice.call(e).map(function(e){return e(c)}),analytics_core_module_v({},o,{dispatch:u=analytics_core_module_N.apply(void 0,a)(o.dispatch)})}}}var analytics_core_module_A=j+"anon_id",analytics_core_module_=j+"user_id",analytics_core_module_x=j+"user_traits",analytics_core_module_j={__proto__:null,ANON_ID:analytics_core_module_A,USER_ID:analytics_core_module_,USER_TRAITS:analytics_core_module_x},analytics_core_module_k="userId",analytics_core_module_T="anonymousId",analytics_core_module_z=["bootstrap","params","campaign","initializeStart","initialize","initializeEnd","ready","resetStart","reset","resetEnd","pageStart","page","pageEnd","pageAborted","trackStart","track","trackEnd","trackAborted","identifyStart","identify","identifyEnd","identifyAborted","userIdChanged","registerPlugins","enablePlugin","disablePlugin","online","offline","setItemStart","setItem","setItemEnd","setItemAborted","removeItemStart","removeItem","removeItemEnd","removeItemAborted"],analytics_core_module_M=["name","EVENTS","config","loaded"],analytics_core_module_q=analytics_core_module_z.reduce(function(e,n){return e[n]=n,e},{registerPluginType:function(e){return"registerPlugin:"+e},pluginReadyType:function(e){return"ready:"+e}}),analytics_core_module_U=/^utm_/,analytics_core_module_V=/^an_prop_/,analytics_core_module_L=/^an_trait_/;function analytics_core_module_C(e){var n=e.storage.setItem;return function(t){return function(r){return function(i){if(i.type===analytics_core_module_q.bootstrap){var a=i.params,o=i.user,u=i.persistedUser,c=i.initialUser,s=u.userId===o.userId;u.anonymousId!==o.anonymousId&&n(analytics_core_module_A,o.anonymousId),s||n(analytics_core_module_,o.userId),c.traits&&n(analytics_core_module_x,analytics_core_module_v({},s&&u.traits?u.traits:{},c.traits));var l=Object.keys(i.params);if(l.length){var f=a.an_uid,d=a.an_event,p=l.reduce(function(e,n){if(n.match(analytics_core_module_U)||n.match(/^(d|g)clid/)){var t=n.replace(analytics_core_module_U,"");e.campaign["campaign"===t?"name":t]=a[n]}return n.match(analytics_core_module_V)&&(e.props[n.replace(analytics_core_module_V,"")]=a[n]),n.match(analytics_core_module_L)&&(e.traits[n.replace(analytics_core_module_L,"")]=a[n]),e},{campaign:{},props:{},traits:{}});t.dispatch(analytics_core_module_v({type:analytics_core_module_q.params,raw:a},p,f?{userId:f}:{})),f&&setTimeout(function(){return e.identify(f,p.traits)},0),d&&setTimeout(function(){return e.track(d,p.props)},0),Object.keys(p.campaign).length&&t.dispatch({type:analytics_core_module_q.campaign,campaign:p.campaign})}}return r(i)}}}}function analytics_core_module_R(e){return function(n,t){if(void 0===n&&(n={}),void 0===t&&(t={}),t.type===analytics_core_module_q.setItemEnd){if(t.key===analytics_core_module_A)return analytics_core_module_v({},n,{anonymousId:t.value});if(t.key===analytics_core_module_)return analytics_core_module_v({},n,{userId:t.value})}switch(t.type){case analytics_core_module_q.identify:return Object.assign({},n,{userId:t.userId,traits:analytics_core_module_v({},n.traits,t.traits)});case analytics_core_module_q.reset:return[analytics_core_module_,analytics_core_module_A,analytics_core_module_x].forEach(function(n){e.removeItem(n)}),Object.assign({},n,{userId:null,anonymousId:null,traits:{}});default:return n}}}function analytics_core_module_$(e){return{userId:e.getItem(analytics_core_module_),anonymousId:e.getItem(analytics_core_module_A),traits:e.getItem(analytics_core_module_x)}}var analytics_core_module_D=function(e){return j+"TEMP"+j+e};function analytics_core_module_B(n){var t=n.storage,r=t.setItem,i=t.removeItem,a=t.getItem;return function(n){return function(t){return function(u){var c=u.userId,s=u.traits,l=u.options;if(u.type===analytics_core_module_q.reset&&([analytics_core_module_,analytics_core_module_x,analytics_core_module_A].forEach(function(e){i(e)}),[analytics_core_module_k,analytics_core_module_T,"traits"].forEach(function(e){analytics_util_global_storage_module_i(analytics_core_module_D(e))})),u.type===analytics_core_module_q.identify){a(analytics_core_module_A)||r(analytics_core_module_A,analytics_utils_module_y());var f=a(analytics_core_module_),d=a(analytics_core_module_x)||{};f&&f!==c&&n.dispatch({type:analytics_core_module_q.userIdChanged,old:{userId:f,traits:d},new:{userId:c,traits:s},options:l}),c&&r(analytics_core_module_,c),s&&r(analytics_core_module_x,analytics_core_module_v({},d,s))}return t(u)}}}}var analytics_core_module_X={};function analytics_core_module_J(e,n){analytics_core_module_X[e]&&analytics_util_types_module_W(analytics_core_module_X[e])&&(analytics_core_module_X[e](n),delete analytics_core_module_X[e])}function W(e,n,t){return new Promise(function(r,i){return n()?r(e):t<1?i(analytics_core_module_v({},e,{queue:!0})):new Promise(function(e){return setTimeout(e,10)}).then(function(a){return W(e,n,t-10).then(r,i)})})}function analytics_core_module_H(e,n,t){var r=n(),i=e.getState(),a=i.plugins,o=i.queue,u=i.user;if(!i.context.offline&&o&&o.actions&&o.actions.length){var c=o.actions.reduce(function(e,n,t){return a[n.plugin].loaded?(e.process.push(n),e.processIndex.push(t)):(e.requeue.push(n),e.requeueIndex.push(t)),e},{processIndex:[],process:[],requeue:[],requeueIndex:[]});if(c.processIndex&&c.processIndex.length){c.processIndex.forEach(function(n){var i=o.actions[n],c=i.plugin,s=i.payload.type,l=r[c][s];if(l&&analytics_util_types_module_W(l)){var f=function(e,n){return void 0===e&&(e={}),void 0===n&&(n={}),[analytics_core_module_k,analytics_core_module_T].reduce(function(t,r){return e.hasOwnProperty(r)&&n[r]&&n[r]!==e[r]&&(t[r]=n[r]),t},e)}(i.payload,u);l({payload:f,config:a[c].config,instance:t});var p=s+":"+c;e.dispatch(analytics_core_module_v({},f,{type:p,_:{called:p,from:"queueDrain"}}))}});var s=o.actions.filter(function(e,n){return!~c.processIndex.indexOf(n)});o.actions=s}}}var analytics_core_module_F=function(e){var n=e.data,t=e.action,r=e.instance,i=e.state,a=e.allPlugins,o=e.allMatches,u=e.store,c=e.EVENTS;try{var s=i.plugins,f=i.context,p=t.type,m=p.match(analytics_core_module_G),g=n.exact.map(function(e){return e.pluginName});m&&(g=o.during.map(function(e){return e.pluginName}));var h=function(e,n){return function(t,r,i){var a=r.config,o=r.name,u=o+"."+t.type;i&&(u=i.event);var c=t.type.match(analytics_core_module_G)?function(e,n,t,r,i){return function(a,o){var u=r?r.name:e,c=o&&ie(o)?o:t;if(r&&(!(c=o&&ie(o)?o:[e]).includes(e)||1!==c.length))throw new Error("Method "+n+" can only abort "+e+" plugin. "+JSON.stringify(c)+" input valid");return analytics_core_module_v({},i,{abort:{reason:a,plugins:c,caller:n,_:u}})}}(o,u,n,i,t):function(e,n){return function(){throw new Error(e.type+" action not cancellable. Remove abort in "+n)}}(t,u);return{payload:ue(t),instance:e,config:a||{},abort:c}}}(r,g),y=n.exact.reduce(function(e,n){var t=n.pluginName,r=n.methodName,i=!1;return r.match(/^initialize/)||r.match(/^reset/)||(i=!s[t].loaded),f.offline&&r.match(/^(page|track|identify)/)&&(i=!0),e[""+t]=i,e},{});return Promise.resolve(n.exact.reduce(function(e,i,o){try{var u=i.pluginName;return Promise.resolve(e).then(function(e){function i(){return Promise.resolve(e)}var o=function(){if(n.namespaced&&n.namespaced[u])return Promise.resolve(n.namespaced[u].reduce(function(e,n,t){try{return Promise.resolve(e).then(function(e){return n.method&&analytics_util_types_module_W(n.method)?(function(e,n){var t=oe(e);if(t&&t.name===n){var r=oe(t.method);throw new Error([n+" plugin is calling method "+e,"Plugins cant call self","Use "+t.method+" "+(r?"or "+r.method:"")+" in "+n+" plugin insteadof "+e].join("\n"))}}(n.methodName,n.pluginName),Promise.resolve(n.method({payload:e,instance:r,abort:(t=e,i=u,o=n.pluginName,function(e,n){return analytics_core_module_v({},t,{abort:{reason:e,plugins:n||[i],caller:p,from:o||i}})}),config:analytics_core_module_Z(n.pluginName,s,a),plugins:s})).then(function(n){var t=on(n)?n:{};return Promise.resolve(analytics_core_module_v({},e,t))})):e;var t,i,o})}catch(e){return Promise.reject(e)}},Promise.resolve(t))).then(function(n){e[u]=n});e[u]=t}();return o&&o.then?o.then(i):i()})}catch(e){return Promise.reject(e)}},Promise.resolve({}))).then(function(e){return Promise.resolve(n.exact.reduce(function(t,i,o){try{var c=n.exact.length===o+1,f=i.pluginName,d=a[f];return Promise.resolve(t).then(function(n){var t=e[f]?e[f]:{};if(m&&(t=n),te(t,f))return analytics_core_module_Y({data:t,method:p,instance:r,pluginName:f,store:u}),Promise.resolve(n);if(te(n,f))return c&&analytics_core_module_Y({data:n,method:p,instance:r,store:u}),Promise.resolve(n);if(y.hasOwnProperty(f)&&!0===y[f])return u.dispatch({type:"queue",plugin:f,payload:t,_:{called:"queue",from:"queueMechanism"}}),Promise.resolve(n);var i=h(e[f],a[f]);return Promise.resolve(d[p]({abort:i.abort,payload:t,instance:r,config:analytics_core_module_Z(f,s,a),plugins:s})).then(function(i){var a=on(i)?i:{},o=analytics_core_module_v({},n,a),c=e[f];if(te(c,f))analytics_core_module_Y({data:c,method:p,instance:r,pluginName:f,store:u});else{var s=p+":"+f;(s.match(/:/g)||[]).length<2&&!p.match(analytics_core_module_K)&&!p.match(analytics_core_module_Q)&&r.dispatch(analytics_core_module_v({},m?o:t,{type:s,_:{called:s,from:"submethod"}}))}return Promise.resolve(o)})})}catch(e){return Promise.reject(e)}},Promise.resolve(t))).then(function(e){if(!(p.match(analytics_core_module_G)||p.match(/^registerPlugin/)||p.match(analytics_core_module_Q)||p.match(analytics_core_module_K)||p.match(/^params/)||p.match(/^userIdChanged/))){if(c.plugins.includes(p),e._&&e._.originalAction===p)return e;var t=analytics_core_module_v({},e,{_:{originalAction:e.type,called:e.type,from:"engineEnd"}});re(e,n.exact.length)&&!p.match(/End$/)&&(t=analytics_core_module_v({},t,{type:e.type+"Aborted"})),u.dispatch(t)}return e})})}catch(e){return Promise.reject(e)}},analytics_core_module_G=/Start$/,analytics_core_module_K=/^bootstrap/,analytics_core_module_Q=/^ready/;function analytics_core_module_Y(e){var n=e.pluginName,t=e.method+"Aborted"+(n?":"+n:"");e.store.dispatch(analytics_core_module_v({},e.data,{type:t,_:{called:t,from:"abort"}}))}function analytics_core_module_Z(e,n,t){var r=n[e]||t[e];return r&&r.config?r.config:{}}function ee(e,n){return n.reduce(function(n,t){return t[e]?n.concat({methodName:e,pluginName:t.name,method:t[e]}):n},[])}function ne(e,n){var t=e.replace(analytics_core_module_G,""),r=n?":"+n:"";return[""+e+r,""+t+r,t+"End"+r]}function te(e,n){var t=e.abort;return!!t&&(!0===t||ae(t,n)||t&&ae(t.plugins,n))}function re(e,n){var t=e.abort;if(!t)return!1;if(!0===t||q(t))return!0;var r=t.plugins;return ie(t)&&t.length===n||ie(r)&&r.length===n}function ie(e){return Array.isArray(e)}function ae(e,n){return!(!e||!ie(e))&&e.includes(n)}function oe(e){var n=e.match(/(.*):(.*)/);return!!n&&{method:n[1],name:n[2]}}function ue(e){return Object.keys(e).reduce(function(n,t){return"type"===t||(n[t]=on(e[t])?Object.assign({},e[t]):e[t]),n},{})}function ce(e,n,t){var r={};return function(i){return function(a){return function(o){try{var u,c=function(e){return u?e:a(f)},s=o.type,l=o.plugins,f=o;if(o.abort)return Promise.resolve(a(o));if(s===analytics_core_module_q.enablePlugin&&i.dispatch({type:analytics_core_module_q.initializeStart,plugins:l,disabled:[],fromEnable:!0,meta:o.meta}),s===analytics_core_module_q.disablePlugin&&setTimeout(function(){return analytics_core_module_J(o.meta.rid,{payload:o})},0),s===analytics_core_module_q.initializeEnd){var m=n(),g=Object.keys(m),h=g.filter(function(e){return l.includes(e)}).map(function(e){return m[e]}),y=[],b=[],I=o.disabled,w=h.map(function(e){var n=e.loaded,t=e.name,a=e.config;return W(e,function(){return n({config:a})},1e4).then(function(n){return r[t]||(i.dispatch({type:analytics_core_module_q.pluginReadyType(t),name:t,events:Object.keys(e).filter(function(e){return!analytics_core_module_M.includes(e)})}),r[t]=!0),y=y.concat(t),e}).catch(function(e){if(e instanceof Error)throw new Error(e);return b=b.concat(e.name),e})});Promise.all(w).then(function(e){var n={plugins:y,failed:b,disabled:I};setTimeout(function(){g.length===w.length+I.length&&i.dispatch(analytics_core_module_v({},{type:analytics_core_module_q.ready},n))},0)})}var E=function(){if(s!==analytics_core_module_q.bootstrap)return/^ready:([^:]*)$/.test(s)&&setTimeout(function(){return analytics_core_module_H(i,n,e)},0),Promise.resolve(function(e,n,t,r,i){try{var a=analytics_util_types_module_W(n)?n():n,o=e.type,u=o.replace(analytics_core_module_G,"");if(e._&&e._.called)return Promise.resolve(e);var c=t.getState(),s=(m=a,void 0===(g=c.plugins)&&(g={}),void 0===(h=e.options)&&(h={}),Object.keys(m).filter(function(e){var n=h.plugins||{};return Q(n[e])?n[e]:!1!==n.all&&(!g[e]||!1!==g[e].enabled)}).map(function(e){return m[e]}));o===analytics_core_module_q.initializeStart&&e.fromEnable&&(s=Object.keys(c.plugins).filter(function(n){var t=c.plugins[n];return e.plugins.includes(n)&&!t.initialized}).map(function(e){return a[e]}));var l=s.map(function(e){return e.name}),f=function(e,n,t){var r=ne(e).map(function(e){return ee(e,n)});return n.reduce(function(t,r){var i=r.name,a=ne(e,i).map(function(e){return ee(e,n)}),o=a[0],u=a[1],c=a[2];return o.length&&(t.beforeNS[i]=o),u.length&&(t.duringNS[i]=u),c.length&&(t.afterNS[i]=c),t},{before:r[0],beforeNS:{},during:r[1],duringNS:{},after:r[2],afterNS:{}})}(o,s);return Promise.resolve(analytics_core_module_F({action:e,data:{exact:f.before,namespaced:f.beforeNS},state:c,allPlugins:a,allMatches:f,instance:t,store:r,EVENTS:i})).then(function(e){function n(){var n=function(){if(o.match(analytics_core_module_G))return Promise.resolve(analytics_core_module_F({action:analytics_core_module_v({},s,{type:u+"End"}),data:{exact:f.after,namespaced:f.afterNS},state:c,allPlugins:a,allMatches:f,instance:t,store:r,EVENTS:i})).then(function(e){e.meta&&e.meta.hasCallback&&analytics_core_module_J(e.meta.rid,{payload:e})})}();return n&&n.then?n.then(function(){return e}):e}if(re(e,l.length))return e;var s,d=function(){if(o!==u)return Promise.resolve(analytics_core_module_F({action:analytics_core_module_v({},e,{type:u}),data:{exact:f.during,namespaced:f.duringNS},state:c,allPlugins:a,allMatches:f,instance:t,store:r,EVENTS:i})).then(function(e){s=e});s=e}();return d&&d.then?d.then(n):n()})}catch(e){return Promise.reject(e)}var m,g,h}(o,n,e,i,t)).then(function(e){return u=1,a(e)})}();return Promise.resolve(E&&E.then?E.then(c):c(E))}catch(e){return Promise.reject(e)}}}}}function se(e){return function(n){return function(n){return function(t){var r=t.type,i=t.key,a=t.value,o=t.options;if(r===analytics_core_module_q.setItem||r===analytics_core_module_q.removeItem){if(t.abort)return n(t);r===analytics_core_module_q.setItem?e.setItem(i,a,o):e.removeItem(i,o)}return n(t)}}}}var le=function(){var e=this;this.before=[],this.after=[],this.addMiddleware=function(n,t){e[t]=e[t].concat(n)},this.removeMiddleware=function(n,t){var r=e[t].findIndex(function(e){return e===n});-1!==r&&(e[t]=[].concat(e[t].slice(0,r),e[t].slice(r+1)))},this.dynamicMiddlewares=function(n){return function(t){return function(r){return function(i){var a={getState:t.getState,dispatch:function(e){return t.dispatch(e)}},o=e[n].map(function(e){return e(a)});return analytics_core_module_N.apply(void 0,o)(r)(i)}}}}};function fe(e){return function(n,t){void 0===n&&(n={});var r={};if("initialize:aborted"===t.type)return n;if(/^registerPlugin:([^:]*)$/.test(t.type)){var i=de(t.type,"registerPlugin"),a=e()[i];if(!a||!i)return n;var o=t.enabled,u=a.config;return r[i]={enabled:o,initialized:!!o&&Boolean(!a.initialize),loaded:!!o&&Boolean(a.loaded({config:u})),config:u},analytics_core_module_v({},n,r)}if(/^initialize:([^:]*)$/.test(t.type)){var c=de(t.type,analytics_core_module_q.initialize),s=e()[c];return s&&c?(r[c]=analytics_core_module_v({},n[c],{initialized:!0,loaded:Boolean(s.loaded({config:s.config}))}),analytics_core_module_v({},n,r)):n}if(/^ready:([^:]*)$/.test(t.type))return r[t.name]=analytics_core_module_v({},n[t.name],{loaded:!0}),analytics_core_module_v({},n,r);switch(t.type){case analytics_core_module_q.disablePlugin:return analytics_core_module_v({},n,pe(t.plugins,!1,n));case analytics_core_module_q.enablePlugin:return analytics_core_module_v({},n,pe(t.plugins,!0,n));default:return n}}}function de(e,n){return e.substring(n.length+1,e.length)}function pe(e,n,t){return e.reduce(function(e,r){return e[r]=analytics_core_module_v({},t[r],{enabled:n}),e},t)}function me(e){try{return JSON.parse(JSON.stringify(e))}catch(e){}return e}var ge={last:{},history:[]};function he(e,n){void 0===e&&(e=ge);var t=n.options,r=n.meta;if(n.type===analytics_core_module_q.track){var i=me(analytics_core_module_v({event:n.event,properties:n.properties},Object.keys(t).length&&{options:t},{meta:r}));return analytics_core_module_v({},e,{last:i,history:e.history.concat(i)})}return e}var ve={actions:[]};function ye(e,n){void 0===e&&(e=ve);var t=n.payload;switch(n.type){case"queue":var r;return r=t&&t.type&&t.type===analytics_core_module_q.identify?[n].concat(e.actions):e.actions.concat(n),analytics_core_module_v({},e,{actions:r});case"dequeue":return[];default:return e}}var be=/#.*$/;function Ie(e){var n=/(http[s]?:\/\/)?([^\/\s]+\/)(.*)/g.exec(e);return"/"+(n&&n[3]?n[3].split("?")[0].replace(be,""):"")}var we,Ee,Pe,Se,Ne=function(e){if(void 0===e&&(e={}),!$)return e;var n=document,t=n.title,r=n.referrer,i=window,a=i.location,o=i.innerWidth,u=i.innerHeight,c=a.hash,s=a.search,l=function(e){var n=function(){if($)for(var e,n=document.getElementsByTagName("link"),t=0;e=n[t];t++)if("canonical"===e.getAttribute("rel"))return e.getAttribute("href")}();return n?n.match(/\?/)?n:n+e:window.location.href.replace(be,"")}(s),f={title:t,url:l,path:Ie(l),hash:c,search:s,width:o,height:u};return r&&""!==r&&(f.referrer=r),analytics_core_module_v({},f,e)},Oe={last:{},history:[]};function Ae(e,n){void 0===e&&(e=Oe);var t=n.options;if(n.type===analytics_core_module_q.page){var r=me(analytics_core_module_v({properties:n.properties,meta:n.meta},Object.keys(t).length&&{options:t}));return analytics_core_module_v({},e,{last:r,history:e.history.concat(r)})}return e}we=function(){if(!$)return!1;var e=navigator.appVersion;return~e.indexOf("Win")?"Windows":~e.indexOf("Mac")?"MacOS":~e.indexOf("X11")?"UNIX":~e.indexOf("Linux")?"Linux":"Unknown OS"}(),Ee=$?document.referrer:null,Pe=analytics_utils_module_o(),Se=analytics_utils_module_a();var _e={initialized:!1,sessionId:analytics_utils_module_y(),app:null,version:null,debug:!1,offline:!!$&&!navigator.onLine,os:{name:we},userAgent:$?navigator.userAgent:"node",library:{name:"analytics",version:"0.12.5"},timezone:Se,locale:Pe,campaign:{},referrer:Ee};function xe(e,n){void 0===e&&(e=_e);var t=e.initialized,r=n.campaign;switch(n.type){case analytics_core_module_q.campaign:return analytics_core_module_v({},e,{campaign:r});case analytics_core_module_q.offline:return analytics_core_module_v({},e,{offline:!0});case analytics_core_module_q.online:return analytics_core_module_v({},e,{offline:!1});default:return t?e:analytics_core_module_v({},_e,e,{initialized:!0})}}var je=["plugins","reducers","storage"];function ke(e,n,t){if($){var r=window[(t?"add":"remove")+"EventListener"];e.split(" ").forEach(function(e){r(e,n)})}}function Te(e){var n=ke.bind(null,"online offline",function(n){return Promise.resolve(!navigator.onLine).then(e)});return n(!0),function(e){return n(!1)}}function ze(){return analytics_util_global_storage_module_f("analytics",[]),function(e){return function(n,t,r){var i=e(n,t,r),a=i.dispatch;return Object.assign(i,{dispatch:function(e){return analytics_util_global_storage_module_n[analytics_util_global_storage_module_o].analytics.push(e.action||e),a(e)}})}}}function Me(e){return function(){return analytics_core_module_N(analytics_core_module_N.apply(null,arguments),ze())}}function qe(e){return e?rn(e)?e:[e]:[]}function Ue(n,t,r){void 0===n&&(n={});var i,a,o=analytics_utils_module_y();return t&&(analytics_core_module_X[o]=(i=t,a=function(e){for(var n,t=e||Array.prototype.slice.call(arguments),r=0;r<t.length;r++)if(analytics_util_types_module_W(t[r])){n=t[r];break}return n}(r),function(e){a&&a(e),i(e)})),analytics_core_module_v({},n,{rid:o,ts:(new Date).getTime()},t?{hasCallback:!0}:{})}function Ve(n){void 0===n&&(n={});var t=n.reducers||{},c=n.initialUser||{},s=(n.plugins||[]).reduce(function(e,n){if(analytics_util_types_module_W(n))return e.middlewares=e.middlewares.concat(n),e;if(n.NAMESPACE&&(n.name=n.NAMESPACE),!n.name)throw new Error("https://lytics.dev/errors/1");n.config||(n.config={});var t=n.EVENTS?Object.keys(n.EVENTS).map(function(e){return n.EVENTS[e]}):[];e.pluginEnabled[n.name]=!(!1===n.enabled||!1===n.config.enabled),delete n.enabled,n.methods&&(e.methods[n.name]=Object.keys(n.methods).reduce(function(e,t){var r;return e[t]=(r=n.methods[t],function(){for(var e=Array.prototype.slice.call(arguments),n=new Array(r.length),t=0;t<e.length;t++)n[t]=e[t];return n[n.length]=Q,r.apply({instance:Q},n)}),e},{}),delete n.methods);var r=Object.keys(n).concat(t),i=new Set(e.events.concat(r));if(e.events=Array.from(i),e.pluginsArray=e.pluginsArray.concat(n),e.plugins[n.name])throw new Error(n.name+"AlreadyLoaded");return e.plugins[n.name]=n,e.plugins[n.name].loaded||(e.plugins[n.name].loaded=function(){return!0}),e},{plugins:{},pluginEnabled:{},methods:{},pluginsArray:[],middlewares:[],events:[]}),f=n.storage?n.storage:{getItem:analytics_util_global_storage_module_a,setItem:analytics_util_global_storage_module_f,removeItem:analytics_util_global_storage_module_i},p=function(e){return function(n,t,r){return t.getState("user")[n]||(r&&on(r)&&r[n]?r[n]:analytics_core_module_$(e)[n]||analytics_util_global_storage_module_a(analytics_core_module_D(n))||null)}}(f),h=s.plugins,w=s.events.filter(function(e){return!analytics_core_module_M.includes(e)}).sort(),E=new Set(w.concat(analytics_core_module_z).filter(function(e){return!analytics_core_module_M.includes(e)})),_=Array.from(E).sort(),x=function(){return h},j=new le,U=j.addMiddleware,V=j.removeMiddleware,L=j.dynamicMiddlewares,X=function(){throw new Error("Abort disabled inListener")},J=analytics_utils_module_s(),W=analytics_core_module_$(f),F=analytics_core_module_v({},W,c,J.an_uid?{userId:J.an_uid}:{},J.an_aid?{anonymousId:J.an_aid}:{});F.anonymousId||(F.anonymousId=analytics_utils_module_y());var G=analytics_core_module_v({enable:function(e,n){return new Promise(function(t){ue.dispatch({type:analytics_core_module_q.enablePlugin,plugins:qe(e),_:{originalAction:analytics_core_module_q.enablePlugin}},t,[n])})},disable:function(e,n){return new Promise(function(t){ue.dispatch({type:analytics_core_module_q.disablePlugin,plugins:qe(e),_:{originalAction:analytics_core_module_q.disablePlugin}},t,[n])})}},s.methods),K=!1,Q={identify:function(e,n,t,r){try{var i=q(e)?e:null,a=on(e)?e:n,o=t||{},c=Q.user();analytics_util_global_storage_module_f(analytics_core_module_D(analytics_core_module_k),i);var s=i||a.userId||p(analytics_core_module_k,Q,a);return Promise.resolve(new Promise(function(e){ue.dispatch(analytics_core_module_v({type:analytics_core_module_q.identifyStart,userId:s,traits:a||{},options:o,anonymousId:c.anonymousId},c.id&&c.id!==i&&{previousId:c.id}),e,[n,t,r])}))}catch(e){return Promise.reject(e)}},track:function(e,n,t,r){try{var i=on(e)?e.event:e;if(!i||!q(i))throw new Error("EventMissing");var a=on(e)?e:n||{},o=on(t)?t:{};return Promise.resolve(new Promise(function(e){ue.dispatch({type:analytics_core_module_q.trackStart,event:i,properties:a,options:o,userId:p(analytics_core_module_k,Q,n),anonymousId:p(analytics_core_module_T,Q,n)},e,[n,t,r])}))}catch(e){return Promise.reject(e)}},page:function(e,n,t){try{var r=on(e)?e:{},i=on(n)?n:{};return Promise.resolve(new Promise(function(a){ue.dispatch({type:analytics_core_module_q.pageStart,properties:Ne(r),options:i,userId:p(analytics_core_module_k,Q,r),anonymousId:p(analytics_core_module_T,Q,r)},a,[e,n,t])}))}catch(e){return Promise.reject(e)}},user:function(e){if(e===analytics_core_module_k||"id"===e)return p(analytics_core_module_k,Q);if(e===analytics_core_module_T||"anonId"===e)return p(analytics_core_module_T,Q);var n=Q.getState("user");return e?dlv_umd_default()(n,e):n},reset:function(e){return new Promise(function(n){ue.dispatch({type:analytics_core_module_q.resetStart},n,e)})},ready:function(e){return K&&e({plugins:G,instance:Q}),Q.on(analytics_core_module_q.ready,function(n){e(n),K=!0})},on:function(e,n){if(!e||!analytics_util_types_module_W(n))return!1;if(e===analytics_core_module_q.bootstrap)throw new Error(".on disabled for "+e);var t=/Start$|Start:/;if("*"===e){var r=function(e){return function(e){return function(r){return r.type.match(t)&&n({payload:r,instance:Q,plugins:h}),e(r)}}},i=function(e){return function(e){return function(r){return r.type.match(t)||n({payload:r,instance:Q,plugins:h}),e(r)}}};return U(r,Le),U(i,Ce),function(){V(r,Le),V(i,Ce)}}var a=e.match(t)?Le:Ce,o=function(t){return function(t){return function(r){return r.type===e&&n({payload:r,instance:Q,plugins:h,abort:X}),t(r)}}};return U(o,a),function(){return V(o,a)}},once:function(e,n){if(!e||!analytics_util_types_module_W(n))return!1;if(e===analytics_core_module_q.bootstrap)throw new Error(".once disabled for "+e);var t=Q.on(e,function(e){n({payload:e.payload,instance:Q,plugins:h,abort:X}),t()});return t},getState:function(e){var n=ue.getState();return e?dlv_umd_default()(n,e):Object.assign({},n)},dispatch:function(e){var n=q(e)?{type:e}:e;if(analytics_core_module_z.includes(n.type))throw new Error("reserved action "+n.type);var t=analytics_core_module_v({},n,{_:analytics_core_module_v({originalAction:n.type},e._||{})});ue.dispatch(t)},enablePlugin:G.enable,disablePlugin:G.disable,plugins:G,storage:{getItem:f.getItem,setItem:function(e,n,t){ue.dispatch({type:analytics_core_module_q.setItemStart,key:e,value:n,options:t})},removeItem:function(e,n){ue.dispatch({type:analytics_core_module_q.removeItemStart,key:e,options:n})}},setAnonymousId:function(e,n){Q.storage.setItem(analytics_core_module_A,e,n)},events:{core:analytics_core_module_z,plugins:w}},Y=s.middlewares.concat([function(e){return function(e){return function(n){return n.meta||(n.meta=Ue()),e(n)}}},L(Le),ce(Q,x,{all:_,plugins:w}),se(f),analytics_core_module_C(Q),analytics_core_module_B(Q),L(Ce)]),Z={context:xe,user:analytics_core_module_R(f),page:Ae,track:he,plugins:fe(x),queue:ye},ee=analytics_core_module_N,ne=analytics_core_module_N;if($&&n.debug){var te=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;te&&(ee=te({trace:!0,traceLimit:25})),ne=function(){return 0===arguments.length?ze():on(typeof arguments[0])?Me():Me().apply(null,arguments)}}var re,ie=function(e){return Object.keys(e).reduce(function(n,t){return je.includes(t)||(n[t]=e[t]),n},{})}(n),ae=s.pluginsArray.reduce(function(e,n){var t=n.name,r=n.config,i=n.loaded,a=s.pluginEnabled[t];return e[t]={enabled:a,initialized:!!a&&Boolean(!n.initialize),loaded:Boolean(i({config:r})),config:r},e},{}),oe={context:ie,user:F,plugins:ae},ue=analytics_core_module_P(function(e){for(var n=Object.keys(e),t={},r=0;r<n.length;r++){var i=n[r];typeof e[i]===analytics_core_module_y&&(t[i]=e[i])}var a,o=Object.keys(t);try{!function(e){Object.keys(e).forEach(function(n){var t=e[n];if(typeof t(void 0,{type:"@@redux/INIT"})===analytics_core_module_b||typeof t(void 0,{type:analytics_core_module_I})===analytics_core_module_b)throw new Error("reducer "+n+" "+analytics_core_module_b)})}(t)}catch(e){a=e}return function(e,n){if(void 0===e&&(e={}),a)throw a;for(var r=!1,i={},u=0;u<o.length;u++){var c=o[u],s=e[c],l=(0,t[c])(s,n);if(typeof l===analytics_core_module_b){var f=analytics_core_module_S(c,n);throw new Error(f)}i[c]=l,r=r||l!==s}return r?i:e}}(analytics_core_module_v({},Z,t)),oe,ne(ee(analytics_core_module_O.apply(void 0,Y))));ue.dispatch=(re=ue.dispatch,function(e,n,t){var r=analytics_core_module_v({},e,{meta:Ue(e.meta,n,qe(t))});return re.apply(null,[r])});var de=Object.keys(h);ue.dispatch({type:analytics_core_module_q.bootstrap,plugins:de,config:ie,params:J,user:F,initialUser:c,persistedUser:W});var pe=de.filter(function(e){return s.pluginEnabled[e]}),me=de.filter(function(e){return!s.pluginEnabled[e]});return ue.dispatch({type:analytics_core_module_q.registerPlugins,plugins:de,enabled:s.pluginEnabled}),s.pluginsArray.map(function(e,n){var t=e.bootstrap,r=e.config,i=e.name;t&&analytics_util_types_module_W(t)&&t({instance:Q,config:r,payload:e}),ue.dispatch({type:analytics_core_module_q.registerPluginType(i),name:i,enabled:s.pluginEnabled[i],plugin:e}),s.pluginsArray.length===n+1&&ue.dispatch({type:analytics_core_module_q.initializeStart,plugins:pe,disabled:me})}),Te(function(e){ue.dispatch({type:e?analytics_core_module_q.offline:analytics_core_module_q.online})}),function(e,n,t){setInterval(function(){return analytics_core_module_H(e,n,t)},3e3)}(ue,x,Q),Q}var Le="before",Ce="after";
//# sourceMappingURL=analytics-core.module.js.map

;// CONCATENATED MODULE: ../../../node_modules/@analytics/cookie-utils/dist/analytics-util-cookie.module.js
var analytics_util_cookie_module_t="cookie",analytics_util_cookie_module_i=analytics_util_cookie_module_a(),analytics_util_cookie_module_r=analytics_util_cookie_module_d,analytics_util_cookie_module_c=analytics_util_cookie_module_d;function analytics_util_cookie_module_u(o){return analytics_util_cookie_module_i?analytics_util_cookie_module_d(o,"",-1):analytics_util_global_storage_module_i(o)}function analytics_util_cookie_module_a(){if(void 0!==analytics_util_cookie_module_i)return analytics_util_cookie_module_i;var e="cookiecookie";try{analytics_util_cookie_module_d(e,e),analytics_util_cookie_module_i=-1!==document.cookie.indexOf(e),analytics_util_cookie_module_u(e)}catch(e){analytics_util_cookie_module_i=!1}return analytics_util_cookie_module_i}function analytics_util_cookie_module_d(e,t,r,c,u,a){if("undefined"!=typeof window){var d=arguments.length>1;return!1===analytics_util_cookie_module_i&&(d?analytics_util_global_storage_module_f(e,t):analytics_util_global_storage_module_a(e)),d?document.cookie=e+"="+encodeURIComponent(t)+(r?"; expires="+new Date(+new Date+1e3*r).toUTCString()+(c?"; path="+c:"")+(u?"; domain="+u:"")+(a?"; secure":""):""):decodeURIComponent((("; "+document.cookie).split("; "+e+"=")[1]||"").split(";")[0])}}
//# sourceMappingURL=analytics-util-cookie.module.js.map

;// CONCATENATED MODULE: ../../../node_modules/@analytics/localstorage-utils/dist/analytics-util-localstorage.module.js
var analytics_util_localstorage_module_r="localStorage",analytics_util_localstorage_module_g=analytics_util_global_storage_module_b.bind(null,"localStorage"),analytics_util_localstorage_module_c=analytics_util_global_storage_module_u("localStorage","getItem",analytics_util_global_storage_module_a),analytics_util_localstorage_module_m=analytics_util_global_storage_module_u("localStorage","setItem",analytics_util_global_storage_module_f),analytics_util_localstorage_module_S=analytics_util_global_storage_module_u("localStorage","removeItem",analytics_util_global_storage_module_i);
//# sourceMappingURL=analytics-util-localstorage.module.js.map

;// CONCATENATED MODULE: ../../../node_modules/@analytics/session-storage-utils/dist/analytics-util-session-storage.module.js
var analytics_util_session_storage_module_a="sessionStorage",analytics_util_session_storage_module_i=analytics_util_global_storage_module_b.bind(null,"sessionStorage"),analytics_util_session_storage_module_g=analytics_util_global_storage_module_u("sessionStorage","getItem",analytics_util_global_storage_module_a),analytics_util_session_storage_module_n=analytics_util_global_storage_module_u("sessionStorage","setItem",analytics_util_global_storage_module_f),analytics_util_session_storage_module_l=analytics_util_global_storage_module_u("sessionStorage","removeItem",analytics_util_global_storage_module_i);
//# sourceMappingURL=analytics-util-session-storage.module.js.map

;// CONCATENATED MODULE: ../../../node_modules/@analytics/storage-utils/dist/analytics-util-storage.module.js
function analytics_util_storage_module_I(t){var o=t;try{if("true"===(o=JSON.parse(t)))return!0;if("false"===o)return!1;if(on(o))return o;parseFloat(o)===o&&(o=parseFloat(o))}catch(t){}if(null!==o&&""!==o)return o}var analytics_util_storage_module_k=analytics_util_localstorage_module_g(),analytics_util_storage_module_O=analytics_util_session_storage_module_i(),analytics_util_storage_module_x=analytics_util_cookie_module_a();function analytics_util_storage_module_C(o,e){if(o){var r=analytics_util_storage_module_A(e),a=!analytics_util_storage_module_N(r),i=analytics_util_storage_module_d(r)?analytics_util_storage_module_I(localStorage.getItem(o)):void 0;if(a&&!I(i))return i;var n=analytics_util_storage_module_h(r)?analytics_util_storage_module_I(analytics_util_cookie_module_r(o)):void 0;if(a&&n)return n;var l=analytics_util_storage_module_E(r)?analytics_util_storage_module_I(sessionStorage.getItem(o)):void 0;if(a&&l)return l;var u=analytics_util_global_storage_module_a(o);return a?u:{localStorage:i,sessionStorage:l,cookie:n,global:u}}}function analytics_util_storage_module_L(r,a,l){if(r&&!I(a)){var u={},g=analytics_util_storage_module_A(l),m=JSON.stringify(a),S=!analytics_util_storage_module_N(g);return analytics_util_storage_module_d(g)&&(u[analytics_util_localstorage_module_r]=analytics_util_storage_module_F(analytics_util_localstorage_module_r,a,analytics_util_storage_module_I(localStorage.getItem(r))),localStorage.setItem(r,m),S)?u[analytics_util_localstorage_module_r]:analytics_util_storage_module_h(g)&&(u[analytics_util_cookie_module_t]=analytics_util_storage_module_F(analytics_util_cookie_module_t,a,analytics_util_storage_module_I(analytics_util_cookie_module_r(r))),analytics_util_cookie_module_c(r,m),S)?u[analytics_util_cookie_module_t]:analytics_util_storage_module_E(g)&&(u[analytics_util_session_storage_module_a]=analytics_util_storage_module_F(analytics_util_session_storage_module_a,a,analytics_util_storage_module_I(sessionStorage.getItem(r))),sessionStorage.setItem(r,m),S)?u[analytics_util_session_storage_module_a]:(u[analytics_util_global_storage_module_l]=analytics_util_storage_module_F(analytics_util_global_storage_module_l,a,analytics_util_global_storage_module_a(r)),analytics_util_global_storage_module_f(r,a),S?u[analytics_util_global_storage_module_l]:u)}}function analytics_util_storage_module_b(t,e){if(t){var a=analytics_util_storage_module_A(e),s=analytics_util_storage_module_C(t,m),n={};return!I(s.localStorage)&&analytics_util_storage_module_d(a)&&(localStorage.removeItem(t),n[analytics_util_localstorage_module_r]=s.localStorage),!I(s.cookie)&&analytics_util_storage_module_h(a)&&(analytics_util_cookie_module_u(t),n[analytics_util_cookie_module_t]=s.cookie),!I(s.sessionStorage)&&analytics_util_storage_module_E(a)&&(sessionStorage.removeItem(t),n[analytics_util_session_storage_module_a]=s.sessionStorage),!I(s.global)&&analytics_util_storage_module_G(a,analytics_util_global_storage_module_l)&&(analytics_util_global_storage_module_i(t),n[analytics_util_global_storage_module_l]=s.global),n}}function analytics_util_storage_module_A(t){return t?q(t)?t:t.storage:b}function analytics_util_storage_module_d(t){return analytics_util_storage_module_k&&analytics_util_storage_module_G(t,analytics_util_localstorage_module_r)}function analytics_util_storage_module_h(t){return analytics_util_storage_module_x&&analytics_util_storage_module_G(t,analytics_util_cookie_module_t)}function analytics_util_storage_module_E(t){return analytics_util_storage_module_O&&analytics_util_storage_module_G(t,analytics_util_session_storage_module_a)}function analytics_util_storage_module_N(t){return t===m||"all"===t}function analytics_util_storage_module_G(t,o){return t===b||t===o||analytics_util_storage_module_N(t)}function analytics_util_storage_module_F(t,o,e){return{location:t,current:o,previous:e}}var analytics_util_storage_module_J={setItem:analytics_util_storage_module_L,getItem:analytics_util_storage_module_C,removeItem:analytics_util_storage_module_b};
//# sourceMappingURL=analytics-util-storage.module.js.map

;// CONCATENATED MODULE: ../../../node_modules/analytics/lib/analytics.browser.es.js




function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function analyticsLib() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultSettings = {
    storage: analytics_util_storage_module_J
  };
  return Ve(_objectSpread2(_objectSpread2({}, defaultSettings), opts));
}




/***/ }),

/***/ 72256:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _iterationDecorator = _interopRequireDefault(__webpack_require__(34818));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var properties = [['aria-activedescendant', {
  'type': 'id'
}], ['aria-atomic', {
  'type': 'boolean'
}], ['aria-autocomplete', {
  'type': 'token',
  'values': ['inline', 'list', 'both', 'none']
}], ['aria-busy', {
  'type': 'boolean'
}], ['aria-checked', {
  'type': 'tristate'
}], ['aria-colcount', {
  type: 'integer'
}], ['aria-colindex', {
  type: 'integer'
}], ['aria-colspan', {
  type: 'integer'
}], ['aria-controls', {
  'type': 'idlist'
}], ['aria-current', {
  type: 'token',
  values: ['page', 'step', 'location', 'date', 'time', true, false]
}], ['aria-describedby', {
  'type': 'idlist'
}], ['aria-details', {
  'type': 'id'
}], ['aria-disabled', {
  'type': 'boolean'
}], ['aria-dropeffect', {
  'type': 'tokenlist',
  'values': ['copy', 'execute', 'link', 'move', 'none', 'popup']
}], ['aria-errormessage', {
  'type': 'id'
}], ['aria-expanded', {
  'type': 'boolean',
  'allowundefined': true
}], ['aria-flowto', {
  'type': 'idlist'
}], ['aria-grabbed', {
  'type': 'boolean',
  'allowundefined': true
}], ['aria-haspopup', {
  'type': 'token',
  'values': [false, true, 'menu', 'listbox', 'tree', 'grid', 'dialog']
}], ['aria-hidden', {
  'type': 'boolean',
  'allowundefined': true
}], ['aria-invalid', {
  'type': 'token',
  'values': ['grammar', false, 'spelling', true]
}], ['aria-keyshortcuts', {
  type: 'string'
}], ['aria-label', {
  'type': 'string'
}], ['aria-labelledby', {
  'type': 'idlist'
}], ['aria-level', {
  'type': 'integer'
}], ['aria-live', {
  'type': 'token',
  'values': ['assertive', 'off', 'polite']
}], ['aria-modal', {
  type: 'boolean'
}], ['aria-multiline', {
  'type': 'boolean'
}], ['aria-multiselectable', {
  'type': 'boolean'
}], ['aria-orientation', {
  'type': 'token',
  'values': ['vertical', 'undefined', 'horizontal']
}], ['aria-owns', {
  'type': 'idlist'
}], ['aria-placeholder', {
  type: 'string'
}], ['aria-posinset', {
  'type': 'integer'
}], ['aria-pressed', {
  'type': 'tristate'
}], ['aria-readonly', {
  'type': 'boolean'
}], ['aria-relevant', {
  'type': 'tokenlist',
  'values': ['additions', 'all', 'removals', 'text']
}], ['aria-required', {
  'type': 'boolean'
}], ['aria-roledescription', {
  type: 'string'
}], ['aria-rowcount', {
  type: 'integer'
}], ['aria-rowindex', {
  type: 'integer'
}], ['aria-rowspan', {
  type: 'integer'
}], ['aria-selected', {
  'type': 'boolean',
  'allowundefined': true
}], ['aria-setsize', {
  'type': 'integer'
}], ['aria-sort', {
  'type': 'token',
  'values': ['ascending', 'descending', 'none', 'other']
}], ['aria-valuemax', {
  'type': 'number'
}], ['aria-valuemin', {
  'type': 'number'
}], ['aria-valuenow', {
  'type': 'number'
}], ['aria-valuetext', {
  'type': 'string'
}]];
var ariaPropsMap = {
  entries: function entries() {
    return properties;
  },
  forEach: function forEach(fn) {
    var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _iterator = _createForOfIteratorHelper(properties),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          values = _step$value[1];
        fn.call(thisArg, values, key, properties);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  get: function get(key) {
    var item = properties.find(function (tuple) {
      return tuple[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!ariaPropsMap.get(key);
  },
  keys: function keys() {
    return properties.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key;
    });
  },
  values: function values() {
    return properties.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        values = _ref4[1];
      return values;
    });
  }
};
var _default = (0, _iterationDecorator.default)(ariaPropsMap, ariaPropsMap.entries());
exports["default"] = _default;

/***/ }),

/***/ 92607:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _iterationDecorator = _interopRequireDefault(__webpack_require__(34818));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var dom = [['a', {
  reserved: false
}], ['abbr', {
  reserved: false
}], ['acronym', {
  reserved: false
}], ['address', {
  reserved: false
}], ['applet', {
  reserved: false
}], ['area', {
  reserved: false
}], ['article', {
  reserved: false
}], ['aside', {
  reserved: false
}], ['audio', {
  reserved: false
}], ['b', {
  reserved: false
}], ['base', {
  reserved: true
}], ['bdi', {
  reserved: false
}], ['bdo', {
  reserved: false
}], ['big', {
  reserved: false
}], ['blink', {
  reserved: false
}], ['blockquote', {
  reserved: false
}], ['body', {
  reserved: false
}], ['br', {
  reserved: false
}], ['button', {
  reserved: false
}], ['canvas', {
  reserved: false
}], ['caption', {
  reserved: false
}], ['center', {
  reserved: false
}], ['cite', {
  reserved: false
}], ['code', {
  reserved: false
}], ['col', {
  reserved: true
}], ['colgroup', {
  reserved: true
}], ['content', {
  reserved: false
}], ['data', {
  reserved: false
}], ['datalist', {
  reserved: false
}], ['dd', {
  reserved: false
}], ['del', {
  reserved: false
}], ['details', {
  reserved: false
}], ['dfn', {
  reserved: false
}], ['dialog', {
  reserved: false
}], ['dir', {
  reserved: false
}], ['div', {
  reserved: false
}], ['dl', {
  reserved: false
}], ['dt', {
  reserved: false
}], ['em', {
  reserved: false
}], ['embed', {
  reserved: false
}], ['fieldset', {
  reserved: false
}], ['figcaption', {
  reserved: false
}], ['figure', {
  reserved: false
}], ['font', {
  reserved: false
}], ['footer', {
  reserved: false
}], ['form', {
  reserved: false
}], ['frame', {
  reserved: false
}], ['frameset', {
  reserved: false
}], ['h1', {
  reserved: false
}], ['h2', {
  reserved: false
}], ['h3', {
  reserved: false
}], ['h4', {
  reserved: false
}], ['h5', {
  reserved: false
}], ['h6', {
  reserved: false
}], ['head', {
  reserved: true
}], ['header', {
  reserved: false
}], ['hgroup', {
  reserved: false
}], ['hr', {
  reserved: false
}], ['html', {
  reserved: true
}], ['i', {
  reserved: false
}], ['iframe', {
  reserved: false
}], ['img', {
  reserved: false
}], ['input', {
  reserved: false
}], ['ins', {
  reserved: false
}], ['kbd', {
  reserved: false
}], ['keygen', {
  reserved: false
}], ['label', {
  reserved: false
}], ['legend', {
  reserved: false
}], ['li', {
  reserved: false
}], ['link', {
  reserved: true
}], ['main', {
  reserved: false
}], ['map', {
  reserved: false
}], ['mark', {
  reserved: false
}], ['marquee', {
  reserved: false
}], ['menu', {
  reserved: false
}], ['menuitem', {
  reserved: false
}], ['meta', {
  reserved: true
}], ['meter', {
  reserved: false
}], ['nav', {
  reserved: false
}], ['noembed', {
  reserved: true
}], ['noscript', {
  reserved: true
}], ['object', {
  reserved: false
}], ['ol', {
  reserved: false
}], ['optgroup', {
  reserved: false
}], ['option', {
  reserved: false
}], ['output', {
  reserved: false
}], ['p', {
  reserved: false
}], ['param', {
  reserved: true
}], ['picture', {
  reserved: true
}], ['pre', {
  reserved: false
}], ['progress', {
  reserved: false
}], ['q', {
  reserved: false
}], ['rp', {
  reserved: false
}], ['rt', {
  reserved: false
}], ['rtc', {
  reserved: false
}], ['ruby', {
  reserved: false
}], ['s', {
  reserved: false
}], ['samp', {
  reserved: false
}], ['script', {
  reserved: true
}], ['section', {
  reserved: false
}], ['select', {
  reserved: false
}], ['small', {
  reserved: false
}], ['source', {
  reserved: true
}], ['spacer', {
  reserved: false
}], ['span', {
  reserved: false
}], ['strike', {
  reserved: false
}], ['strong', {
  reserved: false
}], ['style', {
  reserved: true
}], ['sub', {
  reserved: false
}], ['summary', {
  reserved: false
}], ['sup', {
  reserved: false
}], ['table', {
  reserved: false
}], ['tbody', {
  reserved: false
}], ['td', {
  reserved: false
}], ['textarea', {
  reserved: false
}], ['tfoot', {
  reserved: false
}], ['th', {
  reserved: false
}], ['thead', {
  reserved: false
}], ['time', {
  reserved: false
}], ['title', {
  reserved: true
}], ['tr', {
  reserved: false
}], ['track', {
  reserved: true
}], ['tt', {
  reserved: false
}], ['u', {
  reserved: false
}], ['ul', {
  reserved: false
}], ['var', {
  reserved: false
}], ['video', {
  reserved: false
}], ['wbr', {
  reserved: false
}], ['xmp', {
  reserved: false
}]];
var domMap = {
  entries: function entries() {
    return dom;
  },
  forEach: function forEach(fn) {
    var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _iterator = _createForOfIteratorHelper(dom),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          values = _step$value[1];
        fn.call(thisArg, values, key, dom);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  get: function get(key) {
    var item = dom.find(function (tuple) {
      return tuple[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!domMap.get(key);
  },
  keys: function keys() {
    return dom.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key;
    });
  },
  values: function values() {
    return dom.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        values = _ref4[1];
      return values;
    });
  }
};
var _default = (0, _iterationDecorator.default)(domMap, domMap.entries());
exports["default"] = _default;

/***/ }),

/***/ 74490:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _deepEqual = _interopRequireDefault(__webpack_require__(4562));
var _iterationDecorator = _interopRequireDefault(__webpack_require__(34818));
var _rolesMap = _interopRequireDefault(__webpack_require__(29312));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var elementRoles = [];
var keys = _rolesMap.default.keys();
for (var i = 0; i < keys.length; i++) {
  var key = keys[i];
  var role = _rolesMap.default.get(key);
  if (role) {
    var concepts = [].concat(role.baseConcepts, role.relatedConcepts);
    for (var k = 0; k < concepts.length; k++) {
      var relation = concepts[k];
      if (relation.module === 'HTML') {
        var concept = relation.concept;
        if (concept) {
          (function () {
            var conceptStr = JSON.stringify(concept);
            var elementRoleRelation = elementRoles.find(function (relation) {
              return JSON.stringify(relation[0]) === conceptStr;
            });
            var roles = void 0;
            if (elementRoleRelation) {
              roles = elementRoleRelation[1];
            } else {
              roles = [];
            }
            var isUnique = true;
            for (var _i = 0; _i < roles.length; _i++) {
              if (roles[_i] === key) {
                isUnique = false;
                break;
              }
            }
            if (isUnique) {
              roles.push(key);
            }
            elementRoles.push([concept, roles]);
          })();
        }
      }
    }
  }
}
var elementRoleMap = {
  entries: function entries() {
    return elementRoles;
  },
  forEach: function forEach(fn) {
    var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _iterator = _createForOfIteratorHelper(elementRoles),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          _key = _step$value[0],
          values = _step$value[1];
        fn.call(thisArg, values, _key, elementRoles);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  get: function get(key) {
    var item = elementRoles.find(function (tuple) {
      return (0, _deepEqual.default)(key, tuple[0]);
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!elementRoleMap.get(key);
  },
  keys: function keys() {
    return elementRoles.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key;
    });
  },
  values: function values() {
    return elementRoles.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        values = _ref4[1];
      return values;
    });
  }
};
var _default = (0, _iterationDecorator.default)(elementRoleMap, elementRoleMap.entries());
exports["default"] = _default;

/***/ }),

/***/ 69742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var commandRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'menuitem'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget']]
};
var _default = commandRole;
exports["default"] = _default;

/***/ }),

/***/ 7938:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var compositeRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-activedescendant': null,
    'aria-disabled': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget']]
};
var _default = compositeRole;
exports["default"] = _default;

/***/ }),

/***/ 46214:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var inputRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null
  },
  relatedConcepts: [{
    concept: {
      name: 'input'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget']]
};
var _default = inputRole;
exports["default"] = _default;

/***/ }),

/***/ 10134:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var landmarkRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = landmarkRole;
exports["default"] = _default;

/***/ }),

/***/ 18950:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var rangeRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-valuemax': null,
    'aria-valuemin': null,
    'aria-valuenow': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = rangeRole;
exports["default"] = _default;

/***/ }),

/***/ 65966:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var roletypeRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {
    'aria-atomic': null,
    'aria-busy': null,
    'aria-controls': null,
    'aria-current': null,
    'aria-describedby': null,
    'aria-details': null,
    'aria-dropeffect': null,
    'aria-flowto': null,
    'aria-grabbed': null,
    'aria-hidden': null,
    'aria-keyshortcuts': null,
    'aria-label': null,
    'aria-labelledby': null,
    'aria-live': null,
    'aria-owns': null,
    'aria-relevant': null,
    'aria-roledescription': null
  },
  relatedConcepts: [{
    concept: {
      name: 'rel'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'role'
    },
    module: 'XHTML'
  }, {
    concept: {
      name: 'type'
    },
    module: 'Dublin Core'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: []
};
var _default = roletypeRole;
exports["default"] = _default;

/***/ }),

/***/ 65067:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var sectionRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'frontmatter'
    },
    module: 'DTB'
  }, {
    concept: {
      name: 'level'
    },
    module: 'DTB'
  }, {
    concept: {
      name: 'level'
    },
    module: 'SMIL'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = sectionRole;
exports["default"] = _default;

/***/ }),

/***/ 50233:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var sectionheadRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = sectionheadRole;
exports["default"] = _default;

/***/ }),

/***/ 27426:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var selectRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-orientation': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite'], ['roletype', 'structure', 'section', 'group']]
};
var _default = selectRole;
exports["default"] = _default;

/***/ }),

/***/ 12781:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var structureRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype']]
};
var _default = structureRole;
exports["default"] = _default;

/***/ }),

/***/ 20182:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var widgetRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype']]
};
var _default = widgetRole;
exports["default"] = _default;

/***/ }),

/***/ 59943:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var windowRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-modal': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype']]
};
var _default = windowRole;
exports["default"] = _default;

/***/ }),

/***/ 14690:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _commandRole = _interopRequireDefault(__webpack_require__(69742));
var _compositeRole = _interopRequireDefault(__webpack_require__(7938));
var _inputRole = _interopRequireDefault(__webpack_require__(46214));
var _landmarkRole = _interopRequireDefault(__webpack_require__(10134));
var _rangeRole = _interopRequireDefault(__webpack_require__(18950));
var _roletypeRole = _interopRequireDefault(__webpack_require__(65966));
var _sectionRole = _interopRequireDefault(__webpack_require__(65067));
var _sectionheadRole = _interopRequireDefault(__webpack_require__(50233));
var _selectRole = _interopRequireDefault(__webpack_require__(27426));
var _structureRole = _interopRequireDefault(__webpack_require__(12781));
var _widgetRole = _interopRequireDefault(__webpack_require__(20182));
var _windowRole = _interopRequireDefault(__webpack_require__(59943));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ariaAbstractRoles = [['command', _commandRole.default], ['composite', _compositeRole.default], ['input', _inputRole.default], ['landmark', _landmarkRole.default], ['range', _rangeRole.default], ['roletype', _roletypeRole.default], ['section', _sectionRole.default], ['sectionhead', _sectionheadRole.default], ['select', _selectRole.default], ['structure', _structureRole.default], ['widget', _widgetRole.default], ['window', _windowRole.default]];
var _default = ariaAbstractRoles;
exports["default"] = _default;

/***/ }),

/***/ 61413:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _docAbstractRole = _interopRequireDefault(__webpack_require__(18868));
var _docAcknowledgmentsRole = _interopRequireDefault(__webpack_require__(79710));
var _docAfterwordRole = _interopRequireDefault(__webpack_require__(77958));
var _docAppendixRole = _interopRequireDefault(__webpack_require__(99074));
var _docBacklinkRole = _interopRequireDefault(__webpack_require__(23961));
var _docBiblioentryRole = _interopRequireDefault(__webpack_require__(68917));
var _docBibliographyRole = _interopRequireDefault(__webpack_require__(20555));
var _docBibliorefRole = _interopRequireDefault(__webpack_require__(85081));
var _docChapterRole = _interopRequireDefault(__webpack_require__(38935));
var _docColophonRole = _interopRequireDefault(__webpack_require__(53076));
var _docConclusionRole = _interopRequireDefault(__webpack_require__(46406));
var _docCoverRole = _interopRequireDefault(__webpack_require__(44613));
var _docCreditRole = _interopRequireDefault(__webpack_require__(2060));
var _docCreditsRole = _interopRequireDefault(__webpack_require__(79176));
var _docDedicationRole = _interopRequireDefault(__webpack_require__(97684));
var _docEndnoteRole = _interopRequireDefault(__webpack_require__(75835));
var _docEndnotesRole = _interopRequireDefault(__webpack_require__(4656));
var _docEpigraphRole = _interopRequireDefault(__webpack_require__(34767));
var _docEpilogueRole = _interopRequireDefault(__webpack_require__(34726));
var _docErrataRole = _interopRequireDefault(__webpack_require__(363));
var _docExampleRole = _interopRequireDefault(__webpack_require__(25742));
var _docFootnoteRole = _interopRequireDefault(__webpack_require__(37863));
var _docForewordRole = _interopRequireDefault(__webpack_require__(89953));
var _docGlossaryRole = _interopRequireDefault(__webpack_require__(29209));
var _docGlossrefRole = _interopRequireDefault(__webpack_require__(43145));
var _docIndexRole = _interopRequireDefault(__webpack_require__(7945));
var _docIntroductionRole = _interopRequireDefault(__webpack_require__(60022));
var _docNoterefRole = _interopRequireDefault(__webpack_require__(21913));
var _docNoticeRole = _interopRequireDefault(__webpack_require__(76648));
var _docPagebreakRole = _interopRequireDefault(__webpack_require__(13551));
var _docPagelistRole = _interopRequireDefault(__webpack_require__(87789));
var _docPartRole = _interopRequireDefault(__webpack_require__(85367));
var _docPrefaceRole = _interopRequireDefault(__webpack_require__(90938));
var _docPrologueRole = _interopRequireDefault(__webpack_require__(59955));
var _docPullquoteRole = _interopRequireDefault(__webpack_require__(99992));
var _docQnaRole = _interopRequireDefault(__webpack_require__(64565));
var _docSubtitleRole = _interopRequireDefault(__webpack_require__(23465));
var _docTipRole = _interopRequireDefault(__webpack_require__(37207));
var _docTocRole = _interopRequireDefault(__webpack_require__(33719));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ariaDpubRoles = [['doc-abstract', _docAbstractRole.default], ['doc-acknowledgments', _docAcknowledgmentsRole.default], ['doc-afterword', _docAfterwordRole.default], ['doc-appendix', _docAppendixRole.default], ['doc-backlink', _docBacklinkRole.default], ['doc-biblioentry', _docBiblioentryRole.default], ['doc-bibliography', _docBibliographyRole.default], ['doc-biblioref', _docBibliorefRole.default], ['doc-chapter', _docChapterRole.default], ['doc-colophon', _docColophonRole.default], ['doc-conclusion', _docConclusionRole.default], ['doc-cover', _docCoverRole.default], ['doc-credit', _docCreditRole.default], ['doc-credits', _docCreditsRole.default], ['doc-dedication', _docDedicationRole.default], ['doc-endnote', _docEndnoteRole.default], ['doc-endnotes', _docEndnotesRole.default], ['doc-epigraph', _docEpigraphRole.default], ['doc-epilogue', _docEpilogueRole.default], ['doc-errata', _docErrataRole.default], ['doc-example', _docExampleRole.default], ['doc-footnote', _docFootnoteRole.default], ['doc-foreword', _docForewordRole.default], ['doc-glossary', _docGlossaryRole.default], ['doc-glossref', _docGlossrefRole.default], ['doc-index', _docIndexRole.default], ['doc-introduction', _docIntroductionRole.default], ['doc-noteref', _docNoterefRole.default], ['doc-notice', _docNoticeRole.default], ['doc-pagebreak', _docPagebreakRole.default], ['doc-pagelist', _docPagelistRole.default], ['doc-part', _docPartRole.default], ['doc-preface', _docPrefaceRole.default], ['doc-prologue', _docPrologueRole.default], ['doc-pullquote', _docPullquoteRole.default], ['doc-qna', _docQnaRole.default], ['doc-subtitle', _docSubtitleRole.default], ['doc-tip', _docTipRole.default], ['doc-toc', _docTocRole.default]];
var _default = ariaDpubRoles;
exports["default"] = _default;

/***/ }),

/***/ 20915:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _graphicsDocumentRole = _interopRequireDefault(__webpack_require__(75805));
var _graphicsObjectRole = _interopRequireDefault(__webpack_require__(46205));
var _graphicsSymbolRole = _interopRequireDefault(__webpack_require__(8855));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ariaGraphicsRoles = [['graphics-document', _graphicsDocumentRole.default], ['graphics-object', _graphicsObjectRole.default], ['graphics-symbol', _graphicsSymbolRole.default]];
var _default = ariaGraphicsRoles;
exports["default"] = _default;

/***/ }),

/***/ 58514:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _alertRole = _interopRequireDefault(__webpack_require__(66472));
var _alertdialogRole = _interopRequireDefault(__webpack_require__(84976));
var _applicationRole = _interopRequireDefault(__webpack_require__(35902));
var _articleRole = _interopRequireDefault(__webpack_require__(36883));
var _bannerRole = _interopRequireDefault(__webpack_require__(25599));
var _blockquoteRole = _interopRequireDefault(__webpack_require__(91621));
var _buttonRole = _interopRequireDefault(__webpack_require__(50855));
var _captionRole = _interopRequireDefault(__webpack_require__(31760));
var _cellRole = _interopRequireDefault(__webpack_require__(73350));
var _checkboxRole = _interopRequireDefault(__webpack_require__(58651));
var _codeRole = _interopRequireDefault(__webpack_require__(87305));
var _columnheaderRole = _interopRequireDefault(__webpack_require__(53486));
var _comboboxRole = _interopRequireDefault(__webpack_require__(81663));
var _complementaryRole = _interopRequireDefault(__webpack_require__(98889));
var _contentinfoRole = _interopRequireDefault(__webpack_require__(94961));
var _definitionRole = _interopRequireDefault(__webpack_require__(4676));
var _deletionRole = _interopRequireDefault(__webpack_require__(48978));
var _dialogRole = _interopRequireDefault(__webpack_require__(94154));
var _directoryRole = _interopRequireDefault(__webpack_require__(95707));
var _documentRole = _interopRequireDefault(__webpack_require__(53212));
var _emphasisRole = _interopRequireDefault(__webpack_require__(55530));
var _feedRole = _interopRequireDefault(__webpack_require__(43478));
var _figureRole = _interopRequireDefault(__webpack_require__(12728));
var _formRole = _interopRequireDefault(__webpack_require__(77841));
var _genericRole = _interopRequireDefault(__webpack_require__(56322));
var _gridRole = _interopRequireDefault(__webpack_require__(10417));
var _gridcellRole = _interopRequireDefault(__webpack_require__(49947));
var _groupRole = _interopRequireDefault(__webpack_require__(48498));
var _headingRole = _interopRequireDefault(__webpack_require__(67830));
var _imgRole = _interopRequireDefault(__webpack_require__(25096));
var _insertionRole = _interopRequireDefault(__webpack_require__(45799));
var _linkRole = _interopRequireDefault(__webpack_require__(78987));
var _listRole = _interopRequireDefault(__webpack_require__(20353));
var _listboxRole = _interopRequireDefault(__webpack_require__(21300));
var _listitemRole = _interopRequireDefault(__webpack_require__(8288));
var _logRole = _interopRequireDefault(__webpack_require__(10503));
var _mainRole = _interopRequireDefault(__webpack_require__(14211));
var _marqueeRole = _interopRequireDefault(__webpack_require__(67165));
var _mathRole = _interopRequireDefault(__webpack_require__(63400));
var _menuRole = _interopRequireDefault(__webpack_require__(65357));
var _menubarRole = _interopRequireDefault(__webpack_require__(78926));
var _menuitemRole = _interopRequireDefault(__webpack_require__(96077));
var _menuitemcheckboxRole = _interopRequireDefault(__webpack_require__(4332));
var _menuitemradioRole = _interopRequireDefault(__webpack_require__(5462));
var _meterRole = _interopRequireDefault(__webpack_require__(10740));
var _navigationRole = _interopRequireDefault(__webpack_require__(24772));
var _noneRole = _interopRequireDefault(__webpack_require__(12109));
var _noteRole = _interopRequireDefault(__webpack_require__(15953));
var _optionRole = _interopRequireDefault(__webpack_require__(72476));
var _paragraphRole = _interopRequireDefault(__webpack_require__(16302));
var _presentationRole = _interopRequireDefault(__webpack_require__(88757));
var _progressbarRole = _interopRequireDefault(__webpack_require__(91548));
var _radioRole = _interopRequireDefault(__webpack_require__(59538));
var _radiogroupRole = _interopRequireDefault(__webpack_require__(2964));
var _regionRole = _interopRequireDefault(__webpack_require__(36542));
var _rowRole = _interopRequireDefault(__webpack_require__(86410));
var _rowgroupRole = _interopRequireDefault(__webpack_require__(22386));
var _rowheaderRole = _interopRequireDefault(__webpack_require__(34773));
var _scrollbarRole = _interopRequireDefault(__webpack_require__(87693));
var _searchRole = _interopRequireDefault(__webpack_require__(26560));
var _searchboxRole = _interopRequireDefault(__webpack_require__(4573));
var _separatorRole = _interopRequireDefault(__webpack_require__(15026));
var _sliderRole = _interopRequireDefault(__webpack_require__(99644));
var _spinbuttonRole = _interopRequireDefault(__webpack_require__(5954));
var _statusRole = _interopRequireDefault(__webpack_require__(23977));
var _strongRole = _interopRequireDefault(__webpack_require__(86484));
var _subscriptRole = _interopRequireDefault(__webpack_require__(79727));
var _superscriptRole = _interopRequireDefault(__webpack_require__(26566));
var _switchRole = _interopRequireDefault(__webpack_require__(6248));
var _tabRole = _interopRequireDefault(__webpack_require__(56767));
var _tableRole = _interopRequireDefault(__webpack_require__(5420));
var _tablistRole = _interopRequireDefault(__webpack_require__(80523));
var _tabpanelRole = _interopRequireDefault(__webpack_require__(33043));
var _termRole = _interopRequireDefault(__webpack_require__(96567));
var _textboxRole = _interopRequireDefault(__webpack_require__(40046));
var _timeRole = _interopRequireDefault(__webpack_require__(20292));
var _timerRole = _interopRequireDefault(__webpack_require__(69895));
var _toolbarRole = _interopRequireDefault(__webpack_require__(79182));
var _tooltipRole = _interopRequireDefault(__webpack_require__(42516));
var _treeRole = _interopRequireDefault(__webpack_require__(27976));
var _treegridRole = _interopRequireDefault(__webpack_require__(39379));
var _treeitemRole = _interopRequireDefault(__webpack_require__(58532));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ariaLiteralRoles = [['alert', _alertRole.default], ['alertdialog', _alertdialogRole.default], ['application', _applicationRole.default], ['article', _articleRole.default], ['banner', _bannerRole.default], ['blockquote', _blockquoteRole.default], ['button', _buttonRole.default], ['caption', _captionRole.default], ['cell', _cellRole.default], ['checkbox', _checkboxRole.default], ['code', _codeRole.default], ['columnheader', _columnheaderRole.default], ['combobox', _comboboxRole.default], ['complementary', _complementaryRole.default], ['contentinfo', _contentinfoRole.default], ['definition', _definitionRole.default], ['deletion', _deletionRole.default], ['dialog', _dialogRole.default], ['directory', _directoryRole.default], ['document', _documentRole.default], ['emphasis', _emphasisRole.default], ['feed', _feedRole.default], ['figure', _figureRole.default], ['form', _formRole.default], ['generic', _genericRole.default], ['grid', _gridRole.default], ['gridcell', _gridcellRole.default], ['group', _groupRole.default], ['heading', _headingRole.default], ['img', _imgRole.default], ['insertion', _insertionRole.default], ['link', _linkRole.default], ['list', _listRole.default], ['listbox', _listboxRole.default], ['listitem', _listitemRole.default], ['log', _logRole.default], ['main', _mainRole.default], ['marquee', _marqueeRole.default], ['math', _mathRole.default], ['menu', _menuRole.default], ['menubar', _menubarRole.default], ['menuitem', _menuitemRole.default], ['menuitemcheckbox', _menuitemcheckboxRole.default], ['menuitemradio', _menuitemradioRole.default], ['meter', _meterRole.default], ['navigation', _navigationRole.default], ['none', _noneRole.default], ['note', _noteRole.default], ['option', _optionRole.default], ['paragraph', _paragraphRole.default], ['presentation', _presentationRole.default], ['progressbar', _progressbarRole.default], ['radio', _radioRole.default], ['radiogroup', _radiogroupRole.default], ['region', _regionRole.default], ['row', _rowRole.default], ['rowgroup', _rowgroupRole.default], ['rowheader', _rowheaderRole.default], ['scrollbar', _scrollbarRole.default], ['search', _searchRole.default], ['searchbox', _searchboxRole.default], ['separator', _separatorRole.default], ['slider', _sliderRole.default], ['spinbutton', _spinbuttonRole.default], ['status', _statusRole.default], ['strong', _strongRole.default], ['subscript', _subscriptRole.default], ['superscript', _superscriptRole.default], ['switch', _switchRole.default], ['tab', _tabRole.default], ['table', _tableRole.default], ['tablist', _tablistRole.default], ['tabpanel', _tabpanelRole.default], ['term', _termRole.default], ['textbox', _textboxRole.default], ['time', _timeRole.default], ['timer', _timerRole.default], ['toolbar', _toolbarRole.default], ['tooltip', _tooltipRole.default], ['tree', _treeRole.default], ['treegrid', _treegridRole.default], ['treeitem', _treeitemRole.default]];
var _default = ariaLiteralRoles;
exports["default"] = _default;

/***/ }),

/***/ 18868:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docAbstractRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'abstract [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docAbstractRole;
exports["default"] = _default;

/***/ }),

/***/ 79710:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docAcknowledgmentsRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'acknowledgments [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docAcknowledgmentsRole;
exports["default"] = _default;

/***/ }),

/***/ 77958:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docAfterwordRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'afterword [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docAfterwordRole;
exports["default"] = _default;

/***/ }),

/***/ 99074:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docAppendixRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'appendix [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docAppendixRole;
exports["default"] = _default;

/***/ }),

/***/ 23961:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docBacklinkRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'content'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'referrer [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command', 'link']]
};
var _default = docBacklinkRole;
exports["default"] = _default;

/***/ }),

/***/ 68917:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docBiblioentryRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'EPUB biblioentry [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: ['doc-bibliography'],
  requiredContextRole: ['doc-bibliography'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'listitem']]
};
var _default = docBiblioentryRole;
exports["default"] = _default;

/***/ }),

/***/ 20555:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docBibliographyRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'bibliography [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['doc-biblioentry']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docBibliographyRole;
exports["default"] = _default;

/***/ }),

/***/ 85081:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docBibliorefRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'biblioref [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command', 'link']]
};
var _default = docBibliorefRole;
exports["default"] = _default;

/***/ }),

/***/ 38935:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docChapterRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'chapter [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docChapterRole;
exports["default"] = _default;

/***/ }),

/***/ 53076:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docColophonRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'colophon [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docColophonRole;
exports["default"] = _default;

/***/ }),

/***/ 46406:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docConclusionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'conclusion [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docConclusionRole;
exports["default"] = _default;

/***/ }),

/***/ 44613:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docCoverRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'cover [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'img']]
};
var _default = docCoverRole;
exports["default"] = _default;

/***/ }),

/***/ 2060:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docCreditRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'credit [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docCreditRole;
exports["default"] = _default;

/***/ }),

/***/ 79176:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docCreditsRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'credits [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docCreditsRole;
exports["default"] = _default;

/***/ }),

/***/ 97684:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docDedicationRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'dedication [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docDedicationRole;
exports["default"] = _default;

/***/ }),

/***/ 75835:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docEndnoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'rearnote [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: ['doc-endnotes'],
  requiredContextRole: ['doc-endnotes'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'listitem']]
};
var _default = docEndnoteRole;
exports["default"] = _default;

/***/ }),

/***/ 4656:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docEndnotesRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'rearnotes [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['doc-endnote']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docEndnotesRole;
exports["default"] = _default;

/***/ }),

/***/ 34767:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docEpigraphRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'epigraph [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docEpigraphRole;
exports["default"] = _default;

/***/ }),

/***/ 34726:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docEpilogueRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'epilogue [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docEpilogueRole;
exports["default"] = _default;

/***/ }),

/***/ 363:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docErrataRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'errata [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docErrataRole;
exports["default"] = _default;

/***/ }),

/***/ 25742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docExampleRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docExampleRole;
exports["default"] = _default;

/***/ }),

/***/ 37863:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docFootnoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'footnote [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docFootnoteRole;
exports["default"] = _default;

/***/ }),

/***/ 89953:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docForewordRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'foreword [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docForewordRole;
exports["default"] = _default;

/***/ }),

/***/ 29209:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docGlossaryRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'glossary [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['definition'], ['term']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docGlossaryRole;
exports["default"] = _default;

/***/ }),

/***/ 43145:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docGlossrefRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'glossref [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command', 'link']]
};
var _default = docGlossrefRole;
exports["default"] = _default;

/***/ }),

/***/ 7945:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docIndexRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'index [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark', 'navigation']]
};
var _default = docIndexRole;
exports["default"] = _default;

/***/ }),

/***/ 60022:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docIntroductionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'introduction [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docIntroductionRole;
exports["default"] = _default;

/***/ }),

/***/ 21913:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docNoterefRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'noteref [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command', 'link']]
};
var _default = docNoterefRole;
exports["default"] = _default;

/***/ }),

/***/ 76648:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docNoticeRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'notice [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'note']]
};
var _default = docNoticeRole;
exports["default"] = _default;

/***/ }),

/***/ 13551:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPagebreakRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'pagebreak [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'separator']]
};
var _default = docPagebreakRole;
exports["default"] = _default;

/***/ }),

/***/ 87789:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPagelistRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'page-list [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark', 'navigation']]
};
var _default = docPagelistRole;
exports["default"] = _default;

/***/ }),

/***/ 85367:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPartRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'part [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docPartRole;
exports["default"] = _default;

/***/ }),

/***/ 90938:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPrefaceRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'preface [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docPrefaceRole;
exports["default"] = _default;

/***/ }),

/***/ 59955:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPrologueRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'prologue [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = docPrologueRole;
exports["default"] = _default;

/***/ }),

/***/ 99992:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docPullquoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'pullquote [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['none']]
};
var _default = docPullquoteRole;
exports["default"] = _default;

/***/ }),

/***/ 64565:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docQnaRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'qna [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = docQnaRole;
exports["default"] = _default;

/***/ }),

/***/ 23465:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docSubtitleRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'subtitle [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'sectionhead']]
};
var _default = docSubtitleRole;
exports["default"] = _default;

/***/ }),

/***/ 37207:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docTipRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'help [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'note']]
};
var _default = docTipRole;
exports["default"] = _default;

/***/ }),

/***/ 33719:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var docTocRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'toc [EPUB-SSV]'
    },
    module: 'EPUB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark', 'navigation']]
};
var _default = docTocRole;
exports["default"] = _default;

/***/ }),

/***/ 75805:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var graphicsDocumentRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    module: 'GRAPHICS',
    concept: {
      name: 'graphics-object'
    }
  }, {
    module: 'ARIA',
    concept: {
      name: 'img'
    }
  }, {
    module: 'ARIA',
    concept: {
      name: 'article'
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'document']]
};
var _default = graphicsDocumentRole;
exports["default"] = _default;

/***/ }),

/***/ 46205:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var graphicsObjectRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    module: 'GRAPHICS',
    concept: {
      name: 'graphics-document'
    }
  }, {
    module: 'ARIA',
    concept: {
      name: 'group'
    }
  }, {
    module: 'ARIA',
    concept: {
      name: 'img'
    }
  }, {
    module: 'GRAPHICS',
    concept: {
      name: 'graphics-symbol'
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'group']]
};
var _default = graphicsObjectRole;
exports["default"] = _default;

/***/ }),

/***/ 8855:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var graphicsSymbolRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'img']]
};
var _default = graphicsSymbolRole;
exports["default"] = _default;

/***/ }),

/***/ 66472:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var alertRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-atomic': 'true',
    'aria-live': 'assertive'
  },
  relatedConcepts: [{
    concept: {
      name: 'alert'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = alertRole;
exports["default"] = _default;

/***/ }),

/***/ 84976:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var alertdialogRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'alert'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'alert'], ['roletype', 'window', 'dialog']]
};
var _default = alertdialogRole;
exports["default"] = _default;

/***/ }),

/***/ 35902:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var applicationRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-activedescendant': null,
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null
  },
  relatedConcepts: [{
    concept: {
      name: 'Device Independence Delivery Unit'
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = applicationRole;
exports["default"] = _default;

/***/ }),

/***/ 36883:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var articleRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-posinset': null,
    'aria-setsize': null
  },
  relatedConcepts: [{
    concept: {
      name: 'article'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'document']]
};
var _default = articleRole;
exports["default"] = _default;

/***/ }),

/***/ 25599:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var bannerRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      constraints: ['direct descendant of document'],
      name: 'header'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = bannerRole;
exports["default"] = _default;

/***/ }),

/***/ 91621:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var blockquoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = blockquoteRole;
exports["default"] = _default;

/***/ }),

/***/ 50855:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var buttonRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-pressed': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'aria-pressed'
      }, {
        name: 'type',
        value: 'checkbox'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'aria-expanded',
        value: 'false'
      }],
      name: 'summary'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'aria-expanded',
        value: 'true'
      }],
      constraints: ['direct descendant of details element with the open attribute defined'],
      name: 'summary'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'type',
        value: 'button'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'type',
        value: 'image'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'type',
        value: 'reset'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'type',
        value: 'submit'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'button'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'trigger'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command']]
};
var _default = buttonRole;
exports["default"] = _default;

/***/ }),

/***/ 31760:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var captionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: ['figure', 'grid', 'table'],
  requiredContextRole: ['figure', 'grid', 'table'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = captionRole;
exports["default"] = _default;

/***/ }),

/***/ 73350:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var cellRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-colindex': null,
    'aria-colspan': null,
    'aria-rowindex': null,
    'aria-rowspan': null
  },
  relatedConcepts: [{
    concept: {
      constraints: ['descendant of table'],
      name: 'td'
    },
    module: 'HTML'
  }],
  requireContextRole: ['row'],
  requiredContextRole: ['row'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = cellRole;
exports["default"] = _default;

/***/ }),

/***/ 58651:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var checkboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-checked': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-required': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'type',
        value: 'checkbox'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'option'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-checked': null
  },
  superClass: [['roletype', 'widget', 'input']]
};
var _default = checkboxRole;
exports["default"] = _default;

/***/ }),

/***/ 87305:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var codeRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = codeRole;
exports["default"] = _default;

/***/ }),

/***/ 53486:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var columnheaderRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-sort': null
  },
  relatedConcepts: [{
    attributes: [{
      name: 'scope',
      value: 'col'
    }],
    concept: {
      name: 'th'
    },
    module: 'HTML'
  }],
  requireContextRole: ['row'],
  requiredContextRole: ['row'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'cell'], ['roletype', 'structure', 'section', 'cell', 'gridcell'], ['roletype', 'widget', 'gridcell'], ['roletype', 'structure', 'sectionhead']]
};
var _default = columnheaderRole;
exports["default"] = _default;

/***/ }),

/***/ 81663:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var comboboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-activedescendant': null,
    'aria-autocomplete': null,
    'aria-errormessage': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-required': null,
    'aria-expanded': 'false',
    'aria-haspopup': 'listbox'
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'email'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'search'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'tel'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'text'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'url'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'list'
      }, {
        name: 'type',
        value: 'url'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'multiple'
      }, {
        constraints: ['undefined'],
        name: 'size'
      }],
      name: 'select'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'multiple'
      }, {
        name: 'size',
        value: 1
      }],
      name: 'select'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'select'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-controls': null,
    'aria-expanded': 'false'
  },
  superClass: [['roletype', 'widget', 'input']]
};
var _default = comboboxRole;
exports["default"] = _default;

/***/ }),

/***/ 98889:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var complementaryRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'aside'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = complementaryRole;
exports["default"] = _default;

/***/ }),

/***/ 94961:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var contentinfoRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      constraints: ['direct descendant of document'],
      name: 'footer'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = contentinfoRole;
exports["default"] = _default;

/***/ }),

/***/ 4676:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var definitionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'dd'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = definitionRole;
exports["default"] = _default;

/***/ }),

/***/ 48978:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var deletionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = deletionRole;
exports["default"] = _default;

/***/ }),

/***/ 94154:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var dialogRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'dialog'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'window']]
};
var _default = dialogRole;
exports["default"] = _default;

/***/ }),

/***/ 95707:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var directoryRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    module: 'DAISY Guide'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'list']]
};
var _default = directoryRole;
exports["default"] = _default;

/***/ }),

/***/ 53212:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var documentRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'Device Independence Delivery Unit'
    }
  }, {
    concept: {
      name: 'body'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = documentRole;
exports["default"] = _default;

/***/ }),

/***/ 55530:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var emphasisRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = emphasisRole;
exports["default"] = _default;

/***/ }),

/***/ 43478:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var feedRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['article']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'list']]
};
var _default = feedRole;
exports["default"] = _default;

/***/ }),

/***/ 12728:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var figureRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'figure'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = figureRole;
exports["default"] = _default;

/***/ }),

/***/ 77841:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var formRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'aria-label'
      }],
      name: 'form'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'aria-labelledby'
      }],
      name: 'form'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'name'
      }],
      name: 'form'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = formRole;
exports["default"] = _default;

/***/ }),

/***/ 56322:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var genericRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'span'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'div'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = genericRole;
exports["default"] = _default;

/***/ }),

/***/ 10417:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var gridRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-multiselectable': null,
    'aria-readonly': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'role',
        value: 'grid'
      }],
      name: 'table'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['row'], ['row', 'rowgroup']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite'], ['roletype', 'structure', 'section', 'table']]
};
var _default = gridRole;
exports["default"] = _default;

/***/ }),

/***/ 49947:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var gridcellRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-required': null,
    'aria-selected': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'role',
        value: 'gridcell'
      }],
      name: 'td'
    },
    module: 'HTML'
  }],
  requireContextRole: ['row'],
  requiredContextRole: ['row'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'cell'], ['roletype', 'widget']]
};
var _default = gridcellRole;
exports["default"] = _default;

/***/ }),

/***/ 48498:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var groupRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-activedescendant': null,
    'aria-disabled': null
  },
  relatedConcepts: [{
    concept: {
      name: 'details'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'fieldset'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'optgroup'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = groupRole;
exports["default"] = _default;

/***/ }),

/***/ 67830:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var headingRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-level': '2'
  },
  relatedConcepts: [{
    concept: {
      name: 'h1'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'h2'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'h3'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'h4'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'h5'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'h6'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-level': '2'
  },
  superClass: [['roletype', 'structure', 'sectionhead']]
};
var _default = headingRole;
exports["default"] = _default;

/***/ }),

/***/ 25096:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var imgRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'alt'
      }],
      name: 'img'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'alt'
      }],
      name: 'img'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'imggroup'
    },
    module: 'DTB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = imgRole;
exports["default"] = _default;

/***/ }),

/***/ 45799:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var insertionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = insertionRole;
exports["default"] = _default;

/***/ }),

/***/ 78987:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var linkRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-expanded': null,
    'aria-haspopup': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'href'
      }],
      name: 'a'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'href'
      }],
      name: 'area'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'href'
      }],
      name: 'link'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command']]
};
var _default = linkRole;
exports["default"] = _default;

/***/ }),

/***/ 20353:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var listRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'menu'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'ol'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'ul'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['listitem']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = listRole;
exports["default"] = _default;

/***/ }),

/***/ 21300:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var listboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-expanded': null,
    'aria-invalid': null,
    'aria-multiselectable': null,
    'aria-readonly': null,
    'aria-required': null,
    'aria-orientation': 'vertical'
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['>1'],
        name: 'size'
      }, {
        name: 'multiple'
      }],
      name: 'select'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['>1'],
        name: 'size'
      }],
      name: 'select'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'multiple'
      }],
      name: 'select'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'datalist'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'list'
    },
    module: 'ARIA'
  }, {
    concept: {
      name: 'select'
    },
    module: 'XForms'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['option', 'group'], ['option']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
};
var _default = listboxRole;
exports["default"] = _default;

/***/ }),

/***/ 8288:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var listitemRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-level': null,
    'aria-posinset': null,
    'aria-setsize': null
  },
  relatedConcepts: [{
    concept: {
      constraints: ['direct descendant of ol, ul or menu'],
      name: 'li'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'item'
    },
    module: 'XForms'
  }],
  requireContextRole: ['directory', 'list'],
  requiredContextRole: ['directory', 'list'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = listitemRole;
exports["default"] = _default;

/***/ }),

/***/ 10503:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var logRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-live': 'polite'
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = logRole;
exports["default"] = _default;

/***/ }),

/***/ 14211:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mainRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'main'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = mainRole;
exports["default"] = _default;

/***/ }),

/***/ 67165:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var marqueeRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = marqueeRole;
exports["default"] = _default;

/***/ }),

/***/ 63400:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var mathRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'math'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = mathRole;
exports["default"] = _default;

/***/ }),

/***/ 65357:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var menuRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-orientation': 'vertical'
  },
  relatedConcepts: [{
    concept: {
      name: 'MENU'
    },
    module: 'JAPI'
  }, {
    concept: {
      name: 'list'
    },
    module: 'ARIA'
  }, {
    concept: {
      name: 'select'
    },
    module: 'XForms'
  }, {
    concept: {
      name: 'sidebar'
    },
    module: 'DTB'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['menuitem', 'group'], ['menuitemradio', 'group'], ['menuitemcheckbox', 'group'], ['menuitem'], ['menuitemcheckbox'], ['menuitemradio']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
};
var _default = menuRole;
exports["default"] = _default;

/***/ }),

/***/ 78926:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var menubarRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-orientation': 'horizontal'
  },
  relatedConcepts: [{
    concept: {
      name: 'toolbar'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['menuitem', 'group'], ['menuitemradio', 'group'], ['menuitemcheckbox', 'group'], ['menuitem'], ['menuitemcheckbox'], ['menuitemradio']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'select', 'menu'], ['roletype', 'structure', 'section', 'group', 'select', 'menu']]
};
var _default = menubarRole;
exports["default"] = _default;

/***/ }),

/***/ 96077:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var menuitemRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-posinset': null,
    'aria-setsize': null
  },
  relatedConcepts: [{
    concept: {
      name: 'MENU_ITEM'
    },
    module: 'JAPI'
  }, {
    concept: {
      name: 'listitem'
    },
    module: 'ARIA'
  }, {
    concept: {
      name: 'menuitem'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'option'
    },
    module: 'ARIA'
  }],
  requireContextRole: ['group', 'menu', 'menubar'],
  requiredContextRole: ['group', 'menu', 'menubar'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'command']]
};
var _default = menuitemRole;
exports["default"] = _default;

/***/ }),

/***/ 4332:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var menuitemcheckboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'menuitem'
    },
    module: 'ARIA'
  }],
  requireContextRole: ['group', 'menu', 'menubar'],
  requiredContextRole: ['group', 'menu', 'menubar'],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-checked': null
  },
  superClass: [['roletype', 'widget', 'input', 'checkbox'], ['roletype', 'widget', 'command', 'menuitem']]
};
var _default = menuitemcheckboxRole;
exports["default"] = _default;

/***/ }),

/***/ 5462:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var menuitemradioRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'menuitem'
    },
    module: 'ARIA'
  }],
  requireContextRole: ['group', 'menu', 'menubar'],
  requiredContextRole: ['group', 'menu', 'menubar'],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-checked': null
  },
  superClass: [['roletype', 'widget', 'input', 'checkbox', 'menuitemcheckbox'], ['roletype', 'widget', 'command', 'menuitem', 'menuitemcheckbox'], ['roletype', 'widget', 'input', 'radio']]
};
var _default = menuitemradioRole;
exports["default"] = _default;

/***/ }),

/***/ 10740:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var meterRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-valuetext': null,
    'aria-valuemax': '100',
    'aria-valuemin': '0'
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-valuenow': null
  },
  superClass: [['roletype', 'structure', 'range']]
};
var _default = meterRole;
exports["default"] = _default;

/***/ }),

/***/ 24772:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var navigationRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'nav'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = navigationRole;
exports["default"] = _default;

/***/ }),

/***/ 12109:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var noneRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: []
};
var _default = noneRole;
exports["default"] = _default;

/***/ }),

/***/ 15953:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var noteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = noteRole;
exports["default"] = _default;

/***/ }),

/***/ 72476:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var optionRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-checked': null,
    'aria-posinset': null,
    'aria-setsize': null,
    'aria-selected': 'false'
  },
  relatedConcepts: [{
    concept: {
      name: 'item'
    },
    module: 'XForms'
  }, {
    concept: {
      name: 'listitem'
    },
    module: 'ARIA'
  }, {
    concept: {
      name: 'option'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-selected': 'false'
  },
  superClass: [['roletype', 'widget', 'input']]
};
var _default = optionRole;
exports["default"] = _default;

/***/ }),

/***/ 16302:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var paragraphRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = paragraphRole;
exports["default"] = _default;

/***/ }),

/***/ 88757:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var presentationRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = presentationRole;
exports["default"] = _default;

/***/ }),

/***/ 91548:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var progressbarRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-valuetext': null
  },
  relatedConcepts: [{
    concept: {
      name: 'progress'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'status'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'range'], ['roletype', 'widget']]
};
var _default = progressbarRole;
exports["default"] = _default;

/***/ }),

/***/ 59538:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var radioRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-checked': null,
    'aria-posinset': null,
    'aria-setsize': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'type',
        value: 'radio'
      }],
      name: 'input'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-checked': null
  },
  superClass: [['roletype', 'widget', 'input']]
};
var _default = radioRole;
exports["default"] = _default;

/***/ }),

/***/ 2964:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var radiogroupRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-required': null
  },
  relatedConcepts: [{
    concept: {
      name: 'list'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['radio']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
};
var _default = radiogroupRole;
exports["default"] = _default;

/***/ }),

/***/ 36542:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var regionRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'aria-label'
      }],
      name: 'section'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['set'],
        name: 'aria-labelledby'
      }],
      name: 'section'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'Device Independence Glossart perceivable unit'
    }
  }, {
    concept: {
      name: 'frame'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = regionRole;
exports["default"] = _default;

/***/ }),

/***/ 86410:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var rowRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-colindex': null,
    'aria-expanded': null,
    'aria-level': null,
    'aria-posinset': null,
    'aria-rowindex': null,
    'aria-selected': null,
    'aria-setsize': null
  },
  relatedConcepts: [{
    concept: {
      name: 'tr'
    },
    module: 'HTML'
  }],
  requireContextRole: ['grid', 'rowgroup', 'table', 'treegrid'],
  requiredContextRole: ['grid', 'rowgroup', 'table', 'treegrid'],
  requiredOwnedElements: [['cell'], ['columnheader'], ['gridcell'], ['rowheader']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'group'], ['roletype', 'widget']]
};
var _default = rowRole;
exports["default"] = _default;

/***/ }),

/***/ 22386:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var rowgroupRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'tbody'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'tfoot'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'thead'
    },
    module: 'HTML'
  }],
  requireContextRole: ['grid', 'table', 'treegrid'],
  requiredContextRole: ['grid', 'table', 'treegrid'],
  requiredOwnedElements: [['row']],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = rowgroupRole;
exports["default"] = _default;

/***/ }),

/***/ 34773:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var rowheaderRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-sort': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'scope',
        value: 'row'
      }],
      name: 'th'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        name: 'scope',
        value: 'rowgroup'
      }],
      name: 'th'
    },
    module: 'HTML'
  }],
  requireContextRole: ['row', 'rowgroup'],
  requiredContextRole: ['row', 'rowgroup'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'cell'], ['roletype', 'structure', 'section', 'cell', 'gridcell'], ['roletype', 'widget', 'gridcell'], ['roletype', 'structure', 'sectionhead']]
};
var _default = rowheaderRole;
exports["default"] = _default;

/***/ }),

/***/ 87693:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var scrollbarRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-valuetext': null,
    'aria-orientation': 'vertical',
    'aria-valuemax': '100',
    'aria-valuemin': '0'
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-controls': null,
    'aria-valuenow': null
  },
  superClass: [['roletype', 'structure', 'range'], ['roletype', 'widget']]
};
var _default = scrollbarRole;
exports["default"] = _default;

/***/ }),

/***/ 26560:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var searchRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'landmark']]
};
var _default = searchRole;
exports["default"] = _default;

/***/ }),

/***/ 4573:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var searchboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'list'
      }, {
        name: 'type',
        value: 'search'
      }],
      name: 'input'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'input', 'textbox']]
};
var _default = searchboxRole;
exports["default"] = _default;

/***/ }),

/***/ 15026:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var separatorRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-orientation': 'horizontal',
    'aria-valuemax': '100',
    'aria-valuemin': '0',
    'aria-valuenow': null,
    'aria-valuetext': null
  },
  relatedConcepts: [{
    concept: {
      name: 'hr'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};
var _default = separatorRole;
exports["default"] = _default;

/***/ }),

/***/ 99644:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var sliderRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-haspopup': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-valuetext': null,
    'aria-orientation': 'horizontal',
    'aria-valuemax': '100',
    'aria-valuemin': '0'
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'type',
        value: 'range'
      }],
      name: 'input'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-valuenow': null
  },
  superClass: [['roletype', 'widget', 'input'], ['roletype', 'structure', 'range']]
};
var _default = sliderRole;
exports["default"] = _default;

/***/ }),

/***/ 5954:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var spinbuttonRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null,
    'aria-readonly': null,
    'aria-required': null,
    'aria-valuetext': null,
    'aria-valuenow': '0'
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: 'type',
        value: 'number'
      }],
      name: 'input'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite'], ['roletype', 'widget', 'input'], ['roletype', 'structure', 'range']]
};
var _default = spinbuttonRole;
exports["default"] = _default;

/***/ }),

/***/ 23977:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var statusRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-atomic': 'true',
    'aria-live': 'polite'
  },
  relatedConcepts: [{
    concept: {
      name: 'output'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = statusRole;
exports["default"] = _default;

/***/ }),

/***/ 86484:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var strongRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = strongRole;
exports["default"] = _default;

/***/ }),

/***/ 79727:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var subscriptRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = subscriptRole;
exports["default"] = _default;

/***/ }),

/***/ 26566:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var superscriptRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['prohibited'],
  prohibitedProps: ['aria-label', 'aria-labelledby'],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = superscriptRole;
exports["default"] = _default;

/***/ }),

/***/ 6248:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var switchRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'button'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-checked': null
  },
  superClass: [['roletype', 'widget', 'input', 'checkbox']]
};
var _default = switchRole;
exports["default"] = _default;

/***/ }),

/***/ 56767:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var tabRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-disabled': null,
    'aria-expanded': null,
    'aria-haspopup': null,
    'aria-posinset': null,
    'aria-setsize': null,
    'aria-selected': 'false'
  },
  relatedConcepts: [],
  requireContextRole: ['tablist'],
  requiredContextRole: ['tablist'],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'sectionhead'], ['roletype', 'widget']]
};
var _default = tabRole;
exports["default"] = _default;

/***/ }),

/***/ 5420:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var tableRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-colcount': null,
    'aria-rowcount': null
  },
  relatedConcepts: [{
    concept: {
      name: 'table'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['row'], ['row', 'rowgroup']],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = tableRole;
exports["default"] = _default;

/***/ }),

/***/ 80523:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var tablistRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-level': null,
    'aria-multiselectable': null,
    'aria-orientation': 'horizontal'
  },
  relatedConcepts: [{
    module: 'DAISY',
    concept: {
      name: 'guide'
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['tab']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite']]
};
var _default = tablistRole;
exports["default"] = _default;

/***/ }),

/***/ 33043:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var tabpanelRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = tabpanelRole;
exports["default"] = _default;

/***/ }),

/***/ 96567:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var termRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: 'dfn'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'dt'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = termRole;
exports["default"] = _default;

/***/ }),

/***/ 40046:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var textboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-activedescendant': null,
    'aria-autocomplete': null,
    'aria-errormessage': null,
    'aria-haspopup': null,
    'aria-invalid': null,
    'aria-multiline': null,
    'aria-placeholder': null,
    'aria-readonly': null,
    'aria-required': null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'type'
      }, {
        constraints: ['undefined'],
        name: 'list'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'list'
      }, {
        name: 'type',
        value: 'email'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'list'
      }, {
        name: 'type',
        value: 'tel'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'list'
      }, {
        name: 'type',
        value: 'text'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      attributes: [{
        constraints: ['undefined'],
        name: 'list'
      }, {
        name: 'type',
        value: 'url'
      }],
      name: 'input'
    },
    module: 'HTML'
  }, {
    concept: {
      name: 'input'
    },
    module: 'XForms'
  }, {
    concept: {
      name: 'textarea'
    },
    module: 'HTML'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'input']]
};
var _default = textboxRole;
exports["default"] = _default;

/***/ }),

/***/ 20292:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var timeRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = timeRole;
exports["default"] = _default;

/***/ }),

/***/ 69895:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var timerRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'status']]
};
var _default = timerRole;
exports["default"] = _default;

/***/ }),

/***/ 79182:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var toolbarRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-orientation': 'horizontal'
  },
  relatedConcepts: [{
    concept: {
      name: 'menubar'
    },
    module: 'ARIA'
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section', 'group']]
};
var _default = toolbarRole;
exports["default"] = _default;

/***/ }),

/***/ 42516:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var tooltipRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure', 'section']]
};
var _default = tooltipRole;
exports["default"] = _default;

/***/ }),

/***/ 27976:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var treeRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {
    'aria-errormessage': null,
    'aria-invalid': null,
    'aria-multiselectable': null,
    'aria-required': null,
    'aria-orientation': 'vertical'
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['treeitem', 'group'], ['treeitem']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'select'], ['roletype', 'structure', 'section', 'group', 'select']]
};
var _default = treeRole;
exports["default"] = _default;

/***/ }),

/***/ 39379:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var treegridRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author'],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [['row'], ['row', 'rowgroup']],
  requiredProps: {},
  superClass: [['roletype', 'widget', 'composite', 'grid'], ['roletype', 'structure', 'section', 'table', 'grid'], ['roletype', 'widget', 'composite', 'select', 'tree'], ['roletype', 'structure', 'section', 'group', 'select', 'tree']]
};
var _default = treegridRole;
exports["default"] = _default;

/***/ }),

/***/ 58532:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var treeitemRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ['author', 'contents'],
  prohibitedProps: [],
  props: {
    'aria-expanded': null,
    'aria-haspopup': null
  },
  relatedConcepts: [],
  requireContextRole: ['group', 'tree'],
  requiredContextRole: ['group', 'tree'],
  requiredOwnedElements: [],
  requiredProps: {
    'aria-selected': null
  },
  superClass: [['roletype', 'structure', 'section', 'listitem'], ['roletype', 'widget', 'input', 'option']]
};
var _default = treeitemRole;
exports["default"] = _default;

/***/ }),

/***/ 41516:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.uJ = exports.UN = exports.Qv = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var _ariaPropsMap = _interopRequireDefault(__webpack_require__(72256));
var _domMap = _interopRequireDefault(__webpack_require__(92607));
var _rolesMap = _interopRequireDefault(__webpack_require__(29312));
var _elementRoleMap = _interopRequireDefault(__webpack_require__(74490));
var _roleElementMap = _interopRequireDefault(__webpack_require__(52438));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var aria = _ariaPropsMap.default;
__webpack_unused_export__ = aria;
var dom = _domMap.default;
__webpack_unused_export__ = dom;
var roles = _rolesMap.default;
exports.uJ = roles;
var elementRoles = _elementRoleMap.default;
exports.Qv = elementRoles;
var roleElements = _roleElementMap.default;
exports.UN = roleElements;

/***/ }),

/***/ 52438:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _iterationDecorator = _interopRequireDefault(__webpack_require__(34818));
var _rolesMap = _interopRequireDefault(__webpack_require__(29312));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var roleElement = [];
var keys = _rolesMap.default.keys();
var _loop = function _loop(i) {
  var key = keys[i];
  var role = _rolesMap.default.get(key);
  if (role) {
    var concepts = [].concat(role.baseConcepts, role.relatedConcepts);
    for (var k = 0; k < concepts.length; k++) {
      var relation = concepts[k];
      if (relation.module === 'HTML') {
        var concept = relation.concept;
        if (concept) {
          var roleElementRelation = roleElement.find(function (item) {
            return item[0] === key;
          });
          var relationConcepts = void 0;
          if (roleElementRelation) {
            relationConcepts = roleElementRelation[1];
          } else {
            relationConcepts = [];
          }
          relationConcepts.push(concept);
          roleElement.push([key, relationConcepts]);
        }
      }
    }
  }
};
for (var i = 0; i < keys.length; i++) {
  _loop(i);
}
var roleElementMap = {
  entries: function entries() {
    return roleElement;
  },
  forEach: function forEach(fn) {
    var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _iterator = _createForOfIteratorHelper(roleElement),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          values = _step$value[1];
        fn.call(thisArg, values, key, roleElement);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  get: function get(key) {
    var item = roleElement.find(function (tuple) {
      return tuple[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!roleElementMap.get(key);
  },
  keys: function keys() {
    return roleElement.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key;
    });
  },
  values: function values() {
    return roleElement.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        values = _ref4[1];
      return values;
    });
  }
};
var _default = (0, _iterationDecorator.default)(roleElementMap, roleElementMap.entries());
exports["default"] = _default;

/***/ }),

/***/ 29312:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _ariaAbstractRoles = _interopRequireDefault(__webpack_require__(14690));
var _ariaLiteralRoles = _interopRequireDefault(__webpack_require__(58514));
var _ariaDpubRoles = _interopRequireDefault(__webpack_require__(61413));
var _ariaGraphicsRoles = _interopRequireDefault(__webpack_require__(20915));
var _iterationDecorator = _interopRequireDefault(__webpack_require__(34818));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var roles = [].concat(_ariaAbstractRoles.default, _ariaLiteralRoles.default, _ariaDpubRoles.default, _ariaGraphicsRoles.default);
roles.forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    roleDefinition = _ref2[1];
  // Conglomerate the properties
  var _iterator = _createForOfIteratorHelper(roleDefinition.superClass),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var superClassIter = _step.value;
      var _iterator2 = _createForOfIteratorHelper(superClassIter),
        _step2;
      try {
        var _loop = function _loop() {
          var superClassName = _step2.value;
          var superClassRoleTuple = roles.find(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 1),
              name = _ref4[0];
            return name === superClassName;
          });
          if (superClassRoleTuple) {
            var superClassDefinition = superClassRoleTuple[1];
            for (var _i2 = 0, _Object$keys = Object.keys(superClassDefinition.props); _i2 < _Object$keys.length; _i2++) {
              var prop = _Object$keys[_i2];
              if (
              // $FlowIssue Accessing the hasOwnProperty on the Object prototype is fine.
              !Object.prototype.hasOwnProperty.call(roleDefinition.props, prop)) {
                Object.assign(roleDefinition.props, _defineProperty({}, prop, superClassDefinition.props[prop]));
              }
            }
          }
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
});
var rolesMap = {
  entries: function entries() {
    return roles;
  },
  forEach: function forEach(fn) {
    var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var _iterator3 = _createForOfIteratorHelper(roles),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value = _slicedToArray(_step3.value, 2),
          key = _step3$value[0],
          values = _step3$value[1];
        fn.call(thisArg, values, key, roles);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  },
  get: function get(key) {
    var item = roles.find(function (tuple) {
      return tuple[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!rolesMap.get(key);
  },
  keys: function keys() {
    return roles.map(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 1),
        key = _ref6[0];
      return key;
    });
  },
  values: function values() {
    return roles.map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
        values = _ref8[1];
      return values;
    });
  }
};
var _default = (0, _iterationDecorator.default)(rolesMap, rolesMap.entries());
exports["default"] = _default;

/***/ }),

/***/ 34818:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = iterationDecorator;
var _iteratorProxy = _interopRequireDefault(__webpack_require__(91101));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function iterationDecorator(collection, entries) {
  if (typeof Symbol === 'function' && _typeof(Symbol.iterator) === 'symbol') {
    Object.defineProperty(collection, Symbol.iterator, {
      value: _iteratorProxy.default.bind(entries)
    });
  }
  return collection;
}

/***/ }),

/***/ 91101:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

// eslint-disable-next-line no-unused-vars
function iteratorProxy() {
  var values = this;
  var index = 0;
  var iter = {
    '@@iterator': function iterator() {
      return iter;
    },
    next: function next() {
      if (index < values.length) {
        var value = values[index];
        index = index + 1;
        return {
          done: false,
          value: value
        };
      } else {
        return {
          done: true
        };
      }
    }
  };
  return iter;
}
var _default = iteratorProxy;
exports["default"] = _default;

/***/ }),

/***/ 4562:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__(42898);
var callBound = __webpack_require__(47737);
var flags = __webpack_require__(81861);
var GetIntrinsic = __webpack_require__(91528);
var getIterator = __webpack_require__(73607);
var getSideChannel = __webpack_require__(62538);
var is = __webpack_require__(10884);
var isArguments = __webpack_require__(14043);
var isArray = __webpack_require__(79930);
var isArrayBuffer = __webpack_require__(12026);
var isDate = __webpack_require__(464);
var isRegex = __webpack_require__(67584);
var isSharedArrayBuffer = __webpack_require__(25178);
var objectKeys = __webpack_require__(13438);
var whichBoxedPrimitive = __webpack_require__(14062);
var whichCollection = __webpack_require__(8121);
var whichTypedArray = __webpack_require__(49154);
var byteLength = __webpack_require__(83366);

var sabByteLength = callBound('SharedArrayBuffer.prototype.byteLength', true);

var $getTime = callBound('Date.prototype.getTime');
var gPO = Object.getPrototypeOf;
var $objToString = callBound('Object.prototype.toString');

var $Set = GetIntrinsic('%Set%', true);
var $mapHas = callBound('Map.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSize = callBound('Map.prototype.size', true);
var $setAdd = callBound('Set.prototype.add', true);
var $setDelete = callBound('Set.prototype.delete', true);
var $setHas = callBound('Set.prototype.has', true);
var $setSize = callBound('Set.prototype.size', true);

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L401-L414
function setHasEqualElement(set, val1, opts, channel) {
  var i = getIterator(set);
  var result;
  while ((result = i.next()) && !result.done) {
    if (internalDeepEqual(val1, result.value, opts, channel)) { // eslint-disable-line no-use-before-define
      // Remove the matching element to make sure we do not check that again.
      $setDelete(set, result.value);
      return true;
    }
  }

  return false;
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L416-L439
function findLooseMatchingPrimitives(prim) {
  if (typeof prim === 'undefined') {
    return null;
  }
  if (typeof prim === 'object') { // Only pass in null as object!
    return void 0;
  }
  if (typeof prim === 'symbol') {
    return false;
  }
  if (typeof prim === 'string' || typeof prim === 'number') {
    // Loose equal entries exist only if the string is possible to convert to a regular number and not NaN.
    return +prim === +prim; // eslint-disable-line no-implicit-coercion
  }
  return true;
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L449-L460
function mapMightHaveLoosePrim(a, b, prim, item, opts, channel) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }
  var curB = $mapGet(b, altValue);
  var looseOpts = assign({}, opts, { strict: false });
  if (
    (typeof curB === 'undefined' && !$mapHas(b, altValue))
    // eslint-disable-next-line no-use-before-define
    || !internalDeepEqual(item, curB, looseOpts, channel)
  ) {
    return false;
  }
  // eslint-disable-next-line no-use-before-define
  return !$mapHas(a, altValue) && internalDeepEqual(item, curB, looseOpts, channel);
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L441-L447
function setMightHaveLoosePrim(a, b, prim) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }

  return $setHas(b, altValue) && !$setHas(a, altValue);
}

// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L518-L533
function mapHasEqualEntry(set, map, key1, item1, opts, channel) {
  var i = getIterator(set);
  var result;
  var key2;
  while ((result = i.next()) && !result.done) {
    key2 = result.value;
    if (
      // eslint-disable-next-line no-use-before-define
      internalDeepEqual(key1, key2, opts, channel)
      // eslint-disable-next-line no-use-before-define
      && internalDeepEqual(item1, $mapGet(map, key2), opts, channel)
    ) {
      $setDelete(set, key2);
      return true;
    }
  }

  return false;
}

function internalDeepEqual(actual, expected, options, channel) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  var actualBoxed = whichBoxedPrimitive(actual);
  var expectedBoxed = whichBoxedPrimitive(expected);
  if (actualBoxed !== expectedBoxed) {
    return false;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected; // eslint-disable-line eqeqeq
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // see https://github.com/nodejs/node/commit/d3aafd02efd3a403d646a3044adcf14e63a88d32 for memos/channel inspiration

  var hasActual = channel.has(actual);
  var hasExpected = channel.has(expected);
  var sentinel;
  if (hasActual && hasExpected) {
    if (channel.get(actual) === channel.get(expected)) {
      return true;
    }
  } else {
    sentinel = {};
  }
  if (!hasActual) { channel.set(actual, sentinel); }
  if (!hasExpected) { channel.set(expected, sentinel); }

  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts, channel);
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }

  return !!(x.constructor && x.constructor.isBuffer && x.constructor.isBuffer(x));
}

function setEquiv(a, b, opts, channel) {
  if ($setSize(a) !== $setSize(b)) {
    return false;
  }
  var iA = getIterator(a);
  var iB = getIterator(b);
  var resultA;
  var resultB;
  var set;
  while ((resultA = iA.next()) && !resultA.done) {
    if (resultA.value && typeof resultA.value === 'object') {
      if (!set) { set = new $Set(); }
      $setAdd(set, resultA.value);
    } else if (!$setHas(b, resultA.value)) {
      if (opts.strict) { return false; }
      if (!setMightHaveLoosePrim(a, b, resultA.value)) {
        return false;
      }
      if (!set) { set = new $Set(); }
      $setAdd(set, resultA.value);
    }
  }
  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      // We have to check if a primitive value is already matching and only if it's not, go hunting for it.
      if (resultB.value && typeof resultB.value === 'object') {
        if (!setHasEqualElement(set, resultB.value, opts.strict, channel)) {
          return false;
        }
      } else if (
        !opts.strict
        && !$setHas(a, resultB.value)
        && !setHasEqualElement(set, resultB.value, opts.strict, channel)
      ) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}

function mapEquiv(a, b, opts, channel) {
  if ($mapSize(a) !== $mapSize(b)) {
    return false;
  }
  var iA = getIterator(a);
  var iB = getIterator(b);
  var resultA;
  var resultB;
  var set;
  var key;
  var item1;
  var item2;
  while ((resultA = iA.next()) && !resultA.done) {
    key = resultA.value[0];
    item1 = resultA.value[1];
    if (key && typeof key === 'object') {
      if (!set) { set = new $Set(); }
      $setAdd(set, key);
    } else {
      item2 = $mapGet(b, key);
      if ((typeof item2 === 'undefined' && !$mapHas(b, key)) || !internalDeepEqual(item1, item2, opts, channel)) {
        if (opts.strict) {
          return false;
        }
        if (!mapMightHaveLoosePrim(a, b, key, item1, opts, channel)) {
          return false;
        }
        if (!set) { set = new $Set(); }
        $setAdd(set, key);
      }
    }
  }

  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      key = resultB.value[0];
      item2 = resultB.value[1];
      if (key && typeof key === 'object') {
        if (!mapHasEqualEntry(set, a, key, item2, opts, channel)) {
          return false;
        }
      } else if (
        !opts.strict
        && (!a.has(key) || !internalDeepEqual($mapGet(a, key), item2, opts, channel))
        && !mapHasEqualEntry(set, a, key, item2, assign({}, opts, { strict: false }), channel)
      ) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}

function objEquiv(a, b, opts, channel) {
  /* eslint max-statements: [2, 100], max-lines-per-function: [2, 120], max-depth: [2, 5], max-lines: [2, 400] */
  var i, key;

  if (typeof a !== typeof b) { return false; }
  if (a == null || b == null) { return false; }

  if ($objToString(a) !== $objToString(b)) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsArray = isArray(a);
  var bIsArray = isArray(b);
  if (aIsArray !== bIsArray) { return false; }

  // TODO: replace when a cross-realm brand check is available
  var aIsError = a instanceof Error;
  var bIsError = b instanceof Error;
  if (aIsError !== bIsError) { return false; }
  if (aIsError || bIsError) {
    if (a.name !== b.name || a.message !== b.message) { return false; }
  }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if ((aIsRegex || bIsRegex) && (a.source !== b.source || flags(a) !== flags(b))) {
    return false;
  }

  var aIsDate = isDate(a);
  var bIsDate = isDate(b);
  if (aIsDate !== bIsDate) { return false; }
  if (aIsDate || bIsDate) { // && would work too, because both are true or both false here
    if ($getTime(a) !== $getTime(b)) { return false; }
  }
  if (opts.strict && gPO && gPO(a) !== gPO(b)) { return false; }

  var aWhich = whichTypedArray(a);
  var bWhich = whichTypedArray(b);
  if (aWhich !== bWhich) {
    return false;
  }
  if (aWhich || bWhich) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  var aIsArrayBuffer = isArrayBuffer(a);
  var bIsArrayBuffer = isArrayBuffer(b);
  if (aIsArrayBuffer !== bIsArrayBuffer) { return false; }
  if (aIsArrayBuffer || bIsArrayBuffer) { // && would work too, because both are true or both false here
    if (byteLength(a) !== byteLength(b)) { return false; }
    return typeof Uint8Array === 'function' && internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
  }

  var aIsSAB = isSharedArrayBuffer(a);
  var bIsSAB = isSharedArrayBuffer(b);
  if (aIsSAB !== bIsSAB) { return false; }
  if (aIsSAB || bIsSAB) { // && would work too, because both are true or both false here
    if (sabByteLength(a) !== sabByteLength(b)) { return false; }
    return typeof Uint8Array === 'function' && internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
  }

  if (typeof a !== typeof b) { return false; }

  var ka = objectKeys(a);
  var kb = objectKeys(b);
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; } // eslint-disable-line eqeqeq
  }

  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!internalDeepEqual(a[key], b[key], opts, channel)) { return false; }
  }

  var aCollection = whichCollection(a);
  var bCollection = whichCollection(b);
  if (aCollection !== bCollection) {
    return false;
  }
  if (aCollection === 'Set' || bCollection === 'Set') { // aCollection === bCollection
    return setEquiv(a, b, opts, channel);
  }
  if (aCollection === 'Map') { // aCollection === bCollection
    return mapEquiv(a, b, opts, channel);
  }

  return true;
}

module.exports = function deepEqual(a, b, opts) {
  return internalDeepEqual(a, b, opts, getSideChannel());
};


/***/ }),

/***/ 83366:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(47737);
var $byteLength = callBound('ArrayBuffer.prototype.byteLength', true);

var isArrayBuffer = __webpack_require__(12026);

module.exports = function byteLength(ab) {
	if (!isArrayBuffer(ab)) {
		return NaN;
	}
	return $byteLength ? $byteLength(ab) : ab.byteLength;
}; // in node < 0.11, byteLength is an own nonconfigurable property


/***/ }),

/***/ 55277:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 75291:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(55277)
var ieee754 = __webpack_require__(2608)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

var K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 47737:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(91528);

var callBind = __webpack_require__(73235);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ 73235:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(37156);
var GetIntrinsic = __webpack_require__(91528);
var setFunctionLength = __webpack_require__(1744);

var $TypeError = GetIntrinsic('%TypeError%');
var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	if (typeof originalFunction !== 'function') {
		throw new $TypeError('a function is required');
	}
	var func = $reflectApply(bind, $call, arguments);
	return setFunctionLength(
		func,
		1 + $max(0, originalFunction.length - (arguments.length - 1)),
		true
	);
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ 27892:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasPropertyDescriptors = __webpack_require__(42320)();

var GetIntrinsic = __webpack_require__(91528);

var $defineProperty = hasPropertyDescriptors && GetIntrinsic('%Object.defineProperty%', true);
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

var $SyntaxError = GetIntrinsic('%SyntaxError%');
var $TypeError = GetIntrinsic('%TypeError%');

var gopd = __webpack_require__(41455);

/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};


/***/ }),

/***/ 26506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(13438);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = __webpack_require__(27892);

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var supportsDescriptors = __webpack_require__(42320)();

var defineProperty = function (object, name, value, predicate) {
	if (name in object) {
		if (predicate === true) {
			if (object[name] === value) {
				return;
			}
		} else if (!isFunction(predicate) || !predicate()) {
			return;
		}
	}

	if (supportsDescriptors) {
		defineDataProperty(object, name, value, true);
	} else {
		defineDataProperty(object, name, value);
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),

/***/ 93964:
/***/ (function(module) {

!function(t,n){ true?module.exports=function(t,n,e,i,o){for(n=n.split?n.split("."):n,i=0;i<n.length;i++)t=t?t[n[i]]:o;return t===o?e:t}:0}(this);
//# sourceMappingURL=dlv.umd.js.map


/***/ }),

/***/ 77025:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__(43765);

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;


/***/ }),

/***/ 62521:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 37156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(62521);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 34019:
/***/ (function(module) {

"use strict";


var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) {
	try {
		gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	if (!functionsHaveNames() || !gOPD) {
		return false;
	}
	var desc = gOPD(function () {}, 'name');
	return !!desc && !!desc.configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

module.exports = functionsHaveNames;


/***/ }),

/***/ 91528:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(10465)();
var hasProto = __webpack_require__(91209)();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(37156);
var hasOwn = __webpack_require__(35673);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 41455:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(91528);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 17155:
/***/ (function(module) {

"use strict";


var $BigInt = typeof BigInt !== 'undefined' && BigInt;

module.exports = function hasNativeBigInts() {
	return typeof $BigInt === 'function'
		&& typeof BigInt === 'function'
		&& typeof $BigInt(42) === 'bigint' // eslint-disable-line no-magic-numbers
		&& typeof BigInt(42) === 'bigint'; // eslint-disable-line no-magic-numbers
};


/***/ }),

/***/ 42320:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(91528);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),

/***/ 91209:
/***/ (function(module) {

"use strict";


var test = {
	foo: {}
};

var $Object = Object;

module.exports = function hasProto() {
	return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
};


/***/ }),

/***/ 10465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(16073);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 16073:
/***/ (function(module) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 76686:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(16073);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),

/***/ 35673:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(37156);

/** @type {(o: {}, p: PropertyKey) => p is keyof o} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 86058:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(81508);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 94883:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 81508:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(94883);
} else {}


/***/ }),

/***/ 2608:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 22111:
/***/ (function(module) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ 86154:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(91528);
var hasOwn = __webpack_require__(35673);
var channel = __webpack_require__(62538)();

var $TypeError = GetIntrinsic('%TypeError%');

var SLOT = {
	assert: function (O, slot) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		channel.assert(O);
		if (!SLOT.has(O, slot)) {
			throw new $TypeError('`' + slot + '` is not present on `O`');
		}
	},
	get: function (O, slot) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		var slots = channel.get(O);
		return slots && slots['$' + slot];
	},
	has: function (O, slot) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		var slots = channel.get(O);
		return !!slots && hasOwn(slots, '$' + slot);
	},
	set: function (O, slot, V) {
		if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
			throw new $TypeError('`O` is not an object');
		}
		if (typeof slot !== 'string') {
			throw new $TypeError('`slot` must be a string');
		}
		var slots = channel.get(O);
		if (!slots) {
			slots = {};
			channel.set(O, slots);
		}
		slots['$' + slot] = V;
	}
};

if (Object.freeze) {
	Object.freeze(SLOT);
}

module.exports = SLOT;


/***/ }),

/***/ 14043:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(76686)();
var callBound = __webpack_require__(47737);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),

/***/ 12026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(73235);
var callBound = __webpack_require__(47737);
var GetIntrinsic = __webpack_require__(91528);
var isTypedArray = __webpack_require__(36421);

var $ArrayBuffer = GetIntrinsic('ArrayBuffer', true);
var $Float32Array = GetIntrinsic('Float32Array', true);
var $byteLength = callBound('ArrayBuffer.prototype.byteLength', true);

// in node 0.10, ArrayBuffers have no prototype methods, but have an own slot-checking `slice` method
var abSlice = $ArrayBuffer && !$byteLength && new $ArrayBuffer().slice;
var $abSlice = abSlice && callBind(abSlice);

module.exports = $byteLength || $abSlice
	? function isArrayBuffer(obj) {
		if (!obj || typeof obj !== 'object') {
			return false;
		}
		try {
			if ($byteLength) {
				$byteLength(obj);
			} else {
				$abSlice(obj, 0);
			}
			return true;
		} catch (e) {
			return false;
		}
	}
	: $Float32Array
		// in node 0.8, ArrayBuffers have no prototype or own methods
		? function IsArrayBuffer(obj) {
			try {
				return (new $Float32Array(obj)).buffer === obj && !isTypedArray(obj);
			} catch (e) {
				return typeof obj === 'object' && e.name === 'RangeError';
			}
		}
		: function isArrayBuffer(obj) { // eslint-disable-line no-unused-vars
			return false;
		};


/***/ }),

/***/ 84155:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var hasBigInts = __webpack_require__(17155)();

if (hasBigInts) {
	var bigIntValueOf = BigInt.prototype.valueOf;
	var tryBigInt = function tryBigIntObject(value) {
		try {
			bigIntValueOf.call(value);
			return true;
		} catch (e) {
		}
		return false;
	};

	module.exports = function isBigInt(value) {
		if (
			value === null
			|| typeof value === 'undefined'
			|| typeof value === 'boolean'
			|| typeof value === 'string'
			|| typeof value === 'number'
			|| typeof value === 'symbol'
			|| typeof value === 'function'
		) {
			return false;
		}
		if (typeof value === 'bigint') {
			return true;
		}

		return tryBigInt(value);
	};
} else {
	module.exports = function isBigInt(value) {
		return  false && 0;
	};
}


/***/ }),

/***/ 4836:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(47737);
var $boolToStr = callBound('Boolean.prototype.toString');
var $toString = callBound('Object.prototype.toString');

var tryBooleanObject = function booleanBrandCheck(value) {
	try {
		$boolToStr(value);
		return true;
	} catch (e) {
		return false;
	}
};
var boolClass = '[object Boolean]';
var hasToStringTag = __webpack_require__(76686)();

module.exports = function isBoolean(value) {
	if (typeof value === 'boolean') {
		return true;
	}
	if (value === null || typeof value !== 'object') {
		return false;
	}
	return hasToStringTag && Symbol.toStringTag in value ? tryBooleanObject(value) : $toString(value) === boolClass;
};


/***/ }),

/***/ 43765:
/***/ (function(module) {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var isDDA = function isDocumentDotAll() { return false; };
if (typeof document === 'object') {
	// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
	var all = document.all;
	if (toStr.call(all) === toStr.call(document.all)) {
		isDDA = function isDocumentDotAll(value) {
			/* globals document: false */
			// in IE 6-8, typeof document.all is "object" and it's truthy
			if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
				try {
					var str = toStr.call(value);
					return (
						str === ddaClass
						|| str === ddaClass2
						|| str === ddaClass3 // opera 12.16
						|| str === objectClass // IE 6-8
					) && value('') == null; // eslint-disable-line eqeqeq
				} catch (e) { /**/ }
			}
			return false;
		};
	}
}

module.exports = reflectApply
	? function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value) && tryFunctionObject(value);
	}
	: function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
		return tryFunctionObject(value);
	};


/***/ }),

/***/ 464:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__(76686)();

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),

/***/ 81859:
/***/ (function(module) {

"use strict";


var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;

var exported;

if (!$Map) {
	// eslint-disable-next-line no-unused-vars
	exported = function isMap(x) {
		// `Map` is not present in this environment.
		return false;
	};
}

var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$mapHas) {
	// eslint-disable-next-line no-unused-vars
	exported = function isMap(x) {
		// `Map` does not have a `has` method
		return false;
	};
}

module.exports = exported || function isMap(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$mapHas.call(x);
		if ($setHas) {
			try {
				$setHas.call(x);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $Map; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};


/***/ }),

/***/ 28038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var numToStr = Number.prototype.toString;
var tryNumberObject = function tryNumberObject(value) {
	try {
		numToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var numClass = '[object Number]';
var hasToStringTag = __webpack_require__(76686)();

module.exports = function isNumberObject(value) {
	if (typeof value === 'number') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag ? tryNumberObject(value) : toStr.call(value) === numClass;
};


/***/ }),

/***/ 13382:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isPlainObject(o) {
  var ctor,prot;

  if (isObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (ctor === undefined) return true;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
}

exports.isPlainObject = isPlainObject;


/***/ }),

/***/ 67584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(47737);
var hasToStringTag = __webpack_require__(76686)();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};


/***/ }),

/***/ 96109:
/***/ (function(module) {

"use strict";


var $Map = typeof Map === 'function' && Map.prototype ? Map : null;
var $Set = typeof Set === 'function' && Set.prototype ? Set : null;

var exported;

if (!$Set) {
	// eslint-disable-next-line no-unused-vars
	exported = function isSet(x) {
		// `Set` is not present in this environment.
		return false;
	};
}

var $mapHas = $Map ? Map.prototype.has : null;
var $setHas = $Set ? Set.prototype.has : null;
if (!exported && !$setHas) {
	// eslint-disable-next-line no-unused-vars
	exported = function isSet(x) {
		// `Set` does not have a `has` method
		return false;
	};
}

module.exports = exported || function isSet(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$setHas.call(x);
		if ($mapHas) {
			try {
				$mapHas.call(x);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $Set; // core-js workaround, pre-v2.5.0
	} catch (e) {}
	return false;
};


/***/ }),

/***/ 25178:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(47737);

var $byteLength = callBound('SharedArrayBuffer.prototype.byteLength', true);

module.exports = $byteLength
	? function isSharedArrayBuffer(obj) {
		if (!obj || typeof obj !== 'object') {
			return false;
		}
		try {
			$byteLength(obj);
			return true;
		} catch (e) {
			return false;
		}
	}
	: function isSharedArrayBuffer(obj) { // eslint-disable-line no-unused-vars
		return false;
	};


/***/ }),

/***/ 91770:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject(value) {
	try {
		strValue.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var strClass = '[object String]';
var hasToStringTag = __webpack_require__(76686)();

module.exports = function isString(value) {
	if (typeof value === 'string') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
};


/***/ }),

/***/ 44582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = __webpack_require__(10465)();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return  false && 0;
	};
}


/***/ }),

/***/ 36421:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var whichTypedArray = __webpack_require__(49154);

module.exports = function isTypedArray(value) {
	return !!whichTypedArray(value);
};


/***/ }),

/***/ 36959:
/***/ (function(module) {

"use strict";


var $WeakMap = typeof WeakMap === 'function' && WeakMap.prototype ? WeakMap : null;
var $WeakSet = typeof WeakSet === 'function' && WeakSet.prototype ? WeakSet : null;

var exported;

if (!$WeakMap) {
	// eslint-disable-next-line no-unused-vars
	exported = function isWeakMap(x) {
		// `WeakMap` is not present in this environment.
		return false;
	};
}

var $mapHas = $WeakMap ? $WeakMap.prototype.has : null;
var $setHas = $WeakSet ? $WeakSet.prototype.has : null;
if (!exported && !$mapHas) {
	// eslint-disable-next-line no-unused-vars
	exported = function isWeakMap(x) {
		// `WeakMap` does not have a `has` method
		return false;
	};
}

module.exports = exported || function isWeakMap(x) {
	if (!x || typeof x !== 'object') {
		return false;
	}
	try {
		$mapHas.call(x, $mapHas);
		if ($setHas) {
			try {
				$setHas.call(x, $setHas);
			} catch (e) {
				return true;
			}
		}
		return x instanceof $WeakMap; // core-js workaround, pre-v3
	} catch (e) {}
	return false;
};


/***/ }),

/***/ 92683:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(91528);
var callBound = __webpack_require__(47737);

var $WeakSet = GetIntrinsic('%WeakSet%', true);

var $setHas = callBound('WeakSet.prototype.has', true);

if ($setHas) {
	var $mapHas = callBound('WeakMap.prototype.has', true);

	module.exports = function isWeakSet(x) {
		if (!x || typeof x !== 'object') {
			return false;
		}
		try {
			$setHas(x, $setHas);
			if ($mapHas) {
				try {
					$mapHas(x, $mapHas);
				} catch (e) {
					return true;
				}
			}
			return x instanceof $WeakSet; // core-js workaround, pre-v3
		} catch (e) {}
		return false;
	};
} else {
	// eslint-disable-next-line no-unused-vars
	module.exports = function isWeakSet(x) {
		// `WeakSet` does not exist, or does not have a `has` method
		return false;
	};
}


/***/ }),

/***/ 79930:
/***/ (function(module) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 49189:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 72976:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root) {/*global exports, Intl*/
/**
 * This script gives you the zone info key representing your device's time zone setting.
 *
 * @name jsTimezoneDetect
 * @version 1.0.6
 * @author Jon Nylander
 * @license MIT License - https://bitbucket.org/pellepim/jstimezonedetect/src/default/LICENCE.txt
 *
 * For usage and examples, visit:
 * http://pellepim.bitbucket.org/jstz/
 *
 * Copyright (c) Jon Nylander
 */


/**
 * Namespace to hold all the code for timezone detection.
 */
var jstz = (function () {
    'use strict';
    var HEMISPHERE_SOUTH = 's',

        consts = {
            DAY: 86400000,
            HOUR: 3600000,
            MINUTE: 60000,
            SECOND: 1000,
            BASELINE_YEAR: 2014,
            MAX_SCORE: 864000000, // 10 days
            AMBIGUITIES: {
                'America/Denver':       ['America/Mazatlan'],
                'Europe/London':        ['Africa/Casablanca'],
                'America/Chicago':      ['America/Mexico_City'],
                'America/Asuncion':     ['America/Campo_Grande', 'America/Santiago'],
                'America/Montevideo':   ['America/Sao_Paulo', 'America/Santiago'],
                // Europe/Minsk should not be in this list... but Windows.
                'Asia/Beirut':          ['Asia/Amman', 'Asia/Jerusalem', 'Europe/Helsinki', 'Asia/Damascus', 'Africa/Cairo', 'Asia/Gaza', 'Europe/Minsk'],
                'Pacific/Auckland':     ['Pacific/Fiji'],
                'America/Los_Angeles':  ['America/Santa_Isabel'],
                'America/New_York':     ['America/Havana'],
                'America/Halifax':      ['America/Goose_Bay'],
                'America/Godthab':      ['America/Miquelon'],
                'Asia/Dubai':           ['Asia/Yerevan'],
                'Asia/Jakarta':         ['Asia/Krasnoyarsk'],
                'Asia/Shanghai':        ['Asia/Irkutsk', 'Australia/Perth'],
                'Australia/Sydney':     ['Australia/Lord_Howe'],
                'Asia/Tokyo':           ['Asia/Yakutsk'],
                'Asia/Dhaka':           ['Asia/Omsk'],
                // In the real world Yerevan is not ambigous for Baku... but Windows.
                'Asia/Baku':            ['Asia/Yerevan'],
                'Australia/Brisbane':   ['Asia/Vladivostok'],
                'Pacific/Noumea':       ['Asia/Vladivostok'],
                'Pacific/Majuro':       ['Asia/Kamchatka', 'Pacific/Fiji'],
                'Pacific/Tongatapu':    ['Pacific/Apia'],
                'Asia/Baghdad':         ['Europe/Minsk', 'Europe/Moscow'],
                'Asia/Karachi':         ['Asia/Yekaterinburg'],
                'Africa/Johannesburg':  ['Asia/Gaza', 'Africa/Cairo']
            }
        },

        /**
         * Gets the offset in minutes from UTC for a certain date.
         * @param {Date} date
         * @returns {Number}
         */
        get_date_offset = function get_date_offset(date) {
            var offset = -date.getTimezoneOffset();
            return (offset !== null ? offset : 0);
        },

        /**
         * This function does some basic calculations to create information about
         * the user's timezone. It uses REFERENCE_YEAR as a solid year for which
         * the script has been tested rather than depend on the year set by the
         * client device.
         *
         * Returns a key that can be used to do lookups in jstz.olson.timezones.
         * eg: "720,1,2".
         *
         * @returns {String}
         */
        lookup_key = function lookup_key() {
            var january_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 0, 2)),
                june_offset = get_date_offset(new Date(consts.BASELINE_YEAR, 5, 2)),
                diff = january_offset - june_offset;

            if (diff < 0) {
                return january_offset + ",1";
            } else if (diff > 0) {
                return june_offset + ",1," + HEMISPHERE_SOUTH;
            }

            return january_offset + ",0";
        },


        /**
         * Tries to get the time zone key directly from the operating system for those
         * environments that support the ECMAScript Internationalization API.
         */
        get_from_internationalization_api = function get_from_internationalization_api() {
            var format, timezone;
            if (typeof Intl === "undefined" || typeof Intl.DateTimeFormat === "undefined") {
                return;
            }
            format = Intl.DateTimeFormat();
            if (typeof format === "undefined" || typeof format.resolvedOptions === "undefined") {
                return;
            }
            timezone = format.resolvedOptions().timeZone;
            if (timezone && (timezone.indexOf("/") > -1 || timezone === 'UTC') && timezone.indexOf("Etc") != 0) {
                return timezone;
            }
        },

        /**
         * Starting point for getting all the DST rules for a specific year
         * for the current timezone (as described by the client system).
         *
         * Returns an object with start and end attributes, or false if no
         * DST rules were found for the year.
         *
         * @param year
         * @returns {Object} || {Boolean}
         */
        dst_dates = function dst_dates(year) {
            var yearstart = new Date(year, 0, 1, 0, 0, 1, 0).getTime();
            var yearend = new Date(year, 12, 31, 23, 59, 59).getTime();
            var current = yearstart;
            var offset = (new Date(current)).getTimezoneOffset();
            var dst_start = null;
            var dst_end = null;

            while (current < yearend - 86400000) {
                var dateToCheck = new Date(current);
                var dateToCheckOffset = dateToCheck.getTimezoneOffset();

                if (dateToCheckOffset !== offset) {
                    if (dateToCheckOffset < offset) {
                        dst_start = dateToCheck;
                    }
                    if (dateToCheckOffset > offset) {
                        dst_end = dateToCheck;
                    }
                    offset = dateToCheckOffset;
                }

                current += 86400000;
            }

            if (dst_start && dst_end) {
                return {
                    s: find_dst_fold(dst_start).getTime(),
                    e: find_dst_fold(dst_end).getTime()
                };
            }

            return false;
        },

        /**
         * Probably completely unnecessary function that recursively finds the
         * exact (to the second) time when a DST rule was changed.
         *
         * @param a_date - The candidate Date.
         * @param padding - integer specifying the padding to allow around the candidate
         *                  date for finding the fold.
         * @param iterator - integer specifying how many milliseconds to iterate while
         *                   searching for the fold.
         *
         * @returns {Date}
         */
        find_dst_fold = function find_dst_fold(a_date, padding, iterator) {
            if (typeof padding === 'undefined') {
                padding = consts.DAY;
                iterator = consts.HOUR;
            }

            var date_start = new Date(a_date.getTime() - padding).getTime();
            var date_end = a_date.getTime() + padding;
            var offset = new Date(date_start).getTimezoneOffset();

            var current = date_start;

            var dst_change = null;
            while (current < date_end - iterator) {
                var dateToCheck = new Date(current);
                var dateToCheckOffset = dateToCheck.getTimezoneOffset();

                if (dateToCheckOffset !== offset) {
                    dst_change = dateToCheck;
                    break;
                }
                current += iterator;
            }

            if (padding === consts.DAY) {
                return find_dst_fold(dst_change, consts.HOUR, consts.MINUTE);
            }

            if (padding === consts.HOUR) {
                return find_dst_fold(dst_change, consts.MINUTE, consts.SECOND);
            }

            return dst_change;
        },

        windows7_adaptations = function windows7_adaptions(rule_list, preliminary_timezone, score, sample) {
            if (score !== 'N/A') {
                return score;
            }
            if (preliminary_timezone === 'Asia/Beirut') {
                if (sample.name === 'Africa/Cairo') {
                    if (rule_list[6].s === 1398376800000 && rule_list[6].e === 1411678800000) {
                        return 0;
                    }
                }
                if (sample.name === 'Asia/Jerusalem') {
                    if (rule_list[6].s === 1395964800000 && rule_list[6].e === 1411858800000) {
                        return 0;
                }
            }
            } else if (preliminary_timezone === 'America/Santiago') {
                if (sample.name === 'America/Asuncion') {
                    if (rule_list[6].s === 1412481600000 && rule_list[6].e === 1397358000000) {
                        return 0;
                    }
                }
                if (sample.name === 'America/Campo_Grande') {
                    if (rule_list[6].s === 1413691200000 && rule_list[6].e === 1392519600000) {
                        return 0;
                    }
                }
            } else if (preliminary_timezone === 'America/Montevideo') {
                if (sample.name === 'America/Sao_Paulo') {
                    if (rule_list[6].s === 1413687600000 && rule_list[6].e === 1392516000000) {
                        return 0;
                    }
                }
            } else if (preliminary_timezone === 'Pacific/Auckland') {
                if (sample.name === 'Pacific/Fiji') {
                    if (rule_list[6].s === 1414245600000 && rule_list[6].e === 1396101600000) {
                        return 0;
                    }
                }
            }

            return score;
        },

        /**
         * Takes the DST rules for the current timezone, and proceeds to find matches
         * in the jstz.olson.dst_rules.zones array.
         *
         * Compares samples to the current timezone on a scoring basis.
         *
         * Candidates are ruled immediately if either the candidate or the current zone
         * has a DST rule where the other does not.
         *
         * Candidates are ruled out immediately if the current zone has a rule that is
         * outside the DST scope of the candidate.
         *
         * Candidates are included for scoring if the current zones rules fall within the
         * span of the samples rules.
         *
         * Low score is best, the score is calculated by summing up the differences in DST
         * rules and if the consts.MAX_SCORE is overreached the candidate is ruled out.
         *
         * Yah follow? :)
         *
         * @param rule_list
         * @param preliminary_timezone
         * @returns {*}
         */
        best_dst_match = function best_dst_match(rule_list, preliminary_timezone) {
            var score_sample = function score_sample(sample) {
                var score = 0;

                for (var j = 0; j < rule_list.length; j++) {

                    // Both sample and current time zone report DST during the year.
                    if (!!sample.rules[j] && !!rule_list[j]) {

                        // The current time zone's DST rules are inside the sample's. Include.
                        if (rule_list[j].s >= sample.rules[j].s && rule_list[j].e <= sample.rules[j].e) {
                            score = 0;
                            score += Math.abs(rule_list[j].s - sample.rules[j].s);
                            score += Math.abs(sample.rules[j].e - rule_list[j].e);

                        // The current time zone's DST rules are outside the sample's. Discard.
                        } else {
                            score = 'N/A';
                            break;
                        }

                        // The max score has been reached. Discard.
                        if (score > consts.MAX_SCORE) {
                            score = 'N/A';
                            break;
                        }
                    }
                }

                score = windows7_adaptations(rule_list, preliminary_timezone, score, sample);

                return score;
            };
            var scoreboard = {};
            var dst_zones = jstz.olson.dst_rules.zones;
            var dst_zones_length = dst_zones.length;
            var ambiguities = consts.AMBIGUITIES[preliminary_timezone];

            for (var i = 0; i < dst_zones_length; i++) {
                var sample = dst_zones[i];
                var score = score_sample(dst_zones[i]);

                if (score !== 'N/A') {
                    scoreboard[sample.name] = score;
                }
            }

            for (var tz in scoreboard) {
                if (scoreboard.hasOwnProperty(tz)) {
                    for (var j = 0; j < ambiguities.length; j++) {
                        if (ambiguities[j] === tz) {
                        return tz;
                        }
                    }
                }
            }

            return preliminary_timezone;
        },

        /**
         * Takes the preliminary_timezone as detected by lookup_key().
         *
         * Builds up the current timezones DST rules for the years defined
         * in the jstz.olson.dst_rules.years array.
         *
         * If there are no DST occurences for those years, immediately returns
         * the preliminary timezone. Otherwise proceeds and tries to solve
         * ambiguities.
         *
         * @param preliminary_timezone
         * @returns {String} timezone_name
         */
        get_by_dst = function get_by_dst(preliminary_timezone) {
            var get_rules = function get_rules() {
                var rule_list = [];
                for (var i = 0; i < jstz.olson.dst_rules.years.length; i++) {
                    var year_rules = dst_dates(jstz.olson.dst_rules.years[i]);
                    rule_list.push(year_rules);
                }
                return rule_list;
            };
            var check_has_dst = function check_has_dst(rules) {
                for (var i = 0; i < rules.length; i++) {
                    if (rules[i] !== false) {
                        return true;
                    }
                }
                return false;
            };
            var rules = get_rules();
            var has_dst = check_has_dst(rules);

            if (has_dst) {
                return best_dst_match(rules, preliminary_timezone);
            }

            return preliminary_timezone;
        },

        /**
         * Uses get_timezone_info() to formulate a key to use in the olson.timezones dictionary.
         *
         * Returns an object with one function ".name()"
         *
         * @returns Object
         */
        determine = function determine() {
            var preliminary_tz = get_from_internationalization_api();

            if (!preliminary_tz) {
                preliminary_tz = jstz.olson.timezones[lookup_key()];

                if (typeof consts.AMBIGUITIES[preliminary_tz] !== 'undefined') {
                    preliminary_tz = get_by_dst(preliminary_tz);
                }
            }

            return {
                name: function () {
                    return preliminary_tz;
                },
                stdTimezoneOffset : function () {
                    // negative to match what (new Date).getTimezoneOffset() will return
                    return -lookup_key().split(',')[0];
                },
                timezoneOffset : function () {
                    // negative to match what (new Date).getTimezoneOffset() will return
                    return -get_date_offset(new Date())
                }
            };
        };

    return {
        determine: determine
    };
}());


jstz.olson = jstz.olson || {};

/**
 * The keys in this dictionary are comma separated as such:
 *
 * First the offset compared to UTC time in minutes.
 *
 * Then a flag which is 0 if the timezone does not take daylight savings into account and 1 if it
 * does.
 *
 * Thirdly an optional 's' signifies that the timezone is in the southern hemisphere,
 * only interesting for timezones with DST.
 *
 * The mapped arrays is used for constructing the jstz.TimeZone object from within
 * jstz.determine();
 */
jstz.olson.timezones = {
    '-720,0': 'Etc/GMT+12',
    '-660,0': 'Pacific/Pago_Pago',
    '-660,1,s': 'Pacific/Apia', // Why? Because windows... cry!
    '-600,1': 'America/Adak',
    '-600,0': 'Pacific/Honolulu',
    '-570,0': 'Pacific/Marquesas',
    '-540,0': 'Pacific/Gambier',
    '-540,1': 'America/Anchorage',
    '-480,1': 'America/Los_Angeles',
    '-480,0': 'Pacific/Pitcairn',
    '-420,0': 'America/Phoenix',
    '-420,1': 'America/Denver',
    '-360,0': 'America/Guatemala',
    '-360,1': 'America/Chicago',
    '-360,1,s': 'Pacific/Easter',
    '-300,0': 'America/Bogota',
    '-300,1': 'America/New_York',
    '-270,0': 'America/Caracas',
    '-240,1': 'America/Halifax',
    '-240,0': 'America/Santo_Domingo',
    '-240,1,s': 'America/Asuncion',
    '-210,1': 'America/St_Johns',
    '-180,1': 'America/Godthab',
    '-180,0': 'America/Argentina/Buenos_Aires',
    '-180,1,s': 'America/Montevideo',
    '-120,0': 'America/Noronha',
    '-120,1': 'America/Noronha',
    '-60,1': 'Atlantic/Azores',
    '-60,0': 'Atlantic/Cape_Verde',
    '0,0': 'UTC',
    '0,1': 'Europe/London',
    '60,1': 'Europe/Berlin',
    '60,0': 'Africa/Lagos',
    '60,1,s': 'Africa/Windhoek',
    '120,1': 'Asia/Beirut',
    '120,0': 'Africa/Johannesburg',
    '180,0': 'Asia/Baghdad',
    '180,1': 'Europe/Moscow',
    '210,1': 'Asia/Tehran',
    '240,0': 'Asia/Dubai',
    '240,1': 'Asia/Baku',
    '270,0': 'Asia/Kabul',
    '300,1': 'Asia/Yekaterinburg',
    '300,0': 'Asia/Karachi',
    '330,0': 'Asia/Kolkata',
    '345,0': 'Asia/Kathmandu',
    '360,0': 'Asia/Dhaka',
    '360,1': 'Asia/Omsk',
    '390,0': 'Asia/Rangoon',
    '420,1': 'Asia/Krasnoyarsk',
    '420,0': 'Asia/Jakarta',
    '480,0': 'Asia/Shanghai',
    '480,1': 'Asia/Irkutsk',
    '525,0': 'Australia/Eucla',
    '525,1,s': 'Australia/Eucla',
    '540,1': 'Asia/Yakutsk',
    '540,0': 'Asia/Tokyo',
    '570,0': 'Australia/Darwin',
    '570,1,s': 'Australia/Adelaide',
    '600,0': 'Australia/Brisbane',
    '600,1': 'Asia/Vladivostok',
    '600,1,s': 'Australia/Sydney',
    '630,1,s': 'Australia/Lord_Howe',
    '660,1': 'Asia/Kamchatka',
    '660,0': 'Pacific/Noumea',
    '690,0': 'Pacific/Norfolk',
    '720,1,s': 'Pacific/Auckland',
    '720,0': 'Pacific/Majuro',
    '765,1,s': 'Pacific/Chatham',
    '780,0': 'Pacific/Tongatapu',
    '780,1,s': 'Pacific/Apia',
    '840,0': 'Pacific/Kiritimati'
};

/* Build time: 2015-11-02 13:01:00Z Build by invoking python utilities/dst.py generate */
jstz.olson.dst_rules = {
    "years": [
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014
    ],
    "zones": [
        {
            "name": "Africa/Cairo",
            "rules": [
                {
                    "e": 1219957200000,
                    "s": 1209074400000
                },
                {
                    "e": 1250802000000,
                    "s": 1240524000000
                },
                {
                    "e": 1285880400000,
                    "s": 1284069600000
                },
                false,
                false,
                false,
                {
                    "e": 1411678800000,
                    "s": 1406844000000
                }
            ]
        },
        {
            "name": "Africa/Casablanca",
            "rules": [
                {
                    "e": 1220223600000,
                    "s": 1212278400000
                },
                {
                    "e": 1250809200000,
                    "s": 1243814400000
                },
                {
                    "e": 1281222000000,
                    "s": 1272758400000
                },
                {
                    "e": 1312066800000,
                    "s": 1301788800000
                },
                {
                    "e": 1348970400000,
                    "s": 1345428000000
                },
                {
                    "e": 1382839200000,
                    "s": 1376100000000
                },
                {
                    "e": 1414288800000,
                    "s": 1406944800000
                }
            ]
        },
        {
            "name": "America/Asuncion",
            "rules": [
                {
                    "e": 1205031600000,
                    "s": 1224388800000
                },
                {
                    "e": 1236481200000,
                    "s": 1255838400000
                },
                {
                    "e": 1270954800000,
                    "s": 1286078400000
                },
                {
                    "e": 1302404400000,
                    "s": 1317528000000
                },
                {
                    "e": 1333854000000,
                    "s": 1349582400000
                },
                {
                    "e": 1364094000000,
                    "s": 1381032000000
                },
                {
                    "e": 1395543600000,
                    "s": 1412481600000
                }
            ]
        },
        {
            "name": "America/Campo_Grande",
            "rules": [
                {
                    "e": 1203217200000,
                    "s": 1224388800000
                },
                {
                    "e": 1234666800000,
                    "s": 1255838400000
                },
                {
                    "e": 1266721200000,
                    "s": 1287288000000
                },
                {
                    "e": 1298170800000,
                    "s": 1318737600000
                },
                {
                    "e": 1330225200000,
                    "s": 1350792000000
                },
                {
                    "e": 1361070000000,
                    "s": 1382241600000
                },
                {
                    "e": 1392519600000,
                    "s": 1413691200000
                }
            ]
        },
        {
            "name": "America/Goose_Bay",
            "rules": [
                {
                    "e": 1225594860000,
                    "s": 1205035260000
                },
                {
                    "e": 1257044460000,
                    "s": 1236484860000
                },
                {
                    "e": 1289098860000,
                    "s": 1268539260000
                },
                {
                    "e": 1320555600000,
                    "s": 1299988860000
                },
                {
                    "e": 1352005200000,
                    "s": 1331445600000
                },
                {
                    "e": 1383454800000,
                    "s": 1362895200000
                },
                {
                    "e": 1414904400000,
                    "s": 1394344800000
                }
            ]
        },
        {
            "name": "America/Havana",
            "rules": [
                {
                    "e": 1224997200000,
                    "s": 1205643600000
                },
                {
                    "e": 1256446800000,
                    "s": 1236488400000
                },
                {
                    "e": 1288501200000,
                    "s": 1268542800000
                },
                {
                    "e": 1321160400000,
                    "s": 1300597200000
                },
                {
                    "e": 1352005200000,
                    "s": 1333256400000
                },
                {
                    "e": 1383454800000,
                    "s": 1362891600000
                },
                {
                    "e": 1414904400000,
                    "s": 1394341200000
                }
            ]
        },
        {
            "name": "America/Mazatlan",
            "rules": [
                {
                    "e": 1225008000000,
                    "s": 1207472400000
                },
                {
                    "e": 1256457600000,
                    "s": 1238922000000
                },
                {
                    "e": 1288512000000,
                    "s": 1270371600000
                },
                {
                    "e": 1319961600000,
                    "s": 1301821200000
                },
                {
                    "e": 1351411200000,
                    "s": 1333270800000
                },
                {
                    "e": 1382860800000,
                    "s": 1365325200000
                },
                {
                    "e": 1414310400000,
                    "s": 1396774800000
                }
            ]
        },
        {
            "name": "America/Mexico_City",
            "rules": [
                {
                    "e": 1225004400000,
                    "s": 1207468800000
                },
                {
                    "e": 1256454000000,
                    "s": 1238918400000
                },
                {
                    "e": 1288508400000,
                    "s": 1270368000000
                },
                {
                    "e": 1319958000000,
                    "s": 1301817600000
                },
                {
                    "e": 1351407600000,
                    "s": 1333267200000
                },
                {
                    "e": 1382857200000,
                    "s": 1365321600000
                },
                {
                    "e": 1414306800000,
                    "s": 1396771200000
                }
            ]
        },
        {
            "name": "America/Miquelon",
            "rules": [
                {
                    "e": 1225598400000,
                    "s": 1205038800000
                },
                {
                    "e": 1257048000000,
                    "s": 1236488400000
                },
                {
                    "e": 1289102400000,
                    "s": 1268542800000
                },
                {
                    "e": 1320552000000,
                    "s": 1299992400000
                },
                {
                    "e": 1352001600000,
                    "s": 1331442000000
                },
                {
                    "e": 1383451200000,
                    "s": 1362891600000
                },
                {
                    "e": 1414900800000,
                    "s": 1394341200000
                }
            ]
        },
        {
            "name": "America/Santa_Isabel",
            "rules": [
                {
                    "e": 1225011600000,
                    "s": 1207476000000
                },
                {
                    "e": 1256461200000,
                    "s": 1238925600000
                },
                {
                    "e": 1288515600000,
                    "s": 1270375200000
                },
                {
                    "e": 1319965200000,
                    "s": 1301824800000
                },
                {
                    "e": 1351414800000,
                    "s": 1333274400000
                },
                {
                    "e": 1382864400000,
                    "s": 1365328800000
                },
                {
                    "e": 1414314000000,
                    "s": 1396778400000
                }
            ]
        },
        {
            "name": "America/Santiago",
            "rules": [
                {
                    "e": 1206846000000,
                    "s": 1223784000000
                },
                {
                    "e": 1237086000000,
                    "s": 1255233600000
                },
                {
                    "e": 1270350000000,
                    "s": 1286683200000
                },
                {
                    "e": 1304823600000,
                    "s": 1313899200000
                },
                {
                    "e": 1335668400000,
                    "s": 1346558400000
                },
                {
                    "e": 1367118000000,
                    "s": 1378612800000
                },
                {
                    "e": 1398567600000,
                    "s": 1410062400000
                }
            ]
        },
        {
            "name": "America/Sao_Paulo",
            "rules": [
                {
                    "e": 1203213600000,
                    "s": 1224385200000
                },
                {
                    "e": 1234663200000,
                    "s": 1255834800000
                },
                {
                    "e": 1266717600000,
                    "s": 1287284400000
                },
                {
                    "e": 1298167200000,
                    "s": 1318734000000
                },
                {
                    "e": 1330221600000,
                    "s": 1350788400000
                },
                {
                    "e": 1361066400000,
                    "s": 1382238000000
                },
                {
                    "e": 1392516000000,
                    "s": 1413687600000
                }
            ]
        },
        {
            "name": "Asia/Amman",
            "rules": [
                {
                    "e": 1225404000000,
                    "s": 1206655200000
                },
                {
                    "e": 1256853600000,
                    "s": 1238104800000
                },
                {
                    "e": 1288303200000,
                    "s": 1269554400000
                },
                {
                    "e": 1319752800000,
                    "s": 1301608800000
                },
                false,
                false,
                {
                    "e": 1414706400000,
                    "s": 1395957600000
                }
            ]
        },
        {
            "name": "Asia/Damascus",
            "rules": [
                {
                    "e": 1225486800000,
                    "s": 1207260000000
                },
                {
                    "e": 1256850000000,
                    "s": 1238104800000
                },
                {
                    "e": 1288299600000,
                    "s": 1270159200000
                },
                {
                    "e": 1319749200000,
                    "s": 1301608800000
                },
                {
                    "e": 1351198800000,
                    "s": 1333058400000
                },
                {
                    "e": 1382648400000,
                    "s": 1364508000000
                },
                {
                    "e": 1414702800000,
                    "s": 1395957600000
                }
            ]
        },
        {
            "name": "Asia/Dubai",
            "rules": [
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Gaza",
            "rules": [
                {
                    "e": 1219957200000,
                    "s": 1206655200000
                },
                {
                    "e": 1252015200000,
                    "s": 1238104800000
                },
                {
                    "e": 1281474000000,
                    "s": 1269640860000
                },
                {
                    "e": 1312146000000,
                    "s": 1301608860000
                },
                {
                    "e": 1348178400000,
                    "s": 1333058400000
                },
                {
                    "e": 1380229200000,
                    "s": 1364508000000
                },
                {
                    "e": 1414098000000,
                    "s": 1395957600000
                }
            ]
        },
        {
            "name": "Asia/Irkutsk",
            "rules": [
                {
                    "e": 1224957600000,
                    "s": 1206813600000
                },
                {
                    "e": 1256407200000,
                    "s": 1238263200000
                },
                {
                    "e": 1288461600000,
                    "s": 1269712800000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Jerusalem",
            "rules": [
                {
                    "e": 1223161200000,
                    "s": 1206662400000
                },
                {
                    "e": 1254006000000,
                    "s": 1238112000000
                },
                {
                    "e": 1284246000000,
                    "s": 1269561600000
                },
                {
                    "e": 1317510000000,
                    "s": 1301616000000
                },
                {
                    "e": 1348354800000,
                    "s": 1333065600000
                },
                {
                    "e": 1382828400000,
                    "s": 1364515200000
                },
                {
                    "e": 1414278000000,
                    "s": 1395964800000
                }
            ]
        },
        {
            "name": "Asia/Kamchatka",
            "rules": [
                {
                    "e": 1224943200000,
                    "s": 1206799200000
                },
                {
                    "e": 1256392800000,
                    "s": 1238248800000
                },
                {
                    "e": 1288450800000,
                    "s": 1269698400000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Krasnoyarsk",
            "rules": [
                {
                    "e": 1224961200000,
                    "s": 1206817200000
                },
                {
                    "e": 1256410800000,
                    "s": 1238266800000
                },
                {
                    "e": 1288465200000,
                    "s": 1269716400000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Omsk",
            "rules": [
                {
                    "e": 1224964800000,
                    "s": 1206820800000
                },
                {
                    "e": 1256414400000,
                    "s": 1238270400000
                },
                {
                    "e": 1288468800000,
                    "s": 1269720000000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Vladivostok",
            "rules": [
                {
                    "e": 1224950400000,
                    "s": 1206806400000
                },
                {
                    "e": 1256400000000,
                    "s": 1238256000000
                },
                {
                    "e": 1288454400000,
                    "s": 1269705600000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Yakutsk",
            "rules": [
                {
                    "e": 1224954000000,
                    "s": 1206810000000
                },
                {
                    "e": 1256403600000,
                    "s": 1238259600000
                },
                {
                    "e": 1288458000000,
                    "s": 1269709200000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Yekaterinburg",
            "rules": [
                {
                    "e": 1224968400000,
                    "s": 1206824400000
                },
                {
                    "e": 1256418000000,
                    "s": 1238274000000
                },
                {
                    "e": 1288472400000,
                    "s": 1269723600000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Asia/Yerevan",
            "rules": [
                {
                    "e": 1224972000000,
                    "s": 1206828000000
                },
                {
                    "e": 1256421600000,
                    "s": 1238277600000
                },
                {
                    "e": 1288476000000,
                    "s": 1269727200000
                },
                {
                    "e": 1319925600000,
                    "s": 1301176800000
                },
                false,
                false,
                false
            ]
        },
        {
            "name": "Australia/Lord_Howe",
            "rules": [
                {
                    "e": 1207407600000,
                    "s": 1223134200000
                },
                {
                    "e": 1238857200000,
                    "s": 1254583800000
                },
                {
                    "e": 1270306800000,
                    "s": 1286033400000
                },
                {
                    "e": 1301756400000,
                    "s": 1317483000000
                },
                {
                    "e": 1333206000000,
                    "s": 1349537400000
                },
                {
                    "e": 1365260400000,
                    "s": 1380987000000
                },
                {
                    "e": 1396710000000,
                    "s": 1412436600000
                }
            ]
        },
        {
            "name": "Australia/Perth",
            "rules": [
                {
                    "e": 1206813600000,
                    "s": 1224957600000
                },
                false,
                false,
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Europe/Helsinki",
            "rules": [
                {
                    "e": 1224982800000,
                    "s": 1206838800000
                },
                {
                    "e": 1256432400000,
                    "s": 1238288400000
                },
                {
                    "e": 1288486800000,
                    "s": 1269738000000
                },
                {
                    "e": 1319936400000,
                    "s": 1301187600000
                },
                {
                    "e": 1351386000000,
                    "s": 1332637200000
                },
                {
                    "e": 1382835600000,
                    "s": 1364691600000
                },
                {
                    "e": 1414285200000,
                    "s": 1396141200000
                }
            ]
        },
        {
            "name": "Europe/Minsk",
            "rules": [
                {
                    "e": 1224979200000,
                    "s": 1206835200000
                },
                {
                    "e": 1256428800000,
                    "s": 1238284800000
                },
                {
                    "e": 1288483200000,
                    "s": 1269734400000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Europe/Moscow",
            "rules": [
                {
                    "e": 1224975600000,
                    "s": 1206831600000
                },
                {
                    "e": 1256425200000,
                    "s": 1238281200000
                },
                {
                    "e": 1288479600000,
                    "s": 1269730800000
                },
                false,
                false,
                false,
                false
            ]
        },
        {
            "name": "Pacific/Apia",
            "rules": [
                false,
                false,
                false,
                {
                    "e": 1301752800000,
                    "s": 1316872800000
                },
                {
                    "e": 1333202400000,
                    "s": 1348927200000
                },
                {
                    "e": 1365256800000,
                    "s": 1380376800000
                },
                {
                    "e": 1396706400000,
                    "s": 1411826400000
                }
            ]
        },
        {
            "name": "Pacific/Fiji",
            "rules": [
                false,
                false,
                {
                    "e": 1269698400000,
                    "s": 1287842400000
                },
                {
                    "e": 1327154400000,
                    "s": 1319292000000
                },
                {
                    "e": 1358604000000,
                    "s": 1350741600000
                },
                {
                    "e": 1390050000000,
                    "s": 1382796000000
                },
                {
                    "e": 1421503200000,
                    "s": 1414850400000
                }
            ]
        },
        {
            "name": "Europe/London",
            "rules": [
                {
                    "e": 1224982800000,
                    "s": 1206838800000
                },
                {
                    "e": 1256432400000,
                    "s": 1238288400000
                },
                {
                    "e": 1288486800000,
                    "s": 1269738000000
                },
                {
                    "e": 1319936400000,
                    "s": 1301187600000
                },
                {
                    "e": 1351386000000,
                    "s": 1332637200000
                },
                {
                    "e": 1382835600000,
                    "s": 1364691600000
                },
                {
                    "e": 1414285200000,
                    "s": 1396141200000
                }
            ]
        }
    ]
};
if ( true && typeof module.exports !== 'undefined') {
    module.exports = jstz;
} else if (( true && __webpack_require__.amdD !== null) && (__webpack_require__.amdO != null)) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return jstz;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
    if (typeof root === 'undefined') {
        window.jstz = jstz;
    } else {
        root.jstz = jstz;
    }
}
}());


/***/ }),

/***/ 96342:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72976);


/***/ }),

/***/ 30612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InvalidTokenError */
function e(e){this.message=e}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";/* harmony default export */ __webpack_exports__["Z"] = (o);
//# sourceMappingURL=jwt-decode.esm.js.map


/***/ }),

/***/ 45391:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(32735));
const types_1 = __webpack_require__(27437);
const context_1 = __webpack_require__(12135);
const initLDClient_1 = __importDefault(__webpack_require__(54529));
const utils_1 = __webpack_require__(38486);
const getFlagsProxy_1 = __importDefault(__webpack_require__(31293));
/**
 * This is an async function which initializes LaunchDarkly's JS SDK (`launchdarkly-js-client-sdk`)
 * and awaits it so all flags and the ldClient are ready before the consumer app is rendered.
 *
 * The difference between `withLDProvider` and `asyncWithLDProvider` is that `withLDProvider` initializes
 * `launchdarkly-js-client-sdk` at componentDidMount. This means your flags and the ldClient are only available after
 * your app has mounted. This can result in a flicker due to flag changes at startup time.
 *
 * `asyncWithLDProvider` initializes `launchdarkly-js-client-sdk` at the entry point of your app prior to render.
 * This means that your flags and the ldClient are ready at the beginning of your app. This ensures your app does not
 * flicker due to flag changes at startup time.
 *
 * `asyncWithLDProvider` accepts a config object which is used to initialize `launchdarkly-js-client-sdk`.
 *
 * `asyncWithLDProvider` does not support the `deferInitialization` config option because `asyncWithLDProvider` needs
 * to be initialized at the entry point prior to render to ensure your flags and the ldClient are ready at the beginning
 * of your app.
 *
 * It returns a provider which is a React FunctionComponent which:
 * - saves all flags and the ldClient instance in the context API
 * - subscribes to flag changes and propagate them through the context API
 *
 * @param config - The configuration used to initialize LaunchDarkly's JS SDK
 */
function asyncWithLDProvider(config) {
    return __awaiter(this, void 0, void 0, function* () {
        const { clientSideID, user, flags: targetFlags, options, reactOptions: userReactOptions } = config;
        const reactOptions = Object.assign(Object.assign({}, types_1.defaultReactOptions), userReactOptions);
        const { ldClient, flags: fetchedFlags, error } = yield (0, initLDClient_1.default)(clientSideID, user, options, targetFlags);
        const initialFlags = (options === null || options === void 0 ? void 0 : options.bootstrap) && options.bootstrap !== 'localStorage' ? options.bootstrap : fetchedFlags;
        const LDProvider = ({ children }) => {
            const [ldData, setLDData] = (0, react_1.useState)(() => (Object.assign({ unproxiedFlags: initialFlags }, (0, getFlagsProxy_1.default)(ldClient, initialFlags, reactOptions, targetFlags))));
            (0, react_1.useEffect)(() => {
                function onChange(changes) {
                    const updates = (0, utils_1.getFlattenedFlagsFromChangeset)(changes, targetFlags);
                    if (Object.keys(updates).length > 0) {
                        setLDData(({ unproxiedFlags }) => {
                            const updatedUnproxiedFlags = Object.assign(Object.assign({}, unproxiedFlags), updates);
                            return Object.assign({ unproxiedFlags: updatedUnproxiedFlags }, (0, getFlagsProxy_1.default)(ldClient, updatedUnproxiedFlags, reactOptions, targetFlags));
                        });
                    }
                }
                ldClient.on('change', onChange);
                return function cleanup() {
                    ldClient.off('change', onChange);
                };
            }, []);
            const { flags, flagKeyMap } = ldData;
            return react_1.default.createElement(context_1.Provider, { value: { flags, flagKeyMap, ldClient, error } }, children);
        };
        return LDProvider;
    });
}
exports["default"] = asyncWithLDProvider;
//# sourceMappingURL=asyncWithLDProvider.js.map

/***/ }),

/***/ 12135:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Consumer = exports.Provider = void 0;
const react_1 = __webpack_require__(32735);
/**
 * @ignore
 */
const context = (0, react_1.createContext)({ flags: {}, flagKeyMap: {}, ldClient: undefined });
const { 
/**
 * @ignore
 */
Provider, 
/**
 * @ignore
 */
Consumer, } = context;
exports.Provider = Provider;
exports.Consumer = Consumer;
exports["default"] = context;
//# sourceMappingURL=context.js.map

/***/ }),

/***/ 31293:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const lodash_camelcase_1 = __importDefault(__webpack_require__(8122));
const types_1 = __webpack_require__(27437);
function getFlagsProxy(ldClient, rawFlags, reactOptions = types_1.defaultReactOptions, targetFlags) {
    const filteredFlags = filterFlags(rawFlags, targetFlags);
    const [flags, flagKeyMap = {}] = reactOptions.useCamelCaseFlagKeys
        ? getCamelizedKeysAndFlagMap(filteredFlags)
        : [filteredFlags];
    return {
        flags: reactOptions.sendEventsOnFlagRead ? toFlagsProxy(ldClient, flags, flagKeyMap) : flags,
        flagKeyMap,
    };
}
exports["default"] = getFlagsProxy;
function filterFlags(flags, targetFlags) {
    if (targetFlags === undefined) {
        return flags;
    }
    return Object.keys(targetFlags).reduce((acc, key) => {
        if (hasFlag(flags, key)) {
            acc[key] = flags[key];
        }
        return acc;
    }, {});
}
function getCamelizedKeysAndFlagMap(rawFlags) {
    const flags = {};
    const flagKeyMap = {};
    for (const rawFlag in rawFlags) {
        // Exclude system keys
        if (rawFlag.indexOf('$') === 0) {
            continue;
        }
        const camelKey = (0, lodash_camelcase_1.default)(rawFlag);
        flags[camelKey] = rawFlags[rawFlag];
        flagKeyMap[camelKey] = rawFlag;
    }
    return [flags, flagKeyMap];
}
function hasFlag(flags, flagKey) {
    return Object.prototype.hasOwnProperty.call(flags, flagKey);
}
function toFlagsProxy(ldClient, flags, flagKeyMap) {
    return new Proxy(flags, {
        // trap for reading a flag value using `LDClient#variation` to trigger an evaluation event
        get(target, prop, receiver) {
            const currentValue = Reflect.get(target, prop, receiver);
            // only process flag keys and ignore symbols and native Object functions
            if (typeof prop === 'symbol' || !hasFlag(flagKeyMap, prop)) {
                return currentValue;
            }
            if (currentValue === undefined) {
                return;
            }
            return ldClient.variation(flagKeyMap[prop], currentValue);
        },
        // disable all mutation functions to make proxy readonly
        setPrototypeOf: () => false,
        set: () => false,
        defineProperty: () => false,
        deleteProperty: () => false,
        preventExtensions: () => false,
    });
}
//# sourceMappingURL=getFlagsProxy.js.map

/***/ }),

/***/ 52850:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withLDConsumer = exports.withLDProvider = exports.useLDClientError = exports.useLDClient = exports.useFlags = exports.camelCaseKeys = exports.asyncWithLDProvider = exports.LDProvider = void 0;
const provider_1 = __importDefault(__webpack_require__(21272));
exports.LDProvider = provider_1.default;
const withLDProvider_1 = __importDefault(__webpack_require__(39506));
exports.withLDProvider = withLDProvider_1.default;
const asyncWithLDProvider_1 = __importDefault(__webpack_require__(45391));
exports.asyncWithLDProvider = asyncWithLDProvider_1.default;
const withLDConsumer_1 = __importDefault(__webpack_require__(92486));
exports.withLDConsumer = withLDConsumer_1.default;
const useFlags_1 = __importDefault(__webpack_require__(34649));
exports.useFlags = useFlags_1.default;
const useLDClient_1 = __importDefault(__webpack_require__(33816));
exports.useLDClient = useLDClient_1.default;
const useLDClientError_1 = __importDefault(__webpack_require__(15673));
exports.useLDClientError = useLDClientError_1.default;
const utils_1 = __webpack_require__(38486);
Object.defineProperty(exports, "camelCaseKeys", ({ enumerable: true, get: function () { return utils_1.camelCaseKeys; } }));
__exportStar(__webpack_require__(27437), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 54529:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const launchdarkly_js_client_sdk_1 = __webpack_require__(35357);
const utils_1 = __webpack_require__(38486);
const packageInfo = __importStar(__webpack_require__(4994));
const wrapperOptions = {
    wrapperName: 'react-client-sdk',
    wrapperVersion: packageInfo.version,
    sendEventsOnlyForVariation: true,
};
/**
 * Internal function to initialize the `LDClient`.
 *
 * @param clientSideID Your project and environment specific client side ID
 * @param user A LaunchDarkly user object
 * @param options LaunchDarkly initialization options
 * @param targetFlags If specified, `launchdarkly-react-client-sdk` will only request and listen to these flags.
 * Flag keys must be in their original form as known to LaunchDarkly rather than in their camel-cased form.
 *
 * @see `ProviderConfig` for more details about the parameters
 * @return An initialized client and flags
 */
const initLDClient = (clientSideID, user = { anonymous: true }, options, targetFlags) => __awaiter(void 0, void 0, void 0, function* () {
    const ldClient = (0, launchdarkly_js_client_sdk_1.initialize)(clientSideID, user, Object.assign(Object.assign({}, wrapperOptions), options));
    return new Promise((resolve) => {
        function cleanup() {
            ldClient.off('ready', handleReady);
            ldClient.off('failed', handleFailure);
        }
        function handleFailure(error) {
            cleanup();
            resolve({ flags: {}, ldClient, error });
        }
        function handleReady() {
            cleanup();
            const flags = (0, utils_1.fetchFlags)(ldClient, targetFlags);
            resolve({ flags, ldClient });
        }
        ldClient.on('failed', handleFailure);
        ldClient.on('ready', handleReady);
    });
});
exports["default"] = initLDClient;
//# sourceMappingURL=initLDClient.js.map

/***/ }),

/***/ 21272:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(32735));
const types_1 = __webpack_require__(27437);
const context_1 = __webpack_require__(12135);
const initLDClient_1 = __importDefault(__webpack_require__(54529));
const utils_1 = __webpack_require__(38486);
const getFlagsProxy_1 = __importDefault(__webpack_require__(31293));
/**
 * The `LDProvider` is a component which accepts a config object which is used to
 * initialize `launchdarkly-js-client-sdk`.
 *
 * This Provider does three things:
 * - It initializes the ldClient instance by calling `launchdarkly-js-client-sdk` initialize on `componentDidMount`
 * - It saves all flags and the ldClient instance in the context API
 * - It subscribes to flag changes and propagate them through the context API
 *
 * Because the `launchdarkly-js-client-sdk` in only initialized on `componentDidMount`, your flags and the
 * ldClient are only available after your app has mounted. This can result in a flicker due to flag changes at
 * startup time.
 *
 * This component can be used as a standalone provider. However, be mindful to only include the component once
 * within your application. This provider is used inside the `withLDProviderHOC` and can be used instead to initialize
 * the `launchdarkly-js-client-sdk`. For async initialization, check out the `asyncWithLDProvider` function
 */
class LDProvider extends react_1.Component {
    constructor(props) {
        super(props);
        this.getReactOptions = () => (Object.assign(Object.assign({}, types_1.defaultReactOptions), this.props.reactOptions));
        this.subscribeToChanges = (ldClient) => {
            const { flags: targetFlags } = this.props;
            ldClient.on('change', (changes) => {
                const reactOptions = this.getReactOptions();
                const updates = (0, utils_1.getFlattenedFlagsFromChangeset)(changes, targetFlags);
                const unproxiedFlags = Object.assign(Object.assign({}, this.state.unproxiedFlags), updates);
                if (Object.keys(updates).length > 0) {
                    this.setState(Object.assign({ unproxiedFlags }, (0, getFlagsProxy_1.default)(ldClient, unproxiedFlags, reactOptions, targetFlags)));
                }
            });
        };
        this.initLDClient = () => __awaiter(this, void 0, void 0, function* () {
            const { clientSideID, flags, options, user } = this.props;
            let ldClient = yield this.props.ldClient;
            const reactOptions = this.getReactOptions();
            let unproxiedFlags;
            let error;
            if (ldClient) {
                unproxiedFlags = (0, utils_1.fetchFlags)(ldClient, flags);
            }
            else {
                const initialisedOutput = yield (0, initLDClient_1.default)(clientSideID, user, options, flags);
                unproxiedFlags = initialisedOutput.flags;
                ldClient = initialisedOutput.ldClient;
                error = initialisedOutput.error;
            }
            this.setState(Object.assign(Object.assign({ unproxiedFlags }, (0, getFlagsProxy_1.default)(ldClient, unproxiedFlags, reactOptions, flags)), { ldClient, error }));
            this.subscribeToChanges(ldClient);
        });
        const { options } = props;
        this.state = {
            flags: {},
            unproxiedFlags: {},
            flagKeyMap: {},
            ldClient: undefined,
        };
        if (options) {
            const { bootstrap } = options;
            if (bootstrap && bootstrap !== 'localStorage') {
                const { useCamelCaseFlagKeys } = this.getReactOptions();
                this.state = {
                    flags: useCamelCaseFlagKeys ? (0, utils_1.camelCaseKeys)(bootstrap) : bootstrap,
                    unproxiedFlags: bootstrap,
                    flagKeyMap: {},
                    ldClient: undefined,
                };
            }
        }
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { user, deferInitialization } = this.props;
            if (deferInitialization && !user) {
                return;
            }
            yield this.initLDClient();
        });
    }
    componentDidUpdate(prevProps) {
        return __awaiter(this, void 0, void 0, function* () {
            const { user, deferInitialization } = this.props;
            const userJustLoaded = !prevProps.user && user;
            if (deferInitialization && userJustLoaded) {
                yield this.initLDClient();
            }
        });
    }
    render() {
        const { flags, flagKeyMap, ldClient, error } = this.state;
        return react_1.default.createElement(context_1.Provider, { value: { flags, flagKeyMap, ldClient, error } }, this.props.children);
    }
}
exports["default"] = LDProvider;
//# sourceMappingURL=provider.js.map

/***/ }),

/***/ 27437:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultReactOptions = void 0;
/**
 * Contains default values for the `reactOptions` object.
 */
exports.defaultReactOptions = { useCamelCaseFlagKeys: true, sendEventsOnFlagRead: true };
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 34649:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __webpack_require__(32735);
const context_1 = __importDefault(__webpack_require__(12135));
/**
 * `useFlags` is a custom hook which returns all feature flags. It uses the `useContext` primitive
 * to access the LaunchDarkly context set up by `withLDProvider`. As such you will still need to
 * use the `withLDProvider` HOC at the root of your app to initialize the React SDK and populate the
 * context with `ldClient` and your flags.
 *
 * @return All the feature flags configured in your LaunchDarkly project
 */
const useFlags = () => {
    const { flags } = (0, react_1.useContext)(context_1.default);
    return flags;
};
exports["default"] = useFlags;
//# sourceMappingURL=useFlags.js.map

/***/ }),

/***/ 33816:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __webpack_require__(32735);
const context_1 = __importDefault(__webpack_require__(12135));
// tslint:disable:max-line-length
/**
 * `useLDClient` is a custom hook which returns the underlying [LaunchDarkly JavaScript SDK client object](https://launchdarkly.github.io/js-client-sdk/interfaces/_launchdarkly_js_client_sdk_.ldclient.html).
 * Like the `useFlags` custom hook, `useLDClient` also uses the `useContext` primitive to access the LaunchDarkly
 * context set up by `withLDProvider`. You will still need to use the `withLDProvider` HOC
 * to initialise the react sdk to use this custom hook.
 *
 * @return The `launchdarkly-js-client-sdk` `LDClient` object
 */
// tslint:enable:max-line-length
const useLDClient = () => {
    const { ldClient } = (0, react_1.useContext)(context_1.default);
    return ldClient;
};
exports["default"] = useLDClient;
//# sourceMappingURL=useLDClient.js.map

/***/ }),

/***/ 15673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __webpack_require__(32735);
const context_1 = __importDefault(__webpack_require__(12135));
/**
 * Provides the LaunchDarkly client initialization error, if there was one.
 *
 * @return The `launchdarkly-js-client-sdk` `LDClient` initialization error
 */
function useLDClientError() {
    const { error } = (0, react_1.useContext)(context_1.default);
    return error;
}
exports["default"] = useLDClientError;
//# sourceMappingURL=useLDClientError.js.map

/***/ }),

/***/ 38486:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchFlags = exports.getFlattenedFlagsFromChangeset = exports.camelCaseKeys = void 0;
const lodash_camelcase_1 = __importDefault(__webpack_require__(8122));
/**
 * Transforms a set of flags so that their keys are camelCased. This function ignores
 * flag keys which start with `$`.
 *
 * @param rawFlags A mapping of flag keys and their values
 * @return A transformed `LDFlagSet` with camelCased flag keys
 */
const camelCaseKeys = (rawFlags) => {
    const flags = {};
    for (const rawFlag in rawFlags) {
        // Exclude system keys
        if (rawFlag.indexOf('$') !== 0) {
            flags[(0, lodash_camelcase_1.default)(rawFlag)] = rawFlags[rawFlag]; // tslint:disable-line:no-unsafe-any
        }
    }
    return flags;
};
exports.camelCaseKeys = camelCaseKeys;
/**
 * Gets the flags to pass to the provider from the changeset.
 *
 * @param changes the `LDFlagChangeset` from the ldClient onchange handler.
 * @param targetFlags if targetFlags are specified, changes to other flags are ignored and not returned in the
 * flattened `LDFlagSet`
 * @return an `LDFlagSet` with the current flag values from the LDFlagChangeset filtered by `targetFlags`. The returned
 * object may be empty `{}` if none of the targetFlags were changed.
 */
const getFlattenedFlagsFromChangeset = (changes, targetFlags) => {
    const flattened = {};
    for (const key in changes) {
        if (!targetFlags || targetFlags[key] !== undefined) {
            flattened[key] = changes[key].current;
        }
    }
    return flattened;
};
exports.getFlattenedFlagsFromChangeset = getFlattenedFlagsFromChangeset;
/**
 * Retrieves flag values.
 *
 * @param ldClient LaunchDarkly client
 * @param targetFlags If specified, `launchdarkly-react-client-sdk` will only request and listen to these flags.
 * Flag keys must be in their original form as known to LaunchDarkly rather than in their camel-cased form.
 *
 * @returns an `LDFlagSet` with the current flag values from LaunchDarkly filtered by `targetFlags`.
 */
const fetchFlags = (ldClient, targetFlags) => {
    const allFlags = ldClient.allFlags();
    if (!targetFlags) {
        return allFlags;
    }
    return Object.keys(targetFlags).reduce((acc, key) => {
        acc[key] = Object.prototype.hasOwnProperty.call(allFlags, key) ? allFlags[key] : targetFlags[key];
        return acc;
    }, {});
};
exports.fetchFlags = fetchFlags;
/**
 * @deprecated The `camelCaseKeys.camelCaseKeys` property will be removed in a future version,
 * please update your code to use the `camelCaseKeys` function directly.
 */
// tslint:disable-next-line deprecation
exports.camelCaseKeys.camelCaseKeys = exports.camelCaseKeys;
exports["default"] = { camelCaseKeys: exports.camelCaseKeys, getFlattenedFlagsFromChangeset: exports.getFlattenedFlagsFromChangeset, fetchFlags: exports.fetchFlags };
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 92486:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const React = __importStar(__webpack_require__(32735));
const context_1 = __webpack_require__(12135);
/**
 * withLDConsumer is a function which accepts an optional options object and returns a function
 * which accepts your React component. This function returns a HOC with flags
 * and the ldClient instance injected via props.
 *
 * @param options - If you need only the `ldClient` instance and not flags, then set `{ clientOnly: true }`
 * to only pass the ldClient prop to your component. Defaults to `{ clientOnly: false }`.
 * @return A HOC with flags and the `ldClient` instance injected via props
 */
function withLDConsumer(options = { clientOnly: false }) {
    return function withLDConsumerHoc(WrappedComponent) {
        return (props) => (React.createElement(context_1.Consumer, null, ({ flags, ldClient }) => {
            if (options.clientOnly) {
                return React.createElement(WrappedComponent, Object.assign({ ldClient: ldClient }, props));
            }
            return React.createElement(WrappedComponent, Object.assign({ flags: flags, ldClient: ldClient }, props));
        }));
    };
}
exports["default"] = withLDConsumer;
//# sourceMappingURL=withLDConsumer.js.map

/***/ }),

/***/ 39506:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withLDProvider = void 0;
const React = __importStar(__webpack_require__(32735));
const types_1 = __webpack_require__(27437);
const provider_1 = __importDefault(__webpack_require__(21272));
const hoist_non_react_statics_1 = __importDefault(__webpack_require__(86058));
/**
 * `withLDProvider` is a function which accepts a config object which is used to
 * initialize `launchdarkly-js-client-sdk`.
 *
 * This HOC handles passing configuration to the `LDProvider`, which does the following:
 * - It initializes the ldClient instance by calling `launchdarkly-js-client-sdk` initialize on `componentDidMount`
 * - It saves all flags and the ldClient instance in the context API
 * - It subscribes to flag changes and propagate them through the context API
 *
 * The difference between `withLDProvider` and `asyncWithLDProvider` is that `withLDProvider` initializes
 * `launchdarkly-js-client-sdk` at `componentDidMount`. This means your flags and the ldClient are only available after
 * your app has mounted. This can result in a flicker due to flag changes at startup time.
 *
 * `asyncWithLDProvider` initializes `launchdarkly-js-client-sdk` at the entry point of your app prior to render.
 * This means that your flags and the ldClient are ready at the beginning of your app. This ensures your app does not
 * flicker due to flag changes at startup time.
 *
 * @param config - The configuration used to initialize LaunchDarkly's JS SDK
 * @return A function which accepts your root React component and returns a HOC
 */
function withLDProvider(config) {
    return function withLDProviderHoc(WrappedComponent) {
        const { reactOptions: userReactOptions } = config;
        const reactOptions = Object.assign(Object.assign({}, types_1.defaultReactOptions), userReactOptions);
        const providerProps = Object.assign(Object.assign({}, config), { reactOptions });
        function HoistedComponent(props) {
            return (React.createElement(provider_1.default, Object.assign({}, providerProps),
                React.createElement(WrappedComponent, Object.assign({}, props))));
        }
        (0, hoist_non_react_statics_1.default)(HoistedComponent, WrappedComponent);
        return HoistedComponent;
    };
}
exports.withLDProvider = withLDProvider;
exports["default"] = withLDProvider;
//# sourceMappingURL=withLDProvider.js.map

/***/ }),

/***/ 35357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "basicLogger": function() { return /* binding */ pn; },
/* harmony export */   "createConsoleLogger": function() { return /* binding */ mn; },
/* harmony export */   "default": function() { return /* binding */ yn; },
/* harmony export */   "initialize": function() { return /* binding */ gn; },
/* harmony export */   "version": function() { return /* binding */ hn; }
/* harmony export */ });
function e(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function n(n){for(var t=1;t<arguments.length;t++){var o=null!=arguments[t]?arguments[t]:{};t%2?e(Object(o),!0).forEach((function(e){r(n,e,o[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(n,Object.getOwnPropertyDescriptors(o)):e(Object(o)).forEach((function(e){Object.defineProperty(n,e,Object.getOwnPropertyDescriptor(o,e))}))}return n}function t(e){return(t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function r(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function o(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){var t=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=t){var r,o,i=[],a=!0,u=!1;try{for(t=t.call(e);!(a=(r=t.next()).done)&&(i.push(r.value),!n||i.length!==n);a=!0);}catch(e){u=!0,o=e}finally{try{a||null==t.return||t.return()}finally{if(u)throw o}}return i}}(e,n)||a(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function i(e){return function(e){if(Array.isArray(e))return u(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||a(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function a(e,n){if(e){if("string"==typeof e)return u(e,n);var t=Object.prototype.toString.call(e).slice(8,-1);return"Object"===t&&e.constructor&&(t=e.constructor.name),"Map"===t||"Set"===t?Array.from(e):"Arguments"===t||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)?u(e,n):void 0}}function u(e,n){(null==n||n>e.length)&&(n=e.length);for(var t=0,r=new Array(n);t<n;t++)r[t]=e[t];return r}function c(e){function n(e,n){Error.captureStackTrace&&Error.captureStackTrace(this,this.constructor),this.message=e,this.code=n}return n.prototype=new Error,n.prototype.name=e,n.prototype.constructor=n,n}var s=c("LaunchDarklyUnexpectedResponseError"),l=c("LaunchDarklyInvalidEnvironmentIdError"),f=c("LaunchDarklyInvalidUserError"),d=c("LaunchDarklyInvalidEventKeyError"),v=c("LaunchDarklyInvalidArgumentError"),g=c("LaunchDarklyFlagFetchError"),p=c("LaunchDarklyInvalidDataError");function m(e){return!(e>=400&&e<500)||400===e||408===e||429===e}for(var h=Object.freeze({__proto__:null,LDUnexpectedResponseError:s,LDInvalidEnvironmentIdError:l,LDInvalidUserError:f,LDInvalidEventKeyError:d,LDInvalidArgumentError:v,LDFlagFetchError:g,LDInvalidDataError:p,isHttpErrorRecoverable:m}),y=[],w=[],b="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",E=0,k=b.length;E<k;++E)y[E]=b[E],w[b.charCodeAt(E)]=E;function D(e,n,t){for(var r,o,i=[],a=n;a<t;a+=3)r=(e[a]<<16&16711680)+(e[a+1]<<8&65280)+(255&e[a+2]),i.push(y[(o=r)>>18&63]+y[o>>12&63]+y[o>>6&63]+y[63&o]);return i.join("")}w["-".charCodeAt(0)]=62,w["_".charCodeAt(0)]=63;var S=Array.isArray,O=Object.keys,P=Object.prototype.hasOwnProperty,U=["key","secondary","ip","country","email","firstName","lastName","avatar","name"];function I(e,n){return(e.endsWith("/")?e.substring(0,e.length-1):e)+(n.startsWith("/")?"":"/")+n}function j(e){return function(e){for(var n,t=e.length,r=t%3,o=[],i=0,a=t-r;i<a;i+=16383)o.push(D(e,i,i+16383>a?a:i+16383));return 1===r?(n=e[t-1],o.push(y[n>>2]+y[n<<4&63]+"==")):2===r&&(n=(e[t-2]<<8)+e[t-1],o.push(y[n>>10]+y[n>>4&63]+y[n<<2&63]+"=")),o.join("")}(function(e){for(var n=[],t=0;t<e.length;t++)n.push(e.charCodeAt(t));return n}(unescape(encodeURIComponent(e))))}function R(e){return j(e).replace(/=/g,"").replace(/\+/g,"-").replace(/\//g,"_")}function T(e){return JSON.parse(JSON.stringify(e))}function C(e,n){return function e(n,t){if(n===t)return!0;if(n&&t&&"object"==typeof n&&"object"==typeof t){var r,o,i,a=S(n),u=S(t);if(a&&u){if((o=n.length)!=t.length)return!1;for(r=o;0!=r--;)if(!e(n[r],t[r]))return!1;return!0}if(a!=u)return!1;var c=n instanceof Date,s=t instanceof Date;if(c!=s)return!1;if(c&&s)return n.getTime()==t.getTime();var l=n instanceof RegExp,f=t instanceof RegExp;if(l!=f)return!1;if(l&&f)return n.toString()==t.toString();var d=O(n);if((o=d.length)!==O(t).length)return!1;for(r=o;0!=r--;)if(!P.call(t,d[r]))return!1;for(r=o;0!=r--;)if(!e(n[i=d[r]],t[i]))return!1;return!0}return n!=n&&t!=t}(e,n)}function L(e){setTimeout(e,0)}function A(e,n){var t=e.then((function(e){return n&&setTimeout((function(){n(null,e)}),0),e}),(function(e){if(!n)return Promise.reject(e);setTimeout((function(){n(e,null)}),0)}));return n?void 0:t}function x(e){var n={};for(var t in e)V(e,t)&&(n[t]={value:e[t],version:0});return n}function F(e){var n={};for(var t in e)V(e,t)&&(n[t]=e[t].value);return n}function N(e,n){for(var t,r=n.slice(0),o=[],i=e;r.length>0;){for(t=[];i>0;){var a=r.shift();if(!a)break;(i-=R(JSON.stringify(a)).length)<0&&t.length>0?r.unshift(a):t.push(a)}i=e,o.push(t)}return o}function q(e){var n=e.version||"3.8.2";return e.userAgent+"/"+n}function _(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return t.reduce((function(e,t){return n(n({},e),t)}),{})}function V(e,n){return Object.prototype.hasOwnProperty.call(e,n)}function M(e){if(!e)return e;var t;for(var r in U){var o=U[r],i=e[o];void 0!==i&&"string"!=typeof i&&((t=t||n({},e))[o]=String(i))}return t||e}for(var z=Object.freeze({__proto__:null,appendUrlPath:I,btoa:j,base64URLEncode:R,clone:T,deepEquals:C,onNextTick:L,wrapPromiseCallback:A,transformValuesToVersionedValues:x,transformVersionedValuesToValues:F,chunkUserEventsForUrl:N,getLDUserAgentString:q,extend:_,objectHasOwnProperty:V,sanitizeUser:M}),J=function(e,n){return function(e){var n="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof window.msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto);if(n){var t=new Uint8Array(16);e.exports=function(){return n(t),t}}else{var r=new Array(16);e.exports=function(){for(var e,n=0;n<16;n++)0==(3&n)&&(e=4294967296*Math.random()),r[n]=e>>>((3&n)<<3)&255;return r}}}(n={exports:{}}),n.exports}(),$=[],H=0;H<256;++H)$[H]=(H+256).toString(16).substr(1);var K,B,G=0,X=0,W=function(e,n,t){var r=n&&t||0,o=n||[],i=(e=e||{}).node||K,a=void 0!==e.clockseq?e.clockseq:B;if(null==i||null==a){var u=J();null==i&&(i=K=[1|u[0],u[1],u[2],u[3],u[4],u[5]]),null==a&&(a=B=16383&(u[6]<<8|u[7]))}var c=void 0!==e.msecs?e.msecs:(new Date).getTime(),s=void 0!==e.nsecs?e.nsecs:X+1,l=c-G+(s-X)/1e4;if(l<0&&void 0===e.clockseq&&(a=a+1&16383),(l<0||c>G)&&void 0===e.nsecs&&(s=0),s>=1e4)throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");G=c,X=s,B=a;var f=(1e4*(268435455&(c+=122192928e5))+s)%4294967296;o[r++]=f>>>24&255,o[r++]=f>>>16&255,o[r++]=f>>>8&255,o[r++]=255&f;var d=c/4294967296*1e4&268435455;o[r++]=d>>>8&255,o[r++]=255&d,o[r++]=d>>>24&15|16,o[r++]=d>>>16&255,o[r++]=a>>>8|128,o[r++]=255&a;for(var v=0;v<6;++v)o[r+v]=i[v];return n||function(e,n){var t=n||0,r=$;return[r[e[t++]],r[e[t++]],r[e[t++]],r[e[t++]],"-",r[e[t++]],r[e[t++]],"-",r[e[t++]],r[e[t++]],"-",r[e[t++]],r[e[t++]],"-",r[e[t++]],r[e[t++]],r[e[t++]],r[e[t++]],r[e[t++]],r[e[t++]]].join("")}(o)},Q=["debug","info","warn","error","none"];function Y(e,n){if(e&&e.destination&&"function"!=typeof e.destination)throw new Error("destination for basicLogger was set to a non-function");function t(e){return function(n){console&&console[e]&&console[e].call(console,n)}}var r=e&&e.destination?[e.destination,e.destination,e.destination,e.destination]:[t("log"),t("info"),t("warn"),t("error")],o=!(!e||!e.destination),a=e&&void 0!==e.prefix&&null!==e.prefix?e.prefix:"[LaunchDarkly] ",u=1;if(e&&e.level)for(var c=0;c<Q.length;c++)Q[c]===e.level&&(u=c);function s(e,t,u){if(!(u.length<1)){var c,s=o?t+": "+a:a;if(1!==u.length&&n){var l=i(u);l[0]=s+l[0],c=n.apply(void 0,i(l))}else c=s+u[0];try{r[e](c)}catch(e){console&&console.log&&console.log("[LaunchDarkly] Configured logger's "+t+" method threw an exception: "+e)}}}for(var l={},f=function(e){var n=Q[e];if("none"!==n)if(e<u)l[n]=function(){};else{var t=e;l[n]=function(){s(t,n,arguments)}}},d=0;d<Q.length;d++)f(d);return l}function Z(e,n){return Y({level:e,prefix:n})}function ee(e){return e&&e.message?e.message:"string"==typeof e||e instanceof String?e:JSON.stringify(e)}var ne=" Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initializing-the-client for instructions on SDK initialization.",te=function(e){return'Expected application/json content type but got "'+e+'"'},re=function(e){return"local storage is unavailable: "+ee(e)},oe=function(e){return"network error"+(e?" ("+e+")":"")},ie=function(e){return'Custom event "'+e+'" does not exist'},ae=function(){return"Environment not found. Double check that you specified a valid environment/client-side ID."+ne},ue=function(){return"No environment/client-side ID was specified."+ne},ce=function(e){return"Error fetching flag settings: "+ee(e)},se=function(){return"No user specified."+ne},le=function(){return"Invalid user specified."+ne},fe=function(){return"LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly."+ne},de=function(e,n){return n?'"'+e+'" is deprecated, please use "'+n+'"':'"'+e+'" is deprecated'},ve=function(e,n,t){return"Received error "+e+(401===e?" (invalid SDK key)":"")+" for "+n+" - "+(m(e)?t:"giving up permanently")},ge=function(){return"Cannot make HTTP requests in this environment."+ne},pe=function(e){return"Opening stream connection to "+e},me=function(e,n){return"Error on stream connection: "+ee(e)+", will continue retrying after "+n+" milliseconds."},he=function(e){return"Error on stream connection ".concat(ee(e),", giving up permanently")},ye=function(e){return'Ignoring unknown config option "'+e+'"'},we=function(e,n,t){return'Config option "'+e+'" should be of type '+n+", got "+t+", using default value"},be=function(e,n){return'Config option "'+e+'" should be a boolean, got '+n+", converting to boolean"},Ee=function(e,n,t){return'Config option "'+e+'" was set to '+n+", changing to minimum value of "+t},ke=function(e){return"polling for feature flags at "+e},De=function(e){return'received streaming update for flag "'+e+'"'},Se=function(e){return'received streaming update for flag "'+e+'" but ignored due to version check'},Oe=function(e){return'received streaming deletion for flag "'+e+'"'},Pe=function(e){return'received streaming deletion for flag "'+e+'" but ignored due to version check'},Ue=function(e){return'enqueueing "'+e+'" event'},Ie=function(e){return"sending "+e+" events"},je=function(e){return'Config option "'.concat(e,'" must only contain letters, numbers, ., _ or -.')},Re=function(e,n){return'an inspector: "'.concat(n,'" of an invalid type (').concat(e,") was configured")},Te=function(e,n){return'an inspector: "'.concat(n,'" of type: "').concat(e,'" generated an exception')},Ce=function(e){return'Value of "'.concat(e,'" was longer than 64 characters and was discarded.')},Le=Object.freeze({__proto__:null,clientInitialized:function(){return"LaunchDarkly client initialized"},clientNotReady:function(){return"LaunchDarkly client is not ready"},eventCapacityExceeded:function(){return"Exceeded event queue capacity. Increase capacity to avoid dropping events."},eventWithoutUser:function(){return"Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript"},invalidContentType:te,invalidKey:function(){return"Event key must be a string"},localStorageUnavailable:re,networkError:oe,unknownCustomEventKey:ie,environmentNotFound:ae,environmentNotSpecified:ue,errorFetchingFlags:ce,userNotSpecified:se,invalidUser:le,invalidData:function(){return"Invalid data received from LaunchDarkly; connection may have been interrupted"},bootstrapOldFormat:fe,bootstrapInvalid:function(){return"LaunchDarkly bootstrap data is not available because the back end could not read the flags."},deprecated:de,httpErrorMessage:ve,httpUnavailable:ge,identifyDisabled:function(){return"identify() has no effect here; it must be called on the main client instance"},streamClosing:function(){return"Closing stream connection"},streamConnecting:pe,streamError:me,unrecoverableStreamError:he,unknownOption:ye,wrongOptionType:we,wrongOptionTypeBoolean:be,optionBelowMinimum:Ee,debugPolling:ke,debugStreamPing:function(){return"received ping message from stream"},debugStreamPut:function(){return"received streaming update for all flags"},debugStreamPatch:De,debugStreamPatchIgnored:Se,debugStreamDelete:Oe,debugStreamDeleteIgnored:Pe,debugEnqueueingEvent:Ue,debugPostingEvents:Ie,debugPostingDiagnosticEvent:function(e){return"sending diagnostic event ("+e.kind+")"},invalidTagValue:je,invalidInspector:Re,inspectorMethodError:Te,tagValueTooLong:Ce}),Ae={baseUrl:{default:"https://app.launchdarkly.com"},streamUrl:{default:"https://clientstream.launchdarkly.com"},eventsUrl:{default:"https://events.launchdarkly.com"},sendEvents:{default:!0},streaming:{type:"boolean"},sendLDHeaders:{default:!0},requestHeaderTransform:{type:"function"},inlineUsersInEvents:{default:!1},allowFrequentDuplicateEvents:{default:!1},sendEventsOnlyForVariation:{default:!1},useReport:{default:!1},evaluationReasons:{default:!1},eventCapacity:{default:100,minimum:1},flushInterval:{default:2e3,minimum:2e3},samplingInterval:{default:0,minimum:0},streamReconnectDelay:{default:1e3,minimum:0},allAttributesPrivate:{default:!1},privateAttributeNames:{default:[]},bootstrap:{type:"string|object"},diagnosticRecordingInterval:{default:9e5,minimum:2e3},diagnosticOptOut:{default:!1},wrapperName:{type:"string"},wrapperVersion:{type:"string"},stateProvider:{type:"object"},autoAliasingOptOut:{default:!1},application:{validator:function(e,n,t){var r={};return n.id&&(r.id=Fe("".concat(e,".id"),n.id,t)),n.version&&(r.version=Fe("".concat(e,".version"),n.version,t)),r}},inspectors:{default:[]}},xe=/^(\w|\.|-)+$/;function Fe(e,n,t){if("string"==typeof n&&n.match(xe)){if(!(n.length>64))return n;t.warn(Ce(e))}else t.warn(je(e))}function Ne(e,n,r,o){var i=_({logger:{default:o}},Ae,r),a={all_attributes_private:"allAttributesPrivate",private_attribute_names:"privateAttributeNames",samplingInterval:null,allowFrequentDuplicateEvents:void 0};function u(e){L((function(){n&&n.maybeReportError(new v(e))}))}var c=_({},e||{});return function(e){var n=e;Object.keys(a).forEach((function(e){if(void 0!==n[e]){var t=a[e];o&&o.warn(de(e,t)),t&&(void 0===n[t]&&(n[t]=n[e]),delete n[e])}}))}(c),function(e){Q.forEach((function(n){if("none"!==n&&(!e[n]||"function"!=typeof e[n]))throw new Error("Provided logger instance must support logger."+n+"(...) method")}))}((c=function(e){var n=_({},e),r=function(e){if(null===e)return"any";if(void 0!==e){if(Array.isArray(e))return"array";var n=t(e);return"boolean"===n||"string"===n||"number"===n||"function"===n?n:"object"}};return Object.keys(e).forEach((function(t){var a=e[t];if(null!=a){var c=i[t];if(void 0===c)u(ye(t));else{var s=c.type||r(c.default),l=c.validator;if(l){var f=l(t,e[t],o);void 0!==f?n[t]=f:delete n[t]}else if("any"!==s){var d=s.split("|"),v=r(a);d.indexOf(v)<0?"boolean"===s?(n[t]=!!a,u(be(t,v))):(u(we(t,s,v)),n[t]=c.default):"number"===v&&void 0!==c.minimum&&a<c.minimum&&(u(Ee(t,a,c.minimum)),n[t]=c.minimum)}}}})),n}(c=function(e){var n=_({},e);return Object.keys(i).forEach((function(e){void 0!==n[e]&&null!==n[e]||(n[e]=i[e]&&i[e].default)})),n}(c))).logger),c}function qe(e){var n={};return e&&(e.application&&void 0!==e.application.id&&null!==e.application.id&&(n["application-id"]=[e.application.id]),e.application&&void 0!==e.application.version&&null!==e.application.id&&(n["application-version"]=[e.application.version])),n}function _e(e,n){if(n&&!n.sendLDHeaders)return{};var t={"X-LaunchDarkly-User-Agent":q(e)};n&&n.wrapperName&&(t["X-LaunchDarkly-Wrapper"]=n.wrapperVersion?n.wrapperName+"/"+n.wrapperVersion:n.wrapperName);var r=qe(n),o=Object.keys(r);return o.length&&(t["x-launchdarkly-tags"]=o.sort().map((function(e){return Array.isArray(r[e])?r[e].sort().map((function(n){return"".concat(e,"/").concat(n)})):["".concat(e,"/").concat(r[e])]})).reduce((function(e,n){return e.concat(n)}),[]).join(" ")),t}function Ve(e,t){return t&&t.requestHeaderTransform?t.requestHeaderTransform(n({},e)):e}function Me(e,n,t){var r="/a/"+n+".gif",o=_({"Content-Type":"application/json"},_e(e,t)),i=e.httpFallbackPing,a={sendChunk:function(n,a,u,c){var s=JSON.stringify(n),l=u?null:W();return c?function n(r){var i=u?o:_({},o,{"X-LaunchDarkly-Event-Schema":"3","X-LaunchDarkly-Payload-ID":l});return e.httpRequest("POST",a,Ve(i,t),s).promise.then((function(e){if(e)return e.status>=400&&m(e.status)&&r?n(!1):function(e){var n={status:e.status},t=e.header("date");if(t){var r=Date.parse(t);r&&(n.serverTime=r)}return n}(e)})).catch((function(){return r?n(!1):Promise.reject()}))}(!0).catch((function(){})):(i&&i(a+r+"?d="+R(s)),Promise.resolve())},sendEvents:function(n,t,r){if(!e.httpRequest)return Promise.resolve();var o,i=e.httpAllowsPost();o=i?[n]:N(2e3-t.length,n);for(var u=[],c=0;c<o.length;c++)u.push(a.sendChunk(o[c],t,r,i));return Promise.all(u)}};return a}function ze(){var e={},n=0,t=0,r={};return e.summarizeEvent=function(e){if("feature"===e.kind){var o=e.key+":"+(null!==e.variation&&void 0!==e.variation?e.variation:"")+":"+(null!==e.version&&void 0!==e.version?e.version:""),i=r[o];i?i.count=i.count+1:r[o]={count:1,key:e.key,variation:e.variation,version:e.version,value:e.value,default:e.default},(0===n||e.creationDate<n)&&(n=e.creationDate),e.creationDate>t&&(t=e.creationDate)}},e.getSummary=function(){var e={},o=!0;for(var i in r){var a=r[i],u=e[a.key];u||(u={default:a.default,counters:[]},e[a.key]=u);var c={value:a.value,count:a.count};void 0!==a.variation&&null!==a.variation&&(c.variation=a.variation),a.version?c.version=a.version:c.unknown=!0,u.counters.push(c),o=!1}return o?null:{startDate:n,endDate:t,features:e}},e.clearSummary=function(){n=0,t=0,r={}},e}function Je(e){var n={},t=e.allAttributesPrivate,r=e.privateAttributeNames||[],o={key:!0,custom:!0,anonymous:!0},i={key:!0,secondary:!0,ip:!0,country:!0,email:!0,firstName:!0,lastName:!0,avatar:!0,name:!0,anonymous:!0,custom:!0};return n.filterUser=function(e){if(!e)return null;var n=e.privateAttributeNames||[],a=function(e,i){return Object.keys(e).reduce((function(a,u){var c=a;return i(u)&&(function(e){return!o[e]&&(t||-1!==n.indexOf(e)||-1!==r.indexOf(e))}(u)?c[1][u]=!0:c[0][u]=e[u]),c}),[{},{}])},u=a(e,(function(e){return i[e]})),c=u[0],s=u[1];if(e.custom){var l=a(e.custom,(function(){return!0}));c.custom=l[0],s=_({},s,l[1])}var f=Object.keys(s);return f.length&&(f.sort(),c.privateAttrs=f),c},n}function $e(e,n,t,r){var o={};function i(){var e="",o=r.getUser();return o&&(e=t||j(JSON.stringify(o))),"ld:"+n+":"+e}return o.loadFlags=function(){return e.get(i()).then((function(e){if(null==e)return null;try{var n=JSON.parse(e);if(n){var t=n.$schema;void 0===t||t<1?n=x(n):delete n.$schema}return n}catch(e){return o.clearFlags().then((function(){return null}))}}))},o.saveFlags=function(n){var t=_({},n,{$schema:1});return e.set(i(),JSON.stringify(t))},o.clearFlags=function(){return e.clear(i())},o}function He(e,n,t,r){var o,i=n.streamUrl,a=n.logger,u={},c=I(i,"/eval/"+t),s=n.useReport,l=n.evaluationReasons,f=n.streamReconnectDelay,d=_e(e,n),v=!1,g=null,p=null,h=null,y=null,w=null,b=0;function E(e){if(e.status&&"number"==typeof e.status&&!m(e.status))return S(),a.error(he(e)),void(p&&(clearTimeout(p),p=null));var n=function(){var e,n=(e=function(){var e=f*Math.pow(2,b);return e>3e4?3e4:e}())-Math.trunc(.5*Math.random()*e);return b+=1,n}();v||(a.warn(me(e,n)),v=!0),O(!1),S(),k(n)}function k(e){p||(e?p=setTimeout(D,e):D())}function D(){var r;p=null;var u="",f={headers:d,readTimeoutMillis:3e5};if(e.eventSourceFactory){for(var v in null!=y&&(u="h="+y),s?e.eventSourceAllowsReport?(r=c,f.method="REPORT",f.headers["Content-Type"]="application/json",f.body=JSON.stringify(h)):(r=I(i,"/ping/"+t),u=""):r=c+"/"+R(JSON.stringify(h)),f.headers=Ve(f.headers,n),l&&(u=u+(u?"&":"")+"withReasons=true"),r=r+(u?"?":"")+u,S(),a.info(pe(r)),o=(new Date).getTime(),g=e.eventSourceFactory(r,f),w)V(w,v)&&g.addEventListener(v,w[v]);g.onerror=E,g.onopen=function(){b=0}}}function S(){g&&(a.info("Closing stream connection"),g.close(),g=null)}function O(e){o&&r&&r.recordStreamInit(o,!e,(new Date).getTime()-o),o=null}return u.connect=function(e,n,t){h=e,y=n,w={};var r=function(e){w[e]=function(n){v=!1,O(!0),t[e]&&t[e](n)}};for(var o in t||{})r(o);k()},u.disconnect=function(){clearTimeout(p),p=null,S()},u.isConnected=function(){return!!(g&&e.eventSourceIsActive&&e.eventSourceIsActive(g))},u}function Ke(e,n,t){var r=n.baseUrl,o=n.useReport,i=n.evaluationReasons,a=n.logger,u={},c={};function s(t,r){if(!e.httpRequest)return new Promise((function(e,n){n(new g(ge()))}));var o=r?"REPORT":"GET",i=_e(e,n);r&&(i["Content-Type"]="application/json");var a=c[t];a||(a=function(e){var n,t,r,o,i={addPromise:function(i,a){n=i,t&&t(),t=a,i.then((function(t){n===i&&(r(t),e&&e())}),(function(t){n===i&&(o(t),e&&e())}))}};return i.resultPromise=new Promise((function(e,n){r=e,o=n})),i}((function(){delete c[t]})),c[t]=a);var u=e.httpRequest(o,t,Ve(i,n),r),s=u.promise.then((function(e){if(200===e.status){if(e.header("content-type")&&"application/json"===e.header("content-type").substring(0,"application/json".length))return JSON.parse(e.body);var n=te(e.header("content-type")||"");return Promise.reject(new g(n))}return Promise.reject(function(e){return 404===e.status?new l(ae()):new g(ce(e.statusText||String(e.status)))}(e))}),(function(e){return Promise.reject(new g(oe(e)))}));return a.addPromise(s,(function(){u.cancel&&u.cancel()})),a.resultPromise}return u.fetchJSON=function(e){return s(I(r,e),null)},u.fetchFlagSettings=function(e,n){var u,c,l,f="";return o?(c=[r,"/sdk/evalx/",t,"/user"].join(""),l=JSON.stringify(e)):(u=R(JSON.stringify(e)),c=[r,"/sdk/evalx/",t,"/users/",u].join("")),n&&(f="h="+n),i&&(f=f+(f?"&":"")+"withReasons=true"),c=c+(f?"?":"")+f,a.debug(ke(c)),s(c,l)},u}function Be(e){var n={validateUser:function(n){if(!n)return Promise.reject(new f(se()));var t=T(n);return null!==t.key&&void 0!==t.key?(t.key=t.key.toString(),Promise.resolve(t)):t.anonymous?e.get("ld:$anonUserId").then((function(n){if(n)return t.key=n,t;var r=W();return t.key=r,function(n){return e.set("ld:$anonUserId",n)}(r).then((function(){return t}))})):Promise.reject(new f(le()))}};return n}var Ge=Object.freeze({__proto__:null,baseOptionDefs:Ae,validate:Ne,getTags:qe}).baseOptionDefs,Xe=z.appendUrlPath,We=function(e){var n={diagnosticId:W()};return e&&(n.sdkKeySuffix=e.length>6?e.substring(e.length-6):e),n},Qe={flagUsed:"flag-used",flagDetailsChanged:"flag-details-changed",flagDetailChanged:"flag-detail-changed",clientIdentityChanged:"client-identity-changed"};function Ye(e,n){var t,o={},i=(r(t={},Qe.flagUsed,[]),r(t,Qe.flagDetailsChanged,[]),r(t,Qe.flagDetailChanged,[]),r(t,Qe.clientIdentityChanged,[]),t);return(null==e?void 0:e.map((function(e){return function(e,n){var t=!1,r={type:e.type,name:e.name,method:function(){try{e.method.apply(e,arguments)}catch(e){t||(t=!0,n.warn(Te(r.type,r.name)))}}};return r}(e,n)}))).forEach((function(e){Object.prototype.hasOwnProperty.call(i,e.type)?i[e.type].push(e):n.warn(Re(e.type,e.name))})),o.hasListeners=function(e){var n;return null===(n=i[e])||void 0===n?void 0:n.length},o.onFlagUsed=function(e,n,t){i[Qe.flagUsed].length&&L((function(){i[Qe.flagUsed].forEach((function(r){return r.method(e,n,t)}))}))},o.onFlags=function(e){i[Qe.flagDetailsChanged].length&&L((function(){i[Qe.flagDetailsChanged].forEach((function(n){return n.method(e)}))}))},o.onFlagChanged=function(e,n){i[Qe.flagDetailChanged].length&&L((function(){i[Qe.flagDetailChanged].forEach((function(t){return t.method(e,n)}))}))},o.onIdentityChanged=function(e){i[Qe.clientIdentityChanged].length&&L((function(){i[Qe.clientIdentityChanged].forEach((function(n){return n.method(e)}))}))},o}function Ze(e,r,i,a,u){var c,f,v,h=i&&i.logger?i.logger:u&&u.logger&&u.logger.default||Z("warn"),y=function(e){var n={},t={};return n.on=function(e,n,r){t[e]=t[e]||[],t[e]=t[e].concat({handler:n,context:r})},n.off=function(e,n,r){if(t[e])for(var o=0;o<t[e].length;o++)t[e][o].handler===n&&t[e][o].context===r&&(t[e]=t[e].slice(0,o).concat(t[e].slice(o+1)))},n.emit=function(e){if(t[e])for(var n=t[e].slice(0),r=0;r<n.length;r++)n[r].handler.apply(n[r].context,Array.prototype.slice.call(arguments,1))},n.getEvents=function(){return Object.keys(t)},n.getEventListenerCount=function(e){return t[e]?t[e].length:0},n.maybeReportError=function(n){n&&(t.error?this.emit("error",n):(e||console).error(n.message))},n}(h),w=function(e){var n=!1,t=!1,r=null,o=null,i=new Promise((function(n){e.on("ready",(function t(){e.off("ready",t),n()}))})).catch((function(){}));return{getInitializationPromise:function(){return o||(n?Promise.resolve():t?Promise.reject(r):o=new Promise((function(n,t){e.on("initialized",(function t(){e.off("initialized",t),n()})),e.on("failed",(function n(r){e.off("failed",n),t(r)}))})))},getReadyPromise:function(){return i},signalSuccess:function(){n||t||(n=!0,e.emit("initialized"),e.emit("ready"))},signalFailure:function(o){n||t||(t=!0,r=o,e.emit("failed",o),e.emit("ready")),e.maybeReportError(o)}}}(y),b=Ne(i,y,u,h),E=Ye(b.inspectors,h),k=b.sendEvents,D=e,S=b.hash,O=function(e,n){var t={},r=!1,o=function(e){r||(r=!0,n.warn(re(e)))};return t.isEnabled=function(){return!!e},t.get=function(n){return new Promise((function(t){e?e.get(n).then(t).catch((function(e){o(e),t(void 0)})):t(void 0)}))},t.set=function(n,t){return new Promise((function(r){e?e.set(n,t).then((function(){return r(!0)})).catch((function(e){o(e),r(!1)})):r(!1)}))},t.clear=function(n){return new Promise((function(t){e?e.clear(n).then((function(){return t(!0)})).catch((function(e){o(e),t(!1)})):t(!1)}))},t}(a.localStorage,h),P=Me(a,D,b),U=b.sendEvents&&!b.diagnosticOptOut,j=U?We(D):null,R=U?function(e){var n,t,r,o;function i(e){n=e,t=0,r=0,o=[]}return i(e),{getProps:function(){return{dataSinceDate:n,droppedEvents:t,eventsInLastBatch:r,streamInits:o}},setProps:function(e){n=e.dataSinceDate,t=e.droppedEvents||0,r=e.eventsInLastBatch||0,o=e.streamInits||[]},incrementDroppedEvents:function(){t++},setEventsInLastBatch:function(e){r=e},recordStreamInit:function(e,n,t){var r={timestamp:e,failed:n,durationMillis:t};o.push(r)},reset:i}}((new Date).getTime()):null,x=U?function(e,t,r,o,i,a,u){var c,s,l=!!e.diagnosticUseCombinedEvent,f="ld:"+i+":$diagnostics",d=Xe(a.eventsUrl,"/events/diagnostic/"+i),v=a.diagnosticRecordingInterval,g=r,p=!!a.streaming,m={};function h(){return{sdk:b(),configuration:(n={customBaseURI:a.baseUrl!==Ge.baseUrl.default,customStreamURI:a.streamUrl!==Ge.streamUrl.default,customEventsURI:a.eventsUrl!==Ge.eventsUrl.default,eventsCapacity:a.eventCapacity,eventsFlushIntervalMillis:a.flushInterval,reconnectTimeMillis:a.streamReconnectDelay,streamingDisabled:!p,allAttributesPrivate:!!a.allAttributesPrivate,inlineUsersInEvents:!!a.inlineUsersInEvents,diagnosticRecordingIntervalMillis:a.diagnosticRecordingInterval,usingSecureMode:!!a.hash,bootstrapMode:!!a.bootstrap,fetchGoalsDisabled:!a.fetchGoals,sendEventsOnlyForVariation:!!a.sendEventsOnlyForVariation,autoAliasingOptOut:!!a.autoAliasingOptOut},n),platform:e.diagnosticPlatformData};var n}function y(e){a.logger&&a.logger.debug(Le.debugPostingDiagnosticEvent(e)),o.sendEvents(e,d,!0).then((function(){})).catch((function(){}))}function w(){var e,r;y((e=(new Date).getTime(),r=n({kind:l?"diagnostic-combined":"diagnostic",id:u,creationDate:e},g.getProps()),l&&(r=n(n({},r),h())),g.reset(e),r)),s=setTimeout(w,v),c=(new Date).getTime(),l&&function(){if(t.isEnabled()){var e=n({},g.getProps());t.set(f,JSON.stringify(e))}}()}function b(){var t=n({},e.diagnosticSdkData);return a.wrapperName&&(t.wrapperName=a.wrapperName),a.wrapperVersion&&(t.wrapperVersion=a.wrapperVersion),t}return m.start=function(){l?function(e){if(!t.isEnabled())return e(!1);t.get(f).then((function(n){if(n)try{var t=JSON.parse(n);g.setProps(t),c=t.dataSinceDate}catch(e){}e(!0)})).catch((function(){e(!1)}))}((function(e){if(e){var n=(c||0)+v,t=(new Date).getTime();t>=n?w():s=setTimeout(w,n-t)}else 0===Math.floor(4*Math.random())?w():s=setTimeout(w,v)})):(y(n({kind:"diagnostic-init",id:u,creationDate:g.getProps().dataSinceDate},h())),s=setTimeout(w,v))},m.stop=function(){s&&clearTimeout(s)},m.setStreaming=function(e){p=e},m}(a,O,R,P,D,b,j):null,N=He(a,b,D,R),q=b.eventProcessor||function(e,n,t){var r,o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:null,a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:null,u={},c=a||Me(e,t,n),l=I(n.eventsUrl,"/events/bulk/"+t),f=ze(),d=Je(n),v=n.inlineUsersInEvents,g=n.samplingInterval,p=n.eventCapacity,h=n.flushInterval,y=n.logger,w=[],b=0,E=!1,k=!1;function D(){return 0===g||0===Math.floor(Math.random()*g)}function S(e){return!!e.debugEventsUntilDate&&e.debugEventsUntilDate>b&&e.debugEventsUntilDate>(new Date).getTime()}function O(e){var n=_({},e);return"alias"===e.kind||(v||"identify"===e.kind?n.user=d.filterUser(e.user):(n.userKey=e.user.key,delete n.user),"feature"===e.kind&&(delete n.trackEvents,delete n.debugEventsUntilDate)),n}function P(e){w.length<p?(w.push(e),k=!1):(k||(k=!0,y.warn("Exceeded event queue capacity. Increase capacity to avoid dropping events.")),o&&o.incrementDroppedEvents())}return u.enqueue=function(e){if(!E){var n=!1,t=!1;if(f.summarizeEvent(e),"feature"===e.kind?D()&&(n=!!e.trackEvents,t=S(e)):n=D(),n&&P(O(e)),t){var r=_({},e,{kind:"debug"});r.user=d.filterUser(r.user),delete r.trackEvents,delete r.debugEventsUntilDate,P(r)}}},u.flush=function(){if(E)return Promise.resolve();var e=w,n=f.getSummary();return f.clearSummary(),n&&(n.kind="summary",e.push(n)),o&&o.setEventsInLastBatch(e.length),0===e.length?Promise.resolve():(w=[],y.debug(Ie(e.length)),c.sendEvents(e,l).then((function(e){e&&(e.serverTime&&(b=e.serverTime),m(e.status)||(E=!0),e.status>=400&&L((function(){i.maybeReportError(new s(ve(e.status,"event posting","some events were dropped")))})))})))},u.start=function(){r=setTimeout((function e(){u.flush(),r=setTimeout(e,h)}),h)},u.stop=function(){clearTimeout(r)},u}(a,b,D,R,y,P),z=Ke(a,b,D),J={},$=b.streaming,H=!1,K=!1,B=!0,G=b.stateProvider,X=function(e,n){var t,r={setUser:function(e){var r=t&&T(t);(t=M(e))&&n&&n(T(t),r)},getUser:function(){return t?T(t):null}};return r}(0,(function(e,n){(function(e){G||e&&Y({kind:"identify",key:e.key,user:e,creationDate:(new Date).getTime()})})(e),!b.autoAliasingOptOut&&n&&n.anonymous&&e&&!e.anonymous&&le(e,n),E.hasListeners(Qe.clientIdentityChanged)&&E.onIdentityChanged(X.getUser())})),W=Be(O),Q=O.isEnabled()?new $e(O,D,S,X):null;function Y(e){if(D&&!(G&&G.enqueueEvent&&G.enqueueEvent(e))){if("alias"!==e.kind){if(!e.user)return void(B&&(h.warn("Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript"),B=!1));B=!1}!k||K||a.isDoNotTrack()||(h.debug(Ue(e.kind)),q.enqueue(e))}}function ee(e,n){E.hasListeners(Qe.flagDetailChanged)&&E.onFlagChanged(e.key,ae(n))}function ne(){E.hasListeners(Qe.flagDetailsChanged)&&E.onFlags(Object.entries(J).map((function(e){var n=o(e,2);return{key:n[0],detail:ae(n[1])}})).reduce((function(e,n){return e[n.key]=n.detail,e}),{}))}function te(e,n,t,r){var o=X.getUser(),i=new Date,a={kind:"feature",key:e,user:o,value:n?n.value:null,variation:n?n.variationIndex:null,default:t,creationDate:i.getTime()};o&&o.anonymous&&(a.contextKind=se(o));var u=J[e];u&&(a.version=u.flagVersion?u.flagVersion:u.version,a.trackEvents=u.trackEvents,a.debugEventsUntilDate=u.debugEventsUntilDate),(r||u&&u.trackReason)&&n&&(a.reason=n.reason),Y(a)}function oe(e,n,t,r,o){var i;if(J&&V(J,e)&&J[e]&&!J[e].deleted){var a=J[e];i=ae(a),null!==a.value&&void 0!==a.value||(i.value=n)}else i={value:n,variationIndex:null,reason:{kind:"ERROR",errorKind:"FLAG_NOT_FOUND"}};return t&&te(e,i,n,r),o||function(e,n){E.hasListeners(Qe.flagUsed)&&E.onFlagUsed(e,n,X.getUser())}(e,i),i}function ae(e){return{value:e.value,variationIndex:void 0===e.variation?null:e.variation,reason:e.reason||null}}function se(e){return e.anonymous?"anonymousUser":"user"}function le(e,n){G||e&&n&&Y({kind:"alias",key:e.key,contextKind:se(e),previousKey:n.key,previousContextKind:se(n),creationDate:(new Date).getTime()})}function de(){if(f=!0,X.getUser()){var e=function(e){try{return JSON.parse(e)}catch(e){return void y.maybeReportError(new p("Invalid data received from LaunchDarkly; connection may have been interrupted"))}};N.connect(X.getUser(),S,{ping:function(){h.debug("received ping message from stream");var e=X.getUser();z.fetchFlagSettings(e,S).then((function(n){C(e,X.getUser())&&pe(n||{})})).catch((function(e){y.maybeReportError(new g(ce(e)))}))},put:function(n){var t=e(n.data);t&&(h.debug("received streaming update for all flags"),pe(t))},patch:function(n){var t=e(n.data);if(t){var r=J[t.key];if(!r||!r.version||!t.version||r.version<t.version){h.debug(De(t.key));var o={},i=_({},t);delete i.key,J[t.key]=i;var a=ae(i);o[t.key]=r?{previous:r.value,current:a}:{current:a},me(o),ee(t,i)}else h.debug(Se(t.key))}},delete:function(n){var t=e(n.data);if(t)if(!J[t.key]||J[t.key].version<t.version){h.debug(Oe(t.key));var r={};J[t.key]&&!J[t.key].deleted&&(r[t.key]={previous:J[t.key].value}),J[t.key]={version:t.version,deleted:!0},ee(t,J[t.key]),me(r)}else h.debug(Pe(t.key))}})}}function ge(){f&&(N.disconnect(),f=!1)}function pe(e){var t={};if(!e)return Promise.resolve();for(var r in J)V(J,r)&&J[r]&&(e[r]&&!C(e[r].value,J[r].value)?t[r]={previous:J[r].value,current:ae(e[r])}:e[r]&&!e[r].deleted||(t[r]={previous:J[r].value}));for(var o in e)V(e,o)&&e[o]&&(!J[o]||J[o].deleted)&&(t[o]={current:ae(e[o])});return J=n({},e),ne(),me(t).catch((function(){}))}function me(e){var n=Object.keys(e);if(n.length>0){var t={};n.forEach((function(n){var r=e[n].current,o=r?r.value:void 0,i=e[n].previous;y.emit("change:"+n,o,i),t[n]=r?{current:o,previous:i}:{previous:i}})),y.emit("change",t),y.emit("internal-change",J),b.sendEventsOnlyForVariation||G||n.forEach((function(n){te(n,e[n].current)}))}return c&&Q?Q.saveFlags(J):Promise.resolve()}function he(){var e=$||v&&void 0===$;e&&!f?de():!e&&f&&ge(),x&&x.setStreaming(e)}function ye(e){return"change"===e||"change:"===e.substr(0,"change".length+1)}if("string"==typeof b.bootstrap&&"LOCALSTORAGE"===b.bootstrap.toUpperCase()&&(Q?c=!0:h.warn(re())),"object"===t(b.bootstrap)&&(J=function(e){var n=Object.keys(e),t=e.$flagsState;!t&&n.length&&h.warn(fe()),!1===e.$valid&&h.warn("LaunchDarkly bootstrap data is not available because the back end could not read the flags.");var r={};return n.forEach((function(n){if("$flagsState"!==n&&"$valid"!==n){var o={value:e[n]};t&&t[n]?o=_(o,t[n]):o.version=0,r[n]=o}})),r}(b.bootstrap)),G){var we=G.getInitialState();we?be(we):G.on("init",be),G.on("update",(function(e){e.user&&X.setUser(e.user),e.flags&&pe(e.flags)}))}else(e?W.validateUser(r).then((function(e){return X.setUser(e),"object"===t(b.bootstrap)?Ee():c?Q.loadFlags().then((function(e){return null==e?(J={},z.fetchFlagSettings(X.getUser(),S).then((function(e){return pe(e||{})})).then(Ee).catch((function(e){ke(new g(ce(e)))}))):(J=e,L(Ee),z.fetchFlagSettings(X.getUser(),S).then((function(e){return pe(e)})).catch((function(e){return y.maybeReportError(e)})))})):z.fetchFlagSettings(X.getUser(),S).then((function(e){J=e||{},ne(),Ee()})).catch((function(e){J={},ke(e)}))})):Promise.reject(new l(ue()))).catch(ke);function be(e){D=e.environment,X.setUser(e.user),J=n({},e.flags),L(Ee)}function Ee(){h.info("LaunchDarkly client initialized"),H=!0,he(),w.signalSuccess()}function ke(e){w.signalFailure(e)}return{client:{waitForInitialization:function(){return w.getInitializationPromise()},waitUntilReady:function(){return w.getReadyPromise()},identify:function(e,n,t){return K?A(Promise.resolve({}),t):G?(h.warn("identify() has no effect here; it must be called on the main client instance"),A(Promise.resolve(F(J)),t)):A((c&&Q?Q.clearFlags():Promise.resolve()).then((function(){return W.validateUser(e)})).then((function(e){return z.fetchFlagSettings(e,n).then((function(t){var r=F(t);return X.setUser(e),S=n,t?pe(t).then((function(){return r})):r}))})).then((function(e){return f&&de(),e})).catch((function(e){return y.maybeReportError(e),Promise.reject(e)})),t)},getUser:function(){return X.getUser()},variation:function(e,n){return oe(e,n,!0,!1,!1).value},variationDetail:function(e,n){return oe(e,n,!0,!0,!1)},track:function(e,n,t){if("string"==typeof e){a.customEventFilter&&!a.customEventFilter(e)&&h.warn(ie(e));var r=X.getUser(),o={kind:"custom",key:e,user:r,url:a.getCurrentUrl(),creationDate:(new Date).getTime()};r&&r.anonymous&&(o.contextKind=se(r)),null!=n&&(o.data=n),null!=t&&(o.metricValue=t),Y(o)}else y.maybeReportError(new d(ie(e)))},alias:le,on:function(e,n,t){ye(e)?(v=!0,H&&he(),y.on(e,n,t)):y.on.apply(y,arguments)},off:function(e){if(y.off.apply(y,arguments),ye(e)){var n=!1;y.getEvents().forEach((function(e){ye(e)&&y.getEventListenerCount(e)>0&&(n=!0)})),n||(v=!1,f&&void 0===$&&ge())}},setStreaming:function(e){var n=null===e?void 0:e;n!==$&&($=n,he())},flush:function(e){return A(k?q.flush():Promise.resolve(),e)},allFlags:function(){var e={};if(!J)return e;for(var n in J)V(J,n)&&!J[n].deleted&&(e[n]=oe(n,null,!b.sendEventsOnlyForVariation,!1,!0).value);return e},close:function(e){if(K)return A(Promise.resolve(),e);var n=function(){K=!0,J={}};return A(Promise.resolve().then((function(){if(ge(),x&&x.stop(),k)return q.stop(),q.flush()})).then(n).catch(n),e)}},options:b,emitter:y,ident:X,logger:h,requestor:z,start:function(){k&&(x&&x.start(),q.start())},enqueueEvent:Y,getFlagsInternal:function(){return J},getEnvironmentId:function(){return D},internalChangeEventName:"internal-change"}}Object.freeze(Qe);function en(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function nn(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?en(Object(t),!0).forEach((function(n){tn(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):en(Object(t)).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function tn(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var rn=Object.freeze({__proto__:null,commonBasicLogger:Y,createConsoleLogger:Z,get errors(){return h},initialize:Ze,messages:Le,utils:z,version:"3.8.2"}).commonBasicLogger;var on=function(e){return rn(nn({destination:console.log},e))};var an={promise:Promise.resolve({status:200,header:function(){return null},body:null})};function un(e,n,t,r,o){if(o&&!function(){var e=window.navigator&&window.navigator.userAgent;if(e){var n=e.match(/Chrom(e|ium)\/([0-9]+)\./);if(n)return parseInt(n[2],10)<73}return!0}())return an;var i=new window.XMLHttpRequest;for(var a in i.open(e,n,!o),t||{})Object.prototype.hasOwnProperty.call(t,a)&&i.setRequestHeader(a,t[a]);if(o)return i.send(r),an;var u,c=new Promise((function(e,n){i.addEventListener("load",(function(){u||e({status:i.status,header:function(e){return i.getResponseHeader(e)},body:i.responseText})})),i.addEventListener("error",(function(){u||n(new Error)})),i.send(r)}));return{promise:c,cancel:function(){u=!0,i.abort()}}}function cn(e){var n,t={synchronousFlush:!1};if(window.XMLHttpRequest){var r=e&&e.disableSyncEventPost;t.httpRequest=function(e,n,o,i){var a=t.synchronousFlush&!r;return t.synchronousFlush=!1,un(e,n,o,i,a)}}t.httpAllowsPost=function(){return void 0===n&&(n=!!window.XMLHttpRequest&&"withCredentials"in new window.XMLHttpRequest),n},t.httpFallbackPing=function(e){(new window.Image).src=e};var o,i=e&&e.eventUrlTransformer;t.getCurrentUrl=function(){return i?i(window.location.href):window.location.href},t.isDoNotTrack=function(){var e;return 1===(e=window.navigator&&void 0!==window.navigator.doNotTrack?window.navigator.doNotTrack:window.navigator&&void 0!==window.navigator.msDoNotTrack?window.navigator.msDoNotTrack:window.doNotTrack)||!0===e||"1"===e||"yes"===e};try{window.localStorage&&(t.localStorage={get:function(e){return new Promise((function(n){n(window.localStorage.getItem(e))}))},set:function(e,n){return new Promise((function(t){window.localStorage.setItem(e,n),t()}))},clear:function(e){return new Promise((function(n){window.localStorage.removeItem(e),n()}))}})}catch(e){t.localStorage=null}if(e&&e.useReport&&"function"==typeof window.EventSourcePolyfill&&window.EventSourcePolyfill.supportedOptions&&window.EventSourcePolyfill.supportedOptions.method?(t.eventSourceAllowsReport=!0,o=window.EventSourcePolyfill):(t.eventSourceAllowsReport=!1,o=window.EventSource),window.EventSource){var a=3e5;t.eventSourceFactory=function(e,n){var t=nn(nn({},{heartbeatTimeout:a,silentTimeout:a,skipDefaultHeaders:!0}),n);return new o(e,t)},t.eventSourceIsActive=function(e){return e.readyState===window.EventSource.OPEN||e.readyState===window.EventSource.CONNECTING}}return t.userAgent="JSClient",t.version="2.24.2",t.diagnosticSdkData={name:"js-client-sdk",version:"2.24.2"},t.diagnosticPlatformData={name:"JS"},t.diagnosticUseCombinedEvent=!0,t}var sn=e=>{if("string"!=typeof e)throw new TypeError("Expected a string");return e.replace(/[|\\{}()[\]^$+*?.]/g,"\\$&").replace(/-/g,"\\x2d")};function ln(e,n,t,r){var o,i,a=(("substring"===e.kind||"regex"===e.kind)&&r.includes("/")?n:n.replace(r,"")).replace(t,"");switch(e.kind){case"exact":i=n,o=new RegExp("^"+sn(e.url)+"/?$");break;case"canonical":i=a,o=new RegExp("^"+sn(e.url)+"/?$");break;case"substring":i=a,o=new RegExp(".*"+sn(e.substring)+".*$");break;case"regex":i=a,o=new RegExp(e.pattern);break;default:return!1}return o.test(i)}function fn(e,n){for(var t={},r=null,o=[],i=0;i<e.length;i++)for(var a=e[i],u=a.urls||[],c=0;c<u.length;c++)if(ln(u[c],window.location.href,window.location.search,window.location.hash)){"pageview"===a.kind?n("pageview",a):(o.push(a),n("click_pageview",a));break}return o.length>0&&(r=function(e){for(var t=function(e,n){for(var t=[],r=0;r<n.length;r++)for(var o=e.target,i=n[r],a=i.selector,u=document.querySelectorAll(a);o&&u.length>0;){for(var c=0;c<u.length;c++)o===u[c]&&t.push(i);o=o.parentNode}return t}(e,o),r=0;r<t.length;r++)n("click",t[r])},document.addEventListener("click",r)),t.dispose=function(){document.removeEventListener("click",r)},t}function dn(e,n){var t,r;function o(){r&&r.dispose(),t&&t.length&&(r=fn(t,i))}function i(n,t){var r=e.ident.getUser(),o={kind:n,key:t.key,data:null,url:window.location.href,user:r,creationDate:(new Date).getTime()};return r&&r.anonymous&&(o.contextKind="anonymousUser"),"click"===n&&(o.selector=t.selector),e.enqueueEvent(o)}return e.requestor.fetchJSON("/sdk/goals/"+e.getEnvironmentId()).then((function(e){e&&e.length>0&&(r=fn(t=e,i),function(e,n){var t,r=window.location.href;function o(){(t=window.location.href)!==r&&(r=t,n())}!function e(n,t){n(),setTimeout((function(){e(n,t)}),t)}(o,e),window.history&&window.history.pushState?window.addEventListener("popstate",o):window.addEventListener("hashchange",o)}(300,o)),n()})).catch((function(t){e.emitter.maybeReportError(new h.LDUnexpectedResponseError((t&&t.message,t.message))),n()})),{}}var vn={fetchGoals:{default:!0},hash:{type:"string"},eventProcessor:{type:"object"},eventUrlTransformer:{type:"function"},disableSyncEventPost:{default:!1}};function gn(e,n){var t=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=cn(t),o=Ze(e,n,t,r,vn),i=o.client,a=o.options,u=o.emitter,c=new Promise((function(e){var n=u.on("goalsReady",(function(){u.off("goalsReady",n),e()}))}));i.waitUntilGoalsReady=function(){return c},a.fetchGoals?dn(o,(function(){return u.emit("goalsReady")})):u.emit("goalsReady"),"complete"!==document.readyState?window.addEventListener("load",o.start):o.start();var s=function(){r.synchronousFlush=!0,i.flush().catch((function(){})),r.synchronousFlush=!1};return window.addEventListener("beforeunload",s),window.addEventListener("unload",s),i}var pn=on,mn=Z,hn="2.24.2";var yn={initialize:function(e,n){var t=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return console&&console.warn&&console.warn(Le.deprecated("default export","named LDClient export")),gn(e,n,t)},version:"2.24.2"};
//# sourceMappingURL=ldclient.es.js.map


/***/ }),

/***/ 8122:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsAstral = '[' + rsAstralRange + ']',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
  rsUpper + '+' + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = camelCase;


/***/ }),

/***/ 26499:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = (function() {

// private property
var f = String.fromCharCode;
var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
var baseReverseDic = {};

function getBaseValue(alphabet, character) {
  if (!baseReverseDic[alphabet]) {
    baseReverseDic[alphabet] = {};
    for (var i=0 ; i<alphabet.length ; i++) {
      baseReverseDic[alphabet][alphabet.charAt(i)] = i;
    }
  }
  return baseReverseDic[alphabet][character];
}

var LZString = {
  compressToBase64 : function (input) {
    if (input == null) return "";
    var res = LZString._compress(input, 6, function(a){return keyStrBase64.charAt(a);});
    switch (res.length % 4) { // To produce valid Base64
    default: // When could this happen ?
    case 0 : return res;
    case 1 : return res+"===";
    case 2 : return res+"==";
    case 3 : return res+"=";
    }
  },

  decompressFromBase64 : function (input) {
    if (input == null) return "";
    if (input == "") return null;
    return LZString._decompress(input.length, 32, function(index) { return getBaseValue(keyStrBase64, input.charAt(index)); });
  },

  compressToUTF16 : function (input) {
    if (input == null) return "";
    return LZString._compress(input, 15, function(a){return f(a+32);}) + " ";
  },

  decompressFromUTF16: function (compressed) {
    if (compressed == null) return "";
    if (compressed == "") return null;
    return LZString._decompress(compressed.length, 16384, function(index) { return compressed.charCodeAt(index) - 32; });
  },

  //compress into uint8array (UCS-2 big endian format)
  compressToUint8Array: function (uncompressed) {
    var compressed = LZString.compress(uncompressed);
    var buf=new Uint8Array(compressed.length*2); // 2 bytes per character

    for (var i=0, TotalLen=compressed.length; i<TotalLen; i++) {
      var current_value = compressed.charCodeAt(i);
      buf[i*2] = current_value >>> 8;
      buf[i*2+1] = current_value % 256;
    }
    return buf;
  },

  //decompress from uint8array (UCS-2 big endian format)
  decompressFromUint8Array:function (compressed) {
    if (compressed===null || compressed===undefined){
        return LZString.decompress(compressed);
    } else {
        var buf=new Array(compressed.length/2); // 2 bytes per character
        for (var i=0, TotalLen=buf.length; i<TotalLen; i++) {
          buf[i]=compressed[i*2]*256+compressed[i*2+1];
        }

        var result = [];
        buf.forEach(function (c) {
          result.push(f(c));
        });
        return LZString.decompress(result.join(''));

    }

  },


  //compress into a string that is already URI encoded
  compressToEncodedURIComponent: function (input) {
    if (input == null) return "";
    return LZString._compress(input, 6, function(a){return keyStrUriSafe.charAt(a);});
  },

  //decompress from an output of compressToEncodedURIComponent
  decompressFromEncodedURIComponent:function (input) {
    if (input == null) return "";
    if (input == "") return null;
    input = input.replace(/ /g, "+");
    return LZString._decompress(input.length, 32, function(index) { return getBaseValue(keyStrUriSafe, input.charAt(index)); });
  },

  compress: function (uncompressed) {
    return LZString._compress(uncompressed, 16, function(a){return f(a);});
  },
  _compress: function (uncompressed, bitsPerChar, getCharFromInt) {
    if (uncompressed == null) return "";
    var i, value,
        context_dictionary= {},
        context_dictionaryToCreate= {},
        context_c="",
        context_wc="",
        context_w="",
        context_enlargeIn= 2, // Compensate for the first entry which should not count
        context_dictSize= 3,
        context_numBits= 2,
        context_data=[],
        context_data_val=0,
        context_data_position=0,
        ii;

    for (ii = 0; ii < uncompressed.length; ii += 1) {
      context_c = uncompressed.charAt(ii);
      if (!Object.prototype.hasOwnProperty.call(context_dictionary,context_c)) {
        context_dictionary[context_c] = context_dictSize++;
        context_dictionaryToCreate[context_c] = true;
      }

      context_wc = context_w + context_c;
      if (Object.prototype.hasOwnProperty.call(context_dictionary,context_wc)) {
        context_w = context_wc;
      } else {
        if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate,context_w)) {
          if (context_w.charCodeAt(0)<256) {
            for (i=0 ; i<context_numBits ; i++) {
              context_data_val = (context_data_val << 1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
            }
            value = context_w.charCodeAt(0);
            for (i=0 ; i<8 ; i++) {
              context_data_val = (context_data_val << 1) | (value&1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          } else {
            value = 1;
            for (i=0 ; i<context_numBits ; i++) {
              context_data_val = (context_data_val << 1) | value;
              if (context_data_position ==bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = 0;
            }
            value = context_w.charCodeAt(0);
            for (i=0 ; i<16 ; i++) {
              context_data_val = (context_data_val << 1) | (value&1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          }
          context_enlargeIn--;
          if (context_enlargeIn == 0) {
            context_enlargeIn = Math.pow(2, context_numBits);
            context_numBits++;
          }
          delete context_dictionaryToCreate[context_w];
        } else {
          value = context_dictionary[context_w];
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }


        }
        context_enlargeIn--;
        if (context_enlargeIn == 0) {
          context_enlargeIn = Math.pow(2, context_numBits);
          context_numBits++;
        }
        // Add wc to the dictionary.
        context_dictionary[context_wc] = context_dictSize++;
        context_w = String(context_c);
      }
    }

    // Output the code for w.
    if (context_w !== "") {
      if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate,context_w)) {
        if (context_w.charCodeAt(0)<256) {
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
          }
          value = context_w.charCodeAt(0);
          for (i=0 ; i<8 ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }
        } else {
          value = 1;
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1) | value;
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = 0;
          }
          value = context_w.charCodeAt(0);
          for (i=0 ; i<16 ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }
        }
        context_enlargeIn--;
        if (context_enlargeIn == 0) {
          context_enlargeIn = Math.pow(2, context_numBits);
          context_numBits++;
        }
        delete context_dictionaryToCreate[context_w];
      } else {
        value = context_dictionary[context_w];
        for (i=0 ; i<context_numBits ; i++) {
          context_data_val = (context_data_val << 1) | (value&1);
          if (context_data_position == bitsPerChar-1) {
            context_data_position = 0;
            context_data.push(getCharFromInt(context_data_val));
            context_data_val = 0;
          } else {
            context_data_position++;
          }
          value = value >> 1;
        }


      }
      context_enlargeIn--;
      if (context_enlargeIn == 0) {
        context_enlargeIn = Math.pow(2, context_numBits);
        context_numBits++;
      }
    }

    // Mark the end of the stream
    value = 2;
    for (i=0 ; i<context_numBits ; i++) {
      context_data_val = (context_data_val << 1) | (value&1);
      if (context_data_position == bitsPerChar-1) {
        context_data_position = 0;
        context_data.push(getCharFromInt(context_data_val));
        context_data_val = 0;
      } else {
        context_data_position++;
      }
      value = value >> 1;
    }

    // Flush the last char
    while (true) {
      context_data_val = (context_data_val << 1);
      if (context_data_position == bitsPerChar-1) {
        context_data.push(getCharFromInt(context_data_val));
        break;
      }
      else context_data_position++;
    }
    return context_data.join('');
  },

  decompress: function (compressed) {
    if (compressed == null) return "";
    if (compressed == "") return null;
    return LZString._decompress(compressed.length, 32768, function(index) { return compressed.charCodeAt(index); });
  },

  _decompress: function (length, resetValue, getNextValue) {
    var dictionary = [],
        next,
        enlargeIn = 4,
        dictSize = 4,
        numBits = 3,
        entry = "",
        result = [],
        i,
        w,
        bits, resb, maxpower, power,
        c,
        data = {val:getNextValue(0), position:resetValue, index:1};

    for (i = 0; i < 3; i += 1) {
      dictionary[i] = i;
    }

    bits = 0;
    maxpower = Math.pow(2,2);
    power=1;
    while (power!=maxpower) {
      resb = data.val & data.position;
      data.position >>= 1;
      if (data.position == 0) {
        data.position = resetValue;
        data.val = getNextValue(data.index++);
      }
      bits |= (resb>0 ? 1 : 0) * power;
      power <<= 1;
    }

    switch (next = bits) {
      case 0:
          bits = 0;
          maxpower = Math.pow(2,8);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
        c = f(bits);
        break;
      case 1:
          bits = 0;
          maxpower = Math.pow(2,16);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
        c = f(bits);
        break;
      case 2:
        return "";
    }
    dictionary[3] = c;
    w = c;
    result.push(c);
    while (true) {
      if (data.index > length) {
        return "";
      }

      bits = 0;
      maxpower = Math.pow(2,numBits);
      power=1;
      while (power!=maxpower) {
        resb = data.val & data.position;
        data.position >>= 1;
        if (data.position == 0) {
          data.position = resetValue;
          data.val = getNextValue(data.index++);
        }
        bits |= (resb>0 ? 1 : 0) * power;
        power <<= 1;
      }

      switch (c = bits) {
        case 0:
          bits = 0;
          maxpower = Math.pow(2,8);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }

          dictionary[dictSize++] = f(bits);
          c = dictSize-1;
          enlargeIn--;
          break;
        case 1:
          bits = 0;
          maxpower = Math.pow(2,16);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
          dictionary[dictSize++] = f(bits);
          c = dictSize-1;
          enlargeIn--;
          break;
        case 2:
          return result.join('');
      }

      if (enlargeIn == 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits++;
      }

      if (dictionary[c]) {
        entry = dictionary[c];
      } else {
        if (c === dictSize) {
          entry = w + w.charAt(0);
        } else {
          return null;
        }
      }
      result.push(entry);

      // Add w+entry[0] to the dictionary.
      dictionary[dictSize++] = w + entry.charAt(0);
      enlargeIn--;

      w = entry;

      if (enlargeIn == 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits++;
      }

    }
  }
};
  return LZString;
})();

if (true) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () { return LZString; }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {}


/***/ }),

/***/ 89454:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["Z"] = (memoizeOne);


/***/ }),

/***/ 18463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isodate = __webpack_require__(87956);
var milliseconds = __webpack_require__(89430);
var seconds = __webpack_require__(85533);

var objProto = Object.prototype;
var toStr = objProto.toString;

function isDate(value) {
  return toStr.call(value) === "[object Date]";
}

function isNumber(value) {
  return toStr.call(value) === "[object Number]";
}

/**
 * Returns a new Javascript Date object, allowing a variety of extra input types
 * over the native Date constructor.
 *
 * @param {Date|string|number} val
 */
module.exports = function newDate(val) {
  if (isDate(val)) return val;
  if (isNumber(val)) return new Date(toMs(val));

  // date strings
  if (isodate.is(val)) {
    return isodate.parse(val);
  }
  if (milliseconds.is(val)) {
    return milliseconds.parse(val);
  }
  if (seconds.is(val)) {
    return seconds.parse(val);
  }

  // fallback to Date.parse
  return new Date(val);
};

/**
 * If the number passed val is seconds from the epoch, turn it into milliseconds.
 * Milliseconds would be greater than 31557600000 (December 31, 1970).
 *
 * @param {number} num
 */
function toMs(num) {
  if (num < 31557600000) return num * 1000;
  return num;
}


/***/ }),

/***/ 89430:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


/**
 * Matcher.
 */

var matcher = /\d{13}/;

/**
 * Check whether a string is a millisecond date string.
 *
 * @param {string} string
 * @return {boolean}
 */
exports.is = function (string) {
  return matcher.test(string);
};

/**
 * Convert a millisecond string to a date.
 *
 * @param {string} millis
 * @return {Date}
 */
exports.parse = function (millis) {
  millis = parseInt(millis, 10);
  return new Date(millis);
};


/***/ }),

/***/ 85533:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


/**
 * Matcher.
 */

var matcher = /\d{10}/;

/**
 * Check whether a string is a second date string.
 *
 * @param {string} string
 * @return {Boolean}
 */
exports.is = function (string) {
  return matcher.test(string);
};

/**
 * Convert a second string to a date.
 *
 * @param {string} seconds
 * @return {Date}
 */
exports.parse = function (seconds) {
  var millis = parseInt(seconds, 10) * 1000;
  return new Date(millis);
};


/***/ }),

/***/ 6957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(47564)


/***/ }),

/***/ 75785:
/***/ (function(module) {

"use strict";

/* globals self */ var fetch = self.fetch.bind(self);
module.exports = fetch;
module.exports["default"] = module.exports;

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 42898:
/***/ (function(module) {

"use strict";

var assign = Object.assign.bind(Object);
function g() {
    return assign;
}
Object.defineProperties(g(), {
    implementation: {
        get: g
    },
    shim: {
        value: g
    },
    getPolyfill: {
        value: g
    }
});
module.exports = g();

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 94562:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(67413);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 81878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FG": function() { return /* binding */ updateCustomerRecord; },
/* harmony export */   "H5": function() { return /* binding */ resolveOwner; },
/* harmony export */   "Ir": function() { return /* binding */ requestOwner; },
/* harmony export */   "LC": function() { return /* binding */ getLinkedCustomerMobile; },
/* harmony export */   "LS": function() { return /* binding */ mergeAccounts; },
/* harmony export */   "Pt": function() { return /* binding */ getActivatedLead; },
/* harmony export */   "TD": function() { return /* binding */ getCustomerDetails; },
/* harmony export */   "Ud": function() { return /* binding */ putUnverifiedPhone; },
/* harmony export */   "X7": function() { return /* binding */ setAdvocate; },
/* harmony export */   "YF": function() { return /* binding */ removeLinkability; },
/* harmony export */   "qD": function() { return /* binding */ verifyOTP; }
/* harmony export */ });
/* unused harmony export CustomerDetailsBrandEnum */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97939);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88830);


var CustomerDetailsBrandEnum;
(function(CustomerDetailsBrandEnum) {
    CustomerDetailsBrandEnum["Lendi"] = "lendi";
    CustomerDetailsBrandEnum["Aussie"] = "aussie";
})(CustomerDetailsBrandEnum || (CustomerDetailsBrandEnum = {}));
var getCustomerDetails = function(token) {
    var baseURL = "https://api.lendi.com.au";
    return axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(baseURL, "/v1/customers/me/"), {
        headers: {
            Authorization: "Bearer ".concat(token)
        }
    }).then(function(res) {
        return res.data.data;
    });
};
var putUnverifiedPhone = function(session, dataToPatch) {
    var ref;
    var customerId = (ref = session.identity) === null || ref === void 0 ? void 0 : ref.id;
    var baseURL = "https://api.lendi.com.au";
    return axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .Z.put("".concat(baseURL, "/v1/customers/").concat(customerId, "/unverified-mobile"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, dataToPatch), {
        headers: {
            Authorization: "Bearer ".concat(session.token)
        }
    });
};
var getLinkedCustomerMobile = function(session) {
    var baseURL = "https://api.lendi.com.au";
    return axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(baseURL, "/v1/customers/me/linkable-customer/mobile"), {
        headers: {
            Authorization: "Bearer ".concat(session.token)
        }
    });
};
var verifyOTP = function(otpCode, token) {
    var baseURL = "https://api.lendi.com.au";
    return axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("".concat(baseURL, "/v1/customers/me/link-otp"), {
        otp: otpCode
    }, {
        headers: {
            Authorization: "Bearer ".concat(token)
        }
    });
};
var getActivatedLead = function(leadId) {
    var baseURL = "https://api.lendi.com.au";
    return axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(baseURL, "/v1/customers/external/leads/activated/").concat(leadId));
};
var mergeAccounts = function(accessToken, fromAccountToken, toAccountToken) {
    var baseURL = "https://api.lendi.com.au";
    return axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("".concat(baseURL, "/v1/customers/me/merged"), {
        fromAccountToken: fromAccountToken,
        toAccountToken: toAccountToken
    }, {
        headers: {
            Authorization: "Bearer ".concat(accessToken)
        }
    });
};
var removeLinkability = function(accessToken) {
    var baseURL = "https://api.lendi.com.au";
    return axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .Z["delete"]("".concat(baseURL, "/v1/customers/me/linkable"), {
        headers: {
            Authorization: "Bearer ".concat(accessToken)
        }
    });
};
var requestOwner = function(accessToken, customerId, requestedOwnerId, requestedStoreId) {
    var baseURL = "https://api.lendi.com.au";
    return axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .Z.put("/v1/customers/".concat(customerId), {
        requestedOwnerId: requestedOwnerId,
        requestedStoreId: requestedStoreId
    }, {
        headers: {
            Authorization: "Bearer ".concat(accessToken)
        },
        baseURL: baseURL
    });
};
var resolveOwner = function(refCode) {
    var baseURL = "https://api.lendi.com.au";
    return axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/v1/customers/external/refcodes/".concat(refCode), {
        baseURL: baseURL
    }).then(function(res) {
        return res.data || {};
    });
};
var setAdvocate = function(accessToken, referralCode) {
    var baseURL = "https://api.lendi.com.au";
    return axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .Z.put("/v1/customers/me/advocate/", {
        referralCode: referralCode
    }, {
        headers: {
            Authorization: "Bearer ".concat(accessToken)
        },
        baseURL: baseURL
    });
};
var updateCustomerRecord = function(accessToken, customerId, campaignName, isCompanyGen) {
    var baseURL = "https://api.lendi.com.au";
    var payload = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        campaignName: campaignName
    }, isCompanyGen === true && {
        selfGen: false
    });
    return axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .Z.put("/v1/customers/".concat(customerId), payload, {
        headers: {
            Authorization: "Bearer ".concat(accessToken)
        },
        baseURL: baseURL
    });
};


/***/ }),

/***/ 49932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ LDContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44229);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97939);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70111);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89799);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92712);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var _lendi_lala_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25980);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67921);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var launchdarkly_react_client_sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91649);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32735);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24819);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(uuid__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _helpers_tracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67458);
/* harmony import */ var _api_customer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81878);













var initialState = {
    identifyCalled: false,
    ldReady: false
};
var LDContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.createContext(initialState);
var LaunchDarklyConsumer = function(param) {
    var children = param.children;
    var targetId = js_cookie__WEBPACK_IMPORTED_MODULE_2__.get("targetId") || (0,uuid__WEBPACK_IMPORTED_MODULE_5__.v4)();
    var hasSSOAccessed = !!js_cookie__WEBPACK_IMPORTED_MODULE_2__.get("hasSSOAccessed");
    var ldClient = (0,launchdarkly_react_client_sdk__WEBPACK_IMPORTED_MODULE_3__/* .useLDClient */ .mC)();
    var ref = (0,_lendi_lala_react__WEBPACK_IMPORTED_MODULE_1__/* .useSession */ .kP)(), identity = ref.identity, status = ref.status, token = ref.token;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_4__.useState(false), 2), identifyCalled = ref1[0], setIdentifyCalled = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_4__.useState(false), 2), ldReady = ref2[0], setLDReady = ref2[1];
    var ref3 = (0,_lendi_lala_react__WEBPACK_IMPORTED_MODULE_1__/* .useSession */ .kP)(), brand = ref3.brand, type = ref3.type;
    // get LD user from launchDarkly when user is anonymous
    var ldMultiContext = {
        kind: "multi",
        unauthUser: {
            key: targetId,
            isTeamView: false,
            hasSSOAccessed: hasSSOAccessed,
            brand: brand
        }
    };
    react__WEBPACK_IMPORTED_MODULE_4__.useEffect(function() {
        if (ldClient && status !== _lendi_lala_react__WEBPACK_IMPORTED_MODULE_1__/* .Status.Authenticated */ .qb.Authenticated) {
            ldClient.identify(ldMultiContext, undefined, function(_error, flags) {
                _helpers_tracking__WEBPACK_IMPORTED_MODULE_6__/* .identityTracking.trackCustomer */ .l2.trackCustomer("", flags || undefined, {
                    brand: brand,
                    type: type
                });
                setIdentifyCalled(true);
            });
        }
    }, [
        ldClient,
        status
    ]);
    // get LD user from launchDarkly when user is logged in
    react__WEBPACK_IMPORTED_MODULE_4__.useEffect(function() {
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var ref, authOrigin, emailVerified, mobileVerified, utm, details, err;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(ldClient && status === _lendi_lala_react__WEBPACK_IMPORTED_MODULE_1__/* .Status.Authenticated */ .qb.Authenticated)) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,_api_customer__WEBPACK_IMPORTED_MODULE_7__/* .getCustomerDetails */ .TD)(token)
                        ];
                    case 2:
                        ref = _state.sent(), authOrigin = ref.authOrigin, emailVerified = ref.emailVerified, mobileVerified = ref.mobileVerified, utm = ref.utm;
                        details = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                            authOrigin: authOrigin,
                            emailVerified: emailVerified,
                            mobileVerified: mobileVerified
                        }, utm);
                        ldClient.identify((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, ldMultiContext), {
                            user: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                                key: identity === null || identity === void 0 ? void 0 : identity.id,
                                isTeamView: false,
                                hasSSOAccessed: hasSSOAccessed,
                                brand: brand,
                                authOrigin: authOrigin,
                                emailVerified: emailVerified,
                                mobileVerified: mobileVerified
                            }, utm)
                        }), undefined, function(_error, flags) {
                            _helpers_tracking__WEBPACK_IMPORTED_MODULE_6__/* .identityTracking.trackCustomer */ .l2.trackCustomer(identity === null || identity === void 0 ? void 0 : identity.id, flags, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, details), {
                                brand: brand,
                                type: type
                            }));
                            setIdentifyCalled(true);
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        ldClient.identify((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, ldMultiContext), {
                            user: {
                                key: identity === null || identity === void 0 ? void 0 : identity.id,
                                isTeamView: false,
                                hasSSOAccessed: hasSSOAccessed,
                                brand: brand
                            }
                        }), undefined, function(_error, flags) {
                            _helpers_tracking__WEBPACK_IMPORTED_MODULE_6__/* .identityTracking.trackCustomer */ .l2.trackCustomer("", flags || undefined, {
                                brand: brand,
                                type: type
                            });
                            setIdentifyCalled(true);
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        ldClient,
        status
    ]);
    react__WEBPACK_IMPORTED_MODULE_4__.useEffect(function() {
        var checkLDReady = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!ldClient) return [
                                2
                            ];
                            return [
                                4,
                                ldClient.waitUntilReady()
                            ];
                        case 1:
                            _state.sent();
                            setLDReady(true);
                            return [
                                2
                            ];
                    }
                });
            });
            return function checkLDReady() {
                return _ref.apply(this, arguments);
            };
        }();
        checkLDReady();
    }, [
        ldClient,
        identifyCalled
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LDContext.Provider, {
        value: {
            identifyCalled: identifyCalled,
            ldReady: ldReady
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LaunchDarklyConsumer);


/***/ }),

/***/ 62804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ DOUBLE_VERIFICATION_EMAIL; }
/* harmony export */ });
var DOUBLE_VERIFICATION_EMAIL = "double_verification_email";


/***/ }),

/***/ 37829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OB": function() { return /* reexport */ TranslationContext; },
  "$j": function() { return /* reexport */ TranslationProvider; }
});

// UNUSED EXPORTS: TRANSLATION_KEY_ARR

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(23745);
// EXTERNAL MODULE: ../../../packages/lala-utils/dist/esm/index.js + 23 modules
var esm = __webpack_require__(82839);
;// CONCATENATED MODULE: ./context/translation/translations.ts


var _obj;
var Translations = (_obj = {}, (0,_define_property/* default */.Z)(_obj, esm/* Brand.Lendi */.H2.Lendi, {
    SITE_NAME: "Lendi",
    TIME_SELECTION_CONFIRMATION_TITLE: {
        text: "To confirm your appointment, <br/>sign in",
        requireParse: true
    },
    TIME_SELECTION_CONFIRMATION_SUBTITLE: {
        text: "If you’re new to Lendi, you'll be prompted to <br/>create an account.",
        requireParse: true
    },
    BOOK_APPOINTMENT_TITLE: {
        text: "Book an appointment with one of our experts",
        requireParse: true
    },
    BOOK_APPOINTMENT_SUBTITLE: {
        text: "We’ll help you find the right home loan for your situation. Sign in below or, if you’re new to Lendi, you'll be prompted to create an account.",
        requireParse: true
    },
    STAMP_DUTY_TITLE: {
        text: "View your stamp duty results",
        requireParse: true
    },
    STAMP_DUTY_SUBTITLE: {
        text: "Sign in below or, if you’re new to Lendi, you'll be prompted to create an account.",
        requireParse: true
    },
    PROPERTY_REPORT_TITLE: {
        text: "View your property report",
        requireParse: true
    },
    PROPERTY_REPORT_SUBTITLE: {
        text: "Sign in below to view your report. <br/>New to Lendi? Create an account by entering your number.",
        requireParse: true
    },
    CREDIT_SCORE_TITLE: {
        text: "Create an account with Lendi",
        requireParse: true
    },
    CREDIT_SCORE_SUBTITLE: {
        text: "To keep your details and score saved, accessible and secure.",
        requireParse: true
    },
    REFERRAL_SUBTITLE: {
        text: "To connect a friend with your trusted Home Loan Specialist",
        requireParse: true
    },
    PRIVACY_POLICY_LINK: "/privacypolicy/",
    SIGN_IN_TITLE: "Sign in to Lendi",
    SIGN_IN_SUBTITLE: "To access your application or create a new account, enter your mobile phone number and receive a one-time passcode via SMS.",
    SAFETY_NET_TITLE: "You're almost there",
    SAFETY_NET_SUBTITLE: "Lendi will send you a one-time passcode via SMS to access your personalised home loan results.",
    RETURNED_SSO_TITLE: "Secure your account",
    RETURNED_SSO_SUBTITLE: "You'll be able to verify with your mobile phone number right after this.",
    BOOK_APPOINTMENT_BUYERS_AGENT_TITLE: undefined,
    BOOK_APPOINTMENT_BUYERS_AGENT_SUBTITLE: undefined
}), (0,_define_property/* default */.Z)(_obj, esm/* Brand.Aussie */.H2.Aussie, {
    SITE_NAME: "Aussie",
    TIME_SELECTION_CONFIRMATION_TITLE: {
        text: "To confirm your appointment, <br/>sign in",
        requireParse: true
    },
    TIME_SELECTION_CONFIRMATION_SUBTITLE: {
        text: "If you’re new to Aussie, you'll be prompted to <br/>create an account.",
        requireParse: true
    },
    BOOK_APPOINTMENT_TITLE: {
        text: "Book an appointment with one of our experts",
        requireParse: true
    },
    BOOK_APPOINTMENT_SUBTITLE: {
        text: "We’ll help you find the right home loan for your situation. Sign in below or, if you're new to Aussie, you'll be prompted to create an account.",
        requireParse: true
    },
    BOOK_APPOINTMENT_BUYERS_AGENT_TITLE: {
        text: "Book an appointment with one of our experts",
        requireParse: true
    },
    BOOK_APPOINTMENT_BUYERS_AGENT_SUBTITLE: {
        text: "We’re here to help you make the right choice. Sign in below, or follow the prompts to create an account if it’s your first time with Aussie.",
        requireParse: true
    },
    STAMP_DUTY_TITLE: {
        text: "View your stamp duty results",
        requireParse: true
    },
    STAMP_DUTY_SUBTITLE: {
        text: "Sign in below or, if you’re new to Aussie, you'll be prompted to create an account.",
        requireParse: true
    },
    PROPERTY_REPORT_TITLE: {
        text: "View your property report",
        requireParse: true
    },
    PROPERTY_REPORT_SUBTITLE: {
        text: "Sign in below to view your report. <br/>New to Aussie? Create an account by entering your number.",
        requireParse: true
    },
    CREDIT_SCORE_TITLE: {
        text: "Create an account with Aussie",
        requireParse: true
    },
    CREDIT_SCORE_SUBTITLE: {
        text: "To keep your details and score saved, accessible and secure.",
        requireParse: true
    },
    REFERRAL_SUBTITLE: {
        text: "To refer a friend to your Aussie Broker",
        requireParse: true
    },
    PRIVACY_POLICY_LINK: "/about-us/privacy/",
    SIGN_IN_TITLE: "Sign in to Aussie",
    SIGN_IN_SUBTITLE: "Aussie uses a one-time passcode with your Australian mobile number. You will receive a one-time passcode via SMS.",
    SAFETY_NET_TITLE: "You're almost there",
    SAFETY_NET_SUBTITLE: "Aussie will send you a one-time passcode via SMS to access your personalised home loan results.",
    RETURNED_SSO_TITLE: "Secure your account",
    RETURNED_SSO_SUBTITLE: "You'll be able to verify with your mobile phone number right after this."
}), _obj);

;// CONCATENATED MODULE: ./context/translation/TranslationProvider.tsx



var TranslationContext = /*#__PURE__*/ react.createContext(undefined);
var TranslationProvider = function(param) {
    var children = param.children, brand = param.brand;
    var getBrandTranslation = function() {
        return Translations[brand];
    };
    var translations = react.useMemo(function() {
        return getBrandTranslation();
    }, [
        brand
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TranslationContext.Provider, {
        value: translations,
        children: children
    });
};

;// CONCATENATED MODULE: ./context/translation/types.ts

var TRANSLATION_KEY_ARR = (/* unused pure expression or super */ null && ([
    "SITE_NAME",
    "PRIVACY_POLICY_LINK",
    "SIGN_IN_TITLE",
    "SIGN_IN_SUBTITLE",
    "TIME_SELECTION_CONFIRMATION_TITLE",
    "TIME_SELECTION_CONFIRMATION_SUBTITLE",
    "BOOK_APPOINTMENT_TITLE",
    "BOOK_APPOINTMENT_SUBTITLE",
    "BOOK_APPOINTMENT_BUYERS_AGENT_TITLE",
    "BOOK_APPOINTMENT_BUYERS_AGENT_SUBTITLE",
    "STAMP_DUTY_TITLE",
    "STAMP_DUTY_SUBTITLE",
    "PROPERTY_REPORT_TITLE",
    "PROPERTY_REPORT_SUBTITLE",
    "CREDIT_SCORE_TITLE",
    "CREDIT_SCORE_SUBTITLE",
    "SAFETY_NET_TITLE",
    "SAFETY_NET_SUBTITLE",
    "RETURNED_SSO_TITLE",
    "RETURNED_SSO_SUBTITLE",
    "REFERRAL_SUBTITLE", 
]));

;// CONCATENATED MODULE: ./context/translation/index.ts



;// CONCATENATED MODULE: ./context/index.ts



/***/ }),

/***/ 45343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V$": function() { return /* reexport */ doRedirect; },
  "dU": function() { return /* binding */ getEnv; },
  "an": function() { return /* binding */ getReferrer; },
  "ZD": function() { return /* binding */ mapSignInTranslationKey; },
  "Yz": function() { return /* binding */ useInterval; },
  "eR": function() { return /* reexport */ useRedirect; }
});

// EXTERNAL MODULE: ../node_modules/@lendi/core-constants/lib/esm/index.js + 84 modules
var esm = __webpack_require__(82419);
// EXTERNAL MODULE: ../../../packages/lala-utils/dist/esm/index.js + 23 modules
var dist_esm = __webpack_require__(82839);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/lala-react/dist/esm/index.js + 318 modules
var lala_react_dist_esm = __webpack_require__(25980);
// EXTERNAL MODULE: ./helpers/router.ts
var router = __webpack_require__(59060);
// EXTERNAL MODULE: ./state/actionProvider.tsx
var actionProvider = __webpack_require__(3842);
;// CONCATENATED MODULE: ./helpers/useRedirect.ts






var doRedirect = function() {
    var brand = (0,dist_esm/* getBrandFromHostname */.Y6)();
    var urlQueries = (0,dist_esm/* getReturnURLFromQuery */.Uy)();
    (0,dist_esm/* executeReturnURL */.ew)(brand, dist_esm/* Type.Customer */.Dy.Customer, getEnv(), urlQueries);
};
var useRedirect = function() {
    var status = (0,lala_react_dist_esm/* useSession */.kP)().status;
    var passwordlessAuth = (0,lala_react_dist_esm/* usePasswordlessAuthentication */.er)();
    var expireSession = (0,actionProvider/* useActions */.ol)().expireSession;
    (0,react.useEffect)(function() {
        dist_esm/* LalaSentry.logInfo */.GG.logInfo("useRedirect hit on load", {
            status: status,
            otpStatus: passwordlessAuth === null || passwordlessAuth === void 0 ? void 0 : passwordlessAuth.status
        });
        if (status === lala_react_dist_esm/* Status.Authenticated */.qb.Authenticated && passwordlessAuth.status === undefined) {
            doRedirect();
        }
        if (status === lala_react_dist_esm/* Status.Expired */.qb.Expired) {
            var me = (0,lala_react_dist_esm/* getMeFromStorage */.ON)();
            expireSession(me === null || me === void 0 ? void 0 : me.firstName, me === null || me === void 0 ? void 0 : me.phone);
            // using location.search because at this point the Router.query() is empty
            router/* default.push */.Z.push("/expired".concat(location.search));
        }
    }, []);
};

;// CONCATENATED MODULE: ./helpers/index.ts



/***
 * taken from @dan_abramov
 * https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 */ function useInterval(callback, delay) {
    var savedCallback = (0,react.useRef)(function() {
        return null;
    });
    // Remember the latest callback.
    (0,react.useEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0,react.useEffect)(function() {
        var tick = function tick() {
            savedCallback.current();
        };
        if (delay !== null) {
            var id = setInterval(tick, delay);
            return function() {
                return clearInterval(id);
            };
        }
        return;
    }, [
        delay
    ]);
}
var getEnv = function() {
    var env = "production" || 0;
    switch(env){
        case dist_esm/* Environment.Development */.qA.Development:
        case dist_esm/* Environment.Staging */.qA.Staging:
        case dist_esm/* Environment.Preproduction */.qA.Preproduction:
        case dist_esm/* Environment.Production */.qA.Production:
            return env;
        default:
            throw new Error("Invalid environment ".concat(env));
    }
};
var getReferrer = function() {
    if (false) {}
    return window.document.referrer;
};
var mapSignInTranslationKey = function(referrer, textKey) {
    switch(true){
        case textKey === "returned":
            return {
                title: "RETURNED_SSO_TITLE",
                subtitle: "RETURNED_SSO_SUBTITLE"
            };
        case referrer.includes(esm/* PlatformPathname.REFER_A_FRIEND_PATHNAME */.C1.REFER_A_FRIEND_PATHNAME):
            return {
                title: "SIGN_IN_TITLE",
                subtitle: "REFERRAL_SUBTITLE"
            };
        case referrer.includes(esm/* PlatformPathname.TIME_SELECTION_PROCESS_PATHNAME */.C1.TIME_SELECTION_PROCESS_PATHNAME):
            return {
                title: "TIME_SELECTION_CONFIRMATION_TITLE",
                subtitle: "TIME_SELECTION_CONFIRMATION_SUBTITLE"
            };
        case referrer.includes(esm/* PlatformPathname.BOOKING_APPOINTMENT_PATHNAME */.C1.BOOKING_APPOINTMENT_PATHNAME):
            return {
                title: "BOOK_APPOINTMENT_TITLE",
                subtitle: "BOOK_APPOINTMENT_SUBTITLE"
            };
        case referrer.includes(esm/* PlatformPathname.BOOKING_APPOINTMENT_BUYERS_AGENT_PATHNAME */.C1.BOOKING_APPOINTMENT_BUYERS_AGENT_PATHNAME):
        case referrer.includes(esm/* PlatformPathname.BUYERS_AGENT_PATHNAME */.C1.BUYERS_AGENT_PATHNAME):
            return {
                title: "BOOK_APPOINTMENT_BUYERS_AGENT_TITLE",
                subtitle: "BOOK_APPOINTMENT_BUYERS_AGENT_SUBTITLE"
            };
        case referrer.includes(esm/* PlatformPathname.STAMP_DUTY_PATHNAME */.C1.STAMP_DUTY_PATHNAME):
            return {
                title: "STAMP_DUTY_TITLE",
                subtitle: "STAMP_DUTY_SUBTITLE"
            };
        case referrer.includes(esm/* PlatformPathname.PROPERTY_REPORT_PATHNAME */.C1.PROPERTY_REPORT_PATHNAME):
            return {
                title: "PROPERTY_REPORT_TITLE",
                subtitle: "PROPERTY_REPORT_SUBTITLE"
            };
        case referrer.includes(esm/* PlatformPathname.CHECK_YOUR_CREDIT_SCORE_PATHNAME */.C1.CHECK_YOUR_CREDIT_SCORE_PATHNAME):
        case referrer.includes(esm/* PlatformPathname.CREDIT_SCORE_RESULT_PATHNAME */.C1.CREDIT_SCORE_RESULT_PATHNAME):
        case referrer.includes(esm/* PlatformPathname.FREE_CREDIT_SCORE_CHECK_PATHNAME */.C1.FREE_CREDIT_SCORE_CHECK_PATHNAME):
            return {
                title: "CREDIT_SCORE_TITLE",
                subtitle: "CREDIT_SCORE_SUBTITLE"
            };
        default:
            return {
                title: "SIGN_IN_TITLE",
                subtitle: "SIGN_IN_SUBTITLE"
            };
    }
};




/***/ }),

/***/ 59060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35837);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22512);
/* harmony import */ var url__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(url__WEBPACK_IMPORTED_MODULE_1__);


var addPrefixToPath = function(url, as) {
    return "".concat("/sign-in").concat(url__WEBPACK_IMPORTED_MODULE_1__.format(as ? as : url));
};
var Router = {
    push: function(url, as, options) {
        next_router__WEBPACK_IMPORTED_MODULE_0___default().push(url, addPrefixToPath(url, as), options);
    },
    replace: function(url, as, options) {
        next_router__WEBPACK_IMPORTED_MODULE_0___default().replace(url, addPrefixToPath(url, as), options);
    },
    query: function() {
        return (next_router__WEBPACK_IMPORTED_MODULE_0___default().query);
    },
    pathname: function() {
        return (next_router__WEBPACK_IMPORTED_MODULE_0___default().pathname);
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (Router);


/***/ }),

/***/ 67458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fn": function() { return /* binding */ eventTracking; },
  "l2": function() { return /* binding */ identityTracking; },
  "ep": function() { return /* binding */ pageTracking; }
});

// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(44229);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(84872);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(34650);
;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_instanceof.mjs
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(97939);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(31268);
// EXTERNAL MODULE: ../../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92712);
// EXTERNAL MODULE: ../../../packages/lala-utils/dist/esm/index.js + 23 modules
var esm = __webpack_require__(82839);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/analytics-web/dist/esm/events/common.js
var CustomerType;
(function (CustomerType) {
    CustomerType["CUSTOMER"] = "Customer";
    CustomerType["TEAM"] = "Team";
})(CustomerType || (CustomerType = {}));
var AuthenticationStatus;
(function (AuthenticationStatus) {
    AuthenticationStatus["AUTHENTICATED"] = "Authenticated";
    AuthenticationStatus["UNAUTHENTICATED"] = "Unauthenticated";
})(AuthenticationStatus || (AuthenticationStatus = {}));
var EventCategory;
(function (EventCategory) {
    EventCategory["APPLICATION_SUMMARY"] = "Application Summary";
    EventCategory["APPLICATION"] = "Application";
    EventCategory["APPROVAL_CONFIDENCE"] = "Approval Confidence";
    EventCategory["AUTH"] = "Auth";
    EventCategory["BOOK_APPOINTMENT"] = "Book Appointment";
    EventCategory["CASH_OUT"] = "Cash Out";
    EventCategory["CHAT"] = "Chat";
    EventCategory["CHAT_PRO"] = "Chat Pro";
    EventCategory["CHOOSE_YOUR_LOAN"] = "Choose Your Loan";
    EventCategory["COMMSPANEL"] = "CommsPanel";
    EventCategory["CREDIT_GUIDE"] = "Credit Guide";
    EventCategory["CREDIT_PROPOSAL"] = "Credit Proposal";
    EventCategory["CUSTOMER"] = "Customer";
    EventCategory["DASHBOARD"] = "Dashboard";
    EventCategory["ERROR_PAGES"] = "Error Pages";
    EventCategory["FOOTER"] = "Footer";
    EventCategory["FUNDING_POSITION"] = "Funding Position";
    EventCategory["FREE_FORM_FUNDING_POSITION"] = "Free Form Funding Position";
    EventCategory["INITIAL_FUNDING_POSITION"] = "Initial Funding Position";
    EventCategory["FUNNELS"] = "Funnels";
    EventCategory["INSPIRE_BLOG"] = "Inspire Blog";
    EventCategory["JAM_LANDING_PAGES"] = "Jam Landing Pages";
    EventCategory["NAVBAR"] = "Navbar";
    EventCategory["NOTES"] = "Notes";
    EventCategory["NOTIFICATION"] = "Notification";
    EventCategory["PACKAGE_COMPARISON"] = "Package Comparison";
    EventCategory["PRODUCT_SEARCH"] = "Product Search";
    EventCategory["PROPERTY_REPORT"] = "Property Report";
    EventCategory["REQUIRED_ACTIONS"] = "Required Actions";
    EventCategory["REQUIRED_DOCUMENTS"] = "Required Documents";
    EventCategory["SAFETYNET_CTP"] = "Safetynet CTP";
    EventCategory["SAVINGS_CALCULATOR"] = "Savings Calculator";
    EventCategory["FREE_FORM_SAVINGS_CALCULATOR"] = "Free Form Savings Calculator";
    EventCategory["STAMP_DUTY_CALCULATOR"] = "Stamp Duty Calculator";
    EventCategory["CMS"] = "CMS";
    EventCategory["POSTCODE"] = "Customer Suburb";
    EventCategory["EMAIL_VERIFICATION"] = "email-verification";
    EventCategory["ACCOUNT_LINKING"] = "account-linking";
    EventCategory["SMS_SENDER"] = "SMS Sender";
    EventCategory["FIXED_RATE_EXPIRY_CALCULATOR"] = "Fixed Rate Expiry Calculator";
    EventCategory["TEAM_VIEW_NAV_V2"] = "Team Nav v2";
    EventCategory["REFERRALS"] = "Referrals";
    EventCategory["CREDIT_SCORE"] = "Credit Score";
})(EventCategory || (EventCategory = {}));
//# sourceMappingURL=common.js.map
;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_create_class.mjs
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/get-process-env.js
/* provided dependency */ var process = __webpack_require__(13158);
/**
 * Returns `process.env` if it is available in the environment.
 * Always returns an object make it similarly easy to use as `process.env`.
 */
function getProcessEnv() {
    if (typeof process === 'undefined' || !process.env) {
        return {};
    }
    return process.env;
}
//# sourceMappingURL=get-process-env.js.map
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/parse-cdn.js
var parse_cdn = __webpack_require__(35008);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/fetch.js
var fetch = __webpack_require__(30826);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/validation/helpers.js
var helpers = __webpack_require__(58459);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/arguments-resolver/index.js

/**
 * Helper for the track method
 */
function resolveArguments(eventName, properties, options, callback) {
    var _a;
    var args = [eventName, properties, options, callback];
    var name = (0,helpers/* isPlainObject */.PO)(eventName) ? eventName.event : eventName;
    if (!name || !(0,helpers/* isString */.HD)(name)) {
        throw new Error('Event missing');
    }
    var data = (0,helpers/* isPlainObject */.PO)(eventName)
        ? (_a = eventName.properties) !== null && _a !== void 0 ? _a : {}
        : (0,helpers/* isPlainObject */.PO)(properties)
            ? properties
            : {};
    var opts = {};
    if (!(0,helpers/* isFunction */.mf)(options)) {
        opts = options !== null && options !== void 0 ? options : {};
    }
    if ((0,helpers/* isPlainObject */.PO)(eventName) && !(0,helpers/* isFunction */.mf)(properties)) {
        opts = properties !== null && properties !== void 0 ? properties : {};
    }
    var cb = args.find(helpers/* isFunction */.mf);
    return [name, data, opts, cb];
}
/**
 * Helper for page, screen methods
 */
function resolvePageArguments(category, name, properties, options, callback) {
    var _a, _b;
    var resolvedCategory = null;
    var resolvedName = null;
    var args = [category, name, properties, options, callback];
    var strings = args.filter(helpers/* isString */.HD);
    if (strings[0] !== undefined && strings[1] !== undefined) {
        resolvedCategory = strings[0];
        resolvedName = strings[1];
    }
    if (strings.length === 1) {
        resolvedCategory = null;
        resolvedName = strings[0];
    }
    var resolvedCallback = args.find(helpers/* isFunction */.mf);
    var objects = args.filter(function (obj) {
        if (resolvedName === null) {
            return (0,helpers/* isPlainObject */.PO)(obj);
        }
        return (0,helpers/* isPlainObject */.PO)(obj) || obj === null;
    });
    var resolvedProperties = ((_a = objects[0]) !== null && _a !== void 0 ? _a : {});
    var resolvedOptions = ((_b = objects[1]) !== null && _b !== void 0 ? _b : {});
    return [
        resolvedCategory,
        resolvedName,
        resolvedProperties,
        resolvedOptions,
        resolvedCallback,
    ];
}
/**
 * Helper for group, identify methods
 */
var resolveUserArguments = function (user) {
    return function () {
        var _a, _b, _c;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var values = {};
        // It's a stack so it's reversed so that we go through each of the expected arguments
        var orderStack = [
            'callback',
            'options',
            'traits',
            'id',
        ];
        // Read each argument and eval the possible values here
        for (var _d = 0, args_1 = args; _d < args_1.length; _d++) {
            var arg = args_1[_d];
            var current = orderStack.pop();
            if (current === 'id') {
                if ((0,helpers/* isString */.HD)(arg) || (0,helpers/* isNumber */.hj)(arg)) {
                    values.id = arg.toString();
                    continue;
                }
                if (arg === null || arg === undefined) {
                    continue;
                }
                // First argument should always be the id, if it is not a valid value we can skip it
                current = orderStack.pop();
            }
            // Traits and Options
            if ((current === 'traits' || current === 'options') &&
                (arg === null || arg === undefined || (0,helpers/* isPlainObject */.PO)(arg))) {
                values[current] = arg;
            }
            // Callback
            if ((0,helpers/* isFunction */.mf)(arg)) {
                values.callback = arg;
                break; // This is always the last argument
            }
        }
        return [
            (_a = values.id) !== null && _a !== void 0 ? _a : user.id(),
            ((_b = values.traits) !== null && _b !== void 0 ? _b : {}),
            (_c = values.options) !== null && _c !== void 0 ? _c : {},
            values.callback,
        ];
    };
};
/**
 * Helper for alias method
 */
function resolveAliasArguments(to, from, options, callback) {
    if ((0,helpers/* isNumber */.hj)(to))
        to = to.toString(); // Legacy behaviour - allow integers for alias calls
    if ((0,helpers/* isNumber */.hj)(from))
        from = from.toString();
    var args = [to, from, options, callback];
    var _a = args.filter(helpers/* isString */.HD), _b = _a[0], aliasTo = _b === void 0 ? to : _b, _c = _a[1], aliasFrom = _c === void 0 ? null : _c;
    var _d = args.filter(helpers/* isPlainObject */.PO)[0], opts = _d === void 0 ? {} : _d;
    var resolvedCallback = args.find(helpers/* isFunction */.mf);
    return [aliasTo, aliasFrom, opts, resolvedCallback];
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/connection/index.js
var connection = __webpack_require__(57897);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/context/index.js
var context = __webpack_require__(47130);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/callback/index.js
var callback = __webpack_require__(56631);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/analytics/dispatch.js


/* The amount of time in ms to wait before invoking the callback. */
var getDelay = function (startTimeInEpochMS, timeoutInMS) {
    var elapsedTime = Date.now() - startTimeInEpochMS;
    // increasing the timeout increases the delay by almost the same amount -- this is weird legacy behavior.
    return Math.max((timeoutInMS !== null && timeoutInMS !== void 0 ? timeoutInMS : 300) - elapsedTime, 0);
};
/**
 * Push an event into the dispatch queue and invoke any callbacks.
 *
 * @param event - Segment event to enqueue.
 * @param queue - Queue to dispatch against.
 * @param emitter - This is typically an instance of "Analytics" -- used for metrics / progress information.
 * @param options
 */
function dispatch(ctx, queue, emitter, options) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var startTime, dispatched;
        return (0,tslib_es6.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    emitter.emit('dispatch_start', ctx);
                    startTime = Date.now();
                    if (!queue.isEmpty()) return [3 /*break*/, 2];
                    return [4 /*yield*/, queue.dispatchSingle(ctx)];
                case 1:
                    dispatched = _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, queue.dispatch(ctx)];
                case 3:
                    dispatched = _a.sent();
                    _a.label = 4;
                case 4:
                    if (!(options === null || options === void 0 ? void 0 : options.callback)) return [3 /*break*/, 6];
                    return [4 /*yield*/, (0,callback/* invokeCallback */.UI)(dispatched, options.callback, getDelay(startTime, options.timeout))];
                case 5:
                    dispatched = _a.sent();
                    _a.label = 6;
                case 6:
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        dispatched.flush();
                    }
                    return [2 /*return*/, dispatched];
            }
        });
    });
}
//# sourceMappingURL=dispatch.js.map
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-generic-utils/dist/esm/emitter/emitter.js
var emitter = __webpack_require__(53994);
// EXTERNAL MODULE: ../../../node_modules/@lukeed/uuid/dist/index.mjs
var dist = __webpack_require__(29625);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/pick.js

/**
 * @example
 * pick({ 'a': 1, 'b': '2', 'c': 3 }, ['a', 'c'])
 * => { 'a': 1, 'c': 3 }
 */
function pick(object, keys) {
    return Object.assign.apply(Object, (0,tslib_es6.__spreadArray)([{}], keys.map(function (key) {
        var _a;
        if (object && Object.prototype.hasOwnProperty.call(object, key)) {
            return _a = {}, _a[key] = object[key], _a;
        }
    }), false));
}
//# sourceMappingURL=pick.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/page/get-page-context.js

var BufferedPageContextDiscriminant = 'bpc';
/**
 * `BufferedPageContext` object builder
 */
var createBufferedPageContext = function (url, canonicalUrl, search, path, title, referrer) { return ({
    __t: BufferedPageContextDiscriminant,
    c: canonicalUrl,
    p: path,
    u: url,
    s: search,
    t: title,
    r: referrer,
}); };
// my clever/dubious way of making sure this type guard does not get out sync with the type definition
var BUFFERED_PAGE_CONTEXT_KEYS = Object.keys(createBufferedPageContext('', '', '', '', '', ''));
function isBufferedPageContext(bufferedPageCtx) {
    if (!(0,helpers/* isPlainObject */.PO)(bufferedPageCtx))
        return false;
    if (bufferedPageCtx.__t !== BufferedPageContextDiscriminant)
        return false;
    // ensure obj has all the keys we expect, and none we don't.
    for (var k in bufferedPageCtx) {
        if (!BUFFERED_PAGE_CONTEXT_KEYS.includes(k)) {
            return false;
        }
    }
    return true;
}
//  Legacy logic: we are we appending search parameters to the canonical URL -- I guess the canonical URL is  "not canonical enough" (lol)
var createCanonicalURL = function (canonicalUrl, searchParams) {
    return canonicalUrl.indexOf('?') > -1
        ? canonicalUrl
        : canonicalUrl + searchParams;
};
/**
 * Strips hash from URL.
 * http://www.segment.local#test -> http://www.segment.local
 */
var removeHash = function (href) {
    var hashIdx = href.indexOf('#');
    return hashIdx === -1 ? href : href.slice(0, hashIdx);
};
var parseCanonicalPath = function (canonicalUrl) {
    try {
        return new URL(canonicalUrl).pathname;
    }
    catch (_e) {
        // this is classic behavior -- we assume that if the canonical URL is invalid, it's a raw path.
        return canonicalUrl[0] === '/' ? canonicalUrl : '/' + canonicalUrl;
    }
};
/**
 * Create a `PageContext` from a `BufferedPageContext`.
 * `BufferedPageContext` keys are minified to save bytes in the snippet.
 */
var createPageContext = function (_a) {
    var canonicalUrl = _a.c, pathname = _a.p, search = _a.s, url = _a.u, referrer = _a.r, title = _a.t;
    var newPath = canonicalUrl ? parseCanonicalPath(canonicalUrl) : pathname;
    var newUrl = canonicalUrl
        ? createCanonicalURL(canonicalUrl, search)
        : removeHash(url);
    return {
        path: newPath,
        referrer: referrer,
        search: search,
        title: title,
        url: newUrl,
    };
};
/**
 * Get page properties from the browser window/document.
 */
var getDefaultBufferedPageContext = function () {
    var c = document.querySelector("link[rel='canonical']");
    return createBufferedPageContext(location.href, (c && c.getAttribute('href')) || undefined, location.search, location.pathname, document.title, document.referrer);
};
/**
 * Get page properties from the browser window/document.
 */
var getDefaultPageContext = function () {
    return createPageContext(getDefaultBufferedPageContext());
};
//# sourceMappingURL=get-page-context.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/page/add-page-context.js



/**
 * Augments a segment event with information about the current page.
 * Page information like URL changes frequently, so this is meant to be captured as close to the event call as possible.
 * Things like `userAgent` do not change, so they can be added later in the flow.
 * We prefer not to add this information to this function, as it increases the main bundle size.
 */
var addPageContext = function (event, pageCtx) {
    if (pageCtx === void 0) { pageCtx = getDefaultPageContext(); }
    var evtCtx = event.context; // Context should be set earlier in the flow
    var pageContextFromEventProps;
    if (event.type === 'page') {
        pageContextFromEventProps =
            event.properties && pick(event.properties, Object.keys(pageCtx));
        event.properties = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, pageCtx), event.properties), (event.name ? { name: event.name } : {}));
    }
    evtCtx.page = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, pageCtx), pageContextFromEventProps), evtCtx.page);
};
//# sourceMappingURL=add-page-context.js.map
// EXTERNAL MODULE: ../../../node_modules/dset/dist/index.mjs
var dset_dist = __webpack_require__(58506);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/utils/pick.js
var pickBy = function (obj, fn) {
    return Object.keys(obj)
        .filter(function (k) { return fn(k, obj[k]); })
        .reduce(function (acc, key) { return ((acc[key] = obj[key]), acc); }, {});
};
//# sourceMappingURL=pick.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/validation/errors.js

var errors_ValidationError = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(ValidationError, _super);
    function ValidationError(field, message) {
        var _this = _super.call(this, "".concat(field, " ").concat(message)) || this;
        _this.field = field;
        return _this;
    }
    return ValidationError;
}(Error));

//# sourceMappingURL=errors.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/validation/assertions.js


var stringError = 'is not a string';
var objError = 'is not an object';
var nilError = 'is nil';
// user identity check could hypothetically could be used in the browser event factory, but not 100% sure -- so this is node only for now
function assertUserIdentity(event) {
    var USER_FIELD_NAME = '.userId/anonymousId/previousId/groupId';
    var getAnyUserId = function (event) { var _a, _b, _c; return (_c = (_b = (_a = event.userId) !== null && _a !== void 0 ? _a : event.anonymousId) !== null && _b !== void 0 ? _b : event.groupId) !== null && _c !== void 0 ? _c : event.previousId; };
    var id = getAnyUserId(event);
    if (!exists(id)) {
        throw new ValidationError(USER_FIELD_NAME, nilError);
    }
    else if (!isString(id)) {
        throw new ValidationError(USER_FIELD_NAME, stringError);
    }
}
function assertEventExists(event) {
    if (!(0,helpers/* exists */.Gg)(event)) {
        throw new errors_ValidationError('Event', nilError);
    }
    if (typeof event !== 'object') {
        throw new errors_ValidationError('Event', objError);
    }
}
function assertEventType(event) {
    if (!(0,helpers/* isString */.HD)(event.type)) {
        throw new errors_ValidationError('.type', stringError);
    }
}
function assertTrackEventName(event) {
    if (!(0,helpers/* isString */.HD)(event.event)) {
        throw new errors_ValidationError('.event', stringError);
    }
}
function assertTrackEventProperties(event) {
    if (!(0,helpers/* isPlainObject */.PO)(event.properties)) {
        throw new errors_ValidationError('.properties', objError);
    }
}
function assertTraits(event) {
    if (!(0,helpers/* isPlainObject */.PO)(event.traits)) {
        throw new errors_ValidationError('.traits', objError);
    }
}
function assertMessageId(event) {
    if (!(0,helpers/* isString */.HD)(event.messageId)) {
        throw new errors_ValidationError('.messageId', stringError);
    }
}
function validateEvent(event) {
    assertEventExists(event);
    assertEventType(event);
    assertMessageId(event);
    if (event.type === 'track') {
        assertTrackEventName(event);
        assertTrackEventProperties(event);
    }
    if (['group', 'identify'].includes(event.type)) {
        assertTraits(event);
    }
}
//# sourceMappingURL=assertions.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/events/index.js





/**
 * Internal settings object that is used internally by the factory
 */
var InternalEventFactorySettings = /** @class */ (function () {
    function InternalEventFactorySettings(settings) {
        var _a, _b;
        this.settings = settings;
        this.createMessageId = settings.createMessageId;
        this.onEventMethodCall = (_a = settings.onEventMethodCall) !== null && _a !== void 0 ? _a : (function () { });
        this.onFinishedEvent = (_b = settings.onFinishedEvent) !== null && _b !== void 0 ? _b : (function () { });
    }
    return InternalEventFactorySettings;
}());
var CoreEventFactory = /** @class */ (function () {
    function CoreEventFactory(settings) {
        this.settings = new InternalEventFactorySettings(settings);
    }
    CoreEventFactory.prototype.track = function (event, properties, options, globalIntegrations) {
        this.settings.onEventMethodCall({ type: 'track', options: options });
        return this.normalize((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.baseEvent()), { event: event, type: 'track', properties: properties !== null && properties !== void 0 ? properties : {}, options: (0,tslib_es6.__assign)({}, options), integrations: (0,tslib_es6.__assign)({}, globalIntegrations) }));
    };
    CoreEventFactory.prototype.page = function (category, page, properties, options, globalIntegrations) {
        var _a;
        this.settings.onEventMethodCall({ type: 'page', options: options });
        var event = {
            type: 'page',
            properties: (0,tslib_es6.__assign)({}, properties),
            options: (0,tslib_es6.__assign)({}, options),
            integrations: (0,tslib_es6.__assign)({}, globalIntegrations),
        };
        if (category !== null) {
            event.category = category;
            event.properties = (_a = event.properties) !== null && _a !== void 0 ? _a : {};
            event.properties.category = category;
        }
        if (page !== null) {
            event.name = page;
        }
        return this.normalize((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.baseEvent()), event));
    };
    CoreEventFactory.prototype.screen = function (category, screen, properties, options, globalIntegrations) {
        this.settings.onEventMethodCall({ type: 'screen', options: options });
        var event = {
            type: 'screen',
            properties: (0,tslib_es6.__assign)({}, properties),
            options: (0,tslib_es6.__assign)({}, options),
            integrations: (0,tslib_es6.__assign)({}, globalIntegrations),
        };
        if (category !== null) {
            event.category = category;
        }
        if (screen !== null) {
            event.name = screen;
        }
        return this.normalize((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.baseEvent()), event));
    };
    CoreEventFactory.prototype.identify = function (userId, traits, options, globalIntegrations) {
        this.settings.onEventMethodCall({ type: 'identify', options: options });
        return this.normalize((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.baseEvent()), { type: 'identify', userId: userId, traits: traits !== null && traits !== void 0 ? traits : {}, options: (0,tslib_es6.__assign)({}, options), integrations: globalIntegrations }));
    };
    CoreEventFactory.prototype.group = function (groupId, traits, options, globalIntegrations) {
        this.settings.onEventMethodCall({ type: 'group', options: options });
        return this.normalize((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.baseEvent()), { type: 'group', traits: traits !== null && traits !== void 0 ? traits : {}, options: (0,tslib_es6.__assign)({}, options), integrations: (0,tslib_es6.__assign)({}, globalIntegrations), //
            groupId: groupId }));
    };
    CoreEventFactory.prototype.alias = function (to, from, // TODO: can we make this undefined?
    options, globalIntegrations) {
        this.settings.onEventMethodCall({ type: 'alias', options: options });
        var base = {
            userId: to,
            type: 'alias',
            options: (0,tslib_es6.__assign)({}, options),
            integrations: (0,tslib_es6.__assign)({}, globalIntegrations),
        };
        if (from !== null) {
            base.previousId = from;
        }
        if (to === undefined) {
            return this.normalize((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, base), this.baseEvent()));
        }
        return this.normalize((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.baseEvent()), base));
    };
    CoreEventFactory.prototype.baseEvent = function () {
        return {
            integrations: {},
            options: {},
        };
    };
    /**
     * Builds the context part of an event based on "foreign" keys that
     * are provided in the `Options` parameter for an Event
     */
    CoreEventFactory.prototype.context = function (options) {
        var _a;
        /**
         * If the event options are known keys from this list, we move them to the top level of the event.
         * Any other options are moved to context.
         */
        var eventOverrideKeys = [
            'userId',
            'anonymousId',
            'timestamp',
            'messageId',
        ];
        delete options['integrations'];
        var providedOptionsKeys = Object.keys(options);
        var context = (_a = options.context) !== null && _a !== void 0 ? _a : {};
        var eventOverrides = {};
        providedOptionsKeys.forEach(function (key) {
            if (key === 'context') {
                return;
            }
            if (eventOverrideKeys.includes(key)) {
                (0,dset_dist/* dset */.N)(eventOverrides, key, options[key]);
            }
            else {
                (0,dset_dist/* dset */.N)(context, key, options[key]);
            }
        });
        return [context, eventOverrides];
    };
    CoreEventFactory.prototype.normalize = function (event) {
        var _a, _b;
        var integrationBooleans = Object.keys((_a = event.integrations) !== null && _a !== void 0 ? _a : {}).reduce(function (integrationNames, name) {
            var _a;
            var _b;
            return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, integrationNames), (_a = {}, _a[name] = Boolean((_b = event.integrations) === null || _b === void 0 ? void 0 : _b[name]), _a));
        }, {});
        // filter out any undefined options
        event.options = pickBy(event.options || {}, function (_, value) {
            return value !== undefined;
        });
        // This is pretty trippy, but here's what's going on:
        // - a) We don't pass initial integration options as part of the event, only if they're true or false
        // - b) We do accept per integration overrides (like integrations.Amplitude.sessionId) at the event level
        // Hence the need to convert base integration options to booleans, but maintain per event integration overrides
        var allIntegrations = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, integrationBooleans), (_b = event.options) === null || _b === void 0 ? void 0 : _b.integrations);
        var _c = event.options
            ? this.context(event.options)
            : [], context = _c[0], overrides = _c[1];
        var options = event.options, rest = (0,tslib_es6.__rest)(event, ["options"]);
        var evt = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({ timestamp: new Date() }, rest), { context: context, integrations: allIntegrations }), overrides), { messageId: options.messageId || this.settings.createMessageId() });
        this.settings.onFinishedEvent(evt);
        validateEvent(evt);
        return evt;
    };
    return CoreEventFactory;
}());

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/events/index.js





var EventFactory = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(EventFactory, _super);
    function EventFactory(user) {
        var _this = _super.call(this, {
            createMessageId: function () { return "ajs-next-".concat(Date.now(), "-").concat((0,dist.v4)()); },
            onEventMethodCall: function (_a) {
                var options = _a.options;
                _this.maybeUpdateAnonId(options);
            },
            onFinishedEvent: function (event) {
                _this.addIdentity(event);
                return event;
            },
        }) || this;
        _this.user = user;
        return _this;
    }
    /**
     * Updates the anonymousId *globally* if it's provided in the options.
     * This should generally be done in the identify method, but some customers rely on this.
     */
    EventFactory.prototype.maybeUpdateAnonId = function (options) {
        (options === null || options === void 0 ? void 0 : options.anonymousId) && this.user.anonymousId(options.anonymousId);
    };
    /**
     * add user id / anonymous id to the event
     */
    EventFactory.prototype.addIdentity = function (event) {
        if (this.user.id()) {
            event.userId = this.user.id();
        }
        if (this.user.anonymousId()) {
            event.anonymousId = this.user.anonymousId();
        }
    };
    EventFactory.prototype.track = function (event, properties, options, globalIntegrations, pageCtx) {
        var ev = _super.prototype.track.call(this, event, properties, options, globalIntegrations);
        addPageContext(ev, pageCtx);
        return ev;
    };
    EventFactory.prototype.page = function (category, page, properties, options, globalIntegrations, pageCtx) {
        var ev = _super.prototype.page.call(this, category, page, properties, options, globalIntegrations);
        addPageContext(ev, pageCtx);
        return ev;
    };
    EventFactory.prototype.screen = function (category, screen, properties, options, globalIntegrations, pageCtx) {
        var ev = _super.prototype.screen.call(this, category, screen, properties, options, globalIntegrations);
        addPageContext(ev, pageCtx);
        return ev;
    };
    EventFactory.prototype.identify = function (userId, traits, options, globalIntegrations, pageCtx) {
        var ev = _super.prototype.identify.call(this, userId, traits, options, globalIntegrations);
        addPageContext(ev, pageCtx);
        return ev;
    };
    EventFactory.prototype.group = function (groupId, traits, options, globalIntegrations, pageCtx) {
        var ev = _super.prototype.group.call(this, groupId, traits, options, globalIntegrations);
        addPageContext(ev, pageCtx);
        return ev;
    };
    EventFactory.prototype.alias = function (to, from, options, globalIntegrations, pageCtx) {
        var ev = _super.prototype.alias.call(this, to, from, options, globalIntegrations);
        addPageContext(ev, pageCtx);
        return ev;
    };
    return EventFactory;
}(CoreEventFactory));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/plugin/index.js
var isDestinationPluginWithAddMiddleware = function (plugin) {
    // FYI: segment's plugin does not currently have an 'addMiddleware' method
    return 'addMiddleware' in plugin && plugin.type === 'destination';
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/priority-queue/persisted.js
var persisted = __webpack_require__(14296);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/utils/group-by.js

function groupBy(collection, grouper) {
    var results = {};
    collection.forEach(function (item) {
        var _a;
        var key = undefined;
        if (typeof grouper === 'string') {
            var suggestedKey = item[grouper];
            key =
                typeof suggestedKey !== 'string'
                    ? JSON.stringify(suggestedKey)
                    : suggestedKey;
        }
        else if (grouper instanceof Function) {
            key = grouper(item);
        }
        if (key === undefined) {
            return;
        }
        results[key] = (0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([], ((_a = results[key]) !== null && _a !== void 0 ? _a : []), true), [item], false);
    });
    return results;
}
//# sourceMappingURL=group-by.js.map
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/priority-queue/index.js + 1 modules
var priority_queue = __webpack_require__(82635);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/context/index.js + 1 modules
var esm_context = __webpack_require__(58074);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/utils/is-thenable.js
/**
 *  Check if  thenable
 *  (instanceof Promise doesn't respect realms)
 */
var isThenable = function (value) {
    return typeof value === 'object' &&
        value !== null &&
        'then' in value &&
        typeof value.then === 'function';
};
//# sourceMappingURL=is-thenable.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/task/task-group.js

var createTaskGroup = function () {
    var taskCompletionPromise;
    var resolvePromise;
    var count = 0;
    return {
        done: function () { return taskCompletionPromise; },
        run: function (op) {
            var returnValue = op();
            if (isThenable(returnValue)) {
                if (++count === 1) {
                    taskCompletionPromise = new Promise(function (res) { return (resolvePromise = res); });
                }
                returnValue.finally(function () { return --count === 0 && resolvePromise(); });
            }
            return returnValue;
        },
    };
};
//# sourceMappingURL=task-group.js.map
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/queue/delivery.js
var delivery = __webpack_require__(94270);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-core/dist/esm/queue/event-queue.js







var CoreEventQueue = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(CoreEventQueue, _super);
    function CoreEventQueue(priorityQueue) {
        var _this = _super.call(this) || this;
        /**
         * All event deliveries get suspended until all the tasks in this task group are complete.
         * For example: a middleware that augments the event object should be loaded safely as a
         * critical task, this way, event queue will wait for it to be ready before sending events.
         *
         * This applies to all the events already in the queue, and the upcoming ones
         */
        _this.criticalTasks = createTaskGroup();
        _this.plugins = [];
        _this.failedInitializations = [];
        _this.flushing = false;
        _this.queue = priorityQueue;
        _this.queue.on(priority_queue/* ON_REMOVE_FROM_FUTURE */.M, function () {
            _this.scheduleFlush(0);
        });
        return _this;
    }
    CoreEventQueue.prototype.register = function (ctx, plugin, instance) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var handleLoadError, err_1;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.plugins.push(plugin);
                        handleLoadError = function (err) {
                            _this.failedInitializations.push(plugin.name);
                            _this.emit('initialization_failure', plugin);
                            console.warn(plugin.name, err);
                            ctx.log('warn', 'Failed to load destination', {
                                plugin: plugin.name,
                                error: err,
                            });
                            // Filter out the failed plugin by excluding it from the list
                            _this.plugins = _this.plugins.filter(function (p) { return p !== plugin; });
                        };
                        if (!(plugin.type === 'destination' && plugin.name !== 'Segment.io')) return [3 /*break*/, 1];
                        plugin.load(ctx, instance).catch(handleLoadError);
                        return [3 /*break*/, 4];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, plugin.load(ctx, instance)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        handleLoadError(err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CoreEventQueue.prototype.deregister = function (ctx, plugin, instance) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var e_1;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!plugin.unload) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.resolve(plugin.unload(ctx, instance))];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.plugins = this.plugins.filter(function (p) { return p.name !== plugin.name; });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        ctx.log('warn', 'Failed to unload destination', {
                            plugin: plugin.name,
                            error: e_1,
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CoreEventQueue.prototype.dispatch = function (ctx) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var willDeliver;
            return (0,tslib_es6.__generator)(this, function (_a) {
                ctx.log('debug', 'Dispatching');
                ctx.stats.increment('message_dispatched');
                this.queue.push(ctx);
                willDeliver = this.subscribeToDelivery(ctx);
                this.scheduleFlush(0);
                return [2 /*return*/, willDeliver];
            });
        });
    };
    CoreEventQueue.prototype.subscribeToDelivery = function (ctx) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        var onDeliver = function (flushed, delivered) {
                            if (flushed.isSame(ctx)) {
                                _this.off('flush', onDeliver);
                                if (delivered) {
                                    resolve(flushed);
                                }
                                else {
                                    resolve(flushed);
                                }
                            }
                        };
                        _this.on('flush', onDeliver);
                    })];
            });
        });
    };
    CoreEventQueue.prototype.dispatchSingle = function (ctx) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                ctx.log('debug', 'Dispatching');
                ctx.stats.increment('message_dispatched');
                this.queue.updateAttempts(ctx);
                ctx.attempts = 1;
                return [2 /*return*/, this.deliver(ctx).catch(function (err) {
                        var accepted = _this.enqueuRetry(err, ctx);
                        if (!accepted) {
                            ctx.setFailedDelivery({ reason: err });
                            return ctx;
                        }
                        return _this.subscribeToDelivery(ctx);
                    })];
            });
        });
    };
    CoreEventQueue.prototype.isEmpty = function () {
        return this.queue.length === 0;
    };
    CoreEventQueue.prototype.scheduleFlush = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 500; }
        if (this.flushing) {
            return;
        }
        this.flushing = true;
        setTimeout(function () {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            _this.flush().then(function () {
                setTimeout(function () {
                    _this.flushing = false;
                    if (_this.queue.length) {
                        _this.scheduleFlush(0);
                    }
                }, 0);
            });
        }, timeout);
    };
    CoreEventQueue.prototype.deliver = function (ctx) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var start, done, err_2, error;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.criticalTasks.done()];
                    case 1:
                        _a.sent();
                        start = Date.now();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.flushOne(ctx)];
                    case 3:
                        ctx = _a.sent();
                        done = Date.now() - start;
                        this.emit('delivery_success', ctx);
                        ctx.stats.gauge('delivered', done);
                        ctx.log('debug', 'Delivered', ctx.event);
                        return [2 /*return*/, ctx];
                    case 4:
                        err_2 = _a.sent();
                        error = err_2;
                        ctx.log('error', 'Failed to deliver', error);
                        this.emit('delivery_failure', ctx, error);
                        ctx.stats.increment('delivery_failed');
                        throw err_2;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CoreEventQueue.prototype.enqueuRetry = function (err, ctx) {
        var retriable = !(err instanceof esm_context/* ContextCancelation */.Y) || err.retry;
        if (!retriable) {
            return false;
        }
        return this.queue.pushWithBackoff(ctx);
    };
    CoreEventQueue.prototype.flush = function () {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var ctx, err_3, accepted;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.queue.length === 0) {
                            return [2 /*return*/, []];
                        }
                        ctx = this.queue.pop();
                        if (!ctx) {
                            return [2 /*return*/, []];
                        }
                        ctx.attempts = this.queue.getAttempts(ctx);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.deliver(ctx)];
                    case 2:
                        ctx = _a.sent();
                        this.emit('flush', ctx, true);
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        accepted = this.enqueuRetry(err_3, ctx);
                        if (!accepted) {
                            ctx.setFailedDelivery({ reason: err_3 });
                            this.emit('flush', ctx, false);
                        }
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/, [ctx]];
                }
            });
        });
    };
    CoreEventQueue.prototype.isReady = function () {
        // return this.plugins.every((p) => p.isLoaded())
        // should we wait for every plugin to load?
        return true;
    };
    CoreEventQueue.prototype.availableExtensions = function (denyList) {
        var available = this.plugins.filter(function (p) {
            var _a, _b, _c;
            // Only filter out destination plugins or the Segment.io plugin
            if (p.type !== 'destination' && p.name !== 'Segment.io') {
                return true;
            }
            var alternativeNameMatch = undefined;
            (_a = p.alternativeNames) === null || _a === void 0 ? void 0 : _a.forEach(function (name) {
                if (denyList[name] !== undefined) {
                    alternativeNameMatch = denyList[name];
                }
            });
            // Explicit integration option takes precedence, `All: false` does not apply to Segment.io
            return ((_c = (_b = denyList[p.name]) !== null && _b !== void 0 ? _b : alternativeNameMatch) !== null && _c !== void 0 ? _c : (p.name === 'Segment.io' ? true : denyList.All) !== false);
        });
        var _a = groupBy(available, 'type'), _b = _a.before, before = _b === void 0 ? [] : _b, _c = _a.enrichment, enrichment = _c === void 0 ? [] : _c, _d = _a.destination, destination = _d === void 0 ? [] : _d, _e = _a.after, after = _e === void 0 ? [] : _e;
        return {
            before: before,
            enrichment: enrichment,
            destinations: destination,
            after: after,
        };
    };
    CoreEventQueue.prototype.flushOne = function (ctx) {
        var _a, _b;
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var _c, before, enrichment, _i, before_1, beforeWare, temp, _d, enrichment_1, enrichmentWare, temp, _e, destinations, after, afterCalls;
            return (0,tslib_es6.__generator)(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!this.isReady()) {
                            throw new Error('Not ready');
                        }
                        if (ctx.attempts > 1) {
                            this.emit('delivery_retry', ctx);
                        }
                        _c = this.availableExtensions((_a = ctx.event.integrations) !== null && _a !== void 0 ? _a : {}), before = _c.before, enrichment = _c.enrichment;
                        _i = 0, before_1 = before;
                        _f.label = 1;
                    case 1:
                        if (!(_i < before_1.length)) return [3 /*break*/, 4];
                        beforeWare = before_1[_i];
                        return [4 /*yield*/, (0,delivery/* ensure */.z)(ctx, beforeWare)];
                    case 2:
                        temp = _f.sent();
                        if (temp instanceof esm_context/* CoreContext */._) {
                            ctx = temp;
                        }
                        this.emit('message_enriched', ctx, beforeWare);
                        _f.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        _d = 0, enrichment_1 = enrichment;
                        _f.label = 5;
                    case 5:
                        if (!(_d < enrichment_1.length)) return [3 /*break*/, 8];
                        enrichmentWare = enrichment_1[_d];
                        return [4 /*yield*/, (0,delivery/* attempt */.a)(ctx, enrichmentWare)];
                    case 6:
                        temp = _f.sent();
                        if (temp instanceof esm_context/* CoreContext */._) {
                            ctx = temp;
                        }
                        this.emit('message_enriched', ctx, enrichmentWare);
                        _f.label = 7;
                    case 7:
                        _d++;
                        return [3 /*break*/, 5];
                    case 8:
                        _e = this.availableExtensions((_b = ctx.event.integrations) !== null && _b !== void 0 ? _b : {}), destinations = _e.destinations, after = _e.after;
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                setTimeout(function () {
                                    var attempts = destinations.map(function (destination) {
                                        return (0,delivery/* attempt */.a)(ctx, destination);
                                    });
                                    Promise.all(attempts).then(resolve).catch(reject);
                                }, 0);
                            })];
                    case 9:
                        _f.sent();
                        ctx.stats.increment('message_delivered');
                        this.emit('message_delivered', ctx);
                        afterCalls = after.map(function (after) { return (0,delivery/* attempt */.a)(ctx, after); });
                        return [4 /*yield*/, Promise.all(afterCalls)];
                    case 10:
                        _f.sent();
                        return [2 /*return*/, ctx];
                }
            });
        });
    };
    return CoreEventQueue;
}(emitter/* Emitter */.Q));

//# sourceMappingURL=event-queue.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/queue/event-queue.js




var EventQueue = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(EventQueue, _super);
    function EventQueue(nameOrQueue) {
        return _super.call(this, typeof nameOrQueue === 'string'
            ? new persisted/* PersistedPriorityQueue */.$(4, nameOrQueue)
            : nameOrQueue) || this;
    }
    EventQueue.prototype.flush = function () {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                if ((0,connection/* isOffline */.s)())
                    return [2 /*return*/, []];
                return [2 /*return*/, _super.prototype.flush.call(this)];
            });
        });
    };
    return EventQueue;
}(CoreEventQueue));

//# sourceMappingURL=event-queue.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/bind-all.js
function bindAll(obj) {
    var proto = obj.constructor.prototype;
    for (var _i = 0, _a = Object.getOwnPropertyNames(proto); _i < _a.length; _i++) {
        var key = _a[_i];
        if (key !== 'constructor') {
            var desc = Object.getOwnPropertyDescriptor(obj.constructor.prototype, key);
            if (!!desc && typeof desc.value === 'function') {
                obj[key] = obj[key].bind(obj);
            }
        }
    }
    return obj;
}
//# sourceMappingURL=bind-all.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/storage/types.js
var StoreType = {
    Cookie: 'cookie',
    LocalStorage: 'localStorage',
    Memory: 'memory',
};
//# sourceMappingURL=types.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/storage/universalStorage.js
// not adding to private method because those method names do not get minified atm, and does not use 'this'
var _logStoreKeyError = function (store, action, key, err) {
    console.warn("".concat(store.constructor.name, ": Can't ").concat(action, " key \"").concat(key, "\" | Err: ").concat(err));
};
/**
 * Uses multiple storages in a priority list to get/set values in the order they are specified.
 */
var UniversalStorage = /** @class */ (function () {
    function UniversalStorage(stores) {
        this.stores = stores;
    }
    UniversalStorage.prototype.get = function (key) {
        var val = null;
        for (var _i = 0, _a = this.stores; _i < _a.length; _i++) {
            var store = _a[_i];
            try {
                val = store.get(key);
                if (val !== undefined && val !== null) {
                    return val;
                }
            }
            catch (e) {
                _logStoreKeyError(store, 'get', key, e);
            }
        }
        return null;
    };
    UniversalStorage.prototype.set = function (key, value) {
        this.stores.forEach(function (store) {
            try {
                store.set(key, value);
            }
            catch (e) {
                _logStoreKeyError(store, 'set', key, e);
            }
        });
    };
    UniversalStorage.prototype.clear = function (key) {
        this.stores.forEach(function (store) {
            try {
                store.remove(key);
            }
            catch (e) {
                _logStoreKeyError(store, 'remove', key, e);
            }
        });
    };
    /*
      This is to support few scenarios where:
      - value exist in one of the stores ( as a result of other stores being cleared from browser ) and we want to resync them
      - read values in AJS 1.0 format ( for customers after 1.0 --> 2.0 migration ) and then re-write them in AJS 2.0 format
    */
    UniversalStorage.prototype.getAndSync = function (key) {
        var val = this.get(key);
        // legacy behavior, getAndSync can change the type of a value from number to string (AJS 1.0 stores numerical values as a number)
        var coercedValue = (typeof val === 'number' ? val.toString() : val);
        this.set(key, coercedValue);
        return coercedValue;
    };
    return UniversalStorage;
}());

//# sourceMappingURL=universalStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/storage/memoryStorage.js
/**
 * Data Storage using in memory object
 */
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.cache = {};
    }
    MemoryStorage.prototype.get = function (key) {
        var _a;
        return ((_a = this.cache[key]) !== null && _a !== void 0 ? _a : null);
    };
    MemoryStorage.prototype.set = function (key, value) {
        this.cache[key] = value;
    };
    MemoryStorage.prototype.remove = function (key) {
        delete this.cache[key];
    };
    return MemoryStorage;
}());

//# sourceMappingURL=memoryStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/storage/settings.js

function isArrayOfStoreType(s) {
    return (s &&
        s.stores &&
        Array.isArray(s.stores) &&
        s.stores.every(function (e) { return Object.values(StoreType).includes(e); }));
}
function isStoreTypeWithSettings(s) {
    return typeof s === 'object' && s.name !== undefined;
}
//# sourceMappingURL=settings.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */

/* harmony default export */ var js_cookie = (api);

;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/user/tld.js

/**
 * Levels returns all levels of the given url.
 *
 * @param {string} url
 * @return {Array}
 * @api public
 */
function levels(url) {
    var host = url.hostname;
    var parts = host.split('.');
    var last = parts[parts.length - 1];
    var levels = [];
    // Ip address.
    if (parts.length === 4 && parseInt(last, 10) > 0) {
        return levels;
    }
    // Localhost.
    if (parts.length <= 1) {
        return levels;
    }
    // Create levels.
    for (var i = parts.length - 2; i >= 0; --i) {
        levels.push(parts.slice(i).join('.'));
    }
    return levels;
}
function parseUrl(url) {
    try {
        return new URL(url);
    }
    catch (_a) {
        return;
    }
}
function tld(url) {
    var parsedUrl = parseUrl(url);
    if (!parsedUrl)
        return;
    var lvls = levels(parsedUrl);
    // Lookup the real top level one.
    for (var i = 0; i < lvls.length; ++i) {
        var cname = '__tld__';
        var domain = lvls[i];
        var opts = { domain: '.' + domain };
        try {
            // cookie access throw an error if the library is ran inside a sandboxed environment (e.g. sandboxed iframe)
            js_cookie.set(cname, '1', opts);
            if (js_cookie.get(cname)) {
                js_cookie.remove(cname, opts);
                return domain;
            }
        }
        catch (_) {
            return;
        }
    }
}
//# sourceMappingURL=tld.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/storage/cookieStorage.js



var ONE_YEAR = 365;
/**
 * Data storage using browser cookies
 */
var CookieStorage = /** @class */ (function () {
    function CookieStorage(options) {
        if (options === void 0) { options = CookieStorage.defaults; }
        this.options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, CookieStorage.defaults), options);
    }
    Object.defineProperty(CookieStorage, "defaults", {
        get: function () {
            return {
                maxage: ONE_YEAR,
                domain: tld(window.location.href),
                path: '/',
                sameSite: 'Lax',
            };
        },
        enumerable: false,
        configurable: true
    });
    CookieStorage.prototype.opts = function () {
        return {
            sameSite: this.options.sameSite,
            expires: this.options.maxage,
            domain: this.options.domain,
            path: this.options.path,
            secure: this.options.secure,
        };
    };
    CookieStorage.prototype.get = function (key) {
        var _a;
        try {
            var value = js_cookie.get(key);
            if (value === undefined || value === null) {
                return null;
            }
            try {
                return (_a = JSON.parse(value)) !== null && _a !== void 0 ? _a : null;
            }
            catch (e) {
                return (value !== null && value !== void 0 ? value : null);
            }
        }
        catch (e) {
            return null;
        }
    };
    CookieStorage.prototype.set = function (key, value) {
        if (typeof value === 'string') {
            js_cookie.set(key, value, this.opts());
        }
        else if (value === null) {
            js_cookie.remove(key, this.opts());
        }
        else {
            js_cookie.set(key, JSON.stringify(value), this.opts());
        }
    };
    CookieStorage.prototype.remove = function (key) {
        return js_cookie.remove(key, this.opts());
    };
    return CookieStorage;
}());

//# sourceMappingURL=cookieStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/storage/localStorage.js
/**
 * Data storage using browser's localStorage
 */
var LocalStorage = /** @class */ (function () {
    function LocalStorage() {
    }
    LocalStorage.prototype.localStorageWarning = function (key, state) {
        console.warn("Unable to access ".concat(key, ", localStorage may be ").concat(state));
    };
    LocalStorage.prototype.get = function (key) {
        var _a;
        try {
            var val = localStorage.getItem(key);
            if (val === null) {
                return null;
            }
            try {
                return (_a = JSON.parse(val)) !== null && _a !== void 0 ? _a : null;
            }
            catch (e) {
                return (val !== null && val !== void 0 ? val : null);
            }
        }
        catch (err) {
            this.localStorageWarning(key, 'unavailable');
            return null;
        }
    };
    LocalStorage.prototype.set = function (key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        }
        catch (_a) {
            this.localStorageWarning(key, 'full');
        }
    };
    LocalStorage.prototype.remove = function (key) {
        try {
            return localStorage.removeItem(key);
        }
        catch (err) {
            this.localStorageWarning(key, 'unavailable');
        }
    };
    return LocalStorage;
}());

//# sourceMappingURL=localStorage.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/storage/index.js











/**
 * Creates multiple storage systems from an array of StoreType and options
 * @param args StoreType and options
 * @returns Storage array
 */
function initializeStorages(args) {
    var storages = args.map(function (s) {
        var type;
        var settings;
        if (isStoreTypeWithSettings(s)) {
            type = s.name;
            settings = s.settings;
        }
        else {
            type = s;
        }
        switch (type) {
            case StoreType.Cookie:
                return new CookieStorage(settings);
            case StoreType.LocalStorage:
                return new LocalStorage();
            case StoreType.Memory:
                return new MemoryStorage();
            default:
                throw new Error("Unknown Store Type: ".concat(s));
        }
    });
    return storages;
}
/**
 * Injects the CookieOptions into a the arguments for initializeStorage
 * @param storeTypes list of storeType
 * @param cookieOptions cookie Options
 * @returns arguments for initializeStorage
 */
function applyCookieOptions(storeTypes, cookieOptions) {
    return storeTypes.map(function (s) {
        if (cookieOptions && s === StoreType.Cookie) {
            return {
                name: s,
                settings: cookieOptions,
            };
        }
        return s;
    });
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/user/index.js




var defaults = {
    persist: true,
    cookie: {
        key: 'ajs_user_id',
        oldKey: 'ajs_user',
    },
    localStorage: {
        key: 'ajs_user_traits',
    },
};
var User = /** @class */ (function () {
    function User(options, cookieOptions) {
        if (options === void 0) { options = defaults; }
        var _this = this;
        var _a, _b, _c, _d;
        this.options = {};
        this.id = function (id) {
            if (_this.options.disable) {
                return null;
            }
            var prevId = _this.identityStore.getAndSync(_this.idKey);
            if (id !== undefined) {
                _this.identityStore.set(_this.idKey, id);
                var changingIdentity = id !== prevId && prevId !== null && id !== null;
                if (changingIdentity) {
                    _this.anonymousId(null);
                }
            }
            var retId = _this.identityStore.getAndSync(_this.idKey);
            if (retId)
                return retId;
            var retLeg = _this.legacyUserStore.get(defaults.cookie.oldKey);
            return retLeg ? (typeof retLeg === 'object' ? retLeg.id : retLeg) : null;
        };
        this.anonymousId = function (id) {
            var _a, _b;
            if (_this.options.disable) {
                return null;
            }
            if (id === undefined) {
                var val = (_a = _this.identityStore.getAndSync(_this.anonKey)) !== null && _a !== void 0 ? _a : (_b = _this.legacySIO()) === null || _b === void 0 ? void 0 : _b[0];
                if (val) {
                    return val;
                }
            }
            if (id === null) {
                _this.identityStore.set(_this.anonKey, null);
                return _this.identityStore.getAndSync(_this.anonKey);
            }
            _this.identityStore.set(_this.anonKey, id !== null && id !== void 0 ? id : (0,dist.v4)());
            return _this.identityStore.getAndSync(_this.anonKey);
        };
        this.traits = function (traits) {
            var _a;
            if (_this.options.disable) {
                return;
            }
            if (traits === null) {
                traits = {};
            }
            if (traits) {
                _this.traitsStore.set(_this.traitsKey, traits !== null && traits !== void 0 ? traits : {});
            }
            return (_a = _this.traitsStore.get(_this.traitsKey)) !== null && _a !== void 0 ? _a : {};
        };
        this.options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, defaults), options);
        this.cookieOptions = cookieOptions;
        this.idKey = (_b = (_a = options.cookie) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : defaults.cookie.key;
        this.traitsKey = (_d = (_c = options.localStorage) === null || _c === void 0 ? void 0 : _c.key) !== null && _d !== void 0 ? _d : defaults.localStorage.key;
        this.anonKey = 'ajs_anonymous_id';
        this.identityStore = this.createStorage(this.options, cookieOptions);
        // using only cookies for legacy user store
        this.legacyUserStore = this.createStorage(this.options, cookieOptions, function (s) { return s === StoreType.Cookie; });
        // using only localStorage / memory for traits store
        this.traitsStore = this.createStorage(this.options, cookieOptions, function (s) { return s !== StoreType.Cookie; });
        var legacyUser = this.legacyUserStore.get(defaults.cookie.oldKey);
        if (legacyUser && typeof legacyUser === 'object') {
            legacyUser.id && this.id(legacyUser.id);
            legacyUser.traits && this.traits(legacyUser.traits);
        }
        bindAll(this);
    }
    User.prototype.legacySIO = function () {
        var val = this.legacyUserStore.get('_sio');
        if (!val) {
            return null;
        }
        var _a = val.split('----'), anon = _a[0], user = _a[1];
        return [anon, user];
    };
    User.prototype.identify = function (id, traits) {
        if (this.options.disable) {
            return;
        }
        traits = traits !== null && traits !== void 0 ? traits : {};
        var currentId = this.id();
        if (currentId === null || currentId === id) {
            traits = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.traits()), traits);
        }
        if (id) {
            this.id(id);
        }
        this.traits(traits);
    };
    User.prototype.logout = function () {
        this.anonymousId(null);
        this.id(null);
        this.traits({});
    };
    User.prototype.reset = function () {
        this.logout();
        this.identityStore.clear(this.idKey);
        this.identityStore.clear(this.anonKey);
        this.traitsStore.clear(this.traitsKey);
    };
    User.prototype.load = function () {
        return new User(this.options, this.cookieOptions);
    };
    User.prototype.save = function () {
        return true;
    };
    /**
     * Creates the right storage system applying all the user options, cookie options and particular filters
     * @param options UserOptions
     * @param cookieOpts CookieOptions
     * @param filterStores filter function to apply to any StoreTypes (skipped if options specify using a custom storage)
     * @returns a Storage object
     */
    User.prototype.createStorage = function (options, cookieOpts, filterStores) {
        var stores = [
            StoreType.LocalStorage,
            StoreType.Cookie,
            StoreType.Memory,
        ];
        // If disabled we won't have any storage functionality
        if (options.disable) {
            return new UniversalStorage([]);
        }
        // If persistance is disabled we will always fallback to Memory Storage
        if (!options.persist) {
            return new UniversalStorage([new MemoryStorage()]);
        }
        if (options.storage !== undefined && options.storage !== null) {
            if (isArrayOfStoreType(options.storage)) {
                // If the user only specified order of stores we will still apply filters and transformations e.g. not using localStorage if localStorageFallbackDisabled
                stores = options.storage.stores;
            }
        }
        // Disable LocalStorage
        if (options.localStorageFallbackDisabled) {
            stores = stores.filter(function (s) { return s !== StoreType.LocalStorage; });
        }
        // Apply Additional filters
        if (filterStores) {
            stores = stores.filter(filterStores);
        }
        return new UniversalStorage(initializeStorages(applyCookieOptions(stores, cookieOpts)));
    };
    User.defaults = defaults;
    return User;
}());

var groupDefaults = {
    persist: true,
    cookie: {
        key: 'ajs_group_id',
    },
    localStorage: {
        key: 'ajs_group_properties',
    },
};
var Group = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(Group, _super);
    function Group(options, cookie) {
        if (options === void 0) { options = groupDefaults; }
        var _this = _super.call(this, (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, groupDefaults), options), cookie) || this;
        _this.anonymousId = function (_id) {
            return undefined;
        };
        bindAll(_this);
        return _this;
    }
    return Group;
}(User));

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/generated/version.js
var version = __webpack_require__(74042);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/get-global.js
var get_global = __webpack_require__(38415);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/global-analytics-helper.js
var global_analytics_helper = __webpack_require__(32957);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/is-thenable.js
/**
 *  Check if  thenable
 *  (instanceof Promise doesn't respect realms)
 */
var is_thenable_isThenable = function (value) {
    return typeof value === 'object' &&
        value !== null &&
        'then' in value &&
        typeof value.then === 'function';
};
//# sourceMappingURL=is-thenable.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/buffer/index.js





var flushSyncAnalyticsCalls = function (name, analytics, buffer) {
    buffer.getCalls(name).forEach(function (c) {
        // While the underlying methods are synchronous, the callAnalyticsMethod returns a promise,
        // which normalizes success and error states between async and non-async methods, with no perf penalty.
        callAnalyticsMethod(analytics, c).catch(console.error);
    });
};
var flushAddSourceMiddleware = function (analytics, buffer) { return (0,tslib_es6.__awaiter)(void 0, void 0, void 0, function () {
    var _i, _a, c;
    return (0,tslib_es6.__generator)(this, function (_b) {
        switch (_b.label) {
            case 0:
                _i = 0, _a = buffer.getCalls('addSourceMiddleware');
                _b.label = 1;
            case 1:
                if (!(_i < _a.length)) return [3 /*break*/, 4];
                c = _a[_i];
                return [4 /*yield*/, callAnalyticsMethod(analytics, c).catch(console.error)];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                _i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}); };
var flushOn = flushSyncAnalyticsCalls.bind(undefined, 'on');
var flushSetAnonymousID = flushSyncAnalyticsCalls.bind(undefined, 'setAnonymousId');
var flushAnalyticsCallsInNewTask = function (analytics, buffer) {
    buffer.toArray().forEach(function (m) {
        setTimeout(function () {
            callAnalyticsMethod(analytics, m).catch(console.error);
        }, 0);
    });
};
var popPageContext = function (args) {
    if (hasBufferedPageContextAsLastArg(args)) {
        var ctx = args.pop();
        return createPageContext(ctx);
    }
};
var hasBufferedPageContextAsLastArg = function (args) {
    var lastArg = args[args.length - 1];
    return isBufferedPageContext(lastArg);
};
/**
 *  Represents a buffered method call that occurred before initialization.
 */
var PreInitMethodCall = /** @class */ (function () {
    function PreInitMethodCall(method, args, resolve, reject) {
        if (resolve === void 0) { resolve = function () { }; }
        if (reject === void 0) { reject = console.error; }
        this.method = method;
        this.resolve = resolve;
        this.reject = reject;
        this.called = false;
        this.args = args;
    }
    return PreInitMethodCall;
}());

/**
 *  Represents any and all the buffered method calls that occurred before initialization.
 */
var PreInitMethodCallBuffer = /** @class */ (function () {
    function PreInitMethodCallBuffer() {
        var calls = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            calls[_i] = arguments[_i];
        }
        this._callMap = {};
        this.push.apply(this, calls);
    }
    Object.defineProperty(PreInitMethodCallBuffer.prototype, "calls", {
        /**
         * Pull any buffered method calls from the window object, and use them to hydrate the instance buffer.
         */
        get: function () {
            this._pushSnippetWindowBuffer();
            return this._callMap;
        },
        set: function (calls) {
            this._callMap = calls;
        },
        enumerable: false,
        configurable: true
    });
    PreInitMethodCallBuffer.prototype.getCalls = function (methodName) {
        var _a;
        return ((_a = this.calls[methodName]) !== null && _a !== void 0 ? _a : []);
    };
    PreInitMethodCallBuffer.prototype.push = function () {
        var _this = this;
        var calls = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            calls[_i] = arguments[_i];
        }
        calls.forEach(function (call) {
            var eventsExpectingPageContext = [
                'track',
                'screen',
                'alias',
                'group',
                'page',
                'identify',
            ];
            if (eventsExpectingPageContext.includes(call.method) &&
                !hasBufferedPageContextAsLastArg(call.args)) {
                call.args = (0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([], call.args, true), [getDefaultBufferedPageContext()], false);
            }
            if (_this.calls[call.method]) {
                _this.calls[call.method].push(call);
            }
            else {
                _this.calls[call.method] = [call];
            }
        });
    };
    PreInitMethodCallBuffer.prototype.clear = function () {
        // clear calls in the global snippet buffered array.
        this._pushSnippetWindowBuffer();
        // clear calls in this instance
        this.calls = {};
    };
    PreInitMethodCallBuffer.prototype.toArray = function () {
        var _a;
        return (_a = []).concat.apply(_a, Object.values(this.calls));
    };
    /**
     * Fetch the buffered method calls from the window object,
     * normalize them, and use them to hydrate the buffer.
     * This removes existing buffered calls from the window object.
     */
    PreInitMethodCallBuffer.prototype._pushSnippetWindowBuffer = function () {
        var wa = (0,global_analytics_helper/* getGlobalAnalytics */.wI)();
        if (!Array.isArray(wa))
            return undefined;
        var buffered = wa.splice(0, wa.length);
        var calls = buffered.map(function (_a) {
            var methodName = _a[0], args = _a.slice(1);
            return new PreInitMethodCall(methodName, args);
        });
        this.push.apply(this, calls);
    };
    return PreInitMethodCallBuffer;
}());

/**
 *  Call method and mark as "called"
 *  This function should never throw an error
 */
function callAnalyticsMethod(analytics, call) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var result, err_1;
        return (0,tslib_es6.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (call.called) {
                        return [2 /*return*/, undefined];
                    }
                    call.called = true;
                    result = analytics[call.method].apply(analytics, call.args);
                    if (!is_thenable_isThenable(result)) return [3 /*break*/, 2];
                    // do not defer for non-async methods
                    return [4 /*yield*/, result];
                case 1:
                    // do not defer for non-async methods
                    _a.sent();
                    _a.label = 2;
                case 2:
                    call.resolve(result);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    call.reject(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var AnalyticsBuffered = /** @class */ (function () {
    function AnalyticsBuffered(loader) {
        var _this = this;
        this.trackSubmit = this._createMethod('trackSubmit');
        this.trackClick = this._createMethod('trackClick');
        this.trackLink = this._createMethod('trackLink');
        this.pageView = this._createMethod('pageview');
        this.identify = this._createMethod('identify');
        this.reset = this._createMethod('reset');
        this.group = this._createMethod('group');
        this.track = this._createMethod('track');
        this.ready = this._createMethod('ready');
        this.alias = this._createMethod('alias');
        this.debug = this._createChainableMethod('debug');
        this.page = this._createMethod('page');
        this.once = this._createChainableMethod('once');
        this.off = this._createChainableMethod('off');
        this.on = this._createChainableMethod('on');
        this.addSourceMiddleware = this._createMethod('addSourceMiddleware');
        this.setAnonymousId = this._createMethod('setAnonymousId');
        this.addDestinationMiddleware = this._createMethod('addDestinationMiddleware');
        this.screen = this._createMethod('screen');
        this.register = this._createMethod('register');
        this.deregister = this._createMethod('deregister');
        this.user = this._createMethod('user');
        this.VERSION = version/* version */.i;
        this._preInitBuffer = new PreInitMethodCallBuffer();
        this._promise = loader(this._preInitBuffer);
        this._promise
            .then(function (_a) {
            var ajs = _a[0], ctx = _a[1];
            _this.instance = ajs;
            _this.ctx = ctx;
        })
            .catch(function () {
            // intentionally do nothing...
            // this result of this promise will be caught by the 'catch' block on this class.
        });
    }
    AnalyticsBuffered.prototype.then = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this._promise).then.apply(_a, args);
    };
    AnalyticsBuffered.prototype.catch = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this._promise).catch.apply(_a, args);
    };
    AnalyticsBuffered.prototype.finally = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this._promise).finally.apply(_a, args);
    };
    AnalyticsBuffered.prototype._createMethod = function (methodName) {
        var _this = this;
        return function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.instance) {
                var result = (_a = _this.instance)[methodName].apply(_a, args);
                return Promise.resolve(result);
            }
            return new Promise(function (resolve, reject) {
                _this._preInitBuffer.push(new PreInitMethodCall(methodName, args, resolve, reject));
            });
        };
    };
    /**
     *  These are for methods that where determining when the method gets "flushed" is not important.
     *  These methods will resolve when analytics is fully initialized, and return type (other than Analytics)will not be available.
     */
    AnalyticsBuffered.prototype._createChainableMethod = function (methodName) {
        var _this = this;
        return function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.instance) {
                void (_a = _this.instance)[methodName].apply(_a, args);
                return _this;
            }
            else {
                _this._preInitBuffer.push(new PreInitMethodCall(methodName, args));
            }
            return _this;
        };
    };
    return AnalyticsBuffered;
}());

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/analytics/index.js


















var deprecationWarning = 'This is being deprecated and will be not be available in future releases of Analytics JS';
// reference any pre-existing "analytics" object so a user can restore the reference
var global = (0,get_global/* getGlobal */.R)();
var _analytics = global === null || global === void 0 ? void 0 : global.analytics;
function createDefaultQueue(name, retryQueue, disablePersistance) {
    if (retryQueue === void 0) { retryQueue = false; }
    if (disablePersistance === void 0) { disablePersistance = false; }
    var maxAttempts = retryQueue ? 10 : 1;
    var priorityQueue = disablePersistance
        ? new priority_queue/* PriorityQueue */.Z(maxAttempts, [])
        : new persisted/* PersistedPriorityQueue */.$(maxAttempts, name);
    return new EventQueue(priorityQueue);
}
/**
 * The public settings that are set on the analytics instance
 */
var AnalyticsInstanceSettings = /** @class */ (function () {
    function AnalyticsInstanceSettings(settings) {
        var _a;
        /**
         * Auto-track specific timeout setting   for legacy purposes.
         */
        this.timeout = 300;
        this.writeKey = settings.writeKey;
        this.cdnSettings = (_a = settings.cdnSettings) !== null && _a !== void 0 ? _a : { integrations: {} };
    }
    return AnalyticsInstanceSettings;
}());

/* analytics-classic stubs */
function _stub() {
    console.warn(deprecationWarning);
}
var Analytics = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(Analytics, _super);
    function Analytics(settings, options, queue, user, group) {
        var _this = this;
        var _a, _b;
        _this = _super.call(this) || this;
        _this._debug = false;
        _this.initialized = false;
        _this.user = function () {
            return _this._user;
        };
        _this.init = _this.initialize.bind(_this);
        _this.log = _stub;
        _this.addIntegrationMiddleware = _stub;
        _this.listeners = _stub;
        _this.addEventListener = _stub;
        _this.removeAllListeners = _stub;
        _this.removeListener = _stub;
        _this.removeEventListener = _stub;
        _this.hasListeners = _stub;
        _this.add = _stub;
        _this.addIntegration = _stub;
        var cookieOptions = options === null || options === void 0 ? void 0 : options.cookie;
        var disablePersistance = (_a = options === null || options === void 0 ? void 0 : options.disableClientPersistence) !== null && _a !== void 0 ? _a : false;
        _this.settings = new AnalyticsInstanceSettings(settings);
        _this.queue =
            queue !== null && queue !== void 0 ? queue : createDefaultQueue("".concat(settings.writeKey, ":event-queue"), options === null || options === void 0 ? void 0 : options.retryQueue, disablePersistance);
        var storageSetting = options === null || options === void 0 ? void 0 : options.storage;
        _this._universalStorage = _this.createStore(disablePersistance, storageSetting, cookieOptions);
        _this._user =
            user !== null && user !== void 0 ? user : new User((0,tslib_es6.__assign)({ persist: !disablePersistance, storage: options === null || options === void 0 ? void 0 : options.storage }, options === null || options === void 0 ? void 0 : options.user), cookieOptions).load();
        _this._group =
            group !== null && group !== void 0 ? group : new Group((0,tslib_es6.__assign)({ persist: !disablePersistance, storage: options === null || options === void 0 ? void 0 : options.storage }, options === null || options === void 0 ? void 0 : options.group), cookieOptions).load();
        _this.eventFactory = new EventFactory(_this._user);
        _this.integrations = (_b = options === null || options === void 0 ? void 0 : options.integrations) !== null && _b !== void 0 ? _b : {};
        _this.options = options !== null && options !== void 0 ? options : {};
        bindAll(_this);
        return _this;
    }
    /**
     * Creates the storage system based on the settings received
     * @returns Storage
     */
    Analytics.prototype.createStore = function (disablePersistance, storageSetting, cookieOptions) {
        // DisablePersistance option overrides all, no storage will be used outside of memory even if specified
        if (disablePersistance) {
            return new UniversalStorage([new MemoryStorage()]);
        }
        else {
            if (storageSetting) {
                if (isArrayOfStoreType(storageSetting)) {
                    // We will create the store with the priority for customer settings
                    return new UniversalStorage(initializeStorages(applyCookieOptions(storageSetting.stores, cookieOptions)));
                }
            }
        }
        // We default to our multi storage with priority
        return new UniversalStorage(initializeStorages([
            StoreType.LocalStorage,
            {
                name: StoreType.Cookie,
                settings: cookieOptions,
            },
            StoreType.Memory,
        ]));
    };
    Object.defineProperty(Analytics.prototype, "storage", {
        get: function () {
            return this._universalStorage;
        },
        enumerable: false,
        configurable: true
    });
    Analytics.prototype.track = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var pageCtx, _a, name, data, opts, cb, segmentEvent;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_b) {
                pageCtx = popPageContext(args);
                _a = resolveArguments.apply(void 0, args), name = _a[0], data = _a[1], opts = _a[2], cb = _a[3];
                segmentEvent = this.eventFactory.track(name, data, opts, this.integrations, pageCtx);
                return [2 /*return*/, this._dispatch(segmentEvent, cb).then(function (ctx) {
                        _this.emit('track', name, ctx.event.properties, ctx.event.options);
                        return ctx;
                    })];
            });
        });
    };
    Analytics.prototype.page = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var pageCtx, _a, category, page, properties, options, callback, segmentEvent;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_b) {
                pageCtx = popPageContext(args);
                _a = resolvePageArguments.apply(void 0, args), category = _a[0], page = _a[1], properties = _a[2], options = _a[3], callback = _a[4];
                segmentEvent = this.eventFactory.page(category, page, properties, options, this.integrations, pageCtx);
                return [2 /*return*/, this._dispatch(segmentEvent, callback).then(function (ctx) {
                        _this.emit('page', category, page, ctx.event.properties, ctx.event.options);
                        return ctx;
                    })];
            });
        });
    };
    Analytics.prototype.identify = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var pageCtx, _a, id, _traits, options, callback, segmentEvent;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_b) {
                pageCtx = popPageContext(args);
                _a = resolveUserArguments(this._user).apply(void 0, args), id = _a[0], _traits = _a[1], options = _a[2], callback = _a[3];
                this._user.identify(id, _traits);
                segmentEvent = this.eventFactory.identify(this._user.id(), this._user.traits(), options, this.integrations, pageCtx);
                return [2 /*return*/, this._dispatch(segmentEvent, callback).then(function (ctx) {
                        _this.emit('identify', ctx.event.userId, ctx.event.traits, ctx.event.options);
                        return ctx;
                    })];
            });
        });
    };
    Analytics.prototype.group = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var pageCtx = popPageContext(args);
        if (args.length === 0) {
            return this._group;
        }
        var _a = resolveUserArguments(this._group).apply(void 0, args), id = _a[0], _traits = _a[1], options = _a[2], callback = _a[3];
        this._group.identify(id, _traits);
        var groupId = this._group.id();
        var groupTraits = this._group.traits();
        var segmentEvent = this.eventFactory.group(groupId, groupTraits, options, this.integrations, pageCtx);
        return this._dispatch(segmentEvent, callback).then(function (ctx) {
            _this.emit('group', ctx.event.groupId, ctx.event.traits, ctx.event.options);
            return ctx;
        });
    };
    Analytics.prototype.alias = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var pageCtx, _a, to, from, options, callback, segmentEvent;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_b) {
                pageCtx = popPageContext(args);
                _a = resolveAliasArguments.apply(void 0, args), to = _a[0], from = _a[1], options = _a[2], callback = _a[3];
                segmentEvent = this.eventFactory.alias(to, from, options, this.integrations, pageCtx);
                return [2 /*return*/, this._dispatch(segmentEvent, callback).then(function (ctx) {
                        _this.emit('alias', to, from, ctx.event.options);
                        return ctx;
                    })];
            });
        });
    };
    Analytics.prototype.screen = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var pageCtx, _a, category, page, properties, options, callback, segmentEvent;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_b) {
                pageCtx = popPageContext(args);
                _a = resolvePageArguments.apply(void 0, args), category = _a[0], page = _a[1], properties = _a[2], options = _a[3], callback = _a[4];
                segmentEvent = this.eventFactory.screen(category, page, properties, options, this.integrations, pageCtx);
                return [2 /*return*/, this._dispatch(segmentEvent, callback).then(function (ctx) {
                        _this.emit('screen', category, page, ctx.event.properties, ctx.event.options);
                        return ctx;
                    })];
            });
        });
    };
    Analytics.prototype.trackClick = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var autotrack;
            var _a;
            return (0,tslib_es6.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, __webpack_require__.e(/* import() | auto-track */ 119).then(__webpack_require__.bind(__webpack_require__, 47932))];
                    case 1:
                        autotrack = _b.sent();
                        return [2 /*return*/, (_a = autotrack.link).call.apply(_a, (0,tslib_es6.__spreadArray)([this], args, false))];
                }
            });
        });
    };
    Analytics.prototype.trackLink = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var autotrack;
            var _a;
            return (0,tslib_es6.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, __webpack_require__.e(/* import() | auto-track */ 119).then(__webpack_require__.bind(__webpack_require__, 47932))];
                    case 1:
                        autotrack = _b.sent();
                        return [2 /*return*/, (_a = autotrack.link).call.apply(_a, (0,tslib_es6.__spreadArray)([this], args, false))];
                }
            });
        });
    };
    Analytics.prototype.trackSubmit = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var autotrack;
            var _a;
            return (0,tslib_es6.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, __webpack_require__.e(/* import() | auto-track */ 119).then(__webpack_require__.bind(__webpack_require__, 47932))];
                    case 1:
                        autotrack = _b.sent();
                        return [2 /*return*/, (_a = autotrack.form).call.apply(_a, (0,tslib_es6.__spreadArray)([this], args, false))];
                }
            });
        });
    };
    Analytics.prototype.trackForm = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var autotrack;
            var _a;
            return (0,tslib_es6.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, __webpack_require__.e(/* import() | auto-track */ 119).then(__webpack_require__.bind(__webpack_require__, 47932))];
                    case 1:
                        autotrack = _b.sent();
                        return [2 /*return*/, (_a = autotrack.form).call.apply(_a, (0,tslib_es6.__spreadArray)([this], args, false))];
                }
            });
        });
    };
    Analytics.prototype.register = function () {
        var plugins = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            plugins[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var ctx, registrations;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ctx = context/* Context.system */._.system();
                        registrations = plugins.map(function (xt) {
                            return _this.queue.register(ctx, xt, _this);
                        });
                        return [4 /*yield*/, Promise.all(registrations)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, ctx];
                }
            });
        });
    };
    Analytics.prototype.deregister = function () {
        var plugins = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            plugins[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var ctx, deregistrations;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ctx = context/* Context.system */._.system();
                        deregistrations = plugins.map(function (pl) {
                            var plugin = _this.queue.plugins.find(function (p) { return p.name === pl; });
                            if (plugin) {
                                return _this.queue.deregister(ctx, plugin, _this);
                            }
                            else {
                                ctx.log('warn', "plugin ".concat(pl, " not found"));
                            }
                        });
                        return [4 /*yield*/, Promise.all(deregistrations)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, ctx];
                }
            });
        });
    };
    Analytics.prototype.debug = function (toggle) {
        // Make sure legacy ajs debug gets turned off if it was enabled before upgrading.
        if (toggle === false && localStorage.getItem('debug')) {
            localStorage.removeItem('debug');
        }
        this._debug = toggle;
        return this;
    };
    Analytics.prototype.reset = function () {
        this._user.reset();
        this._group.reset();
        this.emit('reset');
    };
    Analytics.prototype.timeout = function (timeout) {
        this.settings.timeout = timeout;
    };
    Analytics.prototype._dispatch = function (event, callback) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var ctx;
            return (0,tslib_es6.__generator)(this, function (_a) {
                ctx = new context/* Context */._(event);
                if ((0,connection/* isOffline */.s)() && !this.options.retryQueue) {
                    return [2 /*return*/, ctx];
                }
                return [2 /*return*/, dispatch(ctx, this.queue, this, {
                        callback: callback,
                        debug: this._debug,
                        timeout: this.settings.timeout,
                    })];
            });
        });
    };
    Analytics.prototype.addSourceMiddleware = function (fn) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queue.criticalTasks.run(function () { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                            var sourceMiddlewarePlugin, integrations, plugin;
                            return (0,tslib_es6.__generator)(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 55779))];
                                    case 1:
                                        sourceMiddlewarePlugin = (_a.sent()).sourceMiddlewarePlugin;
                                        integrations = {};
                                        this.queue.plugins.forEach(function (plugin) {
                                            if (plugin.type === 'destination') {
                                                return (integrations[plugin.name] = true);
                                            }
                                        });
                                        plugin = sourceMiddlewarePlugin(fn, integrations);
                                        return [4 /*yield*/, this.register(plugin)];
                                    case 2:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this];
                }
            });
        });
    };
    /* TODO: This does not have to return a promise? */
    Analytics.prototype.addDestinationMiddleware = function (integrationName) {
        var middlewares = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            middlewares[_i - 1] = arguments[_i];
        }
        this.queue.plugins
            .filter(isDestinationPluginWithAddMiddleware)
            .forEach(function (p) {
            if (integrationName === '*' ||
                p.name.toLowerCase() === integrationName.toLowerCase()) {
                p.addMiddleware.apply(p, middlewares);
            }
        });
        return Promise.resolve(this);
    };
    Analytics.prototype.setAnonymousId = function (id) {
        return this._user.anonymousId(id);
    };
    Analytics.prototype.queryString = function (query) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var queryString;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.options.useQueryString === false) {
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, __webpack_require__.e(/* import() | queryString */ 96).then(__webpack_require__.bind(__webpack_require__, 71503))];
                    case 1:
                        queryString = (_a.sent()).queryString;
                        return [2 /*return*/, queryString(this, query)];
                }
            });
        });
    };
    /**
     * @deprecated This function does not register a destination plugin.
     *
     * Instantiates a legacy Analytics.js destination.
     *
     * This function does not register the destination as an Analytics.JS plugin,
     * all the it does it to invoke the factory function back.
     */
    Analytics.prototype.use = function (legacyPluginFactory) {
        legacyPluginFactory(this);
        return this;
    };
    Analytics.prototype.ready = function (callback) {
        if (callback === void 0) { callback = function (res) { return res; }; }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                return [2 /*return*/, Promise.all(this.queue.plugins.map(function (i) { return (i.ready ? i.ready() : Promise.resolve()); })).then(function (res) {
                        callback(res);
                        return res;
                    })];
            });
        });
    };
    // analytics-classic api
    Analytics.prototype.noConflict = function () {
        console.warn(deprecationWarning);
        (0,global_analytics_helper/* setGlobalAnalytics */.ql)(_analytics !== null && _analytics !== void 0 ? _analytics : this);
        return this;
    };
    Analytics.prototype.normalize = function (msg) {
        console.warn(deprecationWarning);
        return this.eventFactory['normalize'](msg);
    };
    Object.defineProperty(Analytics.prototype, "failedInitializations", {
        get: function () {
            console.warn(deprecationWarning);
            return this.queue.failedInitializations;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Analytics.prototype, "VERSION", {
        get: function () {
            return version/* version */.i;
        },
        enumerable: false,
        configurable: true
    });
    /* @deprecated - noop */
    Analytics.prototype.initialize = function (_settings, _options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                console.warn(deprecationWarning);
                return [2 /*return*/, Promise.resolve(this)];
            });
        });
    };
    Analytics.prototype.pageview = function (url) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.warn(deprecationWarning);
                        return [4 /*yield*/, this.page({ path: url })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this];
                }
            });
        });
    };
    Object.defineProperty(Analytics.prototype, "plugins", {
        get: function () {
            var _a;
            console.warn(deprecationWarning);
            // @ts-expect-error
            return (_a = this._plugins) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Analytics.prototype, "Integrations", {
        get: function () {
            console.warn(deprecationWarning);
            var integrations = this.queue.plugins
                .filter(function (plugin) { return plugin.type === 'destination'; })
                .reduce(function (acc, plugin) {
                var name = "".concat(plugin.name
                    .toLowerCase()
                    .replace('.', '')
                    .split(' ')
                    .join('-'), "Integration");
                // @ts-expect-error
                var integration = window[name];
                if (!integration) {
                    return acc;
                }
                var nested = integration.Integration; // hack - Google Analytics function resides in the "Integration" field
                if (nested) {
                    acc[plugin.name] = nested;
                    return acc;
                }
                acc[plugin.name] = integration;
                return acc;
            }, {});
            return integrations;
        },
        enumerable: false,
        configurable: true
    });
    // snippet function
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Analytics.prototype.push = function (args) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var an = this;
        var method = args.shift();
        if (method) {
            if (!an[method])
                return;
        }
        an[method].apply(this, args);
    };
    return Analytics;
}(emitter/* Emitter */.Q));

/**
 * @returns a no-op analytics instance that does not create cookies or localstorage, or send any events to segment.
 */
var NullAnalytics = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(NullAnalytics, _super);
    function NullAnalytics() {
        var _this = _super.call(this, { writeKey: '' }, { disableClientPersistence: true }) || this;
        _this.initialized = true;
        return _this;
    }
    return NullAnalytics;
}(Analytics));

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/merged-options.js
var merged_options = __webpack_require__(90412);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-generic-utils/dist/esm/create-deferred/create-deferred.js
var create_deferred = __webpack_require__(34498);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/version-type.js
var version_type = __webpack_require__(22029);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/query-string/gracefulDecodeURIComponent.js
var gracefulDecodeURIComponent = __webpack_require__(86198);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/client-hints/index.js

function clientHints(hints) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var userAgentData;
        return (0,tslib_es6.__generator)(this, function (_a) {
            userAgentData = navigator.userAgentData;
            if (!userAgentData)
                return [2 /*return*/, undefined];
            if (!hints)
                return [2 /*return*/, userAgentData.toJSON()];
            return [2 /*return*/, userAgentData
                    .getHighEntropyValues(hints)
                    .catch(function () { return userAgentData.toJSON(); })];
        });
    });
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/plugins/env-enrichment/index.js








var cookieOptions;
function getCookieOptions() {
    if (cookieOptions) {
        return cookieOptions;
    }
    var domain = tld(window.location.href);
    cookieOptions = {
        expires: 31536000000,
        secure: false,
        path: '/',
    };
    if (domain) {
        cookieOptions.domain = domain;
    }
    return cookieOptions;
}
function ads(query) {
    var queryIds = {
        btid: 'dataxu',
        urid: 'millennial-media',
    };
    if (query.startsWith('?')) {
        query = query.substring(1);
    }
    query = query.replace(/\?/g, '&');
    var parts = query.split('&');
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
        var part = parts_1[_i];
        var _a = part.split('='), k = _a[0], v = _a[1];
        if (queryIds[k]) {
            return {
                id: v,
                type: queryIds[k],
            };
        }
    }
}
function utm(query) {
    if (query.startsWith('?')) {
        query = query.substring(1);
    }
    query = query.replace(/\?/g, '&');
    return query.split('&').reduce(function (acc, str) {
        var _a = str.split('='), k = _a[0], _b = _a[1], v = _b === void 0 ? '' : _b;
        if (k.includes('utm_') && k.length > 4) {
            var utmParam = k.slice(4);
            if (utmParam === 'campaign') {
                utmParam = 'name';
            }
            acc[utmParam] = (0,gracefulDecodeURIComponent/* gracefulDecodeURIComponent */.a)(v);
        }
        return acc;
    }, {});
}
function ampId() {
    var ampId = js_cookie.get('_ga');
    if (ampId && ampId.startsWith('amp')) {
        return ampId;
    }
}
function referrerId(query, ctx, disablePersistance) {
    var _a;
    var storage = new UniversalStorage(disablePersistance ? [] : [new CookieStorage(getCookieOptions())]);
    var stored = storage.get('s:context.referrer');
    var ad = (_a = ads(query)) !== null && _a !== void 0 ? _a : stored;
    if (!ad) {
        return;
    }
    if (ctx) {
        ctx.referrer = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, ctx.referrer), ad);
    }
    storage.set('s:context.referrer', ad);
}
/**
 *
 * @param obj e.g. { foo: 'b', bar: 'd', baz: ['123', '456']}
 * @returns e.g. 'foo=b&bar=d&baz=123&baz=456'
 */
var objectToQueryString = function (obj) {
    try {
        var searchParams_1 = new URLSearchParams();
        Object.entries(obj).forEach(function (_a) {
            var k = _a[0], v = _a[1];
            if (Array.isArray(v)) {
                v.forEach(function (value) { return searchParams_1.append(k, value); });
            }
            else {
                searchParams_1.append(k, v);
            }
        });
        return searchParams_1.toString();
    }
    catch (_a) {
        return '';
    }
};
var EnvironmentEnrichmentPlugin = /** @class */ (function () {
    function EnvironmentEnrichmentPlugin() {
        var _this = this;
        this.name = 'Page Enrichment';
        this.type = 'before';
        this.version = '0.1.0';
        this.isLoaded = function () { return true; };
        this.load = function (_ctx, instance) { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
            var _a, _1;
            return (0,tslib_es6.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.instance = instance;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, clientHints(this.instance.options.highEntropyValuesClientHints)];
                    case 2:
                        _a.userAgentData = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _1 = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, Promise.resolve()];
                }
            });
        }); };
        this.enrich = function (ctx) {
            var _a, _b;
            // Note: Types are off - context should never be undefined here, since it is set as part of event creation.
            var evtCtx = ctx.event.context;
            var search = evtCtx.page.search || '';
            var query = typeof search === 'object' ? objectToQueryString(search) : search;
            evtCtx.userAgent = navigator.userAgent;
            evtCtx.userAgentData = _this.userAgentData;
            // @ts-ignore
            var locale = navigator.userLanguage || navigator.language;
            if (typeof evtCtx.locale === 'undefined' && typeof locale !== 'undefined') {
                evtCtx.locale = locale;
            }
            (_a = evtCtx.library) !== null && _a !== void 0 ? _a : (evtCtx.library = {
                name: 'analytics.js',
                version: "".concat((0,version_type/* getVersionType */.B)() === 'web' ? 'next' : 'npm:next', "-").concat(version/* version */.i),
            });
            if (query && !evtCtx.campaign) {
                evtCtx.campaign = utm(query);
            }
            var amp = ampId();
            if (amp) {
                evtCtx.amp = { id: amp };
            }
            referrerId(query, evtCtx, (_b = _this.instance.options.disableClientPersistence) !== null && _b !== void 0 ? _b : false);
            try {
                evtCtx.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
            catch (_) {
                // If browser doesn't have support leave timezone undefined
            }
            return ctx;
        };
        this.track = this.enrich;
        this.identify = this.enrich;
        this.page = this.enrich;
        this.group = this.enrich;
        this.alias = this.enrich;
        this.screen = this.enrich;
    }
    return EnvironmentEnrichmentPlugin;
}());
var envEnrichment = new EnvironmentEnrichmentPlugin();
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/load-script.js
var load_script = __webpack_require__(49729);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/plugins/middleware/index.js
var middleware = __webpack_require__(55779);
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/stats/metric-helpers.js
var metric_helpers = __webpack_require__(1242);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/plugins/remote-loader/index.js







var ActionDestination = /** @class */ (function () {
    function ActionDestination(name, action) {
        this.version = '1.0.0';
        this.alternativeNames = [];
        this.loadPromise = (0,create_deferred/* createDeferred */.d)();
        this.middleware = [];
        this.alias = this._createMethod('alias');
        this.group = this._createMethod('group');
        this.identify = this._createMethod('identify');
        this.page = this._createMethod('page');
        this.screen = this._createMethod('screen');
        this.track = this._createMethod('track');
        this.action = action;
        this.name = name;
        this.type = action.type;
        this.alternativeNames.push(action.name);
    }
    ActionDestination.prototype.addMiddleware = function () {
        var _a;
        var fn = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fn[_i] = arguments[_i];
        }
        /** Make sure we only apply destination filters to actions of the "destination" type to avoid causing issues for hybrid destinations */
        if (this.type === 'destination') {
            (_a = this.middleware).push.apply(_a, fn);
        }
    };
    ActionDestination.prototype.transform = function (ctx) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var modifiedEvent;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0,middleware.applyDestinationMiddleware)(this.name, ctx.event, this.middleware)];
                    case 1:
                        modifiedEvent = _a.sent();
                        if (modifiedEvent === null) {
                            ctx.cancel(new esm_context/* ContextCancelation */.Y({
                                retry: false,
                                reason: 'dropped by destination middleware',
                            }));
                        }
                        return [2 /*return*/, new context/* Context */._(modifiedEvent)];
                }
            });
        });
    };
    ActionDestination.prototype._createMethod = function (methodName) {
        var _this = this;
        return function (ctx) { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
            var transformedContext, error_1;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.action[methodName])
                            return [2 /*return*/, ctx];
                        transformedContext = ctx;
                        if (!(this.type === 'destination')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.transform(ctx)];
                    case 1:
                        transformedContext = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, this.ready()];
                    case 3:
                        if (!(_a.sent())) {
                            throw new Error('Something prevented the destination from getting ready');
                        }
                        (0,metric_helpers/* recordIntegrationMetric */.z)(ctx, {
                            integrationName: this.action.name,
                            methodName: methodName,
                            type: 'action',
                        });
                        return [4 /*yield*/, this.action[methodName](transformedContext)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        (0,metric_helpers/* recordIntegrationMetric */.z)(ctx, {
                            integrationName: this.action.name,
                            methodName: methodName,
                            type: 'action',
                            didError: true,
                        });
                        throw error_1;
                    case 6: return [2 /*return*/, ctx];
                }
            });
        }); };
    };
    /* --- PASSTHROUGH METHODS --- */
    ActionDestination.prototype.isLoaded = function () {
        return this.action.isLoaded();
    };
    ActionDestination.prototype.ready = function () {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var _a;
            return (0,tslib_es6.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.loadPromise.promise];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, true];
                    case 2:
                        _a = _b.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ActionDestination.prototype.load = function (ctx, analytics) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var loadP, _a, _b, error_2;
            return (0,tslib_es6.__generator)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.loadPromise.isSettled()) {
                            return [2 /*return*/, this.loadPromise.promise];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        (0,metric_helpers/* recordIntegrationMetric */.z)(ctx, {
                            integrationName: this.action.name,
                            methodName: 'load',
                            type: 'action',
                        });
                        loadP = this.action.load(ctx, analytics);
                        _b = (_a = this.loadPromise).resolve;
                        return [4 /*yield*/, loadP];
                    case 2:
                        _b.apply(_a, [_c.sent()]);
                        return [2 /*return*/, loadP];
                    case 3:
                        error_2 = _c.sent();
                        (0,metric_helpers/* recordIntegrationMetric */.z)(ctx, {
                            integrationName: this.action.name,
                            methodName: 'load',
                            type: 'action',
                            didError: true,
                        });
                        this.loadPromise.reject(error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ActionDestination.prototype.unload = function (ctx, analytics) {
        var _a, _b;
        return (_b = (_a = this.action).unload) === null || _b === void 0 ? void 0 : _b.call(_a, ctx, analytics);
    };
    return ActionDestination;
}());

function validate(pluginLike) {
    if (!Array.isArray(pluginLike)) {
        throw new Error('Not a valid list of plugins');
    }
    var required = ['load', 'isLoaded', 'name', 'version', 'type'];
    pluginLike.forEach(function (plugin) {
        required.forEach(function (method) {
            var _a;
            if (plugin[method] === undefined) {
                throw new Error("Plugin: ".concat((_a = plugin.name) !== null && _a !== void 0 ? _a : 'unknown', " missing required function ").concat(method));
            }
        });
    });
    return true;
}
function isPluginDisabled(userIntegrations, remotePlugin) {
    var creationNameEnabled = userIntegrations[remotePlugin.creationName];
    var currentNameEnabled = userIntegrations[remotePlugin.name];
    // Check that the plugin isn't explicitly enabled when All: false
    if (userIntegrations.All === false &&
        !creationNameEnabled &&
        !currentNameEnabled) {
        return true;
    }
    // Check that the plugin isn't explicitly disabled
    if (creationNameEnabled === false || currentNameEnabled === false) {
        return true;
    }
    return false;
}
function loadPluginFactory(remotePlugin, obfuscate) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var defaultCdn, cdn, urlSplit, name_1, obfuscatedURL, error_3;
        return (0,tslib_es6.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    defaultCdn = new RegExp('https://cdn.segment.(com|build)');
                    cdn = (0,parse_cdn/* getCDN */.Vl)();
                    if (!obfuscate) return [3 /*break*/, 6];
                    urlSplit = remotePlugin.url.split('/');
                    name_1 = urlSplit[urlSplit.length - 2];
                    obfuscatedURL = remotePlugin.url.replace(name_1, btoa(name_1).replace(/=/g, ''));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, (0,load_script/* loadScript */.v)(obfuscatedURL.replace(defaultCdn, cdn))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _a.sent();
                    // Due to syncing concerns it is possible that the obfuscated action destination (or requested version) might not exist.
                    // We should use the unobfuscated version as a fallback.
                    return [4 /*yield*/, (0,load_script/* loadScript */.v)(remotePlugin.url.replace(defaultCdn, cdn))];
                case 4:
                    // Due to syncing concerns it is possible that the obfuscated action destination (or requested version) might not exist.
                    // We should use the unobfuscated version as a fallback.
                    _a.sent();
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, (0,load_script/* loadScript */.v)(remotePlugin.url.replace(defaultCdn, cdn))];
                case 7:
                    _a.sent();
                    _a.label = 8;
                case 8:
                    // @ts-expect-error
                    if (typeof window[remotePlugin.libraryName] === 'function') {
                        // @ts-expect-error
                        return [2 /*return*/, window[remotePlugin.libraryName]];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function remoteLoader(settings, userIntegrations, mergedIntegrations, options, routingMiddleware, pluginSources) {
    var _a, _b, _c;
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var allPlugins, routingRules, pluginPromises;
        var _this = this;
        return (0,tslib_es6.__generator)(this, function (_d) {
            switch (_d.label) {
                case 0:
                    allPlugins = [];
                    routingRules = (_b = (_a = settings.middlewareSettings) === null || _a === void 0 ? void 0 : _a.routingRules) !== null && _b !== void 0 ? _b : [];
                    pluginPromises = ((_c = settings.remotePlugins) !== null && _c !== void 0 ? _c : []).map(function (remotePlugin) { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                        var pluginFactory, _a, plugin, plugins, routing_1, error_4;
                        return (0,tslib_es6.__generator)(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (isPluginDisabled(userIntegrations, remotePlugin))
                                        return [2 /*return*/];
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 6, , 7]);
                                    _a = (pluginSources === null || pluginSources === void 0 ? void 0 : pluginSources.find(function (_a) {
                                        var pluginName = _a.pluginName;
                                        return pluginName === remotePlugin.name;
                                    }));
                                    if (_a) return [3 /*break*/, 3];
                                    return [4 /*yield*/, loadPluginFactory(remotePlugin, options === null || options === void 0 ? void 0 : options.obfuscate)];
                                case 2:
                                    _a = (_b.sent());
                                    _b.label = 3;
                                case 3:
                                    pluginFactory = _a;
                                    if (!pluginFactory) return [3 /*break*/, 5];
                                    return [4 /*yield*/, pluginFactory((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, remotePlugin.settings), mergedIntegrations[remotePlugin.name]))];
                                case 4:
                                    plugin = _b.sent();
                                    plugins = Array.isArray(plugin) ? plugin : [plugin];
                                    validate(plugins);
                                    routing_1 = routingRules.filter(function (rule) { return rule.destinationName === remotePlugin.creationName; });
                                    plugins.forEach(function (plugin) {
                                        var wrapper = new ActionDestination(remotePlugin.creationName, plugin);
                                        if (routing_1.length && routingMiddleware) {
                                            wrapper.addMiddleware(routingMiddleware);
                                        }
                                        allPlugins.push(wrapper);
                                    });
                                    _b.label = 5;
                                case 5: return [3 /*break*/, 7];
                                case 6:
                                    error_4 = _b.sent();
                                    console.warn('Failed to load Remote Plugin', error_4);
                                    return [3 /*break*/, 7];
                                case 7: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(pluginPromises)];
                case 1:
                    _d.sent();
                    return [2 /*return*/, allPlugins.filter(Boolean)];
            }
        });
    });
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/to-facade.js
var to_facade = __webpack_require__(84499);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/on-page-change.js
/**
 * Register event listener on document that fires when:
 * * tab change or tab close (in mobile or desktop)
 * * click back / forward button
 * * click any link or perform any other navigation action
 * * soft refresh / hard refresh
 *
 * adapted from https://stackoverflow.com/questions/3239834/window-onbeforeunload-not-working-on-the-ipad/52864508#52864508,
 */
var onPageChange = function (cb) {
    var unloaded = false; // prevents double firing if both are supported
    window.addEventListener('pagehide', function () {
        if (unloaded)
            return;
        unloaded = true;
        cb(unloaded);
    });
    // using document instead of window because of bug affecting browsers before safari 14 (detail in footnotes https://caniuse.com/?search=visibilitychange)
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState == 'hidden') {
            if (unloaded)
                return;
            unloaded = true;
        }
        else {
            unloaded = false;
        }
        cb(unloaded);
    });
};
//# sourceMappingURL=on-page-change.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/plugins/segmentio/batched-dispatcher.js



var MAX_PAYLOAD_SIZE = 500;
function kilobytes(buffer) {
    var size = encodeURI(JSON.stringify(buffer)).split(/%..|./).length - 1;
    return size / 1024;
}
/**
 * Checks if the payload is over or close to
 * the maximum payload size allowed by tracking
 * API.
 */
function approachingTrackingAPILimit(buffer) {
    return kilobytes(buffer) >= MAX_PAYLOAD_SIZE - 50;
}
function chunks(batch) {
    var result = [];
    var index = 0;
    batch.forEach(function (item) {
        var size = kilobytes(result[index]);
        if (size >= 64) {
            index++;
        }
        if (result[index]) {
            result[index].push(item);
        }
        else {
            result[index] = [item];
        }
    });
    return result;
}
function batch(apiHost, config) {
    var _a, _b;
    var buffer = [];
    var pageUnloaded = false;
    var limit = (_a = config === null || config === void 0 ? void 0 : config.size) !== null && _a !== void 0 ? _a : 10;
    var timeout = (_b = config === null || config === void 0 ? void 0 : config.timeout) !== null && _b !== void 0 ? _b : 5000;
    function sendBatch(batch) {
        var _a;
        if (batch.length === 0) {
            return;
        }
        var writeKey = (_a = batch[0]) === null || _a === void 0 ? void 0 : _a.writeKey;
        // Remove sentAt from every event as batching only needs a single timestamp
        var updatedBatch = batch.map(function (event) {
            var _a = event, sentAt = _a.sentAt, newEvent = (0,tslib_es6.__rest)(_a, ["sentAt"]);
            return newEvent;
        });
        return (0,fetch/* fetch */.h)("https://".concat(apiHost, "/b"), {
            keepalive: pageUnloaded,
            headers: {
                'Content-Type': 'text/plain',
            },
            method: 'post',
            body: JSON.stringify({
                writeKey: writeKey,
                batch: updatedBatch,
                sentAt: new Date().toISOString(),
            }),
        });
    }
    function flush() {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var batch_1;
            return (0,tslib_es6.__generator)(this, function (_a) {
                if (buffer.length) {
                    batch_1 = buffer;
                    buffer = [];
                    return [2 /*return*/, sendBatch(batch_1)];
                }
                return [2 /*return*/];
            });
        });
    }
    var schedule;
    function scheduleFlush() {
        if (schedule) {
            return;
        }
        schedule = setTimeout(function () {
            schedule = undefined;
            flush().catch(console.error);
        }, timeout);
    }
    onPageChange(function (unloaded) {
        pageUnloaded = unloaded;
        if (pageUnloaded && buffer.length) {
            var reqs = chunks(buffer).map(sendBatch);
            Promise.all(reqs).catch(console.error);
        }
    });
    function dispatch(_url, body) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var bufferOverflow;
            return (0,tslib_es6.__generator)(this, function (_a) {
                buffer.push(body);
                bufferOverflow = buffer.length >= limit || approachingTrackingAPILimit(buffer);
                return [2 /*return*/, bufferOverflow || pageUnloaded ? flush() : scheduleFlush()];
            });
        });
    }
    return {
        dispatch: dispatch,
    };
}
//# sourceMappingURL=batched-dispatcher.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/plugins/segmentio/fetch-dispatcher.js

/* harmony default export */ function fetch_dispatcher(config) {
    function dispatch(url, body) {
        return (0,fetch/* fetch */.h)(url, {
            keepalive: config === null || config === void 0 ? void 0 : config.keepalive,
            headers: { 'Content-Type': 'text/plain' },
            method: 'post',
            body: JSON.stringify(body),
        });
    }
    return {
        dispatch: dispatch,
    };
}
//# sourceMappingURL=fetch-dispatcher.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/plugins/segmentio/normalize.js

function normalize(analytics, json, settings, integrations) {
    var _a;
    var user = analytics.user();
    delete json.options;
    json.writeKey = settings === null || settings === void 0 ? void 0 : settings.apiKey;
    json.userId = json.userId || user.id();
    json.anonymousId = json.anonymousId || user.anonymousId();
    json.sentAt = new Date();
    var failed = analytics.queue.failedInitializations || [];
    if (failed.length > 0) {
        json._metadata = { failedInitializations: failed };
    }
    var bundled = [];
    var unbundled = [];
    for (var key in integrations) {
        var integration = integrations[key];
        if (key === 'Segment.io') {
            bundled.push(key);
        }
        if (integration.bundlingStatus === 'bundled') {
            bundled.push(key);
        }
        if (integration.bundlingStatus === 'unbundled') {
            unbundled.push(key);
        }
    }
    // This will make sure that the disabled cloud mode destinations will be
    // included in the unbundled list.
    for (var _i = 0, _b = (settings === null || settings === void 0 ? void 0 : settings.unbundledIntegrations) || []; _i < _b.length; _i++) {
        var settingsUnbundled = _b[_i];
        if (!unbundled.includes(settingsUnbundled)) {
            unbundled.push(settingsUnbundled);
        }
    }
    var configIds = (_a = settings === null || settings === void 0 ? void 0 : settings.maybeBundledConfigIds) !== null && _a !== void 0 ? _a : {};
    var bundledConfigIds = [];
    bundled.sort().forEach(function (name) {
        var _a;
        ;
        ((_a = configIds[name]) !== null && _a !== void 0 ? _a : []).forEach(function (id) {
            bundledConfigIds.push(id);
        });
    });
    if ((settings === null || settings === void 0 ? void 0 : settings.addBundledMetadata) !== false) {
        json._metadata = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, json._metadata), { bundled: bundled.sort(), unbundled: unbundled.sort(), bundledIds: bundledConfigIds });
    }
    return json;
}
//# sourceMappingURL=normalize.js.map
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/lib/p-while.js
var p_while = __webpack_require__(49457);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/plugins/segmentio/schedule-flush.js





function flushQueue(xt, queue) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var failedQueue;
        var _this = this;
        return (0,tslib_es6.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    failedQueue = [];
                    if ((0,connection/* isOffline */.s)()) {
                        return [2 /*return*/, queue];
                    }
                    return [4 /*yield*/, (0,p_while/* pWhile */.x)(function () { return queue.length > 0 && !(0,connection/* isOffline */.s)(); }, function () { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                            var ctx, result, success;
                            return (0,tslib_es6.__generator)(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        ctx = queue.pop();
                                        if (!ctx) {
                                            return [2 /*return*/];
                                        }
                                        return [4 /*yield*/, (0,delivery/* attempt */.a)(ctx, xt)];
                                    case 1:
                                        result = _a.sent();
                                        success = result instanceof context/* Context */._;
                                        if (!success) {
                                            failedQueue.push(ctx);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); })
                        // re-add failed tasks
                    ];
                case 1:
                    _a.sent();
                    // re-add failed tasks
                    failedQueue.map(function (failed) { return queue.pushWithBackoff(failed); });
                    return [2 /*return*/, queue];
            }
        });
    });
}
function scheduleFlush(flushing, buffer, xt, scheduleFlush) {
    var _this = this;
    if (flushing) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    setTimeout(function () { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
        var isFlushing, newBuffer;
        return (0,tslib_es6.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isFlushing = true;
                    return [4 /*yield*/, flushQueue(xt, buffer)];
                case 1:
                    newBuffer = _a.sent();
                    isFlushing = false;
                    if (buffer.todo > 0) {
                        scheduleFlush(isFlushing, newBuffer, xt, scheduleFlush);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, Math.random() * 5000);
}
//# sourceMappingURL=schedule-flush.js.map
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/constants/index.js
var constants = __webpack_require__(76211);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/plugins/segmentio/index.js










function onAlias(analytics, json) {
    var _a, _b, _c, _d;
    var user = analytics.user();
    json.previousId =
        (_c = (_b = (_a = json.previousId) !== null && _a !== void 0 ? _a : json.from) !== null && _b !== void 0 ? _b : user.id()) !== null && _c !== void 0 ? _c : user.anonymousId();
    json.userId = (_d = json.userId) !== null && _d !== void 0 ? _d : json.to;
    delete json.from;
    delete json.to;
    return json;
}
function segmentio(analytics, settings, integrations) {
    var _a, _b, _c;
    // Attach `pagehide` before buffer is created so that inflight events are added
    // to the buffer before the buffer persists events in its own `pagehide` handler.
    window.addEventListener('pagehide', function () {
        buffer.push.apply(buffer, Array.from(inflightEvents));
        inflightEvents.clear();
    });
    var writeKey = (_a = settings === null || settings === void 0 ? void 0 : settings.apiKey) !== null && _a !== void 0 ? _a : '';
    var buffer = analytics.options.disableClientPersistence
        ? new priority_queue/* PriorityQueue */.Z(analytics.queue.queue.maxAttempts, [])
        : new persisted/* PersistedPriorityQueue */.$(analytics.queue.queue.maxAttempts, "".concat(writeKey, ":dest-Segment.io"));
    var inflightEvents = new Set();
    var flushing = false;
    var apiHost = (_b = settings === null || settings === void 0 ? void 0 : settings.apiHost) !== null && _b !== void 0 ? _b : constants/* SEGMENT_API_HOST */.U;
    var protocol = (_c = settings === null || settings === void 0 ? void 0 : settings.protocol) !== null && _c !== void 0 ? _c : 'https';
    var remote = "".concat(protocol, "://").concat(apiHost);
    var deliveryStrategy = settings === null || settings === void 0 ? void 0 : settings.deliveryStrategy;
    var client = (deliveryStrategy === null || deliveryStrategy === void 0 ? void 0 : deliveryStrategy.strategy) === 'batching'
        ? batch(apiHost, deliveryStrategy.config)
        : fetch_dispatcher(deliveryStrategy === null || deliveryStrategy === void 0 ? void 0 : deliveryStrategy.config);
    function send(ctx) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var path, json;
            return (0,tslib_es6.__generator)(this, function (_a) {
                if ((0,connection/* isOffline */.s)()) {
                    buffer.push(ctx);
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    scheduleFlush(flushing, buffer, segmentio, scheduleFlush);
                    return [2 /*return*/, ctx];
                }
                inflightEvents.add(ctx);
                path = ctx.event.type.charAt(0);
                json = (0,to_facade/* toFacade */.D)(ctx.event).json();
                if (ctx.event.type === 'track') {
                    delete json.traits;
                }
                if (ctx.event.type === 'alias') {
                    json = onAlias(analytics, json);
                }
                return [2 /*return*/, client
                        .dispatch("".concat(remote, "/").concat(path), normalize(analytics, json, settings, integrations))
                        .then(function () { return ctx; })
                        .catch(function () {
                        buffer.pushWithBackoff(ctx);
                        // eslint-disable-next-line @typescript-eslint/no-use-before-define
                        scheduleFlush(flushing, buffer, segmentio, scheduleFlush);
                        return ctx;
                    })
                        .finally(function () {
                        inflightEvents.delete(ctx);
                    })];
            });
        });
    }
    var segmentio = {
        name: 'Segment.io',
        type: 'destination',
        version: '0.1.0',
        isLoaded: function () { return true; },
        load: function () { return Promise.resolve(); },
        track: send,
        identify: send,
        page: send,
        alias: send,
        group: send,
        screen: send,
    };
    // Buffer may already have items if they were previously stored in localStorage.
    // Start flushing them immediately.
    if (buffer.todo) {
        scheduleFlush(flushing, buffer, segmentio, scheduleFlush);
    }
    return segmentio;
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/inspector/index.js
var _a;
var _b;

var env = (0,get_global/* getGlobal */.R)();
// The code below assumes the inspector extension will use Object.assign
// to add the inspect interface on to this object reference (unless the
// extension code ran first and has already set up the variable)
var inspectorHost = ((_a = (_b = env)['__SEGMENT_INSPECTOR__']) !== null && _a !== void 0 ? _a : (_b['__SEGMENT_INSPECTOR__'] = {}));
var attachInspector = function (analytics) { var _a; return (_a = inspectorHost.attach) === null || _a === void 0 ? void 0 : _a.call(inspectorHost, analytics); };
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/core/stats/index.js + 1 modules
var stats = __webpack_require__(15686);
;// CONCATENATED MODULE: ../../../node_modules/@segment/analytics-next/dist/pkg/browser/index.js















function loadCDNSettings(writeKey, cdnURL) {
    var baseUrl = cdnURL !== null && cdnURL !== void 0 ? cdnURL : (0,parse_cdn/* getCDN */.Vl)();
    return (0,fetch/* fetch */.h)("".concat(baseUrl, "/v1/projects/").concat(writeKey, "/settings"))
        .then(function (res) {
        if (!res.ok) {
            return res.text().then(function (errorResponseMessage) {
                throw new Error(errorResponseMessage);
            });
        }
        return res.json();
    })
        .catch(function (err) {
        console.error(err.message);
        throw err;
    });
}
function hasLegacyDestinations(settings) {
    return (getProcessEnv().NODE_ENV !== 'test' &&
        // just one integration means segmentio
        Object.keys(settings.integrations).length > 1);
}
function hasTsubMiddleware(settings) {
    var _a, _b, _c;
    return (getProcessEnv().NODE_ENV !== 'test' &&
        ((_c = (_b = (_a = settings.middlewareSettings) === null || _a === void 0 ? void 0 : _a.routingRules) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0);
}
/**
 * With AJS classic, we allow users to call setAnonymousId before the library initialization.
 * This is important because some of the destinations will use the anonymousId during the initialization,
 * and if we set anonId afterwards, that wouldn’t impact the destination.
 *
 * Also Ensures events can be registered before library initialization.
 * This is important so users can register to 'initialize' and any events that may fire early during setup.
 */
function flushPreBuffer(analytics, buffer) {
    flushSetAnonymousID(analytics, buffer);
    flushOn(analytics, buffer);
}
/**
 * Finish flushing buffer and cleanup.
 */
function flushFinalBuffer(analytics, buffer) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        return (0,tslib_es6.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // Call popSnippetWindowBuffer before each flush task since there may be
                // analytics calls during async function calls.
                return [4 /*yield*/, flushAddSourceMiddleware(analytics, buffer)];
                case 1:
                    // Call popSnippetWindowBuffer before each flush task since there may be
                    // analytics calls during async function calls.
                    _a.sent();
                    flushAnalyticsCallsInNewTask(analytics, buffer);
                    // Clear buffer, just in case analytics is loaded twice; we don't want to fire events off again.
                    buffer.clear();
                    return [2 /*return*/];
            }
        });
    });
}
function registerPlugins(writeKey, cdnSettings, analytics, options, pluginLikes, legacyIntegrationSources) {
    var _a, _b, _c;
    if (pluginLikes === void 0) { pluginLikes = []; }
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var plugins, pluginSources, tsubMiddleware, _d, legacyDestinations, _e, schemaFilter, _f, mergedSettings, remotePlugins, toRegister, shouldIgnoreSegmentio, _g, _h, ctx;
        var _this = this;
        return (0,tslib_es6.__generator)(this, function (_j) {
            switch (_j.label) {
                case 0:
                    plugins = pluginLikes === null || pluginLikes === void 0 ? void 0 : pluginLikes.filter(function (pluginLike) { return typeof pluginLike === 'object'; });
                    pluginSources = pluginLikes === null || pluginLikes === void 0 ? void 0 : pluginLikes.filter(function (pluginLike) {
                        return typeof pluginLike === 'function' &&
                            typeof pluginLike.pluginName === 'string';
                    });
                    if (!hasTsubMiddleware(cdnSettings)) return [3 /*break*/, 2];
                    return [4 /*yield*/, __webpack_require__.e(/* import() | tsub-middleware */ 604).then(__webpack_require__.bind(__webpack_require__, 45134)).then(function (mod) {
                            return mod.tsubMiddleware(cdnSettings.middlewareSettings.routingRules);
                        })];
                case 1:
                    _d = _j.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _d = undefined;
                    _j.label = 3;
                case 3:
                    tsubMiddleware = _d;
                    if (!(hasLegacyDestinations(cdnSettings) || legacyIntegrationSources.length > 0)) return [3 /*break*/, 5];
                    return [4 /*yield*/, __webpack_require__.e(/* import() | ajs-destination */ 464).then(__webpack_require__.bind(__webpack_require__, 11900)).then(function (mod) {
                            return mod.ajsDestinations(writeKey, cdnSettings, analytics.integrations, options, tsubMiddleware, legacyIntegrationSources);
                        })];
                case 4:
                    _e = _j.sent();
                    return [3 /*break*/, 6];
                case 5:
                    _e = [];
                    _j.label = 6;
                case 6:
                    legacyDestinations = _e;
                    if (!cdnSettings.legacyVideoPluginsEnabled) return [3 /*break*/, 8];
                    return [4 /*yield*/, __webpack_require__.e(/* import() | legacyVideos */ 150).then(__webpack_require__.bind(__webpack_require__, 54482)).then(function (mod) {
                            return mod.loadLegacyVideoPlugins(analytics);
                        })];
                case 7:
                    _j.sent();
                    _j.label = 8;
                case 8:
                    if (!((_a = options.plan) === null || _a === void 0 ? void 0 : _a.track)) return [3 /*break*/, 10];
                    return [4 /*yield*/, __webpack_require__.e(/* import() | schemaFilter */ 493).then(__webpack_require__.bind(__webpack_require__, 23959)).then(function (mod) {
                            var _a;
                            return mod.schemaFilter((_a = options.plan) === null || _a === void 0 ? void 0 : _a.track, cdnSettings);
                        })];
                case 9:
                    _f = _j.sent();
                    return [3 /*break*/, 11];
                case 10:
                    _f = undefined;
                    _j.label = 11;
                case 11:
                    schemaFilter = _f;
                    mergedSettings = (0,merged_options/* mergedOptions */.o)(cdnSettings, options);
                    return [4 /*yield*/, remoteLoader(cdnSettings, analytics.integrations, mergedSettings, options, tsubMiddleware, pluginSources).catch(function () { return []; })];
                case 12:
                    remotePlugins = _j.sent();
                    toRegister = (0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([
                        envEnrichment
                    ], plugins, true), legacyDestinations, true), remotePlugins, true);
                    if (schemaFilter) {
                        toRegister.push(schemaFilter);
                    }
                    shouldIgnoreSegmentio = (((_b = options.integrations) === null || _b === void 0 ? void 0 : _b.All) === false &&
                        !options.integrations['Segment.io']) ||
                        (options.integrations && options.integrations['Segment.io'] === false);
                    if (!!shouldIgnoreSegmentio) return [3 /*break*/, 14];
                    _h = (_g = toRegister).push;
                    return [4 /*yield*/, segmentio(analytics, mergedSettings['Segment.io'], cdnSettings.integrations)];
                case 13:
                    _h.apply(_g, [_j.sent()]);
                    _j.label = 14;
                case 14: return [4 /*yield*/, analytics.register.apply(analytics, toRegister)];
                case 15:
                    ctx = _j.sent();
                    if (!Object.entries((_c = cdnSettings.enabledMiddleware) !== null && _c !== void 0 ? _c : {}).some(function (_a) {
                        var enabled = _a[1];
                        return enabled;
                    })) return [3 /*break*/, 17];
                    return [4 /*yield*/, __webpack_require__.e(/* import() | remoteMiddleware */ 214).then(__webpack_require__.bind(__webpack_require__, 72627)).then(function (_a) {
                            var remoteMiddlewares = _a.remoteMiddlewares;
                            return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                                var middleware, promises;
                                return (0,tslib_es6.__generator)(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, remoteMiddlewares(ctx, cdnSettings, options.obfuscate)];
                                        case 1:
                                            middleware = _b.sent();
                                            promises = middleware.map(function (mdw) {
                                                return analytics.addSourceMiddleware(mdw);
                                            });
                                            return [2 /*return*/, Promise.all(promises)];
                                    }
                                });
                            });
                        })];
                case 16:
                    _j.sent();
                    _j.label = 17;
                case 17: return [2 /*return*/, ctx];
            }
        });
    });
}
function loadAnalytics(settings, options, preInitBuffer) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (options === void 0) { options = {}; }
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var cdnSettings, _l, disabled, retryQueue, analytics, plugins, classicIntegrations, segmentLoadOptions, ctx, search, hash, term;
        return (0,tslib_es6.__generator)(this, function (_m) {
            switch (_m.label) {
                case 0:
                    // return no-op analytics instance if disabled
                    if (options.disable === true) {
                        return [2 /*return*/, [new NullAnalytics(), context/* Context.system */._.system()]];
                    }
                    if (options.globalAnalyticsKey)
                        (0,global_analytics_helper/* setGlobalAnalyticsKey */.jV)(options.globalAnalyticsKey);
                    // this is an ugly side-effect, but it's for the benefits of the plugins that get their cdn via getCDN()
                    if (settings.cdnURL)
                        (0,parse_cdn/* setGlobalCDNUrl */.UH)(settings.cdnURL);
                    if (options.initialPageview) {
                        // capture the page context early, so it's always up-to-date
                        preInitBuffer.push(new PreInitMethodCall('page', []));
                    }
                    if (!((_a = settings.cdnSettings) !== null && _a !== void 0)) return [3 /*break*/, 1];
                    _l = _a;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, loadCDNSettings(settings.writeKey, settings.cdnURL)];
                case 2:
                    _l = (_m.sent());
                    _m.label = 3;
                case 3:
                    cdnSettings = _l;
                    if (options.updateCDNSettings) {
                        cdnSettings = options.updateCDNSettings(cdnSettings);
                    }
                    if (!(typeof options.disable === 'function')) return [3 /*break*/, 5];
                    return [4 /*yield*/, options.disable(cdnSettings)];
                case 4:
                    disabled = _m.sent();
                    if (disabled) {
                        return [2 /*return*/, [new NullAnalytics(), context/* Context.system */._.system()]];
                    }
                    _m.label = 5;
                case 5:
                    retryQueue = (_c = (_b = cdnSettings.integrations['Segment.io']) === null || _b === void 0 ? void 0 : _b.retryQueue) !== null && _c !== void 0 ? _c : true;
                    options = (0,tslib_es6.__assign)({ retryQueue: retryQueue }, options);
                    analytics = new Analytics((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, settings), { cdnSettings: cdnSettings }), options);
                    attachInspector(analytics);
                    plugins = (_d = settings.plugins) !== null && _d !== void 0 ? _d : [];
                    classicIntegrations = (_e = settings.classicIntegrations) !== null && _e !== void 0 ? _e : [];
                    segmentLoadOptions = (_f = options.integrations) === null || _f === void 0 ? void 0 : _f['Segment.io'];
                    stats/* Stats.initRemoteMetrics */.j.initRemoteMetrics((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, cdnSettings.metrics), { host: (_g = segmentLoadOptions === null || segmentLoadOptions === void 0 ? void 0 : segmentLoadOptions.apiHost) !== null && _g !== void 0 ? _g : (_h = cdnSettings.metrics) === null || _h === void 0 ? void 0 : _h.host, protocol: segmentLoadOptions === null || segmentLoadOptions === void 0 ? void 0 : segmentLoadOptions.protocol }));
                    // needs to be flushed before plugins are registered
                    flushPreBuffer(analytics, preInitBuffer);
                    return [4 /*yield*/, registerPlugins(settings.writeKey, cdnSettings, analytics, options, plugins, classicIntegrations)];
                case 6:
                    ctx = _m.sent();
                    search = (_j = window.location.search) !== null && _j !== void 0 ? _j : '';
                    hash = (_k = window.location.hash) !== null && _k !== void 0 ? _k : '';
                    term = search.length ? search : hash.replace(/(?=#).*(?=\?)/, '');
                    if (!term.includes('ajs_')) return [3 /*break*/, 8];
                    return [4 /*yield*/, analytics.queryString(term).catch(console.error)];
                case 7:
                    _m.sent();
                    _m.label = 8;
                case 8:
                    analytics.initialized = true;
                    analytics.emit('initialize', settings, options);
                    return [4 /*yield*/, flushFinalBuffer(analytics, preInitBuffer)];
                case 9:
                    _m.sent();
                    return [2 /*return*/, [analytics, ctx]];
            }
        });
    });
}
/**
 * The public browser interface for Segment Analytics
 *
 * @example
 * ```ts
 *  export const analytics = new AnalyticsBrowser()
 *  analytics.load({ writeKey: 'foo' })
 * ```
 * @link https://github.com/segmentio/analytics-next/#readme
 */
var AnalyticsBrowser = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(AnalyticsBrowser, _super);
    function AnalyticsBrowser() {
        var _this = this;
        var _a = (0,create_deferred/* createDeferred */.d)(), loadStart = _a.promise, resolveLoadStart = _a.resolve;
        _this = _super.call(this, function (buffer) {
            return loadStart.then(function (_a) {
                var settings = _a[0], options = _a[1];
                return loadAnalytics(settings, options, buffer);
            });
        }) || this;
        _this._resolveLoadStart = function (settings, options) {
            return resolveLoadStart([settings, options]);
        };
        return _this;
    }
    /**
     * Fully initialize an analytics instance, including:
     *
     * * Fetching settings from the segment CDN (by default).
     * * Fetching all remote destinations configured by the user (if applicable).
     * * Flushing buffered analytics events.
     * * Loading all middleware.
     *
     * Note:️  This method should only be called *once* in your application.
     *
     * @example
     * ```ts
     * export const analytics = new AnalyticsBrowser()
     * analytics.load({ writeKey: 'foo' })
     * ```
     */
    AnalyticsBrowser.prototype.load = function (settings, options) {
        if (options === void 0) { options = {}; }
        this._resolveLoadStart(settings, options);
        return this;
    };
    /**
     * Instantiates an object exposing Analytics methods.
     *
     * @example
     * ```ts
     * const ajs = AnalyticsBrowser.load({ writeKey: '<YOUR_WRITE_KEY>' })
     *
     * ajs.track("foo")
     * ...
     * ```
     */
    AnalyticsBrowser.load = function (settings, options) {
        if (options === void 0) { options = {}; }
        return new AnalyticsBrowser().load(settings, options);
    };
    AnalyticsBrowser.standalone = function (writeKey, options) {
        return AnalyticsBrowser.load({ writeKey: writeKey }, options).then(function (res) { return res[0]; });
    };
    return AnalyticsBrowser;
}(AnalyticsBuffered));

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/lodash.camelcase/index.js
var lodash_camelcase = __webpack_require__(8122);
var lodash_camelcase_default = /*#__PURE__*/__webpack_require__.n(lodash_camelcase);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/analytics-web/dist/esm/WebAnalytics/index.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


/**
 * Converts the keys of an object from kebab case to camel case if they are in kebab case.
 *
 * @param {{ [key: string]: any }} obj - The object with potentially kebab-cased keys.
 * @returns A new object with camel-cased keys where applicable.
 */
function convertObjectKeysToCamelCase(obj) {
    var newObj = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var newKey = key.includes('-') ? lodash_camelcase_default()(key) : key;
            newObj[newKey] = obj[key];
        }
    }
    return newObj;
}
var WebAnalytics = /** @class */ (function () {
    function WebAnalytics(_a) {
        var writeKey = _a.writeKey;
        this.analyticsInstance = AnalyticsBrowser.load({
            writeKey: writeKey,
        });
    }
    /**
     * Track an event.
     * Lets you record the actions your users perform. Every action triggers what we call an “event”, which can also have associated properties.
     *
     * @template T - The type of the event, extending BaseEvent.
     * @param {T} event - The event to track, must be of type T.
     * @returns Promise
     * @example
     * analytics.trackEvent({
     *  category: EventCategory.DASHBOARD,
     *  event_name: 'Button Clicked',
     *  buttonType: ButtonType.PRIMARY,
     *  position: productLable,
     *  customerType: CustomerType.CUSTOMER,
     *  text: capitalizeString(actionLabel),
     * })
     *
     */
    WebAnalytics.prototype.trackEvent = function (event) {
        // eslint-disable-next-line camelcase
        var event_name = event.event_name, otherProperties = __rest(event, ["event_name"]);
        // Add path property to otherProperties based on current location
        otherProperties.path = location.href.replace(location.origin, '');
        return this.analyticsInstance.track(event_name, otherProperties);
    };
    /**
     * Identify a user with the provided user ID and optional traits.
     * Lets you tie a user to their actions and record traits about them. It includes a unique User ID and/or anonymous ID, and any optional traits you know about them.
     * Call identify once when the user’s account is first created, and then again any time their traits change.
     *
     * @param {string} userId - The unique identifier for the user.
     * @param {{ [key: string]: any }} featureFlags - LaunchDarkly feature flags associated with the user.
     * @param {Object} [userTraits] - Optional traits associated with the user.
     * @param {Object} [options] - Additional options for the identification process.
     * @returns  - Promise
     *
     * @example
     * // Identify a user with basic information
     * analyticsTracker.identify("user123", { featureFlag: true }, { name: "John Doe", email: "john@example.com" });
     *
     * // Identify a user with options
     * analyticsTracker.identify("user123", { featureFlag: true }, { name: "John Doe" }, { timestamp: 1637731200000 });
     */
    WebAnalytics.prototype.identify = function (userId, featureFlags, userTraits, options) {
        var traits = __assign(__assign({}, userTraits), { test_experiment_flags: convertObjectKeysToCamelCase(featureFlags) });
        return this.analyticsInstance.identify(userId, traits, options);
    };
    /**
     * Track a page view with the specified category and name.
     * Lets you record page views on your website, along with optional extra information about the page being viewed.
     *
     * @param {EventCategory} category - The category of the page event.
     * @param {string} name - The name or title of the page.
     * @param {Object} [properties] - Optional properties associated with the page view.
     * @returns - Promise
     *
     * @example
     * // Track a page view with category and name
     * analyticsTracker.trackPage("Home", "Homepage");
     */
    WebAnalytics.prototype.trackPage = function (category, name, properties) {
        var _a;
        var isAuthenticated;
        try {
            var auth = JSON.parse(window.sessionStorage.getItem('lendi_auth') || '{}');
            isAuthenticated = !!((_a = auth.identity) === null || _a === void 0 ? void 0 : _a.id);
        }
        catch (error) {
            isAuthenticated = false;
        }
        return this.analyticsInstance.page(category, name, __assign(__assign({}, properties), { isAuthenticated: isAuthenticated }));
    };
    /**
     * Identify the specific group or company, the group method receives traits that are specific to the group.
     *
     * @param {string} groupId - The unique identifier for the group.
     * @param {Object} [traits] - Optional traits associated with the group.
     * @param {Object} [options] - Free-form dictionary of traits of the group, like email or name
     * @returns  - Promise
     *
     * @example
     * // Identify a group with basic information
     * analyticsTracker.group("group123", { name: "Infitech", industry: "Technology", employees: 329, plan: "enterprise", "total billed": 830 });
     *
     */
    WebAnalytics.prototype.trackGroup = function (groupId, traits, options) {
        return this.analyticsInstance.group(groupId, traits, options);
    };
    return WebAnalytics;
}());
/* harmony default export */ var esm_WebAnalytics = (WebAnalytics);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/@lendi/analytics-web/dist/esm/index.js


/* harmony default export */ var dist_esm = (esm_WebAnalytics);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./helpers/tracking/WebAnalytics.ts



var LALAWebAnalytics = /*#__PURE__*/ function() {
    "use strict";
    function LALAWebAnalytics() {
        (0,_class_call_check/* default */.Z)(this, LALAWebAnalytics);
        var writeKey;
        var hostname =  true ? window.location.hostname : 0;
        if (hostname.indexOf("aussie") !== -1) {
            writeKey = "DG28VL1bGGGxzPCmafNbGoTkBJzGh0HH";
        } else {
            writeKey = "PFkvq4uKElRVl2KtYPdHDpN2Up9isSYY";
        }
        var lendiAnalytics = new dist_esm({
            writeKey: writeKey
        });
        this.lendiAnalytics = lendiAnalytics;
    }
    _createClass(LALAWebAnalytics, [
        {
            key: "instance",
            get: function get() {
                return this.lendiAnalytics;
            }
        }
    ]);
    return LALAWebAnalytics;
}();

;// CONCATENATED MODULE: ./helpers/tracking/IdentityTrackingService.ts










var IdentityTrackingService = /*#__PURE__*/ function(LALAWebAnalytics) {
    "use strict";
    (0,_inherits/* default */.Z)(IdentityTrackingService, LALAWebAnalytics);
    var _super = (0,_create_super/* default */.Z)(IdentityTrackingService);
    function IdentityTrackingService() {
        (0,_class_call_check/* default */.Z)(this, IdentityTrackingService);
        return _super.apply(this, arguments);
    }
    var _proto = IdentityTrackingService.prototype;
    _proto.createTraits = function createTraits() {
        return {
            user_type: CustomerType.CUSTOMER
        };
    };
    _proto.trackCustomer = function trackCustomer(customerId, flags, userTraits) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var baseTraits, traits, err, cannotIdentifyError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        baseTraits = _this.createTraits();
                        traits = (0,_object_spread/* default */.Z)({}, baseTraits, userTraits);
                        return [
                            4,
                            _this.instance.identify(customerId || "", flags || {}, traits)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        cannotIdentifyError = _instanceof(err, Error) ? err : new Error("Cannot identify customer");
                        esm/* LalaSentry.captureException */.GG.captureException(cannotIdentifyError, "Cannot identify customer: ".concat(customerId));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return IdentityTrackingService;
}(LALAWebAnalytics);

;// CONCATENATED MODULE: ./helpers/tracking/types.ts
var AuthTrackingPageNames;
(function(AuthTrackingPageNames) {
    AuthTrackingPageNames["SIGN_IN"] = "login";
    AuthTrackingPageNames["INVITE"] = "invite";
    AuthTrackingPageNames["LEAD"] = "lead";
    AuthTrackingPageNames["REGISTER"] = "register";
    AuthTrackingPageNames["REGISTER_VERIFY"] = "register verify";
    AuthTrackingPageNames["SIGN_IN_OTP"] = "login verify";
    AuthTrackingPageNames["BAA_SIGN_IN"] = "Book Appointment Login";
    AuthTrackingPageNames["BAA_BUYERS_AGENT_SIGN_IN"] = "Book Appointment Buyers Agent Login";
    AuthTrackingPageNames["BAA_SIGN_IN_OTP"] = "Book Appointment Login OTP";
    AuthTrackingPageNames["BAA_BUYERS_AGENT_SIGN_IN_OTP"] = "Book Appointment Buyers Agent Login OTP";
    AuthTrackingPageNames["STAMP_DUTY_SIGN_IN"] = "Stamp duty calculator Login";
    AuthTrackingPageNames["STAMP_DUTY_SIGN_IN_OTP"] = "Stamp duty calculator Login OTP";
    AuthTrackingPageNames["PROPERTY_REPORT_SIGN_IN"] = "Property report Login";
    AuthTrackingPageNames["REFER_A_FRIND_SIGN_IN"] = "Refer a friend Login";
    AuthTrackingPageNames["CREDIT_SCORE_SIGN_IN"] = "Credit score Login";
    AuthTrackingPageNames["PROPERTY_REPORT_SIGN_IN_OTP"] = "Property report Login OTP";
    AuthTrackingPageNames["SIGN_IN_MARKETING"] = "Marketing returned SSO login";
    AuthTrackingPageNames["VERIFY_LEADS"] = "Verify leads";
    AuthTrackingPageNames["UNKNOWN"] = "";
    AuthTrackingPageNames["SIGN_IN_V2"] = "login V2";
    AuthTrackingPageNames["BAA_SIGN_IN_V2"] = "Book Appointment Login v2";
    AuthTrackingPageNames["STAMP_DUTY_SIGN_IN_V2"] = "Stamp duty calculator Login v2";
    AuthTrackingPageNames["PROPERTY_REPORT_SIGN_IN_V2"] = "Property report Login v2";
    AuthTrackingPageNames["SIGN_IN_MARKETING_V2"] = "Marketing returned SSO login v2";
    AuthTrackingPageNames["EMAIL_SAFETY_NET"] = "Email Safety net";
    AuthTrackingPageNames["INTL_NOT_RECOGNIZED"] = "Not Recognized Intl Number";
    AuthTrackingPageNames["INTL_OTP"] = "Intl Verify";
    AuthTrackingPageNames["INTL_SIGN_IN"] = "Intl Login";
    AuthTrackingPageNames["POST_CODE"] = "Postcode Search";
})(AuthTrackingPageNames || (AuthTrackingPageNames = {}));
var AccountLinkingPageNames;
(function(AccountLinkingPageNames) {
    AccountLinkingPageNames["PROMPT"] = "account-link-prompt";
    AccountLinkingPageNames["SUCCESS"] = "account-link-success";
    AccountLinkingPageNames["VERIFY"] = "account-link-verify";
})(AccountLinkingPageNames || (AccountLinkingPageNames = {}));

;// CONCATENATED MODULE: ./helpers/tracking/PageTrackingService.ts











var PageTrackingService = /*#__PURE__*/ function(LALAWebAnalytics) {
    "use strict";
    (0,_inherits/* default */.Z)(PageTrackingService, LALAWebAnalytics);
    var _super = (0,_create_super/* default */.Z)(PageTrackingService);
    function PageTrackingService() {
        (0,_class_call_check/* default */.Z)(this, PageTrackingService);
        var _this;
        _this = _super.apply(this, arguments);
        _this.AuthTrackingPageNames = AuthTrackingPageNames;
        _this.AccountLinkingPageNames = AccountLinkingPageNames;
        return _this;
    }
    var _proto = PageTrackingService.prototype;
    _proto.trackAuthPage = function trackAuthPage(name) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var err, cannotIdentifyError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.instance.trackPage(EventCategory.AUTH, name)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        cannotIdentifyError = _instanceof(err, Error) ? err : new Error("Cannot track page");
                        esm/* LalaSentry.captureException */.GG.captureException(cannotIdentifyError, "Cannot track page for Category: Auth and Page Name: ".concat(name));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.trackAccountLinkingPage = function trackAccountLinkingPage(name) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var err, cannotIdentifyError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.instance.trackPage(EventCategory.ACCOUNT_LINKING, name)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        cannotIdentifyError = _instanceof(err, Error) ? err : new Error("Cannot track page");
                        esm/* LalaSentry.captureException */.GG.captureException(cannotIdentifyError, "Cannot track page for Category: account-linking and Page Name: ".concat(name));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _createClass(PageTrackingService, [
        {
            key: "authTrackingPageName",
            get: function get() {
                return this.AuthTrackingPageNames;
            }
        },
        {
            key: "accountLinkingPageNames",
            get: function get() {
                return this.AccountLinkingPageNames;
            }
        }
    ]);
    return PageTrackingService;
}(LALAWebAnalytics);

// EXTERNAL MODULE: ../node_modules/@lendi/core-constants/lib/esm/index.js + 84 modules
var lib_esm = __webpack_require__(82419);
;// CONCATENATED MODULE: ../../../node_modules/@lendi/analytics-web/dist/esm/events/objects/button/index.js
var ButtonType;
(function (ButtonType) {
    ButtonType["PRIMARY"] = "Primary";
    ButtonType["SECONDARY"] = "Secondary";
    ButtonType["EMPHASIS"] = "Emphasis";
    ButtonType["EMPTY"] = "Empty";
    ButtonType["LINK"] = "Link";
    ButtonType["ICON"] = "Icon";
})(ButtonType || (ButtonType = {}));
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./helpers/index.ts + 1 modules
var helpers_0 = __webpack_require__(45343);
;// CONCATENATED MODULE: ./helpers/tracking/EventTrackingService.ts











var EventTrackingService = /*#__PURE__*/ function(LALAWebAnalytics) {
    "use strict";
    (0,_inherits/* default */.Z)(EventTrackingService, LALAWebAnalytics);
    var _super = (0,_create_super/* default */.Z)(EventTrackingService);
    function EventTrackingService() {
        (0,_class_call_check/* default */.Z)(this, EventTrackingService);
        return _super.apply(this, arguments);
    }
    var _proto = EventTrackingService.prototype;
    _proto.tracking = function tracking(event, trackingFailedErrorMessage) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var err, cannotTrackError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            _this.instance.trackEvent(event)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        cannotTrackError = _instanceof(err, Error) ? err : new Error("Cannot track event");
                        esm/* LalaSentry.captureException */.GG.captureException(cannotTrackError, trackingFailedErrorMessage || "cannot track event: ".concat(event.event_name));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.getFunnelName = function getFunnelName() {
        var referrer = (0,helpers_0/* getReferrer */.an)();
        if (!referrer) return undefined;
        var funnelNames = Object.values(lib_esm/* PlatformPathname */.C1);
        var matchedFunnelName = funnelNames.find(function(funnelName) {
            referrer.includes(funnelName);
        });
        return matchedFunnelName;
    };
    _proto.trackAuthButtonClickEvent = function trackAuthButtonClickEvent(purpose, text, buttonType) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var event;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event = {
                            event_name: "Button Clicked",
                            category: EventCategory.AUTH,
                            buttonType: buttonType === "secondary" ? ButtonType.SECONDARY : ButtonType.PRIMARY,
                            text: text,
                            purpose: purpose
                        };
                        return [
                            4,
                            _this.tracking(event)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.trackAuthSelectEvent = function trackAuthSelectEvent(selectedValue, title) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var event;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event = {
                            category: EventCategory.AUTH,
                            event_name: "Dropdown Selected",
                            selection: selectedValue,
                            title: "Postcode or Suburb",
                            customerType: CustomerType.CUSTOMER
                        };
                        return [
                            4,
                            _this.tracking(event)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.trackAuthLinkClickEvent = function trackAuthLinkClickEvent(text) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var event;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event = {
                            event_name: "Link Clicked",
                            category: EventCategory.AUTH,
                            linkType: "Linktopage",
                            text: text
                        };
                        return [
                            4,
                            _this.tracking(event)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.trackAuthenticationEvent = function trackAuthenticationEvent(connection) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var event;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event = {
                            event_name: AuthenticationStatus.AUTHENTICATED,
                            category: EventCategory.AUTH,
                            funnel: _this.getFunnelName(),
                            authSource: connection
                        };
                        return [
                            4,
                            _this.tracking(event, EventCategory.AUTH)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.trackRegisterEvent = function trackRegisterEvent(customerId, connection) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var event;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event = {
                            event_name: "Registered",
                            user_id: customerId,
                            category: EventCategory.AUTH,
                            funnel: _this.getFunnelName(),
                            authSource: connection
                        };
                        return [
                            4,
                            _this.tracking(event, EventCategory.AUTH)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.trackPreRoutedEvent = function trackPreRoutedEvent(brokerId, storeId) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var event;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event = {
                            event_name: "Pre routed Customer",
                            category: EventCategory.AUTH,
                            brokerId: brokerId,
                            storeId: storeId
                        };
                        return [
                            4,
                            _this.tracking(event, EventCategory.AUTH)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.trackCustomerReferralEvent = function trackCustomerReferralEvent(brokerId, refCode) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var event;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event = {
                            event_name: "Customer Referral",
                            category: EventCategory.AUTH,
                            brokerId: brokerId,
                            refCode: refCode
                        };
                        return [
                            4,
                            _this.tracking(event, EventCategory.AUTH)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return EventTrackingService;
}(LALAWebAnalytics);

;// CONCATENATED MODULE: ./helpers/tracking/index.ts



var eventTracking = new EventTrackingService();
var identityTracking = new IdentityTrackingService();
var pageTracking = new PageTrackingService();


/***/ }),

/***/ 61414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Po": function() { return /* binding */ getFirstNameForFunnel; },
/* harmony export */   "YY": function() { return /* binding */ maskPhoneNumber; },
/* harmony export */   "Z1": function() { return /* binding */ formatInitialPhoneNumber; },
/* harmony export */   "of": function() { return /* binding */ maskEmail; },
/* harmony export */   "p3": function() { return /* binding */ formattedPhoneNumber; },
/* harmony export */   "u3": function() { return /* binding */ trimPhoneNumber; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89799);

var trimPhoneNumber = function(phoneNumber) {
    return phoneNumber.split(" ").join("");
};
var formatInitialPhoneNumber = function(phoneNumber) {
    return phoneNumber.replace(/(\+61)?0?(4\d{8})/, "$2");
};
var maskPhoneNumber = function(phoneNumber) {
    return phoneNumber.split("").map(function(phone, index) {
        return index >= 1 && index <= 4 ? "X" : phone;
    }).join("");
};
var maskMiddle = function() {
    var val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return val.length < 3 ? "".padEnd(val.length, "*") : val[0] + "".padEnd(val.length - 2, "*") + val[val.length - 1];
};
var maskEmail = function() {
    var email = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(email.split("@"), 2), account = ref[0], domain = ref[1];
    return maskMiddle(account) + "@" + domain;
};
var formattedPhoneNumber = function(phoneNumber) {
    return phoneNumber.replace(/(\+61)0?(4\d{2})(\d{3})(\d{3})/, "$1 $2 $3 $4");
};
var getFirstNameForFunnel = function() {
    var funnelSessionStorageStr = sessionStorage.getItem("funnel_one_form_values");
    if (!funnelSessionStorageStr) return undefined;
    var funnelSessionStorage = JSON.parse(funnelSessionStorageStr);
    if (funnelSessionStorage.applicants && funnelSessionStorage.applicants[0]) {
        return funnelSessionStorage.applicants[0].firstName;
    }
    return undefined;
};


/***/ }),

/***/ 67413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(44229);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(84872);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(39978);
;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_super_prop_base.mjs


function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = (0,_get_prototype_of/* default */.Z)(object);
    if (object === null) break;
  }

  return object;
}

;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_get.mjs


function get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    get = Reflect.get;
  } else {
    get = function get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver || target);
      }

      return desc.value;
    };
  }

  return get(target, property, receiver);
}

function _get(target, property, receiver) {
  return get(target, property, receiver);
}

// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(34650);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(97939);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(31268);
// EXTERNAL MODULE: ../../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92712);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../packages/lala-react/dist/esm/index.js + 318 modules
var esm = __webpack_require__(25980);
// EXTERNAL MODULE: ../../../packages/lala-utils/dist/esm/index.js + 23 modules
var dist_esm = __webpack_require__(82839);
// EXTERNAL MODULE: ../../../node_modules/@lendi/chat/dist/esm/providers/ChatBootstrapperProvider/provider.js + 13 modules
var provider = __webpack_require__(51641);
// EXTERNAL MODULE: ../node_modules/@lendi/ui/dist/select-73d530a0.esm.js + 1 modules
var select_73d530a0_esm = __webpack_require__(36437);
// EXTERNAL MODULE: ../node_modules/@lendi/ui/dist/index-83c6f867.esm.js
var index_83c6f867_esm = __webpack_require__(38570);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../node_modules/@lendi/ui/dist/index-03130070.esm.js
var index_03130070_esm = __webpack_require__(66299);
// EXTERNAL MODULE: ../../../node_modules/@testing-library/react/dist/@testing-library/react.esm.js + 1 modules
var react_esm = __webpack_require__(72720);
// EXTERNAL MODULE: ../../../node_modules/@lendi-ui/commons/utils/dist/commons.esm.js
var commons_esm = __webpack_require__(7401);
// EXTERNAL MODULE: ../../../node_modules/react-helmet/es/Helmet.js
var Helmet = __webpack_require__(74758);
// EXTERNAL MODULE: ../../../node_modules/react-element-to-jsx-string/dist/cjs/index.js
var cjs = __webpack_require__(44782);
;// CONCATENATED MODULE: ../node_modules/@lendi/ui/Theme/dist/ui.esm.js












// EXTERNAL MODULE: ../../../node_modules/next/app.js
var app = __webpack_require__(6957);
// EXTERNAL MODULE: ./components/LaunchDarkly/index.tsx
var LaunchDarkly = __webpack_require__(49932);
// EXTERNAL MODULE: ./context/index.ts + 4 modules
var context = __webpack_require__(37829);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(89799);
// EXTERNAL MODULE: ./state/actionProvider.tsx
var actionProvider = __webpack_require__(3842);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70111);
;// CONCATENATED MODULE: ./state/actions.ts
var SENDING_CODE = "SENDING_CODE";
var CODE_SENT = "CODE_SENT";
var VERIFYING_CODE = "VERIFYING_CODE";
var AUTH_ME_ENDED = "AUTH_ME_ENDED";
var AUTH_ERROR = "AUTH_ERROR";
var SAVE_LEAD_ID = "SAVE_LEAD_ID";
var SESSION_EXPIRED = "SESSION_EXPIRED";
var RESET_SEND_CODE = "RESET_SEND_CODE";
var RESET_ERROR = "RESET_ERROR";
var RESET_AUTH_STATE = "RESET_AUTH_STATE";
var EXPIRED_SENDING_CODE = "EXPIRED_SENDING_CODE";
var AUTHORISE_STARTED = "AUTHORISE_STARTED";

// EXTERNAL MODULE: ./state/state.ts
var state_state = __webpack_require__(79826);
;// CONCATENATED MODULE: ./state/reducer.ts




var reducer = function(state, action) {
    switch(action.type){
        case AUTH_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                sendingCode: false,
                error: action.error
            });
        case VERIFYING_CODE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true,
                email: action.email,
                error: undefined
            });
        case SENDING_CODE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                sendingCode: true,
                loading: true,
                phoneNumber: action.phoneNumber,
                firstName: action.firstName || state.firstName,
                error: undefined
            });
        case CODE_SENT:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                sendingCode: false,
                loading: false,
                codeSent: true
            });
        case RESET_SEND_CODE:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                codeSent: false
            });
        case SESSION_EXPIRED:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                existingCustomer: true,
                phoneNumber: action.phoneNumber || state.phoneNumber,
                firstName: action.firstName || state.firstName
            });
        case SAVE_LEAD_ID:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                leadId: action.leadId
            });
        case AUTH_ME_ENDED:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: false,
                error: action.error ? action.error : undefined
            });
        case RESET_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: undefined
            });
        case RESET_AUTH_STATE:
            return state_state/* initialState */.E3;
        case AUTHORISE_STARTED:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                loading: true
            });
        default:
            return state;
    }
};

// EXTERNAL MODULE: ../node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(67921);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(62804);
// EXTERNAL MODULE: ./helpers/index.ts + 1 modules
var helpers = __webpack_require__(45343);
// EXTERNAL MODULE: ./helpers/util.ts
var util = __webpack_require__(61414);
// EXTERNAL MODULE: ./helpers/tracking/index.ts + 53 modules
var tracking = __webpack_require__(67458);
// EXTERNAL MODULE: ./helpers/router.ts
var router = __webpack_require__(59060);
// EXTERNAL MODULE: ./api/customer.ts
var api_customer = __webpack_require__(81878);
// EXTERNAL MODULE: ../node_modules/@lendi/core-constants/lib/esm/index.js + 84 modules
var lib_esm = __webpack_require__(82419);
// EXTERNAL MODULE: ../node_modules/@lendi/lendigroup-leads-library/dist/esm/index.js + 206 modules
var lendigroup_leads_library_dist_esm = __webpack_require__(49481);
;// CONCATENATED MODULE: ./state/sendLeadsData.ts






function sendLeadsData(data) {
    return _sendLeadsData.apply(this, arguments);
}
function _sendLeadsData() {
    _sendLeadsData = (0,_async_to_generator/* default */.Z)(function(data) {
        var ref, brand, baseURL, leadData, isLendiGroupLead, params, storeId, brokerId, refCode, isDefaultLendiGroupLeads, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    brand = data.brand || (0,dist_esm/* getBrandFromHostname */.Y6)();
                    baseURL = (0,dist_esm/* getAPIBaseURL */.K0)((0,dist_esm/* getEnv */.dU)());
                    leadData = lendigroup_leads_library_dist_esm/* LendiGroupLeads.retrieveLatestLeadData */.vA.retrieveLatestLeadData();
                    isLendiGroupLead = (leadData === null || leadData === void 0 ? void 0 : (ref = leadData.data) === null || ref === void 0 ? void 0 : ref.version) === "v3";
                    dist_esm/* LalaSentry.logInfo */.GG.logInfo("Sending lead!", {
                        isLendiGroupLead: isLendiGroupLead
                    });
                    params = new URLSearchParams(window.location.search);
                    storeId = params.get("storeid");
                    brokerId = params.get("brokerid");
                    refCode = params.get("refcode");
                    localStorage.setItem(dist_esm/* BYPASS_POSTCODE */.or, storeId || brokerId ? "true" : "false");
                    isDefaultLendiGroupLeads = leadData.funnelName === lendigroup_leads_library_dist_esm/* Origin.SignUp */.aP.SignUp && leadData.data.timestamp === 0;
                    return [
                        4,
                        lendigroup_leads_library_dist_esm/* LendiGroupLeads.sendLatestLead */.vA.sendLatestLead(baseURL, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                            brand: brand,
                            firstName: data.firstName || leadData.data.firstName
                        }), isDefaultLendiGroupLeads && {
                            accountOrigin: window.location.href
                        }, refCode && {
                            utm: {
                                utmSource: "CustomerReferral"
                            }
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    dist_esm/* LalaSentry.logError */.GG.logError("Posting lead data failed!", {
                        error: error
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _sendLeadsData.apply(this, arguments);
}

// EXTERNAL MODULE: ./state/handleOwnershipChange.ts + 4 modules
var handleOwnershipChange = __webpack_require__(88866);
// EXTERNAL MODULE: ../../../node_modules/jwt-decode/build/jwt-decode.esm.js
var jwt_decode_esm = __webpack_require__(30612);
;// CONCATENATED MODULE: ./state/isLinkableSso.ts

var linkableCustomerIdClaimName = "https://lendi/linkableCustomerId";
var connectionClaimName = "https://lendi/connection";
var decodeToken = function(token) {
    return token ? (0,jwt_decode_esm/* default */.Z)(token) : undefined;
};
function isLinkableSso(token) {
    var jwt = decodeToken(token);
    var linkableCustomerId = jwt === null || jwt === void 0 ? void 0 : jwt[linkableCustomerIdClaimName];
    var connection = jwt === null || jwt === void 0 ? void 0 : jwt[connectionClaimName];
    return !!(linkableCustomerId && connection === "google-oauth2");
}
function getLinkableCustomerId(token) {
    var ref;
    return (ref = decodeToken(token)) === null || ref === void 0 ? void 0 : ref[linkableCustomerIdClaimName];
}

;// CONCATENATED MODULE: ./state/sagas.ts

















var LalaCustomerSagas = /*#__PURE__*/ function() {
    "use strict";
    function LalaCustomerSagas(dispatch, param, deprecatedAuthReset, popupAuthorise) {
        var send = param.send, verify = param.verify;
        (0,_class_call_check/* default */.Z)(this, LalaCustomerSagas);
        this._dispatch = dispatch;
        this._send = send;
        this._verify = verify;
        this._popupAuthorise = popupAuthorise;
        this._deprecatedAuthReset = deprecatedAuthReset;
    }
    var _proto = LalaCustomerSagas.prototype;
    _proto.expireSession = function expireSession(firstName, phoneNumber) {
        this._dispatch({
            type: "SESSION_EXPIRED",
            firstName: firstName,
            phoneNumber: phoneNumber
        });
    };
    _proto.resetError = function resetError() {
        this._dispatch({
            type: "RESET_ERROR"
        });
    };
    _proto.resetSendCode = function resetSendCode() {
        this._dispatch({
            type: "RESET_SEND_CODE"
        });
    };
    _proto.resetAuthState = function resetAuthState(callback) {
        this._dispatch({
            type: "RESET_AUTH_STATE"
        });
        if (typeof sessionStorage !== "undefined") {
            sessionStorage.removeItem(dist_esm/* STATE_STORAGE_KEY */.OB);
        }
        if (callback) callback();
    };
    _proto.sendCode = function sendCode(phoneNumber, firstName, callback) {
        var _this = this;
        var ref;
        var state = (0,dist_esm/* getStateFromStorage */.Fi)();
        this._dispatch({
            type: "SENDING_CODE",
            phoneNumber: phoneNumber,
            firstName: firstName
        });
        if (!(state === null || state === void 0 ? void 0 : (ref = state.identity) === null || ref === void 0 ? void 0 : ref.id)) {
            sendLeadsData({
                authOrigin: lib_esm/* AuthOrigin.Passwordless */.hH.Passwordless,
                mobileNumber: phoneNumber,
                firstName: firstName
            });
        }
        this.configureUserContext(phoneNumber);
        this._send(phoneNumber).then(function() {
            _this._dispatch({
                type: "CODE_SENT"
            });
            if (callback) callback();
        }).catch(function(error) {
            _this.captureException(error, "Auth0CodeSend");
            _this._dispatch({
                type: "AUTH_ERROR",
                error: {
                    authError: error,
                    flow: state_state/* LALAAuthFlow.Passwordless */.x1.Passwordless
                }
            });
        });
    };
    _proto.configureUserContext = function configureUserContext(phoneNumber) {
        dist_esm/* LalaSentry.configureUserContext */.GG.configureUserContext({
            phoneNumber: (0,util/* maskPhoneNumber */.YY)(phoneNumber)
        });
    };
    _proto.captureException = function captureException(error, tag) {
        dist_esm/* LalaSentry.captureException */.GG.captureException(error, tag);
    };
    _proto.verifyCode = function verifyCode(phone, email, verificationCode, ssoMergeFF, leadId, firstName) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, state;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = (0,dist_esm/* getStateFromStorage */.Fi)();
                        dist_esm/* LalaSentry.logInfo */.GG.logInfo("saga.verifyCode", {
                            ssoMergeFF: ssoMergeFF,
                            userId: state === null || state === void 0 ? void 0 : (ref = state.identity) === null || ref === void 0 ? void 0 : ref.id
                        });
                        _this._dispatch({
                            type: "VERIFYING_CODE",
                            email: email
                        });
                        return [
                            4,
                            _this._verify({
                                phone: phone,
                                code: verificationCode,
                                email: email,
                                leadId: leadId,
                                firstName: firstName
                            }).then(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(token) {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    _this.verifyCodeSuccess(token, state, ssoMergeFF)
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(token) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function(error) {
                                _this.captureException(error, "Auth0CodeVerify");
                                _this._dispatch({
                                    type: "AUTH_ERROR",
                                    error: {
                                        authError: error,
                                        flow: state_state/* LALAAuthFlow.Passwordless */.x1.Passwordless
                                    }
                                });
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.clearLeadsSession = function clearLeadsSession() {
        var origins = [
            "BORROWING_POWER",
            "PROPERTY_REPORT",
            "TOOLBOX",
            "LAM_FORM",
            "SIGN_UP",
            "NEW_HOME_LOAN",
            "REFINANCE",
            "BLOG",
            // 'STAMP_DUTY_CALCULATOR', -> due to IM-271
            "APPOINTMENT_BOOKING",
            "INVITE",
            "CHAT",
            "SELF_GEN", 
        ];
        try {
            origins.forEach(function(origin) {
                sessionStorage.removeItem("l3-".concat(origin));
            });
        } catch (error) {
            console.error("Failed to clear the storage", error);
        }
    };
    _proto.verifyCodeSuccess = function verifyCodeSuccess(accessToken, preState, ssoMergeFF) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var state, existingUser, brand, ref, ref1, customer, params, isEmailVerify, next, ref2, _err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        state = (0,dist_esm/* getStateFromStorage */.Fi)();
                        existingUser = state.identity.existingUser;
                        // fire Authenticated event
                        return [
                            4,
                            tracking/* eventTracking.trackAuthenticationEvent */.fn.trackAuthenticationEvent(state.identity.connection)
                        ];
                    case 1:
                        _state.sent();
                        brand = (0,dist_esm/* getBrandFromHostname */.Y6)();
                        if (brand === dist_esm/* Brand.Aussie */.H2.Aussie) {
                            _this.clearLeadsSession();
                        }
                        js_cookie.set(dist_esm/* SAFETY_NET_COOKIE_NAME */.x7, "false");
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            10,
                            ,
                            11
                        ]);
                        return [
                            4,
                            (0,api_customer/* getCustomerDetails */.TD)(accessToken)
                        ];
                    case 3:
                        customer = _state.sent();
                        if (!!existingUser) return [
                            3,
                            5
                        ];
                        // fire Registered event
                        return [
                            4,
                            tracking/* eventTracking.trackRegisterEvent */.fn.trackRegisterEvent(customer.id, state.identity.connection)
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        params = new URLSearchParams(window.location.search.toLowerCase());
                        isEmailVerify = (ref = params.get("returnurl")) === null || ref === void 0 ? void 0 : ref.includes("/me/verify-email");
                        next = undefined;
                        if (!(((ref1 = customer.state) === null || ref1 === void 0 ? void 0 : ref1.emailVerification) === "NEEDED" && !isEmailVerify)) return [
                            3,
                            6
                        ];
                        sessionStorage.setItem(constants/* DOUBLE_VERIFICATION_EMAIL */.U, customer.email || "");
                        next = "email-safety-net";
                        return [
                            3,
                            8
                        ];
                    case 6:
                        if (!ssoMergeFF) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            _this.getNextAfterConditionalMerge(accessToken, preState)
                        ];
                    case 7:
                        next = _state.sent();
                        _state.label = 8;
                    case 8:
                        return [
                            4,
                            (0,handleOwnershipChange/* handleOwnershipChange */.S)(accessToken, next)
                        ];
                    case 9:
                        next = _state.sent() || next;
                        if (next) {
                            ;
                            dist_esm/* LalaSentry.logInfo */.GG.logInfo("Next on getCustomer done", {
                                userId: state === null || state === void 0 ? void 0 : (ref2 = state.identity) === null || ref2 === void 0 ? void 0 : ref2.id,
                                next: next
                            });
                            router/* default.push */.Z.push({
                                pathname: "/" + next,
                                query: router/* default.query */.Z.query()
                            });
                        } else (0,helpers/* doRedirect */.V$)();
                        return [
                            3,
                            11
                        ];
                    case 10:
                        _err = _state.sent();
                        _this._dispatch({
                            type: "AUTH_ME_ENDED",
                            error: {
                                authError: new dist_esm/* GenericError */.pY(),
                                flow: state_state/* LALAAuthFlow.Passwordless */.x1.Passwordless
                            }
                        });
                        _this._deprecatedAuthReset();
                        return [
                            3,
                            11
                        ];
                    case 11:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.getNextAfterConditionalMerge = function getNextAfterConditionalMerge(accessToken, preState) {
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, currentState, preToken, userId, isPreviousTokenLinkableSso, ssoToken, otpToken, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentState = (0,dist_esm/* getStateFromStorage */.Fi)();
                        preToken = preState === null || preState === void 0 ? void 0 : preState.token;
                        userId = currentState === null || currentState === void 0 ? void 0 : (ref = currentState.identity) === null || ref === void 0 ? void 0 : ref.id;
                        isPreviousTokenLinkableSso = isLinkableSso(preToken);
                        dist_esm/* LalaSentry.logInfo */.GG.logInfo("Check merge", {
                            isPreviousTokenLinkableSso: isPreviousTokenLinkableSso,
                            userId: userId
                        });
                        if (!isPreviousTokenLinkableSso) return [
                            3,
                            5
                        ];
                        ssoToken = preToken;
                        otpToken = accessToken;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,api_customer/* mergeAccounts */.LS)(accessToken, ssoToken, otpToken)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        return [
                            2,
                            "safety-net"
                        ];
                    case 4:
                        return [
                            3,
                            6
                        ];
                    case 5:
                        if (getLinkableCustomerId(accessToken)) {
                            return [
                                2,
                                "verify-sso"
                            ];
                        }
                        _state.label = 6;
                    case 6:
                        return [
                            2,
                            undefined
                        ];
                }
            });
        })();
    };
    _proto.authoriseSuccess = function authoriseSuccess(token, _existingCustomer) {
        var _this = this;
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, brand, mobileNumber, email, firstName, customerId, next, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,api_customer/* getCustomerDetails */.TD)(token)
                        ];
                    case 1:
                        ref = _state.sent(), brand = ref.brand, mobileNumber = ref.mobileNumber, email = ref.email, firstName = ref.firstName, customerId = ref.id;
                        sendLeadsData({
                            authOrigin: lib_esm/* AuthOrigin.Google */.hH.Google,
                            brand: brand,
                            mobileNumber: mobileNumber,
                            email: email,
                            firstName: firstName,
                            customerId: customerId
                        });
                        js_cookie.set(dist_esm/* SAFETY_NET_COOKIE_NAME */.x7, (mobileNumber === null || mobileNumber === void 0 ? void 0 : mobileNumber.startsWith("+61")) ? "false" : "true");
                        if (!_existingCustomer) {
                            tracking/* eventTracking.trackRegisterEvent */.fn.trackRegisterEvent(customerId, "google-oauth2");
                        }
                        tracking/* eventTracking.trackAuthenticationEvent */.fn.trackAuthenticationEvent("google-oauth2");
                        dist_esm/* LalaSentry.logInfo */.GG.logInfo("SSO lead data sent.");
                        if (isLinkableSso(token)) {
                            next = "verify-to-continue";
                        }
                        return [
                            4,
                            (0,handleOwnershipChange/* handleOwnershipChange */.S)(token, next)
                        ];
                    case 2:
                        next = _state.sent() || next;
                        if (next) {
                            dist_esm/* LalaSentry.logInfo */.GG.logInfo("Next on SSO getCustomer done", {
                                next: next
                            });
                            router/* default.push */.Z.push({
                                pathname: "/" + next,
                                query: router/* default.query */.Z.query()
                            });
                        } else (0,helpers/* doRedirect */.V$)();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        dist_esm/* LalaSentry.logError */.GG.logError("authoriseSuccess method failed!", {
                            error: error
                        });
                        _this._dispatch({
                            type: "AUTH_ME_ENDED",
                            error: {
                                authError: new dist_esm/* GenericError */.pY(),
                                flow: state_state/* LALAAuthFlow.SSI */.x1.SSI
                            }
                        });
                        _this._deprecatedAuthReset();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.authorise = function authorise(connection) {
        var _this = this;
        this._dispatch({
            type: "AUTHORISE_STARTED"
        });
        this._popupAuthorise({
            connection: connection
        }).then(function(result) {
            if (result) _this.authoriseSuccess(result.token, result.existingCustomer);
        }).catch(function(error) {
            if (error.code === dist_esm/* ErrorCodes.POPUP_CLOSED */.SM.POPUP_CLOSED) {
                _this._dispatch({
                    type: "AUTH_ME_ENDED"
                });
                return;
            }
            _this.captureException(error, "Auth0SSIAuthorise");
            _this._dispatch({
                type: "AUTH_ERROR",
                error: {
                    authError: error,
                    flow: state_state/* LALAAuthFlow.SSI */.x1.SSI
                }
            });
        });
    };
    return LalaCustomerSagas;
}();
var useActionsWithAsync = function(dispatch, passwordlessAuthDetails, deprecatedAuthReset, authorisePopup) {
    return (0,react.useMemo)(function() {
        return new LalaCustomerSagas(dispatch, passwordlessAuthDetails, deprecatedAuthReset, authorisePopup);
    }, []);
};

;// CONCATENATED MODULE: ./layout/appInner.tsx








var FunctionalLalaAppInner = function(param) {
    var children = param.children;
    var ref = (0,esm/* useSession */.kP)(), DEPRECATED_RESET = ref.DEPRECATED_RESET, popupAuthorise = ref.popupAuthorise;
    var passwordlessAuth = (0,esm/* usePasswordlessAuthentication */.er)();
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useReducer(reducer, state_state/* initialState */.E3), 2), state = ref1[0], dispatch = ref1[1];
    var actions = useActionsWithAsync(dispatch, passwordlessAuth, DEPRECATED_RESET, popupAuthorise);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(actionProvider/* ActionsProvider */.DG, {
        actions: actions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(state_state/* LALACustomerAppContext.Provider */.no.Provider, {
            value: state,
            children: children
        })
    });
};

// EXTERNAL MODULE: ../node_modules/launchdarkly-react-client-sdk/lib/esm/index.js + 1 modules
var launchdarkly_react_client_sdk_lib_esm = __webpack_require__(91649);
// EXTERNAL MODULE: ../../../node_modules/react-international-phone/build/index.css
var build = __webpack_require__(63269);
// EXTERNAL MODULE: ./components/MobileInput/style.css
var style = __webpack_require__(92861);
;// CONCATENATED MODULE: ./pages/_app.tsx





















dist_esm/* LalaSentry.init */.GG.init();
var session = new esm/* Session */.z_({
    brand: (0,dist_esm/* getBrandFromHostname */.Y6)(),
    type: dist_esm/* Type.Customer */.Dy.Customer,
    environment: (0,dist_esm/* getEnv */.dU)()
});
var LalaApp = /*#__PURE__*/ function(App) {
    "use strict";
    (0,_inherits/* default */.Z)(LalaApp, App);
    var _super = (0,_create_super/* default */.Z)(LalaApp);
    function LalaApp() {
        (0,_class_call_check/* default */.Z)(this, LalaApp);
        return _super.apply(this, arguments);
    }
    var _proto = LalaApp.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        dist_esm/* LalaSentry.captureException */.GG.captureException(error, "LalaApp", errorInfo);
        // @ts-ignore
        _get((0,_get_prototype_of/* default */.Z)(LalaApp.prototype), "componentDidCatch", this).call(this, error, errorInfo);
    };
    _proto.render = function render() {
        var _props = this.props, Component = _props.Component, pageProps = _props.pageProps;
        /**
     * As part of ThemeV2 & Navbar constraint (use of `window`), the following check enforces Client Side Rendering.
     * This is a temporary measure, and will be removed in the future once SSR is fully supported.
     * @see [LUI-854](https://creditandfinance.atlassian.net/browse/LUI-854)
     */ if (false) {}
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(select_73d530a0_esm.T, {
            name: session.brand,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* SessionProvider */.eA, {
                session: session,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LaunchDarkly/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FunctionalLalaAppInner, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(provider/* CustomerChatBootstrapperProvider */.e, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* TranslationProvider */.$j, {
                                brand: session.brand,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                            })
                        })
                    })
                })
            })
        });
    };
    LalaApp.getInitialProps = function getInitialProps(param) {
        var Component = param.Component, ctx = param.ctx;
        return (0,_async_to_generator/* default */.Z)(function() {
            var pageProps, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        pageProps = {};
                        if (!Component.getInitialProps) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            Component.getInitialProps(ctx)
                        ];
                    case 1:
                        pageProps = _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2,
                            {
                                pageProps: pageProps
                            }
                        ];
                    case 3:
                        err = _state.sent();
                        dist_esm/* LalaSentry.captureException */.GG.captureException(err, "LalaApp", ctx);
                        throw err;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return LalaApp;
}(app["default"]);
/* harmony default export */ var _app = ((0,launchdarkly_react_client_sdk_lib_esm/* withLDProvider */.VO)({
    clientSideID: "5e5486f5f434d50824ef46b0" || 0
})(LalaApp));


/***/ }),

/***/ 3842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DG": function() { return /* binding */ ActionsProvider; },
/* harmony export */   "ol": function() { return /* binding */ useActions; }
/* harmony export */ });
/* unused harmony export ActionsContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var launchdarkly_react_client_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91649);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32735);
/* harmony import */ var _lendi_lala_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82839);




var ActionsContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.createContext(undefined);
var useActions = function() {
    var context = react__WEBPACK_IMPORTED_MODULE_2__.useContext(ActionsContext);
    if (!context) {
        throw new Error("ActionsContext must be used inside LALA Customer App");
    }
    return context;
};
var ActionsProvider = function(param) {
    var actions = param.actions, children = param.children;
    var ssoMerge = (0,launchdarkly_react_client_sdk__WEBPACK_IMPORTED_MODULE_1__/* .useFlags */ .Vb)().ssoMerge;
    _lendi_lala_utils__WEBPACK_IMPORTED_MODULE_3__/* .LalaSentry.logInfo */ .GG.logInfo("Loading ActionsProvider", {
        ssoMerge: ssoMerge
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ActionsContext.Provider, {
        value: {
            sendCode: function(phoneNumber, firstName, callback) {
                return actions.sendCode(phoneNumber, firstName, callback);
            },
            verifyCode: function(phone, email, verificationCode, leadId, firstName) {
                return actions.verifyCode(phone, email, verificationCode, ssoMerge, leadId, firstName);
            },
            expireSession: function(firstName, phoneNumber) {
                return actions.expireSession(firstName, phoneNumber);
            },
            resetError: function() {
                return actions.resetError();
            },
            resetAuthState: function(callback) {
                return actions.resetAuthState(callback);
            },
            authorisePopup: function(connection) {
                return actions.authorise(connection);
            },
            resetSendCode: function() {
                return actions.resetSendCode();
            }
        },
        children: children
    });
};


/***/ }),

/***/ 88866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ handleOwnershipChange; }
});

// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(44229);
// EXTERNAL MODULE: ../../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92712);
// EXTERNAL MODULE: ../../../packages/lala-react/dist/esm/index.js + 318 modules
var esm = __webpack_require__(25980);
// EXTERNAL MODULE: ../../../packages/lala-utils/dist/esm/index.js + 23 modules
var dist_esm = __webpack_require__(82839);
// EXTERNAL MODULE: ./api/customer.ts
var api_customer = __webpack_require__(81878);
// EXTERNAL MODULE: ./helpers/tracking/index.ts + 53 modules
var tracking = __webpack_require__(67458);
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 5 modules
var _sliced_to_array = __webpack_require__(89799);
// EXTERNAL MODULE: ../node_modules/axios/lib/axios.js + 42 modules
var axios = __webpack_require__(88830);
;// CONCATENATED MODULE: ./api/team.ts




var getConfig = function(authToken) {
    return {
        baseURL: "https://api.lendi.com.au",
        headers: {
            Authorization: "Bearer ".concat(authToken),
            "Content-Type": "application/json"
        }
    };
};
var getTeamMember = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(authToken, teamMemberId) {
        var data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios/* default.get */.Z.get("/v1/team-member/".concat(teamMemberId), getConfig(authToken))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data === null || data === void 0 ? void 0 : data.data
                    ];
                case 2:
                    error = _state.sent();
                    dist_esm/* LalaSentry.logInfo */.GG.logInfo("Error getting team member", {
                        error: error,
                        teamMemberId: teamMemberId
                    });
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getTeamMember(authToken, teamMemberId) {
        return _ref.apply(this, arguments);
    };
}();
var getStore = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(authToken, storeId) {
        var data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios/* default.get */.Z.get("/v1/store/".concat(storeId), getConfig(authToken))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data === null || data === void 0 ? void 0 : data.data
                    ];
                case 2:
                    error = _state.sent();
                    dist_esm/* LalaSentry.logInfo */.GG.logInfo("Error getting store", {
                        error: error,
                        storeId: storeId
                    });
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getStore(authToken, storeId) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./state/decideOwnershipChange/rules/rules.ts
// Prerouted + Referral Ownership Change confluence : https://creditandfinance.atlassian.net/wiki/spaces/SUB/pages/3271689303/Prerouted+Referral+Ownership+Change
// 1 means no change, 2 means broker or store has changed.
var BrokerStoreValueType;
(function(BrokerStoreValueType) {
    BrokerStoreValueType[BrokerStoreValueType["OriginalValue"] = 1] = "OriginalValue";
    BrokerStoreValueType[BrokerStoreValueType["NewValue"] = 2] = "NewValue";
})(BrokerStoreValueType || (BrokerStoreValueType = {}));
var rules = [
    {
        id: 1,
        input: {
            brokerB: BrokerStoreValueType.NewValue
        },
        output: {
            broker: BrokerStoreValueType.NewValue
        }
    },
    {
        id: 2,
        input: {
            storeB: BrokerStoreValueType.NewValue
        },
        output: {
            store: BrokerStoreValueType.NewValue
        }
    },
    {
        id: 3,
        input: {
            storeB: BrokerStoreValueType.NewValue,
            brokerB: BrokerStoreValueType.NewValue
        },
        output: {
            broker: BrokerStoreValueType.NewValue,
            store: BrokerStoreValueType.NewValue
        }
    },
    {
        id: 4,
        input: {},
        output: {}
    },
    {
        id: 7,
        input: {
            brokerA: BrokerStoreValueType.OriginalValue,
            brokerB: BrokerStoreValueType.NewValue
        },
        output: {
            broker: BrokerStoreValueType.NewValue,
            message1: "Your existing broker is {BrokerA}.",
            message2: "Would you like to update your broker to {BrokerB}, or would you like to keep working with {BrokerA}?",
            title: "Update assigned broker"
        }
    },
    {
        id: 8,
        input: {
            brokerA: BrokerStoreValueType.OriginalValue,
            storeB: BrokerStoreValueType.NewValue,
            brokerB: BrokerStoreValueType.NewValue
        },
        output: {
            store: BrokerStoreValueType.NewValue,
            broker: BrokerStoreValueType.NewValue,
            message1: "Your existing broker is {BrokerA}.",
            message2: "Would you like to update your broker to {BrokerB} from {StoreB}, or would you like to keep working with {BrokerA}?",
            title: "Update assigned broker"
        }
    },
    {
        id: 9,
        input: {
            storeA: BrokerStoreValueType.OriginalValue,
            brokerA: BrokerStoreValueType.OriginalValue,
            brokerB: BrokerStoreValueType.NewValue
        },
        output: {
            broker: BrokerStoreValueType.NewValue,
            message1: "Your existing broker is {BrokerA} from {StoreA}.",
            message2: "Would you like to update your broker to {BrokerB}, or would you like to keep working with {BrokerA}?",
            title: "Update assigned broker"
        }
    },
    {
        id: 10,
        input: {
            storeA: BrokerStoreValueType.OriginalValue,
            brokerA: BrokerStoreValueType.OriginalValue,
            storeB: BrokerStoreValueType.NewValue,
            brokerB: BrokerStoreValueType.NewValue
        },
        output: {
            store: BrokerStoreValueType.NewValue,
            broker: BrokerStoreValueType.NewValue,
            message1: "Your existing broker is {BrokerA} from {StoreA}.",
            message2: "Would you like to update your broker to {BrokerB} from {StoreB}, or would you like to keep working with {BrokerA}?",
            title: "Update assigned broker"
        }
    },
    {
        id: 11,
        input: {
            brokerA: BrokerStoreValueType.OriginalValue,
            brokerB: BrokerStoreValueType.OriginalValue
        },
        output: {}
    },
    {
        id: 12,
        input: {
            storeA: BrokerStoreValueType.OriginalValue,
            brokerA: BrokerStoreValueType.OriginalValue,
            storeB: BrokerStoreValueType.OriginalValue,
            brokerB: BrokerStoreValueType.OriginalValue
        },
        output: {}
    },
    {
        id: 13,
        input: {
            storeA: BrokerStoreValueType.OriginalValue,
            brokerA: BrokerStoreValueType.OriginalValue,
            brokerB: BrokerStoreValueType.OriginalValue
        },
        output: {}
    },
    {
        id: 14,
        input: {
            brokerA: BrokerStoreValueType.OriginalValue,
            storeB: BrokerStoreValueType.OriginalValue,
            brokerB: BrokerStoreValueType.OriginalValue
        },
        output: {}
    },
    {
        id: 15,
        input: {
            storeA: BrokerStoreValueType.OriginalValue,
            brokerA: BrokerStoreValueType.OriginalValue,
            storeB: BrokerStoreValueType.NewValue,
            brokerB: BrokerStoreValueType.OriginalValue
        },
        output: {
            store: BrokerStoreValueType.NewValue,
            broker: BrokerStoreValueType.NewValue,
            message1: "Your existing broker is {BrokerA} from {StoreA}.",
            message2: "Would you like to update your broker to {BrokerA} from {StoreB}, or would you like to keep working with {StoreA}?",
            title: "Update assigned store"
        }
    },
    {
        id: 16,
        input: {
            storeA: BrokerStoreValueType.OriginalValue,
            brokerA: BrokerStoreValueType.OriginalValue,
            storeB: BrokerStoreValueType.NewValue
        },
        output: {
            store: BrokerStoreValueType.NewValue,
            message1: "Your existing broker is {BrokerA} from {StoreA}.",
            message2: "Would you like to update your store to {StoreB}, or would you like to keep working with {BrokerA}?",
            title: "Update assigned store"
        }
    },
    {
        id: 17,
        input: {
            brokerA: BrokerStoreValueType.OriginalValue,
            storeB: BrokerStoreValueType.NewValue
        },
        output: {
            store: BrokerStoreValueType.NewValue,
            message1: "Your existing broker is {BrokerA}.",
            message2: "Would you like to update to {StoreB}, or would you like to keep working with {BrokerA}?",
            title: "Update assigned store"
        }
    },
    {
        id: 18,
        input: {
            brokerA: BrokerStoreValueType.OriginalValue,
            storeA: BrokerStoreValueType.OriginalValue,
            storeB: BrokerStoreValueType.OriginalValue
        },
        output: {}
    },
    {
        id: 19,
        input: {
            brokerA: BrokerStoreValueType.OriginalValue,
            storeA: BrokerStoreValueType.OriginalValue,
            storeB: BrokerStoreValueType.OriginalValue,
            brokerB: BrokerStoreValueType.NewValue
        },
        output: {
            store: BrokerStoreValueType.NewValue,
            broker: BrokerStoreValueType.NewValue,
            message1: "Your existing broker is {BrokerA} from {StoreA}.",
            message2: "Would you like to update your broker to {BrokerB} {StoreA} or would you like to keep working with {BrokerA}?",
            title: "Update assigned broker"
        }
    },
    {
        id: 23,
        input: {
            storeA: BrokerStoreValueType.OriginalValue,
            storeB: BrokerStoreValueType.OriginalValue,
            brokerB: BrokerStoreValueType.NewValue
        },
        output: {
            store: BrokerStoreValueType.NewValue,
            broker: BrokerStoreValueType.NewValue,
            message1: "Your existing store is {StoreA}.",
            message2: "Would you like to update your broker to {StoreA} {BrokerB}, or would you like to keep working with Aussie {StoreA}?",
            title: "Update assigned broker"
        }
    },
    {
        id: 24,
        input: {
            storeA: BrokerStoreValueType.OriginalValue,
            storeB: BrokerStoreValueType.NewValue,
            brokerB: BrokerStoreValueType.NewValue
        },
        output: {
            store: BrokerStoreValueType.NewValue,
            broker: BrokerStoreValueType.NewValue,
            message1: "Your existing store is {StoreA}.",
            message2: "Would you like to update your broker to {StoreB} {BrokerB}, or would you like to keep working with Aussie {StoreA}?",
            title: "Update assigned broker"
        }
    },
    {
        id: 25,
        input: {
            storeA: BrokerStoreValueType.OriginalValue,
            storeB: BrokerStoreValueType.OriginalValue
        },
        output: {
            store: BrokerStoreValueType.NewValue
        }
    },
    {
        id: 26,
        input: {
            storeA: BrokerStoreValueType.OriginalValue,
            storeB: BrokerStoreValueType.NewValue
        },
        output: {
            store: BrokerStoreValueType.NewValue,
            message1: "Your existing store is {StoreA}.",
            message2: "Would you like to update to {StoreB}, or would you like to keep working with Aussie {StoreA}?",
            title: "Update assigned store"
        }
    },
    {
        id: 27,
        input: {
            storeA: BrokerStoreValueType.OriginalValue,
            brokerB: BrokerStoreValueType.NewValue
        },
        output: {
            broker: BrokerStoreValueType.NewValue,
            message1: "Your existing store is {StoreA}.",
            message2: "Would you like to update your broker to {BrokerB}, or would you like to keep working with Aussie {StoreA}?",
            title: "Update assigned broker"
        }
    }, 
];

;// CONCATENATED MODULE: ./state/decideOwnershipChange/rules/findRule.ts

function findRule(currentStore, currentBroker, targetStore, targetBroker) {
    var storeA = currentStore ? 1 : undefined;
    var brokerA = currentBroker ? 1 : undefined;
    var storeB = targetStore ? targetStore == currentStore ? 1 : 2 : undefined;
    var brokerB = targetBroker ? targetBroker == currentBroker ? 1 : 2 : undefined;
    var rule = rules.find(function(r) {
        return r.input.storeA === storeA && r.input.brokerA === brokerA && r.input.storeB === storeB && r.input.brokerB === brokerB;
    });
    return {
        messageTemplate1: rule === null || rule === void 0 ? void 0 : rule.output.message1,
        messageTemplate2: rule === null || rule === void 0 ? void 0 : rule.output.message2,
        title: rule === null || rule === void 0 ? void 0 : rule.output.title,
        requestStoreId: (rule === null || rule === void 0 ? void 0 : rule.output.store) ? targetStore : undefined,
        requestOwnerId: (rule === null || rule === void 0 ? void 0 : rule.output.broker) ? targetBroker : undefined
    };
}

;// CONCATENATED MODULE: ./state/decideOwnershipChange/index.ts






var DoNothingDecision = {};
var brokerActiveStatuses = [
    "Competent",
    "Active",
    "Compliance",
    "Graduate",
    "PIP"
];
function resolveBroker(accessToken, id) {
    return _resolveBroker.apply(this, arguments);
}
function _resolveBroker() {
    _resolveBroker = (0,_async_to_generator/* default */.Z)(function(accessToken, id) {
        var broker, fullName;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!id) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        getTeamMember(accessToken, id)
                    ];
                case 1:
                    broker = _state.sent();
                    fullName = "".concat((broker === null || broker === void 0 ? void 0 : broker.firstName) || "", " ").concat((broker === null || broker === void 0 ? void 0 : broker.lastName) || "").trim();
                    if (brokerActiveStatuses.includes((broker === null || broker === void 0 ? void 0 : broker.brokerStatus) || "")) {
                        return [
                            2,
                            {
                                id: id,
                                fullName: fullName
                            }
                        ];
                    }
                    _state.label = 2;
                case 2:
                    dist_esm/* LalaSentry.logInfo */.GG.logInfo("Broker status is not any of brokerActiveStatusese!", {
                        BrokerId: id
                    });
                    return [
                        2,
                        undefined
                    ];
            }
        });
    });
    return _resolveBroker.apply(this, arguments);
}
function resolveStore(accessToken, id) {
    return _resolveStore.apply(this, arguments);
}
function _resolveStore() {
    _resolveStore = (0,_async_to_generator/* default */.Z)(function(accessToken, id) {
        var store;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!id) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        getStore(accessToken, id)
                    ];
                case 1:
                    store = _state.sent();
                    if ((store === null || store === void 0 ? void 0 : store.storeStatus) === "ACTIVE") {
                        return [
                            2,
                            {
                                id: id,
                                name: (store === null || store === void 0 ? void 0 : store.name) || ""
                            }
                        ];
                    }
                    _state.label = 2;
                case 2:
                    dist_esm/* LalaSentry.logInfo */.GG.logInfo("Store status is not Avtive!", {
                        StoreId: id
                    });
                    return [
                        2,
                        undefined
                    ];
            }
        });
    });
    return _resolveStore.apply(this, arguments);
}
function replacePlaceholders(template, placeholders) {
    return template.replace(/{([^{}]*)}/g, function(match, key) {
        return placeholders[key] || "";
    });
}
function decideOwnershipChange(accessToken, _) {
    return _decideOwnershipChange.apply(this, arguments);
}
function _decideOwnershipChange() {
    _decideOwnershipChange = (0,_async_to_generator/* default */.Z)(function(accessToken, param) {
        var currentOwnerId, targetStoreId, targetBrokerId, currentStoreId, ref, currentBroker, currentStore, targetBroker, targetStore, rule, placeholders1, placeholders2, message1, message2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    currentOwnerId = param.currentOwnerId, targetStoreId = param.targetStoreId, targetBrokerId = param.targetBrokerId, currentStoreId = param.currentStoreId;
                    return [
                        4,
                        Promise.all([
                            resolveBroker(accessToken, currentOwnerId),
                            resolveStore(accessToken, currentStoreId),
                            resolveBroker(accessToken, targetBrokerId),
                            resolveStore(accessToken, targetStoreId)
                        ])
                    ];
                case 1:
                    ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        4
                    ]), currentBroker = ref[0], currentStore = ref[1], targetBroker = ref[2], targetStore = ref[3];
                    rule = findRule(currentStore === null || currentStore === void 0 ? void 0 : currentStore.id, currentBroker === null || currentBroker === void 0 ? void 0 : currentBroker.id, targetStore === null || targetStore === void 0 ? void 0 : targetStore.id, targetBroker === null || targetBroker === void 0 ? void 0 : targetBroker.id);
                    if (rule) {
                        placeholders1 = {
                            BrokerA: currentBroker === null || currentBroker === void 0 ? void 0 : currentBroker.fullName,
                            StoreA: currentStore === null || currentStore === void 0 ? void 0 : currentStore.name
                        };
                        placeholders2 = {
                            BrokerA: currentBroker === null || currentBroker === void 0 ? void 0 : currentBroker.fullName,
                            BrokerB: targetBroker === null || targetBroker === void 0 ? void 0 : targetBroker.fullName,
                            StoreA: currentStore === null || currentStore === void 0 ? void 0 : currentStore.name,
                            StoreB: targetStore === null || targetStore === void 0 ? void 0 : targetStore.name
                        };
                        message1 = rule.messageTemplate1 && replacePlaceholders(rule.messageTemplate1, placeholders1);
                        message2 = rule.messageTemplate2 && replacePlaceholders(rule.messageTemplate2, placeholders2);
                        return [
                            2,
                            {
                                promptMessage1: message1,
                                promptMessage2: message2,
                                title: rule.title,
                                requestStoreId: rule.requestStoreId,
                                requestOwnerId: rule.requestOwnerId
                            }
                        ];
                    }
                    dist_esm/* LalaSentry.logInfo */.GG.logInfo("Could not match with any rule!", {
                        currentStore: currentStore === null || currentStore === void 0 ? void 0 : currentStore.id,
                        currentBroker: currentBroker === null || currentBroker === void 0 ? void 0 : currentBroker.id,
                        targetStore: targetStore === null || targetStore === void 0 ? void 0 : targetStore.id,
                        targetBroker: targetBroker === null || targetBroker === void 0 ? void 0 : targetBroker.id
                    });
                    return [
                        2,
                        DoNothingDecision
                    ];
            }
        });
    });
    return _decideOwnershipChange.apply(this, arguments);
}

;// CONCATENATED MODULE: ./state/handleOwnershipChange.ts







/*
  signedInUser parameter:
    signedInUser parameter is set true when the user is already is signed-in 
    and reaches to ownership-check page, as of now, only from Booking Appointment page.
    signedInUser parameter is falsy/undefined when the user is just signed in.
    the effect of signedInUser parameter are two:
      1- if falsy, NextJs routing could be used, if truthy, browser window.assign
      2- if truthy, use cached owner when noOwnerCacheFF is off, if falsy, always use cached owner
  */ function handleOwnershipChange(accessToken, next, signedInUser, noOwnerCacheFF) {
    return _handleOwnershipChange.apply(this, arguments);
}
function _handleOwnershipChange() {
    _handleOwnershipChange = (0,_async_to_generator/* default */.Z)(function(accessToken, next, signedInUser, noOwnerCacheFF) {
        var ref, brand, currentState, ref1, currentOwnerId, currentStoreId, userId, newStoreIdFromSession, newBrokerIdFromSession, targetFromSession, newStoreId, newBrokerId, customerRefCode, campaignName, companyGen, isCompanyGen, error, referralOwnerId, _tmp, error1, decision, requestOwnerChange, bypassPostcode, error2, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    brand = (0,dist_esm/* getBrandFromHostname */.Y6)();
                    if (![
                        dist_esm/* Brand.Aussie */.H2.Aussie,
                        dist_esm/* Brand.Lendi */.H2.Lendi
                    ].includes(brand)) return [
                        2,
                        undefined
                    ];
                    currentState = (0,dist_esm/* getStateFromStorage */.Fi)();
                    return [
                        4,
                        getCurrentOwnership(accessToken, signedInUser, noOwnerCacheFF)
                    ];
                case 1:
                    ref1 = _state.sent(), currentOwnerId = ref1.currentOwnerId, currentStoreId = ref1.currentStoreId;
                    userId = currentState === null || currentState === void 0 ? void 0 : (ref = currentState.identity) === null || ref === void 0 ? void 0 : ref.id;
                    if (!userId) return [
                        2,
                        undefined
                    ];
                    newStoreIdFromSession = sessionStorage.getItem(dist_esm/* SESSION_STORAGE_KEYS.CTOR_TARGET_STORE_ID */.sO.CTOR_TARGET_STORE_ID) || undefined;
                    newBrokerIdFromSession = sessionStorage.getItem(dist_esm/* SESSION_STORAGE_KEYS.CTOR_TARGET_BROKER_ID */.sO.CTOR_TARGET_BROKER_ID) || undefined;
                    targetFromSession = !!(newStoreIdFromSession || newBrokerIdFromSession);
                    newStoreId = targetFromSession ? newStoreIdFromSession : localStorage.getItem(dist_esm/* PRL_STORE_ID */.Rj) || undefined;
                    newBrokerId = targetFromSession ? newBrokerIdFromSession : localStorage.getItem(dist_esm/* PRL_BROKER_ID */.Gz) || undefined;
                    customerRefCode = localStorage.getItem(dist_esm/* CUSTOMER_REFERRAL_CODE */.TX) || undefined;
                    campaignName = localStorage.getItem(dist_esm/* PRL_CAMPAIGN_NAME */.E4) || undefined;
                    companyGen = localStorage.getItem(dist_esm/* PRL_COMPANY_GEN */.$I) || undefined;
                    isCompanyGen = companyGen === "true" ? true : undefined;
                    sessionStorage.removeItem(dist_esm/* SESSION_STORAGE_KEYS.CTOR_TARGET_STORE_ID */.sO.CTOR_TARGET_STORE_ID);
                    sessionStorage.removeItem(dist_esm/* SESSION_STORAGE_KEYS.CTOR_TARGET_BROKER_ID */.sO.CTOR_TARGET_BROKER_ID);
                    localStorage.removeItem(dist_esm/* PRL_STORE_ID */.Rj);
                    localStorage.removeItem(dist_esm/* PRL_BROKER_ID */.Gz);
                    localStorage.removeItem(dist_esm/* CUSTOMER_REFERRAL_CODE */.TX);
                    localStorage.removeItem(dist_esm/* PRL_COMPANY_GEN */.$I);
                    localStorage.removeItem(dist_esm/* PRL_CAMPAIGN_NAME */.E4);
                    sessionStorage.removeItem(dist_esm/* SESSION_STORAGE_KEYS.CTOR_REQUESTED_STORE_ID */.sO.CTOR_REQUESTED_STORE_ID);
                    sessionStorage.removeItem(dist_esm/* SESSION_STORAGE_KEYS.CTOR_REQUESTED_BROKER_ID */.sO.CTOR_REQUESTED_BROKER_ID);
                    if (!customerRefCode) return [
                        3,
                        5
                    ];
                    tracking/* eventTracking.trackCustomerReferralEvent */.fn.trackCustomerReferralEvent(newBrokerId, customerRefCode);
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        (0,api_customer/* setAdvocate */.X7)(accessToken, customerRefCode)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    error = _state.sent();
                    dist_esm/* LalaSentry.logError */.GG.logError("Something went wrong calling setAdvocate!", {
                        error: error,
                        customerRefCode: customerRefCode
                    });
                    return [
                        3,
                        5
                    ];
                case 5:
                    _state.trys.push([
                        5,
                        9,
                        ,
                        10
                    ]);
                    if (!targetFromSession) return [
                        3,
                        6
                    ];
                    _tmp = undefined;
                    return [
                        3,
                        8
                    ];
                case 6:
                    return [
                        4,
                        getReferralOwner(customerRefCode)
                    ];
                case 7:
                    _tmp = _state.sent();
                    _state.label = 8;
                case 8:
                    referralOwnerId = _tmp;
                    return [
                        3,
                        10
                    ];
                case 9:
                    error1 = _state.sent();
                    dist_esm/* LalaSentry.logError */.GG.logError("Something went wrong calling getReferralOwner!", {
                        error: error1,
                        customerRefCode: customerRefCode
                    });
                    return [
                        3,
                        10
                    ];
                case 10:
                    return [
                        4,
                        decideOwnershipChange(accessToken, {
                            currentOwnerId: currentOwnerId,
                            currentStoreId: currentStoreId,
                            targetStoreId: newStoreId,
                            targetBrokerId: referralOwnerId || newBrokerId
                        })
                    ];
                case 11:
                    decision = _state.sent();
                    requestOwnerChange = !!decision.requestOwnerId || !!decision.requestStoreId;
                    bypassPostcode = sessionStorage.getItem("postcode_bypass_invite") === "true" || requestOwnerChange;
                    localStorage.setItem(dist_esm/* BYPASS_POSTCODE */.or, bypassPostcode ? "true" : "false");
                    if (!requestOwnerChange) {
                        dist_esm/* LalaSentry.logInfo */.GG.logInfo("No change of ownership", {
                            currentStoreId: currentStoreId,
                            currentOwnerId: currentOwnerId,
                            referralOwnerId: referralOwnerId,
                            newStoreId: newStoreId,
                            newBrokerId: newBrokerId,
                            userId: userId
                        });
                        return [
                            2,
                            undefined
                        ];
                    }
                    if (!(campaignName || isCompanyGen)) return [
                        3,
                        15
                    ];
                    _state.label = 12;
                case 12:
                    _state.trys.push([
                        12,
                        14,
                        ,
                        15
                    ]);
                    return [
                        4,
                        (0,api_customer/* updateCustomerRecord */.FG)(accessToken, userId, campaignName, isCompanyGen)
                    ];
                case 13:
                    _state.sent();
                    return [
                        3,
                        15
                    ];
                case 14:
                    error2 = _state.sent();
                    dist_esm/* LalaSentry.logError */.GG.logError("Something went wrong updating customer record with campaignName and selfGen flag!", {
                        error: error2,
                        userId: userId
                    });
                    return [
                        3,
                        15
                    ];
                case 15:
                    tracking/* eventTracking.trackPreRoutedEvent */.fn.trackPreRoutedEvent(decision.requestOwnerId, decision.requestStoreId);
                    if (decision.requestStoreId) {
                        sessionStorage.setItem(dist_esm/* SESSION_STORAGE_KEYS.CTOR_REQUESTED_STORE_ID */.sO.CTOR_REQUESTED_STORE_ID, decision.requestStoreId);
                    }
                    if (decision.requestOwnerId) {
                        sessionStorage.setItem(dist_esm/* SESSION_STORAGE_KEYS.CTOR_REQUESTED_BROKER_ID */.sO.CTOR_REQUESTED_BROKER_ID, decision.requestOwnerId);
                    }
                    if (!(!decision.promptMessage1 && !decision.promptMessage2)) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        (0,api_customer/* requestOwner */.Ir)(accessToken, userId, decision.requestOwnerId, decision.requestStoreId)
                    ];
                case 16:
                    _state.sent();
                    return [
                        2,
                        undefined
                    ];
                case 17:
                    data = JSON.stringify({
                        decision: decision,
                        next: next,
                        outOfLALA: signedInUser
                    });
                    localStorage.setItem(dist_esm/* LOCAL_STORAGE_KEYS.COTR_PROMPT_DATA */.dA.COTR_PROMPT_DATA, data);
                    return [
                        2,
                        "ownership"
                    ];
            }
        });
    });
    return _handleOwnershipChange.apply(this, arguments);
}
function getReferralOwner(customerRefCode) {
    return _getReferralOwner.apply(this, arguments);
}
function _getReferralOwner() {
    _getReferralOwner = (0,_async_to_generator/* default */.Z)(function(customerRefCode) {
        var ownerId;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!customerRefCode) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,api_customer/* resolveOwner */.H5)(customerRefCode)
                    ];
                case 1:
                    ownerId = _state.sent().ownerId;
                    return [
                        2,
                        ownerId || undefined
                    ];
                case 2:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    });
    return _getReferralOwner.apply(this, arguments);
}
function getCurrentOwnership(accessToken, signedInUser, noOwnerCacheFF) {
    return _getCurrentOwnership.apply(this, arguments);
}
function _getCurrentOwnership() {
    _getCurrentOwnership = (0,_async_to_generator/* default */.Z)(function(accessToken, signedInUser, noOwnerCacheFF) {
        var customer, ref, currentOwnerId, currentStoreId;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    dist_esm/* LalaSentry.logInfo */.GG.logInfo("getCurrentOwnership", {
                        signedInUser: signedInUser,
                        noOwnerCacheFF: noOwnerCacheFF
                    });
                    if (!(signedInUser && noOwnerCacheFF)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,api_customer/* getCustomerDetails */.TD)(accessToken)
                    ];
                case 1:
                    customer = _state.sent();
                    return [
                        2,
                        {
                            currentOwnerId: customer.ownerId,
                            currentStoreId: customer.storeId
                        }
                    ];
                case 2:
                    ref = (0,esm/* getMeFromStorage */.ON)() || {}, currentOwnerId = ref.ownerId, currentStoreId = ref.storeId;
                    return [
                        2,
                        {
                            currentOwnerId: currentOwnerId,
                            currentStoreId: currentStoreId
                        }
                    ];
            }
        });
    });
    return _getCurrentOwnership.apply(this, arguments);
}


/***/ }),

/***/ 79826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E3": function() { return /* binding */ initialState; },
/* harmony export */   "g7": function() { return /* binding */ useLALACustomerAppContext; },
/* harmony export */   "no": function() { return /* binding */ LALACustomerAppContext; },
/* harmony export */   "x1": function() { return /* binding */ LALAAuthFlow; }
/* harmony export */ });
/* unused harmony export LALACustomerAppComponentEnum */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);

var LALACustomerAppComponentEnum;
(function(LALACustomerAppComponentEnum) {
    LALACustomerAppComponentEnum[LALACustomerAppComponentEnum["LOADING"] = 0] = "LOADING";
    LALACustomerAppComponentEnum[LALACustomerAppComponentEnum["REQUEST_CODE"] = 1] = "REQUEST_CODE";
    LALACustomerAppComponentEnum[LALACustomerAppComponentEnum["VERIFY_CODE"] = 2] = "VERIFY_CODE";
    LALACustomerAppComponentEnum[LALACustomerAppComponentEnum["EXPIRED"] = 3] = "EXPIRED";
})(LALACustomerAppComponentEnum || (LALACustomerAppComponentEnum = {}));
var LALAAuthFlow;
(function(LALAAuthFlow) {
    LALAAuthFlow[LALAAuthFlow["SSI"] = 0] = "SSI";
    LALAAuthFlow[LALAAuthFlow["Passwordless"] = 1] = "Passwordless";
})(LALAAuthFlow || (LALAAuthFlow = {}));
var initialState = {
    leadId: "",
    phoneNumber: "",
    email: "",
    firstName: undefined,
    existingCustomer: false,
    sendingCode: false,
    loading: false,
    error: undefined,
    codeSent: false
};
var LALACustomerAppContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(undefined);
var useLALACustomerAppContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LALACustomerAppContext);
    if (!context) {
        throw new Error("LALACustomerAppContext must be used inside the LALACustomerApp");
    }
    return context;
};


/***/ }),

/***/ 29470:
/***/ (function(module) {

"use strict";

module.exports = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _onlyFirst = ref.onlyFirst, onlyFirst = _onlyFirst === void 0 ? false : _onlyFirst;
    var pattern = [
        "[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)",
        "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"
    ].join("|");
    return new RegExp(pattern, onlyFirst ? undefined : "g");
};


/***/ }),

/***/ 63269:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 92861:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 22512:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){var e={477:function(e){"use strict";e.exports=__webpack_require__(67526)}};var t={};function __nccwpck_require__(o){var a=t[o];if(a!==undefined){return a.exports}var s=t[o]={exports:{}};var n=true;try{e[o](s,s.exports,__nccwpck_require__);n=false}finally{if(n)delete t[o]}return s.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var o={};!function(){var e=o;var t,a=(t=__nccwpck_require__(477))&&"object"==typeof t&&"default"in t?t.default:t,s=/https?|ftp|gopher|file/;function r(e){"string"==typeof e&&(e=d(e));var t=function(e,t,o){var a=e.auth,s=e.hostname,n=e.protocol||"",p=e.pathname||"",c=e.hash||"",i=e.query||"",u=!1;a=a?encodeURIComponent(a).replace(/%3A/i,":")+"@":"",e.host?u=a+e.host:s&&(u=a+(~s.indexOf(":")?"["+s+"]":s),e.port&&(u+=":"+e.port)),i&&"object"==typeof i&&(i=t.encode(i));var f=e.search||i&&"?"+i||"";return n&&":"!==n.substr(-1)&&(n+=":"),e.slashes||(!n||o.test(n))&&!1!==u?(u="//"+(u||""),p&&"/"!==p[0]&&(p="/"+p)):u||(u=""),c&&"#"!==c[0]&&(c="#"+c),f&&"?"!==f[0]&&(f="?"+f),{protocol:n,host:u,pathname:p=p.replace(/[?#]/g,encodeURIComponent),search:f=f.replace("#","%23"),hash:c}}(e,a,s);return""+t.protocol+t.host+t.pathname+t.search+t.hash}var n="http://",p="w.w",c=n+p,i=/^([a-z0-9.+-]*:\/\/\/)([a-z0-9.+-]:\/*)?/i,u=/https?|ftp|gopher|file/;function h(e,t){var o="string"==typeof e?d(e):e;e="object"==typeof e?r(e):e;var a=d(t),s="";o.protocol&&!o.slashes&&(s=o.protocol,e=e.replace(o.protocol,""),s+="/"===t[0]||"/"===e[0]?"/":""),s&&a.protocol&&(s="",a.slashes||(s=a.protocol,t=t.replace(a.protocol,"")));var p=e.match(i);p&&!a.protocol&&(e=e.substr((s=p[1]+(p[2]||"")).length),/^\/\/[^/]/.test(t)&&(s=s.slice(0,-1)));var f=new URL(e,c+"/"),m=new URL(t,f).toString().replace(c,""),v=a.protocol||o.protocol;return v+=o.slashes||a.slashes?"//":"",!s&&v?m=m.replace(n,v):s&&(m=m.replace(n,"")),u.test(m)||~t.indexOf(".")||"/"===e.slice(-1)||"/"===t.slice(-1)||"/"!==m.slice(-1)||(m=m.slice(0,-1)),s&&(m=s+("/"===m[0]?m.substr(1):m)),m}function l(){}l.prototype.parse=d,l.prototype.format=r,l.prototype.resolve=h,l.prototype.resolveObject=h;var f=/^https?|ftp|gopher|file/,m=/^(.*?)([#?].*)/,v=/^([a-z0-9.+-]*:)(\/{0,3})(.*)/i,_=/^([a-z0-9.+-]*:)?\/\/\/*/i,b=/^([a-z0-9.+-]*:)(\/{0,2})\[(.*)\]$/i;function d(e,t,o){if(void 0===t&&(t=!1),void 0===o&&(o=!1),e&&"object"==typeof e&&e instanceof l)return e;var s=(e=e.trim()).match(m);e=s?s[1].replace(/\\/g,"/")+s[2]:e.replace(/\\/g,"/"),b.test(e)&&"/"!==e.slice(-1)&&(e+="/");var n=!/(^javascript)/.test(e)&&e.match(v),i=_.test(e),u="";n&&(f.test(n[1])||(u=n[1].toLowerCase(),e=""+n[2]+n[3]),n[2]||(i=!1,f.test(n[1])?(u=n[1],e=""+n[3]):e="//"+n[3]),3!==n[2].length&&1!==n[2].length||(u=n[1],e="/"+n[3]));var g,y=(s?s[1]:e).match(/^https?:\/\/[^/]+(:[0-9]+)(?=\/|$)/),w=y&&y[1],C=new l,U="",j="";try{g=new URL(e)}catch(t){U=t,u||o||!/^\/\//.test(e)||/^\/\/.+[@.]/.test(e)||(j="/",e=e.substr(1));try{g=new URL(e,c)}catch(e){return C.protocol=u,C.href=u,C}}C.slashes=i&&!j,C.host=g.host===p?"":g.host,C.hostname=g.hostname===p?"":g.hostname.replace(/(\[|\])/g,""),C.protocol=U?u||null:g.protocol,C.search=g.search.replace(/\\/g,"%5C"),C.hash=g.hash.replace(/\\/g,"%5C");var x=e.split("#");!C.search&&~x[0].indexOf("?")&&(C.search="?"),C.hash||""!==x[1]||(C.hash="#"),C.query=t?a.decode(g.search.substr(1)):C.search.substr(1),C.pathname=j+(n?function(e){return e.replace(/['^|`]/g,(function(e){return"%"+e.charCodeAt().toString(16).toUpperCase()})).replace(/((?:%[0-9A-F]{2})+)/g,(function(e,t){try{return decodeURIComponent(t).split("").map((function(e){var t=e.charCodeAt();return t>256||/^[a-z0-9]$/i.test(e)?e:"%"+t.toString(16).toUpperCase()})).join("")}catch(e){return t}}))}(g.pathname):g.pathname),"about:"===C.protocol&&"blank"===C.pathname&&(C.protocol="",C.pathname=""),U&&"/"!==e[0]&&(C.pathname=C.pathname.substr(1)),u&&!f.test(u)&&"/"!==e.slice(-1)&&"/"===C.pathname&&(C.pathname=""),C.path=C.pathname+C.search,C.auth=[g.username,g.password].map(decodeURIComponent).filter(Boolean).join(":"),C.port=g.port,w&&!C.host.endsWith(w)&&(C.host+=w,C.port=w.slice(1)),C.href=j?""+C.pathname+C.search+C.hash:r(C);var q=/^(file)/.test(C.href)?["host","hostname"]:[];return Object.keys(C).forEach((function(e){~q.indexOf(e)||(C[e]=C[e]||null)})),C}e.parse=d,e.format=r,e.resolve=h,e.resolveObject=function(e,t){return d(h(e,t))},e.Url=l}();module.exports=o})();

/***/ }),

/***/ 35837:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(9839)


/***/ }),

/***/ 75188:
/***/ (function(module) {


var identity = function(_){ return _; };


/**
 * Module exports, export
 */

module.exports = multiple(find);
module.exports.find = module.exports;


/**
 * Export the replacement function, return the modified object
 */

module.exports.replace = function (obj, key, val, options) {
  multiple(replace).call(this, obj, key, val, options);
  return obj;
};


/**
 * Export the delete function, return the modified object
 */

module.exports.del = function (obj, key, options) {
  multiple(del).call(this, obj, key, null, options);
  return obj;
};


/**
 * Compose applying the function to a nested key
 */

function multiple (fn) {
  return function (obj, path, val, options) {
    var normalize = options && isFunction(options.normalizer) ? options.normalizer : defaultNormalize;
    path = normalize(path);

    var key;
    var finished = false;

    while (!finished) loop();

    function loop() {
      for (key in obj) {
        var normalizedKey = normalize(key);
        if (0 === path.indexOf(normalizedKey)) {
          var temp = path.substr(normalizedKey.length);
          if (temp.charAt(0) === '.' || temp.length === 0) {
            path = temp.substr(1);
            var child = obj[key];

            // we're at the end and there is nothing.
            if (null == child) {
              finished = true;
              return;
            }

            // we're at the end and there is something.
            if (!path.length) {
              finished = true;
              return;
            }

            // step into child
            obj = child;

            // but we're done here
            return;
          }
        }
      }

      key = undefined;
      // if we found no matching properties
      // on the current object, there's no match.
      finished = true;
    }

    if (!key) return;
    if (null == obj) return obj;

    // the `obj` and `key` is one above the leaf object and key, so
    // start object: { a: { 'b.c': 10 } }
    // end object: { 'b.c': 10 }
    // end key: 'b.c'
    // this way, you can do `obj[key]` and get `10`.
    return fn(obj, key, val);
  };
}


/**
 * Find an object by its key
 *
 * find({ first_name : 'Calvin' }, 'firstName')
 */

function find (obj, key) {
  if (obj.hasOwnProperty(key)) return obj[key];
}


/**
 * Delete a value for a given key
 *
 * del({ a : 'b', x : 'y' }, 'X' }) -> { a : 'b' }
 */

function del (obj, key) {
  if (obj.hasOwnProperty(key)) delete obj[key];
  return obj;
}


/**
 * Replace an objects existing value with a new one
 *
 * replace({ a : 'b' }, 'a', 'c') -> { a : 'c' }
 */

function replace (obj, key, val) {
  if (obj.hasOwnProperty(key)) obj[key] = val;
  return obj;
}

/**
 * Normalize a `dot.separated.path`.
 *
 * A.HELL(!*&#(!)O_WOR   LD.bar => ahelloworldbar
 *
 * @param {String} path
 * @return {String}
 */

function defaultNormalize(path) {
  return path.replace(/[^a-zA-Z0-9\.]+/g, '').toLowerCase();
}

/**
 * Check if a value is a function.
 *
 * @param {*} val
 * @return {boolean} Returns `true` if `val` is a function, otherwise `false`.
 */

function isFunction(val) {
  return typeof val === 'function';
}


/***/ }),

/***/ 13970:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(45503);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (obj === __webpack_require__.g) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 38502:
/***/ (function(module) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),

/***/ 10884:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(26506);
var callBind = __webpack_require__(73235);

var implementation = __webpack_require__(38502);
var getPolyfill = __webpack_require__(35453);
var shim = __webpack_require__(59789);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),

/***/ 35453:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(38502);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),

/***/ 59789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(35453);
var define = __webpack_require__(26506);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),

/***/ 69113:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(38441); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),

/***/ 13438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(38441);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(69113);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),

/***/ 38441:
/***/ (function(module) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),

/***/ 13158:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 459:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(15704);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 60216:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(459)();
}


/***/ }),

/***/ 15704:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 52490:
/***/ (function(module) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 33348:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(97530);
var parse = __webpack_require__(18429);
var formats = __webpack_require__(52490);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 18429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(33422);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 97530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(62538);
var utils = __webpack_require__(33422);
var formats = __webpack_require__(52490);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 33422:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(52490);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 93456:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 14514:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).filter(Boolean).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 67526:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(93456);
exports.encode = exports.stringify = __webpack_require__(14514);


/***/ }),

/***/ 43064:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);
/** @license React v16.14.0
 * react-dom-test-utils.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var g=__webpack_require__(81412),k=__webpack_require__(32735),m=__webpack_require__(88872),n=__webpack_require__(89489);function p(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var q=k.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
q.hasOwnProperty("ReactCurrentDispatcher")||(q.ReactCurrentDispatcher={current:null});q.hasOwnProperty("ReactCurrentBatchConfig")||(q.ReactCurrentBatchConfig={suspense:null});function r(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function t(a){if(r(a)!==a)throw Error(p(188));}
function u(a){var b=a.alternate;if(!b){b=r(a);if(null===b)throw Error(p(188));return b!==a?null:a}for(var c=a,e=b;;){var d=c.return;if(null===d)break;var f=d.alternate;if(null===f){e=d.return;if(null!==e){c=e;continue}break}if(d.child===f.child){for(f=d.child;f;){if(f===c)return t(d),a;if(f===e)return t(d),b;f=f.sibling}throw Error(p(188));}if(c.return!==e.return)c=d,e=f;else{for(var h=!1,l=d.child;l;){if(l===c){h=!0;c=d;e=f;break}if(l===e){h=!0;e=d;c=f;break}l=l.sibling}if(!h){for(l=f.child;l;){if(l===
c){h=!0;c=f;e=d;break}if(l===e){h=!0;e=f;c=d;break}l=l.sibling}if(!h)throw Error(p(189));}}if(c.alternate!==e)throw Error(p(190));}if(3!==c.tag)throw Error(p(188));return c.stateNode.current===c?a:b}function v(){return!0}function w(){return!1}
function x(a,b,c,e){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var d in a)a.hasOwnProperty(d)&&((b=a[d])?this[d]=b(c):"target"===d?this.target=e:this[d]=c[d]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v:w;this.isPropagationStopped=w;return this}
g(x.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v)},persist:function(){this.isPersistent=v},isPersistent:w,destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=
null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=w;this._dispatchInstances=this._dispatchListeners=null}});x.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
x.extend=function(a){function b(){}function c(){return e.apply(this,arguments)}var e=this;b.prototype=e.prototype;var d=new b;g(d,c.prototype);c.prototype=d;c.prototype.constructor=c;c.Interface=g({},e.Interface,a);c.extend=e.extend;y(c);return c};y(x);function z(a,b,c,e){if(this.eventPool.length){var d=this.eventPool.pop();this.call(d,a,b,c,e);return d}return new this(a,b,c,e)}
function A(a){if(!(a instanceof this))throw Error(p(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function y(a){a.eventPool=[];a.getPooled=z;a.release=A}var B=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement);function C(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}
var D={animationend:C("Animation","AnimationEnd"),animationiteration:C("Animation","AnimationIteration"),animationstart:C("Animation","AnimationStart"),transitionend:C("Transition","TransitionEnd")},E={},F={};B&&(F=document.createElement("div").style,"AnimationEvent"in window||(delete D.animationend.animation,delete D.animationiteration.animation,delete D.animationstart.animation),"TransitionEvent"in window||delete D.transitionend.transition);
function G(a){if(E[a])return E[a];if(!D[a])return a;var b=D[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in F)return E[a]=b[c];return a}var H=G("animationend"),I=G("animationiteration"),J=G("animationstart"),aa=G("transitionend"),K=null;function ba(a){if(null===K)try{var b=("require"+Math.random()).slice(0,7);K=(module&&module[b])("timers").setImmediate}catch(c){K=function(a){var b=new MessageChannel;b.port1.onmessage=a;b.port2.postMessage(void 0)}}return K(a)}
var L=m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events,ca=L[11],M=L[12],da=m.unstable_batchedUpdates,N=q.IsSomeRendererActing,O="function"===typeof n.unstable_flushAllWithoutAsserting,P=n.unstable_flushAllWithoutAsserting||function(){for(var a=!1;ca();)a=!0;return a};function Q(a){try{P(),ba(function(){P()?Q(a):a()})}catch(b){a(b)}}var R=0,S=!1,ea=m.findDOMNode,T=m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events,fa=T[0],U=T[4],ha=T[5],ia=T[6],ja=T[7],ka=T[8],V=T[9],la=T[10];
function W(){}function ma(a,b){if(!a)return[];a=u(a);if(!a)return[];for(var c=a,e=[];;){if(5===c.tag||6===c.tag||1===c.tag||0===c.tag){var d=c.stateNode;b(d)&&e.push(d)}if(c.child)c.child.return=c,c=c.child;else{if(c===a)return e;for(;!c.sibling;){if(!c.return||c.return===a)return e;c=c.return}c.sibling.return=c.return;c=c.sibling}}}
function X(a,b){if(a&&!a._reactInternalFiber){var c=""+a;a=Array.isArray(a)?"an array":a&&1===a.nodeType&&a.tagName?"a DOM node":"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c;throw Error(p(286,b,a));}}
var Y={renderIntoDocument:function(a){var b=document.createElement("div");return m.render(a,b)},isElement:function(a){return k.isValidElement(a)},isElementOfType:function(a,b){return k.isValidElement(a)&&a.type===b},isDOMComponent:function(a){return!(!a||1!==a.nodeType||!a.tagName)},isDOMComponentElement:function(a){return!!(a&&k.isValidElement(a)&&a.tagName)},isCompositeComponent:function(a){return Y.isDOMComponent(a)?!1:null!=a&&"function"===typeof a.render&&"function"===typeof a.setState},isCompositeComponentWithType:function(a,
b){return Y.isCompositeComponent(a)?a._reactInternalFiber.type===b:!1},findAllInRenderedTree:function(a,b){X(a,"findAllInRenderedTree");return a?ma(a._reactInternalFiber,b):[]},scryRenderedDOMComponentsWithClass:function(a,b){X(a,"scryRenderedDOMComponentsWithClass");return Y.findAllInRenderedTree(a,function(a){if(Y.isDOMComponent(a)){var c=a.className;"string"!==typeof c&&(c=a.getAttribute("class")||"");var d=c.split(/\s+/);if(!Array.isArray(b)){if(void 0===b)throw Error(p(11));b=b.split(/\s+/)}return b.every(function(a){return-1!==
d.indexOf(a)})}return!1})},findRenderedDOMComponentWithClass:function(a,b){X(a,"findRenderedDOMComponentWithClass");a=Y.scryRenderedDOMComponentsWithClass(a,b);if(1!==a.length)throw Error("Did not find exactly one match (found: "+a.length+") for class:"+b);return a[0]},scryRenderedDOMComponentsWithTag:function(a,b){X(a,"scryRenderedDOMComponentsWithTag");return Y.findAllInRenderedTree(a,function(a){return Y.isDOMComponent(a)&&a.tagName.toUpperCase()===b.toUpperCase()})},findRenderedDOMComponentWithTag:function(a,
b){X(a,"findRenderedDOMComponentWithTag");a=Y.scryRenderedDOMComponentsWithTag(a,b);if(1!==a.length)throw Error("Did not find exactly one match (found: "+a.length+") for tag:"+b);return a[0]},scryRenderedComponentsWithType:function(a,b){X(a,"scryRenderedComponentsWithType");return Y.findAllInRenderedTree(a,function(a){return Y.isCompositeComponentWithType(a,b)})},findRenderedComponentWithType:function(a,b){X(a,"findRenderedComponentWithType");a=Y.scryRenderedComponentsWithType(a,b);if(1!==a.length)throw Error("Did not find exactly one match (found: "+
a.length+") for componentType:"+b);return a[0]},mockComponent:function(a,b){b=b||a.mockTagName||"div";a.prototype.render.mockImplementation(function(){return k.createElement(b,null,this.props.children)});return this},nativeTouchData:function(a,b){return{touches:[{pageX:a,pageY:b}]}},Simulate:null,SimulateNative:{},act:function(a){function b(){R--;N.current=c;M.current=e}!1===S&&(S=!0,console.error("act(...) is not supported in production builds of React, and might not behave as expected."));R++;var c=
N.current;var e=M.current;N.current=!0;M.current=!0;try{var d=da(a)}catch(f){throw b(),f;}if(null!==d&&"object"===typeof d&&"function"===typeof d.then)return{then:function(a,e){d.then(function(){1<R||!0===O&&!0===c?(b(),a()):Q(function(c){b();c?e(c):a()})},function(a){b();e(a)})}};try{1!==R||!1!==O&&!1!==c||P(),b()}catch(f){throw b(),f;}return{then:function(a){a()}}}};
function na(a){return function(b,c){if(k.isValidElement(b))throw Error(p(228));if(Y.isCompositeComponent(b))throw Error(p(229));var e=U[a],d=new W;d.target=b;d.type=a.toLowerCase();var f=fa(b),h=new x(e,f,d,b);h.persist();g(h,c);e.phasedRegistrationNames?ha(h):ia(h);m.unstable_batchedUpdates(function(){ja(b);la(h)});ka()}}Y.Simulate={};for(var Z in U)Y.Simulate[Z]=na(Z);
function oa(a,b){return function(c,e){var d=new W(a);g(d,e);Y.isDOMComponent(c)?(c=ea(c),d.target=c,V(b,1,document,d)):c.tagName&&(d.target=c,V(b,1,document,d))}}
[["abort","abort"],[H,"animationEnd"],[I,"animationIteration"],[J,"animationStart"],["blur","blur"],["canplaythrough","canPlayThrough"],["canplay","canPlay"],["cancel","cancel"],["change","change"],["click","click"],["close","close"],["compositionend","compositionEnd"],["compositionstart","compositionStart"],["compositionupdate","compositionUpdate"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragenter","dragEnter"],["dragexit","dragExit"],
["dragleave","dragLeave"],["dragover","dragOver"],["dragstart","dragStart"],["drag","drag"],["drop","drop"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],["ended","ended"],["error","error"],["focus","focus"],["input","input"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["loadstart","loadStart"],["loadstart","loadStart"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["mousedown","mouseDown"],["mousemove","mouseMove"],
["mouseout","mouseOut"],["mouseover","mouseOver"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["playing","playing"],["progress","progress"],["ratechange","rateChange"],["scroll","scroll"],["seeked","seeked"],["seeking","seeking"],["selectionchange","selectionChange"],["stalled","stalled"],["suspend","suspend"],["textInput","textInput"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchmove","touchMove"],["touchstart",
"touchStart"],[aa,"transitionEnd"],["volumechange","volumeChange"],["waiting","waiting"],["wheel","wheel"]].forEach(function(a){var b=a[1];Y.SimulateNative[b]=oa(b,a[0])});module.exports=Y.default||Y;


/***/ }),

/***/ 73717:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),

/***/ 89489:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(73717);
} else {}


/***/ }),

/***/ 30740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(43064);
} else {}


/***/ }),

/***/ 44782:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var isPlainObject = __webpack_require__(13382);
var React = __webpack_require__(32735);
var prettyPrintObject = __webpack_require__(58521);
var reactIs = __webpack_require__(72594);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var spacer = (function (times, tabStop) {
  if (times === 0) {
    return '';
  }

  return new Array(times * tabStop).fill(' ').join('');
});

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function safeSortObject(value, seen) {
  // return non-object value as is
  if (value === null || _typeof(value) !== 'object') {
    return value;
  } // return date, regexp and react element values as is


  if (value instanceof Date || value instanceof RegExp || /*#__PURE__*/React__namespace.isValidElement(value)) {
    return value;
  }

  seen.add(value); // make a copy of array with each item passed through the sorting algorithm

  if (Array.isArray(value)) {
    return value.map(function (v) {
      return safeSortObject(v, seen);
    });
  } // make a copy of object with key sorted


  return Object.keys(value).sort().reduce(function (result, key) {
    if (key === '_owner') {
      return result;
    }

    if (key === 'current' || seen.has(value[key])) {
      // eslint-disable-next-line no-param-reassign
      result[key] = '[Circular]';
    } else {
      // eslint-disable-next-line no-param-reassign
      result[key] = safeSortObject(value[key], seen);
    }

    return result;
  }, {});
}

function sortObject(value) {
  return safeSortObject(value, new WeakSet());
}

/* eslint-disable no-use-before-define */
var createStringTreeNode = function createStringTreeNode(value) {
  return {
    type: 'string',
    value: value
  };
};
var createNumberTreeNode = function createNumberTreeNode(value) {
  return {
    type: 'number',
    value: value
  };
};
var createReactElementTreeNode = function createReactElementTreeNode(displayName, props, defaultProps, childrens) {
  return {
    type: 'ReactElement',
    displayName: displayName,
    props: props,
    defaultProps: defaultProps,
    childrens: childrens
  };
};
var createReactFragmentTreeNode = function createReactFragmentTreeNode(key, childrens) {
  return {
    type: 'ReactFragment',
    key: key,
    childrens: childrens
  };
};

var supportFragment = Boolean(React.Fragment);

var getFunctionTypeName = function getFunctionTypeName(functionType) {
  if (!functionType.name || functionType.name === '_default') {
    return 'No Display Name';
  }

  return functionType.name;
};

var getWrappedComponentDisplayName = function getWrappedComponentDisplayName(Component) {
  switch (true) {
    case Boolean(Component.displayName):
      return Component.displayName;

    case Component.$$typeof === reactIs.Memo:
      return getWrappedComponentDisplayName(Component.type);

    case Component.$$typeof === reactIs.ForwardRef:
      return getWrappedComponentDisplayName(Component.render);

    default:
      return getFunctionTypeName(Component);
  }
}; // heavily inspired by:
// https://github.com/facebook/react/blob/3746eaf985dd92f8aa5f5658941d07b6b855e9d9/packages/react-devtools-shared/src/backend/renderer.js#L399-L496


var getReactElementDisplayName = function getReactElementDisplayName(element) {
  switch (true) {
    case typeof element.type === 'string':
      return element.type;

    case typeof element.type === 'function':
      if (element.type.displayName) {
        return element.type.displayName;
      }

      return getFunctionTypeName(element.type);

    case reactIs.isForwardRef(element):
    case reactIs.isMemo(element):
      return getWrappedComponentDisplayName(element.type);

    case reactIs.isContextConsumer(element):
      return "".concat(element.type._context.displayName || 'Context', ".Consumer");

    case reactIs.isContextProvider(element):
      return "".concat(element.type._context.displayName || 'Context', ".Provider");

    case reactIs.isLazy(element):
      return 'Lazy';

    case reactIs.isProfiler(element):
      return 'Profiler';

    case reactIs.isStrictMode(element):
      return 'StrictMode';

    case reactIs.isSuspense(element):
      return 'Suspense';

    default:
      return 'UnknownElementType';
  }
};

var noChildren = function noChildren(propsValue, propName) {
  return propName !== 'children';
};

var onlyMeaningfulChildren = function onlyMeaningfulChildren(children) {
  return children !== true && children !== false && children !== null && children !== '';
};

var filterProps = function filterProps(originalProps, cb) {
  var filteredProps = {};
  Object.keys(originalProps).filter(function (key) {
    return cb(originalProps[key], key);
  }).forEach(function (key) {
    return filteredProps[key] = originalProps[key];
  });
  return filteredProps;
};

var parseReactElement = function parseReactElement(element, options) {
  var _options$displayName = options.displayName,
      displayNameFn = _options$displayName === void 0 ? getReactElementDisplayName : _options$displayName;

  if (typeof element === 'string') {
    return createStringTreeNode(element);
  } else if (typeof element === 'number') {
    return createNumberTreeNode(element);
  } else if (! /*#__PURE__*/React__default["default"].isValidElement(element)) {
    throw new Error("react-element-to-jsx-string: Expected a React.Element, got `".concat(_typeof(element), "`"));
  }

  var displayName = displayNameFn(element);
  var props = filterProps(element.props, noChildren);

  if (element.ref !== null) {
    props.ref = element.ref;
  }

  var key = element.key;

  if (typeof key === 'string' && key.search(/^\./)) {
    // React automatically add key=".X" when there are some children
    props.key = key;
  }

  var defaultProps = filterProps(element.type.defaultProps || {}, noChildren);
  var childrens = React__default["default"].Children.toArray(element.props.children).filter(onlyMeaningfulChildren).map(function (child) {
    return parseReactElement(child, options);
  });

  if (supportFragment && element.type === React.Fragment) {
    return createReactFragmentTreeNode(key, childrens);
  }

  return createReactElementTreeNode(displayName, props, defaultProps, childrens);
};

function noRefCheck() {}

var inlineFunction = function inlineFunction(fn) {
  return fn.toString().split('\n').map(function (line) {
    return line.trim();
  }).join('');
};
var preserveFunctionLineBreak = function preserveFunctionLineBreak(fn) {
  return fn.toString();
};
var defaultFunctionValue = inlineFunction;
var formatFunction = (function (fn, options) {
  var _options$functionValu = options.functionValue,
      functionValue = _options$functionValu === void 0 ? defaultFunctionValue : _options$functionValu,
      showFunctions = options.showFunctions;

  if (!showFunctions && functionValue === defaultFunctionValue) {
    return functionValue(noRefCheck);
  }

  return functionValue(fn);
});

var formatComplexDataStructure = (function (value, inline, lvl, options) {
  var normalizedValue = sortObject(value);
  var stringifiedValue = prettyPrintObject.prettyPrint(normalizedValue, {
    transform: function transform(currentObj, prop, originalResult) {
      var currentValue = currentObj[prop];

      if (currentValue && /*#__PURE__*/React.isValidElement(currentValue)) {
        return formatTreeNode(parseReactElement(currentValue, options), true, lvl, options);
      }

      if (typeof currentValue === 'function') {
        return formatFunction(currentValue, options);
      }

      return originalResult;
    }
  });

  if (inline) {
    return stringifiedValue.replace(/\s+/g, ' ').replace(/{ /g, '{').replace(/ }/g, '}').replace(/\[ /g, '[').replace(/ ]/g, ']');
  } // Replace tabs with spaces, and add necessary indentation in front of each new line


  return stringifiedValue.replace(/\t/g, spacer(1, options.tabStop)).replace(/\n([^$])/g, "\n".concat(spacer(lvl + 1, options.tabStop), "$1"));
});

var escape$1 = function escape(s) {
  return s.replace(/"/g, '&quot;');
};

var formatPropValue = function formatPropValue(propValue, inline, lvl, options) {
  if (typeof propValue === 'number') {
    return "{".concat(String(propValue), "}");
  }

  if (typeof propValue === 'string') {
    return "\"".concat(escape$1(propValue), "\"");
  } // > "Symbols (new in ECMAScript 2015, not yet supported in Flow)"
  // @see: https://flow.org/en/docs/types/primitives/
  // $FlowFixMe: Flow does not support Symbol


  if (_typeof(propValue) === 'symbol') {
    var symbolDescription = propValue.valueOf().toString().replace(/Symbol\((.*)\)/, '$1');

    if (!symbolDescription) {
      return "{Symbol()}";
    }

    return "{Symbol('".concat(symbolDescription, "')}");
  }

  if (typeof propValue === 'function') {
    return "{".concat(formatFunction(propValue, options), "}");
  }

  if ( /*#__PURE__*/React.isValidElement(propValue)) {
    return "{".concat(formatTreeNode(parseReactElement(propValue, options), true, lvl, options), "}");
  }

  if (propValue instanceof Date) {
    if (isNaN(propValue.valueOf())) {
      return "{new Date(NaN)}";
    }

    return "{new Date(\"".concat(propValue.toISOString(), "\")}");
  }

  if (isPlainObject.isPlainObject(propValue) || Array.isArray(propValue)) {
    return "{".concat(formatComplexDataStructure(propValue, inline, lvl, options), "}");
  }

  return "{".concat(String(propValue), "}");
};

var formatProp = (function (name, hasValue, value, hasDefaultValue, defaultValue, inline, lvl, options) {
  if (!hasValue && !hasDefaultValue) {
    throw new Error("The prop \"".concat(name, "\" has no value and no default: could not be formatted"));
  }

  var usedValue = hasValue ? value : defaultValue;
  var useBooleanShorthandSyntax = options.useBooleanShorthandSyntax,
      tabStop = options.tabStop;
  var formattedPropValue = formatPropValue(usedValue, inline, lvl, options);
  var attributeFormattedInline = ' ';
  var attributeFormattedMultiline = "\n".concat(spacer(lvl + 1, tabStop));
  var isMultilineAttribute = formattedPropValue.includes('\n');

  if (useBooleanShorthandSyntax && formattedPropValue === '{false}' && !hasDefaultValue) {
    // If a boolean is false and not different from it's default, we do not render the attribute
    attributeFormattedInline = '';
    attributeFormattedMultiline = '';
  } else if (useBooleanShorthandSyntax && formattedPropValue === '{true}') {
    attributeFormattedInline += "".concat(name);
    attributeFormattedMultiline += "".concat(name);
  } else {
    attributeFormattedInline += "".concat(name, "=").concat(formattedPropValue);
    attributeFormattedMultiline += "".concat(name, "=").concat(formattedPropValue);
  }

  return {
    attributeFormattedInline: attributeFormattedInline,
    attributeFormattedMultiline: attributeFormattedMultiline,
    isMultilineAttribute: isMultilineAttribute
  };
});

var mergeSiblingPlainStringChildrenReducer = (function (previousNodes, currentNode) {
  var nodes = previousNodes.slice(0, previousNodes.length > 0 ? previousNodes.length - 1 : 0);
  var previousNode = previousNodes[previousNodes.length - 1];

  if (previousNode && (currentNode.type === 'string' || currentNode.type === 'number') && (previousNode.type === 'string' || previousNode.type === 'number')) {
    nodes.push(createStringTreeNode(String(previousNode.value) + String(currentNode.value)));
  } else {
    if (previousNode) {
      nodes.push(previousNode);
    }

    nodes.push(currentNode);
  }

  return nodes;
});

var isKeyOrRefProps = function isKeyOrRefProps(propName) {
  return ['key', 'ref'].includes(propName);
};

var sortPropsByNames = (function (shouldSortUserProps) {
  return function (props) {
    var haveKeyProp = props.includes('key');
    var haveRefProp = props.includes('ref');
    var userPropsOnly = props.filter(function (oneProp) {
      return !isKeyOrRefProps(oneProp);
    });
    var sortedProps = shouldSortUserProps ? _toConsumableArray(userPropsOnly.sort()) // We use basic lexical order
    : _toConsumableArray(userPropsOnly);

    if (haveRefProp) {
      sortedProps.unshift('ref');
    }

    if (haveKeyProp) {
      sortedProps.unshift('key');
    }

    return sortedProps;
  };
});

function createPropFilter(props, filter) {
  if (Array.isArray(filter)) {
    return function (key) {
      return filter.indexOf(key) === -1;
    };
  } else {
    return function (key) {
      return filter(props[key], key);
    };
  }
}

var compensateMultilineStringElementIndentation = function compensateMultilineStringElementIndentation(element, formattedElement, inline, lvl, options) {
  var tabStop = options.tabStop;

  if (element.type === 'string') {
    return formattedElement.split('\n').map(function (line, offset) {
      if (offset === 0) {
        return line;
      }

      return "".concat(spacer(lvl, tabStop)).concat(line);
    }).join('\n');
  }

  return formattedElement;
};

var formatOneChildren = function formatOneChildren(inline, lvl, options) {
  return function (element) {
    return compensateMultilineStringElementIndentation(element, formatTreeNode(element, inline, lvl, options), inline, lvl, options);
  };
};

var onlyPropsWithOriginalValue = function onlyPropsWithOriginalValue(defaultProps, props) {
  return function (propName) {
    var haveDefaultValue = Object.keys(defaultProps).includes(propName);
    return !haveDefaultValue || haveDefaultValue && defaultProps[propName] !== props[propName];
  };
};

var isInlineAttributeTooLong = function isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) {
  if (!maxInlineAttributesLineLength) {
    return attributes.length > 1;
  }

  return spacer(lvl, tabStop).length + inlineAttributeString.length > maxInlineAttributesLineLength;
};

var shouldRenderMultilineAttr = function shouldRenderMultilineAttr(attributes, inlineAttributeString, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength) {
  return (isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) || containsMultilineAttr) && !inline;
};

var formatReactElementNode = (function (node, inline, lvl, options) {
  var type = node.type,
      _node$displayName = node.displayName,
      displayName = _node$displayName === void 0 ? '' : _node$displayName,
      childrens = node.childrens,
      _node$props = node.props,
      props = _node$props === void 0 ? {} : _node$props,
      _node$defaultProps = node.defaultProps,
      defaultProps = _node$defaultProps === void 0 ? {} : _node$defaultProps;

  if (type !== 'ReactElement') {
    throw new Error("The \"formatReactElementNode\" function could only format node of type \"ReactElement\". Given:  ".concat(type));
  }

  var filterProps = options.filterProps,
      maxInlineAttributesLineLength = options.maxInlineAttributesLineLength,
      showDefaultProps = options.showDefaultProps,
      sortProps = options.sortProps,
      tabStop = options.tabStop;
  var out = "<".concat(displayName);
  var outInlineAttr = out;
  var outMultilineAttr = out;
  var containsMultilineAttr = false;
  var visibleAttributeNames = [];
  var propFilter = createPropFilter(props, filterProps);
  Object.keys(props).filter(propFilter).filter(onlyPropsWithOriginalValue(defaultProps, props)).forEach(function (propName) {
    return visibleAttributeNames.push(propName);
  });
  Object.keys(defaultProps).filter(propFilter).filter(function () {
    return showDefaultProps;
  }).filter(function (defaultPropName) {
    return !visibleAttributeNames.includes(defaultPropName);
  }).forEach(function (defaultPropName) {
    return visibleAttributeNames.push(defaultPropName);
  });
  var attributes = sortPropsByNames(sortProps)(visibleAttributeNames);
  attributes.forEach(function (attributeName) {
    var _formatProp = formatProp(attributeName, Object.keys(props).includes(attributeName), props[attributeName], Object.keys(defaultProps).includes(attributeName), defaultProps[attributeName], inline, lvl, options),
        attributeFormattedInline = _formatProp.attributeFormattedInline,
        attributeFormattedMultiline = _formatProp.attributeFormattedMultiline,
        isMultilineAttribute = _formatProp.isMultilineAttribute;

    if (isMultilineAttribute) {
      containsMultilineAttr = true;
    }

    outInlineAttr += attributeFormattedInline;
    outMultilineAttr += attributeFormattedMultiline;
  });
  outMultilineAttr += "\n".concat(spacer(lvl, tabStop));

  if (shouldRenderMultilineAttr(attributes, outInlineAttr, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength)) {
    out = outMultilineAttr;
  } else {
    out = outInlineAttr;
  }

  if (childrens && childrens.length > 0) {
    var newLvl = lvl + 1;
    out += '>';

    if (!inline) {
      out += '\n';
      out += spacer(newLvl, tabStop);
    }

    out += childrens.reduce(mergeSiblingPlainStringChildrenReducer, []).map(formatOneChildren(inline, newLvl, options)).join(!inline ? "\n".concat(spacer(newLvl, tabStop)) : '');

    if (!inline) {
      out += '\n';
      out += spacer(newLvl - 1, tabStop);
    }

    out += "</".concat(displayName, ">");
  } else {
    if (!isInlineAttributeTooLong(attributes, outInlineAttr, lvl, tabStop, maxInlineAttributesLineLength)) {
      out += ' ';
    }

    out += '/>';
  }

  return out;
});

var REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX = '';
var REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX = 'React.Fragment';

var toReactElementTreeNode = function toReactElementTreeNode(displayName, key, childrens) {
  var props = {};

  if (key) {
    props = {
      key: key
    };
  }

  return {
    type: 'ReactElement',
    displayName: displayName,
    props: props,
    defaultProps: {},
    childrens: childrens
  };
};

var isKeyedFragment = function isKeyedFragment(_ref) {
  var key = _ref.key;
  return Boolean(key);
};

var hasNoChildren = function hasNoChildren(_ref2) {
  var childrens = _ref2.childrens;
  return childrens.length === 0;
};

var formatReactFragmentNode = (function (node, inline, lvl, options) {
  var type = node.type,
      key = node.key,
      childrens = node.childrens;

  if (type !== 'ReactFragment') {
    throw new Error("The \"formatReactFragmentNode\" function could only format node of type \"ReactFragment\". Given: ".concat(type));
  }

  var useFragmentShortSyntax = options.useFragmentShortSyntax;
  var displayName;

  if (useFragmentShortSyntax) {
    if (hasNoChildren(node) || isKeyedFragment(node)) {
      displayName = REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
    } else {
      displayName = REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX;
    }
  } else {
    displayName = REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
  }

  return formatReactElementNode(toReactElementTreeNode(displayName, key, childrens), inline, lvl, options);
});

var jsxStopChars = ['<', '>', '{', '}'];

var shouldBeEscaped = function shouldBeEscaped(s) {
  return jsxStopChars.some(function (jsxStopChar) {
    return s.includes(jsxStopChar);
  });
};

var escape = function escape(s) {
  if (!shouldBeEscaped(s)) {
    return s;
  }

  return "{`".concat(s, "`}");
};

var preserveTrailingSpace = function preserveTrailingSpace(s) {
  var result = s;

  if (result.endsWith(' ')) {
    result = result.replace(/^(.*?)(\s+)$/, "$1{'$2'}");
  }

  if (result.startsWith(' ')) {
    result = result.replace(/^(\s+)(.*)$/, "{'$1'}$2");
  }

  return result;
};

var formatTreeNode = (function (node, inline, lvl, options) {
  if (node.type === 'number') {
    return String(node.value);
  }

  if (node.type === 'string') {
    return node.value ? "".concat(preserveTrailingSpace(escape(String(node.value)))) : '';
  }

  if (node.type === 'ReactElement') {
    return formatReactElementNode(node, inline, lvl, options);
  }

  if (node.type === 'ReactFragment') {
    return formatReactFragmentNode(node, inline, lvl, options);
  }

  throw new TypeError("Unknow format type \"".concat(node.type, "\""));
});

var formatTree = (function (node, options) {
  return formatTreeNode(node, false, 0, options);
});

var reactElementToJsxString = function reactElementToJsxString(element) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$filterProps = _ref.filterProps,
      filterProps = _ref$filterProps === void 0 ? [] : _ref$filterProps,
      _ref$showDefaultProps = _ref.showDefaultProps,
      showDefaultProps = _ref$showDefaultProps === void 0 ? true : _ref$showDefaultProps,
      _ref$showFunctions = _ref.showFunctions,
      showFunctions = _ref$showFunctions === void 0 ? false : _ref$showFunctions,
      functionValue = _ref.functionValue,
      _ref$tabStop = _ref.tabStop,
      tabStop = _ref$tabStop === void 0 ? 2 : _ref$tabStop,
      _ref$useBooleanShorth = _ref.useBooleanShorthandSyntax,
      useBooleanShorthandSyntax = _ref$useBooleanShorth === void 0 ? true : _ref$useBooleanShorth,
      _ref$useFragmentShort = _ref.useFragmentShortSyntax,
      useFragmentShortSyntax = _ref$useFragmentShort === void 0 ? true : _ref$useFragmentShort,
      _ref$sortProps = _ref.sortProps,
      sortProps = _ref$sortProps === void 0 ? true : _ref$sortProps,
      maxInlineAttributesLineLength = _ref.maxInlineAttributesLineLength,
      displayName = _ref.displayName;

  if (!element) {
    throw new Error('react-element-to-jsx-string: Expected a ReactElement');
  }

  var options = {
    filterProps: filterProps,
    showDefaultProps: showDefaultProps,
    showFunctions: showFunctions,
    functionValue: functionValue,
    tabStop: tabStop,
    useBooleanShorthandSyntax: useBooleanShorthandSyntax,
    useFragmentShortSyntax: useFragmentShortSyntax,
    sortProps: sortProps,
    maxInlineAttributesLineLength: maxInlineAttributesLineLength,
    displayName: displayName
  };
  return formatTree(parseReactElement(element, options), options);
};

exports.ZP = reactElementToJsxString;
__webpack_unused_export__ = inlineFunction;
__webpack_unused_export__ = preserveFunctionLineBreak;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 8266:
/***/ (function(module) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 74758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ HelmetExport; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60216);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_side_effect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25824);
/* harmony import */ var react_side_effect__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_side_effect__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8266);
/* harmony import */ var react_fast_compare__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_fast_compare__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32735);
/* harmony import */ var object_assign__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81412);
/* harmony import */ var object_assign__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(object_assign__WEBPACK_IMPORTED_MODULE_3__);






var ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};

var REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = "data-react-helmet";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = object_assign__WEBPACK_IMPORTED_MODULE_3___default()({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : __webpack_require__.g.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : __webpack_require__.g.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [react__WEBPACK_IMPORTED_MODULE_2__.createElement(TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return react__WEBPACK_IMPORTED_MODULE_2__.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case ATTRIBUTE_NAMES.BODY:
        case ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            classCallCheck(this, HelmetWrapper);
            return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !react_fast_compare__WEBPACK_IMPORTED_MODULE_1___default()(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case TAG_NAMES.SCRIPT:
                case TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));

                case TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _babelHelpers$extends4;

                newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {}

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            react__WEBPACK_IMPORTED_MODULE_2__.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = convertReactPropstoHtmlAttributes(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case TAG_NAMES.LINK:
                    case TAG_NAMES.META:
                    case TAG_NAMES.NOSCRIPT:
                    case TAG_NAMES.SCRIPT:
                    case TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return react__WEBPACK_IMPORTED_MODULE_2__.createElement(Component, newProps);
        };

        createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set$$1(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);
        return HelmetWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_2__.Component), _class.propTypes = {
        base: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().object),
        bodyAttributes: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().object),
        children: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_4___default().node)), (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node)]),
        defaultTitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
        defer: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
        encodeSpecialCharacters: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
        htmlAttributes: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().object),
        link: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_4___default().object)),
        meta: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_4___default().object)),
        noscript: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_4___default().object)),
        onChangeClientState: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
        script: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_4___default().object)),
        style: prop_types__WEBPACK_IMPORTED_MODULE_4___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_4___default().object)),
        title: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
        titleAttributes: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().object),
        titleTemplate: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = react_side_effect__WEBPACK_IMPORTED_MODULE_0___default()(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (HelmetExport)));



/***/ }),

/***/ 26697:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),

/***/ 72594:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(26697);
} else {}


/***/ }),

/***/ 25824:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(32735);
var React__default = _interopDefault(React);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),

/***/ 29745:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var setFunctionName = __webpack_require__(41408);

var $Object = Object;
var $TypeError = TypeError;

module.exports = setFunctionName(function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.hasIndices) {
		result += 'd';
	}
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.unicodeSets) {
		result += 'v';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
}, 'get flags', true);



/***/ }),

/***/ 81861:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(26506);
var callBind = __webpack_require__(73235);

var implementation = __webpack_require__(29745);
var getPolyfill = __webpack_require__(33214);
var shim = __webpack_require__(15233);

var flagsBound = callBind(getPolyfill());

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),

/***/ 33214:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(29745);

var supportsDescriptors = (__webpack_require__(26506).supportsDescriptors);
var $gOPD = Object.getOwnPropertyDescriptor;

module.exports = function getPolyfill() {
	if (supportsDescriptors && (/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (
			descriptor
			&& typeof descriptor.get === 'function'
			&& typeof RegExp.prototype.dotAll === 'boolean'
			&& typeof RegExp.prototype.hasIndices === 'boolean'
		) {
			/* eslint getter-return: 0 */
			var calls = '';
			var o = {};
			Object.defineProperty(o, 'hasIndices', {
				get: function () {
					calls += 'd';
				}
			});
			Object.defineProperty(o, 'sticky', {
				get: function () {
					calls += 'y';
				}
			});
			if (calls === 'dy') {
				return descriptor.get;
			}
		}
	}
	return implementation;
};


/***/ }),

/***/ 15233:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var supportsDescriptors = (__webpack_require__(26506).supportsDescriptors);
var getPolyfill = __webpack_require__(33214);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),

/***/ 1744:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(91528);
var define = __webpack_require__(27892);
var hasDescriptors = __webpack_require__(42320)();
var gOPD = __webpack_require__(41455);

var $TypeError = GetIntrinsic('%TypeError%');
var $floor = GetIntrinsic('%Math.floor%');

module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(fn, 'length', length, true, true);
		} else {
			define(fn, 'length', length);
		}
	}
	return fn;
};


/***/ }),

/***/ 41408:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(27892);
var hasDescriptors = __webpack_require__(42320)();
var functionsHaveConfigurableNames = (__webpack_require__(34019).functionsHaveConfigurableNames)();

var $TypeError = TypeError;

module.exports = function setFunctionName(fn, name) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	var loose = arguments.length > 2 && !!arguments[2];
	if (!loose || functionsHaveConfigurableNames) {
		if (hasDescriptors) {
			define(fn, 'name', name, true, true);
		} else {
			define(fn, 'name', name);
		}
	}
	return fn;
};


/***/ }),

/***/ 62538:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(91528);
var callBound = __webpack_require__(47737);
var inspect = __webpack_require__(13970);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ 52719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var SLOT = __webpack_require__(86154);

var $SyntaxError = SyntaxError;
var $StopIteration = typeof StopIteration === 'object' ? StopIteration : null;

module.exports = function getStopIterationIterator(origIterator) {
	if (!$StopIteration) {
		throw new $SyntaxError('this environment lacks StopIteration');
	}

	SLOT.set(origIterator, '[[Done]]', false);

	var siIterator = {
		next: function next() {
			var iterator = SLOT.get(this, '[[Iterator]]');
			var done = SLOT.get(iterator, '[[Done]]');
			try {
				return {
					done: done,
					value: done ? void undefined : iterator.next()
				};
			} catch (e) {
				SLOT.set(iterator, '[[Done]]', true);
				if (e !== $StopIteration) {
					throw e;
				}
				return {
					done: true,
					value: void undefined
				};
			}
		}
	};

	SLOT.set(siIterator, '[[Iterator]]', origIterator);

	return siIterator;
};


/***/ }),

/***/ 2053:
/***/ (function(module) {

module.exports = defaultsPlugin

function defaultsPlugin() {
	var defaultValues = {}
	
	return {
		defaults: defaults,
		get: get
	}
	
	function defaults(_, values) {
		defaultValues = values
	}
	
	function get(super_fn, key) {
		var val = super_fn()
		return (val !== undefined ? val : defaultValues[key])
	}
}


/***/ }),

/***/ 4330:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var util = __webpack_require__(55897)
var slice = util.slice
var pluck = util.pluck
var each = util.each
var bind = util.bind
var create = util.create
var isList = util.isList
var isFunction = util.isFunction
var isObject = util.isObject

module.exports = {
	createStore: createStore
}

var storeAPI = {
	version: '2.0.12',
	enabled: false,
	
	// get returns the value of the given key. If that value
	// is undefined, it returns optionalDefaultValue instead.
	get: function(key, optionalDefaultValue) {
		var data = this.storage.read(this._namespacePrefix + key)
		return this._deserialize(data, optionalDefaultValue)
	},

	// set will store the given value at key and returns value.
	// Calling set with value === undefined is equivalent to calling remove.
	set: function(key, value) {
		if (value === undefined) {
			return this.remove(key)
		}
		this.storage.write(this._namespacePrefix + key, this._serialize(value))
		return value
	},

	// remove deletes the key and value stored at the given key.
	remove: function(key) {
		this.storage.remove(this._namespacePrefix + key)
	},

	// each will call the given callback once for each key-value pair
	// in this store.
	each: function(callback) {
		var self = this
		this.storage.each(function(val, namespacedKey) {
			callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''))
		})
	},

	// clearAll will remove all the stored key-value pairs in this store.
	clearAll: function() {
		this.storage.clearAll()
	},

	// additional functionality that can't live in plugins
	// ---------------------------------------------------

	// hasNamespace returns true if this store instance has the given namespace.
	hasNamespace: function(namespace) {
		return (this._namespacePrefix == '__storejs_'+namespace+'_')
	},

	// createStore creates a store.js instance with the first
	// functioning storage in the list of storage candidates,
	// and applies the the given mixins to the instance.
	createStore: function() {
		return createStore.apply(this, arguments)
	},
	
	addPlugin: function(plugin) {
		this._addPlugin(plugin)
	},
	
	namespace: function(namespace) {
		return createStore(this.storage, this.plugins, namespace)
	}
}

function _warn() {
	var _console = (typeof console == 'undefined' ? null : console)
	if (!_console) { return }
	var fn = (_console.warn ? _console.warn : _console.log)
	fn.apply(_console, arguments)
}

function createStore(storages, plugins, namespace) {
	if (!namespace) {
		namespace = ''
	}
	if (storages && !isList(storages)) {
		storages = [storages]
	}
	if (plugins && !isList(plugins)) {
		plugins = [plugins]
	}

	var namespacePrefix = (namespace ? '__storejs_'+namespace+'_' : '')
	var namespaceRegexp = (namespace ? new RegExp('^'+namespacePrefix) : null)
	var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
	if (!legalNamespaces.test(namespace)) {
		throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes')
	}
	
	var _privateStoreProps = {
		_namespacePrefix: namespacePrefix,
		_namespaceRegexp: namespaceRegexp,

		_testStorage: function(storage) {
			try {
				var testStr = '__storejs__test__'
				storage.write(testStr, testStr)
				var ok = (storage.read(testStr) === testStr)
				storage.remove(testStr)
				return ok
			} catch(e) {
				return false
			}
		},

		_assignPluginFnProp: function(pluginFnProp, propName) {
			var oldFn = this[propName]
			this[propName] = function pluginFn() {
				var args = slice(arguments, 0)
				var self = this

				// super_fn calls the old function which was overwritten by
				// this mixin.
				function super_fn() {
					if (!oldFn) { return }
					each(arguments, function(arg, i) {
						args[i] = arg
					})
					return oldFn.apply(self, args)
				}

				// Give mixing function access to super_fn by prefixing all mixin function
				// arguments with super_fn.
				var newFnArgs = [super_fn].concat(args)

				return pluginFnProp.apply(self, newFnArgs)
			}
		},

		_serialize: function(obj) {
			return JSON.stringify(obj)
		},

		_deserialize: function(strVal, defaultVal) {
			if (!strVal) { return defaultVal }
			// It is possible that a raw string value has been previously stored
			// in a storage without using store.js, meaning it will be a raw
			// string value instead of a JSON serialized string. By defaulting
			// to the raw string value in case of a JSON parse error, we allow
			// for past stored values to be forwards-compatible with store.js
			var val = ''
			try { val = JSON.parse(strVal) }
			catch(e) { val = strVal }

			return (val !== undefined ? val : defaultVal)
		},
		
		_addStorage: function(storage) {
			if (this.enabled) { return }
			if (this._testStorage(storage)) {
				this.storage = storage
				this.enabled = true
			}
		},

		_addPlugin: function(plugin) {
			var self = this

			// If the plugin is an array, then add all plugins in the array.
			// This allows for a plugin to depend on other plugins.
			if (isList(plugin)) {
				each(plugin, function(plugin) {
					self._addPlugin(plugin)
				})
				return
			}

			// Keep track of all plugins we've seen so far, so that we
			// don't add any of them twice.
			var seenPlugin = pluck(this.plugins, function(seenPlugin) {
				return (plugin === seenPlugin)
			})
			if (seenPlugin) {
				return
			}
			this.plugins.push(plugin)

			// Check that the plugin is properly formed
			if (!isFunction(plugin)) {
				throw new Error('Plugins must be function values that return objects')
			}

			var pluginProperties = plugin.call(this)
			if (!isObject(pluginProperties)) {
				throw new Error('Plugins must return an object of function properties')
			}

			// Add the plugin function properties to this store instance.
			each(pluginProperties, function(pluginFnProp, propName) {
				if (!isFunction(pluginFnProp)) {
					throw new Error('Bad plugin property: '+propName+' from plugin '+plugin.name+'. Plugins should only return functions.')
				}
				self._assignPluginFnProp(pluginFnProp, propName)
			})
		},
		
		// Put deprecated properties in the private API, so as to not expose it to accidential
		// discovery through inspection of the store object.
		
		// Deprecated: addStorage
		addStorage: function(storage) {
			_warn('store.addStorage(storage) is deprecated. Use createStore([storages])')
			this._addStorage(storage)
		}
	}

	var store = create(_privateStoreProps, storeAPI, {
		plugins: []
	})
	store.raw = {}
	each(store, function(prop, propName) {
		if (isFunction(prop)) {
			store.raw[propName] = bind(store, prop)			
		}
	})
	each(storages, function(storage) {
		store._addStorage(storage)
	})
	each(plugins, function(plugin) {
		store._addPlugin(plugin)
	})
	return store
}


/***/ }),

/***/ 55897:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assign = make_assign()
var create = make_create()
var trim = make_trim()
var Global = (typeof window !== 'undefined' ? window : __webpack_require__.g)

module.exports = {
	assign: assign,
	create: create,
	trim: trim,
	bind: bind,
	slice: slice,
	each: each,
	map: map,
	pluck: pluck,
	isList: isList,
	isFunction: isFunction,
	isObject: isObject,
	Global: Global
}

function make_assign() {
	if (Object.assign) {
		return Object.assign
	} else {
		return function shimAssign(obj, props1, props2, etc) {
			for (var i = 1; i < arguments.length; i++) {
				each(Object(arguments[i]), function(val, key) {
					obj[key] = val
				})
			}			
			return obj
		}
	}
}

function make_create() {
	if (Object.create) {
		return function create(obj, assignProps1, assignProps2, etc) {
			var assignArgsList = slice(arguments, 1)
			return assign.apply(this, [Object.create(obj)].concat(assignArgsList))
		}
	} else {
		function F() {} // eslint-disable-line no-inner-declarations
		return function create(obj, assignProps1, assignProps2, etc) {
			var assignArgsList = slice(arguments, 1)
			F.prototype = obj
			return assign.apply(this, [new F()].concat(assignArgsList))
		}
	}
}

function make_trim() {
	if (String.prototype.trim) {
		return function trim(str) {
			return String.prototype.trim.call(str)
		}
	} else {
		return function trim(str) {
			return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '')
		}
	}
}

function bind(obj, fn) {
	return function() {
		return fn.apply(obj, Array.prototype.slice.call(arguments, 0))
	}
}

function slice(arr, index) {
	return Array.prototype.slice.call(arr, index || 0)
}

function each(obj, fn) {
	pluck(obj, function(val, key) {
		fn(val, key)
		return false
	})
}

function map(obj, fn) {
	var res = (isList(obj) ? [] : {})
	pluck(obj, function(v, k) {
		res[k] = fn(v, k)
		return false
	})
	return res
}

function pluck(obj, fn) {
	if (isList(obj)) {
		for (var i=0; i<obj.length; i++) {
			if (fn(obj[i], i)) {
				return obj[i]
			}
		}
	} else {
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) {
				if (fn(obj[key], key)) {
					return obj[key]
				}
			}
		}
	}
}

function isList(val) {
	return (val != null && typeof val != 'function' && typeof val.length == 'number')
}

function isFunction(val) {
	return val && {}.toString.call(val) === '[object Function]'
}

function isObject(val) {
	return val && {}.toString.call(val) === '[object Object]'
}


/***/ }),

/***/ 33600:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var util = __webpack_require__(55897)
var Global = util.Global

module.exports = {
	name: 'sessionStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll
}

function sessionStorage() {
	return Global.sessionStorage
}

function read(key) {
	return sessionStorage().getItem(key)
}

function write(key, data) {
	return sessionStorage().setItem(key, data)
}

function each(fn) {
	for (var i = sessionStorage().length - 1; i >= 0; i--) {
		var key = sessionStorage().key(i)
		fn(read(key), key)
	}
}

function remove(key) {
	return sessionStorage().removeItem(key)
}

function clearAll() {
	return sessionStorage().clear()
}


/***/ }),

/***/ 96324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ni": function() { return /* binding */ ThemeContext; },
  "f6": function() { return /* binding */ ThemeProvider; },
  "vJ": function() { return /* binding */ createGlobalStyle; },
  "iv": function() { return /* binding */ css; },
  "ZP": function() { return /* binding */ styled_components_browser_esm; },
  "F4": function() { return /* binding */ keyframes; },
  "Zz": function() { return /* binding */ withTheme; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS, isStyledComponent

// EXTERNAL MODULE: ../../../node_modules/stylis/stylis.min.js
var stylis_min = __webpack_require__(95703);
var stylis_min_default = /*#__PURE__*/__webpack_require__.n(stylis_min);
// EXTERNAL MODULE: ../../../node_modules/stylis-rule-sheet/index.js
var stylis_rule_sheet = __webpack_require__(52474);
var stylis_rule_sheet_default = /*#__PURE__*/__webpack_require__.n(stylis_rule_sheet);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitless_browser_esm = __webpack_require__(79159);
// EXTERNAL MODULE: ../../../node_modules/styled-components/node_modules/react-is/index.js
var react_is = __webpack_require__(40775);
// EXTERNAL MODULE: ../../../node_modules/memoize-one/dist/memoize-one.esm.js
var memoize_one_esm = __webpack_require__(89454);
// EXTERNAL MODULE: ../../../node_modules/@emotion/memoize/dist/memoize.browser.esm.js
var memoize_browser_esm = __webpack_require__(71250);
;// CONCATENATED MODULE: ../../../node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = (0,memoize_browser_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ var is_prop_valid_browser_esm = (index);

;// CONCATENATED MODULE: ../../../node_modules/is-what/dist/index.esm.js
/**
 * Returns the object type of the given payload
 *
 * @param {*} payload
 * @returns {string}
 */
function getType(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
/**
 * Returns whether the payload is undefined
 *
 * @param {*} payload
 * @returns {payload is undefined}
 */
function isUndefined(payload) {
    return getType(payload) === 'Undefined';
}
/**
 * Returns whether the payload is null
 *
 * @param {*} payload
 * @returns {payload is null}
 */
function isNull(payload) {
    return getType(payload) === 'Null';
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isPlainObject(payload) {
    if (getType(payload) !== 'Object')
        return false;
    return payload.constructor === Object && Object.getPrototypeOf(payload) === Object.prototype;
}
/**
 * Returns whether the payload is a plain JavaScript object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isObject(payload) {
    return isPlainObject(payload);
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is { [K in any]: never }}
 */
function isEmptyObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length === 0;
}
/**
 * Returns whether the payload is a an empty object (excluding special classes or objects with other prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isFullObject(payload) {
    return isPlainObject(payload) && Object.keys(payload).length > 0;
}
/**
 * Returns whether the payload is an any kind of object (including special classes or objects with different prototypes)
 *
 * @param {*} payload
 * @returns {payload is PlainObject}
 */
function isAnyObject(payload) {
    return getType(payload) === 'Object';
}
/**
 * Returns whether the payload is an object like a type passed in < >
 *
 * Usage: isObjectLike<{id: any}>(payload) // will make sure it's an object and has an `id` prop.
 *
 * @template T this must be passed in < >
 * @param {*} payload
 * @returns {payload is T}
 */
function isObjectLike(payload) {
    return isAnyObject(payload);
}
/**
 * Returns whether the payload is a function (regular or async)
 *
 * @param {*} payload
 * @returns {payload is AnyFunction}
 */
function isFunction(payload) {
    return typeof payload === 'function';
}
/**
 * Returns whether the payload is an array
 *
 * @param {any} payload
 * @returns {payload is any[]}
 */
function index_esm_isArray(payload) {
    return getType(payload) === 'Array';
}
/**
 * Returns whether the payload is a an array with at least 1 item
 *
 * @param {*} payload
 * @returns {payload is any[]}
 */
function isFullArray(payload) {
    return index_esm_isArray(payload) && payload.length > 0;
}
/**
 * Returns whether the payload is a an empty array
 *
 * @param {*} payload
 * @returns {payload is []}
 */
function isEmptyArray(payload) {
    return index_esm_isArray(payload) && payload.length === 0;
}
/**
 * Returns whether the payload is a string
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isString(payload) {
    return getType(payload) === 'String';
}
/**
 * Returns whether the payload is a string, BUT returns false for ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isFullString(payload) {
    return isString(payload) && payload !== '';
}
/**
 * Returns whether the payload is ''
 *
 * @param {*} payload
 * @returns {payload is string}
 */
function isEmptyString(payload) {
    return payload === '';
}
/**
 * Returns whether the payload is a number (but not NaN)
 *
 * This will return `false` for `NaN`!!
 *
 * @param {*} payload
 * @returns {payload is number}
 */
function isNumber(payload) {
    return getType(payload) === 'Number' && !isNaN(payload);
}
/**
 * Returns whether the payload is a boolean
 *
 * @param {*} payload
 * @returns {payload is boolean}
 */
function isBoolean(payload) {
    return getType(payload) === 'Boolean';
}
/**
 * Returns whether the payload is a regular expression (RegExp)
 *
 * @param {*} payload
 * @returns {payload is RegExp}
 */
function isRegExp(payload) {
    return getType(payload) === 'RegExp';
}
/**
 * Returns whether the payload is a Map
 *
 * @param {*} payload
 * @returns {payload is Map<any, any>}
 */
function isMap(payload) {
    return getType(payload) === 'Map';
}
/**
 * Returns whether the payload is a WeakMap
 *
 * @param {*} payload
 * @returns {payload is WeakMap<any, any>}
 */
function isWeakMap(payload) {
    return getType(payload) === 'WeakMap';
}
/**
 * Returns whether the payload is a Set
 *
 * @param {*} payload
 * @returns {payload is Set<any>}
 */
function isSet(payload) {
    return getType(payload) === 'Set';
}
/**
 * Returns whether the payload is a WeakSet
 *
 * @param {*} payload
 * @returns {payload is WeakSet<any>}
 */
function isWeakSet(payload) {
    return getType(payload) === 'WeakSet';
}
/**
 * Returns whether the payload is a Symbol
 *
 * @param {*} payload
 * @returns {payload is symbol}
 */
function isSymbol(payload) {
    return getType(payload) === 'Symbol';
}
/**
 * Returns whether the payload is a Date, and that the date is valid
 *
 * @param {*} payload
 * @returns {payload is Date}
 */
function isDate(payload) {
    return getType(payload) === 'Date' && !isNaN(payload);
}
/**
 * Returns whether the payload is a Blob
 *
 * @param {*} payload
 * @returns {payload is Blob}
 */
function isBlob(payload) {
    return getType(payload) === 'Blob';
}
/**
 * Returns whether the payload is a File
 *
 * @param {*} payload
 * @returns {payload is File}
 */
function isFile(payload) {
    return getType(payload) === 'File';
}
/**
 * Returns whether the payload is a Promise
 *
 * @param {*} payload
 * @returns {payload is Promise<any>}
 */
function isPromise(payload) {
    return getType(payload) === 'Promise';
}
/**
 * Returns whether the payload is an Error
 *
 * @param {*} payload
 * @returns {payload is Error}
 */
function isError(payload) {
    return getType(payload) === 'Error';
}
/**
 * Returns whether the payload is literally the value `NaN` (it's `NaN` and also a `number`)
 *
 * @param {*} payload
 * @returns {payload is typeof NaN}
 */
function isNaNValue(payload) {
    return getType(payload) === 'Number' && isNaN(payload);
}
/**
 * Returns whether the payload is a primitive type (eg. Boolean | Null | Undefined | Number | String | Symbol)
 *
 * @param {*} payload
 * @returns {(payload is boolean | null | undefined | number | string | symbol)}
 */
function isPrimitive(payload) {
    return (isBoolean(payload) ||
        isNull(payload) ||
        isUndefined(payload) ||
        isNumber(payload) ||
        isString(payload) ||
        isSymbol(payload));
}
/**
 * Returns true whether the payload is null or undefined
 *
 * @param {*} payload
 * @returns {(payload is null | undefined)}
 */
var isNullOrUndefined = isOneOf(isNull, isUndefined);
function isOneOf(a, b, c, d, e) {
    return function (value) {
        return a(value) || b(value) || (!!c && c(value)) || (!!d && d(value)) || (!!e && e(value));
    };
}
/**
 * Does a generic check to check that the given payload is of a given type.
 * In cases like Number, it will return true for NaN as NaN is a Number (thanks javascript!);
 * It will, however, differentiate between object and null
 *
 * @template T
 * @param {*} payload
 * @param {T} type
 * @throws {TypeError} Will throw type error if type is an invalid type
 * @returns {payload is T}
 */
function isType(payload, type) {
    if (!(type instanceof Function)) {
        throw new TypeError('Type must be a function');
    }
    if (!Object.prototype.hasOwnProperty.call(type, 'prototype')) {
        throw new TypeError('Type is not a class');
    }
    // Classes usually have names (as functions usually have names)
    var name = type.name;
    return getType(payload) === name || Boolean(payload && payload.constructor === type);
}



;// CONCATENATED MODULE: ../../../node_modules/merge-anything/dist/index.esm.js


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function assignProp(carry, key, newVal, originalObject) {
    var propType = originalObject.propertyIsEnumerable(key)
        ? 'enumerable'
        : 'nonenumerable';
    if (propType === 'enumerable')
        carry[key] = newVal;
    if (propType === 'nonenumerable') {
        Object.defineProperty(carry, key, {
            value: newVal,
            enumerable: false,
            writable: true,
            configurable: true
        });
    }
}
function mergeRecursively(origin, newComer, extensions) {
    // work directly on newComer if its not an object
    if (!isPlainObject(newComer)) {
        // extend merge rules
        if (extensions && index_esm_isArray(extensions)) {
            extensions.forEach(function (extend) {
                newComer = extend(origin, newComer);
            });
        }
        return newComer;
    }
    // define newObject to merge all values upon
    var newObject = {};
    if (isPlainObject(origin)) {
        var props_1 = Object.getOwnPropertyNames(origin);
        var symbols_1 = Object.getOwnPropertySymbols(origin);
        newObject = __spreadArrays(props_1, symbols_1).reduce(function (carry, key) {
            // @ts-ignore
            var targetVal = origin[key];
            if ((!isSymbol(key) && !Object.getOwnPropertyNames(newComer).includes(key)) ||
                (isSymbol(key) && !Object.getOwnPropertySymbols(newComer).includes(key))) {
                assignProp(carry, key, targetVal, origin);
            }
            return carry;
        }, {});
    }
    var props = Object.getOwnPropertyNames(newComer);
    var symbols = Object.getOwnPropertySymbols(newComer);
    var result = __spreadArrays(props, symbols).reduce(function (carry, key) {
        // re-define the origin and newComer as targetVal and newVal
        var newVal = newComer[key];
        var targetVal = (isPlainObject(origin))
            // @ts-ignore
            ? origin[key]
            : undefined;
        // extend merge rules
        if (extensions && index_esm_isArray(extensions)) {
            extensions.forEach(function (extend) {
                newVal = extend(targetVal, newVal);
            });
        }
        // When newVal is an object do the merge recursively
        if (targetVal !== undefined && isPlainObject(newVal)) {
            newVal = mergeRecursively(targetVal, newVal, extensions);
        }
        assignProp(carry, key, newVal, newComer);
        return carry;
    }, newObject);
    return result;
}
/**
 * Merge anything recursively.
 * Objects get merged, special objects (classes etc.) are re-assigned "as is".
 * Basic types overwrite objects or other basic types.
 *
 * @param {(IConfig | any)} origin
 * @param {...any[]} newComers
 * @returns the result
 */
function merge(origin) {
    var newComers = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        newComers[_i - 1] = arguments[_i];
    }
    var extensions = null;
    var base = origin;
    if (isPlainObject(origin) && origin.extensions && Object.keys(origin).length === 1) {
        base = {};
        extensions = origin.extensions;
    }
    return newComers.reduce(function (result, newComer) {
        return mergeRecursively(result, newComer, extensions);
    }, base);
}

function concatArrays(originVal, newVal) {
    if (isArray(originVal) && isArray(newVal)) {
        // concat logic
        return originVal.concat(newVal);
    }
    return newVal; // always return newVal as fallback!!
}

/* harmony default export */ var index_esm = (merge);


;// CONCATENATED MODULE: ../../../node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(13158);










// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var styled_components_browser_esm_isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 
function styled_components_browser_esm_isFunction(test) {
  return typeof test === 'function';
}

// 

function getComponentName(target) {
  return ( false) || target.displayName || target.name || 'Component';
}

// 
function isStatelessFunction(test) {
  return typeof test === 'function' && !(test.prototype && test.prototype.isReactComponent);
}

// 
function isStyledComponent(target) {
  return target && typeof target.styledComponentId === 'string';
}

// 

var SC_ATTR = typeof process !== 'undefined' && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || 'data-styled';

var SC_VERSION_ATTR = 'data-styled-version';

var SC_STREAM_ATTR = 'data-styled-streamed';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = typeof SC_DISABLE_SPEEDY === 'boolean' && SC_DISABLE_SPEEDY || typeof process !== 'undefined' && (process.env.REACT_APP_SC_DISABLE_SPEEDY || process.env.SC_DISABLE_SPEEDY) || "production" !== 'production';

// Shared empty execution context when generating static styles
var STATIC_EXECUTION_CONTEXT = {};

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? 0 : {};

/**
 * super basic version of sprintf
 */
function format() {
  var a = arguments.length <= 0 ? undefined : arguments[0];
  var b = [];

  for (var c = 1, len = arguments.length; c < len; c += 1) {
    b.push(arguments.length <= c ? undefined : arguments[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#' + code + ' for more information.' + (interpolations.length > 0 ? ' Additional arguments: ' + interpolations.join(', ') : '')));
    } else { var _this; }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new (stylis_min_default())({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new (stylis_min_default())({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];

// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = stylis_rule_sheet_default()(function (rule) {
  parsingRules.push(rule);
});

var _componentId = void 0;
var _selector = void 0;
var _selectorRegexp = void 0;

var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
  if (
  // the first self-ref is always untouched
  offset > 0 &&
  // there should be at least two self-refs to do a replacement (.b > .b)
  string.slice(0, offset).indexOf(_selector) !== -1 &&
  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
  string.slice(offset - _selector.length, offset) !== _selector) {
    return '.' + _componentId;
  }

  return match;
};

/**
 * When writing a style like
 *
 * & + & {
 *   color: red;
 * }
 *
 * The second ampersand should be a reference to the static component class. stylis
 * has no knowledge of static class so we have to intelligently replace the base selector.
 */
var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
    // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
  }
};

stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

function stringifyRules(rules, selector, prefix) {
  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';

  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  // stylis has no concept of state to be passed to plugins
  // but since JS is single=threaded, we can rely on that to ensure
  // these properties stay in sync with the current stylis run
  _componentId = componentId;
  _selector = selector;
  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');

  return stylis(prefix || !selector ? '' : selector, cssStr);
}

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : 0;
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = tag.ownerDocument.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = tag.ownerDocument.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var targetDocument = document;
  if (target) targetDocument = target.ownerDocument;else if (tagEl) targetDocument = tagEl.ownerDocument;

  var el = targetDocument.createElement('style');
  el.setAttribute(SC_ATTR, '');
  el.setAttribute(SC_VERSION_ATTR, "4.4.1");

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(targetDocument.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.4.1" + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.4.1", _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return react.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    // $FlowFixMe
    if (el.isConnected === false) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(targetDocument, id) {
  return targetDocument.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whether getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(el.ownerDocument, id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(el.ownerDocument, id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTag = function makeServerTag(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTag(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

var rehydrate = function rehydrate(tag, els, extracted) {
  /* add all extracted components to the new tag */
  for (var i = 0, len = extracted.length; i < len; i += 1) {
    var _extracted$i = extracted[i],
        componentId = _extracted$i.componentId,
        cssFromDOM = _extracted$i.cssFromDOM;

    var cssRules = splitByRules(cssFromDOM);
    tag.insertRules(componentId, cssRules);
  }

  /* remove old HTMLStyleElements, since they have been rehydrated */
  for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
    var el = els[_i];
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {

  /* a map from ids to tags */

  /* deferred rules for a given id */

  /* this is used for not reinjecting rules via hasNameForId() */

  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */

  /* a list of tags belonging to this StyleSheet */

  /* a tag for import rules */

  /* current capacity until a new tag must be created */

  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate$$1() {
    if (!IS_BROWSER || this.forceServer) return this;

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.4.1" + '"]');

    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (!nodesSize) return this;

    for (var i = 0; i < nodesSize; i += 1) {
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0, name; j < elNamesSize; j += 1) {
        name = elNames[j];
        /* add rehydrated name to sheet to avoid re-adding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (!extractedSize) return this;

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);

    rehydrate(tag, els, extracted);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(tag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = tag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for createGlobalStyle to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);

    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;

    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return (0,react.cloneElement)(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

// 

var Keyframes = function () {
  function Keyframes(name, rules) {
    var _this = this;

    classCallCheck(this, Keyframes);

    this.inject = function (styleSheet) {
      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
        styleSheet.inject(_this.id, _this.rules, _this.name);
      }
    };

    this.toString = function () {
      throw new StyledComponentsError(12, String(_this.name));
    };

    this.name = name;
    this.rules = rules;

    this.id = 'sc-keyframes-' + name;
  }

  Keyframes.prototype.getName = function getName() {
    return this.name;
  };

  return Keyframes;
}();

// 

/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

// 

// Taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/dangerousStyleValue.js
function addUnitIfNeeded(name, value) {
  // https://github.com/amilajack/eslint-plugin-flowtype-errors/issues/133
  // $FlowFixMe
  if (value == null || typeof value === 'boolean' || value === '') {
    return '';
  }

  if (typeof value === 'number' && value !== 0 && !(name in unitless_browser_esm/* default */.Z)) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return String(value).trim();
}

// 

/**
 * It's falsish not falsy because 0 is allowed.
 */
var isFalsish = function isFalsish(chunk) {
  return chunk === undefined || chunk === null || chunk === false || chunk === '';
};

var objToCssArray = function objToCssArray(obj, prevKey) {
  var rules = [];
  var keys = Object.keys(obj);

  keys.forEach(function (key) {
    if (!isFalsish(obj[key])) {
      if (styled_components_browser_esm_isPlainObject(obj[key])) {
        rules.push.apply(rules, objToCssArray(obj[key], key));

        return rules;
      } else if (styled_components_browser_esm_isFunction(obj[key])) {
        rules.push(hyphenateStyleName(key) + ':', obj[key], ';');

        return rules;
      }
      rules.push(hyphenateStyleName(key) + ': ' + addUnitIfNeeded(key, obj[key]) + ';');
    }
    return rules;
  });

  return prevKey ? [prevKey + ' {'].concat(rules, ['}']) : rules;
};

function flatten(chunk, executionContext, styleSheet) {
  if (Array.isArray(chunk)) {
    var ruleSet = [];

    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
      result = flatten(chunk[i], executionContext, styleSheet);

      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
    }

    return ruleSet;
  }

  if (isFalsish(chunk)) {
    return null;
  }

  /* Handle other components */
  if (isStyledComponent(chunk)) {
    return '.' + chunk.styledComponentId;
  }

  /* Either execute or defer the function */
  if (styled_components_browser_esm_isFunction(chunk)) {
    if (isStatelessFunction(chunk) && executionContext) {
      var _result = chunk(executionContext);

      if (false) {}

      return flatten(_result, executionContext, styleSheet);
    } else return chunk;
  }

  if (chunk instanceof Keyframes) {
    if (styleSheet) {
      chunk.inject(styleSheet);
      return chunk.getName();
    } else return chunk;
  }

  /* Handle objects */
  return styled_components_browser_esm_isPlainObject(chunk) ? objToCssArray(chunk) : chunk.toString();
}

// 

function css(styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (styled_components_browser_esm_isFunction(styles) || styled_components_browser_esm_isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
}

// 

function constructWithOptions(componentConstructor, tag) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  if (!(0,react_is.isValidElementType)(tag)) {
    throw new StyledComponentsError(1, String(tag));
  }

  /* This is callable directly as a template function */
  // $FlowFixMe: Not typed to avoid destructuring arguments
  var templateFunction = function templateFunction() {
    return componentConstructor(tag, options, css.apply(undefined, arguments));
  };

  /* If config methods are called, wrap up a new template function and merge options */
  templateFunction.withConfig = function (config) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
  };

  /* Modify/inject new props at runtime */
  templateFunction.attrs = function (attrs) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
      attrs: Array.prototype.concat(options.attrs, attrs).filter(Boolean)
    }));
  };

  return templateFunction;
}

// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(c) {
  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
  }
  switch (e) {
    case 3:
      a ^= (c.charCodeAt(d + 2) & 255) << 16;
    case 2:
      a ^= (c.charCodeAt(d + 1) & 255) << 8;
    case 1:
      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  }
  a ^= a >>> 13;
  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  return (a ^ a >>> 15) >>> 0;
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
}

// 

function hasFunctionObjectKey(obj) {
  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (var key in obj) {
    if (styled_components_browser_esm_isFunction(obj[key])) {
      return true;
    }
  }

  return false;
}

function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule, attrs)) {
      return false;
    } else if (styled_components_browser_esm_isFunction(rule) && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs.some(function (x) {
    return styled_components_browser_esm_isFunction(x) || hasFunctionObjectKey(x);
  })) return false;

  return true;
}

// 

/* combines hashStr (murmurhash) and nameGenerator for convenience */
var hasher = function hasher(str) {
  return generateAlphabeticName(murmurhash(str));
};

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */

var ComponentStyle = function () {
  function ComponentStyle(rules, attrs, componentId) {
    classCallCheck(this, ComponentStyle);

    this.rules = rules;
    this.isStatic =  true && isStaticRules(rules, attrs);
    this.componentId = componentId;

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  /*
   * Flattens a rule set into valid CSS
   * Hashes it, wraps the whole chunk in a .hash1234 {}
   * Returns the hash to be injected on render()
   * */


  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
    var isStatic = this.isStatic,
        componentId = this.componentId,
        lastClassName = this.lastClassName;

    if (IS_BROWSER && isStatic && typeof lastClassName === 'string' && styleSheet.hasNameForId(componentId, lastClassName)) {
      return lastClassName;
    }

    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var name = hasher(this.componentId + flatCSS.join(''));
    if (!styleSheet.hasNameForId(componentId, name)) {
      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
    }

    this.lastClassName = name;
    return name;
  };

  ComponentStyle.generateName = function generateName(str) {
    return hasher(str);
  };

  return ComponentStyle;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs(props => ({\n' + '    style: {\n' + '      background: props.background,\n' + '    },\n' + '  }))`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function styled_components_browser_esm_escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function isTag(target) {
  return typeof target === 'string' && ( false ? 0 : true);
}

// 

function generateDisplayName(target) {
  // $FlowFixMe
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

var _TYPE_STATICS;

var REACT_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDerivedStateFromProps: true,
  propTypes: true,
  type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[react_is.ForwardRef] = {
  $$typeof: true,
  render: true
}, _TYPE_STATICS);

var defineProperty$1 = Object.defineProperty,
    getOwnPropertyNames = Object.getOwnPropertyNames,
    _Object$getOwnPropert = Object.getOwnPropertySymbols,
    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
  return [];
} : _Object$getOwnPropert,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
    getPrototypeOf = Object.getPrototypeOf,
    objectPrototype = Object.prototype;
var arrayPrototype = Array.prototype;


function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components

    var inheritedComponent = getPrototypeOf(sourceComponent);

    if (inheritedComponent && inheritedComponent !== objectPrototype) {
      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
    }

    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
    // $FlowFixMe
    getOwnPropertySymbols(sourceComponent));

    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;

    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;

    var i = keys.length;
    var descriptor = void 0;
    var key = void 0;

    // eslint-disable-next-line no-plusplus
    while (i--) {
      key = keys[i];

      if (
      // $FlowFixMe
      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
      // $FlowFixMe
      !(targetStatics && targetStatics[key])) {
        descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        if (descriptor) {
          try {
            // Avoid failures from read-only properties
            defineProperty$1(targetComponent, key, descriptor);
          } catch (e) {
            /* fail silently */
          }
        }
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

// 
function isDerivedReactComponent(fn) {
  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb.apply(undefined, arguments);
    }
  };
});

// 

var ThemeContext = (0,react.createContext)();

var ThemeConsumer = ThemeContext.Consumer;

/**
 * Provide a theme to an entire react component tree via context
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider(props) {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = (0,memoize_one_esm/* default */.Z)(_this.getContext.bind(_this));
    _this.renderInner = _this.renderInner.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) return null;

    return react.createElement(
      ThemeContext.Consumer,
      null,
      this.renderInner
    );
  };

  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
    var context = this.getContext(this.props.theme, outerTheme);

    return react.createElement(
      ThemeContext.Provider,
      { value: context },
      this.props.children
    );
  };

  /**
   * Get the theme from the props, supporting both (outerTheme) => {}
   * as well as object notation
   */


  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
    if (styled_components_browser_esm_isFunction(theme)) {
      var mergedTheme = theme(outerTheme);

      if (false) {}

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, outerTheme, theme);
  };

  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
    return this.getTheme(theme, outerTheme);
  };

  return ThemeProvider;
}(react.Component);

// 

var CLOSING_TAG_R = /^\s*<\/[a-z]/i;

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.sealed = false;
  }

  /**
   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
   * StyleSheet singleton.
   */


  ServerStyleSheet.prototype.seal = function seal() {
    if (!this.sealed) {
      /* Remove sealed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.sealed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.sealed) {
      throw new StyledComponentsError(2);
    }

    return react.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.seal();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.seal();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        var renderedHtml = chunk.toString();

        /* prepend style html to chunk, unless the start of the chunk is a closing tag in which case append right after that */
        if (CLOSING_TAG_R.test(renderedHtml)) {
          var endOfClosingTag = renderedHtml.indexOf('>');

          this.push(renderedHtml.slice(0, endOfClosingTag + 1) + html + renderedHtml.slice(endOfClosingTag + 1));
        } else this.push(html + renderedHtml);

        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.seal();
    });

    readableStream.on('error', function (err) {
      _this.seal();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var StyleSheetContext = (0,react.createContext)();
var StyleSheetConsumer = StyleSheetContext.Consumer;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager(props) {
    classCallCheck(this, StyleSheetManager);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = (0,memoize_one_esm/* default */.Z)(_this.getContext);
    return _this;
  }

  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
    if (sheet) {
      return sheet;
    } else if (target) {
      return new StyleSheet(target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        sheet = _props.sheet,
        target = _props.target;


    return react.createElement(
      StyleSheetContext.Provider,
      { value: this.getContext(sheet, target) },
       false ? 0 : children
    );
  };

  return StyleSheetManager;
}(react.Component);
 false ? 0 : void 0;

// 

var identifiers = {};

/* We depend on components having unique IDs */
function generateId(_ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : styled_components_browser_esm_escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);

  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
}

// $FlowFixMe

var StyledComponent = function (_Component) {
  inherits(StyledComponent, _Component);

  function StyledComponent() {
    classCallCheck(this, StyledComponent);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.attrs = {};

    _this.renderOuter = _this.renderOuter.bind(_this);
    _this.renderInner = _this.renderInner.bind(_this);

    if (false) {}
    return _this;
  }

  StyledComponent.prototype.render = function render() {
    return react.createElement(
      StyleSheetConsumer,
      null,
      this.renderOuter
    );
  };

  StyledComponent.prototype.renderOuter = function renderOuter() {
    var styleSheet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : StyleSheet.master;

    this.styleSheet = styleSheet;

    // No need to subscribe a static component to theme changes, it won't change anything
    if (this.props.forwardedComponent.componentStyle.isStatic) return this.renderInner();

    return react.createElement(
      ThemeConsumer,
      null,
      this.renderInner
    );
  };

  StyledComponent.prototype.renderInner = function renderInner(theme) {
    var _props$forwardedCompo = this.props.forwardedComponent,
        componentStyle = _props$forwardedCompo.componentStyle,
        defaultProps = _props$forwardedCompo.defaultProps,
        displayName = _props$forwardedCompo.displayName,
        foldedComponentIds = _props$forwardedCompo.foldedComponentIds,
        styledComponentId = _props$forwardedCompo.styledComponentId,
        target = _props$forwardedCompo.target;


    var generatedClassName = void 0;
    if (componentStyle.isStatic) {
      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props);
    } else {
      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps) || EMPTY_OBJECT, this.props);
    }

    var elementToBeCreated = this.props.as || this.attrs.as || target;
    var isTargetTag = isTag(elementToBeCreated);

    var propsForElement = {};
    var computedProps = _extends({}, this.props, this.attrs);

    var key = void 0;
    // eslint-disable-next-line guard-for-in
    for (key in computedProps) {
      if (false) {}

      if (key === 'forwardedComponent' || key === 'as') {
        continue;
      } else if (key === 'forwardedRef') propsForElement.ref = computedProps[key];else if (key === 'forwardedAs') propsForElement.as = computedProps[key];else if (!isTargetTag || is_prop_valid_browser_esm(key)) {
        // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = computedProps[key];
      }
    }

    if (this.props.style && this.attrs.style) {
      propsForElement.style = _extends({}, this.attrs.style, this.props.style);
    }

    propsForElement.className = Array.prototype.concat(foldedComponentIds, styledComponentId, generatedClassName !== styledComponentId ? generatedClassName : null, this.props.className, this.attrs.className).filter(Boolean).join(' ');

    return (0,react.createElement)(elementToBeCreated, propsForElement);
  };

  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
    var _this2 = this;

    var context = _extends({}, props, { theme: theme });

    if (!attrs.length) return context;

    this.attrs = {};

    attrs.forEach(function (attrDef) {
      var resolvedAttrDef = attrDef;
      var attrDefWasFn = false;
      var attr = void 0;
      var key = void 0;

      if (styled_components_browser_esm_isFunction(resolvedAttrDef)) {
        // $FlowFixMe
        resolvedAttrDef = resolvedAttrDef(context);
        attrDefWasFn = true;
      }

      /* eslint-disable guard-for-in */
      // $FlowFixMe
      for (key in resolvedAttrDef) {
        attr = resolvedAttrDef[key];

        if (!attrDefWasFn) {
          if (styled_components_browser_esm_isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr)) {
            if (false) {}

            attr = attr(context);

            if (false) {}
          }
        }

        _this2.attrs[key] = attr;
        context[key] = attr;
      }
      /* eslint-enable */
    });

    return context;
  };

  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _props$forwardedCompo2 = props.forwardedComponent,
        attrs = _props$forwardedCompo2.attrs,
        componentStyle = _props$forwardedCompo2.componentStyle,
        warnTooManyClasses = _props$forwardedCompo2.warnTooManyClasses;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names

    if (componentStyle.isStatic && !attrs.length) {
      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, this.styleSheet);
    }

    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, attrs), this.styleSheet);

    if (false) {}

    return className;
  };

  return StyledComponent;
}(react.Component);

function createStyledComponent(target, options, rules) {
  var isTargetStyledComp = isStyledComponent(target);
  var isClass = !isTag(target);

  var _options$displayName = options.displayName,
      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
      _options$componentId = options.componentId,
      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
      _options$ParentCompon = options.ParentComponent,
      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
      _options$attrs = options.attrs,
      attrs = _options$attrs === undefined ? EMPTY_ARRAY : _options$attrs;


  var styledComponentId = options.displayName && options.componentId ? styled_components_browser_esm_escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

  // fold the underlying StyledComponent attrs up (implicit extend)
  var finalAttrs =
  // $FlowFixMe
  isTargetStyledComp && target.attrs ? Array.prototype.concat(target.attrs, attrs).filter(Boolean) : attrs;

  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
  // $FlowFixMe
  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);

  /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */
  var WrappedStyledComponent = void 0;
  var forwardRef = function forwardRef(props, ref) {
    return react.createElement(ParentComponent, _extends({}, props, { forwardedComponent: WrappedStyledComponent, forwardedRef: ref }));
  };
  forwardRef.displayName = displayName;
  WrappedStyledComponent = react.forwardRef(forwardRef);
  WrappedStyledComponent.displayName = displayName;

  // $FlowFixMe
  WrappedStyledComponent.attrs = finalAttrs;
  // $FlowFixMe
  WrappedStyledComponent.componentStyle = componentStyle;

  // $FlowFixMe
  WrappedStyledComponent.foldedComponentIds = isTargetStyledComp ? // $FlowFixMe
  Array.prototype.concat(target.foldedComponentIds, target.styledComponentId) : EMPTY_ARRAY;

  // $FlowFixMe
  WrappedStyledComponent.styledComponentId = styledComponentId;

  // fold the underlying StyledComponent target up since we folded the styles
  // $FlowFixMe
  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;

  // $FlowFixMe
  WrappedStyledComponent.withComponent = function withComponent(tag) {
    var previousComponentId = options.componentId,
        optionsToCopy = objectWithoutProperties(options, ['componentId']);


    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : styled_components_browser_esm_escape(getComponentName(tag)));

    var newOptions = _extends({}, optionsToCopy, {
      attrs: finalAttrs,
      componentId: newComponentId,
      ParentComponent: ParentComponent
    });

    return createStyledComponent(tag, newOptions, rules);
  };

  // $FlowFixMe
  Object.defineProperty(WrappedStyledComponent, 'defaultProps', {
    get: function get$$1() {
      return this._foldedDefaultProps;
    },
    set: function set$$1(obj) {
      // $FlowFixMe
      this._foldedDefaultProps = isTargetStyledComp ? index_esm(target.defaultProps, obj) : obj;
    }
  });

  if (false) {}

  // $FlowFixMe
  WrappedStyledComponent.toString = function () {
    return '.' + WrappedStyledComponent.styledComponentId;
  };

  if (isClass) {
    hoistNonReactStatics(WrappedStyledComponent, target, {
      // all SC-specific things should not be hoisted
      attrs: true,
      componentStyle: true,
      displayName: true,
      foldedComponentIds: true,
      styledComponentId: true,
      target: true,
      withComponent: true
    });
  }

  return WrappedStyledComponent;
}

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'marker', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var styled = function styled(tag) {
  return constructWithOptions(createStyledComponent, tag);
};

// Shorthands for all valid HTML Elements
domElements.forEach(function (domElement) {
  styled[domElement] = styled(domElement);
});

// 

var GlobalStyle = function () {
  function GlobalStyle(rules, componentId) {
    classCallCheck(this, GlobalStyle);

    this.rules = rules;
    this.componentId = componentId;
    this.isStatic = isStaticRules(rules, EMPTY_ARRAY);

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var css = stringifyRules(flatCSS, '');

    styleSheet.inject(this.componentId, css);
  };

  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
    var componentId = this.componentId;

    if (styleSheet.hasId(componentId)) {
      styleSheet.remove(componentId);
    }
  };

  // TODO: overwrite in-place instead of remove+create?


  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
    this.removeStyles(styleSheet);
    this.createStyles(executionContext, styleSheet);
  };

  return GlobalStyle;
}();

// 

// place our cache into shared context so it'll persist between HMRs
if (IS_BROWSER) {
  window.scCGSHMRCache = {};
}

function createGlobalStyle(strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));
  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
  var style = new GlobalStyle(rules, id);

  var GlobalStyleComponent = function (_React$Component) {
    inherits(GlobalStyleComponent, _React$Component);

    function GlobalStyleComponent(props) {
      classCallCheck(this, GlobalStyleComponent);

      var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

      var _this$constructor = _this.constructor,
          globalStyle = _this$constructor.globalStyle,
          styledComponentId = _this$constructor.styledComponentId;


      if (IS_BROWSER) {
        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
      }

      /**
       * This fixes HMR compatibility. Don't ask me why, but this combination of
       * caching the closure variables via statics and then persisting the statics in
       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
       */
      _this.state = {
        globalStyle: globalStyle,
        styledComponentId: styledComponentId
      };
      return _this;
    }

    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      if (window.scCGSHMRCache[this.state.styledComponentId]) {
        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
      }
      /**
       * Depending on the order "render" is called this can cause the styles to be lost
       * until the next render pass of the remaining instance, which may
       * not be immediate.
       */
      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
        this.state.globalStyle.removeStyles(this.styleSheet);
      }
    };

    GlobalStyleComponent.prototype.render = function render() {
      var _this2 = this;

      if (false) {}

      return react.createElement(
        StyleSheetConsumer,
        null,
        function (styleSheet) {
          _this2.styleSheet = styleSheet || StyleSheet.master;

          var globalStyle = _this2.state.globalStyle;


          if (globalStyle.isStatic) {
            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);

            return null;
          } else {
            return react.createElement(
              ThemeConsumer,
              null,
              function (theme) {
                // $FlowFixMe
                var defaultProps = _this2.constructor.defaultProps;


                var context = _extends({}, _this2.props);

                if (typeof theme !== 'undefined') {
                  context.theme = determineTheme(_this2.props, theme, defaultProps);
                }

                globalStyle.renderStyles(context, _this2.styleSheet);

                return null;
              }
            );
          }
        }
      );
    };

    return GlobalStyleComponent;
  }(react.Component);

  GlobalStyleComponent.globalStyle = style;
  GlobalStyleComponent.styledComponentId = id;


  return GlobalStyleComponent;
}

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

function keyframes(strings) {
  /* Warning if you've used keyframes on React Native */
  if (false) {}

  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));

  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));

  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
}

// 

var withTheme = (function (Component$$1) {
  var WithTheme = react.forwardRef(function (props, ref) {
    return react.createElement(
      ThemeConsumer,
      null,
      function (theme) {
        // $FlowFixMe
        var defaultProps = Component$$1.defaultProps;

        var themeProp = determineTheme(props, theme, defaultProps);

        if (false) {}

        return react.createElement(Component$$1, _extends({}, props, { theme: themeProp, ref: ref }));
      }
    );
  });

  hoistNonReactStatics(WithTheme, Component$$1);

  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';

  return WithTheme;
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {}

/* Warning if there are several instances of styled-components */
if (false) {}

//

/* harmony default export */ var styled_components_browser_esm = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 5888:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}__webpack_unused_export__=l;__webpack_unused_export__=m;__webpack_unused_export__=k;__webpack_unused_export__=h;__webpack_unused_export__=c;exports.ForwardRef=n;__webpack_unused_export__=e;__webpack_unused_export__=t;__webpack_unused_export__=r;__webpack_unused_export__=d;
__webpack_unused_export__=g;__webpack_unused_export__=f;__webpack_unused_export__=p;__webpack_unused_export__=function(a){return A(a)||z(a)===l};__webpack_unused_export__=A;__webpack_unused_export__=function(a){return z(a)===k};__webpack_unused_export__=function(a){return z(a)===h};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};__webpack_unused_export__=function(a){return z(a)===n};__webpack_unused_export__=function(a){return z(a)===e};__webpack_unused_export__=function(a){return z(a)===t};
__webpack_unused_export__=function(a){return z(a)===r};__webpack_unused_export__=function(a){return z(a)===d};__webpack_unused_export__=function(a){return z(a)===g};__webpack_unused_export__=function(a){return z(a)===f};__webpack_unused_export__=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};__webpack_unused_export__=z;


/***/ }),

/***/ 40775:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(5888);
} else {}


/***/ }),

/***/ 52474:
/***/ (function(module) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		0
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),

/***/ 95703:
/***/ (function(module) {

!function(e){ true?module.exports=e(null):0}(function e(a){"use strict";var r=/^\0+/g,c=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,p=/::(place)/g,k=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,C=/(\{[^{]+?);(?=\})/g,w=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z=/([^-])(image-set\()/,N="-webkit-",S="-moz-",F="-ms-",W=59,q=125,B=123,D=40,E=41,G=91,H=93,I=10,J=13,K=9,L=64,M=32,P=38,Q=45,R=95,T=42,U=44,V=58,X=39,Y=34,Z=47,_=62,ee=43,ae=126,re=0,ce=12,se=11,te=107,ie=109,fe=115,ne=112,le=111,oe=105,he=99,ue=100,de=112,be=1,pe=1,ke=0,ge=1,Ae=1,Ce=1,we=0,ve=0,me=0,xe=[],$e=[],ye=0,Oe=null,je=-2,ze=-1,Ne=0,Se=1,Fe=2,We=3,qe=0,Be=1,De="",Ee="",Ge="";function He(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,C=0,w=0,m=0,$=0,y=0,O=0,j=0,z=0,R=0,we=0,$e=0,Oe=0,je=0,ze=s.length,Je=ze-1,Re="",Te="",Ue="",Ve="",Xe="",Ye="";R<ze;){if(C=s.charCodeAt(R),R===Je)if(h+d+u+o!==0){if(0!==h)C=h===Z?I:Z;d=u=o=0,ze++,Je++}if(h+d+u+o===0){if(R===Je){if(we>0)Te=Te.replace(c,"");if(Te.trim().length>0){switch(C){case M:case K:case W:case J:case I:break;default:Te+=s.charAt(R)}C=W}}if(1===$e)switch(C){case B:case q:case W:case Y:case X:case D:case E:case U:$e=0;case K:case J:case I:case M:break;default:for($e=0,je=R,g=C,R--,C=W;je<ze;)switch(s.charCodeAt(je++)){case I:case J:case W:++R,C=g,je=ze;break;case V:if(we>0)++R,C=g;case B:je=ze}}switch(C){case B:for(g=(Te=Te.trim()).charCodeAt(0),y=1,je=++R;R<ze;){switch(C=s.charCodeAt(R)){case B:y++;break;case q:y--;break;case Z:switch(A=s.charCodeAt(R+1)){case T:case Z:R=Qe(A,R,Je,s)}break;case G:C++;case D:C++;case Y:case X:for(;R++<Je&&s.charCodeAt(R)!==C;);}if(0===y)break;R++}if(Ue=s.substring(je,R),g===re)g=(Te=Te.replace(r,"").trim()).charCodeAt(0);switch(g){case L:if(we>0)Te=Te.replace(c,"");switch(A=Te.charCodeAt(1)){case ue:case ie:case fe:case Q:f=a;break;default:f=xe}if(je=(Ue=He(a,f,Ue,A,i+1)).length,me>0&&0===je)je=Te.length;if(ye>0)if(f=Ie(xe,Te,Oe),n=Pe(We,Ue,f,a,pe,be,je,A,i,t),Te=f.join(""),void 0!==n)if(0===(je=(Ue=n.trim()).length))A=0,Ue="";if(je>0)switch(A){case fe:Te=Te.replace(x,Me);case ue:case ie:case Q:Ue=Te+"{"+Ue+"}";break;case te:if(Ue=(Te=Te.replace(b,"$1 $2"+(Be>0?De:"")))+"{"+Ue+"}",1===Ae||2===Ae&&Le("@"+Ue,3))Ue="@"+N+Ue+"@"+Ue;else Ue="@"+Ue;break;default:if(Ue=Te+Ue,t===de)Ve+=Ue,Ue=""}else Ue="";break;default:Ue=He(a,Ie(a,Te,Oe),Ue,t,i+1)}Xe+=Ue,O=0,$e=0,z=0,we=0,Oe=0,j=0,Te="",Ue="",C=s.charCodeAt(++R);break;case q:case W:if((je=(Te=(we>0?Te.replace(c,""):Te).trim()).length)>1){if(0===z)if((g=Te.charCodeAt(0))===Q||g>96&&g<123)je=(Te=Te.replace(" ",":")).length;if(ye>0)if(void 0!==(n=Pe(Se,Te,a,e,pe,be,Ve.length,t,i,t)))if(0===(je=(Te=n.trim()).length))Te="\0\0";switch(g=Te.charCodeAt(0),A=Te.charCodeAt(1),g){case re:break;case L:if(A===oe||A===he){Ye+=Te+s.charAt(R);break}default:if(Te.charCodeAt(je-1)===V)break;Ve+=Ke(Te,g,A,Te.charCodeAt(2))}}O=0,$e=0,z=0,we=0,Oe=0,Te="",C=s.charCodeAt(++R)}}switch(C){case J:case I:if(h+d+u+o+ve===0)switch($){case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case W:case B:case q:break;default:if(z>0)$e=1}if(h===Z)h=0;else if(ge+O===0&&t!==te&&Te.length>0)we=1,Te+="\0";if(ye*qe>0)Pe(Ne,Te,a,e,pe,be,Ve.length,t,i,t);be=1,pe++;break;case W:case q:if(h+d+u+o===0){be++;break}default:switch(be++,Re=s.charAt(R),C){case K:case M:if(d+o+h===0)switch(w){case U:case V:case K:case M:Re="";break;default:if(C!==M)Re=" "}break;case re:Re="\\0";break;case ce:Re="\\f";break;case se:Re="\\v";break;case P:if(d+h+o===0&&ge>0)Oe=1,we=1,Re="\f"+Re;break;case 108:if(d+h+o+ke===0&&z>0)switch(R-z){case 2:if(w===ne&&s.charCodeAt(R-3)===V)ke=w;case 8:if(m===le)ke=m}break;case V:if(d+h+o===0)z=R;break;case U:if(h+u+d+o===0)we=1,Re+="\r";break;case Y:case X:if(0===h)d=d===C?0:0===d?C:d;break;case G:if(d+h+u===0)o++;break;case H:if(d+h+u===0)o--;break;case E:if(d+h+o===0)u--;break;case D:if(d+h+o===0){if(0===O)switch(2*w+3*m){case 533:break;default:y=0,O=1}u++}break;case L:if(h+u+d+o+z+j===0)j=1;break;case T:case Z:if(d+o+u>0)break;switch(h){case 0:switch(2*C+3*s.charCodeAt(R+1)){case 235:h=Z;break;case 220:je=R,h=T}break;case T:if(C===Z&&w===T&&je+2!==R){if(33===s.charCodeAt(je+2))Ve+=s.substring(je,R+1);Re="",h=0}}}if(0===h){if(ge+d+o+j===0&&t!==te&&C!==W)switch(C){case U:case ae:case _:case ee:case E:case D:if(0===O){switch(w){case K:case M:case I:case J:Re+="\0";break;default:Re="\0"+Re+(C===U?"":"\0")}we=1}else switch(C){case D:if(z+7===R&&108===w)z=0;O=++y;break;case E:if(0==(O=--y))we=1,Re+="\0"}break;case K:case M:switch(w){case re:case B:case q:case W:case U:case ce:case K:case M:case I:case J:break;default:if(0===O)we=1,Re+="\0"}}if(Te+=Re,C!==M&&C!==K)$=C}}m=w,w=C,R++}if(je=Ve.length,me>0)if(0===je&&0===Xe.length&&0===a[0].length==false)if(t!==ie||1===a.length&&(ge>0?Ee:Ge)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===ge&&t!==te?function(e){for(var a,r,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(r=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=r.charCodeAt(0),a="",0!==o)switch(u){case T:case ae:case _:case ee:case M:case D:break;default:a=" "}switch(d){case P:r=a+Ee;case ae:case _:case ee:case M:case E:case D:break;case G:r=a+r+Ee;break;case V:switch(2*r.charCodeAt(1)+3*r.charCodeAt(2)){case 530:if(Ce>0){r=a+r.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)r=a+Ee+r}break;case U:a="";default:if(h>1&&r.indexOf(":")>0)r=a+r.replace(v,"$1"+Ee+"$2");else r=a+r+Ee}n+=r}i[s]=n.replace(c,"").trim()}return i}(a):a,ye>0)if(void 0!==(n=Pe(Fe,Ve,f,e,pe,be,je,t,i,t))&&0===(Ve=n).length)return Ye+Ve+Xe;if(Ve=f.join(",")+"{"+Ve+"}",Ae*ke!=0){if(2===Ae&&!Le(Ve,2))ke=0;switch(ke){case le:Ve=Ve.replace(k,":"+S+"$1")+Ve;break;case ne:Ve=Ve.replace(p,"::"+N+"input-$1")+Ve.replace(p,"::"+S+"$1")+Ve.replace(p,":"+F+"input-$1")+Ve}ke=0}}return Ye+Ve+Xe}function Ie(e,a,r){var c=a.trim().split(o),s=c,t=c.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Je(n,s[f],r,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Je(e[h]+" ",c[f],r,i).trim()}return s}function Je(e,a,r,c){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case P:switch(ge+c){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case V:switch(s.charCodeAt(1)){case 103:if(Ce>0&&ge>0)return s.replace(u,"$1").replace(h,"$1"+Ge);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(r*ge>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===V?"":"$1")+e.trim())}return e+s}function Ke(e,a,r,c){var l,o=0,h=e+";",u=2*a+3*r+4*c;if(944===u)return function(e){var a=e.length,r=e.indexOf(":",9)+1,c=e.substring(0,r).trim(),s=e.substring(r,a-1).trim();switch(e.charCodeAt(9)*Be){case 0:break;case Q:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,r=0,a=t.length;i<a;r=0,++i){for(var l=t[i],o=l.split(n);l=o[r];){var h=l.charCodeAt(0);if(1===Be&&(h>L&&h<90||h>96&&h<123||h===R||h===Q&&l.charCodeAt(1)!==Q))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=De}}o[r++]=l}s+=(0===i?"":",")+o.join(" ")}}if(s=c+s+";",1===Ae||2===Ae&&Le(s,1))return N+s+s;return s}(h);else if(0===Ae||2===Ae&&!Le(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?N+h+h:h;case 951:return 116===h.charCodeAt(3)?N+h+h:h;case 963:return 110===h.charCodeAt(5)?N+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return N+h+h;case 978:return N+h+S+h+h;case 1019:case 983:return N+h+S+h+F+h+h;case 883:if(h.charCodeAt(8)===Q)return N+h+h;if(h.indexOf("image-set(",11)>0)return h.replace(z,"$1"+N+"$2")+h;return h;case 932:if(h.charCodeAt(4)===Q)switch(h.charCodeAt(5)){case 103:return N+"box-"+h.replace("-grow","")+N+h+F+h.replace("grow","positive")+h;case 115:return N+h+F+h.replace("shrink","negative")+h;case 98:return N+h+F+h.replace("basis","preferred-size")+h}return N+h+F+h+h;case 964:return N+h+F+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),N+"box-pack"+l+N+h+F+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+N)+h.replace(s,":"+S)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return N+h+F+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,N+l)+";"+h;break;case 207:case 102:h=h.replace(l,N+(u>102?"inline-":"")+"box")+";"+h.replace(l,N+l)+";"+h.replace(l,F+l+"box")+";"+h}return h+";";case 938:if(h.charCodeAt(5)===Q)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),N+h+N+"box-"+l+F+"flex-"+l+h;case 115:return N+h+F+"flex-item-"+h.replace(y,"")+h;default:return N+h+F+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==Q||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Ke(e.replace("stretch","fill-available"),a,r,c).replace(":fill-available",":stretch");else return h.replace(l,N+l)+h.replace(l,S+l.replace("fill-",""))+h;break;case 962:if(h=N+h+(102===h.charCodeAt(5)?F+h:"")+h,r+c===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+N+"$2")+h}return h}function Le(e,a){var r=e.indexOf(1===a?":":"{"),c=e.substring(0,3!==a?r:10),s=e.substring(r+1,e.length-1);return Oe(2!==a?c:c.replace(O,"$1"),s,a)}function Me(e,a){var r=Ke(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return r!==a+";"?r.replace($," or ($1)").substring(4):"("+a+")"}function Pe(e,a,r,c,s,t,i,f,n,l){for(var o,h=0,u=a;h<ye;++h)switch(o=$e[h].call(Te,e,u,r,c,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o}if(u!==a)return u}function Qe(e,a,r,c){for(var s=a+1;s<r;++s)switch(c.charCodeAt(s)){case Z:if(e===T)if(c.charCodeAt(s-1)===T&&a+2!==s)return s+1;break;case I:if(e===Z)return s+1}return s}function Re(e){for(var a in e){var r=e[a];switch(a){case"keyframe":Be=0|r;break;case"global":Ce=0|r;break;case"cascade":ge=0|r;break;case"compress":we=0|r;break;case"semicolon":ve=0|r;break;case"preserve":me=0|r;break;case"prefix":if(Oe=null,!r)Ae=0;else if("function"!=typeof r)Ae=1;else Ae=2,Oe=r}}return Re}function Te(a,r){if(void 0!==this&&this.constructor===Te)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(Be>0)De=s.replace(d,t===G?"":"-");if(t=1,1===ge)Ge=s;else Ee=s;var i,f=[Ge];if(ye>0)if(void 0!==(i=Pe(ze,r,f,f,pe,be,0,0,0,0))&&"string"==typeof i)r=i;var n=He(xe,f,r,0,0);if(ye>0)if(void 0!==(i=Pe(je,n,f,f,pe,be,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return De="",Ge="",Ee="",ke=0,pe=1,be=1,we*t==0?n:n.replace(c,"").replace(g,"").replace(A,"$1").replace(C,"$1").replace(w," ")}if(Te.use=function e(a){switch(a){case void 0:case null:ye=$e.length=0;break;default:if("function"==typeof a)$e[ye++]=a;else if("object"==typeof a)for(var r=0,c=a.length;r<c;++r)e(a[r]);else qe=0|!!a}return e},Te.set=Re,void 0!==a)Re(a);return Te});
//# sourceMappingURL=stylis.min.js.map

/***/ }),

/***/ 90567:
/***/ (function(module) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;


/***/ }),

/***/ 24819:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var v1 = __webpack_require__(98633);
var v4 = __webpack_require__(72516);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),

/***/ 80026:
/***/ (function(module) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),

/***/ 51814:
/***/ (function(module) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),

/***/ 98633:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var rng = __webpack_require__(51814);
var bytesToUuid = __webpack_require__(80026);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),

/***/ 72516:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var rng = __webpack_require__(51814);
var bytesToUuid = __webpack_require__(80026);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),

/***/ 14062:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isString = __webpack_require__(91770);
var isNumber = __webpack_require__(28038);
var isBoolean = __webpack_require__(4836);
var isSymbol = __webpack_require__(44582);
var isBigInt = __webpack_require__(84155);

// eslint-disable-next-line consistent-return
module.exports = function whichBoxedPrimitive(value) {
	// eslint-disable-next-line eqeqeq
	if (value == null || (typeof value !== 'object' && typeof value !== 'function')) {
		return null;
	}
	if (isString(value)) {
		return 'String';
	}
	if (isNumber(value)) {
		return 'Number';
	}
	if (isBoolean(value)) {
		return 'Boolean';
	}
	if (isSymbol(value)) {
		return 'Symbol';
	}
	if (isBigInt(value)) {
		return 'BigInt';
	}
};


/***/ }),

/***/ 49154:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var forEach = __webpack_require__(77025);
var availableTypedArrays = __webpack_require__(23206);
var callBind = __webpack_require__(73235);
var callBound = __webpack_require__(47737);
var gOPD = __webpack_require__(41455);

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__(76686)();

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();

var $slice = callBound('String.prototype.slice');
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');

var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};
var cache = { __proto__: null };
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		if (Symbol.toStringTag in arr) {
			var proto = getPrototypeOf(arr);
			var descriptor = gOPD(proto, Symbol.toStringTag);
			if (!descriptor) {
				var superProto = getPrototypeOf(proto);
				descriptor = gOPD(superProto, Symbol.toStringTag);
			}
			cache['$' + typedArray] = callBind(descriptor.get);
		}
	});
} else {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		var fn = arr.slice || arr.set;
		if (fn) {
			cache['$' + typedArray] = callBind(fn);
		}
	});
}

var tryTypedArrays = function tryAllTypedArrays(value) {
	var found = false;
	forEach(cache, function (getter, typedArray) {
		if (!found) {
			try {
				if ('$' + getter(value) === typedArray) {
					found = $slice(typedArray, 1);
				}
			} catch (e) { /**/ }
		}
	});
	return found;
};

var trySlices = function tryAllSlices(value) {
	var found = false;
	forEach(cache, function (getter, name) {
		if (!found) {
			try {
				getter(value);
				found = $slice(name, 1);
			} catch (e) { /**/ }
		}
	});
	return found;
};

module.exports = function whichTypedArray(value) {
	if (!value || typeof value !== 'object') { return false; }
	if (!hasToStringTag) {
		var tag = $slice($toString(value), 8, -1);
		if ($indexOf(typedArrays, tag) > -1) {
			return tag;
		}
		if (tag !== 'Object') {
			return false;
		}
		// node < 0.6 hits here on real Typed Arrays
		return trySlices(value);
	}
	if (!gOPD) { return null; } // unknown engine
	return tryTypedArrays(value);
};


/***/ }),

/***/ 25980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H2": function() { return /* reexport */ esm/* Brand */.H2; },
  "qA": function() { return /* reexport */ esm/* Environment */.qA; },
  "SM": function() { return /* reexport */ esm/* ErrorCodes */.SM; },
  "z_": function() { return /* reexport */ Session; },
  "eA": function() { return /* reexport */ SessionProvider; },
  "$v": function() { return /* reexport */ SessionRedirect; },
  "Yc": function() { return /* reexport */ SessionRefresh; },
  "qb": function() { return /* reexport */ types_Status; },
  "Dy": function() { return /* reexport */ esm/* Type */.Dy; },
  "ON": function() { return /* reexport */ getMeFromStorage; },
  "D$": function() { return /* reexport */ esm/* getURLs */.D$; },
  "er": function() { return /* reexport */ usePasswordlessAuthentication; },
  "kP": function() { return /* reexport */ useSession_useSession; }
});

// UNUSED EXPORTS: AuthError, ErrorMessages, GoogleOTIntegration, IsAuthenticated, IsNotAuthenticated, MockSession, PasswordlessAuthenticationStatus, VerifyCodeResult, checkNewTeamViewUrlEnabled, mockAuthenticatedOutsideProduction, mockIdentity, saveMeToStorage, useGoogleOTIntegration, useToken

// NAMESPACE OBJECT: ../../../packages/lala-react/node_modules/axios/lib/platform/common/utils.js
var common_utils_namespaceObject = {};
__webpack_require__.r(common_utils_namespaceObject);
__webpack_require__.d(common_utils_namespaceObject, {
  "hasBrowserEnv": function() { return hasBrowserEnv; },
  "hasStandardBrowserEnv": function() { return hasStandardBrowserEnv; },
  "hasStandardBrowserWebWorkerEnv": function() { return hasStandardBrowserWebWorkerEnv; },
  "navigator": function() { return _navigator; },
  "origin": function() { return origin; }
});

// EXTERNAL MODULE: ../../../packages/lala-utils/dist/esm/index.js + 23 modules
var esm = __webpack_require__(82839);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/ApplicantEntity.js
var ApplicantEntity;
(function (ApplicantEntity) {
    ApplicantEntity["Person"] = "PERSON";
    ApplicantEntity["Company"] = "COMPANY";
    ApplicantEntity["Trust"] = "TRUST";
})(ApplicantEntity || (ApplicantEntity = {}));
//# sourceMappingURL=ApplicantEntity.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/ApplicantType.js
var ApplicantType;
(function (ApplicantType) {
    ApplicantType["Borrower"] = "BORROWER";
    ApplicantType["BorrowerAndGuarantor"] = "BORROWER_AND_GUARANTOR";
    ApplicantType["Guarantor"] = "GUARANTOR";
})(ApplicantType || (ApplicantType = {}));
//# sourceMappingURL=ApplicantType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Assets.js
var AssetType;
(function (AssetType) {
    AssetType["Property"] = "PROPERTY";
    AssetType["Vehicle"] = "VEHICLE";
    AssetType["HomeContents"] = "HOME_CONTENTS";
    AssetType["SavingCheckAccount"] = "SAVING_CHECK_ACCOUNT";
    AssetType["Superannuation"] = "SUPERANNUATION";
    AssetType["TermDeposit"] = "TERM_DEPOSIT";
    AssetType["Shares"] = "SHARES";
    AssetType["ManagedFunds"] = "MANAGED_FUNDS";
    AssetType["Gifts"] = "GIFTS";
    AssetType["OtherAsset"] = "OTHER_ASSET";
})(AssetType || (AssetType = {}));
var AssetPrimaryPurpose;
(function (AssetPrimaryPurpose) {
    AssetPrimaryPurpose["Investment"] = "INVESTMENT";
    AssetPrimaryPurpose["OwnerOccupied"] = "OWNER_OCCUPIED";
})(AssetPrimaryPurpose || (AssetPrimaryPurpose = {}));
//# sourceMappingURL=Assets.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/AuthOrigin.js
var AuthOrigin;
(function (AuthOrigin) {
    AuthOrigin["Passwordless"] = "passwordless";
    AuthOrigin["Domain"] = "domain";
    AuthOrigin["Google"] = "google";
})(AuthOrigin || (AuthOrigin = {}));
//# sourceMappingURL=AuthOrigin.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/AuthTokenFields.js
var AuthTokenFields;
(function (AuthTokenFields) {
    AuthTokenFields["UserId"] = "https://lendi/userId";
    AuthTokenFields["Type"] = "https://lendi/type";
    AuthTokenFields["Brand"] = "https://lendi/brand";
    AuthTokenFields["AuthApplications"] = "authorized-applications";
    AuthTokenFields["AuthCustomer"] = "authorized-customer";
    AuthTokenFields["Connection"] = "https://lendi/connection";
})(AuthTokenFields || (AuthTokenFields = {}));
//# sourceMappingURL=AuthTokenFields.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Brand.js
var Brand;
(function (Brand) {
    Brand["Lendi"] = "lendi";
    Brand["Domain"] = "domain";
    Brand["Aussie"] = "aussie";
})(Brand || (Brand = {}));
//# sourceMappingURL=Brand.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/BankingFeatures.js
var BankingFeatures;
(function (BankingFeatures) {
    BankingFeatures["ApplePay"] = "APPLE_PAY";
    BankingFeatures["BranchAccess"] = "BRANCH_ACCESS";
    BankingFeatures["CreditCard"] = "CREDIT_CARD";
    BankingFeatures["FeeFreeAtmTransactions"] = "FEE_FREE_ATM_TRANSACTIONS";
    BankingFeatures["GooglePay"] = "GOOGLE_PAY";
    BankingFeatures["InternetBanking"] = "INTERNET_BANKING";
    BankingFeatures["MobileApp"] = "MOBILE_APP";
    BankingFeatures["OpenToEverything"] = "OPEN_TO_EVERYTHING";
    BankingFeatures["SamsungPay"] = "SAMSUNG_PAY";
    BankingFeatures["UrgentTurnaround"] = "URGENT_TURNAROUND";
})(BankingFeatures || (BankingFeatures = {}));
//# sourceMappingURL=BankingFeatures.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/BrokerInterviews.js
var BenefitEnquiries;
(function (BenefitEnquiries) {
    BenefitEnquiries["Other"] = "OTHER";
    BenefitEnquiries["ProportionsInAssetsPurchased"] = "PROPORTION_IN_ASSETS_PURCHASED";
    BenefitEnquiries["RepayDebtsOrOtherObligations"] = "REPAY_DEBTS_OR_OTHER_OBLIGATIONS";
})(BenefitEnquiries || (BenefitEnquiries = {}));
var CoApplicantBenefit;
(function (CoApplicantBenefit) {
    CoApplicantBenefit["NoSubstantialBenefit"] = "NO_SUBSTANTIAL_BENEFIT";
    CoApplicantBenefit["NoSubstantialBenefitAndProceed"] = "NO_SUBSTANTIAL_BENEFIT_AND_PROCEED";
    CoApplicantBenefit["SubstantialBenefit"] = "SUBSTANTIAL_BENEFIT";
})(CoApplicantBenefit || (CoApplicantBenefit = {}));
var CoApplicantReason;
(function (CoApplicantReason) {
    CoApplicantReason["AccessToCashOrEquity"] = "ACCESS_TO_CASH_OR_EQUITY";
    CoApplicantReason["BuyingAVehicalWhereOnlyOneBorrowerCanBeTheRegisteredOwner"] = "BUYING_A_VEHICLE_WHERE_ONLY_ONE_BORROWER_CAN_BE_THE_REGISTERED_OWNER";
    CoApplicantReason["IndependentFinancialLegalOrAccountingAdviceRequired"] = "INDEPENDENT_FINANCIAL_LEGAL_OR_ACCOUNTING_ADVICE_RECEIVED";
    CoApplicantReason["SpousalAssetProtectionTaxBenefitsOrDebtReduction"] = "SPOUSAL_ASSET_PROTECTION_TAX_BENEFITS_OR_DEBT_REDUCTION";
    CoApplicantReason["SubstantialBenefitFromAtLeastOneOfTheLoanPurposes"] = "SUBSTANTIAL_BENEFIT_FROM_AT_LEAST_ONE_OF_THE_LOAN_PURPOSES";
})(CoApplicantReason || (CoApplicantReason = {}));
var DocumentationDeliveryMethod;
(function (DocumentationDeliveryMethod) {
    DocumentationDeliveryMethod["email"] = "EMAIL";
    DocumentationDeliveryMethod["post"] = "POST";
    DocumentationDeliveryMethod["collectFromNearestBranch"] = "COLLECT_FROM_NEAREST_BRANCH";
})(DocumentationDeliveryMethod || (DocumentationDeliveryMethod = {}));
var GuarantorLocationType;
(function (GuarantorLocationType) {
    GuarantorLocationType["lendiApprovedPhotoInterview"] = "LENDI_APPROVED_PHONE_INTERVIEW";
    GuarantorLocationType["faceToFace"] = "FACE_TO_FACE";
})(GuarantorLocationType || (GuarantorLocationType = {}));
var IndependentAdviceTypeRequired;
(function (IndependentAdviceTypeRequired) {
    IndependentAdviceTypeRequired["legalAdvice"] = "LEGAL_ADVICE";
    IndependentAdviceTypeRequired["financialAdvice"] = "FINANCIAL_ADVICE";
    IndependentAdviceTypeRequired["notNeeded"] = "NOT_NEEDED";
})(IndependentAdviceTypeRequired || (IndependentAdviceTypeRequired = {}));
var LocationType;
(function (LocationType) {
    LocationType["CustomerResidence"] = "CUSTOMER_RESIDENCE";
    LocationType["LendiApprovedPhoneInterview"] = "LENDI_APPROVED_PHONE_INTERVIEW";
    LocationType["Other"] = "OTHER";
})(LocationType || (LocationType = {}));
//# sourceMappingURL=BrokerInterviews.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Company.js
var CompanyStructure;
(function (CompanyStructure) {
    CompanyStructure["Corporation"] = "CORPORATION";
    CompanyStructure["Partnership"] = "PARTNERSHIP";
    CompanyStructure["SoleTrader"] = "SOLE_TRADER";
    CompanyStructure["Trust"] = "TRUST";
})(CompanyStructure || (CompanyStructure = {}));
var CompanyType;
(function (CompanyType) {
    CompanyType["Incorporated"] = "INCORPORATED";
    CompanyType["Ltd"] = "LTD";
    CompanyType["NL"] = "NL";
    CompanyType["PtyLtd"] = "PTY_LTD";
})(CompanyType || (CompanyType = {}));
//# sourceMappingURL=Company.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Confidence.js
var Confidence;
(function (Confidence) {
    Confidence["Low"] = "LOW";
    Confidence["MediumLow"] = "MEDIUM_LOW";
    Confidence["Medium"] = "MEDIUM";
    Confidence["MediumHigh"] = "MEDIUM_HIGH";
    Confidence["High"] = "HIGH";
})(Confidence || (Confidence = {}));
//# sourceMappingURL=Confidence.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Construction.js
var Construction;
(function (Construction) {
    Construction["BuildAProperty"] = "BUILD_A_PROPERTY";
    Construction["KnockdownRebuild"] = "KNOCKDOWN_REBUILD";
    Construction["StructuralRenovations"] = "STRUCTURAL_RENOVATIONS";
})(Construction || (Construction = {}));
//# sourceMappingURL=Construction.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/CreditStatus.js
var CreditStatus;
(function (CreditStatus) {
    CreditStatus["Fair"] = "FAIR";
    CreditStatus["Unknown"] = "UNKNOWN";
    CreditStatus["Average"] = "AVERAGE";
    CreditStatus["Excellent"] = "EXCELLENT";
})(CreditStatus || (CreditStatus = {}));
//# sourceMappingURL=CreditStatus.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/DesiredFeatures.js
var DesiredFeatures;
(function (DesiredFeatures) {
    DesiredFeatures["MobileApp"] = "MOBILE_APP";
    DesiredFeatures["MajorLender"] = "MAJOR_LENDER";
    DesiredFeatures["OffsetOrRedraw"] = "OFFSET_OR_REDRAW";
    DesiredFeatures["FixedRate"] = "FIXED_RATE";
})(DesiredFeatures || (DesiredFeatures = {}));
//# sourceMappingURL=DesiredFeatures.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/EligibleForFHOG.js
var EligibleForFHOG;
(function (EligibleForFHOG) {
    EligibleForFHOG["Yes"] = "YES";
    EligibleForFHOG["No"] = "NO";
    EligibleForFHOG["NotSure"] = "NOT_SURE";
})(EligibleForFHOG || (EligibleForFHOG = {}));
//# sourceMappingURL=EligibleForFHOG.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/EmploymentType.js
var EmploymentType;
(function (EmploymentType) {
    EmploymentType["Employee"] = "EMPLOYEE";
    EmploymentType["SelfEmployed"] = "SELF_EMPLOYED";
    EmploymentType["NotEmployed"] = "NOT_EMPLOYED";
    EmploymentType["Unknown"] = "UNKNOWN";
    EmploymentType["NotWorking"] = "NOT_WORKING";
})(EmploymentType || (EmploymentType = {}));
//# sourceMappingURL=EmploymentType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/FinancialSituation.js
var FinancialSituation;
(function (FinancialSituation) {
    FinancialSituation["ExtendedUnpaidLeave"] = "EXTENDED_UNPAID_LEAVE";
    FinancialSituation["IncreasedDebtRepaymentForExistingLoan"] = "INCREASED_DEBT_REPAYMENT_FOR_EXISTING_LOAN";
    FinancialSituation["LargeExpenditure"] = "LARGE_EXPENDITURE";
    FinancialSituation["MedicalTreatmentOrIllness"] = "MEDICAL_TREATMENT_OR_ILLNESS";
    FinancialSituation["None"] = "NONE";
    FinancialSituation["Other"] = "OTHER";
    FinancialSituation["PermanentDecreaseInIncome"] = "PERMANENT_DECREASE_IN_INCOME";
    FinancialSituation["TemporaryDecreaseInIncome"] = "TEMPORARY_DECREASE_IN_INCOME";
    FinancialSituation["TemporaryIncreaseInExpense"] = "TEMPORARY_INCREASE_IN_EXPENSE";
})(FinancialSituation || (FinancialSituation = {}));
//# sourceMappingURL=FinancialSituation.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Gender.js
var Gender;
(function (Gender) {
    Gender["Female"] = "FEMALE";
    Gender["Male"] = "MALE";
    Gender["Undisclosed"] = "UNDISCLOSED";
    Gender["Unknown"] = "UNKNOWN";
})(Gender || (Gender = {}));
//# sourceMappingURL=Gender.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/InterestRateType.js
var InterestRateType;
(function (InterestRateType) {
    InterestRateType["Variable"] = "VARIABLE";
    InterestRateType["Fixed"] = "FIXED";
    InterestRateType["Both"] = "BOTH";
})(InterestRateType || (InterestRateType = {}));
//# sourceMappingURL=InterestRateType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/InvitationStatus.js
var InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus["Pending"] = "PENDING";
    InvitationStatus["Expired"] = "EXPIRED";
    InvitationStatus["Accepted"] = "ACCEPTED";
    InvitationStatus["Cancelled"] = "CANCELLED";
})(InvitationStatus || (InvitationStatus = {}));
//# sourceMappingURL=InvitationStatus.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Liabilities.js
var LiabilityType;
(function (LiabilityType) {
    LiabilityType["Vehicle"] = "CAR_LOAN";
    LiabilityType["HomeLoan"] = "HOME_LOAN";
    LiabilityType["CreditCard"] = "CREDIT_CARD";
    LiabilityType["StoreCard"] = "STORE_CARD";
    LiabilityType["PersonalLoan"] = "PERSONAL_LOAN";
    LiabilityType["ShortTermFinance"] = "SHORT_TERM_FINANCE";
    LiabilityType["Lease"] = "LEASE";
    LiabilityType["HirePurchase"] = "HIRE_PURCHASE";
    LiabilityType["TaxDebt"] = "TAX_DEBT";
    LiabilityType["LineOfCredit"] = "LINE_OF_CREDIT";
    LiabilityType["Overdraft"] = "OVERDRAFT";
    LiabilityType["HelpHecsDebt"] = "HELP_HECS_DEBT";
    LiabilityType["Other"] = "OTHER";
    LiabilityType["Unknown"] = "UNKNOWN";
})(LiabilityType || (LiabilityType = {}));
var LiabilityRepaymentTypeDetails;
(function (LiabilityRepaymentTypeDetails) {
    LiabilityRepaymentTypeDetails["InterestOnly"] = "INTEREST_ONLY";
    LiabilityRepaymentTypeDetails["PrincipalAndInterest"] = "PRINCIPAL_AND_INTEREST";
})(LiabilityRepaymentTypeDetails || (LiabilityRepaymentTypeDetails = {}));
var LiabilityRepaymentFrequency;
(function (LiabilityRepaymentFrequency) {
    LiabilityRepaymentFrequency["Weekly"] = "WEEKLY";
    LiabilityRepaymentFrequency["Fortnightly"] = "FORTNIGHTLY";
    LiabilityRepaymentFrequency["Monthly"] = "MONTHLY";
    LiabilityRepaymentFrequency["Annually"] = "ANNUALLY";
})(LiabilityRepaymentFrequency || (LiabilityRepaymentFrequency = {}));
var LiabilityClearingFromOtherSource;
(function (LiabilityClearingFromOtherSource) {
    LiabilityClearingFromOtherSource["PayingOut"] = "PAYING_OUT";
    LiabilityClearingFromOtherSource["Reducing"] = "REDUCING";
})(LiabilityClearingFromOtherSource || (LiabilityClearingFromOtherSource = {}));
var LiabilityInterestType;
(function (LiabilityInterestType) {
    LiabilityInterestType["FixedRate"] = "FIXED_RATE";
    LiabilityInterestType["Variable"] = "VARIABLE";
})(LiabilityInterestType || (LiabilityInterestType = {}));
//# sourceMappingURL=Liabilities.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/MaritalStatus.js
var MaritalStatus;
(function (MaritalStatus) {
    MaritalStatus["DeFacto"] = "DE_FACTO";
    MaritalStatus["Divorced"] = "DIVORCED";
    MaritalStatus["Married"] = "MARRIED";
    MaritalStatus["Single"] = "SINGLE";
    MaritalStatus["Unknown"] = "UNKNOWN";
})(MaritalStatus || (MaritalStatus = {}));
//# sourceMappingURL=MaritalStatus.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Mitigant.js
var Mitigant;
(function (Mitigant) {
    Mitigant["ApplicationReflectsChanges"] = "APPLICATION_REFLECTS_CHANGES";
    Mitigant["CoApplicantsIncome"] = "CO_APPLICANTS_INCOME";
    Mitigant["ReduceExpenditure"] = "REDUCING_EXPENDITURE";
    Mitigant["SaleOfAssets"] = "SALE_OF_ASSETS";
    Mitigant["SecuringAdditionalIncome"] = "SECURING_ADDITIONAL_INCOME";
    Mitigant["UsingSavings"] = "USING_SAVINGS";
    Mitigant["Other"] = "OTHER";
})(Mitigant || (Mitigant = {}));
//# sourceMappingURL=Mitigant.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/OwnershipProportions.js
var OwnershipProportions;
(function (OwnershipProportions) {
    OwnershipProportions["Equal"] = "EQUAL";
    OwnershipProportions["Specified"] = "SPECIFIED";
    OwnershipProportions["NotSpecified"] = "NOT_SPECIFIED";
})(OwnershipProportions || (OwnershipProportions = {}));
//# sourceMappingURL=OwnershipProportions.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/PaymentIssues.js
var PaymentIssues;
(function (PaymentIssues) {
    PaymentIssues["HardshipArrangements"] = "HARDSHIP_ARRANGEMENTS";
    PaymentIssues["LatePayments"] = "LATE_PAYMENTS";
    PaymentIssues["MissedPayments"] = "MISSED_PAYMENTS";
    PaymentIssues["OutstandingArrears"] = "OUTSTANDING_ARREARS";
    PaymentIssues["None"] = "NONE";
})(PaymentIssues || (PaymentIssues = {}));
//# sourceMappingURL=PaymentIssues.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/PaymentType.js
var PaymentType;
(function (PaymentType) {
    PaymentType["InterestOnly"] = "INTEREST_ONLY";
    PaymentType["PrincipalAndInterest"] = "PRINCIPAL_AND_INTEREST";
    PaymentType["Both"] = "BOTH";
    PaymentType["StillDeciding"] = "STILL_DECIDING";
    PaymentType["Unknown"] = "UNKNOWN";
})(PaymentType || (PaymentType = {}));
//# sourceMappingURL=PaymentType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/ProductFeatures.js
var ProductFeatures;
(function (ProductFeatures) {
    ProductFeatures["Offset"] = "OFFSET";
    ProductFeatures["Redraw"] = "REDRAW";
})(ProductFeatures || (ProductFeatures = {}));
//# sourceMappingURL=ProductFeatures.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/ProductPreferences.js
var ProductPreferences;
(function (ProductPreferences) {
    ProductPreferences["AbilityToAccessPrepaidFundsIfNeeded"] = "ABILITY_TO_ACCESS_PREPAID_FUNDS_IF_NEEDED";
    ProductPreferences["AbilityToPayOffLoanSooner"] = "ABILITY_TO_PAY_OFF_LOAN_SOONER";
    ProductPreferences["AccessFundsSameWayAsRegularBankAccount"] = "ACCESS_FUNDS_SAME_WAY_AS_A_REGULAR_BANK_ACCOUNT";
    ProductPreferences["HaveABalanceOfCertaintyOfRepaymentsAndFlexibility"] = "HAVE_A_BALANCE_OF_CERTAINTY_OF_REPAYMENTS_AND_FLEXIBILITY";
    ProductPreferences["HaveSetRepayments"] = "HAVE_SET_REPAYMENTS";
    ProductPreferences["TakeAdvantageOfInterestRateDrops"] = "TAKE_ADVANTAGE_OF_INTEREST_RATE_DROPS";
    ProductPreferences["UseSavingsOrSalaryToReduceInterest"] = "USE_SAVINGS_OR_SALARY_TO_REDUCE_INTEREST";
})(ProductPreferences || (ProductPreferences = {}));
//# sourceMappingURL=ProductPreferences.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Properties.js
var PropertyStatus;
(function (PropertyStatus) {
    PropertyStatus["NewBuilding"] = "NEW_BUILDING";
    PropertyStatus["OffThePlan"] = "OFF_THE_PLAN";
    PropertyStatus["VacantLand"] = "VACANT_LAND";
    PropertyStatus["Established"] = "ESTABLISHED";
})(PropertyStatus || (PropertyStatus = {}));
var PropertyZoneType;
(function (PropertyZoneType) {
    PropertyZoneType["Residential"] = "RESIDENTIAL";
    PropertyZoneType["Commercial"] = "COMMERCIAL";
    PropertyZoneType["Rural"] = "RURAL";
    PropertyZoneType["Industrial"] = "INDUSTRIAL";
})(PropertyZoneType || (PropertyZoneType = {}));
var PropertyType;
(function (PropertyType) {
    PropertyType["ApartmentUnitLessThan50M2"] = "APARTMENT_UNIT_LESS_THAN_50M2";
    PropertyType["ApartmentUnitMoreThan50M2"] = "APARTMENT_UNIT_MORE_THAN_50M2";
    PropertyType["ServicedApartment"] = "SERVICED_APARTMENT";
    PropertyType["Stuido"] = "STUDIO";
    PropertyType["StudentAccommodation"] = "STUDENT_ACCOMMODATION";
    PropertyType["WarehouseApartment"] = "WAREHOUSE_APARTMENT";
    PropertyType["Duplex"] = "DUPLEX";
    PropertyType["Villa"] = "VILLA";
    PropertyType["FullyDetachedHouse"] = "FULLY_DETACHED_HOUSE";
    PropertyType["KitHome"] = "KIT_HOME";
    PropertyType["MultiDwellingSingleTitle"] = "MULTI_DWELLING_SINGLE_TITLE";
    PropertyType["PropertyOver10HA"] = "PROPERTY_OVER_10_HA";
    PropertyType["SemiDetachedHouse"] = "SEMI_DETACHED_HOUSE";
    PropertyType["Terrace"] = "TERRACE";
    PropertyType["Townhouse"] = "TOWNHOUSE";
    PropertyType["Land"] = "LAND";
})(PropertyType || (PropertyType = {}));
var PropertyEstimateBasis;
(function (PropertyEstimateBasis) {
    PropertyEstimateBasis["ApplicantEstimate"] = "APPLICANT_ESTIMATE";
    PropertyEstimateBasis["BankAssessment"] = "BANK_ASSESSMENT";
    PropertyEstimateBasis["CertifiedValuation"] = "CERTIFIED_VALUATION";
    PropertyEstimateBasis["ElectronicValuation"] = "ELECTRONIC_VALUATION";
    PropertyEstimateBasis["RatesNotice"] = "RATES_NOTICE";
    PropertyEstimateBasis["RPData"] = "RP_DATA";
    PropertyEstimateBasis["Valocity"] = "VALOCITY";
})(PropertyEstimateBasis || (PropertyEstimateBasis = {}));
//# sourceMappingURL=Properties.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/PurchaseReason.js
var PurchaseReason;
(function (PurchaseReason) {
    PurchaseReason["LoanApproval"] = "LOAN_APPROVAL";
    PurchaseReason["LoanEligibility"] = "LOAN_ELIGIBILITY";
    PurchaseReason["LoanAffordability"] = "LOAN_AFFORDABILITY";
})(PurchaseReason || (PurchaseReason = {}));
//# sourceMappingURL=PurchaseReason.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/PurchaseSituation.js
var PurchaseSituation;
(function (PurchaseSituation) {
    PurchaseSituation["ContractsExchanged"] = "CONTRACTS_EXCHANGED";
    PurchaseSituation["OfferMade"] = "OFFER_MADE";
    PurchaseSituation["BuyingSoon"] = "BUYING_SOON";
    PurchaseSituation["ExploringOptions"] = "EXPLORING_OPTIONS";
})(PurchaseSituation || (PurchaseSituation = {}));
//# sourceMappingURL=PurchaseSituation.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Purpose.js
var Purpose;
(function (Purpose) {
    Purpose["NewPurchase"] = "NEW_PURCHASE";
    Purpose["Refinance"] = "REFINANCE";
})(Purpose || (Purpose = {}));
var PrimaryPurpose;
(function (PrimaryPurpose) {
    PrimaryPurpose["Commercial"] = "COMMERCIAL";
    PrimaryPurpose["Construction"] = "CONSTRUCTION";
    PrimaryPurpose["ConstructionAndPurchase"] = "CONSTRUCTION_AND_PURCHASE";
    PrimaryPurpose["ConstructionAndRefinance"] = "CONSTRUCTION_AND_REFINANCE";
    PrimaryPurpose["FastRefinance"] = "FAST_REFINANCE";
    PrimaryPurpose["InternalRefinance"] = "INTERNAL_REFINANCE";
    PrimaryPurpose["NewPurchase"] = "NEW_PURCHASE";
    PrimaryPurpose["PreApproval"] = "PRE_APPROVAL";
    PrimaryPurpose["Purchase"] = "PURCHASE";
    PrimaryPurpose["PurchaseAndRefinance"] = "PURCHASE_AND_REFINANCE";
    PrimaryPurpose["Refinance"] = "REFINANCE";
    PrimaryPurpose["SLR"] = "SLR";
    PrimaryPurpose["TopUp"] = "TOP_UP";
    PrimaryPurpose["Variation"] = "VARIATION";
    PrimaryPurpose["VariationCreditCritical"] = "VARIATION_CREDIT_CRITICAL";
    PrimaryPurpose["VariationNonCreditCritical"] = "VARIATION_NON_CREDIT_CRITICAL";
})(PrimaryPurpose || (PrimaryPurpose = {}));
//# sourceMappingURL=Purpose.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/RefinancingReasons.js
var RefinancingReasons;
(function (RefinancingReasons) {
    RefinancingReasons["ConsolidateCashout"] = "CONSOLIDATE_CASHOUT";
    RefinancingReasons["FasterPayoff"] = "FASTER_PAYOFF";
    RefinancingReasons["DecreaseRepayments"] = "DECREASE_REPAYMENTS";
    RefinancingReasons["Construction"] = "CONSTRUCTION";
    // Few more from Needs & Objectives
    RefinancingReasons["CloseToTheEndOfAFixedRateOrInterestOnlyPeriod"] = "CLOSE_TO_THE_END_OF_A_FIXED_RATE_OR_INTEREST_ONLY_PERIOD";
    RefinancingReasons["ConsolidateDebtAndReduceNumberOfLenders"] = "CONSOLIDATE_DEBT_AND_REDUCE_NUMBER_OF_LENDERS";
    RefinancingReasons["DissatisfiedWithCurrentLender"] = "DISSATISFIED_WITH_CURRENT_LENDER";
    RefinancingReasons["GreaterFlexibilityOrAdditionalLoanFeatures"] = "GREATER_FLEXIBILITY_OR_ADDITIONAL_LOAN_FEATURES";
    RefinancingReasons["IncreaseLoanAmount"] = "INCREASE_LOAN_AMOUNT";
    RefinancingReasons["PayOffLoanFasterWithALowerInterestRate"] = "PAY_OFF_LOAN_FASTER_WITH_A_LOWER_INTEREST_RATE";
    RefinancingReasons["Other"] = "OTHER";
})(RefinancingReasons || (RefinancingReasons = {}));
//# sourceMappingURL=RefinancingReasons.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/RelationshipToBorrower.js
var RelationshipToBorrower;
(function (RelationshipToBorrower) {
    RelationshipToBorrower["FATHER"] = "Father";
    RelationshipToBorrower["MOTHER"] = "Mother";
    RelationshipToBorrower["SPOUSE"] = "Spouse";
    RelationshipToBorrower["BROTHER"] = "Brother";
    RelationshipToBorrower["SISTER"] = "Sister";
    RelationshipToBorrower["SON"] = "Son";
    RelationshipToBorrower["OTHER_RELATIVE"] = "Other Relative";
    RelationshipToBorrower["OTHER"] = "Other";
})(RelationshipToBorrower || (RelationshipToBorrower = {}));
//# sourceMappingURL=RelationshipToBorrower.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/RepaymentOptions.js
var RepaymentOptions;
(function (RepaymentOptions) {
    RepaymentOptions["Downsize"] = "DOWNSIZE";
    RepaymentOptions["RelyOnCoApplicantsIncome"] = "RELY_ON_CO_APPLICANTS_INCOME";
    RepaymentOptions["RepayLoanBeforeRetirement"] = "REPAY_LOAN_BEFORE_RETIREMENT";
    RepaymentOptions["SellAssets"] = "SELL_ASSETS";
    RepaymentOptions["UseIncomeFromOtherInvestments"] = "USE_INCOME_FROM_OTHER_INVESTMENTS";
    RepaymentOptions["UseSavings"] = "USE_SAVINGS";
    RepaymentOptions["UseSuperannuationLumpSum"] = "USE_SUPERANNUATION_LUMP_SUM";
    RepaymentOptions["UseSuperannuationOnGoing"] = "USE_SUPERANNUATION_ONGOING";
    RepaymentOptions["WorkPastRetirementAge"] = "WORK_PAST_RETIREMENT_AGE";
    RepaymentOptions["Other"] = "OTHER";
})(RepaymentOptions || (RepaymentOptions = {}));
//# sourceMappingURL=RepaymentOptions.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/RepaymentType.js
var RepaymentType;
(function (RepaymentType) {
    RepaymentType["InterestOnly"] = "INTEREST_ONLY";
    RepaymentType["PrincipalAndInterest"] = "PRINCIPAL_AND_INTEREST";
    RepaymentType["Both"] = "BOTH";
})(RepaymentType || (RepaymentType = {}));
//# sourceMappingURL=RepaymentType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/RepaymentTypeDetails.js
var RepaymentTypeDetails;
(function (RepaymentTypeDetails) {
    RepaymentTypeDetails["InterestOnlyDueToVariableAndUnpredictableIncome"] = "INTEREST_ONLY_DUE_TO_VARIABLE_AND_UNPREDICTABLE_INCOME";
    RepaymentTypeDetails["InterestOnlyForTaxAndAccountingPurpose"] = "INTEREST_ONLY_FOR_TAX_AND_ACCOUNTING_PURPOSE";
    RepaymentTypeDetails["InterestOnlyToAccommodateTemporaryReductionInIncome"] = "INTEREST_ONLY_TO_ACCOMMODATE_TEMPORARY_REDUCTION_IN_INCOME";
    RepaymentTypeDetails["InterestOnlyToAccommodateNonRecurringExpenses"] = "INTEREST_ONLY_TO_ACCOMMODATE_NON_RECURRING_EXPENSES";
    RepaymentTypeDetails["InterestOnlyToPayOffNonDeductibleDebtsAsAPriority"] = "INTEREST_ONLY_TO_PAY_OFF_NON_DEDUCTIBLE_DEBTS_AS_A_PRIORITY";
    RepaymentTypeDetails["DecreaseDebtOwingOnProperty"] = "DECREASE_DEBT_OWING_ON_PROPERTY";
    RepaymentTypeDetails["MaximiseBorrowingCapacityWithDepositOrAmountOfEquityAccessible"] = "MAXIMISE_BORROWING_CAPACITY_WITH_DEPOSIT_OR_AMOUNT_OF_EQUITY_ACCESSIBLE";
    RepaymentTypeDetails["PaydownPrincipleToMinimiseInterestPaidOverTime"] = "PAY_DOWN_PRINCIPAL_TO_MINIMISE_INTEREST_PAID_OVER_TIME";
    RepaymentTypeDetails["PayLowestPossibleDeposit"] = "PAY_LOWEST_POSSIBLE_DEPOSIT";
    RepaymentTypeDetails["Other"] = "OTHER";
})(RepaymentTypeDetails || (RepaymentTypeDetails = {}));
//# sourceMappingURL=RepaymentTypeDetails.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/ResidencyStatus.js
var ResidencyStatus;
(function (ResidencyStatus) {
    ResidencyStatus["AustralianCitizen"] = "AUSTRALIAN_CITIZEN";
    ResidencyStatus["PermanentResident"] = "PERMANENT_RESIDENT";
    ResidencyStatus["TemporaryResident"] = "TEMPORARY_RESIDENT";
    ResidencyStatus["Unknown"] = "UNKNOWN";
})(ResidencyStatus || (ResidencyStatus = {}));
//# sourceMappingURL=ResidencyStatus.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/States.js
var State;
(function (State) {
    State["QLD"] = "QLD";
    State["NSW"] = "NSW";
    State["VIC"] = "VIC";
    State["WA"] = "WA";
    State["SA"] = "SA";
    State["TAS"] = "TAS";
    State["ACT"] = "ACT";
    State["NT"] = "NT";
})(State || (State = {}));
//# sourceMappingURL=States.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/TeamMemberSkill.js
var TeamMemberSkill;
(function (TeamMemberSkill) {
    TeamMemberSkill["Bridging"] = "Bridging";
    TeamMemberSkill["ComplexInvestments"] = "Complex Investments";
    TeamMemberSkill["Construction"] = "Construction";
    TeamMemberSkill["DebtConsolidation"] = "Debt Consolidation";
    TeamMemberSkill["ExistingCustomer"] = "Existing Customer";
    TeamMemberSkill["Guarantor"] = "Guarantor";
    TeamMemberSkill["HighValue"] = "High Value";
    TeamMemberSkill["LoanSizeLessThan200k"] = "Loan Size < 200k";
    TeamMemberSkill["LowDoc"] = "Low Doc";
    TeamMemberSkill["NonConformingLending"] = "Non-conforming lending";
    TeamMemberSkill["PAYG"] = "PAYG";
    TeamMemberSkill["SelfEmployedPtyLtd"] = "Self Employed PTY LTD";
    TeamMemberSkill["SelfEmployedSoleTrader"] = "Self Employed sole trader";
    TeamMemberSkill["Trust"] = "Trust";
    TeamMemberSkill["SlrToHls"] = "SLR to HLS";
    TeamMemberSkill["VideoAppointment"] = "Video Appointment";
})(TeamMemberSkill || (TeamMemberSkill = {}));
//# sourceMappingURL=TeamMemberSkill.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/TeamMemberSkillLGSF.js
var TeamMemberSkillLGSF;
(function (TeamMemberSkillLGSF) {
    TeamMemberSkillLGSF["NewPurchase"] = "NEW_PURCHASE";
    TeamMemberSkillLGSF["Refinance"] = "REFINANCE";
    TeamMemberSkillLGSF["Construction"] = "CONSTRUCTION";
    TeamMemberSkillLGSF["TopUps"] = "TOP_UPS";
    TeamMemberSkillLGSF["LowDoc"] = "LOW_DOC";
    TeamMemberSkillLGSF["Bridging"] = "BRIDGING";
    TeamMemberSkillLGSF["NonConformingLoan"] = "NON_CONFORMING_LOAN";
    TeamMemberSkillLGSF["Trust"] = "TRUST";
    TeamMemberSkillLGSF["Guarantor"] = "GUARANTOR";
    TeamMemberSkillLGSF["Commercial"] = "COMMERCIAL";
    TeamMemberSkillLGSF["SelfEmployed"] = "SELF_EMPLOYED";
    TeamMemberSkillLGSF["AssetFinance"] = "ASSET_FINANCE";
})(TeamMemberSkillLGSF || (TeamMemberSkillLGSF = {}));
var TeamMemberSkillLGSFWithLabel = {
    NewPurchase: {
        value: 'NEW_PURCHASE',
        label: 'New Purchase',
    },
    Refinance: {
        value: 'REFINANCE',
        label: 'Refinance',
    },
    Construction: {
        value: 'CONSTRUCTION',
        label: 'Construction',
    },
    TopUps: {
        value: 'TOP_UPS',
        label: 'Top ups',
    },
    LowDoc: {
        value: 'LOW_DOC',
        label: 'Low Doc',
    },
    Bridging: {
        value: 'BRIDGING',
        label: 'Bridging',
    },
    NonConformingLoan: {
        value: 'NON_CONFORMING_LOAN',
        label: 'Non Conforming Loan',
    },
    Trust: {
        value: 'TRUST',
        label: 'Trust',
    },
    Guarantor: {
        value: 'GUARANTOR',
        label: 'Guarantor',
    },
    Commercial: {
        value: 'COMMERCIAL',
        label: 'Commercial',
    },
    SelfEmployed: {
        value: 'SELF_EMPLOYED',
        label: 'Self employed',
    },
    AssetFinance: {
        value: 'ASSET_FINANCE',
        label: 'Asset Finance',
    },
};
//# sourceMappingURL=TeamMemberSkillLGSF.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/TeamMemberSubSkillLGSF.js
var TeamMemberSubSkillLGSF;
(function (TeamMemberSubSkillLGSF) {
    TeamMemberSubSkillLGSF["ExistingCustomer"] = "EXISTING_CUSTOMER";
    TeamMemberSubSkillLGSF["SlrToHls"] = "SLR_TO_HLS";
    TeamMemberSubSkillLGSF["HighValue"] = "HIGH_VALUE";
    TeamMemberSubSkillLGSF["ComplexInvestment"] = "COMPLEX_INVESTMENT";
    TeamMemberSubSkillLGSF["LoanAmountUnder200k"] = "LOAN_AMOUNT_UNDER_200K";
    TeamMemberSubSkillLGSF["TestGroupA"] = "TEST_GROUP_A";
    TeamMemberSubSkillLGSF["TestGroupB"] = "TEST_GROUP_B";
    TeamMemberSubSkillLGSF["PurchaseExploringOptions"] = "PURCHASE_EXPLORING_OPTIONS";
})(TeamMemberSubSkillLGSF || (TeamMemberSubSkillLGSF = {}));
var TeamMemberSubSkillLGSFWithLabel = {
    ExistingCustomer: {
        value: 'EXISTING_CUSTOMER',
        label: 'Existing Customer',
    },
    SlrToHls: {
        value: 'SLR_TO_HLS',
        label: 'SLR to HLS',
    },
    HighValue: {
        value: 'HIGH_VALUE',
        label: 'High Value',
    },
    ComplexInvestment: {
        value: 'COMPLEX_INVESTMENT',
        label: 'Complex Investment',
    },
    LoanAmountUnder200k: {
        value: 'LOAN_AMOUNT_UNDER_200K',
        label: 'Loan amount under 200k',
    },
    TestGroupA: {
        value: 'TEST_GROUP_A',
        label: 'Test Group A',
    },
    TestGroupB: {
        value: 'TEST_GROUP_B',
        label: 'Test Group B',
    },
    PurchaseExploringOptions: {
        value: 'PURCHASE_EXPLORING_OPTIONS',
        label: 'Purchase Exploring Options',
    },
};
//# sourceMappingURL=TeamMemberSubSkillLGSF.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Title.js
var Title;
(function (Title) {
    Title["Dr"] = "DR";
    Title["Miss"] = "MISS";
    Title["Mr"] = "MR";
    Title["Mrs"] = "MRS";
    Title["Ms"] = "MS";
    Title["Other"] = "OTHER";
    Title["Unknown"] = "UNKNOWN";
})(Title || (Title = {}));
//# sourceMappingURL=Title.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/TransactionType.js
var TransactionType;
(function (TransactionType) {
    TransactionType["ConstructionLoan"] = "CONSTRUCTION_LOAN";
})(TransactionType || (TransactionType = {}));
//# sourceMappingURL=TransactionType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Urgency.js
var Urgency;
(function (Urgency) {
    Urgency["Urgent"] = "URGENT";
    Urgency["NotUrgent"] = "NOT_URGENT";
})(Urgency || (Urgency = {}));
//# sourceMappingURL=Urgency.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/UserType.js
var UserType;
(function (UserType) {
    UserType["Customer"] = "customer";
    UserType["Team"] = "team";
    UserType["M2M"] = "m2m";
})(UserType || (UserType = {}));
//# sourceMappingURL=UserType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/DynamoStream.js
var DynamoEventName;
(function (DynamoEventName) {
    DynamoEventName["Insert"] = "INSERT";
    DynamoEventName["Modify"] = "MODIFY";
    DynamoEventName["Remove"] = "REMOVE";
})(DynamoEventName || (DynamoEventName = {}));
//# sourceMappingURL=DynamoStream.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/HousingStatusList.js
var HousingStatusList;
(function (HousingStatusList) {
    HousingStatusList["Renting"] = "Renting";
    HousingStatusList["Boarding"] = "Boarding";
    HousingStatusList["Caravan"] = "Caravan";
    HousingStatusList["Other"] = "Other";
    HousingStatusList["OwnHome"] = "Own Home";
    HousingStatusList["OwnHomeMortgage"] = "Own Home Mortgage";
    HousingStatusList["SuppliedByEmployer"] = "Supplied by Employer";
    HousingStatusList["WithParents"] = "With Parents";
})(HousingStatusList || (HousingStatusList = {}));
//# sourceMappingURL=HousingStatusList.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/ExpenseTypes.js
var ExpenseTypes;
(function (ExpenseTypes) {
    ExpenseTypes["LivingExpensesEstimate"] = "LIVING_EXPENSES_ESTIMATE";
    ExpenseTypes["Groceries"] = "GROCERIES";
    ExpenseTypes["Childcare"] = "CHILDCARE";
    ExpenseTypes["ChildAndSpousalMaintenance"] = "CHILD_AND_SPOUSAL_MAINTENANCE";
    ExpenseTypes["PrimarySecondaryEducation"] = "PRIMARY_SECONDARY_EDUCATION";
    ExpenseTypes["HigherVocationalTrainingEducation"] = "HIGHER_VOCATIONAL_TRAINING_EDUCATION";
    ExpenseTypes["PrivateSchoolingAndTuition"] = "PRIVATE_SCHOOLING_AND_TUITION";
    ExpenseTypes["ClothingAndPersonalCare"] = "CLOTHING_AND_PERSONAL_CARE";
    ExpenseTypes["RecreationAndEntertainment"] = "RECREATION_AND_ENTERTAINMENT";
    ExpenseTypes["TelephoneInternetPayTvAndMediaStreamingSubscriptions"] = "TELEPHONE_INTERNET_PAY_TV_AND_MEDIA_STREAMING_SUBSCRIPTIONS";
    ExpenseTypes["PetCare"] = "PET_CARE";
    ExpenseTypes["Transport"] = "TRANSPORT";
    ExpenseTypes["BodyCorporateFeesStrataFeesAndLandTax"] = "BODY_CORPORATE_FEES_STRATA_FEES_AND_LAND_TAX";
    ExpenseTypes["PrimaryResidenceRunningCosts"] = "PRIMARY_RESIDENCE_RUNNING_COSTS";
    ExpenseTypes["InvestmentPropertyRunningCosts"] = "INVESTMENT_PROPERTY_RUNNING_COSTS";
    ExpenseTypes["SecondaryResidenceRunningCosts"] = "SECONDARY_RESIDENCE_RUNNING_COSTS";
    ExpenseTypes["Insurance"] = "INSURANCE";
    ExpenseTypes["LifeInsurance"] = "LIFE_INSURANCE";
    ExpenseTypes["HealthInsurance"] = "HEALTH_INSURANCE";
    ExpenseTypes["MedicalAndHealth"] = "MEDICAL_AND_HEALTH";
    ExpenseTypes["Rent"] = "RENT";
    ExpenseTypes["RentUtilities"] = "RENT_UTILITIES";
    ExpenseTypes["Board"] = "BOARD";
    ExpenseTypes["Other"] = "OTHER";
})(ExpenseTypes || (ExpenseTypes = {}));
//# sourceMappingURL=ExpenseTypes.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Frequency.js
var Frequency;
(function (Frequency) {
    Frequency["Fortnightly"] = "FORTNIGHTLY";
    Frequency["Monthly"] = "MONTHLY";
    Frequency["Quarterly"] = "QUARTERLY";
    Frequency["Weekly"] = "WEEKLY";
    Frequency["Yearly"] = "YEARLY";
})(Frequency || (Frequency = {}));
//# sourceMappingURL=Frequency.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/GovtBenefitTypes.js
var GovtBenefitTypes;
(function (GovtBenefitTypes) {
    GovtBenefitTypes["FamilyTax"] = "FAMILY_TAX";
    GovtBenefitTypes["AgePension"] = "AGE_PENSION";
    GovtBenefitTypes["DisabilitySupportPension"] = "DISABILITY_SUPPORT_PENSION";
    GovtBenefitTypes["Other"] = "OTHER";
})(GovtBenefitTypes || (GovtBenefitTypes = {}));
//# sourceMappingURL=GovtBenefitTypes.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/IncomeTypesAsset.js
var IncomeTypesAsset;
(function (IncomeTypesAsset) {
    IncomeTypesAsset["SelfEmployedBusinessIncome"] = "SELF_EMPLOYED_BUSINESS_INCOME";
    IncomeTypesAsset["RentalIncome"] = "RENTAL_INCOME";
    IncomeTypesAsset["InvestmentIncome"] = "INVESTMENT_INCOME";
})(IncomeTypesAsset || (IncomeTypesAsset = {}));
//# sourceMappingURL=IncomeTypesAsset.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/IncomeTypesGovt.js
var IncomeTypesGovt;
(function (IncomeTypesGovt) {
    IncomeTypesGovt["GovtBenefit"] = "GOVT_BENEFIT";
})(IncomeTypesGovt || (IncomeTypesGovt = {}));
//# sourceMappingURL=IncomeTypesGovt.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/IncomeTypesOthers.js
var IncomeTypesOthers;
(function (IncomeTypesOthers) {
    IncomeTypesOthers["SuperAnnuityPension"] = "SUPER_ANNUITY_PENSION";
    IncomeTypesOthers["WorkersCompensation"] = "WORKERS_COMPENSATION";
    IncomeTypesOthers["ForeignIncome"] = "FOREIGN_INCOME";
    IncomeTypesOthers["ChildMaintenance"] = "CHILD_MAINTENANCE";
    IncomeTypesOthers["CentrelinkBenefit"] = "CENTRELINK_BENEFIT";
    IncomeTypesOthers["OtherIncome"] = "OTHER_INCOME";
})(IncomeTypesOthers || (IncomeTypesOthers = {}));
//# sourceMappingURL=IncomeTypesOthers.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/IncomeTypesPayg.js
var IncomeTypesPayg;
(function (IncomeTypesPayg) {
    IncomeTypesPayg["BaseSalary"] = "PAYG_BASE_SALARY";
    IncomeTypesPayg["CommissionIncome"] = "PAYG_COMMISSION_INCOME";
    IncomeTypesPayg["BonusIncome"] = "PAYG_BONUS_INCOME";
    IncomeTypesPayg["OvertimeIncome"] = "PAYG_OVERTIME_INCOME";
    IncomeTypesPayg["CarAllowance"] = "PAYG_CAR_ALLOWANCE";
    IncomeTypesPayg["AllowancesTaxed"] = "PAYG_ALLOWANCES_TAXED";
    IncomeTypesPayg["AllowancesNotTaxed"] = "PAYG_ALLOWANCES_NOT_TAXED";
    IncomeTypesPayg["CompanyCar"] = "PAYG_COMPANY_CAR";
    IncomeTypesPayg["NonVoluntaryDeductionsPreTax"] = "PAYG_NON_VOLUNTARY_DEDUCTIONS_PRE_TAX";
    IncomeTypesPayg["SalarySacrifice"] = "PAYG_SALARY_SACRIFICE";
})(IncomeTypesPayg || (IncomeTypesPayg = {}));
//# sourceMappingURL=IncomeTypesPayg.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/IncomeTypesSelfEmployed.js
var IncomeTypesSelfEmployed;
(function (IncomeTypesSelfEmployed) {
    IncomeTypesSelfEmployed["SelfEmployedBusinessIncomeFullDoc"] = "SELF_EMPLOYED_BUSINESS_INCOME_FULL_DOC";
    IncomeTypesSelfEmployed["SelfEmployedBusinessIncomeLowDoc"] = "SELF_EMPLOYED_BUSINESS_INCOME_LOW_DOC";
})(IncomeTypesSelfEmployed || (IncomeTypesSelfEmployed = {}));
//# sourceMappingURL=IncomeTypesSelfEmployed.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Lenders.js
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var PARTNER_LENDERS_WITH_SHORTNAME = [
    { name: 'Adelaide Bank', shortName: 'ADE', id: 'adelaide_bank', isPartner: true },
    { name: 'AMP', shortName: 'AMP', id: 'amp', isPartner: true },
    { name: 'ANZ Bank', shortName: 'anz', id: 'anz_bank', isPartner: true },
    { name: 'Auswide Bank', shortName: 'auswide', id: 'auswide_bank', isPartner: true },
    { name: 'Bank Australia', shortName: 'BAU', id: 'bank_australia', isPartner: true },
    { name: 'Bank First', shortName: 'BF', id: 'bank_first', isPartner: true },
    { name: 'Bankwest', shortName: 'bankwest', id: 'bank_west', isPartner: true },
    { name: 'Bluebay Home Loans', shortName: 'BLB', id: 'bluebay_home_loans', isPartner: true },
    { name: 'Better Mortgage Mgmt', shortName: 'BMM', id: 'better_mortgage_mgmt', isPartner: true },
    { name: 'Bank of Melbourne', shortName: 'bom', id: 'bank_of_melbourne', isPartner: true },
    { name: 'Bank SA', shortName: 'BSA', id: 'bank_sa', isPartner: true },
    { name: 'Bluestone', shortName: 'BST', id: 'blue_stone', isPartner: true },
    { name: 'Commonwealth Bank', shortName: 'CBA', id: 'commonwealth_bank', isPartner: true },
    { name: 'Connective Home Loans', shortName: 'CHLA', id: 'connective_home_loans', isPartner: true },
    { name: 'Citibank', shortName: 'citibank', id: 'citi_bank', isPartner: true },
    { name: 'Click Loans', shortName: 'Click_loans', id: 'click_loans', isPartner: true },
    { name: 'Firstmac', shortName: 'FMC', id: 'first_mac', isPartner: true },
    { name: 'Gateway Bank', shortName: 'GCU', id: 'gateway_bank', isPartner: true },
    { name: 'Heritage', shortName: 'heritage', id: 'heritage', isPartner: true },
    { name: 'Better Choice', shortName: 'IDE', id: 'better_choice', isPartner: true },
    { name: 'ING', shortName: 'ing', id: 'ing', isPartner: true },
    { name: 'Laboratories Credit Union', shortName: 'LCU', id: 'laboratories_credit_union', isPartner: true },
    { name: 'LaTrobe', shortName: 'La_Trobe', id: 'la_trobe', isPartner: true },
    { name: 'Loanave', shortName: 'LOA', id: 'loanave', isPartner: true },
    { name: 'Macquarie', shortName: 'macquarie', id: 'macquarie', isPartner: true },
    { name: 'ME Bank', shortName: 'mebank', id: 'me_bank', isPartner: true },
    { name: 'MKM Capital', shortName: 'MKM', id: 'mkm_capital', isPartner: true },
    { name: 'My State Bank', shortName: 'mystate', id: 'my_state_bank', isPartner: true },
    { name: 'NAB', shortName: 'NAB', id: 'nab', isPartner: true },
    {
        name: 'Newcastle Permanent Building Society',
        shortName: 'newcastle',
        id: 'newcastle_permanent_building_society',
        isPartner: true,
    },
    { name: 'Paramount', shortName: 'PAM', id: 'paramount', isPartner: true },
    { name: 'Pepper', shortName: 'pepper', id: 'pepper', isPartner: true },
    { name: 'P&N Bank', shortName: 'pnbank', id: 'pn_bank', isPartner: true },
    { name: 'RESIMAC', shortName: 'Resimac', id: 'resimac', isPartner: true },
    { name: 'St George', shortName: 'stgeorge', id: 'st_george', isPartner: true },
    { name: 'Suncorp', shortName: 'suncorp', id: 'suncorp', isPartner: true },
    { name: 'Teachers Mutual', shortName: 'TMB', id: 'teachers_mutual', isPartner: true },
    { name: 'Virgin Money', shortName: 'VMY', id: 'virgin_money', isPartner: true },
    { name: 'Westpac Bank', shortName: 'Westpac', id: 'westpac_bank', isPartner: true },
    {
        name: 'Connective Home Loans Select ',
        shortName: 'CHLAB',
        id: 'connective_home_loans_select_adelaide',
        isPartner: true,
    },
];
var PARTNER_LENDERS_WITHOUT_SHORTNAME = [
    { name: 'Pacific Mortgage Group', shortName: '', id: 'pacific_mortgage_group', isPartner: true },
    { name: 'Gateway Credit Union', shortName: '', id: 'gateway_credit_union', isPartner: true },
];
var PARTNER_LENDERS = __spreadArray(__spreadArray([], PARTNER_LENDERS_WITH_SHORTNAME, true), PARTNER_LENDERS_WITHOUT_SHORTNAME, true);
var NON_PARTNER_WITH_SHORTNAME = [
    { name: 'AAMI', shortName: 'AAMI', id: 'aami', isPartner: false },
    { name: 'AAPBS Settlements Services', shortName: 'AAPBS', id: 'aapbs_ settlements_services', isPartner: false },
    { name: 'Arab Bank of Australia', shortName: 'ABAL', id: 'arab_bank_of_australia', isPartner: false },
    { name: 'ABN AMRO', shortName: 'ABN AMRO', id: 'abn_amro', isPartner: false },
    { name: 'Australia Central Credit Union', shortName: 'ACCU', id: 'australia_central_credit_union', isPartner: false },
    {
        name: 'Australian Defence Credit Union',
        shortName: 'ADCU',
        id: 'australian_defence_credit_union',
        isPartner: false,
    },
    { name: 'Advantedge', shortName: 'Advantedge', id: 'advantedge', isPartner: false },
    { name: 'AFG Home Loans', shortName: 'AFG', id: 'afg_home_loans', isPartner: false },
    { name: 'Australian First Mortgage', shortName: 'AFM', id: 'australian_first_mortgage', isPartner: false },
    { name: 'Australian Military Bank', shortName: 'AMB', id: 'australian_military_bank', isPartner: false },
    { name: 'Australian Mortgage Options', shortName: 'AMO', id: 'australian_mortgage_options', isPartner: false },
    { name: 'AGC', shortName: 'AGC', id: 'agc', isPartner: false },
    { name: 'AIMS Home Loans', shortName: 'AIMS', id: 'aims', isPartner: false },
    { name: 'Allianz', shortName: 'ALV', id: 'allianz', isPartner: false },
    { name: 'AMG', shortName: 'AMG', id: 'amg', isPartner: false },
    { name: 'AMIC', shortName: 'AMIC', id: 'amic', isPartner: false },
    { name: 'AMIST', shortName: 'AMIST', id: 'amist', isPartner: false },
    { name: 'AMS', shortName: 'AMS', id: 'ams', isPartner: false },
    { name: 'Aon Master Trust', shortName: 'AON', id: 'aon_master_trust', isPartner: false },
    { name: 'API', shortName: 'API', id: 'api', isPartner: false },
    { name: 'Athena Home Loans', shortName: 'Athena', id: 'athena_home_loans', isPartner: false },
    {
        name: 'Australian Unity Building Society',
        shortName: 'AUBS',
        id: 'australian_unity_building_society',
        isPartner: false,
    },
    { name: 'Aussie Activate', shortName: 'AUSPEPPER', id: 'aussie_activate', isPartner: false },
    { name: 'Aussie Elevate', shortName: 'AUSADE', id: 'aussie_elevate', isPartner: false },
    { name: 'Aussie Home Loans', shortName: 'Aussie', id: 'aussie_home_loans', isPartner: false },
    { name: 'Aussie Select', shortName: 'AUSCBA', id: 'aussie_select', isPartner: false },
    { name: 'AVCO', shortName: 'AVCO', id: 'avco', isPartner: false },
    { name: 'AWA Alliance Bank', shortName: 'AWA', id: 'awa_alliance_bank', isPartner: false },
    { name: 'AXA', shortName: 'AXA', id: 'axa', isPartner: false },
    { name: 'American Express', shortName: 'AMEX', id: 'american_express', isPartner: false },
    { name: 'Bank of America', shortName: 'BAC', id: 'bank_of_america', isPartner: false },
    { name: 'B&E', shortName: 'bande', id: 'bande', isPartner: false },
    { name: 'Bank mecu', shortName: 'bankmecu', id: 'bank_mecu', isPartner: false },
    { name: 'Bank of Sydney', shortName: 'banksyd', id: 'bank_of_sydney', isPartner: false },
    { name: 'Bank Vic', shortName: 'bankvic', id: 'bank_vic', isPartner: false },
    { name: 'Barclays', shortName: 'BARC', id: 'barclays', isPartner: false },
    { name: 'BCU', shortName: 'bcu', id: 'bcu', isPartner: false },
    { name: 'BDCU Alliance Bank', shortName: 'BDCUAB', id: 'bdcu_alliance_bank', isPartner: false },
    {
        name: 'Bass and Equitable Building Society',
        shortName: 'BEBS',
        id: 'bass_and_equitable_building_society',
        isPartner: false,
    },
    { name: 'Bendigo Bank', shortName: 'bendigo', id: 'bendigo_bank', isPartner: false },
    { name: 'Beyond Bank Australia', shortName: 'beyondbank', id: 'beyond_bank_australia', isPartner: false },
    {
        name: 'Broken Hill Community Credit Union',
        shortName: 'BHCCU',
        id: 'broken_hill_community_credit_union',
        isPartner: false,
    },
    { name: 'Bigsky Building Society', shortName: 'bigsky', id: 'bigsky_building_society', isPartner: false },
    { name: 'Better Mortgage Corporation', shortName: 'BMMC', id: 'better_mortgage_corporation', isPartner: false },
    { name: 'BMW Australia', shortName: 'BMW', id: 'bmw_australia', isPartner: false },
    { name: 'Banque Nationale De Paris', shortName: 'BNP', id: 'banque_nationale_de_paris', isPartner: false },
    { name: 'Bank of China', shortName: 'BOC', id: 'bank_of_china', isPartner: false },
    { name: 'Bank of Heritage Isle', shortName: 'BOCHI', id: 'bank_of_heritage_isle', isPartner: false },
    { name: 'Bank of Queensland', shortName: 'boq', id: 'bank_of_queensland', isPartner: false },
    { name: 'Bankers Trust Australia', shortName: 'BTA', id: 'bankers_trust_australia', isPartner: false },
    { name: 'BankVic', shortName: 'BV', id: 'bankvic', isPartner: false },
    { name: 'Mutual Community', shortName: 'Bupa', id: 'mutual_community', isPartner: false },
    { name: 'BUSSQ', shortName: 'BUSSQ', id: 'bussq', isPartner: false },
    { name: 'CBFC', shortName: 'CBFC', id: 'cbfc', isPartner: false },
    { name: 'CBUS', shortName: 'CBUS', id: 'cbus', isPartner: false },
    { name: 'Central West Credit Union', shortName: 'CWCU', id: 'central_west_credit_union', isPartner: false },
    { name: 'City Coast Credit Union', shortName: 'CCCU', id: 'city_coast_credit_union', isPartner: false },
    { name: 'Circle Credit Union', shortName: 'CCU', id: 'circle_credit_union', isPartner: false },
    { name: 'CGU', shortName: 'CGU', id: 'cgu', isPartner: false },
    { name: 'CHU', shortName: 'CHU', id: 'chu', isPartner: false },
    { name: 'CIC', shortName: 'CIC', id: 'cic', isPartner: false },
    { name: 'CIL', shortName: 'CIL', id: 'cil', isPartner: false },
    { name: 'Circle Alliance Bank', shortName: 'CAB', id: 'circle_alliance_bank', isPartner: false },
    { name: 'CIT Credit Pty', shortName: 'CIT', id: 'cit_credit_pty', isPartner: false },
    { name: 'Club Plus Super', shortName: 'CLB', id: 'clb_plus_super', isPartner: false },
    { name: 'Challenge Bank', shortName: 'CLG', id: 'challenge_bank', isPartner: false },
    {
        name: 'Community First Credit Union',
        shortName: 'communityfirst',
        id: 'comunity_first_credit_union',
        isPartner: false,
    },
    { name: 'Credit Union Australia', shortName: 'cua', id: 'credit_union_australia', isPartner: false },
    {
        name: 'Credit Union Financial Services',
        shortName: 'CUFS',
        id: 'credit_union_financial_services',
        isPartner: false,
    },
    { name: 'Coastline Credit Union', shortName: 'CUS', id: 'coastline_credit_union', isPartner: false },
    { name: 'Deutsche Bank', shortName: 'DBK', id: 'deutsche_bank', isPartner: false },
    { name: 'Diners Club', shortName: 'DCI', id: 'diners_club', isPartner: false },
    { name: 'Defence Bank', shortName: 'defencebank', id: 'defence_bank', isPartner: false },
    { name: 'ECU', shortName: 'ECU', id: 'ecu', isPartner: false },
    { name: 'EECU', shortName: 'EECU', id: 'eecu', isPartner: false },
    { name: 'Elders', shortName: 'EFP', id: 'elders', isPartner: false },
    { name: 'EISS', shortName: 'EISS', id: 'eiss', isPartner: false },
    { name: 'Fundcorp', shortName: 'FCI', id: 'fundcorp', isPartner: false },
    { name: 'Firefighters mutual bank', shortName: 'FMB', id: 'firefighters_mutual_bank', isPartner: false },
    { name: 'Genworth', shortName: 'Genworth', id: 'genworth', isPartner: false },
    { name: 'GIO', shortName: 'GIO', id: 'gio', isPartner: false },
    { name: 'Goldfields Money', shortName: 'goldfields_money', id: 'gmac_finance', isPartner: false },
    { name: 'Great Pacific Financial', shortName: 'GPF', id: 'great_pacific_financial', isPartner: false },
    { name: 'Great Southern Bank', shortName: 'GSB', id: 'great_southern_bank', isPartner: false },
    { name: 'GRE', shortName: 'GRE', id: 'gre', isPartner: false },
    { name: 'Guild', shortName: 'Guild', id: 'guild', isPartner: false },
    { name: 'HBF', shortName: 'HBF', id: 'hbf', isPartner: false },
    { name: 'HESTA', shortName: 'Hesta', id: 'hesta', isPartner: false },
    { name: 'Holiday Coast Credit Union', shortName: 'HCCU', id: 'holiday_coast_credit_union', isPartner: false },
    { name: 'Homeloans Ltd', shortName: 'HLLC', id: 'homeloans_ltd', isPartner: false },
    { name: 'HSBC', shortName: 'hsbc', id: 'hsbc', isPartner: false },
    { name: 'Hume Building Society', shortName: 'Hume', id: 'hume_building_society', isPartner: false },
    { name: 'International Acceptance', shortName: 'IA', id: 'international_acceptance', isPartner: false },
    {
        name: 'International Commercial Bank of China',
        shortName: 'ICBC',
        id: 'international_commercial_bank_of_china',
        isPartner: false,
    },
    { name: 'IDEG', shortName: 'IDEG', id: 'ideg', isPartner: false },
    { name: 'Illawarra Credit Union', shortName: 'illawarra', id: 'illawarra_credit_union', isPartner: false },
    { name: 'IMB Ltd', shortName: 'imb', id: 'imb_ltd', isPartner: false },
    { name: 'ING Direct', shortName: 'INGC', id: 'ing_direct', isPartner: false },
    { name: 'IOOF Building Society', shortName: 'IOOF', id: 'ioof_building_society', isPartner: false },
    { name: 'Keystart Home Loans', shortName: 'KST', id: 'keystart_home_loans', isPartner: false },
    { name: 'Kwik Kash International', shortName: 'Kwik Kash', id: 'kwik_kash_international', isPartner: false },
    { name: 'Local Government', shortName: 'LGS', id: 'local_government', isPartner: false },
    { name: 'Liberty', shortName: 'liberty', id: 'liberty', isPartner: false },
    { name: 'Lombard Finance', shortName: 'Lombard', id: 'lombard_finance', isPartner: false },
    { name: 'LUCRF Super', shortName: 'LUCRF', id: 'lucrf_super', isPartner: false },
    { name: 'Macquarie Credit Union', shortName: 'macquariecu', id: 'macquarie_credit_union', isPartner: false },
    { name: 'MAP', shortName: 'MAP', id: 'map', isPartner: false },
    { name: 'Mediplan Australia', shortName: 'Mediplan', id: 'mediplan_australia', isPartner: false },
    { name: 'Mercantile Mutual', shortName: 'MERC', id: 'mercantile_mutual', isPartner: false },
    { name: 'Mercer Wealth', shortName: 'Mercer', id: 'mercer_wealth', isPartner: false },
    { name: 'Midland Bank PLC', shortName: 'Midland', id: 'midland_bank_plc', isPartner: false },
    { name: 'Mine Wealth and Wellbeing', shortName: 'Mine Super', id: 'mine_wealth_and_wellbeing', isPartner: false },
    { name: 'MIP', shortName: 'MIP', id: 'mip', isPartner: false },
    { name: 'MIS', shortName: 'MIS', id: 'mis', isPartner: false },
    { name: 'MLC', shortName: 'MLC', id: 'mlc', isPartner: false },
    { name: 'MMI', shortName: 'MMI', id: 'mmi', isPartner: false },
    { name: 'MTAA', shortName: 'MTAA', id: 'mtaa', isPartner: false },
    { name: 'My Credit Union', shortName: 'mycredit', id: 'my_credit_union', isPartner: false },
    { name: 'NSF Super', shortName: 'Nationwide', id: 'nsf_super', isPartner: false },
    { name: 'Natwest Markets Australia', shortName: 'Natwest', id: 'natwest_markets_australia', isPartner: false },
    { name: 'Northern Building Society', shortName: 'NBS', id: 'northern_building_society', isPartner: false },
    { name: 'Northern Inland Credit Union', shortName: 'NICU', id: 'northern_inland_credit_union', isPartner: false },
    { name: 'NGS', shortName: 'NGS', id: 'ngs', isPartner: false },
    { name: 'National Mortgage Company', shortName: 'nmc', id: 'national_mortgage_company', isPartner: false },
    { name: 'NRMA', shortName: 'NRMA', id: 'nrma', isPartner: false },
    { name: 'NZI', shortName: 'NZI', id: 'nzi', isPartner: false },
    { name: 'OneTwo', shortName: 'OneTwo', id: 'one_two', isPartner: false },
    {
        name: 'Overseas-Chinese Banking Corporation',
        shortName: 'OCBC Bank',
        id: 'overseas_chinese_banking_corporation',
        isPartner: false,
    },
    { name: 'Origin Finance', shortName: 'Origin', id: 'origin_finance', isPartner: false },
    { name: 'Origin MMS', shortName: 'OriginMMS', id: 'origin_mms', isPartner: false },
    {
        name: 'Pioneer Permanent Building Society',
        shortName: 'PBS',
        id: 'pioneer_permanent_building_society',
        isPartner: false,
    },
    {
        name: "People's Choice Credit Union",
        shortName: 'peopleschoicecu',
        id: 'peoples_choice_credit_union',
        isPartner: false,
    },
    { name: 'Perpetual Limited', shortName: 'Perpetual', id: 'perpetual_limited', isPartner: false },
    { name: 'Plum', shortName: 'Plum', id: 'plum', isPartner: false },
    { name: 'Police Credit Union', shortName: 'policecu', id: 'police_credit_union', isPartner: false },
    { name: 'QANTAS Credit Union', shortName: 'qantas', id: 'qantas_credit_union', isPartner: false },
    { name: 'QBE', shortName: 'QBE', id: 'qbe', isPartner: false },
    {
        name: 'Queensland Country Credit Union',
        shortName: 'QCCU',
        id: 'queensland_country_credit_union',
        isPartner: false,
    },
    { name: 'RAC', shortName: 'RAC', id: 'rac', isPartner: false },
    { name: 'RACV', shortName: 'RACV', id: 'racv', isPartner: false },
    { name: 'RAMS', shortName: 'rams', id: 'rams', isPartner: false },
    { name: 'Reserve Bank of Australia', shortName: 'RBA', id: 'reserve_bank_of_australia', isPartner: false },
    { name: 'REA Home Loans', shortName: 'REA', id: 'rea_home_loans', isPartner: false },
    { name: 'Safrock Finance', shortName: 'Safrock', id: 'safrock_finance', isPartner: false },
    { name: 'Suncorp Metway', shortName: 'SCMC', id: 'suncorp_metway', isPartner: false },
    { name: 'SGIC', shortName: 'SGIC', id: 'sgic', isPartner: false },
    { name: 'SGIO', shortName: 'SGIO', id: 'sgio', isPartner: false },
    {
        name: 'State Street Bank And Trust Company',
        shortName: 'state street',
        id: 'state_street_bank_and_trust_company',
        isPartner: false,
    },
    { name: 'Summerland Credit Union', shortName: 'Summerland', id: 'summerland_credit_union', isPartner: false },
    { name: 'Macarthur Credit Union', shortName: 'The MAC', id: 'macarthur_credit_union', isPartner: false },
    {
        name: 'Maitland Mutual Building Society',
        shortName: 'The Mutual',
        id: 'maitland_mutual_building_society',
        isPartner: false,
    },
    {
        name: 'Thinktank lending commercial finance',
        shortName: 'Thinktank',
        id: 'thinktank_lending_commercial_finance',
        isPartner: false,
    },
    { name: 'Tictoc Online', shortName: 'Tictoc', id: 'tictoc_online', isPartner: false },
    { name: 'Tic:Toc Home Loans', shortName: 'Tictoc', id: 'tictoc_home_loans', isPartner: false },
    { name: 'Trust Bank of Tasmania', shortName: 'Trust Bank', id: 'trust_bank_of_tasmania', isPartner: false },
    { name: 'Unibank', shortName: 'Uni', id: 'unibank', isPartner: false },
    { name: 'United Overseas Bank', shortName: 'UOB', id: 'united_overseas_bank', isPartner: false },
    {
        name: 'Victoria Teachers Credit Union Ltd',
        shortName: 'victeach',
        id: 'victeach_teachers_credit_union_ltd',
        isPartner: false,
    },
    { name: 'Credit Corp', shortName: 'CCFS', id: 'credit_corp', isPartner: false },
    { name: 'Credit Union SA', shortName: 'CUSA', id: 'credit_union_sa', isPartner: false },
    { name: 'Family First Credit Union', shortName: 'FFCU', id: 'family_first_credit_union', isPartner: false },
    { name: 'Fox Symes', shortName: 'FS', id: 'fox_symes', isPartner: false },
    { name: 'Freedom Lend', shortName: 'FL', id: 'freedom_lend', isPartner: false },
    { name: 'Lysaght Credit Union', shortName: 'LCU', id: 'lysaght_credit_union', isPartner: false },
    { name: 'Police Credit Union (NSW)', shortName: 'policecu', id: 'police_credit_union_nsw', isPartner: false },
    { name: 'The Rock', shortName: 'RBS', id: 'the_rock', isPartner: false },
    { name: 'Zip Co', shortName: 'Zip', id: 'zip', isPartner: false },
    { name: 'Plenti', shortName: 'Plenti', id: 'plenti', isPartner: false },
    { name: 'Latitude Financial', shortName: 'Latitude', id: 'latitude', isPartner: false },
    { name: 'Cash Converters', shortName: 'Cash Converters', id: 'cash_converters', isPartner: false },
    { name: 'Nimble', shortName: 'Nimble', id: 'nimble', isPartner: false },
    { name: 'SocietyOne', shortName: 'SocietyOne', id: 'societyone', isPartner: false },
    { name: 'MoneyMe', shortName: 'mme', id: 'moneyme', isPartner: false },
    { name: 'Harmoney', shortName: 'Harmoney', id: 'harmoney', isPartner: false },
    { name: 'Afterpay', shortName: 'Afterpay', id: 'afterpay', isPartner: false },
    {
        name: 'Australian Pensioners Insurance',
        shortName: 'API',
        id: 'australian_pensioners_insurance',
        isPartner: false,
    },
    { name: 'Cash Converters ', shortName: 'Cash Converters', id: 'cash_converters_', isPartner: false },
    { name: 'Iden Group', shortName: 'Iden', id: 'iden_group', isPartner: false },
    { name: 'Members Equity Bank', shortName: 'ME Bank', id: 'members_equity_bank', isPartner: false },
    { name: 'National Mortgage Corporation', shortName: 'NMC', id: 'national_mortgage_corporation', isPartner: false },
    { name: 'Queensland Credit Union', shortName: 'QCU', id: 'queensland_credit_union', isPartner: false },
    {
        name: 'Queensland Professional Credit Union',
        shortName: 'QPCU',
        id: 'queensland_professional_credit_union',
        isPartner: false,
    },
    { name: 'Think Tank Group Pty Ltd', shortName: 'Think Tank', id: 'think_tank_group_pty_ltd', isPartner: false },
    {
        name: 'Volkswagon Financial Services',
        shortName: 'VW Finance',
        id: 'volkswagon_financial_services',
        isPartner: false,
    },
    { name: 'Zip Co', shortName: 'zip', id: 'zip_co', isPartner: false },
];
var NON_PARTNER_WITHOUT_SHORTNAME = [
    { name: 'CommBank Financial Planner', shortName: '', id: 'commBank_financial_planner', isPartner: false },
    { name: 'Homeloans.com.au', shortName: '', id: 'homeloans_com_au', isPartner: false },
    { name: 'Horizon Bank', shortName: '', id: 'horizon_bank', isPartner: false },
    { name: 'Loans.com.au', shortName: '', id: 'loans_com_au', isPartner: false },
    { name: 'Nova Alliance Bank', shortName: '', id: 'nova_alliance_bank', isPartner: false },
    { name: 'QBank', shortName: '', id: 'qbank', isPartner: false },
    { name: 'Reduce', shortName: '', id: 'reduce', isPartner: false },
    { name: 'Regional Australia Bank', shortName: '', id: 'regional_australia_bank', isPartner: false },
    { name: 'Unity Bank', shortName: '', id: 'unity_bank', isPartner: false },
    { name: 'Allstate Home Loans', shortName: '', id: 'allstate_home_loans', isPartner: false },
    { name: 'ANZ Wealth', shortName: '', id: 'anz_wealth', isPartner: false },
    { name: 'Armidale Building Society', shortName: '', id: 'armidale_building_society', isPartner: false },
    { name: 'Asahi Bank', shortName: '', id: 'asahi_bank', isPartner: false },
    { name: 'Assured', shortName: '', id: 'assured', isPartner: false },
    { name: 'Athena', shortName: '', id: 'athena', isPartner: false },
    { name: 'Aussie Mastercard', shortName: '', id: 'aussie_mastercard', isPartner: false },
    { name: 'Aussie Mortgage Ltd', shortName: '', id: 'aussie_mortgage', isPartner: false },
    { name: 'Aust Alliance', shortName: '', id: 'aust_alliance', isPartner: false },
    { name: 'Austral Mortgage', shortName: '', id: 'austral_mortgage', isPartner: false },
    { name: 'Australian Ethical', shortName: '', id: 'australian _ethical', isPartner: false },
    { name: 'AustralianSuper', shortName: '', id: 'australian_super', isPartner: false },
    { name: 'AustSafe', shortName: '', id: 'aust_safe', isPartner: false },
    { name: 'Australian Catholic', shortName: '', id: 'australian_catholic', isPartner: false },
    { name: 'Australian Eagle', shortName: '', id: 'australian_eagle', isPartner: false },
    { name: 'AV Super', shortName: '', id: 'av_super', isPartner: false },
    { name: 'Bank of Tokyo-Mitsubishi', shortName: '', id: 'bank_of_tokyo_mitsubishi', isPartner: false },
    { name: 'Barnes Home Loans', shortName: '', id: 'barnes_home_loans', isPartner: false },
    { name: 'Brighten Home Loans', shortName: '', id: 'brighten_ome_loans', isPartner: false },
    { name: 'Building Society MP', shortName: '', id: 'building_society_mp', isPartner: false },
    { name: 'Buyers Edge', shortName: '', id: 'buyers_edge', isPartner: false },
    { name: 'Capital Finance', shortName: '', id: 'capital_finance', isPartner: false },
    { name: 'Capricornia Credit Union', shortName: '', id: 'capricornia_credit_union', isPartner: false },
    { name: 'CareSuper', shortName: '', id: 'care_super', isPartner: false },
    { name: 'Cash Doctors', shortName: '', id: 'cash_doctors', isPartner: false },
    { name: 'Catalyst Money', shortName: '', id: 'catalyst_money', isPartner: false },
    { name: 'Catholic Church', shortName: '', id: 'catholic_church', isPartner: false },
    { name: 'Catholic Super', shortName: '', id: 'catholic_super', isPartner: false },
    { name: 'Certegy', shortName: '', id: 'certegy', isPartner: false },
    { name: 'Chase Manhattan Bank', shortName: '', id: 'chase_manhattan_bank', isPartner: false },
    { name: 'Chequecash Pty Ltd', shortName: '', id: 'chequecash_pty_ltd', isPartner: false },
    { name: 'ChoiceLend', shortName: '', id: 'choiceLend', isPartner: false },
    { name: 'Christian Super', shortName: '', id: 'christian_super', isPartner: false },
    { name: 'Citywide Home Loans', shortName: '', id: 'citywide_home_loans', isPartner: false },
    { name: 'Co Operative Ins Co', shortName: '', id: 'co_operative_ins_co', isPartner: false },
    { name: 'Colonial First State', shortName: '', id: 'colonial_first_state', isPartner: false },
    { name: 'Colonial Mutual', shortName: '', id: 'colonial_mutual', isPartner: false },
    { name: 'Colonial', shortName: '', id: 'colonial', isPartner: false },
    { name: 'Commercial Union', shortName: '', id: 'commercial_union', isPartner: false },
    { name: 'CommInsure', shortName: '', id: 'commInsure', isPartner: false },
    { name: 'CPS Credit Union', shortName: '', id: 'cps_ credit Union', isPartner: false },
    { name: 'Credit Union Settlement Services', shortName: '', id: 'credit_union_settlement_services', isPartner: false },
    { name: 'Cumis', shortName: '', id: 'cumis', isPartner: false },
    { name: 'Cuscal', shortName: '', id: 'Cuscal', isPartner: false },
    { name: 'Custom Credit', shortName: '', id: 'custom_credit', isPartner: false },
    { name: 'Dai-Ichi Kango Bank', shortName: '', id: 'dai_ichi_kango_bank', isPartner: false },
    { name: 'Daimlerchrysler Finance', shortName: '', id: 'daimlerchrysler_finance', isPartner: false },
    { name: 'Debt Purchase Australia', shortName: '', id: 'debt_purchase_australia', isPartner: false },
    { name: 'Defence Credit', shortName: '', id: 'defence_credit', isPartner: false },
    {
        name: 'Defence Force Credit Union Limited',
        shortName: '',
        id: 'defence_force_credit_union_limited',
        isPartner: false,
    },
    { name: 'Defence Services Homes', shortName: '', id: 'defence_services_homes', isPartner: false },
    { name: 'Delphi Bank', shortName: '', id: 'delphi_bank', isPartner: false },
    {
        name: 'Dnister Ukrainian Credit Co-operative',
        shortName: '',
        id: 'dnister_ukrainian_credit_co_operative',
        isPartner: false,
    },
    { name: 'Easy Street Financial Services', shortName: '', id: 'easy_street_financial_services', isPartner: false },
    { name: 'ELCOM Credit Union', shortName: '', id: 'elcom_credit_union', isPartner: false },
    { name: 'Energy Super', shortName: '', id: 'energy_super', isPartner: false },
    { name: 'Equity Super', shortName: '', id: 'equity_super', isPartner: false },
    { name: 'Esanda', shortName: '', id: 'esanda', isPartner: false },
    { name: 'Essential Super', shortName: '', id: 'essential_super', isPartner: false },
    { name: 'Ezy Bank', shortName: '', id: 'ezy_bank', isPartner: false },
    { name: 'FAI', shortName: '', id: 'fai', isPartner: false },
    { name: 'FASTLend', shortName: '', id: 'fastlend', isPartner: false },
    { name: 'Federation', shortName: '', id: 'federation', isPartner: false },
    { name: 'FinancePath', shortName: '', id: 'finance_path', isPartner: false },
    { name: 'Fire Brigades Credit Union', shortName: '', id: 'fire_brigades_credit_union', isPartner: false },
    { name: 'Fire Service Credit Union', shortName: '', id: 'fire_service_credit_union', isPartner: false },
    { name: 'First Choice Credit Union', shortName: '', id: 'first_choice_credit_union', isPartner: false },
    { name: 'First National Bank of Chicago', shortName: '', id: 'first_national_bank_of_chicago', isPartner: false },
    { name: 'First Option Bank', shortName: '', id: 'first_option_bank', isPartner: false },
    { name: 'First Permanent Home Loans', shortName: '', id: 'first_permanent_home_loans', isPartner: false },
    {
        name: 'First Provincial Building Society',
        shortName: '',
        id: 'first_provincial_building_society',
        isPartner: false,
    },
    { name: 'First State Super', shortName: '', id: 'first_state_super', isPartner: false },
    { name: 'First Super', shortName: '', id: 'first_super', isPartner: false },
    { name: 'Flexirent', shortName: '', id: 'flexirent', isPartner: false },
    { name: 'Ford Credit', shortName: '', id: 'ford_credit', isPartner: false },
    { name: 'Fortis', shortName: '', id: 'fortis', isPartner: false },
    { name: 'Future Financial', shortName: '', id: 'future_financial', isPartner: false },
    { name: 'G&C Mutual Bank', shortName: '', id: 'gc_mutual_bank', isPartner: false },
    { name: 'GE Automotive', shortName: '', id: 'ge_automotive', isPartner: false },
    {
        name: 'GE Capital Finance (Go Mastercard)',
        shortName: '',
        id: 'ge_capital_finance_go_mastercard',
        isPartner: false,
    },
    { name: 'GE Capital Finance', shortName: '', id: 'ge_capital_finance', isPartner: false },
    { name: 'GE Credit Line', shortName: '', id: 'ge_credit_line', isPartner: false },
    { name: 'Ge Finance', shortName: '', id: 'ge_finance', isPartner: false },
    { name: 'GE Money Aust Pty Ltd', shortName: '', id: 'ge_money_aust_pty_ltd', isPartner: false },
    { name: 'GE Mortgages', shortName: '', id: 'ge_mortgages', isPartner: false },
    { name: 'Geelong Bank', shortName: '', id: 'geelong_bank', isPartner: false },
    { name: 'GIO Building Society', shortName: '', id: 'gio_building_society', isPartner: false },
    { name: 'Grace Bros', shortName: '', id: 'grace_bros', isPartner: false },
    { name: 'Greater Building Society', shortName: '', id: 'greater_building_society', isPartner: false },
    { name: 'Hanover Consumer Finance', shortName: '', id: 'hanover_consumer_finance', isPartner: false },
    { name: 'Home Building Society', shortName: '', id: 'home_building_society', isPartner: false },
    { name: 'Homeside', shortName: '', id: 'homeside', isPartner: false },
    { name: 'Homestar Finance', shortName: '', id: 'homestar_finance', isPartner: false },
    { name: 'Homestart Finance', shortName: 'HST', id: 'homestart_finance', isPartner: false },
    { name: 'Homeswest', shortName: '', id: 'homeswest', isPartner: false },
    { name: 'Hunter United', shortName: '', id: 'hunter_united', isPartner: false },
    { name: 'IBJ Australia Bank', shortName: '', id: 'ibj_australia_bank', isPartner: false },
    { name: 'Ignite', shortName: '', id: 'ignite', isPartner: false },
    { name: 'Illawarra Building Society', shortName: '', id: 'illawarra_building_society', isPartner: false },
    { name: 'INC Invest', shortName: '', id: 'inc_invest', isPartner: false },
    { name: 'ING Mercantile Mutual Bank', shortName: '', id: 'ing_mercantile_mutual_bank', isPartner: false },
    { name: 'Intech Credit Union', shortName: '', id: 'intech_credit_union', isPartner: false },
    { name: 'InTrust', shortName: '', id: 'in_trust', isPartner: false },
    { name: 'Investec', shortName: '', id: 'investec', isPartner: false },
    { name: 'Kinetic', shortName: '', id: 'kinetic', isPartner: false },
    { name: 'Legal Super', shortName: '', id: 'legal_super', isPartner: false },
    { name: 'Lion Finance', shortName: '', id: 'lion_finance', isPartner: false },
    { name: 'M Capitol', shortName: '', id: 'm_capitol', isPartner: false },
    {
        name: 'Mackay Permanent Building Society',
        shortName: '',
        id: 'mackay_permanent_building_society',
        isPartner: false,
    },
    { name: 'Manufacture Mutual', shortName: '', id: 'manufacture_mutual', isPartner: false },
    { name: 'Media Super', shortName: '', id: 'media_super', isPartner: false },
    { name: 'Mitchell Building Society', shortName: '', id: 'mitchell_building_society', isPartner: false },
    {
        name: 'Morgan Guaranty Trust Bank of New York',
        shortName: '',
        id: 'morgan_guaranty_trust_bank_of_new_york',
        isPartner: false,
    },
    { name: 'Mortgage Choice', shortName: '', id: 'mortgage_choice', isPartner: false },
    { name: 'Mortgage Ezy', shortName: '', id: 'mortgage_ezy', isPartner: false },
    { name: 'Mortgage House', shortName: '', id: 'mortgage_house', isPartner: false },
    { name: 'Mortgage Mart', shortName: '', id: 'mortgage_mart', isPartner: false },
    { name: 'Mortgageport', shortName: '', id: 'mortgageport', isPartner: false },
    { name: 'MOVE Bank', shortName: '', id: 'move_bank', isPartner: false },
    { name: 'NCUIS', shortName: '', id: 'ncuis', isPartner: false },
    { name: 'NSW Home Loans', shortName: '', id: 'new_home_loans', isPartner: false },
    { name: 'NSW Teachers Credit Union', shortName: '', id: 'new__teachers_credit_union', isPartner: false },
    { name: 'OneAnswer', shortName: '', id: 'one_answer', isPartner: false },
    { name: 'Orange Credit Union', shortName: '', id: 'orange_credit_union', isPartner: false },
    { name: 'Other', shortName: '', id: 'other', isPartner: false },
    { name: 'Payday Central', shortName: '', id: 'payday_central', isPartner: false },
    { name: 'Pensioners Insurance', shortName: '', id: 'pensioners_insurance', isPartner: false },
    { name: 'Perpetual Trustee', shortName: '', id: 'perpetual_trustee', isPartner: false },
    { name: 'PLANLend', shortName: '', id: 'planlend', isPartner: false },
    { name: 'Police and Nurses', shortName: '', id: 'police_and_nurses', isPartner: false },
    { name: 'Police Bank', shortName: '', id: 'police_bank', isPartner: false },
    { name: 'Powerstate Credit Union', shortName: '', id: 'powerstate_credit_union', isPartner: false },
    {
        name: 'Primary Industry Bank of Australia',
        shortName: '',
        id: 'primary_industry_bank_of_australia',
        isPartner: false,
    },
    { name: 'Prime', shortName: '', id: 'prime', isPartner: false },
    { name: 'Prospect Credit Union', shortName: '', id: 'prospect_credit_union', isPartner: false },
    { name: 'Public Trustee', shortName: '', id: 'public_trustee', isPartner: false },
    { name: 'Pulse Credit Union', shortName: '', id: 'pulse_credit_union', isPartner: false },
    { name: 'Qudos Bank', shortName: '', id: 'qudos_bank', isPartner: false },
    {
        name: 'Queensland Industry Development Corp',
        shortName: '',
        id: 'queensland_industry_development_corp',
        isPartner: false,
    },
    { name: 'Queensland Teachers Credit Union', shortName: '', id: 'queensland_teachers_credit_union', isPartner: false },
    { name: 'Queenslanders Credit Union', shortName: '', id: 'queenslanders_credit_union', isPartner: false },
    { name: 'REST Super', shortName: '', id: 'rest_super', isPartner: false },
    { name: 'RAC WA', shortName: '', id: 'rac_wa', isPartner: false },
    { name: 'RACQ Bank', shortName: '', id: 'racq_bank', isPartner: false },
    { name: 'Radio Rentals', shortName: '', id: 'radio_rentals', isPartner: false },
    { name: 'Railways Credit Union', shortName: '', id: 'railways_credit_union', isPartner: false },
    { name: 'Repcol', shortName: '', id: 'repcol', isPartner: false },
    { name: 'RESI Mortgage Corporation', shortName: '', id: 'resi_mortgage_corporation,', isPartner: false },
    { name: 'Resi', shortName: '', id: 'resi,', isPartner: false },
    { name: 'Royal Life', shortName: '', id: 'royal_life,', isPartner: false },
    { name: 'Russell Investments', shortName: '', id: 'russell_investments', isPartner: false },
    { name: 'Sanwa Australia Finance Limited', shortName: '', id: 'Sanwa Australia Finance Limited', isPartner: false },
    { name: 'Savings And Loans Credit Union', shortName: '', id: 'savings_and_loans_credit_union', isPartner: false },
    { name: 'SCU', shortName: '', id: 'scu', isPartner: false },
    { name: 'Service One Alliance Bank', shortName: '', id: 'service_one_alliance_bank', isPartner: false },
    { name: 'Shannons', shortName: '', id: 'shannons', isPartner: false },
    { name: 'SmartSave', shortName: '', id: 'smart_save', isPartner: false },
    { name: 'Southern Cross Credit Union', shortName: '', id: 'southern_cross_credit_union', isPartner: false },
    { name: 'Sovereign Credit', shortName: '', id: 'sovereign_credit', isPartner: false },
    { name: 'St Andrew', shortName: '', id: 'st_andrew', isPartner: false },
    { name: 'Standard Chartered Bank Aust', shortName: '', id: 'standard_chartered_bank_aust', isPartner: false },
    { name: 'State Custodians', shortName: '', id: 'state_custodians', isPartner: false },
    { name: 'Statewide', shortName: '', id: 'statewide', isPartner: false },
    { name: 'Stronghold', shortName: '', id: 'stronghold', isPartner: false },
    { name: 'Sun Alliance', shortName: '', id: 'sun_alliance', isPartner: false },
    { name: 'Sunsuper', shortName: '', id: 'sunsuper', isPartner: false },
    { name: 'Swann', shortName: '', id: 'swann', isPartner: false },
    { name: 'TasPlan', shortName: '', id: 'tas_plan', isPartner: false },
    { name: 'Teachers Credit Union', shortName: '', id: 'teachers_credit_union', isPartner: false },
    {
        name: 'Territory Mutual Building Society',
        shortName: '',
        id: 'territory_mutual_building_society',
        isPartner: false,
    },
    { name: 'The Capricornia', shortName: '', id: 'the_capricornia', isPartner: false },
    { name: 'The Mac', shortName: '', id: 'the_mac', isPartner: false },
    { name: 'The Mutual Bank', shortName: '', id: 'the_mutual_bank', isPartner: false },
    { name: 'Tonto Home Loans', shortName: '', id: 'tonto_home_loans', isPartner: false },
    { name: 'Town And Country Bank', shortName: '', id: 'town_and_country_bank', isPartner: false },
    { name: 'Toyota Finance Australia', shortName: '', id: 'toyota_finance_australia', isPartner: false },
    { name: 'Transport Mutual Credit Union', shortName: '', id: 'transport_mutual_credit_union', isPartner: false },
    { name: 'TWUSUPER', shortName: '', id: 'twusuper', isPartner: false },
    { name: 'UBank', shortName: '', id: 'ubank', isPartner: false },
    { name: 'United Credit Union', shortName: '', id: 'united_credit_union', isPartner: false },
    { name: 'University Credit Society', shortName: '', id: 'university_credit_society', isPartner: false },
    { name: 'VACC', shortName: '', id: 'vacc', isPartner: false },
    { name: 'Vero', shortName: '', id: 'vero', isPartner: false },
    { name: 'VicSuper', shortName: '', id: 'vic_super', isPartner: false },
    { name: 'Virgin Super', shortName: '', id: 'virgin_super', isPartner: false },
    { name: 'Visions', shortName: '', id: 'visions', isPartner: false },
    { name: 'Western QBE', shortName: '', id: 'western_qbe', isPartner: false },
    { name: 'Westfarmers', shortName: '', id: 'westfarmers', isPartner: false },
    { name: 'Westpack Insurance Services', shortName: '', id: 'westpack_insurance_services', isPartner: false },
    {
        name: 'Wide Bay Capricorn Building Society',
        shortName: '',
        id: 'wide_bay_capricorn_building_society',
        isPartner: false,
    },
    { name: 'Wizard', shortName: '', id: 'wizard', isPartner: false },
    {
        name: 'Woolworths Employees Credit Union',
        shortName: '',
        id: 'woolworths_employees_credit_union',
        isPartner: false,
    },
    { name: 'ANZ Asset Finance', shortName: '', id: 'anz_asset_finance', isPartner: false },
    { name: 'Nab Broker', shortName: '', id: 'nab_broker', isPartner: false },
    { name: 'PNC Financial services', shortName: '', id: 'pnc_financial_services', isPartner: false },
    { name: 'World Marine and General', shortName: '', id: 'world_marine_and_general', isPartner: false },
    { name: 'Xinja', shortName: '', id: 'xinjia', isPartner: false },
    { name: 'Yellow Brick Road', shortName: '', id: 'yellow_brick_road', isPartner: false },
    { name: 'Zurich', shortName: '', id: 'zurich', isPartner: false },
    { name: 'Volt', shortName: '', id: 'volt', isPartner: false },
    { name: 'BNK', shortName: '', id: 'BNK', isPartner: false },
    { name: '86 400', shortName: '', id: '86_400', isPartner: false },
    { name: 'ADCU', shortName: '', id: 'adcu', isPartner: false },
    { name: 'AFG Advantedge', shortName: '', id: 'afg_advantedge', isPartner: false },
    { name: 'AFM', shortName: '', id: 'afm', isPartner: false },
    { name: 'Ample Capital Australia', shortName: '', id: 'ample_capital_australia', isPartner: false },
    { name: 'Anchorage', shortName: '', id: 'anchorage', isPartner: false },
    { name: 'ANZ Asset Finance ', shortName: '', id: 'anz_asset_finance_', isPartner: false },
    { name: 'AUL', shortName: '', id: 'aul', isPartner: false },
    {
        name: 'Australian Financial Holdings Pty Ltd',
        shortName: '',
        id: 'australian_financial_holdings_pty_ltd',
        isPartner: false,
    },
    { name: 'Australian Lending Services', shortName: '', id: 'australian_lending_services', isPartner: false },
    { name: 'Australian Wholesale Lending', shortName: '', id: 'australian_wholesale_lending', isPartner: false },
    { name: 'Bank of South Australia', shortName: '', id: 'bank_of_south_australia', isPartner: false },
    { name: 'Banksia', shortName: '', id: 'banksia', isPartner: false },
    { name: 'BCHL', shortName: '', id: 'bchl', isPartner: false },
    { name: 'Bluegum', shortName: '', id: 'bluegum', isPartner: false },
    { name: 'BMC', shortName: '', id: 'bmc', isPartner: false },
    { name: 'BMC Advantedge', shortName: '', id: 'bmc_advantedge', isPartner: false },
    { name: 'CACU', shortName: '', id: 'cacu', isPartner: false },
    { name: 'Coles Financial Services', shortName: '', id: 'coles_financial_services', isPartner: false },
    { name: 'Collins Securities', shortName: '', id: 'collins_securities', isPartner: false },
    { name: 'Columbus Capital Pty Ltd', shortName: '', id: 'columbus_capital_pty_ltd', isPartner: false },
    { name: 'Community CPS Australia ', shortName: '', id: 'community_cps_australia_', isPartner: false },
    { name: 'Community Mutual Ltd', shortName: '', id: 'community_mutual_ltd', isPartner: false },
    { name: 'Credit Union Home Loans', shortName: '', id: 'credit_union_home_loans', isPartner: false },
    { name: 'Direct Mortgage Solutions', shortName: '', id: 'direct_mortgage_solutions', isPartner: false },
    { name: 'Director of Housing VIC ', shortName: '', id: 'director_of_housing_vic_', isPartner: false },
    { name: 'Domain', shortName: '', id: 'domain', isPartner: false },
    { name: 'Economy', shortName: '', id: 'economy', isPartner: false },
    { name: 'eMoney', shortName: '', id: 'emoney', isPartner: false },
    { name: 'Ezy Mortgage', shortName: '', id: 'ezy_mortgage', isPartner: false },
    { name: 'Faraday West and Co Pty Ltd', shortName: '', id: 'faraday_west_and_co_pty_ltd', isPartner: false },
    { name: 'Fifty Group', shortName: '', id: 'fifty_group', isPartner: false },
    { name: 'Finance Express Home Loans', shortName: '', id: 'finance_express_home_loans', isPartner: false },
    { name: 'First Folio', shortName: '', id: 'first_folio', isPartner: false },
    { name: 'Firstmac', shortName: '', id: 'firstmac', isPartner: false },
    { name: 'Fleet Partners Auto Loan', shortName: '', id: 'fleet_partners_auto_loan', isPartner: false },
    { name: 'FlexiGroup', shortName: '', id: 'flexigroup', isPartner: false },
    { name: 'Good Shepherd Microfinance', shortName: '', id: 'good_shepherd_microfinance', isPartner: false },
    { name: 'Great Southern Loans', shortName: '', id: 'great_southern_loans', isPartner: false },
    { name: 'Greater Bank Ltd', shortName: '', id: 'greater_bank_ltd', isPartner: false },
    { name: 'Harmoney Australia', shortName: '', id: 'harmoney_australia', isPartner: false },
    { name: 'HBS', shortName: '', id: 'hbs', isPartner: false },
    { name: 'Hemisphere', shortName: '', id: 'hemisphere', isPartner: false },
    { name: 'Homeloan Centre Australia', shortName: '', id: 'homeloan_centre_australia', isPartner: false },
    { name: 'HomePath', shortName: '', id: 'homepath', isPartner: false },
    { name: 'HostPlus', shortName: '', id: 'hostplus', isPartner: false },
    { name: 'Humm', shortName: '', id: 'humm', isPartner: false },
    { name: 'Infiniti Finservices Australia', shortName: '', id: 'infiniti_finservices_australia', isPartner: false },
    { name: 'JetStar Credit Cards', shortName: '', id: 'jetstar_credit_cards', isPartner: false },
    { name: 'Latitude Finance Australia', shortName: '', id: 'latitude_finance_australia', isPartner: false },
    { name: 'LoanMarket Advantedge', shortName: '', id: 'loanmarket_advantedge', isPartner: false },
    { name: 'LoanPlan', shortName: '', id: 'loanplan', isPartner: false },
    { name: 'Maxxia', shortName: '', id: 'maxxia', isPartner: false },
    { name: 'MCCA', shortName: '', id: 'mcca', isPartner: false },
    { name: 'Mercedez-Benz Financial Services', shortName: '', id: 'mercedez-benz_financial_services', isPartner: false },
    { name: 'MIIP', shortName: '', id: 'miip', isPartner: false },
    { name: 'Mitsubishi', shortName: '', id: 'mitsubishi', isPartner: false },
    { name: 'Money Quest Australia Pty Ltd', shortName: '', id: 'money_quest_australia_pty_ltd', isPartner: false },
    { name: 'MoneyPlace AFSL', shortName: '', id: 'moneyplace_afsl', isPartner: false },
    { name: 'MSL', shortName: '', id: 'msl', isPartner: false },
    { name: 'Myer Credit Cards', shortName: '', id: 'myer_credit_cards', isPartner: false },
    { name: 'MyOzMoney', shortName: '', id: 'myozmoney', isPartner: false },
    { name: 'Napiers', shortName: '', id: 'napiers', isPartner: false },
    { name: 'NCF Financial Services PtyLtd', shortName: '', id: 'ncf_financial_services_ptyltd', isPartner: false },
    { name: 'NFC', shortName: '', id: 'nfc', isPartner: false },
    { name: 'NHL', shortName: '', id: 'nhl', isPartner: false },
    { name: 'Nissan Financial Services', shortName: '', id: 'nissan_financial_services', isPartner: false },
    { name: 'NMMC', shortName: '', id: 'nmmc', isPartner: false },
    { name: 'Now Finance', shortName: '', id: 'now_finance', isPartner: false },
    { name: 'OFG', shortName: '', id: 'ofg', isPartner: false },
    { name: 'ORIX', shortName: '', id: 'orix', isPartner: false },
    { name: 'Paladin', shortName: '', id: 'paladin', isPartner: false },
    { name: 'Pioneer Credit Ltd', shortName: '', id: 'pioneer_credit_ltd', isPartner: false },
    { name: 'PNCS', shortName: '', id: 'pncs', isPartner: false },
    { name: 'Power Home Loans', shortName: '', id: 'power_home_loans', isPartner: false },
    { name: 'Rate Money Pty Ltd', shortName: '', id: 'rate_money_pty_ltd', isPartner: false },
    { name: 'RedZed', shortName: '', id: 'redzed', isPartner: false },
    { name: 'Renault Finance ', shortName: '', id: 'renault_finance_', isPartner: false },
    { name: 'Residential Mortgage Group', shortName: '', id: 'residential_mortgage_group', isPartner: false },
    { name: 'RHG', shortName: '', id: 'rhg', isPartner: false },
    { name: 'Sam Loans', shortName: '', id: 'sam_loans', isPartner: false },
    { name: 'Sandhurst Trustees', shortName: '', id: 'sandhurst_trustees', isPartner: false },
    { name: 'SGE Credit Union', shortName: '', id: 'sge_credit_union', isPartner: false },
    { name: 'Skyline Car Finance', shortName: '', id: 'skyline_car_finance', isPartner: false },
    { name: 'Smartline', shortName: '', id: 'smartline', isPartner: false },
    { name: 'Society One Australia', shortName: '', id: 'society_one_australia', isPartner: false },
    { name: 'Southland Building Society', shortName: '', id: 'southland_building_society', isPartner: false },
    { name: 'Sydney Home Loans', shortName: '', id: 'sydney_home_loans', isPartner: false },
    { name: 'Symple Loans Australia', shortName: '', id: 'symple_loans_australia', isPartner: false },
    { name: 'The Co-operative Bank', shortName: '', id: 'the_co-operative_bank', isPartner: false },
    { name: 'ThinkMe Finance', shortName: '', id: 'thinkme_finance', isPartner: false },
    { name: 'VTMB', shortName: '', id: 'vtmb', isPartner: false },
    { name: 'Wisr Finance Pty Ltd', shortName: '', id: 'wisr_finance_pty_ltd', isPartner: false },
    { name: 'Woolworths', shortName: '', id: 'woolworths', isPartner: false },
    { name: 'World Home Loans', shortName: '', id: 'world_home_loans', isPartner: false },
    { name: 'Yes Home Loans', shortName: '', id: 'yes_home_loans', isPartner: false },
    { name: 'Your Manager', shortName: '', id: 'your_manager', isPartner: false },
];
var NON_PARTNER_LENDERS = __spreadArray(__spreadArray([], NON_PARTNER_WITH_SHORTNAME, true), NON_PARTNER_WITHOUT_SHORTNAME, true);
var LENDERS = __spreadArray(__spreadArray([], PARTNER_LENDERS, true), NON_PARTNER_LENDERS, true);
var LENDER_DICTIONARY = Object.fromEntries(__spreadArray(__spreadArray([], PARTNER_LENDERS_WITH_SHORTNAME.map(function (pl) { return [pl.name, pl]; }), true), NON_PARTNER_WITH_SHORTNAME.map(function (npl) { return [npl.name, npl]; }), true));
var getByName = function (name) {
    return LENDER_DICTIONARY[name];
};
//# sourceMappingURL=Lenders.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Address.js
var StreetSuffixes;
(function (StreetSuffixes) {
    StreetSuffixes[StreetSuffixes["Central"] = 0] = "Central";
    StreetSuffixes[StreetSuffixes["Deviation"] = 1] = "Deviation";
    StreetSuffixes[StreetSuffixes["East"] = 2] = "East";
    StreetSuffixes[StreetSuffixes["Extension"] = 3] = "Extension";
    StreetSuffixes[StreetSuffixes["Lower"] = 4] = "Lower";
    StreetSuffixes[StreetSuffixes["Inner"] = 5] = "Inner";
    StreetSuffixes[StreetSuffixes["Mall"] = 6] = "Mall";
    StreetSuffixes[StreetSuffixes["North"] = 7] = "North";
    StreetSuffixes[StreetSuffixes["North East"] = 8] = "North East";
    StreetSuffixes[StreetSuffixes["North West"] = 9] = "North West";
    StreetSuffixes[StreetSuffixes["Off"] = 10] = "Off";
    StreetSuffixes[StreetSuffixes["On"] = 11] = "On";
    StreetSuffixes[StreetSuffixes["Outer"] = 12] = "Outer";
    StreetSuffixes[StreetSuffixes["Overpass"] = 13] = "Overpass";
    StreetSuffixes[StreetSuffixes["South"] = 14] = "South";
    StreetSuffixes[StreetSuffixes["South East"] = 15] = "South East";
    StreetSuffixes[StreetSuffixes["South West"] = 16] = "South West";
    StreetSuffixes[StreetSuffixes["Upper"] = 17] = "Upper";
    StreetSuffixes[StreetSuffixes["West"] = 18] = "West";
})(StreetSuffixes || (StreetSuffixes = {}));
var StreetTypes;
(function (StreetTypes) {
    StreetTypes[StreetTypes["Access"] = 0] = "Access";
    StreetTypes[StreetTypes["Alley"] = 1] = "Alley";
    StreetTypes[StreetTypes["Alleyway"] = 2] = "Alleyway";
    StreetTypes[StreetTypes["Amble"] = 3] = "Amble";
    StreetTypes[StreetTypes["Anchorage"] = 4] = "Anchorage";
    StreetTypes[StreetTypes["Approach"] = 5] = "Approach";
    StreetTypes[StreetTypes["Arcade"] = 6] = "Arcade";
    StreetTypes[StreetTypes["Arterial"] = 7] = "Arterial";
    StreetTypes[StreetTypes["Artery"] = 8] = "Artery";
    StreetTypes[StreetTypes["Avenue"] = 9] = "Avenue";
    StreetTypes[StreetTypes["Banan"] = 10] = "Banan";
    StreetTypes[StreetTypes["Bank"] = 11] = "Bank";
    StreetTypes[StreetTypes["Basin"] = 12] = "Basin";
    StreetTypes[StreetTypes["Bay"] = 13] = "Bay";
    StreetTypes[StreetTypes["Beach"] = 14] = "Beach";
    StreetTypes[StreetTypes["Bend"] = 15] = "Bend";
    StreetTypes[StreetTypes["Block"] = 16] = "Block";
    StreetTypes[StreetTypes["Boardwalk"] = 17] = "Boardwalk";
    StreetTypes[StreetTypes["Boulevard"] = 18] = "Boulevard";
    StreetTypes[StreetTypes["Boulevarde"] = 19] = "Boulevarde";
    StreetTypes[StreetTypes["Bowl"] = 20] = "Bowl";
    StreetTypes[StreetTypes["Brace"] = 21] = "Brace";
    StreetTypes[StreetTypes["Brae"] = 22] = "Brae";
    StreetTypes[StreetTypes["Break"] = 23] = "Break";
    StreetTypes[StreetTypes["Bridge"] = 24] = "Bridge";
    StreetTypes[StreetTypes["Broadway"] = 25] = "Broadway";
    StreetTypes[StreetTypes["Brow"] = 26] = "Brow";
    StreetTypes[StreetTypes["Bypass"] = 27] = "Bypass";
    StreetTypes[StreetTypes["Byway"] = 28] = "Byway";
    StreetTypes[StreetTypes["Canal"] = 29] = "Canal";
    StreetTypes[StreetTypes["Causeway"] = 30] = "Causeway";
    StreetTypes[StreetTypes["Centre"] = 31] = "Centre";
    StreetTypes[StreetTypes["Centreway"] = 32] = "Centreway";
    StreetTypes[StreetTypes["Chase"] = 33] = "Chase";
    StreetTypes[StreetTypes["Circle"] = 34] = "Circle";
    StreetTypes[StreetTypes["Circlet"] = 35] = "Circlet";
    StreetTypes[StreetTypes["Circuit"] = 36] = "Circuit";
    StreetTypes[StreetTypes["Circus"] = 37] = "Circus";
    StreetTypes[StreetTypes["Close"] = 38] = "Close";
    StreetTypes[StreetTypes["Cluster"] = 39] = "Cluster";
    StreetTypes[StreetTypes["Colonnade"] = 40] = "Colonnade";
    StreetTypes[StreetTypes["Common"] = 41] = "Common";
    StreetTypes[StreetTypes["Concourse"] = 42] = "Concourse";
    StreetTypes[StreetTypes["Connection"] = 43] = "Connection";
    StreetTypes[StreetTypes["Copse"] = 44] = "Copse";
    StreetTypes[StreetTypes["Corner"] = 45] = "Corner";
    StreetTypes[StreetTypes["Corso"] = 46] = "Corso";
    StreetTypes[StreetTypes["Course"] = 47] = "Course";
    StreetTypes[StreetTypes["Court"] = 48] = "Court";
    StreetTypes[StreetTypes["Courtyard"] = 49] = "Courtyard";
    StreetTypes[StreetTypes["Cove"] = 50] = "Cove";
    StreetTypes[StreetTypes["Crescent"] = 51] = "Crescent";
    StreetTypes[StreetTypes["Crest"] = 52] = "Crest";
    StreetTypes[StreetTypes["Cross"] = 53] = "Cross";
    StreetTypes[StreetTypes["Crossing"] = 54] = "Crossing";
    StreetTypes[StreetTypes["Crossroad"] = 55] = "Crossroad";
    StreetTypes[StreetTypes["Crossway"] = 56] = "Crossway";
    StreetTypes[StreetTypes["Cruiseway"] = 57] = "Cruiseway";
    StreetTypes[StreetTypes["Cul-De-Sac"] = 58] = "Cul-De-Sac";
    StreetTypes[StreetTypes["Cutting"] = 59] = "Cutting";
    StreetTypes[StreetTypes["Dale"] = 60] = "Dale";
    StreetTypes[StreetTypes["Dell"] = 61] = "Dell";
    StreetTypes[StreetTypes["Dene"] = 62] = "Dene";
    StreetTypes[StreetTypes["Deviation"] = 63] = "Deviation";
    StreetTypes[StreetTypes["Dip"] = 64] = "Dip";
    StreetTypes[StreetTypes["Distributor"] = 65] = "Distributor";
    StreetTypes[StreetTypes["Divide"] = 66] = "Divide";
    StreetTypes[StreetTypes["Dock"] = 67] = "Dock";
    StreetTypes[StreetTypes["Domain"] = 68] = "Domain";
    StreetTypes[StreetTypes["Drive"] = 69] = "Drive";
    StreetTypes[StreetTypes["Driveway"] = 70] = "Driveway";
    StreetTypes[StreetTypes["Edge"] = 71] = "Edge";
    StreetTypes[StreetTypes["Elbow"] = 72] = "Elbow";
    StreetTypes[StreetTypes["End"] = 73] = "End";
    StreetTypes[StreetTypes["Entrance"] = 74] = "Entrance";
    StreetTypes[StreetTypes["Esplanade"] = 75] = "Esplanade";
    StreetTypes[StreetTypes["Estate"] = 76] = "Estate";
    StreetTypes[StreetTypes["Estuary"] = 77] = "Estuary";
    StreetTypes[StreetTypes["Expressway"] = 78] = "Expressway";
    StreetTypes[StreetTypes["Extension"] = 79] = "Extension";
    StreetTypes[StreetTypes["Fairway"] = 80] = "Fairway";
    StreetTypes[StreetTypes["Fire Track"] = 81] = "Fire Track";
    StreetTypes[StreetTypes["Firebreak"] = 82] = "Firebreak";
    StreetTypes[StreetTypes["Fireline"] = 83] = "Fireline";
    StreetTypes[StreetTypes["Firetrack"] = 84] = "Firetrack";
    StreetTypes[StreetTypes["Firetrail"] = 85] = "Firetrail";
    StreetTypes[StreetTypes["Flat"] = 86] = "Flat";
    StreetTypes[StreetTypes["Follow"] = 87] = "Follow";
    StreetTypes[StreetTypes["Footway"] = 88] = "Footway";
    StreetTypes[StreetTypes["Ford"] = 89] = "Ford";
    StreetTypes[StreetTypes["Foreshore"] = 90] = "Foreshore";
    StreetTypes[StreetTypes["Formation"] = 91] = "Formation";
    StreetTypes[StreetTypes["Freeway"] = 92] = "Freeway";
    StreetTypes[StreetTypes["Front"] = 93] = "Front";
    StreetTypes[StreetTypes["Frontage"] = 94] = "Frontage";
    StreetTypes[StreetTypes["Gap"] = 95] = "Gap";
    StreetTypes[StreetTypes["Garden"] = 96] = "Garden";
    StreetTypes[StreetTypes["Gardens"] = 97] = "Gardens";
    StreetTypes[StreetTypes["Gate"] = 98] = "Gate";
    StreetTypes[StreetTypes["Gates"] = 99] = "Gates";
    StreetTypes[StreetTypes["Gateway"] = 100] = "Gateway";
    StreetTypes[StreetTypes["Glade"] = 101] = "Glade";
    StreetTypes[StreetTypes["Glen"] = 102] = "Glen";
    StreetTypes[StreetTypes["Grange"] = 103] = "Grange";
    StreetTypes[StreetTypes["Green"] = 104] = "Green";
    StreetTypes[StreetTypes["Ground"] = 105] = "Ground";
    StreetTypes[StreetTypes["Grove"] = 106] = "Grove";
    StreetTypes[StreetTypes["Gully"] = 107] = "Gully";
    StreetTypes[StreetTypes["Harbour"] = 108] = "Harbour";
    StreetTypes[StreetTypes["Heath"] = 109] = "Heath";
    StreetTypes[StreetTypes["Heights"] = 110] = "Heights";
    StreetTypes[StreetTypes["Highroad"] = 111] = "Highroad";
    StreetTypes[StreetTypes["Highway"] = 112] = "Highway";
    StreetTypes[StreetTypes["Hill"] = 113] = "Hill";
    StreetTypes[StreetTypes["Hollow"] = 114] = "Hollow";
    StreetTypes[StreetTypes["Hub"] = 115] = "Hub";
    StreetTypes[StreetTypes["Interchange"] = 116] = "Interchange";
    StreetTypes[StreetTypes["Intersection"] = 117] = "Intersection";
    StreetTypes[StreetTypes["Junction"] = 118] = "Junction";
    StreetTypes[StreetTypes["Key"] = 119] = "Key";
    StreetTypes[StreetTypes["Keys"] = 120] = "Keys";
    StreetTypes[StreetTypes["Landing"] = 121] = "Landing";
    StreetTypes[StreetTypes["Lane"] = 122] = "Lane";
    StreetTypes[StreetTypes["Laneway"] = 123] = "Laneway";
    StreetTypes[StreetTypes["Lees"] = 124] = "Lees";
    StreetTypes[StreetTypes["Line"] = 125] = "Line";
    StreetTypes[StreetTypes["Link"] = 126] = "Link";
    StreetTypes[StreetTypes["Little"] = 127] = "Little";
    StreetTypes[StreetTypes["Lookout"] = 128] = "Lookout";
    StreetTypes[StreetTypes["Loop"] = 129] = "Loop";
    StreetTypes[StreetTypes["Lower"] = 130] = "Lower";
    StreetTypes[StreetTypes["Mall"] = 131] = "Mall";
    StreetTypes[StreetTypes["Manor"] = 132] = "Manor";
    StreetTypes[StreetTypes["Meander"] = 133] = "Meander";
    StreetTypes[StreetTypes["Mears"] = 134] = "Mears";
    StreetTypes[StreetTypes["Mew"] = 135] = "Mew";
    StreetTypes[StreetTypes["Mews"] = 136] = "Mews";
    StreetTypes[StreetTypes["Mile"] = 137] = "Mile";
    StreetTypes[StreetTypes["Motorway"] = 138] = "Motorway";
    StreetTypes[StreetTypes["Mount"] = 139] = "Mount";
    StreetTypes[StreetTypes["Nook"] = 140] = "Nook";
    StreetTypes[StreetTypes["Outlet"] = 141] = "Outlet";
    StreetTypes[StreetTypes["Outlook"] = 142] = "Outlook";
    StreetTypes[StreetTypes["Parade"] = 143] = "Parade";
    StreetTypes[StreetTypes["Park"] = 144] = "Park";
    StreetTypes[StreetTypes["Parklands"] = 145] = "Parklands";
    StreetTypes[StreetTypes["Parkway"] = 146] = "Parkway";
    StreetTypes[StreetTypes["Part"] = 147] = "Part";
    StreetTypes[StreetTypes["Pass"] = 148] = "Pass";
    StreetTypes[StreetTypes["Passage"] = 149] = "Passage";
    StreetTypes[StreetTypes["Path"] = 150] = "Path";
    StreetTypes[StreetTypes["Pathway"] = 151] = "Pathway";
    StreetTypes[StreetTypes["Piazza"] = 152] = "Piazza";
    StreetTypes[StreetTypes["Pier"] = 153] = "Pier";
    StreetTypes[StreetTypes["Place"] = 154] = "Place";
    StreetTypes[StreetTypes["Plateau"] = 155] = "Plateau";
    StreetTypes[StreetTypes["Plaza"] = 156] = "Plaza";
    StreetTypes[StreetTypes["Pocket"] = 157] = "Pocket";
    StreetTypes[StreetTypes["Point"] = 158] = "Point";
    StreetTypes[StreetTypes["Port"] = 159] = "Port";
    StreetTypes[StreetTypes["Portal"] = 160] = "Portal";
    StreetTypes[StreetTypes["Promenade"] = 161] = "Promenade";
    StreetTypes[StreetTypes["Pursuit"] = 162] = "Pursuit";
    StreetTypes[StreetTypes["Quad"] = 163] = "Quad";
    StreetTypes[StreetTypes["Quadrangle"] = 164] = "Quadrangle";
    StreetTypes[StreetTypes["Quadrant"] = 165] = "Quadrant";
    StreetTypes[StreetTypes["Quay"] = 166] = "Quay";
    StreetTypes[StreetTypes["Quays"] = 167] = "Quays";
    StreetTypes[StreetTypes["Ramble"] = 168] = "Ramble";
    StreetTypes[StreetTypes["Ramp"] = 169] = "Ramp";
    StreetTypes[StreetTypes["Range"] = 170] = "Range";
    StreetTypes[StreetTypes["Reach"] = 171] = "Reach";
    StreetTypes[StreetTypes["Reserve"] = 172] = "Reserve";
    StreetTypes[StreetTypes["Rest"] = 173] = "Rest";
    StreetTypes[StreetTypes["Retreat"] = 174] = "Retreat";
    StreetTypes[StreetTypes["Return"] = 175] = "Return";
    StreetTypes[StreetTypes["Ride"] = 176] = "Ride";
    StreetTypes[StreetTypes["Ridge"] = 177] = "Ridge";
    StreetTypes[StreetTypes["Ridgeway"] = 178] = "Ridgeway";
    StreetTypes[StreetTypes["Right Of Way"] = 179] = "Right Of Way";
    StreetTypes[StreetTypes["Ring"] = 180] = "Ring";
    StreetTypes[StreetTypes["Rise"] = 181] = "Rise";
    StreetTypes[StreetTypes["Rising"] = 182] = "Rising";
    StreetTypes[StreetTypes["River"] = 183] = "River";
    StreetTypes[StreetTypes["Riverway"] = 184] = "Riverway";
    StreetTypes[StreetTypes["Riviera"] = 185] = "Riviera";
    StreetTypes[StreetTypes["Road"] = 186] = "Road";
    StreetTypes[StreetTypes["Roads"] = 187] = "Roads";
    StreetTypes[StreetTypes["Roadside"] = 188] = "Roadside";
    StreetTypes[StreetTypes["Roadway"] = 189] = "Roadway";
    StreetTypes[StreetTypes["Ronde"] = 190] = "Ronde";
    StreetTypes[StreetTypes["Rosebowl"] = 191] = "Rosebowl";
    StreetTypes[StreetTypes["Rotary"] = 192] = "Rotary";
    StreetTypes[StreetTypes["Round"] = 193] = "Round";
    StreetTypes[StreetTypes["Route"] = 194] = "Route";
    StreetTypes[StreetTypes["Row"] = 195] = "Row";
    StreetTypes[StreetTypes["Rue"] = 196] = "Rue";
    StreetTypes[StreetTypes["Run"] = 197] = "Run";
    StreetTypes[StreetTypes["Service Way"] = 198] = "Service Way";
    StreetTypes[StreetTypes["Shunt"] = 199] = "Shunt";
    StreetTypes[StreetTypes["Siding"] = 200] = "Siding";
    StreetTypes[StreetTypes["Slope"] = 201] = "Slope";
    StreetTypes[StreetTypes["Sound"] = 202] = "Sound";
    StreetTypes[StreetTypes["Spur"] = 203] = "Spur";
    StreetTypes[StreetTypes["Square"] = 204] = "Square";
    StreetTypes[StreetTypes["Stairs"] = 205] = "Stairs";
    StreetTypes[StreetTypes["State Highway"] = 206] = "State Highway";
    StreetTypes[StreetTypes["Steps"] = 207] = "Steps";
    StreetTypes[StreetTypes["Strand"] = 208] = "Strand";
    StreetTypes[StreetTypes["Street"] = 209] = "Street";
    StreetTypes[StreetTypes["Streets"] = 210] = "Streets";
    StreetTypes[StreetTypes["Strip"] = 211] = "Strip";
    StreetTypes[StreetTypes["Subway"] = 212] = "Subway";
    StreetTypes[StreetTypes["Tarn"] = 213] = "Tarn";
    StreetTypes[StreetTypes["Tarnice Way"] = 214] = "Tarnice Way";
    StreetTypes[StreetTypes["Terrace"] = 215] = "Terrace";
    StreetTypes[StreetTypes["Thoroughfare"] = 216] = "Thoroughfare";
    StreetTypes[StreetTypes["Throughway"] = 217] = "Throughway";
    StreetTypes[StreetTypes["Tollway"] = 218] = "Tollway";
    StreetTypes[StreetTypes["Top"] = 219] = "Top";
    StreetTypes[StreetTypes["Tor"] = 220] = "Tor";
    StreetTypes[StreetTypes["Towers"] = 221] = "Towers";
    StreetTypes[StreetTypes["Track"] = 222] = "Track";
    StreetTypes[StreetTypes["Trail"] = 223] = "Trail";
    StreetTypes[StreetTypes["Trailer"] = 224] = "Trailer";
    StreetTypes[StreetTypes["Triangle"] = 225] = "Triangle";
    StreetTypes[StreetTypes["Trunkway"] = 226] = "Trunkway";
    StreetTypes[StreetTypes["Turn"] = 227] = "Turn";
    StreetTypes[StreetTypes["Twist"] = 228] = "Twist";
    StreetTypes[StreetTypes["Underpass"] = 229] = "Underpass";
    StreetTypes[StreetTypes["Upper"] = 230] = "Upper";
    StreetTypes[StreetTypes["Vale"] = 231] = "Vale";
    StreetTypes[StreetTypes["Viaduct"] = 232] = "Viaduct";
    StreetTypes[StreetTypes["View"] = 233] = "View";
    StreetTypes[StreetTypes["Villas"] = 234] = "Villas";
    StreetTypes[StreetTypes["Vista"] = 235] = "Vista";
    StreetTypes[StreetTypes["Wade"] = 236] = "Wade";
    StreetTypes[StreetTypes["Walk"] = 237] = "Walk";
    StreetTypes[StreetTypes["Walkway"] = 238] = "Walkway";
    StreetTypes[StreetTypes["Waterway"] = 239] = "Waterway";
    StreetTypes[StreetTypes["Way"] = 240] = "Way";
    StreetTypes[StreetTypes["Wharf"] = 241] = "Wharf";
    StreetTypes[StreetTypes["Woods"] = 242] = "Woods";
    StreetTypes[StreetTypes["Wynd"] = 243] = "Wynd";
    StreetTypes[StreetTypes["Yard"] = 244] = "Yard";
})(StreetTypes || (StreetTypes = {}));
//# sourceMappingURL=Address.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/BusinessType.js
var BusinessType;
(function (BusinessType) {
    BusinessType["Private"] = "PRIVATE";
    BusinessType["Public"] = "PUBLIC";
})(BusinessType || (BusinessType = {}));
//# sourceMappingURL=BusinessType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/BusinessStructureType.js
var BusinessStructureType;
(function (BusinessStructureType) {
    BusinessStructureType["Company"] = "COMPANY";
    BusinessStructureType["SoleTrader"] = "SOLE_TRADER";
    BusinessStructureType["Partnership"] = "PARTNERSHIP";
    BusinessStructureType["Trust"] = "TRUST";
})(BusinessStructureType || (BusinessStructureType = {}));
//# sourceMappingURL=BusinessStructureType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/BeneficialOwnerRole.js
var BeneficialOwnerRole;
(function (BeneficialOwnerRole) {
    BeneficialOwnerRole["Accountant"] = "ACCOUNTANT";
    BeneficialOwnerRole["Appointor"] = "APPOINTOR";
    BeneficialOwnerRole["AuthorisedSignatory"] = "AUTHORISED_SIGNATORY";
    BeneficialOwnerRole["Beneficiary"] = "BENEFICIARY";
    BeneficialOwnerRole["BusinessPartner"] = "BUSINESS_PARTNER";
    BeneficialOwnerRole["Ceo"] = "CEO";
    BeneficialOwnerRole["Cfo"] = "CFO";
    BeneficialOwnerRole["Chairman"] = "CHAIRMAN";
    BeneficialOwnerRole["CoBorrower"] = "CO_BORROWER";
    BeneficialOwnerRole["Coo"] = "COO";
    BeneficialOwnerRole["Director"] = "DIRECTOR";
    BeneficialOwnerRole["Guarantor"] = "GUARANTOR";
    BeneficialOwnerRole["Guardian"] = "GUARDIAN";
    BeneficialOwnerRole["Partner"] = "PARTNER";
    BeneficialOwnerRole["PowerOfAttorney"] = "POWER_OF_ATTORNEY";
    BeneficialOwnerRole["President"] = "PRESIDENT";
    BeneficialOwnerRole["Secretary"] = "SECRETARY";
    BeneficialOwnerRole["ShareholderOfLessThan25Percent"] = "SHAREHOLDER_OF_LESS_THAN_25_PERCENT";
    BeneficialOwnerRole["SupportStaff"] = "SUPPORT_STAFF";
    BeneficialOwnerRole["ThirdPartyAuthority"] = "THIRD_PARTY_AUTHORITY";
    BeneficialOwnerRole["Treasurer"] = "TREASURER";
    BeneficialOwnerRole["Trustee"] = "TRUSTEE";
})(BeneficialOwnerRole || (BeneficialOwnerRole = {}));
//# sourceMappingURL=BeneficialOwnerRole.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/BeneficialOwnerType.js
var BeneficialOwnerType;
(function (BeneficialOwnerType) {
    BeneficialOwnerType["Controller"] = "CONTROLLER";
    BeneficialOwnerType["ShareHolder"] = "SHARE_HOLDER";
    BeneficialOwnerType["Other"] = "OTHER";
})(BeneficialOwnerType || (BeneficialOwnerType = {}));
//# sourceMappingURL=BeneficialOwnerType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/Countries.js
var Countries;
(function (Countries) {
    Countries[Countries["Afghanistan"] = 0] = "Afghanistan";
    Countries[Countries["Albania"] = 1] = "Albania";
    Countries[Countries["Algeria"] = 2] = "Algeria";
    Countries[Countries["American Samoa"] = 3] = "American Samoa";
    Countries[Countries["Andorra"] = 4] = "Andorra";
    Countries[Countries["Angola"] = 5] = "Angola";
    Countries[Countries["Anguilla"] = 6] = "Anguilla";
    Countries[Countries["Antarctica"] = 7] = "Antarctica";
    Countries[Countries["Antigua And Barbuda"] = 8] = "Antigua And Barbuda";
    Countries[Countries["Argentina"] = 9] = "Argentina";
    Countries[Countries["Armenia"] = 10] = "Armenia";
    Countries[Countries["Aruba"] = 11] = "Aruba";
    Countries[Countries["Australia"] = 12] = "Australia";
    Countries[Countries["Austria"] = 13] = "Austria";
    Countries[Countries["Azerbaijan"] = 14] = "Azerbaijan";
    Countries[Countries["Bahamas"] = 15] = "Bahamas";
    Countries[Countries["Bahrain"] = 16] = "Bahrain";
    Countries[Countries["Bangladesh"] = 17] = "Bangladesh";
    Countries[Countries["Barbados"] = 18] = "Barbados";
    Countries[Countries["Belarus"] = 19] = "Belarus";
    Countries[Countries["Belgium"] = 20] = "Belgium";
    Countries[Countries["Belize"] = 21] = "Belize";
    Countries[Countries["Benin"] = 22] = "Benin";
    Countries[Countries["Bermuda"] = 23] = "Bermuda";
    Countries[Countries["Bhutan"] = 24] = "Bhutan";
    Countries[Countries["Bolivia"] = 25] = "Bolivia";
    Countries[Countries["Bosnia And Herzegovina"] = 26] = "Bosnia And Herzegovina";
    Countries[Countries["Botswana"] = 27] = "Botswana";
    Countries[Countries["Bouvet Island"] = 28] = "Bouvet Island";
    Countries[Countries["Brazil"] = 29] = "Brazil";
    Countries[Countries["British Indian Ocean Territory"] = 30] = "British Indian Ocean Territory";
    Countries[Countries["Brunei Darussalam"] = 31] = "Brunei Darussalam";
    Countries[Countries["Bulgaria"] = 32] = "Bulgaria";
    Countries[Countries["Burkina Faso"] = 33] = "Burkina Faso";
    Countries[Countries["Burundi"] = 34] = "Burundi";
    Countries[Countries["Cambodia"] = 35] = "Cambodia";
    Countries[Countries["Cameroon"] = 36] = "Cameroon";
    Countries[Countries["Canada"] = 37] = "Canada";
    Countries[Countries["Cape Verde"] = 38] = "Cape Verde";
    Countries[Countries["Cayman Islands"] = 39] = "Cayman Islands";
    Countries[Countries["Central African Republic"] = 40] = "Central African Republic";
    Countries[Countries["Chad"] = 41] = "Chad";
    Countries[Countries["Chile"] = 42] = "Chile";
    Countries[Countries["China"] = 43] = "China";
    Countries[Countries["Christmas Island"] = 44] = "Christmas Island";
    Countries[Countries["Cocos (Keeling) Islands"] = 45] = "Cocos (Keeling) Islands";
    Countries[Countries["Colombia"] = 46] = "Colombia";
    Countries[Countries["Comoros"] = 47] = "Comoros";
    Countries[Countries["Democratic People's Republic of Korea"] = 48] = "Democratic People's Republic of Korea";
    Countries[Countries["Democratic Republic Of The Congo"] = 49] = "Democratic Republic Of The Congo";
    Countries[Countries["Cook Islands"] = 50] = "Cook Islands";
    Countries[Countries["Costa Rica"] = 51] = "Costa Rica";
    Countries[Countries["Cote D'ivoire"] = 52] = "Cote D'ivoire";
    Countries[Countries["Croatia"] = 53] = "Croatia";
    Countries[Countries["Cuba"] = 54] = "Cuba";
    Countries[Countries["Cyprus"] = 55] = "Cyprus";
    Countries[Countries["Czech Republic"] = 56] = "Czech Republic";
    Countries[Countries["Denmark"] = 57] = "Denmark";
    Countries[Countries["Djibouti"] = 58] = "Djibouti";
    Countries[Countries["Dominica"] = 59] = "Dominica";
    Countries[Countries["Dominican Republic"] = 60] = "Dominican Republic";
    Countries[Countries["East Timor"] = 61] = "East Timor";
    Countries[Countries["Ecuador"] = 62] = "Ecuador";
    Countries[Countries["Egypt"] = 63] = "Egypt";
    Countries[Countries["El Salvador"] = 64] = "El Salvador";
    Countries[Countries["Equatorial Guinea"] = 65] = "Equatorial Guinea";
    Countries[Countries["Eritrea"] = 66] = "Eritrea";
    Countries[Countries["Estonia"] = 67] = "Estonia";
    Countries[Countries["Ethiopia"] = 68] = "Ethiopia";
    Countries[Countries["Falkland Islands"] = 69] = "Falkland Islands";
    Countries[Countries["Faroe Islands"] = 70] = "Faroe Islands";
    Countries[Countries["Fiji"] = 71] = "Fiji";
    Countries[Countries["Finland"] = 72] = "Finland";
    Countries[Countries["France"] = 73] = "France";
    Countries[Countries["French Guiana"] = 74] = "French Guiana";
    Countries[Countries["French Polynesia"] = 75] = "French Polynesia";
    Countries[Countries["French Southern Territories"] = 76] = "French Southern Territories";
    Countries[Countries["Gabon"] = 77] = "Gabon";
    Countries[Countries["Gambia"] = 78] = "Gambia";
    Countries[Countries["Georgia"] = 79] = "Georgia";
    Countries[Countries["Germany"] = 80] = "Germany";
    Countries[Countries["Ghana"] = 81] = "Ghana";
    Countries[Countries["Gibraltar"] = 82] = "Gibraltar";
    Countries[Countries["Greece"] = 83] = "Greece";
    Countries[Countries["Greenland"] = 84] = "Greenland";
    Countries[Countries["Grenada"] = 85] = "Grenada";
    Countries[Countries["Guadeloupe"] = 86] = "Guadeloupe";
    Countries[Countries["Guam"] = 87] = "Guam";
    Countries[Countries["Guatemala"] = 88] = "Guatemala";
    Countries[Countries["Guinea"] = 89] = "Guinea";
    Countries[Countries["Guinea-bissau"] = 90] = "Guinea-bissau";
    Countries[Countries["Guyana"] = 91] = "Guyana";
    Countries[Countries["Haiti"] = 92] = "Haiti";
    Countries[Countries["Heard Island And Mcdonald Islands"] = 93] = "Heard Island And Mcdonald Islands";
    Countries[Countries["Holy See (Vatican City State)"] = 94] = "Holy See (Vatican City State)";
    Countries[Countries["Honduras"] = 95] = "Honduras";
    Countries[Countries["Hong Kong"] = 96] = "Hong Kong";
    Countries[Countries["Hungary"] = 97] = "Hungary";
    Countries[Countries["Iceland"] = 98] = "Iceland";
    Countries[Countries["India"] = 99] = "India";
    Countries[Countries["Indonesia"] = 100] = "Indonesia";
    Countries[Countries["Iran"] = 101] = "Iran";
    Countries[Countries["Iraq"] = 102] = "Iraq";
    Countries[Countries["Ireland"] = 103] = "Ireland";
    Countries[Countries["Israel"] = 104] = "Israel";
    Countries[Countries["Italy"] = 105] = "Italy";
    Countries[Countries["Jamaica"] = 106] = "Jamaica";
    Countries[Countries["Japan"] = 107] = "Japan";
    Countries[Countries["Jordan"] = 108] = "Jordan";
    Countries[Countries["Kazakstan"] = 109] = "Kazakstan";
    Countries[Countries["Kenya"] = 110] = "Kenya";
    Countries[Countries["Kiribati"] = 111] = "Kiribati";
    Countries[Countries["Kosovo"] = 112] = "Kosovo";
    Countries[Countries["Kuwait"] = 113] = "Kuwait";
    Countries[Countries["Kyrgyzstan"] = 114] = "Kyrgyzstan";
    Countries[Countries["Laos"] = 115] = "Laos";
    Countries[Countries["Latvia"] = 116] = "Latvia";
    Countries[Countries["Lebanon"] = 117] = "Lebanon";
    Countries[Countries["Lesotho"] = 118] = "Lesotho";
    Countries[Countries["Liberia"] = 119] = "Liberia";
    Countries[Countries["Libyan Arab Jamahiriya"] = 120] = "Libyan Arab Jamahiriya";
    Countries[Countries["Liechtenstein"] = 121] = "Liechtenstein";
    Countries[Countries["Lithuania"] = 122] = "Lithuania";
    Countries[Countries["Luxembourg"] = 123] = "Luxembourg";
    Countries[Countries["Macau"] = 124] = "Macau";
    Countries[Countries["Macedonia"] = 125] = "Macedonia";
    Countries[Countries["Madagascar"] = 126] = "Madagascar";
    Countries[Countries["Malawi"] = 127] = "Malawi";
    Countries[Countries["Malaysia"] = 128] = "Malaysia";
    Countries[Countries["Maldives"] = 129] = "Maldives";
    Countries[Countries["Mali"] = 130] = "Mali";
    Countries[Countries["Malta"] = 131] = "Malta";
    Countries[Countries["Marshall Islands"] = 132] = "Marshall Islands";
    Countries[Countries["Martinique"] = 133] = "Martinique";
    Countries[Countries["Mauritania"] = 134] = "Mauritania";
    Countries[Countries["Mauritius"] = 135] = "Mauritius";
    Countries[Countries["Mayotte"] = 136] = "Mayotte";
    Countries[Countries["Mexico"] = 137] = "Mexico";
    Countries[Countries["Federated States Of Micronesia"] = 138] = "Federated States Of Micronesia";
    Countries[Countries["Republic Of Moldova"] = 139] = "Republic Of Moldova";
    Countries[Countries["Monaco"] = 140] = "Monaco";
    Countries[Countries["Mongolia"] = 141] = "Mongolia";
    Countries[Countries["Montserrat"] = 142] = "Montserrat";
    Countries[Countries["Montenegro"] = 143] = "Montenegro";
    Countries[Countries["Morocco"] = 144] = "Morocco";
    Countries[Countries["Mozambique"] = 145] = "Mozambique";
    Countries[Countries["Myanmar"] = 146] = "Myanmar";
    Countries[Countries["Namibia"] = 147] = "Namibia";
    Countries[Countries["Nauru"] = 148] = "Nauru";
    Countries[Countries["Nepal"] = 149] = "Nepal";
    Countries[Countries["Netherlands"] = 150] = "Netherlands";
    Countries[Countries["Netherlands Antilles"] = 151] = "Netherlands Antilles";
    Countries[Countries["New Caledonia"] = 152] = "New Caledonia";
    Countries[Countries["New Zealand"] = 153] = "New Zealand";
    Countries[Countries["Nicaragua"] = 154] = "Nicaragua";
    Countries[Countries["Niger"] = 155] = "Niger";
    Countries[Countries["Nigeria"] = 156] = "Nigeria";
    Countries[Countries["Niue"] = 157] = "Niue";
    Countries[Countries["Norfolk Island"] = 158] = "Norfolk Island";
    Countries[Countries["Northern Mariana Islands"] = 159] = "Northern Mariana Islands";
    Countries[Countries["Norway"] = 160] = "Norway";
    Countries[Countries["Oman"] = 161] = "Oman";
    Countries[Countries["Pakistan"] = 162] = "Pakistan";
    Countries[Countries["Palau"] = 163] = "Palau";
    Countries[Countries["Palestinian Territory"] = 164] = "Palestinian Territory";
    Countries[Countries["Panama"] = 165] = "Panama";
    Countries[Countries["Papua New Guinea"] = 166] = "Papua New Guinea";
    Countries[Countries["Paraguay"] = 167] = "Paraguay";
    Countries[Countries["Peru"] = 168] = "Peru";
    Countries[Countries["Philippines"] = 169] = "Philippines";
    Countries[Countries["Pitcairn"] = 170] = "Pitcairn";
    Countries[Countries["Poland"] = 171] = "Poland";
    Countries[Countries["Portugal"] = 172] = "Portugal";
    Countries[Countries["Puerto Rico"] = 173] = "Puerto Rico";
    Countries[Countries["Qatar"] = 174] = "Qatar";
    Countries[Countries["Romania"] = 175] = "Romania";
    Countries[Countries["Russian Federation"] = 176] = "Russian Federation";
    Countries[Countries["Rwanda"] = 177] = "Rwanda";
    Countries[Countries["Saint Helena"] = 178] = "Saint Helena";
    Countries[Countries["Saint Kitts And Nevis"] = 179] = "Saint Kitts And Nevis";
    Countries[Countries["Saint Lucia"] = 180] = "Saint Lucia";
    Countries[Countries["Saint Pierre And Miquelon"] = 181] = "Saint Pierre And Miquelon";
    Countries[Countries["Saint Vincent And The Grenadines"] = 182] = "Saint Vincent And The Grenadines";
    Countries[Countries["Samoa"] = 183] = "Samoa";
    Countries[Countries["San Marino"] = 184] = "San Marino";
    Countries[Countries["Sao Tome And Principe"] = 185] = "Sao Tome And Principe";
    Countries[Countries["Saudi Arabia"] = 186] = "Saudi Arabia";
    Countries[Countries["Senegal"] = 187] = "Senegal";
    Countries[Countries["Serbia"] = 188] = "Serbia";
    Countries[Countries["Seychelles"] = 189] = "Seychelles";
    Countries[Countries["Sierra Leone"] = 190] = "Sierra Leone";
    Countries[Countries["Singapore"] = 191] = "Singapore";
    Countries[Countries["Slovakia"] = 192] = "Slovakia";
    Countries[Countries["Slovenia"] = 193] = "Slovenia";
    Countries[Countries["Solomon Islands"] = 194] = "Solomon Islands";
    Countries[Countries["Somalia"] = 195] = "Somalia";
    Countries[Countries["South Africa"] = 196] = "South Africa";
    Countries[Countries["South Georgia And The South Sandwich Islands"] = 197] = "South Georgia And The South Sandwich Islands";
    Countries[Countries["The Republic of South Korea"] = 198] = "The Republic of South Korea";
    Countries[Countries["Spain"] = 199] = "Spain";
    Countries[Countries["Sri Lanka"] = 200] = "Sri Lanka";
    Countries[Countries["Sudan"] = 201] = "Sudan";
    Countries[Countries["Suriname"] = 202] = "Suriname";
    Countries[Countries["Svalbard And Jan Mayen"] = 203] = "Svalbard And Jan Mayen";
    Countries[Countries["Swaziland"] = 204] = "Swaziland";
    Countries[Countries["Sweden"] = 205] = "Sweden";
    Countries[Countries["Switzerland"] = 206] = "Switzerland";
    Countries[Countries["Syrian Arab Republic"] = 207] = "Syrian Arab Republic";
    Countries[Countries["Taiwan"] = 208] = "Taiwan";
    Countries[Countries["Tajikistan"] = 209] = "Tajikistan";
    Countries[Countries["Tanzania"] = 210] = "Tanzania";
    Countries[Countries["Thailand"] = 211] = "Thailand";
    Countries[Countries["Togo"] = 212] = "Togo";
    Countries[Countries["Tokelau"] = 213] = "Tokelau";
    Countries[Countries["Tonga"] = 214] = "Tonga";
    Countries[Countries["Trinidad And Tobago"] = 215] = "Trinidad And Tobago";
    Countries[Countries["Tunisia"] = 216] = "Tunisia";
    Countries[Countries["Turkey"] = 217] = "Turkey";
    Countries[Countries["Turkmenistan"] = 218] = "Turkmenistan";
    Countries[Countries["Turks And Caicos Islands"] = 219] = "Turks And Caicos Islands";
    Countries[Countries["Tuvalu"] = 220] = "Tuvalu";
    Countries[Countries["Uganda"] = 221] = "Uganda";
    Countries[Countries["Ukraine"] = 222] = "Ukraine";
    Countries[Countries["United Arab Emirates"] = 223] = "United Arab Emirates";
    Countries[Countries["United Kingdom"] = 224] = "United Kingdom";
    Countries[Countries["United States of America"] = 225] = "United States of America";
    Countries[Countries["United States Minor Outlying Islands"] = 226] = "United States Minor Outlying Islands";
    Countries[Countries["Uruguay"] = 227] = "Uruguay";
    Countries[Countries["Uzbekistan"] = 228] = "Uzbekistan";
    Countries[Countries["Vanuatu"] = 229] = "Vanuatu";
    Countries[Countries["Venezuela"] = 230] = "Venezuela";
    Countries[Countries["Vietnam"] = 231] = "Vietnam";
    Countries[Countries["British Virgin Islands"] = 232] = "British Virgin Islands";
    Countries[Countries["US Virgin Islands"] = 233] = "US Virgin Islands";
    Countries[Countries["Wallis And Futuna"] = 234] = "Wallis And Futuna";
    Countries[Countries["Western Sahara"] = 235] = "Western Sahara";
    Countries[Countries["Yemen"] = 236] = "Yemen";
    Countries[Countries["Zambia"] = 237] = "Zambia";
    Countries[Countries["Zimbabwe"] = 238] = "Zimbabwe";
})(Countries || (Countries = {}));
//# sourceMappingURL=Countries.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/RelatedParty.js
var RelatedParty_CompanyType;
(function (CompanyType) {
    CompanyType["Accountant"] = "ACCOUNTANT";
    CompanyType["Solicitor"] = "SOLICITOR";
})(RelatedParty_CompanyType || (RelatedParty_CompanyType = {}));
var PersonType;
(function (PersonType) {
    PersonType["Spouse"] = "SPOUSE";
})(PersonType || (PersonType = {}));
var VisitContactType;
(function (VisitContactType) {
    VisitContactType["LoanParty"] = "LOAN_PARTY";
    VisitContactType["Tenant"] = "TENANT";
    VisitContactType["RealEstateAgent"] = "REAL_ESTATE_AGENT";
})(VisitContactType || (VisitContactType = {}));
var SubstantialBenefitType;
(function (SubstantialBenefitType) {
    SubstantialBenefitType["SubstantialBenefit"] = "SUBSTANTIAL_BENEFIT";
    SubstantialBenefitType["NoSubstantialBenefitAndProceed"] = "NO_SUBSTANTIAL_BENEFIT_AND_PROCEED";
    SubstantialBenefitType["NoSubstantialBenefit"] = "NO_SUBSTANTIAL_BENEFIT";
})(SubstantialBenefitType || (SubstantialBenefitType = {}));
var CompanyApplicantRelatedPartyType;
(function (CompanyApplicantRelatedPartyType) {
    CompanyApplicantRelatedPartyType["CompanyContact"] = "COMPANY_CONTACT";
    CompanyApplicantRelatedPartyType["CompanyBeneficialOwner"] = "COMPANY_BENEFICIAL_OWNER";
    CompanyApplicantRelatedPartyType["Director"] = "DIRECTOR";
})(CompanyApplicantRelatedPartyType || (CompanyApplicantRelatedPartyType = {}));
var TrustApplicantRelatedPartyType;
(function (TrustApplicantRelatedPartyType) {
    TrustApplicantRelatedPartyType["TrustSettlor"] = "TRUST_SETTLOR";
    TrustApplicantRelatedPartyType["TrustBeneficialOwner"] = "TRUST_BENEFICIAL_OWNER";
    TrustApplicantRelatedPartyType["TrustBeneficiary"] = "TRUST_BENEFICIARY";
    TrustApplicantRelatedPartyType["Trustee"] = "TRUSTEE";
})(TrustApplicantRelatedPartyType || (TrustApplicantRelatedPartyType = {}));
//# sourceMappingURL=RelatedParty.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/EmploymentBasisType.js
var EmploymentBasisType;
(function (EmploymentBasisType) {
    EmploymentBasisType["FullTime"] = "FULL_TIME";
    EmploymentBasisType["PartTime"] = "PART_TIME";
    EmploymentBasisType["Casual"] = "CASUAL";
    EmploymentBasisType["Contractor"] = "CONTRACTOR";
    EmploymentBasisType["MaternityLeave"] = "MATERNITY_LEAVE";
})(EmploymentBasisType || (EmploymentBasisType = {}));
//# sourceMappingURL=EmploymentBasisType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/EmploymentStructures.js
var EmploymentStructures;
(function (EmploymentStructures) {
    EmploymentStructures["Primary"] = "PRIMARY";
    EmploymentStructures["Secondary"] = "SECONDARY";
    EmploymentStructures["Previous"] = "PREVIOUS";
})(EmploymentStructures || (EmploymentStructures = {}));
//# sourceMappingURL=EmploymentStructures.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/EmploymentSubType.js
var EmploymentSubType;
(function (EmploymentSubType) {
    EmploymentSubType["FullDoc"] = "FULL_DOC";
    EmploymentSubType["LowDoc"] = "LOW_DOC";
})(EmploymentSubType || (EmploymentSubType = {}));
//# sourceMappingURL=EmploymentSubType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/NonPersonRelatedPartyRelationshipType.js
var NonPersonRelatedPartyRelationshipType;
(function (NonPersonRelatedPartyRelationshipType) {
    NonPersonRelatedPartyRelationshipType["Applicant"] = "APPLICANT";
    NonPersonRelatedPartyRelationshipType["NonApplicant"] = "NON_APPLICANT";
    NonPersonRelatedPartyRelationshipType["NotApplicable"] = "NOT_APPLICABLE";
})(NonPersonRelatedPartyRelationshipType || (NonPersonRelatedPartyRelationshipType = {}));
//# sourceMappingURL=NonPersonRelatedPartyRelationshipType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/RelationshipToTrust.js
var RelationshipToTrust;
(function (RelationshipToTrust) {
    RelationshipToTrust["Trustee"] = "TRUSTEE";
    RelationshipToTrust["Beneficiary"] = "BENEFICIARY";
    RelationshipToTrust["Director"] = "DIRECTOR";
    RelationshipToTrust["ShareholderOfCorporateTrustee"] = "SHAREHOLDER_OF_CORPORATE_TRUSTEE";
})(RelationshipToTrust || (RelationshipToTrust = {}));
//# sourceMappingURL=RelationshipToTrust.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/RelatedCompany.js
var RelatedCompanyType;
(function (RelatedCompanyType) {
    RelatedCompanyType["Employer"] = "EMPLOYER";
    RelatedCompanyType["SelfEmploymentBusiness"] = "SELF_EMPLOYMENT_BUSINESS";
})(RelatedCompanyType || (RelatedCompanyType = {}));
//# sourceMappingURL=RelatedCompany.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/BuilderType.js
var BuilderType;
(function (BuilderType) {
    BuilderType["LicensedBuilder"] = "LICENSED_BUILDER";
    BuilderType["OwnerBuilder"] = "OWNER_BUILDER";
})(BuilderType || (BuilderType = {}));
//# sourceMappingURL=BuilderType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/CustomerPropertyRelationship.js
var CustomerPropertyRelationship;
(function (CustomerPropertyRelationship) {
    CustomerPropertyRelationship["OWNER"] = "OWNER";
    CustomerPropertyRelationship["LOOKING_TO_BUY"] = "LOOKING_TO_BUY";
    CustomerPropertyRelationship["JUST_LOOKING"] = "JUST_LOOKING";
})(CustomerPropertyRelationship || (CustomerPropertyRelationship = {}));
//# sourceMappingURL=CustomerPropertyRelationship.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/PropertyEventTimelineType.js
var PropertyEventTimelineType;
(function (PropertyEventTimelineType) {
    PropertyEventTimelineType["Rented"] = "RENTED";
    PropertyEventTimelineType["Sold"] = "SOLD";
})(PropertyEventTimelineType || (PropertyEventTimelineType = {}));
//# sourceMappingURL=PropertyEventTimelineType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/PropertyVisibility.js
var PropertyVisibility;
(function (PropertyVisibility) {
    PropertyVisibility["ACTIVE"] = "ACTIVE";
    PropertyVisibility["ARCHIVED"] = "ARCHIVED";
    PropertyVisibility["ACTIVE_TO_TEAM_ONLY"] = "ACTIVE_TO_TEAM_ONLY";
})(PropertyVisibility || (PropertyVisibility = {}));
//# sourceMappingURL=PropertyVisibility.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/PlatformPathname.js
var PlatformPathname;
(function (PlatformPathname) {
    PlatformPathname["BOOKING_APPOINTMENT_PATHNAME"] = "/book-appointment";
    PlatformPathname["BOOKING_APPOINTMENT_BUYERS_AGENT_PATHNAME"] = "/book-appointment/buyers-agent";
    PlatformPathname["BUYERS_AGENT_PATHNAME"] = "/buyers-agent";
    PlatformPathname["TIME_SELECTION_PROCESS_PATHNAME"] = "/book-appointment/process";
    PlatformPathname["STAMP_DUTY_PATHNAME"] = "/stamp-duty-calculator";
    PlatformPathname["PROPERTY_REPORT_PATHNAME"] = "/property-report";
    PlatformPathname["CHECK_YOUR_CREDIT_SCORE_PATHNAME"] = "/check-your-credit-score";
    PlatformPathname["FREE_CREDIT_SCORE_CHECK_PATHNAME"] = "/free-credit-score-check";
    PlatformPathname["CREDIT_SCORE_RESULT_PATHNAME"] = "/credit-score/result";
    PlatformPathname["REFINANCE_FUNNEL_PATHNAME"] = "/home-loans/basics/refinance/refinance-loan-amount";
    PlatformPathname["NEW_PURCHASE_FUNNEL_PATHNAME"] = "/home-loans/basics/new-home/purchase-price";
    PlatformPathname["BORROWING_POWER_FUNNEL_PATHNAME"] = "/home-loans/basics/borrowing-power/applicants";
    PlatformPathname["REFER_A_FRIEND_PATHNAME"] = "/home-loans/refer-a-friend";
})(PlatformPathname || (PlatformPathname = {}));
//# sourceMappingURL=PlatformPathname.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/CtpInterestRateType.js
var CtpInterestRateType;
(function (CtpInterestRateType) {
    CtpInterestRateType["Variable"] = "VariableRate";
    CtpInterestRateType["Fixed"] = "FixedRate";
})(CtpInterestRateType || (CtpInterestRateType = {}));
//# sourceMappingURL=CtpInterestRateType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/AppointmentCancellationReason.js
var AppointmentCancellationReason;
(function (AppointmentCancellationReason) {
    AppointmentCancellationReason["CustomerNotResponding"] = "CUSTOMER_NOT_RESPONDING";
    AppointmentCancellationReason["ExploringOptions"] = "EXPLORING_OPTIONS";
    AppointmentCancellationReason["HappyWithCurrentBankAndRates"] = "HAPPY_WITH_CURRENT_BANK_AND_RATES";
    AppointmentCancellationReason["ServicingIncomeOrEmployment"] = "SERVICING_INCOME_OR_EMPLOYMENT";
    AppointmentCancellationReason["DuplicatedAppointment"] = "DUPLICATED_APPOINTMENT";
    AppointmentCancellationReason["CreditIssues"] = "CREDIT_ISSUES";
    AppointmentCancellationReason["LowRefinanceLvr"] = "LOW_REFINANCE_LVR";
    AppointmentCancellationReason["InsufficientDeposit"] = "INSUFFICIENT_DEPOSIT";
    AppointmentCancellationReason["InsufficientExitStrategy"] = "INSUFFICIENT_EXIT_STRATEGY";
    AppointmentCancellationReason["PurchasingAfterThreeMonths"] = "PURCHASING_AFTER_THREE_MONTHS";
    AppointmentCancellationReason["PendingLegalMatter"] = "PENDING_LEGAL_MATTER";
})(AppointmentCancellationReason || (AppointmentCancellationReason = {}));
//# sourceMappingURL=AppointmentCancellationReason.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/TrustType.js
var TrustType;
(function (TrustType) {
    TrustType["CashManagementTrust"] = "CASH_MANAGEMENT_TRUST";
    TrustType["DiscretionaryTrust"] = "DISCRETIONARY_TRUST";
    TrustType["Fixed"] = "FIXED";
    TrustType["Hybrid"] = "HYBRID";
    TrustType["Other"] = "OTHER";
    TrustType["SimpleOrBare"] = "SIMPLE_OR_BARE";
    TrustType["SuperannuationTrusts"] = "SUPERANNUATION_TRUSTS";
    TrustType["Unit"] = "UNIT";
})(TrustType || (TrustType = {}));
//# sourceMappingURL=TrustType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/TrustSettlorNotApplicableReason.js
var TrustSettlorNotApplicableReason;
(function (TrustSettlorNotApplicableReason) {
    TrustSettlorNotApplicableReason["Deceased"] = "DECEASED";
    TrustSettlorNotApplicableReason["MinorContribution"] = "MINOR_CONTRIBUTION";
})(TrustSettlorNotApplicableReason || (TrustSettlorNotApplicableReason = {}));
//# sourceMappingURL=TrustSettlorNotApplicableReason.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/AppointmentLength.js
var _a, _b, _c, _d, _e, _f, _g, _h;

var InteractionType;
(function (InteractionType) {
    InteractionType["Phone"] = "Phone";
    InteractionType["FaceToFace"] = "F2F";
    InteractionType["Video"] = "Video";
    InteractionType["Store"] = "Store";
})(InteractionType || (InteractionType = {}));
var AppointmentLengthType;
(function (AppointmentLengthType) {
    AppointmentLengthType["15_30_15"] = "15_30_15";
    AppointmentLengthType["15_60_15"] = "15_60_15";
    AppointmentLengthType["60_60_60"] = "60_60_60";
})(AppointmentLengthType || (AppointmentLengthType = {}));
var AppointmentLength = {
    '15_30_15': {
        preBuffer: 15,
        length: 30,
        postBuffer: 15,
    },
    '15_60_15': {
        preBuffer: 15,
        length: 60,
        postBuffer: 15,
    },
    '60_60_60': {
        preBuffer: 60,
        length: 60,
        postBuffer: 60,
    },
};
var BrandInteractionType = (_a = {},
    _a[Brand.Lendi] = (_b = {},
        _b[InteractionType.Phone] = AppointmentLengthType['15_30_15'],
        _b[InteractionType.Video] = AppointmentLengthType['15_30_15'],
        _b[InteractionType.FaceToFace] = AppointmentLengthType['15_30_15'],
        _b),
    _a[Brand.Domain] = (_c = {},
        _c[InteractionType.Phone] = AppointmentLengthType['15_30_15'],
        _c[InteractionType.Video] = AppointmentLengthType['15_30_15'],
        _c[InteractionType.FaceToFace] = AppointmentLengthType['15_30_15'],
        _c),
    _a[Brand.Aussie] = (_d = {},
        _d[InteractionType.Phone] = AppointmentLengthType['15_30_15'],
        _d[InteractionType.Video] = AppointmentLengthType['15_30_15'],
        _d[InteractionType.FaceToFace] = AppointmentLengthType['60_60_60'],
        _d[InteractionType.Store] = AppointmentLengthType['15_60_15'],
        _d),
    _a);
var AppointmentLeadTimeMinutes = (_e = {},
    _e[Brand.Lendi] = (_f = {},
        _f[InteractionType.Phone] = 60,
        _f[InteractionType.Video] = 60,
        _f),
    _e[Brand.Domain] = (_g = {},
        _g[InteractionType.Phone] = 60,
        _g[InteractionType.Video] = 60,
        _g),
    _e[Brand.Aussie] = (_h = {},
        _h[InteractionType.Phone] = 120,
        _h[InteractionType.Video] = 120,
        _h[InteractionType.FaceToFace] = 240,
        _h[InteractionType.Store] = 240,
        _h),
    _e);
//# sourceMappingURL=AppointmentLength.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/ActiveRoles.js
var ActiveRole;
(function (ActiveRole) {
    ActiveRole["Borrower"] = "BORROWER";
    ActiveRole["Guarantor"] = "GUARANTOR";
    ActiveRole["AppReadonly"] = "APP_READONLY";
})(ActiveRole || (ActiveRole = {}));
var activeRoles = [ActiveRole.Borrower, ActiveRole.Guarantor, ActiveRole.AppReadonly];
//# sourceMappingURL=ActiveRoles.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/AssetFinance.js
var AssetFinanceType;
(function (AssetFinanceType) {
    AssetFinanceType["BusinessLoanWorkingCapital"] = "BUSINESS_LOAN_OR_WORKING_CAPITAL";
    AssetFinanceType["DebtConsolidation"] = "DEBT_CONSOLIDATION";
    AssetFinanceType["HomeImprovement"] = "HOME_IMPROVEMENT";
    AssetFinanceType["LeisureAsset"] = "LEISURE_ASSET";
    AssetFinanceType["OtherPersonal"] = "OTHER_OR_PERSONAL";
    AssetFinanceType["PlantAndEquipment"] = "PLANT_AND_EQUIPMENT";
    AssetFinanceType["VehicleLoan"] = "VEHICLE_LOAN";
})(AssetFinanceType || (AssetFinanceType = {}));
var ClientStatus;
(function (ClientStatus) {
    ClientStatus["ExistingCustomerWithHomeLoan"] = "EXISTING_HOME_LOAN_CUSTOMER";
    ClientStatus["ExistingCustomerWithoutHomeLoan"] = "EXISTING_CUSTOMER_NO_HOME_LOAN";
    ClientStatus["NewCustomer"] = "NEW_CUSTOMER_NO_PRIOR_RELATIONSHIP";
})(ClientStatus || (ClientStatus = {}));
var FinanceStage;
(function (FinanceStage) {
    FinanceStage["NoQuote"] = "NO_QUOTE";
    FinanceStage["QuoteHeld"] = "QUOTE_HELD";
    FinanceStage["Unknown"] = "UNKNOWN";
})(FinanceStage || (FinanceStage = {}));
var IntentToBuy;
(function (IntentToBuy) {
    IntentToBuy["EnquiryOnly"] = "ENQUIRY_ONLY";
    IntentToBuy["ReadyToGo"] = "READY_TO_GO";
    IntentToBuy["Unknown"] = "UNKNOWN";
})(IntentToBuy || (IntentToBuy = {}));
var LoanCategory;
(function (LoanCategory) {
    LoanCategory["Commercial"] = "COMMERCIAL";
    LoanCategory["Consumer"] = "CONSUMER";
})(LoanCategory || (LoanCategory = {}));
var BusinessLoanWorkingCapitalLoanType;
(function (BusinessLoanWorkingCapitalLoanType) {
    BusinessLoanWorkingCapitalLoanType["BusinessOverdraft"] = "BUSINESS_OVERDRAFT";
    BusinessLoanWorkingCapitalLoanType["InsurancePremium"] = "INSURANCE_PREMIUM";
    BusinessLoanWorkingCapitalLoanType["InvoiceFinance"] = "INVOICE_FINANCE";
    BusinessLoanWorkingCapitalLoanType["LineOfCredit"] = "LINE_OF_CREDIT";
    BusinessLoanWorkingCapitalLoanType["Other"] = "OTHER";
    BusinessLoanWorkingCapitalLoanType["UnsecuredBusinessLoans"] = "UNSECURED_BUSINESS_LOANS";
})(BusinessLoanWorkingCapitalLoanType || (BusinessLoanWorkingCapitalLoanType = {}));
var LeisureAssetLoanType;
(function (LeisureAssetLoanType) {
    LeisureAssetLoanType["MarineAsset"] = "BOAT_JETSKI";
    LeisureAssetLoanType["Other"] = "OTHER";
    LeisureAssetLoanType["WheeledAsset"] = "CARAVAN_HORSEFLOAT_TRAILER";
})(LeisureAssetLoanType || (LeisureAssetLoanType = {}));
var OtherPersonalLoanType;
(function (OtherPersonalLoanType) {
    OtherPersonalLoanType["Dental"] = "DENTAL";
    OtherPersonalLoanType["Education"] = "EDUCATION";
    OtherPersonalLoanType["Furnishings"] = "FURNISHINGS";
    OtherPersonalLoanType["Medical"] = "MEDICAL";
    OtherPersonalLoanType["Other"] = "OTHER";
    OtherPersonalLoanType["Travel"] = "TRAVEL";
    OtherPersonalLoanType["WeddingOrFuneral"] = "WEDDING_OR_FUNERAL";
})(OtherPersonalLoanType || (OtherPersonalLoanType = {}));
var PlantAndEquipmentLoanType;
(function (PlantAndEquipmentLoanType) {
    PlantAndEquipmentLoanType["BusinessEquipment"] = "GENERATORS_MACHINERY_GYM_EQUIPMENT";
    PlantAndEquipmentLoanType["FitoutFinance"] = "FITOUT_FINANCE";
    PlantAndEquipmentLoanType["Other"] = "OTHER";
    PlantAndEquipmentLoanType["TruckAndTrailer"] = "TRUCK_AND_TRAILER";
    PlantAndEquipmentLoanType["WheeledAssets"] = "TRACTORS_EXCAVATORS_LIFTS";
})(PlantAndEquipmentLoanType || (PlantAndEquipmentLoanType = {}));
var VehicleCondition;
(function (VehicleCondition) {
    VehicleCondition["Demo"] = "DEMO";
    VehicleCondition["New"] = "NEW";
    VehicleCondition["Unknown"] = "UNKNOWN";
    VehicleCondition["Used"] = "USED";
})(VehicleCondition || (VehicleCondition = {}));
var VehicleFinanceStage;
(function (VehicleFinanceStage) {
    VehicleFinanceStage["BankOrOtherLenderQuote"] = "BANK_OR_OTHER_LENDER_QUOTE";
    VehicleFinanceStage["DealerQuote"] = "DEALER_QUOTE";
    VehicleFinanceStage["NoQuoteHeld"] = "NO_QUOTE_HELD";
    VehicleFinanceStage["Unknown"] = "UNKNOWN";
})(VehicleFinanceStage || (VehicleFinanceStage = {}));
var VehicleIntentToBuy;
(function (VehicleIntentToBuy) {
    VehicleIntentToBuy["BuyNowVehicleInMind"] = "BUY_NOW_VEHICLE_IN_MIND";
    VehicleIntentToBuy["BuyNowNoVehicleInMind"] = "BUY_NOW_NO_VEHICLE_IN_MIND";
    VehicleIntentToBuy["EnquiryOnly"] = "ENQUIRY_ONLY";
    VehicleIntentToBuy["Unknown"] = "UNKNOWN";
})(VehicleIntentToBuy || (VehicleIntentToBuy = {}));
var VehicleMake;
(function (VehicleMake) {
    VehicleMake["Abarth"] = "Abarth";
    VehicleMake["Alfa Romeo"] = "Alfa Romeo";
    VehicleMake["Aston Martin"] = "Aston Martin";
    VehicleMake["Audi"] = "Audi";
    VehicleMake["BMW"] = "BMW";
    VehicleMake["Bentley"] = "Bentley";
    VehicleMake["Caterham"] = "Caterham";
    VehicleMake["Chery"] = "Chery";
    VehicleMake["Chrysler"] = "Chrysler";
    VehicleMake["Citroen"] = "Citroen";
    VehicleMake["Dodge"] = "Dodge";
    VehicleMake["Ferrari"] = "Ferrari";
    VehicleMake["Fiat"] = "Fiat";
    VehicleMake["Ford"] = "Ford";
    VehicleMake["Foton"] = "Foton";
    VehicleMake["Geely"] = "Geely";
    VehicleMake["Great Wall"] = "Great Wall";
    VehicleMake["HSV"] = "HSV";
    VehicleMake["Holden"] = "Holden";
    VehicleMake["Honda"] = "Honda";
    VehicleMake["Hummer"] = "Hummer";
    VehicleMake["Hyundai"] = "Hyundai";
    VehicleMake["Infiniti"] = "Infiniti";
    VehicleMake["Isuzu"] = "Isuzu";
    VehicleMake["Jaguar"] = "Jaguar";
    VehicleMake["Jeep"] = "Jeep";
    VehicleMake["Kia"] = "Kia";
    VehicleMake["LDV"] = "LDV";
    VehicleMake["Lamborghini"] = "Lamborghini";
    VehicleMake["Land Rover"] = "Land Rover";
    VehicleMake["Lexus"] = "Lexus";
    VehicleMake["Lotus"] = "Lotus";
    VehicleMake["M.G."] = "M.G.";
    VehicleMake["Mahindra"] = "Mahindra";
    VehicleMake["Maserati"] = "Maserati";
    VehicleMake["Maybach"] = "Maybach";
    VehicleMake["Mazda"] = "Mazda";
    VehicleMake["Mclaren"] = "Mclaren";
    VehicleMake["Mercedes-Benz"] = "Mercedes-Benz";
    VehicleMake["Mini"] = "Mini";
    VehicleMake["Mitsubishi"] = "Mitsubishi";
    VehicleMake["Morgan"] = "Morgan";
    VehicleMake["Nissan"] = "Nissan";
    VehicleMake["Opel"] = "Opel";
    VehicleMake["Other"] = "Other";
    VehicleMake["Peugeot"] = "Peugeot";
    VehicleMake["Porsche"] = "Porsche";
    VehicleMake["Proton"] = "Proton";
    VehicleMake["Range Rover"] = "Range Rover";
    VehicleMake["Renault"] = "Renault";
    VehicleMake["Rolls-Royce"] = "Rolls-Royce";
    VehicleMake["Saab"] = "Saab";
    VehicleMake["Skoda"] = "Skoda";
    VehicleMake["Smart"] = "Smart";
    VehicleMake["Ssangyong"] = "Ssangyong";
    VehicleMake["Subaru"] = "Subaru";
    VehicleMake["Suzuki"] = "Suzuki";
    VehicleMake["Tata"] = "Tata";
    VehicleMake["Tesla"] = "Tesla";
    VehicleMake["Toyota"] = "Toyota";
    VehicleMake["Volkswagen"] = "Volkswagen";
    VehicleMake["Volvo"] = "Volvo";
    VehicleMake["ZX Auto"] = "ZX Auto";
})(VehicleMake || (VehicleMake = {}));
var VehicleModel = {
    Abarth: ['500', '595', '695', 'Other'],
    'Alfa Romeo': ['147', '156', '159', '166', '4C', 'Brera', 'GT', 'Giulietta', 'Mito', 'Spider', 'Other'],
    'Aston Martin': ['DB7', 'DB9', 'DBS', 'Rapide', 'V12', 'V8', 'Vanquish', 'Virage', 'Other'],
    Audi: [
        'A1',
        'A3',
        'A4',
        'A5',
        'A6',
        'A7',
        'A8',
        'Allroad Quattro',
        'Q3',
        'Q5',
        'Q7',
        'R8',
        'RS Q3',
        'RS4',
        'RS5',
        'RS6',
        'RS7',
        'S1',
        'S3',
        'S4',
        'S5',
        'S6',
        'S7',
        'S8',
        'SQ5',
        'TT',
        'Other',
    ],
    BMW: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        'I3',
        'I8',
        'M3',
        'M4',
        'M5',
        'M6',
        'X1',
        'X3',
        'X4',
        'X5',
        'X6',
        'Z4',
        'Other',
    ],
    Bentley: ['Arnage', 'Continental', 'Flying Spur', 'Mulsanne', 'Other'],
    Caterham: ['Seven', 'Other'],
    Chery: ['J1', 'J11', 'J3', 'Other'],
    Chrysler: ['300', '300C', 'Crossfire', 'Grand Voyager', 'PT Cruiser', 'Sebring', 'Voyager', 'Other'],
    Citroen: [
        'Berlingo',
        'Berlingo II',
        'C2',
        'C3',
        'C4',
        'C4 Grand Picasso',
        'C4 Picasso',
        'C5',
        'C6',
        'DS3',
        'DS4',
        'DS5',
        'Dispatch',
        'Grand C4',
        'Other',
    ],
    Dodge: ['Avenger', 'Caliber', 'Journey', 'Nitro', 'Other'],
    Ferrari: ['458', '599', '612', 'California', 'F12', 'F430', 'FF', 'Superamerica', 'Other'],
    Fiat: ['500', 'Doblo', 'Freemont', 'Panda', 'Punto', 'Ritmo', 'Scudo', 'Other'],
    Ford: [
        'Courier',
        'Econovan',
        'Ecosport',
        'Escape',
        'Explorer',
        'F250',
        'F350',
        'FPV',
        'Fairlane',
        'Fairmont',
        'Falcon',
        'Fiesta',
        'Focus',
        'G6',
        'Kuga',
        'LTD',
        'Mondeo',
        'Ranger',
        'Territory',
        'Transit',
        'Transit Custom',
        'Other',
    ],
    Foton: ['Tunland', 'Other'],
    Geely: ['MK', 'Other'],
    'Great Wall': ['SA220', 'V200', 'V240', 'X200', 'X240', 'Other'],
    HSV: ['Avalanche', 'Clubsport', 'Coupe', 'GTS', 'Grange', 'Maloo', 'SV6000', 'Senator', 'VXR', 'W427', 'Other'],
    Holden: [
        'Adventra',
        'Astra',
        'Barina',
        'Barina Spark',
        'Berlina',
        'Calais',
        'Caprice',
        'Captiva',
        'Colorado',
        'Colorado 7',
        'Combo',
        'Commodore',
        'Crewman',
        'Cruze',
        'Epica',
        'Malibu',
        'Monaro',
        'Rodeo',
        'Statesman',
        'Tigra',
        'Trax',
        'UTE',
        'Vectra',
        'Viva',
        'Volt',
        'Zafira',
        'Other',
    ],
    Honda: [
        'Accord',
        'CR-Z',
        'CRV',
        'City',
        'Civic',
        'HR-V',
        'Insight',
        'Integra',
        'Jazz',
        'Legend',
        'MDX',
        'Odyssey',
        'S2000',
        'Other',
    ],
    Hummer: ['H3', 'Other'],
    Hyundai: [
        'Accent',
        'Elantra',
        'Genesis',
        'Getz',
        'Grandeur',
        'I20',
        'I30',
        'I40',
        'I45',
        'IX35',
        'Iload',
        'Imax',
        'Santa FE',
        'Sonata',
        'Terracan',
        'Tiburon',
        'Trajet',
        'Tucson',
        'Veloster',
        'Other',
    ],
    Infiniti: ['FX', 'G37', 'M', 'Q50', 'Q60', 'Q70', 'QX70', 'Other'],
    Isuzu: ['D-MAX', 'MU-X', 'Other'],
    Jaguar: ['F-Type', 'S Type', 'X Type', 'XF', 'XJ', 'XJ6', 'XJ8', 'XJR', 'XK', 'XK8', 'XKR', 'Other'],
    Jeep: ['Cherokee', 'Commander', 'Compass', 'Grand Cherokee', 'Patriot', 'Wrangler', 'Wrangler Unlimited', 'Other'],
    Kia: [
        'Carnival',
        'Cerato',
        'Grand Carnival',
        'K2700',
        'K2900',
        'Magentis',
        'Optima',
        'PRO CEE`D',
        'Pregio',
        'RIO',
        'Rondo',
        'Sorento',
        'Soul',
        'Sportage',
        'Other',
    ],
    LDV: ['V80', 'Other'],
    Lamborghini: ['Aventador', 'Gallardo', 'Huracan', 'Murcielago', 'Other'],
    'Land Rover': ['Defender', 'Discovery 3', 'Discovery 4', 'Freelander', 'Freelander 2', 'Other'],
    Lexus: [
        'CT 200H. Hybrid',
        'ES300',
        'ES300H',
        'ES350',
        'GS250',
        'GS300',
        'GS300H',
        'GS350',
        'GS430',
        'GS450H',
        'GS460',
        'IS F',
        'IS250',
        'IS250C',
        'IS300H',
        'IS350',
        'LFA',
        'LS430',
        'LS460',
        'LS600H',
        'LS600HL',
        'LX470',
        'LX570',
        'NX200T',
        'NX300H',
        'RC F',
        'RC350',
        'RX270',
        'RX330',
        'RX350',
        'RX400H',
        'RX450H',
        'SC430',
        'Other',
    ],
    Lotus: ['Elise', 'Europa', 'Evora', 'Exige', 'Other'],
    'M.G.': ['MG6', 'Other'],
    Mahindra: ['Genio', 'PIK-UP', 'XUV500', 'Other'],
    Maserati: ['Coupe', 'Ghibli', 'Grancabrio', 'Gransport', 'Granturismo', 'Quattroporte', 'Spyder', 'Other'],
    Maybach: ['57', '62', 'Other'],
    Mazda: [
        'B2500',
        'B2600',
        'B4000',
        'BT50',
        'CX-5',
        'CX-7',
        'CX-9',
        'E1800',
        'E2000',
        'MPV',
        'MX-5',
        'Mazda2',
        'Mazda3',
        'Mazda6',
        'RX-8',
        'Tribute',
        'Other',
    ],
    Mclaren: ['MP4-12C', 'Other'],
    'Mercedes-Benz': [
        'A150',
        'A170',
        'A180',
        'A200',
        'A250',
        'A45',
        'B180',
        'B200',
        'B250',
        'C180',
        'C200',
        'C220',
        'C230',
        'C250',
        'C280',
        'C300',
        'C320',
        'C350',
        'C55',
        'C63',
        'CL',
        'CL500',
        'CL600',
        'CLA',
        'CLC',
        'CLK200K',
        'CLK280',
        'CLK350',
        'CLK500',
        'CLK55',
        'CLK63',
        'CLS',
        'E200',
        'E200K',
        'E220',
        'E250',
        'E280',
        'E300',
        'E350',
        'E400',
        'E500',
        'E55',
        'E63',
        'G',
        'GL',
        'GLA',
        'ML',
        'R',
        'S300',
        'S320',
        'S350',
        'S400',
        'S430',
        'S500',
        'S55',
        'S600',
        'S63',
        'S65',
        'SL',
        'SL350',
        'SL500',
        'SL600',
        'SLK',
        'SLS',
        'Valente',
        'Viano',
        'Vito',
        'Other',
    ],
    Mini: ['Cooper', 'ONE', 'Other'],
    Mitsubishi: [
        '380',
        'ASX',
        'Challenger',
        'Colt',
        'Express',
        'Grandis',
        'I-Miev',
        'Lancer',
        'Mirage',
        'Outlander',
        'Pajero',
        'Triton',
        'Other',
    ],
    Morgan: ['3 Wheeler', '4/4', 'Aero Coupe', 'Aero Supersports', 'Plus 4', 'Plus 8', 'Roadster', 'Other'],
    Nissan: [
        '350Z',
        '370Z',
        'Almera',
        'Altima',
        'Dualis',
        'GT-R',
        'Juke',
        'Leaf',
        'Maxima',
        'Micra',
        'Murano',
        'Navara',
        'Pathfinder',
        'Patrol',
        'Pulsar',
        'Qashqai',
        'Tiida',
        'X-Trail',
        'Other',
    ],
    Opel: ['Astra', 'Corsa', 'Insignia', 'Zafira', 'Other'],
    Peugeot: [
        '206',
        '207',
        '208',
        '307',
        '308',
        '407',
        '508',
        '607',
        '2008',
        '3008',
        '4007',
        '4008',
        '5008',
        'Expert',
        'Partner',
        'RCZ',
        'Other',
    ],
    Porsche: ['911', 'Boxster', 'Cayenne', 'Cayman', 'Macan', 'Panamera', 'Other'],
    Proton: [
        'Exora',
        'GEN.2',
        'Jumbuck',
        'Persona',
        'Preve',
        'S16',
        'S16 FLX',
        'Satria',
        'Satria-NEO',
        'Savvy',
        'Suprima S',
        'Waja',
        'Other',
    ],
    'Range Rover': ['Evoque', 'Range Rover', 'Other'],
    Renault: [
        'Captur',
        'Clio',
        'Fluence',
        'Grand Scenic II',
        'Kangoo',
        'Koleos',
        'Laguna',
        'Latitude',
        'Megane',
        'Scenic II',
        'Trafic',
        'Other',
    ],
    'Rolls-Royce': ['Ghost', 'Phantom', 'Other'],
    Saab: ['9-3', '9-5', 'Turbo X', 'Other'],
    Skoda: ['Fabia', 'Octavia', 'Rapid Spaceback', 'Roomster', 'Superb', 'Yeti', 'Other'],
    Smart: ['Forfour', 'Fortwo', 'Roadster', 'Other'],
    Ssangyong: [
        'Actyon',
        'Actyon Sports',
        'Chairman',
        'Korando',
        'Kyron',
        'Musso',
        'Rexton',
        'Rexton II',
        'Stavic',
        'Other',
    ],
    Subaru: ['BRZ', 'Forester', 'Impreza', 'Liberty', 'Outback', 'Tribeca', 'WRX', 'XV', 'Other'],
    Suzuki: [
        'APV',
        'Alto',
        'Celerio',
        'Grand Vitara',
        'Jimny',
        'Kizashi',
        'Liana',
        'S-Cross',
        'SX4',
        'Swift',
        'XL-7',
        'Other',
    ],
    Tata: ['Xenon', 'Other'],
    Tesla: ['Model S', 'Other'],
    Toyota: [
        '86',
        'Aurion',
        'Avalon',
        'Avensis',
        'Camry',
        'Celica',
        'Corolla',
        'FJ Cruiser',
        'Hiace',
        'Hilux',
        'Kluger',
        'Landcruiser',
        'MR2',
        'Prius',
        'Prius V',
        'Prius-C',
        'RAV4',
        'Rukus',
        'TRD',
        'Tarago',
        'Yaris',
        'Other',
    ],
    Volkswagen: [
        'Amarok',
        'Beetle',
        'Bora',
        'CC',
        'Caddy',
        'Caravelle',
        'Citivan',
        'EOS',
        'Golf',
        'Jetta',
        'Kombi',
        'Multivan',
        'Passat',
        'Passat CC',
        'Polo',
        'Scirocco',
        'Tiguan',
        'Touareg',
        'Transporter',
        'UP!',
        'Other',
    ],
    Volvo: ['C30', 'C70', 'S40', 'S60', 'S80', 'V40', 'V50', 'V60', 'V70', 'XC60', 'XC70', 'XC90', 'Other'],
    'ZX Auto': ['Grand Tiger', 'Other'],
    Other: ['Other'],
};
var PlatformFinanceStatus;
(function (PlatformFinanceStatus) {
    PlatformFinanceStatus["Accepted"] = "ACCEPTED";
    PlatformFinanceStatus["Application"] = "APPLICATION";
    PlatformFinanceStatus["Approved"] = "APPROVED";
    PlatformFinanceStatus["AppBooked"] = "APP_BOOKED";
    PlatformFinanceStatus["Assessment"] = "ASSESSMENT";
    PlatformFinanceStatus["AwaitingAcceptance"] = "AWAITING_ACCEPTANCE";
    PlatformFinanceStatus["CALL_ONE"] = "CALL_ONE";
    PlatformFinanceStatus["CALL_TWO"] = "CALL_TWO";
    PlatformFinanceStatus["Converted"] = "CONVERTED";
    PlatformFinanceStatus["DealLost"] = "DEAL_LOST";
    PlatformFinanceStatus["DnpMarket"] = "DNP_MARKET";
    PlatformFinanceStatus["Documents"] = "DOCUMENTS";
    PlatformFinanceStatus["FollowUp"] = "FOLLOW_UP";
    PlatformFinanceStatus["HotLead"] = "HOT_LEAD";
    PlatformFinanceStatus["NewLead"] = "NEW_LEAD";
    PlatformFinanceStatus["PendingInfo"] = "PENDING_INFO";
    PlatformFinanceStatus["PendingSupportingDocs"] = "PENDING_SUPPORTING_DOCS";
    PlatformFinanceStatus["QuoteSent"] = "QUOTE_SENT";
    PlatformFinanceStatus["ReferredToBroker"] = "REFERRED_TO_BROKER ";
    PlatformFinanceStatus["Settled"] = "SETTLED";
    PlatformFinanceStatus["SmsSent"] = "SMS_SENT";
    PlatformFinanceStatus["Workshop"] = "WORKSHOP";
})(PlatformFinanceStatus || (PlatformFinanceStatus = {}));
var PlatformFinanceSubStatus;
(function (PlatformFinanceSubStatus) {
    PlatformFinanceSubStatus["AlternativeFunding"] = "ALTERNATIVE_FUNDING";
    PlatformFinanceSubStatus["ApplicationReceived"] = "APPLICATION_RECEIVED";
    PlatformFinanceSubStatus["ApplicationSent"] = "APPLICATION_SENT";
    PlatformFinanceSubStatus["AppointmentIncomplete"] = "APPOINTMENT_INCOMPLET";
    PlatformFinanceSubStatus["AwaitingFurtherInformation"] = "AWAITING_FURTHER_INFORMATION";
    PlatformFinanceSubStatus["AwaitingVehicle"] = "AWAITING_VEHICLE";
    PlatformFinanceSubStatus["BadCredit"] = "BAD_CREDIT";
    PlatformFinanceSubStatus["ChangedMind"] = "CHANGED_MIND";
    PlatformFinanceSubStatus["CouldNotContact"] = "COULD_NOT_CONTACT";
    PlatformFinanceSubStatus["DocumentsReceived"] = "DOCUMENTS_RECEIVED";
    PlatformFinanceSubStatus["DocumentsRequested"] = "DOCUMENTS_REQUESTED";
    PlatformFinanceSubStatus["DocumentsSent"] = "DOCUMENTS_SENT";
    PlatformFinanceSubStatus["Duplicate"] = "DUPLICATE";
    PlatformFinanceSubStatus["FutureContact"] = "FUTURE_CONTACT";
    PlatformFinanceSubStatus["InvoiceReceived"] = "INVOICE_RECEIVED";
    PlatformFinanceSubStatus["InvoiceRequested"] = "INVOICE_REQUESTED";
    PlatformFinanceSubStatus["Junk"] = "JUNK";
    PlatformFinanceSubStatus["Junklead"] = "JUNKLEAD";
    PlatformFinanceSubStatus["NoCapacity"] = "NO_CAPACITY";
    PlatformFinanceSubStatus["NoClientResponse"] = "NO_CLIENT_RESPONSE";
    PlatformFinanceSubStatus["Other"] = "OTHER";
    PlatformFinanceSubStatus["OtherFinancier"] = "OTHER_FINANCIER";
    PlatformFinanceSubStatus["OutsideGuidelines"] = "OUTSIDE_GUIDELINES";
    PlatformFinanceSubStatus["PreApproved"] = "PRE_APPROVED";
    PlatformFinanceSubStatus["QuoteOnly"] = "QUOTE_ONLY";
    PlatformFinanceSubStatus["ReadyForSettlement"] = "READY_FOR_SETTLEMENT";
    PlatformFinanceSubStatus["SentForSettlement"] = "SENT_FOR_SETTLEMENT";
    PlatformFinanceSubStatus["SubmissionRequest"] = "SUBMISSION_REQUEST";
    PlatformFinanceSubStatus["SubmittedToLender"] = "SUBMITTED_TO_LENDER";
})(PlatformFinanceSubStatus || (PlatformFinanceSubStatus = {}));
var AssetFinanceCalculatedStage;
(function (AssetFinanceCalculatedStage) {
    AssetFinanceCalculatedStage["PreSubmission"] = "PRE_SUBMISSION";
    AssetFinanceCalculatedStage["ClosedLost"] = "CLOSED_LOST";
    AssetFinanceCalculatedStage["ApplicationLodgement"] = "APPLICATION_LODGEMENT";
    AssetFinanceCalculatedStage["Application"] = "APPLICATION";
    AssetFinanceCalculatedStage["Assessment"] = "ASSESSMENT";
    AssetFinanceCalculatedStage["Approval"] = "APPROVAL";
    AssetFinanceCalculatedStage["PreSettlement"] = "PRE_SETTLEMENT";
    AssetFinanceCalculatedStage["PostSettlement"] = "POST_SETTLEMENT";
})(AssetFinanceCalculatedStage || (AssetFinanceCalculatedStage = {}));
var AssetFinanceCalculatedStatus;
(function (AssetFinanceCalculatedStatus) {
    AssetFinanceCalculatedStatus["InProgress"] = "IN_PROGRESS";
    AssetFinanceCalculatedStatus["LeadInProgress"] = "LEAD_IN_PROGRESS";
    AssetFinanceCalculatedStatus["OnHold"] = "ON_HOLD";
    AssetFinanceCalculatedStatus["SubmittedToLender"] = "SUBMITTED_TO_LENDER";
    AssetFinanceCalculatedStatus["SubmissionRequest"] = "SUBMISSION_REQUEST";
    AssetFinanceCalculatedStatus["MoreInformationRequested"] = "MORE_INFORMATION_REQUESTED";
    AssetFinanceCalculatedStatus["ApprovedInPrinciple"] = "APPROVED_IN_PRINCIPLE";
    AssetFinanceCalculatedStatus["InvoiceRequested"] = "INVOICE_REQUESTED";
    AssetFinanceCalculatedStatus["AwaitingVehicle"] = "AWAITING_VEHICLE";
    AssetFinanceCalculatedStatus["DocumentsRequested"] = "DOCUMENTS_REQUESTED";
    AssetFinanceCalculatedStatus["DocumentsIssued"] = "DOCUMENTS_ISSUED";
    AssetFinanceCalculatedStatus["DocumentsReceived"] = "DOCUMENTS_RECEIVED";
    AssetFinanceCalculatedStatus["ReadyForSettlement"] = "READY_FOR_SETTLEMENT";
    AssetFinanceCalculatedStatus["SettlementBooked"] = "SETTLEMENT_BOOKED";
    AssetFinanceCalculatedStatus["Settled"] = "SETTLED";
    AssetFinanceCalculatedStatus["Lost"] = "LOST";
})(AssetFinanceCalculatedStatus || (AssetFinanceCalculatedStatus = {}));
var AssetFinanceReason;
(function (AssetFinanceReason) {
    AssetFinanceReason["AlternativeFunding"] = "ALTERNATIVE_FUNDING";
    AssetFinanceReason["Other"] = "OTHER";
    AssetFinanceReason["ChangedMind"] = "CHANGED_MIND";
    AssetFinanceReason["CouldNotContact"] = "COULD_NOT_CONTACT";
    AssetFinanceReason["FutureContact"] = "FUTURE_CONTACT";
    AssetFinanceReason["NoClientResponse"] = "NO_CLIENT_RESPONSE";
    AssetFinanceReason["QuoteOnly"] = "QUOTE_ONLY";
    AssetFinanceReason["BadCredit"] = "BAD_CREDIT";
    AssetFinanceReason["NoCapacity"] = "NO_CAPACITY";
    AssetFinanceReason["OtherFinancier"] = "OTHER_FINANCIER";
    AssetFinanceReason["OutsideGuidelines"] = "OUTSIDE_GUIDELINES";
    AssetFinanceReason["NotInterested"] = "NOT_INTERESTED";
})(AssetFinanceReason || (AssetFinanceReason = {}));
var ReferralFeeType;
(function (ReferralFeeType) {
    ReferralFeeType["Dollar"] = "DOLLAR";
    ReferralFeeType["Percentage"] = "PERCENTAGE";
})(ReferralFeeType || (ReferralFeeType = {}));
//# sourceMappingURL=AssetFinance.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/TeamMember.js
var TeamMemberBrand;
(function (TeamMemberBrand) {
    TeamMemberBrand["aussie"] = "AUSSIE";
    TeamMemberBrand["domain"] = "DOMAIN";
    TeamMemberBrand["lendi"] = "LENDI";
})(TeamMemberBrand || (TeamMemberBrand = {}));
var TeamMemberProfile;
(function (TeamMemberProfile) {
    TeamMemberProfile["associate"] = "Associate";
    TeamMemberProfile["broker"] = "Broker";
    TeamMemberProfile["brokerManager"] = "Broker Manager";
    TeamMemberProfile["customerSolutions"] = "Customer Solutions";
    TeamMemberProfile["offboardedUser"] = "Offboarded User";
    TeamMemberProfile["partnerBroker"] = "Partner Broker";
    TeamMemberProfile["relationshipManager"] = "Relationship Manager";
    TeamMemberProfile["seniorRelationshipManager"] = "Senior Relationship Manager";
})(TeamMemberProfile || (TeamMemberProfile = {}));
var TeamMemberUserRole;
(function (TeamMemberUserRole) {
    TeamMemberUserRole["aussieExecutive"] = "AUSSIE_EXECUTIVE";
    TeamMemberUserRole["aussieAssociateManager"] = "AUSSIE_ASSOCIATE_MANAGER";
    TeamMemberUserRole["aussieAssociate"] = "AUSSIE_ASSOCIATE";
    TeamMemberUserRole["brokerLifecycle"] = "BROKER_LIFECYCLE";
    TeamMemberUserRole["clientSolutions"] = "CLIENT_SOLUTIONS";
    TeamMemberUserRole["clientSolutionsAssessmentAssociate"] = "CLIENT_SOLUTIONS_ASSESSMENT_ASSOCIATE";
    TeamMemberUserRole["clientSolutionsAssessmentExpert"] = "CLIENT_SOLUTIONS_ASSESSMENT_EXPERT";
    TeamMemberUserRole["clientSolutionsManager"] = "CLIENT_SOLUTIONS_MANAGER";
    TeamMemberUserRole["clientSolutionsSettlementAssociate"] = "CLIENT_SOLUTIONS_SETTLEMENT_ASSOCIATE";
    TeamMemberUserRole["clientSolutionsSettlementExpert"] = "CLIENT_SOLUTIONS_SETTLEMENT_EXPERT";
    TeamMemberUserRole["clientSolutionsSpecialist"] = "CLIENT_SOLUTIONS_SPECIALIST";
    TeamMemberUserRole["domainAssociate"] = "DOMAIN_ASSOCIATE";
    TeamMemberUserRole["domainAssociateManager"] = "DOMAIN_ASSOCIATE_MANAGER";
    TeamMemberUserRole["domainBrokerLiaison"] = "DOMAIN_BROKER_LIAISON";
    TeamMemberUserRole["domainBrokerManager"] = "DOMAIN_BROKER_MANAGER";
    TeamMemberUserRole["domainExecutive"] = "DOMAIN_EXECUTIVE";
    TeamMemberUserRole["domainHomeLoanSpecialist"] = "DOMAIN_HOME_LOAN_SPECIALIST";
    TeamMemberUserRole["domainSalesExecutive"] = "DOMAIN_SALES_EXECUTIVE";
    TeamMemberUserRole["fieldAssistant"] = "FIELD_ASSISTANT";
    TeamMemberUserRole["franchiseeBroker"] = "FRANCHISEE_BROKER";
    TeamMemberUserRole["franchiseeNonBroker"] = "FRANCHISEE_NON_BROKER";
    TeamMemberUserRole["graduateManager"] = "GRADUATE_MANAGER";
    TeamMemberUserRole["lendiAssociate"] = "LENDI_ASSOCIATE";
    TeamMemberUserRole["lendiAssociateManager"] = "LENDI_ASSOCIATE_MANAGER";
    TeamMemberUserRole["lendiBrokerAdmin"] = "LENDI_BROKER_ADMIN";
    TeamMemberUserRole["lendiBrokerLiaison"] = "LENDI_BROKER_LIAISON";
    TeamMemberUserRole["lendiBrokerManager"] = "LENDI_BROKER_MANAGER";
    TeamMemberUserRole["lendiExecutive"] = "LENDI_EXECUTIVE";
    TeamMemberUserRole["lendiGroupExecutive"] = "LENDI_GROUP_EXECUTIVE";
    TeamMemberUserRole["lendiHomeLoanConsultant"] = "LENDI_HOME_LOAN_CONSULTANT";
    TeamMemberUserRole["lendiHomeLoanSpecialist"] = "LENDI_HOME_LOAN_SPECIALIST";
    TeamMemberUserRole["lendiSalesExecutive"] = "LENDI_SALES_EXECUTIVE";
    TeamMemberUserRole["lendiSameLenderRefinance"] = "LENDI_SAME_LENDER_REFINANCE";
    TeamMemberUserRole["mobileRegionHead"] = "MOBILE_REGION_HEAD";
    TeamMemberUserRole["mobileRegionManager"] = "MOBILE_REGION_MANAGER";
    TeamMemberUserRole["mobileBroker"] = "MOBILE_BROKER";
    TeamMemberUserRole["seniorRelationshipManager"] = "SENIOR_RELATIONSHIP_MANAGER";
    TeamMemberUserRole["offboardedTeamMember"] = "OFFBOARDED_TEAM_MEMBER";
    TeamMemberUserRole["relationshipManager"] = "RELATIONSHIP_MANAGER";
    TeamMemberUserRole["retailStateHead"] = "RETAIL_STATE_HEAD";
    TeamMemberUserRole["retailManager"] = "RETAIL_MANAGER";
    TeamMemberUserRole["retailBroker"] = "RETAIL_BROKER";
    TeamMemberUserRole["storeAdmin"] = "STORE_ADMIN";
    TeamMemberUserRole["trainer"] = "TRAINER";
})(TeamMemberUserRole || (TeamMemberUserRole = {}));
var TeamMemberSalutation;
(function (TeamMemberSalutation) {
    TeamMemberSalutation["mr"] = "Mr.";
    TeamMemberSalutation["ms"] = "Ms.";
    TeamMemberSalutation["mrs"] = "Mrs.";
    TeamMemberSalutation["dr"] = "Dr.";
    TeamMemberSalutation["prof"] = "Prof.";
})(TeamMemberSalutation || (TeamMemberSalutation = {}));
var TeamMemberRestrictionStatus;
(function (TeamMemberRestrictionStatus) {
    TeamMemberRestrictionStatus["restricted"] = "RESTRICTED";
    TeamMemberRestrictionStatus["unrestricted"] = "UNRESTRICTED";
})(TeamMemberRestrictionStatus || (TeamMemberRestrictionStatus = {}));
var TeamMemberBrokerStatus;
(function (TeamMemberBrokerStatus) {
    TeamMemberBrokerStatus["competent"] = "Competent";
    TeamMemberBrokerStatus["compliance"] = "Compliance";
    TeamMemberBrokerStatus["graduate"] = "Graduate";
    TeamMemberBrokerStatus["pip"] = "PIP";
    TeamMemberBrokerStatus["offBoarded"] = "Off Boarded";
    TeamMemberBrokerStatus["roleChange"] = "Role Change";
    TeamMemberBrokerStatus["active"] = "Active";
    TeamMemberBrokerStatus["suspended"] = "Suspended";
})(TeamMemberBrokerStatus || (TeamMemberBrokerStatus = {}));
var TeamMemberTimeZone;
(function (TeamMemberTimeZone) {
    TeamMemberTimeZone["adelaide"] = "Australia/Adelaide";
    TeamMemberTimeZone["brisbane"] = "Australia/Brisbane";
    TeamMemberTimeZone["brokenHill"] = "Australia/Broken_Hill";
    TeamMemberTimeZone["currie"] = "Australia/Currie";
    TeamMemberTimeZone["darwin"] = "Australia/Darwin";
    TeamMemberTimeZone["eucla"] = "Australia/Eucla";
    TeamMemberTimeZone["hobart"] = "Australia/Hobart";
    TeamMemberTimeZone["lindeman"] = "Australia/Lindeman";
    TeamMemberTimeZone["lordHowe"] = "Australia/Lord_Howe";
    TeamMemberTimeZone["melbourne"] = "Australia/Melbourne";
    TeamMemberTimeZone["perth"] = "Australia/Perth";
    TeamMemberTimeZone["sydney"] = "Australia/Sydney";
})(TeamMemberTimeZone || (TeamMemberTimeZone = {}));
var TeamMemberCommissionStatus;
(function (TeamMemberCommissionStatus) {
    TeamMemberCommissionStatus["active"] = "Active";
    TeamMemberCommissionStatus["inactive"] = "Inactive";
    TeamMemberCommissionStatus["suspended"] = "Suspended";
})(TeamMemberCommissionStatus || (TeamMemberCommissionStatus = {}));
//# sourceMappingURL=TeamMember.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/AppLockReason.js
var AppLockReason;
(function (AppLockReason) {
    AppLockReason["PostSettlementSettled"] = "POST_SETTLEMENT_SETTLED";
    AppLockReason["PostSettlementDischarged"] = "POST_SETTLEMENT_DISCHARGED";
    AppLockReason["ClosedLostLost"] = "CLOSED_LOST_LOST";
    AppLockReason["ClosedLostDeclined"] = "CLOSED_LOST_DECLINED";
    AppLockReason["RetiredDomainBrand"] = "RETIRED_DOMAIN_BRAND";
    AppLockReason["SubmittedToLender"] = "SUBMITTED_TO_LENDER";
    AppLockReason["PreApproved"] = "PRE_APPROVED";
    AppLockReason["Settlement"] = "SETTLEMENT";
})(AppLockReason || (AppLockReason = {}));
//# sourceMappingURL=AppLockReason.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/InternationalMobileCountries.js

var InternationalMobileCountriesByBrand = new Map([
    [Brand.Lendi, ['AU']],
    [Brand.Domain, ['AU']],
    [
        Brand.Aussie,
        [
            'AC',
            'AD',
            'AE',
            'AF',
            'AI',
            'AL',
            'AM',
            'AO',
            'AR',
            'AS',
            'AT',
            'AU',
            'AW',
            'AZ',
            'BA',
            'BB',
            'BD',
            'BE',
            'BF',
            'BG',
            'BH',
            'BI',
            'BJ',
            'BM',
            'BN',
            'BO',
            'BR',
            'BS',
            'BT',
            'BW',
            'BY',
            'BZ',
            'CA',
            'CC',
            'CD',
            'CF',
            'CG',
            'CH',
            'CI',
            'CK',
            'CL',
            'CM',
            'CN',
            'CO',
            'CR',
            'CU',
            'CV',
            'CW',
            'CX',
            'CY',
            'CZ',
            'DE',
            'DJ',
            'DK',
            'DM',
            'DO',
            'DO',
            'DZ',
            'EC',
            'EG',
            'ER',
            'ES',
            'ET',
            'FI',
            'FJ',
            'FK',
            'FM',
            'FO',
            'FR',
            'GA',
            'GB',
            'GD',
            'GE',
            'GF',
            'GG',
            'GH',
            'GI',
            'GL',
            'GM',
            'GN',
            'GP',
            'GQ',
            'GR',
            'GS',
            'GT',
            'GU',
            'GW',
            'GY',
            'HK',
            'HN',
            'HR',
            'HT',
            'HU',
            'ID',
            'IE',
            'IL',
            'IM',
            'IN',
            'IO',
            'IQ',
            'IR',
            'IS',
            'IT',
            'JE',
            'JM',
            'JO',
            'JP',
            'KE',
            'KG',
            'KH',
            'KI',
            'KM',
            'KN',
            'KP',
            'KR',
            'KW',
            'KY',
            'KZ',
            'LA',
            'LB',
            'LC',
            'LI',
            'LK',
            'LR',
            'LS',
            'LT',
            'LU',
            'LV',
            'LY',
            'MA',
            'MC',
            'MD',
            'ME',
            'MF',
            'MG',
            'MH',
            'MK',
            'ML',
            'MM',
            'MN',
            'MO',
            'MP',
            'MQ',
            'MR',
            'MS',
            'MT',
            'MU',
            'MV',
            'MW',
            'MX',
            'MY',
            'MZ',
            'NA',
            'NC',
            'NE',
            'NF',
            'NG',
            'NI',
            'NL',
            'NO',
            'NP',
            'NR',
            'NU',
            'NZ',
            'OM',
            'PA',
            'PE',
            'PF',
            'PG',
            'PH',
            'PK',
            'PL',
            'PM',
            'PN',
            'PR',
            'PS',
            'PT',
            'PW',
            'PY',
            'QA',
            'RE',
            'RO',
            'RS',
            'RU',
            'RW',
            'SA',
            'SB',
            'SC',
            'SD',
            'SE',
            'SG',
            'SH',
            'SI',
            'SK',
            'SL',
            'SM',
            'SN',
            'SO',
            'SR',
            'SS',
            'ST',
            'SV',
            'SX',
            'SY',
            'SZ',
            'TC',
            'TD',
            'TG',
            'TH',
            'TJ',
            'TK',
            'TL',
            'TM',
            'TN',
            'TO',
            'TR',
            'TT',
            'TV',
            'TW',
            'TZ',
            'UA',
            'UG',
            'US',
            'UY',
            'UZ',
            'VA',
            'VC',
            'VE',
            'VG',
            'VI',
            'VN',
            'VU',
            'WF',
            'WS',
            'YE',
            'YT',
            'ZA',
            'ZM',
            'ZW',
        ],
    ],
]);
//# sourceMappingURL=InternationalMobileCountries.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/core-constants/lib/esm/index.js





















































































//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/types.js

var types_Status;
(function (Status) {
    Status["Authenticating"] = "authenticating";
    Status["Authenticated"] = "authenticated";
    Status["Unauthenticated"] = "unauthenticated";
    Status["Unauthenticating"] = "unauthenticating";
    Status["Expired"] = "expired";
    Status["Errored"] = "errored";
})(types_Status || (types_Status = {}));
var ConnectionEnum;
(function (ConnectionEnum) {
    ConnectionEnum[ConnectionEnum["google-oauth2"] = 0] = "google-oauth2";
    ConnectionEnum[ConnectionEnum["paypal"] = 1] = "paypal";
    ConnectionEnum[ConnectionEnum["paypal-sandbox"] = 2] = "paypal-sandbox";
    ConnectionEnum[ConnectionEnum["salesforce"] = 3] = "salesforce";
    ConnectionEnum[ConnectionEnum["salesforce-sandbox"] = 4] = "salesforce-sandbox";
    ConnectionEnum[ConnectionEnum["sms"] = 5] = "sms";
    ConnectionEnum[ConnectionEnum["lendigroup-salesforce"] = 6] = "lendigroup-salesforce";
})(ConnectionEnum || (ConnectionEnum = {}));
var PasswordlessAuthenticationStatus;
(function (PasswordlessAuthenticationStatus) {
    PasswordlessAuthenticationStatus["Errored"] = "errored";
    PasswordlessAuthenticationStatus["Sending"] = "sending";
    PasswordlessAuthenticationStatus["Sent"] = "sent";
    PasswordlessAuthenticationStatus["Verifying"] = "verifying";
    PasswordlessAuthenticationStatus["Verified"] = "verified";
    PasswordlessAuthenticationStatus["Denied"] = "denied";
})(PasswordlessAuthenticationStatus || (PasswordlessAuthenticationStatus = {}));
//# sourceMappingURL=types.js.map
// EXTERNAL MODULE: ../../../node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(49189);
// EXTERNAL MODULE: ../../../node_modules/jwt-decode/build/jwt-decode.esm.js
var jwt_decode_esm = __webpack_require__(30612);
;// CONCATENATED MODULE: ../../../node_modules/auth0-js/dist/auth0.min.esm.js
/* provided dependency */ var process = __webpack_require__(13158);
/**
 * auth0-js v9.23.2
 * Author: Auth0
 * Date: 2023-10-27
 * License: MIT
 */

var commonjsGlobal="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:{};function createCommonjsModule(fn,module){return fn(module={exports:{}},module.exports),module.exports}var urlJoin=createCommonjsModule((function(module){var context,definition;context=commonjsGlobal,definition=function(){function normalize(strArray){var resultArray=[];if(0===strArray.length)return"";if("string"!=typeof strArray[0])throw new TypeError("Url must be a string. Received "+strArray[0]);if(strArray[0].match(/^[^/:]+:\/*$/)&&strArray.length>1){var first=strArray.shift();strArray[0]=first+strArray[0]}strArray[0].match(/^file:\/\/\//)?strArray[0]=strArray[0].replace(/^([^/:]+):\/*/,"$1:///"):strArray[0]=strArray[0].replace(/^([^/:]+):\/*/,"$1://");for(var i=0;i<strArray.length;i++){var component=strArray[i];if("string"!=typeof component)throw new TypeError("Url must be a string. Received "+component);""!==component&&(i>0&&(component=component.replace(/^[\/]+/,"")),component=i<strArray.length-1?component.replace(/[\/]+$/,""):component.replace(/[\/]+$/,"/"),resultArray.push(component))}var str=resultArray.join("/"),parts=(str=str.replace(/\/(\?|&|#[^!])/g,"$1")).split("?");return str=parts.shift()+(parts.length>0?"?":"")+parts.join("&")}return function(){return normalize("object"==typeof arguments[0]?arguments[0]:[].slice.call(arguments))}},module.exports?module.exports=definition():context.urljoin=definition()})),origSymbol="undefined"!=typeof Symbol&&Symbol,test={foo:{}},$Object=Object,ERROR_MESSAGE="Function.prototype.bind called on incompatible ",slice=Array.prototype.slice,toStr=Object.prototype.toString,functionBind=Function.prototype.bind||function(that){var target=this;if("function"!=typeof target||"[object Function]"!==toStr.call(target))throw new TypeError(ERROR_MESSAGE+target);for(var bound,args=slice.call(arguments,1),binder=function(){if(this instanceof bound){var result=target.apply(this,args.concat(slice.call(arguments)));return Object(result)===result?result:this}return target.apply(that,args.concat(slice.call(arguments)))},boundLength=Math.max(0,target.length-args.length),boundArgs=[],i=0;i<boundLength;i++)boundArgs.push("$"+i);if(bound=Function("binder","return function ("+boundArgs.join(",")+"){ return binder.apply(this,arguments); }")(binder),target.prototype){var Empty=function(){};Empty.prototype=target.prototype,bound.prototype=new Empty,Empty.prototype=null}return bound},src=functionBind.call(Function.call,Object.prototype.hasOwnProperty),$SyntaxError=SyntaxError,$Function=Function,$TypeError=TypeError,getEvalledConstructor=function(expressionSyntax){try{return $Function('"use strict"; return ('+expressionSyntax+").constructor;")()}catch(e){}},$gOPD=Object.getOwnPropertyDescriptor;if($gOPD)try{$gOPD({},"")}catch(e){$gOPD=null}var throwTypeError=function(){throw new $TypeError},ThrowTypeError=$gOPD?function(){try{return throwTypeError}catch(calleeThrows){try{return $gOPD(arguments,"callee").get}catch(gOPDthrows){return throwTypeError}}}():throwTypeError,hasSymbols$1="function"==typeof origSymbol&&"function"==typeof Symbol&&"symbol"==typeof origSymbol("foo")&&"symbol"==typeof Symbol("bar")&&function(){if("function"!=typeof Symbol||"function"!=typeof Object.getOwnPropertySymbols)return!1;if("symbol"==typeof Symbol.iterator)return!0;var obj={},sym=Symbol("test"),symObj=Object(sym);if("string"==typeof sym)return!1;if("[object Symbol]"!==Object.prototype.toString.call(sym))return!1;if("[object Symbol]"!==Object.prototype.toString.call(symObj))return!1;for(sym in obj[sym]=42,obj)return!1;if("function"==typeof Object.keys&&0!==Object.keys(obj).length)return!1;if("function"==typeof Object.getOwnPropertyNames&&0!==Object.getOwnPropertyNames(obj).length)return!1;var syms=Object.getOwnPropertySymbols(obj);if(1!==syms.length||syms[0]!==sym)return!1;if(!Object.prototype.propertyIsEnumerable.call(obj,sym))return!1;if("function"==typeof Object.getOwnPropertyDescriptor){var descriptor=Object.getOwnPropertyDescriptor(obj,sym);if(42!==descriptor.value||!0!==descriptor.enumerable)return!1}return!0}(),hasProto$1={__proto__:test}.foo===test.foo&&!({__proto__:null}instanceof $Object),getProto=Object.getPrototypeOf||(hasProto$1?function(x){return x.__proto__}:null),needsEval={},TypedArray="undefined"!=typeof Uint8Array&&getProto?getProto(Uint8Array):void 0,INTRINSICS={"%AggregateError%":"undefined"==typeof AggregateError?void 0:AggregateError,"%Array%":Array,"%ArrayBuffer%":"undefined"==typeof ArrayBuffer?void 0:ArrayBuffer,"%ArrayIteratorPrototype%":hasSymbols$1&&getProto?getProto([][Symbol.iterator]()):void 0,"%AsyncFromSyncIteratorPrototype%":void 0,"%AsyncFunction%":needsEval,"%AsyncGenerator%":needsEval,"%AsyncGeneratorFunction%":needsEval,"%AsyncIteratorPrototype%":needsEval,"%Atomics%":"undefined"==typeof Atomics?void 0:Atomics,"%BigInt%":"undefined"==typeof BigInt?void 0:BigInt,"%BigInt64Array%":"undefined"==typeof BigInt64Array?void 0:BigInt64Array,"%BigUint64Array%":"undefined"==typeof BigUint64Array?void 0:BigUint64Array,"%Boolean%":Boolean,"%DataView%":"undefined"==typeof DataView?void 0:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":Error,"%eval%":eval,"%EvalError%":EvalError,"%Float32Array%":"undefined"==typeof Float32Array?void 0:Float32Array,"%Float64Array%":"undefined"==typeof Float64Array?void 0:Float64Array,"%FinalizationRegistry%":"undefined"==typeof FinalizationRegistry?void 0:FinalizationRegistry,"%Function%":$Function,"%GeneratorFunction%":needsEval,"%Int8Array%":"undefined"==typeof Int8Array?void 0:Int8Array,"%Int16Array%":"undefined"==typeof Int16Array?void 0:Int16Array,"%Int32Array%":"undefined"==typeof Int32Array?void 0:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":hasSymbols$1&&getProto?getProto(getProto([][Symbol.iterator]())):void 0,"%JSON%":"object"==typeof JSON?JSON:void 0,"%Map%":"undefined"==typeof Map?void 0:Map,"%MapIteratorPrototype%":"undefined"!=typeof Map&&hasSymbols$1&&getProto?getProto((new Map)[Symbol.iterator]()):void 0,"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":"undefined"==typeof Promise?void 0:Promise,"%Proxy%":"undefined"==typeof Proxy?void 0:Proxy,"%RangeError%":RangeError,"%ReferenceError%":ReferenceError,"%Reflect%":"undefined"==typeof Reflect?void 0:Reflect,"%RegExp%":RegExp,"%Set%":"undefined"==typeof Set?void 0:Set,"%SetIteratorPrototype%":"undefined"!=typeof Set&&hasSymbols$1&&getProto?getProto((new Set)[Symbol.iterator]()):void 0,"%SharedArrayBuffer%":"undefined"==typeof SharedArrayBuffer?void 0:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":hasSymbols$1&&getProto?getProto(""[Symbol.iterator]()):void 0,"%Symbol%":hasSymbols$1?Symbol:void 0,"%SyntaxError%":$SyntaxError,"%ThrowTypeError%":ThrowTypeError,"%TypedArray%":TypedArray,"%TypeError%":$TypeError,"%Uint8Array%":"undefined"==typeof Uint8Array?void 0:Uint8Array,"%Uint8ClampedArray%":"undefined"==typeof Uint8ClampedArray?void 0:Uint8ClampedArray,"%Uint16Array%":"undefined"==typeof Uint16Array?void 0:Uint16Array,"%Uint32Array%":"undefined"==typeof Uint32Array?void 0:Uint32Array,"%URIError%":URIError,"%WeakMap%":"undefined"==typeof WeakMap?void 0:WeakMap,"%WeakRef%":"undefined"==typeof WeakRef?void 0:WeakRef,"%WeakSet%":"undefined"==typeof WeakSet?void 0:WeakSet};if(getProto)try{null.error}catch(e){var errorProto=getProto(getProto(e));INTRINSICS["%Error.prototype%"]=errorProto}var LEGACY_ALIASES={"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]},$concat=functionBind.call(Function.call,Array.prototype.concat),$spliceApply=functionBind.call(Function.apply,Array.prototype.splice),$replace=functionBind.call(Function.call,String.prototype.replace),$strSlice=functionBind.call(Function.call,String.prototype.slice),$exec=functionBind.call(Function.call,RegExp.prototype.exec),rePropName=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,reEscapeChar=/\\(\\)?/g,stringToPath=function(string){var first=$strSlice(string,0,1),last=$strSlice(string,-1);if("%"===first&&"%"!==last)throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");if("%"===last&&"%"!==first)throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");var result=[];return $replace(string,rePropName,(function(match,number,quote,subString){result[result.length]=quote?$replace(subString,reEscapeChar,"$1"):number||match})),result},getBaseIntrinsic=function(name,allowMissing){var alias,intrinsicName=name;if(src(LEGACY_ALIASES,intrinsicName)&&(intrinsicName="%"+(alias=LEGACY_ALIASES[intrinsicName])[0]+"%"),src(INTRINSICS,intrinsicName)){var value=INTRINSICS[intrinsicName];if(value===needsEval&&(value=function doEval(name){var value;if("%AsyncFunction%"===name)value=getEvalledConstructor("async function () {}");else if("%GeneratorFunction%"===name)value=getEvalledConstructor("function* () {}");else if("%AsyncGeneratorFunction%"===name)value=getEvalledConstructor("async function* () {}");else if("%AsyncGenerator%"===name){var fn=doEval("%AsyncGeneratorFunction%");fn&&(value=fn.prototype)}else if("%AsyncIteratorPrototype%"===name){var gen=doEval("%AsyncGenerator%");gen&&getProto&&(value=getProto(gen.prototype))}return INTRINSICS[name]=value,value}(intrinsicName)),void 0===value&&!allowMissing)throw new $TypeError("intrinsic "+name+" exists, but is not available. Please file an issue!");return{alias:alias,name:intrinsicName,value:value}}throw new $SyntaxError("intrinsic "+name+" does not exist!")},getIntrinsic=function(name,allowMissing){if("string"!=typeof name||0===name.length)throw new $TypeError("intrinsic name must be a non-empty string");if(arguments.length>1&&"boolean"!=typeof allowMissing)throw new $TypeError('"allowMissing" argument must be a boolean');if(null===$exec(/^%?[^%]*%?$/,name))throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");var parts=stringToPath(name),intrinsicBaseName=parts.length>0?parts[0]:"",intrinsic=getBaseIntrinsic("%"+intrinsicBaseName+"%",allowMissing),intrinsicRealName=intrinsic.name,value=intrinsic.value,skipFurtherCaching=!1,alias=intrinsic.alias;alias&&(intrinsicBaseName=alias[0],$spliceApply(parts,$concat([0,1],alias)));for(var i=1,isOwn=!0;i<parts.length;i+=1){var part=parts[i],first=$strSlice(part,0,1),last=$strSlice(part,-1);if(('"'===first||"'"===first||"`"===first||'"'===last||"'"===last||"`"===last)&&first!==last)throw new $SyntaxError("property names with quotes must have matching quotes");if("constructor"!==part&&isOwn||(skipFurtherCaching=!0),src(INTRINSICS,intrinsicRealName="%"+(intrinsicBaseName+="."+part)+"%"))value=INTRINSICS[intrinsicRealName];else if(null!=value){if(!(part in value)){if(!allowMissing)throw new $TypeError("base intrinsic for "+name+" exists, but the property is not available.");return}if($gOPD&&i+1>=parts.length){var desc=$gOPD(value,part);value=(isOwn=!!desc)&&"get"in desc&&!("originalValue"in desc.get)?desc.get:value[part]}else isOwn=src(value,part),value=value[part];isOwn&&!skipFurtherCaching&&(INTRINSICS[intrinsicRealName]=value)}}return value},callBind=createCommonjsModule((function(module){var $apply=getIntrinsic("%Function.prototype.apply%"),$call=getIntrinsic("%Function.prototype.call%"),$reflectApply=getIntrinsic("%Reflect.apply%",!0)||functionBind.call($call,$apply),$gOPD=getIntrinsic("%Object.getOwnPropertyDescriptor%",!0),$defineProperty=getIntrinsic("%Object.defineProperty%",!0),$max=getIntrinsic("%Math.max%");if($defineProperty)try{$defineProperty({},"a",{value:1})}catch(e){$defineProperty=null}module.exports=function(originalFunction){var func=$reflectApply(functionBind,$call,arguments);if($gOPD&&$defineProperty){var desc=$gOPD(func,"length");desc.configurable&&$defineProperty(func,"length",{value:1+$max(0,originalFunction.length-(arguments.length-1))})}return func};var applyBind=function(){return $reflectApply(functionBind,$apply,arguments)};$defineProperty?$defineProperty(module.exports,"apply",{value:applyBind}):module.exports.apply=applyBind})),$indexOf=(callBind.apply,callBind(getIntrinsic("String.prototype.indexOf"))),callBound=function(name,allowMissing){var intrinsic=getIntrinsic(name,!!allowMissing);return"function"==typeof intrinsic&&$indexOf(name,".prototype.")>-1?callBind(intrinsic):intrinsic},semver=function(n){return n&&n.default||n}(Object.freeze({__proto__:null,default:{}})),hasMap="function"==typeof Map&&Map.prototype,mapSizeDescriptor=Object.getOwnPropertyDescriptor&&hasMap?Object.getOwnPropertyDescriptor(Map.prototype,"size"):null,mapSize=hasMap&&mapSizeDescriptor&&"function"==typeof mapSizeDescriptor.get?mapSizeDescriptor.get:null,mapForEach=hasMap&&Map.prototype.forEach,hasSet="function"==typeof Set&&Set.prototype,setSizeDescriptor=Object.getOwnPropertyDescriptor&&hasSet?Object.getOwnPropertyDescriptor(Set.prototype,"size"):null,setSize=hasSet&&setSizeDescriptor&&"function"==typeof setSizeDescriptor.get?setSizeDescriptor.get:null,setForEach=hasSet&&Set.prototype.forEach,weakMapHas="function"==typeof WeakMap&&WeakMap.prototype?WeakMap.prototype.has:null,weakSetHas="function"==typeof WeakSet&&WeakSet.prototype?WeakSet.prototype.has:null,weakRefDeref="function"==typeof WeakRef&&WeakRef.prototype?WeakRef.prototype.deref:null,booleanValueOf=Boolean.prototype.valueOf,objectToString=Object.prototype.toString,functionToString=Function.prototype.toString,$match=String.prototype.match,$slice=String.prototype.slice,$replace$1=String.prototype.replace,$toUpperCase=String.prototype.toUpperCase,$toLowerCase=String.prototype.toLowerCase,$test=RegExp.prototype.test,$concat$1=Array.prototype.concat,$join=Array.prototype.join,$arrSlice=Array.prototype.slice,$floor=Math.floor,bigIntValueOf="function"==typeof BigInt?BigInt.prototype.valueOf:null,gOPS=Object.getOwnPropertySymbols,symToString="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?Symbol.prototype.toString:null,hasShammedSymbols="function"==typeof Symbol&&"object"==typeof Symbol.iterator,toStringTag="function"==typeof Symbol&&Symbol.toStringTag&&(typeof Symbol.toStringTag===hasShammedSymbols||"symbol")?Symbol.toStringTag:null,isEnumerable=Object.prototype.propertyIsEnumerable,gPO=("function"==typeof Reflect?Reflect.getPrototypeOf:Object.getPrototypeOf)||([].__proto__===Array.prototype?function(O){return O.__proto__}:null);function addNumericSeparator(num,str){if(num===1/0||num===-1/0||num!=num||num&&num>-1e3&&num<1e3||$test.call(/e/,str))return str;var sepRegex=/[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;if("number"==typeof num){var int=num<0?-$floor(-num):$floor(num);if(int!==num){var intStr=String(int),dec=$slice.call(str,intStr.length+1);return $replace$1.call(intStr,sepRegex,"$&_")+"."+$replace$1.call($replace$1.call(dec,/([0-9]{3})/g,"$&_"),/_$/,"")}}return $replace$1.call(str,sepRegex,"$&_")}var inspectCustom=semver.custom,inspectSymbol=isSymbol(inspectCustom)?inspectCustom:null,objectInspect=function inspect_(obj,options,depth,seen){var opts=options||{};if(has(opts,"quoteStyle")&&"single"!==opts.quoteStyle&&"double"!==opts.quoteStyle)throw new TypeError('option "quoteStyle" must be "single" or "double"');if(has(opts,"maxStringLength")&&("number"==typeof opts.maxStringLength?opts.maxStringLength<0&&opts.maxStringLength!==1/0:null!==opts.maxStringLength))throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');var customInspect=!has(opts,"customInspect")||opts.customInspect;if("boolean"!=typeof customInspect&&"symbol"!==customInspect)throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");if(has(opts,"indent")&&null!==opts.indent&&"\t"!==opts.indent&&!(parseInt(opts.indent,10)===opts.indent&&opts.indent>0))throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');if(has(opts,"numericSeparator")&&"boolean"!=typeof opts.numericSeparator)throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');var numericSeparator=opts.numericSeparator;if(void 0===obj)return"undefined";if(null===obj)return"null";if("boolean"==typeof obj)return obj?"true":"false";if("string"==typeof obj)return function inspectString(str,opts){if(str.length>opts.maxStringLength){var remaining=str.length-opts.maxStringLength,trailer="... "+remaining+" more character"+(remaining>1?"s":"");return inspectString($slice.call(str,0,opts.maxStringLength),opts)+trailer}return wrapQuotes($replace$1.call($replace$1.call(str,/(['\\])/g,"\\$1"),/[\x00-\x1f]/g,lowbyte),"single",opts)}(obj,opts);if("number"==typeof obj){if(0===obj)return 1/0/obj>0?"0":"-0";var str=String(obj);return numericSeparator?addNumericSeparator(obj,str):str}if("bigint"==typeof obj){var bigIntStr=String(obj)+"n";return numericSeparator?addNumericSeparator(obj,bigIntStr):bigIntStr}var maxDepth=void 0===opts.depth?5:opts.depth;if(void 0===depth&&(depth=0),depth>=maxDepth&&maxDepth>0&&"object"==typeof obj)return isArray(obj)?"[Array]":"[Object]";var indent=function(opts,depth){var baseIndent;if("\t"===opts.indent)baseIndent="\t";else{if(!("number"==typeof opts.indent&&opts.indent>0))return null;baseIndent=$join.call(Array(opts.indent+1)," ")}return{base:baseIndent,prev:$join.call(Array(depth+1),baseIndent)}}(opts,depth);if(void 0===seen)seen=[];else if(indexOf(seen,obj)>=0)return"[Circular]";function inspect(value,from,noIndent){if(from&&(seen=$arrSlice.call(seen)).push(from),noIndent){var newOpts={depth:opts.depth};return has(opts,"quoteStyle")&&(newOpts.quoteStyle=opts.quoteStyle),inspect_(value,newOpts,depth+1,seen)}return inspect_(value,opts,depth+1,seen)}if("function"==typeof obj&&!isRegExp(obj)){var name=function(f){if(f.name)return f.name;var m=$match.call(functionToString.call(f),/^function\s*([\w$]+)/);if(m)return m[1];return null}(obj),keys=arrObjKeys(obj,inspect);return"[Function"+(name?": "+name:" (anonymous)")+"]"+(keys.length>0?" { "+$join.call(keys,", ")+" }":"")}if(isSymbol(obj)){var symString=hasShammedSymbols?$replace$1.call(String(obj),/^(Symbol\(.*\))_[^)]*$/,"$1"):symToString.call(obj);return"object"!=typeof obj||hasShammedSymbols?symString:markBoxed(symString)}if(function(x){if(!x||"object"!=typeof x)return!1;if("undefined"!=typeof HTMLElement&&x instanceof HTMLElement)return!0;return"string"==typeof x.nodeName&&"function"==typeof x.getAttribute}(obj)){for(var s="<"+$toLowerCase.call(String(obj.nodeName)),attrs=obj.attributes||[],i=0;i<attrs.length;i++)s+=" "+attrs[i].name+"="+wrapQuotes(quote(attrs[i].value),"double",opts);return s+=">",obj.childNodes&&obj.childNodes.length&&(s+="..."),s+="</"+$toLowerCase.call(String(obj.nodeName))+">"}if(isArray(obj)){if(0===obj.length)return"[]";var xs=arrObjKeys(obj,inspect);return indent&&!function(xs){for(var i=0;i<xs.length;i++)if(indexOf(xs[i],"\n")>=0)return!1;return!0}(xs)?"["+indentedJoin(xs,indent)+"]":"[ "+$join.call(xs,", ")+" ]"}if(function(obj){return!("[object Error]"!==toStr$1(obj)||toStringTag&&"object"==typeof obj&&toStringTag in obj)}(obj)){var parts=arrObjKeys(obj,inspect);return"cause"in Error.prototype||!("cause"in obj)||isEnumerable.call(obj,"cause")?0===parts.length?"["+String(obj)+"]":"{ ["+String(obj)+"] "+$join.call(parts,", ")+" }":"{ ["+String(obj)+"] "+$join.call($concat$1.call("[cause]: "+inspect(obj.cause),parts),", ")+" }"}if("object"==typeof obj&&customInspect){if(inspectSymbol&&"function"==typeof obj[inspectSymbol]&&semver)return semver(obj,{depth:maxDepth-depth});if("symbol"!==customInspect&&"function"==typeof obj.inspect)return obj.inspect()}if(function(x){if(!mapSize||!x||"object"!=typeof x)return!1;try{mapSize.call(x);try{setSize.call(x)}catch(s){return!0}return x instanceof Map}catch(e){}return!1}(obj)){var mapParts=[];return mapForEach&&mapForEach.call(obj,(function(value,key){mapParts.push(inspect(key,obj,!0)+" => "+inspect(value,obj))})),collectionOf("Map",mapSize.call(obj),mapParts,indent)}if(function(x){if(!setSize||!x||"object"!=typeof x)return!1;try{setSize.call(x);try{mapSize.call(x)}catch(m){return!0}return x instanceof Set}catch(e){}return!1}(obj)){var setParts=[];return setForEach&&setForEach.call(obj,(function(value){setParts.push(inspect(value,obj))})),collectionOf("Set",setSize.call(obj),setParts,indent)}if(function(x){if(!weakMapHas||!x||"object"!=typeof x)return!1;try{weakMapHas.call(x,weakMapHas);try{weakSetHas.call(x,weakSetHas)}catch(s){return!0}return x instanceof WeakMap}catch(e){}return!1}(obj))return weakCollectionOf("WeakMap");if(function(x){if(!weakSetHas||!x||"object"!=typeof x)return!1;try{weakSetHas.call(x,weakSetHas);try{weakMapHas.call(x,weakMapHas)}catch(s){return!0}return x instanceof WeakSet}catch(e){}return!1}(obj))return weakCollectionOf("WeakSet");if(function(x){if(!weakRefDeref||!x||"object"!=typeof x)return!1;try{return weakRefDeref.call(x),!0}catch(e){}return!1}(obj))return weakCollectionOf("WeakRef");if(function(obj){return!("[object Number]"!==toStr$1(obj)||toStringTag&&"object"==typeof obj&&toStringTag in obj)}(obj))return markBoxed(inspect(Number(obj)));if(function(obj){if(!obj||"object"!=typeof obj||!bigIntValueOf)return!1;try{return bigIntValueOf.call(obj),!0}catch(e){}return!1}(obj))return markBoxed(inspect(bigIntValueOf.call(obj)));if(function(obj){return!("[object Boolean]"!==toStr$1(obj)||toStringTag&&"object"==typeof obj&&toStringTag in obj)}(obj))return markBoxed(booleanValueOf.call(obj));if(function(obj){return!("[object String]"!==toStr$1(obj)||toStringTag&&"object"==typeof obj&&toStringTag in obj)}(obj))return markBoxed(inspect(String(obj)));if(!function(obj){return!("[object Date]"!==toStr$1(obj)||toStringTag&&"object"==typeof obj&&toStringTag in obj)}(obj)&&!isRegExp(obj)){var ys=arrObjKeys(obj,inspect),isPlainObject=gPO?gPO(obj)===Object.prototype:obj instanceof Object||obj.constructor===Object,protoTag=obj instanceof Object?"":"null prototype",stringTag=!isPlainObject&&toStringTag&&Object(obj)===obj&&toStringTag in obj?$slice.call(toStr$1(obj),8,-1):protoTag?"Object":"",tag=(isPlainObject||"function"!=typeof obj.constructor?"":obj.constructor.name?obj.constructor.name+" ":"")+(stringTag||protoTag?"["+$join.call($concat$1.call([],stringTag||[],protoTag||[]),": ")+"] ":"");return 0===ys.length?tag+"{}":indent?tag+"{"+indentedJoin(ys,indent)+"}":tag+"{ "+$join.call(ys,", ")+" }"}return String(obj)};function wrapQuotes(s,defaultStyle,opts){var quoteChar="double"===(opts.quoteStyle||defaultStyle)?'"':"'";return quoteChar+s+quoteChar}function quote(s){return $replace$1.call(String(s),/"/g,"&quot;")}function isArray(obj){return!("[object Array]"!==toStr$1(obj)||toStringTag&&"object"==typeof obj&&toStringTag in obj)}function isRegExp(obj){return!("[object RegExp]"!==toStr$1(obj)||toStringTag&&"object"==typeof obj&&toStringTag in obj)}function isSymbol(obj){if(hasShammedSymbols)return obj&&"object"==typeof obj&&obj instanceof Symbol;if("symbol"==typeof obj)return!0;if(!obj||"object"!=typeof obj||!symToString)return!1;try{return symToString.call(obj),!0}catch(e){}return!1}var hasOwn=Object.prototype.hasOwnProperty||function(key){return key in this};function has(obj,key){return hasOwn.call(obj,key)}function toStr$1(obj){return objectToString.call(obj)}function indexOf(xs,x){if(xs.indexOf)return xs.indexOf(x);for(var i=0,l=xs.length;i<l;i++)if(xs[i]===x)return i;return-1}function lowbyte(c){var n=c.charCodeAt(0),x={8:"b",9:"t",10:"n",12:"f",13:"r"}[n];return x?"\\"+x:"\\x"+(n<16?"0":"")+$toUpperCase.call(n.toString(16))}function markBoxed(str){return"Object("+str+")"}function weakCollectionOf(type){return type+" { ? }"}function collectionOf(type,size,entries,indent){return type+" ("+size+") {"+(indent?indentedJoin(entries,indent):$join.call(entries,", "))+"}"}function indentedJoin(xs,indent){if(0===xs.length)return"";var lineJoiner="\n"+indent.prev+indent.base;return lineJoiner+$join.call(xs,","+lineJoiner)+"\n"+indent.prev}function arrObjKeys(obj,inspect){var isArr=isArray(obj),xs=[];if(isArr){xs.length=obj.length;for(var i=0;i<obj.length;i++)xs[i]=has(obj,i)?inspect(obj[i],obj):""}var symMap,syms="function"==typeof gOPS?gOPS(obj):[];if(hasShammedSymbols){symMap={};for(var k=0;k<syms.length;k++)symMap["$"+syms[k]]=syms[k]}for(var key in obj)has(obj,key)&&(isArr&&String(Number(key))===key&&key<obj.length||hasShammedSymbols&&symMap["$"+key]instanceof Symbol||($test.call(/[^\w$]/,key)?xs.push(inspect(key,obj)+": "+inspect(obj[key],obj)):xs.push(key+": "+inspect(obj[key],obj))));if("function"==typeof gOPS)for(var j=0;j<syms.length;j++)isEnumerable.call(obj,syms[j])&&xs.push("["+inspect(syms[j])+"]: "+inspect(obj[syms[j]],obj));return xs}var $TypeError$1=getIntrinsic("%TypeError%"),$WeakMap=getIntrinsic("%WeakMap%",!0),$Map=getIntrinsic("%Map%",!0),$weakMapGet=callBound("WeakMap.prototype.get",!0),$weakMapSet=callBound("WeakMap.prototype.set",!0),$weakMapHas=callBound("WeakMap.prototype.has",!0),$mapGet=callBound("Map.prototype.get",!0),$mapSet=callBound("Map.prototype.set",!0),$mapHas=callBound("Map.prototype.has",!0),listGetNode=function(list,key){for(var curr,prev=list;null!==(curr=prev.next);prev=curr)if(curr.key===key)return prev.next=curr.next,curr.next=list.next,list.next=curr,curr},sideChannel=function(){var $wm,$m,$o,channel={assert:function(key){if(!channel.has(key))throw new $TypeError$1("Side channel does not contain "+objectInspect(key))},get:function(key){if($WeakMap&&key&&("object"==typeof key||"function"==typeof key)){if($wm)return $weakMapGet($wm,key)}else if($Map){if($m)return $mapGet($m,key)}else if($o)return function(objects,key){var node=listGetNode(objects,key);return node&&node.value}($o,key)},has:function(key){if($WeakMap&&key&&("object"==typeof key||"function"==typeof key)){if($wm)return $weakMapHas($wm,key)}else if($Map){if($m)return $mapHas($m,key)}else if($o)return function(objects,key){return!!listGetNode(objects,key)}($o,key);return!1},set:function(key,value){$WeakMap&&key&&("object"==typeof key||"function"==typeof key)?($wm||($wm=new $WeakMap),$weakMapSet($wm,key,value)):$Map?($m||($m=new $Map),$mapSet($m,key,value)):($o||($o={key:{},next:null}),function(objects,key,value){var node=listGetNode(objects,key);node?node.value=value:objects.next={key:key,next:objects.next,value:value}}($o,key,value))}};return channel},replace=String.prototype.replace,percentTwenties=/%20/g,Format_RFC3986="RFC3986",formats={default:Format_RFC3986,formatters:{RFC1738:function(value){return replace.call(value,percentTwenties,"+")},RFC3986:function(value){return String(value)}},RFC1738:"RFC1738",RFC3986:Format_RFC3986},has$1=Object.prototype.hasOwnProperty,isArray$1=Array.isArray,hexTable=function(){for(var array=[],i=0;i<256;++i)array.push("%"+((i<16?"0":"")+i.toString(16)).toUpperCase());return array}(),arrayToObject=function(source,options){for(var obj=options&&options.plainObjects?Object.create(null):{},i=0;i<source.length;++i)void 0!==source[i]&&(obj[i]=source[i]);return obj},utils={arrayToObject:arrayToObject,assign:function(target,source){return Object.keys(source).reduce((function(acc,key){return acc[key]=source[key],acc}),target)},combine:function(a,b){return[].concat(a,b)},compact:function(value){for(var queue=[{obj:{o:value},prop:"o"}],refs=[],i=0;i<queue.length;++i)for(var item=queue[i],obj=item.obj[item.prop],keys=Object.keys(obj),j=0;j<keys.length;++j){var key=keys[j],val=obj[key];"object"==typeof val&&null!==val&&-1===refs.indexOf(val)&&(queue.push({obj:obj,prop:key}),refs.push(val))}return function(queue){for(;queue.length>1;){var item=queue.pop(),obj=item.obj[item.prop];if(isArray$1(obj)){for(var compacted=[],j=0;j<obj.length;++j)void 0!==obj[j]&&compacted.push(obj[j]);item.obj[item.prop]=compacted}}}(queue),value},decode:function(str,decoder,charset){var strWithoutPlus=str.replace(/\+/g," ");if("iso-8859-1"===charset)return strWithoutPlus.replace(/%[0-9a-f]{2}/gi,unescape);try{return decodeURIComponent(strWithoutPlus)}catch(e){return strWithoutPlus}},encode:function(str,defaultEncoder,charset,kind,format){if(0===str.length)return str;var string=str;if("symbol"==typeof str?string=Symbol.prototype.toString.call(str):"string"!=typeof str&&(string=String(str)),"iso-8859-1"===charset)return escape(string).replace(/%u[0-9a-f]{4}/gi,(function($0){return"%26%23"+parseInt($0.slice(2),16)+"%3B"}));for(var out="",i=0;i<string.length;++i){var c=string.charCodeAt(i);45===c||46===c||95===c||126===c||c>=48&&c<=57||c>=65&&c<=90||c>=97&&c<=122||format===formats.RFC1738&&(40===c||41===c)?out+=string.charAt(i):c<128?out+=hexTable[c]:c<2048?out+=hexTable[192|c>>6]+hexTable[128|63&c]:c<55296||c>=57344?out+=hexTable[224|c>>12]+hexTable[128|c>>6&63]+hexTable[128|63&c]:(i+=1,c=65536+((1023&c)<<10|1023&string.charCodeAt(i)),out+=hexTable[240|c>>18]+hexTable[128|c>>12&63]+hexTable[128|c>>6&63]+hexTable[128|63&c])}return out},isBuffer:function(obj){return!(!obj||"object"!=typeof obj)&&!!(obj.constructor&&obj.constructor.isBuffer&&obj.constructor.isBuffer(obj))},isRegExp:function(obj){return"[object RegExp]"===Object.prototype.toString.call(obj)},maybeMap:function(val,fn){if(isArray$1(val)){for(var mapped=[],i=0;i<val.length;i+=1)mapped.push(fn(val[i]));return mapped}return fn(val)},merge:function merge(target,source,options){if(!source)return target;if("object"!=typeof source){if(isArray$1(target))target.push(source);else{if(!target||"object"!=typeof target)return[target,source];(options&&(options.plainObjects||options.allowPrototypes)||!has$1.call(Object.prototype,source))&&(target[source]=!0)}return target}if(!target||"object"!=typeof target)return[target].concat(source);var mergeTarget=target;return isArray$1(target)&&!isArray$1(source)&&(mergeTarget=arrayToObject(target,options)),isArray$1(target)&&isArray$1(source)?(source.forEach((function(item,i){if(has$1.call(target,i)){var targetItem=target[i];targetItem&&"object"==typeof targetItem&&item&&"object"==typeof item?target[i]=merge(targetItem,item,options):target.push(item)}else target[i]=item})),target):Object.keys(source).reduce((function(acc,key){var value=source[key];return has$1.call(acc,key)?acc[key]=merge(acc[key],value,options):acc[key]=value,acc}),mergeTarget)}},has$2=Object.prototype.hasOwnProperty,arrayPrefixGenerators={brackets:function(prefix){return prefix+"[]"},comma:"comma",indices:function(prefix,key){return prefix+"["+key+"]"},repeat:function(prefix){return prefix}},isArray$2=Array.isArray,push=Array.prototype.push,pushToArray=function(arr,valueOrArray){push.apply(arr,isArray$2(valueOrArray)?valueOrArray:[valueOrArray])},toISO=Date.prototype.toISOString,defaultFormat=formats.default,defaults={addQueryPrefix:!1,allowDots:!1,charset:"utf-8",charsetSentinel:!1,delimiter:"&",encode:!0,encoder:utils.encode,encodeValuesOnly:!1,format:defaultFormat,formatter:formats.formatters[defaultFormat],indices:!1,serializeDate:function(date){return toISO.call(date)},skipNulls:!1,strictNullHandling:!1},sentinel={},stringify=function stringify(object,prefix,generateArrayPrefix,commaRoundTrip,strictNullHandling,skipNulls,encoder,filter,sort,allowDots,serializeDate,format,formatter,encodeValuesOnly,charset,sideChannel$1){for(var obj=object,tmpSc=sideChannel$1,step=0,findFlag=!1;void 0!==(tmpSc=tmpSc.get(sentinel))&&!findFlag;){var pos=tmpSc.get(object);if(step+=1,void 0!==pos){if(pos===step)throw new RangeError("Cyclic object value");findFlag=!0}void 0===tmpSc.get(sentinel)&&(step=0)}if("function"==typeof filter?obj=filter(prefix,obj):obj instanceof Date?obj=serializeDate(obj):"comma"===generateArrayPrefix&&isArray$2(obj)&&(obj=utils.maybeMap(obj,(function(value){return value instanceof Date?serializeDate(value):value}))),null===obj){if(strictNullHandling)return encoder&&!encodeValuesOnly?encoder(prefix,defaults.encoder,charset,"key",format):prefix;obj=""}if(function(v){return"string"==typeof v||"number"==typeof v||"boolean"==typeof v||"symbol"==typeof v||"bigint"==typeof v}(obj)||utils.isBuffer(obj))return encoder?[formatter(encodeValuesOnly?prefix:encoder(prefix,defaults.encoder,charset,"key",format))+"="+formatter(encoder(obj,defaults.encoder,charset,"value",format))]:[formatter(prefix)+"="+formatter(String(obj))];var objKeys,values=[];if(void 0===obj)return values;if("comma"===generateArrayPrefix&&isArray$2(obj))encodeValuesOnly&&encoder&&(obj=utils.maybeMap(obj,encoder)),objKeys=[{value:obj.length>0?obj.join(",")||null:void 0}];else if(isArray$2(filter))objKeys=filter;else{var keys=Object.keys(obj);objKeys=sort?keys.sort(sort):keys}for(var adjustedPrefix=commaRoundTrip&&isArray$2(obj)&&1===obj.length?prefix+"[]":prefix,j=0;j<objKeys.length;++j){var key=objKeys[j],value="object"==typeof key&&void 0!==key.value?key.value:obj[key];if(!skipNulls||null!==value){var keyPrefix=isArray$2(obj)?"function"==typeof generateArrayPrefix?generateArrayPrefix(adjustedPrefix,key):adjustedPrefix:adjustedPrefix+(allowDots?"."+key:"["+key+"]");sideChannel$1.set(object,step);var valueSideChannel=sideChannel();valueSideChannel.set(sentinel,sideChannel$1),pushToArray(values,stringify(value,keyPrefix,generateArrayPrefix,commaRoundTrip,strictNullHandling,skipNulls,"comma"===generateArrayPrefix&&encodeValuesOnly&&isArray$2(obj)?null:encoder,filter,sort,allowDots,serializeDate,format,formatter,encodeValuesOnly,charset,valueSideChannel))}}return values},has$3=Object.prototype.hasOwnProperty,isArray$3=Array.isArray,defaults$1={allowDots:!1,allowPrototypes:!1,allowSparse:!1,arrayLimit:20,charset:"utf-8",charsetSentinel:!1,comma:!1,decoder:utils.decode,delimiter:"&",depth:5,ignoreQueryPrefix:!1,interpretNumericEntities:!1,parameterLimit:1e3,parseArrays:!0,plainObjects:!1,strictNullHandling:!1},interpretNumericEntities=function(str){return str.replace(/&#(\d+);/g,(function($0,numberStr){return String.fromCharCode(parseInt(numberStr,10))}))},parseArrayValue=function(val,options){return val&&"string"==typeof val&&options.comma&&val.indexOf(",")>-1?val.split(","):val},parseKeys=function(givenKey,val,options,valuesParsed){if(givenKey){var key=options.allowDots?givenKey.replace(/\.([^.[]+)/g,"[$1]"):givenKey,child=/(\[[^[\]]*])/g,segment=options.depth>0&&/(\[[^[\]]*])/.exec(key),parent=segment?key.slice(0,segment.index):key,keys=[];if(parent){if(!options.plainObjects&&has$3.call(Object.prototype,parent)&&!options.allowPrototypes)return;keys.push(parent)}for(var i=0;options.depth>0&&null!==(segment=child.exec(key))&&i<options.depth;){if(i+=1,!options.plainObjects&&has$3.call(Object.prototype,segment[1].slice(1,-1))&&!options.allowPrototypes)return;keys.push(segment[1])}return segment&&keys.push("["+key.slice(segment.index)+"]"),function(chain,val,options,valuesParsed){for(var leaf=valuesParsed?val:parseArrayValue(val,options),i=chain.length-1;i>=0;--i){var obj,root=chain[i];if("[]"===root&&options.parseArrays)obj=[].concat(leaf);else{obj=options.plainObjects?Object.create(null):{};var cleanRoot="["===root.charAt(0)&&"]"===root.charAt(root.length-1)?root.slice(1,-1):root,index=parseInt(cleanRoot,10);options.parseArrays||""!==cleanRoot?!isNaN(index)&&root!==cleanRoot&&String(index)===cleanRoot&&index>=0&&options.parseArrays&&index<=options.arrayLimit?(obj=[])[index]=leaf:"__proto__"!==cleanRoot&&(obj[cleanRoot]=leaf):obj={0:leaf}}leaf=obj}return leaf}(keys,val,options,valuesParsed)}},lib={formats:formats,parse:function(str,opts){var options=function(opts){if(!opts)return defaults$1;if(null!==opts.decoder&&void 0!==opts.decoder&&"function"!=typeof opts.decoder)throw new TypeError("Decoder has to be a function.");if(void 0!==opts.charset&&"utf-8"!==opts.charset&&"iso-8859-1"!==opts.charset)throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");var charset=void 0===opts.charset?defaults$1.charset:opts.charset;return{allowDots:void 0===opts.allowDots?defaults$1.allowDots:!!opts.allowDots,allowPrototypes:"boolean"==typeof opts.allowPrototypes?opts.allowPrototypes:defaults$1.allowPrototypes,allowSparse:"boolean"==typeof opts.allowSparse?opts.allowSparse:defaults$1.allowSparse,arrayLimit:"number"==typeof opts.arrayLimit?opts.arrayLimit:defaults$1.arrayLimit,charset:charset,charsetSentinel:"boolean"==typeof opts.charsetSentinel?opts.charsetSentinel:defaults$1.charsetSentinel,comma:"boolean"==typeof opts.comma?opts.comma:defaults$1.comma,decoder:"function"==typeof opts.decoder?opts.decoder:defaults$1.decoder,delimiter:"string"==typeof opts.delimiter||utils.isRegExp(opts.delimiter)?opts.delimiter:defaults$1.delimiter,depth:"number"==typeof opts.depth||!1===opts.depth?+opts.depth:defaults$1.depth,ignoreQueryPrefix:!0===opts.ignoreQueryPrefix,interpretNumericEntities:"boolean"==typeof opts.interpretNumericEntities?opts.interpretNumericEntities:defaults$1.interpretNumericEntities,parameterLimit:"number"==typeof opts.parameterLimit?opts.parameterLimit:defaults$1.parameterLimit,parseArrays:!1!==opts.parseArrays,plainObjects:"boolean"==typeof opts.plainObjects?opts.plainObjects:defaults$1.plainObjects,strictNullHandling:"boolean"==typeof opts.strictNullHandling?opts.strictNullHandling:defaults$1.strictNullHandling}}(opts);if(""===str||null==str)return options.plainObjects?Object.create(null):{};for(var tempObj="string"==typeof str?function(str,options){var i,obj={__proto__:null},cleanStr=options.ignoreQueryPrefix?str.replace(/^\?/,""):str,limit=options.parameterLimit===1/0?void 0:options.parameterLimit,parts=cleanStr.split(options.delimiter,limit),skipIndex=-1,charset=options.charset;if(options.charsetSentinel)for(i=0;i<parts.length;++i)0===parts[i].indexOf("utf8=")&&("utf8=%E2%9C%93"===parts[i]?charset="utf-8":"utf8=%26%2310003%3B"===parts[i]&&(charset="iso-8859-1"),skipIndex=i,i=parts.length);for(i=0;i<parts.length;++i)if(i!==skipIndex){var key,val,part=parts[i],bracketEqualsPos=part.indexOf("]="),pos=-1===bracketEqualsPos?part.indexOf("="):bracketEqualsPos+1;-1===pos?(key=options.decoder(part,defaults$1.decoder,charset,"key"),val=options.strictNullHandling?null:""):(key=options.decoder(part.slice(0,pos),defaults$1.decoder,charset,"key"),val=utils.maybeMap(parseArrayValue(part.slice(pos+1),options),(function(encodedVal){return options.decoder(encodedVal,defaults$1.decoder,charset,"value")}))),val&&options.interpretNumericEntities&&"iso-8859-1"===charset&&(val=interpretNumericEntities(val)),part.indexOf("[]=")>-1&&(val=isArray$3(val)?[val]:val),has$3.call(obj,key)?obj[key]=utils.combine(obj[key],val):obj[key]=val}return obj}(str,options):str,obj=options.plainObjects?Object.create(null):{},keys=Object.keys(tempObj),i=0;i<keys.length;++i){var key=keys[i],newObj=parseKeys(key,tempObj[key],options,"string"==typeof str);obj=utils.merge(obj,newObj,options)}return!0===options.allowSparse?obj:utils.compact(obj)},stringify:function(object,opts){var objKeys,obj=object,options=function(opts){if(!opts)return defaults;if(null!==opts.encoder&&void 0!==opts.encoder&&"function"!=typeof opts.encoder)throw new TypeError("Encoder has to be a function.");var charset=opts.charset||defaults.charset;if(void 0!==opts.charset&&"utf-8"!==opts.charset&&"iso-8859-1"!==opts.charset)throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");var format=formats.default;if(void 0!==opts.format){if(!has$2.call(formats.formatters,opts.format))throw new TypeError("Unknown format option provided.");format=opts.format}var formatter=formats.formatters[format],filter=defaults.filter;return("function"==typeof opts.filter||isArray$2(opts.filter))&&(filter=opts.filter),{addQueryPrefix:"boolean"==typeof opts.addQueryPrefix?opts.addQueryPrefix:defaults.addQueryPrefix,allowDots:void 0===opts.allowDots?defaults.allowDots:!!opts.allowDots,charset:charset,charsetSentinel:"boolean"==typeof opts.charsetSentinel?opts.charsetSentinel:defaults.charsetSentinel,delimiter:void 0===opts.delimiter?defaults.delimiter:opts.delimiter,encode:"boolean"==typeof opts.encode?opts.encode:defaults.encode,encoder:"function"==typeof opts.encoder?opts.encoder:defaults.encoder,encodeValuesOnly:"boolean"==typeof opts.encodeValuesOnly?opts.encodeValuesOnly:defaults.encodeValuesOnly,filter:filter,format:format,formatter:formatter,serializeDate:"function"==typeof opts.serializeDate?opts.serializeDate:defaults.serializeDate,skipNulls:"boolean"==typeof opts.skipNulls?opts.skipNulls:defaults.skipNulls,sort:"function"==typeof opts.sort?opts.sort:null,strictNullHandling:"boolean"==typeof opts.strictNullHandling?opts.strictNullHandling:defaults.strictNullHandling}}(opts);"function"==typeof options.filter?obj=(0,options.filter)("",obj):isArray$2(options.filter)&&(objKeys=options.filter);var arrayFormat,keys=[];if("object"!=typeof obj||null===obj)return"";arrayFormat=opts&&opts.arrayFormat in arrayPrefixGenerators?opts.arrayFormat:opts&&"indices"in opts?opts.indices?"indices":"repeat":"indices";var generateArrayPrefix=arrayPrefixGenerators[arrayFormat];if(opts&&"commaRoundTrip"in opts&&"boolean"!=typeof opts.commaRoundTrip)throw new TypeError("`commaRoundTrip` must be a boolean, or absent");var commaRoundTrip="comma"===generateArrayPrefix&&opts&&opts.commaRoundTrip;objKeys||(objKeys=Object.keys(obj)),options.sort&&objKeys.sort(options.sort);for(var sideChannel$1=sideChannel(),i=0;i<objKeys.length;++i){var key=objKeys[i];options.skipNulls&&null===obj[key]||pushToArray(keys,stringify(obj[key],key,generateArrayPrefix,commaRoundTrip,options.strictNullHandling,options.skipNulls,options.encode?options.encoder:null,options.filter,options.sort,options.allowDots,options.serializeDate,options.format,options.formatter,options.encodeValuesOnly,options.charset,sideChannel$1))}var joined=keys.join(options.delimiter),prefix=!0===options.addQueryPrefix?"?":"";return options.charsetSentinel&&("iso-8859-1"===options.charset?prefix+="utf8=%26%2310003%3B&":prefix+="utf8=%E2%9C%93&"),joined.length>0?prefix+joined:""}},componentEmitter=createCommonjsModule((function(module){function Emitter(obj){if(obj)return function(obj){for(var key in Emitter.prototype)obj[key]=Emitter.prototype[key];return obj}(obj)}module.exports=Emitter,Emitter.prototype.on=Emitter.prototype.addEventListener=function(event,fn){return this._callbacks=this._callbacks||{},(this._callbacks["$"+event]=this._callbacks["$"+event]||[]).push(fn),this},Emitter.prototype.once=function(event,fn){function on(){this.off(event,on),fn.apply(this,arguments)}return on.fn=fn,this.on(event,on),this},Emitter.prototype.off=Emitter.prototype.removeListener=Emitter.prototype.removeAllListeners=Emitter.prototype.removeEventListener=function(event,fn){if(this._callbacks=this._callbacks||{},0==arguments.length)return this._callbacks={},this;var cb,callbacks=this._callbacks["$"+event];if(!callbacks)return this;if(1==arguments.length)return delete this._callbacks["$"+event],this;for(var i=0;i<callbacks.length;i++)if((cb=callbacks[i])===fn||cb.fn===fn){callbacks.splice(i,1);break}return 0===callbacks.length&&delete this._callbacks["$"+event],this},Emitter.prototype.emit=function(event){this._callbacks=this._callbacks||{};for(var args=new Array(arguments.length-1),callbacks=this._callbacks["$"+event],i=1;i<arguments.length;i++)args[i-1]=arguments[i];if(callbacks){i=0;for(var len=(callbacks=callbacks.slice(0)).length;i<len;++i)callbacks[i].apply(this,args)}return this},Emitter.prototype.listeners=function(event){return this._callbacks=this._callbacks||{},this._callbacks["$"+event]||[]},Emitter.prototype.hasListeners=function(event){return!!this.listeners(event).length}})),fastSafeStringify=stringify$1;stringify$1.default=stringify$1,stringify$1.stable=deterministicStringify,stringify$1.stableStringify=deterministicStringify;var arr=[],replacerStack=[];function defaultOptions(){return{depthLimit:Number.MAX_SAFE_INTEGER,edgesLimit:Number.MAX_SAFE_INTEGER}}function stringify$1(obj,replacer,spacer,options){var res;void 0===options&&(options=defaultOptions()),function decirc(val,k,edgeIndex,stack,parent,depth,options){var i;if(depth+=1,"object"==typeof val&&null!==val){for(i=0;i<stack.length;i++)if(stack[i]===val)return void setReplace("[Circular]",val,k,parent);if(void 0!==options.depthLimit&&depth>options.depthLimit)return void setReplace("[...]",val,k,parent);if(void 0!==options.edgesLimit&&edgeIndex+1>options.edgesLimit)return void setReplace("[...]",val,k,parent);if(stack.push(val),Array.isArray(val))for(i=0;i<val.length;i++)decirc(val[i],i,i,stack,val,depth,options);else{var keys=Object.keys(val);for(i=0;i<keys.length;i++){var key=keys[i];decirc(val[key],key,i,stack,val,depth,options)}}stack.pop()}}(obj,"",0,[],void 0,0,options);try{res=0===replacerStack.length?JSON.stringify(obj,replacer,spacer):JSON.stringify(obj,replaceGetterValues(replacer),spacer)}catch(_){return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]")}finally{for(;0!==arr.length;){var part=arr.pop();4===part.length?Object.defineProperty(part[0],part[1],part[3]):part[0][part[1]]=part[2]}}return res}function setReplace(replace,val,k,parent){var propertyDescriptor=Object.getOwnPropertyDescriptor(parent,k);void 0!==propertyDescriptor.get?propertyDescriptor.configurable?(Object.defineProperty(parent,k,{value:replace}),arr.push([parent,k,val,propertyDescriptor])):replacerStack.push([val,k,replace]):(parent[k]=replace,arr.push([parent,k,val]))}function compareFunction(a,b){return a<b?-1:a>b?1:0}function deterministicStringify(obj,replacer,spacer,options){void 0===options&&(options=defaultOptions());var res,tmp=function deterministicDecirc(val,k,edgeIndex,stack,parent,depth,options){var i;if(depth+=1,"object"==typeof val&&null!==val){for(i=0;i<stack.length;i++)if(stack[i]===val)return void setReplace("[Circular]",val,k,parent);try{if("function"==typeof val.toJSON)return}catch(_){return}if(void 0!==options.depthLimit&&depth>options.depthLimit)return void setReplace("[...]",val,k,parent);if(void 0!==options.edgesLimit&&edgeIndex+1>options.edgesLimit)return void setReplace("[...]",val,k,parent);if(stack.push(val),Array.isArray(val))for(i=0;i<val.length;i++)deterministicDecirc(val[i],i,i,stack,val,depth,options);else{var tmp={},keys=Object.keys(val).sort(compareFunction);for(i=0;i<keys.length;i++){var key=keys[i];deterministicDecirc(val[key],key,i,stack,val,depth,options),tmp[key]=val[key]}if(void 0===parent)return tmp;arr.push([parent,k,val]),parent[k]=tmp}stack.pop()}}(obj,"",0,[],void 0,0,options)||obj;try{res=0===replacerStack.length?JSON.stringify(tmp,replacer,spacer):JSON.stringify(tmp,replaceGetterValues(replacer),spacer)}catch(_){return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]")}finally{for(;0!==arr.length;){var part=arr.pop();4===part.length?Object.defineProperty(part[0],part[1],part[3]):part[0][part[1]]=part[2]}}return res}function replaceGetterValues(replacer){return replacer=void 0!==replacer?replacer:function(k,v){return v},function(key,val){if(replacerStack.length>0)for(var i=0;i<replacerStack.length;i++){var part=replacerStack[i];if(part[1]===key&&part[0]===val){val=part[2],replacerStack.splice(i,1);break}}return replacer.call(this,key,val)}}var utils$1=createCommonjsModule((function(module,exports){function _typeof(obj){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj})(obj)}function _createForOfIteratorHelper(o,allowArrayLike){var it="undefined"!=typeof Symbol&&o[Symbol.iterator]||o["@@iterator"];if(!it){if(Array.isArray(o)||(it=function(o,minLen){if(!o)return;if("string"==typeof o)return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);"Object"===n&&o.constructor&&(n=o.constructor.name);if("Map"===n||"Set"===n)return Array.from(o);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen)}(o))||allowArrayLike&&o&&"number"==typeof o.length){it&&(o=it);var i=0,F=function(){};return{s:F,n:function(){return i>=o.length?{done:!0}:{done:!1,value:o[i++]}},e:function(_e){throw _e},f:F}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var err,normalCompletion=!0,didErr=!1;return{s:function(){it=it.call(o)},n:function(){var step=it.next();return normalCompletion=step.done,step},e:function(_e2){didErr=!0,err=_e2},f:function(){try{normalCompletion||null==it.return||it.return()}finally{if(didErr)throw err}}}}function _arrayLikeToArray(arr,len){(null==len||len>arr.length)&&(len=arr.length);for(var i=0,arr2=new Array(len);i<len;i++)arr2[i]=arr[i];return arr2}exports.type=function(string_){return string_.split(/ *; */).shift()},exports.params=function(value){var _step,object={},_iterator=_createForOfIteratorHelper(value.split(/ *; */));try{for(_iterator.s();!(_step=_iterator.n()).done;){var parts=_step.value.split(/ *= */),key=parts.shift(),_value=parts.shift();key&&_value&&(object[key]=_value)}}catch(err){_iterator.e(err)}finally{_iterator.f()}return object},exports.parseLinks=function(value){var _step2,object={},_iterator2=_createForOfIteratorHelper(value.split(/ *, */));try{for(_iterator2.s();!(_step2=_iterator2.n()).done;){var parts=_step2.value.split(/ *; */),url=parts[0].slice(1,-1);object[parts[1].split(/ *= */)[1].slice(1,-1)]=url}}catch(err){_iterator2.e(err)}finally{_iterator2.f()}return object},exports.cleanHeader=function(header,changesOrigin){return delete header["content-type"],delete header["content-length"],delete header["transfer-encoding"],delete header.host,changesOrigin&&(delete header.authorization,delete header.cookie),header},exports.isObject=function(object){return null!==object&&"object"===_typeof(object)},exports.hasOwn=Object.hasOwn||function(object,property){if(null==object)throw new TypeError("Cannot convert undefined or null to object");return Object.prototype.hasOwnProperty.call(new Object(object),property)},exports.mixin=function(target,source){for(var key in source)exports.hasOwn(source,key)&&(target[key]=source[key])}}));utils$1.type,utils$1.params,utils$1.parseLinks,utils$1.cleanHeader,utils$1.isObject,utils$1.hasOwn,utils$1.mixin;function _typeof(obj){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj})(obj)}var isObject=utils$1.isObject,hasOwn$1=utils$1.hasOwn,requestBase=RequestBase;function RequestBase(){}RequestBase.prototype.clearTimeout=function(){return clearTimeout(this._timer),clearTimeout(this._responseTimeoutTimer),clearTimeout(this._uploadTimeoutTimer),delete this._timer,delete this._responseTimeoutTimer,delete this._uploadTimeoutTimer,this},RequestBase.prototype.parse=function(fn){return this._parser=fn,this},RequestBase.prototype.responseType=function(value){return this._responseType=value,this},RequestBase.prototype.serialize=function(fn){return this._serializer=fn,this},RequestBase.prototype.timeout=function(options){if(!options||"object"!==_typeof(options))return this._timeout=options,this._responseTimeout=0,this._uploadTimeout=0,this;for(var option in options)if(hasOwn$1(options,option))switch(option){case"deadline":this._timeout=options.deadline;break;case"response":this._responseTimeout=options.response;break;case"upload":this._uploadTimeout=options.upload;break;default:console.warn("Unknown timeout option",option)}return this},RequestBase.prototype.retry=function(count,fn){return 0!==arguments.length&&!0!==count||(count=1),count<=0&&(count=0),this._maxRetries=count,this._retries=0,this._retryCallback=fn,this};var ERROR_CODES=new Set(["ETIMEDOUT","ECONNRESET","EADDRINUSE","ECONNREFUSED","EPIPE","ENOTFOUND","ENETUNREACH","EAI_AGAIN"]),STATUS_CODES=new Set([408,413,429,500,502,503,504,521,522,524]);RequestBase.prototype._shouldRetry=function(error,res){if(!this._maxRetries||this._retries++>=this._maxRetries)return!1;if(this._retryCallback)try{var override=this._retryCallback(error,res);if(!0===override)return!0;if(!1===override)return!1}catch(err){console.error(err)}if(res&&res.status&&STATUS_CODES.has(res.status))return!0;if(error){if(error.code&&ERROR_CODES.has(error.code))return!0;if(error.timeout&&"ECONNABORTED"===error.code)return!0;if(error.crossDomain)return!0}return!1},RequestBase.prototype._retry=function(){return this.clearTimeout(),this.req&&(this.req=null,this.req=this.request()),this._aborted=!1,this.timedout=!1,this.timedoutError=null,this._end()},RequestBase.prototype.then=function(resolve,reject){var _this=this;if(!this._fullfilledPromise){var self=this;this._endCalled&&console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises"),this._fullfilledPromise=new Promise((function(resolve,reject){self.on("abort",(function(){if(!(_this._maxRetries&&_this._maxRetries>_this._retries))if(_this.timedout&&_this.timedoutError)reject(_this.timedoutError);else{var error=new Error("Aborted");error.code="ABORTED",error.status=_this.status,error.method=_this.method,error.url=_this.url,reject(error)}})),self.end((function(error,res){error?reject(error):resolve(res)}))}))}return this._fullfilledPromise.then(resolve,reject)},RequestBase.prototype.catch=function(callback){return this.then(void 0,callback)},RequestBase.prototype.use=function(fn){return fn(this),this},RequestBase.prototype.ok=function(callback){if("function"!=typeof callback)throw new Error("Callback required");return this._okCallback=callback,this},RequestBase.prototype._isResponseOK=function(res){return!!res&&(this._okCallback?this._okCallback(res):res.status>=200&&res.status<300)},RequestBase.prototype.get=function(field){return this._header[field.toLowerCase()]},RequestBase.prototype.getHeader=RequestBase.prototype.get,RequestBase.prototype.set=function(field,value){if(isObject(field)){for(var key in field)hasOwn$1(field,key)&&this.set(key,field[key]);return this}return this._header[field.toLowerCase()]=value,this.header[field]=value,this},RequestBase.prototype.unset=function(field){return delete this._header[field.toLowerCase()],delete this.header[field],this},RequestBase.prototype.field=function(name,value,options){if(null==name)throw new Error(".field(name, val) name can not be empty");if(this._data)throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");if(isObject(name)){for(var key in name)hasOwn$1(name,key)&&this.field(key,name[key]);return this}if(Array.isArray(value)){for(var i in value)hasOwn$1(value,i)&&this.field(name,value[i]);return this}if(null==value)throw new Error(".field(name, val) val can not be empty");return"boolean"==typeof value&&(value=String(value)),options?this._getFormData().append(name,value,options):this._getFormData().append(name,value),this},RequestBase.prototype.abort=function(){if(this._aborted)return this;if(this._aborted=!0,this.xhr&&this.xhr.abort(),this.req){if(semver.gte(process.version,"v13.0.0")&&semver.lt(process.version,"v14.0.0"))throw new Error("Superagent does not work in v13 properly with abort() due to Node.js core changes");semver.gte(process.version,"v14.0.0")&&(this.req.destroyed=!0),this.req.abort()}return this.clearTimeout(),this.emit("abort"),this},RequestBase.prototype._auth=function(user,pass,options,base64Encoder){switch(options.type){case"basic":this.set("Authorization","Basic ".concat(base64Encoder("".concat(user,":").concat(pass))));break;case"auto":this.username=user,this.password=pass;break;case"bearer":this.set("Authorization","Bearer ".concat(user))}return this},RequestBase.prototype.withCredentials=function(on){return void 0===on&&(on=!0),this._withCredentials=on,this},RequestBase.prototype.redirects=function(n){return this._maxRedirects=n,this},RequestBase.prototype.maxResponseSize=function(n){if("number"!=typeof n)throw new TypeError("Invalid argument");return this._maxResponseSize=n,this},RequestBase.prototype.toJSON=function(){return{method:this.method,url:this.url,data:this._data,headers:this._header}},RequestBase.prototype.send=function(data){var isObject_=isObject(data),type=this._header["content-type"];if(this._formData)throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");if(isObject_&&!this._data)Array.isArray(data)?this._data=[]:this._isHost(data)||(this._data={});else if(data&&this._data&&this._isHost(this._data))throw new Error("Can't merge these send calls");if(isObject_&&isObject(this._data))for(var key in data)hasOwn$1(data,key)&&(this._data[key]=data[key]);else"string"==typeof data?(type||this.type("form"),(type=this._header["content-type"])&&(type=type.toLowerCase().trim()),this._data="application/x-www-form-urlencoded"===type?this._data?"".concat(this._data,"&").concat(data):data:(this._data||"")+data):this._data=data;return!isObject_||this._isHost(data)||type||this.type("json"),this},RequestBase.prototype.sortQuery=function(sort){return this._sort=void 0===sort||sort,this},RequestBase.prototype._finalizeQueryString=function(){var query=this._query.join("&");if(query&&(this.url+=(this.url.includes("?")?"&":"?")+query),this._query.length=0,this._sort){var index=this.url.indexOf("?");if(index>=0){var queryArray=this.url.slice(index+1).split("&");"function"==typeof this._sort?queryArray.sort(this._sort):queryArray.sort(),this.url=this.url.slice(0,index)+"?"+queryArray.join("&")}}},RequestBase.prototype._appendQueryString=function(){console.warn("Unsupported")},RequestBase.prototype._timeoutError=function(reason,timeout,errno){if(!this._aborted){var error=new Error("".concat(reason+timeout,"ms exceeded"));error.timeout=timeout,error.code="ECONNABORTED",error.errno=errno,this.timedout=!0,this.timedoutError=error,this.abort(),this.callback(error)}},RequestBase.prototype._setTimeouts=function(){var self=this;this._timeout&&!this._timer&&(this._timer=setTimeout((function(){self._timeoutError("Timeout of ",self._timeout,"ETIME")}),this._timeout)),this._responseTimeout&&!this._responseTimeoutTimer&&(this._responseTimeoutTimer=setTimeout((function(){self._timeoutError("Response timeout of ",self._responseTimeout,"ETIMEDOUT")}),this._responseTimeout))};var responseBase=ResponseBase;function ResponseBase(){}function _toConsumableArray(arr){return function(arr){if(Array.isArray(arr))return _arrayLikeToArray(arr)}(arr)||function(iter){if("undefined"!=typeof Symbol&&null!=iter[Symbol.iterator]||null!=iter["@@iterator"])return Array.from(iter)}(arr)||_unsupportedIterableToArray(arr)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function _unsupportedIterableToArray(o,minLen){if(o){if("string"==typeof o)return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);return"Object"===n&&o.constructor&&(n=o.constructor.name),"Map"===n||"Set"===n?Array.from(o):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?_arrayLikeToArray(o,minLen):void 0}}function _arrayLikeToArray(arr,len){(null==len||len>arr.length)&&(len=arr.length);for(var i=0,arr2=new Array(len);i<len;i++)arr2[i]=arr[i];return arr2}function Agent(){this._defaults=[]}ResponseBase.prototype.get=function(field){return this.header[field.toLowerCase()]},ResponseBase.prototype._setHeaderProperties=function(header){var ct=header["content-type"]||"";this.type=utils$1.type(ct);var parameters=utils$1.params(ct);for(var key in parameters)Object.prototype.hasOwnProperty.call(parameters,key)&&(this[key]=parameters[key]);this.links={};try{header.link&&(this.links=utils$1.parseLinks(header.link))}catch(_unused){}},ResponseBase.prototype._setStatusProperties=function(status){var type=Math.trunc(status/100);this.statusCode=status,this.status=this.statusCode,this.statusType=type,this.info=1===type,this.ok=2===type,this.redirect=3===type,this.clientError=4===type,this.serverError=5===type,this.error=(4===type||5===type)&&this.toError(),this.created=201===status,this.accepted=202===status,this.noContent=204===status,this.badRequest=400===status,this.unauthorized=401===status,this.notAcceptable=406===status,this.forbidden=403===status,this.notFound=404===status,this.unprocessableEntity=422===status};for(var _loop=function(){var fn=_arr[_i];Agent.prototype[fn]=function(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++)args[_key]=arguments[_key];return this._defaults.push({fn:fn,args:args}),this}},_i=0,_arr=["use","on","once","set","query","type","accept","auth","withCredentials","sortQuery","retry","ok","redirects","timeout","buffer","serialize","parse","ca","key","pfx","cert","disableTLSCerts"];_i<_arr.length;_i++)_loop();Agent.prototype._setDefaults=function(request){var _step,_iterator=function(o,allowArrayLike){var it="undefined"!=typeof Symbol&&o[Symbol.iterator]||o["@@iterator"];if(!it){if(Array.isArray(o)||(it=_unsupportedIterableToArray(o))||allowArrayLike&&o&&"number"==typeof o.length){it&&(o=it);var i=0,F=function(){};return{s:F,n:function(){return i>=o.length?{done:!0}:{done:!1,value:o[i++]}},e:function(_e){throw _e},f:F}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var err,normalCompletion=!0,didErr=!1;return{s:function(){it=it.call(o)},n:function(){var step=it.next();return normalCompletion=step.done,step},e:function(_e2){didErr=!0,err=_e2},f:function(){try{normalCompletion||null==it.return||it.return()}finally{if(didErr)throw err}}}}(this._defaults);try{for(_iterator.s();!(_step=_iterator.n()).done;){var def=_step.value;request[def.fn].apply(request,_toConsumableArray(def.args))}}catch(err){_iterator.e(err)}finally{_iterator.f()}};for(var agentBase=Agent,client=createCommonjsModule((function(module,exports){function _typeof(obj){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj})(obj)}function _createForOfIteratorHelper(o,allowArrayLike){var it="undefined"!=typeof Symbol&&o[Symbol.iterator]||o["@@iterator"];if(!it){if(Array.isArray(o)||(it=function(o,minLen){if(!o)return;if("string"==typeof o)return _arrayLikeToArray(o,minLen);var n=Object.prototype.toString.call(o).slice(8,-1);"Object"===n&&o.constructor&&(n=o.constructor.name);if("Map"===n||"Set"===n)return Array.from(o);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return _arrayLikeToArray(o,minLen)}(o))||allowArrayLike&&o&&"number"==typeof o.length){it&&(o=it);var i=0,F=function(){};return{s:F,n:function(){return i>=o.length?{done:!0}:{done:!1,value:o[i++]}},e:function(_e){throw _e},f:F}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var err,normalCompletion=!0,didErr=!1;return{s:function(){it=it.call(o)},n:function(){var step=it.next();return normalCompletion=step.done,step},e:function(_e2){didErr=!0,err=_e2},f:function(){try{normalCompletion||null==it.return||it.return()}finally{if(didErr)throw err}}}}function _arrayLikeToArray(arr,len){(null==len||len>arr.length)&&(len=arr.length);for(var i=0,arr2=new Array(len);i<len;i++)arr2[i]=arr[i];return arr2}var root;"undefined"!=typeof window?root=window:"undefined"==typeof self?(console.warn("Using browser-only version of superagent in non-browser environment"),root=void 0):root=self;var isObject=utils$1.isObject,mixin=utils$1.mixin,hasOwn=utils$1.hasOwn;function noop(){}module.exports=function(method,url){return"function"==typeof url?new exports.Request("GET",method).end(url):1===arguments.length?new exports.Request("GET",method):new exports.Request(method,url)};var request=exports=module.exports;exports.Request=Request,request.getXHR=function(){if(root.XMLHttpRequest&&(!root.location||"file:"!==root.location.protocol||!root.ActiveXObject))return new XMLHttpRequest;try{return new ActiveXObject("Microsoft.XMLHTTP")}catch(_unused){}try{return new ActiveXObject("Msxml2.XMLHTTP.6.0")}catch(_unused2){}try{return new ActiveXObject("Msxml2.XMLHTTP.3.0")}catch(_unused3){}try{return new ActiveXObject("Msxml2.XMLHTTP")}catch(_unused4){}throw new Error("Browser-only version of superagent could not find XHR")};var trim="".trim?function(s){return s.trim()}:function(s){return s.replace(/(^\s*|\s*$)/g,"")};function serialize(object){if(!isObject(object))return object;var pairs=[];for(var key in object)hasOwn(object,key)&&pushEncodedKeyValuePair(pairs,key,object[key]);return pairs.join("&")}function pushEncodedKeyValuePair(pairs,key,value){if(void 0!==value)if(null!==value)if(Array.isArray(value)){var _step,_iterator=_createForOfIteratorHelper(value);try{for(_iterator.s();!(_step=_iterator.n()).done;){pushEncodedKeyValuePair(pairs,key,_step.value)}}catch(err){_iterator.e(err)}finally{_iterator.f()}}else if(isObject(value))for(var subkey in value)hasOwn(value,subkey)&&pushEncodedKeyValuePair(pairs,"".concat(key,"[").concat(subkey,"]"),value[subkey]);else pairs.push(encodeURI(key)+"="+encodeURIComponent(value));else pairs.push(encodeURI(key))}function parseString(string_){for(var pair,pos,object={},pairs=string_.split("&"),i=0,length_=pairs.length;i<length_;++i)-1===(pos=(pair=pairs[i]).indexOf("="))?object[decodeURIComponent(pair)]="":object[decodeURIComponent(pair.slice(0,pos))]=decodeURIComponent(pair.slice(pos+1));return object}function isJSON(mime){return/[/+]json($|[^-\w])/i.test(mime)}function Response(request_){this.req=request_,this.xhr=this.req.xhr,this.text="HEAD"!==this.req.method&&(""===this.xhr.responseType||"text"===this.xhr.responseType)||void 0===this.xhr.responseType?this.xhr.responseText:null,this.statusText=this.req.xhr.statusText;var status=this.xhr.status;1223===status&&(status=204),this._setStatusProperties(status),this.headers=function(string_){for(var index,line,field,value,lines=string_.split(/\r?\n/),fields={},i=0,length_=lines.length;i<length_;++i)-1!==(index=(line=lines[i]).indexOf(":"))&&(field=line.slice(0,index).toLowerCase(),value=trim(line.slice(index+1)),fields[field]=value);return fields}(this.xhr.getAllResponseHeaders()),this.header=this.headers,this.header["content-type"]=this.xhr.getResponseHeader("content-type"),this._setHeaderProperties(this.header),null===this.text&&request_._responseType?this.body=this.xhr.response:this.body="HEAD"===this.req.method?null:this._parseBody(this.text?this.text:this.xhr.response)}function Request(method,url){var self=this;this._query=this._query||[],this.method=method,this.url=url,this.header={},this._header={},this.on("end",(function(){var new_error,error=null,res=null;try{res=new Response(self)}catch(err){return(error=new Error("Parser is unable to parse the response")).parse=!0,error.original=err,self.xhr?(error.rawResponse=void 0===self.xhr.responseType?self.xhr.responseText:self.xhr.response,error.status=self.xhr.status?self.xhr.status:null,error.statusCode=error.status):(error.rawResponse=null,error.status=null),self.callback(error)}self.emit("response",res);try{self._isResponseOK(res)||(new_error=new Error(res.statusText||res.text||"Unsuccessful HTTP response"))}catch(err){new_error=err}new_error?(new_error.original=error,new_error.response=res,new_error.status=res.status,self.callback(new_error,res)):self.callback(null,res)}))}request.serializeObject=serialize,request.parseString=parseString,request.types={html:"text/html",json:"application/json",xml:"text/xml",urlencoded:"application/x-www-form-urlencoded",form:"application/x-www-form-urlencoded","form-data":"application/x-www-form-urlencoded"},request.serialize={"application/x-www-form-urlencoded":lib.stringify,"application/json":fastSafeStringify},request.parse={"application/x-www-form-urlencoded":parseString,"application/json":JSON.parse},mixin(Response.prototype,responseBase.prototype),Response.prototype._parseBody=function(string_){var parse=request.parse[this.type];return this.req._parser?this.req._parser(this,string_):(!parse&&isJSON(this.type)&&(parse=request.parse["application/json"]),parse&&string_&&(string_.length>0||string_ instanceof Object)?parse(string_):null)},Response.prototype.toError=function(){var req=this.req,method=req.method,url=req.url,message="cannot ".concat(method," ").concat(url," (").concat(this.status,")"),error=new Error(message);return error.status=this.status,error.method=method,error.url=url,error},request.Response=Response,componentEmitter(Request.prototype),mixin(Request.prototype,requestBase.prototype),Request.prototype.type=function(type){return this.set("Content-Type",request.types[type]||type),this},Request.prototype.accept=function(type){return this.set("Accept",request.types[type]||type),this},Request.prototype.auth=function(user,pass,options){1===arguments.length&&(pass=""),"object"===_typeof(pass)&&null!==pass&&(options=pass,pass=""),options||(options={type:"function"==typeof btoa?"basic":"auto"});var encoder=options.encoder?options.encoder:function(string){if("function"==typeof btoa)return btoa(string);throw new Error("Cannot use basic auth, btoa is not a function")};return this._auth(user,pass,options,encoder)},Request.prototype.query=function(value){return"string"!=typeof value&&(value=serialize(value)),value&&this._query.push(value),this},Request.prototype.attach=function(field,file,options){if(file){if(this._data)throw new Error("superagent can't mix .send() and .attach()");this._getFormData().append(field,file,options||file.name)}return this},Request.prototype._getFormData=function(){return this._formData||(this._formData=new root.FormData),this._formData},Request.prototype.callback=function(error,res){if(this._shouldRetry(error,res))return this._retry();var fn=this._callback;this.clearTimeout(),error&&(this._maxRetries&&(error.retries=this._retries-1),this.emit("error",error)),fn(error,res)},Request.prototype.crossDomainError=function(){var error=new Error("Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.");error.crossDomain=!0,error.status=this.status,error.method=this.method,error.url=this.url,this.callback(error)},Request.prototype.agent=function(){return console.warn("This is not supported in browser version of superagent"),this},Request.prototype.ca=Request.prototype.agent,Request.prototype.buffer=Request.prototype.ca,Request.prototype.write=function(){throw new Error("Streaming is not supported in browser version of superagent")},Request.prototype.pipe=Request.prototype.write,Request.prototype._isHost=function(object){return object&&"object"===_typeof(object)&&!Array.isArray(object)&&"[object Object]"!==Object.prototype.toString.call(object)},Request.prototype.end=function(fn){this._endCalled&&console.warn("Warning: .end() was called twice. This is not supported in superagent"),this._endCalled=!0,this._callback=fn||noop,this._finalizeQueryString(),this._end()},Request.prototype._setUploadTimeout=function(){var self=this;this._uploadTimeout&&!this._uploadTimeoutTimer&&(this._uploadTimeoutTimer=setTimeout((function(){self._timeoutError("Upload timeout of ",self._uploadTimeout,"ETIMEDOUT")}),this._uploadTimeout))},Request.prototype._end=function(){if(this._aborted)return this.callback(new Error("The request has been aborted even before .end() was called"));var self=this;this.xhr=request.getXHR();var xhr=this.xhr,data=this._formData||this._data;this._setTimeouts(),xhr.addEventListener("readystatechange",(function(){var readyState=xhr.readyState;if(readyState>=2&&self._responseTimeoutTimer&&clearTimeout(self._responseTimeoutTimer),4===readyState){var status;try{status=xhr.status}catch(_unused5){status=0}if(!status){if(self.timedout||self._aborted)return;return self.crossDomainError()}self.emit("end")}}));var handleProgress=function(direction,e){e.total>0&&(e.percent=e.loaded/e.total*100,100===e.percent&&clearTimeout(self._uploadTimeoutTimer)),e.direction=direction,self.emit("progress",e)};if(this.hasListeners("progress"))try{xhr.addEventListener("progress",handleProgress.bind(null,"download")),xhr.upload&&xhr.upload.addEventListener("progress",handleProgress.bind(null,"upload"))}catch(_unused6){}xhr.upload&&this._setUploadTimeout();try{this.username&&this.password?xhr.open(this.method,this.url,!0,this.username,this.password):xhr.open(this.method,this.url,!0)}catch(err){return this.callback(err)}if(this._withCredentials&&(xhr.withCredentials=!0),!this._formData&&"GET"!==this.method&&"HEAD"!==this.method&&"string"!=typeof data&&!this._isHost(data)){var contentType=this._header["content-type"],_serialize=this._serializer||request.serialize[contentType?contentType.split(";")[0]:""];!_serialize&&isJSON(contentType)&&(_serialize=request.serialize["application/json"]),_serialize&&(data=_serialize(data))}for(var field in this.header)null!==this.header[field]&&hasOwn(this.header,field)&&xhr.setRequestHeader(field,this.header[field]);this._responseType&&(xhr.responseType=this._responseType),this.emit("request",this),xhr.send(void 0===data?null:data)},request.agent=function(){return new agentBase};for(var _loop=function(){var method=_arr[_i];agentBase.prototype[method.toLowerCase()]=function(url,fn){var request_=new request.Request(method,url);return this._setDefaults(request_),fn&&request_.end(fn),request_}},_i=0,_arr=["GET","POST","OPTIONS","PATCH","PUT","DELETE"];_i<_arr.length;_i++)_loop();function del(url,data,fn){var request_=request("DELETE",url);return"function"==typeof data&&(fn=data,data=null),data&&request_.send(data),fn&&request_.end(fn),request_}agentBase.prototype.del=agentBase.prototype.delete,request.get=function(url,data,fn){var request_=request("GET",url);return"function"==typeof data&&(fn=data,data=null),data&&request_.query(data),fn&&request_.end(fn),request_},request.head=function(url,data,fn){var request_=request("HEAD",url);return"function"==typeof data&&(fn=data,data=null),data&&request_.query(data),fn&&request_.end(fn),request_},request.options=function(url,data,fn){var request_=request("OPTIONS",url);return"function"==typeof data&&(fn=data,data=null),data&&request_.send(data),fn&&request_.end(fn),request_},request.del=del,request.delete=del,request.patch=function(url,data,fn){var request_=request("PATCH",url);return"function"==typeof data&&(fn=data,data=null),data&&request_.send(data),fn&&request_.end(fn),request_},request.post=function(url,data,fn){var request_=request("POST",url);return"function"==typeof data&&(fn=data,data=null),data&&request_.send(data),fn&&request_.end(fn),request_},request.put=function(url,data,fn){var request_=request("PUT",url);return"function"==typeof data&&(fn=data,data=null),data&&request_.send(data),fn&&request_.end(fn),request_}})),byteLength_1=(client.Request,function(b64){var lens=getLens(b64),validLen=lens[0],placeHoldersLen=lens[1];return 3*(validLen+placeHoldersLen)/4-placeHoldersLen}),toByteArray_1=function(b64){var tmp,i,lens=getLens(b64),validLen=lens[0],placeHoldersLen=lens[1],arr=new Arr(function(b64,validLen,placeHoldersLen){return 3*(validLen+placeHoldersLen)/4-placeHoldersLen}(0,validLen,placeHoldersLen)),curByte=0,len=placeHoldersLen>0?validLen-4:validLen;for(i=0;i<len;i+=4)tmp=revLookup[b64.charCodeAt(i)]<<18|revLookup[b64.charCodeAt(i+1)]<<12|revLookup[b64.charCodeAt(i+2)]<<6|revLookup[b64.charCodeAt(i+3)],arr[curByte++]=tmp>>16&255,arr[curByte++]=tmp>>8&255,arr[curByte++]=255&tmp;2===placeHoldersLen&&(tmp=revLookup[b64.charCodeAt(i)]<<2|revLookup[b64.charCodeAt(i+1)]>>4,arr[curByte++]=255&tmp);1===placeHoldersLen&&(tmp=revLookup[b64.charCodeAt(i)]<<10|revLookup[b64.charCodeAt(i+1)]<<4|revLookup[b64.charCodeAt(i+2)]>>2,arr[curByte++]=tmp>>8&255,arr[curByte++]=255&tmp);return arr},fromByteArray_1=function(uint8){for(var tmp,len=uint8.length,extraBytes=len%3,parts=[],i=0,len2=len-extraBytes;i<len2;i+=16383)parts.push(encodeChunk(uint8,i,i+16383>len2?len2:i+16383));1===extraBytes?(tmp=uint8[len-1],parts.push(lookup[tmp>>2]+lookup[tmp<<4&63]+"==")):2===extraBytes&&(tmp=(uint8[len-2]<<8)+uint8[len-1],parts.push(lookup[tmp>>10]+lookup[tmp>>4&63]+lookup[tmp<<2&63]+"="));return parts.join("")},lookup=[],revLookup=[],Arr="undefined"!=typeof Uint8Array?Uint8Array:Array,code="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=0,len=code.length;i<len;++i)lookup[i]=code[i],revLookup[code.charCodeAt(i)]=i;function getLens(b64){var len=b64.length;if(len%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var validLen=b64.indexOf("=");return-1===validLen&&(validLen=len),[validLen,validLen===len?0:4-validLen%4]}function encodeChunk(uint8,start,end){for(var tmp,num,output=[],i=start;i<end;i+=3)tmp=(uint8[i]<<16&16711680)+(uint8[i+1]<<8&65280)+(255&uint8[i+2]),output.push(lookup[(num=tmp)>>18&63]+lookup[num>>12&63]+lookup[num>>6&63]+lookup[63&num]);return output.join("")}revLookup["-".charCodeAt(0)]=62,revLookup["_".charCodeAt(0)]=63;var base64Js={byteLength:byteLength_1,toByteArray:toByteArray_1,fromByteArray:fromByteArray_1};var base64Url={encode:function(str){return base64Js.fromByteArray(function(str){for(var arr=new Array(str.length),a=0;a<str.length;a++)arr[a]=str.charCodeAt(a);return arr}(str)).replace(/\+/g,"-").replace(/\//g,"_")},decode:function(str){return str=function(str){var mod=str.length%4;return 0===mod?str:str+new Array(1+(4-mod)).join("=")}(str).replace(/-/g,"+").replace(/_/g,"/"),function(array){for(var result="",i=0;i<array.length;i++)result+=String.fromCharCode(array[i]);return result}(base64Js.toByteArray(str))}},version={raw:"9.23.2"},auth0_min_esm_toString=Object.prototype.toString;function attribute(o,attr,type,text){if(type="array"===type?"object":type,o&&typeof o[attr]!==type)throw new Error(text)}function variable(o,type,text){if(typeof o!==type)throw new Error(text)}function value(o,values,text){if(-1===values.indexOf(o))throw new Error(text)}var assert={check:function(o,config,attributes){if(config.optional&&!o||variable(o,config.type,config.message),"object"===config.type&&attributes)for(var keys=Object.keys(attributes),index=0;index<keys.length;index++){var a=keys[index];attributes[a].optional&&!o[a]||attributes[a].condition&&!attributes[a].condition(o)||(attribute(o,a,attributes[a].type,attributes[a].message),attributes[a].values&&value(o[a],attributes[a].values,attributes[a].value_message))}},attribute:attribute,variable:variable,value:value,isArray:function(array){return this.supportsIsArray()?Array.isArray(array):"[object Array]"===auth0_min_esm_toString.call(array)},supportsIsArray:function(){return null!=Array.isArray}};function objectAssignPolyfill(target){if(null==target)throw new TypeError("Cannot convert first argument to object");for(var to=Object(target),i=1;i<arguments.length;i++){var nextSource=arguments[i];if(null!=nextSource)for(var keysArray=Object.keys(Object(nextSource)),nextIndex=0,len=keysArray.length;nextIndex<len;nextIndex++){var nextKey=keysArray[nextIndex],desc=Object.getOwnPropertyDescriptor(nextSource,nextKey);void 0!==desc&&desc.enumerable&&(to[nextKey]=nextSource[nextKey])}}return to}var objectAssign={get:function(){return Object.assign?Object.assign:objectAssignPolyfill},objectAssignPolyfill:objectAssignPolyfill};function pick(object,keys){return keys.reduce((function(prev,key){return object[key]&&(prev[key]=object[key]),prev}),{})}function objectValues(obj){var values=[];for(var key in obj)values.push(obj[key]);return values}function extend(){var params=objectValues(arguments);return params.unshift({}),objectAssign.get().apply(void 0,params)}function getLocationFromUrl(href){var match=href.match(/^(https?:|file:|chrome-extension:)\/\/(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);return match&&{href:href,protocol:match[1],host:match[2],hostname:match[3],port:match[4],pathname:match[5],search:match[6],hash:match[7]}}function trim(options,key){var trimmed=extend(options);return options[key]&&(trimmed[key]=options[key].trim()),trimmed}var objectHelper={toSnakeCase:function toSnakeCase(object,exceptions){return"object"!=typeof object||assert.isArray(object)||null===object?object:(exceptions=exceptions||[],Object.keys(object).reduce((function(p,key){return p[-1===exceptions.indexOf(key)?function(str){for(var code,newKey="",index=0,wasPrevNumber=!0,wasPrevUppercase=!0;index<str.length;)code=str.charCodeAt(index),!wasPrevUppercase&&code>=65&&code<=90||!wasPrevNumber&&code>=48&&code<=57?(newKey+="_",newKey+=str[index].toLowerCase()):newKey+=str[index].toLowerCase(),wasPrevNumber=code>=48&&code<=57,wasPrevUppercase=code>=65&&code<=90,index++;return newKey}(key):key]=toSnakeCase(object[key]),p}),{}))},toCamelCase:function toCamelCase(object,exceptions,options){return"object"!=typeof object||assert.isArray(object)||null===object?object:(exceptions=exceptions||[],options=options||{},Object.keys(object).reduce((function(p,key){var parts,newKey=-1===exceptions.indexOf(key)?(parts=key.split("_")).reduce((function(p,c){return p+c.charAt(0).toUpperCase()+c.slice(1)}),parts.shift()):key;return p[newKey]=toCamelCase(object[newKey]||object[key],[],options),options.keepOriginal&&(p[key]=toCamelCase(object[key],[],options)),p}),{}))},blacklist:function(object,blacklistedKeys){return Object.keys(object).reduce((function(p,key){return-1===blacklistedKeys.indexOf(key)&&(p[key]=object[key]),p}),{})},merge:function(object,keys){return{base:keys?pick(object,keys):object,with:function(object2,keys2){return object2=keys2?pick(object2,keys2):object2,extend(this.base,object2)}}},pick:pick,getKeysNotIn:function(obj,allowedKeys){var notAllowed=[];for(var key in obj)-1===allowedKeys.indexOf(key)&&notAllowed.push(key);return notAllowed},extend:extend,getOriginFromUrl:function(url){if(url){var parsed=getLocationFromUrl(url);if(!parsed)return null;var origin=parsed.protocol+"//"+parsed.hostname;return parsed.port&&(origin+=":"+parsed.port),origin}},getLocationFromUrl:getLocationFromUrl,trimUserDetails:function(options){return function(options,keys){return keys.reduce(trim,options)}(options,["username","email","phoneNumber"])},updatePropertyOn:function updatePropertyOn(obj,path,value){"string"==typeof path&&(path=path.split("."));var next=path[0];obj.hasOwnProperty(next)&&(1===path.length?obj[next]=value:updatePropertyOn(obj[next],path.slice(1),value))}};function RequestWrapper(req){this.request=req,this.method=req.method,this.url=req.url,this.body=req._data,this.headers=req._header}function RequestObj(req){this.request=req}function RequestBuilder(options){this._sendTelemetry=!1!==options._sendTelemetry||options._sendTelemetry,this._telemetryInfo=options._telemetryInfo||null,this._timesToRetryFailedRequests=options._timesToRetryFailedRequests,this.headers=options.headers||{},this._universalLoginPage=options.universalLoginPage}function getWindow(){return window}RequestWrapper.prototype.abort=function(){this.request.abort()},RequestWrapper.prototype.getMethod=function(){return this.method},RequestWrapper.prototype.getBody=function(){return this.body},RequestWrapper.prototype.getUrl=function(){return this.url},RequestWrapper.prototype.getHeaders=function(){return this.headers},RequestObj.prototype.set=function(key,value){return this.request=this.request.set(key,value),this},RequestObj.prototype.send=function(body){return this.request=this.request.send(objectHelper.trimUserDetails(body)),this},RequestObj.prototype.withCredentials=function(){return this.request=this.request.withCredentials(),this},RequestObj.prototype.end=function(cb){return this.request.end(cb),new RequestWrapper(this.request)},RequestBuilder.prototype.setCommonConfiguration=function(ongoingRequest,options){if(options=options||{},this._timesToRetryFailedRequests>0&&(ongoingRequest=ongoingRequest.retry(this._timesToRetryFailedRequests)),options.noHeaders)return ongoingRequest;var headers=this.headers;ongoingRequest=ongoingRequest.set("Content-Type","application/json"),options.xRequestLanguage&&(ongoingRequest=ongoingRequest.set("X-Request-Language",options.xRequestLanguage));for(var keys=Object.keys(this.headers),a=0;a<keys.length;a++)ongoingRequest=ongoingRequest.set(keys[a],headers[keys[a]]);return this._sendTelemetry&&(ongoingRequest=ongoingRequest.set("Auth0-Client",this.getTelemetryData())),ongoingRequest},RequestBuilder.prototype.getTelemetryData=function(){var telemetryName=this._universalLoginPage?"auth0.js-ulp":"auth0.js",clientInfo={name:telemetryName,version:version.raw};this._telemetryInfo&&((clientInfo=objectHelper.extend({},this._telemetryInfo)).env=objectHelper.extend({},this._telemetryInfo.env),clientInfo.env[telemetryName]=version.raw);var jsonClientInfo=JSON.stringify(clientInfo);return base64Url.encode(jsonClientInfo)},RequestBuilder.prototype.get=function(url,options){return new RequestObj(this.setCommonConfiguration(client.get(url),options))},RequestBuilder.prototype.post=function(url,options){return new RequestObj(this.setCommonConfiguration(client.post(url),options))},RequestBuilder.prototype.patch=function(url,options){return new RequestObj(this.setCommonConfiguration(client.patch(url),options))};var windowHelper={redirect:function(url){getWindow().location=url},getDocument:function(){return getWindow().document},getWindow:getWindow,getOrigin:function(){var location=getWindow().location,origin=location.origin;return origin||(origin=objectHelper.getOriginFromUrl(location.href)),origin}};function DummyStorage(){}DummyStorage.prototype.getItem=function(){return null},DummyStorage.prototype.removeItem=function(){},DummyStorage.prototype.setItem=function(){};var auth0_min_esm_js_cookie=createCommonjsModule((function(module,exports){var factory;factory=function(){function extend(){for(var i=0,result={};i<arguments.length;i++){var attributes=arguments[i];for(var key in attributes)result[key]=attributes[key]}return result}function decode(s){return s.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent)}return function init(converter){function api(){}function set(key,value,attributes){if("undefined"!=typeof document){"number"==typeof(attributes=extend({path:"/"},api.defaults,attributes)).expires&&(attributes.expires=new Date(1*new Date+864e5*attributes.expires)),attributes.expires=attributes.expires?attributes.expires.toUTCString():"";try{var result=JSON.stringify(value);/^[\{\[]/.test(result)&&(value=result)}catch(e){}value=converter.write?converter.write(value,key):encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),key=encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);var stringifiedAttributes="";for(var attributeName in attributes)attributes[attributeName]&&(stringifiedAttributes+="; "+attributeName,!0!==attributes[attributeName]&&(stringifiedAttributes+="="+attributes[attributeName].split(";")[0]));return document.cookie=key+"="+value+stringifiedAttributes}}function get(key,json){if("undefined"!=typeof document){for(var jar={},cookies=document.cookie?document.cookie.split("; "):[],i=0;i<cookies.length;i++){var parts=cookies[i].split("="),cookie=parts.slice(1).join("=");json||'"'!==cookie.charAt(0)||(cookie=cookie.slice(1,-1));try{var name=decode(parts[0]);if(cookie=(converter.read||converter)(cookie,name)||decode(cookie),json)try{cookie=JSON.parse(cookie)}catch(e){}if(jar[name]=cookie,key===name)break}catch(e){}}return key?jar[key]:jar}}return api.set=set,api.get=function(key){return get(key,!1)},api.getJSON=function(key){return get(key,!0)},api.remove=function(key,attributes){set(key,"",extend(attributes,{expires:-1}))},api.defaults={},api.withConverter=init,api}((function(){}))},module.exports=factory()}));function buildCompatCookieKey(key){return"_"+key+"_compat"}function CookieStorage(options){this._options=options||{}}function Warn(options){this.disableWarnings=options.disableWarnings}function StorageHandler(options){if(this.warn=new Warn({}),this.storage=new CookieStorage(options),!0===options.__tryLocalStorageFirst)try{var localStorage=windowHelper.getWindow().localStorage;localStorage&&(this.storage=localStorage)}catch(e){this.warn.warning(e),this.warn.warning("Can't use localStorage. Using CookieStorage instead.")}}function Storage(options){this.handler=new StorageHandler(options)}function SSODataStorage(options){this.storage=new Storage(options)}function buildResponse(error,description){return{error:error,errorDescription:description}}CookieStorage.prototype.getItem=function(key){return auth0_min_esm_js_cookie.get(key)||auth0_min_esm_js_cookie.get(buildCompatCookieKey(key))},CookieStorage.prototype.removeItem=function(key){var params={};this._options.cookieDomain&&(params.domain=this._options.cookieDomain),auth0_min_esm_js_cookie.remove(key,params),auth0_min_esm_js_cookie.remove(buildCompatCookieKey(key),params)},CookieStorage.prototype.setItem=function(key,value,options){var params=objectHelper.extend({expires:1},options);if("https:"===windowHelper.getWindow().location.protocol&&(params.secure=!0,params.sameSite="none",this._options.legacySameSiteCookie)){var legacyOptions=objectHelper.blacklist(params,["sameSite"]);auth0_min_esm_js_cookie.set(buildCompatCookieKey(key),value,legacyOptions)}this._options.cookieDomain&&(params.domain=this._options.cookieDomain),auth0_min_esm_js_cookie.set(key,value,params)},Warn.prototype.warning=function(message){this.disableWarnings||console.warn(message)},StorageHandler.prototype.failover=function(){this.storage instanceof DummyStorage?this.warn.warning("DummyStorage: ignore failover"):this.storage instanceof CookieStorage?(this.warn.warning("CookieStorage: failing over DummyStorage"),this.storage=new DummyStorage):(this.warn.warning("LocalStorage: failing over CookieStorage"),this.storage=new CookieStorage)},StorageHandler.prototype.getItem=function(key){try{return this.storage.getItem(key)}catch(e){return this.warn.warning(e),this.failover(),this.getItem(key)}},StorageHandler.prototype.removeItem=function(key){try{return this.storage.removeItem(key)}catch(e){return this.warn.warning(e),this.failover(),this.removeItem(key)}},StorageHandler.prototype.setItem=function(key,value,options){try{return this.storage.setItem(key,value,options)}catch(e){return this.warn.warning(e),this.failover(),this.setItem(key,value,options)}},Storage.prototype.getItem=function(key){var value=this.handler.getItem(key);try{return JSON.parse(value)}catch(_){return value}},Storage.prototype.removeItem=function(key){return this.handler.removeItem(key)},Storage.prototype.setItem=function(key,value,options){var json=JSON.stringify(value);return this.handler.setItem(key,json,options)},SSODataStorage.prototype.set=function(connection,sub){var ssodata={lastUsedConnection:connection,lastUsedSub:sub};this.storage.setItem("auth0.ssodata",JSON.stringify(ssodata))},SSODataStorage.prototype.get=function(){var ssodata=this.storage.getItem("auth0.ssodata");if(ssodata)return JSON.parse(ssodata)};var error={buildResponse:buildResponse,invalidToken:function(description){return buildResponse("invalid_token",description)}};function wrapCallback(cb,options){return(options=options||{}).ignoreCasing=!!options.ignoreCasing&&options.ignoreCasing,function(err,data){var errObj;return err||data?(!err&&data.err&&(err=data.err,data=null),!err&&data.error&&(err=data,data=null),err?(errObj={original:err},objectHelper.updatePropertyOn(errObj,"original.response.req._data.password","*****"),err.response&&err.response.statusCode&&(errObj.statusCode=err.response.statusCode),err.response&&err.response.statusText&&(errObj.statusText=err.response.statusText),err.response&&err.response.body&&(err=err.response.body),err.err&&(err=err.err),errObj.code=err.code||err.error||err.error_code||err.status||null,errObj.description=err.errorDescription||err.error_description||err.description||err.error||err.details||err.err||null,options.forceLegacyError&&(errObj.error=errObj.code,errObj.error_description=errObj.description),err.error_codes&&err.error_details&&(errObj.errorDetails={codes:err.error_codes,details:err.error_details}),err.name&&(errObj.name=err.name),err.policy&&(errObj.policy=err.policy),cb(errObj)):!data.type||"text/html"!==data.type&&"text/plain"!==data.type?options.ignoreCasing?cb(null,data.body||data):cb(null,objectHelper.toCamelCase(data.body||data,[],{keepOriginal:options.keepOriginalCasing})):cb(null,data.text)):cb(error.buildResponse("generic_error","Something went wrong"))}}var tokenParams=["realm","audience","otp","client_id","client_secret","redirect_uri","scope","code","grant_type","username","password","refresh_token","assertion","client_assertion","client_assertion_type","code_verifier"],authorizeParams=["connection","connection_scope","auth0Client","owp","device","realm","organization","invitation","protocol","_csrf","_intstate","login_ticket","client_id","response_type","response_mode","redirect_uri","audience","scope","state","nonce","display","prompt","screen_hint","max_age","ui_locales","claims_locales","id_token_hint","login_hint","acr_values","claims","registration","request","request_uri","code_challenge","code_challenge_method","access_type","display"];var parametersWhitelist={oauthTokenParams:function(warn,params){return objectHelper.pick(params,tokenParams)},oauthAuthorizeParams:function(warn,params){var notAllowed=objectHelper.getKeysNotIn(params,authorizeParams);return notAllowed.length>0&&warn.warning("Following parameters are not allowed on the `/authorize` endpoint: ["+notAllowed.join(",")+"]"),params}},t="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:{};function e(t){var e={exports:{}};return t(e,e.exports),e.exports}var r=e((function(e,r){e.exports=function(){function e(t){return"function"==typeof t}var r=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)},i=0,n=void 0,o=void 0,s=function(t,e){l[i]=t,l[i+1]=e,2===(i+=2)&&(o?o(d):w())},h="undefined"!=typeof window?window:void 0,u=h||{},a=u.MutationObserver||u.WebKitMutationObserver,f="undefined"==typeof self&&"undefined"!=typeof process&&"[object process]"==={}.toString.call(process),c="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel;function p(){var t=setTimeout;return function(){return t(d,1)}}var l=new Array(1e3);function d(){for(var t=0;t<i;t+=2)(0,l[t])(l[t+1]),l[t]=void 0,l[t+1]=void 0;i=0}var m,v,y,g,w=void 0;function T(t,e){var r=this,i=new this.constructor(S);void 0===i[_]&&O(i);var n=r._state;if(n){var o=arguments[n-1];s((function(){return C(n,i,o,r._result)}))}else I(r,i,t,e);return i}function b(t){if(t&&"object"==typeof t&&t.constructor===this)return t;var e=new this(S);return B(e,t),e}w=f?function(){return process.nextTick(d)}:a?(v=0,y=new a(d),g=document.createTextNode(""),y.observe(g,{characterData:!0}),function(){g.data=v=++v%2}):c?((m=new MessageChannel).port1.onmessage=d,function(){return m.port2.postMessage(0)}):void 0===h?function(){try{var t=Function("return this")().require("vertx");return void 0!==(n=t.runOnLoop||t.runOnContext)?function(){n(d)}:p()}catch(t){return p()}}():p();var _=Math.random().toString(36).substring(2);function S(){}var A=void 0;function D(t,r,i){r.constructor===t.constructor&&i===T&&r.constructor.resolve===b?function(t,e){1===e._state?E(t,e._result):2===e._state?k(t,e._result):I(e,void 0,(function(e){return B(t,e)}),(function(e){return k(t,e)}))}(t,r):void 0===i?E(t,r):e(i)?function(t,e,r){s((function(t){var i=!1,n=function(r,n,o,s){try{r.call(n,(function(r){i||(i=!0,e!==r?B(t,r):E(t,r))}),(function(e){i||(i=!0,k(t,e))}))}catch(t){return t}}(r,e);!i&&n&&(i=!0,k(t,n))}),t)}(t,r,i):E(t,r)}function B(t,e){if(t===e)k(t,new TypeError("You cannot resolve a promise with itself"));else if(n=typeof(i=e),null===i||"object"!==n&&"function"!==n)E(t,e);else{var r=void 0;try{r=e.then}catch(e){return void k(t,e)}D(t,e,r)}var i,n}function x(t){t._onerror&&t._onerror(t._result),M(t)}function E(t,e){t._state===A&&(t._result=e,t._state=1,0!==t._subscribers.length&&s(M,t))}function k(t,e){t._state===A&&(t._state=2,t._result=e,s(x,t))}function I(t,e,r,i){var n=t._subscribers,o=n.length;t._onerror=null,n[o]=e,n[o+1]=r,n[o+2]=i,0===o&&t._state&&s(M,t)}function M(t){var e=t._subscribers,r=t._state;if(0!==e.length){for(var i=void 0,n=void 0,o=t._result,s=0;s<e.length;s+=3)n=e[s+r],(i=e[s])?C(r,i,n,o):n(o);t._subscribers.length=0}}function C(t,r,i,n){var o=e(i),s=void 0,h=void 0,u=!0;if(o){try{s=i(n)}catch(t){u=!1,h=t}if(r===s)return void k(r,new TypeError("A promises callback cannot return that same promise."))}else s=n;r._state!==A||(o&&u?B(r,s):!1===u?k(r,h):1===t?E(r,s):2===t&&k(r,s))}var R=0;function O(t){t[_]=R++,t._state=void 0,t._result=void 0,t._subscribers=[]}var j=function(){function t(t,e){this._instanceConstructor=t,this.promise=new t(S),this.promise[_]||O(this.promise),r(e)?(this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?E(this.promise,this._result):(this.length=this.length||0,this._enumerate(e),0===this._remaining&&E(this.promise,this._result))):k(this.promise,new Error("Array Methods must be provided an Array"))}return t.prototype._enumerate=function(t){for(var e=0;this._state===A&&e<t.length;e++)this._eachEntry(t[e],e)},t.prototype._eachEntry=function(t,e){var r=this._instanceConstructor,i=r.resolve;if(i===b){var n=void 0,o=void 0,s=!1;try{n=t.then}catch(t){s=!0,o=t}if(n===T&&t._state!==A)this._settledAt(t._state,e,t._result);else if("function"!=typeof n)this._remaining--,this._result[e]=t;else if(r===N){var h=new r(S);s?k(h,o):D(h,t,n),this._willSettleAt(h,e)}else this._willSettleAt(new r((function(e){return e(t)})),e)}else this._willSettleAt(i(t),e)},t.prototype._settledAt=function(t,e,r){var i=this.promise;i._state===A&&(this._remaining--,2===t?k(i,r):this._result[e]=r),0===this._remaining&&E(i,this._result)},t.prototype._willSettleAt=function(t,e){var r=this;I(t,void 0,(function(t){return r._settledAt(1,e,t)}),(function(t){return r._settledAt(2,e,t)}))},t}(),N=function(){function t(e){this[_]=R++,this._result=this._state=void 0,this._subscribers=[],S!==e&&("function"!=typeof e&&function(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}(),this instanceof t?function(t,e){try{e((function(e){B(t,e)}),(function(e){k(t,e)}))}catch(e){k(t,e)}}(this,e):function(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}())}return t.prototype.catch=function(t){return this.then(null,t)},t.prototype.finally=function(t){var r=this,i=r.constructor;return e(t)?r.then((function(e){return i.resolve(t()).then((function(){return e}))}),(function(e){return i.resolve(t()).then((function(){throw e}))})):r.then(t,t)},t}();return N.prototype.then=T,N.all=function(t){return new j(this,t).promise},N.race=function(t){var e=this;return r(t)?new e((function(r,i){for(var n=t.length,o=0;o<n;o++)e.resolve(t[o]).then(r,i)})):new e((function(t,e){return e(new TypeError("You must pass an array to race."))}))},N.resolve=b,N.reject=function(t){var e=new this(S);return k(e,t),e},N._setScheduler=function(t){o=t},N._setAsap=function(t){s=t},N._asap=s,N.polyfill=function(){var e=void 0;if(void 0!==t)e=t;else if("undefined"!=typeof self)e=self;else try{e=Function("return this")()}catch(t){throw new Error("polyfill failed because global object is unavailable in this environment")}var r=e.Promise;if(r){var i=null;try{i=Object.prototype.toString.call(r.resolve())}catch(t){}if("[object Promise]"===i&&!r.cast)return}e.Promise=N},N.Promise=N,N}()})),i$1={__proto__:null,default:{}},n=e((function(e,r){var n;e.exports=n=n||function(e,r){var n;if("undefined"!=typeof window&&window.crypto&&(n=window.crypto),"undefined"!=typeof self&&self.crypto&&(n=self.crypto),"undefined"!=typeof globalThis&&globalThis.crypto&&(n=globalThis.crypto),!n&&"undefined"!=typeof window&&window.msCrypto&&(n=window.msCrypto),!n&&void 0!==t&&t.crypto&&(n=t.crypto),!n)try{n=i$1}catch(t){}var o=function(){if(n){if("function"==typeof n.getRandomValues)try{return n.getRandomValues(new Uint32Array(1))[0]}catch(t){}if("function"==typeof n.randomBytes)try{return n.randomBytes(4).readInt32LE()}catch(t){}}throw new Error("Native crypto module could not be used to get secure random number.")},s=Object.create||function(){function t(){}return function(e){var r;return t.prototype=e,r=new t,t.prototype=null,r}}(),h={},u=h.lib={},a=u.Base={extend:function(t){var e=s(this);return t&&e.mixIn(t),e.hasOwnProperty("init")&&this.init!==e.init||(e.init=function(){e.$super.init.apply(this,arguments)}),e.init.prototype=e,e.$super=this,e},create:function(){var t=this.extend();return t.init.apply(t,arguments),t},init:function(){},mixIn:function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e]);t.hasOwnProperty("toString")&&(this.toString=t.toString)},clone:function(){return this.init.prototype.extend(this)}},f=u.WordArray=a.extend({init:function(t,e){t=this.words=t||[],this.sigBytes=null!=e?e:4*t.length},toString:function(t){return(t||p).stringify(this)},concat:function(t){var e=this.words,r=t.words,i=this.sigBytes,n=t.sigBytes;if(this.clamp(),i%4)for(var o=0;o<n;o++)e[i+o>>>2]|=(r[o>>>2]>>>24-o%4*8&255)<<24-(i+o)%4*8;else for(var s=0;s<n;s+=4)e[i+s>>>2]=r[s>>>2];return this.sigBytes+=n,this},clamp:function(){var t=this.words,r=this.sigBytes;t[r>>>2]&=4294967295<<32-r%4*8,t.length=e.ceil(r/4)},clone:function(){var t=a.clone.call(this);return t.words=this.words.slice(0),t},random:function(t){for(var e=[],r=0;r<t;r+=4)e.push(o());return new f.init(e,t)}}),c=h.enc={},p=c.Hex={stringify:function(t){for(var e=t.words,r=t.sigBytes,i=[],n=0;n<r;n++){var o=e[n>>>2]>>>24-n%4*8&255;i.push((o>>>4).toString(16)),i.push((15&o).toString(16))}return i.join("")},parse:function(t){for(var e=t.length,r=[],i=0;i<e;i+=2)r[i>>>3]|=parseInt(t.substr(i,2),16)<<24-i%8*4;return new f.init(r,e/2)}},l=c.Latin1={stringify:function(t){for(var e=t.words,r=t.sigBytes,i=[],n=0;n<r;n++)i.push(String.fromCharCode(e[n>>>2]>>>24-n%4*8&255));return i.join("")},parse:function(t){for(var e=t.length,r=[],i=0;i<e;i++)r[i>>>2]|=(255&t.charCodeAt(i))<<24-i%4*8;return new f.init(r,e)}},d=c.Utf8={stringify:function(t){try{return decodeURIComponent(escape(l.stringify(t)))}catch(t){throw new Error("Malformed UTF-8 data")}},parse:function(t){return l.parse(unescape(encodeURIComponent(t)))}},m=u.BufferedBlockAlgorithm=a.extend({reset:function(){this._data=new f.init,this._nDataBytes=0},_append:function(t){"string"==typeof t&&(t=d.parse(t)),this._data.concat(t),this._nDataBytes+=t.sigBytes},_process:function(t){var r,i=this._data,n=i.words,o=i.sigBytes,s=this.blockSize,h=o/(4*s),u=(h=t?e.ceil(h):e.max((0|h)-this._minBufferSize,0))*s,a=e.min(4*u,o);if(u){for(var c=0;c<u;c+=s)this._doProcessBlock(n,c);r=n.splice(0,u),i.sigBytes-=a}return new f.init(r,a)},clone:function(){var t=a.clone.call(this);return t._data=this._data.clone(),t},_minBufferSize:0});u.Hasher=m.extend({cfg:a.extend(),init:function(t){this.cfg=this.cfg.extend(t),this.reset()},reset:function(){m.reset.call(this),this._doReset()},update:function(t){return this._append(t),this._process(),this},finalize:function(t){return t&&this._append(t),this._doFinalize()},blockSize:16,_createHelper:function(t){return function(e,r){return new t.init(r).finalize(e)}},_createHmacHelper:function(t){return function(e,r){return new v.HMAC.init(t,r).finalize(e)}}});var v=h.algo={};return h}(Math)})),o=e((function(t,e){var r;t.exports=(r=n,function(t){var e=r,i=e.lib,n=i.WordArray,o=i.Hasher,s=e.algo,h=[],u=[];!function(){function e(e){for(var r=t.sqrt(e),i=2;i<=r;i++)if(!(e%i))return!1;return!0}function r(t){return 4294967296*(t-(0|t))|0}for(var i=2,n=0;n<64;)e(i)&&(n<8&&(h[n]=r(t.pow(i,.5))),u[n]=r(t.pow(i,1/3)),n++),i++}();var a=[],f=s.SHA256=o.extend({_doReset:function(){this._hash=new n.init(h.slice(0))},_doProcessBlock:function(t,e){for(var r=this._hash.words,i=r[0],n=r[1],o=r[2],s=r[3],h=r[4],f=r[5],c=r[6],p=r[7],l=0;l<64;l++){if(l<16)a[l]=0|t[e+l];else{var d=a[l-15],m=a[l-2];a[l]=((d<<25|d>>>7)^(d<<14|d>>>18)^d>>>3)+a[l-7]+((m<<15|m>>>17)^(m<<13|m>>>19)^m>>>10)+a[l-16]}var v=i&n^i&o^n&o,y=p+((h<<26|h>>>6)^(h<<21|h>>>11)^(h<<7|h>>>25))+(h&f^~h&c)+u[l]+a[l];p=c,c=f,f=h,h=s+y|0,s=o,o=n,n=i,i=y+(((i<<30|i>>>2)^(i<<19|i>>>13)^(i<<10|i>>>22))+v)|0}r[0]=r[0]+i|0,r[1]=r[1]+n|0,r[2]=r[2]+o|0,r[3]=r[3]+s|0,r[4]=r[4]+h|0,r[5]=r[5]+f|0,r[6]=r[6]+c|0,r[7]=r[7]+p|0},_doFinalize:function(){var e=this._data,r=e.words,i=8*this._nDataBytes,n=8*e.sigBytes;return r[n>>>5]|=128<<24-n%32,r[14+(n+64>>>9<<4)]=t.floor(i/4294967296),r[15+(n+64>>>9<<4)]=i,e.sigBytes=4*r.length,this._process(),this._hash},clone:function(){var t=o.clone.call(this);return t._hash=this._hash.clone(),t}});e.SHA256=o._createHelper(f),e.HmacSHA256=o._createHmacHelper(f)}(Math),r.SHA256)})),s=e((function(t,e){var r,i;t.exports=(i=(r=n).lib.WordArray,r.enc.Base64={stringify:function(t){var e=t.words,r=t.sigBytes,i=this._map;t.clamp();for(var n=[],o=0;o<r;o+=3)for(var s=(e[o>>>2]>>>24-o%4*8&255)<<16|(e[o+1>>>2]>>>24-(o+1)%4*8&255)<<8|e[o+2>>>2]>>>24-(o+2)%4*8&255,h=0;h<4&&o+.75*h<r;h++)n.push(i.charAt(s>>>6*(3-h)&63));var u=i.charAt(64);if(u)for(;n.length%4;)n.push(u);return n.join("")},parse:function(t){var e=t.length,r=this._map,n=this._reverseMap;if(!n){n=this._reverseMap=[];for(var o=0;o<r.length;o++)n[r.charCodeAt(o)]=o}var s=r.charAt(64);if(s){var h=t.indexOf(s);-1!==h&&(e=h)}return function(t,e,r){for(var n=[],o=0,s=0;s<e;s++)if(s%4){var h=r[t.charCodeAt(s-1)]<<s%4*2,u=r[t.charCodeAt(s)]>>>6-s%4*2;n[o>>>2]|=(h|u)<<24-o%4*8,o++}return i.create(n,o)}(t,e,n)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="},r.enc.Base64)})),h=e((function(t,e){t.exports=n.enc.Hex})),u=e((function(e,r){(function(){var t;function r(t,e,r){null!=t&&("number"==typeof t?this.fromNumber(t,e,r):this.fromString(t,null==e&&"string"!=typeof t?256:e))}function i(){return new r(null)}var n="undefined"!=typeof navigator;n&&"Microsoft Internet Explorer"==navigator.appName?(r.prototype.am=function(t,e,r,i,n,o){for(var s=32767&e,h=e>>15;--o>=0;){var u=32767&this[t],a=this[t++]>>15,f=h*u+a*s;n=((u=s*u+((32767&f)<<15)+r[i]+(1073741823&n))>>>30)+(f>>>15)+h*a+(n>>>30),r[i++]=1073741823&u}return n},t=30):n&&"Netscape"!=navigator.appName?(r.prototype.am=function(t,e,r,i,n,o){for(;--o>=0;){var s=e*this[t++]+r[i]+n;n=Math.floor(s/67108864),r[i++]=67108863&s}return n},t=26):(r.prototype.am=function(t,e,r,i,n,o){for(var s=16383&e,h=e>>14;--o>=0;){var u=16383&this[t],a=this[t++]>>14,f=h*u+a*s;n=((u=s*u+((16383&f)<<14)+r[i]+n)>>28)+(f>>14)+h*a,r[i++]=268435455&u}return n},t=28),r.prototype.DB=t,r.prototype.DM=(1<<t)-1,r.prototype.DV=1<<t,r.prototype.FV=Math.pow(2,52),r.prototype.F1=52-t,r.prototype.F2=2*t-52;var o,s,h=new Array;for(o="0".charCodeAt(0),s=0;s<=9;++s)h[o++]=s;for(o="a".charCodeAt(0),s=10;s<36;++s)h[o++]=s;for(o="A".charCodeAt(0),s=10;s<36;++s)h[o++]=s;function u(t){return"0123456789abcdefghijklmnopqrstuvwxyz".charAt(t)}function a(t,e){var r=h[t.charCodeAt(e)];return null==r?-1:r}function f(t){var e=i();return e.fromInt(t),e}function c(t){var e,r=1;return 0!=(e=t>>>16)&&(t=e,r+=16),0!=(e=t>>8)&&(t=e,r+=8),0!=(e=t>>4)&&(t=e,r+=4),0!=(e=t>>2)&&(t=e,r+=2),0!=(e=t>>1)&&(t=e,r+=1),r}function p(t){this.m=t}function l(t){this.m=t,this.mp=t.invDigit(),this.mpl=32767&this.mp,this.mph=this.mp>>15,this.um=(1<<t.DB-15)-1,this.mt2=2*t.t}function d(t,e){return t&e}function m(t,e){return t|e}function v(t,e){return t^e}function y(t,e){return t&~e}function g(t){if(0==t)return-1;var e=0;return 0==(65535&t)&&(t>>=16,e+=16),0==(255&t)&&(t>>=8,e+=8),0==(15&t)&&(t>>=4,e+=4),0==(3&t)&&(t>>=2,e+=2),0==(1&t)&&++e,e}function w(t){for(var e=0;0!=t;)t&=t-1,++e;return e}function T(){}function b(t){return t}function _(t){this.r2=i(),this.q3=i(),r.ONE.dlShiftTo(2*t.t,this.r2),this.mu=this.r2.divide(t),this.m=t}p.prototype.convert=function(t){return t.s<0||t.compareTo(this.m)>=0?t.mod(this.m):t},p.prototype.revert=function(t){return t},p.prototype.reduce=function(t){t.divRemTo(this.m,null,t)},p.prototype.mulTo=function(t,e,r){t.multiplyTo(e,r),this.reduce(r)},p.prototype.sqrTo=function(t,e){t.squareTo(e),this.reduce(e)},l.prototype.convert=function(t){var e=i();return t.abs().dlShiftTo(this.m.t,e),e.divRemTo(this.m,null,e),t.s<0&&e.compareTo(r.ZERO)>0&&this.m.subTo(e,e),e},l.prototype.revert=function(t){var e=i();return t.copyTo(e),this.reduce(e),e},l.prototype.reduce=function(t){for(;t.t<=this.mt2;)t[t.t++]=0;for(var e=0;e<this.m.t;++e){var r=32767&t[e],i=r*this.mpl+((r*this.mph+(t[e]>>15)*this.mpl&this.um)<<15)&t.DM;for(t[r=e+this.m.t]+=this.m.am(0,i,t,e,0,this.m.t);t[r]>=t.DV;)t[r]-=t.DV,t[++r]++}t.clamp(),t.drShiftTo(this.m.t,t),t.compareTo(this.m)>=0&&t.subTo(this.m,t)},l.prototype.mulTo=function(t,e,r){t.multiplyTo(e,r),this.reduce(r)},l.prototype.sqrTo=function(t,e){t.squareTo(e),this.reduce(e)},r.prototype.copyTo=function(t){for(var e=this.t-1;e>=0;--e)t[e]=this[e];t.t=this.t,t.s=this.s},r.prototype.fromInt=function(t){this.t=1,this.s=t<0?-1:0,t>0?this[0]=t:t<-1?this[0]=t+this.DV:this.t=0},r.prototype.fromString=function(t,e){var i;if(16==e)i=4;else if(8==e)i=3;else if(256==e)i=8;else if(2==e)i=1;else if(32==e)i=5;else{if(4!=e)return void this.fromRadix(t,e);i=2}this.t=0,this.s=0;for(var n=t.length,o=!1,s=0;--n>=0;){var h=8==i?255&t[n]:a(t,n);h<0?"-"==t.charAt(n)&&(o=!0):(o=!1,0==s?this[this.t++]=h:s+i>this.DB?(this[this.t-1]|=(h&(1<<this.DB-s)-1)<<s,this[this.t++]=h>>this.DB-s):this[this.t-1]|=h<<s,(s+=i)>=this.DB&&(s-=this.DB))}8==i&&0!=(128&t[0])&&(this.s=-1,s>0&&(this[this.t-1]|=(1<<this.DB-s)-1<<s)),this.clamp(),o&&r.ZERO.subTo(this,this)},r.prototype.clamp=function(){for(var t=this.s&this.DM;this.t>0&&this[this.t-1]==t;)--this.t},r.prototype.dlShiftTo=function(t,e){var r;for(r=this.t-1;r>=0;--r)e[r+t]=this[r];for(r=t-1;r>=0;--r)e[r]=0;e.t=this.t+t,e.s=this.s},r.prototype.drShiftTo=function(t,e){for(var r=t;r<this.t;++r)e[r-t]=this[r];e.t=Math.max(this.t-t,0),e.s=this.s},r.prototype.lShiftTo=function(t,e){var r,i=t%this.DB,n=this.DB-i,o=(1<<n)-1,s=Math.floor(t/this.DB),h=this.s<<i&this.DM;for(r=this.t-1;r>=0;--r)e[r+s+1]=this[r]>>n|h,h=(this[r]&o)<<i;for(r=s-1;r>=0;--r)e[r]=0;e[s]=h,e.t=this.t+s+1,e.s=this.s,e.clamp()},r.prototype.rShiftTo=function(t,e){e.s=this.s;var r=Math.floor(t/this.DB);if(r>=this.t)e.t=0;else{var i=t%this.DB,n=this.DB-i,o=(1<<i)-1;e[0]=this[r]>>i;for(var s=r+1;s<this.t;++s)e[s-r-1]|=(this[s]&o)<<n,e[s-r]=this[s]>>i;i>0&&(e[this.t-r-1]|=(this.s&o)<<n),e.t=this.t-r,e.clamp()}},r.prototype.subTo=function(t,e){for(var r=0,i=0,n=Math.min(t.t,this.t);r<n;)i+=this[r]-t[r],e[r++]=i&this.DM,i>>=this.DB;if(t.t<this.t){for(i-=t.s;r<this.t;)i+=this[r],e[r++]=i&this.DM,i>>=this.DB;i+=this.s}else{for(i+=this.s;r<t.t;)i-=t[r],e[r++]=i&this.DM,i>>=this.DB;i-=t.s}e.s=i<0?-1:0,i<-1?e[r++]=this.DV+i:i>0&&(e[r++]=i),e.t=r,e.clamp()},r.prototype.multiplyTo=function(t,e){var i=this.abs(),n=t.abs(),o=i.t;for(e.t=o+n.t;--o>=0;)e[o]=0;for(o=0;o<n.t;++o)e[o+i.t]=i.am(0,n[o],e,o,0,i.t);e.s=0,e.clamp(),this.s!=t.s&&r.ZERO.subTo(e,e)},r.prototype.squareTo=function(t){for(var e=this.abs(),r=t.t=2*e.t;--r>=0;)t[r]=0;for(r=0;r<e.t-1;++r){var i=e.am(r,e[r],t,2*r,0,1);(t[r+e.t]+=e.am(r+1,2*e[r],t,2*r+1,i,e.t-r-1))>=e.DV&&(t[r+e.t]-=e.DV,t[r+e.t+1]=1)}t.t>0&&(t[t.t-1]+=e.am(r,e[r],t,2*r,0,1)),t.s=0,t.clamp()},r.prototype.divRemTo=function(t,e,n){var o=t.abs();if(!(o.t<=0)){var s=this.abs();if(s.t<o.t)return null!=e&&e.fromInt(0),void(null!=n&&this.copyTo(n));null==n&&(n=i());var h=i(),u=this.s,a=t.s,f=this.DB-c(o[o.t-1]);f>0?(o.lShiftTo(f,h),s.lShiftTo(f,n)):(o.copyTo(h),s.copyTo(n));var p=h.t,l=h[p-1];if(0!=l){var d=l*(1<<this.F1)+(p>1?h[p-2]>>this.F2:0),m=this.FV/d,v=(1<<this.F1)/d,y=1<<this.F2,g=n.t,w=g-p,T=null==e?i():e;for(h.dlShiftTo(w,T),n.compareTo(T)>=0&&(n[n.t++]=1,n.subTo(T,n)),r.ONE.dlShiftTo(p,T),T.subTo(h,h);h.t<p;)h[h.t++]=0;for(;--w>=0;){var b=n[--g]==l?this.DM:Math.floor(n[g]*m+(n[g-1]+y)*v);if((n[g]+=h.am(0,b,n,w,0,p))<b)for(h.dlShiftTo(w,T),n.subTo(T,n);n[g]<--b;)n.subTo(T,n)}null!=e&&(n.drShiftTo(p,e),u!=a&&r.ZERO.subTo(e,e)),n.t=p,n.clamp(),f>0&&n.rShiftTo(f,n),u<0&&r.ZERO.subTo(n,n)}}},r.prototype.invDigit=function(){if(this.t<1)return 0;var t=this[0];if(0==(1&t))return 0;var e=3&t;return(e=(e=(e=(e=e*(2-(15&t)*e)&15)*(2-(255&t)*e)&255)*(2-((65535&t)*e&65535))&65535)*(2-t*e%this.DV)%this.DV)>0?this.DV-e:-e},r.prototype.isEven=function(){return 0==(this.t>0?1&this[0]:this.s)},r.prototype.exp=function(t,e){if(t>4294967295||t<1)return r.ONE;var n=i(),o=i(),s=e.convert(this),h=c(t)-1;for(s.copyTo(n);--h>=0;)if(e.sqrTo(n,o),(t&1<<h)>0)e.mulTo(o,s,n);else{var u=n;n=o,o=u}return e.revert(n)},r.prototype.toString=function(t){if(this.s<0)return"-"+this.negate().toString(t);var e;if(16==t)e=4;else if(8==t)e=3;else if(2==t)e=1;else if(32==t)e=5;else{if(4!=t)return this.toRadix(t);e=2}var r,i=(1<<e)-1,n=!1,o="",s=this.t,h=this.DB-s*this.DB%e;if(s-- >0)for(h<this.DB&&(r=this[s]>>h)>0&&(n=!0,o=u(r));s>=0;)h<e?(r=(this[s]&(1<<h)-1)<<e-h,r|=this[--s]>>(h+=this.DB-e)):(r=this[s]>>(h-=e)&i,h<=0&&(h+=this.DB,--s)),r>0&&(n=!0),n&&(o+=u(r));return n?o:"0"},r.prototype.negate=function(){var t=i();return r.ZERO.subTo(this,t),t},r.prototype.abs=function(){return this.s<0?this.negate():this},r.prototype.compareTo=function(t){var e=this.s-t.s;if(0!=e)return e;var r=this.t;if(0!=(e=r-t.t))return this.s<0?-e:e;for(;--r>=0;)if(0!=(e=this[r]-t[r]))return e;return 0},r.prototype.bitLength=function(){return this.t<=0?0:this.DB*(this.t-1)+c(this[this.t-1]^this.s&this.DM)},r.prototype.mod=function(t){var e=i();return this.abs().divRemTo(t,null,e),this.s<0&&e.compareTo(r.ZERO)>0&&t.subTo(e,e),e},r.prototype.modPowInt=function(t,e){var r;return r=t<256||e.isEven()?new p(e):new l(e),this.exp(t,r)},r.ZERO=f(0),r.ONE=f(1),T.prototype.convert=b,T.prototype.revert=b,T.prototype.mulTo=function(t,e,r){t.multiplyTo(e,r)},T.prototype.sqrTo=function(t,e){t.squareTo(e)},_.prototype.convert=function(t){if(t.s<0||t.t>2*this.m.t)return t.mod(this.m);if(t.compareTo(this.m)<0)return t;var e=i();return t.copyTo(e),this.reduce(e),e},_.prototype.revert=function(t){return t},_.prototype.reduce=function(t){for(t.drShiftTo(this.m.t-1,this.r2),t.t>this.m.t+1&&(t.t=this.m.t+1,t.clamp()),this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3),this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);t.compareTo(this.r2)<0;)t.dAddOffset(1,this.m.t+1);for(t.subTo(this.r2,t);t.compareTo(this.m)>=0;)t.subTo(this.m,t)},_.prototype.mulTo=function(t,e,r){t.multiplyTo(e,r),this.reduce(r)},_.prototype.sqrTo=function(t,e){t.squareTo(e),this.reduce(e)};var S,A,D,B=[2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997],x=(1<<26)/B[B.length-1];function E(){var t;t=(new Date).getTime(),A[D++]^=255&t,A[D++]^=t>>8&255,A[D++]^=t>>16&255,A[D++]^=t>>24&255,D>=j&&(D-=j)}if(r.prototype.chunkSize=function(t){return Math.floor(Math.LN2*this.DB/Math.log(t))},r.prototype.toRadix=function(t){if(null==t&&(t=10),0==this.signum()||t<2||t>36)return"0";var e=this.chunkSize(t),r=Math.pow(t,e),n=f(r),o=i(),s=i(),h="";for(this.divRemTo(n,o,s);o.signum()>0;)h=(r+s.intValue()).toString(t).substr(1)+h,o.divRemTo(n,o,s);return s.intValue().toString(t)+h},r.prototype.fromRadix=function(t,e){this.fromInt(0),null==e&&(e=10);for(var i=this.chunkSize(e),n=Math.pow(e,i),o=!1,s=0,h=0,u=0;u<t.length;++u){var f=a(t,u);f<0?"-"==t.charAt(u)&&0==this.signum()&&(o=!0):(h=e*h+f,++s>=i&&(this.dMultiply(n),this.dAddOffset(h,0),s=0,h=0))}s>0&&(this.dMultiply(Math.pow(e,s)),this.dAddOffset(h,0)),o&&r.ZERO.subTo(this,this)},r.prototype.fromNumber=function(t,e,i){if("number"==typeof e)if(t<2)this.fromInt(1);else for(this.fromNumber(t,i),this.testBit(t-1)||this.bitwiseTo(r.ONE.shiftLeft(t-1),m,this),this.isEven()&&this.dAddOffset(1,0);!this.isProbablePrime(e);)this.dAddOffset(2,0),this.bitLength()>t&&this.subTo(r.ONE.shiftLeft(t-1),this);else{var n=new Array,o=7&t;n.length=1+(t>>3),e.nextBytes(n),o>0?n[0]&=(1<<o)-1:n[0]=0,this.fromString(n,256)}},r.prototype.bitwiseTo=function(t,e,r){var i,n,o=Math.min(t.t,this.t);for(i=0;i<o;++i)r[i]=e(this[i],t[i]);if(t.t<this.t){for(n=t.s&this.DM,i=o;i<this.t;++i)r[i]=e(this[i],n);r.t=this.t}else{for(n=this.s&this.DM,i=o;i<t.t;++i)r[i]=e(n,t[i]);r.t=t.t}r.s=e(this.s,t.s),r.clamp()},r.prototype.changeBit=function(t,e){var i=r.ONE.shiftLeft(t);return this.bitwiseTo(i,e,i),i},r.prototype.addTo=function(t,e){for(var r=0,i=0,n=Math.min(t.t,this.t);r<n;)i+=this[r]+t[r],e[r++]=i&this.DM,i>>=this.DB;if(t.t<this.t){for(i+=t.s;r<this.t;)i+=this[r],e[r++]=i&this.DM,i>>=this.DB;i+=this.s}else{for(i+=this.s;r<t.t;)i+=t[r],e[r++]=i&this.DM,i>>=this.DB;i+=t.s}e.s=i<0?-1:0,i>0?e[r++]=i:i<-1&&(e[r++]=this.DV+i),e.t=r,e.clamp()},r.prototype.dMultiply=function(t){this[this.t]=this.am(0,t-1,this,0,0,this.t),++this.t,this.clamp()},r.prototype.dAddOffset=function(t,e){if(0!=t){for(;this.t<=e;)this[this.t++]=0;for(this[e]+=t;this[e]>=this.DV;)this[e]-=this.DV,++e>=this.t&&(this[this.t++]=0),++this[e]}},r.prototype.multiplyLowerTo=function(t,e,r){var i,n=Math.min(this.t+t.t,e);for(r.s=0,r.t=n;n>0;)r[--n]=0;for(i=r.t-this.t;n<i;++n)r[n+this.t]=this.am(0,t[n],r,n,0,this.t);for(i=Math.min(t.t,e);n<i;++n)this.am(0,t[n],r,n,0,e-n);r.clamp()},r.prototype.multiplyUpperTo=function(t,e,r){--e;var i=r.t=this.t+t.t-e;for(r.s=0;--i>=0;)r[i]=0;for(i=Math.max(e-this.t,0);i<t.t;++i)r[this.t+i-e]=this.am(e-i,t[i],r,0,0,this.t+i-e);r.clamp(),r.drShiftTo(1,r)},r.prototype.modInt=function(t){if(t<=0)return 0;var e=this.DV%t,r=this.s<0?t-1:0;if(this.t>0)if(0==e)r=this[0]%t;else for(var i=this.t-1;i>=0;--i)r=(e*r+this[i])%t;return r},r.prototype.millerRabin=function(t){var e=this.subtract(r.ONE),n=e.getLowestSetBit();if(n<=0)return!1;var o=e.shiftRight(n);(t=t+1>>1)>B.length&&(t=B.length);for(var s=i(),h=0;h<t;++h){s.fromInt(B[Math.floor(Math.random()*B.length)]);var u=s.modPow(o,this);if(0!=u.compareTo(r.ONE)&&0!=u.compareTo(e)){for(var a=1;a++<n&&0!=u.compareTo(e);)if(0==(u=u.modPowInt(2,this)).compareTo(r.ONE))return!1;if(0!=u.compareTo(e))return!1}}return!0},r.prototype.clone=function(){var t=i();return this.copyTo(t),t},r.prototype.intValue=function(){if(this.s<0){if(1==this.t)return this[0]-this.DV;if(0==this.t)return-1}else{if(1==this.t)return this[0];if(0==this.t)return 0}return(this[1]&(1<<32-this.DB)-1)<<this.DB|this[0]},r.prototype.byteValue=function(){return 0==this.t?this.s:this[0]<<24>>24},r.prototype.shortValue=function(){return 0==this.t?this.s:this[0]<<16>>16},r.prototype.signum=function(){return this.s<0?-1:this.t<=0||1==this.t&&this[0]<=0?0:1},r.prototype.toByteArray=function(){var t=this.t,e=new Array;e[0]=this.s;var r,i=this.DB-t*this.DB%8,n=0;if(t-- >0)for(i<this.DB&&(r=this[t]>>i)!=(this.s&this.DM)>>i&&(e[n++]=r|this.s<<this.DB-i);t>=0;)i<8?(r=(this[t]&(1<<i)-1)<<8-i,r|=this[--t]>>(i+=this.DB-8)):(r=this[t]>>(i-=8)&255,i<=0&&(i+=this.DB,--t)),0!=(128&r)&&(r|=-256),0==n&&(128&this.s)!=(128&r)&&++n,(n>0||r!=this.s)&&(e[n++]=r);return e},r.prototype.equals=function(t){return 0==this.compareTo(t)},r.prototype.min=function(t){return this.compareTo(t)<0?this:t},r.prototype.max=function(t){return this.compareTo(t)>0?this:t},r.prototype.and=function(t){var e=i();return this.bitwiseTo(t,d,e),e},r.prototype.or=function(t){var e=i();return this.bitwiseTo(t,m,e),e},r.prototype.xor=function(t){var e=i();return this.bitwiseTo(t,v,e),e},r.prototype.andNot=function(t){var e=i();return this.bitwiseTo(t,y,e),e},r.prototype.not=function(){for(var t=i(),e=0;e<this.t;++e)t[e]=this.DM&~this[e];return t.t=this.t,t.s=~this.s,t},r.prototype.shiftLeft=function(t){var e=i();return t<0?this.rShiftTo(-t,e):this.lShiftTo(t,e),e},r.prototype.shiftRight=function(t){var e=i();return t<0?this.lShiftTo(-t,e):this.rShiftTo(t,e),e},r.prototype.getLowestSetBit=function(){for(var t=0;t<this.t;++t)if(0!=this[t])return t*this.DB+g(this[t]);return this.s<0?this.t*this.DB:-1},r.prototype.bitCount=function(){for(var t=0,e=this.s&this.DM,r=0;r<this.t;++r)t+=w(this[r]^e);return t},r.prototype.testBit=function(t){var e=Math.floor(t/this.DB);return e>=this.t?0!=this.s:0!=(this[e]&1<<t%this.DB)},r.prototype.setBit=function(t){return this.changeBit(t,m)},r.prototype.clearBit=function(t){return this.changeBit(t,y)},r.prototype.flipBit=function(t){return this.changeBit(t,v)},r.prototype.add=function(t){var e=i();return this.addTo(t,e),e},r.prototype.subtract=function(t){var e=i();return this.subTo(t,e),e},r.prototype.multiply=function(t){var e=i();return this.multiplyTo(t,e),e},r.prototype.divide=function(t){var e=i();return this.divRemTo(t,e,null),e},r.prototype.remainder=function(t){var e=i();return this.divRemTo(t,null,e),e},r.prototype.divideAndRemainder=function(t){var e=i(),r=i();return this.divRemTo(t,e,r),new Array(e,r)},r.prototype.modPow=function(t,e){var r,n,o=t.bitLength(),s=f(1);if(o<=0)return s;r=o<18?1:o<48?3:o<144?4:o<768?5:6,n=o<8?new p(e):e.isEven()?new _(e):new l(e);var h=new Array,u=3,a=r-1,d=(1<<r)-1;if(h[1]=n.convert(this),r>1){var m=i();for(n.sqrTo(h[1],m);u<=d;)h[u]=i(),n.mulTo(m,h[u-2],h[u]),u+=2}var v,y,g=t.t-1,w=!0,T=i();for(o=c(t[g])-1;g>=0;){for(o>=a?v=t[g]>>o-a&d:(v=(t[g]&(1<<o+1)-1)<<a-o,g>0&&(v|=t[g-1]>>this.DB+o-a)),u=r;0==(1&v);)v>>=1,--u;if((o-=u)<0&&(o+=this.DB,--g),w)h[v].copyTo(s),w=!1;else{for(;u>1;)n.sqrTo(s,T),n.sqrTo(T,s),u-=2;u>0?n.sqrTo(s,T):(y=s,s=T,T=y),n.mulTo(T,h[v],s)}for(;g>=0&&0==(t[g]&1<<o);)n.sqrTo(s,T),y=s,s=T,T=y,--o<0&&(o=this.DB-1,--g)}return n.revert(s)},r.prototype.modInverse=function(t){var e=t.isEven();if(this.isEven()&&e||0==t.signum())return r.ZERO;for(var i=t.clone(),n=this.clone(),o=f(1),s=f(0),h=f(0),u=f(1);0!=i.signum();){for(;i.isEven();)i.rShiftTo(1,i),e?(o.isEven()&&s.isEven()||(o.addTo(this,o),s.subTo(t,s)),o.rShiftTo(1,o)):s.isEven()||s.subTo(t,s),s.rShiftTo(1,s);for(;n.isEven();)n.rShiftTo(1,n),e?(h.isEven()&&u.isEven()||(h.addTo(this,h),u.subTo(t,u)),h.rShiftTo(1,h)):u.isEven()||u.subTo(t,u),u.rShiftTo(1,u);i.compareTo(n)>=0?(i.subTo(n,i),e&&o.subTo(h,o),s.subTo(u,s)):(n.subTo(i,n),e&&h.subTo(o,h),u.subTo(s,u))}return 0!=n.compareTo(r.ONE)?r.ZERO:u.compareTo(t)>=0?u.subtract(t):u.signum()<0?(u.addTo(t,u),u.signum()<0?u.add(t):u):u},r.prototype.pow=function(t){return this.exp(t,new T)},r.prototype.gcd=function(t){var e=this.s<0?this.negate():this.clone(),r=t.s<0?t.negate():t.clone();if(e.compareTo(r)<0){var i=e;e=r,r=i}var n=e.getLowestSetBit(),o=r.getLowestSetBit();if(o<0)return e;for(n<o&&(o=n),o>0&&(e.rShiftTo(o,e),r.rShiftTo(o,r));e.signum()>0;)(n=e.getLowestSetBit())>0&&e.rShiftTo(n,e),(n=r.getLowestSetBit())>0&&r.rShiftTo(n,r),e.compareTo(r)>=0?(e.subTo(r,e),e.rShiftTo(1,e)):(r.subTo(e,r),r.rShiftTo(1,r));return o>0&&r.lShiftTo(o,r),r},r.prototype.isProbablePrime=function(t){var e,r=this.abs();if(1==r.t&&r[0]<=B[B.length-1]){for(e=0;e<B.length;++e)if(r[0]==B[e])return!0;return!1}if(r.isEven())return!1;for(e=1;e<B.length;){for(var i=B[e],n=e+1;n<B.length&&i<x;)i*=B[n++];for(i=r.modInt(i);e<n;)if(i%B[e++]==0)return!1}return r.millerRabin(t)},r.prototype.square=function(){var t=i();return this.squareTo(t),t},r.prototype.Barrett=_,null==A){var k;if(A=new Array,D=0,"undefined"!=typeof window&&window.crypto)if(window.crypto.getRandomValues){var I=new Uint8Array(32);for(window.crypto.getRandomValues(I),k=0;k<32;++k)A[D++]=I[k]}else if("Netscape"==navigator.appName&&navigator.appVersion<"5"){var M=window.crypto.random(32);for(k=0;k<M.length;++k)A[D++]=255&M.charCodeAt(k)}for(;D<j;)k=Math.floor(65536*Math.random()),A[D++]=k>>>8,A[D++]=255&k;D=0,E()}function C(){if(null==S){for(E(),(S=new O).init(A),D=0;D<A.length;++D)A[D]=0;D=0}return S.next()}function R(){}function O(){this.i=0,this.j=0,this.S=new Array}R.prototype.nextBytes=function(t){var e;for(e=0;e<t.length;++e)t[e]=C()},O.prototype.init=function(t){var e,r,i;for(e=0;e<256;++e)this.S[e]=e;for(r=0,e=0;e<256;++e)i=this.S[e],this.S[e]=this.S[r=r+this.S[e]+t[e%t.length]&255],this.S[r]=i;this.i=0,this.j=0},O.prototype.next=function(){var t;return this.i=this.i+1&255,this.j=this.j+this.S[this.i]&255,t=this.S[this.i],this.S[this.i]=this.S[this.j],this.S[this.j]=t,this.S[t+this.S[this.i]&255]};var j=256;e.exports={default:r,BigInteger:r,SecureRandom:R}}).call(t)})),a={sha1:"3021300906052b0e03021a05000414",sha224:"302d300d06096086480165030402040500041c",sha256:"3031300d060960864801650304020105000420",sha384:"3041300d060960864801650304020205000430",sha512:"3051300d060960864801650304020305000440",md2:"3020300c06082a864886f70d020205000410",md5:"3020300c06082a864886f70d020505000410",ripemd160:"3021300906052b2403020105000414"},f={sha256:o};function c(t,e){if(this.n=null,this.e=0,!(null!=t&&null!=e&&t.length>0&&e.length>0))throw new Error("Invalid key data");this.n=new u.BigInteger(t,16),this.e=parseInt(e,16)}c.prototype.verify=function(t,e){e=e.replace(/[^0-9a-f]|[\s\n]]/gi,"");var r=new u.BigInteger(e,16);if(r.bitLength()>this.n.bitLength())throw new Error("Signature does not match with the key modulus.");var i=function(t){for(var e in a){var r=a[e],i=r.length;if(t.substring(0,i)===r)return{alg:e,hash:t.substring(i)}}return[]}(r.modPowInt(this.e,this.n).toString(16).replace(/^1f+00/,""));if(0===i.length)return!1;if(!f.hasOwnProperty(i.alg))throw new Error("Hashing algorithm is not supported.");var n=f[i.alg](t).toString();return i.hash===n};for(var p=[],l=[],d="undefined"!=typeof Uint8Array?Uint8Array:Array,m="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",v=0,y=m.length;v<y;++v)p[v]=m[v],l[m.charCodeAt(v)]=v;l["-".charCodeAt(0)]=62,l["_".charCodeAt(0)]=63;var g=function(t){var e,r,i=function(t){var e=t.length;if(e%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var r=t.indexOf("=");return-1===r&&(r=e),[r,r===e?0:4-r%4]}(t),n=i[0],o=i[1],s=new d(function(t,e,r){return 3*(e+r)/4-r}(0,n,o)),h=0,u=o>0?n-4:n;for(r=0;r<u;r+=4)e=l[t.charCodeAt(r)]<<18|l[t.charCodeAt(r+1)]<<12|l[t.charCodeAt(r+2)]<<6|l[t.charCodeAt(r+3)],s[h++]=e>>16&255,s[h++]=e>>8&255,s[h++]=255&e;return 2===o&&(e=l[t.charCodeAt(r)]<<2|l[t.charCodeAt(r+1)]>>4,s[h++]=255&e),1===o&&(e=l[t.charCodeAt(r)]<<10|l[t.charCodeAt(r+1)]<<4|l[t.charCodeAt(r+2)]>>2,s[h++]=e>>8&255,s[h++]=255&e),s};function w(t){var e=t.length%4;return 0===e?t:t+new Array(4-e+1).join("=")}function T(t){return t=w(t).replace(/\-/g,"+").replace(/_/g,"/"),decodeURIComponent(function(t){for(var e="",r=0;r<t.length;r++)e+=String.fromCharCode(t[r]);return e}(g(t)).split("").map((function(t){return"%"+("00"+t.charCodeAt(0).toString(16)).slice(-2)})).join(""))}function b(t){return function(t){for(var e="",r=0;r<t.length;r++){var i=t[r].toString(16);e+=2===i.length?i:"0"+i}return e}(g(w(t)))}var _=e((function(e){var r,i;r=t,i=function(){function t(t){var e=[];if(0===t.length)return"";if("string"!=typeof t[0])throw new TypeError("Url must be a string. Received "+t[0]);if(t[0].match(/^[^/:]+:\/*$/)&&t.length>1){var r=t.shift();t[0]=r+t[0]}t[0]=t[0].match(/^file:\/\/\//)?t[0].replace(/^([^/:]+):\/*/,"$1:///"):t[0].replace(/^([^/:]+):\/*/,"$1://");for(var i=0;i<t.length;i++){var n=t[i];if("string"!=typeof n)throw new TypeError("Url must be a string. Received "+n);""!==n&&(i>0&&(n=n.replace(/^[\/]+/,"")),n=n.replace(/[\/]+$/,i<t.length-1?"":"/"),e.push(n))}var o=e.join("/"),s=(o=o.replace(/\/(\?|&|#[^!])/g,"$1")).split("?");return s.shift()+(s.length>0?"?":"")+s.join("&")}return function(){return t("object"==typeof arguments[0]?arguments[0]:[].slice.call(arguments))}},e.exports?e.exports=i():r.urljoin=i()}));function S(t,e){return e=e||{},new Promise((function(r,i){var n=new XMLHttpRequest,o=[],s=[],h={},u=function(){return{ok:2==(n.status/100|0),statusText:n.statusText,status:n.status,url:n.responseURL,text:function(){return Promise.resolve(n.responseText)},json:function(){return Promise.resolve(n.responseText).then(JSON.parse)},blob:function(){return Promise.resolve(new Blob([n.response]))},clone:u,headers:{keys:function(){return o},entries:function(){return s},get:function(t){return h[t.toLowerCase()]},has:function(t){return t.toLowerCase()in h}}}};for(var a in n.open(e.method||"get",t,!0),n.onload=function(){n.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,(function(t,e,r){o.push(e=e.toLowerCase()),s.push([e,r]),h[e]=h[e]?h[e]+","+r:r})),r(u())},n.onerror=i,n.withCredentials="include"==e.credentials,e.headers)n.setRequestHeader(a,e.headers[a]);n.send(e.body||null)}))}function A(t){if(t.ok)return t.json();var e=new Error(t.statusText);return e.response=t,Promise.reject(e)}function D(t){this.name="ConfigurationError",this.message=t||""}function B(t){this.name="TokenValidationError",this.message=t||""}D.prototype=Error.prototype,B.prototype=Error.prototype;var x=function(){function t(){}var e=t.prototype;return e.get=function(){return null},e.has=function(){return null},e.set=function(){return null},t}();r.polyfill();var E="RS256",k=function(t){return"number"==typeof t},I=function(){return new Date};function M(t){var e=t||{};if(this.jwksCache=e.jwksCache||new x,this.expectedAlg=e.expectedAlg||"RS256",this.issuer=e.issuer,this.audience=e.audience,this.leeway=0===e.leeway?0:e.leeway||60,this.jwksURI=e.jwksURI,this.maxAge=e.maxAge,this.__clock="function"==typeof e.__clock?e.__clock:I,this.leeway<0||this.leeway>300)throw new D("The leeway should be positive and lower than five minutes.");if(E!==this.expectedAlg)throw new D('Signature algorithm of "'+this.expectedAlg+'" is not supported. Expected the ID token to be signed with "'+E+'".')}function PluginHandler(webAuth,plugins){this.plugins=plugins;for(var a=0;a<this.plugins.length;a++){if(this.plugins[a].version!==version.raw){var pluginName="";throw this.plugins[a].constructor&&this.plugins[a].constructor.name&&(pluginName=this.plugins[a].constructor.name),new Error("Plugin "+pluginName+" version ("+this.plugins[a].version+") is not compatible with the SDK version ("+version.raw+")")}this.plugins[a].setWebAuth(webAuth)}}M.prototype.verify=function(t,e,r){if(!r&&e&&"function"==typeof e&&(r=e,e=void 0),!t)return r(new B("ID token is required but missing"),null);var i=this.decode(t);if(i instanceof Error)return r(new B("ID token could not be decoded"),null);var n=i.encoded.header+"."+i.encoded.payload,o=b(i.encoded.signature),s=i.header.alg,h=i.header.kid,u=i.payload.aud,a=i.payload.sub,f=i.payload.iss,c=i.payload.exp,p=i.payload.nbf,l=i.payload.iat,d=i.payload.azp,m=i.payload.auth_time,v=i.payload.nonce,y=this.__clock(),g=this;if(g.expectedAlg!==s)return r(new B('Signature algorithm of "'+s+'" is not supported. Expected the ID token to be signed with "'+E+'".'),null);this.getRsaVerifier(f,h,(function(t,s){if(t)return r(t,null);if(!s.verify(n,o))return r(new B("Invalid ID token signature."),null);if(!f||"string"!=typeof f)return r(new B("Issuer (iss) claim must be a string present in the ID token"),null);if(g.issuer!==f)return r(new B('Issuer (iss) claim mismatch in the ID token, expected "'+g.issuer+'", found "'+f+'"'),null);if(!a||"string"!=typeof a)return r(new B("Subject (sub) claim must be a string present in the ID token"),null);if(!u||"string"!=typeof u&&!Array.isArray(u))return r(new B("Audience (aud) claim must be a string or array of strings present in the ID token"),null);if(Array.isArray(u)&&!u.includes(g.audience))return r(new B('Audience (aud) claim mismatch in the ID token; expected "'+g.audience+'" but was not one of "'+u.join(", ")+'"'),null);if("string"==typeof u&&g.audience!==u)return r(new B('Audience (aud) claim mismatch in the ID token; expected "'+g.audience+'" but found "'+u+'"'),null);if(e){if(!v||"string"!=typeof v)return r(new B("Nonce (nonce) claim must be a string present in the ID token"),null);if(v!==e)return r(new B('Nonce (nonce) claim value mismatch in the ID token; expected "'+e+'", found "'+v+'"'),null)}if(Array.isArray(u)&&u.length>1){if(!d||"string"!=typeof d)return r(new B("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values"),null);if(d!==g.audience)return r(new B('Authorized Party (azp) claim mismatch in the ID token; expected "'+g.audience+'", found "'+d+'"'),null)}if(!c||!k(c))return r(new B("Expiration Time (exp) claim must be a number present in the ID token"),null);if(!l||!k(l))return r(new B("Issued At (iat) claim must be a number present in the ID token"),null);var h=c+g.leeway,w=new Date(0);if(w.setUTCSeconds(h),y>w)return r(new B('Expiration Time (exp) claim error in the ID token; current time "'+y+'" is after expiration time "'+w+'"'),null);if(p&&k(p)){var T=p-g.leeway,b=new Date(0);if(b.setUTCSeconds(T),y<b)return r(new B('Not Before Time (nbf) claim error in the ID token; current time "'+y+'" is before the not before time "'+b+'"'),null)}if(g.maxAge){if(!m||!k(m))return r(new B("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified"),null);var _=m+g.maxAge+g.leeway,S=new Date(0);if(S.setUTCSeconds(_),y>S)return r(new B('Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time "'+y+'" is after last auth time at "'+S+'"'),null)}return r(null,i.payload)}))},M.prototype.getRsaVerifier=function(t,e,r){var i=this,n=t+e;Promise.resolve(this.jwksCache.has(n)).then((function(r){return r?i.jwksCache.get(n):(o={jwksURI:i.jwksURI,iss:t,kid:e},("undefined"==typeof fetch?S:fetch)(o.jwksURI||_(o.iss,".well-known","jwks.json")).then(A).then((function(t){var e,r,i,n=null;for(e=0;e<t.keys.length&&null===n;e++)(r=t.keys[e]).kid===o.kid&&(n=r);if(!n)throw new Error('Could not find a public key for Key ID (kid) "'+o.kid+'"');return{modulus:b((i=n).n),exp:b(i.e)}})).catch((function(t){throw t})));var o})).then((function(t){if(!t||!t.modulus||!t.exp)throw new Error("Empty keyInfo in response");return Promise.resolve(i.jwksCache.set(n,t)).then((function(){r&&r(null,new c(t.modulus,t.exp))}))})).catch((function(t){r&&r(t)}))},M.prototype.decode=function(t){var e,r,i=t.split(".");if(3!==i.length)return new B("Cannot decode a malformed JWT");try{e=JSON.parse(T(i[0])),r=JSON.parse(T(i[1]))}catch(t){return new B("Token header or payload is not valid JSON")}return{header:e,payload:r,encoded:{header:i[0],payload:i[1],signature:i[2]}}},M.prototype.validateAccessToken=function(t,e,r,i){if(this.expectedAlg!==e)return i(new B('Signature algorithm of "'+e+'" is not supported. Expected "'+this.expectedAlg+'"'));var n,u=o(t),a=h.stringify(u),f=a.substring(0,a.length/2),c=h.parse(f),p=s.stringify(c);return i((n={"+":"-","/":"_","=":""},p.replace(/[+/=]/g,(function(t){return n[t]}))!==r?new B("Invalid access_token"):null))},PluginHandler.prototype.get=function(extensibilityPoint){for(var a=0;a<this.plugins.length;a++)if(this.plugins[a].supports(extensibilityPoint))return this.plugins[a].init();return null};var random={randomString:function(length){var bytes=new Uint8Array(length),result=[],charset="0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~",cryptoObj=windowHelper.getWindow().crypto||windowHelper.getWindow().msCrypto;if(!cryptoObj)return null;for(var random=cryptoObj.getRandomValues(bytes),a=0;a<random.length;a++)result.push(charset[random[a]%charset.length]);return result.join("")}};function TransactionManager(options){var transaction=options.transaction||{};this.namespace=transaction.namespace||"com.auth0.auth.",this.keyLength=transaction.keyLength||32,this.stateExpiration=options.stateExpiration?options.stateExpiration/60/24:1/48,this.storage=new Storage(options),this.options=options}function IframeHandler(options){if(this.url=options.url,this.callback=options.callback,this.timeout=options.timeout||6e4,this.timeoutCallback=options.timeoutCallback||null,this.eventListenerType=options.eventListenerType||"message",this.iframe=null,this.timeoutHandle=null,this._destroyTimeout=null,this.transientMessageEventListener=null,this.proxyEventListener=null,this.eventValidator=options.eventValidator||{isValid:function(){return!0}},"function"!=typeof this.callback)throw new Error("options.callback must be a function")}function WebMessageHandler(webAuth){this.webAuth=webAuth,this.warn=new Warn(webAuth.baseOptions)}function CrossOriginAuthentication(webAuth,options){this.webAuth=webAuth,this.baseOptions=options,this.request=new RequestBuilder(options),this.webMessageHandler=new WebMessageHandler(webAuth),this.storage=new Storage(options)}function createKey(origin,coId){return["co/verifier",encodeURIComponent(origin),encodeURIComponent(coId)].join("/")}function Redirect(auth0,options){this.webAuth=auth0,this.baseOptions=options,this.crossOriginAuthentication=new CrossOriginAuthentication(auth0,this.baseOptions),this.warn=new Warn({disableWarnings:!!options._disableDeprecationWarnings})}TransactionManager.prototype.process=function(options){if(!options.responseType)throw new Error("responseType is required");var lastUsedConnection=options.realm||options.connection,responseTypeIncludesIdToken=-1!==options.responseType.indexOf("id_token"),transaction=this.generateTransaction(options.appState,options.state,options.nonce,lastUsedConnection,responseTypeIncludesIdToken,options.organization);return options.state||(options.state=transaction.state),responseTypeIncludesIdToken&&!options.nonce&&(options.nonce=transaction.nonce),options},TransactionManager.prototype.generateTransaction=function(appState,state,nonce,lastUsedConnection,generateNonce,organization){if(state=state||random.randomString(this.keyLength),nonce=nonce||(generateNonce?random.randomString(this.keyLength):null),!(windowHelper.getWindow().location.host===this.options.domain)){var transactionPayload={nonce:nonce,appState:appState,state:state,lastUsedConnection:lastUsedConnection};organization&&(transactionPayload.organization=organization),this.storage.setItem(this.namespace+state,transactionPayload,{expires:this.stateExpiration})}return{state:state,nonce:nonce}},TransactionManager.prototype.getStoredTransaction=function(state){var transactionData;return transactionData=this.storage.getItem(this.namespace+state),this.clearTransaction(state),transactionData},TransactionManager.prototype.clearTransaction=function(state){this.storage.removeItem(this.namespace+state)},IframeHandler.prototype.init=function(){var _this=this,_window=windowHelper.getWindow();switch(this.iframe=_window.document.createElement("iframe"),this.iframe.style.display="none",this.proxyEventListener=function(e){_this.eventListener(e)},this.eventListenerType){case"message":this.eventSourceObject=_window;break;case"load":this.eventSourceObject=this.iframe;break;default:throw new Error("Unsupported event listener type: "+this.eventListenerType)}this.eventSourceObject.addEventListener(this.eventListenerType,this.proxyEventListener,!1),_window.document.body.appendChild(this.iframe),this.iframe.src=this.url,this.timeoutHandle=setTimeout((function(){_this.timeoutHandler()}),this.timeout)},IframeHandler.prototype.eventListener=function(event){var eventData={event:event,sourceObject:this.eventSourceObject};this.eventValidator.isValid(eventData)&&(this.destroy(),this.callback(eventData))},IframeHandler.prototype.timeoutHandler=function(){this.destroy(),this.timeoutCallback&&this.timeoutCallback()},IframeHandler.prototype.destroy=function(){var _this=this;clearTimeout(this.timeoutHandle),this._destroyTimeout=setTimeout((function(){_this.eventSourceObject.removeEventListener(_this.eventListenerType,_this.proxyEventListener,!1),_this.iframe.parentNode&&_this.iframe.parentNode.removeChild(_this.iframe)}),0)},WebMessageHandler.prototype.run=function(options,cb){var _this=this;options.responseMode="web_message",options.prompt="none";var currentOrigin=windowHelper.getOrigin(),redirectUriOrigin=objectHelper.getOriginFromUrl(options.redirectUri);if(redirectUriOrigin&&currentOrigin!==redirectUriOrigin)return cb({error:"origin_mismatch",error_description:"The redirectUri's origin ("+redirectUriOrigin+") should match the window's origin ("+currentOrigin+")."});!function(authorizeUrl,options,callback){new IframeHandler({url:authorizeUrl,eventListenerType:"message",callback:function(eventData){callback(null,eventData)},timeout:options.timeout,eventValidator:{isValid:function(eventData){return!(!eventData.event.data||"authorization_response"!==eventData.event.data.type||options.state!==eventData.event.data.response.state)}},timeoutCallback:function(){callback({error:"timeout",error_description:"Timeout during executing web_message communication",state:options.state})}}).init()}(this.webAuth.client.buildAuthorizeUrl(options),options,(function(err,eventData){var error=err;if(!err&&eventData.event.data.response.error&&(error=eventData.event.data.response),!error){var parsedHash=eventData.event.data.response;return _this.webAuth.validateAuthenticationResponse(options,parsedHash,cb)}return"consent_required"===error.error&&"localhost"===windowHelper.getWindow().location.hostname&&_this.warn.warning("Consent Required. Consent can't be skipped on localhost. Read more here: https://auth0.com/docs/api-auth/user-consent#skipping-consent-for-first-party-clients"),_this.webAuth.transactionManager.clearTransaction(error.state),cb(objectHelper.pick(error,["error","error_description"]))}))},CrossOriginAuthentication.prototype.login=function(options,cb){var _this=this,url=urlJoin(this.baseOptions.rootUrl,"/co/authenticate");options.username=options.username||options.email,delete options.email;var authenticateBody={client_id:options.clientID||this.baseOptions.clientID,username:options.username};options.password&&(authenticateBody.password=options.password),options.otp&&(authenticateBody.otp=options.otp);var realm=options.realm||this.baseOptions.realm;if(realm){var credentialType=options.credentialType||this.baseOptions.credentialType||"http://auth0.com/oauth/grant-type/password-realm";authenticateBody.realm=realm,authenticateBody.credential_type=credentialType}else authenticateBody.credential_type="password";this.request.post(url).withCredentials().send(authenticateBody).end((function(err,data){if(err){var errorObject=err.response&&err.response.body||{error:"request_error",error_description:JSON.stringify(err)};return wrapCallback(cb,{forceLegacyError:!0})(errorObject)}function doAuth(){var popupMode=!0===options.popup;options=objectHelper.blacklist(options,["password","credentialType","otp","popup","onRedirecting"]);var authorizeOptions=objectHelper.merge(options).with({loginTicket:data.body.login_ticket}),key=createKey(_this.baseOptions.rootUrl,data.body.co_id);_this.storage.setItem(key,data.body.co_verifier,{expires:1/96}),popupMode?_this.webMessageHandler.run(authorizeOptions,wrapCallback(cb,{forceLegacyError:!0})):_this.webAuth.authorize(authorizeOptions)}"function"==typeof options.onRedirecting?options.onRedirecting(doAuth):doAuth()}))},CrossOriginAuthentication.prototype.callback=function(){var targetOrigin=decodeURIComponent(function(name){var parts=("&"+windowHelper.getWindow().location.hash.substring(1)).split("&"+name+"=");if(2===parts.length)return parts.pop().split("&").shift()}("origin")),theWindow=windowHelper.getWindow(),_this=this;theWindow.addEventListener("message",(function(evt){if("co_verifier_request"===evt.data.type){var key=createKey(evt.origin,evt.data.request.id),verifier=function(storage,key){try{var verifier=storage.getItem(key);return storage.removeItem(key),verifier||""}catch(e){return""}}(_this.storage,key);evt.source.postMessage({type:"co_verifier_response",response:{verifier:verifier}},evt.origin)}})),theWindow.parent.postMessage({type:"ready"},targetOrigin)},Redirect.prototype.loginWithCredentials=function(options,cb){options.realm=options.realm||options.connection,delete options.connection,this.crossOriginAuthentication.login(options,cb)},Redirect.prototype.signupAndLogin=function(options,cb){var _this=this;return this.webAuth.client.dbConnection.signup(options,(function(err){return err?cb(err):(options.realm=options.realm||options.connection,delete options.connection,_this.webAuth.login(options,cb))}))};var winchan=createCommonjsModule((function(module){var WinChan=function(){function addListener(w,event,cb){w.attachEvent?w.attachEvent("on"+event,cb):w.addEventListener&&w.addEventListener(event,cb,!1)}function removeListener(w,event,cb){w.detachEvent?w.detachEvent("on"+event,cb):w.removeEventListener&&w.removeEventListener(event,cb,!1)}function extractOrigin(url){/^https?:\/\//.test(url)||(url=window.location.href);var m=/^(https?:\/\/[\-_a-zA-Z\.0-9:]+)/.exec(url);return m?m[1]:url}var isIE=function(){if("undefined"==typeof navigator)return!1;var rv=-1,ua=navigator.userAgent;if("Microsoft Internet Explorer"===navigator.appName)null!=new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})").exec(ua)&&(rv=parseFloat(RegExp.$1));else if(ua.indexOf("Trident")>-1){null!==new RegExp("rv:([0-9]{2,2}[.0-9]{0,})").exec(ua)&&(rv=parseFloat(RegExp.$1))}return rv>=8}();return"undefined"!=typeof window&&window.JSON&&window.JSON.stringify&&window.JSON.parse&&window.postMessage?{open:function(opts,cb){if(!cb)throw"missing required callback argument";var err,iframe;opts.url||(err="missing required 'url' parameter"),opts.relay_url||(err="missing required 'relay_url' parameter"),err&&setTimeout((function(){cb(err)}),0),opts.window_name||(opts.window_name=null),opts.window_features&&!function(){try{var userAgent=navigator.userAgent;return-1!=userAgent.indexOf("Fennec/")||-1!=userAgent.indexOf("Firefox/")&&-1!=userAgent.indexOf("Android")}catch(e){}return!1}()||(opts.window_features=void 0);var messageTarget,origin=opts.origin||extractOrigin(opts.url);if(origin!==extractOrigin(opts.relay_url))return setTimeout((function(){cb("invalid arguments: origin of url and relay_url must match")}),0);isIE&&((iframe=document.createElement("iframe")).setAttribute("src",opts.relay_url),iframe.style.display="none",iframe.setAttribute("name","__winchan_relay_frame"),document.body.appendChild(iframe),messageTarget=iframe.contentWindow);var w=opts.popup||window.open(opts.url,opts.window_name,opts.window_features);opts.popup&&(w.location.href=opts.url),messageTarget||(messageTarget=w);var closeInterval=setInterval((function(){w&&w.closed&&(cleanup(),cb&&(cb("User closed the popup window"),cb=null))}),500),req=JSON.stringify({a:"request",d:opts.params});function cleanup(){if(iframe&&document.body.removeChild(iframe),iframe=void 0,closeInterval&&(closeInterval=clearInterval(closeInterval)),removeListener(window,"message",onMessage),removeListener(window,"unload",cleanup),w)try{w.close()}catch(securityViolation){messageTarget.postMessage("die",origin)}w=messageTarget=void 0}function onMessage(e){if(e.origin===origin){try{var d=JSON.parse(e.data)}catch(err){if(cb)return cb(err);throw err}"ready"===d.a?messageTarget.postMessage(req,origin):"error"===d.a?(cleanup(),cb&&(cb(d.d),cb=null)):"response"===d.a&&(cleanup(),cb&&(cb(null,d.d),cb=null))}}return addListener(window,"unload",cleanup),addListener(window,"message",onMessage),{originalPopup:w,close:cleanup,focus:function(){if(w)try{w.focus()}catch(e){}}}},onOpen:function(cb){var o="*",msgTarget=isIE?function(){for(var frames=window.opener.frames,i=frames.length-1;i>=0;i--)try{if(frames[i].location.protocol===window.location.protocol&&frames[i].location.host===window.location.host&&"__winchan_relay_frame"===frames[i].name)return frames[i]}catch(e){}}():window.opener;if(!msgTarget)throw"can't find relay frame";function doPost(msg){msg=JSON.stringify(msg),isIE?msgTarget.doPost(msg,o):msgTarget.postMessage(msg,o)}function onDie(e){if("die"===e.data)try{window.close()}catch(o_O){}}addListener(isIE?msgTarget:window,"message",(function onMessage(e){var d;try{d=JSON.parse(e.data)}catch(err){}d&&"request"===d.a&&(removeListener(window,"message",onMessage),o=e.origin,cb&&setTimeout((function(){cb(o,d.d,(function(r){cb=void 0,doPost({a:"response",d:r})}))}),0))})),addListener(isIE?msgTarget:window,"message",onDie);try{doPost({a:"ready"})}catch(e){addListener(msgTarget,"load",(function(e){doPost({a:"ready"})}))}var onUnload=function(){try{removeListener(isIE?msgTarget:window,"message",onDie)}catch(ohWell){}cb&&doPost({a:"error",d:"client closed window"}),cb=void 0;try{window.close()}catch(e){}};return addListener(window,"unload",onUnload),{detach:function(){removeListener(window,"unload",onUnload)}}}}:{open:function(url,winopts,arg,cb){setTimeout((function(){cb("unsupported browser")}),0)},onOpen:function(cb){setTimeout((function(){cb("unsupported browser")}),0)}}}();module.exports&&(module.exports=WinChan)}));var urlHelper={extractOrigin:function(url){/^https?:\/\//.test(url)||(url=window.location.href);var m=/^(https?:\/\/[-_a-zA-Z.0-9:]+)/.exec(url);return m?m[1]:url}};function PopupHandler(){this._current_popup=null}function Popup(webAuth,options){this.baseOptions=options,this.baseOptions.popupOrigin=options.popupOrigin,this.client=webAuth.client,this.webAuth=webAuth,this.transactionManager=new TransactionManager(this.baseOptions),this.crossOriginAuthentication=new CrossOriginAuthentication(webAuth,this.baseOptions),this.warn=new Warn({disableWarnings:!!options._disableDeprecationWarnings})}function SilentAuthenticationHandler(options){this.authenticationUrl=options.authenticationUrl,this.timeout=options.timeout||6e4,this.handler=null,this.postMessageDataType=options.postMessageDataType||!1,this.postMessageOrigin=options.postMessageOrigin||windowHelper.getWindow().location.origin||windowHelper.getWindow().location.protocol+"//"+windowHelper.getWindow().location.hostname+(windowHelper.getWindow().location.port?":"+windowHelper.getWindow().location.port:"")}function UsernamePassword(options){this.baseOptions=options,this.request=new RequestBuilder(options),this.transactionManager=new TransactionManager(this.baseOptions)}function HostedPages(client,options){this.baseOptions=options,this.client=client,this.baseOptions.universalLoginPage=!0,this.request=new RequestBuilder(this.baseOptions),this.warn=new Warn({disableWarnings:!!options._disableDeprecationWarnings})}PopupHandler.prototype.calculatePosition=function(options){var width=options.width||500,height=options.height||600,_window=windowHelper.getWindow(),screenX=void 0!==_window.screenX?_window.screenX:_window.screenLeft,screenY=void 0!==_window.screenY?_window.screenY:_window.screenTop,outerWidth=void 0!==_window.outerWidth?_window.outerWidth:_window.document.body.clientWidth,outerHeight=void 0!==_window.outerHeight?_window.outerHeight:_window.document.body.clientHeight;return{width:width,height:height,left:options.left||screenX+(outerWidth-width)/2,top:options.top||screenY+(outerHeight-height)/2}},PopupHandler.prototype.preload=function(options){var _this=this,_window=windowHelper.getWindow(),popupPosition=this.calculatePosition(options.popupOptions||{}),popupOptions=objectHelper.merge(popupPosition).with(options.popupOptions),url=options.url||"about:blank",windowFeatures=lib.stringify(popupOptions,{encode:!1,delimiter:","});return this._current_popup&&!this._current_popup.closed||(this._current_popup=_window.open(url,"auth0_signup_popup",windowFeatures),this._current_popup.kill=function(){this.close(),_this._current_popup=null}),this._current_popup},PopupHandler.prototype.load=function(url,relayUrl,options,cb){var _this=this,popupPosition=this.calculatePosition(options.popupOptions||{}),popupOptions=objectHelper.merge(popupPosition).with(options.popupOptions),winchanOptions=objectHelper.merge({url:url,relay_url:relayUrl,window_features:lib.stringify(popupOptions,{delimiter:",",encode:!1}),popup:this._current_popup}).with(options),popup=winchan.open(winchanOptions,(function(err,data){if(!err||"SyntaxError"!==err.name)return _this._current_popup=null,cb(err,data)}));return popup.focus(),popup},Popup.prototype.buildPopupHandler=function(){var pluginHandler=this.baseOptions.plugins.get("popup.getPopupHandler");return pluginHandler?pluginHandler.getPopupHandler():new PopupHandler},Popup.prototype.preload=function(options){options=options||{};var popup=this.buildPopupHandler();return popup.preload(options),popup},Popup.prototype.getPopupHandler=function(options,preload){return options.popupHandler?options.popupHandler:preload?this.preload(options):this.buildPopupHandler()},Popup.prototype.callback=function(options){var _this=this,theWindow=windowHelper.getWindow(),originUrl=(options=options||{}).popupOrigin||this.baseOptions.popupOrigin||windowHelper.getOrigin();theWindow.opener?winchan.onOpen((function(popupOrigin,r,cb){if(popupOrigin!==originUrl)return cb({error:"origin_mismatch",error_description:"The popup's origin ("+popupOrigin+") should match the `popupOrigin` parameter ("+originUrl+")."});_this.webAuth.parseHash(options||{},(function(err,data){return cb(err||data)}))})):theWindow.doPost=function(msg){theWindow.parent&&theWindow.parent.postMessage(msg,originUrl)}},Popup.prototype.authorize=function(options,cb){var url,relayUrl,popOpts={},pluginHandler=this.baseOptions.plugins.get("popup.authorize"),params=objectHelper.merge(this.baseOptions,["clientID","scope","domain","audience","tenant","responseType","redirectUri","_csrf","state","_intstate","nonce","organization","invitation"]).with(objectHelper.blacklist(options,["popupHandler"]));return assert.check(params,{type:"object",message:"options parameter is not valid"},{responseType:{type:"string",message:"responseType option is required"}}),relayUrl=urlJoin(this.baseOptions.rootUrl,"relay.html"),options.owp?params.owp=!0:(popOpts.origin=urlHelper.extractOrigin(params.redirectUri),relayUrl=params.redirectUri),options.popupOptions&&(popOpts.popupOptions=objectHelper.pick(options.popupOptions,["width","height","top","left"])),pluginHandler&&(params=pluginHandler.processParams(params)),(params=this.transactionManager.process(params)).scope=params.scope||"openid profile email",delete params.domain,url=this.client.buildAuthorizeUrl(params),this.getPopupHandler(options).load(url,relayUrl,popOpts,wrapCallback(cb,{keepOriginalCasing:!0}))},Popup.prototype.loginWithCredentials=function(options,cb){options.realm=options.realm||options.connection,options.popup=!0,options=objectHelper.merge(this.baseOptions,["redirectUri","responseType","state","nonce","timeout"]).with(objectHelper.blacklist(options,["popupHandler","connection"])),options=this.transactionManager.process(options),this.crossOriginAuthentication.login(options,cb)},Popup.prototype.passwordlessVerify=function(options,cb){var _this=this;return this.client.passwordless.verify(objectHelper.blacklist(options,["popupHandler"]),(function(err){if(err)return cb(err);options.username=options.phoneNumber||options.email,options.password=options.verificationCode,delete options.email,delete options.phoneNumber,delete options.verificationCode,delete options.type,_this.client.loginWithResourceOwner(options,cb)}))},Popup.prototype.signupAndLogin=function(options,cb){var _this=this;return this.client.dbConnection.signup(options,(function(err){if(err)return cb(err);_this.loginWithCredentials(options,cb)}))},SilentAuthenticationHandler.create=function(options){return new SilentAuthenticationHandler(options)},SilentAuthenticationHandler.prototype.login=function(usePostMessage,callback){this.handler=new IframeHandler({auth0:this.auth0,url:this.authenticationUrl,eventListenerType:usePostMessage?"message":"load",callback:this.getCallbackHandler(callback,usePostMessage),timeout:this.timeout,eventValidator:this.getEventValidator(),timeoutCallback:function(){callback(null,"#error=timeout&error_description=Timeout+during+authentication+renew.")},usePostMessage:usePostMessage||!1}),this.handler.init()},SilentAuthenticationHandler.prototype.getEventValidator=function(){var _this=this;return{isValid:function(eventData){switch(eventData.event.type){case"message":return eventData.event.origin===_this.postMessageOrigin&&eventData.event.source===_this.handler.iframe.contentWindow&&(!1===_this.postMessageDataType||eventData.event.data.type&&eventData.event.data.type===_this.postMessageDataType);case"load":if("about:"===eventData.sourceObject.contentWindow.location.protocol)return!1;default:return!0}}}},SilentAuthenticationHandler.prototype.getCallbackHandler=function(callback,usePostMessage){return function(eventData){var callbackValue;callbackValue=usePostMessage?"object"==typeof eventData.event.data&&eventData.event.data.hash?eventData.event.data.hash:eventData.event.data:eventData.sourceObject.contentWindow.location.hash,callback(null,callbackValue)}},UsernamePassword.prototype.login=function(options,cb){var url,body;return url=urlJoin(this.baseOptions.rootUrl,"usernamepassword","login"),options.username=options.username||options.email,options=objectHelper.blacklist(options,["email","onRedirecting"]),body=objectHelper.merge(this.baseOptions,["clientID","redirectUri","tenant","responseType","responseMode","scope","audience"]).with(options),body=this.transactionManager.process(body),body=objectHelper.toSnakeCase(body,["auth0Client"]),this.request.post(url).send(body).end(wrapCallback(cb))},UsernamePassword.prototype.callback=function(formHtml){var div,_document=windowHelper.getDocument();(div=_document.createElement("div")).innerHTML=formHtml,_document.body.appendChild(div).children[0].submit()},HostedPages.prototype.login=function(options,cb){if(windowHelper.getWindow().location.host!==this.baseOptions.domain)throw new Error("This method is meant to be used only inside the Universal Login Page.");var usernamePassword,params=objectHelper.merge(this.baseOptions,["clientID","redirectUri","tenant","responseType","responseMode","scope","audience","_csrf","state","_intstate","nonce"]).with(options);return assert.check(params,{type:"object",message:"options parameter is not valid"},{responseType:{type:"string",message:"responseType option is required"}}),(usernamePassword=new UsernamePassword(this.baseOptions)).login(params,(function(err,data){if(err)return cb(err);function doAuth(){usernamePassword.callback(data)}if("function"==typeof options.onRedirecting)return options.onRedirecting((function(){doAuth()}));doAuth()}))},HostedPages.prototype.signupAndLogin=function(options,cb){var _this=this;return _this.client.client.dbConnection.signup(options,(function(err){return err?cb(err):_this.login(options,cb)}))},HostedPages.prototype.getSSOData=function(withActiveDirectories,cb){var url,params="";return"function"==typeof withActiveDirectories&&(cb=withActiveDirectories,withActiveDirectories=!1),assert.check(withActiveDirectories,{type:"boolean",message:"withActiveDirectories parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),withActiveDirectories&&(params="?"+lib.stringify({ldaps:1,client_id:this.baseOptions.clientID})),url=urlJoin(this.baseOptions.rootUrl,"user","ssodata",params),this.request.get(url,{noHeaders:!0}).withCredentials().end(wrapCallback(cb))};var noop=function(){},captchaSolved=noop,defaults$2={lang:"en",templates:{auth0:function(challenge){var message="code"===challenge.type?"Enter the code shown above":"Solve the formula shown above";return'<div class="captcha-challenge">\n  <img src="'+challenge.image+'" />\n  <button type="button" class="captcha-reload">↺</button>\n</div>\n<input type="text" name="captcha"\n  class="form-control captcha-control"\n  placeholder="'+message+'" />'},recaptcha_v2:function(){return'<div class="recaptcha" ></div><input type="hidden" name="captcha" />'},recaptcha_enterprise:function(){return'<div class="recaptcha" ></div><input type="hidden" name="captcha" />'},hcaptcha:function(){return'<div class="hcaptcha" ></div><input type="hidden" name="captcha" />'},friendly_captcha:function(){return'<div class="friendly-captcha" ></div><input type="hidden" name="captcha" />'},arkose:function(){return'<div class="arkose" ></div><input type="hidden" name="captcha" />'},error:function(){return'<div class="error" style="color: red;">Error getting the bot detection challenge. Please contact the system administrator.</div>'}}};function handleAuth0Provider(element,options,challenge,load){element.innerHTML=options.templates[challenge.provider](challenge),element.querySelector(".captcha-reload").addEventListener("click",(function(e){e.preventDefault(),load()}))}function globalForCaptchaProvider(provider){switch(provider){case"recaptcha_v2":return window.grecaptcha;case"recaptcha_enterprise":return window.grecaptcha.enterprise;case"hcaptcha":return window.hcaptcha;case"friendly_captcha":return window.friendlyChallenge;case"arkose":return window.arkose;default:throw new Error("Unknown captcha provider")}}function loadScript(url,attributes){var script=window.document.createElement("script");for(var attr in attributes)attr.startsWith("data-")?script.dataset[attr.replace("data-","")]=attributes[attr]:script[attr]=attributes[attr];script.src=url,window.document.body.appendChild(script)}function removeScript(url){window.document.querySelectorAll('script[src="'+url+'"]').forEach((function(script){script.remove()}))}function injectCaptchaScript(element,opts,callback,setValue){var callbackName=opts.provider+"Callback_"+Math.floor(1000001*Math.random()),attributes={async:!0,defer:!0},scriptSrc=function(provider,lang,callback,clientSubdomain,siteKey){switch(provider){case"recaptcha_v2":return"https://www.recaptcha.net/recaptcha/api.js?hl="+lang+"&onload="+callback;case"recaptcha_enterprise":return"https://www.recaptcha.net/recaptcha/enterprise.js?render=explicit&hl="+lang+"&onload="+callback;case"hcaptcha":return"https://js.hcaptcha.com/1/api.js?hl="+lang+"&onload="+callback;case"friendly_captcha":return"https://cdn.jsdelivr.net/npm/friendly-challenge@0.9.12/widget.min.js";case"arkose":return"https://"+clientSubdomain+".arkoselabs.com/v2/"+siteKey+"/api.js";default:throw new Error("Unknown captcha provider")}}(opts.provider,opts.lang,callbackName,opts.clientSubdomain,opts.siteKey);if("arkose"===opts.provider){var retryCount=0;attributes["data-callback"]=callbackName,attributes.onerror=function(){if(retryCount<3)return removeScript(scriptSrc),loadScript(scriptSrc,attributes),void retryCount++;removeScript(scriptSrc),setValue("BYPASS_CAPTCHA")},window[callbackName]=function(arkose){window.arkose=arkose,callback(arkose)}}else window[callbackName]=function(){delete window[callbackName],callback()},"friendly_captcha"===opts.provider&&(attributes.onload=window[callbackName]);loadScript(scriptSrc,attributes)}function handleCaptchaProvider(element,options,challenge){var captchaClass,widgetId=element.hasAttribute("data-wid")&&element.getAttribute("data-wid");function setValue(value){element.querySelector('input[name="captcha"]').value=value||""}if("friendly_captcha"===challenge.provider&&window.auth0FCInstance)return setValue(),void window.auth0FCInstance.reset();if("arkose"===challenge.provider&&globalForCaptchaProvider(challenge.provider))return setValue(),void globalForCaptchaProvider(challenge.provider).reset();if(widgetId)return setValue(),void globalForCaptchaProvider(challenge.provider).reset(widgetId);switch(element.innerHTML=options.templates[challenge.provider](challenge),challenge.provider){case"recaptcha_enterprise":case"recaptcha_v2":captchaClass=".recaptcha";break;case"hcaptcha":captchaClass=".hcaptcha";break;case"friendly_captcha":captchaClass=".friendly-captcha";break;case"arkose":captchaClass=".arkose"}var captchaDiv=element.querySelector(captchaClass);injectCaptchaScript(0,{lang:options.lang,provider:challenge.provider,clientSubdomain:challenge.clientSubdomain,siteKey:challenge.siteKey},(function(arkose){var global=globalForCaptchaProvider(challenge.provider);if("arkose"===challenge.provider){var retryCount=0;arkose.setConfig({onCompleted:function(response){setValue(response.token),captchaSolved()},onError:function(){retryCount<3?(setValue(),arkose.reset(),setTimeout((function(){arkose.run()}),500),retryCount++):setValue("BYPASS_CAPTCHA")}})}else"friendly_captcha"===challenge.provider?window.auth0FCInstance=new global.WidgetInstance(captchaDiv,{sitekey:challenge.siteKey,language:options.lang,doneCallback:function(solution){setValue(solution)},errorCallback:function(){setValue()}}):(widgetId=global.render(captchaDiv,{callback:setValue,"expired-callback":function(){setValue()},"error-callback":function(){setValue()},sitekey:challenge.siteKey}),element.setAttribute("data-wid",widgetId))}),setValue)}var captcha={render:function(auth0Client,element,options,callback){function load(done){done=done||noop,auth0Client.getChallenge((function(err,challenge){return err?(element.innerHTML=options.templates.error(err),done(err)):challenge.required?(element.style.display="","auth0"===challenge.provider?handleAuth0Provider(element,options,challenge,load):"recaptcha_v2"!==challenge.provider&&"recaptcha_enterprise"!==challenge.provider&&"hcaptcha"!==challenge.provider&&"friendly_captcha"!==challenge.provider&&"arkose"!==challenge.provider||handleCaptchaProvider(element,options,challenge),void("arkose"===challenge.provider?done(null,{triggerCaptcha:function(solvedCallback){globalForCaptchaProvider(challenge.provider).run(),captchaSolved=solvedCallback}}):done())):(element.style.display="none",void(element.innerHTML=""))}))}return options=objectHelper.merge(defaults$2).with(options||{}),load(callback),{reload:load,getValue:function(){var captchaInput=element.querySelector('input[name="captcha"]');if(captchaInput)return captchaInput.value}}},renderPasswordless:function(auth0Client,element,options,callback){function load(done){done=done||noop,auth0Client.passwordless.getChallenge((function(err,challenge){return err?(element.innerHTML=options.templates.error(err),done(err)):challenge.required?(element.style.display="","auth0"===challenge.provider?handleAuth0Provider(element,options,challenge,load):"recaptcha_v2"!==challenge.provider&&"recaptcha_enterprise"!==challenge.provider&&"hcaptcha"!==challenge.provider&&"friendly_captcha"!==challenge.provider&&"arkose"!==challenge.provider||handleCaptchaProvider(element,options,challenge),void("arkose"===challenge.provider?done(null,{triggerCaptcha:function(solvedCallback){globalForCaptchaProvider(challenge.provider).run(),captchaSolved=solvedCallback}}):done())):(element.style.display="none",void(element.innerHTML=""))}))}return options=objectHelper.merge(defaults$2).with(options||{}),load(callback),{reload:load,getValue:function(){var captchaInput=element.querySelector('input[name="captcha"]');if(captchaInput)return captchaInput.value}}}};function defaultClock(){return new Date}function WebAuth(options){assert.check(options,{type:"object",message:"options parameter is not valid"},{domain:{type:"string",message:"domain option is required"},clientID:{type:"string",message:"clientID option is required"},responseType:{optional:!0,type:"string",message:"responseType is not valid"},responseMode:{optional:!0,type:"string",message:"responseMode is not valid"},redirectUri:{optional:!0,type:"string",message:"redirectUri is not valid"},scope:{optional:!0,type:"string",message:"scope is not valid"},audience:{optional:!0,type:"string",message:"audience is not valid"},popupOrigin:{optional:!0,type:"string",message:"popupOrigin is not valid"},leeway:{optional:!0,type:"number",message:"leeway is not valid"},plugins:{optional:!0,type:"array",message:"plugins is not valid"},maxAge:{optional:!0,type:"number",message:"maxAge is not valid"},stateExpiration:{optional:!0,type:"number",message:"stateExpiration is not valid"},legacySameSiteCookie:{optional:!0,type:"boolean",message:"legacySameSiteCookie option is not valid"},_disableDeprecationWarnings:{optional:!0,type:"boolean",message:"_disableDeprecationWarnings option is not valid"},_sendTelemetry:{optional:!0,type:"boolean",message:"_sendTelemetry option is not valid"},_telemetryInfo:{optional:!0,type:"object",message:"_telemetryInfo option is not valid"},_timesToRetryFailedRequests:{optional:!0,type:"number",message:"_timesToRetryFailedRequests option is not valid"}}),options.overrides&&assert.check(options.overrides,{type:"object",message:"overrides option is not valid"},{__tenant:{optional:!0,type:"string",message:"__tenant option is required"},__token_issuer:{optional:!0,type:"string",message:"__token_issuer option is required"},__jwks_uri:{optional:!0,type:"string",message:"__jwks_uri is required"}}),this.baseOptions=options,this.baseOptions.plugins=new PluginHandler(this,this.baseOptions.plugins||[]),this.baseOptions._sendTelemetry=!1!==this.baseOptions._sendTelemetry||this.baseOptions._sendTelemetry,this.baseOptions._timesToRetryFailedRequests=options._timesToRetryFailedRequests?parseInt(options._timesToRetryFailedRequests):0,this.baseOptions.tenant=this.baseOptions.overrides&&this.baseOptions.overrides.__tenant||this.baseOptions.domain.split(".")[0],this.baseOptions.token_issuer=this.baseOptions.overrides&&this.baseOptions.overrides.__token_issuer||"https://"+this.baseOptions.domain+"/",this.baseOptions.jwksURI=this.baseOptions.overrides&&this.baseOptions.overrides.__jwks_uri,!1!==options.legacySameSiteCookie&&(this.baseOptions.legacySameSiteCookie=!0),this.transactionManager=new TransactionManager(this.baseOptions),this.client=new Authentication(this.baseOptions),this.redirect=new Redirect(this,this.baseOptions),this.popup=new Popup(this,this.baseOptions),this.crossOriginAuthentication=new CrossOriginAuthentication(this,this.baseOptions),this.webMessageHandler=new WebMessageHandler(this),this._universalLogin=new HostedPages(this,this.baseOptions),this.ssodataStorage=new SSODataStorage(this.baseOptions)}function PasswordlessAuthentication(request,options){this.baseOptions=options,this.request=request}function DBConnection(request,options){this.baseOptions=options,this.request=request}function Authentication(auth0,options){2===arguments.length?this.auth0=auth0:options=auth0,assert.check(options,{type:"object",message:"options parameter is not valid"},{domain:{type:"string",message:"domain option is required"},clientID:{type:"string",message:"clientID option is required"},responseType:{optional:!0,type:"string",message:"responseType is not valid"},responseMode:{optional:!0,type:"string",message:"responseMode is not valid"},redirectUri:{optional:!0,type:"string",message:"redirectUri is not valid"},scope:{optional:!0,type:"string",message:"scope is not valid"},audience:{optional:!0,type:"string",message:"audience is not valid"},_disableDeprecationWarnings:{optional:!0,type:"boolean",message:"_disableDeprecationWarnings option is not valid"},_sendTelemetry:{optional:!0,type:"boolean",message:"_sendTelemetry option is not valid"},_telemetryInfo:{optional:!0,type:"object",message:"_telemetryInfo option is not valid"}}),this.baseOptions=options,this.baseOptions._sendTelemetry=!1!==this.baseOptions._sendTelemetry||this.baseOptions._sendTelemetry,this.baseOptions.rootUrl=this.baseOptions.domain&&0===this.baseOptions.domain.toLowerCase().indexOf("http")?this.baseOptions.domain:"https://"+this.baseOptions.domain,this.request=new RequestBuilder(this.baseOptions),this.passwordless=new PasswordlessAuthentication(this.request,this.baseOptions),this.dbConnection=new DBConnection(this.request,this.baseOptions),this.warn=new Warn({disableWarnings:!!options._disableDeprecationWarnings}),this.ssodataStorage=new SSODataStorage(this.baseOptions)}function Management(options){assert.check(options,{type:"object",message:"options parameter is not valid"},{domain:{type:"string",message:"domain option is required"},token:{type:"string",message:"token option is required"},_sendTelemetry:{optional:!0,type:"boolean",message:"_sendTelemetry option is not valid"},_telemetryInfo:{optional:!0,type:"object",message:"_telemetryInfo option is not valid"}}),this.baseOptions=options,this.baseOptions.headers={Authorization:"Bearer "+this.baseOptions.token},this.request=new RequestBuilder(this.baseOptions),this.baseOptions.rootUrl=urlJoin("https://"+this.baseOptions.domain,"api","v2")}WebAuth.prototype.parseHash=function(options,cb){var parsedQs,err;cb||"function"!=typeof options?options=options||{}:(cb=options,options={});var hashStr=void 0===options.hash?windowHelper.getWindow().location.hash:options.hash;if(hashStr=hashStr.replace(/^#?\/?/,""),(parsedQs=lib.parse(hashStr)).hasOwnProperty("error"))return err=error.buildResponse(parsedQs.error,parsedQs.error_description),parsedQs.state&&(err.state=parsedQs.state),cb(err);if(!parsedQs.hasOwnProperty("access_token")&&!parsedQs.hasOwnProperty("id_token")&&!parsedQs.hasOwnProperty("refresh_token"))return cb(null,null);var responseTypes=(this.baseOptions.responseType||options.responseType||"").split(" ");return responseTypes.length>0&&-1!==responseTypes.indexOf("token")&&!parsedQs.hasOwnProperty("access_token")?cb(error.buildResponse("invalid_hash","response_type contains `token`, but the parsed hash does not contain an `access_token` property")):responseTypes.length>0&&-1!==responseTypes.indexOf("id_token")&&!parsedQs.hasOwnProperty("id_token")?cb(error.buildResponse("invalid_hash","response_type contains `id_token`, but the parsed hash does not contain an `id_token` property")):this.validateAuthenticationResponse(options,parsedQs,cb)},WebAuth.prototype.validateAuthenticationResponse=function(options,parsedHash,cb){var _this=this;options.__enableIdPInitiatedLogin=options.__enableIdPInitiatedLogin||options.__enableImpersonation;var state=parsedHash.state,transaction=this.transactionManager.getStoredTransaction(state),transactionState=options.state||transaction&&transaction.state||null,transactionStateMatchesState=transactionState===state;if(!(!state&&!transactionState&&options.__enableIdPInitiatedLogin)&&!transactionStateMatchesState)return cb({error:"invalid_token",errorDescription:"`state` does not match."});var transactionNonce=options.nonce||transaction&&transaction.nonce||null,transactionOrganization=transaction&&transaction.organization,appState=options.state||transaction&&transaction.appState||null,callback=function(err,payload){if(err)return cb(err);var sub;transaction&&transaction.lastUsedConnection&&(payload&&(sub=payload.sub),_this.ssodataStorage.set(transaction.lastUsedConnection,sub));return cb(null,function(qsParams,appState,token){return{accessToken:qsParams.access_token||null,idToken:qsParams.id_token||null,idTokenPayload:token||null,appState:appState||null,refreshToken:qsParams.refresh_token||null,state:qsParams.state||null,expiresIn:qsParams.expires_in?parseInt(qsParams.expires_in,10):null,tokenType:qsParams.token_type||null,scope:qsParams.scope||null}}(parsedHash,appState,payload))};return parsedHash.id_token?this.validateToken(parsedHash.id_token,transactionNonce,(function(validationError,payload){if(!validationError){if(transactionOrganization)if(0===transactionOrganization.indexOf("org_")){if(!payload.org_id)return callback(error.invalidToken("Organization Id (org_id) claim must be a string present in the ID token"));if(payload.org_id!==transactionOrganization)return callback(error.invalidToken('Organization Id (org_id) claim value mismatch in the ID token; expected "'+transactionOrganization+'", found "'+payload.org_id+'"'))}else{if(!payload.org_name)return callback(error.invalidToken("Organization Name (org_name) claim must be a string present in the ID token"));if(payload.org_name!==transactionOrganization.toLowerCase())return callback(error.invalidToken('Organization Name (org_name) claim value mismatch in the ID token; expected "'+transactionOrganization+'", found "'+payload.org_name+'"'))}return parsedHash.access_token&&payload.at_hash?(new M).validateAccessToken(parsedHash.access_token,"RS256",payload.at_hash,(function(err){return err?callback(error.invalidToken(err.message)):callback(null,payload)})):callback(null,payload)}if("invalid_token"!==validationError.error||validationError.errorDescription&&validationError.errorDescription.indexOf("Nonce (nonce) claim value mismatch in the ID token")>-1)return callback(validationError);var decodedToken=(new M).decode(parsedHash.id_token);if("HS256"!==decodedToken.header.alg)return callback(validationError);if((decodedToken.payload.nonce||null)!==transactionNonce)return callback({error:"invalid_token",errorDescription:'Nonce (nonce) claim value mismatch in the ID token; expected "'+transactionNonce+'", found "'+decodedToken.payload.nonce+'"'});if(!parsedHash.access_token){return callback({error:"invalid_token",description:"The id_token cannot be validated because it was signed with the HS256 algorithm and public clients (like a browser) can’t store secrets. Please read the associated doc for possible ways to fix this. Read more: https://auth0.com/docs/errors/libraries/auth0-js/invalid-token#parsing-an-hs256-signed-id-token-without-an-access-token"})}return _this.client.userInfo(parsedHash.access_token,(function(errUserInfo,profile){return errUserInfo?callback(errUserInfo):callback(null,profile)}))})):callback(null,null)},WebAuth.prototype.validateToken=function(token,nonce,cb){new M({issuer:this.baseOptions.token_issuer,jwksURI:this.baseOptions.jwksURI,audience:this.baseOptions.clientID,leeway:this.baseOptions.leeway||60,maxAge:this.baseOptions.maxAge,__clock:this.baseOptions.__clock||defaultClock}).verify(token,nonce,(function(err,payload){if(err)return cb(error.invalidToken(err.message));cb(null,payload)}))},WebAuth.prototype.renewAuth=function(options,cb){var usePostMessage=!!options.usePostMessage,postMessageDataType=options.postMessageDataType||!1,postMessageOrigin=options.postMessageOrigin||windowHelper.getWindow().origin,timeout=options.timeout,_this=this,params=objectHelper.merge(this.baseOptions,["clientID","redirectUri","responseType","scope","audience","_csrf","state","_intstate","nonce"]).with(options);params.responseType=params.responseType||"token",params.responseMode=params.responseMode||"fragment",params=this.transactionManager.process(params),assert.check(params,{type:"object",message:"options parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),params.prompt="none",params=objectHelper.blacklist(params,["usePostMessage","tenant","postMessageDataType","postMessageOrigin"]),SilentAuthenticationHandler.create({authenticationUrl:this.client.buildAuthorizeUrl(params),postMessageDataType:postMessageDataType,postMessageOrigin:postMessageOrigin,timeout:timeout}).login(usePostMessage,(function(err,hash){if("object"==typeof hash)return cb(err,hash);_this.parseHash({hash:hash},cb)}))},WebAuth.prototype.checkSession=function(options,cb){var params=objectHelper.merge(this.baseOptions,["clientID","responseType","redirectUri","scope","audience","_csrf","state","_intstate","nonce"]).with(options);return"code"===params.responseType?cb({error:"error",error_description:"responseType can't be `code`"}):(options.nonce||(params=this.transactionManager.process(params)),params.redirectUri?(assert.check(params,{type:"object",message:"options parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),params=objectHelper.blacklist(params,["usePostMessage","tenant","postMessageDataType"]),void this.webMessageHandler.run(params,wrapCallback(cb,{forceLegacyError:!0,ignoreCasing:!0}))):cb({error:"error",error_description:"redirectUri can't be empty"}))},WebAuth.prototype.changePassword=function(options,cb){return this.client.dbConnection.changePassword(options,cb)},WebAuth.prototype.passwordlessStart=function(options,cb){var authParams=objectHelper.merge(this.baseOptions,["responseType","responseMode","redirectUri","scope","audience","_csrf","state","_intstate","nonce"]).with(options.authParams);return options.authParams=this.transactionManager.process(authParams),this.client.passwordless.start(options,cb)},WebAuth.prototype.signup=function(options,cb){return this.client.dbConnection.signup(options,cb)},WebAuth.prototype.authorize=function(options){var params=objectHelper.merge(this.baseOptions,["clientID","responseType","responseMode","redirectUri","scope","audience","_csrf","state","_intstate","nonce","organization","invitation"]).with(options);assert.check(params,{type:"object",message:"options parameter is not valid"},{responseType:{type:"string",message:"responseType option is required"}}),(params=this.transactionManager.process(params)).scope=params.scope||"openid profile email",windowHelper.redirect(this.client.buildAuthorizeUrl(params))},WebAuth.prototype.signupAndAuthorize=function(options,cb){var _this=this;return this.client.dbConnection.signup(objectHelper.blacklist(options,["popupHandler"]),(function(err){if(err)return cb(err);options.realm=options.connection,options.username||(options.username=options.email),_this.client.login(options,cb)}))},WebAuth.prototype.login=function(options,cb){var params=objectHelper.merge(this.baseOptions,["clientID","responseType","redirectUri","scope","audience","_csrf","state","_intstate","nonce","onRedirecting","organization","invitation"]).with(options);params=this.transactionManager.process(params),windowHelper.getWindow().location.host===this.baseOptions.domain?(params.connection=params.realm,delete params.realm,this._universalLogin.login(params,cb)):this.crossOriginAuthentication.login(params,cb)},WebAuth.prototype.passwordlessLogin=function(options,cb){var params=objectHelper.merge(this.baseOptions,["clientID","responseType","redirectUri","scope","audience","_csrf","state","_intstate","nonce","onRedirecting"]).with(options);if(params=this.transactionManager.process(params),windowHelper.getWindow().location.host===this.baseOptions.domain)this.passwordlessVerify(params,cb);else{var crossOriginOptions=objectHelper.extend({credentialType:"http://auth0.com/oauth/grant-type/passwordless/otp",realm:params.connection,username:params.email||params.phoneNumber,otp:params.verificationCode},objectHelper.blacklist(params,["connection","email","phoneNumber","verificationCode"]));this.crossOriginAuthentication.login(crossOriginOptions,cb)}},WebAuth.prototype.crossOriginAuthenticationCallback=function(){this.crossOriginVerification()},WebAuth.prototype.crossOriginVerification=function(){this.crossOriginAuthentication.callback()},WebAuth.prototype.logout=function(options){windowHelper.redirect(this.client.buildLogoutUrl(options))},WebAuth.prototype.passwordlessVerify=function(options,cb){var _this=this,params=objectHelper.merge(this.baseOptions,["clientID","responseType","responseMode","redirectUri","scope","audience","_csrf","state","_intstate","nonce","onRedirecting"]).with(options);return assert.check(params,{type:"object",message:"options parameter is not valid"},{responseType:{type:"string",message:"responseType option is required"}}),params=this.transactionManager.process(params),this.client.passwordless.verify(params,(function(err){if(err)return cb(err);function doAuth(){windowHelper.redirect(_this.client.passwordless.buildVerifyUrl(params))}if("function"==typeof options.onRedirecting)return options.onRedirecting((function(){doAuth()}));doAuth()}))},WebAuth.prototype.renderCaptcha=function(element,options,callback){return captcha.render(this.client,element,options,callback)},WebAuth.prototype.renderPasswordlessCaptcha=function(element,options,callback){return captcha.renderPasswordless(this.client,element,options,callback)},PasswordlessAuthentication.prototype.buildVerifyUrl=function(options){var params,qString;return assert.check(options,{type:"object",message:"options parameter is not valid"},{connection:{type:"string",message:"connection option is required"},verificationCode:{type:"string",message:"verificationCode option is required"},phoneNumber:{optional:!1,type:"string",message:"phoneNumber option is required",condition:function(o){return!o.email}},email:{optional:!1,type:"string",message:"email option is required",condition:function(o){return!o.phoneNumber}}}),params=objectHelper.merge(this.baseOptions,["clientID","responseType","responseMode","redirectUri","scope","audience","_csrf","state","_intstate","protocol","nonce"]).with(options),this.baseOptions._sendTelemetry&&(params.auth0Client=this.request.getTelemetryData()),params=objectHelper.toSnakeCase(params,["auth0Client"]),qString=lib.stringify(params),urlJoin(this.baseOptions.rootUrl,"passwordless","verify_redirect","?"+qString)},PasswordlessAuthentication.prototype.start=function(options,cb){var url,body;assert.check(options,{type:"object",message:"options parameter is not valid"},{connection:{type:"string",message:"connection option is required"},send:{type:"string",message:"send option is required",values:["link","code"],value_message:"send is not valid ([link, code])"},phoneNumber:{optional:!0,type:"string",message:"phoneNumber option is required",condition:function(o){return"code"===o.send||!o.email}},email:{optional:!0,type:"string",message:"email option is required",condition:function(o){return"link"===o.send||!o.phoneNumber}},authParams:{optional:!0,type:"object",message:"authParams option is required"}}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"passwordless","start");var xRequestLanguage=options.xRequestLanguage;delete options.xRequestLanguage,(body=objectHelper.merge(this.baseOptions,["clientID","responseType","redirectUri","scope"]).with(options)).scope&&(body.authParams=body.authParams||{},body.authParams.scope=body.authParams.scope||body.scope),body.redirectUri&&(body.authParams=body.authParams||{},body.authParams.redirect_uri=body.authParams.redirectUri||body.redirectUri),body.responseType&&(body.authParams=body.authParams||{},body.authParams.response_type=body.authParams.responseType||body.responseType),delete body.redirectUri,delete body.responseType,delete body.scope,body=objectHelper.toSnakeCase(body,["auth0Client","authParams"]);var postOptions=xRequestLanguage?{xRequestLanguage:xRequestLanguage}:void 0;return this.request.post(url,postOptions).send(body).end(wrapCallback(cb))},PasswordlessAuthentication.prototype.verify=function(options,cb){var url,cleanOption;return assert.check(options,{type:"object",message:"options parameter is not valid"},{connection:{type:"string",message:"connection option is required"},verificationCode:{type:"string",message:"verificationCode option is required"},phoneNumber:{optional:!1,type:"string",message:"phoneNumber option is required",condition:function(o){return!o.email}},email:{optional:!1,type:"string",message:"email option is required",condition:function(o){return!o.phoneNumber}}}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),cleanOption=objectHelper.pick(options,["connection","verificationCode","phoneNumber","email","auth0Client","clientID"]),cleanOption=objectHelper.toSnakeCase(cleanOption,["auth0Client"]),url=urlJoin(this.baseOptions.rootUrl,"passwordless","verify"),this.request.post(url).send(cleanOption).end(wrapCallback(cb))},PasswordlessAuthentication.prototype.getChallenge=function(cb){if(assert.check(cb,{type:"function",message:"cb parameter is not valid"}),!this.baseOptions.state)return cb();var url=urlJoin(this.baseOptions.rootUrl,"passwordless","challenge");return this.request.post(url).send({state:this.baseOptions.state}).end(wrapCallback(cb,{ignoreCasing:!0}))},DBConnection.prototype.signup=function(options,cb){var url,body,metadata;return assert.check(options,{type:"object",message:"options parameter is not valid"},{connection:{type:"string",message:"connection option is required"},email:{type:"string",message:"email option is required"},password:{type:"string",message:"password option is required"}}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"dbconnections","signup"),metadata=(body=objectHelper.merge(this.baseOptions,["clientID","state"]).with(options)).user_metadata||body.userMetadata,body=objectHelper.blacklist(body,["scope","userMetadata","user_metadata"]),body=objectHelper.toSnakeCase(body,["auth0Client"]),metadata&&(body.user_metadata=metadata),this.request.post(url).send(body).end(wrapCallback(cb))},DBConnection.prototype.changePassword=function(options,cb){var url,body;return assert.check(options,{type:"object",message:"options parameter is not valid"},{connection:{type:"string",message:"connection option is required"},email:{type:"string",message:"email option is required"}}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"dbconnections","change_password"),body=objectHelper.merge(this.baseOptions,["clientID"]).with(options,["email","connection"]),body=objectHelper.toSnakeCase(body,["auth0Client"]),this.request.post(url).send(body).end(wrapCallback(cb))},Authentication.prototype.buildAuthorizeUrl=function(options){var params,qString;return assert.check(options,{type:"object",message:"options parameter is not valid"}),params=objectHelper.merge(this.baseOptions,["clientID","responseType","responseMode","redirectUri","scope","audience"]).with(options),assert.check(params,{type:"object",message:"options parameter is not valid"},{clientID:{type:"string",message:"clientID option is required"},redirectUri:{optional:!0,type:"string",message:"redirectUri option is required"},responseType:{type:"string",message:"responseType option is required"},nonce:{type:"string",message:"nonce option is required",condition:function(o){return-1===o.responseType.indexOf("code")&&-1!==o.responseType.indexOf("id_token")}},scope:{optional:!0,type:"string",message:"scope option is required"},audience:{optional:!0,type:"string",message:"audience option is required"}}),this.baseOptions._sendTelemetry&&(params.auth0Client=this.request.getTelemetryData()),params.connection_scope&&assert.isArray(params.connection_scope)&&(params.connection_scope=params.connection_scope.join(",")),params=objectHelper.blacklist(params,["username","popupOptions","domain","tenant","timeout","appState"]),params=objectHelper.toSnakeCase(params,["auth0Client"]),params=parametersWhitelist.oauthAuthorizeParams(this.warn,params),qString=lib.stringify(params),urlJoin(this.baseOptions.rootUrl,"authorize","?"+qString)},Authentication.prototype.buildLogoutUrl=function(options){var params,qString;return assert.check(options,{optional:!0,type:"object",message:"options parameter is not valid"}),params=objectHelper.merge(this.baseOptions,["clientID"]).with(options||{}),this.baseOptions._sendTelemetry&&(params.auth0Client=this.request.getTelemetryData()),params=objectHelper.toSnakeCase(params,["auth0Client","returnTo"]),qString=lib.stringify(objectHelper.blacklist(params,["federated"])),options&&void 0!==options.federated&&!1!==options.federated&&"false"!==options.federated&&(qString+="&federated"),urlJoin(this.baseOptions.rootUrl,"v2","logout","?"+qString)},Authentication.prototype.loginWithDefaultDirectory=function(options,cb){return assert.check(options,{type:"object",message:"options parameter is not valid"},{username:{type:"string",message:"username option is required"},password:{type:"string",message:"password option is required"},scope:{optional:!0,type:"string",message:"scope option is required"},audience:{optional:!0,type:"string",message:"audience option is required"}}),options.grantType="password",this.oauthToken(options,cb)},Authentication.prototype.login=function(options,cb){return assert.check(options,{type:"object",message:"options parameter is not valid"},{username:{type:"string",message:"username option is required"},password:{type:"string",message:"password option is required"},realm:{type:"string",message:"realm option is required"},scope:{optional:!0,type:"string",message:"scope option is required"},audience:{optional:!0,type:"string",message:"audience option is required"}}),options.grantType="http://auth0.com/oauth/grant-type/password-realm",this.oauthToken(options,cb)},Authentication.prototype.oauthToken=function(options,cb){var url,body;return assert.check(options,{type:"object",message:"options parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"oauth","token"),body=objectHelper.merge(this.baseOptions,["clientID","scope","audience"]).with(options),assert.check(body,{type:"object",message:"options parameter is not valid"},{clientID:{type:"string",message:"clientID option is required"},grantType:{type:"string",message:"grantType option is required"},scope:{optional:!0,type:"string",message:"scope option is required"},audience:{optional:!0,type:"string",message:"audience option is required"}}),body=objectHelper.toSnakeCase(body,["auth0Client"]),body=parametersWhitelist.oauthTokenParams(this.warn,body),this.request.post(url).send(body).end(wrapCallback(cb))},Authentication.prototype.loginWithResourceOwner=function(options,cb){var url,body;return assert.check(options,{type:"object",message:"options parameter is not valid"},{username:{type:"string",message:"username option is required"},password:{type:"string",message:"password option is required"},connection:{type:"string",message:"connection option is required"},scope:{optional:!0,type:"string",message:"scope option is required"}}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"oauth","ro"),body=objectHelper.merge(this.baseOptions,["clientID","scope"]).with(options,["username","password","scope","connection","device"]),(body=objectHelper.toSnakeCase(body,["auth0Client"])).grant_type=body.grant_type||"password",this.request.post(url).send(body).end(wrapCallback(cb))},Authentication.prototype.getSSOData=function(withActiveDirectories,cb){if(this.auth0||(this.auth0=new WebAuth(this.baseOptions)),windowHelper.getWindow().location.host===this.baseOptions.domain)return this.auth0._universalLogin.getSSOData(withActiveDirectories,cb);"function"==typeof withActiveDirectories&&(cb=withActiveDirectories),assert.check(cb,{type:"function",message:"cb parameter is not valid"});var clientId=this.baseOptions.clientID,ssodataInformation=this.ssodataStorage.get()||{};this.auth0.checkSession({responseType:"token id_token",scope:"openid profile email",connection:ssodataInformation.lastUsedConnection,timeout:5e3},(function(err,result){return err?"login_required"===err.error?cb(null,{sso:!1}):("consent_required"===err.error&&(err.error_description="Consent required. When using `getSSOData`, the user has to be authenticated with the following scope: `openid profile email`."),cb(err,{sso:!1})):ssodataInformation.lastUsedSub&&ssodataInformation.lastUsedSub!==result.idTokenPayload.sub?cb(err,{sso:!1}):cb(null,{lastUsedConnection:{name:ssodataInformation.lastUsedConnection},lastUsedUserID:result.idTokenPayload.sub,lastUsedUsername:result.idTokenPayload.email||result.idTokenPayload.name,lastUsedClientID:clientId,sessionClients:[clientId],sso:!0})}))},Authentication.prototype.userInfo=function(accessToken,cb){var url;return assert.check(accessToken,{type:"string",message:"accessToken parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"userinfo"),this.request.get(url).set("Authorization","Bearer "+accessToken).end(wrapCallback(cb,{ignoreCasing:!0}))},Authentication.prototype.getChallenge=function(cb){if(assert.check(cb,{type:"function",message:"cb parameter is not valid"}),!this.baseOptions.state)return cb();var url=urlJoin(this.baseOptions.rootUrl,"usernamepassword","challenge");return this.request.post(url).send({state:this.baseOptions.state}).end(wrapCallback(cb,{ignoreCasing:!0}))},Authentication.prototype.delegation=function(options,cb){var url,body;return assert.check(options,{type:"object",message:"options parameter is not valid"},{grant_type:{type:"string",message:"grant_type option is required"}}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"delegation"),body=objectHelper.merge(this.baseOptions,["clientID"]).with(options),body=objectHelper.toSnakeCase(body,["auth0Client"]),this.request.post(url).send(body).end(wrapCallback(cb))},Authentication.prototype.getUserCountry=function(cb){var url;return assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"user","geoloc","country"),this.request.get(url).end(wrapCallback(cb))},Management.prototype.getUser=function(userId,cb){var url;return assert.check(userId,{type:"string",message:"userId parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"users",userId),this.request.get(url).end(wrapCallback(cb,{ignoreCasing:!0}))},Management.prototype.patchUserMetadata=function(userId,userMetadata,cb){var url;return assert.check(userId,{type:"string",message:"userId parameter is not valid"}),assert.check(userMetadata,{type:"object",message:"userMetadata parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"users",userId),this.request.patch(url).send({user_metadata:userMetadata}).end(wrapCallback(cb,{ignoreCasing:!0}))},Management.prototype.patchUserAttributes=function(userId,user,cb){var url;return assert.check(userId,{type:"string",message:"userId parameter is not valid"}),assert.check(user,{type:"object",message:"user parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"users",userId),this.request.patch(url).send(user).end(wrapCallback(cb,{ignoreCasing:!0}))},Management.prototype.linkUser=function(userId,secondaryUserToken,cb){var url;return assert.check(userId,{type:"string",message:"userId parameter is not valid"}),assert.check(secondaryUserToken,{type:"string",message:"secondaryUserToken parameter is not valid"}),assert.check(cb,{type:"function",message:"cb parameter is not valid"}),url=urlJoin(this.baseOptions.rootUrl,"users",userId,"identities"),this.request.post(url).send({link_with:secondaryUserToken}).end(wrapCallback(cb,{ignoreCasing:!0}))};var index={Authentication:Authentication,Management:Management,WebAuth:WebAuth,version:version};/* harmony default export */ var auth0_min_esm = ((/* unused pure expression or super */ null && (index)));
//# sourceMappingURL=auth0.min.esm.js.map

// EXTERNAL MODULE: ../../../node_modules/broadcast-channel/dist/esbrowser/broadcast-channel.js + 8 modules
var broadcast_channel = __webpack_require__(75280);
// EXTERNAL MODULE: ../../../node_modules/tiny-emitter/index.js
var tiny_emitter = __webpack_require__(90567);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var stringify_i = 0; stringify_i < 256; ++stringify_i) {
  byteToHex.push((stringify_i + 0x100).toString(16).substr(1));
}

function stringify_stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify_stringify);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/getUserFromAPI.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

var devURL = 'https://api.lendi-dev.net';
var stagingURL = 'https://api.lendi-stg.net';
var prodURL = 'https://api.lendi.com.au';
var preProdURL = 'https://api.lendi-preprod.net';
var apiPath = '/v1/customers/me';
var getAPIBaseURL = function (env) {
    switch (env) {
        case esm/* Environment.Development */.qA.Development:
        default:
            return devURL;
        case esm/* Environment.Production */.qA.Production:
            return prodURL;
        case esm/* Environment.Preproduction */.qA.Preproduction:
            return preProdURL;
        case esm/* Environment.Staging */.qA.Staging:
            return stagingURL;
    }
};
function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts && parts.length === 2) {
        var poppedPart = parts.pop() || '';
        return poppedPart.split(';').shift() || '';
    }
    else {
        return '';
    }
}
function getUserFromAPI(environment, token) {
    return __awaiter(this, void 0, void 0, function () {
        var baseURL, user, apiData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    baseURL = getAPIBaseURL(environment);
                    return [4 /*yield*/, fetch("".concat(baseURL).concat(apiPath), {
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                'Content-Type': 'application/json',
                            },
                        })];
                case 1:
                    user = _a.sent();
                    return [4 /*yield*/, user.json()];
                case 2:
                    apiData = _a.sent();
                    return [2 /*return*/, apiData.data];
            }
        });
    });
}
//# sourceMappingURL=getUserFromAPI.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/MeSessionStorage.js
var ME_STORAGE_VERSION = 2;
var ME_STORAGE_KEY = 'lendi_me';
var saveMeToStorage = function (_a) {
    var firstName = _a.firstName, phone = _a.phone, email = _a.email, ownerId = _a.ownerId, storeId = _a.storeId;
    sessionStorage.setItem(ME_STORAGE_KEY, JSON.stringify({
        firstName: firstName,
        phone: phone,
        email: email,
        ownerId: ownerId,
        storeId: storeId,
        version: ME_STORAGE_VERSION,
    }));
};
var getMeFromStorage = function () {
    try {
        var me = JSON.parse(sessionStorage.getItem(ME_STORAGE_KEY) || '{}');
        if (me.version === ME_STORAGE_VERSION) {
            return me;
        }
        return undefined;
    }
    catch (e) {
        return undefined;
    }
};
//# sourceMappingURL=MeSessionStorage.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/Session.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Session_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var Session_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};











var EXPIRED_WITHIN_LIMIT = 120000; // 2 minutes
function isAuthenticatedState(state) {
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return state.token !== undefined;
}
function isUnauthenticatedState(state) {
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return state === undefined;
}
/**
 * Session defines and instantiates the connection with our authentication service
 *
 * @export
 * @class Session
 */
var Session = /** @class */ (function () {
    /**
     * Creates an instance of Session.
     * @param {SessionOptions} options
     * @memberof Session
     */
    function Session(options) {
        this._emitter = new tiny_emitter.TinyEmitter();
        /**
         * If the environment is test then we use simulate type so that our tests do not break
         * as referenced here: https://github.com/pubkey/broadcast-channel/issues/8
         * using simulate is documented here: https://github.com/pubkey/broadcast-channel#methods
         */
        this._lalaChannel = new broadcast_channel/* BroadcastChannel */.g0('lala', __assign({}, ( false && 0)));
        this.responseType = 'token id_token';
        this.uuidregex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        var environment = options.environment, brand = options.brand, type = options.type, scope = options.scope, audience = options.audience, forceRefresh = options.forceRefresh, lendiGroupTeamView = options.lendiGroupTeamView;
        // tslint:disable-next-line no-console
        console.log('Construct session', {
            environment: environment,
            brand: brand,
            type: type,
            scope: scope,
            audience: audience,
            forceRefresh: forceRefresh,
            lendiGroupTeamView: lendiGroupTeamView,
            logV: '1.7',
        });
        this.environment = environment;
        this.type = type;
        this.brand = brand;
        this.lendiGroupTeamView = lendiGroupTeamView;
        var domain = (0,esm/* getDomain */.ge)(this.brand, this.type, this.environment);
        var clientID = (0,esm/* getClientID */.kU)(this.brand, this.type, this.environment);
        var apiAudience = audience || (0,esm/* getAudience */.KG)(environment);
        this.auth0 = new WebAuth({
            domain: domain,
            clientID: clientID,
            scope: scope,
            audience: apiAudience,
            responseType: this.responseType,
            redirectUri: (0,esm/* getURLs */.D$)(this.brand, this.type, this.environment, lendiGroupTeamView).callback,
        });
        var state = (0,esm/* getStateFromStorage */.Fi)();
        /* tslint:disable:no-floating-promises */
        this.init(state, forceRefresh)
            .then(function () { return esm/* LalaSentry.logToSentry */.GG.logToSentry('authentication successful'); })
            .catch(function (err) { return esm/* LalaSentry.captureException */.GG.captureException(err); });
    }
    Session.prototype.on = function (event, listener) {
        this._emitter.on(event, listener);
        return this;
    };
    Session.prototype.off = function (event, listener) {
        this._emitter.off(event, listener);
        return this;
    };
    Session.prototype.handleLalaBroadcastMessage = function (state) {
        (0,esm/* setStateInStorage */.Dt)(state, false);
        this.update(state);
    };
    Session.prototype.listenToBroadcastChannel = function () {
        this._lalaChannel.addEventListener('message', this.handleLalaBroadcastMessage.bind(this));
    };
    Session.prototype.stopListeningToBroadcastChannel = function () {
        this._lalaChannel.removeEventListener('message', this.handleLalaBroadcastMessage.bind(this));
        // tslint:disable-next-line: no-floating-promises
        this._lalaChannel.close();
    };
    Object.defineProperty(Session.prototype, "status", {
        /**
         * The status of the session
         */
        get: function () {
            return this._status || types_Status.Authenticating;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "expiry", {
        /**
         * If there is a time when the session is going to expire, it is returned
         */
        get: function () {
            return this._expiry;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "token", {
        /**
         * The access token for the session
         */
        get: function () {
            return this._token;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "identity", {
        /**
         * Details about the identity authenticated by this session
         */
        get: function () {
            return this._identity;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Session.prototype, "error", {
        get: function () {
            return this._error;
        },
        enumerable: false,
        configurable: true
    });
    Session.prototype.reset = function () {
        this._expiry = undefined;
        this._token = undefined;
        this._identity = undefined;
        this._error = undefined;
        js_cookie.set(esm/* LG_APP_AUTH_SESSION_COOKIE_NAME */.Vf, '', { expires: new Date(Date.now() - 1) });
        esm/* LalaSentry.logInfo */.GG.logInfo('Reset done.');
    };
    Session.prototype.login = function (state) {
        var _this = this;
        this.update(state);
        if (this.token && isAuthenticatedState(state)) {
            getUserFromAPI(this.environment, this.token)
                .then(function (user) {
                saveMeToStorage(__assign(__assign({}, user), { phone: user.mobileNumber }));
            })
                .catch(function (e) {
                var _a;
                esm/* LalaSentry.logError */.GG.logError('login getUserFromAPI failed', {
                    userId: (_a = state === null || state === void 0 ? void 0 : state.identity) === null || _a === void 0 ? void 0 : _a.id,
                    type: _this.type,
                    error: e,
                });
                // Swallow error, the application will
                // still run fine without this code.
            });
        }
    };
    // An extra step on initialisation is to check whether Auth0 considers the customer authenticated
    // this means that even if you change tab and we lose your sessionStorage we will still consider you authenticated
    Session.prototype.init = function (state, forceRefresh) {
        var _a;
        return Session_awaiter(this, void 0, void 0, function () {
            return Session_generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        esm/* LalaSentry.logInfo */.GG.logInfo('Initializing session...', { userId: (_a = state === null || state === void 0 ? void 0 : state.identity) === null || _a === void 0 ? void 0 : _a.id, type: this.type });
                        if (!(isUnauthenticatedState(state) && this.type !== esm/* Type.Team */.Dy.Team)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.refresh(undefined, undefined, forceRefresh)];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.update(state);
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Session.prototype.update = function (state) {
        var _this = this;
        var _a;
        esm/* LalaSentry.logInfo */.GG.logInfo('Updating session...', { userId: (_a = state === null || state === void 0 ? void 0 : state.identity) === null || _a === void 0 ? void 0 : _a.id });
        // This checks whether we are running this function on the backend and will set status as authenticating
        // This allows control to frontends to what should be shown irrespective of authentication status
        if (typeof window === 'undefined') {
            this.reset();
            this._status = types_Status.Authenticating;
            this._emitter.emit('session', {});
        }
        else if (isUnauthenticatedState(state)) {
            this.reset();
            this._status = types_Status.Unauthenticated;
            this._emitter.emit('session', {});
        }
        else if (isAuthenticatedState(state)) {
            var token = state.token, expiry = state.expiry, identity = state.identity;
            this._token = token;
            this._identity = identity;
            this._expiry = expiry;
            this._error = undefined;
            if (expiry <= Date.now()) {
                // checks if user expired recently within 2 mins, else we will call it out `unAuthenticated`
                if (expiry >= Date.now() - EXPIRED_WITHIN_LIMIT) {
                    this._status = types_Status.Expired;
                    this._emitter.emit('expire', {});
                }
                else {
                    this._status = types_Status.Unauthenticated;
                }
                js_cookie.set(esm/* LG_APP_AUTH_SESSION_COOKIE_NAME */.Vf, '', { expires: new Date(Date.now() - 1) });
            }
            else {
                this._status = types_Status.Authenticated;
                this._emitter.emit('session', {});
                var sessionId = esm_browser_v4();
                var id = (identity !== null && identity !== void 0 ? identity : {}).id;
                var defaultExpiryMilliSeconds = 8 * 60 * 60 * 1000;
                var expires = new Date((expiry || Date.now() + defaultExpiryMilliSeconds) - 1);
                js_cookie.set(esm/* LG_APP_AUTH_SESSION_COOKIE_NAME */.Vf, "".concat(sessionId, ",").concat(id), { expires: expires });
                if (expiry) {
                    window.clearTimeout(this.expiryTimeout);
                    this.expiryTimeout = window.setTimeout(function () {
                        _this._status = types_Status.Expired;
                        _this._emitter.emit('expire', {});
                        js_cookie.set(esm/* LG_APP_AUTH_SESSION_COOKIE_NAME */.Vf, '', { expires: new Date(Date.now() - 1) });
                    }, expiry - Date.now());
                }
            }
        }
        else {
            var error = state.error;
            this._status = types_Status.Errored;
            this._token = undefined;
            this._identity = undefined;
            this._expiry = undefined;
            this._error = error;
            this._emitter.emit('error', {});
        }
        esm/* LalaSentry.logInfo */.GG.logInfo('Session updated', { status: this._status });
    };
    Session.prototype.clearExpiry = function () {
        esm/* LalaSentry.logInfo */.GG.logInfo('Clearing expiry', { status: this._status });
        if (this._status === types_Status.Expired) {
            this._status = types_Status.Unauthenticated;
            this._emitter.emit('session', {});
        }
    };
    Session.prototype.getTokenValues = function (applicationId) {
        // typeof window === 'undefined' -> ssr support
        var pathname = typeof window !== 'undefined' ? window.location.pathname : '';
        var maybeapplicatinoid = pathname.split('/')[5];
        var applicationIdFromUrl = maybeapplicatinoid && this.uuidregex.test(maybeapplicatinoid) ? maybeapplicatinoid : undefined;
        /**
         * If there is a token,
         * then we need to stick to the values to token has defined,
         * no matter what the url says
         *
         * the url only serves for the fallback case - that is, in case, we don't have obtained a token yet
         */
        if (this.token) {
            var jwt = (0,jwt_decode_esm/* default */.Z)(this.token);
            return {
                customer: jwt['authorized-customer'],
                // if we got a param, we want exactly that application
                // else, if we are in TV already, make sure we get - at least - the current application back
                application: applicationId !== null && applicationId !== void 0 ? applicationId : applicationIdFromUrl,
                // even if we were in TV with a customer or M2M token, we'd never ask for a specific application or customer
                isTeamView: jwt['https://lendi/type'] === UserType.Team,
            };
        }
        // we are not in a refresh scenario yet, this is the first run
        return {
            customer: pathname.split('/')[3],
            // for the first-time flow, we never have a manual overwrite, we always get this from the url
            application: applicationIdFromUrl,
            isTeamView: (0,esm/* getTypeFromHostname */.bT)() === esm/* Type.Team */.Dy.Team,
        };
    };
    Session.prototype.refresh = function (audience, demandApplicationID, forceRefresh) {
        if (audience === void 0) { audience = (0,esm/* getAudience */.KG)(this.environment); }
        return Session_awaiter(this, void 0, void 0, function () {
            var state, _a, customerID, applicationID, isTeamView, sessionCookieValue, randomUUID, newState;
            var _this = this;
            return Session_generator(this, function (_b) {
                esm/* LalaSentry.logInfo */.GG.logInfo('Refreshing session...', { status: this._status });
                // auth0-js doesn't support any SSR and will cause the auth0.checkSession to break in the nextJS apps before it's mounted
                if (typeof window === 'undefined') {
                    this.reset();
                    this._status = types_Status.Authenticating;
                    this._emitter.emit('session', {});
                    return [2 /*return*/, Promise.reject()];
                }
                // if we don't have a status then set the state to Authenticating while we are awaiting check session
                if (this._status === undefined) {
                    this._status = types_Status.Authenticating;
                }
                _a = this.getTokenValues(demandApplicationID), customerID = _a.customer, applicationID = _a.application, isTeamView = _a.isTeamView;
                sessionCookieValue = js_cookie.get(esm/* LG_APP_AUTH_SESSION_COOKIE_NAME */.Vf);
                esm/* LalaSentry.logInfo */.GG.logInfo('Rejection check', { forceRefresh: forceRefresh, sessionCookieValue: sessionCookieValue, isTeamView: isTeamView });
                if (!forceRefresh && !sessionCookieValue && !isTeamView) {
                    (0,esm/* setStateInStorage */.Dt)(undefined);
                    this.update(undefined);
                    return [2 /*return*/, Promise.reject("Refresh cannot proceed! ".concat(forceRefresh, ", ").concat(sessionCookieValue))];
                }
                if (isTeamView && customerID) {
                    randomUUID = esm_browser_v4();
                    newState = customerID + '@@@' + randomUUID + (applicationID ? '$$$' + applicationID : '');
                    state = btoa(newState);
                }
                esm/* LalaSentry.logInfo */.GG.logInfo('Calling checkSession...', { status: this._status });
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.auth0.checkSession({ audience: audience, state: state }, function (error, result) {
                            if (error && error.code === 'login_required') {
                                (0,esm/* setStateInStorage */.Dt)(undefined);
                                _this.update(undefined);
                                reject();
                            }
                            else {
                                var state_1 = (0,esm/* getStateFromAuthResult */.aC)(error || undefined, result || undefined);
                                (0,esm/* setStateInStorage */.Dt)(state_1);
                                _this.login(state_1);
                                resolve(_this.token);
                            }
                        });
                    })];
            });
        });
    };
    Session.prototype.clearSession = function () {
        localStorage.clear();
        sessionStorage.clear();
        js_cookie.set(esm/* SAFETY_NET_COOKIE_NAME */.x7, 'false');
    };
    Session.prototype.logout = function () {
        var returnURL = (0,esm/* getURLs */.D$)(this.brand, this.type, this.environment).unauthenticated;
        this.auth0.logout({
            returnTo: returnURL,
        });
        this._status = types_Status.Unauthenticating;
        this.reset();
        this.clearSession();
        // Added setStateInStorage with false for broadcasting to keep existing functionality
        // But I guess it needs to be changed to true to log out the user from other tabs as well.
        (0,esm/* setStateInStorage */.Dt)(undefined, false);
        // notify listeners that the session has ended
        this._emitter.emit('logout', {});
    };
    Session.prototype.DEPRECATED_RESET = function () {
        (0,esm/* setStateInStorage */.Dt)(undefined);
        this.reset();
        this._emitter.emit('logout', {});
    };
    /**
     * @private
     * Avoid directly calling this method in a application that isn't a login page because there
     * may be some slight changes if the auth implementation changes e.g. Auth0 => Cognito
     */
    Session.prototype.sendCode = function (phoneNumber) {
        return Session_awaiter(this, void 0, void 0, function () {
            var _this = this;
            return Session_generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.auth0.passwordlessStart({
                            connection: 'sms',
                            send: 'code',
                            phoneNumber: phoneNumber,
                        }, function (err) {
                            if (err) {
                                // tslint:disable-next-line: no-unnecessary-type-assertion
                                var error = (0,esm/* getStateFromAuthResult */.aC)(err, undefined).error;
                                reject(error);
                                return;
                            }
                            resolve();
                        });
                    })];
            });
        });
    };
    /**
     * @private
     * Avoid directly calling this method in a application that isn't a login page because there
     * may be some slight changes if the auth implementation changes e.g. Auth0 => Cognito
     */
    Session.prototype.verifyCode = function (_a) {
        var phone = _a.phone, code = _a.code, email = _a.email, leadId = _a.leadId, firstName = _a.firstName;
        return Session_awaiter(this, void 0, void 0, function () {
            var _this = this;
            return Session_generator(this, function (_b) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var callback = function (error, result) {
                            esm/* LalaSentry.logInfo */.GG.logInfo('VerifyCode callback', { error: error });
                            var state = (0,esm/* getStateFromAuthResult */.aC)(error || undefined, result || undefined);
                            (0,esm/* setStateInStorage */.Dt)(state);
                            _this.login(state);
                            if (state) {
                                if (isAuthenticatedState(state)) {
                                    resolve({ valid: true, token: state.token });
                                }
                                else if (isUnauthenticatedState(state)) {
                                    // unreachable code, getStateFromAuthResult never returns undefined
                                    esm/* LalaSentry.logInfo */.GG.logInfo('isUnauthenticatedState is true!');
                                    resolve({ valid: true });
                                }
                                else {
                                    reject(state.error);
                                }
                            }
                            else {
                                // unreachable code, getStateFromAuthResult never returns undefined
                                esm/* LalaSentry.logInfo */.GG.logInfo('undefined state!');
                                resolve({ valid: false });
                            }
                        };
                        var state = btoa(email + '@@@' + (leadId ? leadId + '###' : '') + (firstName ? firstName + '$$$' : '') + esm_browser_v4());
                        esm/* LalaSentry.logInfo */.GG.logInfo('VerifyCode');
                        /*
                          loginWithCredentials() instead of passwordlessLogin() is a hack from
                          Auth0 to prevent the user being redirected
                        */
                        _this.auth0.popup.loginWithCredentials({
                            connection: 'sms',
                            username: phone,
                            password: code,
                            state: state,
                        }, callback);
                    })];
            });
        });
    };
    /**
     * @private
     * Avoid directly calling this method in a application that isn't a login page because there
     * may be some slight changes if the auth implementation changes e.g. Auth0 => Cognito
     */
    Session.prototype.popupAuthorise = function (_a) {
        var _this = this;
        var connection = _a.connection, audience = _a.audience, scope = _a.scope, returnURL = _a.returnURL, state = _a.state, loginHint = _a.loginHint;
        return new Promise(function (resolve, reject) {
            var callback = function (error, result) {
                var state = (0,esm/* getStateFromAuthResult */.aC)(error || undefined, result || undefined);
                // auth0 returns an error when user closes google popup window and we want to leave state unchanged
                if (error) {
                    var errorState = state;
                    if (errorState.error.code === esm/* ErrorCodes.POPUP_CLOSED */.SM.POPUP_CLOSED) {
                        esm/* LalaSentry.logError */.GG.logError('SSO failed!', { errorCode: errorState.error.code, error: errorState.error });
                        reject(errorState.error);
                        return;
                    }
                }
                esm/* LalaSentry.logInfo */.GG.logInfo('SSO auth passed.');
                (0,esm/* setStateInStorage */.Dt)(state);
                _this.login(state);
                if (state) {
                    if (isAuthenticatedState(state)) {
                        resolve({ existingCustomer: state.identity.existingUser, token: state.token });
                    }
                    else if (isUnauthenticatedState(state)) {
                        resolve(undefined);
                    }
                    else {
                        reject(state.error);
                    }
                }
                else {
                    reject(new esm/* GenericError */.pY());
                }
            };
            if (returnURL) {
                (0,esm/* setReturnURLInStorage */.nx)(returnURL);
            }
            _this.auth0.popup.authorize(__assign({ redirectUri: "".concat((0,esm/* getURLs */.D$)(_this.brand, _this.type, _this.environment).popupCallback), connection: connection, audience: audience || (0,esm/* getAudience */.KG)(_this.environment), scope: scope, state: state, prompt: 'select_account', responseType: 'token id_token' }, (loginHint && { login_hint: loginHint })), callback);
        });
    };
    /**
     * @private
     * Avoid directly calling this method in a application that isn't a login page because there
     * may be some slight changes if the auth implementation changes e.g. Auth0 => Cognito
     */
    Session.prototype.popupAuthoriseWithoutSetSession = function (_a) {
        var _this = this;
        var connection = _a.connection, audience = _a.audience, scope = _a.scope, state = _a.state;
        return new Promise(function (resolve, reject) {
            var callback = function (error, result) {
                esm/* LalaSentry.logInfo */.GG.logInfo('SSO auth done without set session.', { error: error });
                if (result) {
                    var accessToken = result.accessToken, idTokenPayload = result.idTokenPayload;
                    resolve({ token: accessToken, idTokenPayload: idTokenPayload });
                }
                else {
                    reject(new esm/* GenericError */.pY());
                }
            };
            _this.auth0.popup.authorize({
                redirectUri: "".concat((0,esm/* getURLs */.D$)(_this.brand, _this.type, _this.environment).popupCallback),
                connection: connection,
                audience: audience || (0,esm/* getAudience */.KG)(_this.environment),
                scope: scope,
                state: state,
                responseType: _this.responseType,
            }, callback);
        });
    };
    /**
     * @private
     * Avoid directly calling this method in a application that isn't a login page because there
     * may be some slight changes if the auth implementation changes e.g. Auth0 => Cognito
     */
    Session.prototype.authorise = function (_a) {
        var connection = _a.connection, audience = _a.audience, scope = _a.scope, returnURL = _a.returnURL, state = _a.state;
        esm/* LalaSentry.logInfo */.GG.logInfo('authorise called.', { returnURL: returnURL });
        if (returnURL) {
            (0,esm/* setReturnURLInStorage */.nx)(returnURL);
        }
        this.auth0.authorize({
            connection: connection,
            audience: audience || (0,esm/* getAudience */.KG)(this.environment),
            scope: scope,
            state: state,
        });
    };
    return Session;
}());

//# sourceMappingURL=Session.js.map
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/Context.js

var Context = react.createContext(undefined);
//# sourceMappingURL=Context.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/MockSession.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var MockSession_assign = (undefined && undefined.__assign) || function () {
    MockSession_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return MockSession_assign.apply(this, arguments);
};
var MockSession_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var MockSession_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



var mockSessionOptions = {
    brand: esm/* Brand.Lendi */.H2.Lendi,
    type: esm/* Type.Customer */.Dy.Customer,
    environment: esm/* Environment.Production */.qA.Production,
};
var mockIdentity = {
    id: 'mock-identity-id',
};
var VerifyCodeResult;
(function (VerifyCodeResult) {
    VerifyCodeResult[VerifyCodeResult["Authenticated"] = 0] = "Authenticated";
    VerifyCodeResult[VerifyCodeResult["Errored"] = 1] = "Errored";
    VerifyCodeResult[VerifyCodeResult["Denied"] = 2] = "Denied";
})(VerifyCodeResult || (VerifyCodeResult = {}));
/**
 * MockSession provides access to private Session properties
 *
 * @export
 * @class MockSession
 * @extends {Session}
 */
var MockSession = /** @class */ (function (_super) {
    __extends(MockSession, _super);
    /**
     * Creates an instance of MockSession.
     * Default session options are Lendi-Customer-Production
     * @param {SessionOptions} [options=mockSessionOptions]
     * @memberof MockSession
     */
    function MockSession(options, identity) {
        if (options === void 0) { options = mockSessionOptions; }
        if (identity === void 0) { identity = mockIdentity; }
        var _this = _super.call(this, MockSession_assign(MockSession_assign({}, options), { forceRefresh: true })) || this;
        _this._verifyResult = VerifyCodeResult.Authenticated;
        _this._identity = identity;
        return _this;
    }
    Object.defineProperty(MockSession.prototype, "emitter", {
        get: function () {
            return this._emitter;
        },
        enumerable: false,
        configurable: true
    });
    MockSession.prototype.setStatus = function (status) {
        this._status = status;
    };
    MockSession.prototype.setExpiry = function (expiry) {
        this._expiry = expiry;
    };
    MockSession.prototype.setToken = function (token) {
        this._token = token;
    };
    Object.defineProperty(MockSession.prototype, "error", {
        get: function () {
            return this._error;
        },
        enumerable: false,
        configurable: true
    });
    MockSession.prototype.setError = function (error) {
        this._error = error;
    };
    Object.defineProperty(MockSession.prototype, "verifyResult", {
        set: function (result) {
            if (this._error === undefined)
                this._error = new esm/* GenericError */.pY();
            this._verifyResult = result;
        },
        enumerable: false,
        configurable: true
    });
    MockSession.prototype.clearExpiry = function () {
        if (this._status === types_Status.Expired) {
            this._status = types_Status.Unauthenticated;
        }
    };
    MockSession.prototype.sendCode = function (phoneNumber) {
        if (phoneNumber === void 0) { phoneNumber = '123456'; }
        return MockSession_awaiter(this, void 0, void 0, function () {
            return MockSession_generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    MockSession.prototype.verifyCode = function (_a) {
        var _b = _a === void 0 ? {
            phone: '123456',
            code: '654321',
            email: 'ab@cd.ef',
        } : _a, phone = _b.phone, code = _b.code, email = _b.email;
        return MockSession_awaiter(this, void 0, void 0, function () {
            return MockSession_generator(this, function (_c) {
                if (this._verifyResult === VerifyCodeResult.Errored) {
                    return [2 /*return*/, Promise.reject(this.error)];
                }
                return [2 /*return*/, Promise.resolve({ valid: this._verifyResult === VerifyCodeResult.Authenticated })];
            });
        });
    };
    MockSession.prototype.popupAuthorise = function (props) {
        return MockSession_awaiter(this, void 0, void 0, function () {
            return MockSession_generator(this, function (_a) {
                if (this._error) {
                    return [2 /*return*/, Promise.reject(this._error)];
                }
                return [2 /*return*/, Promise.resolve(this._token ? { existingCustomer: false, token: this._token } : undefined)];
            });
        });
    };
    MockSession.prototype.popupAuthoriseWithoutSetSession = function (props) {
        return MockSession_awaiter(this, void 0, void 0, function () {
            return MockSession_generator(this, function (_a) {
                if (this._error) {
                    return [2 /*return*/, Promise.reject(this._error)];
                }
                return [2 /*return*/, Promise.resolve(this._token ? { token: this._token, idTokenPayload: {} } : undefined)];
            });
        });
    };
    return MockSession;
}(Session));

//# sourceMappingURL=MockSession.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/SessionProvider.js





var nonProductionDomain = [
    /^localhost$/,
    /^www\.lendi\.com\.au\.local$/,
    /^(www|team)\.lendi-(dev|stg)\.net$/,
    /^[^\/]+\.lendi-paas-(dev|stg)\.net$/,
];
var mockAuthenticatedOutsideProduction = function (session, mockAuthenticated) {
    var isMockAuthenticated = typeof mockAuthenticated === 'function' ? mockAuthenticated() : mockAuthenticated;
    if (isMockAuthenticated &&
        typeof window !== 'undefined' &&
        nonProductionDomain.find(function (regex) { return window.location.hostname.match(regex); })) {
        var mockSession = new MockSession({
            brand: session.brand,
            type: session.type,
            environment: session.environment,
        });
        mockSession.setStatus(types_Status.Authenticated);
        return mockSession;
    }
    return session;
};
/**
 * This component is responsible for maintaining state about the auth session and passing it deep into the
 *  UI tree via the react context
 */
var SessionProvider = function (_a) {
    var session = _a.session, developAsAuthenticated = _a.developAsAuthenticated, children = _a.children;
    var internalSession = react.useMemo(function () { return mockAuthenticatedOutsideProduction(session, developAsAuthenticated); }, []);
    var status = internalSession.status, error = internalSession.error, expiry = internalSession.expiry, token = internalSession.token, identity = internalSession.identity, lendiGroupTeamView = internalSession.lendiGroupTeamView;
    // Using LalaSentry makes NextJs app consumers unhappy :(
    // tslint:disable-next-line no-console
    console.log('Initializing session context in provider', { status: status, error: error, expiry: expiry, identity: identity, lendiGroupTeamView: lendiGroupTeamView });
    var _b = react.useState({ status: status, error: error, expiry: expiry, token: token, identity: identity }), state = _b[0], setState = _b[1];
    var update = function () {
        var status = internalSession.status, error = internalSession.error, expiry = internalSession.expiry, token = internalSession.token, identity = internalSession.identity;
        esm/* LalaSentry.logInfo */.GG.logInfo('Updating session context in provider', { status: status, error: error, expiry: expiry, identity: identity, lendiGroupTeamView: lendiGroupTeamView });
        setState({ status: status, error: error, expiry: expiry, token: token, identity: identity });
    };
    var savedSession = react.useRef(session);
    react.useEffect(function () {
        if (savedSession.current !== session) {
            esm/* LalaSentry.logError */.GG.logError('Changing the session');
            throw new Error('Changing the session is not supported at this time.');
        }
    }, [session]);
    react.useEffect(function () {
        internalSession.on('session', update);
        internalSession.on('logout', update);
        internalSession.on('expire', update);
        internalSession.on('error', update);
        internalSession.listenToBroadcastChannel();
        return function () {
            internalSession.off('session', update);
            internalSession.off('logout', update);
            internalSession.off('expire', update);
            internalSession.off('error', update);
            internalSession.stopListeningToBroadcastChannel();
        };
    }, []);
    return (react.createElement(Context.Provider, { value: {
            status: state.status,
            error: state.error,
            expiry: state.expiry,
            token: state.token,
            identity: state.identity,
            brand: internalSession.brand,
            type: internalSession.type,
            environment: internalSession.environment,
            clearExpiry: function () { return internalSession.clearExpiry(); },
            refresh: function () { return internalSession.refresh(); },
            logout: function () { return internalSession.logout(); },
            DEPRECATED_RESET: function () { return internalSession.DEPRECATED_RESET(); },
            sendCode: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return internalSession.sendCode.apply(internalSession, args);
            },
            verifyCode: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return internalSession.verifyCode.apply(internalSession, args);
            },
            popupAuthorise: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return internalSession.popupAuthorise.apply(internalSession, args);
            },
            popupAuthoriseWithoutSetSession: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return internalSession.popupAuthoriseWithoutSetSession.apply(internalSession, args);
            },
            authorise: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return internalSession.authorise.apply(internalSession, args);
            },
            lendiGroupTeamView: lendiGroupTeamView,
        } }, children));
};
//# sourceMappingURL=SessionProvider.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/useSession.js


var useSession_useSession = function () {
    var session = react.useContext(Context);
    if (!session) {
        throw new Error('@lendi/lala-react: Please setup <SessionProvider/> in an ancestor component of the component using useSession().');
    }
    return session;
};
//# sourceMappingURL=useSession.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/useToken.js


var useToken = function () {
    var _a = useSession(), status = _a.status, token = _a.token;
    return status === Status.Authenticated ? token : undefined;
};
//# sourceMappingURL=useToken.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/SessionRefresh.js



var useEffect = react.useEffect, useRef = react.useRef;
var ONE_MINUTE = 1 * 60 * 1000;
function shouldRefresh(status) {
    return status === types_Status.Authenticated;
}
var SessionRefresh = function (_a) {
    var children = _a.children;
    var session = useSession_useSession();
    var status = session.status, refresh = session.refresh, expiry = session.expiry;
    var refreshInterval = useRef(undefined);
    useEffect(function () {
        var wasUserActivityInInterval = false;
        /**
         * Record that there was user activity since the last refresh
         */
        var handleUserActivity = function () {
            wasUserActivityInInterval = true;
        };
        /**
         * Refresh if there has been user activity since the last refresh
         */
        var handleInterval = function () {
            if (!wasUserActivityInInterval) {
                return;
            }
            refresh();
        };
        var start = function () {
            // start refreshing when the session status has changed to authenticated
            //  or the sessiwon is authenticated and the expiry has changed
            if (status !== types_Status.Authenticated || !expiry) {
                return;
            }
            window.addEventListener('click', handleUserActivity);
            window.addEventListener('keydown', handleUserActivity);
            window.addEventListener('mousemove', handleUserActivity);
            refreshInterval.current = window.setTimeout(handleInterval, expiry - Date.now() - ONE_MINUTE);
        };
        var stop = function () {
            // stop refreshing  when the session switches from authenticated to unauthenticated
            window.removeEventListener('click', handleUserActivity);
            window.removeEventListener('keydown', handleUserActivity);
            window.removeEventListener('mousemove', handleUserActivity);
            window.clearTimeout(refreshInterval.current);
        };
        if (shouldRefresh(status)) {
            start();
        }
        else {
            stop();
        }
        return function () { return stop(); };
    }, [status, refresh, expiry]);
    if (children !== null) {
        return react.createElement(react.Fragment, null, children);
    }
    return null;
};
//# sourceMappingURL=SessionRefresh.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/SessionRedirect.js
var SessionRedirect_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var SessionRedirect_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// https://www.lendi-dev.net/sign-in/email-safety-net/?returnURL=/v2/dashboard/





var SessionRedirect_useEffect = react.useEffect;
var unAuthedStatuses = [types_Status.Unauthenticated, types_Status.Expired, types_Status.Errored];
function shouldRedirect(status, statuses) {
    return statuses.includes(status);
}
var encodeIfNotEncoded = function (returnURL) {
    return decodeURIComponent(returnURL) === returnURL ? encodeURIComponent(returnURL) : returnURL;
};
var getURL = function (session, redirectToRegisterPage, returnURL) {
    var brand = session.brand, type = session.type, environment = session.environment, lendiGroupTeamView = session.lendiGroupTeamView;
    var authURL = redirectToRegisterPage
        ? (0,esm/* getURLs */.D$)(brand, type, environment, lendiGroupTeamView).register
        : (0,esm/* getURLs */.D$)(brand, type, environment, lendiGroupTeamView).authenticate;
    if (returnURL) {
        return "".concat(authURL, "?returnURL=").concat(encodeIfNotEncoded(returnURL));
    }
    else {
        return authURL;
    }
};
var SessionRedirect = function (_a) {
    var _b = _a.statuses, statuses = _b === void 0 ? unAuthedStatuses : _b, children = _a.children, returnURL = _a.returnURL, redirectToRegisterPage = _a.redirectToRegisterPage, _c = _a.skipDoubleVerification, skipDoubleVerification = _c === void 0 ? false : _c, _d = _a.skipPostcodeCheck, skipPostcodeCheck = _d === void 0 ? false : _d;
    var session = useSession_useSession();
    var status = session.status, token = session.token, environment = session.environment, brand = session.brand, type = session.type, lendiGroupTeamView = session.lendiGroupTeamView;
    var _e = react.useState(false), postAuthCheckPassed = _e[0], setPostAuthCheckPassed = _e[1];
    SessionRedirect_useEffect(function () {
        if (shouldRedirect(status, statuses)) {
            window.location.assign(getURL(session, redirectToRegisterPage || false, returnURL));
        }
    }, [status]);
    SessionRedirect_useEffect(function () {
        var checkUserPostAuth = function () { return SessionRedirect_awaiter(void 0, void 0, void 0, function () {
            var user, bypassPostCode, emailSafetyNetNeeded, postCodeNeeded, redirectURL;
            var _a, _b, _c, _d;
            return SessionRedirect_generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!(status === types_Status.Authenticated)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getUserFromAPI(environment, token)];
                    case 1:
                        user = _e.sent();
                        if (!user) {
                            esm/* LalaSentry.logError */.GG.logError('Session redirect: user is not found which is a critical information to proceed');
                            setPostAuthCheckPassed(false);
                        }
                        else {
                            esm/* LalaSentry.logInfo */.GG.logInfo('checkUserPostAuth v2', {
                                verifiedEmail: user.emailVerified,
                                requireDoubleVerification: user.requireDoubleVerification,
                                ownerId: user.ownerId,
                                storeId: user.storeId,
                                skipDoubleVerification: skipDoubleVerification,
                                noPostcodeRedirection: skipPostcodeCheck,
                                brand: brand,
                                lendiGroupTeamView: lendiGroupTeamView,
                                state_postcode: (_a = user.state) === null || _a === void 0 ? void 0 : _a.postcode,
                                state_emailVerification: (_b = user.state) === null || _b === void 0 ? void 0 : _b.emailVerification,
                            });
                            bypassPostCode = localStorage.getItem(esm/* BYPASS_POSTCODE */.or) === 'true';
                            emailSafetyNetNeeded = !skipDoubleVerification && ((_c = user.state) === null || _c === void 0 ? void 0 : _c.emailVerification) === 'NEEDED';
                            postCodeNeeded = !skipPostcodeCheck && !bypassPostCode && ((_d = user.state) === null || _d === void 0 ? void 0 : _d.postcode) === 'NEEDED';
                            if (emailSafetyNetNeeded || postCodeNeeded) {
                                redirectURL = emailSafetyNetNeeded ? 'sign-in/email-safety-net/' : 'customer/suburb/';
                                esm/* LalaSentry.logInfo */.GG.logInfo('redirecting from SessionRedirect', {
                                    emailSafetyNetNeeded: emailSafetyNetNeeded,
                                    postCodeNeeded: postCodeNeeded,
                                    redirectURL: redirectURL,
                                });
                                window.location.assign("".concat((0,esm/* getURLs */.D$)(brand, type, environment, lendiGroupTeamView).origin).concat(redirectURL).concat(returnURL ? "?returnURL=".concat(encodeIfNotEncoded(returnURL)) : ''));
                            }
                            else
                                setPostAuthCheckPassed(true);
                        }
                        _e.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        var skipPostAuthCheck = (skipDoubleVerification && skipPostcodeCheck) || type !== esm/* Type.Customer */.Dy.Customer;
        if (skipPostAuthCheck) {
            setPostAuthCheckPassed(true);
        }
        else {
            checkUserPostAuth().catch(function (error) {
                esm/* LalaSentry.logError */.GG.logError('Session redirect: unable to double verify email:', { error: error });
                setPostAuthCheckPassed(false);
            });
        }
    }, [status, skipDoubleVerification, skipPostcodeCheck, type]);
    // @see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
    return statuses.includes(status) || !postAuthCheckPassed ? null : react.createElement(react.Fragment, null, children);
};
//# sourceMappingURL=SessionRedirect.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/IsAuthenticated.js
var IsAuthenticated_assign = (undefined && undefined.__assign) || function () {
    IsAuthenticated_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return IsAuthenticated_assign.apply(this, arguments);
};



var IsAuthenticated = function (_a) {
    var children = _a.children;
    var session = useSession();
    var status = session.status;
    if (![Status.Authenticated, Status.Unauthenticating].includes(status)) {
        return null;
    }
    // @see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
    return React.createElement(React.Fragment, null, typeof children === 'function' ? children(IsAuthenticated_assign({}, session)) : children);
};
//# sourceMappingURL=IsAuthenticated.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/IsNotAuthenticated.js



var IsNotAuthenticated = function (_a) {
    var children = _a.children;
    var status = useSession().status;
    if ([Status.Authenticated, Status.Unauthenticating].includes(status)) {
        return null;
    }
    // @see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
    return React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=IsNotAuthenticated.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/usePasswordlessAuthentication.js
var usePasswordlessAuthentication_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var usePasswordlessAuthentication_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




function usePasswordlessAuthentication() {
    var _this = this;
    var _a = useSession_useSession(), sendCode = _a.sendCode, verifyCode = _a.verifyCode;
    var _b = react.useState({
        status: undefined,
        error: undefined,
    }), state = _b[0], setState = _b[1];
    var send = function (phoneNumber) { return usePasswordlessAuthentication_awaiter(_this, void 0, void 0, function () {
        var error_1;
        return usePasswordlessAuthentication_generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setState({
                        status: PasswordlessAuthenticationStatus.Sending,
                        error: undefined,
                    });
                    return [4 /*yield*/, sendCode(phoneNumber)];
                case 1:
                    _a.sent();
                    setState({
                        status: PasswordlessAuthenticationStatus.Sent,
                        error: undefined,
                    });
                    return [2 /*return*/, Promise.resolve()];
                case 2:
                    error_1 = _a.sent();
                    setState({
                        status: PasswordlessAuthenticationStatus.Errored,
                        error: error_1,
                    });
                    return [2 /*return*/, Promise.reject(error_1)];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var verify = function (_a) {
        var phone = _a.phone, code = _a.code, email = _a.email, leadId = _a.leadId, firstName = _a.firstName;
        return usePasswordlessAuthentication_awaiter(_this, void 0, void 0, function () {
            var _b, valid, token, error_2;
            return usePasswordlessAuthentication_generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        esm/* LalaSentry.logInfo */.GG.logInfo('verifying in usePasswordlessAuthentication');
                        setState({
                            status: PasswordlessAuthenticationStatus.Verifying,
                            error: undefined,
                        });
                        return [4 /*yield*/, verifyCode({ phone: phone, code: code, email: email, leadId: leadId, firstName: firstName })];
                    case 1:
                        _b = _c.sent(), valid = _b.valid, token = _b.token;
                        setState({
                            status: valid ? PasswordlessAuthenticationStatus.Verified : PasswordlessAuthenticationStatus.Denied,
                            error: undefined,
                        });
                        return [2 /*return*/, valid ? Promise.resolve(token) : Promise.reject()];
                    case 2:
                        error_2 = _c.sent();
                        esm/* LalaSentry.logError */.GG.logError('Error on verifying in usePasswordlessAuthentication', { error: error_2 });
                        setState({
                            status: PasswordlessAuthenticationStatus.Errored,
                            error: error_2,
                        });
                        return [2 /*return*/, Promise.reject(error_2)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return {
        status: state.status,
        error: state.error,
        send: send,
        verify: verify,
    };
}
//# sourceMappingURL=usePasswordlessAuthentication.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/GoogleOneTapLogin/useScript.js
// copied from https://raw.githubusercontent.com/MSalmanTariq/react-google-one-tap-login/main/src/useScript.ts
// https://usehooks.com/useScript/

function useScript(src) {
    // Keep track of script status ("idle", "loading", "ready", "error")
    var _a = (0,react.useState)(src ? 'loading' : 'idle'), status = _a[0], setStatus = _a[1];
    (0,react.useEffect)(function () {
        // Allow falsy src value if waiting on other data needed for
        // constructing the script URL passed to this hook.
        if (!src) {
            setStatus('idle');
            return;
        }
        // Fetch existing script element by src
        // It may have been added by another intance of this hook
        var script = document.querySelector("script[src=\"".concat(src, "\"]"));
        if (!script) {
            // Create script
            script = document.createElement('script');
            script.src = src;
            script.async = true;
            script.setAttribute('data-status', 'loading');
            // Add script to document body
            document.body.appendChild(script);
            // Store status in attribute on script
            // This can be read by other instances of this hook
            var setAttributeFromEvent = function (event) {
                if (script) {
                    script.setAttribute('data-status', event.type === 'load' ? 'ready' : 'error');
                }
            };
            script.addEventListener('load', setAttributeFromEvent);
            script.addEventListener('error', setAttributeFromEvent);
        }
        else {
            // Grab existing script status from attribute and set to state.
            setStatus(script.getAttribute('data-status') || 'idle');
        }
        // Script event handler to update status in state
        // Note: Even if the script already exists we still need to add
        // event handlers to update the state for *this* hook instance.
        var setStateFromEvent = function (event) {
            setStatus(event.type === 'load' ? 'ready' : 'error');
        };
        // Add event listeners
        script.addEventListener('load', setStateFromEvent);
        script.addEventListener('error', setStateFromEvent);
        // Remove event listeners on cleanup
        return function () {
            if (script) {
                script.removeEventListener('load', setStateFromEvent);
                script.removeEventListener('error', setStateFromEvent);
            }
        };
    }, [src] // Only re-run effect if script src changes
    );
    return status;
}
//# sourceMappingURL=useScript.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/GoogleOneTapLogin/useGoogleOneTapLogin.js
// Copied from https://github.com/MSalmanTariq/react-google-one-tap-login/blob/main/src/useGoogleOneTapLogin.ts
var useGoogleOneTapLogin_assign = (undefined && undefined.__assign) || function () {
    useGoogleOneTapLogin_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return useGoogleOneTapLogin_assign.apply(this, arguments);
};


var scriptFlag = '__googleOneTapScript__';
var googleClientScriptURL = 'https://accounts.google.com/gsi/client';
var oauthEndpointURL = 'https://oauth2.googleapis.com/tokeninfo?id_token=';
function callback(_a) {
    var data = _a.data, onError = _a.onError, onSuccess = _a.onSuccess;
    if (data === null || data === void 0 ? void 0 : data.credential) {
        fetch("".concat(oauthEndpointURL).concat(data.credential))
            .then(function (resp) {
            if ((resp === null || resp === void 0 ? void 0 : resp.status) === 200 && (resp === null || resp === void 0 ? void 0 : resp.json)) {
                return resp.json();
            }
            else {
                if (onError) {
                    onError();
                }
                throw new Error('Something went wrong');
            }
        })
            .then(function (resp) {
            if (onSuccess) {
                onSuccess(resp);
            }
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
            throw error;
        });
    }
}
function useGoogleOneTapLogin(_a) {
    var onError = _a.onError, disabled = _a.disabled, onSuccess = _a.onSuccess, onRender = _a.onRender, googleAccountConfigs = _a.googleAccountConfigs, _b = _a.disableCancelOnUnmount, disableCancelOnUnmount = _b === void 0 ? false : _b;
    var script = useScript(googleClientScriptURL);
    // Use the user's custom callback if they specified one; otherwise use the default one defined above:
    var callbackToUse = googleAccountConfigs.callback
        ? googleAccountConfigs.callback
        : function (data) { return callback({ data: data, onError: onError, onSuccess: onSuccess }); };
    (0,react.useEffect)(function () {
        if (!(window === null || window === void 0 ? void 0 : window[scriptFlag]) && window.google && script === 'ready') {
            // @ts-ignore
            window.google.accounts.id.initialize(useGoogleOneTapLogin_assign(useGoogleOneTapLogin_assign({}, googleAccountConfigs), { callback: callbackToUse }));
            window[scriptFlag] = true;
        }
        if ((window === null || window === void 0 ? void 0 : window[scriptFlag]) && script === 'ready') {
            if (!disabled) {
                // @ts-ignore
                window.google.accounts.id.prompt(function (notification) {
                    if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
                        // Uncomment the following line just for local dev to redisplay the popup even after the user closed it
                        // document.cookie = `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
                        // @ts-ignore
                        google.accounts.id.prompt();
                    }
                });
                if (onRender)
                    onRender();
            }
            else {
                // @ts-ignore
                window.google.accounts.id.cancel();
            }
            return function () {
                if (!disableCancelOnUnmount) {
                    // @ts-ignore
                    window.google.accounts.id.cancel();
                }
            };
        }
        return;
    }, [script, window === null || window === void 0 ? void 0 : window[scriptFlag], disabled]);
    return null;
}
//# sourceMappingURL=useGoogleOneTapLogin.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/GoogleOneTapLogin/index.js
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Copied from https://github.com/MSalmanTariq/react-google-one-tap-login


function GoogleOneTapLoginInternal(_a) {
    var _b = _a.children, children = _b === void 0 ? null : _b, props = __rest(_a, ["children"]);
    useGoogleOneTapLogin(props);
    return children;
}
var GoogleOneTapLogin = (0,react.memo)(GoogleOneTapLoginInternal);


//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/boot/init.js
var init = __webpack_require__(27627);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/getGlobalObject.js
var getGlobalObject = __webpack_require__(1692);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/context/contextManager.js
var contextManager = __webpack_require__(79217);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/boundedBuffer.js
var boundedBuffer = __webpack_require__(84554);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/mergeInto.js
var mergeInto = __webpack_require__(20377);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/timeUtils.js
var timeUtils = __webpack_require__(853);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/monitor.js
var monitor = __webpack_require__(93099);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/display.js
var display = __webpack_require__(42818);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/eventBridge.js
var eventBridge = __webpack_require__(52325);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/context/storedContextManager.js
var storedContextManager = __webpack_require__(7876);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/serialisation/sanitize.js
var sanitize = __webpack_require__(53185);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/user/user.js
var user = __webpack_require__(17662);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/polyfills.js
var polyfills = __webpack_require__(95959);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.js
var byteUtils = __webpack_require__(10160);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/configuration/configuration.js + 3 modules
var configuration_configuration = __webpack_require__(66869);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/report/reportObservable.js
var reportObservable = __webpack_require__(11954);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/arrayUtils.js
var arrayUtils = __webpack_require__(50985);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/domain/configuration.js

/**
 * arbitrary value, byte precision not needed
 */
var DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT = 32 * byteUtils/* ONE_KIBI_BYTE */.Hi;
function validateAndBuildLogsConfiguration(initConfiguration) {
    var baseConfiguration = (0,configuration_configuration/* validateAndBuildConfiguration */.fP)(initConfiguration);
    var forwardConsoleLogs = validateAndBuildForwardOption(initConfiguration.forwardConsoleLogs, (0,polyfills/* objectValues */.TT)(display/* ConsoleApiName */.vA), 'Forward Console Logs');
    var forwardReports = validateAndBuildForwardOption(initConfiguration.forwardReports, (0,polyfills/* objectValues */.TT)(reportObservable/* RawReportType */._), 'Forward Reports');
    if (!baseConfiguration || !forwardConsoleLogs || !forwardReports) {
        return;
    }
    if (initConfiguration.forwardErrorsToLogs && !(0,polyfills/* includes */.q9)(forwardConsoleLogs, display/* ConsoleApiName.error */.vA.error)) {
        forwardConsoleLogs.push(display/* ConsoleApiName.error */.vA.error);
    }
    return (0,polyfills/* assign */.f0)({
        forwardErrorsToLogs: initConfiguration.forwardErrorsToLogs !== false,
        forwardConsoleLogs: forwardConsoleLogs,
        forwardReports: forwardReports,
        requestErrorResponseLengthLimit: DEFAULT_REQUEST_ERROR_RESPONSE_LENGTH_LIMIT,
    }, baseConfiguration);
}
function validateAndBuildForwardOption(option, allowedValues, label) {
    if (option === undefined) {
        return [];
    }
    if (!(option === 'all' || (Array.isArray(option) && option.every(function (api) { return (0,polyfills/* includes */.q9)(allowedValues, api); })))) {
        display/* display.error */.jf.error("".concat(label, " should be \"all\" or an array with allowed values \"").concat(allowedValues.join('", "'), "\""));
        return;
    }
    return option === 'all' ? allowedValues : (0,arrayUtils/* removeDuplicates */.R)(option);
}
function serializeLogsConfiguration(configuration) {
    var baseSerializedInitConfiguration = (0,configuration_configuration/* serializeConfiguration */.JZ)(configuration);
    return (0,polyfills/* assign */.f0)({
        forward_errors_to_logs: configuration.forwardErrorsToLogs,
        forward_console_logs: configuration.forwardConsoleLogs,
        forward_reports: configuration.forwardReports,
    }, baseSerializedInitConfiguration);
}
//# sourceMappingURL=configuration.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.types.js
var error_types = __webpack_require__(10494);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/tracekit/computeStackTrace.js
var computeStackTrace = __webpack_require__(94856);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/error.js
var error_error = __webpack_require__(30331);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/domain/logger.js
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var StatusType = {
    debug: 'debug',
    error: 'error',
    info: 'info',
    warn: 'warn',
};
var HandlerType = {
    console: 'console',
    http: 'http',
    silent: 'silent',
};
var STATUSES = Object.keys(StatusType);
var Logger = /** @class */ (function () {
    function Logger(handleLogStrategy, name, handlerType, level, loggerContext) {
        if (handlerType === void 0) { handlerType = HandlerType.http; }
        if (level === void 0) { level = StatusType.debug; }
        if (loggerContext === void 0) { loggerContext = {}; }
        this.handleLogStrategy = handleLogStrategy;
        this.handlerType = handlerType;
        this.level = level;
        this.contextManager = (0,contextManager/* createContextManager */.W)(3 /* CustomerDataType.LoggerContext */);
        this.contextManager.set((0,polyfills/* assign */.f0)({}, loggerContext, name ? { logger: { name: name } } : undefined));
    }
    Logger.prototype.log = function (message, messageContext, status, error) {
        if (status === void 0) { status = StatusType.info; }
        var errorContext;
        if (status === StatusType.error) {
            // Always add origin if status is error (backward compatibility - Remove in next major)
            errorContext = { origin: error_types/* ErrorSource.LOGGER */.z.LOGGER };
        }
        if (error !== undefined && error !== null) {
            var stackTrace = error instanceof Error ? (0,computeStackTrace/* computeStackTrace */._)(error) : undefined;
            var rawError = (0,error_error/* computeRawError */.AP)({
                stackTrace: stackTrace,
                originalError: error,
                nonErrorPrefix: "Provided" /* NonErrorPrefix.PROVIDED */,
                source: error_types/* ErrorSource.LOGGER */.z.LOGGER,
                handling: "handled" /* ErrorHandling.HANDLED */,
                startClocks: (0,timeUtils/* clocksNow */.$I)(),
            });
            errorContext = {
                origin: error_types/* ErrorSource.LOGGER */.z.LOGGER,
                stack: rawError.stack,
                kind: rawError.type,
                message: rawError.message,
            };
        }
        var sanitizedMessageContext = (0,sanitize/* sanitize */.N)(messageContext);
        var context = errorContext
            ? (0,mergeInto/* combine */.$e)({ error: errorContext }, sanitizedMessageContext)
            : sanitizedMessageContext;
        this.handleLogStrategy({
            message: (0,sanitize/* sanitize */.N)(message),
            context: context,
            status: status,
        }, this);
    };
    Logger.prototype.debug = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.debug, error);
    };
    Logger.prototype.info = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.info, error);
    };
    Logger.prototype.warn = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.warn, error);
    };
    Logger.prototype.error = function (message, messageContext, error) {
        this.log(message, messageContext, StatusType.error, error);
    };
    Logger.prototype.setContext = function (context) {
        this.contextManager.set(context);
    };
    Logger.prototype.getContext = function () {
        return this.contextManager.get();
    };
    Logger.prototype.addContext = function (key, value) {
        this.contextManager.add(key, value);
    };
    Logger.prototype.removeContext = function (key) {
        this.contextManager.remove(key);
    };
    Logger.prototype.setHandler = function (handler) {
        this.handlerType = handler;
    };
    Logger.prototype.getHandler = function () {
        return this.handlerType;
    };
    Logger.prototype.setLevel = function (level) {
        this.level = level;
    };
    Logger.prototype.getLevel = function () {
        return this.level;
    };
    __decorate([
        monitor/* monitored */.Th
    ], Logger.prototype, "log", null);
    return Logger;
}());

//# sourceMappingURL=logger.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/boot/logsPublicApi.js



var LOGS_STORAGE_KEY = 'logs';
function makeLogsPublicApi(startLogsImpl) {
    var isAlreadyInitialized = false;
    var globalContextManager = (0,contextManager/* createContextManager */.W)(2 /* CustomerDataType.GlobalContext */);
    var userContextManager = (0,contextManager/* createContextManager */.W)(1 /* CustomerDataType.User */);
    var customLoggers = {};
    var getInternalContextStrategy = function () { return undefined; };
    var beforeInitLoggerLog = new boundedBuffer/* BoundedBuffer */.S();
    var handleLogStrategy = function (logsMessage, logger, savedCommonContext, date) {
        if (savedCommonContext === void 0) { savedCommonContext = (0,mergeInto/* deepClone */.I8)(buildCommonContext()); }
        if (date === void 0) { date = (0,timeUtils/* timeStampNow */.n$)(); }
        beforeInitLoggerLog.add(function () { return handleLogStrategy(logsMessage, logger, savedCommonContext, date); });
    };
    var getInitConfigurationStrategy = function () { return undefined; };
    var mainLogger = new Logger(function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        return handleLogStrategy.apply(void 0, params);
    });
    function buildCommonContext() {
        return {
            view: {
                referrer: document.referrer,
                url: window.location.href,
            },
            context: globalContextManager.getContext(),
            user: userContextManager.getContext(),
        };
    }
    return (0,init/* makePublicApi */.r)({
        logger: mainLogger,
        init: (0,monitor/* monitor */.zk)(function (initConfiguration) {
            var _a;
            if (!initConfiguration) {
                display/* display.error */.jf.error('Missing configuration');
                return;
            }
            // This function should be available, regardless of initialization success.
            getInitConfigurationStrategy = function () { return (0,mergeInto/* deepClone */.I8)(initConfiguration); };
            if ((0,eventBridge/* canUseEventBridge */.x)()) {
                initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
            }
            if (!canInitLogs(initConfiguration)) {
                return;
            }
            var configuration = validateAndBuildLogsConfiguration(initConfiguration);
            if (!configuration) {
                return;
            }
            if (initConfiguration.storeContextsAcrossPages) {
                var beforeInitGlobalContext = globalContextManager.getContext();
                globalContextManager = (0,storedContextManager/* createStoredContextManager */.PI)(configuration, LOGS_STORAGE_KEY, 2 /* CustomerDataType.GlobalContext */);
                globalContextManager.setContext((0,mergeInto/* combine */.$e)(globalContextManager.getContext(), beforeInitGlobalContext));
                var beforeInitUserContext = userContextManager.getContext();
                userContextManager = (0,storedContextManager/* createStoredContextManager */.PI)(configuration, LOGS_STORAGE_KEY, 1 /* CustomerDataType.User */);
                userContextManager.setContext((0,mergeInto/* combine */.$e)(userContextManager.getContext(), beforeInitUserContext));
            }
            ;
            (_a = startLogsImpl(initConfiguration, configuration, buildCommonContext, mainLogger), handleLogStrategy = _a.handleLog, getInternalContextStrategy = _a.getInternalContext);
            beforeInitLoggerLog.drain();
            isAlreadyInitialized = true;
        }),
        /** @deprecated: use getGlobalContext instead */
        getLoggerGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.get(); }),
        getGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.getContext(); }),
        /** @deprecated: use setGlobalContext instead */
        setLoggerGlobalContext: (0,monitor/* monitor */.zk)(function (context) { return globalContextManager.set(context); }),
        setGlobalContext: (0,monitor/* monitor */.zk)(function (context) { return globalContextManager.setContext(context); }),
        /** @deprecated: use setGlobalContextProperty instead */
        addLoggerGlobalContext: (0,monitor/* monitor */.zk)(function (key, value) { return globalContextManager.add(key, value); }),
        setGlobalContextProperty: (0,monitor/* monitor */.zk)(function (key, value) { return globalContextManager.setContextProperty(key, value); }),
        /** @deprecated: use removeGlobalContextProperty instead */
        removeLoggerGlobalContext: (0,monitor/* monitor */.zk)(function (key) { return globalContextManager.remove(key); }),
        removeGlobalContextProperty: (0,monitor/* monitor */.zk)(function (key) { return globalContextManager.removeContextProperty(key); }),
        clearGlobalContext: (0,monitor/* monitor */.zk)(function () { return globalContextManager.clearContext(); }),
        createLogger: (0,monitor/* monitor */.zk)(function (name, conf) {
            if (conf === void 0) { conf = {}; }
            customLoggers[name] = new Logger(function () {
                var params = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    params[_i] = arguments[_i];
                }
                return handleLogStrategy.apply(void 0, params);
            }, (0,sanitize/* sanitize */.N)(name), conf.handler, conf.level, (0,sanitize/* sanitize */.N)(conf.context));
            return customLoggers[name];
        }),
        getLogger: (0,monitor/* monitor */.zk)(function (name) { return customLoggers[name]; }),
        getInitConfiguration: (0,monitor/* monitor */.zk)(function () { return getInitConfigurationStrategy(); }),
        getInternalContext: (0,monitor/* monitor */.zk)(function (startTime) { return getInternalContextStrategy(startTime); }),
        setUser: (0,monitor/* monitor */.zk)(function (newUser) {
            if ((0,user/* checkUser */.z)(newUser)) {
                userContextManager.setContext((0,user/* sanitizeUser */.I)(newUser));
            }
        }),
        getUser: (0,monitor/* monitor */.zk)(function () { return userContextManager.getContext(); }),
        setUserProperty: (0,monitor/* monitor */.zk)(function (key, property) {
            var _a;
            var sanitizedProperty = (0,user/* sanitizeUser */.I)((_a = {}, _a[key] = property, _a))[key];
            userContextManager.setContextProperty(key, sanitizedProperty);
        }),
        removeUserProperty: (0,monitor/* monitor */.zk)(function (key) { return userContextManager.removeContextProperty(key); }),
        clearUser: (0,monitor/* monitor */.zk)(function () { return userContextManager.clearContext(); }),
    });
    function overrideInitConfigurationForBridge(initConfiguration) {
        return (0,polyfills/* assign */.f0)({}, initConfiguration, { clientToken: 'empty' });
    }
    function canInitLogs(initConfiguration) {
        if (isAlreadyInitialized) {
            if (!initConfiguration.silentMultipleInit) {
                display/* display.error */.jf.error('DD_LOGS is already initialized.');
            }
            return false;
        }
        return true;
    }
}
//# sourceMappingURL=logsPublicApi.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/sendToExtension.js
var sendToExtension = __webpack_require__(15017);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.js + 1 modules
var telemetry_telemetry = __webpack_require__(41887);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/pageExitObservable.js
var browser_pageExitObservable = __webpack_require__(19609);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/synthetics/syntheticsWorkerValues.js
var syntheticsWorkerValues = __webpack_require__(27478);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/transport/startBatchWithReplica.js + 2 modules
var startBatchWithReplica = __webpack_require__(22556);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/session/sessionManager.js
var session_sessionManager = __webpack_require__(42972);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/observable.js
var observable = __webpack_require__(87658);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.js
var numberUtils = __webpack_require__(76135);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/domain/logsSessionManager.js

var LOGS_SESSION_KEY = 'logs';
function startLogsSessionManager(configuration) {
    var sessionManager = (0,session_sessionManager/* startSessionManager */.HX)(configuration, LOGS_SESSION_KEY, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    return {
        findTrackedSession: function (startTime) {
            var session = sessionManager.findActiveSession(startTime);
            return session && session.trackingType === "1" /* LoggerTrackingType.TRACKED */
                ? {
                    id: session.id,
                }
                : undefined;
        },
        expireObservable: sessionManager.expireObservable,
    };
}
function startLogsSessionManagerStub(configuration) {
    var isTracked = computeTrackingType(configuration) === "1" /* LoggerTrackingType.TRACKED */;
    var session = isTracked ? {} : undefined;
    return {
        findTrackedSession: function () { return session; },
        expireObservable: new observable/* Observable */.y(),
    };
}
function computeTrackingType(configuration) {
    if (!(0,numberUtils/* performDraw */.y7)(configuration.sessionSampleRate)) {
        return "0" /* LoggerTrackingType.NOT_TRACKED */;
    }
    return "1" /* LoggerTrackingType.TRACKED */;
}
function computeSessionState(configuration, rawSessionType) {
    var trackingType = hasValidLoggerSession(rawSessionType) ? rawSessionType : computeTrackingType(configuration);
    return {
        trackingType: trackingType,
        isTracked: trackingType === "1" /* LoggerTrackingType.TRACKED */,
    };
}
function hasValidLoggerSession(trackingType) {
    return trackingType === "0" /* LoggerTrackingType.NOT_TRACKED */ || trackingType === "1" /* LoggerTrackingType.TRACKED */;
}
//# sourceMappingURL=logsSessionManager.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/eventRateLimiter/createEventRateLimiter.js
var createEventRateLimiter = __webpack_require__(76427);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.js
var objectUtils = __webpack_require__(47970);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/domain/logger/loggerCollection.js
var loggerCollection_a;


var STATUS_PRIORITIES = (loggerCollection_a = {},
    loggerCollection_a[StatusType.debug] = 0,
    loggerCollection_a[StatusType.info] = 1,
    loggerCollection_a[StatusType.warn] = 2,
    loggerCollection_a[StatusType.error] = 3,
    loggerCollection_a);
function startLoggerCollection(lifeCycle) {
    function handleLog(logsMessage, logger, savedCommonContext, savedDate) {
        var messageContext = logsMessage.context;
        if (isAuthorized(logsMessage.status, HandlerType.console, logger)) {
            displayInConsole(logsMessage, (0,mergeInto/* combine */.$e)(logger.getContext(), messageContext));
        }
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: savedDate || (0,timeUtils/* timeStampNow */.n$)(),
                message: logsMessage.message,
                status: logsMessage.status,
                origin: error_types/* ErrorSource.LOGGER */.z.LOGGER,
            },
            messageContext: messageContext,
            savedCommonContext: savedCommonContext,
            logger: logger,
        });
    }
    return {
        handleLog: handleLog,
    };
}
function isAuthorized(status, handlerType, logger) {
    var loggerHandler = logger.getHandler();
    var sanitizedHandlerType = Array.isArray(loggerHandler) ? loggerHandler : [loggerHandler];
    return (STATUS_PRIORITIES[status] >= STATUS_PRIORITIES[logger.getLevel()] && (0,polyfills/* includes */.q9)(sanitizedHandlerType, handlerType));
}
function displayInConsole(logsMessage, messageContext) {
    display/* originalConsoleMethods */.LD[logsMessage.status].call(display/* globalConsole */.jG, logsMessage.message, messageContext);
}
//# sourceMappingURL=loggerCollection.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/domain/assembly.js



function startLogsAssembly(sessionManager, configuration, lifeCycle, buildCommonContext, mainLogger, // Todo: [RUMF-1230] Remove this parameter in the next major release
reportError) {
    var statusWithCustom = STATUSES.concat(['custom']);
    var logRateLimiters = {};
    statusWithCustom.forEach(function (status) {
        logRateLimiters[status] = (0,createEventRateLimiter/* createEventRateLimiter */.K)(status, configuration.eventRateLimiterThreshold, reportError);
    });
    lifeCycle.subscribe(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, function (_a) {
        var _b, _c, _d;
        var rawLogsEvent = _a.rawLogsEvent, _e = _a.messageContext, messageContext = _e === void 0 ? undefined : _e, _f = _a.savedCommonContext, savedCommonContext = _f === void 0 ? undefined : _f, _g = _a.logger, logger = _g === void 0 ? mainLogger : _g;
        var startTime = (0,timeUtils/* getRelativeTime */.ni)(rawLogsEvent.date);
        var session = sessionManager.findTrackedSession(startTime);
        if (!session) {
            return;
        }
        var commonContext = savedCommonContext || buildCommonContext();
        var log = (0,mergeInto/* combine */.$e)({
            service: configuration.service,
            session_id: session.id,
            // Insert user first to allow overrides from global context
            usr: !(0,objectUtils/* isEmptyObject */.Qr)(commonContext.user) ? commonContext.user : undefined,
            view: commonContext.view,
        }, commonContext.context, getRUMInternalContext(startTime), rawLogsEvent, logger.getContext(), messageContext);
        if (
        // Todo: [RUMF-1230] Move this check to the logger collection in the next major release
        !isAuthorized(rawLogsEvent.status, HandlerType.http, logger) ||
            ((_b = configuration.beforeSend) === null || _b === void 0 ? void 0 : _b.call(configuration, log)) === false ||
            (((_c = log.error) === null || _c === void 0 ? void 0 : _c.origin) !== error_types/* ErrorSource.AGENT */.z.AGENT &&
                ((_d = logRateLimiters[log.status]) !== null && _d !== void 0 ? _d : logRateLimiters['custom']).isLimitReached())) {
            return;
        }
        lifeCycle.notify(1 /* LifeCycleEventType.LOG_COLLECTED */, log);
    });
}
var logsSentBeforeRumInjectionTelemetryAdded = false;
function getRUMInternalContext(startTime) {
    var browserWindow = window;
    if ((0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)()) {
        var context = getInternalContextFromRumGlobal(browserWindow.DD_RUM_SYNTHETICS);
        if (!context && !logsSentBeforeRumInjectionTelemetryAdded) {
            logsSentBeforeRumInjectionTelemetryAdded = true;
            (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Logs sent before RUM is injected by the synthetics worker', {
                testId: (0,syntheticsWorkerValues/* getSyntheticsTestId */.L7)(),
                resultId: (0,syntheticsWorkerValues/* getSyntheticsResultId */.QB)(),
            });
        }
        return context;
    }
    return getInternalContextFromRumGlobal(browserWindow.DD_RUM);
    function getInternalContextFromRumGlobal(rumGlobal) {
        if (rumGlobal && rumGlobal.getInternalContext) {
            return rumGlobal.getInternalContext(startTime);
        }
    }
}
function resetRUMInternalContext() {
    logsSentBeforeRumInjectionTelemetryAdded = false;
}
//# sourceMappingURL=assembly.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.js
var consoleObservable = __webpack_require__(78587);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/domain/console/consoleCollection.js
var consoleCollection_a;


var LogStatusForApi = (consoleCollection_a = {},
    consoleCollection_a[display/* ConsoleApiName.log */.vA.log] = StatusType.info,
    consoleCollection_a[display/* ConsoleApiName.debug */.vA.debug] = StatusType.debug,
    consoleCollection_a[display/* ConsoleApiName.info */.vA.info] = StatusType.info,
    consoleCollection_a[display/* ConsoleApiName.warn */.vA.warn] = StatusType.warn,
    consoleCollection_a[display/* ConsoleApiName.error */.vA.error] = StatusType.error,
    consoleCollection_a);
function startConsoleCollection(configuration, lifeCycle) {
    var consoleSubscription = (0,consoleObservable/* initConsoleObservable */.a)(configuration.forwardConsoleLogs).subscribe(function (log) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: (0,timeUtils/* timeStampNow */.n$)(),
                message: log.message,
                origin: error_types/* ErrorSource.CONSOLE */.z.CONSOLE,
                error: log.api === display/* ConsoleApiName.error */.vA.error
                    ? {
                        origin: error_types/* ErrorSource.CONSOLE */.z.CONSOLE,
                        stack: log.stack,
                        fingerprint: log.fingerprint,
                    }
                    : undefined,
                status: LogStatusForApi[log.api],
            },
        });
    });
    return {
        stop: function () {
            consoleSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=consoleCollection.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/domain/report/reportCollection.js
var reportCollection_a;


var LogStatusForReport = (reportCollection_a = {},
    reportCollection_a[reportObservable/* RawReportType.cspViolation */._.cspViolation] = StatusType.error,
    reportCollection_a[reportObservable/* RawReportType.intervention */._.intervention] = StatusType.error,
    reportCollection_a[reportObservable/* RawReportType.deprecation */._.deprecation] = StatusType.warn,
    reportCollection_a);
function startReportCollection(configuration, lifeCycle) {
    var reportSubscription = (0,reportObservable/* initReportObservable */.v)(configuration, configuration.forwardReports).subscribe(function (report) {
        var message = report.message;
        var status = LogStatusForReport[report.type];
        var error;
        if (status === StatusType.error) {
            error = {
                kind: report.subtype,
                origin: error_types/* ErrorSource.REPORT */.z.REPORT,
                stack: report.stack,
            };
        }
        else if (report.stack) {
            message += " Found in ".concat((0,error_error/* getFileFromStackTraceString */.u5)(report.stack));
        }
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                date: (0,timeUtils/* timeStampNow */.n$)(),
                message: message,
                origin: error_types/* ErrorSource.REPORT */.z.REPORT,
                error: error,
                status: status,
            },
        });
    });
    return {
        stop: function () {
            reportSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=reportCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.js
var functionUtils = __webpack_require__(84164);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/xhrObservable.js
var xhrObservable = __webpack_require__(76842);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/browser/fetchObservable.js
var fetchObservable = __webpack_require__(96817);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.js
var responseUtils = __webpack_require__(98744);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/readBytesFromStream.js
var readBytesFromStream = __webpack_require__(57717);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/domain/networkError/networkErrorCollection.js


function startNetworkErrorCollection(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) {
        return { stop: functionUtils/* noop */.Z };
    }
    var xhrSubscription = (0,xhrObservable/* initXhrObservable */.S)(configuration).subscribe(function (context) {
        if (context.state === 'complete') {
            handleResponse("xhr" /* RequestType.XHR */, context);
        }
    });
    var fetchSubscription = (0,fetchObservable/* initFetchObservable */.y)().subscribe(function (context) {
        if (context.state === 'resolve') {
            handleResponse("fetch" /* RequestType.FETCH */, context);
        }
    });
    function handleResponse(type, request) {
        if (!configuration.isIntakeUrl(request.url) && (isRejected(request) || (0,responseUtils/* isServerError */.o)(request.status))) {
            if ('xhr' in request) {
                computeXhrResponseData(request.xhr, configuration, onResponseDataAvailable);
            }
            else if (request.response) {
                computeFetchResponseText(request.response, configuration, onResponseDataAvailable);
            }
            else if (request.error) {
                computeFetchErrorText(request.error, configuration, onResponseDataAvailable);
            }
        }
        function onResponseDataAvailable(responseData) {
            lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
                rawLogsEvent: {
                    message: "".concat(format(type), " error ").concat(request.method, " ").concat(request.url),
                    date: request.startClocks.timeStamp,
                    error: {
                        origin: error_types/* ErrorSource.NETWORK */.z.NETWORK,
                        stack: responseData || 'Failed to load',
                    },
                    http: {
                        method: request.method,
                        status_code: request.status,
                        url: request.url,
                    },
                    status: StatusType.error,
                    origin: error_types/* ErrorSource.NETWORK */.z.NETWORK,
                },
            });
        }
    }
    return {
        stop: function () {
            xhrSubscription.unsubscribe();
            fetchSubscription.unsubscribe();
        },
    };
}
// TODO: ideally, computeXhrResponseData should always call the callback with a string instead of
// `unknown`. But to keep backward compatibility, in the case of XHR with a `responseType` different
// than "text", the response data should be whatever `xhr.response` is. This is a bit confusing as
// Logs event 'stack' is expected to be a string. This should be changed in a future major version
// as it could be a breaking change.
function computeXhrResponseData(xhr, configuration, callback) {
    if (typeof xhr.response === 'string') {
        callback(truncateResponseText(xhr.response, configuration));
    }
    else {
        callback(xhr.response);
    }
}
function computeFetchErrorText(error, configuration, callback) {
    callback(truncateResponseText((0,error_error/* toStackTraceString */.P3)((0,computeStackTrace/* computeStackTrace */._)(error)), configuration));
}
function computeFetchResponseText(response, configuration, callback) {
    var clonedResponse = (0,responseUtils/* tryToClone */.u)(response);
    if (!clonedResponse || !clonedResponse.body) {
        // if the clone failed or if the body is null, let's not try to read it.
        callback();
    }
    else if (!window.TextDecoder) {
        // If the browser doesn't support TextDecoder, let's read the whole response then truncate it.
        //
        // This should only be the case on early versions of Edge (before they migrated to Chromium).
        // Even if it could be possible to implement a workaround for the missing TextDecoder API (using
        // a Blob and FileReader), we found another issue preventing us from reading only the first
        // bytes from the response: contrary to other browsers, when reading from the cloned response,
        // if the original response gets canceled, the cloned response is also canceled and we can't
        // know about it.  In the following illustration, the promise returned by `reader.read()` may
        // never be fulfilled:
        //
        // fetch('/').then((response) => {
        //   const reader = response.clone().body.getReader()
        //   readMore()
        //   function readMore() {
        //     reader.read().then(
        //       (result) => {
        //         if (result.done) {
        //           console.log('done')
        //         } else {
        //           readMore()
        //         }
        //       },
        //       () => console.log('error')
        //     )
        //   }
        //   response.body.getReader().cancel()
        // })
        clonedResponse.text().then((0,monitor/* monitor */.zk)(function (text) { return callback(truncateResponseText(text, configuration)); }), (0,monitor/* monitor */.zk)(function (error) { return callback("Unable to retrieve response: ".concat(error)); }));
    }
    else {
        truncateResponseStream(clonedResponse.body, configuration.requestErrorResponseLengthLimit, function (error, responseText) {
            if (error) {
                callback("Unable to retrieve response: ".concat(error));
            }
            else {
                callback(responseText);
            }
        });
    }
}
function isRejected(request) {
    return request.status === 0 && request.responseType !== 'opaque';
}
function truncateResponseText(responseText, configuration) {
    if (responseText.length > configuration.requestErrorResponseLengthLimit) {
        return "".concat(responseText.substring(0, configuration.requestErrorResponseLengthLimit), "...");
    }
    return responseText;
}
function format(type) {
    if ("xhr" /* RequestType.XHR */ === type) {
        return 'XHR';
    }
    return 'Fetch';
}
function truncateResponseStream(stream, bytesLimit, callback) {
    (0,readBytesFromStream/* readBytesFromStream */.n)(stream, function (error, bytes, limitExceeded) {
        if (error) {
            callback(error);
        }
        else {
            var responseText = new TextDecoder().decode(bytes);
            if (limitExceeded) {
                responseText += '...';
            }
            callback(undefined, responseText);
        }
    }, {
        bytesLimit: bytesLimit,
        collectStreamBody: true,
    });
}
//# sourceMappingURL=networkErrorCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.js + 1 modules
var trackRuntimeError = __webpack_require__(80676);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/domain/runtimeError/runtimeErrorCollection.js


function startRuntimeErrorCollection(configuration, lifeCycle) {
    if (!configuration.forwardErrorsToLogs) {
        return { stop: functionUtils/* noop */.Z };
    }
    var rawErrorObservable = new observable/* Observable */.y();
    var stopRuntimeErrorTracking = (0,trackRuntimeError/* trackRuntimeError */.L)(rawErrorObservable).stop;
    var rawErrorSubscription = rawErrorObservable.subscribe(function (rawError) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: rawError.message,
                date: rawError.startClocks.timeStamp,
                error: {
                    kind: rawError.type,
                    origin: error_types/* ErrorSource.SOURCE */.z.SOURCE,
                    stack: rawError.stack,
                },
                origin: error_types/* ErrorSource.SOURCE */.z.SOURCE,
                status: StatusType.error,
            },
        });
    });
    return {
        stop: function () {
            stopRuntimeErrorTracking();
            rawErrorSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=runtimeErrorCollection.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-core/esm/tools/abstractLifeCycle.js
var abstractLifeCycle = __webpack_require__(77357);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/domain/lifeCycle.js

var LifeCycle = (abstractLifeCycle/* AbstractLifeCycle */.l);
//# sourceMappingURL=lifeCycle.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/transport/startLogsBatch.js

function startLogsBatch(configuration, lifeCycle, reportError, pageExitObservable, sessionExpireObservable) {
    var batch = (0,startBatchWithReplica/* startBatchWithReplica */.W)(configuration, {
        endpoint: configuration.logsEndpointBuilder,
    }, configuration.replica && {
        endpoint: configuration.replica.logsEndpointBuilder,
    }, reportError, pageExitObservable, sessionExpireObservable);
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */, function (serverLogsEvent) {
        batch.add(serverLogsEvent);
    });
    return batch;
}
//# sourceMappingURL=startLogsBatch.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/transport/startLogsBridge.js

function startLogsBridge(lifeCycle) {
    var bridge = (0,eventBridge/* getEventBridge */.A)();
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */, function (serverLogsEvent) {
        bridge.send('log', serverLogsEvent);
    });
}
//# sourceMappingURL=startLogsBridge.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/domain/internalContext.js
function startInternalContext(sessionManager) {
    return {
        get: function (startTime) {
            var trackedSession = sessionManager.findTrackedSession(startTime);
            if (trackedSession) {
                return {
                    session_id: trackedSession.id,
                };
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/boot/startLogs.js














function startLogs(initConfiguration, configuration, buildCommonContext, mainLogger) {
    var lifeCycle = new LifeCycle();
    var cleanupTasks = [];
    lifeCycle.subscribe(1 /* LifeCycleEventType.LOG_COLLECTED */, function (log) { return (0,sendToExtension/* sendToExtension */.j)('logs', log); });
    var reportError = function (error) {
        lifeCycle.notify(0 /* LifeCycleEventType.RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: error.message,
                date: error.startClocks.timeStamp,
                error: {
                    origin: error_types/* ErrorSource.AGENT */.z.AGENT, // Todo: Remove in the next major release
                },
                origin: error_types/* ErrorSource.AGENT */.z.AGENT,
                status: StatusType.error,
            },
        });
        (0,telemetry_telemetry/* addTelemetryDebug */.eJ)('Error reported to customer', { 'error.message': error.message });
    };
    var pageExitObservable = (0,browser_pageExitObservable/* createPageExitObservable */.Pd)(configuration);
    var session = configuration.sessionStoreStrategyType && !(0,eventBridge/* canUseEventBridge */.x)() && !(0,syntheticsWorkerValues/* willSyntheticsInjectRum */.Y9)()
        ? startLogsSessionManager(configuration)
        : startLogsSessionManagerStub(configuration);
    var _a = startLogsTelemetry(configuration, reportError, pageExitObservable, session.expireObservable), telemetry = _a.telemetry, stopLogsTelemetry = _a.stop;
    cleanupTasks.push(function () { return stopLogsTelemetry(); });
    telemetry.setContextProvider(function () {
        var _a, _b, _c, _d, _e, _f;
        return ({
            application: {
                id: (_a = getRUMInternalContext()) === null || _a === void 0 ? void 0 : _a.application_id,
            },
            session: {
                id: (_b = session.findTrackedSession()) === null || _b === void 0 ? void 0 : _b.id,
            },
            view: {
                id: (_d = (_c = getRUMInternalContext()) === null || _c === void 0 ? void 0 : _c.view) === null || _d === void 0 ? void 0 : _d.id,
            },
            action: {
                id: (_f = (_e = getRUMInternalContext()) === null || _e === void 0 ? void 0 : _e.user_action) === null || _f === void 0 ? void 0 : _f.id,
            },
        });
    });
    startNetworkErrorCollection(configuration, lifeCycle);
    startRuntimeErrorCollection(configuration, lifeCycle);
    startConsoleCollection(configuration, lifeCycle);
    startReportCollection(configuration, lifeCycle);
    var handleLog = startLoggerCollection(lifeCycle).handleLog;
    startLogsAssembly(session, configuration, lifeCycle, buildCommonContext, mainLogger, reportError);
    if (!(0,eventBridge/* canUseEventBridge */.x)()) {
        var stopLogsBatch_1 = startLogsBatch(configuration, lifeCycle, reportError, pageExitObservable, session.expireObservable).stop;
        cleanupTasks.push(function () { return stopLogsBatch_1(); });
    }
    else {
        startLogsBridge(lifeCycle);
    }
    (0,telemetry_telemetry/* addTelemetryConfiguration */.Uo)(serializeLogsConfiguration(initConfiguration));
    var internalContext = startInternalContext(session);
    return {
        handleLog: handleLog,
        getInternalContext: internalContext.get,
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
function startLogsTelemetry(configuration, reportError, pageExitObservable, sessionExpireObservable) {
    var telemetry = (0,telemetry_telemetry/* startTelemetry */.VL)("browser-logs-sdk" /* TelemetryService.LOGS */, configuration);
    var cleanupTasks = [];
    if ((0,eventBridge/* canUseEventBridge */.x)()) {
        var bridge_1 = (0,eventBridge/* getEventBridge */.A)();
        var telemetrySubscription_1 = telemetry.observable.subscribe(function (event) { return bridge_1.send('internal_telemetry', event); });
        cleanupTasks.push(function () { return telemetrySubscription_1.unsubscribe(); });
    }
    else {
        var telemetryBatch_1 = (0,startBatchWithReplica/* startBatchWithReplica */.W)(configuration, {
            endpoint: configuration.rumEndpointBuilder,
        }, configuration.replica && {
            endpoint: configuration.replica.rumEndpointBuilder,
        }, reportError, pageExitObservable, sessionExpireObservable);
        cleanupTasks.push(function () { return telemetryBatch_1.stop(); });
        var telemetrySubscription_2 = telemetry.observable.subscribe(function (event) {
            return telemetryBatch_1.add(event, (0,telemetry_telemetry/* isTelemetryReplicationAllowed */.VG)(configuration));
        });
        cleanupTasks.push(function () { return telemetrySubscription_2.unsubscribe(); });
    }
    return {
        telemetry: telemetry,
        stop: function () {
            cleanupTasks.forEach(function (task) { return task(); });
        },
    };
}
//# sourceMappingURL=startLogs.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@datadog/browser-logs/esm/entries/main.js




var datadogLogs = makeLogsPublicApi(startLogs);
(0,init/* defineGlobal */.y)((0,getGlobalObject/* getGlobalObject */.R)(), 'DD_LOGS', datadogLogs);
//# sourceMappingURL=main.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/initialize-logger/config.js
// set env vars used by the app
var datadogConfig = {
    applicationId: '06f787c5-114c-47ed-b589-b6e5fbe1c7a7',
    site: 'datadoghq.com',
    clientToken: 'pubc8838d3ffe6ce05a722407476b02a006',
    serviceId: 'lendigroup-leads-library',
};
//# sourceMappingURL=config.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/initialize-logger/index.js


var redactEmail = function (payload) { return payload.replace(/email=[^&]*/, 'email=REDACTED'); };
var redactName = function (payload) { return payload.replace(/name=[^&]*/, 'name=REDACTED'); };
var redactToken = function (payload) { return payload.replace(/access_token=[^&]*/, 'access_token=REDACTED'); };
var redactPII = function (payload) { return redactToken(redactName(redactEmail(payload))); };
var initializeLogger = function () {
    datadogLogs.init({
        clientToken: datadogConfig.clientToken,
        site: datadogConfig.site,
        service: datadogConfig.serviceId,
        forwardErrorsToLogs: false,
        sampleRate: 100,
        beforeSend: function (log) {
            var _a, _b, _c, _d, _e;
            // @ts-ignore
            if ((_b = (_a = log === null || log === void 0 ? void 0 : log.error) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.data) {
                // @ts-ignore
                log.error.config.data = undefined;
            }
            if ((_c = log === null || log === void 0 ? void 0 : log.view) === null || _c === void 0 ? void 0 : _c.url) {
                log.view.url = redactPII(log.view.url);
            }
            if ((_d = log === null || log === void 0 ? void 0 : log.http) === null || _d === void 0 ? void 0 : _d.url) {
                log.http.url = redactPII(log.http.url);
            }
            if ((_e = log === null || log === void 0 ? void 0 : log.view) === null || _e === void 0 ? void 0 : _e.referrer) {
                log.view.referrer = redactPII(log.view.referrer);
            }
        },
    });
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/ApplicantEntity.js
var ApplicantEntity_ApplicantEntity;
(function (ApplicantEntity) {
    ApplicantEntity["Person"] = "PERSON";
    ApplicantEntity["Company"] = "COMPANY";
    ApplicantEntity["Trust"] = "TRUST";
})(ApplicantEntity_ApplicantEntity || (ApplicantEntity_ApplicantEntity = {}));
//# sourceMappingURL=ApplicantEntity.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/ApplicantType.js
var ApplicantType_ApplicantType;
(function (ApplicantType) {
    ApplicantType["Borrower"] = "BORROWER";
    ApplicantType["BorrowerAndGuarantor"] = "BORROWER_AND_GUARANTOR";
    ApplicantType["Guarantor"] = "GUARANTOR";
})(ApplicantType_ApplicantType || (ApplicantType_ApplicantType = {}));
//# sourceMappingURL=ApplicantType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Assets.js
var Assets_AssetType;
(function (AssetType) {
    AssetType["Property"] = "PROPERTY";
    AssetType["Vehicle"] = "VEHICLE";
    AssetType["HomeContents"] = "HOME_CONTENTS";
    AssetType["SavingCheckAccount"] = "SAVING_CHECK_ACCOUNT";
    AssetType["Superannuation"] = "SUPERANNUATION";
    AssetType["TermDeposit"] = "TERM_DEPOSIT";
    AssetType["Shares"] = "SHARES";
    AssetType["ManagedFunds"] = "MANAGED_FUNDS";
    AssetType["Gifts"] = "GIFTS";
    AssetType["OtherAsset"] = "OTHER_ASSET";
})(Assets_AssetType || (Assets_AssetType = {}));
var Assets_AssetPrimaryPurpose;
(function (AssetPrimaryPurpose) {
    AssetPrimaryPurpose["Investment"] = "INVESTMENT";
    AssetPrimaryPurpose["OwnerOccupied"] = "OWNER_OCCUPIED";
})(Assets_AssetPrimaryPurpose || (Assets_AssetPrimaryPurpose = {}));
//# sourceMappingURL=Assets.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/AuthOrigin.js
var AuthOrigin_AuthOrigin;
(function (AuthOrigin) {
    AuthOrigin["Passwordless"] = "passwordless";
    AuthOrigin["Domain"] = "domain";
    AuthOrigin["Google"] = "google";
})(AuthOrigin_AuthOrigin || (AuthOrigin_AuthOrigin = {}));
//# sourceMappingURL=AuthOrigin.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/AuthTokenFields.js
var AuthTokenFields_AuthTokenFields;
(function (AuthTokenFields) {
    AuthTokenFields["UserId"] = "https://lendi/userId";
    AuthTokenFields["Type"] = "https://lendi/type";
    AuthTokenFields["Brand"] = "https://lendi/brand";
    AuthTokenFields["AuthApplications"] = "authorized-applications";
    AuthTokenFields["AuthCustomer"] = "authorized-customer";
})(AuthTokenFields_AuthTokenFields || (AuthTokenFields_AuthTokenFields = {}));
//# sourceMappingURL=AuthTokenFields.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Brand.js
var Brand_Brand;
(function (Brand) {
    Brand["Lendi"] = "lendi";
    Brand["Domain"] = "domain";
    Brand["Aussie"] = "aussie";
})(Brand_Brand || (Brand_Brand = {}));
//# sourceMappingURL=Brand.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/BankingFeatures.js
var BankingFeatures_BankingFeatures;
(function (BankingFeatures) {
    BankingFeatures["ApplePay"] = "APPLE_PAY";
    BankingFeatures["BranchAccess"] = "BRANCH_ACCESS";
    BankingFeatures["CreditCard"] = "CREDIT_CARD";
    BankingFeatures["FeeFreeAtmTransactions"] = "FEE_FREE_ATM_TRANSACTIONS";
    BankingFeatures["GooglePay"] = "GOOGLE_PAY";
    BankingFeatures["InternetBanking"] = "INTERNET_BANKING";
    BankingFeatures["MobileApp"] = "MOBILE_APP";
    BankingFeatures["OpenToEverything"] = "OPEN_TO_EVERYTHING";
    BankingFeatures["SamsungPay"] = "SAMSUNG_PAY";
    BankingFeatures["UrgentTurnaround"] = "URGENT_TURNAROUND";
})(BankingFeatures_BankingFeatures || (BankingFeatures_BankingFeatures = {}));
//# sourceMappingURL=BankingFeatures.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/BrokerInterviews.js
var BrokerInterviews_BenefitEnquiries;
(function (BenefitEnquiries) {
    BenefitEnquiries["Other"] = "OTHER";
    BenefitEnquiries["ProportionsInAssetsPurchased"] = "PROPORTION_IN_ASSETS_PURCHASED";
    BenefitEnquiries["RepayDebtsOrOtherObligations"] = "REPAY_DEBTS_OR_OTHER_OBLIGATIONS";
})(BrokerInterviews_BenefitEnquiries || (BrokerInterviews_BenefitEnquiries = {}));
var BrokerInterviews_CoApplicantBenefit;
(function (CoApplicantBenefit) {
    CoApplicantBenefit["NoSubstantialBenefit"] = "NO_SUBSTANTIAL_BENEFIT";
    CoApplicantBenefit["NoSubstantialBenefitAndProceed"] = "NO_SUBSTANTIAL_BENEFIT_AND_PROCEED";
    CoApplicantBenefit["SubstantialBenefit"] = "SUBSTANTIAL_BENEFIT";
})(BrokerInterviews_CoApplicantBenefit || (BrokerInterviews_CoApplicantBenefit = {}));
var BrokerInterviews_CoApplicantReason;
(function (CoApplicantReason) {
    CoApplicantReason["AccessToCashOrEquity"] = "ACCESS_TO_CASH_OR_EQUITY";
    CoApplicantReason["BuyingAVehicalWhereOnlyOneBorrowerCanBeTheRegisteredOwner"] = "BUYING_A_VEHICLE_WHERE_ONLY_ONE_BORROWER_CAN_BE_THE_REGISTERED_OWNER";
    CoApplicantReason["IndependentFinancialLegalOrAccountingAdviceRequired"] = "INDEPENDENT_FINANCIAL_LEGAL_OR_ACCOUNTING_ADVICE_RECEIVED";
    CoApplicantReason["SpousalAssetProtectionTaxBenefitsOrDebtReduction"] = "SPOUSAL_ASSET_PROTECTION_TAX_BENEFITS_OR_DEBT_REDUCTION";
    CoApplicantReason["SubstantialBenefitFromAtLeastOneOfTheLoanPurposes"] = "SUBSTANTIAL_BENEFIT_FROM_AT_LEAST_ONE_OF_THE_LOAN_PURPOSES";
})(BrokerInterviews_CoApplicantReason || (BrokerInterviews_CoApplicantReason = {}));
var BrokerInterviews_DocumentationDeliveryMethod;
(function (DocumentationDeliveryMethod) {
    DocumentationDeliveryMethod["email"] = "EMAIL";
    DocumentationDeliveryMethod["post"] = "POST";
    DocumentationDeliveryMethod["collectFromNearestBranch"] = "COLLECT_FROM_NEAREST_BRANCH";
})(BrokerInterviews_DocumentationDeliveryMethod || (BrokerInterviews_DocumentationDeliveryMethod = {}));
var BrokerInterviews_GuarantorLocationType;
(function (GuarantorLocationType) {
    GuarantorLocationType["lendiApprovedPhotoInterview"] = "LENDI_APPROVED_PHONE_INTERVIEW";
    GuarantorLocationType["faceToFace"] = "FACE_TO_FACE";
})(BrokerInterviews_GuarantorLocationType || (BrokerInterviews_GuarantorLocationType = {}));
var BrokerInterviews_IndependentAdviceTypeRequired;
(function (IndependentAdviceTypeRequired) {
    IndependentAdviceTypeRequired["legalAdvice"] = "LEGAL_ADVICE";
    IndependentAdviceTypeRequired["financialAdvice"] = "FINANCIAL_ADVICE";
    IndependentAdviceTypeRequired["notNeeded"] = "NOT_NEEDED";
})(BrokerInterviews_IndependentAdviceTypeRequired || (BrokerInterviews_IndependentAdviceTypeRequired = {}));
var BrokerInterviews_LocationType;
(function (LocationType) {
    LocationType["CustomerResidence"] = "CUSTOMER_RESIDENCE";
    LocationType["LendiApprovedPhoneInterview"] = "LENDI_APPROVED_PHONE_INTERVIEW";
    LocationType["Other"] = "OTHER";
})(BrokerInterviews_LocationType || (BrokerInterviews_LocationType = {}));
//# sourceMappingURL=BrokerInterviews.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Confidence.js
var Confidence_Confidence;
(function (Confidence) {
    Confidence["Low"] = "LOW";
    Confidence["MediumLow"] = "MEDIUM_LOW";
    Confidence["Medium"] = "MEDIUM";
    Confidence["MediumHigh"] = "MEDIUM_HIGH";
    Confidence["High"] = "HIGH";
})(Confidence_Confidence || (Confidence_Confidence = {}));
//# sourceMappingURL=Confidence.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Construction.js
var Construction_Construction;
(function (Construction) {
    Construction["BuildAProperty"] = "BUILD_A_PROPERTY";
    Construction["KnockdownRebuild"] = "KNOCKDOWN_REBUILD";
    Construction["StructuralRenovations"] = "STRUCTURAL_RENOVATIONS";
})(Construction_Construction || (Construction_Construction = {}));
//# sourceMappingURL=Construction.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/CreditStatus.js
var CreditStatus_CreditStatus;
(function (CreditStatus) {
    CreditStatus["Fair"] = "FAIR";
    CreditStatus["Unknown"] = "UNKNOWN";
    CreditStatus["Average"] = "AVERAGE";
    CreditStatus["Excellent"] = "EXCELLENT";
})(CreditStatus_CreditStatus || (CreditStatus_CreditStatus = {}));
//# sourceMappingURL=CreditStatus.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/DesiredFeatures.js
var DesiredFeatures_DesiredFeatures;
(function (DesiredFeatures) {
    DesiredFeatures["MobileApp"] = "MOBILE_APP";
    DesiredFeatures["MajorLender"] = "MAJOR_LENDER";
    DesiredFeatures["OffsetOrRedraw"] = "OFFSET_OR_REDRAW";
    DesiredFeatures["FixedRate"] = "FIXED_RATE";
})(DesiredFeatures_DesiredFeatures || (DesiredFeatures_DesiredFeatures = {}));
//# sourceMappingURL=DesiredFeatures.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/EligibleForFHOG.js
var EligibleForFHOG_EligibleForFHOG;
(function (EligibleForFHOG) {
    EligibleForFHOG["Yes"] = "YES";
    EligibleForFHOG["No"] = "NO";
    EligibleForFHOG["NotSure"] = "NOT_SURE";
})(EligibleForFHOG_EligibleForFHOG || (EligibleForFHOG_EligibleForFHOG = {}));
//# sourceMappingURL=EligibleForFHOG.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/EmploymentType.js
var EmploymentType_EmploymentType;
(function (EmploymentType) {
    EmploymentType["Employee"] = "EMPLOYEE";
    EmploymentType["SelfEmployed"] = "SELF_EMPLOYED";
    EmploymentType["NotEmployed"] = "NOT_EMPLOYED";
    EmploymentType["Unknown"] = "UNKNOWN";
    EmploymentType["NotWorking"] = "NOT_WORKING";
})(EmploymentType_EmploymentType || (EmploymentType_EmploymentType = {}));
//# sourceMappingURL=EmploymentType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/FinancialSituation.js
var FinancialSituation_FinancialSituation;
(function (FinancialSituation) {
    FinancialSituation["ExtendedUnpaidLeave"] = "EXTENDED_UNPAID_LEAVE";
    FinancialSituation["IncreasedDebtRepaymentForExistingLoan"] = "INCREASED_DEBT_REPAYMENT_FOR_EXISTING_LOAN";
    FinancialSituation["LargeExpenditure"] = "LARGE_EXPENDITURE";
    FinancialSituation["MedicalTreatmentOrIllness"] = "MEDICAL_TREATMENT_OR_ILLNESS";
    FinancialSituation["None"] = "NONE";
    FinancialSituation["Other"] = "OTHER";
    FinancialSituation["PermanentDecreaseInIncome"] = "PERMANENT_DECREASE_IN_INCOME";
    FinancialSituation["TemporaryDecreaseInIncome"] = "TEMPORARY_DECREASE_IN_INCOME";
    FinancialSituation["TemporaryIncreaseInExpense"] = "TEMPORARY_INCREASE_IN_EXPENSE";
})(FinancialSituation_FinancialSituation || (FinancialSituation_FinancialSituation = {}));
//# sourceMappingURL=FinancialSituation.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Gender.js
var Gender_Gender;
(function (Gender) {
    Gender["Female"] = "FEMALE";
    Gender["Male"] = "MALE";
    Gender["Undisclosed"] = "UNDISCLOSED";
    Gender["Unknown"] = "UNKNOWN";
})(Gender_Gender || (Gender_Gender = {}));
//# sourceMappingURL=Gender.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/InterestRateType.js
var InterestRateType_InterestRateType;
(function (InterestRateType) {
    InterestRateType["Variable"] = "VARIABLE";
    InterestRateType["Fixed"] = "FIXED";
    InterestRateType["Both"] = "BOTH";
})(InterestRateType_InterestRateType || (InterestRateType_InterestRateType = {}));
//# sourceMappingURL=InterestRateType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/InvitationStatus.js
var InvitationStatus_InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus["Pending"] = "PENDING";
    InvitationStatus["Expired"] = "EXPIRED";
    InvitationStatus["Accepted"] = "ACCEPTED";
    InvitationStatus["Cancelled"] = "CANCELLED";
})(InvitationStatus_InvitationStatus || (InvitationStatus_InvitationStatus = {}));
//# sourceMappingURL=InvitationStatus.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Liabilities.js
var Liabilities_LiabilityType;
(function (LiabilityType) {
    LiabilityType["Vehicle"] = "CAR_LOAN";
    LiabilityType["HomeLoan"] = "HOME_LOAN";
    LiabilityType["CreditCard"] = "CREDIT_CARD";
    LiabilityType["StoreCard"] = "STORE_CARD";
    LiabilityType["PersonalLoan"] = "PERSONAL_LOAN";
    LiabilityType["ShortTermFinance"] = "SHORT_TERM_FINANCE";
    LiabilityType["Lease"] = "LEASE";
    LiabilityType["HirePurchase"] = "HIRE_PURCHASE";
    LiabilityType["TaxDebt"] = "TAX_DEBT";
    LiabilityType["LineOfCredit"] = "LINE_OF_CREDIT";
    LiabilityType["Overdraft"] = "OVERDRAFT";
    LiabilityType["HelpHecsDebt"] = "HELP_HECS_DEBT";
    LiabilityType["Other"] = "OTHER";
    LiabilityType["Unknown"] = "UNKNOWN";
})(Liabilities_LiabilityType || (Liabilities_LiabilityType = {}));
var Liabilities_LiabilityRepaymentTypeDetails;
(function (LiabilityRepaymentTypeDetails) {
    LiabilityRepaymentTypeDetails["InterestOnly"] = "INTEREST_ONLY";
    LiabilityRepaymentTypeDetails["PrincipalAndInterest"] = "PRINCIPAL_AND_INTEREST";
})(Liabilities_LiabilityRepaymentTypeDetails || (Liabilities_LiabilityRepaymentTypeDetails = {}));
var Liabilities_LiabilityRepaymentFrequency;
(function (LiabilityRepaymentFrequency) {
    LiabilityRepaymentFrequency["Weekly"] = "WEEKLY";
    LiabilityRepaymentFrequency["Fortnightly"] = "FORTNIGHTLY";
    LiabilityRepaymentFrequency["Monthly"] = "MONTHLY";
    LiabilityRepaymentFrequency["Annually"] = "ANNUALLY";
})(Liabilities_LiabilityRepaymentFrequency || (Liabilities_LiabilityRepaymentFrequency = {}));
var Liabilities_LiabilityClearingFromOtherSource;
(function (LiabilityClearingFromOtherSource) {
    LiabilityClearingFromOtherSource["PayingOut"] = "PAYING_OUT";
    LiabilityClearingFromOtherSource["Reducing"] = "REDUCING";
})(Liabilities_LiabilityClearingFromOtherSource || (Liabilities_LiabilityClearingFromOtherSource = {}));
var Liabilities_LiabilityInterestType;
(function (LiabilityInterestType) {
    LiabilityInterestType["FixedRate"] = "FIXED_RATE";
    LiabilityInterestType["Variable"] = "VARIABLE";
})(Liabilities_LiabilityInterestType || (Liabilities_LiabilityInterestType = {}));
//# sourceMappingURL=Liabilities.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/MaritalStatus.js
var MaritalStatus_MaritalStatus;
(function (MaritalStatus) {
    MaritalStatus["DeFacto"] = "DE_FACTO";
    MaritalStatus["Divorced"] = "DIVORCED";
    MaritalStatus["Married"] = "MARRIED";
    MaritalStatus["Single"] = "SINGLE";
    MaritalStatus["Unknown"] = "UNKNOWN";
})(MaritalStatus_MaritalStatus || (MaritalStatus_MaritalStatus = {}));
//# sourceMappingURL=MaritalStatus.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Mitigant.js
var Mitigant_Mitigant;
(function (Mitigant) {
    Mitigant["ApplicationReflectsChanges"] = "APPLICATION_REFLECTS_CHANGES";
    Mitigant["CoApplicantsIncome"] = "CO_APPLICANTS_INCOME";
    Mitigant["ReduceExpenditure"] = "REDUCING_EXPENDITURE";
    Mitigant["SaleOfAssets"] = "SALE_OF_ASSETS";
    Mitigant["SecuringAdditionalIncome"] = "SECURING_ADDITIONAL_INCOME";
    Mitigant["UsingSavings"] = "USING_SAVINGS";
    Mitigant["Other"] = "OTHER";
})(Mitigant_Mitigant || (Mitigant_Mitigant = {}));
//# sourceMappingURL=Mitigant.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/OwnershipProportions.js
var OwnershipProportions_OwnershipProportions;
(function (OwnershipProportions) {
    OwnershipProportions["Equal"] = "EQUAL";
    OwnershipProportions["Specified"] = "SPECIFIED";
    OwnershipProportions["NotSpecified"] = "NOT_SPECIFIED";
})(OwnershipProportions_OwnershipProportions || (OwnershipProportions_OwnershipProportions = {}));
//# sourceMappingURL=OwnershipProportions.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/PaymentIssues.js
var PaymentIssues_PaymentIssues;
(function (PaymentIssues) {
    PaymentIssues["HardshipArrangements"] = "HARDSHIP_ARRANGEMENTS";
    PaymentIssues["LatePayments"] = "LATE_PAYMENTS";
    PaymentIssues["MissedPayments"] = "MISSED_PAYMENTS";
    PaymentIssues["OutstandingArrears"] = "OUTSTANDING_ARREARS";
    PaymentIssues["None"] = "NONE";
})(PaymentIssues_PaymentIssues || (PaymentIssues_PaymentIssues = {}));
//# sourceMappingURL=PaymentIssues.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/PaymentType.js
var PaymentType_PaymentType;
(function (PaymentType) {
    PaymentType["InterestOnly"] = "INTEREST_ONLY";
    PaymentType["PrincipalAndInterest"] = "PRINCIPAL_AND_INTEREST";
    PaymentType["Both"] = "BOTH";
    PaymentType["StillDeciding"] = "STILL_DECIDING";
    PaymentType["Unknown"] = "UNKNOWN";
})(PaymentType_PaymentType || (PaymentType_PaymentType = {}));
//# sourceMappingURL=PaymentType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/ProductFeatures.js
var ProductFeatures_ProductFeatures;
(function (ProductFeatures) {
    ProductFeatures["Offset"] = "OFFSET";
    ProductFeatures["Redraw"] = "REDRAW";
})(ProductFeatures_ProductFeatures || (ProductFeatures_ProductFeatures = {}));
//# sourceMappingURL=ProductFeatures.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/ProductPreferences.js
var ProductPreferences_ProductPreferences;
(function (ProductPreferences) {
    ProductPreferences["AbilityToAccessPrepaidFundsIfNeeded"] = "ABILITY_TO_ACCESS_PREPAID_FUNDS_IF_NEEDED";
    ProductPreferences["AbilityToPayOffLoanSooner"] = "ABILITY_TO_PAY_OFF_LOAN_SOONER";
    ProductPreferences["AccessFundsSameWayAsRegularBankAccount"] = "ACCESS_FUNDS_SAME_WAY_AS_A_REGULAR_BANK_ACCOUNT";
    ProductPreferences["HaveABalanceOfCertaintyOfRepaymentsAndFlexibility"] = "HAVE_A_BALANCE_OF_CERTAINTY_OF_REPAYMENTS_AND_FLEXIBILITY";
    ProductPreferences["HaveSetRepayments"] = "HAVE_SET_REPAYMENTS";
    ProductPreferences["TakeAdvantageOfInterestRateDrops"] = "TAKE_ADVANTAGE_OF_INTEREST_RATE_DROPS";
    ProductPreferences["UseSavingsOrSalaryToReduceInterest"] = "USE_SAVINGS_OR_SALARY_TO_REDUCE_INTEREST";
})(ProductPreferences_ProductPreferences || (ProductPreferences_ProductPreferences = {}));
//# sourceMappingURL=ProductPreferences.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Properties.js
var Properties_PropertyStatus;
(function (PropertyStatus) {
    PropertyStatus["NewBuilding"] = "NEW_BUILDING";
    PropertyStatus["OffThePlan"] = "OFF_THE_PLAN";
    PropertyStatus["VacantLand"] = "VACANT_LAND";
    PropertyStatus["Established"] = "ESTABLISHED";
})(Properties_PropertyStatus || (Properties_PropertyStatus = {}));
var Properties_PropertyZoneType;
(function (PropertyZoneType) {
    PropertyZoneType["Residential"] = "RESIDENTIAL";
    PropertyZoneType["Commercial"] = "COMMERCIAL";
    PropertyZoneType["Rural"] = "RURAL";
    PropertyZoneType["Industrial"] = "INDUSTRIAL";
})(Properties_PropertyZoneType || (Properties_PropertyZoneType = {}));
var Properties_PropertyType;
(function (PropertyType) {
    PropertyType["ApartmentUnitLessThan50M2"] = "APARTMENT_UNIT_LESS_THAN_50M2";
    PropertyType["ApartmentUnitMoreThan50M2"] = "APARTMENT_UNIT_MORE_THAN_50M2";
    PropertyType["ServicedApartment"] = "SERVICED_APARTMENT";
    PropertyType["Stuido"] = "STUDIO";
    PropertyType["StudentAccommodation"] = "STUDENT_ACCOMMODATION";
    PropertyType["WarehouseApartment"] = "WAREHOUSE_APARTMENT";
    PropertyType["Duplex"] = "DUPLEX";
    PropertyType["Villa"] = "VILLA";
    PropertyType["FullyDetachedHouse"] = "FULLY_DETACHED_HOUSE";
    PropertyType["KitHome"] = "KIT_HOME";
    PropertyType["MultiDwellingSingleTitle"] = "MULTI_DWELLING_SINGLE_TITLE";
    PropertyType["PropertyOver10HA"] = "PROPERTY_OVER_10_HA";
    PropertyType["SemiDetachedHouse"] = "SEMI_DETACHED_HOUSE";
    PropertyType["Terrace"] = "TERRACE";
    PropertyType["Townhouse"] = "TOWNHOUSE";
    PropertyType["Land"] = "LAND";
})(Properties_PropertyType || (Properties_PropertyType = {}));
var Properties_PropertyEstimateBasis;
(function (PropertyEstimateBasis) {
    PropertyEstimateBasis["ApplicantEstimate"] = "APPLICANT_ESTIMATE";
    PropertyEstimateBasis["BankAssessment"] = "BANK_ASSESSMENT";
    PropertyEstimateBasis["CertifiedValuation"] = "CERTIFIED_VALUATION";
    PropertyEstimateBasis["ElectronicValuation"] = "ELECTRONIC_VALUATION";
    PropertyEstimateBasis["RatesNotice"] = "RATES_NOTICE";
    PropertyEstimateBasis["RPData"] = "RP_DATA";
    PropertyEstimateBasis["Valocity"] = "VALOCITY";
})(Properties_PropertyEstimateBasis || (Properties_PropertyEstimateBasis = {}));
//# sourceMappingURL=Properties.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/PurchaseReason.js
var PurchaseReason_PurchaseReason;
(function (PurchaseReason) {
    PurchaseReason["LoanApproval"] = "LOAN_APPROVAL";
    PurchaseReason["LoanEligibility"] = "LOAN_ELIGIBILITY";
    PurchaseReason["LoanAffordability"] = "LOAN_AFFORDABILITY";
})(PurchaseReason_PurchaseReason || (PurchaseReason_PurchaseReason = {}));
//# sourceMappingURL=PurchaseReason.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/PurchaseSituation.js
var PurchaseSituation_PurchaseSituation;
(function (PurchaseSituation) {
    PurchaseSituation["ContractsExchanged"] = "CONTRACTS_EXCHANGED";
    PurchaseSituation["OfferMade"] = "OFFER_MADE";
    PurchaseSituation["BuyingSoon"] = "BUYING_SOON";
    PurchaseSituation["ExploringOptions"] = "EXPLORING_OPTIONS";
})(PurchaseSituation_PurchaseSituation || (PurchaseSituation_PurchaseSituation = {}));
//# sourceMappingURL=PurchaseSituation.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Purpose.js
var Purpose_Purpose;
(function (Purpose) {
    Purpose["NewPurchase"] = "NEW_PURCHASE";
    Purpose["Refinance"] = "REFINANCE";
})(Purpose_Purpose || (Purpose_Purpose = {}));
var Purpose_PrimaryPurpose;
(function (PrimaryPurpose) {
    PrimaryPurpose["Commercial"] = "COMMERCIAL";
    PrimaryPurpose["Construction"] = "CONSTRUCTION";
    PrimaryPurpose["ConstructionAndPurchase"] = "CONSTRUCTION_AND_PURCHASE";
    PrimaryPurpose["ConstructionAndRefinance"] = "CONSTRUCTION_AND_REFINANCE";
    PrimaryPurpose["InternalRefinance"] = "INTERNAL_REFINANCE";
    PrimaryPurpose["NewPurchase"] = "NEW_PURCHASE";
    PrimaryPurpose["PreApproval"] = "PRE_APPROVAL";
    PrimaryPurpose["Purchase"] = "PURCHASE";
    PrimaryPurpose["PurchaseAndRefinance"] = "PURCHASE_AND_REFINANCE";
    PrimaryPurpose["Refinance"] = "REFINANCE";
    PrimaryPurpose["SLR"] = "SLR";
    PrimaryPurpose["TopUp"] = "TOP_UP";
    PrimaryPurpose["Variation"] = "VARIATION";
    PrimaryPurpose["VariationCreditCritical"] = "VARIATION_CREDIT_CRITICAL";
    PrimaryPurpose["VariationNonCreditCritical"] = "VARIATION_NON_CREDIT_CRITICAL";
})(Purpose_PrimaryPurpose || (Purpose_PrimaryPurpose = {}));
//# sourceMappingURL=Purpose.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RefinancingReasons.js
var RefinancingReasons_RefinancingReasons;
(function (RefinancingReasons) {
    RefinancingReasons["ConsolidateCashout"] = "CONSOLIDATE_CASHOUT";
    RefinancingReasons["FasterPayoff"] = "FASTER_PAYOFF";
    RefinancingReasons["DecreaseRepayments"] = "DECREASE_REPAYMENTS";
    RefinancingReasons["Construction"] = "CONSTRUCTION";
    // Few more from Needs & Objectives
    RefinancingReasons["CloseToTheEndOfAFixedRateOrInterestOnlyPeriod"] = "CLOSE_TO_THE_END_OF_A_FIXED_RATE_OR_INTEREST_ONLY_PERIOD";
    RefinancingReasons["ConsolidateDebtAndReduceNumberOfLenders"] = "CONSOLIDATE_DEBT_AND_REDUCE_NUMBER_OF_LENDERS";
    RefinancingReasons["DissatisfiedWithCurrentLender"] = "DISSATISFIED_WITH_CURRENT_LENDER";
    RefinancingReasons["GreaterFlexibilityOrAdditionalLoanFeatures"] = "GREATER_FLEXIBILITY_OR_ADDITIONAL_LOAN_FEATURES";
    RefinancingReasons["IncreaseLoanAmount"] = "INCREASE_LOAN_AMOUNT";
    RefinancingReasons["PayOffLoanFasterWithALowerInterestRate"] = "PAY_OFF_LOAN_FASTER_WITH_A_LOWER_INTEREST_RATE";
    RefinancingReasons["Other"] = "OTHER";
})(RefinancingReasons_RefinancingReasons || (RefinancingReasons_RefinancingReasons = {}));
//# sourceMappingURL=RefinancingReasons.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RelationshipToBorrower.js
var RelationshipToBorrower_RelationshipToBorrower;
(function (RelationshipToBorrower) {
    RelationshipToBorrower["FATHER"] = "Father";
    RelationshipToBorrower["MOTHER"] = "Mother";
    RelationshipToBorrower["SPOUSE"] = "Spouse";
    RelationshipToBorrower["BROTHER"] = "Brother";
    RelationshipToBorrower["SISTER"] = "Sister";
    RelationshipToBorrower["SON"] = "Son";
    RelationshipToBorrower["OTHER_RELATIVE"] = "Other Relative";
    RelationshipToBorrower["OTHER"] = "Other";
})(RelationshipToBorrower_RelationshipToBorrower || (RelationshipToBorrower_RelationshipToBorrower = {}));
//# sourceMappingURL=RelationshipToBorrower.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RepaymentOptions.js
var RepaymentOptions_RepaymentOptions;
(function (RepaymentOptions) {
    RepaymentOptions["Downsize"] = "DOWNSIZE";
    RepaymentOptions["RelyOnCoApplicantsIncome"] = "RELY_ON_CO_APPLICANTS_INCOME";
    RepaymentOptions["RepayLoanBeforeRetirement"] = "REPAY_LOAN_BEFORE_RETIREMENT";
    RepaymentOptions["SellAssets"] = "SELL_ASSETS";
    RepaymentOptions["UseIncomeFromOtherInvestments"] = "USE_INCOME_FROM_OTHER_INVESTMENTS";
    RepaymentOptions["UseSavings"] = "USE_SAVINGS";
    RepaymentOptions["UseSuperannuationLumpSum"] = "USE_SUPERANNUATION_LUMP_SUM";
    RepaymentOptions["UseSuperannuationOnGoing"] = "USE_SUPERANNUATION_ONGOING";
    RepaymentOptions["WorkPastRetirementAge"] = "WORK_PAST_RETIREMENT_AGE";
    RepaymentOptions["Other"] = "OTHER";
})(RepaymentOptions_RepaymentOptions || (RepaymentOptions_RepaymentOptions = {}));
//# sourceMappingURL=RepaymentOptions.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RepaymentType.js
var RepaymentType_RepaymentType;
(function (RepaymentType) {
    RepaymentType["InterestOnly"] = "INTEREST_ONLY";
    RepaymentType["PrincipalAndInterest"] = "PRINCIPAL_AND_INTEREST";
    RepaymentType["Both"] = "BOTH";
})(RepaymentType_RepaymentType || (RepaymentType_RepaymentType = {}));
//# sourceMappingURL=RepaymentType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RepaymentTypeDetails.js
var RepaymentTypeDetails_RepaymentTypeDetails;
(function (RepaymentTypeDetails) {
    RepaymentTypeDetails["InterestOnlyDueToVariableAndUnpredictableIncome"] = "INTEREST_ONLY_DUE_TO_VARIABLE_AND_UNPREDICTABLE_INCOME";
    RepaymentTypeDetails["InterestOnlyForTaxAndAccountingPurpose"] = "INTEREST_ONLY_FOR_TAX_AND_ACCOUNTING_PURPOSE";
    RepaymentTypeDetails["InterestOnlyToAccommodateTemporaryReductionInIncome"] = "INTEREST_ONLY_TO_ACCOMMODATE_TEMPORARY_REDUCTION_IN_INCOME";
    RepaymentTypeDetails["InterestOnlyToAccommodateNonRecurringExpenses"] = "INTEREST_ONLY_TO_ACCOMMODATE_NON_RECURRING_EXPENSES";
    RepaymentTypeDetails["InterestOnlyToPayOffNonDeductibleDebtsAsAPriority"] = "INTEREST_ONLY_TO_PAY_OFF_NON_DEDUCTIBLE_DEBTS_AS_A_PRIORITY";
    RepaymentTypeDetails["DecreaseDebtOwingOnProperty"] = "DECREASE_DEBT_OWING_ON_PROPERTY";
    RepaymentTypeDetails["MaximiseBorrowingCapacityWithDepositOrAmountOfEquityAccessible"] = "MAXIMISE_BORROWING_CAPACITY_WITH_DEPOSIT_OR_AMOUNT_OF_EQUITY_ACCESSIBLE";
    RepaymentTypeDetails["PaydownPrincipleToMinimiseInterestPaidOverTime"] = "PAY_DOWN_PRINCIPAL_TO_MINIMISE_INTEREST_PAID_OVER_TIME";
    RepaymentTypeDetails["PayLowestPossibleDeposit"] = "PAY_LOWEST_POSSIBLE_DEPOSIT";
    RepaymentTypeDetails["Other"] = "OTHER";
})(RepaymentTypeDetails_RepaymentTypeDetails || (RepaymentTypeDetails_RepaymentTypeDetails = {}));
//# sourceMappingURL=RepaymentTypeDetails.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/ResidencyStatus.js
var ResidencyStatus_ResidencyStatus;
(function (ResidencyStatus) {
    ResidencyStatus["AustralianCitizen"] = "AUSTRALIAN_CITIZEN";
    ResidencyStatus["PermanentResident"] = "PERMANENT_RESIDENT";
    ResidencyStatus["TemporaryResident"] = "TEMPORARY_RESIDENT";
    ResidencyStatus["Unknown"] = "UNKNOWN";
})(ResidencyStatus_ResidencyStatus || (ResidencyStatus_ResidencyStatus = {}));
//# sourceMappingURL=ResidencyStatus.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/States.js
var States_State;
(function (State) {
    State["QLD"] = "QLD";
    State["NSW"] = "NSW";
    State["VIC"] = "VIC";
    State["WA"] = "WA";
    State["SA"] = "SA";
    State["TAS"] = "TAS";
    State["ACT"] = "ACT";
    State["NT"] = "NT";
})(States_State || (States_State = {}));
//# sourceMappingURL=States.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/TeamMemberSkill.js
var TeamMemberSkill_TeamMemberSkill;
(function (TeamMemberSkill) {
    TeamMemberSkill["Bridging"] = "Bridging";
    TeamMemberSkill["ComplexInvestments"] = "Complex Investments";
    TeamMemberSkill["Construction"] = "Construction";
    TeamMemberSkill["DebtConsolidation"] = "Debt Consolidation";
    TeamMemberSkill["ExistingCustomer"] = "Existing Customer";
    TeamMemberSkill["Guarantor"] = "Guarantor";
    TeamMemberSkill["HighValue"] = "High Value";
    TeamMemberSkill["LoanSizeLessThan200k"] = "Loan Size < 200k";
    TeamMemberSkill["LowDoc"] = "Low Doc";
    TeamMemberSkill["NonConformingLending"] = "Non-conforming lending";
    TeamMemberSkill["PAYG"] = "PAYG";
    TeamMemberSkill["SelfEmployedPtyLtd"] = "Self Employed PTY LTD";
    TeamMemberSkill["SelfEmployedSoleTrader"] = "Self Employed sole trader";
    TeamMemberSkill["Trust"] = "Trust";
    TeamMemberSkill["SlrToHls"] = "SLR to HLS";
    TeamMemberSkill["VideoAppointment"] = "Video Appointment";
})(TeamMemberSkill_TeamMemberSkill || (TeamMemberSkill_TeamMemberSkill = {}));
//# sourceMappingURL=TeamMemberSkill.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/TeamMemberSkillLGSF.js
var TeamMemberSkillLGSF_TeamMemberSkillLGSF;
(function (TeamMemberSkillLGSF) {
    TeamMemberSkillLGSF["Construction"] = "CONSTRUCTION";
    TeamMemberSkillLGSF["LowDoc"] = "LOW_DOC";
    TeamMemberSkillLGSF["NonConformingLoan"] = "NON_CONFORMING_LOAN";
    TeamMemberSkillLGSF["Guarantor"] = "GUARANTOR";
    TeamMemberSkillLGSF["SelfEmployed"] = "SELF_EMPLOYED";
    TeamMemberSkillLGSF["TopUps"] = "TOP_UPS";
    TeamMemberSkillLGSF["Bridging"] = "BRIDGING";
    TeamMemberSkillLGSF["Trust"] = "TRUST";
    TeamMemberSkillLGSF["Commercial"] = "COMMERCIAL";
})(TeamMemberSkillLGSF_TeamMemberSkillLGSF || (TeamMemberSkillLGSF_TeamMemberSkillLGSF = {}));
var TeamMemberSkillLGSF_TeamMemberSkillLGSFWithLabel = {
    Construction: {
        value: 'CONSTRUCTION',
        label: 'Construction',
    },
    LowDoc: {
        value: 'LOW_DOC',
        label: 'Low Doc',
    },
    NonConformingLoan: {
        value: 'NON_CONFORMING_LOAN',
        label: 'Non Conforming Loan',
    },
    Guarantor: {
        value: 'GUARANTOR',
        label: 'Guarantor',
    },
    SelfEmployed: {
        value: 'SELF_EMPLOYED',
        label: 'Self employed',
    },
    TopUps: {
        value: 'TOP_UPS',
        label: 'Top ups',
    },
    Bridging: {
        value: 'BRIDGING',
        label: 'Bridging',
    },
    Trust: {
        value: 'TRUST',
        label: 'Trust',
    },
    Commercial: {
        value: 'COMMERCIAL',
        label: 'Commercial',
    },
};
//# sourceMappingURL=TeamMemberSkillLGSF.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/TeamMemberSubSkillLGSF.js
var TeamMemberSubSkillLGSF_TeamMemberSubSkillLGSF;
(function (TeamMemberSubSkillLGSF) {
    TeamMemberSubSkillLGSF["ExistingCustomer"] = "EXISTING_CUSTOMER";
    TeamMemberSubSkillLGSF["SlrToHls"] = "SLR_TO_HLS";
    TeamMemberSubSkillLGSF["VideoAppts"] = "VIDEO_APPTS";
    TeamMemberSubSkillLGSF["HighValue"] = "HIGH_VALUE";
    TeamMemberSubSkillLGSF["ComplexInvestment"] = "COMPLEX_INVESTMENT";
    TeamMemberSubSkillLGSF["LoanAmountUnder200k"] = "LOAN_AMOUNT_UNDER_200K";
    TeamMemberSubSkillLGSF["TestGroupA"] = "TEST_GROUP_A";
    TeamMemberSubSkillLGSF["TestGroupB"] = "TEST_GROUP_B";
})(TeamMemberSubSkillLGSF_TeamMemberSubSkillLGSF || (TeamMemberSubSkillLGSF_TeamMemberSubSkillLGSF = {}));
var TeamMemberSubSkillLGSF_TeamMemberSubSkillLGSFWithLabel = {
    ExistingCustomer: {
        value: 'EXISTING_CUSTOMER',
        label: 'Existing Customer',
    },
    SlrToHls: {
        value: 'SLR_TO_HLS',
        label: 'SLR to HLS',
    },
    VideoAppts: {
        value: 'VIDEO_APPTS',
        label: 'Video Appointments',
    },
    HighValue: {
        value: 'HIGH_VALUE',
        label: 'High Value',
    },
    ComplexInvestment: {
        value: 'COMPLEX_INVESTMENT',
        label: 'Complex Investment',
    },
    LoanAmountUnder200k: {
        value: 'LOAN_AMOUNT_UNDER_200K',
        label: 'Loan amount under 200k',
    },
    TestGroupA: {
        value: 'TEST_GROUP_A',
        label: 'Test Group A',
    },
    TestGroupB: {
        value: 'TEST_GROUP_B',
        label: 'Test Group B',
    },
};
//# sourceMappingURL=TeamMemberSubSkillLGSF.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Title.js
var Title_Title;
(function (Title) {
    Title["Dr"] = "DR";
    Title["Miss"] = "MISS";
    Title["Mr"] = "MR";
    Title["Mrs"] = "MRS";
    Title["Ms"] = "MS";
    Title["Other"] = "OTHER";
    Title["Unknown"] = "UNKNOWN";
})(Title_Title || (Title_Title = {}));
//# sourceMappingURL=Title.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/TransactionType.js
var TransactionType_TransactionType;
(function (TransactionType) {
    TransactionType["ConstructionLoan"] = "CONSTRUCTION_LOAN";
})(TransactionType_TransactionType || (TransactionType_TransactionType = {}));
//# sourceMappingURL=TransactionType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Urgency.js
var Urgency_Urgency;
(function (Urgency) {
    Urgency["Urgent"] = "URGENT";
    Urgency["NotUrgent"] = "NOT_URGENT";
})(Urgency_Urgency || (Urgency_Urgency = {}));
//# sourceMappingURL=Urgency.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/UserType.js
var UserType_UserType;
(function (UserType) {
    UserType["Customer"] = "customer";
    UserType["Team"] = "team";
    UserType["M2M"] = "m2m";
})(UserType_UserType || (UserType_UserType = {}));
//# sourceMappingURL=UserType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/DynamoStream.js
var DynamoStream_DynamoEventName;
(function (DynamoEventName) {
    DynamoEventName["Insert"] = "INSERT";
    DynamoEventName["Modify"] = "MODIFY";
    DynamoEventName["Remove"] = "REMOVE";
})(DynamoStream_DynamoEventName || (DynamoStream_DynamoEventName = {}));
//# sourceMappingURL=DynamoStream.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/HousingStatusList.js
var HousingStatusList_HousingStatusList;
(function (HousingStatusList) {
    HousingStatusList["Renting"] = "Renting";
    HousingStatusList["Boarding"] = "Boarding";
    HousingStatusList["Caravan"] = "Caravan";
    HousingStatusList["Other"] = "Other";
    HousingStatusList["OwnHome"] = "Own Home";
    HousingStatusList["OwnHomeMortgage"] = "Own Home Mortgage";
    HousingStatusList["SuppliedByEmployer"] = "Supplied by Employer";
    HousingStatusList["WithParents"] = "With Parents";
})(HousingStatusList_HousingStatusList || (HousingStatusList_HousingStatusList = {}));
//# sourceMappingURL=HousingStatusList.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/ExpenseTypes.js
var ExpenseTypes_ExpenseTypes;
(function (ExpenseTypes) {
    ExpenseTypes["LivingExpensesEstimate"] = "LIVING_EXPENSES_ESTIMATE";
    ExpenseTypes["Groceries"] = "GROCERIES";
    ExpenseTypes["Childcare"] = "CHILDCARE";
    ExpenseTypes["ChildAndSpousalMaintenance"] = "CHILD_AND_SPOUSAL_MAINTENANCE";
    ExpenseTypes["PrimarySecondaryEducation"] = "PRIMARY_SECONDARY_EDUCATION";
    ExpenseTypes["HigherVocationalTrainingEducation"] = "HIGHER_VOCATIONAL_TRAINING_EDUCATION";
    ExpenseTypes["PrivateSchoolingAndTuition"] = "PRIVATE_SCHOOLING_AND_TUITION";
    ExpenseTypes["ClothingAndPersonalCare"] = "CLOTHING_AND_PERSONAL_CARE";
    ExpenseTypes["RecreationAndEntertainment"] = "RECREATION_AND_ENTERTAINMENT";
    ExpenseTypes["TelephoneInternetPayTvAndMediaStreamingSubscriptions"] = "TELEPHONE_INTERNET_PAY_TV_AND_MEDIA_STREAMING_SUBSCRIPTIONS";
    ExpenseTypes["PetCare"] = "PET_CARE";
    ExpenseTypes["Transport"] = "TRANSPORT";
    ExpenseTypes["BodyCorporateFeesStrataFeesAndLandTax"] = "BODY_CORPORATE_FEES_STRATA_FEES_AND_LAND_TAX";
    ExpenseTypes["PrimaryResidenceRunningCosts"] = "PRIMARY_RESIDENCE_RUNNING_COSTS";
    ExpenseTypes["InvestmentPropertyRunningCosts"] = "INVESTMENT_PROPERTY_RUNNING_COSTS";
    ExpenseTypes["SecondaryResidenceRunningCosts"] = "SECONDARY_RESIDENCE_RUNNING_COSTS";
    ExpenseTypes["Insurance"] = "INSURANCE";
    ExpenseTypes["LifeInsurance"] = "LIFE_INSURANCE";
    ExpenseTypes["HealthInsurance"] = "HEALTH_INSURANCE";
    ExpenseTypes["MedicalAndHealth"] = "MEDICAL_AND_HEALTH";
    ExpenseTypes["Rent"] = "RENT";
    ExpenseTypes["Board"] = "BOARD";
    ExpenseTypes["Other"] = "OTHER";
})(ExpenseTypes_ExpenseTypes || (ExpenseTypes_ExpenseTypes = {}));
//# sourceMappingURL=ExpenseTypes.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Frequency.js
var Frequency_Frequency;
(function (Frequency) {
    Frequency["Fortnightly"] = "FORTNIGHTLY";
    Frequency["Monthly"] = "MONTHLY";
    Frequency["Quarterly"] = "QUARTERLY";
    Frequency["Weekly"] = "WEEKLY";
    Frequency["Yearly"] = "YEARLY";
})(Frequency_Frequency || (Frequency_Frequency = {}));
//# sourceMappingURL=Frequency.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/GovtBenefitTypes.js
var GovtBenefitTypes_GovtBenefitTypes;
(function (GovtBenefitTypes) {
    GovtBenefitTypes["FamilyTax"] = "FAMILY_TAX";
    GovtBenefitTypes["AgePension"] = "AGE_PENSION";
    GovtBenefitTypes["DisabilitySupportPension"] = "DISABILITY_SUPPORT_PENSION";
    GovtBenefitTypes["Other"] = "OTHER";
})(GovtBenefitTypes_GovtBenefitTypes || (GovtBenefitTypes_GovtBenefitTypes = {}));
//# sourceMappingURL=GovtBenefitTypes.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/IncomeTypesAsset.js
var IncomeTypesAsset_IncomeTypesAsset;
(function (IncomeTypesAsset) {
    IncomeTypesAsset["SelfEmployedBusinessIncome"] = "SELF_EMPLOYED_BUSINESS_INCOME";
    IncomeTypesAsset["RentalIncome"] = "RENTAL_INCOME";
    IncomeTypesAsset["InvestmentIncome"] = "INVESTMENT_INCOME";
})(IncomeTypesAsset_IncomeTypesAsset || (IncomeTypesAsset_IncomeTypesAsset = {}));
//# sourceMappingURL=IncomeTypesAsset.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/IncomeTypesGovt.js
var IncomeTypesGovt_IncomeTypesGovt;
(function (IncomeTypesGovt) {
    IncomeTypesGovt["GovtBenefit"] = "GOVT_BENEFIT";
})(IncomeTypesGovt_IncomeTypesGovt || (IncomeTypesGovt_IncomeTypesGovt = {}));
//# sourceMappingURL=IncomeTypesGovt.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/IncomeTypesOthers.js
var IncomeTypesOthers_IncomeTypesOthers;
(function (IncomeTypesOthers) {
    IncomeTypesOthers["SuperAnnuityPension"] = "SUPER_ANNUITY_PENSION";
    IncomeTypesOthers["WorkersCompensation"] = "WORKERS_COMPENSATION";
    IncomeTypesOthers["ForeignIncome"] = "FOREIGN_INCOME";
    IncomeTypesOthers["ChildMaintenance"] = "CHILD_MAINTENANCE";
    IncomeTypesOthers["CentrelinkBenefit"] = "CENTRELINK_BENEFIT";
    IncomeTypesOthers["OtherIncome"] = "OTHER_INCOME";
})(IncomeTypesOthers_IncomeTypesOthers || (IncomeTypesOthers_IncomeTypesOthers = {}));
//# sourceMappingURL=IncomeTypesOthers.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/IncomeTypesPayg.js
var IncomeTypesPayg_IncomeTypesPayg;
(function (IncomeTypesPayg) {
    IncomeTypesPayg["BaseSalary"] = "PAYG_BASE_SALARY";
    IncomeTypesPayg["CommissionIncome"] = "PAYG_COMMISSION_INCOME";
    IncomeTypesPayg["BonusIncome"] = "PAYG_BONUS_INCOME";
    IncomeTypesPayg["OvertimeIncome"] = "PAYG_OVERTIME_INCOME";
    IncomeTypesPayg["CarAllowance"] = "PAYG_CAR_ALLOWANCE";
    IncomeTypesPayg["AllowancesTaxed"] = "PAYG_ALLOWANCES_TAXED";
    IncomeTypesPayg["AllowancesNotTaxed"] = "PAYG_ALLOWANCES_NOT_TAXED";
    IncomeTypesPayg["CompanyCar"] = "PAYG_COMPANY_CAR";
    IncomeTypesPayg["NonVoluntaryDeductionsPreTax"] = "PAYG_NON_VOLUNTARY_DEDUCTIONS_PRE_TAX";
    IncomeTypesPayg["SalarySacrifice"] = "PAYG_SALARY_SACRIFICE";
})(IncomeTypesPayg_IncomeTypesPayg || (IncomeTypesPayg_IncomeTypesPayg = {}));
//# sourceMappingURL=IncomeTypesPayg.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/IncomeTypesSelfEmployed.js
var IncomeTypesSelfEmployed_IncomeTypesSelfEmployed;
(function (IncomeTypesSelfEmployed) {
    IncomeTypesSelfEmployed["SelfEmployedBusinessIncomeFullDoc"] = "SELF_EMPLOYED_BUSINESS_INCOME_FULL_DOC";
    IncomeTypesSelfEmployed["SelfEmployedBusinessIncomeLowDoc"] = "SELF_EMPLOYED_BUSINESS_INCOME_LOW_DOC";
})(IncomeTypesSelfEmployed_IncomeTypesSelfEmployed || (IncomeTypesSelfEmployed_IncomeTypesSelfEmployed = {}));
//# sourceMappingURL=IncomeTypesSelfEmployed.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Lenders.js
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var Lenders_PARTNER_LENDERS_WITH_SHORTNAME = [
    { name: 'Adelaide Bank', shortName: 'ADE', id: 'adelaide_bank', isPartner: true },
    { name: 'AMP', shortName: 'AMP', id: 'amp', isPartner: true },
    { name: 'ANZ Bank', shortName: 'anz', id: 'anz_bank', isPartner: true },
    { name: 'Auswide Bank', shortName: 'auswide', id: 'auswide_bank', isPartner: true },
    { name: 'Bank Australia', shortName: 'BAU', id: 'bank_australia', isPartner: true },
    { name: 'Bank First', shortName: 'BF', id: 'bank_first', isPartner: true },
    { name: 'Bankwest', shortName: 'bankwest', id: 'bank_west', isPartner: true },
    { name: 'Bluebay Home Loans', shortName: 'BLB', id: 'bluebay_home_loans', isPartner: true },
    { name: 'Better Mortgage Mgmt', shortName: 'BMM', id: 'better_mortgage_mgmt', isPartner: true },
    { name: 'Bank of Melbourne', shortName: 'bom', id: 'bank_of_melbourne', isPartner: true },
    { name: 'Bank SA', shortName: 'BSA', id: 'bank_sa', isPartner: true },
    { name: 'Bluestone', shortName: 'BST', id: 'blue_stone', isPartner: true },
    { name: 'Commonwealth Bank', shortName: 'CBA', id: 'commonwealth_bank', isPartner: true },
    { name: 'Connective Home Loans', shortName: 'CHLA', id: 'connective_home_loans', isPartner: true },
    { name: 'Citibank', shortName: 'citibank', id: 'citi_bank', isPartner: true },
    { name: 'Click Loans', shortName: 'Click_loans', id: 'click_loans', isPartner: true },
    { name: 'Firstmac', shortName: 'FMC', id: 'first_mac', isPartner: true },
    { name: 'Gateway Bank', shortName: 'GCU', id: 'gateway_bank', isPartner: true },
    { name: 'Heritage', shortName: 'heritage', id: 'heritage', isPartner: true },
    { name: 'Better Choice', shortName: 'IDE', id: 'better_choice', isPartner: true },
    { name: 'ING', shortName: 'ing', id: 'ing', isPartner: true },
    { name: 'Laboratories Credit Union', shortName: 'LCU', id: 'laboratories_credit_union', isPartner: true },
    { name: 'LaTrobe', shortName: 'La_Trobe', id: 'la_trobe', isPartner: true },
    { name: 'Loanave', shortName: 'LOA', id: 'loanave', isPartner: true },
    { name: 'Macquarie', shortName: 'macquarie', id: 'macquarie', isPartner: true },
    { name: 'ME Bank', shortName: 'mebank', id: 'me_bank', isPartner: true },
    { name: 'MKM Capital', shortName: 'MKM', id: 'mkm_capital', isPartner: true },
    { name: 'My State Bank', shortName: 'mystate', id: 'my_state_bank', isPartner: true },
    { name: 'NAB', shortName: 'NAB', id: 'nab', isPartner: true },
    {
        name: 'Newcastle Permanent Building Society',
        shortName: 'newcastle',
        id: 'newcastle_permanent_building_society',
        isPartner: true,
    },
    { name: 'Paramount', shortName: 'PAM', id: 'paramount', isPartner: true },
    { name: 'Pepper', shortName: 'pepper', id: 'pepper', isPartner: true },
    { name: 'P&N Bank', shortName: 'pnbank', id: 'pn_bank', isPartner: true },
    { name: 'RESIMAC', shortName: 'Resimac', id: 'resimac', isPartner: true },
    { name: 'St George', shortName: 'stgeorge', id: 'st_george', isPartner: true },
    { name: 'Suncorp', shortName: 'suncorp', id: 'suncorp', isPartner: true },
    { name: 'Teachers Mutual', shortName: 'TMB', id: 'teachers_mutual', isPartner: true },
    { name: 'Virgin Money', shortName: 'VMY', id: 'virgin_money', isPartner: true },
    { name: 'Westpac Bank', shortName: 'Westpac', id: 'westpac_bank', isPartner: true },
    {
        name: 'Connective Home Loans Select ',
        shortName: 'CHLAB',
        id: 'connective_home_loans_select_adelaide',
        isPartner: true,
    },
];
var Lenders_PARTNER_LENDERS_WITHOUT_SHORTNAME = [
    { name: 'Pacific Mortgage Group', shortName: '', id: 'pacific_mortgage_group', isPartner: true },
    { name: 'Gateway Credit Union', shortName: '', id: 'gateway_credit_union', isPartner: true },
];
var Lenders_PARTNER_LENDERS = __spreadArrays(Lenders_PARTNER_LENDERS_WITH_SHORTNAME, Lenders_PARTNER_LENDERS_WITHOUT_SHORTNAME);
var Lenders_NON_PARTNER_WITH_SHORTNAME = [
    { name: 'AAMI', shortName: 'AAMI', id: 'aami', isPartner: false },
    { name: 'AAPBS Settlements Services', shortName: 'AAPBS', id: 'aapbs_ settlements_services', isPartner: false },
    { name: 'Arab Bank of Australia', shortName: 'ABAL', id: 'arab_bank_of_australia', isPartner: false },
    { name: 'ABN AMRO', shortName: 'ABN AMRO', id: 'abn_amro', isPartner: false },
    { name: 'Australia Central Credit Union', shortName: 'ACCU', id: 'australia_central_credit_union', isPartner: false },
    {
        name: 'Australian Defence Credit Union',
        shortName: 'ADCU',
        id: 'australian_defence_credit_union',
        isPartner: false,
    },
    { name: 'Advantedge', shortName: 'Advantedge', id: 'advantedge', isPartner: false },
    { name: 'AFG Home Loans', shortName: 'AFG', id: 'afg_home_loans', isPartner: false },
    { name: 'Australian First Mortgage', shortName: 'AFM', id: 'australian_first_mortgage', isPartner: false },
    { name: 'Australian Military Bank', shortName: 'AMB', id: 'australian_military_bank', isPartner: false },
    { name: 'Australian Mortgage Options', shortName: 'AMO', id: 'australian_mortgage_options', isPartner: false },
    { name: 'AGC', shortName: 'AGC', id: 'agc', isPartner: false },
    { name: 'AIMS Home Loans', shortName: 'AIMS', id: 'aims', isPartner: false },
    { name: 'Allianz', shortName: 'ALV', id: 'allianz', isPartner: false },
    { name: 'AMG', shortName: 'AMG', id: 'amg', isPartner: false },
    { name: 'AMIC', shortName: 'AMIC', id: 'amic', isPartner: false },
    { name: 'AMIST', shortName: 'AMIST', id: 'amist', isPartner: false },
    { name: 'AMS', shortName: 'AMS', id: 'ams', isPartner: false },
    { name: 'Aon Master Trust', shortName: 'AON', id: 'aon_master_trust', isPartner: false },
    { name: 'API', shortName: 'API', id: 'api', isPartner: false },
    { name: 'Athena Home Loans', shortName: 'Athena', id: 'athena_home_loans', isPartner: false },
    {
        name: 'Australian Unity Building Society',
        shortName: 'AUBS',
        id: 'australian_unity_building_society',
        isPartner: false,
    },
    { name: 'Aussie Home Loans', shortName: 'Aussie', id: 'aussie_home_loans', isPartner: false },
    { name: 'AVCO', shortName: 'AVCO', id: 'avco', isPartner: false },
    { name: 'AWA Alliance Bank', shortName: 'AWA', id: 'awa_alliance_bank', isPartner: false },
    { name: 'AXA', shortName: 'AXA', id: 'axa', isPartner: false },
    { name: 'American Express', shortName: 'AMEX', id: 'american_express', isPartner: false },
    { name: 'Bank of America', shortName: 'BAC', id: 'bank_of_america', isPartner: false },
    { name: 'B&E', shortName: 'bande', id: 'bande', isPartner: false },
    { name: 'Bank mecu', shortName: 'bankmecu', id: 'bank_mecu', isPartner: false },
    { name: 'Bank of Sydney', shortName: 'banksyd', id: 'bank_of_sydney', isPartner: false },
    { name: 'Bank Vic', shortName: 'bankvic', id: 'bank_vic', isPartner: false },
    { name: 'Barclays', shortName: 'BARC', id: 'barclays', isPartner: false },
    { name: 'BCU', shortName: 'bcu', id: 'bcu', isPartner: false },
    { name: 'BDCU Alliance Bank', shortName: 'BDCUAB', id: 'bdcu_alliance_bank', isPartner: false },
    {
        name: 'Bass and Equitable Building Society',
        shortName: 'BEBS',
        id: 'bass_and_equitable_building_society',
        isPartner: false,
    },
    { name: 'Bendigo Bank', shortName: 'bendigo', id: 'bendigo_bank', isPartner: false },
    { name: 'Beyond Bank Australia', shortName: 'beyondbank', id: 'beyond_bank_australia', isPartner: false },
    {
        name: 'Broken Hill Community Credit Union',
        shortName: 'BHCCU',
        id: 'broken_hill_community_credit_union',
        isPartner: false,
    },
    { name: 'Bigsky Building Society', shortName: 'bigsky', id: 'bigsky_building_society', isPartner: false },
    { name: 'Better Mortgage Corporation', shortName: 'BMMC', id: 'better_mortgage_corporation', isPartner: false },
    { name: 'BMW Australia', shortName: 'BMW', id: 'bmw_australia', isPartner: false },
    { name: 'Banque Nationale De Paris', shortName: 'BNP', id: 'banque_nationale_de_paris', isPartner: false },
    { name: 'Bank of China', shortName: 'BOC', id: 'bank_of_china', isPartner: false },
    { name: 'Bank of Heritage Isle', shortName: 'BOCHI', id: 'bank_of_heritage_isle', isPartner: false },
    { name: 'Bank of Queensland', shortName: 'boq', id: 'bank_of_queensland', isPartner: false },
    { name: 'Bankers Trust Australia', shortName: 'BTA', id: 'bankers_trust_australia', isPartner: false },
    { name: 'BankVic', shortName: 'BV', id: 'bankvic', isPartner: false },
    { name: 'Mutual Community', shortName: 'Bupa', id: 'mutual_community', isPartner: false },
    { name: 'BUSSQ', shortName: 'BUSSQ', id: 'bussq', isPartner: false },
    { name: 'CBFC', shortName: 'CBFC', id: 'cbfc', isPartner: false },
    { name: 'CBUS', shortName: 'CBUS', id: 'cbus', isPartner: false },
    { name: 'Central West Credit Union', shortName: 'CWCU', id: 'central_west_credit_union', isPartner: false },
    { name: 'City Coast Credit Union', shortName: 'CCCU', id: 'city_coast_credit_union', isPartner: false },
    { name: 'Circle Credit Union', shortName: 'CCU', id: 'circle_credit_union', isPartner: false },
    { name: 'CGU', shortName: 'CGU', id: 'cgu', isPartner: false },
    { name: 'CHU', shortName: 'CHU', id: 'chu', isPartner: false },
    { name: 'CIC', shortName: 'CIC', id: 'cic', isPartner: false },
    { name: 'CIL', shortName: 'CIL', id: 'cil', isPartner: false },
    { name: 'Circle Alliance Bank', shortName: 'CAB', id: 'circle_alliance_bank', isPartner: false },
    { name: 'CIT Credit Pty', shortName: 'CIT', id: 'cit_credit_pty', isPartner: false },
    { name: 'Club Plus Super', shortName: 'CLB', id: 'clb_plus_super', isPartner: false },
    { name: 'Challenge Bank', shortName: 'CLG', id: 'challenge_bank', isPartner: false },
    {
        name: 'Community First Credit Union',
        shortName: 'communityfirst',
        id: 'comunity_first_credit_union',
        isPartner: false,
    },
    { name: 'Credit Union Australia', shortName: 'cua', id: 'credit_union_australia', isPartner: false },
    {
        name: 'Credit Union Financial Services',
        shortName: 'CUFS',
        id: 'credit_union_financial_services',
        isPartner: false,
    },
    { name: 'Coastline Credit Union', shortName: 'CUS', id: 'coastline_credit_union', isPartner: false },
    { name: 'Deutsche Bank', shortName: 'DBK', id: 'deutsche_bank', isPartner: false },
    { name: 'Diners Club', shortName: 'DCI', id: 'diners_club', isPartner: false },
    { name: 'Defence Bank', shortName: 'defencebank', id: 'defence_bank', isPartner: false },
    { name: 'ECU', shortName: 'ECU', id: 'ecu', isPartner: false },
    { name: 'EECU', shortName: 'EECU', id: 'eecu', isPartner: false },
    { name: 'Elders', shortName: 'EFP', id: 'elders', isPartner: false },
    { name: 'EISS', shortName: 'EISS', id: 'eiss', isPartner: false },
    { name: 'Fundcorp', shortName: 'FCI', id: 'fundcorp', isPartner: false },
    { name: 'Firefighters mutual bank', shortName: 'FMB', id: 'firefighters_mutual_bank', isPartner: false },
    { name: 'Genworth', shortName: 'Genworth', id: 'genworth', isPartner: false },
    { name: 'GIO', shortName: 'GIO', id: 'gio', isPartner: false },
    { name: 'Goldfields Money', shortName: 'goldfields_money', id: 'gmac_finance', isPartner: false },
    { name: 'Great Pacific Financial', shortName: 'GPF', id: 'great_pacific_financial', isPartner: false },
    { name: 'GRE', shortName: 'GRE', id: 'gre', isPartner: false },
    { name: 'Guild', shortName: 'Guild', id: 'guild', isPartner: false },
    { name: 'HBF', shortName: 'HBF', id: 'hbf', isPartner: false },
    { name: 'HESTA', shortName: 'Hesta', id: 'hesta', isPartner: false },
    { name: 'Holiday Coast Credit Union', shortName: 'HCCU', id: 'holiday_coast_credit_union', isPartner: false },
    { name: 'Homeloans Ltd', shortName: 'HLLC', id: 'homeloans_ltd', isPartner: false },
    { name: 'HSBC', shortName: 'hsbc', id: 'hsbc', isPartner: false },
    { name: 'Hume Building Society', shortName: 'Hume', id: 'hume_building_society', isPartner: false },
    { name: 'International Acceptance', shortName: 'IA', id: 'international_acceptance', isPartner: false },
    {
        name: 'International Commercial Bank of China',
        shortName: 'ICBC',
        id: 'international_commercial_bank_of_china',
        isPartner: false,
    },
    { name: 'IDEG', shortName: 'IDEG', id: 'ideg', isPartner: false },
    { name: 'Illawarra Credit Union', shortName: 'illawarra', id: 'illawarra_credit_union', isPartner: false },
    { name: 'IMB Ltd', shortName: 'imb', id: 'imb_ltd', isPartner: false },
    { name: 'ING Direct', shortName: 'INGC', id: 'ing_direct', isPartner: false },
    { name: 'IOOF Building Society', shortName: 'IOOF', id: 'ioof_building_society', isPartner: false },
    { name: 'Keystart Home Loans', shortName: 'Keystart', id: 'keystart_home_loans', isPartner: false },
    { name: 'Kwik Kash International', shortName: 'Kwik Kash', id: 'kwik_kash_international', isPartner: false },
    { name: 'Local Government', shortName: 'LGS', id: 'local_government', isPartner: false },
    { name: 'Liberty', shortName: 'liberty', id: 'liberty', isPartner: false },
    { name: 'Lombard Finance', shortName: 'Lombard', id: 'lombard_finance', isPartner: false },
    { name: 'LUCRF Super', shortName: 'LUCRF', id: 'lucrf_super', isPartner: false },
    { name: 'Macquarie Credit Union', shortName: 'macquariecu', id: 'macquarie_credit_union', isPartner: false },
    { name: 'MAP', shortName: 'MAP', id: 'map', isPartner: false },
    { name: 'Mediplan Australia', shortName: 'Mediplan', id: 'mediplan_australia', isPartner: false },
    { name: 'Mercantile Mutual', shortName: 'MERC', id: 'mercantile_mutual', isPartner: false },
    { name: 'Mercer Wealth', shortName: 'Mercer', id: 'mercer_wealth', isPartner: false },
    { name: 'Midland Bank PLC', shortName: 'Midland', id: 'midland_bank_plc', isPartner: false },
    { name: 'Mine Wealth and Wellbeing', shortName: 'Mine Super', id: 'mine_wealth_and_wellbeing', isPartner: false },
    { name: 'MIP', shortName: 'MIP', id: 'mip', isPartner: false },
    { name: 'MIS', shortName: 'MIS', id: 'mis', isPartner: false },
    { name: 'MLC', shortName: 'MLC', id: 'mlc', isPartner: false },
    { name: 'MMI', shortName: 'MMI', id: 'mmi', isPartner: false },
    { name: 'MTAA', shortName: 'MTAA', id: 'mtaa', isPartner: false },
    { name: 'My Credit Union', shortName: 'mycredit', id: 'my_credit_union', isPartner: false },
    { name: 'NSF Super', shortName: 'Nationwide', id: 'nsf_super', isPartner: false },
    { name: 'Natwest Markets Australia', shortName: 'Natwest', id: 'natwest_markets_australia', isPartner: false },
    { name: 'Northern Building Society', shortName: 'NBS', id: 'northern_building_society', isPartner: false },
    { name: 'Northern Inland Credit Union', shortName: 'NICU', id: 'northern_inland_credit_union', isPartner: false },
    { name: 'NGS', shortName: 'NGS', id: 'ngs', isPartner: false },
    { name: 'National Mortgage Company', shortName: 'nmc', id: 'national_mortgage_company', isPartner: false },
    { name: 'NRMA', shortName: 'NRMA', id: 'nrma', isPartner: false },
    { name: 'NZI', shortName: 'NZI', id: 'nzi', isPartner: false },
    {
        name: 'Overseas-Chinese Banking Corporation',
        shortName: 'OCBC Bank',
        id: 'overseas_chinese_banking_corporation',
        isPartner: false,
    },
    { name: 'Origin Finance', shortName: 'Origin', id: 'origin_finance', isPartner: false },
    { name: 'Origin MMS', shortName: 'OriginMMS', id: 'origin_mms', isPartner: false },
    {
        name: 'Pioneer Permanent Building Society',
        shortName: 'PBS',
        id: 'pioneer_permanent_building_society',
        isPartner: false,
    },
    {
        name: "People's Choice Credit Union",
        shortName: 'peopleschoicecu',
        id: 'peoples_choice_credit_union',
        isPartner: false,
    },
    { name: 'Perpetual Limited', shortName: 'Perpetual', id: 'perpetual_limited', isPartner: false },
    { name: 'Plum', shortName: 'Plum', id: 'plum', isPartner: false },
    { name: 'Police Credit Union', shortName: 'policecu', id: 'police_credit_union', isPartner: false },
    { name: 'QANTAS Credit Union', shortName: 'qantas', id: 'qantas_credit_union', isPartner: false },
    { name: 'QBE', shortName: 'QBE', id: 'qbe', isPartner: false },
    {
        name: 'Queensland Country Credit Union',
        shortName: 'QCCU',
        id: 'queensland_country_credit_union',
        isPartner: false,
    },
    { name: 'RAC', shortName: 'RAC', id: 'rac', isPartner: false },
    { name: 'RACV', shortName: 'RACV', id: 'racv', isPartner: false },
    { name: 'RAMS', shortName: 'rams', id: 'rams', isPartner: false },
    { name: 'Reserve Bank of Australia', shortName: 'RBA', id: 'reserve_bank_of_australia', isPartner: false },
    { name: 'REA Home Loans', shortName: 'REA', id: 'rea_home_loans', isPartner: false },
    { name: 'Safrock Finance', shortName: 'Safrock', id: 'safrock_finance', isPartner: false },
    { name: 'Suncorp Metway', shortName: 'SCMC', id: 'suncorp_metway', isPartner: false },
    { name: 'SGIC', shortName: 'SGIC', id: 'sgic', isPartner: false },
    { name: 'SGIO', shortName: 'SGIO', id: 'sgio', isPartner: false },
    {
        name: 'State Street Bank And Trust Company',
        shortName: 'state street',
        id: 'state_street_bank_and_trust_company',
        isPartner: false,
    },
    { name: 'Summerland Credit Union', shortName: 'Summerland', id: 'summerland_credit_union', isPartner: false },
    { name: 'Macarthur Credit Union', shortName: 'The MAC', id: 'macarthur_credit_union', isPartner: false },
    {
        name: 'Maitland Mutual Building Society',
        shortName: 'The Mutual',
        id: 'maitland_mutual_building_society',
        isPartner: false,
    },
    {
        name: 'Thinktank lending commercial finance',
        shortName: 'Thinktank',
        id: 'thinktank_lending_commercial_finance',
        isPartner: false,
    },
    { name: 'Tictoc Online', shortName: 'Tictoc', id: 'tictoc_online', isPartner: false },
    { name: 'Tic:Toc Home Loans', shortName: 'Tictoc', id: 'tictoc_home_loans', isPartner: false },
    { name: 'Trust Bank of Tasmania', shortName: 'Trust Bank', id: 'trust_bank_of_tasmania', isPartner: false },
    { name: 'Unibank', shortName: 'Uni', id: 'unibank', isPartner: false },
    { name: 'United Overseas Bank', shortName: 'UOB', id: 'united_overseas_bank', isPartner: false },
    {
        name: 'Victoria Teachers Credit Union Ltd',
        shortName: 'victeach',
        id: 'victeach_teachers_credit_union_ltd',
        isPartner: false,
    },
    { name: 'Credit Corp', shortName: 'CCFS', id: 'credit_corp', isPartner: false },
    { name: 'Credit Union SA', shortName: 'CUSA', id: 'credit_union_sa', isPartner: false },
    { name: 'Family First Credit Union', shortName: 'FFCU', id: 'family_first_credit_union', isPartner: false },
    { name: 'Fox Symes', shortName: 'FS', id: 'fox_symes', isPartner: false },
    { name: 'Freedom Lend', shortName: 'FL', id: 'freedom_lend', isPartner: false },
    { name: 'Lysaght Credit Union', shortName: 'LCU', id: 'lysaght_credit_union', isPartner: false },
    { name: 'Police Credit Union (NSW)', shortName: 'policecu', id: 'police_credit_union_nsw', isPartner: false },
    { name: 'The Rock', shortName: 'RBS', id: 'the_rock', isPartner: false },
    { name: 'Zip Co', shortName: 'Zip', id: 'zip', isPartner: false },
    { name: 'Plenti', shortName: 'Plenti', id: 'plenti', isPartner: false },
    { name: 'Latitude Financial', shortName: 'Latitude', id: 'latitude', isPartner: false },
    { name: 'Cash Converters', shortName: 'Cash Converters', id: 'cash_converters', isPartner: false },
    { name: 'Nimble', shortName: 'Nimble', id: 'nimble', isPartner: false },
    { name: 'SocietyOne', shortName: 'SocietyOne', id: 'societyone', isPartner: false },
    { name: 'MoneyMe', shortName: 'mme', id: 'moneyme', isPartner: false },
    { name: 'Harmoney', shortName: 'Harmoney', id: 'harmoney', isPartner: false },
    { name: 'Afterpay', shortName: 'Afterpay', id: 'afterpay', isPartner: false },
    {
        name: 'Australian Pensioners Insurance',
        shortName: 'API',
        id: 'australian_pensioners_insurance',
        isPartner: false,
    },
    { name: 'Cash Converters ', shortName: 'Cash Converters', id: 'cash_converters_', isPartner: false },
    { name: 'Iden Group', shortName: 'Iden', id: 'iden_group', isPartner: false },
    { name: 'Members Equity Bank', shortName: 'ME Bank', id: 'members_equity_bank', isPartner: false },
    { name: 'National Mortgage Corporation', shortName: 'NMC', id: 'national_mortgage_corporation', isPartner: false },
    { name: 'Queensland Credit Union', shortName: 'QCU', id: 'queensland_credit_union', isPartner: false },
    {
        name: 'Queensland Professional Credit Union',
        shortName: 'QPCU',
        id: 'queensland_professional_credit_union',
        isPartner: false,
    },
    { name: 'Think Tank Group Pty Ltd', shortName: 'Think Tank', id: 'think_tank_group_pty_ltd', isPartner: false },
    {
        name: 'Volkswagon Financial Services',
        shortName: 'VW Finance',
        id: 'volkswagon_financial_services',
        isPartner: false,
    },
    { name: 'Zip Co', shortName: 'zip', id: 'zip_co', isPartner: false },
];
var Lenders_NON_PARTNER_WITHOUT_SHORTNAME = [
    { name: 'CommBank Financial Planner', shortName: '', id: 'commBank_financial_planner', isPartner: false },
    { name: 'Homeloans.com.au', shortName: '', id: 'homeloans_com_au', isPartner: false },
    { name: 'Horizon Bank', shortName: '', id: 'horizon_bank', isPartner: false },
    { name: 'Loans.com.au', shortName: '', id: 'loans_com_au', isPartner: false },
    { name: 'Nova Alliance Bank', shortName: '', id: 'nova_alliance_bank', isPartner: false },
    { name: 'QBank', shortName: '', id: 'qbank', isPartner: false },
    { name: 'Reduce', shortName: '', id: 'reduce', isPartner: false },
    { name: 'Regional Australia Bank', shortName: '', id: 'regional_australia_bank', isPartner: false },
    { name: 'Unity Bank', shortName: '', id: 'unity_bank', isPartner: false },
    { name: 'Allstate Home Loans', shortName: '', id: 'allstate_home_loans', isPartner: false },
    { name: 'ANZ Wealth', shortName: '', id: 'anz_wealth', isPartner: false },
    { name: 'Armidale Building Society', shortName: '', id: 'armidale_building_society', isPartner: false },
    { name: 'Asahi Bank', shortName: '', id: 'asahi_bank', isPartner: false },
    { name: 'Assured', shortName: '', id: 'assured', isPartner: false },
    { name: 'Athena', shortName: '', id: 'athena', isPartner: false },
    { name: 'Aussie Mastercard', shortName: '', id: 'aussie_mastercard', isPartner: false },
    { name: 'Aussie Mortgage Ltd', shortName: '', id: 'aussie_mortgage', isPartner: false },
    { name: 'Aust Alliance', shortName: '', id: 'aust_alliance', isPartner: false },
    { name: 'Austral Mortgage', shortName: '', id: 'austral_mortgage', isPartner: false },
    { name: 'Australian Ethical', shortName: '', id: 'australian _ethical', isPartner: false },
    { name: 'AustralianSuper', shortName: '', id: 'australian_super', isPartner: false },
    { name: 'AustSafe', shortName: '', id: 'aust_safe', isPartner: false },
    { name: 'Australian Catholic', shortName: '', id: 'australian_catholic', isPartner: false },
    { name: 'Australian Eagle', shortName: '', id: 'australian_eagle', isPartner: false },
    { name: 'AV Super', shortName: '', id: 'av_super', isPartner: false },
    { name: 'Bank of Tokyo-Mitsubishi', shortName: '', id: 'bank_of_tokyo_mitsubishi', isPartner: false },
    { name: 'Barnes Home Loans', shortName: '', id: 'barnes_home_loans', isPartner: false },
    { name: 'Brighten Home Loans', shortName: '', id: 'brighten_ome_loans', isPartner: false },
    { name: 'Building Society MP', shortName: '', id: 'building_society_mp', isPartner: false },
    { name: 'Buyers Edge', shortName: '', id: 'buyers_edge', isPartner: false },
    { name: 'Capital Finance', shortName: '', id: 'capital_finance', isPartner: false },
    { name: 'Capricornia Credit Union', shortName: '', id: 'capricornia_credit_union', isPartner: false },
    { name: 'CareSuper', shortName: '', id: 'care_super', isPartner: false },
    { name: 'Cash Doctors', shortName: '', id: 'cash_doctors', isPartner: false },
    { name: 'Catalyst Money', shortName: '', id: 'catalyst_money', isPartner: false },
    { name: 'Catholic Church', shortName: '', id: 'catholic_church', isPartner: false },
    { name: 'Catholic Super', shortName: '', id: 'catholic_super', isPartner: false },
    { name: 'Certegy', shortName: '', id: 'certegy', isPartner: false },
    { name: 'Chase Manhattan Bank', shortName: '', id: 'chase_manhattan_bank', isPartner: false },
    { name: 'Chequecash Pty Ltd', shortName: '', id: 'chequecash_pty_ltd', isPartner: false },
    { name: 'ChoiceLend', shortName: '', id: 'choiceLend', isPartner: false },
    { name: 'Christian Super', shortName: '', id: 'christian_super', isPartner: false },
    { name: 'Citywide Home Loans', shortName: '', id: 'citywide_home_loans', isPartner: false },
    { name: 'Co Operative Ins Co', shortName: '', id: 'co_operative_ins_co', isPartner: false },
    { name: 'Colonial First State', shortName: '', id: 'colonial_first_state', isPartner: false },
    { name: 'Colonial Mutual', shortName: '', id: 'colonial_mutual', isPartner: false },
    { name: 'Colonial', shortName: '', id: 'colonial', isPartner: false },
    { name: 'Commercial Union', shortName: '', id: 'commercial_union', isPartner: false },
    { name: 'CommInsure', shortName: '', id: 'commInsure', isPartner: false },
    { name: 'CPS Credit Union', shortName: '', id: 'cps_ credit Union', isPartner: false },
    { name: 'Credit Union Settlement Services', shortName: '', id: 'credit_union_settlement_services', isPartner: false },
    { name: 'Cumis', shortName: '', id: 'cumis', isPartner: false },
    { name: 'Cuscal', shortName: '', id: 'Cuscal', isPartner: false },
    { name: 'Custom Credit', shortName: '', id: 'custom_credit', isPartner: false },
    { name: 'Dai-Ichi Kango Bank', shortName: '', id: 'dai_ichi_kango_bank', isPartner: false },
    { name: 'Daimlerchrysler Finance', shortName: '', id: 'daimlerchrysler_finance', isPartner: false },
    { name: 'Debt Purchase Australia', shortName: '', id: 'debt_purchase_australia', isPartner: false },
    { name: 'Defence Credit', shortName: '', id: 'defence_credit', isPartner: false },
    {
        name: 'Defence Force Credit Union Limited',
        shortName: '',
        id: 'defence_force_credit_union_limited',
        isPartner: false,
    },
    { name: 'Defence Services Homes', shortName: '', id: 'defence_services_homes', isPartner: false },
    { name: 'Delphi Bank', shortName: '', id: 'delphi_bank', isPartner: false },
    {
        name: 'Dnister Ukrainian Credit Co-operative',
        shortName: '',
        id: 'dnister_ukrainian_credit_co_operative',
        isPartner: false,
    },
    { name: 'Easy Street Financial Services', shortName: '', id: 'easy_street_financial_services', isPartner: false },
    { name: 'ELCOM Credit Union', shortName: '', id: 'elcom_credit_union', isPartner: false },
    { name: 'Energy Super', shortName: '', id: 'energy_super', isPartner: false },
    { name: 'Equity Super', shortName: '', id: 'equity_super', isPartner: false },
    { name: 'Esanda', shortName: '', id: 'esanda', isPartner: false },
    { name: 'Essential Super', shortName: '', id: 'essential_super', isPartner: false },
    { name: 'Ezy Bank', shortName: '', id: 'ezy_bank', isPartner: false },
    { name: 'FAI', shortName: '', id: 'fai', isPartner: false },
    { name: 'FASTLend', shortName: '', id: 'fastlend', isPartner: false },
    { name: 'Federation', shortName: '', id: 'federation', isPartner: false },
    { name: 'FinancePath', shortName: '', id: 'finance_path', isPartner: false },
    { name: 'Fire Brigades Credit Union', shortName: '', id: 'fire_brigades_credit_union', isPartner: false },
    { name: 'Fire Service Credit Union', shortName: '', id: 'fire_service_credit_union', isPartner: false },
    { name: 'First Choice Credit Union', shortName: '', id: 'first_choice_credit_union', isPartner: false },
    { name: 'First National Bank of Chicago', shortName: '', id: 'first_national_bank_of_chicago', isPartner: false },
    { name: 'First Option Bank', shortName: '', id: 'first_option_bank', isPartner: false },
    { name: 'First Permanent Home Loans', shortName: '', id: 'first_permanent_home_loans', isPartner: false },
    {
        name: 'First Provincial Building Society',
        shortName: '',
        id: 'first_provincial_building_society',
        isPartner: false,
    },
    { name: 'First State Super', shortName: '', id: 'first_state_super', isPartner: false },
    { name: 'First Super', shortName: '', id: 'first_super', isPartner: false },
    { name: 'Flexirent', shortName: '', id: 'flexirent', isPartner: false },
    { name: 'Ford Credit', shortName: '', id: 'ford_credit', isPartner: false },
    { name: 'Fortis', shortName: '', id: 'fortis', isPartner: false },
    { name: 'Future Financial', shortName: '', id: 'future_financial', isPartner: false },
    { name: 'G&C Mutual Bank', shortName: '', id: 'gc_mutual_bank', isPartner: false },
    { name: 'GE Automotive', shortName: '', id: 'ge_automotive', isPartner: false },
    {
        name: 'GE Capital Finance (Go Mastercard)',
        shortName: '',
        id: 'ge_capital_finance_go_mastercard',
        isPartner: false,
    },
    { name: 'GE Capital Finance', shortName: '', id: 'ge_capital_finance', isPartner: false },
    { name: 'GE Credit Line', shortName: '', id: 'ge_credit_line', isPartner: false },
    { name: 'Ge Finance', shortName: '', id: 'ge_finance', isPartner: false },
    { name: 'GE Money Aust Pty Ltd', shortName: '', id: 'ge_money_aust_pty_ltd', isPartner: false },
    { name: 'GE Mortgages', shortName: '', id: 'ge_mortgages', isPartner: false },
    { name: 'Geelong Bank', shortName: '', id: 'geelong_bank', isPartner: false },
    { name: 'GIO Building Society', shortName: '', id: 'gio_building_society', isPartner: false },
    { name: 'Grace Bros', shortName: '', id: 'grace_bros', isPartner: false },
    { name: 'Greater Building Society', shortName: '', id: 'greater_building_society', isPartner: false },
    { name: 'Hanover Consumer Finance', shortName: '', id: 'hanover_consumer_finance', isPartner: false },
    { name: 'Home Building Society', shortName: '', id: 'home_building_society', isPartner: false },
    { name: 'Homeside', shortName: '', id: 'homeside', isPartner: false },
    { name: 'Homestar Finance', shortName: '', id: 'homestar_finance', isPartner: false },
    { name: 'Homestart Finance', shortName: '', id: 'homestart_finance', isPartner: false },
    { name: 'Homeswest', shortName: '', id: 'homeswest', isPartner: false },
    { name: 'Hunter United', shortName: '', id: 'hunter_united', isPartner: false },
    { name: 'IBJ Australia Bank', shortName: '', id: 'ibj_australia_bank', isPartner: false },
    { name: 'Ignite', shortName: '', id: 'ignite', isPartner: false },
    { name: 'Illawarra Building Society', shortName: '', id: 'illawarra_building_society', isPartner: false },
    { name: 'INC Invest', shortName: '', id: 'inc_invest', isPartner: false },
    { name: 'ING Mercantile Mutual Bank', shortName: '', id: 'ing_mercantile_mutual_bank', isPartner: false },
    { name: 'Intech Credit Union', shortName: '', id: 'intech_credit_union', isPartner: false },
    { name: 'InTrust', shortName: '', id: 'in_trust', isPartner: false },
    { name: 'Investec', shortName: '', id: 'investec', isPartner: false },
    { name: 'Kinetic', shortName: '', id: 'kinetic', isPartner: false },
    { name: 'Legal Super', shortName: '', id: 'legal_super', isPartner: false },
    { name: 'Lion Finance', shortName: '', id: 'lion_finance', isPartner: false },
    { name: 'M Capitol', shortName: '', id: 'm_capitol', isPartner: false },
    {
        name: 'Mackay Permanent Building Society',
        shortName: '',
        id: 'mackay_permanent_building_society',
        isPartner: false,
    },
    { name: 'Manufacture Mutual', shortName: '', id: 'manufacture_mutual', isPartner: false },
    { name: 'Media Super', shortName: '', id: 'media_super', isPartner: false },
    { name: 'Mitchell Building Society', shortName: '', id: 'mitchell_building_society', isPartner: false },
    {
        name: 'Morgan Guaranty Trust Bank of New York',
        shortName: '',
        id: 'morgan_guaranty_trust_bank_of_new_york',
        isPartner: false,
    },
    { name: 'Mortgage Choice', shortName: '', id: 'mortgage_choice', isPartner: false },
    { name: 'Mortgage Ezy', shortName: '', id: 'mortgage_ezy', isPartner: false },
    { name: 'Mortgage House', shortName: '', id: 'mortgage_house', isPartner: false },
    { name: 'Mortgage Mart', shortName: '', id: 'mortgage_mart', isPartner: false },
    { name: 'Mortgageport', shortName: '', id: 'mortgageport', isPartner: false },
    { name: 'MOVE Bank', shortName: '', id: 'move_bank', isPartner: false },
    { name: 'NCUIS', shortName: '', id: 'ncuis', isPartner: false },
    { name: 'NSW Home Loans', shortName: '', id: 'new_home_loans', isPartner: false },
    { name: 'NSW Teachers Credit Union', shortName: '', id: 'new__teachers_credit_union', isPartner: false },
    { name: 'OneAnswer', shortName: '', id: 'one_answer', isPartner: false },
    { name: 'Orange Credit Union', shortName: '', id: 'orange_credit_union', isPartner: false },
    { name: 'Other', shortName: '', id: 'other', isPartner: false },
    { name: 'Payday Central', shortName: '', id: 'payday_central', isPartner: false },
    { name: 'Pensioners Insurance', shortName: '', id: 'pensioners_insurance', isPartner: false },
    { name: 'Perpetual Trustee', shortName: '', id: 'perpetual_trustee', isPartner: false },
    { name: 'PLANLend', shortName: '', id: 'planlend', isPartner: false },
    { name: 'Police and Nurses', shortName: '', id: 'police_and_nurses', isPartner: false },
    { name: 'Police Bank', shortName: '', id: 'police_bank', isPartner: false },
    { name: 'Powerstate Credit Union', shortName: '', id: 'powerstate_credit_union', isPartner: false },
    {
        name: 'Primary Industry Bank of Australia',
        shortName: '',
        id: 'primary_industry_bank_of_australia',
        isPartner: false,
    },
    { name: 'Prime', shortName: '', id: 'prime', isPartner: false },
    { name: 'Prospect Credit Union', shortName: '', id: 'prospect_credit_union', isPartner: false },
    { name: 'Public Trustee', shortName: '', id: 'public_trustee', isPartner: false },
    { name: 'Pulse Credit Union', shortName: '', id: 'pulse_credit_union', isPartner: false },
    { name: 'Qudos Bank', shortName: '', id: 'qudos_bank', isPartner: false },
    {
        name: 'Queensland Industry Development Corp',
        shortName: '',
        id: 'queensland_industry_development_corp',
        isPartner: false,
    },
    { name: 'Queensland Teachers Credit Union', shortName: '', id: 'queensland_teachers_credit_union', isPartner: false },
    { name: 'Queenslanders Credit Union', shortName: '', id: 'queenslanders_credit_union', isPartner: false },
    { name: 'RAC WA', shortName: '', id: 'rac_wa', isPartner: false },
    { name: 'RACQ Bank', shortName: '', id: 'racq_bank', isPartner: false },
    { name: 'Radio Rentals', shortName: '', id: 'radio_rentals', isPartner: false },
    { name: 'Railways Credit Union', shortName: '', id: 'railways_credit_union', isPartner: false },
    { name: 'Repcol', shortName: '', id: 'repcol', isPartner: false },
    { name: 'RESI Mortgage Corporation', shortName: '', id: 'resi_mortgage_corporation,', isPartner: false },
    { name: 'Resi', shortName: '', id: 'resi,', isPartner: false },
    { name: 'Royal Life', shortName: '', id: 'royal_life,', isPartner: false },
    { name: 'Russell Investments', shortName: '', id: 'russell_investments', isPartner: false },
    { name: 'Sanwa Australia Finance Limited', shortName: '', id: 'Sanwa Australia Finance Limited', isPartner: false },
    { name: 'Savings And Loans Credit Union', shortName: '', id: 'savings_and_loans_credit_union', isPartner: false },
    { name: 'SCU', shortName: '', id: 'scu', isPartner: false },
    { name: 'Service One Alliance Bank', shortName: '', id: 'service_one_alliance_bank', isPartner: false },
    { name: 'Shannons', shortName: '', id: 'shannons', isPartner: false },
    { name: 'SmartSave', shortName: '', id: 'smart_save', isPartner: false },
    { name: 'Southern Cross Credit Union', shortName: '', id: 'southern_cross_credit_union', isPartner: false },
    { name: 'Sovereign Credit', shortName: '', id: 'sovereign_credit', isPartner: false },
    { name: 'St Andrew', shortName: '', id: 'st_andrew', isPartner: false },
    { name: 'Standard Chartered Bank Aust', shortName: '', id: 'standard_chartered_bank_aust', isPartner: false },
    { name: 'State Custodians', shortName: '', id: 'state_custodians', isPartner: false },
    { name: 'Statewide', shortName: '', id: 'statewide', isPartner: false },
    { name: 'Stronghold', shortName: '', id: 'stronghold', isPartner: false },
    { name: 'Sun Alliance', shortName: '', id: 'sun_alliance', isPartner: false },
    { name: 'Sunsuper', shortName: '', id: 'sunsuper', isPartner: false },
    { name: 'Swann', shortName: '', id: 'swann', isPartner: false },
    { name: 'TasPlan', shortName: '', id: 'tas_plan', isPartner: false },
    { name: 'Teachers Credit Union', shortName: '', id: 'teachers_credit_union', isPartner: false },
    {
        name: 'Territory Mutual Building Society',
        shortName: '',
        id: 'territory_mutual_building_society',
        isPartner: false,
    },
    { name: 'The Capricornia', shortName: '', id: 'the_capricornia', isPartner: false },
    { name: 'The Mac', shortName: '', id: 'the_mac', isPartner: false },
    { name: 'The Mutual Bank', shortName: '', id: 'the_mutual_bank', isPartner: false },
    { name: 'Tonto Home Loans', shortName: '', id: 'tonto_home_loans', isPartner: false },
    { name: 'Town And Country Bank', shortName: '', id: 'town_and_country_bank', isPartner: false },
    { name: 'Toyota Finance Australia', shortName: '', id: 'toyota_finance_australia', isPartner: false },
    { name: 'Transport Mutual Credit Union', shortName: '', id: 'transport_mutual_credit_union', isPartner: false },
    { name: 'TWUSUPER', shortName: '', id: 'twusuper', isPartner: false },
    { name: 'UBank', shortName: '', id: 'ubank', isPartner: false },
    { name: 'United Credit Union', shortName: '', id: 'united_credit_union', isPartner: false },
    { name: 'University Credit Society', shortName: '', id: 'university_credit_society', isPartner: false },
    { name: 'VACC', shortName: '', id: 'vacc', isPartner: false },
    { name: 'Vero', shortName: '', id: 'vero', isPartner: false },
    { name: 'VicSuper', shortName: '', id: 'vic_super', isPartner: false },
    { name: 'Virgin Super', shortName: '', id: 'virgin_super', isPartner: false },
    { name: 'Visions', shortName: '', id: 'visions', isPartner: false },
    { name: 'Western QBE', shortName: '', id: 'western_qbe', isPartner: false },
    { name: 'Westfarmers', shortName: '', id: 'westfarmers', isPartner: false },
    { name: 'Westpack Insurance Services', shortName: '', id: 'westpack_insurance_services', isPartner: false },
    {
        name: 'Wide Bay Capricorn Building Society',
        shortName: '',
        id: 'wide_bay_capricorn_building_society',
        isPartner: false,
    },
    { name: 'Wizard', shortName: '', id: 'wizard', isPartner: false },
    {
        name: 'Woolworths Employees Credit Union',
        shortName: '',
        id: 'woolworths_employees_credit_union',
        isPartner: false,
    },
    { name: 'ANZ Asset Finance', shortName: '', id: 'anz_asset_finance', isPartner: false },
    { name: 'Nab Broker', shortName: '', id: 'nab_broker', isPartner: false },
    { name: 'PNC Financial services', shortName: '', id: 'pnc_financial_services', isPartner: false },
    { name: 'World Marine and General', shortName: '', id: 'world_marine_and_general', isPartner: false },
    { name: 'Xinja', shortName: '', id: 'xinjia', isPartner: false },
    { name: 'Yellow Brick Road', shortName: '', id: 'yellow_brick_road', isPartner: false },
    { name: 'Zurich', shortName: '', id: 'zurich', isPartner: false },
    { name: 'Volt', shortName: '', id: 'volt', isPartner: false },
    { name: 'BNK', shortName: '', id: 'BNK', isPartner: false },
    { name: '86 400', shortName: '', id: '86_400', isPartner: false },
    { name: 'ADCU', shortName: '', id: 'adcu', isPartner: false },
    { name: 'AFG Advantedge', shortName: '', id: 'afg_advantedge', isPartner: false },
    { name: 'AFM', shortName: '', id: 'afm', isPartner: false },
    { name: 'Ample Capital Australia', shortName: '', id: 'ample_capital_australia', isPartner: false },
    { name: 'Anchorage', shortName: '', id: 'anchorage', isPartner: false },
    { name: 'ANZ Asset Finance ', shortName: '', id: 'anz_asset_finance_', isPartner: false },
    { name: 'AUL', shortName: '', id: 'aul', isPartner: false },
    {
        name: 'Australian Financial Holdings Pty Ltd',
        shortName: '',
        id: 'australian_financial_holdings_pty_ltd',
        isPartner: false,
    },
    { name: 'Australian Lending Services', shortName: '', id: 'australian_lending_services', isPartner: false },
    { name: 'Australian Wholesale Lending', shortName: '', id: 'australian_wholesale_lending', isPartner: false },
    { name: 'Bank of South Australia', shortName: '', id: 'bank_of_south_australia', isPartner: false },
    { name: 'Banksia', shortName: '', id: 'banksia', isPartner: false },
    { name: 'BCHL', shortName: '', id: 'bchl', isPartner: false },
    { name: 'Bluegum', shortName: '', id: 'bluegum', isPartner: false },
    { name: 'BMC', shortName: '', id: 'bmc', isPartner: false },
    { name: 'BMC Advantedge', shortName: '', id: 'bmc_advantedge', isPartner: false },
    { name: 'CACU', shortName: '', id: 'cacu', isPartner: false },
    { name: 'Coles Financial Services', shortName: '', id: 'coles_financial_services', isPartner: false },
    { name: 'Collins Securities', shortName: '', id: 'collins_securities', isPartner: false },
    { name: 'Columbus Capital Pty Ltd', shortName: '', id: 'columbus_capital_pty_ltd', isPartner: false },
    { name: 'Community CPS Australia ', shortName: '', id: 'community_cps_australia_', isPartner: false },
    { name: 'Community Mutual Ltd', shortName: '', id: 'community_mutual_ltd', isPartner: false },
    { name: 'Credit Union Home Loans', shortName: '', id: 'credit_union_home_loans', isPartner: false },
    { name: 'Direct Mortgage Solutions', shortName: '', id: 'direct_mortgage_solutions', isPartner: false },
    { name: 'Director of Housing VIC ', shortName: '', id: 'director_of_housing_vic_', isPartner: false },
    { name: 'Domain', shortName: '', id: 'domain', isPartner: false },
    { name: 'Economy', shortName: '', id: 'economy', isPartner: false },
    { name: 'eMoney', shortName: '', id: 'emoney', isPartner: false },
    { name: 'Ezy Mortgage', shortName: '', id: 'ezy_mortgage', isPartner: false },
    { name: 'Faraday West and Co Pty Ltd', shortName: '', id: 'faraday_west_and_co_pty_ltd', isPartner: false },
    { name: 'Fifty Group', shortName: '', id: 'fifty_group', isPartner: false },
    { name: 'Finance Express Home Loans', shortName: '', id: 'finance_express_home_loans', isPartner: false },
    { name: 'First Folio', shortName: '', id: 'first_folio', isPartner: false },
    { name: 'Firstmac', shortName: '', id: 'firstmac', isPartner: false },
    { name: 'Fleet Partners Auto Loan', shortName: '', id: 'fleet_partners_auto_loan', isPartner: false },
    { name: 'FlexiGroup', shortName: '', id: 'flexigroup', isPartner: false },
    { name: 'Good Shepherd Microfinance', shortName: '', id: 'good_shepherd_microfinance', isPartner: false },
    { name: 'Great Southern Loans', shortName: '', id: 'great_southern_loans', isPartner: false },
    { name: 'Greater Bank Ltd', shortName: '', id: 'greater_bank_ltd', isPartner: false },
    { name: 'Harmoney Australia', shortName: '', id: 'harmoney_australia', isPartner: false },
    { name: 'HBS', shortName: '', id: 'hbs', isPartner: false },
    { name: 'Hemisphere', shortName: '', id: 'hemisphere', isPartner: false },
    { name: 'Homeloan Centre Australia', shortName: '', id: 'homeloan_centre_australia', isPartner: false },
    { name: 'HomePath', shortName: '', id: 'homepath', isPartner: false },
    { name: 'HostPlus', shortName: '', id: 'hostplus', isPartner: false },
    { name: 'Humm', shortName: '', id: 'humm', isPartner: false },
    { name: 'Infiniti Finservices Australia', shortName: '', id: 'infiniti_finservices_australia', isPartner: false },
    { name: 'JetStar Credit Cards', shortName: '', id: 'jetstar_credit_cards', isPartner: false },
    { name: 'Latitude Finance Australia', shortName: '', id: 'latitude_finance_australia', isPartner: false },
    { name: 'LoanMarket Advantedge', shortName: '', id: 'loanmarket_advantedge', isPartner: false },
    { name: 'LoanPlan', shortName: '', id: 'loanplan', isPartner: false },
    { name: 'Maxxia', shortName: '', id: 'maxxia', isPartner: false },
    { name: 'MCCA', shortName: '', id: 'mcca', isPartner: false },
    { name: 'Mercedez-Benz Financial Services', shortName: '', id: 'mercedez-benz_financial_services', isPartner: false },
    { name: 'MIIP', shortName: '', id: 'miip', isPartner: false },
    { name: 'Mitsubishi', shortName: '', id: 'mitsubishi', isPartner: false },
    { name: 'Money Quest Australia Pty Ltd', shortName: '', id: 'money_quest_australia_pty_ltd', isPartner: false },
    { name: 'MoneyPlace AFSL', shortName: '', id: 'moneyplace_afsl', isPartner: false },
    { name: 'MSL', shortName: '', id: 'msl', isPartner: false },
    { name: 'Myer Credit Cards', shortName: '', id: 'myer_credit_cards', isPartner: false },
    { name: 'MyOzMoney', shortName: '', id: 'myozmoney', isPartner: false },
    { name: 'Napiers', shortName: '', id: 'napiers', isPartner: false },
    { name: 'NCF Financial Services PtyLtd', shortName: '', id: 'ncf_financial_services_ptyltd', isPartner: false },
    { name: 'NFC', shortName: '', id: 'nfc', isPartner: false },
    { name: 'NHL', shortName: '', id: 'nhl', isPartner: false },
    { name: 'Nissan Financial Services', shortName: '', id: 'nissan_financial_services', isPartner: false },
    { name: 'NMMC', shortName: '', id: 'nmmc', isPartner: false },
    { name: 'Now Finance', shortName: '', id: 'now_finance', isPartner: false },
    { name: 'OFG', shortName: '', id: 'ofg', isPartner: false },
    { name: 'ORIX', shortName: '', id: 'orix', isPartner: false },
    { name: 'Paladin', shortName: '', id: 'paladin', isPartner: false },
    { name: 'Pioneer Credit Ltd', shortName: '', id: 'pioneer_credit_ltd', isPartner: false },
    { name: 'PNCS', shortName: '', id: 'pncs', isPartner: false },
    { name: 'Power Home Loans', shortName: '', id: 'power_home_loans', isPartner: false },
    { name: 'Rate Money Pty Ltd', shortName: '', id: 'rate_money_pty_ltd', isPartner: false },
    { name: 'RedZed', shortName: '', id: 'redzed', isPartner: false },
    { name: 'Renault Finance ', shortName: '', id: 'renault_finance_', isPartner: false },
    { name: 'Residential Mortgage Group', shortName: '', id: 'residential_mortgage_group', isPartner: false },
    { name: 'RHG', shortName: '', id: 'rhg', isPartner: false },
    { name: 'Sam Loans', shortName: '', id: 'sam_loans', isPartner: false },
    { name: 'Sandhurst Trustees', shortName: '', id: 'sandhurst_trustees', isPartner: false },
    { name: 'SGE Credit Union', shortName: '', id: 'sge_credit_union', isPartner: false },
    { name: 'Skyline Car Finance', shortName: '', id: 'skyline_car_finance', isPartner: false },
    { name: 'Smartline', shortName: '', id: 'smartline', isPartner: false },
    { name: 'Society One Australia', shortName: '', id: 'society_one_australia', isPartner: false },
    { name: 'Southland Building Society', shortName: '', id: 'southland_building_society', isPartner: false },
    { name: 'Sydney Home Loans', shortName: '', id: 'sydney_home_loans', isPartner: false },
    { name: 'Symple Loans Australia', shortName: '', id: 'symple_loans_australia', isPartner: false },
    { name: 'The Co-operative Bank', shortName: '', id: 'the_co-operative_bank', isPartner: false },
    { name: 'ThinkMe Finance', shortName: '', id: 'thinkme_finance', isPartner: false },
    { name: 'VTMB', shortName: '', id: 'vtmb', isPartner: false },
    { name: 'Wisr Finance Pty Ltd', shortName: '', id: 'wisr_finance_pty_ltd', isPartner: false },
    { name: 'Woolworths', shortName: '', id: 'woolworths', isPartner: false },
    { name: 'World Home Loans', shortName: '', id: 'world_home_loans', isPartner: false },
    { name: 'Yes Home Loans', shortName: '', id: 'yes_home_loans', isPartner: false },
    { name: 'Your Manager', shortName: '', id: 'your_manager', isPartner: false },
];
var Lenders_NON_PARTNER_LENDERS = __spreadArrays(Lenders_NON_PARTNER_WITH_SHORTNAME, Lenders_NON_PARTNER_WITHOUT_SHORTNAME);
var Lenders_LENDERS = __spreadArrays(Lenders_PARTNER_LENDERS, Lenders_NON_PARTNER_LENDERS);
var Lenders_LENDER_DICTIONARY = Object.fromEntries(__spreadArrays(Lenders_PARTNER_LENDERS_WITH_SHORTNAME.map(function (pl) { return [pl.name, pl]; }), Lenders_NON_PARTNER_WITH_SHORTNAME.map(function (npl) { return [npl.name, npl]; })));
var Lenders_getByName = function (name) {
    return Lenders_LENDER_DICTIONARY[name];
};
//# sourceMappingURL=Lenders.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Address.js
var Address_StreetSuffixes;
(function (StreetSuffixes) {
    StreetSuffixes[StreetSuffixes["Central"] = 0] = "Central";
    StreetSuffixes[StreetSuffixes["Deviation"] = 1] = "Deviation";
    StreetSuffixes[StreetSuffixes["East"] = 2] = "East";
    StreetSuffixes[StreetSuffixes["Extension"] = 3] = "Extension";
    StreetSuffixes[StreetSuffixes["Lower"] = 4] = "Lower";
    StreetSuffixes[StreetSuffixes["Inner"] = 5] = "Inner";
    StreetSuffixes[StreetSuffixes["Mall"] = 6] = "Mall";
    StreetSuffixes[StreetSuffixes["North"] = 7] = "North";
    StreetSuffixes[StreetSuffixes["North East"] = 8] = "North East";
    StreetSuffixes[StreetSuffixes["North West"] = 9] = "North West";
    StreetSuffixes[StreetSuffixes["Off"] = 10] = "Off";
    StreetSuffixes[StreetSuffixes["On"] = 11] = "On";
    StreetSuffixes[StreetSuffixes["Outer"] = 12] = "Outer";
    StreetSuffixes[StreetSuffixes["Overpass"] = 13] = "Overpass";
    StreetSuffixes[StreetSuffixes["South"] = 14] = "South";
    StreetSuffixes[StreetSuffixes["South East"] = 15] = "South East";
    StreetSuffixes[StreetSuffixes["South West"] = 16] = "South West";
    StreetSuffixes[StreetSuffixes["Upper"] = 17] = "Upper";
    StreetSuffixes[StreetSuffixes["West"] = 18] = "West";
})(Address_StreetSuffixes || (Address_StreetSuffixes = {}));
var Address_StreetTypes;
(function (StreetTypes) {
    StreetTypes[StreetTypes["Access"] = 0] = "Access";
    StreetTypes[StreetTypes["Alley"] = 1] = "Alley";
    StreetTypes[StreetTypes["Alleyway"] = 2] = "Alleyway";
    StreetTypes[StreetTypes["Amble"] = 3] = "Amble";
    StreetTypes[StreetTypes["Anchorage"] = 4] = "Anchorage";
    StreetTypes[StreetTypes["Approach"] = 5] = "Approach";
    StreetTypes[StreetTypes["Arcade"] = 6] = "Arcade";
    StreetTypes[StreetTypes["Arterial"] = 7] = "Arterial";
    StreetTypes[StreetTypes["Artery"] = 8] = "Artery";
    StreetTypes[StreetTypes["Avenue"] = 9] = "Avenue";
    StreetTypes[StreetTypes["Banan"] = 10] = "Banan";
    StreetTypes[StreetTypes["Bank"] = 11] = "Bank";
    StreetTypes[StreetTypes["Basin"] = 12] = "Basin";
    StreetTypes[StreetTypes["Bay"] = 13] = "Bay";
    StreetTypes[StreetTypes["Beach"] = 14] = "Beach";
    StreetTypes[StreetTypes["Bend"] = 15] = "Bend";
    StreetTypes[StreetTypes["Block"] = 16] = "Block";
    StreetTypes[StreetTypes["Boardwalk"] = 17] = "Boardwalk";
    StreetTypes[StreetTypes["Boulevard"] = 18] = "Boulevard";
    StreetTypes[StreetTypes["Boulevarde"] = 19] = "Boulevarde";
    StreetTypes[StreetTypes["Bowl"] = 20] = "Bowl";
    StreetTypes[StreetTypes["Brace"] = 21] = "Brace";
    StreetTypes[StreetTypes["Brae"] = 22] = "Brae";
    StreetTypes[StreetTypes["Break"] = 23] = "Break";
    StreetTypes[StreetTypes["Bridge"] = 24] = "Bridge";
    StreetTypes[StreetTypes["Broadway"] = 25] = "Broadway";
    StreetTypes[StreetTypes["Brow"] = 26] = "Brow";
    StreetTypes[StreetTypes["Bypass"] = 27] = "Bypass";
    StreetTypes[StreetTypes["Byway"] = 28] = "Byway";
    StreetTypes[StreetTypes["Canal"] = 29] = "Canal";
    StreetTypes[StreetTypes["Causeway"] = 30] = "Causeway";
    StreetTypes[StreetTypes["Centre"] = 31] = "Centre";
    StreetTypes[StreetTypes["Centreway"] = 32] = "Centreway";
    StreetTypes[StreetTypes["Chase"] = 33] = "Chase";
    StreetTypes[StreetTypes["Circle"] = 34] = "Circle";
    StreetTypes[StreetTypes["Circlet"] = 35] = "Circlet";
    StreetTypes[StreetTypes["Circuit"] = 36] = "Circuit";
    StreetTypes[StreetTypes["Circus"] = 37] = "Circus";
    StreetTypes[StreetTypes["Close"] = 38] = "Close";
    StreetTypes[StreetTypes["Cluster"] = 39] = "Cluster";
    StreetTypes[StreetTypes["Colonnade"] = 40] = "Colonnade";
    StreetTypes[StreetTypes["Common"] = 41] = "Common";
    StreetTypes[StreetTypes["Concourse"] = 42] = "Concourse";
    StreetTypes[StreetTypes["Connection"] = 43] = "Connection";
    StreetTypes[StreetTypes["Copse"] = 44] = "Copse";
    StreetTypes[StreetTypes["Corner"] = 45] = "Corner";
    StreetTypes[StreetTypes["Corso"] = 46] = "Corso";
    StreetTypes[StreetTypes["Course"] = 47] = "Course";
    StreetTypes[StreetTypes["Court"] = 48] = "Court";
    StreetTypes[StreetTypes["Courtyard"] = 49] = "Courtyard";
    StreetTypes[StreetTypes["Cove"] = 50] = "Cove";
    StreetTypes[StreetTypes["Crescent"] = 51] = "Crescent";
    StreetTypes[StreetTypes["Crest"] = 52] = "Crest";
    StreetTypes[StreetTypes["Cross"] = 53] = "Cross";
    StreetTypes[StreetTypes["Crossing"] = 54] = "Crossing";
    StreetTypes[StreetTypes["Crossroad"] = 55] = "Crossroad";
    StreetTypes[StreetTypes["Crossway"] = 56] = "Crossway";
    StreetTypes[StreetTypes["Cruiseway"] = 57] = "Cruiseway";
    StreetTypes[StreetTypes["Cul-De-Sac"] = 58] = "Cul-De-Sac";
    StreetTypes[StreetTypes["Cutting"] = 59] = "Cutting";
    StreetTypes[StreetTypes["Dale"] = 60] = "Dale";
    StreetTypes[StreetTypes["Dell"] = 61] = "Dell";
    StreetTypes[StreetTypes["Dene"] = 62] = "Dene";
    StreetTypes[StreetTypes["Deviation"] = 63] = "Deviation";
    StreetTypes[StreetTypes["Dip"] = 64] = "Dip";
    StreetTypes[StreetTypes["Distributor"] = 65] = "Distributor";
    StreetTypes[StreetTypes["Divide"] = 66] = "Divide";
    StreetTypes[StreetTypes["Dock"] = 67] = "Dock";
    StreetTypes[StreetTypes["Domain"] = 68] = "Domain";
    StreetTypes[StreetTypes["Drive"] = 69] = "Drive";
    StreetTypes[StreetTypes["Driveway"] = 70] = "Driveway";
    StreetTypes[StreetTypes["Edge"] = 71] = "Edge";
    StreetTypes[StreetTypes["Elbow"] = 72] = "Elbow";
    StreetTypes[StreetTypes["End"] = 73] = "End";
    StreetTypes[StreetTypes["Entrance"] = 74] = "Entrance";
    StreetTypes[StreetTypes["Esplanade"] = 75] = "Esplanade";
    StreetTypes[StreetTypes["Estate"] = 76] = "Estate";
    StreetTypes[StreetTypes["Estuary"] = 77] = "Estuary";
    StreetTypes[StreetTypes["Expressway"] = 78] = "Expressway";
    StreetTypes[StreetTypes["Extension"] = 79] = "Extension";
    StreetTypes[StreetTypes["Fairway"] = 80] = "Fairway";
    StreetTypes[StreetTypes["Fire Track"] = 81] = "Fire Track";
    StreetTypes[StreetTypes["Firebreak"] = 82] = "Firebreak";
    StreetTypes[StreetTypes["Fireline"] = 83] = "Fireline";
    StreetTypes[StreetTypes["Firetrack"] = 84] = "Firetrack";
    StreetTypes[StreetTypes["Firetrail"] = 85] = "Firetrail";
    StreetTypes[StreetTypes["Flat"] = 86] = "Flat";
    StreetTypes[StreetTypes["Follow"] = 87] = "Follow";
    StreetTypes[StreetTypes["Footway"] = 88] = "Footway";
    StreetTypes[StreetTypes["Ford"] = 89] = "Ford";
    StreetTypes[StreetTypes["Foreshore"] = 90] = "Foreshore";
    StreetTypes[StreetTypes["Formation"] = 91] = "Formation";
    StreetTypes[StreetTypes["Freeway"] = 92] = "Freeway";
    StreetTypes[StreetTypes["Front"] = 93] = "Front";
    StreetTypes[StreetTypes["Frontage"] = 94] = "Frontage";
    StreetTypes[StreetTypes["Gap"] = 95] = "Gap";
    StreetTypes[StreetTypes["Garden"] = 96] = "Garden";
    StreetTypes[StreetTypes["Gardens"] = 97] = "Gardens";
    StreetTypes[StreetTypes["Gate"] = 98] = "Gate";
    StreetTypes[StreetTypes["Gates"] = 99] = "Gates";
    StreetTypes[StreetTypes["Gateway"] = 100] = "Gateway";
    StreetTypes[StreetTypes["Glade"] = 101] = "Glade";
    StreetTypes[StreetTypes["Glen"] = 102] = "Glen";
    StreetTypes[StreetTypes["Grange"] = 103] = "Grange";
    StreetTypes[StreetTypes["Green"] = 104] = "Green";
    StreetTypes[StreetTypes["Ground"] = 105] = "Ground";
    StreetTypes[StreetTypes["Grove"] = 106] = "Grove";
    StreetTypes[StreetTypes["Gully"] = 107] = "Gully";
    StreetTypes[StreetTypes["Harbour"] = 108] = "Harbour";
    StreetTypes[StreetTypes["Heath"] = 109] = "Heath";
    StreetTypes[StreetTypes["Heights"] = 110] = "Heights";
    StreetTypes[StreetTypes["Highroad"] = 111] = "Highroad";
    StreetTypes[StreetTypes["Highway"] = 112] = "Highway";
    StreetTypes[StreetTypes["Hill"] = 113] = "Hill";
    StreetTypes[StreetTypes["Hollow"] = 114] = "Hollow";
    StreetTypes[StreetTypes["Hub"] = 115] = "Hub";
    StreetTypes[StreetTypes["Interchange"] = 116] = "Interchange";
    StreetTypes[StreetTypes["Intersection"] = 117] = "Intersection";
    StreetTypes[StreetTypes["Junction"] = 118] = "Junction";
    StreetTypes[StreetTypes["Key"] = 119] = "Key";
    StreetTypes[StreetTypes["Keys"] = 120] = "Keys";
    StreetTypes[StreetTypes["Landing"] = 121] = "Landing";
    StreetTypes[StreetTypes["Lane"] = 122] = "Lane";
    StreetTypes[StreetTypes["Laneway"] = 123] = "Laneway";
    StreetTypes[StreetTypes["Lees"] = 124] = "Lees";
    StreetTypes[StreetTypes["Line"] = 125] = "Line";
    StreetTypes[StreetTypes["Link"] = 126] = "Link";
    StreetTypes[StreetTypes["Little"] = 127] = "Little";
    StreetTypes[StreetTypes["Lookout"] = 128] = "Lookout";
    StreetTypes[StreetTypes["Loop"] = 129] = "Loop";
    StreetTypes[StreetTypes["Lower"] = 130] = "Lower";
    StreetTypes[StreetTypes["Mall"] = 131] = "Mall";
    StreetTypes[StreetTypes["Manor"] = 132] = "Manor";
    StreetTypes[StreetTypes["Meander"] = 133] = "Meander";
    StreetTypes[StreetTypes["Mears"] = 134] = "Mears";
    StreetTypes[StreetTypes["Mew"] = 135] = "Mew";
    StreetTypes[StreetTypes["Mews"] = 136] = "Mews";
    StreetTypes[StreetTypes["Mile"] = 137] = "Mile";
    StreetTypes[StreetTypes["Motorway"] = 138] = "Motorway";
    StreetTypes[StreetTypes["Mount"] = 139] = "Mount";
    StreetTypes[StreetTypes["Nook"] = 140] = "Nook";
    StreetTypes[StreetTypes["Outlet"] = 141] = "Outlet";
    StreetTypes[StreetTypes["Outlook"] = 142] = "Outlook";
    StreetTypes[StreetTypes["Parade"] = 143] = "Parade";
    StreetTypes[StreetTypes["Park"] = 144] = "Park";
    StreetTypes[StreetTypes["Parklands"] = 145] = "Parklands";
    StreetTypes[StreetTypes["Parkway"] = 146] = "Parkway";
    StreetTypes[StreetTypes["Part"] = 147] = "Part";
    StreetTypes[StreetTypes["Pass"] = 148] = "Pass";
    StreetTypes[StreetTypes["Passage"] = 149] = "Passage";
    StreetTypes[StreetTypes["Path"] = 150] = "Path";
    StreetTypes[StreetTypes["Pathway"] = 151] = "Pathway";
    StreetTypes[StreetTypes["Piazza"] = 152] = "Piazza";
    StreetTypes[StreetTypes["Pier"] = 153] = "Pier";
    StreetTypes[StreetTypes["Place"] = 154] = "Place";
    StreetTypes[StreetTypes["Plateau"] = 155] = "Plateau";
    StreetTypes[StreetTypes["Plaza"] = 156] = "Plaza";
    StreetTypes[StreetTypes["Pocket"] = 157] = "Pocket";
    StreetTypes[StreetTypes["Point"] = 158] = "Point";
    StreetTypes[StreetTypes["Port"] = 159] = "Port";
    StreetTypes[StreetTypes["Portal"] = 160] = "Portal";
    StreetTypes[StreetTypes["Promenade"] = 161] = "Promenade";
    StreetTypes[StreetTypes["Pursuit"] = 162] = "Pursuit";
    StreetTypes[StreetTypes["Quad"] = 163] = "Quad";
    StreetTypes[StreetTypes["Quadrangle"] = 164] = "Quadrangle";
    StreetTypes[StreetTypes["Quadrant"] = 165] = "Quadrant";
    StreetTypes[StreetTypes["Quay"] = 166] = "Quay";
    StreetTypes[StreetTypes["Quays"] = 167] = "Quays";
    StreetTypes[StreetTypes["Ramble"] = 168] = "Ramble";
    StreetTypes[StreetTypes["Ramp"] = 169] = "Ramp";
    StreetTypes[StreetTypes["Range"] = 170] = "Range";
    StreetTypes[StreetTypes["Reach"] = 171] = "Reach";
    StreetTypes[StreetTypes["Reserve"] = 172] = "Reserve";
    StreetTypes[StreetTypes["Rest"] = 173] = "Rest";
    StreetTypes[StreetTypes["Retreat"] = 174] = "Retreat";
    StreetTypes[StreetTypes["Return"] = 175] = "Return";
    StreetTypes[StreetTypes["Ride"] = 176] = "Ride";
    StreetTypes[StreetTypes["Ridge"] = 177] = "Ridge";
    StreetTypes[StreetTypes["Ridgeway"] = 178] = "Ridgeway";
    StreetTypes[StreetTypes["Right Of Way"] = 179] = "Right Of Way";
    StreetTypes[StreetTypes["Ring"] = 180] = "Ring";
    StreetTypes[StreetTypes["Rise"] = 181] = "Rise";
    StreetTypes[StreetTypes["Rising"] = 182] = "Rising";
    StreetTypes[StreetTypes["River"] = 183] = "River";
    StreetTypes[StreetTypes["Riverway"] = 184] = "Riverway";
    StreetTypes[StreetTypes["Riviera"] = 185] = "Riviera";
    StreetTypes[StreetTypes["Road"] = 186] = "Road";
    StreetTypes[StreetTypes["Roads"] = 187] = "Roads";
    StreetTypes[StreetTypes["Roadside"] = 188] = "Roadside";
    StreetTypes[StreetTypes["Roadway"] = 189] = "Roadway";
    StreetTypes[StreetTypes["Ronde"] = 190] = "Ronde";
    StreetTypes[StreetTypes["Rosebowl"] = 191] = "Rosebowl";
    StreetTypes[StreetTypes["Rotary"] = 192] = "Rotary";
    StreetTypes[StreetTypes["Round"] = 193] = "Round";
    StreetTypes[StreetTypes["Route"] = 194] = "Route";
    StreetTypes[StreetTypes["Row"] = 195] = "Row";
    StreetTypes[StreetTypes["Rue"] = 196] = "Rue";
    StreetTypes[StreetTypes["Run"] = 197] = "Run";
    StreetTypes[StreetTypes["Service Way"] = 198] = "Service Way";
    StreetTypes[StreetTypes["Shunt"] = 199] = "Shunt";
    StreetTypes[StreetTypes["Siding"] = 200] = "Siding";
    StreetTypes[StreetTypes["Slope"] = 201] = "Slope";
    StreetTypes[StreetTypes["Sound"] = 202] = "Sound";
    StreetTypes[StreetTypes["Spur"] = 203] = "Spur";
    StreetTypes[StreetTypes["Square"] = 204] = "Square";
    StreetTypes[StreetTypes["Stairs"] = 205] = "Stairs";
    StreetTypes[StreetTypes["State Highway"] = 206] = "State Highway";
    StreetTypes[StreetTypes["Steps"] = 207] = "Steps";
    StreetTypes[StreetTypes["Strand"] = 208] = "Strand";
    StreetTypes[StreetTypes["Street"] = 209] = "Street";
    StreetTypes[StreetTypes["Streets"] = 210] = "Streets";
    StreetTypes[StreetTypes["Strip"] = 211] = "Strip";
    StreetTypes[StreetTypes["Subway"] = 212] = "Subway";
    StreetTypes[StreetTypes["Tarn"] = 213] = "Tarn";
    StreetTypes[StreetTypes["Tarnice Way"] = 214] = "Tarnice Way";
    StreetTypes[StreetTypes["Terrace"] = 215] = "Terrace";
    StreetTypes[StreetTypes["Thoroughfare"] = 216] = "Thoroughfare";
    StreetTypes[StreetTypes["Throughway"] = 217] = "Throughway";
    StreetTypes[StreetTypes["Tollway"] = 218] = "Tollway";
    StreetTypes[StreetTypes["Top"] = 219] = "Top";
    StreetTypes[StreetTypes["Tor"] = 220] = "Tor";
    StreetTypes[StreetTypes["Towers"] = 221] = "Towers";
    StreetTypes[StreetTypes["Track"] = 222] = "Track";
    StreetTypes[StreetTypes["Trail"] = 223] = "Trail";
    StreetTypes[StreetTypes["Trailer"] = 224] = "Trailer";
    StreetTypes[StreetTypes["Triangle"] = 225] = "Triangle";
    StreetTypes[StreetTypes["Trunkway"] = 226] = "Trunkway";
    StreetTypes[StreetTypes["Turn"] = 227] = "Turn";
    StreetTypes[StreetTypes["Twist"] = 228] = "Twist";
    StreetTypes[StreetTypes["Underpass"] = 229] = "Underpass";
    StreetTypes[StreetTypes["Upper"] = 230] = "Upper";
    StreetTypes[StreetTypes["Vale"] = 231] = "Vale";
    StreetTypes[StreetTypes["Viaduct"] = 232] = "Viaduct";
    StreetTypes[StreetTypes["View"] = 233] = "View";
    StreetTypes[StreetTypes["Villas"] = 234] = "Villas";
    StreetTypes[StreetTypes["Vista"] = 235] = "Vista";
    StreetTypes[StreetTypes["Wade"] = 236] = "Wade";
    StreetTypes[StreetTypes["Walk"] = 237] = "Walk";
    StreetTypes[StreetTypes["Walkway"] = 238] = "Walkway";
    StreetTypes[StreetTypes["Waterway"] = 239] = "Waterway";
    StreetTypes[StreetTypes["Way"] = 240] = "Way";
    StreetTypes[StreetTypes["Wharf"] = 241] = "Wharf";
    StreetTypes[StreetTypes["Woods"] = 242] = "Woods";
    StreetTypes[StreetTypes["Wynd"] = 243] = "Wynd";
    StreetTypes[StreetTypes["Yard"] = 244] = "Yard";
})(Address_StreetTypes || (Address_StreetTypes = {}));
//# sourceMappingURL=Address.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/Countries.js
var Countries_Countries;
(function (Countries) {
    Countries[Countries["Afghanistan"] = 0] = "Afghanistan";
    Countries[Countries["Albania"] = 1] = "Albania";
    Countries[Countries["Algeria"] = 2] = "Algeria";
    Countries[Countries["American Samoa"] = 3] = "American Samoa";
    Countries[Countries["Andorra"] = 4] = "Andorra";
    Countries[Countries["Angola"] = 5] = "Angola";
    Countries[Countries["Anguilla"] = 6] = "Anguilla";
    Countries[Countries["Antarctica"] = 7] = "Antarctica";
    Countries[Countries["Antigua And Barbuda"] = 8] = "Antigua And Barbuda";
    Countries[Countries["Argentina"] = 9] = "Argentina";
    Countries[Countries["Armenia"] = 10] = "Armenia";
    Countries[Countries["Aruba"] = 11] = "Aruba";
    Countries[Countries["Australia"] = 12] = "Australia";
    Countries[Countries["Austria"] = 13] = "Austria";
    Countries[Countries["Azerbaijan"] = 14] = "Azerbaijan";
    Countries[Countries["Bahamas"] = 15] = "Bahamas";
    Countries[Countries["Bahrain"] = 16] = "Bahrain";
    Countries[Countries["Bangladesh"] = 17] = "Bangladesh";
    Countries[Countries["Barbados"] = 18] = "Barbados";
    Countries[Countries["Belarus"] = 19] = "Belarus";
    Countries[Countries["Belgium"] = 20] = "Belgium";
    Countries[Countries["Belize"] = 21] = "Belize";
    Countries[Countries["Benin"] = 22] = "Benin";
    Countries[Countries["Bermuda"] = 23] = "Bermuda";
    Countries[Countries["Bhutan"] = 24] = "Bhutan";
    Countries[Countries["Bolivia"] = 25] = "Bolivia";
    Countries[Countries["Bosnia And Herzegovina"] = 26] = "Bosnia And Herzegovina";
    Countries[Countries["Botswana"] = 27] = "Botswana";
    Countries[Countries["Bouvet Island"] = 28] = "Bouvet Island";
    Countries[Countries["Brazil"] = 29] = "Brazil";
    Countries[Countries["British Indian Ocean Territory"] = 30] = "British Indian Ocean Territory";
    Countries[Countries["Brunei Darussalam"] = 31] = "Brunei Darussalam";
    Countries[Countries["Bulgaria"] = 32] = "Bulgaria";
    Countries[Countries["Burkina Faso"] = 33] = "Burkina Faso";
    Countries[Countries["Burundi"] = 34] = "Burundi";
    Countries[Countries["Cambodia"] = 35] = "Cambodia";
    Countries[Countries["Cameroon"] = 36] = "Cameroon";
    Countries[Countries["Canada"] = 37] = "Canada";
    Countries[Countries["Cape Verde"] = 38] = "Cape Verde";
    Countries[Countries["Cayman Islands"] = 39] = "Cayman Islands";
    Countries[Countries["Central African Republic"] = 40] = "Central African Republic";
    Countries[Countries["Chad"] = 41] = "Chad";
    Countries[Countries["Chile"] = 42] = "Chile";
    Countries[Countries["China"] = 43] = "China";
    Countries[Countries["Christmas Island"] = 44] = "Christmas Island";
    Countries[Countries["Cocos (Keeling) Islands"] = 45] = "Cocos (Keeling) Islands";
    Countries[Countries["Colombia"] = 46] = "Colombia";
    Countries[Countries["Comoros"] = 47] = "Comoros";
    Countries[Countries["Democratic People's Republic of Korea"] = 48] = "Democratic People's Republic of Korea";
    Countries[Countries["Democratic Republic Of The Congo"] = 49] = "Democratic Republic Of The Congo";
    Countries[Countries["Cook Islands"] = 50] = "Cook Islands";
    Countries[Countries["Costa Rica"] = 51] = "Costa Rica";
    Countries[Countries["Cote D'ivoire"] = 52] = "Cote D'ivoire";
    Countries[Countries["Croatia"] = 53] = "Croatia";
    Countries[Countries["Cuba"] = 54] = "Cuba";
    Countries[Countries["Cyprus"] = 55] = "Cyprus";
    Countries[Countries["Czech Republic"] = 56] = "Czech Republic";
    Countries[Countries["Denmark"] = 57] = "Denmark";
    Countries[Countries["Djibouti"] = 58] = "Djibouti";
    Countries[Countries["Dominica"] = 59] = "Dominica";
    Countries[Countries["Dominican Republic"] = 60] = "Dominican Republic";
    Countries[Countries["East Timor"] = 61] = "East Timor";
    Countries[Countries["Ecuador"] = 62] = "Ecuador";
    Countries[Countries["Egypt"] = 63] = "Egypt";
    Countries[Countries["El Salvador"] = 64] = "El Salvador";
    Countries[Countries["Equatorial Guinea"] = 65] = "Equatorial Guinea";
    Countries[Countries["Eritrea"] = 66] = "Eritrea";
    Countries[Countries["Estonia"] = 67] = "Estonia";
    Countries[Countries["Ethiopia"] = 68] = "Ethiopia";
    Countries[Countries["Falkland Islands"] = 69] = "Falkland Islands";
    Countries[Countries["Faroe Islands"] = 70] = "Faroe Islands";
    Countries[Countries["Fiji"] = 71] = "Fiji";
    Countries[Countries["Finland"] = 72] = "Finland";
    Countries[Countries["France"] = 73] = "France";
    Countries[Countries["French Guiana"] = 74] = "French Guiana";
    Countries[Countries["French Polynesia"] = 75] = "French Polynesia";
    Countries[Countries["French Southern Territories"] = 76] = "French Southern Territories";
    Countries[Countries["Gabon"] = 77] = "Gabon";
    Countries[Countries["Gambia"] = 78] = "Gambia";
    Countries[Countries["Georgia"] = 79] = "Georgia";
    Countries[Countries["Germany"] = 80] = "Germany";
    Countries[Countries["Ghana"] = 81] = "Ghana";
    Countries[Countries["Gibraltar"] = 82] = "Gibraltar";
    Countries[Countries["Greece"] = 83] = "Greece";
    Countries[Countries["Greenland"] = 84] = "Greenland";
    Countries[Countries["Grenada"] = 85] = "Grenada";
    Countries[Countries["Guadeloupe"] = 86] = "Guadeloupe";
    Countries[Countries["Guam"] = 87] = "Guam";
    Countries[Countries["Guatemala"] = 88] = "Guatemala";
    Countries[Countries["Guinea"] = 89] = "Guinea";
    Countries[Countries["Guinea-bissau"] = 90] = "Guinea-bissau";
    Countries[Countries["Guyana"] = 91] = "Guyana";
    Countries[Countries["Haiti"] = 92] = "Haiti";
    Countries[Countries["Heard Island And Mcdonald Islands"] = 93] = "Heard Island And Mcdonald Islands";
    Countries[Countries["Holy See (Vatican City State)"] = 94] = "Holy See (Vatican City State)";
    Countries[Countries["Honduras"] = 95] = "Honduras";
    Countries[Countries["Hong Kong"] = 96] = "Hong Kong";
    Countries[Countries["Hungary"] = 97] = "Hungary";
    Countries[Countries["Iceland"] = 98] = "Iceland";
    Countries[Countries["India"] = 99] = "India";
    Countries[Countries["Indonesia"] = 100] = "Indonesia";
    Countries[Countries["Iran"] = 101] = "Iran";
    Countries[Countries["Iraq"] = 102] = "Iraq";
    Countries[Countries["Ireland"] = 103] = "Ireland";
    Countries[Countries["Israel"] = 104] = "Israel";
    Countries[Countries["Italy"] = 105] = "Italy";
    Countries[Countries["Jamaica"] = 106] = "Jamaica";
    Countries[Countries["Japan"] = 107] = "Japan";
    Countries[Countries["Jordan"] = 108] = "Jordan";
    Countries[Countries["Kazakstan"] = 109] = "Kazakstan";
    Countries[Countries["Kenya"] = 110] = "Kenya";
    Countries[Countries["Kiribati"] = 111] = "Kiribati";
    Countries[Countries["Kosovo"] = 112] = "Kosovo";
    Countries[Countries["Kuwait"] = 113] = "Kuwait";
    Countries[Countries["Kyrgyzstan"] = 114] = "Kyrgyzstan";
    Countries[Countries["Laos"] = 115] = "Laos";
    Countries[Countries["Latvia"] = 116] = "Latvia";
    Countries[Countries["Lebanon"] = 117] = "Lebanon";
    Countries[Countries["Lesotho"] = 118] = "Lesotho";
    Countries[Countries["Liberia"] = 119] = "Liberia";
    Countries[Countries["Libyan Arab Jamahiriya"] = 120] = "Libyan Arab Jamahiriya";
    Countries[Countries["Liechtenstein"] = 121] = "Liechtenstein";
    Countries[Countries["Lithuania"] = 122] = "Lithuania";
    Countries[Countries["Luxembourg"] = 123] = "Luxembourg";
    Countries[Countries["Macau"] = 124] = "Macau";
    Countries[Countries["Macedonia"] = 125] = "Macedonia";
    Countries[Countries["Madagascar"] = 126] = "Madagascar";
    Countries[Countries["Malawi"] = 127] = "Malawi";
    Countries[Countries["Malaysia"] = 128] = "Malaysia";
    Countries[Countries["Maldives"] = 129] = "Maldives";
    Countries[Countries["Mali"] = 130] = "Mali";
    Countries[Countries["Malta"] = 131] = "Malta";
    Countries[Countries["Marshall Islands"] = 132] = "Marshall Islands";
    Countries[Countries["Martinique"] = 133] = "Martinique";
    Countries[Countries["Mauritania"] = 134] = "Mauritania";
    Countries[Countries["Mauritius"] = 135] = "Mauritius";
    Countries[Countries["Mayotte"] = 136] = "Mayotte";
    Countries[Countries["Mexico"] = 137] = "Mexico";
    Countries[Countries["Federated States Of Micronesia"] = 138] = "Federated States Of Micronesia";
    Countries[Countries["Republic Of Moldova"] = 139] = "Republic Of Moldova";
    Countries[Countries["Monaco"] = 140] = "Monaco";
    Countries[Countries["Mongolia"] = 141] = "Mongolia";
    Countries[Countries["Montserrat"] = 142] = "Montserrat";
    Countries[Countries["Montenegro"] = 143] = "Montenegro";
    Countries[Countries["Morocco"] = 144] = "Morocco";
    Countries[Countries["Mozambique"] = 145] = "Mozambique";
    Countries[Countries["Myanmar"] = 146] = "Myanmar";
    Countries[Countries["Namibia"] = 147] = "Namibia";
    Countries[Countries["Nauru"] = 148] = "Nauru";
    Countries[Countries["Nepal"] = 149] = "Nepal";
    Countries[Countries["Netherlands"] = 150] = "Netherlands";
    Countries[Countries["Netherlands Antilles"] = 151] = "Netherlands Antilles";
    Countries[Countries["New Caledonia"] = 152] = "New Caledonia";
    Countries[Countries["New Zealand"] = 153] = "New Zealand";
    Countries[Countries["Nicaragua"] = 154] = "Nicaragua";
    Countries[Countries["Niger"] = 155] = "Niger";
    Countries[Countries["Nigeria"] = 156] = "Nigeria";
    Countries[Countries["Niue"] = 157] = "Niue";
    Countries[Countries["Norfolk Island"] = 158] = "Norfolk Island";
    Countries[Countries["Northern Mariana Islands"] = 159] = "Northern Mariana Islands";
    Countries[Countries["Norway"] = 160] = "Norway";
    Countries[Countries["Oman"] = 161] = "Oman";
    Countries[Countries["Pakistan"] = 162] = "Pakistan";
    Countries[Countries["Palau"] = 163] = "Palau";
    Countries[Countries["Palestinian Territory"] = 164] = "Palestinian Territory";
    Countries[Countries["Panama"] = 165] = "Panama";
    Countries[Countries["Papua New Guinea"] = 166] = "Papua New Guinea";
    Countries[Countries["Paraguay"] = 167] = "Paraguay";
    Countries[Countries["Peru"] = 168] = "Peru";
    Countries[Countries["Philippines"] = 169] = "Philippines";
    Countries[Countries["Pitcairn"] = 170] = "Pitcairn";
    Countries[Countries["Poland"] = 171] = "Poland";
    Countries[Countries["Portugal"] = 172] = "Portugal";
    Countries[Countries["Puerto Rico"] = 173] = "Puerto Rico";
    Countries[Countries["Qatar"] = 174] = "Qatar";
    Countries[Countries["Romania"] = 175] = "Romania";
    Countries[Countries["Russian Federation"] = 176] = "Russian Federation";
    Countries[Countries["Rwanda"] = 177] = "Rwanda";
    Countries[Countries["Saint Helena"] = 178] = "Saint Helena";
    Countries[Countries["Saint Kitts And Nevis"] = 179] = "Saint Kitts And Nevis";
    Countries[Countries["Saint Lucia"] = 180] = "Saint Lucia";
    Countries[Countries["Saint Pierre And Miquelon"] = 181] = "Saint Pierre And Miquelon";
    Countries[Countries["Saint Vincent And The Grenadines"] = 182] = "Saint Vincent And The Grenadines";
    Countries[Countries["Samoa"] = 183] = "Samoa";
    Countries[Countries["San Marino"] = 184] = "San Marino";
    Countries[Countries["Sao Tome And Principe"] = 185] = "Sao Tome And Principe";
    Countries[Countries["Saudi Arabia"] = 186] = "Saudi Arabia";
    Countries[Countries["Senegal"] = 187] = "Senegal";
    Countries[Countries["Serbia"] = 188] = "Serbia";
    Countries[Countries["Seychelles"] = 189] = "Seychelles";
    Countries[Countries["Sierra Leone"] = 190] = "Sierra Leone";
    Countries[Countries["Singapore"] = 191] = "Singapore";
    Countries[Countries["Slovakia"] = 192] = "Slovakia";
    Countries[Countries["Slovenia"] = 193] = "Slovenia";
    Countries[Countries["Solomon Islands"] = 194] = "Solomon Islands";
    Countries[Countries["Somalia"] = 195] = "Somalia";
    Countries[Countries["South Africa"] = 196] = "South Africa";
    Countries[Countries["South Georgia And The South Sandwich Islands"] = 197] = "South Georgia And The South Sandwich Islands";
    Countries[Countries["The Republic of South Korea"] = 198] = "The Republic of South Korea";
    Countries[Countries["Spain"] = 199] = "Spain";
    Countries[Countries["Sri Lanka"] = 200] = "Sri Lanka";
    Countries[Countries["Sudan"] = 201] = "Sudan";
    Countries[Countries["Suriname"] = 202] = "Suriname";
    Countries[Countries["Svalbard And Jan Mayen"] = 203] = "Svalbard And Jan Mayen";
    Countries[Countries["Swaziland"] = 204] = "Swaziland";
    Countries[Countries["Sweden"] = 205] = "Sweden";
    Countries[Countries["Switzerland"] = 206] = "Switzerland";
    Countries[Countries["Syrian Arab Republic"] = 207] = "Syrian Arab Republic";
    Countries[Countries["Taiwan"] = 208] = "Taiwan";
    Countries[Countries["Tajikistan"] = 209] = "Tajikistan";
    Countries[Countries["Tanzania"] = 210] = "Tanzania";
    Countries[Countries["Thailand"] = 211] = "Thailand";
    Countries[Countries["Togo"] = 212] = "Togo";
    Countries[Countries["Tokelau"] = 213] = "Tokelau";
    Countries[Countries["Tonga"] = 214] = "Tonga";
    Countries[Countries["Trinidad And Tobago"] = 215] = "Trinidad And Tobago";
    Countries[Countries["Tunisia"] = 216] = "Tunisia";
    Countries[Countries["Turkey"] = 217] = "Turkey";
    Countries[Countries["Turkmenistan"] = 218] = "Turkmenistan";
    Countries[Countries["Turks And Caicos Islands"] = 219] = "Turks And Caicos Islands";
    Countries[Countries["Tuvalu"] = 220] = "Tuvalu";
    Countries[Countries["Uganda"] = 221] = "Uganda";
    Countries[Countries["Ukraine"] = 222] = "Ukraine";
    Countries[Countries["United Arab Emirates"] = 223] = "United Arab Emirates";
    Countries[Countries["United Kingdom"] = 224] = "United Kingdom";
    Countries[Countries["United States of America"] = 225] = "United States of America";
    Countries[Countries["United States Minor Outlying Islands"] = 226] = "United States Minor Outlying Islands";
    Countries[Countries["Uruguay"] = 227] = "Uruguay";
    Countries[Countries["Uzbekistan"] = 228] = "Uzbekistan";
    Countries[Countries["Vanuatu"] = 229] = "Vanuatu";
    Countries[Countries["Venezuela"] = 230] = "Venezuela";
    Countries[Countries["Vietnam"] = 231] = "Vietnam";
    Countries[Countries["British Virgin Islands"] = 232] = "British Virgin Islands";
    Countries[Countries["US Virgin Islands"] = 233] = "US Virgin Islands";
    Countries[Countries["Wallis And Futuna"] = 234] = "Wallis And Futuna";
    Countries[Countries["Western Sahara"] = 235] = "Western Sahara";
    Countries[Countries["Yemen"] = 236] = "Yemen";
    Countries[Countries["Zambia"] = 237] = "Zambia";
    Countries[Countries["Zimbabwe"] = 238] = "Zimbabwe";
})(Countries_Countries || (Countries_Countries = {}));
//# sourceMappingURL=Countries.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RelatedParty.js
var esm_RelatedParty_CompanyType;
(function (CompanyType) {
    CompanyType["Accountant"] = "ACCOUNTANT";
    CompanyType["Solicitor"] = "SOLICITOR";
})(esm_RelatedParty_CompanyType || (esm_RelatedParty_CompanyType = {}));
var RelatedParty_PersonType;
(function (PersonType) {
    PersonType["Spouse"] = "SPOUSE";
})(RelatedParty_PersonType || (RelatedParty_PersonType = {}));
var RelatedParty_VisitContactType;
(function (VisitContactType) {
    VisitContactType["LoanParty"] = "LOAN_PARTY";
    VisitContactType["Tenant"] = "TENANT";
    VisitContactType["RealEstateAgent"] = "REAL_ESTATE_AGENT";
})(RelatedParty_VisitContactType || (RelatedParty_VisitContactType = {}));
var RelatedParty_SubstantialBenefitType;
(function (SubstantialBenefitType) {
    SubstantialBenefitType["SubstantialBenefit"] = "SUBSTANTIAL_BENEFIT";
    SubstantialBenefitType["NoSubstantialBenefitAndProceed"] = "NO_SUBSTANTIAL_BENEFIT_AND_PROCEED";
    SubstantialBenefitType["NoSubstantialBenefit"] = "NO_SUBSTANTIAL_BENEFIT";
})(RelatedParty_SubstantialBenefitType || (RelatedParty_SubstantialBenefitType = {}));
//# sourceMappingURL=RelatedParty.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/BusinessType.js
var BusinessType_BusinessType;
(function (BusinessType) {
    BusinessType["Private"] = "PRIVATE";
    BusinessType["Public"] = "PUBLIC";
})(BusinessType_BusinessType || (BusinessType_BusinessType = {}));
//# sourceMappingURL=BusinessType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/BusinessStructureType.js
var BusinessStructureType_BusinessStructureType;
(function (BusinessStructureType) {
    BusinessStructureType["Company"] = "COMPANY";
    BusinessStructureType["SoleTrader"] = "SOLE_TRADER";
    BusinessStructureType["Partnership"] = "PARTNERSHIP";
    BusinessStructureType["Trust"] = "TRUST";
})(BusinessStructureType_BusinessStructureType || (BusinessStructureType_BusinessStructureType = {}));
//# sourceMappingURL=BusinessStructureType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/TrustType.js
var TrustType_TrustType;
(function (TrustType) {
    TrustType["CashManagementTrust"] = "CASH_MANAGEMENT_TRUST";
    TrustType["DiscretionaryTrust"] = "DISCRETIONARY_TRUST";
    TrustType["Fixed"] = "FIXED";
    TrustType["Hybrid"] = "HYBRID";
    TrustType["Other"] = "OTHER";
    TrustType["SimpleOrBare"] = "SIMPLE_OR_BARE";
    TrustType["SuperannuationTrusts"] = "SUPERANNUATION_TRUSTS";
    TrustType["Unit"] = "UNIT";
})(TrustType_TrustType || (TrustType_TrustType = {}));
//# sourceMappingURL=TrustType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/EmploymentBasisType.js
var EmploymentBasisType_EmploymentBasisType;
(function (EmploymentBasisType) {
    EmploymentBasisType["FullTime"] = "FULL_TIME";
    EmploymentBasisType["PartTime"] = "PART_TIME";
    EmploymentBasisType["Casual"] = "CASUAL";
    EmploymentBasisType["Contractor"] = "CONTRACTOR";
    EmploymentBasisType["MaternityLeave"] = "MATERNITY_LEAVE";
})(EmploymentBasisType_EmploymentBasisType || (EmploymentBasisType_EmploymentBasisType = {}));
//# sourceMappingURL=EmploymentBasisType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/EmploymentStructures.js
var EmploymentStructures_EmploymentStructures;
(function (EmploymentStructures) {
    EmploymentStructures["Primary"] = "PRIMARY";
    EmploymentStructures["Secondary"] = "SECONDARY";
    EmploymentStructures["Previous"] = "PREVIOUS";
})(EmploymentStructures_EmploymentStructures || (EmploymentStructures_EmploymentStructures = {}));
//# sourceMappingURL=EmploymentStructures.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/EmploymentSubType.js
var EmploymentSubType_EmploymentSubType;
(function (EmploymentSubType) {
    EmploymentSubType["FullDoc"] = "FULL_DOC";
    EmploymentSubType["LowDoc"] = "LOW_DOC";
})(EmploymentSubType_EmploymentSubType || (EmploymentSubType_EmploymentSubType = {}));
//# sourceMappingURL=EmploymentSubType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RelationshipToTrust.js
var RelationshipToTrust_RelationshipToTrust;
(function (RelationshipToTrust) {
    RelationshipToTrust["Trustee"] = "TRUSTEE";
    RelationshipToTrust["Beneficiary"] = "BENEFICIARY";
    RelationshipToTrust["Director"] = "DIRECTOR";
    RelationshipToTrust["ShareholderOfCorporateTrustee"] = "SHAREHOLDER_OF_CORPORATE_TRUSTEE";
})(RelationshipToTrust_RelationshipToTrust || (RelationshipToTrust_RelationshipToTrust = {}));
//# sourceMappingURL=RelationshipToTrust.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/RelatedCompany.js
var RelatedCompany_RelatedCompanyType;
(function (RelatedCompanyType) {
    RelatedCompanyType["Employer"] = "EMPLOYER";
    RelatedCompanyType["SelfEmploymentBusiness"] = "SELF_EMPLOYMENT_BUSINESS";
})(RelatedCompany_RelatedCompanyType || (RelatedCompany_RelatedCompanyType = {}));
//# sourceMappingURL=RelatedCompany.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/BuilderType.js
var BuilderType_BuilderType;
(function (BuilderType) {
    BuilderType["LicensedBuilder"] = "LICENSED_BUILDER";
    BuilderType["OwnerBuilder"] = "OWNER_BUILDER";
})(BuilderType_BuilderType || (BuilderType_BuilderType = {}));
//# sourceMappingURL=BuilderType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/CustomerPropertyRelationship.js
var CustomerPropertyRelationship_CustomerPropertyRelationship;
(function (CustomerPropertyRelationship) {
    CustomerPropertyRelationship["OWNER"] = "OWNER";
    CustomerPropertyRelationship["LOOKING_TO_BUY"] = "LOOKING_TO_BUY";
    CustomerPropertyRelationship["JUST_LOOKING"] = "JUST_LOOKING";
})(CustomerPropertyRelationship_CustomerPropertyRelationship || (CustomerPropertyRelationship_CustomerPropertyRelationship = {}));
//# sourceMappingURL=CustomerPropertyRelationship.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/PropertyEventTimelineType.js
var PropertyEventTimelineType_PropertyEventTimelineType;
(function (PropertyEventTimelineType) {
    PropertyEventTimelineType["Rented"] = "RENTED";
    PropertyEventTimelineType["Sold"] = "SOLD";
})(PropertyEventTimelineType_PropertyEventTimelineType || (PropertyEventTimelineType_PropertyEventTimelineType = {}));
//# sourceMappingURL=PropertyEventTimelineType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/PropertyVisibility.js
var PropertyVisibility_PropertyVisibility;
(function (PropertyVisibility) {
    PropertyVisibility["ACTIVE"] = "ACTIVE";
    PropertyVisibility["ARCHIVED"] = "ARCHIVED";
    PropertyVisibility["ACTIVE_TO_TEAM_ONLY"] = "ACTIVE_TO_TEAM_ONLY";
})(PropertyVisibility_PropertyVisibility || (PropertyVisibility_PropertyVisibility = {}));
//# sourceMappingURL=PropertyVisibility.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/PlatformPathname.js
var PlatformPathname_PlatformPathname;
(function (PlatformPathname) {
    PlatformPathname["BOOKING_APPOINTMENT_PATHNAME"] = "/book-appointment";
    PlatformPathname["TIME_SELECTION_PROCESS_PATHNAME"] = "/book-appointment/process";
    PlatformPathname["STAMP_DUTY_PATHNAME"] = "/stamp-duty-calculator";
    PlatformPathname["PROPERTY_REPORT_PATHNAME"] = "/property-report";
    PlatformPathname["REFINANCE_FUNNEL_PATHNAME"] = "/home-loans/basics/refinance/refinance-loan-amount";
    PlatformPathname["NEW_PURCHASE_FUNNEL_PATHNAME"] = "/home-loans/basics/new-home/purchase-price";
    PlatformPathname["BORROWING_POWER_FUNNEL_PATHNAME"] = "/home-loans/basics/borrowing-power/applicants";
})(PlatformPathname_PlatformPathname || (PlatformPathname_PlatformPathname = {}));
//# sourceMappingURL=PlatformPathname.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/CtpInterestRateType.js
var CtpInterestRateType_CtpInterestRateType;
(function (CtpInterestRateType) {
    CtpInterestRateType["Variable"] = "VariableRate";
    CtpInterestRateType["Fixed"] = "FixedRate";
})(CtpInterestRateType_CtpInterestRateType || (CtpInterestRateType_CtpInterestRateType = {}));
//# sourceMappingURL=CtpInterestRateType.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/AppointmentCancellationReason.js
var AppointmentCancellationReason_AppointmentCancellationReason;
(function (AppointmentCancellationReason) {
    AppointmentCancellationReason["CustomerNotResponding"] = "CUSTOMER_NOT_RESPONDING";
    AppointmentCancellationReason["ExploringOptions"] = "EXPLORING_OPTIONS";
    AppointmentCancellationReason["HappyWithCurrentBankAndRates"] = "HAPPY_WITH_CURRENT_BANK_AND_RATES";
    AppointmentCancellationReason["ServicingIncomeOrEmployment"] = "SERVICING_INCOME_OR_EMPLOYMENT";
    AppointmentCancellationReason["DuplicatedAppointment"] = "DUPLICATED_APPOINTMENT";
    AppointmentCancellationReason["CreditIssues"] = "CREDIT_ISSUES";
    AppointmentCancellationReason["LowRefinanceLvr"] = "LOW_REFINANCE_LVR";
    AppointmentCancellationReason["InsufficientDeposit"] = "INSUFFICIENT_DEPOSIT";
    AppointmentCancellationReason["InsufficientExitStrategy"] = "INSUFFICIENT_EXIT_STRATEGY";
    AppointmentCancellationReason["PurchasingAfterThreeMonths"] = "PURCHASING_AFTER_THREE_MONTHS";
    AppointmentCancellationReason["PendingLegalMatter"] = "PENDING_LEGAL_MATTER";
})(AppointmentCancellationReason_AppointmentCancellationReason || (AppointmentCancellationReason_AppointmentCancellationReason = {}));
//# sourceMappingURL=AppointmentCancellationReason.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/node_modules/@lendi/core-constants/lib/esm/index.js










































































//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/appointment-source/index.js
var AppointmentSource;
(function (AppointmentSource) {
    AppointmentSource["CallbackRequest"] = "CALLBACK_REQUEST";
    AppointmentSource["NoAppointmentAvailabilities"] = "NO_APPOINTMENT_AVAILABILITIES";
})(AppointmentSource || (AppointmentSource = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/credit-score-purpose/index.js
var CreditScorePurpose;
(function (CreditScorePurpose) {
    CreditScorePurpose["Refinance"] = "REFINANCE";
    CreditScorePurpose["NewPurchase"] = "NEW_PURCHASE";
    CreditScorePurpose["NewPurchaseLater"] = "NEW_PURCHASE_LATER";
    CreditScorePurpose["NmpPersonalCarLoan"] = "NMP_PERSONAL_CAR_LOAN";
    CreditScorePurpose["Curious"] = "CURIOUS";
    CreditScorePurpose["CreditCard"] = "CREDIT_CARD";
    CreditScorePurpose["Other"] = "OTHER";
})(CreditScorePurpose || (CreditScorePurpose = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/credit-status/index.js
var credit_status_CreditStatus;
(function (CreditStatus) {
    CreditStatus["Excellent"] = "EXCELLENT";
    CreditStatus["Average"] = "AVERAGE";
    CreditStatus["Fair"] = "FAIR";
    CreditStatus["Unknown"] = "UNKNOWN";
})(credit_status_CreditStatus || (credit_status_CreditStatus = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/desired-features/index.js
var desired_features_DesiredFeatures;
(function (DesiredFeatures) {
    DesiredFeatures["FixedRate"] = "FIXED_RATE";
    DesiredFeatures["MobileApp"] = "MOBILE_APP";
    DesiredFeatures["MajorLender"] = "MAJOR_LENDER";
    DesiredFeatures["OffsetRedraw"] = "OFFSET_OR_REDRAW";
    DesiredFeatures["Offset"] = "OFFSET";
    DesiredFeatures["Redraw"] = "REDRAW";
})(desired_features_DesiredFeatures || (desired_features_DesiredFeatures = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/eligible-for-fhog/index.js
var eligible_for_fhog_EligibleForFHOG;
(function (EligibleForFHOG) {
    EligibleForFHOG["Yes"] = "YES";
    EligibleForFHOG["No"] = "No";
    EligibleForFHOG["NotSure"] = "NotSure";
})(eligible_for_fhog_EligibleForFHOG || (eligible_for_fhog_EligibleForFHOG = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/employment-type/index.js
var employment_type_EmploymentType;
(function (EmploymentType) {
    EmploymentType["Employee"] = "EMPLOYEE";
    EmploymentType["SelfEmployed"] = "SELF_EMPLOYED";
    EmploymentType["Other"] = "UNKNOWN";
})(employment_type_EmploymentType || (employment_type_EmploymentType = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/enquiry-purpose/index.js
var EnquiryPurpose;
(function (EnquiryPurpose) {
    EnquiryPurpose["AppointmentRequest"] = "APPOINTMENT_REQUEST";
    EnquiryPurpose["Insurance"] = "INSURANCE";
    EnquiryPurpose["Investor"] = "INVESTOR";
    EnquiryPurpose["NewPurchase"] = "NEW_PURCHASE";
    EnquiryPurpose["NonMortgageLoan"] = "NON_MORTGAGE_LOAN";
    EnquiryPurpose["Other"] = "OTHER";
    EnquiryPurpose["Refinance"] = "REFINANCE";
    EnquiryPurpose["UrgentCallbackRequest"] = "URGENT_CALLBACK_REQUEST";
})(EnquiryPurpose || (EnquiryPurpose = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/funnel-property-status/index.js
var FunnelPropertyStatus;
(function (FunnelPropertyStatus) {
    FunnelPropertyStatus["NewBuilding"] = "NEW_BUILDING";
    FunnelPropertyStatus["VacantLand"] = "VACANT_LAND";
    FunnelPropertyStatus["Established"] = "ESTABLISHED";
})(FunnelPropertyStatus || (FunnelPropertyStatus = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/funnel-property-type/index.js
var FunnelPropertyType;
(function (FunnelPropertyType) {
    FunnelPropertyType["ApartmentUnitLessThan50M2"] = "APARTMENT_UNIT_LESS_THAN_50M2";
    FunnelPropertyType["ApartmentUnitMoreThan50M2"] = "APARTMENT_UNIT_MORE_THAN_50M2";
    FunnelPropertyType["ServicedApartment"] = "SERVICED_APARTMENT";
    FunnelPropertyType["Studio"] = "STUDIO";
    FunnelPropertyType["StudentAccommodation"] = "STUDENT_ACCOMMODATION";
    FunnelPropertyType["WarehouseApartment"] = "WAREHOUSE_APARTMENT";
    FunnelPropertyType["Duplex"] = "DUPLEX";
    FunnelPropertyType["Villa"] = "VILLA";
    FunnelPropertyType["FullyDetachedHouse"] = "FULLY_DETACHED_HOUSE";
    FunnelPropertyType["KitHome"] = "KIT_HOME";
    FunnelPropertyType["MultiDwellingSingleTitle"] = "MULTI_DWELLING_SINGLE_TITLE";
    FunnelPropertyType["PropertyOver10HA"] = "PROPERTY_OVER_10_HA";
    FunnelPropertyType["SemiDetachedHouse"] = "SEMI_DETACHED_HOUSE";
    FunnelPropertyType["Terrace"] = "TERRACE";
    FunnelPropertyType["Townhouse"] = "TOWNHOUSE";
    FunnelPropertyType["Land"] = "LAND";
})(FunnelPropertyType || (FunnelPropertyType = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/number-of-borrowers/index.js
var NumberOfBorrowers;
(function (NumberOfBorrowers) {
    NumberOfBorrowers[NumberOfBorrowers["One"] = 1] = "One";
    NumberOfBorrowers[NumberOfBorrowers["Two"] = 2] = "Two";
})(NumberOfBorrowers || (NumberOfBorrowers = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/origin/index.js
var Origin;
(function (Origin) {
    Origin["AreaReport"] = "AREA_REPORT";
    Origin["AussieHomes"] = "AUSSIE_HOMES";
    Origin["BorrowingPower"] = "BORROWING_POWER";
    Origin["PropertyReport"] = "PROPERTY_REPORT";
    Origin["Toolbox"] = "TOOLBOX";
    Origin["LAMForm"] = "LAM_FORM";
    Origin["SignUp"] = "SIGN_UP";
    Origin["NewHomeLoan"] = "NEW_HOME_LOAN";
    Origin["Refinance"] = "REFINANCE";
    Origin["Blog"] = "BLOG";
    Origin["StampDutyCalculator"] = "STAMP_DUTY_CALCULATOR";
    Origin["AppointmentBooking"] = "APPOINTMENT_BOOKING";
    Origin["Invite"] = "INVITE";
    Origin["Chat"] = "CHAT";
    Origin["SelfGen"] = "SELF_GEN";
    Origin["CreditScore"] = "CREDIT_SCORE";
    Origin["FixedRateExpiry"] = "FIXED_RATE_EXPIRY";
    Origin["AffiliateLead"] = "AFFILIATE_LEAD";
    Origin["MarketingOther"] = "MARKETING_OTHER";
    Origin["CarLoan"] = "CAR_LOAN";
    Origin["BusinessLoanAssetFinance"] = "BUSINESS_LOAN_ASSET_FINANCE";
    Origin["BusinessLoanCommercial"] = "BUSINESS_LOAN_COMMERCIAL";
    Origin["Insurance"] = "INSURANCE";
})(Origin || (Origin = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/payment-method/index.js
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["InterestOnly"] = "INTEREST_ONLY";
    PaymentMethod["PrincipalInterest"] = "PRINCIPAL_AND_INTEREST";
    PaymentMethod["StillDeciding"] = "STILL_DECIDING";
})(PaymentMethod || (PaymentMethod = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/property-use/index.js
var PropertyUse;
(function (PropertyUse) {
    PropertyUse["OwnerOccupied"] = "OWNER_OCCUPIED";
    PropertyUse["Investment"] = "INVESTMENT";
})(PropertyUse || (PropertyUse = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/purchase-intent/index.js
var PurchaseIntent;
(function (PurchaseIntent) {
    PurchaseIntent["FirstHome"] = "FIRST_HOME";
    PurchaseIntent["NextHome"] = "NEXT_HOME";
    PurchaseIntent["Investment"] = "INVESTMENT";
})(PurchaseIntent || (PurchaseIntent = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/purchase-situation/index.js
var purchase_situation_PurchaseSituation;
(function (PurchaseSituation) {
    PurchaseSituation["ContractsExchanged"] = "CONTRACTS_EXCHANGED";
    PurchaseSituation["OfferMade"] = "OFFER_MADE";
    PurchaseSituation["BuyingSoon"] = "BUYING_SOON";
    PurchaseSituation["ExploringOptions"] = "EXPLORING_OPTIONS";
    PurchaseSituation["ActivelyLookingForAHome"] = "ACTIVELY_LOOKING_FOR_A_HOME";
})(purchase_situation_PurchaseSituation || (purchase_situation_PurchaseSituation = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/purpose/index.js
var purpose_Purpose;
(function (Purpose) {
    Purpose["NewPurchase"] = "NEW_PURCHASE";
    Purpose["Refinance"] = "REFINANCE";
})(purpose_Purpose || (purpose_Purpose = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/refinancing-reason/index.js
var RefinancingReason;
(function (RefinancingReason) {
    RefinancingReason["ConsolidateCashout"] = "CONSOLIDATE_CASHOUT";
    RefinancingReason["FasterPayoff"] = "FASTER_PAYOFF";
    RefinancingReason["DecreaseRepayments"] = "DECREASE_REPAYMENTS";
    RefinancingReason["Construction"] = "CONSTRUCTION";
    RefinancingReason["Consolidate"] = "CONSOLIDATE_DEBT";
    RefinancingReason["Cashout"] = "GET_CASHOUT";
})(RefinancingReason || (RefinancingReason = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/relationship-with-property/index.js
var RelationshipWithProperty;
(function (RelationshipWithProperty) {
    RelationshipWithProperty["Owner"] = "OWNER";
    RelationshipWithProperty["InterestedToBuy"] = "INTERESTED_TO_BUY";
    RelationshipWithProperty["CurrentlyRenting"] = "CURRENTLY_RENTING";
    RelationshipWithProperty["Curious"] = "JUST_CURIOUS";
})(RelationshipWithProperty || (RelationshipWithProperty = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/stamp-duty-property-state/index.js
var StampDutyPropertyState;
(function (StampDutyPropertyState) {
    StampDutyPropertyState["NSW"] = "NSW";
    StampDutyPropertyState["QLD"] = "QLD";
    StampDutyPropertyState["WA"] = "WA";
    StampDutyPropertyState["VIC"] = "VIC";
    StampDutyPropertyState["TAS"] = "TAS";
    StampDutyPropertyState["ACT"] = "ACT";
    StampDutyPropertyState["NT"] = "NT";
    StampDutyPropertyState["SA"] = "SA";
})(StampDutyPropertyState || (StampDutyPropertyState = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/stamp-duty-property-type/index.js
var StampDutyPropertyType;
(function (StampDutyPropertyType) {
    StampDutyPropertyType["NewHome"] = "NEW_HOME";
    StampDutyPropertyType["EstablishedHome"] = "ESTABLISHED_HOME";
    StampDutyPropertyType["VacantLand"] = "VACANT_LAND";
})(StampDutyPropertyType || (StampDutyPropertyType = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/urgency/index.js
var urgency_Urgency;
(function (Urgency) {
    Urgency["Urgent"] = "URGENT";
    Urgency["NotUrgent"] = "NOT_URGENT";
})(urgency_Urgency || (urgency_Urgency = {}));
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/enums/index.js






















//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/configuration/index.js

var configuration = {
    sessionStorageKeyPrefix: 'l3',
    sessionStorageKeySuffixes: {
        firstName: 'firstName',
        mobileNumber: 'mobileNumber',
        email: 'email',
        brokerId: 'brokerId',
        storeId: 'storeId',
    },
    brokerStorePageLeadJourneys: [Origin.AppointmentBooking, Origin.Refinance, Origin.NewHomeLoan, Origin.BorrowingPower],
    defaultTimezone: 'Australia/Sydney',
};
/* harmony default export */ var esm_configuration = (configuration);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/utils.js
/* provided dependency */ var utils_process = __webpack_require__(13158);




// utils is a library of generic helper functions non-specific to axios

const {toString: utils_toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = utils_toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray: utils_isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const utils_isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => utils_isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

const [isReadableStream, isRequest, isResponse, isHeaders] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(kindOfTest);

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const utils_trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (utils_isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (utils_isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const utils_extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (utils_isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const utils_isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  utils_isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const utils_noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (utils_isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = utils_isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (utils_isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34

const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }

  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({source, data}) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);

    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    }
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === 'function',
  isFunction(_global.postMessage)
);

const asap = typeof queueMicrotask !== 'undefined' ?
  queueMicrotask.bind(_global) : ( typeof utils_process !== 'undefined' && utils_process.nextTick || _setImmediate);

// *********************

/* harmony default export */ var lib_utils = ({
  isArray: utils_isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject: utils_isObject,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp: utils_isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend: utils_extend,
  trim: utils_trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: utils_noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap
});

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}

lib_utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: lib_utils.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});

const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);

  lib_utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ var core_AxiosError = (AxiosError);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ var helpers_null = (null);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(75291)["lW"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return lib_utils.isPlainObject(thing) || lib_utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return lib_utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return lib_utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = lib_utils.toFlatObject(lib_utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!lib_utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = lib_utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !lib_utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && lib_utils.isSpecCompliantForm(formData);

  if (!lib_utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (lib_utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && lib_utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (lib_utils.isArrayBuffer(value) || lib_utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (lib_utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (lib_utils.isArray(value) && isFlatArray(value)) ||
        ((lib_utils.isFileList(value) || lib_utils.endsWith(key, '[]')) && (arr = lib_utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(lib_utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (lib_utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    lib_utils.forEach(value, function each(el, key) {
      const result = !(lib_utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, lib_utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!lib_utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ var helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = lib_utils.isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    lib_utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ var core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/platform/browser/index.js




/* harmony default export */ var browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/platform/common/utils.js
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

const _navigator = typeof navigator === 'object' && navigator || undefined;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = hasBrowserEnv &&
  (!_navigator || ['ReactNative', 'NativeScript', 'NS'].indexOf(_navigator.product) < 0);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();

const origin = hasBrowserEnv && window.location.href || 'http://localhost';



;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/platform/index.js



/* harmony default export */ var platform = ({
  ...common_utils_namespaceObject,
  ...browser
});

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && lib_utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return lib_utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function formDataToJSON_arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && lib_utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (lib_utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !lib_utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && lib_utils.isArray(target[name])) {
      target[name] = formDataToJSON_arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (lib_utils.isFormData(formData) && lib_utils.isFunction(formData.entries)) {
    const obj = {};

    lib_utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/defaults/index.js










/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (lib_utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return lib_utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults_defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http', 'fetch'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = lib_utils.isObject(data);

    if (isObjectPayload && lib_utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = lib_utils.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (lib_utils.isArrayBuffer(data) ||
      lib_utils.isBuffer(data) ||
      lib_utils.isStream(data) ||
      lib_utils.isFile(data) ||
      lib_utils.isBlob(data) ||
      lib_utils.isReadableStream(data)
    ) {
      return data;
    }
    if (lib_utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (lib_utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = lib_utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults_defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (lib_utils.isResponse(data) || lib_utils.isReadableStream(data)) {
      return data;
    }

    if (data && lib_utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

lib_utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults_defaults.headers[method] = {};
});

/* harmony default export */ var lib_defaults = (defaults_defaults);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = lib_utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return lib_utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (lib_utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!lib_utils.isString(value)) return;

  if (lib_utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (lib_utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = lib_utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = lib_utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      lib_utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (lib_utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(lib_utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (lib_utils.isHeaders(header)) {
      for (const [key, value] of header.entries()) {
        setHeader(value, key, rewrite);
      }
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = lib_utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (lib_utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (lib_utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = lib_utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = lib_utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (lib_utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    lib_utils.forEach(this, (value, header) => {
      const key = lib_utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    lib_utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && lib_utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    lib_utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
lib_utils.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

lib_utils.freezeMethods(AxiosHeaders);

/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  lib_utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

lib_utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});

/* harmony default export */ var cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/throttle.js
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle(fn, freq) {
  let timestamp = 0;
  let threshold = 1000 / freq;
  let lastArgs;
  let timer;

  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn.apply(null, args);
  }

  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if ( passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs)
        }, threshold - passed);
      }
    }
  }

  const flush = () => lastArgs && invoke(lastArgs);

  return [throttled, flush];
}

/* harmony default export */ var helpers_throttle = (throttle);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/progressEventReducer.js




const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return helpers_throttle(e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? 'download' : 'upload']: true
    };

    listener(data);
  }, freq);
}

const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;

  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
}

const asyncDecorator = (fn) => (...args) => lib_utils.asap(() => fn(...args));

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/isURLSameOrigin.js





/* harmony default export */ var isURLSameOrigin = (platform.hasStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (lib_utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/cookies.js



/* harmony default export */ var cookies = (platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      lib_utils.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      lib_utils.isString(path) && cookie.push('path=' + path);

      lib_utils.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  });


;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (lib_utils.isPlainObject(target) && lib_utils.isPlainObject(source)) {
      return lib_utils.merge.call({caseless}, target, source);
    } else if (lib_utils.isPlainObject(source)) {
      return lib_utils.merge({}, source);
    } else if (lib_utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!lib_utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!lib_utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!lib_utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!lib_utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!lib_utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  lib_utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (lib_utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/resolveConfig.js









/* harmony default export */ var resolveConfig = ((config) => {
  const newConfig = mergeConfig({}, config);

  let {data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth} = newConfig;

  newConfig.headers = headers = core_AxiosHeaders.from(headers);

  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);

  // HTTP basic authentication
  if (auth) {
    headers.set('Authorization', 'Basic ' +
      btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : ''))
    );
  }

  let contentType;

  if (lib_utils.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(undefined); // Let the browser set it
    } else if ((contentType = headers.getContentType()) !== false) {
      // fix semicolon duplication issue for ReactNative FormData implementation
      const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
    }
  }

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.

  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && lib_utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));

    if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(newConfig.url))) {
      // Add xsrf header
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);

      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }

  return newConfig;
});


;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/adapters/xhr.js











const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = core_AxiosHeaders.from(_config.headers).normalize();
    let {responseType, onUploadProgress, onDownloadProgress} = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;

    function done() {
      flushUpload && flushUpload(); // flush events
      flushDownload && flushDownload(); // flush events

      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);

      _config.signal && _config.signal.removeEventListener('abort', onCanceled);
    }

    let request = new XMLHttpRequest();

    request.open(_config.method.toUpperCase(), _config.url, true);

    // Set the request timeout in MS
    request.timeout = _config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = _config.transitional || defaults_transitional;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      lib_utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!lib_utils.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = _config.responseType;
    }

    // Handle progress if needed
    if (onDownloadProgress) {
      ([downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true));
      request.addEventListener('progress', downloadThrottled);
    }

    // Not all browsers support upload events
    if (onUploadProgress && request.upload) {
      ([uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress));

      request.upload.addEventListener('progress', uploadThrottled);

      request.upload.addEventListener('loadend', flushUpload);
    }

    if (_config.cancelToken || _config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(_config.url);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/composeSignals.js




const composeSignals = (signals, timeout) => {
  const {length} = (signals = signals ? signals.filter(Boolean) : []);

  if (timeout || length) {
    let controller = new AbortController();

    let aborted;

    const onabort = function (reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof core_AxiosError ? err : new cancel_CanceledError(err instanceof Error ? err.message : err));
      }
    }

    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new core_AxiosError(`timeout ${timeout} of ms exceeded`, core_AxiosError.ETIMEDOUT))
    }, timeout)

    const unsubscribe = () => {
      if (signals) {
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach(signal => {
          signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
      }
    }

    signals.forEach((signal) => signal.addEventListener('abort', onabort));

    const {signal} = controller;

    signal.unsubscribe = () => lib_utils.asap(unsubscribe);

    return signal;
  }
}

/* harmony default export */ var helpers_composeSignals = (composeSignals);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/trackStream.js

const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;

  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }

  let pos = 0;
  let end;

  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
}

const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
}

const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }

  const reader = stream.getReader();
  try {
    for (;;) {
      const {done, value} = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
}

const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);

  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  }

  return new ReadableStream({
    async pull(controller) {
      try {
        const {done, value} = await iterator.next();

        if (done) {
         _onFinish();
          controller.close();
          return;
        }

        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  })
}

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/adapters/fetch.js










const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';

// used only inside the fetch adapter
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ?
    ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) :
    async (str) => new Uint8Array(await new Response(str).arrayBuffer())
);

const fetch_test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false
  }
}

const supportsRequestStream = isReadableStreamSupported && fetch_test(() => {
  let duplexAccessed = false;

  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: 'POST',
    get duplex() {
      duplexAccessed = true;
      return 'half';
    },
  }).headers.has('Content-Type');

  return duplexAccessed && !hasContentType;
});

const DEFAULT_CHUNK_SIZE = 64 * 1024;

const supportsResponseStream = isReadableStreamSupported &&
  fetch_test(() => lib_utils.isReadableStream(new Response('').body));


const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};

isFetchSupported && (((res) => {
  ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(type => {
    !resolvers[type] && (resolvers[type] = lib_utils.isFunction(res[type]) ? (res) => res[type]() :
      (_, config) => {
        throw new core_AxiosError(`Response type '${type}' is not supported`, core_AxiosError.ERR_NOT_SUPPORT, config);
      })
  });
})(new Response));

const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }

  if(lib_utils.isBlob(body)) {
    return body.size;
  }

  if(lib_utils.isSpecCompliantForm(body)) {
    const _request = new Request(platform.origin, {
      method: 'POST',
      body,
    });
    return (await _request.arrayBuffer()).byteLength;
  }

  if(lib_utils.isArrayBufferView(body) || lib_utils.isArrayBuffer(body)) {
    return body.byteLength;
  }

  if(lib_utils.isURLSearchParams(body)) {
    body = body + '';
  }

  if(lib_utils.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
}

const resolveBodyLength = async (headers, body) => {
  const length = lib_utils.toFiniteNumber(headers.getContentLength());

  return length == null ? getBodyLength(body) : length;
}

/* harmony default export */ var adapters_fetch = (isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = 'same-origin',
    fetchOptions
  } = resolveConfig(config);

  responseType = responseType ? (responseType + '').toLowerCase() : 'text';

  let composedSignal = helpers_composeSignals([signal, cancelToken && cancelToken.toAbortSignal()], timeout);

  let request;

  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
      composedSignal.unsubscribe();
  });

  let requestContentLength;

  try {
    if (
      onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' &&
      (requestContentLength = await resolveBodyLength(headers, data)) !== 0
    ) {
      let _request = new Request(url, {
        method: 'POST',
        body: data,
        duplex: "half"
      });

      let contentTypeHeader;

      if (lib_utils.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
        headers.setContentType(contentTypeHeader)
      }

      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(
          requestContentLength,
          progressEventReducer(asyncDecorator(onUploadProgress))
        );

        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }

    if (!lib_utils.isString(withCredentials)) {
      withCredentials = withCredentials ? 'include' : 'omit';
    }

    // Cloudflare Workers throws when credentials are defined
    // see https://github.com/cloudflare/workerd/issues/902
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : undefined
    });

    let response = await fetch(request);

    const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');

    if (supportsResponseStream && (onDownloadProgress || (isStreamResponse && unsubscribe))) {
      const options = {};

      ['status', 'statusText', 'headers'].forEach(prop => {
        options[prop] = response[prop];
      });

      const responseContentLength = lib_utils.toFiniteNumber(response.headers.get('content-length'));

      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
        responseContentLength,
        progressEventReducer(asyncDecorator(onDownloadProgress), true)
      ) || [];

      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          unsubscribe && unsubscribe();
        }),
        options
      );
    }

    responseType = responseType || 'text';

    let responseData = await resolvers[lib_utils.findKey(resolvers, responseType) || 'text'](response, config);

    !isStreamResponse && unsubscribe && unsubscribe();

    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: core_AxiosHeaders.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      })
    })
  } catch (err) {
    unsubscribe && unsubscribe();

    if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) {
      throw Object.assign(
        new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      )
    }

    throw core_AxiosError.from(err, err && err.code, config, request);
  }
}));



;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/adapters/adapters.js






const knownAdapters = {
  http: helpers_null,
  xhr: xhr,
  fetch: adapters_fetch
}

lib_utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => lib_utils.isFunction(adapter) || adapter === null || adapter === false;

/* harmony default export */ var adapters = ({
  getAdapter: (adapters) => {
    adapters = lib_utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new core_AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new core_AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
});

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/env/data.js
const VERSION = "1.7.7";
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var validator = ({
  assertOptions,
  validators
});

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/core/Axios.js











const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy;

        Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
        try {
          if (!err.stack) {
            err.stack = stack;
            // match without the 2 top stack lines
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
            err.stack += '\n' + stack
          }
        } catch (e) {
          // ignore the case where "stack" is an un-writable property
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (lib_utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && lib_utils.merge(
      headers.common,
      headers[config.method]
    );

    headers && lib_utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
lib_utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

lib_utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ var core_Axios = (Axios);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  toAbortSignal() {
    const controller = new AbortController();

    const abort = (err) => {
      controller.abort(err);
    };

    this.subscribe(abort);

    controller.signal.unsubscribe = () => this.unsubscribe(abort);

    return controller.signal;
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ var cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return lib_utils.isObject(payload) && (payload.isAxiosError === true);
}

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  lib_utils.extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  lib_utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(lib_utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios);

;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/integrations/leads-api/index.js
var leads_api_assign = (undefined && undefined.__assign) || function () {
    leads_api_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return leads_api_assign.apply(this, arguments);
};
var leads_api_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var leads_api_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


var buildAxiosRequestConfig = function (options) {
    if (options === void 0) { options = {}; }
    return (leads_api_assign(leads_api_assign({}, options), { headers: leads_api_assign({ Accept: 'application/json' }, ('headers' in options && options.headers)) }));
};
var sendLead = function (baseURL, payload, options) {
    if (options === void 0) { options = {}; }
    return leads_api_awaiter(void 0, void 0, void 0, function () {
        var request, data, error_1;
        return leads_api_generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!baseURL)
                        throw new Error("A baseURL must be provided for sendLead() to be used.");
                    if (!payload)
                        throw new Error("A payload must be provided to call sendLead().");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    logInvokedLeadRequest(payload);
                    return [4 /*yield*/, lib_axios.post(baseURL.concat("/v3/leads"), payload, buildAxiosRequestConfig(options))];
                case 2:
                    request = _a.sent();
                    data = request.data;
                    logSuccessfulLeadRequest(payload, data);
                    return [2 /*return*/, data];
                case 3:
                    error_1 = _a.sent();
                    logFailedLeadRequest(payload, error_1);
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/LendiGroupLeads/index.js
var LendiGroupLeads_assign = (undefined && undefined.__assign) || function () {
    LendiGroupLeads_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return LendiGroupLeads_assign.apply(this, arguments);
};
var LendiGroupLeads_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var LendiGroupLeads_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





var keyPrefix = configuration.sessionStorageKeyPrefix;
var keySuffixes = configuration.sessionStorageKeySuffixes;
var LendiGroupLeads = /** @class */ (function () {
    function LendiGroupLeads(leadOrigin) {
        this.storageKey = "".concat(keyPrefix, "-").concat(leadOrigin);
    }
    /**
     * set()
     *
     * @version: Used by LALA to identify this lead data is a lg lead as opposed to a legacy lead.
     * @timestamp: Used by this library to identify the latest lead that was set. (see retrieveLatestLeadData())
     *
     * @param payload
     */
    LendiGroupLeads.prototype.set = function (payload) {
        session_storage_sessionStorage.set(this.storageKey, LendiGroupLeads_assign(LendiGroupLeads_assign({}, payload), { version: 'v3', timestamp: new Date().getTime() }));
    };
    LendiGroupLeads.prototype.get = function () {
        return session_storage_sessionStorage.get(this.storageKey) || {};
    };
    Object.defineProperty(LendiGroupLeads, "firstName", {
        get: function () {
            return session_storage_sessionStorage.get("".concat(keyPrefix, "-").concat(keySuffixes.firstName));
        },
        enumerable: false,
        configurable: true
    });
    LendiGroupLeads.prototype.setFirstName = function (firstName) {
        session_storage_sessionStorage.set("".concat(keyPrefix, "-").concat(keySuffixes.firstName), firstName);
    };
    Object.defineProperty(LendiGroupLeads, "email", {
        get: function () {
            return session_storage_sessionStorage.get("".concat(keyPrefix, "-").concat(keySuffixes.email));
        },
        enumerable: false,
        configurable: true
    });
    LendiGroupLeads.prototype.setEmail = function (email) {
        session_storage_sessionStorage.set("".concat(keyPrefix, "-").concat(keySuffixes.email), email);
    };
    Object.defineProperty(LendiGroupLeads, "mobileNumber", {
        get: function () {
            return session_storage_sessionStorage.get("".concat(keyPrefix, "-").concat(keySuffixes.mobileNumber));
        },
        enumerable: false,
        configurable: true
    });
    LendiGroupLeads.prototype.setMobileNumber = function (mobileNumber) {
        session_storage_sessionStorage.set("".concat(keyPrefix, "-").concat(keySuffixes.mobileNumber), mobileNumber);
    };
    Object.defineProperty(LendiGroupLeads, "storeId", {
        /**
         * storeId()
         *
         * Used to get the store id set by broker & store pages for Aussie leads.
         */
        get: function () {
            return session_storage_sessionStorage.get("".concat(keyPrefix, "-").concat(keySuffixes.storeId));
        },
        enumerable: false,
        configurable: true
    });
    /**
     * setStoreId()
     *
     * Used to set a store id by broker & store pages for Aussie leads.
     */
    LendiGroupLeads.setStoreId = function (storeId) {
        session_storage_sessionStorage.set("".concat(keyPrefix, "-").concat(keySuffixes.storeId), storeId);
    };
    /**
     * unsetStoreId()
     *
     * Used to unset a store id set by store pages for Aussie leads.
     */
    LendiGroupLeads.unsetStoreId = function () {
        session_storage_sessionStorage.remove("".concat(keyPrefix, "-").concat(keySuffixes.storeId));
    };
    Object.defineProperty(LendiGroupLeads, "brokerId", {
        /**
         * brokerId()
         *
         * Set by broker & store pages for Aussie leads.
         */
        get: function () {
            return session_storage_sessionStorage.get("".concat(keyPrefix, "-").concat(keySuffixes.brokerId));
        },
        enumerable: false,
        configurable: true
    });
    /**
     * unsetBrokerId()
     *
     * Used to unset a broker id set by broker pages for Aussie leads.
     */
    LendiGroupLeads.unsetBrokerId = function () {
        session_storage_sessionStorage.remove("".concat(keyPrefix, "-").concat(keySuffixes.brokerId));
    };
    /**
     * setBrokerId()
     *
     * Set by broker & store pages for Aussie leads.
     */
    LendiGroupLeads.setBrokerId = function (brokerId) {
        session_storage_sessionStorage.set("".concat(keyPrefix, "-").concat(keySuffixes.brokerId), brokerId);
    };
    LendiGroupLeads.getAllStoredLeads = function () {
        var results = [];
        var leadOrigins = Object.keys(lead_store_leadStoreGenerator());
        leadOrigins.forEach(function (origin) {
            var data = session_storage_sessionStorage.get("".concat(configuration.sessionStorageKeyPrefix, "-").concat(origin));
            if (data)
                results.push({ data: data, funnelName: origin });
        });
        return results;
    };
    /**
     * retrieveLatestLeadData()
     *
     * Finds the latest stored lead data in sessionStorage
     * by timestamp.
     */
    LendiGroupLeads.retrieveLatestLeadData = function () {
        var defaultLead = {
            funnelName: Origin.SignUp,
            data: { timestamp: 0, version: 'v3' },
        };
        try {
            var leads = this.getAllStoredLeads();
            return leads.reduce(function (acc, funnelData) {
                var _b, _c;
                try {
                    if (((_b = acc === null || acc === void 0 ? void 0 : acc.data) === null || _b === void 0 ? void 0 : _b.timestamp) === undefined || ((_c = funnelData === null || funnelData === void 0 ? void 0 : funnelData.data) === null || _c === void 0 ? void 0 : _c.timestamp) === undefined)
                        return acc;
                    var isLatestLead = acc.data.timestamp < funnelData.data.timestamp;
                    return isLatestLead ? funnelData : acc;
                }
                catch (_d) {
                    return acc;
                }
            }, defaultLead);
        }
        catch (error) {
            datadogLogs.logger.error("An error occurred while retrieve latest lead data.", {}, error);
            return defaultLead;
        }
    };
    var _a;
    _a = LendiGroupLeads;
    /**
     * constructLeadsServicePayload()
     *
     * Used to construct lead data and obtain any additional
     * properties and add them to the lead object before sending
     * the lead data to the leads service.
     *
     * It also deletes properties that are specifically applied by the
     * lendigroup-leads-library (timestamp & version).
     *
     * @param leadData
     * @param returnUrl
     */
    LendiGroupLeads.constructLeadsServicePayload = function (leadData, returnUrl) {
        var leadOrigin = leadData.origin || Origin.SignUp;
        var shouldRetrieveBrokerStorePageData = configuration.brokerStorePageLeadJourneys.includes(leadOrigin);
        var leadAccountOrigin = (leadData === null || leadData === void 0 ? void 0 : leadData.accountOrigin) || retrieveAccountOrigin(leadData);
        var leadStoreId = leadData.storeId || (shouldRetrieveBrokerStorePageData && LendiGroupLeads.storeId);
        var leadOwnerId = (shouldRetrieveBrokerStorePageData && LendiGroupLeads.brokerId) || leadData.ownerId;
        var leadMobileNumber = leadData.mobileNumber || LendiGroupLeads.mobileNumber;
        var leadEmail = leadData.email || LendiGroupLeads.email;
        var leadFirstName = leadData.firstName || LendiGroupLeads.firstName;
        var leadGeneratedAt = new Date().toISOString();
        var leadGclId = retrieveGCLID(leadData.accountOrigin);
        var leadTimezone = leadData.timeZone || getTimezone();
        var retrievedUTMs = retrieveUtm(leadData, returnUrl);
        var lead = LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign({}, leadData), { 
            // Required properties
            mobileNumber: leadMobileNumber, origin: leadOrigin, accountOrigin: leadAccountOrigin, generatedAt: leadGeneratedAt, timeZone: leadTimezone }), (leadData.data && { data: leadData.data })), (leadFirstName && { firstName: leadFirstName })), (leadEmail && { email: leadEmail })), (leadStoreId && { storeId: leadStoreId })), (leadOwnerId && { ownerId: leadOwnerId })), (leadGclId && { gclId: leadGclId })), (retrievedUTMs && { utm: retrievedUTMs }));
        // Cleanup properties set by lendigroup-leads-library
        if ('timestamp' in lead)
            delete lead.timestamp;
        if ('version' in lead)
            delete lead.version;
        return lead;
    };
    /**
     * sendLatestLead()
     *
     * @param baseURL
     * @param additionalLeadProperties
     * @param returnUrl
     * @usage
     *
     * import { LendiGroupLeads } from 'lendigroup-leads-library'
     *
     * LendiGroupLeads.sendLatestLead(baseURL, additionalLeadData)
     */
    LendiGroupLeads.sendLatestLead = function (baseURL, additionalLeadProperties, returnUrl) { return LendiGroupLeads_awaiter(void 0, void 0, void 0, function () {
        var leadFunnelObject, leadFunnelOrigin, leadFunnelData, error_1;
        return LendiGroupLeads_generator(_a, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    leadFunnelObject = this.retrieveLatestLeadData();
                    leadFunnelOrigin = leadFunnelObject.funnelName;
                    leadFunnelData = leadFunnelObject.data;
                    return [4 /*yield*/, sendLead(baseURL, this.constructLeadsServicePayload(LendiGroupLeads_assign(LendiGroupLeads_assign(LendiGroupLeads_assign({}, leadFunnelData), additionalLeadProperties), { origin: leadFunnelOrigin }), returnUrl))];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    error_1 = _b.sent();
                    datadogLogs.logger.error('An error occurred while sending a lead.', {}, error_1);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /**
     * sendRawLead()
     *
     * Used to send a raw lead to leads v3 API. This lead
     * data will still be validated inside sendLead().
     *
     * @param baseURL
     * @param rawLeadData
     * @usage
     *
     * import { LendiGroupLeads } from 'lendigroup-leads-library'
     *
     * LendiGroupLeads.sendRawLead(baseURL, rawLeadData)
     */
    LendiGroupLeads.sendRawLead = function (baseURL, rawLeadData) { return LendiGroupLeads_awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return LendiGroupLeads_generator(_a, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, sendLead(baseURL, rawLeadData)];
                case 1: return [2 /*return*/, _b.sent()];
                case 2:
                    error_2 = _b.sent();
                    datadogLogs.logger.error("An error occurred while sending a raw lead.", {}, error_2);
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return LendiGroupLeads;
}());

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/Affiliate/index.js
var Affiliate_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Affiliate = /** @class */ (function (_super) {
    Affiliate_extends(Affiliate, _super);
    function Affiliate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Affiliate;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/AppointmentBooking/index.js
var AppointmentBooking_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AppointmentBooking = /** @class */ (function (_super) {
    AppointmentBooking_extends(AppointmentBooking, _super);
    function AppointmentBooking() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AppointmentBooking;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/Blog/index.js
var Blog_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Blog = /** @class */ (function (_super) {
    Blog_extends(Blog, _super);
    function Blog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Blog;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/BorrowingPower/index.js
var BorrowingPower_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var BorrowingPower = /** @class */ (function (_super) {
    BorrowingPower_extends(BorrowingPower, _super);
    function BorrowingPower() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BorrowingPower;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/BusinessLoanAssetFinance/index.js
var BusinessLoanAssetFinance_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var BusinessLoanAssetFinance = /** @class */ (function (_super) {
    BusinessLoanAssetFinance_extends(BusinessLoanAssetFinance, _super);
    function BusinessLoanAssetFinance() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BusinessLoanAssetFinance;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/BusinessLoanCommercial/index.js
var BusinessLoanCommercial_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var BusinessLoanCommercial = /** @class */ (function (_super) {
    BusinessLoanCommercial_extends(BusinessLoanCommercial, _super);
    function BusinessLoanCommercial() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BusinessLoanCommercial;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/CarLoan/index.js
var CarLoan_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var CarLoan = /** @class */ (function (_super) {
    CarLoan_extends(CarLoan, _super);
    function CarLoan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CarLoan;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/Chat/index.js
var Chat_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Chat = /** @class */ (function (_super) {
    Chat_extends(Chat, _super);
    function Chat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Chat;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/CreditScore/index.js
var CreditScore_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var CreditScore = /** @class */ (function (_super) {
    CreditScore_extends(CreditScore, _super);
    function CreditScore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CreditScore;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/FixedRateExpiry/index.js
var FixedRateExpiry_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var FixedRateExpiry = /** @class */ (function (_super) {
    FixedRateExpiry_extends(FixedRateExpiry, _super);
    function FixedRateExpiry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FixedRateExpiry;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/Insurance/index.js
var Insurance_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Insurance = /** @class */ (function (_super) {
    Insurance_extends(Insurance, _super);
    function Insurance() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Insurance;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/Invite/index.js
var Invite_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Invite = /** @class */ (function (_super) {
    Invite_extends(Invite, _super);
    function Invite() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Invite;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/MarketingOther/index.js
var MarketingOther_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var MarketingOther = /** @class */ (function (_super) {
    MarketingOther_extends(MarketingOther, _super);
    function MarketingOther() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MarketingOther;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/NewHomeLoan/index.js
var NewHomeLoan_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var NewHomeLoan = /** @class */ (function (_super) {
    NewHomeLoan_extends(NewHomeLoan, _super);
    function NewHomeLoan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NewHomeLoan;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/PropertyReport/index.js
var PropertyReport_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var PropertyReport = /** @class */ (function (_super) {
    PropertyReport_extends(PropertyReport, _super);
    function PropertyReport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertyReport;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/Refinance/index.js
var Refinance_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Refinance = /** @class */ (function (_super) {
    Refinance_extends(Refinance, _super);
    function Refinance() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Refinance;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/RetrievalUtils/index.js

var RetrievalUtils = /** @class */ (function () {
    function RetrievalUtils() {
    }
    RetrievalUtils.retrieveUtm = function (leadData) {
        return retrieveUtm(leadData);
    };
    RetrievalUtils.retrieveGCLID = function (accountOrigin) {
        return retrieveGCLID(accountOrigin);
    };
    RetrievalUtils.retrieveAccountOrigin = function (leadData) {
        return retrieveAccountOrigin(leadData);
    };
    return RetrievalUtils;
}());

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/SelfGen/index.js
var SelfGen_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var SelfGen = /** @class */ (function (_super) {
    SelfGen_extends(SelfGen, _super);
    function SelfGen() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SelfGen;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/SignUp/index.js
var SignUp_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var SignUp = /** @class */ (function (_super) {
    SignUp_extends(SignUp, _super);
    function SignUp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SignUp;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/StampDutyCalculator/index.js
var StampDutyCalculator_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var StampDutyCalculator = /** @class */ (function (_super) {
    StampDutyCalculator_extends(StampDutyCalculator, _super);
    function StampDutyCalculator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StampDutyCalculator;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/AussieHomes/index.js
var AussieHomes_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AussieHomes = /** @class */ (function (_super) {
    AussieHomes_extends(AussieHomes, _super);
    function AussieHomes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AussieHomes;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/AreaReport/index.js
var AreaReport_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var AreaReport = /** @class */ (function (_super) {
    AreaReport_extends(AreaReport, _super);
    function AreaReport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AreaReport;
}(LendiGroupLeads));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/classes/index.js























//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/lead-store/index.js


var lead_store_leadStoreGenerator = function () {
    var _a;
    return (_a = {},
        _a[Origin.PropertyReport] = PropertyReport,
        _a[Origin.SignUp] = SignUp,
        _a[Origin.BorrowingPower] = BorrowingPower,
        _a[Origin.NewHomeLoan] = NewHomeLoan,
        _a[Origin.Refinance] = Refinance,
        _a[Origin.Blog] = Blog,
        _a[Origin.StampDutyCalculator] = StampDutyCalculator,
        _a[Origin.AppointmentBooking] = AppointmentBooking,
        _a[Origin.Invite] = Invite,
        _a[Origin.Chat] = Chat,
        _a[Origin.SelfGen] = SelfGen,
        _a[Origin.CreditScore] = CreditScore,
        _a[Origin.FixedRateExpiry] = FixedRateExpiry,
        _a[Origin.AffiliateLead] = Affiliate,
        _a[Origin.MarketingOther] = MarketingOther,
        _a[Origin.CarLoan] = CarLoan,
        _a[Origin.BusinessLoanAssetFinance] = BusinessLoanAssetFinance,
        _a[Origin.BusinessLoanCommercial] = BusinessLoanCommercial,
        _a[Origin.Insurance] = Insurance,
        _a[Origin.AussieHomes] = AussieHomes,
        _a[Origin.AreaReport] = AreaReport,
        _a);
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/create-lead/index.js

var createLead = function (origin) {
    var leadStore = leadStoreGenerator();
    if (!Object.keys(leadStore).includes(origin)) {
        throw new Error("Invalid origin of ".concat(origin, " provided. This lead origin is not supported by this library."));
    }
    return new leadStore[origin](origin);
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/constants/index.js
var UTMS = ['utmSource', 'utmContent', 'utmMedium', 'utmCampaign', 'utmTerm'];
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/camel-to-snake/index.js
var camelToSnake = function (str) {
    return str.replace(/([a-zA-Z])(?=[A-Z])/g, '$1_').toLowerCase();
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/remove-duplicate/index.js
var removeDuplicate = function (field) { return (Array.isArray(field) ? field[0] : field); };
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/snake-to-camel/index.js
var snakeToCamel = function (str) { return str.replace(/(_\w)/g, function (k) { return k[1].toUpperCase(); }); };
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/format-utm/index.js
var format_utm_assign = (undefined && undefined.__assign) || function () {
    format_utm_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return format_utm_assign.apply(this, arguments);
};





var isValidUTMParam = function (paramKey) { return Boolean(paramKey.startsWith('utm') && UTMS.includes(paramKey)); };
function formatUtm(queryParams) {
    var defaultUTMs = {
        utmSource: '',
        utmContent: '',
        utmMedium: '',
        utmCampaign: '',
        utmTerm: '',
    };
    try {
        var parsedUTMs = Object.keys(queryParams)
            .map(function (queryParamKey) { return snakeToCamel(queryParamKey); })
            .filter(function (queryParamKey) { return isValidUTMParam(queryParamKey); })
            .reduce(function (acc, utmParamKey) {
            var _a;
            var _b;
            return (format_utm_assign(format_utm_assign({}, acc), (_a = {}, _a[utmParamKey] = removeDuplicate((_b = queryParams[camelToSnake(utmParamKey)]) !== null && _b !== void 0 ? _b : queryParams[utmParamKey]), _a)));
        }, {});
        return parsedUTMs;
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred while attempting to retrieve UTM's from query data", {}, error);
        return defaultUTMs;
    }
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/jstz/index.js
var jstz = __webpack_require__(96342);
var jstz_default = /*#__PURE__*/__webpack_require__.n(jstz);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/get-timezone/index.js


var getTimezone = function (defaultTimezone) {
    if (defaultTimezone === void 0) { defaultTimezone = esm_configuration.defaultTimezone; }
    try {
        var timezone = jstz_default().determine();
        return timezone.name() || defaultTimezone;
    }
    catch (_a) {
        return defaultTimezone;
    }
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/create-pii-excluded-lead-log/index.js
var createPIIExcludedLeadLog = function (lead) { return ({
    leadHasMobileNumber: Boolean('mobileNumber' in lead && (lead === null || lead === void 0 ? void 0 : lead.mobileNumber)),
    leadHasEmail: Boolean('email' in lead && (lead === null || lead === void 0 ? void 0 : lead.email)),
    leadHasAccountOrigin: Boolean('accountOrigin' in lead && (lead === null || lead === void 0 ? void 0 : lead.accountOrigin)),
    leadHasFirstName: Boolean('firstName' in lead && (lead === null || lead === void 0 ? void 0 : lead.firstName)),
    leadHasLastName: Boolean('lastName' in lead && (lead === null || lead === void 0 ? void 0 : lead.lastName)),
    generatedAt: lead === null || lead === void 0 ? void 0 : lead.generatedAt,
    customerId: lead === null || lead === void 0 ? void 0 : lead.customerId,
    brand: lead === null || lead === void 0 ? void 0 : lead.brand,
    utm: lead === null || lead === void 0 ? void 0 : lead.utm,
    origin: lead === null || lead === void 0 ? void 0 : lead.origin,
    timeZone: lead === null || lead === void 0 ? void 0 : lead.timeZone,
    storeId: lead === null || lead === void 0 ? void 0 : lead.storeId,
    ownerId: lead === null || lead === void 0 ? void 0 : lead.ownerId,
    gclId: lead === null || lead === void 0 ? void 0 : lead.gclId,
}); };
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/log-utils/index.js


var logInvokedLeadRequest = function (payload) {
    datadogLogs.logger.info('Lead request invoked.', {
        leadData: createPIIExcludedLeadLog(payload),
    });
};
var logSuccessfulLeadRequest = function (payload, response) {
    datadogLogs.logger.info('Lead request successful.', {
        leadData: createPIIExcludedLeadLog(payload),
        response: response,
    });
};
var logFailedLeadRequest = function (payload, error) {
    datadogLogs.logger.error('Lead request failed.', {
        leadData: createPIIExcludedLeadLog(payload),
    }, error);
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/qs/lib/index.js
var qs_lib = __webpack_require__(33348);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/retrieve-account-origin/index.js



var retrieveAccountOriginFromQueryString = function () {
    var queryString = qs_lib.parse(location === null || location === void 0 ? void 0 : location.search, { ignoreQueryPrefix: true });
    return (queryString === null || queryString === void 0 ? void 0 : queryString.origin) || '';
};
var retrieveAccountOriginFromLeadData = function (leadData) {
    var _a;
    try {
        return (leadData === null || leadData === void 0 ? void 0 : leadData.accountOrigin) || ((_a = leadData === null || leadData === void 0 ? void 0 : leadData.data) === null || _a === void 0 ? void 0 : _a.accountOrigin) || '';
    }
    catch (_b) {
        return '';
    }
};
var retrieveAccountOrigin = function (leadData) {
    try {
        return leadData && retrieveAccountOriginFromLeadData(leadData)
            ? retrieveAccountOriginFromLeadData(leadData)
            : retrieveAccountOriginFromQueryString();
    }
    catch (error) {
        datadogLogs.logger.error('An error occurred while attempting to retrieve account origin from lead data.', { leadData: leadData ? createPIIExcludedLeadLog(leadData) : {} }, error);
        return '';
    }
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/retrieve-gcl-id/index.js



var retrieveGCLID = function (accountOrigin) {
    var _a, _b;
    try {
        if (location === null || location === void 0 ? void 0 : location.search) {
            var queryString = qs_lib.parse(location === null || location === void 0 ? void 0 : location.search, { ignoreQueryPrefix: true });
            return ((_a = removeDuplicate(queryString.gclid)) === null || _a === void 0 ? void 0 : _a.toString()) || null;
        }
        else if (accountOrigin) {
            var queryString = qs_lib.parse(new URL(accountOrigin).search, { ignoreQueryPrefix: true });
            return ((_b = removeDuplicate(queryString.gclid)) === null || _b === void 0 ? void 0 : _b.toString()) || null;
        }
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred while attempting to retrieve GclId.", { error: error }, error);
    }
    return null;
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/add-protocol-if-missing/index.js
var addProtocolIfMissing = function (url) {
    if (!/^(?:f|ht)tps?:\/\//.test(url)) {
        url = 'http://' + url;
    }
    return url;
};
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/retrieve-utm/index.js
var retrieve_utm_assign = (undefined && undefined.__assign) || function () {
    retrieve_utm_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return retrieve_utm_assign.apply(this, arguments);
};




var replaceLTMsWithUTMs = function (payload) {
    return payload.replace(/ltm_(?<verb>(term|campaign|content|source|medium))/gm, 'utm_$<verb>');
};
var emptyUTMsObject = {
    utmSource: '',
};
var parseUTMsFromURLOrPath = function (payload) {
    if (!payload)
        return emptyUTMsObject;
    var parsedPayload = payload.indexOf('utm') === -1 ? replaceLTMsWithUTMs(payload) : payload;
    var parsedQueryString = qs_lib.parse(parsedPayload, { ignoreQueryPrefix: true });
    var parsedUTMs = formatUtm(parsedQueryString);
    var nestedParamsPossible = Boolean(!(parsedUTMs === null || parsedUTMs === void 0 ? void 0 : parsedUTMs.utmSource) && (parsedQueryString === null || parsedQueryString === void 0 ? void 0 : parsedQueryString.returnURL));
    if (nestedParamsPossible) {
        var parsedReturnURLParams = parseUTMsFromURLOrPath(new URL(addProtocolIfMissing(parsedQueryString.returnURL)).search);
        return retrieve_utm_assign(retrieve_utm_assign({}, parsedUTMs), parsedReturnURLParams);
    }
    return parsedUTMs;
};
var parseUTMsFromCurrentUrl = function () {
    var _a;
    try {
        return parseUTMsFromURLOrPath((_a = location === null || location === void 0 ? void 0 : location.search) !== null && _a !== void 0 ? _a : '');
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred parsing location.search, see errorDetails for more information.", {
            errorDetails: {
                error: error,
                locationSearch: location === null || location === void 0 ? void 0 : location.search,
            },
        });
        return emptyUTMsObject;
    }
};
/**
 * parseUTMsFromReturnURL()
 *
 * Sources UTM data from returnURL if provided.
 *
 * @param returnUrl
 */
var parseUTMsFromReturnURL = function (returnUrl) {
    try {
        if (!returnUrl)
            return emptyUTMsObject;
        var builtReturnURL = new URL(addProtocolIfMissing(returnUrl));
        return parseUTMsFromURLOrPath(builtReturnURL.search);
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred parsing UTMs from returnURL, see errorDetails for more information.", {
            errorDetails: {
                error: error,
                returnURL: returnUrl !== null && returnUrl !== void 0 ? returnUrl : '',
            },
        });
        return emptyUTMsObject;
    }
};
/**
 * parseUTMsFromAccountOrigin()
 *
 * Sources UTMs from accountOrigin if provided.
 *
 * @param accountOrigin
 */
var parseUTMsFromAccountOrigin = function (accountOrigin) {
    try {
        if (!accountOrigin)
            return emptyUTMsObject;
        var builtAccountOrigin = new URL(addProtocolIfMissing(accountOrigin));
        return parseUTMsFromURLOrPath(builtAccountOrigin.search);
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred parsing account origin, see errorDetails for more information.", {
            errorDetails: {
                error: error,
                accountOrigin: accountOrigin,
            },
        });
        return emptyUTMsObject;
    }
};
var isValidUTMData = function (utmData) {
    try {
        return !!(utmData === null || utmData === void 0 ? void 0 : utmData.utmSource);
    }
    catch (_a) {
        return false;
    }
};
/**
 * Retrieve UTMs is used to retrieve UTMs with consideration for fallbacks and niche flows.
 *
 * The fallback flow is as follows:
 *
 * - If UTMs are in lead data, the lead UTM data will be used.
 * - If UTMs are found in the current URL (location?.search), the current URL UTM data will be used.
 * - If UTMs are found using the account origin set in the lead data, the account origin UTM data will be used.
 * - If UTMs are found in the returnURL provided by LALA, the returnURL UTM data will be used.
 *
 * In order for lead data to be considered valid, it must contain utmSource with a value, the rest are optional.
 *
 * ie:
 *
 * ```
 * {
 *   utmSource: 'some-utm-source'
 * }
 * ```
 *
 * @param leadData
 * @param returnUrl - Provided by LALA due to Domain redirection flow, absolute fallback for sourcing UTMs
 */
var retrieveUtm = function (leadData, returnUrl) {
    var _a;
    try {
        var leadDataUTMs = ((_a = leadData === null || leadData === void 0 ? void 0 : leadData.utm) === null || _a === void 0 ? void 0 : _a.utmSource) ? leadData === null || leadData === void 0 ? void 0 : leadData.utm : emptyUTMsObject;
        var currentUrlUTMs = parseUTMsFromCurrentUrl();
        var accountOriginUTMs = parseUTMsFromAccountOrigin(leadData === null || leadData === void 0 ? void 0 : leadData.accountOrigin);
        var returnUrlUTMs = parseUTMsFromReturnURL(returnUrl);
        if (isValidUTMData(leadDataUTMs))
            return leadDataUTMs;
        if (isValidUTMData(currentUrlUTMs))
            return currentUrlUTMs;
        if (isValidUTMData(accountOriginUTMs))
            return accountOriginUTMs;
        if (isValidUTMData(returnUrlUTMs))
            return returnUrlUTMs;
        return false;
    }
    catch (error) {
        datadogLogs.logger.error("An error occurred while attempting to retrieve UTMs.", {}, error);
        return false;
    }
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../../node_modules/store/plugins/defaults.js
var plugins_defaults = __webpack_require__(2053);
var defaults_default = /*#__PURE__*/__webpack_require__.n(plugins_defaults);
// EXTERNAL MODULE: ../../../node_modules/store/src/store-engine.js
var store_engine = __webpack_require__(4330);
var store_engine_default = /*#__PURE__*/__webpack_require__.n(store_engine);
// EXTERNAL MODULE: ../../../node_modules/store/storages/sessionStorage.js
var storages_sessionStorage = __webpack_require__(33600);
var sessionStorage_default = /*#__PURE__*/__webpack_require__.n(storages_sessionStorage);
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/session-storage/index.js



var session_storage_sessionStorage = store_engine_default().createStore([(sessionStorage_default())], [(defaults_default())]);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/utils/index.js















//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/node_modules/@lendi/lendigroup-leads-library/dist/esm/index.js

// Library Setup
initializeLogger();




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/GoogleOTIntegration/sendLead.js
var sendLead_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var sendLead_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




function sendLead_sendLead(environment, token) {
    var _a, _b, _c;
    return sendLead_awaiter(this, void 0, void 0, function () {
        var customer, leadData, baseURL;
        return sendLead_generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, getUserFromAPI(environment, token)];
                case 1:
                    customer = _d.sent();
                    esm/* LalaSentry.logInfo */.GG.logInfo('Customer fetched', { customerId: customer === null || customer === void 0 ? void 0 : customer.id });
                    leadData = LendiGroupLeads.retrieveLatestLeadData();
                    baseURL = (0,esm/* getAPIBaseURL */.K0)(environment);
                    return [4 /*yield*/, LendiGroupLeads.sendLatestLead(baseURL, {
                            mobileNumber: customer.mobileNumber,
                            email: customer.email,
                            firstName: leadData.data.firstName || customer.firstName,
                            customerId: customer.id,
                            brand: customer.brand,
                            accountOrigin: (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href,
                            authOrigin: AuthOrigin.Google,
                        })];
                case 2:
                    _d.sent();
                    esm/* LalaSentry.logInfo */.GG.logInfo('Lead sent', {
                        customerId: customer === null || customer === void 0 ? void 0 : customer.id,
                        mobileNumberL: (_b = customer.mobileNumber) === null || _b === void 0 ? void 0 : _b.length,
                        emailL: (_c = customer.email) === null || _c === void 0 ? void 0 : _c.length,
                    });
                    return [2 /*return*/, customer];
            }
        });
    });
}
//# sourceMappingURL=sendLead.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/GoogleOTIntegration/authenticateByAuth0.js
var authenticateByAuth0_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var authenticateByAuth0_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



function authenticateByAuth0(session, environment, email) {
    var _a;
    return authenticateByAuth0_awaiter(this, void 0, void 0, function () {
        var result, customer;
        return authenticateByAuth0_generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    esm/* LalaSentry.logInfo */.GG.logInfo('Google One Tap succeeded', { emailL: email === null || email === void 0 ? void 0 : email.length });
                    return [4 /*yield*/, session.popupAuthorise({ connection: 'google-oauth2', loginHint: email })];
                case 1:
                    result = _b.sent();
                    esm/* LalaSentry.logInfo */.GG.logInfo('Google One Tap selected', { tokenExists: !!(result === null || result === void 0 ? void 0 : result.token) });
                    if (!(result === null || result === void 0 ? void 0 : result.token)) return [3 /*break*/, 3];
                    return [4 /*yield*/, sendLead_sendLead(environment, result === null || result === void 0 ? void 0 : result.token)];
                case 2:
                    customer = _b.sent();
                    js_cookie.set(esm/* SAFETY_NET_COOKIE_NAME */.x7, ((_a = customer === null || customer === void 0 ? void 0 : customer.mobileNumber) === null || _a === void 0 ? void 0 : _a.startsWith('+61')) ? 'false' : 'true');
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=authenticateByAuth0.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/GoogleOTIntegration/useGoogleOTIntegration.js
var useGoogleOTIntegration_assign = (undefined && undefined.__assign) || function () {
    useGoogleOTIntegration_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return useGoogleOTIntegration_assign.apply(this, arguments);
};




function useGoogleOTIntegration(_a) {
    var _b, _c;
    var enabled = _a.enabled, googleOAuthClientId = _a.googleOAuthClientId, additionalGoogleOAuthConfigs = _a.additionalGoogleOAuthConfigs, env = _a.env, events = _a.events;
    var session = useSession_useSession();
    var brand = (0,esm/* getBrandFromHostname */.Y6)();
    esm/* LalaSentry.logInfo */.GG.logInfo('useGoogleOTIntegration called', {
        enabled: enabled,
        brand: brand,
        googleOAuthClientIdL: googleOAuthClientId === null || googleOAuthClientId === void 0 ? void 0 : googleOAuthClientId.length,
    });
    var environment = (0,esm/* getEnv */.dU)(env);
    var _d = additionalGoogleOAuthConfigs !== null && additionalGoogleOAuthConfigs !== void 0 ? additionalGoogleOAuthConfigs : {}, prompt_parent_id = _d.prompt_parent_id, cancel_on_tap_outside = _d.cancel_on_tap_outside, auto_select = _d.auto_select, itp_support = _d.itp_support, context = _d.context, nonce = _d.nonce, state_cookie_domain = _d.state_cookie_domain;
    var googleAccountConfigs = useGoogleOTIntegration_assign(useGoogleOTIntegration_assign(useGoogleOTIntegration_assign(useGoogleOTIntegration_assign(useGoogleOTIntegration_assign(useGoogleOTIntegration_assign(useGoogleOTIntegration_assign(useGoogleOTIntegration_assign({ client_id: googleOAuthClientId }, (prompt_parent_id !== undefined && { prompt_parent_id: prompt_parent_id })), (cancel_on_tap_outside !== undefined && { cancel_on_tap_outside: cancel_on_tap_outside })), (auto_select !== undefined && { auto_select: auto_select })), (itp_support !== undefined && { itp_support: itp_support })), (context !== undefined && { context: context })), (nonce !== undefined && { nonce: nonce })), (context !== undefined && { context: context })), (state_cookie_domain !== undefined && { state_cookie_domain: state_cookie_domain }));
    var disabled = ![esm/* Brand.Lendi */.H2.Lendi, esm/* Brand.Aussie */.H2.Aussie].includes(brand) || !enabled || !!((_b = session === null || session === void 0 ? void 0 : session.identity) === null || _b === void 0 ? void 0 : _b.id);
    esm/* LalaSentry.logInfo */.GG.logInfo('Display Google One Tap', { disabled: disabled, environment: environment, userId: (_c = session === null || session === void 0 ? void 0 : session.identity) === null || _c === void 0 ? void 0 : _c.id });
    useGoogleOneTapLogin({
        disabled: disabled,
        onRender: function () { var _a; return (_a = events === null || events === void 0 ? void 0 : events.onRendered) === null || _a === void 0 ? void 0 : _a.call(events); },
        onError: function (error) { return esm/* LalaSentry.logError */.GG.logError('Google One Tap failed', { error: error }); },
        onSuccess: function (_a) {
            var _b;
            var email = _a.email;
            (_b = events === null || events === void 0 ? void 0 : events.onSelected) === null || _b === void 0 ? void 0 : _b.call(events);
            authenticateByAuth0(session, environment, email).catch(function (error) {
                return esm/* LalaSentry.logError */.GG.logError('Auth0 authN failed', { error: error });
            });
        },
        googleAccountConfigs: googleAccountConfigs,
    });
}
//# sourceMappingURL=useGoogleOTIntegration.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/GoogleOTIntegration/index.js
var GoogleOTIntegration_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Copied from https://github.com/MSalmanTariq/react-google-one-tap-login


function GoogleOTIntegrationInternal(_a) {
    var _b = _a.children, children = _b === void 0 ? null : _b, props = GoogleOTIntegration_rest(_a, ["children"]);
    useGoogleOTIntegration(props);
    return children;
}
var GoogleOTIntegration = (0,react.memo)(GoogleOTIntegrationInternal);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../packages/lala-react/dist/esm/index.js















//# sourceMappingURL=index.js.map

/***/ }),

/***/ 82839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "or": function() { return /* reexport */ BYPASS_POSTCODE; },
  "H2": function() { return /* reexport */ Brand; },
  "TX": function() { return /* reexport */ CUSTOMER_REFERRAL_CODE; },
  "qA": function() { return /* reexport */ Environment; },
  "SM": function() { return /* reexport */ ErrorCodes; },
  "pY": function() { return /* reexport */ GenericError; },
  "Vf": function() { return /* reexport */ LG_APP_AUTH_SESSION_COOKIE_NAME; },
  "dA": function() { return /* reexport */ LOCAL_STORAGE_KEYS; },
  "GG": function() { return /* reexport */ LalaSentry; },
  "Gz": function() { return /* reexport */ PRL_BROKER_ID; },
  "E4": function() { return /* reexport */ PRL_CAMPAIGN_NAME; },
  "$I": function() { return /* reexport */ PRL_COMPANY_GEN; },
  "Rj": function() { return /* reexport */ PRL_STORE_ID; },
  "x7": function() { return /* reexport */ SAFETY_NET_COOKIE_NAME; },
  "sO": function() { return /* reexport */ SESSION_STORAGE_KEYS; },
  "sr": function() { return /* reexport */ SSOAccountMerge; },
  "OB": function() { return /* reexport */ STATE_STORAGE_KEY; },
  "YB": function() { return /* reexport */ SsoVerifyGeneric; },
  "Dy": function() { return /* reexport */ Type; },
  "zl": function() { return /* reexport */ WrongCode; },
  "ew": function() { return /* reexport */ executeReturnURL; },
  "K0": function() { return /* reexport */ getAPIBaseURL; },
  "KG": function() { return /* reexport */ getAudience; },
  "Y6": function() { return /* reexport */ getBrandFromHostname; },
  "kU": function() { return /* reexport */ getClientID; },
  "ge": function() { return /* reexport */ getDomain; },
  "dU": function() { return /* reexport */ getEnv; },
  "Uy": function() { return /* reexport */ getReturnURLFromQuery; },
  "aC": function() { return /* reexport */ getStateFromAuthResult; },
  "Fi": function() { return /* reexport */ getStateFromStorage; },
  "bT": function() { return /* reexport */ getTypeFromHostname; },
  "D$": function() { return /* reexport */ getURLs_getURLs; },
  "nx": function() { return /* reexport */ setReturnURLInStorage; },
  "Dt": function() { return /* reexport */ setStateInStorage; }
});

// UNUSED EXPORTS: AuthError, BlockedUser, DailyLimitError, EMPTY_RETURNURL, ErrorMessages, IDENTITY_TOKEN_AUTH_ID_KEY, IDENTITY_TOKEN_CONNECTION_KEY, IDENTITY_TOKEN_EXISTING_KEY, IDENTITY_TOKEN_PROFILE_KEY, IDENTITY_TOKEN_ROLE_KEY, IDENTITY_TOKEN_USER_ID_KEY, InvalidCountry, LegacyAuthMeError, NoAccessToken, NoExpiry, NoIdentityToken, NumberNotWorking, ParseStateError, PopupClosedError, RETURNURL_STORAGE_KEY, SMSGatewayError, STATE_STORAGE_VERSION, TooManyAttempts, checkNewTeamViewUrlEnabled, getReturnURLFromLALAURLQueries, getReturnURLFromStorage, isAuthenticatedState, isUnauthenticatedState, matchAuth0ErrorToLALAAuthError, matchPatterns, parseAuthError, parseStorageError, shorternReturnURL, validateReturnURL, validateReturnURLByMap

;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/Brand.js
var Brand;
(function (Brand) {
    Brand["Lendi"] = "lendi";
    Brand["Aussie"] = "aussie";
})(Brand || (Brand = {}));
//# sourceMappingURL=Brand.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/Type.js
var Type;
(function (Type) {
    Type["Customer"] = "customer";
    Type["Team"] = "team";
})(Type || (Type = {}));
//# sourceMappingURL=Type.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/Environment.js
var Environment;
(function (Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Preproduction"] = "preproduction";
    Environment["Production"] = "production";
})(Environment || (Environment = {}));
var getEnv = function (environment) {
    var env = environment || "production" || 0;
    switch (env) {
        case Environment.Development:
        case Environment.Staging:
        case Environment.Preproduction:
        case Environment.Production:
            return env;
        default:
            throw new Error("Invalid environment ".concat(env));
    }
};
var getAPIBaseURL = function (env) {
    switch (env) {
        case Environment.Development:
        default:
            return 'https://api.lendi-dev.net';
        case Environment.Production:
            return 'https://api.lendi.com.au';
        case Environment.Preproduction:
            return 'https://api.lendi-preprod.net';
        case Environment.Staging:
            return 'https://api.lendi-stg.net';
    }
};
//# sourceMappingURL=Environment.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/State.js
var STATE_STORAGE_KEY = 'lendi_auth';
var STATE_STORAGE_VERSION = '1';
//# sourceMappingURL=State.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/getTenant.js



function getTenant(brand, type, environment) {
    if (type === Type.Team) {
        // lendi-team cause we were too pushed for time to delete the old tenants and create new
        // tenants when we found that team members aren't split by brand
        return "lendi-team-".concat(environment, ".au.auth0.com");
    }
    if (type === Type.Customer && brand === Brand.Lendi) {
        switch (environment) {
            case Environment.Development:
                return "lala.lendi-dev.net";
            case Environment.Staging:
                return "lala.lendi-stg.net";
            case Environment.Preproduction:
                return "lala.lendi-preprod.net";
            case Environment.Production:
                return "lala.lendi.com.au";
        }
    }
    if (type === Type.Customer && brand === Brand.Aussie) {
        switch (environment) {
            case Environment.Development:
                return "lala.aussie-dev.com.au";
            case Environment.Staging:
                return "lala.aussie-stg.com.au";
            case Environment.Preproduction:
                return "lala.aussie-preprod.com.au";
            case Environment.Production:
                return "lala.aussie.com.au";
        }
    }
    return "".concat(brand, "-").concat(type, "-").concat(environment, ".au.auth0.com");
}
//# sourceMappingURL=getTenant.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/getDomain.js

function getDomain(brand, type, environment) {
    return getTenant(brand, type, environment);
}
//# sourceMappingURL=getDomain.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/getClientID.js



function getClientID(brand, type, environment) {
    if (type === Type.Team) {
        switch (environment) {
            // FIXME: reduce to one team tenant per environment instead of two
            // using `lendi-team-*` for now
            case Environment.Development:
                return 'IdtM2Iu7uhHWQNRMVB6vuaeSo0tRmkXe';
            case Environment.Staging:
                return '7VfZtkRmcNwkL5hLrr2JOz6ID09aQx5S';
            case Environment.Preproduction:
                return 'Q1kDu5GAx4xslZa9yCNg09Iu8KjbTqTb';
            case Environment.Production:
                return 'oVRWqJ9V6BjAKExYQEYHbmbHD9ey4BA7';
        }
    }
    if (brand === Brand.Lendi && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return '02HMKpY3DBWow93s4Liv4hOo7LBy5E0v';
            case Environment.Staging:
                return 'KX2f6VfN8m46kAmo2aeVJ6rp3ZSn8G6V';
            case Environment.Preproduction:
                return 'Wo0q6I3JX2gpgCW2ACNvi1z2Ua3YeLoW';
            case Environment.Production:
                return 'HRuDIzIv8Y0X5XNcCzN6xu0E84VkGS0z';
        }
    }
    if (brand === Brand.Aussie && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'BmMQl2jaxrMHr8S814STOl46RH75Bb5V';
            case Environment.Staging:
                return '8hO4kNgj4ejLlnh5PRooHQt6g0x88Cqe';
            case Environment.Preproduction:
                return 'YA3q6iku85NDdWOfUQXCOeuB0kD3q5qb';
            case Environment.Production:
                return '3Kb8uy7nsTawMVTviFmuBjSCkajs24GE';
        }
    }
    throw new Error("Unable to determine client ID for ".concat(brand, " ").concat(type, " ").concat(environment, "."));
}
//# sourceMappingURL=getClientID.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/getURLs.js

var checkNewTeamViewUrlEnabled = function () {
    if (typeof window !== 'undefined') {
        if (window.location.hostname && window.location.hostname.indexOf('lendigroup.com.au') !== -1) {
            return true;
        }
        return false;
    }
    return undefined;
};
function getBaseURL(brand, type, environment, lendiGroupTeamView) {
    if (typeof window !== 'undefined') {
        switch (window.location.hostname) {
            case 'www.lendi.com.au.local':
            case 'team.lendi.com.au.local':
            case 'team.aussie.com.au.local':
                return location.origin;
        }
        if (window.location.hostname && window.location.hostname.indexOf('test.lendi-dev.net') >= 0) {
            return location.origin;
        }
    }
    // We need this explicit check on lendigroup_tv cookie because getBaseURL is exposed to multiple consumers, so they might miss to pass this flag to support new TV url
    var lendiGroupTvEnabled = type === Type.Team && lendiGroupTeamView === undefined ? checkNewTeamViewUrlEnabled() : lendiGroupTeamView;
    if (brand === Brand.Lendi && type === Type.Team) {
        switch (environment) {
            case Environment.Development:
                return !lendiGroupTvEnabled ? 'https://team.lendi-dev.net' : 'https://lendi-team-dev.lendigroup.com.au';
            case Environment.Staging:
                return !lendiGroupTvEnabled ? 'https://team.lendi-stg.net' : 'https://lendi-team-stg.lendigroup.com.au';
            case Environment.Preproduction:
                return !lendiGroupTvEnabled ? 'https://team.lendi-preprod.net' : 'https://lendi-team-preprod.lendigroup.com.au';
            case Environment.Production:
                return !lendiGroupTvEnabled ? 'https://team.lendi.com.au' : 'https://lendi-team.lendigroup.com.au';
        }
    }
    if (brand === Brand.Aussie && type === Type.Team) {
        switch (environment) {
            case Environment.Development:
                return !lendiGroupTvEnabled ? 'https://team.aussie-dev.com.au' : 'https://aussie-team-dev.lendigroup.com.au';
            case Environment.Staging:
                return !lendiGroupTvEnabled ? 'https://team.aussie-stg.com.au' : 'https://aussie-team-stg.lendigroup.com.au';
            case Environment.Preproduction:
                return !lendiGroupTvEnabled
                    ? 'https://team.aussie-preprod.com.au'
                    : 'https://aussie-team-preprod.lendigroup.com.au';
            case Environment.Production:
                return !lendiGroupTvEnabled ? 'https://team.aussie.com.au' : 'https://aussie-team.lendigroup.com.au';
        }
    }
    if (brand === Brand.Lendi && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'https://www.lendi-dev.net';
            case Environment.Staging:
                return 'https://www.lendi-stg.net';
            case Environment.Preproduction:
                return 'https://www.lendi-preprod.net';
            case Environment.Production:
                return 'https://www.lendi.com.au';
        }
    }
    if (brand === Brand.Aussie && type === Type.Customer) {
        switch (environment) {
            case Environment.Development:
                return 'https://www.aussie-dev.com.au';
            case Environment.Staging:
                return 'https://www.aussie-stg.com.au';
            case Environment.Preproduction:
                return 'https://www.aussie-preprod.com.au';
            case Environment.Production:
                return 'https://www.aussie.com.au';
        }
    }
    throw new Error("Unable to determine URLs for ".concat(brand, " ").concat(type, " ").concat(environment));
}
function getURLs_getURLs(brand, type, environment, lendiGroupTeamView // optional and required to pass only in case of TV else we can ignore to pass
) {
    var baseURL = getBaseURL(brand, type, environment, lendiGroupTeamView);
    var unauthBaseURL = baseURL;
    var authBaseURL = baseURL;
    if (type === Type.Team) {
        return {
            origin: "".concat(baseURL, "/"),
            authenticate: "".concat(baseURL, "/sign-in/"),
            register: '',
            authenticated: "".concat(baseURL, "/dashboard/applications"),
            unauthenticated: "".concat(baseURL, "/"),
            callback: "".concat(baseURL, "/sign-in/callback/"),
            popupCallback: "".concat(baseURL, "/sign-in/callback/popup/"),
            linkCustomer: "".concat(baseURL, "/sign-in/link-accounts/"),
        };
    }
    if (type === Type.Customer) {
        return {
            origin: "".concat(baseURL, "/"),
            authenticate: "".concat(baseURL, "/sign-in/"),
            register: "".concat(baseURL, "/sign-in/sign-up/"),
            authenticated: "".concat(authBaseURL),
            unauthenticated: "".concat(unauthBaseURL, "/"),
            callback: "".concat(baseURL, "/sign-in/callback/"),
            popupCallback: "".concat(baseURL, "/sign-in/callback/popup/"),
            linkCustomer: "".concat(baseURL, "/sign-in/link-accounts/"),
        };
    }
    throw new Error("Unable to determine URLs for ".concat(brand, " ").concat(type, " ").concat(environment));
}
//# sourceMappingURL=getURLs.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/AuthError.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["ACCESS_DENIED"] = "access_denied";
    ErrorCodes["TOO_MANY_ATTEMPTS"] = "too_many_attempts";
    ErrorCodes["BLOCKED_USER"] = "blocked_user";
    ErrorCodes["SMS_PROVIDER_ERROR"] = "sms_provider_error";
    ErrorCodes["GENERIC"] = "invalid";
    ErrorCodes["PARSE_STATE"] = "parse";
    ErrorCodes["POPUP_CLOSED"] = "popup_closed";
    ErrorCodes["NUMBER_NOT_WORKING"] = "number_not_working";
    ErrorCodes["SSO_VERIFY_GENERIC"] = "sso_verify_generic";
    ErrorCodes["SSO_ACCOUNT_MERGE"] = "sso_account_merge";
    ErrorCodes["UNAUTHORIZED"] = "unauthorized";
    ErrorCodes["INVALID_COUNTRY"] = "invalid_country";
})(ErrorCodes || (ErrorCodes = {}));
var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["WRONG_CODE"] = "One-time passcode incorrect, please try again.";
    ErrorMessages["TOO_MANY_ATTEMPTS"] = "Sorry, your account has been locked following multiple failed login attempts.";
    ErrorMessages["SUSPICIOUS_LOGIN"] = "Sorry, you have been blocked from logging in because we detected suspicious login behaviour.";
    ErrorMessages["GENERIC"] = "Please try again, something went wrong.";
    ErrorMessages["BLOCKED_USER"] = "Sorry, you may be blocked from logging in.";
    ErrorMessages["NO_ACCESS_TOKEN"] = "An access token was not received from the identity provider.";
    ErrorMessages["NO_EXPIRY"] = "The access token did not have an expiry date.";
    ErrorMessages["NO_IDENTITY_TOKEN"] = "An identity token was not received from the identity provider.";
    ErrorMessages["PARSE_STATE"] = "An error occured while parsing the authentication state.";
    ErrorMessages["NUMBER_NOT_WORKING"] = "The provided number is not working, please check again.";
    ErrorMessages["SMS_GATEWAY_ERROR"] = "Unexpected response while calling the SMS gateway, try after sometime.";
    ErrorMessages["POPUP_CLOSED"] = "The popup window has been closed.";
    ErrorMessages["SSO_VERIFY_GENERIC"] = "Something went wrong with the social sign in verification";
    ErrorMessages["SSO_ACCOUNT_MERGE"] = "Something went wrong while merging accounts";
    ErrorMessages["INVALID_COUNTRY"] = "Non-AU customer self-sign-up is not allowed!";
    ErrorMessages["DAILY_LIMIT_ERROR"] = "Account exceeded the daily messages limit";
})(ErrorMessages || (ErrorMessages = {}));
var AuthError = /** @class */ (function () {
    function AuthError(code, description, contactUs) {
        this._code = code || ErrorCodes.GENERIC;
        this._description = description || ErrorMessages.GENERIC;
        this._contactUs = typeof contactUs === 'undefined' ? false : contactUs;
    }
    Object.defineProperty(AuthError.prototype, "code", {
        get: function () {
            return this._code;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthError.prototype, "description", {
        get: function () {
            return this._description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AuthError.prototype, "contactUs", {
        get: function () {
            return this._contactUs;
        },
        enumerable: false,
        configurable: true
    });
    return AuthError;
}());

var WrongCode = /** @class */ (function (_super) {
    __extends(WrongCode, _super);
    function WrongCode() {
        return _super.call(this, ErrorCodes.ACCESS_DENIED, ErrorMessages.WRONG_CODE) || this;
    }
    return WrongCode;
}(AuthError));

var TooManyAttempts = /** @class */ (function (_super) {
    __extends(TooManyAttempts, _super);
    function TooManyAttempts() {
        return _super.call(this, ErrorCodes.TOO_MANY_ATTEMPTS, ErrorMessages.TOO_MANY_ATTEMPTS) || this;
    }
    return TooManyAttempts;
}(AuthError));

var BlockedUser = /** @class */ (function (_super) {
    __extends(BlockedUser, _super);
    function BlockedUser() {
        return _super.call(this, ErrorCodes.BLOCKED_USER, ErrorMessages.BLOCKED_USER, true) || this;
    }
    return BlockedUser;
}(AuthError));

var NumberNotWorking = /** @class */ (function (_super) {
    __extends(NumberNotWorking, _super);
    function NumberNotWorking() {
        return _super.call(this, ErrorCodes.NUMBER_NOT_WORKING, ErrorMessages.NUMBER_NOT_WORKING) || this;
    }
    return NumberNotWorking;
}(AuthError));

var SMSGatewayError = /** @class */ (function (_super) {
    __extends(SMSGatewayError, _super);
    function SMSGatewayError() {
        return _super.call(this, ErrorCodes.SMS_PROVIDER_ERROR, ErrorMessages.SMS_GATEWAY_ERROR) || this;
    }
    return SMSGatewayError;
}(AuthError));

var DailyLimitError = /** @class */ (function (_super) {
    __extends(DailyLimitError, _super);
    function DailyLimitError() {
        return _super.call(this, ErrorCodes.SMS_PROVIDER_ERROR, ErrorMessages.DAILY_LIMIT_ERROR) || this;
    }
    return DailyLimitError;
}(AuthError));

var NoAccessToken = /** @class */ (function (_super) {
    __extends(NoAccessToken, _super);
    function NoAccessToken() {
        return _super.call(this, ErrorCodes.GENERIC, ErrorMessages.NO_ACCESS_TOKEN) || this;
    }
    return NoAccessToken;
}(AuthError));

var NoExpiry = /** @class */ (function (_super) {
    __extends(NoExpiry, _super);
    function NoExpiry() {
        return _super.call(this, ErrorCodes.GENERIC, ErrorMessages.NO_EXPIRY) || this;
    }
    return NoExpiry;
}(AuthError));

var NoIdentityToken = /** @class */ (function (_super) {
    __extends(NoIdentityToken, _super);
    function NoIdentityToken() {
        return _super.call(this, ErrorCodes.GENERIC, ErrorMessages.NO_IDENTITY_TOKEN) || this;
    }
    return NoIdentityToken;
}(AuthError));

var GenericError = /** @class */ (function (_super) {
    __extends(GenericError, _super);
    function GenericError() {
        return _super.call(this, ErrorCodes.GENERIC, ErrorMessages.GENERIC, true) || this;
    }
    return GenericError;
}(AuthError));

var ParseStateError = /** @class */ (function (_super) {
    __extends(ParseStateError, _super);
    function ParseStateError() {
        return _super.call(this, ErrorCodes.PARSE_STATE, ErrorMessages.PARSE_STATE) || this;
    }
    return ParseStateError;
}(AuthError));

var PopupClosedError = /** @class */ (function (_super) {
    __extends(PopupClosedError, _super);
    function PopupClosedError() {
        return _super.call(this, ErrorCodes.POPUP_CLOSED, ErrorMessages.POPUP_CLOSED) || this;
    }
    return PopupClosedError;
}(AuthError));

var SsoVerifyGeneric = /** @class */ (function (_super) {
    __extends(SsoVerifyGeneric, _super);
    function SsoVerifyGeneric() {
        return _super.call(this, ErrorCodes.SSO_VERIFY_GENERIC, ErrorMessages.SSO_VERIFY_GENERIC) || this;
    }
    return SsoVerifyGeneric;
}(AuthError));

var SSOAccountMerge = /** @class */ (function (_super) {
    __extends(SSOAccountMerge, _super);
    function SSOAccountMerge() {
        return _super.call(this, ErrorCodes.SSO_ACCOUNT_MERGE, ErrorMessages.SSO_ACCOUNT_MERGE) || this;
    }
    return SSOAccountMerge;
}(AuthError));

var InvalidCountry = /** @class */ (function (_super) {
    __extends(InvalidCountry, _super);
    function InvalidCountry() {
        return _super.call(this, ErrorCodes.INVALID_COUNTRY, ErrorMessages.INVALID_COUNTRY) || this;
    }
    return InvalidCountry;
}(AuthError));

//# sourceMappingURL=AuthError.js.map
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-rum/esm/entries/main.js + 108 modules
var main = __webpack_require__(66715);
// EXTERNAL MODULE: ../../../node_modules/@datadog/browser-logs/esm/index.js + 24 modules
var esm = __webpack_require__(45142);
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/Sentry.js
var Sentry_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var rumOptions = {
    applicationId: "a64100b3-87a7-479c-962a-bf16197efb0f" || 0,
    clientToken: "pub7cc4fc74825700ff94e7c47696f5cd54" || 0,
    site: 'datadoghq.com',
    service: 'LALA',
    sampleRate: 100,
    resourceSampleRate: 100,
    env: "production",
    version: "LALA-6163",
    trackInteractions: true,
};
var logsOptions = {
    clientToken: "pub7cc4fc74825700ff94e7c47696f5cd54" || 0,
    site: 'datadoghq.com',
    service: 'LALA',
    forwardErrorsToLogs: true,
    sampleRate: 100,
    version: "LALA-6163",
    env: "production",
    defaultPrivacyLevel: main/* DefaultPrivacyLevel.MASK */.J.MASK,
};
var LegacyAuthMeError = /** @class */ (function (_super) {
    Sentry_extends(LegacyAuthMeError, _super);
    function LegacyAuthMeError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LegacyAuthMeError;
}(Error));

var logger;
var LalaSentry = {
    configureUserContext: function (userCxt) {
        main/* datadogRum.setUser */.v.setUser({ username: userCxt.phoneNumber });
        main/* datadogRum.addAction */.v.addAction('Updated User Context');
    },
    init: function () {
        if (!logger) {
            main/* datadogRum.init */.v.init(rumOptions);
            main/* datadogRum.addAction */.v.addAction('Initialized Rum client');
            esm/* datadogLogs.init */.fy.init(logsOptions);
            logger = esm/* datadogLogs.createLogger */.fy.createLogger('lalaSentryLogger');
        }
    },
    captureException: function (error, errorTag, errorInfo) {
        main/* datadogRum.addError */.v.addError(error, __assign(__assign({}, errorInfo), { errorTag: errorTag }));
    },
    logToSentry: function (message, event) {
        console.log(message, { event: event, loggerInitialized: !!logger, level: 'Info', oldLog: true }); // tslint:disable-line no-console
        if (logger)
            logger.info(message, { event: event });
    },
    logInfo: function (message, tags) {
        console.log(message, __assign(__assign({}, tags), { loggerInitialized: !!logger, level: 'Info' })); // tslint:disable-line no-console
        if (logger)
            logger.info(message, __assign({}, (tags !== null && tags !== void 0 ? tags : {})));
    },
    logWarn: function (message, tags) {
        console.log(message, __assign(__assign({}, tags), { loggerInitialized: !!logger, level: 'warn' })); // tslint:disable-line no-console
        if (logger)
            logger.warn(message, __assign({}, (tags !== null && tags !== void 0 ? tags : {})));
    },
    logError: function (message, tags) {
        console.log(message, __assign(__assign({}, tags), { loggerInitialized: !!logger, level: 'error' })); // tslint:disable-line no-console
        if (logger)
            logger.error(message, __assign({}, (tags !== null && tags !== void 0 ? tags : {})));
    },
};
//# sourceMappingURL=Sentry.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/AuthErrorUtils.js


var matchPatterns;
(function (matchPatterns) {
    matchPatterns["WRONG_CODE"] = "verification code";
    matchPatterns["TOO_MANY_ATTEMPTS"] = "attempts";
    matchPatterns["BLOCKED_USER"] = "blocked";
    matchPatterns["NUMBER_NOT_WORKING"] = "not a valid phone";
    matchPatterns["SMS_GATEWAY_NOT_WORKING"] = "unexpected response";
    matchPatterns["POPUP_CLOSED"] = "User closed the popup window";
    matchPatterns["INVALID_COUNTRY"] = "non-allowed country";
    matchPatterns["EXCEEDED_DAILY_LIMIT"] = "exceeded the null daily messages limit";
})(matchPatterns || (matchPatterns = {}));
var matchAuth0ErrorToLALAAuthError = function (code, description) {
    if (code === ErrorCodes.ACCESS_DENIED && description.toLowerCase().includes(matchPatterns.WRONG_CODE)) {
        return new WrongCode();
    }
    if (code === ErrorCodes.ACCESS_DENIED && description.toLowerCase().includes(matchPatterns.TOO_MANY_ATTEMPTS)) {
        return new TooManyAttempts();
    }
    if (code === ErrorCodes.BLOCKED_USER && description.toLowerCase().includes(matchPatterns.BLOCKED_USER)) {
        return new BlockedUser();
    }
    if (code === ErrorCodes.SMS_PROVIDER_ERROR && description.toLowerCase().includes(matchPatterns.NUMBER_NOT_WORKING)) {
        return new NumberNotWorking();
    }
    if (code === ErrorCodes.UNAUTHORIZED && description.toLowerCase().includes(matchPatterns.INVALID_COUNTRY)) {
        return new InvalidCountry();
    }
    if (code === ErrorCodes.SMS_PROVIDER_ERROR &&
        description.toLowerCase().includes(matchPatterns.SMS_GATEWAY_NOT_WORKING)) {
        return new SMSGatewayError();
    }
    if (code === ErrorCodes.SMS_PROVIDER_ERROR &&
        description.toLowerCase().includes(matchPatterns.EXCEEDED_DAILY_LIMIT)) {
        return new DailyLimitError();
    }
    return new GenericError();
};
var parseAuthError = function (auth0Error) {
    var code = auth0Error.code, description = auth0Error.description, original = auth0Error.original;
    LalaSentry.logError('Auth failed', { auth0Error: auth0Error });
    if (original === matchPatterns.POPUP_CLOSED) {
        return { error: new PopupClosedError() };
    }
    var errCode = code ? code : ErrorCodes.GENERIC;
    var error = description ? matchAuth0ErrorToLALAAuthError(errCode, description) : new GenericError();
    return {
        error: error,
    };
};
var parseStorageError = function (_a) {
    var _code = _a._code, _description = _a._description, _contactUs = _a._contactUs;
    return new AuthError(_code, _description, _contactUs);
};
//# sourceMappingURL=AuthErrorUtils.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/consts.js
var NAMESPACE = "https://lendi";
var IDENTITY_TOKEN_USER_ID_KEY = "".concat(NAMESPACE, "/userId");
var IDENTITY_TOKEN_ROLE_KEY = "".concat(NAMESPACE, "/userRole");
var IDENTITY_TOKEN_PROFILE_KEY = "".concat(NAMESPACE, "/userProfile");
var IDENTITY_TOKEN_EXISTING_KEY = "".concat(NAMESPACE, "/existingUser");
var IDENTITY_TOKEN_AUTH_ID_KEY = "".concat(NAMESPACE, "/authId");
var IDENTITY_TOKEN_CONNECTION_KEY = "".concat(NAMESPACE, "/connection");
var consts_RETURNURL_STORAGE_KEY = 'lendi_auth:return_url';
var SAFETY_NET_COOKIE_NAME = 'safetynet';
var LG_APP_AUTH_SESSION_COOKIE_NAME = 'authsession';
var BYPASS_POSTCODE = 'bypass_postcode';
var PRL_STORE_ID = 'prl_storeid';
var PRL_BROKER_ID = 'prl_brokerid';
var CUSTOMER_REFERRAL_CODE = 'customer_refcode';
var PRL_COMPANY_GEN = 'prl_company_gen';
var PRL_CAMPAIGN_NAME = 'prl_campaign_name';
var LOCAL_STORAGE_KEYS = {
    COTR_PROMPT_DATA: 'cotr_prompt_data',
};
var SESSION_STORAGE_KEYS = {
    CTOR_TARGET_STORE_ID: 'target-storeid',
    CTOR_TARGET_BROKER_ID: 'target-brokerid',
    CTOR_REQUESTED_STORE_ID: 'requested-storeid',
    CTOR_REQUESTED_BROKER_ID: 'requested-brokerid',
};
//# sourceMappingURL=consts.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/getStateFromAuthResult.js



function getStateFromAuthResult(error, result) {
    if (result) {
        if (!result.accessToken) {
            return {
                error: new NoAccessToken(),
            };
        }
        var accessToken = result.accessToken;
        if (!result.expiresIn) {
            return {
                error: new NoExpiry(),
            };
        }
        var expiry = Date.now() + result.expiresIn * 1000;
        if (!result.idTokenPayload) {
            return {
                error: new NoIdentityToken(),
            };
        }
        var userID = result.idTokenPayload[IDENTITY_TOKEN_USER_ID_KEY];
        var role = result.idTokenPayload[IDENTITY_TOKEN_ROLE_KEY];
        var profile = result.idTokenPayload[IDENTITY_TOKEN_PROFILE_KEY];
        var authId = result.idTokenPayload[IDENTITY_TOKEN_AUTH_ID_KEY];
        var existingUser = result.idTokenPayload[IDENTITY_TOKEN_EXISTING_KEY];
        var connection = result.idTokenPayload[IDENTITY_TOKEN_CONNECTION_KEY];
        return {
            token: accessToken,
            expiry: expiry,
            identity: {
                id: userID,
                role: role,
                profile: profile,
                existingUser: existingUser,
                authId: authId,
                connection: connection,
            },
        };
    }
    else if (error) {
        return parseAuthError(error);
    }
    else {
        throw new Error('Please call getStateFromAuthResult() with either an error or a result.');
    }
}
//# sourceMappingURL=getStateFromAuthResult.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/getStateFromStorage.js



function getStateFromStorage() {
    if (typeof sessionStorage === 'undefined') {
        return;
    }
    var value = sessionStorage.getItem(STATE_STORAGE_KEY);
    if (!value) {
        return undefined;
    }
    try {
        var json = JSON.parse(value);
        // if we don't have an object then wtf do we have
        if (typeof json !== 'object') {
            return { error: new ParseStateError() };
        }
        // make sure the object is compatible with this version of the parser
        if (!json.v || json.v !== STATE_STORAGE_VERSION) {
            return undefined;
        }
        delete json.v;
        // parse the authError from storage
        if (json.error) {
            json.error = parseStorageError(json.error);
        }
        return json;
    }
    catch (error) {
        return { error: new ParseStateError() };
    }
}
//# sourceMappingURL=getStateFromStorage.js.map
// EXTERNAL MODULE: ../../../node_modules/broadcast-channel/dist/esbrowser/broadcast-channel.js + 8 modules
var broadcast_channel = __webpack_require__(75280);
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/setStateInStorage.js
var setStateInStorage_assign = (undefined && undefined.__assign) || function () {
    setStateInStorage_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return setStateInStorage_assign.apply(this, arguments);
};



function isAuthenticatedState(state) {
    return state.token !== undefined;
}
function isUnauthenticatedState(state) {
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return state === undefined;
}
function setStateInStorage(state, broadcast) {
    var _a, _b, _c;
    if (broadcast === void 0) { broadcast = true; }
    LalaSentry.logInfo('setStateInStorage...', { userId: (_a = state === null || state === void 0 ? void 0 : state.identity) === null || _a === void 0 ? void 0 : _a.id });
    if (typeof sessionStorage === 'undefined') {
        return;
    }
    /**
     * If the environment is test then we use simulate type so that our tests do not break
     * as referenced here: https://github.com/pubkey/broadcast-channel/issues/8
     * using simulate is documented here: https://github.com/pubkey/broadcast-channel#methods
     */
    var lalaChannel = new broadcast_channel/* BroadcastChannel */.g0('lala', setStateInStorage_assign({}, ( false && 0)));
    var setStorage = function (session) {
        return sessionStorage.setItem(STATE_STORAGE_KEY, JSON.stringify(setStateInStorage_assign({ v: STATE_STORAGE_VERSION }, session)));
    };
    if (isUnauthenticatedState(state)) {
        LalaSentry.logInfo('Removing state from sessionStorage...', { userId: (_b = state === null || state === void 0 ? void 0 : state.identity) === null || _b === void 0 ? void 0 : _b.id });
        sessionStorage.removeItem(STATE_STORAGE_KEY);
    }
    else {
        if (isAuthenticatedState(state)) {
            // this if block is temporary measure to cater for removal of legacy token
            // as soon as all consumers of lala-react upgraded to v12+
            // , this could be removed
            localStorage.setItem('token', 'random-value');
        }
        LalaSentry.logInfo('Setting state to sessionStorage...', { userId: (_c = state === null || state === void 0 ? void 0 : state.identity) === null || _c === void 0 ? void 0 : _c.id });
        setStorage(state);
    }
    if (broadcast) {
        lalaChannel.postMessage(state).catch(function (error) { return LalaSentry.captureException(error, 'setStateInStorageBroadcast'); });
    }
    // tslint:disable-next-line: no-floating-promises
    lalaChannel.close();
}
//# sourceMappingURL=setStateInStorage.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/getAudience.js

function getAudience(environment) {
    switch (environment) {
        case Environment.Staging: {
            return 'https://api.lendi-stg.net/';
        }
        case Environment.Preproduction: {
            return 'https://api.lendi-preprod.net/';
        }
        case Environment.Production: {
            return 'https://api.lendi.com.au/';
        }
        case Environment.Development:
        default: {
            return 'https://api.lendi-dev.net/';
        }
    }
}
//# sourceMappingURL=getAudience.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/getReturnURLFromStorage.js

var EMPTY_RETURNURL = '{ "queries": {} }';
function getReturnURLFromStorage() {
    return JSON.parse(sessionStorage.getItem(RETURNURL_STORAGE_KEY) || EMPTY_RETURNURL);
}
//# sourceMappingURL=getReturnURLFromStorage.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/setReturnURLInStorage.js

function setReturnURLInStorage(url) {
    if (url) {
        sessionStorage.setItem(consts_RETURNURL_STORAGE_KEY, JSON.stringify(url));
    }
    else {
        sessionStorage.removeItem(consts_RETURNURL_STORAGE_KEY);
    }
}
//# sourceMappingURL=setReturnURLInStorage.js.map
// EXTERNAL MODULE: ../../../node_modules/querystring/index.js
var querystring = __webpack_require__(67526);
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/getReturnURLQueryString.js
var getReturnURLQueryString_assign = (undefined && undefined.__assign) || function () {
    getReturnURLQueryString_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return getReturnURLQueryString_assign.apply(this, arguments);
};


var getOtherQueryStrings = function (queries) {
    return Object.keys(queries)
        .filter(function (queryKey) { return queryKey !== 'returnURL'; })
        .reduce(function (obj, key) {
        var _a;
        var newObj = getReturnURLQueryString_assign(getReturnURLQueryString_assign({}, obj), (_a = {}, _a[key] = queries[key], _a));
        return newObj;
    }, {});
};
var generateReturnURL = function (redirectLinks) {
    if (!redirectLinks.length) {
        return '';
    }
    var returnURL = redirectLinks.pop();
    redirectLinks.reverse();
    redirectLinks.forEach(function (link, i) {
        if (returnURL.includes('?')) {
            returnURL = "".concat(link, "&returnURL=").concat(encodeURIComponent(returnURL));
        }
        else {
            returnURL = "".concat(link, "?returnURL=").concat(encodeURIComponent(returnURL));
        }
    });
    returnURL = "".concat(decodeURI(returnURL));
    return returnURL;
};
var shorternReturnURL = function (returnURL) {
    // IM-422 redirect to the homepage
    if (returnURL.length > 1000) {
        if (returnURL.includes('applicationidplaceholder')) {
            return '/home-loans/basics/landing/?returnURL=/home-loans/basics/application/applicationidplaceholder/ctp/';
        }
        return '/dashboard';
    }
    return returnURL;
};
var getReturnURLFromQuery = function () {
    if (typeof window === 'undefined') {
        return { returnURL: undefined, queries: {} };
    }
    var searchQueries = window.location.search.replace(/\?/, '');
    var parsedQueries = querystring.parse(searchQueries);
    if (parsedQueries) {
        var otherQueries = getOtherQueryStrings(parsedQueries);
        if (parsedQueries.returnURL) {
            var returnURLInQuery = parsedQueries.returnURL;
            if (Array.isArray(returnURLInQuery)) {
                var returnURLArrayString = generateReturnURL(returnURLInQuery);
                LalaSentry.logToSentry('Multiple Return Urls found', returnURLArrayString);
                return { returnURL: shorternReturnURL(returnURLArrayString), queries: otherQueries };
            }
            else {
                return { returnURL: shorternReturnURL(returnURLInQuery), queries: otherQueries };
            }
        }
        return { returnURL: undefined, queries: otherQueries };
    }
    return { returnURL: undefined, queries: {} };
};
//# sourceMappingURL=getReturnURLQueryString.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/validateReturnURL.js

var validateReturnURL = function (brand, type, env, returnURL) {
    var returnURLs = getURLs(brand, type, env);
    return validateReturnURLByMap(returnURLs, returnURL);
};
var validateReturnURLByMap = function (returnURLs, returnURL) {
    return ((returnURL.startsWith(returnURLs.origin) || returnURL.startsWith('/')) &&
        !returnURL.startsWith(returnURLs.origin + '/') &&
        !returnURL.startsWith('//'));
};
//# sourceMappingURL=validateReturnURL.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/executeReturnURL.js
/// <reference types="node"/>



var generateReturnURLHOF = function (returnURLs) { return function (urlQueries) {
    var stringQueries = querystring.stringify(urlQueries.queries);
    var returnUrlParam = urlQueries.returnURL || '';
    var returnURL = validateReturnURLByMap(returnURLs, returnUrlParam) ? returnUrlParam : returnURLs.authenticated;
    if (stringQueries === '')
        return returnURL;
    if (returnURL.includes('?'))
        return "".concat(returnURL, "&").concat(stringQueries);
    return "".concat(returnURL, "?").concat(stringQueries);
}; };
var getReturnURLFromLALAURLQueries = function (brand, type, env, returnURL, lendiGroupTeamView) {
    var returnURLs = getURLs_getURLs(brand, type, env, lendiGroupTeamView);
    var generateReturnURL = generateReturnURLHOF(returnURLs);
    return generateReturnURL(returnURL);
};
var executeReturnURL = function (brand, type, env, returnURL, lendiGroupTeamView) {
    var returnUrl = getReturnURLFromLALAURLQueries(brand, type, env, returnURL, lendiGroupTeamView);
    LalaSentry.logInfo('redirect by executeReturnURL', { returnUrl: returnUrl });
    window.location.assign(returnUrl);
};
//# sourceMappingURL=executeReturnURL.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/getBrandFromHostname.js

function getBrandFromHostname() {
    if (typeof window === 'undefined')
        return Brand.Lendi;
    var hostname = window.location.hostname;
    // lendi customer
    if (hostname === 'www.lendi.com.au' ||
        hostname === 'www.lendi-preprod.net' ||
        hostname === 'www.lendi-stg.net' ||
        hostname === 'www.lendi-dev.net') {
        return Brand.Lendi;
    }
    // aussie customer
    if (hostname === 'www.aussie.com.au' ||
        hostname === 'www.aussie-preprod.com.au' ||
        hostname === 'www.aussie-dev.com.au' ||
        hostname === 'www.aussie-stg.com.au' ||
        hostname === 'www.aussie-dev.com.au.local') {
        return Brand.Aussie;
    }
    // aussie team
    if (hostname === 'team.aussie.com.au' ||
        hostname === 'team.aussie-preprod.com.au' ||
        hostname === 'team.aussie-dev.com.au' ||
        hostname === 'team.aussie-stg.com.au' ||
        hostname === 'team.aussie-dev.com.au.local' ||
        hostname === 'aussie-team-dev.lendigroup.com.au' ||
        hostname === 'aussie-team-stg.lendigroup.com.au' ||
        hostname === 'aussie-team-preprod.lendigroup.com.au' ||
        hostname === 'aussie-team.lendigroup.com.au' ||
        hostname === 'tools.aussie-dev.com.au' ||
        hostname === 'tools.aussie-stg.com.au' ||
        hostname === 'tools.aussie-preprod.com.au' ||
        hostname === 'tools.aussie.com.au') {
        return Brand.Aussie;
    }
    // default to customer
    return Brand.Lendi;
}
//# sourceMappingURL=getBrandFromHostname.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/getTypeFromHostname.js

function getTypeFromHostname() {
    var hostname = window.location.hostname;
    var hostNameRegex = new RegExp('team');
    /*
      hostname === 'team.lendi.com.au' ||
      hostname === 'team.lendi-stg.net' ||
      hostname === 'team.lendi-preprod.net' ||
      hostname === 'team.lendi-dev.net' ||
      hostname === 'team.aussie.com.au' ||
      hostname === 'team.aussie-stg.com.au' ||
      hostname === 'team.aussie-preprod.com.au' ||
      hostname === 'team.aussie-dev.com.au' ||
    */
    // team
    if (hostNameRegex.test(hostname) || hostname.startsWith('tools.')) {
        return Type.Team;
    }
    // lendi customer
    if (hostname === 'www.lendi.com.au' ||
        hostname === 'www.lendi-stg.net' ||
        hostname === 'www.lendi-dev.net' ||
        hostname === 'www.lendi-preprod.net') {
        return Type.Customer;
    }
    // aussie customer
    if (hostname === 'www.aussie.com.au' ||
        hostname === 'www.aussie-stg.com.au' ||
        hostname === 'www.aussie-dev.com.au' ||
        hostname === 'www.aussie-preprod.com.au') {
        return Type.Customer;
    }
    // default to customer
    return Type.Customer;
}
//# sourceMappingURL=getTypeFromHostname.js.map
;// CONCATENATED MODULE: ../../../packages/lala-utils/dist/esm/index.js






















//# sourceMappingURL=index.js.map

/***/ }),

/***/ 45503:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 39649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(8114)["default"]);
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 8114:
/***/ (function(module) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 72975:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(39649)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 23206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var possibleNames = [
	'BigInt64Array',
	'BigUint64Array',
	'Float32Array',
	'Float64Array',
	'Int16Array',
	'Int32Array',
	'Int8Array',
	'Uint16Array',
	'Uint32Array',
	'Uint8Array',
	'Uint8ClampedArray'
];

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;

module.exports = function availableTypedArrays() {
	var out = [];
	for (var i = 0; i < possibleNames.length; i++) {
		if (typeof g[possibleNames[i]] === 'function') {
			out[out.length] = possibleNames[i];
		}
	}
	return out;
};


/***/ }),

/***/ 73607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(13158);


/* eslint global-require: 0 */
// the code is structured this way so that bundlers can
// alias out `has-symbols` to `() => true` or `() => false` if your target
// environments' Symbol capabilities are known, and then use
// dead code elimination on the rest of this module.
//
// Similarly, `isarray` can be aliased to `Array.isArray` if
// available in all target environments.

var isArguments = __webpack_require__(14043);
var getStopIterationIterator = __webpack_require__(52719);

if (__webpack_require__(10465)() || __webpack_require__(16073)()) {
	var $iterator = Symbol.iterator;
	// Symbol is available natively or shammed
	// natively:
	//  - Chrome >= 38
	//  - Edge 12-14?, Edge >= 15 for sure
	//  - FF >= 36
	//  - Safari >= 9
	//  - node >= 0.12
	module.exports = function getIterator(iterable) {
		// alternatively, `iterable[$iterator]?.()`
		if (iterable != null && typeof iterable[$iterator] !== 'undefined') {
			return iterable[$iterator]();
		}
		if (isArguments(iterable)) {
			// arguments objects lack Symbol.iterator
			// - node 0.12
			return Array.prototype[$iterator].call(iterable);
		}
	};
} else {
	// Symbol is not available, native or shammed
	var isArray = __webpack_require__(79930);
	var isString = __webpack_require__(91770);
	var GetIntrinsic = __webpack_require__(91528);
	var $Map = GetIntrinsic('%Map%', true);
	var $Set = GetIntrinsic('%Set%', true);
	var callBound = __webpack_require__(47737);
	var $arrayPush = callBound('Array.prototype.push');
	var $charCodeAt = callBound('String.prototype.charCodeAt');
	var $stringSlice = callBound('String.prototype.slice');

	var advanceStringIndex = function advanceStringIndex(S, index) {
		var length = S.length;
		if ((index + 1) >= length) {
			return index + 1;
		}

		var first = $charCodeAt(S, index);
		if (first < 0xD800 || first > 0xDBFF) {
			return index + 1;
		}

		var second = $charCodeAt(S, index + 1);
		if (second < 0xDC00 || second > 0xDFFF) {
			return index + 1;
		}

		return index + 2;
	};

	var getArrayIterator = function getArrayIterator(arraylike) {
		var i = 0;
		return {
			next: function next() {
				var done = i >= arraylike.length;
				var value;
				if (!done) {
					value = arraylike[i];
					i += 1;
				}
				return {
					done: done,
					value: value
				};
			}
		};
	};

	var getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
		if (isArray(iterable) || isArguments(iterable)) {
			return getArrayIterator(iterable);
		}
		if (isString(iterable)) {
			var i = 0;
			return {
				next: function next() {
					var nextIndex = advanceStringIndex(iterable, i);
					var value = $stringSlice(iterable, i, nextIndex);
					i = nextIndex;
					return {
						done: nextIndex > iterable.length,
						value: value
					};
				}
			};
		}

		// es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.
		if (noPrimordialCollections && typeof iterable['_es6-shim iterator_'] !== 'undefined') {
			return iterable['_es6-shim iterator_']();
		}
	};

	if (!$Map && !$Set) {
		// the only language iterables are Array, String, arguments
		// - Safari <= 6.0
		// - Chrome < 38
		// - node < 0.12
		// - FF < 13
		// - IE < 11
		// - Edge < 11

		module.exports = function getIterator(iterable) {
			if (iterable != null) {
				return getNonCollectionIterator(iterable, true);
			}
		};
	} else {
		// either Map or Set are available, but Symbol is not
		// - es6-shim on an ES5 browser
		// - Safari 6.2 (maybe 6.1?)
		// - FF v[13, 36)
		// - IE 11
		// - Edge 11
		// - Safari v[6, 9)

		var isMap = __webpack_require__(81859);
		var isSet = __webpack_require__(96109);

		// Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach
		var $mapForEach = callBound('Map.prototype.forEach', true);
		var $setForEach = callBound('Set.prototype.forEach', true);
		if (typeof process === 'undefined' || !process.versions || !process.versions.node) { // "if is not node"

			// Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
			// returns a value, or throws a StopIteration object. These browsers
			// do not have any other mechanism for iteration.
			var $mapIterator = callBound('Map.prototype.iterator', true);
			var $setIterator = callBound('Set.prototype.iterator', true);
		}
		// Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
		// this returns a proper iterator object, so we should use it instead of forEach.
		// newer es6-shim versions use a string "_es6-shim iterator_" property.
		var $mapAtAtIterator = callBound('Map.prototype.@@iterator', true) || callBound('Map.prototype._es6-shim iterator_', true);
		var $setAtAtIterator = callBound('Set.prototype.@@iterator', true) || callBound('Set.prototype._es6-shim iterator_', true);

		var getCollectionIterator = function getCollectionIterator(iterable) {
			if (isMap(iterable)) {
				if ($mapIterator) {
					return getStopIterationIterator($mapIterator(iterable));
				}
				if ($mapAtAtIterator) {
					return $mapAtAtIterator(iterable);
				}
				if ($mapForEach) {
					var entries = [];
					$mapForEach(iterable, function (v, k) {
						$arrayPush(entries, [k, v]);
					});
					return getArrayIterator(entries);
				}
			}
			if (isSet(iterable)) {
				if ($setIterator) {
					return getStopIterationIterator($setIterator(iterable));
				}
				if ($setAtAtIterator) {
					return $setAtAtIterator(iterable);
				}
				if ($setForEach) {
					var values = [];
					$setForEach(iterable, function (v) {
						$arrayPush(values, v);
					});
					return getArrayIterator(values);
				}
			}
		};

		module.exports = function getIterator(iterable) {
			return getCollectionIterator(iterable) || getNonCollectionIterator(iterable);
		};
	}
}


/***/ }),

/***/ 8121:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isMap = __webpack_require__(81859);
var isSet = __webpack_require__(96109);
var isWeakMap = __webpack_require__(36959);
var isWeakSet = __webpack_require__(92683);

module.exports = function whichCollection(value) {
	if (value && typeof value === 'object') {
		if (isMap(value)) {
			return 'Map';
		}
		if (isSet(value)) {
			return 'Set';
		}
		if (isWeakMap(value)) {
			return 'WeakMap';
		}
		if (isWeakSet(value)) {
			return 'WeakSet';
		}
	}
	return false;
};


/***/ }),

/***/ 88830:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_axios; }
});

// NAMESPACE OBJECT: ../node_modules/axios/lib/platform/common/utils.js
var common_utils_namespaceObject = {};
__webpack_require__.r(common_utils_namespaceObject);
__webpack_require__.d(common_utils_namespaceObject, {
  "hasBrowserEnv": function() { return hasBrowserEnv; },
  "hasStandardBrowserEnv": function() { return hasStandardBrowserEnv; },
  "hasStandardBrowserWebWorkerEnv": function() { return hasStandardBrowserWebWorkerEnv; }
});

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ../node_modules/axios/lib/utils.js




// utils is a library of generic helper functions non-specific to axios

const {toString: utils_toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = utils_toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

/* harmony default export */ var utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
});

;// CONCATENATED MODULE: ../node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ var core_AxiosError = (AxiosError);

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ var helpers_null = (null);

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(75291)["lW"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ var helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ../node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ var core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ../node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

;// CONCATENATED MODULE: ../node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ../node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

;// CONCATENATED MODULE: ../node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

;// CONCATENATED MODULE: ../node_modules/axios/lib/platform/browser/index.js




/* harmony default export */ var browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

;// CONCATENATED MODULE: ../node_modules/axios/lib/platform/common/utils.js
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = (
  (product) => {
    return hasBrowserEnv && ['ReactNative', 'NativeScript', 'NS'].indexOf(product) < 0
  })(typeof navigator !== 'undefined' && navigator.product);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();



;// CONCATENATED MODULE: ../node_modules/axios/lib/platform/index.js



/* harmony default export */ var platform = ({
  ...common_utils_namespaceObject,
  ...browser
});

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ../node_modules/axios/lib/defaults/index.js










/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

/* harmony default export */ var lib_defaults = (defaults);

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

;// CONCATENATED MODULE: ../node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils.freezeMethods(AxiosHeaders);

/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ../node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ../node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ../node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});

/* harmony default export */ var cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ../node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/cookies.js



/* harmony default export */ var cookies = (platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils.isString(path) && cookie.push('path=' + path);

      utils.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  });


;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ../node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/isURLSameOrigin.js





/* harmony default export */ var isURLSameOrigin = (platform.hasStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ../node_modules/axios/lib/adapters/xhr.js
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = core_AxiosHeaders.from(config.headers).normalize();
    let {responseType, withXSRFToken} = config;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    let contentType;

    if (utils.isFormData(requestData)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else if ((contentType = requestHeaders.getContentType()) !== false) {
        // fix semicolon duplication issue for ReactNative FormData implementation
        const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
        requestHeaders.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || defaults_transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if(platform.hasStandardBrowserEnv) {
      withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));

      if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(fullPath))) {
        // Add xsrf header
        const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

        if (xsrfValue) {
          requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

;// CONCATENATED MODULE: ../node_modules/axios/lib/adapters/adapters.js





const knownAdapters = {
  http: helpers_null,
  xhr: xhr
}

utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils.isFunction(adapter) || adapter === null || adapter === false;

/* harmony default export */ var adapters = ({
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new core_AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new core_AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
});

;// CONCATENATED MODULE: ../node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

;// CONCATENATED MODULE: ../node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? thing.toJSON() : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ../node_modules/axios/lib/env/data.js
const VERSION = "1.6.5";
;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var validator = ({
  assertOptions,
  validators
});

;// CONCATENATED MODULE: ../node_modules/axios/lib/core/Axios.js











const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ var core_Axios = (Axios);

;// CONCATENATED MODULE: ../node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ var cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

;// CONCATENATED MODULE: ../node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);

;// CONCATENATED MODULE: ../node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios);


/***/ }),

/***/ 8940:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_axios; }
});

// NAMESPACE OBJECT: ../../../node_modules/@lendi/chat/node_modules/axios/lib/platform/common/utils.js
var common_utils_namespaceObject = {};
__webpack_require__.r(common_utils_namespaceObject);
__webpack_require__.d(common_utils_namespaceObject, {
  "hasBrowserEnv": function() { return hasBrowserEnv; },
  "hasStandardBrowserEnv": function() { return hasStandardBrowserEnv; },
  "hasStandardBrowserWebWorkerEnv": function() { return hasStandardBrowserWebWorkerEnv; }
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/bind.js


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/utils.js




// utils is a library of generic helper functions non-specific to axios

const {toString: utils_toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = utils_toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

/* harmony default export */ var utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/core/AxiosError.js




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const AxiosError_prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(AxiosError_prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(AxiosError_prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ var core_AxiosError = (AxiosError);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ var helpers_null = (null);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(75291)["lW"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result = !(utils.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ var helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || buildURL_encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils.isURLSearchParams(params) ?
      params.toString() :
      new helpers_AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ var core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/platform/browser/index.js




/* harmony default export */ var browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/platform/common/utils.js
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = (
  (product) => {
    return hasBrowserEnv && ['ReactNative', 'NativeScript', 'NS'].indexOf(product) < 0
  })(typeof navigator !== 'undefined' && navigator.product);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();



;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/platform/index.js



/* harmony default export */ var platform = ({
  ...common_utils_namespaceObject,
  ...browser
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/defaults/index.js










/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: defaults_transitional,

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils.isObject(data);

    if (isObjectPayload && utils.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils.isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
    }

    if (utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return helpers_toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && utils.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

/* harmony default export */ var lib_defaults = (defaults);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/core/AxiosHeaders.js





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils.freezeMethods(AxiosHeaders);

/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/cancel/CanceledError.js





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  core_AxiosError.call(this, message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, core_AxiosError, {
  __CANCEL__: true
});

/* harmony default export */ var cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      [core_AxiosError.ERR_BAD_REQUEST, core_AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/cookies.js



/* harmony default export */ var cookies = (platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils.isString(path) && cookie.push('path=' + path);

      utils.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  });


;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/isURLSameOrigin.js





/* harmony default export */ var isURLSameOrigin = (platform.hasStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/adapters/xhr.js
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ var xhr = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = core_AxiosHeaders.from(config.headers).normalize();
    let {responseType, withXSRFToken} = config;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    let contentType;

    if (utils.isFormData(requestData)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false); // Let the browser set it
      } else if ((contentType = requestHeaders.getContentType()) !== false) {
        // fix semicolon duplication issue for ReactNative FormData implementation
        const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
        requestHeaders.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
      }
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = core_AxiosHeaders.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new core_AxiosError('Network Error', core_AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || defaults_transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new core_AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if(platform.hasStandardBrowserEnv) {
      withXSRFToken && utils.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));

      if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(fullPath))) {
        // Add xsrf header
        const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && cookies.read(config.xsrfCookieName);

        if (xsrfValue) {
          requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(fullPath);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new core_AxiosError('Unsupported protocol ' + protocol + ':', core_AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/adapters/adapters.js





const knownAdapters = {
  http: helpers_null,
  xhr: xhr
}

utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils.isFunction(adapter) || adapter === null || adapter === false;

/* harmony default export */ var adapters = ({
  getAdapter: (adapters) => {
    adapters = utils.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new core_AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new core_AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = core_AxiosHeaders.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => thing instanceof core_AxiosHeaders ? thing.toJSON() : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({caseless}, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  utils.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/env/data.js
const VERSION = "1.6.2";
;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError('option ' + opt + ' must be ' + result, core_AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var validator = ({
  assertOptions,
  validators
});

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/core/Axios.js











const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
        clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: Axios_validators.function,
          serialize: Axios_validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ var core_Axios = (Axios);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ var cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
}

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);

;// CONCATENATED MODULE: ../../../node_modules/@lendi/chat/node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = thing => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios);


/***/ }),

/***/ 29625:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v4": function() { return /* binding */ v4; }
/* harmony export */ });
var IDX=256, HEX=[], BUFFER;
while (IDX--) HEX[IDX] = (IDX + 256).toString(16).substring(1);

function v4() {
	var i=0, num, out='';

	if (!BUFFER || ((IDX + 16) > 256)) {
		BUFFER = Array(i=256);
		while (i--) BUFFER[i] = 256 * Math.random() | 0;
		i = IDX = 0;
	}

	for (; i < 16; i++) {
		num = BUFFER[IDX + i];
		if (i==6) out += HEX[num & 15 | 64];
		else if (i==8) out += HEX[num & 63 | 128];
		else out += HEX[num];

		if (i & 1 && i > 1 && i < 11) out += '-';
	}

	IDX++;
	return out;
}


/***/ }),

/***/ 44229:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 84872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 31268:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
// EXTERNAL MODULE: ../../../node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(39978);
;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0,_get_prototype_of/* default */.Z)(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0,_get_prototype_of/* default */.Z)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 23745:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 39978:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}

/***/ }),

/***/ 34650:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}


/***/ }),

/***/ 97939:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23745);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 70111:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 89799:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_array_like_to_array.mjs
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

;// CONCATENATED MODULE: ../../../node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArray(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 75280:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g0": function() { return /* binding */ broadcast_channel_BroadcastChannel; }
});

// UNUSED EXPORTS: OPEN_BROADCAST_CHANNELS, clearNodeFolder, enforceOptions

;// CONCATENATED MODULE: ../../../node_modules/broadcast-channel/dist/esbrowser/util.js
/**
 * returns true if the given object is a promise
 */
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}
var util_PROMISE_RESOLVED_FALSE = Promise.resolve(false);
var PROMISE_RESOLVED_TRUE = Promise.resolve(true);
var PROMISE_RESOLVED_VOID = Promise.resolve();
function sleep(time, resolveWith) {
  if (!time) time = 0;
  return new Promise(function (res) {
    return setTimeout(function () {
      return res(resolveWith);
    }, time);
  });
}
function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 * https://stackoverflow.com/a/8084248
 */
function randomToken() {
  return Math.random().toString(36).substring(2);
}
var lastMs = 0;
var additional = 0;

/**
 * returns the current time in micro-seconds,
 * WARNING: This is a pseudo-function
 * Performance.now is not reliable in webworkers, so we just make sure to never return the same time.
 * This is enough in browsers, and this function will not be used in nodejs.
 * The main reason for this hack is to ensure that BroadcastChannel behaves equal to production when it is used in fast-running unit tests.
 */
function microSeconds() {
  var ms = Date.now();
  if (ms === lastMs) {
    additional++;
    return ms * 1000 + additional;
  } else {
    lastMs = ms;
    additional = 0;
    return ms * 1000;
  }
}

/**
 * Check if WebLock API is supported.
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Locks_API
 */
function supportsWebLockAPI() {
  if (typeof navigator !== 'undefined' && typeof navigator.locks !== 'undefined' && typeof navigator.locks.request === 'function') {
    return true;
  } else {
    return false;
  }
}
;// CONCATENATED MODULE: ../../../node_modules/broadcast-channel/dist/esbrowser/methods/native.js

var native_microSeconds = microSeconds;
var type = 'native';
function create(channelName) {
  var state = {
    messagesCallback: null,
    bc: new BroadcastChannel(channelName),
    subFns: [] // subscriberFunctions
  };

  state.bc.onmessage = function (msg) {
    if (state.messagesCallback) {
      state.messagesCallback(msg.data);
    }
  };
  return state;
}
function native_close(channelState) {
  channelState.bc.close();
  channelState.subFns = [];
}
function postMessage(channelState, messageJson) {
  try {
    channelState.bc.postMessage(messageJson, false);
    return PROMISE_RESOLVED_VOID;
  } catch (err) {
    return Promise.reject(err);
  }
}
function onMessage(channelState, fn) {
  channelState.messagesCallback = fn;
}
function canBeUsed() {
  if ((typeof window !== 'undefined' || typeof self !== 'undefined') && typeof BroadcastChannel === 'function') {
    if (BroadcastChannel._pubkey) {
      throw new Error('BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill');
    }
    return true;
  } else {
    return false;
  }
}
function averageResponseTime() {
  return 150;
}
var NativeMethod = {
  create: create,
  close: native_close,
  onMessage: onMessage,
  postMessage: postMessage,
  canBeUsed: canBeUsed,
  type: type,
  averageResponseTime: averageResponseTime,
  microSeconds: native_microSeconds
};
;// CONCATENATED MODULE: ../../../node_modules/oblivious-set/dist/es/index.js
/**
 * this is a set which automatically forgets
 * a given entry when a new entry is set and the ttl
 * of the old one is over
 */
var ObliviousSet = /** @class */ (function () {
    function ObliviousSet(ttl) {
        this.ttl = ttl;
        this.map = new Map();
        /**
         * Creating calls to setTimeout() is expensive,
         * so we only do that if there is not timeout already open.
         */
        this._to = false;
    }
    ObliviousSet.prototype.has = function (value) {
        return this.map.has(value);
    };
    ObliviousSet.prototype.add = function (value) {
        var _this = this;
        this.map.set(value, now());
        /**
         * When a new value is added,
         * start the cleanup at the next tick
         * to not block the cpu for more important stuff
         * that might happen.
         */
        if (!this._to) {
            this._to = true;
            setTimeout(function () {
                _this._to = false;
                removeTooOldValues(_this);
            }, 0);
        }
    };
    ObliviousSet.prototype.clear = function () {
        this.map.clear();
    };
    return ObliviousSet;
}());

/**
 * Removes all entries from the set
 * where the TTL has expired
 */
function removeTooOldValues(obliviousSet) {
    var olderThen = now() - obliviousSet.ttl;
    var iterator = obliviousSet.map[Symbol.iterator]();
    /**
     * Because we can assume the new values are added at the bottom,
     * we start from the top and stop as soon as we reach a non-too-old value.
     */
    while (true) {
        var next = iterator.next().value;
        if (!next) {
            return; // no more elements
        }
        var value = next[0];
        var time = next[1];
        if (time < olderThen) {
            obliviousSet.map.delete(value);
        }
        else {
            // We reached a value that is not old enough
            return;
        }
    }
}
function now() {
    return new Date().getTime();
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../../node_modules/broadcast-channel/dist/esbrowser/options.js
function options_fillOptionsWithDefaults() {
  var originalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = JSON.parse(JSON.stringify(originalOptions));

  // main
  if (typeof options.webWorkerSupport === 'undefined') options.webWorkerSupport = true;

  // indexed-db
  if (!options.idb) options.idb = {};
  //  after this time the messages get deleted
  if (!options.idb.ttl) options.idb.ttl = 1000 * 45;
  if (!options.idb.fallbackInterval) options.idb.fallbackInterval = 150;
  //  handles abrupt db onclose events.
  if (originalOptions.idb && typeof originalOptions.idb.onclose === 'function') options.idb.onclose = originalOptions.idb.onclose;

  // localstorage
  if (!options.localstorage) options.localstorage = {};
  if (!options.localstorage.removeTimeout) options.localstorage.removeTimeout = 1000 * 60;

  // custom methods
  if (originalOptions.methods) options.methods = originalOptions.methods;

  // node
  if (!options.node) options.node = {};
  if (!options.node.ttl) options.node.ttl = 1000 * 60 * 2; // 2 minutes;
  /**
   * On linux use 'ulimit -Hn' to get the limit of open files.
   * On ubuntu this was 4096 for me, so we use half of that as maxParallelWrites default.
   */
  if (!options.node.maxParallelWrites) options.node.maxParallelWrites = 2048;
  if (typeof options.node.useFastPath === 'undefined') options.node.useFastPath = true;
  return options;
}
;// CONCATENATED MODULE: ../../../node_modules/broadcast-channel/dist/esbrowser/methods/indexed-db.js
/**
 * this method uses indexeddb to store the messages
 * There is currently no observerAPI for idb
 * @link https://github.com/w3c/IndexedDB/issues/51
 * 
 * When working on this, ensure to use these performance optimizations:
 * @link https://rxdb.info/slow-indexeddb.html
 */


var indexed_db_microSeconds = microSeconds;


var DB_PREFIX = 'pubkey.broadcast-channel-0-';
var OBJECT_STORE_ID = 'messages';

/**
 * Use relaxed durability for faster performance on all transactions.
 * @link https://nolanlawson.com/2021/08/22/speeding-up-indexeddb-reads-and-writes/
 */
var TRANSACTION_SETTINGS = {
  durability: 'relaxed'
};
var indexed_db_type = 'idb';
function getIdb() {
  if (typeof indexedDB !== 'undefined') return indexedDB;
  if (typeof window !== 'undefined') {
    if (typeof window.mozIndexedDB !== 'undefined') return window.mozIndexedDB;
    if (typeof window.webkitIndexedDB !== 'undefined') return window.webkitIndexedDB;
    if (typeof window.msIndexedDB !== 'undefined') return window.msIndexedDB;
  }
  return false;
}

/**
 * If possible, we should explicitly commit IndexedDB transactions
 * for better performance.
 * @link https://nolanlawson.com/2021/08/22/speeding-up-indexeddb-reads-and-writes/
 */
function commitIndexedDBTransaction(tx) {
  if (tx.commit) {
    tx.commit();
  }
}
function createDatabase(channelName) {
  var IndexedDB = getIdb();

  // create table
  var dbName = DB_PREFIX + channelName;

  /**
   * All IndexedDB databases are opened without version
   * because it is a bit faster, especially on firefox
   * @link http://nparashuram.com/IndexedDB/perf/#Open%20Database%20with%20version
   */
  var openRequest = IndexedDB.open(dbName);
  openRequest.onupgradeneeded = function (ev) {
    var db = ev.target.result;
    db.createObjectStore(OBJECT_STORE_ID, {
      keyPath: 'id',
      autoIncrement: true
    });
  };
  return new Promise(function (res, rej) {
    openRequest.onerror = function (ev) {
      return rej(ev);
    };
    openRequest.onsuccess = function () {
      res(openRequest.result);
    };
  });
}

/**
 * writes the new message to the database
 * so other readers can find it
 */
function writeMessage(db, readerUuid, messageJson) {
  var time = Date.now();
  var writeObject = {
    uuid: readerUuid,
    time: time,
    data: messageJson
  };
  var tx = db.transaction([OBJECT_STORE_ID], 'readwrite', TRANSACTION_SETTINGS);
  return new Promise(function (res, rej) {
    tx.oncomplete = function () {
      return res();
    };
    tx.onerror = function (ev) {
      return rej(ev);
    };
    var objectStore = tx.objectStore(OBJECT_STORE_ID);
    objectStore.add(writeObject);
    commitIndexedDBTransaction(tx);
  });
}
function getAllMessages(db) {
  var tx = db.transaction(OBJECT_STORE_ID, 'readonly', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  var ret = [];
  return new Promise(function (res) {
    objectStore.openCursor().onsuccess = function (ev) {
      var cursor = ev.target.result;
      if (cursor) {
        ret.push(cursor.value);
        //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);
        cursor["continue"]();
      } else {
        commitIndexedDBTransaction(tx);
        res(ret);
      }
    };
  });
}
function getMessagesHigherThan(db, lastCursorId) {
  var tx = db.transaction(OBJECT_STORE_ID, 'readonly', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  var ret = [];
  var keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);

  /**
   * Optimization shortcut,
   * if getAll() can be used, do not use a cursor.
   * @link https://rxdb.info/slow-indexeddb.html
   */
  if (objectStore.getAll) {
    var getAllRequest = objectStore.getAll(keyRangeValue);
    return new Promise(function (res, rej) {
      getAllRequest.onerror = function (err) {
        return rej(err);
      };
      getAllRequest.onsuccess = function (e) {
        res(e.target.result);
      };
    });
  }
  function openCursor() {
    // Occasionally Safari will fail on IDBKeyRange.bound, this
    // catches that error, having it open the cursor to the first
    // item. When it gets data it will advance to the desired key.
    try {
      keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);
      return objectStore.openCursor(keyRangeValue);
    } catch (e) {
      return objectStore.openCursor();
    }
  }
  return new Promise(function (res, rej) {
    var openCursorRequest = openCursor();
    openCursorRequest.onerror = function (err) {
      return rej(err);
    };
    openCursorRequest.onsuccess = function (ev) {
      var cursor = ev.target.result;
      if (cursor) {
        if (cursor.value.id < lastCursorId + 1) {
          cursor["continue"](lastCursorId + 1);
        } else {
          ret.push(cursor.value);
          cursor["continue"]();
        }
      } else {
        commitIndexedDBTransaction(tx);
        res(ret);
      }
    };
  });
}
function removeMessagesById(channelState, ids) {
  if (channelState.closed) {
    return Promise.resolve([]);
  }
  var tx = channelState.db.transaction(OBJECT_STORE_ID, 'readwrite', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  return Promise.all(ids.map(function (id) {
    var deleteRequest = objectStore["delete"](id);
    return new Promise(function (res) {
      deleteRequest.onsuccess = function () {
        return res();
      };
    });
  }));
}
function getOldMessages(db, ttl) {
  var olderThen = Date.now() - ttl;
  var tx = db.transaction(OBJECT_STORE_ID, 'readonly', TRANSACTION_SETTINGS);
  var objectStore = tx.objectStore(OBJECT_STORE_ID);
  var ret = [];
  return new Promise(function (res) {
    objectStore.openCursor().onsuccess = function (ev) {
      var cursor = ev.target.result;
      if (cursor) {
        var msgObk = cursor.value;
        if (msgObk.time < olderThen) {
          ret.push(msgObk);
          //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);
          cursor["continue"]();
        } else {
          // no more old messages,
          commitIndexedDBTransaction(tx);
          res(ret);
        }
      } else {
        res(ret);
      }
    };
  });
}
function cleanOldMessages(channelState) {
  return getOldMessages(channelState.db, channelState.options.idb.ttl).then(function (tooOld) {
    return removeMessagesById(channelState, tooOld.map(function (msg) {
      return msg.id;
    }));
  });
}
function indexed_db_create(channelName, options) {
  options = options_fillOptionsWithDefaults(options);
  return createDatabase(channelName).then(function (db) {
    var state = {
      closed: false,
      lastCursorId: 0,
      channelName: channelName,
      options: options,
      uuid: randomToken(),
      /**
       * emittedMessagesIds
       * contains all messages that have been emitted before
       * @type {ObliviousSet}
       */
      eMIs: new ObliviousSet(options.idb.ttl * 2),
      // ensures we do not read messages in parallel
      writeBlockPromise: PROMISE_RESOLVED_VOID,
      messagesCallback: null,
      readQueuePromises: [],
      db: db
    };

    /**
     * Handle abrupt closes that do not originate from db.close().
     * This could happen, for example, if the underlying storage is
     * removed or if the user clears the database in the browser's
     * history preferences.
     */
    db.onclose = function () {
      state.closed = true;
      if (options.idb.onclose) options.idb.onclose();
    };

    /**
     * if service-workers are used,
     * we have no 'storage'-event if they post a message,
     * therefore we also have to set an interval
     */
    _readLoop(state);
    return state;
  });
}
function _readLoop(state) {
  if (state.closed) return;
  readNewMessages(state).then(function () {
    return sleep(state.options.idb.fallbackInterval);
  }).then(function () {
    return _readLoop(state);
  });
}
function _filterMessage(msgObj, state) {
  if (msgObj.uuid === state.uuid) return false; // send by own
  if (state.eMIs.has(msgObj.id)) return false; // already emitted
  if (msgObj.data.time < state.messagesCallbackTime) return false; // older then onMessageCallback
  return true;
}

/**
 * reads all new messages from the database and emits them
 */
function readNewMessages(state) {
  // channel already closed
  if (state.closed) return PROMISE_RESOLVED_VOID;

  // if no one is listening, we do not need to scan for new messages
  if (!state.messagesCallback) return PROMISE_RESOLVED_VOID;
  return getMessagesHigherThan(state.db, state.lastCursorId).then(function (newerMessages) {
    var useMessages = newerMessages
    /**
     * there is a bug in iOS where the msgObj can be undefined sometimes
     * so we filter them out
     * @link https://github.com/pubkey/broadcast-channel/issues/19
     */.filter(function (msgObj) {
      return !!msgObj;
    }).map(function (msgObj) {
      if (msgObj.id > state.lastCursorId) {
        state.lastCursorId = msgObj.id;
      }
      return msgObj;
    }).filter(function (msgObj) {
      return _filterMessage(msgObj, state);
    }).sort(function (msgObjA, msgObjB) {
      return msgObjA.time - msgObjB.time;
    }); // sort by time
    useMessages.forEach(function (msgObj) {
      if (state.messagesCallback) {
        state.eMIs.add(msgObj.id);
        state.messagesCallback(msgObj.data);
      }
    });
    return PROMISE_RESOLVED_VOID;
  });
}
function indexed_db_close(channelState) {
  channelState.closed = true;
  channelState.db.close();
}
function indexed_db_postMessage(channelState, messageJson) {
  channelState.writeBlockPromise = channelState.writeBlockPromise.then(function () {
    return writeMessage(channelState.db, channelState.uuid, messageJson);
  }).then(function () {
    if (randomInt(0, 10) === 0) {
      /* await (do not await) */
      cleanOldMessages(channelState);
    }
  });
  return channelState.writeBlockPromise;
}
function indexed_db_onMessage(channelState, fn, time) {
  channelState.messagesCallbackTime = time;
  channelState.messagesCallback = fn;
  readNewMessages(channelState);
}
function indexed_db_canBeUsed() {
  return !!getIdb();
}
function indexed_db_averageResponseTime(options) {
  return options.idb.fallbackInterval * 2;
}
var IndexedDBMethod = {
  create: indexed_db_create,
  close: indexed_db_close,
  onMessage: indexed_db_onMessage,
  postMessage: indexed_db_postMessage,
  canBeUsed: indexed_db_canBeUsed,
  type: indexed_db_type,
  averageResponseTime: indexed_db_averageResponseTime,
  microSeconds: indexed_db_microSeconds
};
;// CONCATENATED MODULE: ../../../node_modules/broadcast-channel/dist/esbrowser/methods/localstorage.js
/**
 * A localStorage-only method which uses localstorage and its 'storage'-event
 * This does not work inside webworkers because they have no access to localstorage
 * This is basically implemented to support IE9 or your grandmother's toaster.
 * @link https://caniuse.com/#feat=namevalue-storage
 * @link https://caniuse.com/#feat=indexeddb
 */




var localstorage_microSeconds = microSeconds;
var KEY_PREFIX = 'pubkey.broadcastChannel-';
var localstorage_type = 'localstorage';

/**
 * copied from crosstab
 * @link https://github.com/tejacques/crosstab/blob/master/src/crosstab.js#L32
 */
function getLocalStorage() {
  var localStorage;
  if (typeof window === 'undefined') return null;
  try {
    localStorage = window.localStorage;
    localStorage = window['ie8-eventlistener/storage'] || window.localStorage;
  } catch (e) {
    // New versions of Firefox throw a Security exception
    // if cookies are disabled. See
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1028153
  }
  return localStorage;
}
function storageKey(channelName) {
  return KEY_PREFIX + channelName;
}

/**
* writes the new message to the storage
* and fires the storage-event so other readers can find it
*/
function localstorage_postMessage(channelState, messageJson) {
  return new Promise(function (res) {
    sleep().then(function () {
      var key = storageKey(channelState.channelName);
      var writeObj = {
        token: randomToken(),
        time: Date.now(),
        data: messageJson,
        uuid: channelState.uuid
      };
      var value = JSON.stringify(writeObj);
      getLocalStorage().setItem(key, value);

      /**
       * StorageEvent does not fire the 'storage' event
       * in the window that changes the state of the local storage.
       * So we fire it manually
       */
      var ev = document.createEvent('Event');
      ev.initEvent('storage', true, true);
      ev.key = key;
      ev.newValue = value;
      window.dispatchEvent(ev);
      res();
    });
  });
}
function addStorageEventListener(channelName, fn) {
  var key = storageKey(channelName);
  var listener = function listener(ev) {
    if (ev.key === key) {
      fn(JSON.parse(ev.newValue));
    }
  };
  window.addEventListener('storage', listener);
  return listener;
}
function removeStorageEventListener(listener) {
  window.removeEventListener('storage', listener);
}
function localstorage_create(channelName, options) {
  options = options_fillOptionsWithDefaults(options);
  if (!localstorage_canBeUsed()) {
    throw new Error('BroadcastChannel: localstorage cannot be used');
  }
  var uuid = randomToken();

  /**
   * eMIs
   * contains all messages that have been emitted before
   * @type {ObliviousSet}
   */
  var eMIs = new ObliviousSet(options.localstorage.removeTimeout);
  var state = {
    channelName: channelName,
    uuid: uuid,
    eMIs: eMIs // emittedMessagesIds
  };

  state.listener = addStorageEventListener(channelName, function (msgObj) {
    if (!state.messagesCallback) return; // no listener
    if (msgObj.uuid === uuid) return; // own message
    if (!msgObj.token || eMIs.has(msgObj.token)) return; // already emitted
    if (msgObj.data.time && msgObj.data.time < state.messagesCallbackTime) return; // too old

    eMIs.add(msgObj.token);
    state.messagesCallback(msgObj.data);
  });
  return state;
}
function localstorage_close(channelState) {
  removeStorageEventListener(channelState.listener);
}
function localstorage_onMessage(channelState, fn, time) {
  channelState.messagesCallbackTime = time;
  channelState.messagesCallback = fn;
}
function localstorage_canBeUsed() {
  var ls = getLocalStorage();
  if (!ls) return false;
  try {
    var key = '__broadcastchannel_check';
    ls.setItem(key, 'works');
    ls.removeItem(key);
  } catch (e) {
    // Safari 10 in private mode will not allow write access to local
    // storage and fail with a QuotaExceededError. See
    // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API#Private_Browsing_Incognito_modes
    return false;
  }
  return true;
}
function localstorage_averageResponseTime() {
  var defaultTime = 120;
  var userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
    // safari is much slower so this time is higher
    return defaultTime * 2;
  }
  return defaultTime;
}
var LocalstorageMethod = {
  create: localstorage_create,
  close: localstorage_close,
  onMessage: localstorage_onMessage,
  postMessage: localstorage_postMessage,
  canBeUsed: localstorage_canBeUsed,
  type: localstorage_type,
  averageResponseTime: localstorage_averageResponseTime,
  microSeconds: localstorage_microSeconds
};
;// CONCATENATED MODULE: ../../../node_modules/broadcast-channel/dist/esbrowser/methods/simulate.js

var simulate_microSeconds = microSeconds;
var simulate_type = 'simulate';
var SIMULATE_CHANNELS = new Set();
function simulate_create(channelName) {
  var state = {
    name: channelName,
    messagesCallback: null
  };
  SIMULATE_CHANNELS.add(state);
  return state;
}
function simulate_close(channelState) {
  SIMULATE_CHANNELS["delete"](channelState);
}
function simulate_postMessage(channelState, messageJson) {
  return new Promise(function (res) {
    return setTimeout(function () {
      var channelArray = Array.from(SIMULATE_CHANNELS);
      channelArray.filter(function (channel) {
        return channel.name === channelState.name;
      }).filter(function (channel) {
        return channel !== channelState;
      }).filter(function (channel) {
        return !!channel.messagesCallback;
      }).forEach(function (channel) {
        return channel.messagesCallback(messageJson);
      });
      res();
    }, 5);
  });
}
function simulate_onMessage(channelState, fn) {
  channelState.messagesCallback = fn;
}
function simulate_canBeUsed() {
  return true;
}
function simulate_averageResponseTime() {
  return 5;
}
var SimulateMethod = {
  create: simulate_create,
  close: simulate_close,
  onMessage: simulate_onMessage,
  postMessage: simulate_postMessage,
  canBeUsed: simulate_canBeUsed,
  type: simulate_type,
  averageResponseTime: simulate_averageResponseTime,
  microSeconds: simulate_microSeconds
};
;// CONCATENATED MODULE: ../../../node_modules/broadcast-channel/dist/esbrowser/method-chooser.js




// the line below will be removed from es5/browser builds

// order is important
var METHODS = [NativeMethod,
// fastest
IndexedDBMethod, LocalstorageMethod];
function method_chooser_chooseMethod(options) {
  var chooseMethods = [].concat(options.methods, METHODS).filter(Boolean);

  // the line below will be removed from es5/browser builds

  // directly chosen
  if (options.type) {
    if (options.type === 'simulate') {
      // only use simulate-method if directly chosen
      return SimulateMethod;
    }
    var ret = chooseMethods.find(function (m) {
      return m.type === options.type;
    });
    if (!ret) throw new Error('method-type ' + options.type + ' not found');else return ret;
  }

  /**
   * if no webworker support is needed,
   * remove idb from the list so that localstorage will be chosen
   */
  if (!options.webWorkerSupport) {
    chooseMethods = chooseMethods.filter(function (m) {
      return m.type !== 'idb';
    });
  }
  var useMethod = chooseMethods.find(function (method) {
    return method.canBeUsed();
  });
  if (!useMethod) {
    throw new Error("No usable method found in " + JSON.stringify(METHODS.map(function (m) {
      return m.type;
    })));
  } else {
    return useMethod;
  }
}
;// CONCATENATED MODULE: ../../../node_modules/broadcast-channel/dist/esbrowser/broadcast-channel.js




/**
 * Contains all open channels,
 * used in tests to ensure everything is closed.
 */
var OPEN_BROADCAST_CHANNELS = new Set();
var lastId = 0;
var broadcast_channel_BroadcastChannel = function BroadcastChannel(name, options) {
  // identifier of the channel to debug stuff
  this.id = lastId++;
  OPEN_BROADCAST_CHANNELS.add(this);
  this.name = name;
  if (ENFORCED_OPTIONS) {
    options = ENFORCED_OPTIONS;
  }
  this.options = options_fillOptionsWithDefaults(options);
  this.method = method_chooser_chooseMethod(this.options);

  // isListening
  this._iL = false;

  /**
   * _onMessageListener
   * setting onmessage twice,
   * will overwrite the first listener
   */
  this._onML = null;

  /**
   * _addEventListeners
   */
  this._addEL = {
    message: [],
    internal: []
  };

  /**
   * Unsent message promises
   * where the sending is still in progress
   * @type {Set<Promise>}
   */
  this._uMP = new Set();

  /**
   * _beforeClose
   * array of promises that will be awaited
   * before the channel is closed
   */
  this._befC = [];

  /**
   * _preparePromise
   */
  this._prepP = null;
  _prepareChannel(this);
};

// STATICS

/**
 * used to identify if someone overwrites
 * window.BroadcastChannel with this
 * See methods/native.js
 */
broadcast_channel_BroadcastChannel._pubkey = true;

/**
 * clears the tmp-folder if is node
 * @return {Promise<boolean>} true if has run, false if not node
 */
function clearNodeFolder(options) {
  options = fillOptionsWithDefaults(options);
  var method = chooseMethod(options);
  if (method.type === 'node') {
    return method.clearNodeFolder().then(function () {
      return true;
    });
  } else {
    return PROMISE_RESOLVED_FALSE;
  }
}

/**
 * if set, this method is enforced,
 * no mather what the options are
 */
var ENFORCED_OPTIONS;
function enforceOptions(options) {
  ENFORCED_OPTIONS = options;
}

// PROTOTYPE
broadcast_channel_BroadcastChannel.prototype = {
  postMessage: function postMessage(msg) {
    if (this.closed) {
      throw new Error('BroadcastChannel.postMessage(): ' + 'Cannot post message after channel has closed ' +
      /**
       * In the past when this error appeared, it was really hard to debug.
       * So now we log the msg together with the error so it at least
       * gives some clue about where in your application this happens.
       */
      JSON.stringify(msg));
    }
    return _post(this, 'message', msg);
  },
  postInternal: function postInternal(msg) {
    return _post(this, 'internal', msg);
  },
  set onmessage(fn) {
    var time = this.method.microSeconds();
    var listenObj = {
      time: time,
      fn: fn
    };
    _removeListenerObject(this, 'message', this._onML);
    if (fn && typeof fn === 'function') {
      this._onML = listenObj;
      _addListenerObject(this, 'message', listenObj);
    } else {
      this._onML = null;
    }
  },
  addEventListener: function addEventListener(type, fn) {
    var time = this.method.microSeconds();
    var listenObj = {
      time: time,
      fn: fn
    };
    _addListenerObject(this, type, listenObj);
  },
  removeEventListener: function removeEventListener(type, fn) {
    var obj = this._addEL[type].find(function (obj) {
      return obj.fn === fn;
    });
    _removeListenerObject(this, type, obj);
  },
  close: function close() {
    var _this = this;
    if (this.closed) {
      return;
    }
    OPEN_BROADCAST_CHANNELS["delete"](this);
    this.closed = true;
    var awaitPrepare = this._prepP ? this._prepP : PROMISE_RESOLVED_VOID;
    this._onML = null;
    this._addEL.message = [];
    return awaitPrepare
    // wait until all current sending are processed
    .then(function () {
      return Promise.all(Array.from(_this._uMP));
    })
    // run before-close hooks
    .then(function () {
      return Promise.all(_this._befC.map(function (fn) {
        return fn();
      }));
    })
    // close the channel
    .then(function () {
      return _this.method.close(_this._state);
    });
  },
  get type() {
    return this.method.type;
  },
  get isClosed() {
    return this.closed;
  }
};

/**
 * Post a message over the channel
 * @returns {Promise} that resolved when the message sending is done
 */
function _post(broadcastChannel, type, msg) {
  var time = broadcastChannel.method.microSeconds();
  var msgObj = {
    time: time,
    type: type,
    data: msg
  };
  var awaitPrepare = broadcastChannel._prepP ? broadcastChannel._prepP : PROMISE_RESOLVED_VOID;
  return awaitPrepare.then(function () {
    var sendPromise = broadcastChannel.method.postMessage(broadcastChannel._state, msgObj);

    // add/remove to unsent messages list
    broadcastChannel._uMP.add(sendPromise);
    sendPromise["catch"]().then(function () {
      return broadcastChannel._uMP["delete"](sendPromise);
    });
    return sendPromise;
  });
}
function _prepareChannel(channel) {
  var maybePromise = channel.method.create(channel.name, channel.options);
  if (isPromise(maybePromise)) {
    channel._prepP = maybePromise;
    maybePromise.then(function (s) {
      // used in tests to simulate slow runtime
      /*if (channel.options.prepareDelay) {
           await new Promise(res => setTimeout(res, this.options.prepareDelay));
      }*/
      channel._state = s;
    });
  } else {
    channel._state = maybePromise;
  }
}
function _hasMessageListeners(channel) {
  if (channel._addEL.message.length > 0) return true;
  if (channel._addEL.internal.length > 0) return true;
  return false;
}
function _addListenerObject(channel, type, obj) {
  channel._addEL[type].push(obj);
  _startListening(channel);
}
function _removeListenerObject(channel, type, obj) {
  channel._addEL[type] = channel._addEL[type].filter(function (o) {
    return o !== obj;
  });
  _stopListening(channel);
}
function _startListening(channel) {
  if (!channel._iL && _hasMessageListeners(channel)) {
    // someone is listening, start subscribing

    var listenerFn = function listenerFn(msgObj) {
      channel._addEL[msgObj.type].forEach(function (listenerObject) {
        /**
         * Getting the current time in JavaScript has no good precision.
         * So instead of only listening to events that happened 'after' the listener
         * was added, we also listen to events that happened 100ms before it.
         * This ensures that when another process, like a WebWorker, sends events
         * we do not miss them out because their timestamp is a bit off compared to the main process.
         * Not doing this would make messages missing when we send data directly after subscribing and awaiting a response.
         * @link https://johnresig.com/blog/accuracy-of-javascript-time/
         */
        var hundredMsInMicro = 100 * 1000;
        var minMessageTime = listenerObject.time - hundredMsInMicro;
        if (msgObj.time >= minMessageTime) {
          listenerObject.fn(msgObj.data);
        }
      });
    };
    var time = channel.method.microSeconds();
    if (channel._prepP) {
      channel._prepP.then(function () {
        channel._iL = true;
        channel.method.onMessage(channel._state, listenerFn, time);
      });
    } else {
      channel._iL = true;
      channel.method.onMessage(channel._state, listenerFn, time);
    }
  }
}
function _stopListening(channel) {
  if (channel._iL && !_hasMessageListeners(channel)) {
    // no one is listening, stop subscribing
    channel._iL = false;
    var time = channel.method.microSeconds();
    channel.method.onMessage(channel._state, null, time);
  }
}

/***/ }),

/***/ 58506:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ dset; }
/* harmony export */ });
function dset(obj, keys, val) {
	keys.split && (keys=keys.split('.'));
	var i=0, l=keys.length, t=obj, x, k;
	while (i < l) {
		k = keys[i++];
		if (k === '__proto__' || k === 'constructor' || k === 'prototype') break;
		t = t[k] = (i === l) ? val : (typeof(x=t[k])===typeof(keys)) ? x : (keys[i]*0 !== 0 || !!~(''+keys[i]).indexOf('.')) ? {} : [];
	}
}


/***/ }),

/***/ 4994:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"launchdarkly-react-client-sdk","version":"2.29.4","description":"LaunchDarkly SDK for React","author":"LaunchDarkly <team@launchdarkly.com>","license":"Apache-2.0","keywords":["launchdarkly","launch","darkly","react","sdk","bindings"],"main":"lib/index.js","types":"lib/index.d.ts","files":["lib","src","!**/*.test.*","!**/__snapshots__"],"scripts":{"test":"jest","test:junit":"jest --ci --reporters=default --reporters=jest-junit","build":"rimraf lib/* && tsc && mv lib/src/* lib && rimraf lib/package.json lib/src lib/*.test.*","lint":"tslint -p tsconfig.json \'src/**/*.ts*\'","lint:all":"npm run lint","check-typescript":"tsc","prepublishOnly":"npm run build","prettier":"prettier --write \'src/*.@(js|ts|tsx|json|css)\'","link-dev":"./link-dev.sh","check":"npm i && npm run prettier && npm run lint && tsc && npm run test"},"repository":{"type":"git","url":"git://github.com/launchdarkly/react-client-sdk.git"},"homepage":"https://github.com/launchdarkly/react-client-sdk","devDependencies":{"@testing-library/jest-dom":"^5.16.4","@testing-library/react":"^13.0.1","@types/hoist-non-react-statics":"^3.3.1","@types/jest":"^27.0.3","@types/lodash.camelcase":"^4.3.6","@types/prop-types":"^15.7.4","@types/react":"^18.0.3","@types/react-dom":"^18.0.0","@types/react-test-renderer":"^18.0.0","jest":"^27.4.4","jest-environment-jsdom":"^27.4.4","jest-environment-jsdom-global":"^3.0.0","jest-junit":"^13.0.0","prettier":"^1.18.2","prop-types":"^15.7.2","react":"^18.0.0","react-dom":"^18.0.0","react-test-renderer":"^18.0.0","rimraf":"^3.0.0","ts-jest":"^27.1.1","tslint":"^6.1.3","tslint-config-prettier":"^1.18.0","tslint-plugin-prettier":"^2.3.0","typescript":"^4.5.3"},"dependencies":{"hoist-non-react-statics":"^3.3.2","launchdarkly-js-client-sdk":"2.24.2","lodash.camelcase":"^4.3.0"},"peerDependencies":{"react":"^16.6.3 || ^17.0.0 || ^18.0.0","react-dom":"^16.8.4 || ^17.0.0 || ^18.0.0"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(94562), __webpack_exec__(9839); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);